(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebb54"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebb54"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("a58XM", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $757152ee82640ba0$export$ffb0004e005737fa; }, function (v) { return $757152ee82640ba0$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $757152ee82640ba0$export$34b9dba7ce09269b; }, function (v) { return $757152ee82640ba0$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $757152ee82640ba0$export$25062201e9e25d76; }, function (v) { return $757152ee82640ba0$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $757152ee82640ba0$export$ffb0004e005737fa;
var $757152ee82640ba0$export$34b9dba7ce09269b;
var $757152ee82640ba0$export$25062201e9e25d76;
"use strict";

var $6cds3 = parcelRequire("6cds3");
var $757152ee82640ba0$var$k = Symbol.for("react.element"), $757152ee82640ba0$var$l = Symbol.for("react.fragment"), $757152ee82640ba0$var$m = Object.prototype.hasOwnProperty, $757152ee82640ba0$var$n = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $757152ee82640ba0$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $757152ee82640ba0$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$757152ee82640ba0$var$m.call(a, b) && !$757152ee82640ba0$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $757152ee82640ba0$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $757152ee82640ba0$var$n.current
    };
}
$757152ee82640ba0$export$ffb0004e005737fa = $757152ee82640ba0$var$l;
$757152ee82640ba0$export$34b9dba7ce09269b = $757152ee82640ba0$var$q;
$757152ee82640ba0$export$25062201e9e25d76 = $757152ee82640ba0$var$q;

});
parcelRegister("6cds3", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gx6CV"));

});
parcelRegister("gx6CV", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $c094de5bd35107a3$export$dca3b0875bd9a954; }, function (v) { return $c094de5bd35107a3$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $c094de5bd35107a3$export$16fa2f45be04daa8; }, function (v) { return $c094de5bd35107a3$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $c094de5bd35107a3$export$ffb0004e005737fa; }, function (v) { return $c094de5bd35107a3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $c094de5bd35107a3$export$e2c29f18771995cb; }, function (v) { return $c094de5bd35107a3$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $c094de5bd35107a3$export$221d75b3f55bb0bd; }, function (v) { return $c094de5bd35107a3$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $c094de5bd35107a3$export$5f8d39834fd61797; }, function (v) { return $c094de5bd35107a3$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $c094de5bd35107a3$export$74bf444e3cd11ea5; }, function (v) { return $c094de5bd35107a3$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c094de5bd35107a3$export$ae55be85d98224ed; }, function (v) { return $c094de5bd35107a3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $c094de5bd35107a3$export$3ba232387fd5d6dd; }, function (v) { return $c094de5bd35107a3$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $c094de5bd35107a3$export$e530037191fcd5d7; }, function (v) { return $c094de5bd35107a3$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $c094de5bd35107a3$export$fd42f52fd3ae1109; }, function (v) { return $c094de5bd35107a3$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $c094de5bd35107a3$export$c8a8987d4410bf2d; }, function (v) { return $c094de5bd35107a3$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $c094de5bd35107a3$export$d38cd72104c1f0e9; }, function (v) { return $c094de5bd35107a3$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $c094de5bd35107a3$export$7d1e3a5e95ceca43; }, function (v) { return $c094de5bd35107a3$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $c094de5bd35107a3$export$257a8862b851cb5b; }, function (v) { return $c094de5bd35107a3$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $c094de5bd35107a3$export$a8257692ac88316c; }, function (v) { return $c094de5bd35107a3$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $c094de5bd35107a3$export$488013bae63b21da; }, function (v) { return $c094de5bd35107a3$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $c094de5bd35107a3$export$7c73462e0d25e514; }, function (v) { return $c094de5bd35107a3$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $c094de5bd35107a3$export$7568632d0d33d16d; }, function (v) { return $c094de5bd35107a3$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $c094de5bd35107a3$export$88948ce120ea2619; }, function (v) { return $c094de5bd35107a3$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $c094de5bd35107a3$export$35808ee640e87ca7; }, function (v) { return $c094de5bd35107a3$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $c094de5bd35107a3$export$fae74005e78b1a27; }, function (v) { return $c094de5bd35107a3$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e; }, function (v) { return $c094de5bd35107a3$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $c094de5bd35107a3$export$6a7bc4e911dc01cf; }, function (v) { return $c094de5bd35107a3$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $c094de5bd35107a3$export$6d9c69b0de29b591; }, function (v) { return $c094de5bd35107a3$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $c094de5bd35107a3$export$f680877a34711e37; }, function (v) { return $c094de5bd35107a3$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $c094de5bd35107a3$export$d5a552a76deda3c2; }, function (v) { return $c094de5bd35107a3$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $c094de5bd35107a3$export$aaabe4eda9ed9969; }, function (v) { return $c094de5bd35107a3$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $c094de5bd35107a3$export$e5c5a5f917a5871c; }, function (v) { return $c094de5bd35107a3$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $c094de5bd35107a3$export$1538c33de8887b59; }, function (v) { return $c094de5bd35107a3$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $c094de5bd35107a3$export$13e3392192263954; }, function (v) { return $c094de5bd35107a3$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $c094de5bd35107a3$export$b8f5890fc79d6aca; }, function (v) { return $c094de5bd35107a3$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $c094de5bd35107a3$export$60241385465d0a34; }, function (v) { return $c094de5bd35107a3$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $c094de5bd35107a3$export$306c0aa65ff9ec16; }, function (v) { return $c094de5bd35107a3$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $c094de5bd35107a3$export$7b286972b8d8ccbf; }, function (v) { return $c094de5bd35107a3$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $c094de5bd35107a3$export$83d89fbfd8236492; }, function (v) { return $c094de5bd35107a3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c094de5bd35107a3$export$dca3b0875bd9a954;
var $c094de5bd35107a3$export$16fa2f45be04daa8;
var $c094de5bd35107a3$export$ffb0004e005737fa;
var $c094de5bd35107a3$export$e2c29f18771995cb;
var $c094de5bd35107a3$export$221d75b3f55bb0bd;
var $c094de5bd35107a3$export$5f8d39834fd61797;
var $c094de5bd35107a3$export$74bf444e3cd11ea5;
var $c094de5bd35107a3$export$ae55be85d98224ed;
var $c094de5bd35107a3$export$3ba232387fd5d6dd;
var $c094de5bd35107a3$export$e530037191fcd5d7;
var $c094de5bd35107a3$export$fd42f52fd3ae1109;
var $c094de5bd35107a3$export$c8a8987d4410bf2d;
var $c094de5bd35107a3$export$d38cd72104c1f0e9;
var $c094de5bd35107a3$export$7d1e3a5e95ceca43;
var $c094de5bd35107a3$export$257a8862b851cb5b;
var $c094de5bd35107a3$export$a8257692ac88316c;
var $c094de5bd35107a3$export$488013bae63b21da;
var $c094de5bd35107a3$export$7c73462e0d25e514;
var $c094de5bd35107a3$export$7568632d0d33d16d;
var $c094de5bd35107a3$export$88948ce120ea2619;
var $c094de5bd35107a3$export$35808ee640e87ca7;
var $c094de5bd35107a3$export$fae74005e78b1a27;
var $c094de5bd35107a3$export$dc8fbce3eb94dc1e;
var $c094de5bd35107a3$export$6a7bc4e911dc01cf;
var $c094de5bd35107a3$export$6d9c69b0de29b591;
var $c094de5bd35107a3$export$f680877a34711e37;
var $c094de5bd35107a3$export$d5a552a76deda3c2;
var $c094de5bd35107a3$export$aaabe4eda9ed9969;
var $c094de5bd35107a3$export$e5c5a5f917a5871c;
var $c094de5bd35107a3$export$1538c33de8887b59;
var $c094de5bd35107a3$export$13e3392192263954;
var $c094de5bd35107a3$export$b8f5890fc79d6aca;
var $c094de5bd35107a3$export$60241385465d0a34;
var $c094de5bd35107a3$export$306c0aa65ff9ec16;
var $c094de5bd35107a3$export$7b286972b8d8ccbf;
var $c094de5bd35107a3$export$83d89fbfd8236492;
"use strict";
var $c094de5bd35107a3$var$l = Symbol.for("react.element"), $c094de5bd35107a3$var$n = Symbol.for("react.portal"), $c094de5bd35107a3$var$p = Symbol.for("react.fragment"), $c094de5bd35107a3$var$q = Symbol.for("react.strict_mode"), $c094de5bd35107a3$var$r = Symbol.for("react.profiler"), $c094de5bd35107a3$var$t = Symbol.for("react.provider"), $c094de5bd35107a3$var$u = Symbol.for("react.context"), $c094de5bd35107a3$var$v = Symbol.for("react.forward_ref"), $c094de5bd35107a3$var$w = Symbol.for("react.suspense"), $c094de5bd35107a3$var$x = Symbol.for("react.memo"), $c094de5bd35107a3$var$y = Symbol.for("react.lazy"), $c094de5bd35107a3$var$z = Symbol.iterator;
function $c094de5bd35107a3$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c094de5bd35107a3$var$z && a[$c094de5bd35107a3$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c094de5bd35107a3$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $c094de5bd35107a3$var$C = Object.assign, $c094de5bd35107a3$var$D = {};
function $c094de5bd35107a3$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
$c094de5bd35107a3$var$E.prototype.isReactComponent = {};
$c094de5bd35107a3$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$c094de5bd35107a3$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $c094de5bd35107a3$var$F() {}
$c094de5bd35107a3$var$F.prototype = $c094de5bd35107a3$var$E.prototype;
function $c094de5bd35107a3$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $c094de5bd35107a3$var$D;
    this.updater = e || $c094de5bd35107a3$var$B;
}
var $c094de5bd35107a3$var$H = $c094de5bd35107a3$var$G.prototype = new $c094de5bd35107a3$var$F;
$c094de5bd35107a3$var$H.constructor = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$var$C($c094de5bd35107a3$var$H, $c094de5bd35107a3$var$E.prototype);
$c094de5bd35107a3$var$H.isPureReactComponent = !0;
var $c094de5bd35107a3$var$I = Array.isArray, $c094de5bd35107a3$var$J = Object.prototype.hasOwnProperty, $c094de5bd35107a3$var$K = {
    current: null
}, $c094de5bd35107a3$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $c094de5bd35107a3$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$c094de5bd35107a3$var$J.call(b, d) && !$c094de5bd35107a3$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $c094de5bd35107a3$var$K.current
    };
}
function $c094de5bd35107a3$var$N(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $c094de5bd35107a3$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $c094de5bd35107a3$var$l;
}
function $c094de5bd35107a3$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $c094de5bd35107a3$var$P = /\/+/g;
function $c094de5bd35107a3$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $c094de5bd35107a3$var$escape("" + a.key) : b.toString(36);
}
function $c094de5bd35107a3$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $c094de5bd35107a3$var$l:
                case $c094de5bd35107a3$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $c094de5bd35107a3$var$Q(h, 0) : d, $c094de5bd35107a3$var$I(c) ? (e = "", null != a && (e = a.replace($c094de5bd35107a3$var$P, "$&/") + "/"), $c094de5bd35107a3$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($c094de5bd35107a3$var$O(c) && (c = $c094de5bd35107a3$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($c094de5bd35107a3$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($c094de5bd35107a3$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $c094de5bd35107a3$var$Q(k, g);
        h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    }
    else if (f = $c094de5bd35107a3$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $c094de5bd35107a3$var$Q(k, g++), h += $c094de5bd35107a3$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $c094de5bd35107a3$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $c094de5bd35107a3$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $c094de5bd35107a3$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $c094de5bd35107a3$var$U = {
    current: null
}, $c094de5bd35107a3$var$V = {
    transition: null
}, $c094de5bd35107a3$var$W = {
    ReactCurrentDispatcher: $c094de5bd35107a3$var$U,
    ReactCurrentBatchConfig: $c094de5bd35107a3$var$V,
    ReactCurrentOwner: $c094de5bd35107a3$var$K
};
function $c094de5bd35107a3$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$c094de5bd35107a3$export$dca3b0875bd9a954 = {
    map: $c094de5bd35107a3$var$S,
    forEach: function(a, b, e) {
        $c094de5bd35107a3$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $c094de5bd35107a3$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $c094de5bd35107a3$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$c094de5bd35107a3$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$c094de5bd35107a3$export$16fa2f45be04daa8 = $c094de5bd35107a3$var$E;
$c094de5bd35107a3$export$ffb0004e005737fa = $c094de5bd35107a3$var$p;
$c094de5bd35107a3$export$e2c29f18771995cb = $c094de5bd35107a3$var$r;
$c094de5bd35107a3$export$221d75b3f55bb0bd = $c094de5bd35107a3$var$G;
$c094de5bd35107a3$export$5f8d39834fd61797 = $c094de5bd35107a3$var$q;
$c094de5bd35107a3$export$74bf444e3cd11ea5 = $c094de5bd35107a3$var$w;
$c094de5bd35107a3$export$ae55be85d98224ed = $c094de5bd35107a3$var$W;
$c094de5bd35107a3$export$3ba232387fd5d6dd = $c094de5bd35107a3$var$X;
$c094de5bd35107a3$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $c094de5bd35107a3$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $c094de5bd35107a3$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$c094de5bd35107a3$var$J.call(b, f) && !$c094de5bd35107a3$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $c094de5bd35107a3$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$c094de5bd35107a3$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $c094de5bd35107a3$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $c094de5bd35107a3$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$c094de5bd35107a3$export$c8a8987d4410bf2d = $c094de5bd35107a3$var$M;
$c094de5bd35107a3$export$d38cd72104c1f0e9 = function(a) {
    var b = $c094de5bd35107a3$var$M.bind(null, a);
    b.type = a;
    return b;
};
$c094de5bd35107a3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$c094de5bd35107a3$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$v,
        render: a
    };
};
$c094de5bd35107a3$export$a8257692ac88316c = $c094de5bd35107a3$var$O;
$c094de5bd35107a3$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $c094de5bd35107a3$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $c094de5bd35107a3$var$T
    };
};
$c094de5bd35107a3$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $c094de5bd35107a3$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$c094de5bd35107a3$export$7568632d0d33d16d = function(a) {
    var b = $c094de5bd35107a3$var$V.transition;
    $c094de5bd35107a3$var$V.transition = {};
    try {
        a();
    } finally{
        $c094de5bd35107a3$var$V.transition = b;
    }
};
$c094de5bd35107a3$export$88948ce120ea2619 = $c094de5bd35107a3$var$X;
$c094de5bd35107a3$export$35808ee640e87ca7 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useCallback(a, b);
};
$c094de5bd35107a3$export$fae74005e78b1a27 = function(a) {
    return $c094de5bd35107a3$var$U.current.useContext(a);
};
$c094de5bd35107a3$export$dc8fbce3eb94dc1e = function() {};
$c094de5bd35107a3$export$6a7bc4e911dc01cf = function(a) {
    return $c094de5bd35107a3$var$U.current.useDeferredValue(a);
};
$c094de5bd35107a3$export$6d9c69b0de29b591 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useEffect(a, b);
};
$c094de5bd35107a3$export$f680877a34711e37 = function() {
    return $c094de5bd35107a3$var$U.current.useId();
};
$c094de5bd35107a3$export$d5a552a76deda3c2 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useImperativeHandle(a, b, e);
};
$c094de5bd35107a3$export$aaabe4eda9ed9969 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useInsertionEffect(a, b);
};
$c094de5bd35107a3$export$e5c5a5f917a5871c = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useLayoutEffect(a, b);
};
$c094de5bd35107a3$export$1538c33de8887b59 = function(a, b) {
    return $c094de5bd35107a3$var$U.current.useMemo(a, b);
};
$c094de5bd35107a3$export$13e3392192263954 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useReducer(a, b, e);
};
$c094de5bd35107a3$export$b8f5890fc79d6aca = function(a) {
    return $c094de5bd35107a3$var$U.current.useRef(a);
};
$c094de5bd35107a3$export$60241385465d0a34 = function(a) {
    return $c094de5bd35107a3$var$U.current.useState(a);
};
$c094de5bd35107a3$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $c094de5bd35107a3$var$U.current.useSyncExternalStore(a, b, e);
};
$c094de5bd35107a3$export$7b286972b8d8ccbf = function() {
    return $c094de5bd35107a3$var$U.current.useTransition();
};
$c094de5bd35107a3$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("jZA9I", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed; }, function (v) { return $e8dfc29dafb3bbd7$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389; }, function (v) { return $e8dfc29dafb3bbd7$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $e8dfc29dafb3bbd7$export$882461b6382ed46c; }, function (v) { return $e8dfc29dafb3bbd7$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $e8dfc29dafb3bbd7$export$466bfc07425424d5; }, function (v) { return $e8dfc29dafb3bbd7$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4; }, function (v) { return $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db; }, function (v) { return $e8dfc29dafb3bbd7$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e; }, function (v) { return $e8dfc29dafb3bbd7$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99; }, function (v) { return $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $e8dfc29dafb3bbd7$export$502457920280e6be; }, function (v) { return $e8dfc29dafb3bbd7$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1; }, function (v) { return $e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18; }, function (v) { return $e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492; }, function (v) { return $e8dfc29dafb3bbd7$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $e8dfc29dafb3bbd7$export$ae55be85d98224ed;
var $e8dfc29dafb3bbd7$export$d39a5bbd09211389;
var $e8dfc29dafb3bbd7$export$882461b6382ed46c;
var $e8dfc29dafb3bbd7$export$466bfc07425424d5;
var $e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4;
var $e8dfc29dafb3bbd7$export$fa8d919ba61d84db;
var $e8dfc29dafb3bbd7$export$757ceba2d55c277e;
var $e8dfc29dafb3bbd7$export$b3890eb0ae9dca99;
var $e8dfc29dafb3bbd7$export$502457920280e6be;
var $e8dfc29dafb3bbd7$export$c78a37762a8d58e1;
var $e8dfc29dafb3bbd7$export$dc54d992c10e8a18;
var $e8dfc29dafb3bbd7$export$83d89fbfd8236492;
"use strict";

var $6cds3 = parcelRequire("6cds3");

var $1c9zD = parcelRequire("1c9zD");
function $e8dfc29dafb3bbd7$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $e8dfc29dafb3bbd7$var$da = new Set, $e8dfc29dafb3bbd7$var$ea = {};
function $e8dfc29dafb3bbd7$var$fa(a, b) {
    $e8dfc29dafb3bbd7$var$ha(a, b);
    $e8dfc29dafb3bbd7$var$ha(a + "Capture", b);
}
function $e8dfc29dafb3bbd7$var$ha(a, b) {
    $e8dfc29dafb3bbd7$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$da.add(b[a]);
}
var $e8dfc29dafb3bbd7$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $e8dfc29dafb3bbd7$var$ja = Object.prototype.hasOwnProperty, $e8dfc29dafb3bbd7$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $e8dfc29dafb3bbd7$var$la = {}, $e8dfc29dafb3bbd7$var$ma = {};
function $e8dfc29dafb3bbd7$var$oa(a) {
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$ma, a)) return !0;
    if ($e8dfc29dafb3bbd7$var$ja.call($e8dfc29dafb3bbd7$var$la, a)) return !1;
    if ($e8dfc29dafb3bbd7$var$ka.test(a)) return $e8dfc29dafb3bbd7$var$ma[a] = !0;
    $e8dfc29dafb3bbd7$var$la[a] = !0;
    return !1;
}
function $e8dfc29dafb3bbd7$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $e8dfc29dafb3bbd7$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $e8dfc29dafb3bbd7$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $e8dfc29dafb3bbd7$var$ra = /[\-:]([a-z])/g;
function $e8dfc29dafb3bbd7$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($e8dfc29dafb3bbd7$var$ra, $e8dfc29dafb3bbd7$var$sa);
    $e8dfc29dafb3bbd7$var$z[b] = new $e8dfc29dafb3bbd7$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$e8dfc29dafb3bbd7$var$z.xlinkHref = new $e8dfc29dafb3bbd7$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $e8dfc29dafb3bbd7$var$z[a] = new $e8dfc29dafb3bbd7$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $e8dfc29dafb3bbd7$var$ta(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$z.hasOwnProperty(b) ? $e8dfc29dafb3bbd7$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $e8dfc29dafb3bbd7$var$qa(b, c, e, d) && (c = null), d || null === e ? $e8dfc29dafb3bbd7$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $e8dfc29dafb3bbd7$var$ua = $6cds3.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $e8dfc29dafb3bbd7$var$va = Symbol.for("react.element"), $e8dfc29dafb3bbd7$var$wa = Symbol.for("react.portal"), $e8dfc29dafb3bbd7$var$ya = Symbol.for("react.fragment"), $e8dfc29dafb3bbd7$var$za = Symbol.for("react.strict_mode"), $e8dfc29dafb3bbd7$var$Aa = Symbol.for("react.profiler"), $e8dfc29dafb3bbd7$var$Ba = Symbol.for("react.provider"), $e8dfc29dafb3bbd7$var$Ca = Symbol.for("react.context"), $e8dfc29dafb3bbd7$var$Da = Symbol.for("react.forward_ref"), $e8dfc29dafb3bbd7$var$Ea = Symbol.for("react.suspense"), $e8dfc29dafb3bbd7$var$Fa = Symbol.for("react.suspense_list"), $e8dfc29dafb3bbd7$var$Ga = Symbol.for("react.memo"), $e8dfc29dafb3bbd7$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $e8dfc29dafb3bbd7$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $e8dfc29dafb3bbd7$var$Ja = Symbol.iterator;
function $e8dfc29dafb3bbd7$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e8dfc29dafb3bbd7$var$Ja && a[$e8dfc29dafb3bbd7$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e8dfc29dafb3bbd7$var$A = Object.assign, $e8dfc29dafb3bbd7$var$La;
function $e8dfc29dafb3bbd7$var$Ma(a) {
    if (void 0 === $e8dfc29dafb3bbd7$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $e8dfc29dafb3bbd7$var$La = b && b[1] || "";
    }
    return "\n" + $e8dfc29dafb3bbd7$var$La + a;
}
var $e8dfc29dafb3bbd7$var$Na = !1;
function $e8dfc29dafb3bbd7$var$Oa(a, b) {
    if (!a || $e8dfc29dafb3bbd7$var$Na) return "";
    $e8dfc29dafb3bbd7$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $e8dfc29dafb3bbd7$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $e8dfc29dafb3bbd7$var$Ma(a) : "";
}
function $e8dfc29dafb3bbd7$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $e8dfc29dafb3bbd7$var$Ma(a.type);
        case 16:
            return $e8dfc29dafb3bbd7$var$Ma("Lazy");
        case 13:
            return $e8dfc29dafb3bbd7$var$Ma("Suspense");
        case 19:
            return $e8dfc29dafb3bbd7$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !1), a;
        case 11:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $e8dfc29dafb3bbd7$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return "Fragment";
        case $e8dfc29dafb3bbd7$var$wa:
            return "Portal";
        case $e8dfc29dafb3bbd7$var$Aa:
            return "Profiler";
        case $e8dfc29dafb3bbd7$var$za:
            return "StrictMode";
        case $e8dfc29dafb3bbd7$var$Ea:
            return "Suspense";
        case $e8dfc29dafb3bbd7$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $e8dfc29dafb3bbd7$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $e8dfc29dafb3bbd7$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $e8dfc29dafb3bbd7$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $e8dfc29dafb3bbd7$var$Ga:
            return b = a.displayName || null, null !== b ? b : $e8dfc29dafb3bbd7$var$Qa(a.type) || "Memo";
        case $e8dfc29dafb3bbd7$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $e8dfc29dafb3bbd7$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $e8dfc29dafb3bbd7$var$Qa(b);
        case 8:
            return b === $e8dfc29dafb3bbd7$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $e8dfc29dafb3bbd7$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $e8dfc29dafb3bbd7$var$Ua(a) {
    var b = $e8dfc29dafb3bbd7$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $e8dfc29dafb3bbd7$var$Va(a) {
    a._valueTracker || (a._valueTracker = $e8dfc29dafb3bbd7$var$Ua(a));
}
function $e8dfc29dafb3bbd7$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $e8dfc29dafb3bbd7$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $e8dfc29dafb3bbd7$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $e8dfc29dafb3bbd7$var$Ya(a, b) {
    var c = b.checked;
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $e8dfc29dafb3bbd7$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $e8dfc29dafb3bbd7$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $e8dfc29dafb3bbd7$var$ab(a, b) {
    b = b.checked;
    null != b && $e8dfc29dafb3bbd7$var$ta(a, "checked", b, !1);
}
function $e8dfc29dafb3bbd7$var$bb(a, b) {
    $e8dfc29dafb3bbd7$var$ab(a, b);
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $e8dfc29dafb3bbd7$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $e8dfc29dafb3bbd7$var$cb(a, b.type, $e8dfc29dafb3bbd7$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $e8dfc29dafb3bbd7$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $e8dfc29dafb3bbd7$var$cb(a, b, c) {
    if ("number" !== b || $e8dfc29dafb3bbd7$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $e8dfc29dafb3bbd7$var$eb = Array.isArray;
function $e8dfc29dafb3bbd7$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $e8dfc29dafb3bbd7$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $e8dfc29dafb3bbd7$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($e8dfc29dafb3bbd7$var$p(91));
    return $e8dfc29dafb3bbd7$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $e8dfc29dafb3bbd7$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($e8dfc29dafb3bbd7$var$p(92));
            if ($e8dfc29dafb3bbd7$var$eb(c)) {
                if (1 < c.length) throw Error($e8dfc29dafb3bbd7$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $e8dfc29dafb3bbd7$var$Sa(c)
    };
}
function $e8dfc29dafb3bbd7$var$ib(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Sa(b.value), d = $e8dfc29dafb3bbd7$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $e8dfc29dafb3bbd7$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $e8dfc29dafb3bbd7$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $e8dfc29dafb3bbd7$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $e8dfc29dafb3bbd7$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $e8dfc29dafb3bbd7$var$mb, $e8dfc29dafb3bbd7$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $e8dfc29dafb3bbd7$var$mb = $e8dfc29dafb3bbd7$var$mb || document.createElement("div");
        $e8dfc29dafb3bbd7$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $e8dfc29dafb3bbd7$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $e8dfc29dafb3bbd7$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $e8dfc29dafb3bbd7$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $e8dfc29dafb3bbd7$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($e8dfc29dafb3bbd7$var$pb).forEach(function(a) {
    $e8dfc29dafb3bbd7$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $e8dfc29dafb3bbd7$var$pb[b] = $e8dfc29dafb3bbd7$var$pb[a];
    });
});
function $e8dfc29dafb3bbd7$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $e8dfc29dafb3bbd7$var$pb.hasOwnProperty(a) && $e8dfc29dafb3bbd7$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $e8dfc29dafb3bbd7$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $e8dfc29dafb3bbd7$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $e8dfc29dafb3bbd7$var$tb = $e8dfc29dafb3bbd7$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $e8dfc29dafb3bbd7$var$ub(a, b) {
    if (b) {
        if ($e8dfc29dafb3bbd7$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($e8dfc29dafb3bbd7$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($e8dfc29dafb3bbd7$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($e8dfc29dafb3bbd7$var$p(62));
    }
}
function $e8dfc29dafb3bbd7$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $e8dfc29dafb3bbd7$var$wb = null;
function $e8dfc29dafb3bbd7$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $e8dfc29dafb3bbd7$var$yb = null, $e8dfc29dafb3bbd7$var$zb = null, $e8dfc29dafb3bbd7$var$Ab = null;
function $e8dfc29dafb3bbd7$var$Bb(a) {
    if (a = $e8dfc29dafb3bbd7$var$Cb(a)) {
        if ("function" !== typeof $e8dfc29dafb3bbd7$var$yb) throw Error($e8dfc29dafb3bbd7$var$p(280));
        var b = a.stateNode;
        b && (b = $e8dfc29dafb3bbd7$var$Db(b), $e8dfc29dafb3bbd7$var$yb(a.stateNode, a.type, b));
    }
}
function $e8dfc29dafb3bbd7$var$Eb(a) {
    $e8dfc29dafb3bbd7$var$zb ? $e8dfc29dafb3bbd7$var$Ab ? $e8dfc29dafb3bbd7$var$Ab.push(a) : $e8dfc29dafb3bbd7$var$Ab = [
        a
    ] : $e8dfc29dafb3bbd7$var$zb = a;
}
function $e8dfc29dafb3bbd7$var$Fb() {
    if ($e8dfc29dafb3bbd7$var$zb) {
        var a = $e8dfc29dafb3bbd7$var$zb, b = $e8dfc29dafb3bbd7$var$Ab;
        $e8dfc29dafb3bbd7$var$Ab = $e8dfc29dafb3bbd7$var$zb = null;
        $e8dfc29dafb3bbd7$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$e8dfc29dafb3bbd7$var$Bb(b[a]);
    }
}
function $e8dfc29dafb3bbd7$var$Gb(a, b) {
    return a(b);
}
function $e8dfc29dafb3bbd7$var$Hb() {}
var $e8dfc29dafb3bbd7$var$Ib = !1;
function $e8dfc29dafb3bbd7$var$Jb(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$Ib) return a(b, c);
    $e8dfc29dafb3bbd7$var$Ib = !0;
    try {
        return $e8dfc29dafb3bbd7$var$Gb(a, b, c);
    } finally{
        if ($e8dfc29dafb3bbd7$var$Ib = !1, null !== $e8dfc29dafb3bbd7$var$zb || null !== $e8dfc29dafb3bbd7$var$Ab) $e8dfc29dafb3bbd7$var$Hb(), $e8dfc29dafb3bbd7$var$Fb();
    }
}
function $e8dfc29dafb3bbd7$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $e8dfc29dafb3bbd7$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($e8dfc29dafb3bbd7$var$p(231, b, typeof c));
    return c;
}
var $e8dfc29dafb3bbd7$var$Lb = !1;
if ($e8dfc29dafb3bbd7$var$ia) try {
    var $e8dfc29dafb3bbd7$var$Mb = {};
    Object.defineProperty($e8dfc29dafb3bbd7$var$Mb, "passive", {
        get: function() {
            $e8dfc29dafb3bbd7$var$Lb = !0;
        }
    });
    window.addEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
    window.removeEventListener("test", $e8dfc29dafb3bbd7$var$Mb, $e8dfc29dafb3bbd7$var$Mb);
} catch (a) {
    $e8dfc29dafb3bbd7$var$Lb = !1;
}
function $e8dfc29dafb3bbd7$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $e8dfc29dafb3bbd7$var$Ob = !1, $e8dfc29dafb3bbd7$var$Pb = null, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, $e8dfc29dafb3bbd7$var$Sb = {
    onError: function(a) {
        $e8dfc29dafb3bbd7$var$Ob = !0;
        $e8dfc29dafb3bbd7$var$Pb = a;
    }
};
function $e8dfc29dafb3bbd7$var$Tb(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Ob = !1;
    $e8dfc29dafb3bbd7$var$Pb = null;
    $e8dfc29dafb3bbd7$var$Nb.apply($e8dfc29dafb3bbd7$var$Sb, arguments);
}
function $e8dfc29dafb3bbd7$var$Ub(a, b, c, d, e, f, g, h, k) {
    $e8dfc29dafb3bbd7$var$Tb.apply(this, arguments);
    if ($e8dfc29dafb3bbd7$var$Ob) {
        if ($e8dfc29dafb3bbd7$var$Ob) {
            var l = $e8dfc29dafb3bbd7$var$Pb;
            $e8dfc29dafb3bbd7$var$Ob = !1;
            $e8dfc29dafb3bbd7$var$Pb = null;
        } else throw Error($e8dfc29dafb3bbd7$var$p(198));
        $e8dfc29dafb3bbd7$var$Qb || ($e8dfc29dafb3bbd7$var$Qb = !0, $e8dfc29dafb3bbd7$var$Rb = l);
    }
}
function $e8dfc29dafb3bbd7$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $e8dfc29dafb3bbd7$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Xb(a) {
    if ($e8dfc29dafb3bbd7$var$Vb(a) !== a) throw Error($e8dfc29dafb3bbd7$var$p(188));
}
function $e8dfc29dafb3bbd7$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $e8dfc29dafb3bbd7$var$Vb(a);
        if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $e8dfc29dafb3bbd7$var$Xb(e), a;
                if (f === d) return $e8dfc29dafb3bbd7$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($e8dfc29dafb3bbd7$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($e8dfc29dafb3bbd7$var$p(190));
    }
    if (3 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $e8dfc29dafb3bbd7$var$Zb(a) {
    a = $e8dfc29dafb3bbd7$var$Yb(a);
    return null !== a ? $e8dfc29dafb3bbd7$var$$b(a) : null;
}
function $e8dfc29dafb3bbd7$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $e8dfc29dafb3bbd7$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$ac = $1c9zD.unstable_scheduleCallback, $e8dfc29dafb3bbd7$var$bc = $1c9zD.unstable_cancelCallback, $e8dfc29dafb3bbd7$var$cc = $1c9zD.unstable_shouldYield, $e8dfc29dafb3bbd7$var$dc = $1c9zD.unstable_requestPaint, $e8dfc29dafb3bbd7$var$B = $1c9zD.unstable_now, $e8dfc29dafb3bbd7$var$ec = $1c9zD.unstable_getCurrentPriorityLevel, $e8dfc29dafb3bbd7$var$fc = $1c9zD.unstable_ImmediatePriority, $e8dfc29dafb3bbd7$var$gc = $1c9zD.unstable_UserBlockingPriority, $e8dfc29dafb3bbd7$var$hc = $1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$ic = $1c9zD.unstable_LowPriority, $e8dfc29dafb3bbd7$var$jc = $1c9zD.unstable_IdlePriority, $e8dfc29dafb3bbd7$var$kc = null, $e8dfc29dafb3bbd7$var$lc = null;
function $e8dfc29dafb3bbd7$var$mc(a) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $e8dfc29dafb3bbd7$var$oc = Math.clz32 ? Math.clz32 : $e8dfc29dafb3bbd7$var$nc, $e8dfc29dafb3bbd7$var$pc = Math.log, $e8dfc29dafb3bbd7$var$qc = Math.LN2;
function $e8dfc29dafb3bbd7$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($e8dfc29dafb3bbd7$var$pc(a) / $e8dfc29dafb3bbd7$var$qc | 0) | 0;
}
var $e8dfc29dafb3bbd7$var$rc = 64, $e8dfc29dafb3bbd7$var$sc = 4194304;
function $e8dfc29dafb3bbd7$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $e8dfc29dafb3bbd7$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $e8dfc29dafb3bbd7$var$tc(h) : (f &= g, 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $e8dfc29dafb3bbd7$var$tc(g) : 0 !== f && (d = $e8dfc29dafb3bbd7$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $e8dfc29dafb3bbd7$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $e8dfc29dafb3bbd7$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $e8dfc29dafb3bbd7$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $e8dfc29dafb3bbd7$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $e8dfc29dafb3bbd7$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $e8dfc29dafb3bbd7$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $e8dfc29dafb3bbd7$var$yc() {
    var a = $e8dfc29dafb3bbd7$var$rc;
    $e8dfc29dafb3bbd7$var$rc <<= 1;
    0 === ($e8dfc29dafb3bbd7$var$rc & 4194240) && ($e8dfc29dafb3bbd7$var$rc = 64);
    return a;
}
function $e8dfc29dafb3bbd7$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $e8dfc29dafb3bbd7$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $e8dfc29dafb3bbd7$var$oc(b);
    a[b] = c;
}
function $e8dfc29dafb3bbd7$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $e8dfc29dafb3bbd7$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $e8dfc29dafb3bbd7$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $e8dfc29dafb3bbd7$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $e8dfc29dafb3bbd7$var$C = 0;
function $e8dfc29dafb3bbd7$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $e8dfc29dafb3bbd7$var$Ec, $e8dfc29dafb3bbd7$var$Fc, $e8dfc29dafb3bbd7$var$Gc, $e8dfc29dafb3bbd7$var$Hc, $e8dfc29dafb3bbd7$var$Ic, $e8dfc29dafb3bbd7$var$Jc = !1, $e8dfc29dafb3bbd7$var$Kc = [], $e8dfc29dafb3bbd7$var$Lc = null, $e8dfc29dafb3bbd7$var$Mc = null, $e8dfc29dafb3bbd7$var$Nc = null, $e8dfc29dafb3bbd7$var$Oc = new Map, $e8dfc29dafb3bbd7$var$Pc = new Map, $e8dfc29dafb3bbd7$var$Qc = [], $e8dfc29dafb3bbd7$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $e8dfc29dafb3bbd7$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $e8dfc29dafb3bbd7$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $e8dfc29dafb3bbd7$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $e8dfc29dafb3bbd7$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $e8dfc29dafb3bbd7$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $e8dfc29dafb3bbd7$var$Pc.delete(b.pointerId);
    }
}
function $e8dfc29dafb3bbd7$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $e8dfc29dafb3bbd7$var$Cb(b), null !== b && $e8dfc29dafb3bbd7$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $e8dfc29dafb3bbd7$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $e8dfc29dafb3bbd7$var$Lc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $e8dfc29dafb3bbd7$var$Mc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $e8dfc29dafb3bbd7$var$Nc = $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $e8dfc29dafb3bbd7$var$Oc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $e8dfc29dafb3bbd7$var$Pc.set(f, $e8dfc29dafb3bbd7$var$Tc($e8dfc29dafb3bbd7$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Vc(a) {
    var b = $e8dfc29dafb3bbd7$var$Wc(a.target);
    if (null !== b) {
        var c = $e8dfc29dafb3bbd7$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $e8dfc29dafb3bbd7$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $e8dfc29dafb3bbd7$var$Ic(a.priority, function() {
                        $e8dfc29dafb3bbd7$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $e8dfc29dafb3bbd7$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $e8dfc29dafb3bbd7$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $e8dfc29dafb3bbd7$var$wb = d;
            c.target.dispatchEvent(d);
            $e8dfc29dafb3bbd7$var$wb = null;
        } else return b = $e8dfc29dafb3bbd7$var$Cb(c), null !== b && $e8dfc29dafb3bbd7$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Zc(a, b, c) {
    $e8dfc29dafb3bbd7$var$Xc(a) && c.delete(b);
}
function $e8dfc29dafb3bbd7$var$$c() {
    $e8dfc29dafb3bbd7$var$Jc = !1;
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Lc) && ($e8dfc29dafb3bbd7$var$Lc = null);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Mc) && ($e8dfc29dafb3bbd7$var$Mc = null);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$Xc($e8dfc29dafb3bbd7$var$Nc) && ($e8dfc29dafb3bbd7$var$Nc = null);
    $e8dfc29dafb3bbd7$var$Oc.forEach($e8dfc29dafb3bbd7$var$Zc);
    $e8dfc29dafb3bbd7$var$Pc.forEach($e8dfc29dafb3bbd7$var$Zc);
}
function $e8dfc29dafb3bbd7$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $e8dfc29dafb3bbd7$var$Jc || ($e8dfc29dafb3bbd7$var$Jc = !0, $1c9zD.unstable_scheduleCallback($1c9zD.unstable_NormalPriority, $e8dfc29dafb3bbd7$var$$c)));
}
function $e8dfc29dafb3bbd7$var$bd(a) {
    function b(b) {
        return $e8dfc29dafb3bbd7$var$ad(b, a);
    }
    if (0 < $e8dfc29dafb3bbd7$var$Kc.length) {
        $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Kc[0], a);
        for(var c = 1; c < $e8dfc29dafb3bbd7$var$Kc.length; c++){
            var d = $e8dfc29dafb3bbd7$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $e8dfc29dafb3bbd7$var$Lc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Lc, a);
    null !== $e8dfc29dafb3bbd7$var$Mc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Mc, a);
    null !== $e8dfc29dafb3bbd7$var$Nc && $e8dfc29dafb3bbd7$var$ad($e8dfc29dafb3bbd7$var$Nc, a);
    $e8dfc29dafb3bbd7$var$Oc.forEach(b);
    $e8dfc29dafb3bbd7$var$Pc.forEach(b);
    for(c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length; c++)d = $e8dfc29dafb3bbd7$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $e8dfc29dafb3bbd7$var$Qc.length && (c = $e8dfc29dafb3bbd7$var$Qc[0], null === c.blockedOn);)$e8dfc29dafb3bbd7$var$Vc(c), null === c.blockedOn && $e8dfc29dafb3bbd7$var$Qc.shift();
}
var $e8dfc29dafb3bbd7$var$cd = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$dd = !0;
function $e8dfc29dafb3bbd7$var$ed(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$gd(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$C, f = $e8dfc29dafb3bbd7$var$cd.transition;
    $e8dfc29dafb3bbd7$var$cd.transition = null;
    try {
        $e8dfc29dafb3bbd7$var$C = 4, $e8dfc29dafb3bbd7$var$fd(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$C = e, $e8dfc29dafb3bbd7$var$cd.transition = f;
    }
}
function $e8dfc29dafb3bbd7$var$fd(a, b, c, d) {
    if ($e8dfc29dafb3bbd7$var$dd) {
        var e = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
        if (null === e) $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c), $e8dfc29dafb3bbd7$var$Sc(a, d);
        else if ($e8dfc29dafb3bbd7$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($e8dfc29dafb3bbd7$var$Sc(a, d), b & 4 && -1 < $e8dfc29dafb3bbd7$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $e8dfc29dafb3bbd7$var$Cb(e);
                null !== f && $e8dfc29dafb3bbd7$var$Ec(f);
                f = $e8dfc29dafb3bbd7$var$Yc(a, b, c, d);
                null === f && $e8dfc29dafb3bbd7$var$hd(a, b, d, $e8dfc29dafb3bbd7$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $e8dfc29dafb3bbd7$var$hd(a, b, d, null, c);
    }
}
var $e8dfc29dafb3bbd7$var$id = null;
function $e8dfc29dafb3bbd7$var$Yc(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$id = null;
    a = $e8dfc29dafb3bbd7$var$xb(d);
    a = $e8dfc29dafb3bbd7$var$Wc(a);
    if (null !== a) {
        if (b = $e8dfc29dafb3bbd7$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $e8dfc29dafb3bbd7$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $e8dfc29dafb3bbd7$var$id = a;
    return null;
}
function $e8dfc29dafb3bbd7$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($e8dfc29dafb3bbd7$var$ec()){
                case $e8dfc29dafb3bbd7$var$fc:
                    return 1;
                case $e8dfc29dafb3bbd7$var$gc:
                    return 4;
                case $e8dfc29dafb3bbd7$var$hc:
                case $e8dfc29dafb3bbd7$var$ic:
                    return 16;
                case $e8dfc29dafb3bbd7$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ld = null, $e8dfc29dafb3bbd7$var$md = null;
function $e8dfc29dafb3bbd7$var$nd() {
    if ($e8dfc29dafb3bbd7$var$md) return $e8dfc29dafb3bbd7$var$md;
    var a, b = $e8dfc29dafb3bbd7$var$ld, c = b.length, d, e = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $e8dfc29dafb3bbd7$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $e8dfc29dafb3bbd7$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $e8dfc29dafb3bbd7$var$pd() {
    return !0;
}
function $e8dfc29dafb3bbd7$var$qd() {
    return !1;
}
function $e8dfc29dafb3bbd7$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $e8dfc29dafb3bbd7$var$pd : $e8dfc29dafb3bbd7$var$qd;
        this.isPropagationStopped = $e8dfc29dafb3bbd7$var$qd;
        return this;
    }
    $e8dfc29dafb3bbd7$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $e8dfc29dafb3bbd7$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $e8dfc29dafb3bbd7$var$pd);
        },
        persist: function() {},
        isPersistent: $e8dfc29dafb3bbd7$var$pd
    });
    return b;
}
var $e8dfc29dafb3bbd7$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $e8dfc29dafb3bbd7$var$td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$sd), $e8dfc29dafb3bbd7$var$ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    view: 0,
    detail: 0
}), $e8dfc29dafb3bbd7$var$vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$ud), $e8dfc29dafb3bbd7$var$wd, $e8dfc29dafb3bbd7$var$xd, $e8dfc29dafb3bbd7$var$yd, $e8dfc29dafb3bbd7$var$Ad = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $e8dfc29dafb3bbd7$var$yd && ($e8dfc29dafb3bbd7$var$yd && "mousemove" === a.type ? ($e8dfc29dafb3bbd7$var$wd = a.screenX - $e8dfc29dafb3bbd7$var$yd.screenX, $e8dfc29dafb3bbd7$var$xd = a.screenY - $e8dfc29dafb3bbd7$var$yd.screenY) : $e8dfc29dafb3bbd7$var$xd = $e8dfc29dafb3bbd7$var$wd = 0, $e8dfc29dafb3bbd7$var$yd = a);
        return $e8dfc29dafb3bbd7$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $e8dfc29dafb3bbd7$var$xd;
    }
}), $e8dfc29dafb3bbd7$var$Bd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ad), $e8dfc29dafb3bbd7$var$Cd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    dataTransfer: 0
}), $e8dfc29dafb3bbd7$var$Dd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Cd), $e8dfc29dafb3bbd7$var$Ed = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    relatedTarget: 0
}), $e8dfc29dafb3bbd7$var$Fd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ed), $e8dfc29dafb3bbd7$var$Gd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Hd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Gd), $e8dfc29dafb3bbd7$var$Id = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $e8dfc29dafb3bbd7$var$Jd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Id), $e8dfc29dafb3bbd7$var$Kd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    data: 0
}), $e8dfc29dafb3bbd7$var$Ld = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Kd), $e8dfc29dafb3bbd7$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $e8dfc29dafb3bbd7$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $e8dfc29dafb3bbd7$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $e8dfc29dafb3bbd7$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $e8dfc29dafb3bbd7$var$Od[a]) ? !!b[a] : !1;
}
function $e8dfc29dafb3bbd7$var$zd() {
    return $e8dfc29dafb3bbd7$var$Pd;
}
var $e8dfc29dafb3bbd7$var$Qd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $e8dfc29dafb3bbd7$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $e8dfc29dafb3bbd7$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $e8dfc29dafb3bbd7$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $e8dfc29dafb3bbd7$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $e8dfc29dafb3bbd7$var$Rd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Qd), $e8dfc29dafb3bbd7$var$Sd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $e8dfc29dafb3bbd7$var$Td = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Sd), $e8dfc29dafb3bbd7$var$Ud = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $e8dfc29dafb3bbd7$var$zd
}), $e8dfc29dafb3bbd7$var$Vd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Ud), $e8dfc29dafb3bbd7$var$Wd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $e8dfc29dafb3bbd7$var$Xd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Wd), $e8dfc29dafb3bbd7$var$Yd = $e8dfc29dafb3bbd7$var$A({}, $e8dfc29dafb3bbd7$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $e8dfc29dafb3bbd7$var$Zd = $e8dfc29dafb3bbd7$var$rd($e8dfc29dafb3bbd7$var$Yd), $e8dfc29dafb3bbd7$var$$d = [
    9,
    13,
    27,
    32
], $e8dfc29dafb3bbd7$var$ae = $e8dfc29dafb3bbd7$var$ia && "CompositionEvent" in window, $e8dfc29dafb3bbd7$var$be = null;
$e8dfc29dafb3bbd7$var$ia && "documentMode" in document && ($e8dfc29dafb3bbd7$var$be = document.documentMode);
var $e8dfc29dafb3bbd7$var$ce = $e8dfc29dafb3bbd7$var$ia && "TextEvent" in window && !$e8dfc29dafb3bbd7$var$be, $e8dfc29dafb3bbd7$var$de = $e8dfc29dafb3bbd7$var$ia && (!$e8dfc29dafb3bbd7$var$ae || $e8dfc29dafb3bbd7$var$be && 8 < $e8dfc29dafb3bbd7$var$be && 11 >= $e8dfc29dafb3bbd7$var$be), $e8dfc29dafb3bbd7$var$ee = String.fromCharCode(32), $e8dfc29dafb3bbd7$var$fe = !1;
function $e8dfc29dafb3bbd7$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $e8dfc29dafb3bbd7$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $e8dfc29dafb3bbd7$var$ie = !1;
function $e8dfc29dafb3bbd7$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $e8dfc29dafb3bbd7$var$fe = !0;
            return $e8dfc29dafb3bbd7$var$ee;
        case "textInput":
            return a = b.data, a === $e8dfc29dafb3bbd7$var$ee && $e8dfc29dafb3bbd7$var$fe ? null : a;
        default:
            return null;
    }
}
function $e8dfc29dafb3bbd7$var$ke(a, b) {
    if ($e8dfc29dafb3bbd7$var$ie) return "compositionend" === a || !$e8dfc29dafb3bbd7$var$ae && $e8dfc29dafb3bbd7$var$ge(a, b) ? (a = $e8dfc29dafb3bbd7$var$nd(), $e8dfc29dafb3bbd7$var$md = $e8dfc29dafb3bbd7$var$ld = $e8dfc29dafb3bbd7$var$kd = null, $e8dfc29dafb3bbd7$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $e8dfc29dafb3bbd7$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $e8dfc29dafb3bbd7$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$e8dfc29dafb3bbd7$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $e8dfc29dafb3bbd7$var$ne(a, b, c, d) {
    $e8dfc29dafb3bbd7$var$Eb(d);
    b = $e8dfc29dafb3bbd7$var$oe(b, "onChange");
    0 < b.length && (c = new $e8dfc29dafb3bbd7$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $e8dfc29dafb3bbd7$var$pe = null, $e8dfc29dafb3bbd7$var$qe = null;
function $e8dfc29dafb3bbd7$var$re(a) {
    $e8dfc29dafb3bbd7$var$se(a, 0);
}
function $e8dfc29dafb3bbd7$var$te(a) {
    var b = $e8dfc29dafb3bbd7$var$ue(a);
    if ($e8dfc29dafb3bbd7$var$Wa(b)) return a;
}
function $e8dfc29dafb3bbd7$var$ve(a, b) {
    if ("change" === a) return b;
}
var $e8dfc29dafb3bbd7$var$we = !1;
if ($e8dfc29dafb3bbd7$var$ia) {
    var $e8dfc29dafb3bbd7$var$xe;
    if ($e8dfc29dafb3bbd7$var$ia) {
        var $e8dfc29dafb3bbd7$var$ye = "oninput" in document;
        if (!$e8dfc29dafb3bbd7$var$ye) {
            var $e8dfc29dafb3bbd7$var$ze = document.createElement("div");
            $e8dfc29dafb3bbd7$var$ze.setAttribute("oninput", "return;");
            $e8dfc29dafb3bbd7$var$ye = "function" === typeof $e8dfc29dafb3bbd7$var$ze.oninput;
        }
        $e8dfc29dafb3bbd7$var$xe = $e8dfc29dafb3bbd7$var$ye;
    } else $e8dfc29dafb3bbd7$var$xe = !1;
    $e8dfc29dafb3bbd7$var$we = $e8dfc29dafb3bbd7$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $e8dfc29dafb3bbd7$var$Ae() {
    $e8dfc29dafb3bbd7$var$pe && ($e8dfc29dafb3bbd7$var$pe.detachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be), $e8dfc29dafb3bbd7$var$qe = $e8dfc29dafb3bbd7$var$pe = null);
}
function $e8dfc29dafb3bbd7$var$Be(a) {
    if ("value" === a.propertyName && $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe)) {
        var b = [];
        $e8dfc29dafb3bbd7$var$ne(b, $e8dfc29dafb3bbd7$var$qe, a, $e8dfc29dafb3bbd7$var$xb(a));
        $e8dfc29dafb3bbd7$var$Jb($e8dfc29dafb3bbd7$var$re, b);
    }
}
function $e8dfc29dafb3bbd7$var$Ce(a, b, c) {
    "focusin" === a ? ($e8dfc29dafb3bbd7$var$Ae(), $e8dfc29dafb3bbd7$var$pe = b, $e8dfc29dafb3bbd7$var$qe = c, $e8dfc29dafb3bbd7$var$pe.attachEvent("onpropertychange", $e8dfc29dafb3bbd7$var$Be)) : "focusout" === a && $e8dfc29dafb3bbd7$var$Ae();
}
function $e8dfc29dafb3bbd7$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $e8dfc29dafb3bbd7$var$te($e8dfc29dafb3bbd7$var$qe);
}
function $e8dfc29dafb3bbd7$var$Ee(a, b) {
    if ("click" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $e8dfc29dafb3bbd7$var$te(b);
}
function $e8dfc29dafb3bbd7$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e8dfc29dafb3bbd7$var$He = "function" === typeof Object.is ? Object.is : $e8dfc29dafb3bbd7$var$Ge;
function $e8dfc29dafb3bbd7$var$Ie(a, b) {
    if ($e8dfc29dafb3bbd7$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$e8dfc29dafb3bbd7$var$ja.call(b, e) || !$e8dfc29dafb3bbd7$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $e8dfc29dafb3bbd7$var$Ke(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $e8dfc29dafb3bbd7$var$Je(c);
    }
}
function $e8dfc29dafb3bbd7$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $e8dfc29dafb3bbd7$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $e8dfc29dafb3bbd7$var$Me() {
    for(var a = window, b = $e8dfc29dafb3bbd7$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $e8dfc29dafb3bbd7$var$Xa(a.document);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $e8dfc29dafb3bbd7$var$Oe(a) {
    var b = $e8dfc29dafb3bbd7$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $e8dfc29dafb3bbd7$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $e8dfc29dafb3bbd7$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $e8dfc29dafb3bbd7$var$Ke(c, f);
                var g = $e8dfc29dafb3bbd7$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $e8dfc29dafb3bbd7$var$Pe = $e8dfc29dafb3bbd7$var$ia && "documentMode" in document && 11 >= document.documentMode, $e8dfc29dafb3bbd7$var$Qe = null, $e8dfc29dafb3bbd7$var$Re = null, $e8dfc29dafb3bbd7$var$Se = null, $e8dfc29dafb3bbd7$var$Te = !1;
function $e8dfc29dafb3bbd7$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $e8dfc29dafb3bbd7$var$Te || null == $e8dfc29dafb3bbd7$var$Qe || $e8dfc29dafb3bbd7$var$Qe !== $e8dfc29dafb3bbd7$var$Xa(d) || (d = $e8dfc29dafb3bbd7$var$Qe, "selectionStart" in d && $e8dfc29dafb3bbd7$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $e8dfc29dafb3bbd7$var$Se && $e8dfc29dafb3bbd7$var$Ie($e8dfc29dafb3bbd7$var$Se, d) || ($e8dfc29dafb3bbd7$var$Se = d, d = $e8dfc29dafb3bbd7$var$oe($e8dfc29dafb3bbd7$var$Re, "onSelect"), 0 < d.length && (b = new $e8dfc29dafb3bbd7$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $e8dfc29dafb3bbd7$var$Qe)));
}
function $e8dfc29dafb3bbd7$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $e8dfc29dafb3bbd7$var$We = {
    animationend: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationIteration"),
    animationstart: $e8dfc29dafb3bbd7$var$Ve("Animation", "AnimationStart"),
    transitionend: $e8dfc29dafb3bbd7$var$Ve("Transition", "TransitionEnd")
}, $e8dfc29dafb3bbd7$var$Xe = {}, $e8dfc29dafb3bbd7$var$Ye = {};
$e8dfc29dafb3bbd7$var$ia && ($e8dfc29dafb3bbd7$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $e8dfc29dafb3bbd7$var$We.animationend.animation, delete $e8dfc29dafb3bbd7$var$We.animationiteration.animation, delete $e8dfc29dafb3bbd7$var$We.animationstart.animation), "TransitionEvent" in window || delete $e8dfc29dafb3bbd7$var$We.transitionend.transition);
function $e8dfc29dafb3bbd7$var$Ze(a) {
    if ($e8dfc29dafb3bbd7$var$Xe[a]) return $e8dfc29dafb3bbd7$var$Xe[a];
    if (!$e8dfc29dafb3bbd7$var$We[a]) return a;
    var b = $e8dfc29dafb3bbd7$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $e8dfc29dafb3bbd7$var$Ye) return $e8dfc29dafb3bbd7$var$Xe[a] = b[c];
    return a;
}
var $e8dfc29dafb3bbd7$var$$e = $e8dfc29dafb3bbd7$var$Ze("animationend"), $e8dfc29dafb3bbd7$var$af = $e8dfc29dafb3bbd7$var$Ze("animationiteration"), $e8dfc29dafb3bbd7$var$bf = $e8dfc29dafb3bbd7$var$Ze("animationstart"), $e8dfc29dafb3bbd7$var$cf = $e8dfc29dafb3bbd7$var$Ze("transitionend"), $e8dfc29dafb3bbd7$var$df = new Map, $e8dfc29dafb3bbd7$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $e8dfc29dafb3bbd7$var$ff(a, b) {
    $e8dfc29dafb3bbd7$var$df.set(a, b);
    $e8dfc29dafb3bbd7$var$fa(b, [
        a
    ]);
}
for(var $e8dfc29dafb3bbd7$var$gf = 0; $e8dfc29dafb3bbd7$var$gf < $e8dfc29dafb3bbd7$var$ef.length; $e8dfc29dafb3bbd7$var$gf++){
    var $e8dfc29dafb3bbd7$var$hf = $e8dfc29dafb3bbd7$var$ef[$e8dfc29dafb3bbd7$var$gf], $e8dfc29dafb3bbd7$var$jf = $e8dfc29dafb3bbd7$var$hf.toLowerCase(), $e8dfc29dafb3bbd7$var$kf = $e8dfc29dafb3bbd7$var$hf[0].toUpperCase() + $e8dfc29dafb3bbd7$var$hf.slice(1);
    $e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$jf, "on" + $e8dfc29dafb3bbd7$var$kf);
}
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$$e, "onAnimationEnd");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$af, "onAnimationIteration");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$bf, "onAnimationStart");
$e8dfc29dafb3bbd7$var$ff("dblclick", "onDoubleClick");
$e8dfc29dafb3bbd7$var$ff("focusin", "onFocus");
$e8dfc29dafb3bbd7$var$ff("focusout", "onBlur");
$e8dfc29dafb3bbd7$var$ff($e8dfc29dafb3bbd7$var$cf, "onTransitionEnd");
$e8dfc29dafb3bbd7$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$e8dfc29dafb3bbd7$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$e8dfc29dafb3bbd7$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$e8dfc29dafb3bbd7$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$e8dfc29dafb3bbd7$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $e8dfc29dafb3bbd7$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $e8dfc29dafb3bbd7$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($e8dfc29dafb3bbd7$var$lf));
function $e8dfc29dafb3bbd7$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $e8dfc29dafb3bbd7$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $e8dfc29dafb3bbd7$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $e8dfc29dafb3bbd7$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($e8dfc29dafb3bbd7$var$Qb) throw a = $e8dfc29dafb3bbd7$var$Rb, $e8dfc29dafb3bbd7$var$Qb = !1, $e8dfc29dafb3bbd7$var$Rb = null, a;
}
function $e8dfc29dafb3bbd7$var$D(a, b) {
    var c = b[$e8dfc29dafb3bbd7$var$of];
    void 0 === c && (c = b[$e8dfc29dafb3bbd7$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($e8dfc29dafb3bbd7$var$pf(b, a, 2, !1), c.add(d));
}
function $e8dfc29dafb3bbd7$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $e8dfc29dafb3bbd7$var$pf(c, a, d, b);
}
var $e8dfc29dafb3bbd7$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $e8dfc29dafb3bbd7$var$sf(a) {
    if (!a[$e8dfc29dafb3bbd7$var$rf]) {
        a[$e8dfc29dafb3bbd7$var$rf] = !0;
        $e8dfc29dafb3bbd7$var$da.forEach(function(b) {
            "selectionchange" !== b && ($e8dfc29dafb3bbd7$var$mf.has(b) || $e8dfc29dafb3bbd7$var$qf(b, !1, a), $e8dfc29dafb3bbd7$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$e8dfc29dafb3bbd7$var$rf] || (b[$e8dfc29dafb3bbd7$var$rf] = !0, $e8dfc29dafb3bbd7$var$qf("selectionchange", !1, b));
    }
}
function $e8dfc29dafb3bbd7$var$pf(a, b, c, d) {
    switch($e8dfc29dafb3bbd7$var$jd(b)){
        case 1:
            var e = $e8dfc29dafb3bbd7$var$ed;
            break;
        case 4:
            e = $e8dfc29dafb3bbd7$var$gd;
            break;
        default:
            e = $e8dfc29dafb3bbd7$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$e8dfc29dafb3bbd7$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $e8dfc29dafb3bbd7$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $e8dfc29dafb3bbd7$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $e8dfc29dafb3bbd7$var$Jb(function() {
        var d = f, e = $e8dfc29dafb3bbd7$var$xb(c), g = [];
        a: {
            var h = $e8dfc29dafb3bbd7$var$df.get(a);
            if (void 0 !== h) {
                var k = $e8dfc29dafb3bbd7$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $e8dfc29dafb3bbd7$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $e8dfc29dafb3bbd7$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $e8dfc29dafb3bbd7$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $e8dfc29dafb3bbd7$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $e8dfc29dafb3bbd7$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $e8dfc29dafb3bbd7$var$Vd;
                        break;
                    case $e8dfc29dafb3bbd7$var$$e:
                    case $e8dfc29dafb3bbd7$var$af:
                    case $e8dfc29dafb3bbd7$var$bf:
                        k = $e8dfc29dafb3bbd7$var$Hd;
                        break;
                    case $e8dfc29dafb3bbd7$var$cf:
                        k = $e8dfc29dafb3bbd7$var$Xd;
                        break;
                    case "scroll":
                        k = $e8dfc29dafb3bbd7$var$vd;
                        break;
                    case "wheel":
                        k = $e8dfc29dafb3bbd7$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $e8dfc29dafb3bbd7$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $e8dfc29dafb3bbd7$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $e8dfc29dafb3bbd7$var$Kb(w, x), null != F && t.push($e8dfc29dafb3bbd7$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $e8dfc29dafb3bbd7$var$wb && (n = c.relatedTarget || c.fromElement) && ($e8dfc29dafb3bbd7$var$Wc(n) || n[$e8dfc29dafb3bbd7$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $e8dfc29dafb3bbd7$var$Wc(n) : null, null !== n && (J = $e8dfc29dafb3bbd7$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $e8dfc29dafb3bbd7$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $e8dfc29dafb3bbd7$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $e8dfc29dafb3bbd7$var$ue(k);
                        u = null == n ? h : $e8dfc29dafb3bbd7$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $e8dfc29dafb3bbd7$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $e8dfc29dafb3bbd7$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $e8dfc29dafb3bbd7$var$vf(F))u++;
                            for(; 0 < w - u;)t = $e8dfc29dafb3bbd7$var$vf(t), w--;
                            for(; 0 < u - w;)x = $e8dfc29dafb3bbd7$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $e8dfc29dafb3bbd7$var$vf(t);
                                x = $e8dfc29dafb3bbd7$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $e8dfc29dafb3bbd7$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $e8dfc29dafb3bbd7$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $e8dfc29dafb3bbd7$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $e8dfc29dafb3bbd7$var$ve;
                else if ($e8dfc29dafb3bbd7$var$me(h)) {
                    if ($e8dfc29dafb3bbd7$var$we) na = $e8dfc29dafb3bbd7$var$Fe;
                    else {
                        na = $e8dfc29dafb3bbd7$var$De;
                        var xa = $e8dfc29dafb3bbd7$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $e8dfc29dafb3bbd7$var$Ee);
                if (na && (na = na(a, d))) {
                    $e8dfc29dafb3bbd7$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $e8dfc29dafb3bbd7$var$cb(h, "number", h.value);
            }
            xa = d ? $e8dfc29dafb3bbd7$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($e8dfc29dafb3bbd7$var$me(xa) || "true" === xa.contentEditable) $e8dfc29dafb3bbd7$var$Qe = xa, $e8dfc29dafb3bbd7$var$Re = d, $e8dfc29dafb3bbd7$var$Se = null;
                    break;
                case "focusout":
                    $e8dfc29dafb3bbd7$var$Se = $e8dfc29dafb3bbd7$var$Re = $e8dfc29dafb3bbd7$var$Qe = null;
                    break;
                case "mousedown":
                    $e8dfc29dafb3bbd7$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $e8dfc29dafb3bbd7$var$Te = !1;
                    $e8dfc29dafb3bbd7$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($e8dfc29dafb3bbd7$var$Pe) break;
                case "keydown":
                case "keyup":
                    $e8dfc29dafb3bbd7$var$Ue(g, c, e);
            }
            var $a;
            if ($e8dfc29dafb3bbd7$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $e8dfc29dafb3bbd7$var$ie ? $e8dfc29dafb3bbd7$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($e8dfc29dafb3bbd7$var$de && "ko" !== c.locale && ($e8dfc29dafb3bbd7$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $e8dfc29dafb3bbd7$var$ie && ($a = $e8dfc29dafb3bbd7$var$nd()) : ($e8dfc29dafb3bbd7$var$kd = e, $e8dfc29dafb3bbd7$var$ld = "value" in $e8dfc29dafb3bbd7$var$kd ? $e8dfc29dafb3bbd7$var$kd.value : $e8dfc29dafb3bbd7$var$kd.textContent, $e8dfc29dafb3bbd7$var$ie = !0)), xa = $e8dfc29dafb3bbd7$var$oe(d, ba), 0 < xa.length && (ba = new $e8dfc29dafb3bbd7$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $e8dfc29dafb3bbd7$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $e8dfc29dafb3bbd7$var$ce ? $e8dfc29dafb3bbd7$var$je(a, c) : $e8dfc29dafb3bbd7$var$ke(a, c)) d = $e8dfc29dafb3bbd7$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $e8dfc29dafb3bbd7$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $e8dfc29dafb3bbd7$var$se(g, b);
    });
}
function $e8dfc29dafb3bbd7$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $e8dfc29dafb3bbd7$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $e8dfc29dafb3bbd7$var$Kb(a, c), null != f && d.unshift($e8dfc29dafb3bbd7$var$tf(a, f, e)), f = $e8dfc29dafb3bbd7$var$Kb(a, b), null != f && d.push($e8dfc29dafb3bbd7$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $e8dfc29dafb3bbd7$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $e8dfc29dafb3bbd7$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.unshift($e8dfc29dafb3bbd7$var$tf(c, k, h))) : e || (k = $e8dfc29dafb3bbd7$var$Kb(c, f), null != k && g.push($e8dfc29dafb3bbd7$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $e8dfc29dafb3bbd7$var$xf = /\r\n?/g, $e8dfc29dafb3bbd7$var$yf = /\u0000|\uFFFD/g;
function $e8dfc29dafb3bbd7$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($e8dfc29dafb3bbd7$var$xf, "\n").replace($e8dfc29dafb3bbd7$var$yf, "");
}
function $e8dfc29dafb3bbd7$var$Af(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$zf(b);
    if ($e8dfc29dafb3bbd7$var$zf(a) !== b && c) throw Error($e8dfc29dafb3bbd7$var$p(425));
}
function $e8dfc29dafb3bbd7$var$Bf() {}
var $e8dfc29dafb3bbd7$var$Cf = null, $e8dfc29dafb3bbd7$var$Df = null;
function $e8dfc29dafb3bbd7$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $e8dfc29dafb3bbd7$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $e8dfc29dafb3bbd7$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $e8dfc29dafb3bbd7$var$Hf = "function" === typeof Promise ? Promise : void 0, $e8dfc29dafb3bbd7$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $e8dfc29dafb3bbd7$var$Hf ? function(a) {
    return $e8dfc29dafb3bbd7$var$Hf.resolve(null).then(a).catch($e8dfc29dafb3bbd7$var$If);
} : $e8dfc29dafb3bbd7$var$Ff;
function $e8dfc29dafb3bbd7$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $e8dfc29dafb3bbd7$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $e8dfc29dafb3bbd7$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $e8dfc29dafb3bbd7$var$bd(b);
}
function $e8dfc29dafb3bbd7$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Nf = Math.random().toString(36).slice(2), $e8dfc29dafb3bbd7$var$Of = "__reactFiber$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Pf = "__reactProps$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$uf = "__reactContainer$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$of = "__reactEvents$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Qf = "__reactListeners$" + $e8dfc29dafb3bbd7$var$Nf, $e8dfc29dafb3bbd7$var$Rf = "__reactHandles$" + $e8dfc29dafb3bbd7$var$Nf;
function $e8dfc29dafb3bbd7$var$Wc(a) {
    var b = a[$e8dfc29dafb3bbd7$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$e8dfc29dafb3bbd7$var$uf] || c[$e8dfc29dafb3bbd7$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $e8dfc29dafb3bbd7$var$Mf(a); null !== a;){
                if (c = a[$e8dfc29dafb3bbd7$var$Of]) return c;
                a = $e8dfc29dafb3bbd7$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Cb(a) {
    a = a[$e8dfc29dafb3bbd7$var$Of] || a[$e8dfc29dafb3bbd7$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $e8dfc29dafb3bbd7$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($e8dfc29dafb3bbd7$var$p(33));
}
function $e8dfc29dafb3bbd7$var$Db(a) {
    return a[$e8dfc29dafb3bbd7$var$Pf] || null;
}
var $e8dfc29dafb3bbd7$var$Sf = [], $e8dfc29dafb3bbd7$var$Tf = -1;
function $e8dfc29dafb3bbd7$var$Uf(a) {
    return {
        current: a
    };
}
function $e8dfc29dafb3bbd7$var$E(a) {
    0 > $e8dfc29dafb3bbd7$var$Tf || (a.current = $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf], $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = null, $e8dfc29dafb3bbd7$var$Tf--);
}
function $e8dfc29dafb3bbd7$var$G(a, b) {
    $e8dfc29dafb3bbd7$var$Tf++;
    $e8dfc29dafb3bbd7$var$Sf[$e8dfc29dafb3bbd7$var$Tf] = a.current;
    a.current = b;
}
var $e8dfc29dafb3bbd7$var$Vf = {}, $e8dfc29dafb3bbd7$var$H = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$Vf), $e8dfc29dafb3bbd7$var$Wf = $e8dfc29dafb3bbd7$var$Uf(!1), $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$Vf;
function $e8dfc29dafb3bbd7$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $e8dfc29dafb3bbd7$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $e8dfc29dafb3bbd7$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $e8dfc29dafb3bbd7$var$$f() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
}
function $e8dfc29dafb3bbd7$var$ag(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$H.current !== $e8dfc29dafb3bbd7$var$Vf) throw Error($e8dfc29dafb3bbd7$var$p(168));
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
function $e8dfc29dafb3bbd7$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($e8dfc29dafb3bbd7$var$p(108, $e8dfc29dafb3bbd7$var$Ra(a) || "Unknown", e));
    return $e8dfc29dafb3bbd7$var$A({}, c, d);
}
function $e8dfc29dafb3bbd7$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $e8dfc29dafb3bbd7$var$Vf;
    $e8dfc29dafb3bbd7$var$Xf = $e8dfc29dafb3bbd7$var$H.current;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, $e8dfc29dafb3bbd7$var$Wf.current);
    return !0;
}
function $e8dfc29dafb3bbd7$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($e8dfc29dafb3bbd7$var$p(169));
    c ? (a = $e8dfc29dafb3bbd7$var$bg(a, b, $e8dfc29dafb3bbd7$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$H, a)) : $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wf, c);
}
var $e8dfc29dafb3bbd7$var$eg = null, $e8dfc29dafb3bbd7$var$fg = !1, $e8dfc29dafb3bbd7$var$gg = !1;
function $e8dfc29dafb3bbd7$var$hg(a) {
    null === $e8dfc29dafb3bbd7$var$eg ? $e8dfc29dafb3bbd7$var$eg = [
        a
    ] : $e8dfc29dafb3bbd7$var$eg.push(a);
}
function $e8dfc29dafb3bbd7$var$ig(a) {
    $e8dfc29dafb3bbd7$var$fg = !0;
    $e8dfc29dafb3bbd7$var$hg(a);
}
function $e8dfc29dafb3bbd7$var$jg() {
    if (!$e8dfc29dafb3bbd7$var$gg && null !== $e8dfc29dafb3bbd7$var$eg) {
        $e8dfc29dafb3bbd7$var$gg = !0;
        var a = 0, b = $e8dfc29dafb3bbd7$var$C;
        try {
            var c = $e8dfc29dafb3bbd7$var$eg;
            for($e8dfc29dafb3bbd7$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $e8dfc29dafb3bbd7$var$eg = null;
            $e8dfc29dafb3bbd7$var$fg = !1;
        } catch (e) {
            throw null !== $e8dfc29dafb3bbd7$var$eg && ($e8dfc29dafb3bbd7$var$eg = $e8dfc29dafb3bbd7$var$eg.slice(a + 1)), $e8dfc29dafb3bbd7$var$ac($e8dfc29dafb3bbd7$var$fc, $e8dfc29dafb3bbd7$var$jg), e;
        } finally{
            $e8dfc29dafb3bbd7$var$C = b, $e8dfc29dafb3bbd7$var$gg = !1;
        }
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$kg = [], $e8dfc29dafb3bbd7$var$lg = 0, $e8dfc29dafb3bbd7$var$mg = null, $e8dfc29dafb3bbd7$var$ng = 0, $e8dfc29dafb3bbd7$var$og = [], $e8dfc29dafb3bbd7$var$pg = 0, $e8dfc29dafb3bbd7$var$qg = null, $e8dfc29dafb3bbd7$var$rg = 1, $e8dfc29dafb3bbd7$var$sg = "";
function $e8dfc29dafb3bbd7$var$tg(a, b) {
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$ng;
    $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg++] = $e8dfc29dafb3bbd7$var$mg;
    $e8dfc29dafb3bbd7$var$mg = a;
    $e8dfc29dafb3bbd7$var$ng = b;
}
function $e8dfc29dafb3bbd7$var$ug(a, b, c) {
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg;
    $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg;
    $e8dfc29dafb3bbd7$var$qg = a;
    var d = $e8dfc29dafb3bbd7$var$rg;
    a = $e8dfc29dafb3bbd7$var$sg;
    var e = 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $e8dfc29dafb3bbd7$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $e8dfc29dafb3bbd7$var$rg = 1 << 32 - $e8dfc29dafb3bbd7$var$oc(b) + e | c << e | d;
        $e8dfc29dafb3bbd7$var$sg = f + a;
    } else $e8dfc29dafb3bbd7$var$rg = 1 << f | c << e | d, $e8dfc29dafb3bbd7$var$sg = a;
}
function $e8dfc29dafb3bbd7$var$vg(a) {
    null !== a.return && ($e8dfc29dafb3bbd7$var$tg(a, 1), $e8dfc29dafb3bbd7$var$ug(a, 1, 0));
}
function $e8dfc29dafb3bbd7$var$wg(a) {
    for(; a === $e8dfc29dafb3bbd7$var$mg;)$e8dfc29dafb3bbd7$var$mg = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null, $e8dfc29dafb3bbd7$var$ng = $e8dfc29dafb3bbd7$var$kg[--$e8dfc29dafb3bbd7$var$lg], $e8dfc29dafb3bbd7$var$kg[$e8dfc29dafb3bbd7$var$lg] = null;
    for(; a === $e8dfc29dafb3bbd7$var$qg;)$e8dfc29dafb3bbd7$var$qg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$sg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null, $e8dfc29dafb3bbd7$var$rg = $e8dfc29dafb3bbd7$var$og[--$e8dfc29dafb3bbd7$var$pg], $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg] = null;
}
var $e8dfc29dafb3bbd7$var$xg = null, $e8dfc29dafb3bbd7$var$yg = null, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$zg = null;
function $e8dfc29dafb3bbd7$var$Ag(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $e8dfc29dafb3bbd7$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $e8dfc29dafb3bbd7$var$qg ? {
                id: $e8dfc29dafb3bbd7$var$rg,
                overflow: $e8dfc29dafb3bbd7$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $e8dfc29dafb3bbd7$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $e8dfc29dafb3bbd7$var$xg = a, $e8dfc29dafb3bbd7$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $e8dfc29dafb3bbd7$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $e8dfc29dafb3bbd7$var$Eg(a) {
    if ($e8dfc29dafb3bbd7$var$I) {
        var b = $e8dfc29dafb3bbd7$var$yg;
        if (b) {
            var c = b;
            if (!$e8dfc29dafb3bbd7$var$Cg(a, b)) {
                if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
                b = $e8dfc29dafb3bbd7$var$Lf(c.nextSibling);
                var d = $e8dfc29dafb3bbd7$var$xg;
                b && $e8dfc29dafb3bbd7$var$Cg(a, b) ? $e8dfc29dafb3bbd7$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $e8dfc29dafb3bbd7$var$I = !1, $e8dfc29dafb3bbd7$var$xg = a);
            }
        } else {
            if ($e8dfc29dafb3bbd7$var$Dg(a)) throw Error($e8dfc29dafb3bbd7$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $e8dfc29dafb3bbd7$var$I = !1;
            $e8dfc29dafb3bbd7$var$xg = a;
        }
    }
}
function $e8dfc29dafb3bbd7$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $e8dfc29dafb3bbd7$var$xg = a;
}
function $e8dfc29dafb3bbd7$var$Gg(a) {
    if (a !== $e8dfc29dafb3bbd7$var$xg) return !1;
    if (!$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$Fg(a), $e8dfc29dafb3bbd7$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$e8dfc29dafb3bbd7$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $e8dfc29dafb3bbd7$var$yg)) {
        if ($e8dfc29dafb3bbd7$var$Dg(a)) throw $e8dfc29dafb3bbd7$var$Hg(), Error($e8dfc29dafb3bbd7$var$p(418));
        for(; b;)$e8dfc29dafb3bbd7$var$Ag(a, b), b = $e8dfc29dafb3bbd7$var$Lf(b.nextSibling);
    }
    $e8dfc29dafb3bbd7$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($e8dfc29dafb3bbd7$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $e8dfc29dafb3bbd7$var$yg = null;
        }
    } else $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg ? $e8dfc29dafb3bbd7$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Hg() {
    for(var a = $e8dfc29dafb3bbd7$var$yg; a;)a = $e8dfc29dafb3bbd7$var$Lf(a.nextSibling);
}
function $e8dfc29dafb3bbd7$var$Ig() {
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$xg = null;
    $e8dfc29dafb3bbd7$var$I = !1;
}
function $e8dfc29dafb3bbd7$var$Jg(a) {
    null === $e8dfc29dafb3bbd7$var$zg ? $e8dfc29dafb3bbd7$var$zg = [
        a
    ] : $e8dfc29dafb3bbd7$var$zg.push(a);
}
var $e8dfc29dafb3bbd7$var$Kg = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig;
function $e8dfc29dafb3bbd7$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($e8dfc29dafb3bbd7$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($e8dfc29dafb3bbd7$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($e8dfc29dafb3bbd7$var$p(284));
        if (!c._owner) throw Error($e8dfc29dafb3bbd7$var$p(290, a));
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($e8dfc29dafb3bbd7$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $e8dfc29dafb3bbd7$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $e8dfc29dafb3bbd7$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $e8dfc29dafb3bbd7$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $e8dfc29dafb3bbd7$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $e8dfc29dafb3bbd7$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $e8dfc29dafb3bbd7$var$Lg(a, b, c), d.return = a, d;
        d = $e8dfc29dafb3bbd7$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $e8dfc29dafb3bbd7$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $e8dfc29dafb3bbd7$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $e8dfc29dafb3bbd7$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $e8dfc29dafb3bbd7$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c = $e8dfc29dafb3bbd7$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $e8dfc29dafb3bbd7$var$Lg(a, null, b), c.return = a, c;
                case $e8dfc29dafb3bbd7$var$wa:
                    return b = $e8dfc29dafb3bbd7$var$Sg(b, a.mode, c), b.return = a, b;
                case $e8dfc29dafb3bbd7$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($e8dfc29dafb3bbd7$var$eb(b) || $e8dfc29dafb3bbd7$var$Ka(b)) return b = $e8dfc29dafb3bbd7$var$Tg(b, a.mode, c, null), b.return = a, b;
            $e8dfc29dafb3bbd7$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $e8dfc29dafb3bbd7$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($e8dfc29dafb3bbd7$var$eb(c) || $e8dfc29dafb3bbd7$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $e8dfc29dafb3bbd7$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $e8dfc29dafb3bbd7$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($e8dfc29dafb3bbd7$var$eb(d) || $e8dfc29dafb3bbd7$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $e8dfc29dafb3bbd7$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $e8dfc29dafb3bbd7$var$Ka(h);
        if ("function" !== typeof l) throw Error($e8dfc29dafb3bbd7$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($e8dfc29dafb3bbd7$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $e8dfc29dafb3bbd7$var$I && $e8dfc29dafb3bbd7$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $e8dfc29dafb3bbd7$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $e8dfc29dafb3bbd7$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $e8dfc29dafb3bbd7$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $e8dfc29dafb3bbd7$var$Ha && $e8dfc29dafb3bbd7$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $e8dfc29dafb3bbd7$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $e8dfc29dafb3bbd7$var$ya ? (d = $e8dfc29dafb3bbd7$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $e8dfc29dafb3bbd7$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $e8dfc29dafb3bbd7$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $e8dfc29dafb3bbd7$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $e8dfc29dafb3bbd7$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($e8dfc29dafb3bbd7$var$eb(f)) return n(a, d, f, h);
            if ($e8dfc29dafb3bbd7$var$Ka(f)) return t(a, d, f, h);
            $e8dfc29dafb3bbd7$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $e8dfc29dafb3bbd7$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $e8dfc29dafb3bbd7$var$Ug = $e8dfc29dafb3bbd7$var$Og(!0), $e8dfc29dafb3bbd7$var$Vg = $e8dfc29dafb3bbd7$var$Og(!1), $e8dfc29dafb3bbd7$var$Wg = $e8dfc29dafb3bbd7$var$Uf(null), $e8dfc29dafb3bbd7$var$Xg = null, $e8dfc29dafb3bbd7$var$Yg = null, $e8dfc29dafb3bbd7$var$Zg = null;
function $e8dfc29dafb3bbd7$var$$g() {
    $e8dfc29dafb3bbd7$var$Zg = $e8dfc29dafb3bbd7$var$Yg = $e8dfc29dafb3bbd7$var$Xg = null;
}
function $e8dfc29dafb3bbd7$var$ah(a) {
    var b = $e8dfc29dafb3bbd7$var$Wg.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wg);
    a._currentValue = b;
}
function $e8dfc29dafb3bbd7$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $e8dfc29dafb3bbd7$var$ch(a, b) {
    $e8dfc29dafb3bbd7$var$Xg = a;
    $e8dfc29dafb3bbd7$var$Zg = $e8dfc29dafb3bbd7$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($e8dfc29dafb3bbd7$var$dh = !0), a.firstContext = null);
}
function $e8dfc29dafb3bbd7$var$eh(a) {
    var b = a._currentValue;
    if ($e8dfc29dafb3bbd7$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $e8dfc29dafb3bbd7$var$Yg) {
            if (null === $e8dfc29dafb3bbd7$var$Xg) throw Error($e8dfc29dafb3bbd7$var$p(308));
            $e8dfc29dafb3bbd7$var$Yg = a;
            $e8dfc29dafb3bbd7$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $e8dfc29dafb3bbd7$var$Yg = $e8dfc29dafb3bbd7$var$Yg.next = a;
    }
    return b;
}
var $e8dfc29dafb3bbd7$var$fh = null;
function $e8dfc29dafb3bbd7$var$gh(a) {
    null === $e8dfc29dafb3bbd7$var$fh ? $e8dfc29dafb3bbd7$var$fh = [
        a
    ] : $e8dfc29dafb3bbd7$var$fh.push(a);
}
function $e8dfc29dafb3bbd7$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $e8dfc29dafb3bbd7$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $e8dfc29dafb3bbd7$var$ih(a, d);
}
function $e8dfc29dafb3bbd7$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $e8dfc29dafb3bbd7$var$jh = !1;
function $e8dfc29dafb3bbd7$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $e8dfc29dafb3bbd7$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $e8dfc29dafb3bbd7$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $e8dfc29dafb3bbd7$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $e8dfc29dafb3bbd7$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $e8dfc29dafb3bbd7$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $e8dfc29dafb3bbd7$var$ih(a, c);
}
function $e8dfc29dafb3bbd7$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
function $e8dfc29dafb3bbd7$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $e8dfc29dafb3bbd7$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $e8dfc29dafb3bbd7$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $e8dfc29dafb3bbd7$var$A({}, q, r);
                            break a;
                        case 2:
                            $e8dfc29dafb3bbd7$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $e8dfc29dafb3bbd7$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $e8dfc29dafb3bbd7$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($e8dfc29dafb3bbd7$var$p(191, e));
            e.call(d);
        }
    }
}
var $e8dfc29dafb3bbd7$var$th = {}, $e8dfc29dafb3bbd7$var$uh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$th), $e8dfc29dafb3bbd7$var$vh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$th), $e8dfc29dafb3bbd7$var$wh = $e8dfc29dafb3bbd7$var$Uf($e8dfc29dafb3bbd7$var$th);
function $e8dfc29dafb3bbd7$var$xh(a) {
    if (a === $e8dfc29dafb3bbd7$var$th) throw Error($e8dfc29dafb3bbd7$var$p(174));
    return a;
}
function $e8dfc29dafb3bbd7$var$yh(a, b) {
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$wh, b);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$vh, a);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$uh, $e8dfc29dafb3bbd7$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $e8dfc29dafb3bbd7$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $e8dfc29dafb3bbd7$var$lb(b, a);
    }
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$uh);
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$uh, b);
}
function $e8dfc29dafb3bbd7$var$zh() {
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$uh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$vh);
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$wh);
}
function $e8dfc29dafb3bbd7$var$Ah(a) {
    $e8dfc29dafb3bbd7$var$xh($e8dfc29dafb3bbd7$var$wh.current);
    var b = $e8dfc29dafb3bbd7$var$xh($e8dfc29dafb3bbd7$var$uh.current);
    var c = $e8dfc29dafb3bbd7$var$lb(b, a.type);
    b !== c && ($e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$vh, a), $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$uh, c));
}
function $e8dfc29dafb3bbd7$var$Bh(a) {
    $e8dfc29dafb3bbd7$var$vh.current === a && ($e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$uh), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$vh));
}
var $e8dfc29dafb3bbd7$var$L = $e8dfc29dafb3bbd7$var$Uf(0);
function $e8dfc29dafb3bbd7$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $e8dfc29dafb3bbd7$var$Dh = [];
function $e8dfc29dafb3bbd7$var$Eh() {
    for(var a = 0; a < $e8dfc29dafb3bbd7$var$Dh.length; a++)$e8dfc29dafb3bbd7$var$Dh[a]._workInProgressVersionPrimary = null;
    $e8dfc29dafb3bbd7$var$Dh.length = 0;
}
var $e8dfc29dafb3bbd7$var$Fh = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$Gh = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$Hh = 0, $e8dfc29dafb3bbd7$var$M = null, $e8dfc29dafb3bbd7$var$N = null, $e8dfc29dafb3bbd7$var$O = null, $e8dfc29dafb3bbd7$var$Ih = !1, $e8dfc29dafb3bbd7$var$Jh = !1, $e8dfc29dafb3bbd7$var$Kh = 0, $e8dfc29dafb3bbd7$var$Lh = 0;
function $e8dfc29dafb3bbd7$var$P() {
    throw Error($e8dfc29dafb3bbd7$var$p(321));
}
function $e8dfc29dafb3bbd7$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e8dfc29dafb3bbd7$var$He(a[c], b[c])) return !1;
    return !0;
}
function $e8dfc29dafb3bbd7$var$Nh(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$Hh = f;
    $e8dfc29dafb3bbd7$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $e8dfc29dafb3bbd7$var$Fh.current = null === a || null === a.memoizedState ? $e8dfc29dafb3bbd7$var$Oh : $e8dfc29dafb3bbd7$var$Ph;
    a = c(d, e);
    if ($e8dfc29dafb3bbd7$var$Jh) {
        f = 0;
        do {
            $e8dfc29dafb3bbd7$var$Jh = !1;
            $e8dfc29dafb3bbd7$var$Kh = 0;
            if (25 <= f) throw Error($e8dfc29dafb3bbd7$var$p(301));
            f += 1;
            $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = null;
            b.updateQueue = null;
            $e8dfc29dafb3bbd7$var$Fh.current = $e8dfc29dafb3bbd7$var$Qh;
            a = c(d, e);
        }while ($e8dfc29dafb3bbd7$var$Jh);
    }
    $e8dfc29dafb3bbd7$var$Fh.current = $e8dfc29dafb3bbd7$var$Rh;
    b = null !== $e8dfc29dafb3bbd7$var$N && null !== $e8dfc29dafb3bbd7$var$N.next;
    $e8dfc29dafb3bbd7$var$Hh = 0;
    $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = $e8dfc29dafb3bbd7$var$M = null;
    $e8dfc29dafb3bbd7$var$Ih = !1;
    if (b) throw Error($e8dfc29dafb3bbd7$var$p(300));
    return a;
}
function $e8dfc29dafb3bbd7$var$Sh() {
    var a = 0 !== $e8dfc29dafb3bbd7$var$Kh;
    $e8dfc29dafb3bbd7$var$Kh = 0;
    return a;
}
function $e8dfc29dafb3bbd7$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $e8dfc29dafb3bbd7$var$O ? $e8dfc29dafb3bbd7$var$M.memoizedState = $e8dfc29dafb3bbd7$var$O = a : $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$O.next = a;
    return $e8dfc29dafb3bbd7$var$O;
}
function $e8dfc29dafb3bbd7$var$Uh() {
    if (null === $e8dfc29dafb3bbd7$var$N) {
        var a = $e8dfc29dafb3bbd7$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $e8dfc29dafb3bbd7$var$N.next;
    var b = null === $e8dfc29dafb3bbd7$var$O ? $e8dfc29dafb3bbd7$var$M.memoizedState : $e8dfc29dafb3bbd7$var$O.next;
    if (null !== b) $e8dfc29dafb3bbd7$var$O = b, $e8dfc29dafb3bbd7$var$N = a;
    else {
        if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(310));
        $e8dfc29dafb3bbd7$var$N = a;
        a = {
            memoizedState: $e8dfc29dafb3bbd7$var$N.memoizedState,
            baseState: $e8dfc29dafb3bbd7$var$N.baseState,
            baseQueue: $e8dfc29dafb3bbd7$var$N.baseQueue,
            queue: $e8dfc29dafb3bbd7$var$N.queue,
            next: null
        };
        null === $e8dfc29dafb3bbd7$var$O ? $e8dfc29dafb3bbd7$var$M.memoizedState = $e8dfc29dafb3bbd7$var$O = a : $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$O.next = a;
    }
    return $e8dfc29dafb3bbd7$var$O;
}
function $e8dfc29dafb3bbd7$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $e8dfc29dafb3bbd7$var$Wh(a) {
    var b = $e8dfc29dafb3bbd7$var$Uh(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = $e8dfc29dafb3bbd7$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($e8dfc29dafb3bbd7$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $e8dfc29dafb3bbd7$var$M.lanes |= m;
                $e8dfc29dafb3bbd7$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $e8dfc29dafb3bbd7$var$He(d, b.memoizedState) || ($e8dfc29dafb3bbd7$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $e8dfc29dafb3bbd7$var$M.lanes |= f, $e8dfc29dafb3bbd7$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $e8dfc29dafb3bbd7$var$Xh(a) {
    var b = $e8dfc29dafb3bbd7$var$Uh(), c = b.queue;
    if (null === c) throw Error($e8dfc29dafb3bbd7$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e8dfc29dafb3bbd7$var$He(f, b.memoizedState) || ($e8dfc29dafb3bbd7$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $e8dfc29dafb3bbd7$var$Yh() {}
function $e8dfc29dafb3bbd7$var$Zh(a, b) {
    var c = $e8dfc29dafb3bbd7$var$M, d = $e8dfc29dafb3bbd7$var$Uh(), e = b(), f = !$e8dfc29dafb3bbd7$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $e8dfc29dafb3bbd7$var$dh = !0);
    d = d.queue;
    $e8dfc29dafb3bbd7$var$$h($e8dfc29dafb3bbd7$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $e8dfc29dafb3bbd7$var$O && $e8dfc29dafb3bbd7$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $e8dfc29dafb3bbd7$var$bi(9, $e8dfc29dafb3bbd7$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $e8dfc29dafb3bbd7$var$Q) throw Error($e8dfc29dafb3bbd7$var$p(349));
        0 !== ($e8dfc29dafb3bbd7$var$Hh & 30) || $e8dfc29dafb3bbd7$var$di(c, b, e);
    }
    return e;
}
function $e8dfc29dafb3bbd7$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $e8dfc29dafb3bbd7$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $e8dfc29dafb3bbd7$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $e8dfc29dafb3bbd7$var$ei(b) && $e8dfc29dafb3bbd7$var$fi(a);
}
function $e8dfc29dafb3bbd7$var$ai(a, b, c) {
    return c(function() {
        $e8dfc29dafb3bbd7$var$ei(b) && $e8dfc29dafb3bbd7$var$fi(a);
    });
}
function $e8dfc29dafb3bbd7$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$e8dfc29dafb3bbd7$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $e8dfc29dafb3bbd7$var$fi(a) {
    var b = $e8dfc29dafb3bbd7$var$ih(a, 1);
    null !== b && $e8dfc29dafb3bbd7$var$gi(b, a, 1, -1);
}
function $e8dfc29dafb3bbd7$var$hi(a) {
    var b = $e8dfc29dafb3bbd7$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $e8dfc29dafb3bbd7$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $e8dfc29dafb3bbd7$var$ii.bind(null, $e8dfc29dafb3bbd7$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $e8dfc29dafb3bbd7$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $e8dfc29dafb3bbd7$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $e8dfc29dafb3bbd7$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $e8dfc29dafb3bbd7$var$ji() {
    return $e8dfc29dafb3bbd7$var$Uh().memoizedState;
}
function $e8dfc29dafb3bbd7$var$ki(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$Th();
    $e8dfc29dafb3bbd7$var$M.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $e8dfc29dafb3bbd7$var$li(a, b, c, d) {
    var e = $e8dfc29dafb3bbd7$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $e8dfc29dafb3bbd7$var$N) {
        var g = $e8dfc29dafb3bbd7$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $e8dfc29dafb3bbd7$var$Mh(d, g.deps)) {
            e.memoizedState = $e8dfc29dafb3bbd7$var$bi(b, c, f, d);
            return;
        }
    }
    $e8dfc29dafb3bbd7$var$M.flags |= a;
    e.memoizedState = $e8dfc29dafb3bbd7$var$bi(1 | b, c, f, d);
}
function $e8dfc29dafb3bbd7$var$mi(a, b) {
    return $e8dfc29dafb3bbd7$var$ki(8390656, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$$h(a, b) {
    return $e8dfc29dafb3bbd7$var$li(2048, 8, a, b);
}
function $e8dfc29dafb3bbd7$var$ni(a, b) {
    return $e8dfc29dafb3bbd7$var$li(4, 2, a, b);
}
function $e8dfc29dafb3bbd7$var$oi(a, b) {
    return $e8dfc29dafb3bbd7$var$li(4, 4, a, b);
}
function $e8dfc29dafb3bbd7$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $e8dfc29dafb3bbd7$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $e8dfc29dafb3bbd7$var$li(4, 4, $e8dfc29dafb3bbd7$var$pi.bind(null, b, a), c);
}
function $e8dfc29dafb3bbd7$var$ri() {}
function $e8dfc29dafb3bbd7$var$si(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$ti(a, b) {
    var c = $e8dfc29dafb3bbd7$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $e8dfc29dafb3bbd7$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $e8dfc29dafb3bbd7$var$ui(a, b, c) {
    if (0 === ($e8dfc29dafb3bbd7$var$Hh & 21)) return a.baseState && (a.baseState = !1, $e8dfc29dafb3bbd7$var$dh = !0), a.memoizedState = c;
    $e8dfc29dafb3bbd7$var$He(c, b) || (c = $e8dfc29dafb3bbd7$var$yc(), $e8dfc29dafb3bbd7$var$M.lanes |= c, $e8dfc29dafb3bbd7$var$rh |= c, a.baseState = !0);
    return b;
}
function $e8dfc29dafb3bbd7$var$vi(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    $e8dfc29dafb3bbd7$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $e8dfc29dafb3bbd7$var$Gh.transition;
    $e8dfc29dafb3bbd7$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$Gh.transition = d;
    }
}
function $e8dfc29dafb3bbd7$var$wi() {
    return $e8dfc29dafb3bbd7$var$Uh().memoizedState;
}
function $e8dfc29dafb3bbd7$var$xi(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$zi(a)) $e8dfc29dafb3bbd7$var$Ai(b, c);
    else if (c = $e8dfc29dafb3bbd7$var$hh(a, b, c, d), null !== c) {
        var e = $e8dfc29dafb3bbd7$var$R();
        $e8dfc29dafb3bbd7$var$gi(c, a, d, e);
        $e8dfc29dafb3bbd7$var$Bi(c, b, d);
    }
}
function $e8dfc29dafb3bbd7$var$ii(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($e8dfc29dafb3bbd7$var$zi(a)) $e8dfc29dafb3bbd7$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($e8dfc29dafb3bbd7$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $e8dfc29dafb3bbd7$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $e8dfc29dafb3bbd7$var$hh(a, b, e, d);
        null !== c && (e = $e8dfc29dafb3bbd7$var$R(), $e8dfc29dafb3bbd7$var$gi(c, a, d, e), $e8dfc29dafb3bbd7$var$Bi(c, b, d));
    }
}
function $e8dfc29dafb3bbd7$var$zi(a) {
    var b = a.alternate;
    return a === $e8dfc29dafb3bbd7$var$M || null !== b && b === $e8dfc29dafb3bbd7$var$M;
}
function $e8dfc29dafb3bbd7$var$Ai(a, b) {
    $e8dfc29dafb3bbd7$var$Jh = $e8dfc29dafb3bbd7$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $e8dfc29dafb3bbd7$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $e8dfc29dafb3bbd7$var$Cc(a, c);
    }
}
var $e8dfc29dafb3bbd7$var$Rh = {
    readContext: $e8dfc29dafb3bbd7$var$eh,
    useCallback: $e8dfc29dafb3bbd7$var$P,
    useContext: $e8dfc29dafb3bbd7$var$P,
    useEffect: $e8dfc29dafb3bbd7$var$P,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$P,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$P,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$P,
    useMemo: $e8dfc29dafb3bbd7$var$P,
    useReducer: $e8dfc29dafb3bbd7$var$P,
    useRef: $e8dfc29dafb3bbd7$var$P,
    useState: $e8dfc29dafb3bbd7$var$P,
    useDebugValue: $e8dfc29dafb3bbd7$var$P,
    useDeferredValue: $e8dfc29dafb3bbd7$var$P,
    useTransition: $e8dfc29dafb3bbd7$var$P,
    useMutableSource: $e8dfc29dafb3bbd7$var$P,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$P,
    useId: $e8dfc29dafb3bbd7$var$P,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Oh = {
    readContext: $e8dfc29dafb3bbd7$var$eh,
    useCallback: function(a, b) {
        $e8dfc29dafb3bbd7$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $e8dfc29dafb3bbd7$var$eh,
    useEffect: $e8dfc29dafb3bbd7$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $e8dfc29dafb3bbd7$var$ki(4194308, 4, $e8dfc29dafb3bbd7$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $e8dfc29dafb3bbd7$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $e8dfc29dafb3bbd7$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $e8dfc29dafb3bbd7$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $e8dfc29dafb3bbd7$var$xi.bind(null, $e8dfc29dafb3bbd7$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $e8dfc29dafb3bbd7$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $e8dfc29dafb3bbd7$var$hi,
    useDebugValue: $e8dfc29dafb3bbd7$var$ri,
    useDeferredValue: function(a) {
        return $e8dfc29dafb3bbd7$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$hi(!1), b = a[0];
        a = $e8dfc29dafb3bbd7$var$vi.bind(null, a[1]);
        $e8dfc29dafb3bbd7$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $e8dfc29dafb3bbd7$var$M, e = $e8dfc29dafb3bbd7$var$Th();
        if ($e8dfc29dafb3bbd7$var$I) {
            if (void 0 === c) throw Error($e8dfc29dafb3bbd7$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $e8dfc29dafb3bbd7$var$Q) throw Error($e8dfc29dafb3bbd7$var$p(349));
            0 !== ($e8dfc29dafb3bbd7$var$Hh & 30) || $e8dfc29dafb3bbd7$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $e8dfc29dafb3bbd7$var$mi($e8dfc29dafb3bbd7$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $e8dfc29dafb3bbd7$var$bi(9, $e8dfc29dafb3bbd7$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $e8dfc29dafb3bbd7$var$Th(), b = $e8dfc29dafb3bbd7$var$Q.identifierPrefix;
        if ($e8dfc29dafb3bbd7$var$I) {
            var c = $e8dfc29dafb3bbd7$var$sg;
            var d = $e8dfc29dafb3bbd7$var$rg;
            c = (d & ~(1 << 32 - $e8dfc29dafb3bbd7$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $e8dfc29dafb3bbd7$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $e8dfc29dafb3bbd7$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Ph = {
    readContext: $e8dfc29dafb3bbd7$var$eh,
    useCallback: $e8dfc29dafb3bbd7$var$si,
    useContext: $e8dfc29dafb3bbd7$var$eh,
    useEffect: $e8dfc29dafb3bbd7$var$$h,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$qi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$ni,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$oi,
    useMemo: $e8dfc29dafb3bbd7$var$ti,
    useReducer: $e8dfc29dafb3bbd7$var$Wh,
    useRef: $e8dfc29dafb3bbd7$var$ji,
    useState: function() {
        return $e8dfc29dafb3bbd7$var$Wh($e8dfc29dafb3bbd7$var$Vh);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$ri,
    useDeferredValue: function(a) {
        var b = $e8dfc29dafb3bbd7$var$Uh();
        return $e8dfc29dafb3bbd7$var$ui(b, $e8dfc29dafb3bbd7$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$Wh($e8dfc29dafb3bbd7$var$Vh)[0], b = $e8dfc29dafb3bbd7$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$Yh,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$Zh,
    useId: $e8dfc29dafb3bbd7$var$wi,
    unstable_isNewReconciler: !1
}, $e8dfc29dafb3bbd7$var$Qh = {
    readContext: $e8dfc29dafb3bbd7$var$eh,
    useCallback: $e8dfc29dafb3bbd7$var$si,
    useContext: $e8dfc29dafb3bbd7$var$eh,
    useEffect: $e8dfc29dafb3bbd7$var$$h,
    useImperativeHandle: $e8dfc29dafb3bbd7$var$qi,
    useInsertionEffect: $e8dfc29dafb3bbd7$var$ni,
    useLayoutEffect: $e8dfc29dafb3bbd7$var$oi,
    useMemo: $e8dfc29dafb3bbd7$var$ti,
    useReducer: $e8dfc29dafb3bbd7$var$Xh,
    useRef: $e8dfc29dafb3bbd7$var$ji,
    useState: function() {
        return $e8dfc29dafb3bbd7$var$Xh($e8dfc29dafb3bbd7$var$Vh);
    },
    useDebugValue: $e8dfc29dafb3bbd7$var$ri,
    useDeferredValue: function(a) {
        var b = $e8dfc29dafb3bbd7$var$Uh();
        return null === $e8dfc29dafb3bbd7$var$N ? b.memoizedState = a : $e8dfc29dafb3bbd7$var$ui(b, $e8dfc29dafb3bbd7$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $e8dfc29dafb3bbd7$var$Xh($e8dfc29dafb3bbd7$var$Vh)[0], b = $e8dfc29dafb3bbd7$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $e8dfc29dafb3bbd7$var$Yh,
    useSyncExternalStore: $e8dfc29dafb3bbd7$var$Zh,
    useId: $e8dfc29dafb3bbd7$var$wi,
    unstable_isNewReconciler: !1
};
function $e8dfc29dafb3bbd7$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $e8dfc29dafb3bbd7$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $e8dfc29dafb3bbd7$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $e8dfc29dafb3bbd7$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $e8dfc29dafb3bbd7$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$R(), e = $e8dfc29dafb3bbd7$var$yi(a), f = $e8dfc29dafb3bbd7$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$nh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$gi(b, a, e, d), $e8dfc29dafb3bbd7$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $e8dfc29dafb3bbd7$var$R(), e = $e8dfc29dafb3bbd7$var$yi(a), f = $e8dfc29dafb3bbd7$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $e8dfc29dafb3bbd7$var$nh(a, f, e);
        null !== b && ($e8dfc29dafb3bbd7$var$gi(b, a, e, d), $e8dfc29dafb3bbd7$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $e8dfc29dafb3bbd7$var$R(), d = $e8dfc29dafb3bbd7$var$yi(a), e = $e8dfc29dafb3bbd7$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $e8dfc29dafb3bbd7$var$nh(a, e, d);
        null !== b && ($e8dfc29dafb3bbd7$var$gi(b, a, d, c), $e8dfc29dafb3bbd7$var$oh(b, a, d));
    }
};
function $e8dfc29dafb3bbd7$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$e8dfc29dafb3bbd7$var$Ie(c, d) || !$e8dfc29dafb3bbd7$var$Ie(e, f) : !0;
}
function $e8dfc29dafb3bbd7$var$Gi(a, b, c) {
    var d = !1, e = $e8dfc29dafb3bbd7$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $e8dfc29dafb3bbd7$var$eh(f) : (e = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $e8dfc29dafb3bbd7$var$Yf(a, e) : $e8dfc29dafb3bbd7$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $e8dfc29dafb3bbd7$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $e8dfc29dafb3bbd7$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $e8dfc29dafb3bbd7$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $e8dfc29dafb3bbd7$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $e8dfc29dafb3bbd7$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $e8dfc29dafb3bbd7$var$eh(f) : (f = $e8dfc29dafb3bbd7$var$Zf(b) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, e.context = $e8dfc29dafb3bbd7$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($e8dfc29dafb3bbd7$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $e8dfc29dafb3bbd7$var$Ei.enqueueReplaceState(e, e.state, null), $e8dfc29dafb3bbd7$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $e8dfc29dafb3bbd7$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $e8dfc29dafb3bbd7$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $e8dfc29dafb3bbd7$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $e8dfc29dafb3bbd7$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $e8dfc29dafb3bbd7$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $e8dfc29dafb3bbd7$var$Ni(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $e8dfc29dafb3bbd7$var$Oi || ($e8dfc29dafb3bbd7$var$Oi = !0, $e8dfc29dafb3bbd7$var$Pi = d);
        $e8dfc29dafb3bbd7$var$Li(a, b);
    };
    return c;
}
function $e8dfc29dafb3bbd7$var$Qi(a, b, c) {
    c = $e8dfc29dafb3bbd7$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $e8dfc29dafb3bbd7$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $e8dfc29dafb3bbd7$var$Li(a, b);
        "function" !== typeof d && (null === $e8dfc29dafb3bbd7$var$Ri ? $e8dfc29dafb3bbd7$var$Ri = new Set([
            this
        ]) : $e8dfc29dafb3bbd7$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $e8dfc29dafb3bbd7$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $e8dfc29dafb3bbd7$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $e8dfc29dafb3bbd7$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $e8dfc29dafb3bbd7$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $e8dfc29dafb3bbd7$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $e8dfc29dafb3bbd7$var$mh(-1, 1), b.tag = 2, $e8dfc29dafb3bbd7$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $e8dfc29dafb3bbd7$var$Wi = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$dh = !1;
function $e8dfc29dafb3bbd7$var$Xi(a, b, c, d) {
    b.child = null === a ? $e8dfc29dafb3bbd7$var$Vg(b, null, c, d) : $e8dfc29dafb3bbd7$var$Ug(b, a.child, c, d);
}
function $e8dfc29dafb3bbd7$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $e8dfc29dafb3bbd7$var$ch(b, e);
    d = $e8dfc29dafb3bbd7$var$Nh(a, b, c, d, f, e);
    c = $e8dfc29dafb3bbd7$var$Sh();
    if (null !== a && !$e8dfc29dafb3bbd7$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$Zi(a, b, e);
    $e8dfc29dafb3bbd7$var$I && c && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Xi(a, b, d, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$e8dfc29dafb3bbd7$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $e8dfc29dafb3bbd7$var$bj(a, b, f, d, e);
        a = $e8dfc29dafb3bbd7$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $e8dfc29dafb3bbd7$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $e8dfc29dafb3bbd7$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $e8dfc29dafb3bbd7$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $e8dfc29dafb3bbd7$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($e8dfc29dafb3bbd7$var$Ie(f, d) && a.ref === b.ref) {
            if ($e8dfc29dafb3bbd7$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($e8dfc29dafb3bbd7$var$dh = !0);
            else return b.lanes = a.lanes, $e8dfc29dafb3bbd7$var$Zi(a, b, e);
        }
    }
    return $e8dfc29dafb3bbd7$var$cj(a, b, c, d, e);
}
function $e8dfc29dafb3bbd7$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$ej, $e8dfc29dafb3bbd7$var$fj), $e8dfc29dafb3bbd7$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$ej, $e8dfc29dafb3bbd7$var$fj), $e8dfc29dafb3bbd7$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$ej, $e8dfc29dafb3bbd7$var$fj);
            $e8dfc29dafb3bbd7$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$ej, $e8dfc29dafb3bbd7$var$fj), $e8dfc29dafb3bbd7$var$fj |= d;
    $e8dfc29dafb3bbd7$var$Xi(a, b, e, c);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $e8dfc29dafb3bbd7$var$cj(a, b, c, d, e) {
    var f = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current;
    f = $e8dfc29dafb3bbd7$var$Yf(b, f);
    $e8dfc29dafb3bbd7$var$ch(b, e);
    c = $e8dfc29dafb3bbd7$var$Nh(a, b, c, d, f, e);
    d = $e8dfc29dafb3bbd7$var$Sh();
    if (null !== a && !$e8dfc29dafb3bbd7$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $e8dfc29dafb3bbd7$var$Zi(a, b, e);
    $e8dfc29dafb3bbd7$var$I && d && $e8dfc29dafb3bbd7$var$vg(b);
    b.flags |= 1;
    $e8dfc29dafb3bbd7$var$Xi(a, b, c, e);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$hj(a, b, c, d, e) {
    if ($e8dfc29dafb3bbd7$var$Zf(c)) {
        var f = !0;
        $e8dfc29dafb3bbd7$var$cg(b);
    } else f = !1;
    $e8dfc29dafb3bbd7$var$ch(b, e);
    if (null === b.stateNode) $e8dfc29dafb3bbd7$var$ij(a, b), $e8dfc29dafb3bbd7$var$Gi(b, c, d), $e8dfc29dafb3bbd7$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $e8dfc29dafb3bbd7$var$eh(l) : (l = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, l = $e8dfc29dafb3bbd7$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $e8dfc29dafb3bbd7$var$Hi(b, g, d, l);
        $e8dfc29dafb3bbd7$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$jh ? ("function" === typeof m && ($e8dfc29dafb3bbd7$var$Di(b, c, m, d), k = b.memoizedState), (h = $e8dfc29dafb3bbd7$var$jh || $e8dfc29dafb3bbd7$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $e8dfc29dafb3bbd7$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $e8dfc29dafb3bbd7$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $e8dfc29dafb3bbd7$var$eh(k) : (k = $e8dfc29dafb3bbd7$var$Zf(c) ? $e8dfc29dafb3bbd7$var$Xf : $e8dfc29dafb3bbd7$var$H.current, k = $e8dfc29dafb3bbd7$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $e8dfc29dafb3bbd7$var$Hi(b, g, d, k);
        $e8dfc29dafb3bbd7$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $e8dfc29dafb3bbd7$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $e8dfc29dafb3bbd7$var$Wf.current || $e8dfc29dafb3bbd7$var$jh ? ("function" === typeof y && ($e8dfc29dafb3bbd7$var$Di(b, c, y, d), n = b.memoizedState), (l = $e8dfc29dafb3bbd7$var$jh || $e8dfc29dafb3bbd7$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $e8dfc29dafb3bbd7$var$jj(a, b, c, d, f, e);
}
function $e8dfc29dafb3bbd7$var$jj(a, b, c, d, e, f) {
    $e8dfc29dafb3bbd7$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $e8dfc29dafb3bbd7$var$dg(b, c, !1), $e8dfc29dafb3bbd7$var$Zi(a, b, f);
    d = b.stateNode;
    $e8dfc29dafb3bbd7$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $e8dfc29dafb3bbd7$var$Ug(b, a.child, null, f), b.child = $e8dfc29dafb3bbd7$var$Ug(b, null, h, f)) : $e8dfc29dafb3bbd7$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $e8dfc29dafb3bbd7$var$dg(b, c, !0);
    return b.child;
}
function $e8dfc29dafb3bbd7$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $e8dfc29dafb3bbd7$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $e8dfc29dafb3bbd7$var$ag(a, b.context, !1);
    $e8dfc29dafb3bbd7$var$yh(a, b.containerInfo);
}
function $e8dfc29dafb3bbd7$var$lj(a, b, c, d, e) {
    $e8dfc29dafb3bbd7$var$Ig();
    $e8dfc29dafb3bbd7$var$Jg(e);
    b.flags |= 256;
    $e8dfc29dafb3bbd7$var$Xi(a, b, c, d);
    return b.child;
}
var $e8dfc29dafb3bbd7$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $e8dfc29dafb3bbd7$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $e8dfc29dafb3bbd7$var$oj(a, b, c) {
    var d = b.pendingProps, e = $e8dfc29dafb3bbd7$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$L, e & 1);
    if (null === a) {
        $e8dfc29dafb3bbd7$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $e8dfc29dafb3bbd7$var$pj(g, d, 0, null), a = $e8dfc29dafb3bbd7$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $e8dfc29dafb3bbd7$var$nj(c), b.memoizedState = $e8dfc29dafb3bbd7$var$mj, a) : $e8dfc29dafb3bbd7$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $e8dfc29dafb3bbd7$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $e8dfc29dafb3bbd7$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $e8dfc29dafb3bbd7$var$Pg(h, f) : (f = $e8dfc29dafb3bbd7$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $e8dfc29dafb3bbd7$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $e8dfc29dafb3bbd7$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $e8dfc29dafb3bbd7$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $e8dfc29dafb3bbd7$var$qj(a, b) {
    b = $e8dfc29dafb3bbd7$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $e8dfc29dafb3bbd7$var$sj(a, b, c, d) {
    null !== d && $e8dfc29dafb3bbd7$var$Jg(d);
    $e8dfc29dafb3bbd7$var$Ug(b, a.child, null, c);
    a = $e8dfc29dafb3bbd7$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $e8dfc29dafb3bbd7$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(422))), $e8dfc29dafb3bbd7$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $e8dfc29dafb3bbd7$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $e8dfc29dafb3bbd7$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $e8dfc29dafb3bbd7$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $e8dfc29dafb3bbd7$var$nj(g);
        b.memoizedState = $e8dfc29dafb3bbd7$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $e8dfc29dafb3bbd7$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($e8dfc29dafb3bbd7$var$p(419));
        d = $e8dfc29dafb3bbd7$var$Ki(f, d, void 0);
        return $e8dfc29dafb3bbd7$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($e8dfc29dafb3bbd7$var$dh || h) {
        d = $e8dfc29dafb3bbd7$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $e8dfc29dafb3bbd7$var$ih(a, e), $e8dfc29dafb3bbd7$var$gi(d, a, e, -1));
        }
        $e8dfc29dafb3bbd7$var$tj();
        d = $e8dfc29dafb3bbd7$var$Ki(Error($e8dfc29dafb3bbd7$var$p(421)));
        return $e8dfc29dafb3bbd7$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $e8dfc29dafb3bbd7$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(e.nextSibling);
    $e8dfc29dafb3bbd7$var$xg = b;
    $e8dfc29dafb3bbd7$var$I = !0;
    $e8dfc29dafb3bbd7$var$zg = null;
    null !== a && ($e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$rg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$sg, $e8dfc29dafb3bbd7$var$og[$e8dfc29dafb3bbd7$var$pg++] = $e8dfc29dafb3bbd7$var$qg, $e8dfc29dafb3bbd7$var$rg = a.id, $e8dfc29dafb3bbd7$var$sg = a.overflow, $e8dfc29dafb3bbd7$var$qg = b);
    b = $e8dfc29dafb3bbd7$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $e8dfc29dafb3bbd7$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $e8dfc29dafb3bbd7$var$bh(a.return, b, c);
}
function $e8dfc29dafb3bbd7$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $e8dfc29dafb3bbd7$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $e8dfc29dafb3bbd7$var$Xi(a, b, d.children, c);
    d = $e8dfc29dafb3bbd7$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $e8dfc29dafb3bbd7$var$vj(a, c, b);
            else if (19 === a.tag) $e8dfc29dafb3bbd7$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $e8dfc29dafb3bbd7$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $e8dfc29dafb3bbd7$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $e8dfc29dafb3bbd7$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $e8dfc29dafb3bbd7$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $e8dfc29dafb3bbd7$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $e8dfc29dafb3bbd7$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $e8dfc29dafb3bbd7$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($e8dfc29dafb3bbd7$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $e8dfc29dafb3bbd7$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $e8dfc29dafb3bbd7$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $e8dfc29dafb3bbd7$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $e8dfc29dafb3bbd7$var$kj(b);
            $e8dfc29dafb3bbd7$var$Ig();
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$Ah(b);
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$cg(b);
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$L, $e8dfc29dafb3bbd7$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $e8dfc29dafb3bbd7$var$oj(a, b, c);
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$L, $e8dfc29dafb3bbd7$var$L.current & 1);
                a = $e8dfc29dafb3bbd7$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$L, $e8dfc29dafb3bbd7$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $e8dfc29dafb3bbd7$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$L, $e8dfc29dafb3bbd7$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $e8dfc29dafb3bbd7$var$dj(a, b, c);
    }
    return $e8dfc29dafb3bbd7$var$Zi(a, b, c);
}
var $e8dfc29dafb3bbd7$var$zj, $e8dfc29dafb3bbd7$var$Aj, $e8dfc29dafb3bbd7$var$Bj, $e8dfc29dafb3bbd7$var$Cj;
$e8dfc29dafb3bbd7$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$e8dfc29dafb3bbd7$var$Aj = function() {};
$e8dfc29dafb3bbd7$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $e8dfc29dafb3bbd7$var$xh($e8dfc29dafb3bbd7$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $e8dfc29dafb3bbd7$var$Ya(a, e);
                d = $e8dfc29dafb3bbd7$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $e8dfc29dafb3bbd7$var$A({}, e, {
                    value: void 0
                });
                d = $e8dfc29dafb3bbd7$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $e8dfc29dafb3bbd7$var$gb(a, e);
                d = $e8dfc29dafb3bbd7$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
        }
        $e8dfc29dafb3bbd7$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $e8dfc29dafb3bbd7$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$e8dfc29dafb3bbd7$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $e8dfc29dafb3bbd7$var$Dj(a, b) {
    if (!$e8dfc29dafb3bbd7$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $e8dfc29dafb3bbd7$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $e8dfc29dafb3bbd7$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $e8dfc29dafb3bbd7$var$S(b), null;
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 3:
            d = b.stateNode;
            $e8dfc29dafb3bbd7$var$zh();
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
            $e8dfc29dafb3bbd7$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $e8dfc29dafb3bbd7$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Fj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null));
            $e8dfc29dafb3bbd7$var$Aj(a, b);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 5:
            $e8dfc29dafb3bbd7$var$Bh(b);
            var e = $e8dfc29dafb3bbd7$var$xh($e8dfc29dafb3bbd7$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                    $e8dfc29dafb3bbd7$var$S(b);
                    return null;
                }
                a = $e8dfc29dafb3bbd7$var$xh($e8dfc29dafb3bbd7$var$uh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    d[$e8dfc29dafb3bbd7$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $e8dfc29dafb3bbd7$var$D("cancel", d);
                            $e8dfc29dafb3bbd7$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], d);
                            break;
                        case "source":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $e8dfc29dafb3bbd7$var$D("error", d);
                            $e8dfc29dafb3bbd7$var$D("load", d);
                            break;
                        case "details":
                            $e8dfc29dafb3bbd7$var$D("toggle", d);
                            break;
                        case "input":
                            $e8dfc29dafb3bbd7$var$Za(d, f);
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $e8dfc29dafb3bbd7$var$D("invalid", d);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$hb(d, f), $e8dfc29dafb3bbd7$var$D("invalid", d);
                    }
                    $e8dfc29dafb3bbd7$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $e8dfc29dafb3bbd7$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $e8dfc29dafb3bbd7$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$Va(d);
                            $e8dfc29dafb3bbd7$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $e8dfc29dafb3bbd7$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $e8dfc29dafb3bbd7$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$e8dfc29dafb3bbd7$var$Of] = b;
                    a[$e8dfc29dafb3bbd7$var$Pf] = d;
                    $e8dfc29dafb3bbd7$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $e8dfc29dafb3bbd7$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $e8dfc29dafb3bbd7$var$D("cancel", a);
                                $e8dfc29dafb3bbd7$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $e8dfc29dafb3bbd7$var$lf.length; e++)$e8dfc29dafb3bbd7$var$D($e8dfc29dafb3bbd7$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $e8dfc29dafb3bbd7$var$D("error", a);
                                $e8dfc29dafb3bbd7$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $e8dfc29dafb3bbd7$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $e8dfc29dafb3bbd7$var$Za(a, d);
                                e = $e8dfc29dafb3bbd7$var$Ya(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $e8dfc29dafb3bbd7$var$A({}, d, {
                                    value: void 0
                                });
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$hb(a, d);
                                e = $e8dfc29dafb3bbd7$var$gb(a, d);
                                $e8dfc29dafb3bbd7$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $e8dfc29dafb3bbd7$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $e8dfc29dafb3bbd7$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $e8dfc29dafb3bbd7$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $e8dfc29dafb3bbd7$var$ob(a, k) : "number" === typeof k && $e8dfc29dafb3bbd7$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($e8dfc29dafb3bbd7$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $e8dfc29dafb3bbd7$var$D("scroll", a) : null != k && $e8dfc29dafb3bbd7$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $e8dfc29dafb3bbd7$var$Va(a);
                                $e8dfc29dafb3bbd7$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $e8dfc29dafb3bbd7$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $e8dfc29dafb3bbd7$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $e8dfc29dafb3bbd7$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $e8dfc29dafb3bbd7$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(166));
                c = $e8dfc29dafb3bbd7$var$xh($e8dfc29dafb3bbd7$var$wh.current);
                $e8dfc29dafb3bbd7$var$xh($e8dfc29dafb3bbd7$var$uh.current);
                if ($e8dfc29dafb3bbd7$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$e8dfc29dafb3bbd7$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $e8dfc29dafb3bbd7$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $e8dfc29dafb3bbd7$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$e8dfc29dafb3bbd7$var$Of] = b, b.stateNode = d;
            }
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($e8dfc29dafb3bbd7$var$I && null !== $e8dfc29dafb3bbd7$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $e8dfc29dafb3bbd7$var$Hg(), $e8dfc29dafb3bbd7$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $e8dfc29dafb3bbd7$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($e8dfc29dafb3bbd7$var$p(317));
                        f[$e8dfc29dafb3bbd7$var$Of] = b;
                    } else $e8dfc29dafb3bbd7$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $e8dfc29dafb3bbd7$var$S(b);
                    f = !1;
                } else null !== $e8dfc29dafb3bbd7$var$zg && ($e8dfc29dafb3bbd7$var$Fj($e8dfc29dafb3bbd7$var$zg), $e8dfc29dafb3bbd7$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($e8dfc29dafb3bbd7$var$L.current & 1) ? 0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 3) : $e8dfc29dafb3bbd7$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 4:
            return $e8dfc29dafb3bbd7$var$zh(), $e8dfc29dafb3bbd7$var$Aj(a, b), null === a && $e8dfc29dafb3bbd7$var$sf(b.stateNode.containerInfo), $e8dfc29dafb3bbd7$var$S(b), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$ah(b.type._context), $e8dfc29dafb3bbd7$var$S(b), null;
        case 17:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), $e8dfc29dafb3bbd7$var$S(b), null;
        case 19:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$L);
            f = b.memoizedState;
            if (null === f) return $e8dfc29dafb3bbd7$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $e8dfc29dafb3bbd7$var$Dj(f, !1);
                else {
                    if (0 !== $e8dfc29dafb3bbd7$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $e8dfc29dafb3bbd7$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $e8dfc29dafb3bbd7$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$L, $e8dfc29dafb3bbd7$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $e8dfc29dafb3bbd7$var$B() > $e8dfc29dafb3bbd7$var$Gj && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $e8dfc29dafb3bbd7$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $e8dfc29dafb3bbd7$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$e8dfc29dafb3bbd7$var$I) return $e8dfc29dafb3bbd7$var$S(b), null;
                    } else 2 * $e8dfc29dafb3bbd7$var$B() - f.renderingStartTime > $e8dfc29dafb3bbd7$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $e8dfc29dafb3bbd7$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $e8dfc29dafb3bbd7$var$B(), b.sibling = null, c = $e8dfc29dafb3bbd7$var$L.current, $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$L, d ? c & 1 | 2 : c & 1), b;
            $e8dfc29dafb3bbd7$var$S(b);
            return null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($e8dfc29dafb3bbd7$var$fj & 1073741824) && ($e8dfc29dafb3bbd7$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $e8dfc29dafb3bbd7$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
}
function $e8dfc29dafb3bbd7$var$Ij(a, b) {
    $e8dfc29dafb3bbd7$var$wg(b);
    switch(b.tag){
        case 1:
            return $e8dfc29dafb3bbd7$var$Zf(b.type) && $e8dfc29dafb3bbd7$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $e8dfc29dafb3bbd7$var$zh(), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf), $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H), $e8dfc29dafb3bbd7$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $e8dfc29dafb3bbd7$var$Bh(b), null;
        case 13:
            $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($e8dfc29dafb3bbd7$var$p(340));
                $e8dfc29dafb3bbd7$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$L), null;
        case 4:
            return $e8dfc29dafb3bbd7$var$zh(), null;
        case 10:
            return $e8dfc29dafb3bbd7$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $e8dfc29dafb3bbd7$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $e8dfc29dafb3bbd7$var$Jj = !1, $e8dfc29dafb3bbd7$var$U = !1, $e8dfc29dafb3bbd7$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $e8dfc29dafb3bbd7$var$V = null;
function $e8dfc29dafb3bbd7$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $e8dfc29dafb3bbd7$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $e8dfc29dafb3bbd7$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $e8dfc29dafb3bbd7$var$W(a, b, d);
    }
}
var $e8dfc29dafb3bbd7$var$Nj = !1;
function $e8dfc29dafb3bbd7$var$Oj(a, b) {
    $e8dfc29dafb3bbd7$var$Cf = $e8dfc29dafb3bbd7$var$dd;
    a = $e8dfc29dafb3bbd7$var$Me();
    if ($e8dfc29dafb3bbd7$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $e8dfc29dafb3bbd7$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $e8dfc29dafb3bbd7$var$dd = !1;
    for($e8dfc29dafb3bbd7$var$V = b; null !== $e8dfc29dafb3bbd7$var$V;)if (b = $e8dfc29dafb3bbd7$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $e8dfc29dafb3bbd7$var$V = a;
    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
        b = $e8dfc29dafb3bbd7$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $e8dfc29dafb3bbd7$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(163));
            }
        } catch (F) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $e8dfc29dafb3bbd7$var$V = a;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
    n = $e8dfc29dafb3bbd7$var$Nj;
    $e8dfc29dafb3bbd7$var$Nj = !1;
    return n;
}
function $e8dfc29dafb3bbd7$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $e8dfc29dafb3bbd7$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $e8dfc29dafb3bbd7$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $e8dfc29dafb3bbd7$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $e8dfc29dafb3bbd7$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $e8dfc29dafb3bbd7$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$e8dfc29dafb3bbd7$var$Of], delete b[$e8dfc29dafb3bbd7$var$Pf], delete b[$e8dfc29dafb3bbd7$var$of], delete b[$e8dfc29dafb3bbd7$var$Qf], delete b[$e8dfc29dafb3bbd7$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $e8dfc29dafb3bbd7$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $e8dfc29dafb3bbd7$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $e8dfc29dafb3bbd7$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $e8dfc29dafb3bbd7$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Vj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Vj(a, b, c), a = a.sibling;
}
function $e8dfc29dafb3bbd7$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling; null !== a;)$e8dfc29dafb3bbd7$var$Wj(a, b, c), a = a.sibling;
}
var $e8dfc29dafb3bbd7$var$X = null, $e8dfc29dafb3bbd7$var$Xj = !1;
function $e8dfc29dafb3bbd7$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$e8dfc29dafb3bbd7$var$Zj(a, b, c), c = c.sibling;
}
function $e8dfc29dafb3bbd7$var$Zj(a, b, c) {
    if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount) try {
        $e8dfc29dafb3bbd7$var$lc.onCommitFiberUnmount($e8dfc29dafb3bbd7$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Lj(c, b);
        case 6:
            var d = $e8dfc29dafb3bbd7$var$X, e = $e8dfc29dafb3bbd7$var$Xj;
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Yj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Xj = e;
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Xj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $e8dfc29dafb3bbd7$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $e8dfc29dafb3bbd7$var$X && ($e8dfc29dafb3bbd7$var$Xj ? (a = $e8dfc29dafb3bbd7$var$X, c = c.stateNode, 8 === a.nodeType ? $e8dfc29dafb3bbd7$var$Kf(a.parentNode, c) : 1 === a.nodeType && $e8dfc29dafb3bbd7$var$Kf(a, c), $e8dfc29dafb3bbd7$var$bd(a)) : $e8dfc29dafb3bbd7$var$Kf($e8dfc29dafb3bbd7$var$X, c.stateNode));
            break;
        case 4:
            d = $e8dfc29dafb3bbd7$var$X;
            e = $e8dfc29dafb3bbd7$var$Xj;
            $e8dfc29dafb3bbd7$var$X = c.stateNode.containerInfo;
            $e8dfc29dafb3bbd7$var$Xj = !0;
            $e8dfc29dafb3bbd7$var$Yj(a, b, c);
            $e8dfc29dafb3bbd7$var$X = d;
            $e8dfc29dafb3bbd7$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$e8dfc29dafb3bbd7$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $e8dfc29dafb3bbd7$var$Mj(c, b, g) : 0 !== (f & 4) && $e8dfc29dafb3bbd7$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $e8dfc29dafb3bbd7$var$Yj(a, b, c);
            break;
        case 1:
            if (!$e8dfc29dafb3bbd7$var$U && ($e8dfc29dafb3bbd7$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $e8dfc29dafb3bbd7$var$W(c, b, h);
            }
            $e8dfc29dafb3bbd7$var$Yj(a, b, c);
            break;
        case 21:
            $e8dfc29dafb3bbd7$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (d = $e8dfc29dafb3bbd7$var$U) || null !== c.memoizedState, $e8dfc29dafb3bbd7$var$Yj(a, b, c), $e8dfc29dafb3bbd7$var$U = d) : $e8dfc29dafb3bbd7$var$Yj(a, b, c);
            break;
        default:
            $e8dfc29dafb3bbd7$var$Yj(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $e8dfc29dafb3bbd7$var$Kj);
        b.forEach(function(b) {
            var d = $e8dfc29dafb3bbd7$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $e8dfc29dafb3bbd7$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode;
                        $e8dfc29dafb3bbd7$var$Xj = !1;
                        break a;
                    case 3:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Xj = !0;
                        break a;
                    case 4:
                        $e8dfc29dafb3bbd7$var$X = h.stateNode.containerInfo;
                        $e8dfc29dafb3bbd7$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $e8dfc29dafb3bbd7$var$X) throw Error($e8dfc29dafb3bbd7$var$p(160));
            $e8dfc29dafb3bbd7$var$Zj(f, g, e);
            $e8dfc29dafb3bbd7$var$X = null;
            $e8dfc29dafb3bbd7$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $e8dfc29dafb3bbd7$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$e8dfc29dafb3bbd7$var$dk(b, a), b = b.sibling;
}
function $e8dfc29dafb3bbd7$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            if (d & 4) {
                try {
                    $e8dfc29dafb3bbd7$var$Pj(3, a, a.return), $e8dfc29dafb3bbd7$var$Qj(3, a);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
                try {
                    $e8dfc29dafb3bbd7$var$Pj(5, a, a.return);
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Lj(c, c.return);
            break;
        case 5:
            $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            d & 512 && null !== c && $e8dfc29dafb3bbd7$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $e8dfc29dafb3bbd7$var$ob(e, "");
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $e8dfc29dafb3bbd7$var$ab(e, f);
                    $e8dfc29dafb3bbd7$var$vb(h, g);
                    var l = $e8dfc29dafb3bbd7$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $e8dfc29dafb3bbd7$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $e8dfc29dafb3bbd7$var$nb(e, q) : "children" === m ? $e8dfc29dafb3bbd7$var$ob(e, q) : $e8dfc29dafb3bbd7$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $e8dfc29dafb3bbd7$var$bb(e, f);
                            break;
                        case "textarea":
                            $e8dfc29dafb3bbd7$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.defaultValue, !0) : $e8dfc29dafb3bbd7$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$e8dfc29dafb3bbd7$var$Pf] = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($e8dfc29dafb3bbd7$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $e8dfc29dafb3bbd7$var$bd(b.containerInfo);
            } catch (t) {
                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
            }
            break;
        case 4:
            $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($e8dfc29dafb3bbd7$var$fk = $e8dfc29dafb3bbd7$var$B()));
            d & 4 && $e8dfc29dafb3bbd7$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($e8dfc29dafb3bbd7$var$U = (l = $e8dfc29dafb3bbd7$var$U) || m, $e8dfc29dafb3bbd7$var$ck(b, a), $e8dfc29dafb3bbd7$var$U = l) : $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($e8dfc29dafb3bbd7$var$V = a, m = a.child; null !== m;){
                    for(q = $e8dfc29dafb3bbd7$var$V = m; null !== $e8dfc29dafb3bbd7$var$V;){
                        r = $e8dfc29dafb3bbd7$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $e8dfc29dafb3bbd7$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $e8dfc29dafb3bbd7$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $e8dfc29dafb3bbd7$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $e8dfc29dafb3bbd7$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $e8dfc29dafb3bbd7$var$V = y) : $e8dfc29dafb3bbd7$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $e8dfc29dafb3bbd7$var$rb("display", g));
                            } catch (t) {
                                $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $e8dfc29dafb3bbd7$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $e8dfc29dafb3bbd7$var$ck(b, a);
            $e8dfc29dafb3bbd7$var$ek(a);
            d & 4 && $e8dfc29dafb3bbd7$var$ak(a);
            break;
        case 21:
            break;
        default:
            $e8dfc29dafb3bbd7$var$ck(b, a), $e8dfc29dafb3bbd7$var$ek(a);
    }
}
function $e8dfc29dafb3bbd7$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($e8dfc29dafb3bbd7$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($e8dfc29dafb3bbd7$var$ob(e, ""), d.flags &= -33);
                    var f = $e8dfc29dafb3bbd7$var$Uj(a);
                    $e8dfc29dafb3bbd7$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $e8dfc29dafb3bbd7$var$Uj(a);
                    $e8dfc29dafb3bbd7$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(161));
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $e8dfc29dafb3bbd7$var$hk(a, b, c) {
    $e8dfc29dafb3bbd7$var$V = a;
    $e8dfc29dafb3bbd7$var$ik(a, b, c);
}
function $e8dfc29dafb3bbd7$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $e8dfc29dafb3bbd7$var$V;){
        var e = $e8dfc29dafb3bbd7$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $e8dfc29dafb3bbd7$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $e8dfc29dafb3bbd7$var$U;
                h = $e8dfc29dafb3bbd7$var$Jj;
                var l = $e8dfc29dafb3bbd7$var$U;
                $e8dfc29dafb3bbd7$var$Jj = g;
                if (($e8dfc29dafb3bbd7$var$U = k) && !l) for($e8dfc29dafb3bbd7$var$V = e; null !== $e8dfc29dafb3bbd7$var$V;)g = $e8dfc29dafb3bbd7$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $e8dfc29dafb3bbd7$var$jk(e) : null !== k ? (k.return = g, $e8dfc29dafb3bbd7$var$V = k) : $e8dfc29dafb3bbd7$var$jk(e);
                for(; null !== f;)$e8dfc29dafb3bbd7$var$V = f, $e8dfc29dafb3bbd7$var$ik(f, b, c), f = f.sibling;
                $e8dfc29dafb3bbd7$var$V = e;
                $e8dfc29dafb3bbd7$var$Jj = h;
                $e8dfc29dafb3bbd7$var$U = l;
            }
            $e8dfc29dafb3bbd7$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $e8dfc29dafb3bbd7$var$V = f) : $e8dfc29dafb3bbd7$var$kk(a, b, c);
    }
}
function $e8dfc29dafb3bbd7$var$kk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $e8dfc29dafb3bbd7$var$U || $e8dfc29dafb3bbd7$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$e8dfc29dafb3bbd7$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $e8dfc29dafb3bbd7$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $e8dfc29dafb3bbd7$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $e8dfc29dafb3bbd7$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $e8dfc29dafb3bbd7$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($e8dfc29dafb3bbd7$var$p(163));
                }
                $e8dfc29dafb3bbd7$var$U || b.flags & 512 && $e8dfc29dafb3bbd7$var$Rj(b);
            } catch (r) {
                $e8dfc29dafb3bbd7$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$gk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $e8dfc29dafb3bbd7$var$V = c;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$jk(a) {
    for(; null !== $e8dfc29dafb3bbd7$var$V;){
        var b = $e8dfc29dafb3bbd7$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Qj(4, b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $e8dfc29dafb3bbd7$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Rj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $e8dfc29dafb3bbd7$var$Rj(b);
                    } catch (k) {
                        $e8dfc29dafb3bbd7$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $e8dfc29dafb3bbd7$var$W(b, b.return, k);
        }
        if (b === a) {
            $e8dfc29dafb3bbd7$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $e8dfc29dafb3bbd7$var$V = h;
            break;
        }
        $e8dfc29dafb3bbd7$var$V = b.return;
    }
}
var $e8dfc29dafb3bbd7$var$lk = Math.ceil, $e8dfc29dafb3bbd7$var$mk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher, $e8dfc29dafb3bbd7$var$nk = $e8dfc29dafb3bbd7$var$ua.ReactCurrentOwner, $e8dfc29dafb3bbd7$var$ok = $e8dfc29dafb3bbd7$var$ua.ReactCurrentBatchConfig, $e8dfc29dafb3bbd7$var$K = 0, $e8dfc29dafb3bbd7$var$Q = null, $e8dfc29dafb3bbd7$var$Y = null, $e8dfc29dafb3bbd7$var$Z = 0, $e8dfc29dafb3bbd7$var$fj = 0, $e8dfc29dafb3bbd7$var$ej = $e8dfc29dafb3bbd7$var$Uf(0), $e8dfc29dafb3bbd7$var$T = 0, $e8dfc29dafb3bbd7$var$pk = null, $e8dfc29dafb3bbd7$var$rh = 0, $e8dfc29dafb3bbd7$var$qk = 0, $e8dfc29dafb3bbd7$var$rk = 0, $e8dfc29dafb3bbd7$var$sk = null, $e8dfc29dafb3bbd7$var$tk = null, $e8dfc29dafb3bbd7$var$fk = 0, $e8dfc29dafb3bbd7$var$Gj = Infinity, $e8dfc29dafb3bbd7$var$uk = null, $e8dfc29dafb3bbd7$var$Oi = !1, $e8dfc29dafb3bbd7$var$Pi = null, $e8dfc29dafb3bbd7$var$Ri = null, $e8dfc29dafb3bbd7$var$vk = !1, $e8dfc29dafb3bbd7$var$wk = null, $e8dfc29dafb3bbd7$var$xk = 0, $e8dfc29dafb3bbd7$var$yk = 0, $e8dfc29dafb3bbd7$var$zk = null, $e8dfc29dafb3bbd7$var$Ak = -1, $e8dfc29dafb3bbd7$var$Bk = 0;
function $e8dfc29dafb3bbd7$var$R() {
    return 0 !== ($e8dfc29dafb3bbd7$var$K & 6) ? $e8dfc29dafb3bbd7$var$B() : -1 !== $e8dfc29dafb3bbd7$var$Ak ? $e8dfc29dafb3bbd7$var$Ak : $e8dfc29dafb3bbd7$var$Ak = $e8dfc29dafb3bbd7$var$B();
}
function $e8dfc29dafb3bbd7$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 2) && 0 !== $e8dfc29dafb3bbd7$var$Z) return $e8dfc29dafb3bbd7$var$Z & -$e8dfc29dafb3bbd7$var$Z;
    if (null !== $e8dfc29dafb3bbd7$var$Kg.transition) return 0 === $e8dfc29dafb3bbd7$var$Bk && ($e8dfc29dafb3bbd7$var$Bk = $e8dfc29dafb3bbd7$var$yc()), $e8dfc29dafb3bbd7$var$Bk;
    a = $e8dfc29dafb3bbd7$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $e8dfc29dafb3bbd7$var$jd(a.type);
    return a;
}
function $e8dfc29dafb3bbd7$var$gi(a, b, c, d) {
    if (50 < $e8dfc29dafb3bbd7$var$yk) throw $e8dfc29dafb3bbd7$var$yk = 0, $e8dfc29dafb3bbd7$var$zk = null, Error($e8dfc29dafb3bbd7$var$p(185));
    $e8dfc29dafb3bbd7$var$Ac(a, c, d);
    if (0 === ($e8dfc29dafb3bbd7$var$K & 2) || a !== $e8dfc29dafb3bbd7$var$Q) a === $e8dfc29dafb3bbd7$var$Q && (0 === ($e8dfc29dafb3bbd7$var$K & 2) && ($e8dfc29dafb3bbd7$var$qk |= c), 4 === $e8dfc29dafb3bbd7$var$T && $e8dfc29dafb3bbd7$var$Ck(a, $e8dfc29dafb3bbd7$var$Z)), $e8dfc29dafb3bbd7$var$Dk(a, d), 1 === c && 0 === $e8dfc29dafb3bbd7$var$K && 0 === (b.mode & 1) && ($e8dfc29dafb3bbd7$var$Gj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
}
function $e8dfc29dafb3bbd7$var$Dk(a, b) {
    var c = a.callbackNode;
    $e8dfc29dafb3bbd7$var$wc(a, b);
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$Q ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) null !== c && $e8dfc29dafb3bbd7$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $e8dfc29dafb3bbd7$var$bc(c);
        if (1 === b) 0 === a.tag ? $e8dfc29dafb3bbd7$var$ig($e8dfc29dafb3bbd7$var$Ek.bind(null, a)) : $e8dfc29dafb3bbd7$var$hg($e8dfc29dafb3bbd7$var$Ek.bind(null, a)), $e8dfc29dafb3bbd7$var$Jf(function() {
            0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
        }), c = null;
        else {
            switch($e8dfc29dafb3bbd7$var$Dc(d)){
                case 1:
                    c = $e8dfc29dafb3bbd7$var$fc;
                    break;
                case 4:
                    c = $e8dfc29dafb3bbd7$var$gc;
                    break;
                case 16:
                    c = $e8dfc29dafb3bbd7$var$hc;
                    break;
                case 536870912:
                    c = $e8dfc29dafb3bbd7$var$jc;
                    break;
                default:
                    c = $e8dfc29dafb3bbd7$var$hc;
            }
            c = $e8dfc29dafb3bbd7$var$Fk(c, $e8dfc29dafb3bbd7$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $e8dfc29dafb3bbd7$var$Gk(a, b) {
    $e8dfc29dafb3bbd7$var$Ak = -1;
    $e8dfc29dafb3bbd7$var$Bk = 0;
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    var c = a.callbackNode;
    if ($e8dfc29dafb3bbd7$var$Hk() && a.callbackNode !== c) return null;
    var d = $e8dfc29dafb3bbd7$var$uc(a, a === $e8dfc29dafb3bbd7$var$Q ? $e8dfc29dafb3bbd7$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $e8dfc29dafb3bbd7$var$Ik(a, d);
    else {
        b = d;
        var e = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 2;
        var f = $e8dfc29dafb3bbd7$var$Jk();
        if ($e8dfc29dafb3bbd7$var$Q !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$uk = null, $e8dfc29dafb3bbd7$var$Gj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$Kk(a, b);
        for(;;)try {
            $e8dfc29dafb3bbd7$var$Lk();
            break;
        } catch (h) {
            $e8dfc29dafb3bbd7$var$Mk(a, h);
        }
        $e8dfc29dafb3bbd7$var$$g();
        $e8dfc29dafb3bbd7$var$mk.current = f;
        $e8dfc29dafb3bbd7$var$K = e;
        null !== $e8dfc29dafb3bbd7$var$Y ? b = 0 : ($e8dfc29dafb3bbd7$var$Q = null, $e8dfc29dafb3bbd7$var$Z = 0, b = $e8dfc29dafb3bbd7$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $e8dfc29dafb3bbd7$var$xc(a), 0 !== e && (d = e, b = $e8dfc29dafb3bbd7$var$Nk(a, e)));
        if (1 === b) throw c = $e8dfc29dafb3bbd7$var$pk, $e8dfc29dafb3bbd7$var$Kk(a, 0), $e8dfc29dafb3bbd7$var$Ck(a, d), $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$B()), c;
        if (6 === b) $e8dfc29dafb3bbd7$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$e8dfc29dafb3bbd7$var$Ok(e) && (b = $e8dfc29dafb3bbd7$var$Ik(a, d), 2 === b && (f = $e8dfc29dafb3bbd7$var$xc(a), 0 !== f && (d = f, b = $e8dfc29dafb3bbd7$var$Nk(a, f))), 1 === b)) throw c = $e8dfc29dafb3bbd7$var$pk, $e8dfc29dafb3bbd7$var$Kk(a, 0), $e8dfc29dafb3bbd7$var$Ck(a, d), $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($e8dfc29dafb3bbd7$var$p(345));
                case 2:
                    $e8dfc29dafb3bbd7$var$Pk(a, $e8dfc29dafb3bbd7$var$tk, $e8dfc29dafb3bbd7$var$uk);
                    break;
                case 3:
                    $e8dfc29dafb3bbd7$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $e8dfc29dafb3bbd7$var$fk + 500 - $e8dfc29dafb3bbd7$var$B(), 10 < b)) {
                        if (0 !== $e8dfc29dafb3bbd7$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $e8dfc29dafb3bbd7$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Pk.bind(null, a, $e8dfc29dafb3bbd7$var$tk, $e8dfc29dafb3bbd7$var$uk), b);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Pk(a, $e8dfc29dafb3bbd7$var$tk, $e8dfc29dafb3bbd7$var$uk);
                    break;
                case 4:
                    $e8dfc29dafb3bbd7$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $e8dfc29dafb3bbd7$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $e8dfc29dafb3bbd7$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $e8dfc29dafb3bbd7$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $e8dfc29dafb3bbd7$var$Ff($e8dfc29dafb3bbd7$var$Pk.bind(null, a, $e8dfc29dafb3bbd7$var$tk, $e8dfc29dafb3bbd7$var$uk), d);
                        break;
                    }
                    $e8dfc29dafb3bbd7$var$Pk(a, $e8dfc29dafb3bbd7$var$tk, $e8dfc29dafb3bbd7$var$uk);
                    break;
                case 5:
                    $e8dfc29dafb3bbd7$var$Pk(a, $e8dfc29dafb3bbd7$var$tk, $e8dfc29dafb3bbd7$var$uk);
                    break;
                default:
                    throw Error($e8dfc29dafb3bbd7$var$p(329));
            }
        }
    }
    $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$B());
    return a.callbackNode === c ? $e8dfc29dafb3bbd7$var$Gk.bind(null, a) : null;
}
function $e8dfc29dafb3bbd7$var$Nk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$sk;
    a.current.memoizedState.isDehydrated && ($e8dfc29dafb3bbd7$var$Kk(a, b).flags |= 256);
    a = $e8dfc29dafb3bbd7$var$Ik(a, b);
    2 !== a && (b = $e8dfc29dafb3bbd7$var$tk, $e8dfc29dafb3bbd7$var$tk = c, null !== b && $e8dfc29dafb3bbd7$var$Fj(b));
    return a;
}
function $e8dfc29dafb3bbd7$var$Fj(a) {
    null === $e8dfc29dafb3bbd7$var$tk ? $e8dfc29dafb3bbd7$var$tk = a : $e8dfc29dafb3bbd7$var$tk.push.apply($e8dfc29dafb3bbd7$var$tk, a);
}
function $e8dfc29dafb3bbd7$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$e8dfc29dafb3bbd7$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $e8dfc29dafb3bbd7$var$Ck(a, b) {
    b &= ~$e8dfc29dafb3bbd7$var$rk;
    b &= ~$e8dfc29dafb3bbd7$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $e8dfc29dafb3bbd7$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $e8dfc29dafb3bbd7$var$Ek(a) {
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    $e8dfc29dafb3bbd7$var$Hk();
    var b = $e8dfc29dafb3bbd7$var$uc(a, 0);
    if (0 === (b & 1)) return $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$B()), null;
    var c = $e8dfc29dafb3bbd7$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $e8dfc29dafb3bbd7$var$xc(a);
        0 !== d && (b = d, c = $e8dfc29dafb3bbd7$var$Nk(a, d));
    }
    if (1 === c) throw c = $e8dfc29dafb3bbd7$var$pk, $e8dfc29dafb3bbd7$var$Kk(a, 0), $e8dfc29dafb3bbd7$var$Ck(a, b), $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$B()), c;
    if (6 === c) throw Error($e8dfc29dafb3bbd7$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $e8dfc29dafb3bbd7$var$Pk(a, $e8dfc29dafb3bbd7$var$tk, $e8dfc29dafb3bbd7$var$uk);
    $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$B());
    return null;
}
function $e8dfc29dafb3bbd7$var$Qk(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    try {
        return a(b);
    } finally{
        $e8dfc29dafb3bbd7$var$K = c, 0 === $e8dfc29dafb3bbd7$var$K && ($e8dfc29dafb3bbd7$var$Gj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$fg && $e8dfc29dafb3bbd7$var$jg());
    }
}
function $e8dfc29dafb3bbd7$var$Rk(a) {
    null !== $e8dfc29dafb3bbd7$var$wk && 0 === $e8dfc29dafb3bbd7$var$wk.tag && 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$Hk();
    var b = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 1;
    var c = $e8dfc29dafb3bbd7$var$ok.transition, d = $e8dfc29dafb3bbd7$var$C;
    try {
        if ($e8dfc29dafb3bbd7$var$ok.transition = null, $e8dfc29dafb3bbd7$var$C = 1, a) return a();
    } finally{
        $e8dfc29dafb3bbd7$var$C = d, $e8dfc29dafb3bbd7$var$ok.transition = c, $e8dfc29dafb3bbd7$var$K = b, 0 === ($e8dfc29dafb3bbd7$var$K & 6) && $e8dfc29dafb3bbd7$var$jg();
    }
}
function $e8dfc29dafb3bbd7$var$Hj() {
    $e8dfc29dafb3bbd7$var$fj = $e8dfc29dafb3bbd7$var$ej.current;
    $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$ej);
}
function $e8dfc29dafb3bbd7$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $e8dfc29dafb3bbd7$var$Gf(c));
    if (null !== $e8dfc29dafb3bbd7$var$Y) for(c = $e8dfc29dafb3bbd7$var$Y.return; null !== c;){
        var d = c;
        $e8dfc29dafb3bbd7$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $e8dfc29dafb3bbd7$var$$f();
                break;
            case 3:
                $e8dfc29dafb3bbd7$var$zh();
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$Wf);
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$H);
                $e8dfc29dafb3bbd7$var$Eh();
                break;
            case 5:
                $e8dfc29dafb3bbd7$var$Bh(d);
                break;
            case 4:
                $e8dfc29dafb3bbd7$var$zh();
                break;
            case 13:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$L);
                break;
            case 19:
                $e8dfc29dafb3bbd7$var$E($e8dfc29dafb3bbd7$var$L);
                break;
            case 10:
                $e8dfc29dafb3bbd7$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $e8dfc29dafb3bbd7$var$Hj();
        }
        c = c.return;
    }
    $e8dfc29dafb3bbd7$var$Q = a;
    $e8dfc29dafb3bbd7$var$Y = a = $e8dfc29dafb3bbd7$var$Pg(a.current, null);
    $e8dfc29dafb3bbd7$var$Z = $e8dfc29dafb3bbd7$var$fj = b;
    $e8dfc29dafb3bbd7$var$T = 0;
    $e8dfc29dafb3bbd7$var$pk = null;
    $e8dfc29dafb3bbd7$var$rk = $e8dfc29dafb3bbd7$var$qk = $e8dfc29dafb3bbd7$var$rh = 0;
    $e8dfc29dafb3bbd7$var$tk = $e8dfc29dafb3bbd7$var$sk = null;
    if (null !== $e8dfc29dafb3bbd7$var$fh) {
        for(b = 0; b < $e8dfc29dafb3bbd7$var$fh.length; b++)if (c = $e8dfc29dafb3bbd7$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $e8dfc29dafb3bbd7$var$fh = null;
    }
    return a;
}
function $e8dfc29dafb3bbd7$var$Mk(a, b) {
    do {
        var c = $e8dfc29dafb3bbd7$var$Y;
        try {
            $e8dfc29dafb3bbd7$var$$g();
            $e8dfc29dafb3bbd7$var$Fh.current = $e8dfc29dafb3bbd7$var$Rh;
            if ($e8dfc29dafb3bbd7$var$Ih) {
                for(var d = $e8dfc29dafb3bbd7$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $e8dfc29dafb3bbd7$var$Ih = !1;
            }
            $e8dfc29dafb3bbd7$var$Hh = 0;
            $e8dfc29dafb3bbd7$var$O = $e8dfc29dafb3bbd7$var$N = $e8dfc29dafb3bbd7$var$M = null;
            $e8dfc29dafb3bbd7$var$Jh = !1;
            $e8dfc29dafb3bbd7$var$Kh = 0;
            $e8dfc29dafb3bbd7$var$nk.current = null;
            if (null === c || null === c.return) {
                $e8dfc29dafb3bbd7$var$T = 1;
                $e8dfc29dafb3bbd7$var$pk = b;
                $e8dfc29dafb3bbd7$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $e8dfc29dafb3bbd7$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $e8dfc29dafb3bbd7$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $e8dfc29dafb3bbd7$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $e8dfc29dafb3bbd7$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $e8dfc29dafb3bbd7$var$Si(f, l, b);
                            $e8dfc29dafb3bbd7$var$tj();
                            break a;
                        }
                        k = Error($e8dfc29dafb3bbd7$var$p(426));
                    }
                } else if ($e8dfc29dafb3bbd7$var$I && h.mode & 1) {
                    var J = $e8dfc29dafb3bbd7$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $e8dfc29dafb3bbd7$var$Vi(J, g, h, f, b);
                        $e8dfc29dafb3bbd7$var$Jg($e8dfc29dafb3bbd7$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $e8dfc29dafb3bbd7$var$Ji(k, h);
                4 !== $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 2);
                null === $e8dfc29dafb3bbd7$var$sk ? $e8dfc29dafb3bbd7$var$sk = [
                    f
                ] : $e8dfc29dafb3bbd7$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $e8dfc29dafb3bbd7$var$Ni(f, k, b);
                            $e8dfc29dafb3bbd7$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Ri || !$e8dfc29dafb3bbd7$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $e8dfc29dafb3bbd7$var$Qi(f, h, b);
                                $e8dfc29dafb3bbd7$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $e8dfc29dafb3bbd7$var$Sk(c);
        } catch (na) {
            b = na;
            $e8dfc29dafb3bbd7$var$Y === c && null !== c && ($e8dfc29dafb3bbd7$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $e8dfc29dafb3bbd7$var$Jk() {
    var a = $e8dfc29dafb3bbd7$var$mk.current;
    $e8dfc29dafb3bbd7$var$mk.current = $e8dfc29dafb3bbd7$var$Rh;
    return null === a ? $e8dfc29dafb3bbd7$var$Rh : a;
}
function $e8dfc29dafb3bbd7$var$tj() {
    if (0 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T || 2 === $e8dfc29dafb3bbd7$var$T) $e8dfc29dafb3bbd7$var$T = 4;
    null === $e8dfc29dafb3bbd7$var$Q || 0 === ($e8dfc29dafb3bbd7$var$rh & 268435455) && 0 === ($e8dfc29dafb3bbd7$var$qk & 268435455) || $e8dfc29dafb3bbd7$var$Ck($e8dfc29dafb3bbd7$var$Q, $e8dfc29dafb3bbd7$var$Z);
}
function $e8dfc29dafb3bbd7$var$Ik(a, b) {
    var c = $e8dfc29dafb3bbd7$var$K;
    $e8dfc29dafb3bbd7$var$K |= 2;
    var d = $e8dfc29dafb3bbd7$var$Jk();
    if ($e8dfc29dafb3bbd7$var$Q !== a || $e8dfc29dafb3bbd7$var$Z !== b) $e8dfc29dafb3bbd7$var$uk = null, $e8dfc29dafb3bbd7$var$Kk(a, b);
    for(;;)try {
        $e8dfc29dafb3bbd7$var$Tk();
        break;
    } catch (e) {
        $e8dfc29dafb3bbd7$var$Mk(a, e);
    }
    $e8dfc29dafb3bbd7$var$$g();
    $e8dfc29dafb3bbd7$var$K = c;
    $e8dfc29dafb3bbd7$var$mk.current = d;
    if (null !== $e8dfc29dafb3bbd7$var$Y) throw Error($e8dfc29dafb3bbd7$var$p(261));
    $e8dfc29dafb3bbd7$var$Q = null;
    $e8dfc29dafb3bbd7$var$Z = 0;
    return $e8dfc29dafb3bbd7$var$T;
}
function $e8dfc29dafb3bbd7$var$Tk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y;)$e8dfc29dafb3bbd7$var$Uk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Lk() {
    for(; null !== $e8dfc29dafb3bbd7$var$Y && !$e8dfc29dafb3bbd7$var$cc();)$e8dfc29dafb3bbd7$var$Uk($e8dfc29dafb3bbd7$var$Y);
}
function $e8dfc29dafb3bbd7$var$Uk(a) {
    var b = $e8dfc29dafb3bbd7$var$Vk(a.alternate, a, $e8dfc29dafb3bbd7$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $e8dfc29dafb3bbd7$var$Sk(a) : $e8dfc29dafb3bbd7$var$Y = b;
    $e8dfc29dafb3bbd7$var$nk.current = null;
}
function $e8dfc29dafb3bbd7$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $e8dfc29dafb3bbd7$var$Ej(c, b, $e8dfc29dafb3bbd7$var$fj), null !== c) {
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
        } else {
            c = $e8dfc29dafb3bbd7$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $e8dfc29dafb3bbd7$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $e8dfc29dafb3bbd7$var$T = 6;
                $e8dfc29dafb3bbd7$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $e8dfc29dafb3bbd7$var$Y = b;
            return;
        }
        $e8dfc29dafb3bbd7$var$Y = b = a;
    }while (null !== b);
    0 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$T = 5);
}
function $e8dfc29dafb3bbd7$var$Pk(a, b, c) {
    var d = $e8dfc29dafb3bbd7$var$C, e = $e8dfc29dafb3bbd7$var$ok.transition;
    try {
        $e8dfc29dafb3bbd7$var$ok.transition = null, $e8dfc29dafb3bbd7$var$C = 1, $e8dfc29dafb3bbd7$var$Wk(a, b, c, d);
    } finally{
        $e8dfc29dafb3bbd7$var$ok.transition = e, $e8dfc29dafb3bbd7$var$C = d;
    }
    return null;
}
function $e8dfc29dafb3bbd7$var$Wk(a, b, c, d) {
    do $e8dfc29dafb3bbd7$var$Hk();
    while (null !== $e8dfc29dafb3bbd7$var$wk);
    if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($e8dfc29dafb3bbd7$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $e8dfc29dafb3bbd7$var$Bc(a, f);
    a === $e8dfc29dafb3bbd7$var$Q && ($e8dfc29dafb3bbd7$var$Y = $e8dfc29dafb3bbd7$var$Q = null, $e8dfc29dafb3bbd7$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $e8dfc29dafb3bbd7$var$vk || ($e8dfc29dafb3bbd7$var$vk = !0, $e8dfc29dafb3bbd7$var$Fk($e8dfc29dafb3bbd7$var$hc, function() {
        $e8dfc29dafb3bbd7$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $e8dfc29dafb3bbd7$var$ok.transition;
        $e8dfc29dafb3bbd7$var$ok.transition = null;
        var g = $e8dfc29dafb3bbd7$var$C;
        $e8dfc29dafb3bbd7$var$C = 1;
        var h = $e8dfc29dafb3bbd7$var$K;
        $e8dfc29dafb3bbd7$var$K |= 4;
        $e8dfc29dafb3bbd7$var$nk.current = null;
        $e8dfc29dafb3bbd7$var$Oj(a, c);
        $e8dfc29dafb3bbd7$var$dk(c, a);
        $e8dfc29dafb3bbd7$var$Oe($e8dfc29dafb3bbd7$var$Df);
        $e8dfc29dafb3bbd7$var$dd = !!$e8dfc29dafb3bbd7$var$Cf;
        $e8dfc29dafb3bbd7$var$Df = $e8dfc29dafb3bbd7$var$Cf = null;
        a.current = c;
        $e8dfc29dafb3bbd7$var$hk(c, a, e);
        $e8dfc29dafb3bbd7$var$dc();
        $e8dfc29dafb3bbd7$var$K = h;
        $e8dfc29dafb3bbd7$var$C = g;
        $e8dfc29dafb3bbd7$var$ok.transition = f;
    } else a.current = c;
    $e8dfc29dafb3bbd7$var$vk && ($e8dfc29dafb3bbd7$var$vk = !1, $e8dfc29dafb3bbd7$var$wk = a, $e8dfc29dafb3bbd7$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($e8dfc29dafb3bbd7$var$Ri = null);
    $e8dfc29dafb3bbd7$var$mc(c.stateNode, d);
    $e8dfc29dafb3bbd7$var$Dk(a, $e8dfc29dafb3bbd7$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($e8dfc29dafb3bbd7$var$Oi) throw $e8dfc29dafb3bbd7$var$Oi = !1, a = $e8dfc29dafb3bbd7$var$Pi, $e8dfc29dafb3bbd7$var$Pi = null, a;
    0 !== ($e8dfc29dafb3bbd7$var$xk & 1) && 0 !== a.tag && $e8dfc29dafb3bbd7$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $e8dfc29dafb3bbd7$var$zk ? $e8dfc29dafb3bbd7$var$yk++ : ($e8dfc29dafb3bbd7$var$yk = 0, $e8dfc29dafb3bbd7$var$zk = a) : $e8dfc29dafb3bbd7$var$yk = 0;
    $e8dfc29dafb3bbd7$var$jg();
    return null;
}
function $e8dfc29dafb3bbd7$var$Hk() {
    if (null !== $e8dfc29dafb3bbd7$var$wk) {
        var a = $e8dfc29dafb3bbd7$var$Dc($e8dfc29dafb3bbd7$var$xk), b = $e8dfc29dafb3bbd7$var$ok.transition, c = $e8dfc29dafb3bbd7$var$C;
        try {
            $e8dfc29dafb3bbd7$var$ok.transition = null;
            $e8dfc29dafb3bbd7$var$C = 16 > a ? 16 : a;
            if (null === $e8dfc29dafb3bbd7$var$wk) var d = !1;
            else {
                a = $e8dfc29dafb3bbd7$var$wk;
                $e8dfc29dafb3bbd7$var$wk = null;
                $e8dfc29dafb3bbd7$var$xk = 0;
                if (0 !== ($e8dfc29dafb3bbd7$var$K & 6)) throw Error($e8dfc29dafb3bbd7$var$p(331));
                var e = $e8dfc29dafb3bbd7$var$K;
                $e8dfc29dafb3bbd7$var$K |= 4;
                for($e8dfc29dafb3bbd7$var$V = a.current; null !== $e8dfc29dafb3bbd7$var$V;){
                    var f = $e8dfc29dafb3bbd7$var$V, g = f.child;
                    if (0 !== ($e8dfc29dafb3bbd7$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($e8dfc29dafb3bbd7$var$V = l; null !== $e8dfc29dafb3bbd7$var$V;){
                                    var m = $e8dfc29dafb3bbd7$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $e8dfc29dafb3bbd7$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $e8dfc29dafb3bbd7$var$V = q;
                                    else for(; null !== $e8dfc29dafb3bbd7$var$V;){
                                        m = $e8dfc29dafb3bbd7$var$V;
                                        var r = m.sibling, y = m.return;
                                        $e8dfc29dafb3bbd7$var$Sj(m);
                                        if (m === l) {
                                            $e8dfc29dafb3bbd7$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $e8dfc29dafb3bbd7$var$V = r;
                                            break;
                                        }
                                        $e8dfc29dafb3bbd7$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $e8dfc29dafb3bbd7$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $e8dfc29dafb3bbd7$var$V = g;
                    else b: for(; null !== $e8dfc29dafb3bbd7$var$V;){
                        f = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $e8dfc29dafb3bbd7$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $e8dfc29dafb3bbd7$var$V = x;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = f.return;
                    }
                }
                var w = a.current;
                for($e8dfc29dafb3bbd7$var$V = w; null !== $e8dfc29dafb3bbd7$var$V;){
                    g = $e8dfc29dafb3bbd7$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $e8dfc29dafb3bbd7$var$V = u;
                    else b: for(g = w; null !== $e8dfc29dafb3bbd7$var$V;){
                        h = $e8dfc29dafb3bbd7$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $e8dfc29dafb3bbd7$var$Qj(9, h);
                            }
                        } catch (na) {
                            $e8dfc29dafb3bbd7$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $e8dfc29dafb3bbd7$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $e8dfc29dafb3bbd7$var$V = F;
                            break b;
                        }
                        $e8dfc29dafb3bbd7$var$V = h.return;
                    }
                }
                $e8dfc29dafb3bbd7$var$K = e;
                $e8dfc29dafb3bbd7$var$jg();
                if ($e8dfc29dafb3bbd7$var$lc && "function" === typeof $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot) try {
                    $e8dfc29dafb3bbd7$var$lc.onPostCommitFiberRoot($e8dfc29dafb3bbd7$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $e8dfc29dafb3bbd7$var$C = c, $e8dfc29dafb3bbd7$var$ok.transition = b;
        }
    }
    return !1;
}
function $e8dfc29dafb3bbd7$var$Xk(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Ji(c, b);
    b = $e8dfc29dafb3bbd7$var$Ni(a, b, 1);
    a = $e8dfc29dafb3bbd7$var$nh(a, b, 1);
    b = $e8dfc29dafb3bbd7$var$R();
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, 1, b), $e8dfc29dafb3bbd7$var$Dk(a, b));
}
function $e8dfc29dafb3bbd7$var$W(a, b, c) {
    if (3 === a.tag) $e8dfc29dafb3bbd7$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $e8dfc29dafb3bbd7$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $e8dfc29dafb3bbd7$var$Ri || !$e8dfc29dafb3bbd7$var$Ri.has(d))) {
                a = $e8dfc29dafb3bbd7$var$Ji(c, a);
                a = $e8dfc29dafb3bbd7$var$Qi(b, a, 1);
                b = $e8dfc29dafb3bbd7$var$nh(b, a, 1);
                a = $e8dfc29dafb3bbd7$var$R();
                null !== b && ($e8dfc29dafb3bbd7$var$Ac(b, 1, a), $e8dfc29dafb3bbd7$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $e8dfc29dafb3bbd7$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $e8dfc29dafb3bbd7$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $e8dfc29dafb3bbd7$var$Q === a && ($e8dfc29dafb3bbd7$var$Z & c) === c && (4 === $e8dfc29dafb3bbd7$var$T || 3 === $e8dfc29dafb3bbd7$var$T && ($e8dfc29dafb3bbd7$var$Z & 130023424) === $e8dfc29dafb3bbd7$var$Z && 500 > $e8dfc29dafb3bbd7$var$B() - $e8dfc29dafb3bbd7$var$fk ? $e8dfc29dafb3bbd7$var$Kk(a, 0) : $e8dfc29dafb3bbd7$var$rk |= c);
    $e8dfc29dafb3bbd7$var$Dk(a, b);
}
function $e8dfc29dafb3bbd7$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $e8dfc29dafb3bbd7$var$sc, $e8dfc29dafb3bbd7$var$sc <<= 1, 0 === ($e8dfc29dafb3bbd7$var$sc & 130023424) && ($e8dfc29dafb3bbd7$var$sc = 4194304)));
    var c = $e8dfc29dafb3bbd7$var$R();
    a = $e8dfc29dafb3bbd7$var$ih(a, b);
    null !== a && ($e8dfc29dafb3bbd7$var$Ac(a, b, c), $e8dfc29dafb3bbd7$var$Dk(a, c));
}
function $e8dfc29dafb3bbd7$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $e8dfc29dafb3bbd7$var$Yk(a, c);
}
function $e8dfc29dafb3bbd7$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($e8dfc29dafb3bbd7$var$p(314));
    }
    null !== d && d.delete(b);
    $e8dfc29dafb3bbd7$var$Yk(a, c);
}
var $e8dfc29dafb3bbd7$var$Vk;
$e8dfc29dafb3bbd7$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $e8dfc29dafb3bbd7$var$Wf.current) $e8dfc29dafb3bbd7$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $e8dfc29dafb3bbd7$var$dh = !1, $e8dfc29dafb3bbd7$var$yj(a, b, c);
            $e8dfc29dafb3bbd7$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $e8dfc29dafb3bbd7$var$dh = !1, $e8dfc29dafb3bbd7$var$I && 0 !== (b.flags & 1048576) && $e8dfc29dafb3bbd7$var$ug(b, $e8dfc29dafb3bbd7$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $e8dfc29dafb3bbd7$var$ij(a, b);
            a = b.pendingProps;
            var e = $e8dfc29dafb3bbd7$var$Yf(b, $e8dfc29dafb3bbd7$var$H.current);
            $e8dfc29dafb3bbd7$var$ch(b, c);
            e = $e8dfc29dafb3bbd7$var$Nh(null, b, d, a, e, c);
            var f = $e8dfc29dafb3bbd7$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $e8dfc29dafb3bbd7$var$Zf(d) ? (f = !0, $e8dfc29dafb3bbd7$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $e8dfc29dafb3bbd7$var$kh(b), e.updater = $e8dfc29dafb3bbd7$var$Ei, b.stateNode = e, e._reactInternals = b, $e8dfc29dafb3bbd7$var$Ii(b, d, a, c), b = $e8dfc29dafb3bbd7$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $e8dfc29dafb3bbd7$var$I && f && $e8dfc29dafb3bbd7$var$vg(b), $e8dfc29dafb3bbd7$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $e8dfc29dafb3bbd7$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $e8dfc29dafb3bbd7$var$Zk(d);
                a = $e8dfc29dafb3bbd7$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $e8dfc29dafb3bbd7$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $e8dfc29dafb3bbd7$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $e8dfc29dafb3bbd7$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $e8dfc29dafb3bbd7$var$$i(null, b, d, $e8dfc29dafb3bbd7$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($e8dfc29dafb3bbd7$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Ci(d, e), $e8dfc29dafb3bbd7$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Ci(d, e), $e8dfc29dafb3bbd7$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $e8dfc29dafb3bbd7$var$kj(b);
                if (null === a) throw Error($e8dfc29dafb3bbd7$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $e8dfc29dafb3bbd7$var$lh(a, b);
                $e8dfc29dafb3bbd7$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $e8dfc29dafb3bbd7$var$Ji(Error($e8dfc29dafb3bbd7$var$p(423)), b);
                        b = $e8dfc29dafb3bbd7$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $e8dfc29dafb3bbd7$var$Ji(Error($e8dfc29dafb3bbd7$var$p(424)), b);
                        b = $e8dfc29dafb3bbd7$var$lj(a, b, d, c, e);
                        break a;
                    } else for($e8dfc29dafb3bbd7$var$yg = $e8dfc29dafb3bbd7$var$Lf(b.stateNode.containerInfo.firstChild), $e8dfc29dafb3bbd7$var$xg = b, $e8dfc29dafb3bbd7$var$I = !0, $e8dfc29dafb3bbd7$var$zg = null, c = $e8dfc29dafb3bbd7$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $e8dfc29dafb3bbd7$var$Ig();
                    if (d === e) {
                        b = $e8dfc29dafb3bbd7$var$Zi(a, b, c);
                        break a;
                    }
                    $e8dfc29dafb3bbd7$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $e8dfc29dafb3bbd7$var$Ah(b), null === a && $e8dfc29dafb3bbd7$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $e8dfc29dafb3bbd7$var$Ef(d, e) ? g = null : null !== f && $e8dfc29dafb3bbd7$var$Ef(d, f) && (b.flags |= 32), $e8dfc29dafb3bbd7$var$gj(a, b), $e8dfc29dafb3bbd7$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $e8dfc29dafb3bbd7$var$Eg(b), null;
        case 13:
            return $e8dfc29dafb3bbd7$var$oj(a, b, c);
        case 4:
            return $e8dfc29dafb3bbd7$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $e8dfc29dafb3bbd7$var$Ug(b, null, d, c) : $e8dfc29dafb3bbd7$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Ci(d, e), $e8dfc29dafb3bbd7$var$Yi(a, b, d, e, c);
        case 7:
            return $e8dfc29dafb3bbd7$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $e8dfc29dafb3bbd7$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $e8dfc29dafb3bbd7$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $e8dfc29dafb3bbd7$var$G($e8dfc29dafb3bbd7$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($e8dfc29dafb3bbd7$var$He(f.value, g)) {
                        if (f.children === e.children && !$e8dfc29dafb3bbd7$var$Wf.current) {
                            b = $e8dfc29dafb3bbd7$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $e8dfc29dafb3bbd7$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $e8dfc29dafb3bbd7$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($e8dfc29dafb3bbd7$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $e8dfc29dafb3bbd7$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $e8dfc29dafb3bbd7$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $e8dfc29dafb3bbd7$var$ch(b, c), e = $e8dfc29dafb3bbd7$var$eh(e), d = d(e), b.flags |= 1, $e8dfc29dafb3bbd7$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $e8dfc29dafb3bbd7$var$Ci(d, b.pendingProps), e = $e8dfc29dafb3bbd7$var$Ci(d.type, e), $e8dfc29dafb3bbd7$var$$i(a, b, d, e, c);
        case 15:
            return $e8dfc29dafb3bbd7$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $e8dfc29dafb3bbd7$var$Ci(d, e), $e8dfc29dafb3bbd7$var$ij(a, b), b.tag = 1, $e8dfc29dafb3bbd7$var$Zf(d) ? (a = !0, $e8dfc29dafb3bbd7$var$cg(b)) : a = !1, $e8dfc29dafb3bbd7$var$ch(b, c), $e8dfc29dafb3bbd7$var$Gi(b, d, e), $e8dfc29dafb3bbd7$var$Ii(b, d, e, c), $e8dfc29dafb3bbd7$var$jj(null, b, d, !0, a, c);
        case 19:
            return $e8dfc29dafb3bbd7$var$xj(a, b, c);
        case 22:
            return $e8dfc29dafb3bbd7$var$dj(a, b, c);
    }
    throw Error($e8dfc29dafb3bbd7$var$p(156, b.tag));
};
function $e8dfc29dafb3bbd7$var$Fk(a, b) {
    return $e8dfc29dafb3bbd7$var$ac(a, b);
}
function $e8dfc29dafb3bbd7$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $e8dfc29dafb3bbd7$var$Bg(a, b, c, d) {
    return new $e8dfc29dafb3bbd7$var$$k(a, b, c, d);
}
function $e8dfc29dafb3bbd7$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $e8dfc29dafb3bbd7$var$Zk(a) {
    if ("function" === typeof a) return $e8dfc29dafb3bbd7$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $e8dfc29dafb3bbd7$var$Da) return 11;
        if (a === $e8dfc29dafb3bbd7$var$Ga) return 14;
    }
    return 2;
}
function $e8dfc29dafb3bbd7$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $e8dfc29dafb3bbd7$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $e8dfc29dafb3bbd7$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $e8dfc29dafb3bbd7$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $e8dfc29dafb3bbd7$var$ya:
            return $e8dfc29dafb3bbd7$var$Tg(c.children, e, f, b);
        case $e8dfc29dafb3bbd7$var$za:
            g = 8;
            e |= 8;
            break;
        case $e8dfc29dafb3bbd7$var$Aa:
            return a = $e8dfc29dafb3bbd7$var$Bg(12, c, b, e | 2), a.elementType = $e8dfc29dafb3bbd7$var$Aa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ea:
            return a = $e8dfc29dafb3bbd7$var$Bg(13, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Ea, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Fa:
            return a = $e8dfc29dafb3bbd7$var$Bg(19, c, b, e), a.elementType = $e8dfc29dafb3bbd7$var$Fa, a.lanes = f, a;
        case $e8dfc29dafb3bbd7$var$Ia:
            return $e8dfc29dafb3bbd7$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $e8dfc29dafb3bbd7$var$Ba:
                    g = 10;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ca:
                    g = 9;
                    break a;
                case $e8dfc29dafb3bbd7$var$Da:
                    g = 11;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ga:
                    g = 14;
                    break a;
                case $e8dfc29dafb3bbd7$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($e8dfc29dafb3bbd7$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $e8dfc29dafb3bbd7$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $e8dfc29dafb3bbd7$var$Tg(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$pj(a, b, c, d) {
    a = $e8dfc29dafb3bbd7$var$Bg(22, a, d, b);
    a.elementType = $e8dfc29dafb3bbd7$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $e8dfc29dafb3bbd7$var$Qg(a, b, c) {
    a = $e8dfc29dafb3bbd7$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $e8dfc29dafb3bbd7$var$Sg(a, b, c) {
    b = $e8dfc29dafb3bbd7$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $e8dfc29dafb3bbd7$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $e8dfc29dafb3bbd7$var$zc(0);
    this.expirationTimes = $e8dfc29dafb3bbd7$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $e8dfc29dafb3bbd7$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $e8dfc29dafb3bbd7$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $e8dfc29dafb3bbd7$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $e8dfc29dafb3bbd7$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $e8dfc29dafb3bbd7$var$kh(f);
    return a;
}
function $e8dfc29dafb3bbd7$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $e8dfc29dafb3bbd7$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $e8dfc29dafb3bbd7$var$dl(a) {
    if (!a) return $e8dfc29dafb3bbd7$var$Vf;
    a = a._reactInternals;
    a: {
        if ($e8dfc29dafb3bbd7$var$Vb(a) !== a || 1 !== a.tag) throw Error($e8dfc29dafb3bbd7$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($e8dfc29dafb3bbd7$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($e8dfc29dafb3bbd7$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($e8dfc29dafb3bbd7$var$Zf(c)) return $e8dfc29dafb3bbd7$var$bg(a, c, b);
    }
    return b;
}
function $e8dfc29dafb3bbd7$var$el(a, b, c, d, e, f, g, h, k) {
    a = $e8dfc29dafb3bbd7$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $e8dfc29dafb3bbd7$var$dl(null);
    c = a.current;
    d = $e8dfc29dafb3bbd7$var$R();
    e = $e8dfc29dafb3bbd7$var$yi(c);
    f = $e8dfc29dafb3bbd7$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $e8dfc29dafb3bbd7$var$nh(c, f, e);
    a.current.lanes = e;
    $e8dfc29dafb3bbd7$var$Ac(a, e, d);
    $e8dfc29dafb3bbd7$var$Dk(a, d);
    return a;
}
function $e8dfc29dafb3bbd7$var$fl(a, b, c, d) {
    var e = b.current, f = $e8dfc29dafb3bbd7$var$R(), g = $e8dfc29dafb3bbd7$var$yi(e);
    c = $e8dfc29dafb3bbd7$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $e8dfc29dafb3bbd7$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $e8dfc29dafb3bbd7$var$nh(e, b, g);
    null !== a && ($e8dfc29dafb3bbd7$var$gi(a, e, g, f), $e8dfc29dafb3bbd7$var$oh(a, e, g));
    return g;
}
function $e8dfc29dafb3bbd7$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $e8dfc29dafb3bbd7$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $e8dfc29dafb3bbd7$var$il(a, b) {
    $e8dfc29dafb3bbd7$var$hl(a, b);
    (a = a.alternate) && $e8dfc29dafb3bbd7$var$hl(a, b);
}
function $e8dfc29dafb3bbd7$var$jl() {
    return null;
}
var $e8dfc29dafb3bbd7$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $e8dfc29dafb3bbd7$var$ll(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$ml.prototype.render = $e8dfc29dafb3bbd7$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($e8dfc29dafb3bbd7$var$p(409));
    $e8dfc29dafb3bbd7$var$fl(a, b, null, null);
};
$e8dfc29dafb3bbd7$var$ml.prototype.unmount = $e8dfc29dafb3bbd7$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $e8dfc29dafb3bbd7$var$Rk(function() {
            $e8dfc29dafb3bbd7$var$fl(null, a, null, null);
        });
        b[$e8dfc29dafb3bbd7$var$uf] = null;
    }
};
function $e8dfc29dafb3bbd7$var$ml(a) {
    this._internalRoot = a;
}
$e8dfc29dafb3bbd7$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $e8dfc29dafb3bbd7$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $e8dfc29dafb3bbd7$var$Qc.length && 0 !== b && b < $e8dfc29dafb3bbd7$var$Qc[c].priority; c++);
        $e8dfc29dafb3bbd7$var$Qc.splice(c, 0, a);
        0 === c && $e8dfc29dafb3bbd7$var$Vc(a);
    }
};
function $e8dfc29dafb3bbd7$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $e8dfc29dafb3bbd7$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $e8dfc29dafb3bbd7$var$pl() {}
function $e8dfc29dafb3bbd7$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $e8dfc29dafb3bbd7$var$gl(g);
                f.call(a);
            };
        }
        var g = $e8dfc29dafb3bbd7$var$el(b, d, a, 0, null, !1, !1, "", $e8dfc29dafb3bbd7$var$pl);
        a._reactRootContainer = g;
        a[$e8dfc29dafb3bbd7$var$uf] = g.current;
        $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
        $e8dfc29dafb3bbd7$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $e8dfc29dafb3bbd7$var$gl(k);
            h.call(a);
        };
    }
    var k = $e8dfc29dafb3bbd7$var$bl(a, 0, !1, null, null, !1, !1, "", $e8dfc29dafb3bbd7$var$pl);
    a._reactRootContainer = k;
    a[$e8dfc29dafb3bbd7$var$uf] = k.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    $e8dfc29dafb3bbd7$var$Rk(function() {
        $e8dfc29dafb3bbd7$var$fl(b, k, c, d);
    });
    return k;
}
function $e8dfc29dafb3bbd7$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $e8dfc29dafb3bbd7$var$gl(g);
                h.call(a);
            };
        }
        $e8dfc29dafb3bbd7$var$fl(b, g, a, e);
    } else g = $e8dfc29dafb3bbd7$var$ql(c, b, a, e, d);
    return $e8dfc29dafb3bbd7$var$gl(g);
}
$e8dfc29dafb3bbd7$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $e8dfc29dafb3bbd7$var$tc(b.pendingLanes);
                0 !== c && ($e8dfc29dafb3bbd7$var$Cc(b, c | 1), $e8dfc29dafb3bbd7$var$Dk(b, $e8dfc29dafb3bbd7$var$B()), 0 === ($e8dfc29dafb3bbd7$var$K & 6) && ($e8dfc29dafb3bbd7$var$Gj = $e8dfc29dafb3bbd7$var$B() + 500, $e8dfc29dafb3bbd7$var$jg()));
            }
            break;
        case 13:
            $e8dfc29dafb3bbd7$var$Rk(function() {
                var b = $e8dfc29dafb3bbd7$var$ih(a, 1);
                if (null !== b) {
                    var c = $e8dfc29dafb3bbd7$var$R();
                    $e8dfc29dafb3bbd7$var$gi(b, a, 1, c);
                }
            }), $e8dfc29dafb3bbd7$var$il(a, 1);
    }
};
$e8dfc29dafb3bbd7$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$ih(a, 134217728);
        if (null !== b) {
            var c = $e8dfc29dafb3bbd7$var$R();
            $e8dfc29dafb3bbd7$var$gi(b, a, 134217728, c);
        }
        $e8dfc29dafb3bbd7$var$il(a, 134217728);
    }
};
$e8dfc29dafb3bbd7$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $e8dfc29dafb3bbd7$var$yi(a), c = $e8dfc29dafb3bbd7$var$ih(a, b);
        if (null !== c) {
            var d = $e8dfc29dafb3bbd7$var$R();
            $e8dfc29dafb3bbd7$var$gi(c, a, b, d);
        }
        $e8dfc29dafb3bbd7$var$il(a, b);
    }
};
$e8dfc29dafb3bbd7$var$Hc = function() {
    return $e8dfc29dafb3bbd7$var$C;
};
$e8dfc29dafb3bbd7$var$Ic = function(a, b) {
    var c = $e8dfc29dafb3bbd7$var$C;
    try {
        return $e8dfc29dafb3bbd7$var$C = a, b();
    } finally{
        $e8dfc29dafb3bbd7$var$C = c;
    }
};
$e8dfc29dafb3bbd7$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $e8dfc29dafb3bbd7$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $e8dfc29dafb3bbd7$var$Db(d);
                        if (!e) throw Error($e8dfc29dafb3bbd7$var$p(90));
                        $e8dfc29dafb3bbd7$var$Wa(d);
                        $e8dfc29dafb3bbd7$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $e8dfc29dafb3bbd7$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $e8dfc29dafb3bbd7$var$fb(a, !!c.multiple, b, !1);
    }
};
$e8dfc29dafb3bbd7$var$Gb = $e8dfc29dafb3bbd7$var$Qk;
$e8dfc29dafb3bbd7$var$Hb = $e8dfc29dafb3bbd7$var$Rk;
var $e8dfc29dafb3bbd7$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $e8dfc29dafb3bbd7$var$Cb,
        $e8dfc29dafb3bbd7$var$ue,
        $e8dfc29dafb3bbd7$var$Db,
        $e8dfc29dafb3bbd7$var$Eb,
        $e8dfc29dafb3bbd7$var$Fb,
        $e8dfc29dafb3bbd7$var$Qk
    ]
}, $e8dfc29dafb3bbd7$var$tl = {
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $e8dfc29dafb3bbd7$var$ul = {
    bundleType: $e8dfc29dafb3bbd7$var$tl.bundleType,
    version: $e8dfc29dafb3bbd7$var$tl.version,
    rendererPackageName: $e8dfc29dafb3bbd7$var$tl.rendererPackageName,
    rendererConfig: $e8dfc29dafb3bbd7$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $e8dfc29dafb3bbd7$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $e8dfc29dafb3bbd7$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $e8dfc29dafb3bbd7$var$tl.findFiberByHostInstance || $e8dfc29dafb3bbd7$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $e8dfc29dafb3bbd7$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$e8dfc29dafb3bbd7$var$vl.isDisabled && $e8dfc29dafb3bbd7$var$vl.supportsFiber) try {
        $e8dfc29dafb3bbd7$var$kc = $e8dfc29dafb3bbd7$var$vl.inject($e8dfc29dafb3bbd7$var$ul), $e8dfc29dafb3bbd7$var$lc = $e8dfc29dafb3bbd7$var$vl;
    } catch (a) {}
}
$e8dfc29dafb3bbd7$export$ae55be85d98224ed = $e8dfc29dafb3bbd7$var$sl;
$e8dfc29dafb3bbd7$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$e8dfc29dafb3bbd7$var$nl(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$cl(a, b, null, c);
};
$e8dfc29dafb3bbd7$export$882461b6382ed46c = function(a, b) {
    if (!$e8dfc29dafb3bbd7$var$nl(a)) throw Error($e8dfc29dafb3bbd7$var$p(299));
    var c = !1, d = "", e = $e8dfc29dafb3bbd7$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $e8dfc29dafb3bbd7$var$ll(b);
};
$e8dfc29dafb3bbd7$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($e8dfc29dafb3bbd7$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($e8dfc29dafb3bbd7$var$p(268, a));
    }
    a = $e8dfc29dafb3bbd7$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$e8dfc29dafb3bbd7$export$cd75ccfd720a3cd4 = function(a) {
    return $e8dfc29dafb3bbd7$var$Rk(a);
};
$e8dfc29dafb3bbd7$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$ol(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$rl(null, a, b, !0, c);
};
$e8dfc29dafb3bbd7$export$757ceba2d55c277e = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$nl(a)) throw Error($e8dfc29dafb3bbd7$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $e8dfc29dafb3bbd7$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $e8dfc29dafb3bbd7$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$e8dfc29dafb3bbd7$var$uf] = b.current;
    $e8dfc29dafb3bbd7$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $e8dfc29dafb3bbd7$var$ml(b);
};
$e8dfc29dafb3bbd7$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$e8dfc29dafb3bbd7$var$ol(b)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    return $e8dfc29dafb3bbd7$var$rl(null, a, b, !1, c);
};
$e8dfc29dafb3bbd7$export$502457920280e6be = function(a) {
    if (!$e8dfc29dafb3bbd7$var$ol(a)) throw Error($e8dfc29dafb3bbd7$var$p(40));
    return a._reactRootContainer ? ($e8dfc29dafb3bbd7$var$Rk(function() {
        $e8dfc29dafb3bbd7$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$e8dfc29dafb3bbd7$var$uf] = null;
        });
    }), !0) : !1;
};
$e8dfc29dafb3bbd7$export$c78a37762a8d58e1 = $e8dfc29dafb3bbd7$var$Qk;
$e8dfc29dafb3bbd7$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$e8dfc29dafb3bbd7$var$ol(c)) throw Error($e8dfc29dafb3bbd7$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($e8dfc29dafb3bbd7$var$p(38));
    return $e8dfc29dafb3bbd7$var$rl(a, b, c, !1, d);
};
$e8dfc29dafb3bbd7$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("1c9zD", function(module, exports) {
"use strict";

module.exports = (parcelRequire("lffg4"));

});
parcelRegister("lffg4", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f776d5a8b0cafef3$export$c4744153514ff05d; }, function (v) { return $f776d5a8b0cafef3$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7; }, function (v) { return $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875; }, function (v) { return $f776d5a8b0cafef3$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f776d5a8b0cafef3$export$502329bbf4b505b1; }, function (v) { return $f776d5a8b0cafef3$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f776d5a8b0cafef3$export$6e3807111c4874c4; }, function (v) { return $f776d5a8b0cafef3$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f776d5a8b0cafef3$export$c27134553091fb3a; }, function (v) { return $f776d5a8b0cafef3$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2; }, function (v) { return $f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f776d5a8b0cafef3$export$b00a404bbd5edef2; }, function (v) { return $f776d5a8b0cafef3$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $f776d5a8b0cafef3$export$8352ce38b91d0c62; }, function (v) { return $f776d5a8b0cafef3$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b; }, function (v) { return $f776d5a8b0cafef3$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555; }, function (v) { return $f776d5a8b0cafef3$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $f776d5a8b0cafef3$export$839f9183b0465a69; }, function (v) { return $f776d5a8b0cafef3$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f776d5a8b0cafef3$export$72fdf0e06517287b; }, function (v) { return $f776d5a8b0cafef3$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $f776d5a8b0cafef3$export$4b844e58a3e414b4; }, function (v) { return $f776d5a8b0cafef3$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f776d5a8b0cafef3$export$816d2913ae6b83b1; }, function (v) { return $f776d5a8b0cafef3$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f776d5a8b0cafef3$export$61bcfe829111a1d0; }, function (v) { return $f776d5a8b0cafef3$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f; }, function (v) { return $f776d5a8b0cafef3$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f776d5a8b0cafef3$export$b5836b71941fa3ed; }, function (v) { return $f776d5a8b0cafef3$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f776d5a8b0cafef3$export$cf845f2c119da08a; }, function (v) { return $f776d5a8b0cafef3$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f776d5a8b0cafef3$export$c4744153514ff05d;
var $f776d5a8b0cafef3$export$3e506c1ccc9cc1a7;
var $f776d5a8b0cafef3$export$e26fe2ed2fa76875;
var $f776d5a8b0cafef3$export$502329bbf4b505b1;
var $f776d5a8b0cafef3$export$6e3807111c4874c4;
var $f776d5a8b0cafef3$export$c27134553091fb3a;
var $f776d5a8b0cafef3$export$33ee1acdc04fd2a2;
var $f776d5a8b0cafef3$export$b00a404bbd5edef2;
var $f776d5a8b0cafef3$export$8352ce38b91d0c62;
var $f776d5a8b0cafef3$export$d66a1c1c77bd778b;
var $f776d5a8b0cafef3$export$d3dfb8e4810cb555;
var $f776d5a8b0cafef3$export$839f9183b0465a69;
var $f776d5a8b0cafef3$export$72fdf0e06517287b;
var $f776d5a8b0cafef3$export$4b844e58a3e414b4;
var $f776d5a8b0cafef3$export$816d2913ae6b83b1;
var $f776d5a8b0cafef3$export$61bcfe829111a1d0;
var $f776d5a8b0cafef3$export$7ee8c9beb337bc3f;
var $f776d5a8b0cafef3$export$b5836b71941fa3ed;
var $f776d5a8b0cafef3$export$cf845f2c119da08a;
"use strict";
function $f776d5a8b0cafef3$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f776d5a8b0cafef3$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f776d5a8b0cafef3$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f776d5a8b0cafef3$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f776d5a8b0cafef3$var$g(C, c)) n < e && 0 > $f776d5a8b0cafef3$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f776d5a8b0cafef3$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f776d5a8b0cafef3$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f776d5a8b0cafef3$var$l = performance;
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$l.now();
    };
} else {
    var $f776d5a8b0cafef3$var$p = Date, $f776d5a8b0cafef3$var$q = $f776d5a8b0cafef3$var$p.now();
    $f776d5a8b0cafef3$export$c4744153514ff05d = function() {
        return $f776d5a8b0cafef3$var$p.now() - $f776d5a8b0cafef3$var$q;
    };
}
var $f776d5a8b0cafef3$var$r = [], $f776d5a8b0cafef3$var$t = [], $f776d5a8b0cafef3$var$u = 1, $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = 3, $f776d5a8b0cafef3$var$z = !1, $f776d5a8b0cafef3$var$A = !1, $f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$D = "function" === typeof setTimeout ? setTimeout : null, $f776d5a8b0cafef3$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f776d5a8b0cafef3$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f776d5a8b0cafef3$var$G(a) {
    for(var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t); null !== b;){
        if (null === b.callback) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t);
        else if (b.startTime <= a) $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$t), b.sortIndex = b.expirationTime, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, b);
        else break;
        b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
    }
}
function $f776d5a8b0cafef3$var$H(a) {
    $f776d5a8b0cafef3$var$B = !1;
    $f776d5a8b0cafef3$var$G(a);
    if (!$f776d5a8b0cafef3$var$A) {
        if (null !== $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r)) $f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J);
        else {
            var b = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== b && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, b.startTime - a);
        }
    }
}
function $f776d5a8b0cafef3$var$J(a, b) {
    $f776d5a8b0cafef3$var$A = !1;
    $f776d5a8b0cafef3$var$B && ($f776d5a8b0cafef3$var$B = !1, $f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1);
    $f776d5a8b0cafef3$var$z = !0;
    var c = $f776d5a8b0cafef3$var$y;
    try {
        $f776d5a8b0cafef3$var$G(b);
        for($f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r); null !== $f776d5a8b0cafef3$var$v && (!($f776d5a8b0cafef3$var$v.expirationTime > b) || a && !$f776d5a8b0cafef3$var$M());){
            var d = $f776d5a8b0cafef3$var$v.callback;
            if ("function" === typeof d) {
                $f776d5a8b0cafef3$var$v.callback = null;
                $f776d5a8b0cafef3$var$y = $f776d5a8b0cafef3$var$v.priorityLevel;
                var e = d($f776d5a8b0cafef3$var$v.expirationTime <= b);
                b = $f776d5a8b0cafef3$export$c4744153514ff05d();
                "function" === typeof e ? $f776d5a8b0cafef3$var$v.callback = e : $f776d5a8b0cafef3$var$v === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
                $f776d5a8b0cafef3$var$G(b);
            } else $f776d5a8b0cafef3$var$k($f776d5a8b0cafef3$var$r);
            $f776d5a8b0cafef3$var$v = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
        }
        if (null !== $f776d5a8b0cafef3$var$v) var w = !0;
        else {
            var m = $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t);
            null !== m && $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f776d5a8b0cafef3$var$v = null, $f776d5a8b0cafef3$var$y = c, $f776d5a8b0cafef3$var$z = !1;
    }
}
var $f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null, $f776d5a8b0cafef3$var$L = -1, $f776d5a8b0cafef3$var$P = 5, $f776d5a8b0cafef3$var$Q = -1;
function $f776d5a8b0cafef3$var$M() {
    return $f776d5a8b0cafef3$export$c4744153514ff05d() - $f776d5a8b0cafef3$var$Q < $f776d5a8b0cafef3$var$P ? !1 : !0;
}
function $f776d5a8b0cafef3$var$R() {
    if (null !== $f776d5a8b0cafef3$var$O) {
        var a = $f776d5a8b0cafef3$export$c4744153514ff05d();
        $f776d5a8b0cafef3$var$Q = a;
        var b = !0;
        try {
            b = $f776d5a8b0cafef3$var$O(!0, a);
        } finally{
            b ? $f776d5a8b0cafef3$var$S() : ($f776d5a8b0cafef3$var$N = !1, $f776d5a8b0cafef3$var$O = null);
        }
    } else $f776d5a8b0cafef3$var$N = !1;
}
var $f776d5a8b0cafef3$var$S;
if ("function" === typeof $f776d5a8b0cafef3$var$F) $f776d5a8b0cafef3$var$S = function() {
    $f776d5a8b0cafef3$var$F($f776d5a8b0cafef3$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f776d5a8b0cafef3$var$T = new MessageChannel, $f776d5a8b0cafef3$var$U = $f776d5a8b0cafef3$var$T.port2;
    $f776d5a8b0cafef3$var$T.port1.onmessage = $f776d5a8b0cafef3$var$R;
    $f776d5a8b0cafef3$var$S = function() {
        $f776d5a8b0cafef3$var$U.postMessage(null);
    };
} else $f776d5a8b0cafef3$var$S = function() {
    $f776d5a8b0cafef3$var$D($f776d5a8b0cafef3$var$R, 0);
};
function $f776d5a8b0cafef3$var$I(a) {
    $f776d5a8b0cafef3$var$O = a;
    $f776d5a8b0cafef3$var$N || ($f776d5a8b0cafef3$var$N = !0, $f776d5a8b0cafef3$var$S());
}
function $f776d5a8b0cafef3$var$K(a, b) {
    $f776d5a8b0cafef3$var$L = $f776d5a8b0cafef3$var$D(function() {
        a($f776d5a8b0cafef3$export$c4744153514ff05d());
    }, b);
}
$f776d5a8b0cafef3$export$3e506c1ccc9cc1a7 = 5;
$f776d5a8b0cafef3$export$e26fe2ed2fa76875 = 1;
$f776d5a8b0cafef3$export$502329bbf4b505b1 = 4;
$f776d5a8b0cafef3$export$6e3807111c4874c4 = 3;
$f776d5a8b0cafef3$export$c27134553091fb3a = null;
$f776d5a8b0cafef3$export$33ee1acdc04fd2a2 = 2;
$f776d5a8b0cafef3$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f776d5a8b0cafef3$export$8352ce38b91d0c62 = function() {
    $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J));
};
$f776d5a8b0cafef3$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f776d5a8b0cafef3$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f776d5a8b0cafef3$export$d3dfb8e4810cb555 = function() {
    return $f776d5a8b0cafef3$var$y;
};
$f776d5a8b0cafef3$export$839f9183b0465a69 = function() {
    return $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r);
};
$f776d5a8b0cafef3$export$72fdf0e06517287b = function(a) {
    switch($f776d5a8b0cafef3$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f776d5a8b0cafef3$var$y;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = b;
    try {
        return a();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$4b844e58a3e414b4 = function() {};
$f776d5a8b0cafef3$export$816d2913ae6b83b1 = function() {};
$f776d5a8b0cafef3$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f776d5a8b0cafef3$var$y;
    $f776d5a8b0cafef3$var$y = a;
    try {
        return b();
    } finally{
        $f776d5a8b0cafef3$var$y = c;
    }
};
$f776d5a8b0cafef3$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f776d5a8b0cafef3$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f776d5a8b0cafef3$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$t, a), null === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$r) && a === $f776d5a8b0cafef3$var$h($f776d5a8b0cafef3$var$t) && ($f776d5a8b0cafef3$var$B ? ($f776d5a8b0cafef3$var$E($f776d5a8b0cafef3$var$L), $f776d5a8b0cafef3$var$L = -1) : $f776d5a8b0cafef3$var$B = !0, $f776d5a8b0cafef3$var$K($f776d5a8b0cafef3$var$H, c - d))) : (a.sortIndex = e, $f776d5a8b0cafef3$var$f($f776d5a8b0cafef3$var$r, a), $f776d5a8b0cafef3$var$A || $f776d5a8b0cafef3$var$z || ($f776d5a8b0cafef3$var$A = !0, $f776d5a8b0cafef3$var$I($f776d5a8b0cafef3$var$J)));
    return a;
};
$f776d5a8b0cafef3$export$b5836b71941fa3ed = $f776d5a8b0cafef3$var$M;
$f776d5a8b0cafef3$export$cf845f2c119da08a = function(a) {
    var b = $f776d5a8b0cafef3$var$y;
    return function() {
        var c = $f776d5a8b0cafef3$var$y;
        $f776d5a8b0cafef3$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f776d5a8b0cafef3$var$y = c;
        }
    };
};

});



parcelRegister("jlWHo", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("aqbQf")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRegister("aqbQf", function(module, exports) {
"use strict";

});


parcelRegister("cYl7t", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $971b7885424ac20e$export$69f1b2dcda23c5f8; }, function (v) { return $971b7885424ac20e$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $971b7885424ac20e$export$45b10814cc054894; }, function (v) { return $971b7885424ac20e$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $971b7885424ac20e$export$7ea66e3774a60b67; }, function (v) { return $971b7885424ac20e$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $971b7885424ac20e$export$34a52f00f601f6f1; }, function (v) { return $971b7885424ac20e$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $971b7885424ac20e$export$812b0cbd5e8a72ab; }, function (v) { return $971b7885424ac20e$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $971b7885424ac20e$export$f24f9e11d63bb314; }, function (v) { return $971b7885424ac20e$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $971b7885424ac20e$export$b71357c7e07ca1f1; }, function (v) { return $971b7885424ac20e$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $971b7885424ac20e$export$2e58a4b541fdcbe8; }, function (v) { return $971b7885424ac20e$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $971b7885424ac20e$export$183b950bde9faab8; }, function (v) { return $971b7885424ac20e$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $971b7885424ac20e$export$4785c77169fea59e; }, function (v) { return $971b7885424ac20e$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $971b7885424ac20e$export$242a185dfcffac5b; }, function (v) { return $971b7885424ac20e$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $971b7885424ac20e$export$58c04ae0ae31877d; }, function (v) { return $971b7885424ac20e$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $971b7885424ac20e$export$d058ca695f8c6f11; }, function (v) { return $971b7885424ac20e$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $971b7885424ac20e$export$a1efd7fc3e986367; }, function (v) { return $971b7885424ac20e$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $971b7885424ac20e$export$bbfea4a2b5abaab4; }, function (v) { return $971b7885424ac20e$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $971b7885424ac20e$export$97ad4afc7de86152; }, function (v) { return $971b7885424ac20e$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $971b7885424ac20e$export$ce4673d9a79f6a4b; }, function (v) { return $971b7885424ac20e$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $971b7885424ac20e$export$786cc99fc6eedc0b; }, function (v) { return $971b7885424ac20e$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $971b7885424ac20e$export$45c59b9a1848dd0; }, function (v) { return $971b7885424ac20e$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $971b7885424ac20e$export$50d8f613e76d3034; }, function (v) { return $971b7885424ac20e$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $971b7885424ac20e$export$b8e83683c60ee162; }, function (v) { return $971b7885424ac20e$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $971b7885424ac20e$export$aeeb51790d1bcc4a; }, function (v) { return $971b7885424ac20e$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $971b7885424ac20e$export$bb7c616f719ad9c; }, function (v) { return $971b7885424ac20e$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $971b7885424ac20e$export$4d63290824f9d7df; }, function (v) { return $971b7885424ac20e$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $971b7885424ac20e$export$2f64ceb90ef28ea1; }, function (v) { return $971b7885424ac20e$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $971b7885424ac20e$export$8d2089d465f6d10d; }, function (v) { return $971b7885424ac20e$export$8d2089d465f6d10d = v; });
var $971b7885424ac20e$export$69f1b2dcda23c5f8;
var $971b7885424ac20e$export$45b10814cc054894;
var $971b7885424ac20e$export$7ea66e3774a60b67;
var $971b7885424ac20e$export$34a52f00f601f6f1;
var $971b7885424ac20e$export$812b0cbd5e8a72ab;
var $971b7885424ac20e$export$f24f9e11d63bb314;
var $971b7885424ac20e$export$b71357c7e07ca1f1;
var $971b7885424ac20e$export$2e58a4b541fdcbe8;
var $971b7885424ac20e$export$183b950bde9faab8;
var $971b7885424ac20e$export$4785c77169fea59e;
var $971b7885424ac20e$export$242a185dfcffac5b;
var $971b7885424ac20e$export$58c04ae0ae31877d;
var $971b7885424ac20e$export$d058ca695f8c6f11;
var $971b7885424ac20e$export$a1efd7fc3e986367;
var $971b7885424ac20e$export$bbfea4a2b5abaab4;
var $971b7885424ac20e$export$97ad4afc7de86152;
var $971b7885424ac20e$export$ce4673d9a79f6a4b;
var $971b7885424ac20e$export$786cc99fc6eedc0b;
var $971b7885424ac20e$export$45c59b9a1848dd0;
var $971b7885424ac20e$export$50d8f613e76d3034;
var $971b7885424ac20e$export$b8e83683c60ee162;
var $971b7885424ac20e$export$aeeb51790d1bcc4a;
var $971b7885424ac20e$export$bb7c616f719ad9c;
var $971b7885424ac20e$export$4d63290824f9d7df;
var $971b7885424ac20e$export$2f64ceb90ef28ea1;
var $971b7885424ac20e$export$8d2089d465f6d10d;
"use strict";

var $3210N = parcelRequire("3210N");

var $kvFQ5 = parcelRequire("kvFQ5");
$971b7885424ac20e$export$69f1b2dcda23c5f8 = $kvFQ5;
function $971b7885424ac20e$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $971b7885424ac20e$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($971b7885424ac20e$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$971b7885424ac20e$export$45b10814cc054894 = $971b7885424ac20e$var$toArray;
function $971b7885424ac20e$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $971b7885424ac20e$var$zero2(msg[i].toString(16));
    return res;
}
$971b7885424ac20e$export$7ea66e3774a60b67 = $971b7885424ac20e$var$toHex;
function $971b7885424ac20e$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$971b7885424ac20e$export$34a52f00f601f6f1 = $971b7885424ac20e$var$htonl;
function $971b7885424ac20e$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $971b7885424ac20e$var$htonl(w);
        res += $971b7885424ac20e$var$zero8(w.toString(16));
    }
    return res;
}
$971b7885424ac20e$export$812b0cbd5e8a72ab = $971b7885424ac20e$var$toHex32;
function $971b7885424ac20e$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$971b7885424ac20e$export$f24f9e11d63bb314 = $971b7885424ac20e$var$zero2;
function $971b7885424ac20e$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$971b7885424ac20e$export$b71357c7e07ca1f1 = $971b7885424ac20e$var$zero8;
function $971b7885424ac20e$var$join32(msg, start, end, endian) {
    var len = end - start;
    $3210N(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$971b7885424ac20e$export$2e58a4b541fdcbe8 = $971b7885424ac20e$var$join32;
function $971b7885424ac20e$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$971b7885424ac20e$export$183b950bde9faab8 = $971b7885424ac20e$var$split32;
function $971b7885424ac20e$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$971b7885424ac20e$export$4785c77169fea59e = $971b7885424ac20e$var$rotr32;
function $971b7885424ac20e$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$971b7885424ac20e$export$242a185dfcffac5b = $971b7885424ac20e$var$rotl32;
function $971b7885424ac20e$var$sum32(a, b) {
    return a + b >>> 0;
}
$971b7885424ac20e$export$58c04ae0ae31877d = $971b7885424ac20e$var$sum32;
function $971b7885424ac20e$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$971b7885424ac20e$export$d058ca695f8c6f11 = $971b7885424ac20e$var$sum32_3;
function $971b7885424ac20e$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$971b7885424ac20e$export$a1efd7fc3e986367 = $971b7885424ac20e$var$sum32_4;
function $971b7885424ac20e$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$971b7885424ac20e$export$bbfea4a2b5abaab4 = $971b7885424ac20e$var$sum32_5;
function $971b7885424ac20e$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$971b7885424ac20e$export$97ad4afc7de86152 = $971b7885424ac20e$var$sum64;
function $971b7885424ac20e$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$971b7885424ac20e$export$ce4673d9a79f6a4b = $971b7885424ac20e$var$sum64_hi;
function $971b7885424ac20e$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$971b7885424ac20e$export$786cc99fc6eedc0b = $971b7885424ac20e$var$sum64_lo;
function $971b7885424ac20e$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$971b7885424ac20e$export$45c59b9a1848dd0 = $971b7885424ac20e$var$sum64_4_hi;
function $971b7885424ac20e$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$971b7885424ac20e$export$50d8f613e76d3034 = $971b7885424ac20e$var$sum64_4_lo;
function $971b7885424ac20e$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$971b7885424ac20e$export$b8e83683c60ee162 = $971b7885424ac20e$var$sum64_5_hi;
function $971b7885424ac20e$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$971b7885424ac20e$export$aeeb51790d1bcc4a = $971b7885424ac20e$var$sum64_5_lo;
function $971b7885424ac20e$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$971b7885424ac20e$export$bb7c616f719ad9c = $971b7885424ac20e$var$rotr64_hi;
function $971b7885424ac20e$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$971b7885424ac20e$export$4d63290824f9d7df = $971b7885424ac20e$var$rotr64_lo;
function $971b7885424ac20e$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$971b7885424ac20e$export$2f64ceb90ef28ea1 = $971b7885424ac20e$var$shr64_hi;
function $971b7885424ac20e$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$971b7885424ac20e$export$8d2089d465f6d10d = $971b7885424ac20e$var$shr64_lo;

});
parcelRegister("3210N", function(module, exports) {
module.exports = $235257eb35d12727$var$assert;
function $235257eb35d12727$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$235257eb35d12727$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});

parcelRegister("kvFQ5", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("1pS1U", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $10820970b61d1a41$export$8687658379b577e6; }, function (v) { return $10820970b61d1a41$export$8687658379b577e6 = v; });
var $10820970b61d1a41$export$8687658379b577e6;
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $3210N = parcelRequire("3210N");
function $10820970b61d1a41$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$10820970b61d1a41$export$8687658379b577e6 = $10820970b61d1a41$var$BlockHash;
$10820970b61d1a41$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $cYl7t.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $cYl7t.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$10820970b61d1a41$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $3210N(this.pending === null);
    return this._digest(enc);
};
$10820970b61d1a41$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("imuzp", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $d5e1fea904e0f988$export$5091bdda49ba90f5; }, function (v) { return $d5e1fea904e0f988$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $d5e1fea904e0f988$export$97b70509d4e397ea; }, function (v) { return $d5e1fea904e0f988$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $d5e1fea904e0f988$export$bced8d2aada2d1c9; }, function (v) { return $d5e1fea904e0f988$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $d5e1fea904e0f988$export$612d47d55dedde45; }, function (v) { return $d5e1fea904e0f988$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $d5e1fea904e0f988$export$a888d2532e6dc7bb; }, function (v) { return $d5e1fea904e0f988$export$a888d2532e6dc7bb = v; });
var $d5e1fea904e0f988$export$5091bdda49ba90f5;
var $d5e1fea904e0f988$export$97b70509d4e397ea;
var $d5e1fea904e0f988$export$bced8d2aada2d1c9;
var $d5e1fea904e0f988$export$612d47d55dedde45;
var $d5e1fea904e0f988$export$a888d2532e6dc7bb;
"use strict";

$d5e1fea904e0f988$export$5091bdda49ba90f5 = (parcelRequire("2cerY"));

$d5e1fea904e0f988$export$97b70509d4e397ea = (parcelRequire("i5Q5x"));

$d5e1fea904e0f988$export$bced8d2aada2d1c9 = (parcelRequire("3HSKF"));

$d5e1fea904e0f988$export$612d47d55dedde45 = (parcelRequire("aWFyw"));

$d5e1fea904e0f988$export$a888d2532e6dc7bb = (parcelRequire("6bcDP"));

});
parcelRegister("2cerY", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $1pS1U = parcelRequire("1pS1U");

var $bznKp = parcelRequire("bznKp");
var $1997e941b78c78de$var$rotl32 = $cYl7t.rotl32;
var $1997e941b78c78de$var$sum32 = $cYl7t.sum32;
var $1997e941b78c78de$var$sum32_5 = $cYl7t.sum32_5;
var $1997e941b78c78de$var$ft_1 = $bznKp.ft_1;
var $1997e941b78c78de$var$BlockHash = $1pS1U.BlockHash;
var $1997e941b78c78de$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $1997e941b78c78de$var$SHA1() {
    if (!(this instanceof $1997e941b78c78de$var$SHA1)) return new $1997e941b78c78de$var$SHA1();
    $1997e941b78c78de$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$cYl7t.inherits($1997e941b78c78de$var$SHA1, $1997e941b78c78de$var$BlockHash);
module.exports = $1997e941b78c78de$var$SHA1;
$1997e941b78c78de$var$SHA1.blockSize = 512;
$1997e941b78c78de$var$SHA1.outSize = 160;
$1997e941b78c78de$var$SHA1.hmacStrength = 80;
$1997e941b78c78de$var$SHA1.padLength = 64;
$1997e941b78c78de$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $1997e941b78c78de$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $1997e941b78c78de$var$sum32_5($1997e941b78c78de$var$rotl32(a, 5), $1997e941b78c78de$var$ft_1(s, b, c, d), e, W[i], $1997e941b78c78de$var$sha1_K[s]);
        e = d;
        d = c;
        c = $1997e941b78c78de$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $1997e941b78c78de$var$sum32(this.h[0], a);
    this.h[1] = $1997e941b78c78de$var$sum32(this.h[1], b);
    this.h[2] = $1997e941b78c78de$var$sum32(this.h[2], c);
    this.h[3] = $1997e941b78c78de$var$sum32(this.h[3], d);
    this.h[4] = $1997e941b78c78de$var$sum32(this.h[4], e);
};
$1997e941b78c78de$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h, "big");
    else return $cYl7t.split32(this.h, "big");
};

});
parcelRegister("bznKp", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $86c562611187daa4$export$5a92649d7ddb9f63; }, function (v) { return $86c562611187daa4$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $86c562611187daa4$export$c6d0d020c3a6269; }, function (v) { return $86c562611187daa4$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $86c562611187daa4$export$eb90c27fca05f956; }, function (v) { return $86c562611187daa4$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $86c562611187daa4$export$14a4a98e063b1999; }, function (v) { return $86c562611187daa4$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $86c562611187daa4$export$d20cecfa1564c686; }, function (v) { return $86c562611187daa4$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $86c562611187daa4$export$44fd472a12fc6db; }, function (v) { return $86c562611187daa4$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $86c562611187daa4$export$1ed238bb6ea1dd47; }, function (v) { return $86c562611187daa4$export$1ed238bb6ea1dd47 = v; });
var $86c562611187daa4$export$5a92649d7ddb9f63;
var $86c562611187daa4$export$c6d0d020c3a6269;
var $86c562611187daa4$export$eb90c27fca05f956;
var $86c562611187daa4$export$cc992891a14496a1;
var $86c562611187daa4$export$14a4a98e063b1999;
var $86c562611187daa4$export$d20cecfa1564c686;
var $86c562611187daa4$export$44fd472a12fc6db;
var $86c562611187daa4$export$1ed238bb6ea1dd47;
"use strict";

var $cYl7t = parcelRequire("cYl7t");
var $86c562611187daa4$var$rotr32 = $cYl7t.rotr32;
function $86c562611187daa4$var$ft_1(s, x, y, z) {
    if (s === 0) return $86c562611187daa4$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $86c562611187daa4$var$p32(x, y, z);
    if (s === 2) return $86c562611187daa4$var$maj32(x, y, z);
}
$86c562611187daa4$export$5a92649d7ddb9f63 = $86c562611187daa4$var$ft_1;
function $86c562611187daa4$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$86c562611187daa4$export$c6d0d020c3a6269 = $86c562611187daa4$var$ch32;
function $86c562611187daa4$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$86c562611187daa4$export$eb90c27fca05f956 = $86c562611187daa4$var$maj32;
function $86c562611187daa4$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$86c562611187daa4$export$cc992891a14496a1 = $86c562611187daa4$var$p32;
function $86c562611187daa4$var$s0_256(x) {
    return $86c562611187daa4$var$rotr32(x, 2) ^ $86c562611187daa4$var$rotr32(x, 13) ^ $86c562611187daa4$var$rotr32(x, 22);
}
$86c562611187daa4$export$14a4a98e063b1999 = $86c562611187daa4$var$s0_256;
function $86c562611187daa4$var$s1_256(x) {
    return $86c562611187daa4$var$rotr32(x, 6) ^ $86c562611187daa4$var$rotr32(x, 11) ^ $86c562611187daa4$var$rotr32(x, 25);
}
$86c562611187daa4$export$d20cecfa1564c686 = $86c562611187daa4$var$s1_256;
function $86c562611187daa4$var$g0_256(x) {
    return $86c562611187daa4$var$rotr32(x, 7) ^ $86c562611187daa4$var$rotr32(x, 18) ^ x >>> 3;
}
$86c562611187daa4$export$44fd472a12fc6db = $86c562611187daa4$var$g0_256;
function $86c562611187daa4$var$g1_256(x) {
    return $86c562611187daa4$var$rotr32(x, 17) ^ $86c562611187daa4$var$rotr32(x, 19) ^ x >>> 10;
}
$86c562611187daa4$export$1ed238bb6ea1dd47 = $86c562611187daa4$var$g1_256;

});


parcelRegister("i5Q5x", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $3HSKF = parcelRequire("3HSKF");
function $d2c1194d6901331b$var$SHA224() {
    if (!(this instanceof $d2c1194d6901331b$var$SHA224)) return new $d2c1194d6901331b$var$SHA224();
    $3HSKF.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$cYl7t.inherits($d2c1194d6901331b$var$SHA224, $3HSKF);
module.exports = $d2c1194d6901331b$var$SHA224;
$d2c1194d6901331b$var$SHA224.blockSize = 512;
$d2c1194d6901331b$var$SHA224.outSize = 224;
$d2c1194d6901331b$var$SHA224.hmacStrength = 192;
$d2c1194d6901331b$var$SHA224.padLength = 64;
$d2c1194d6901331b$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $cYl7t.toHex32(this.h.slice(0, 7), "big");
    else return $cYl7t.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("3HSKF", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $1pS1U = parcelRequire("1pS1U");

var $bznKp = parcelRequire("bznKp");

var $3210N = parcelRequire("3210N");
var $2b2fdbcd8fab6652$var$sum32 = $cYl7t.sum32;
var $2b2fdbcd8fab6652$var$sum32_4 = $cYl7t.sum32_4;
var $2b2fdbcd8fab6652$var$sum32_5 = $cYl7t.sum32_5;
var $2b2fdbcd8fab6652$var$ch32 = $bznKp.ch32;
var $2b2fdbcd8fab6652$var$maj32 = $bznKp.maj32;
var $2b2fdbcd8fab6652$var$s0_256 = $bznKp.s0_256;
var $2b2fdbcd8fab6652$var$s1_256 = $bznKp.s1_256;
var $2b2fdbcd8fab6652$var$g0_256 = $bznKp.g0_256;
var $2b2fdbcd8fab6652$var$g1_256 = $bznKp.g1_256;
var $2b2fdbcd8fab6652$var$BlockHash = $1pS1U.BlockHash;
var $2b2fdbcd8fab6652$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $2b2fdbcd8fab6652$var$SHA256() {
    if (!(this instanceof $2b2fdbcd8fab6652$var$SHA256)) return new $2b2fdbcd8fab6652$var$SHA256();
    $2b2fdbcd8fab6652$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $2b2fdbcd8fab6652$var$sha256_K;
    this.W = new Array(64);
}
$cYl7t.inherits($2b2fdbcd8fab6652$var$SHA256, $2b2fdbcd8fab6652$var$BlockHash);
module.exports = $2b2fdbcd8fab6652$var$SHA256;
$2b2fdbcd8fab6652$var$SHA256.blockSize = 512;
$2b2fdbcd8fab6652$var$SHA256.outSize = 256;
$2b2fdbcd8fab6652$var$SHA256.hmacStrength = 192;
$2b2fdbcd8fab6652$var$SHA256.padLength = 64;
$2b2fdbcd8fab6652$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $2b2fdbcd8fab6652$var$sum32_4($2b2fdbcd8fab6652$var$g1_256(W[i - 2]), W[i - 7], $2b2fdbcd8fab6652$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $3210N(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $2b2fdbcd8fab6652$var$sum32_5(h, $2b2fdbcd8fab6652$var$s1_256(e), $2b2fdbcd8fab6652$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $2b2fdbcd8fab6652$var$sum32($2b2fdbcd8fab6652$var$s0_256(a), $2b2fdbcd8fab6652$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $2b2fdbcd8fab6652$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $2b2fdbcd8fab6652$var$sum32(T1, T2);
    }
    this.h[0] = $2b2fdbcd8fab6652$var$sum32(this.h[0], a);
    this.h[1] = $2b2fdbcd8fab6652$var$sum32(this.h[1], b);
    this.h[2] = $2b2fdbcd8fab6652$var$sum32(this.h[2], c);
    this.h[3] = $2b2fdbcd8fab6652$var$sum32(this.h[3], d);
    this.h[4] = $2b2fdbcd8fab6652$var$sum32(this.h[4], e);
    this.h[5] = $2b2fdbcd8fab6652$var$sum32(this.h[5], f);
    this.h[6] = $2b2fdbcd8fab6652$var$sum32(this.h[6], g);
    this.h[7] = $2b2fdbcd8fab6652$var$sum32(this.h[7], h);
};
$2b2fdbcd8fab6652$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h, "big");
    else return $cYl7t.split32(this.h, "big");
};

});


parcelRegister("aWFyw", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $6bcDP = parcelRequire("6bcDP");
function $7f7f8e474b2a977d$var$SHA384() {
    if (!(this instanceof $7f7f8e474b2a977d$var$SHA384)) return new $7f7f8e474b2a977d$var$SHA384();
    $6bcDP.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$cYl7t.inherits($7f7f8e474b2a977d$var$SHA384, $6bcDP);
module.exports = $7f7f8e474b2a977d$var$SHA384;
$7f7f8e474b2a977d$var$SHA384.blockSize = 1024;
$7f7f8e474b2a977d$var$SHA384.outSize = 384;
$7f7f8e474b2a977d$var$SHA384.hmacStrength = 192;
$7f7f8e474b2a977d$var$SHA384.padLength = 128;
$7f7f8e474b2a977d$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h.slice(0, 12), "big");
    else return $cYl7t.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("6bcDP", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $1pS1U = parcelRequire("1pS1U");

var $3210N = parcelRequire("3210N");
var $47fd937a71a2450c$var$rotr64_hi = $cYl7t.rotr64_hi;
var $47fd937a71a2450c$var$rotr64_lo = $cYl7t.rotr64_lo;
var $47fd937a71a2450c$var$shr64_hi = $cYl7t.shr64_hi;
var $47fd937a71a2450c$var$shr64_lo = $cYl7t.shr64_lo;
var $47fd937a71a2450c$var$sum64 = $cYl7t.sum64;
var $47fd937a71a2450c$var$sum64_hi = $cYl7t.sum64_hi;
var $47fd937a71a2450c$var$sum64_lo = $cYl7t.sum64_lo;
var $47fd937a71a2450c$var$sum64_4_hi = $cYl7t.sum64_4_hi;
var $47fd937a71a2450c$var$sum64_4_lo = $cYl7t.sum64_4_lo;
var $47fd937a71a2450c$var$sum64_5_hi = $cYl7t.sum64_5_hi;
var $47fd937a71a2450c$var$sum64_5_lo = $cYl7t.sum64_5_lo;
var $47fd937a71a2450c$var$BlockHash = $1pS1U.BlockHash;
var $47fd937a71a2450c$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $47fd937a71a2450c$var$SHA512() {
    if (!(this instanceof $47fd937a71a2450c$var$SHA512)) return new $47fd937a71a2450c$var$SHA512();
    $47fd937a71a2450c$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $47fd937a71a2450c$var$sha512_K;
    this.W = new Array(160);
}
$cYl7t.inherits($47fd937a71a2450c$var$SHA512, $47fd937a71a2450c$var$BlockHash);
module.exports = $47fd937a71a2450c$var$SHA512;
$47fd937a71a2450c$var$SHA512.blockSize = 1024;
$47fd937a71a2450c$var$SHA512.outSize = 512;
$47fd937a71a2450c$var$SHA512.hmacStrength = 192;
$47fd937a71a2450c$var$SHA512.padLength = 128;
$47fd937a71a2450c$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $47fd937a71a2450c$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $47fd937a71a2450c$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $47fd937a71a2450c$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $47fd937a71a2450c$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $47fd937a71a2450c$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $47fd937a71a2450c$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$47fd937a71a2450c$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $3210N(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $47fd937a71a2450c$var$s1_512_hi(eh, el);
        var c1_lo = $47fd937a71a2450c$var$s1_512_lo(eh, el);
        var c2_hi = $47fd937a71a2450c$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $47fd937a71a2450c$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $47fd937a71a2450c$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $47fd937a71a2450c$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $47fd937a71a2450c$var$s0_512_hi(ah, al);
        c0_lo = $47fd937a71a2450c$var$s0_512_lo(ah, al);
        c1_hi = $47fd937a71a2450c$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $47fd937a71a2450c$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $47fd937a71a2450c$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $47fd937a71a2450c$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $47fd937a71a2450c$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $47fd937a71a2450c$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $47fd937a71a2450c$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $47fd937a71a2450c$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $47fd937a71a2450c$var$sum64(this.h, 0, ah, al);
    $47fd937a71a2450c$var$sum64(this.h, 2, bh, bl);
    $47fd937a71a2450c$var$sum64(this.h, 4, ch, cl);
    $47fd937a71a2450c$var$sum64(this.h, 6, dh, dl);
    $47fd937a71a2450c$var$sum64(this.h, 8, eh, el);
    $47fd937a71a2450c$var$sum64(this.h, 10, fh, fl);
    $47fd937a71a2450c$var$sum64(this.h, 12, gh, gl);
    $47fd937a71a2450c$var$sum64(this.h, 14, hh, hl);
};
$47fd937a71a2450c$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h, "big");
    else return $cYl7t.split32(this.h, "big");
};
function $47fd937a71a2450c$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$s0_512_hi(xh, xl) {
    var c0_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $47fd937a71a2450c$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $47fd937a71a2450c$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$s0_512_lo(xh, xl) {
    var c0_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $47fd937a71a2450c$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $47fd937a71a2450c$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$s1_512_hi(xh, xl) {
    var c0_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $47fd937a71a2450c$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$s1_512_lo(xh, xl) {
    var c0_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $47fd937a71a2450c$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$g0_512_hi(xh, xl) {
    var c0_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $47fd937a71a2450c$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$g0_512_lo(xh, xl) {
    var c0_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $47fd937a71a2450c$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$g1_512_hi(xh, xl) {
    var c0_hi = $47fd937a71a2450c$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $47fd937a71a2450c$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $47fd937a71a2450c$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $47fd937a71a2450c$var$g1_512_lo(xh, xl) {
    var c0_lo = $47fd937a71a2450c$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $47fd937a71a2450c$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $47fd937a71a2450c$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("jAZNy", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $e44150fbd2160137$export$d1cea0ee4e3f0d3e; }, function (v) { return $e44150fbd2160137$export$d1cea0ee4e3f0d3e = v; });
var $e44150fbd2160137$export$d1cea0ee4e3f0d3e;
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $1pS1U = parcelRequire("1pS1U");
var $e44150fbd2160137$var$rotl32 = $cYl7t.rotl32;
var $e44150fbd2160137$var$sum32 = $cYl7t.sum32;
var $e44150fbd2160137$var$sum32_3 = $cYl7t.sum32_3;
var $e44150fbd2160137$var$sum32_4 = $cYl7t.sum32_4;
var $e44150fbd2160137$var$BlockHash = $1pS1U.BlockHash;
function $e44150fbd2160137$var$RIPEMD160() {
    if (!(this instanceof $e44150fbd2160137$var$RIPEMD160)) return new $e44150fbd2160137$var$RIPEMD160();
    $e44150fbd2160137$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$cYl7t.inherits($e44150fbd2160137$var$RIPEMD160, $e44150fbd2160137$var$BlockHash);
$e44150fbd2160137$export$d1cea0ee4e3f0d3e = $e44150fbd2160137$var$RIPEMD160;
$e44150fbd2160137$var$RIPEMD160.blockSize = 512;
$e44150fbd2160137$var$RIPEMD160.outSize = 160;
$e44150fbd2160137$var$RIPEMD160.hmacStrength = 192;
$e44150fbd2160137$var$RIPEMD160.padLength = 64;
$e44150fbd2160137$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $e44150fbd2160137$var$sum32($e44150fbd2160137$var$rotl32($e44150fbd2160137$var$sum32_4(A, $e44150fbd2160137$var$f(j, B, C, D), msg[$e44150fbd2160137$var$r[j] + start], $e44150fbd2160137$var$K(j)), $e44150fbd2160137$var$s[j]), E);
        A = E;
        E = D;
        D = $e44150fbd2160137$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $e44150fbd2160137$var$sum32($e44150fbd2160137$var$rotl32($e44150fbd2160137$var$sum32_4(Ah, $e44150fbd2160137$var$f(79 - j, Bh, Ch, Dh), msg[$e44150fbd2160137$var$rh[j] + start], $e44150fbd2160137$var$Kh(j)), $e44150fbd2160137$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $e44150fbd2160137$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $e44150fbd2160137$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $e44150fbd2160137$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $e44150fbd2160137$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $e44150fbd2160137$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $e44150fbd2160137$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$e44150fbd2160137$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $cYl7t.toHex32(this.h, "little");
    else return $cYl7t.split32(this.h, "little");
};
function $e44150fbd2160137$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $e44150fbd2160137$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $e44150fbd2160137$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $e44150fbd2160137$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $e44150fbd2160137$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $e44150fbd2160137$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $e44150fbd2160137$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("hC4jp", function(module, exports) {
"use strict";

var $cYl7t = parcelRequire("cYl7t");

var $3210N = parcelRequire("3210N");
function $cd29549494435068$var$Hmac(hash, key, enc) {
    if (!(this instanceof $cd29549494435068$var$Hmac)) return new $cd29549494435068$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($cYl7t.toArray(key, enc));
}
module.exports = $cd29549494435068$var$Hmac;
$cd29549494435068$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $3210N(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$cd29549494435068$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$cd29549494435068$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});

parcelRegister("dQcqA", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $a139c5939e084c8c$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $a139c5939e084c8c$export$2f872c0f2117be69; });

var $j2rU8 = parcelRequire("j2rU8");

var $6M65e = parcelRequire("6M65e");

var $j3HdL = parcelRequire("j3HdL");
"use strict";
const $a139c5939e084c8c$var$logger = new (0, $6M65e.Logger)((0, $j3HdL.version));
function $a139c5939e084c8c$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $a139c5939e084c8c$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $a139c5939e084c8c$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($a139c5939e084c8c$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $a139c5939e084c8c$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $j2rU8.isBytesLike)(object)) $a139c5939e084c8c$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $j2rU8.arrayify)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $a139c5939e084c8c$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $a139c5939e084c8c$export$c564cdbbe6da493(object) {
    return (0, $j2rU8.hexlify)($a139c5939e084c8c$var$_encode(object));
}
function $a139c5939e084c8c$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $a139c5939e084c8c$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $a139c5939e084c8c$var$logger.throwError("child data too short", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $a139c5939e084c8c$var$_decode(data, offset) {
    if (data.length === 0) $a139c5939e084c8c$var$logger.throwError("data too short", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $a139c5939e084c8c$var$logger.throwError("data short segment too short", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {});
        const length = $a139c5939e084c8c$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $a139c5939e084c8c$var$logger.throwError("data long segment too short", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {});
        return $a139c5939e084c8c$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $a139c5939e084c8c$var$logger.throwError("data array too short", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {});
        return $a139c5939e084c8c$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $a139c5939e084c8c$var$logger.throwError("data array too short", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {});
        const length = $a139c5939e084c8c$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $a139c5939e084c8c$var$logger.throwError("data array too short", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $j2rU8.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $a139c5939e084c8c$var$logger.throwError("data too short", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $j2rU8.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $j2rU8.hexlify)(data[offset])
    };
}
function $a139c5939e084c8c$export$2f872c0f2117be69(data) {
    const bytes = (0, $j2rU8.arrayify)(data);
    const decoded = $a139c5939e084c8c$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $a139c5939e084c8c$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}

});
parcelRegister("j2rU8", function(module, exports) {

$parcel$export(module.exports, "isBytesLike", function () { return $ddc3d9704a40b613$export$9a14abb1a440cd5e; });
$parcel$export(module.exports, "isHexString", function () { return $ddc3d9704a40b613$export$b02a40aff8e4ad18; });
$parcel$export(module.exports, "isBytes", function () { return $ddc3d9704a40b613$export$c6fabfbfd097fc30; });
$parcel$export(module.exports, "arrayify", function () { return $ddc3d9704a40b613$export$3131421a7d01b4fb; });
$parcel$export(module.exports, "concat", function () { return $ddc3d9704a40b613$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "stripZeros", function () { return $ddc3d9704a40b613$export$a8f4574d0e56446c; });
$parcel$export(module.exports, "zeroPad", function () { return $ddc3d9704a40b613$export$3cdc770bf8b2ed3d; });
$parcel$export(module.exports, "hexlify", function () { return $ddc3d9704a40b613$export$2b0d6b5fbe698c70; });
$parcel$export(module.exports, "hexDataLength", function () { return $ddc3d9704a40b613$export$13882f896d3c0683; });
$parcel$export(module.exports, "hexDataSlice", function () { return $ddc3d9704a40b613$export$15da666eba198c18; });
$parcel$export(module.exports, "hexConcat", function () { return $ddc3d9704a40b613$export$6d4b99629b38754a; });
$parcel$export(module.exports, "hexValue", function () { return $ddc3d9704a40b613$export$6916af760a341dd3; });
$parcel$export(module.exports, "hexStripZeros", function () { return $ddc3d9704a40b613$export$967bc0082a978949; });
$parcel$export(module.exports, "hexZeroPad", function () { return $ddc3d9704a40b613$export$e9c46a54370b47e8; });
$parcel$export(module.exports, "splitSignature", function () { return $ddc3d9704a40b613$export$7fb170f1e457988f; });
$parcel$export(module.exports, "joinSignature", function () { return $ddc3d9704a40b613$export$71bb9d78a59bbe25; });

var $6M65e = parcelRequire("6M65e");

var $eraBF = parcelRequire("eraBF");
"use strict";
const $ddc3d9704a40b613$var$logger = new (0, $6M65e.Logger)((0, $eraBF.version));
///////////////////////////////
function $ddc3d9704a40b613$var$isHexable(value) {
    return !!value.toHexString;
}
function $ddc3d9704a40b613$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $ddc3d9704a40b613$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $ddc3d9704a40b613$export$9a14abb1a440cd5e(value) {
    return $ddc3d9704a40b613$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $ddc3d9704a40b613$export$c6fabfbfd097fc30(value);
}
function $ddc3d9704a40b613$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $ddc3d9704a40b613$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$ddc3d9704a40b613$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$ddc3d9704a40b613$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $ddc3d9704a40b613$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $ddc3d9704a40b613$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $ddc3d9704a40b613$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($ddc3d9704a40b613$var$isHexable(value)) value = value.toHexString();
    if ($ddc3d9704a40b613$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $ddc3d9704a40b613$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $ddc3d9704a40b613$var$addSlice(new Uint8Array(result));
    }
    if ($ddc3d9704a40b613$export$c6fabfbfd097fc30(value)) return $ddc3d9704a40b613$var$addSlice(new Uint8Array(value));
    return $ddc3d9704a40b613$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $ddc3d9704a40b613$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$ddc3d9704a40b613$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $ddc3d9704a40b613$var$addSlice(result);
}
function $ddc3d9704a40b613$export$a8f4574d0e56446c(value) {
    let result = $ddc3d9704a40b613$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $ddc3d9704a40b613$export$3cdc770bf8b2ed3d(value, length) {
    value = $ddc3d9704a40b613$export$3131421a7d01b4fb(value);
    if (value.length > length) $ddc3d9704a40b613$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $ddc3d9704a40b613$var$addSlice(result);
}
function $ddc3d9704a40b613$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $ddc3d9704a40b613$var$HexCharacters = "0123456789abcdef";
function $ddc3d9704a40b613$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $ddc3d9704a40b613$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $ddc3d9704a40b613$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($ddc3d9704a40b613$var$isHexable(value)) return value.toHexString();
    if ($ddc3d9704a40b613$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $ddc3d9704a40b613$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($ddc3d9704a40b613$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $ddc3d9704a40b613$var$HexCharacters[(v & 0xf0) >> 4] + $ddc3d9704a40b613$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $ddc3d9704a40b613$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $ddc3d9704a40b613$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(data);
    else if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $ddc3d9704a40b613$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(data);
    else if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(data) || data.length % 2) $ddc3d9704a40b613$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $ddc3d9704a40b613$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $ddc3d9704a40b613$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $ddc3d9704a40b613$export$6916af760a341dd3(value) {
    const trimmed = $ddc3d9704a40b613$export$967bc0082a978949($ddc3d9704a40b613$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $ddc3d9704a40b613$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(value);
    if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(value)) $ddc3d9704a40b613$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $ddc3d9704a40b613$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(value);
    else if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(value)) $ddc3d9704a40b613$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $ddc3d9704a40b613$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $ddc3d9704a40b613$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($ddc3d9704a40b613$export$9a14abb1a440cd5e(signature)) {
        let bytes = $ddc3d9704a40b613$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $ddc3d9704a40b613$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $ddc3d9704a40b613$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $ddc3d9704a40b613$export$3cdc770bf8b2ed3d($ddc3d9704a40b613$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $ddc3d9704a40b613$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $ddc3d9704a40b613$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $ddc3d9704a40b613$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $ddc3d9704a40b613$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$ddc3d9704a40b613$export$b02a40aff8e4ad18(result.r)) $ddc3d9704a40b613$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $ddc3d9704a40b613$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$ddc3d9704a40b613$export$b02a40aff8e4ad18(result.s)) $ddc3d9704a40b613$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $ddc3d9704a40b613$export$e9c46a54370b47e8(result.s, 32);
        const vs = $ddc3d9704a40b613$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $ddc3d9704a40b613$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $ddc3d9704a40b613$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$ddc3d9704a40b613$export$b02a40aff8e4ad18(result._vs)) $ddc3d9704a40b613$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $ddc3d9704a40b613$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $ddc3d9704a40b613$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $ddc3d9704a40b613$export$71bb9d78a59bbe25(signature) {
    signature = $ddc3d9704a40b613$export$7fb170f1e457988f(signature);
    return $ddc3d9704a40b613$export$2b0d6b5fbe698c70($ddc3d9704a40b613$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRegister("6M65e", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "Logger", function () { return $4eebf1ca9f327f54$export$efa9a398d6368992; });

var $3uyfT = parcelRequire("3uyfT");
"use strict";
let $4eebf1ca9f327f54$var$_permanentCensorErrors = false;
let $4eebf1ca9f327f54$var$_censorErrors = false;
const $4eebf1ca9f327f54$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $4eebf1ca9f327f54$var$_logLevel = $4eebf1ca9f327f54$var$LogLevels["default"];
let $4eebf1ca9f327f54$var$_globalLogger = null;
function $4eebf1ca9f327f54$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $4eebf1ca9f327f54$var$_normalizeError = $4eebf1ca9f327f54$var$_checkNormalize();
var $4eebf1ca9f327f54$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($4eebf1ca9f327f54$export$243e62d78d3b544d || ($4eebf1ca9f327f54$export$243e62d78d3b544d = {}));
var $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($4eebf1ca9f327f54$export$d4e71bc0b80dc0fb || ($4eebf1ca9f327f54$export$d4e71bc0b80dc0fb = {}));
const $4eebf1ca9f327f54$var$HEX = "0123456789abcdef";
class $4eebf1ca9f327f54$export$efa9a398d6368992 {
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($4eebf1ca9f327f54$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($4eebf1ca9f327f54$var$_logLevel > $4eebf1ca9f327f54$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($4eebf1ca9f327f54$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($4eebf1ca9f327f54$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($4eebf1ca9f327f54$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($4eebf1ca9f327f54$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $4eebf1ca9f327f54$var$HEX[value[i] >> 4];
                        hex += $4eebf1ca9f327f54$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $4eebf1ca9f327f54$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($4eebf1ca9f327f54$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $4eebf1ca9f327f54$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $4eebf1ca9f327f54$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $4eebf1ca9f327f54$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $4eebf1ca9f327f54$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$4eebf1ca9f327f54$var$_globalLogger) $4eebf1ca9f327f54$var$_globalLogger = new $4eebf1ca9f327f54$export$efa9a398d6368992((0, $3uyfT.version));
        return $4eebf1ca9f327f54$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($4eebf1ca9f327f54$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $4eebf1ca9f327f54$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $4eebf1ca9f327f54$var$_censorErrors = !!censorship;
        $4eebf1ca9f327f54$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $4eebf1ca9f327f54$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $4eebf1ca9f327f54$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $4eebf1ca9f327f54$var$_logLevel = level;
    }
    static from(version) {
        return new $4eebf1ca9f327f54$export$efa9a398d6368992(version);
    }
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
}
$4eebf1ca9f327f54$export$efa9a398d6368992.errors = $4eebf1ca9f327f54$export$d4e71bc0b80dc0fb;
$4eebf1ca9f327f54$export$efa9a398d6368992.levels = $4eebf1ca9f327f54$export$243e62d78d3b544d;

});
parcelRegister("3uyfT", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $28aebedb0958c5ea$export$83d89fbfd8236492; });
const $28aebedb0958c5ea$export$83d89fbfd8236492 = "logger/5.7.0";

});


parcelRegister("eraBF", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $a82bd087aad0b6d2$export$83d89fbfd8236492; });
const $a82bd087aad0b6d2$export$83d89fbfd8236492 = "bytes/5.7.0";

});


parcelRegister("j3HdL", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $ddffd2eacde14166$export$83d89fbfd8236492; });
const $ddffd2eacde14166$export$83d89fbfd8236492 = "rlp/5.7.0";

});


parcelRegister("hk1je", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return (parcelRequire("70PIu")).decode; });
$parcel$export(module.exports, "encode", function () { return (parcelRequire("70PIu")).encode; });

var $70PIu = parcelRequire("70PIu");
"use strict";

});
parcelRegister("70PIu", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $51b0a655b2efccfa$export$2f872c0f2117be69; });
$parcel$export(module.exports, "encode", function () { return $51b0a655b2efccfa$export$c564cdbbe6da493; });

var $j2rU8 = parcelRequire("j2rU8");
"use strict";
function $51b0a655b2efccfa$export$2f872c0f2117be69(textData) {
    textData = atob(textData);
    const data = [];
    for(let i = 0; i < textData.length; i++)data.push(textData.charCodeAt(i));
    return (0, $j2rU8.arrayify)(data);
}
function $51b0a655b2efccfa$export$c564cdbbe6da493(data) {
    data = (0, $j2rU8.arrayify)(data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}

});


parcelRegister("ae8dF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("3Cpsw", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataPackage = void 0;

var $hbWVX = parcelRequire("hbWVX");

var $4nqB9 = parcelRequire("4nqB9");

var $t9PVr = parcelRequire("t9PVr");

var $1rXfw = parcelRequire("1rXfw");

var $1B1Kl = parcelRequire("1B1Kl");

var $872HT = parcelRequire("872HT");
class $2a28ab59f8c89f41$var$DataPackage extends $t9PVr.Serializable {
    getEachDataPointByteSize() {
        return this.dataPoints[0].getValueByteSize();
    }
    toBytes() {
        return (0, $hbWVX.concat)([
            this.serializeDataPoints(),
            this.serializeTimestamp(),
            this.serializeDefaultDataPointByteSize(),
            this.serializeDataPointsCount()
        ]);
    }
    toObj() {
        return {
            dataPoints: this.dataPoints.map((dataPoint)=>dataPoint.toObj()),
            timestampMilliseconds: this.timestampMilliseconds
        };
    }
    static fromObj(plainObject) {
        const dataPoints = plainObject.dataPoints.map($1B1Kl.deserializeDataPointFromObj);
        return new $2a28ab59f8c89f41$var$DataPackage(dataPoints, plainObject.timestampMilliseconds);
    }
    getSignableHash() {
        const serializedDataPackage = this.toBytes();
        const signableHashHex = (0, $hbWVX.keccak256)(serializedDataPackage);
        return (0, $hbWVX.arrayify)(signableHashHex);
    }
    sign(privateKey) {
        const signableHashBytes = this.getSignableHash();
        const signingKey = new $hbWVX.SigningKey(privateKey);
        const fullSignature = signingKey.signDigest(signableHashBytes);
        return new $872HT.SignedDataPackage(this, fullSignature);
    }
    serializeDataPoints() {
        this.dataPoints.sort((dp1, dp2)=>{
            const bytes32dataFeedId1Hexlified = (0, $hbWVX.hexlify)(dp1.serializeDataFeedId());
            const bytes32dataFeedId2Hexlified = (0, $hbWVX.hexlify)(dp2.serializeDataFeedId());
            const comparisonResult = bytes32dataFeedId1Hexlified.localeCompare(bytes32dataFeedId2Hexlified);
            (0, $1rXfw.assert)(comparisonResult !== 0, `Duplicated dataFeedId found: ${dp1.dataFeedId}`);
            return comparisonResult;
        });
        return (0, $hbWVX.concat)(this.dataPoints.map((dp)=>dp.toBytes()));
    }
    serializeTimestamp() {
        return (0, $1rXfw.convertIntegerNumberToBytes)(this.timestampMilliseconds, $4nqB9.TIMESTAMP_BS);
    }
    serializeDataPointsCount() {
        return (0, $1rXfw.convertIntegerNumberToBytes)(this.dataPoints.length, $4nqB9.DATA_POINTS_COUNT_BS);
    }
    serializeDefaultDataPointByteSize() {
        return (0, $1rXfw.convertIntegerNumberToBytes)(this.getEachDataPointByteSize(), $4nqB9.DATA_POINT_VALUE_BYTE_SIZE_BS);
    }
    constructor(dataPoints, timestampMilliseconds){
        super();
        (0, $dxWQo._)(this, "dataPoints", void 0);
        (0, $dxWQo._)(this, "timestampMilliseconds", void 0);
        this.dataPoints = dataPoints;
        this.timestampMilliseconds = timestampMilliseconds;
        if (dataPoints.length === 0) throw new Error("Can not create a data package with no data points");
        const expectedDataPointByteSize = dataPoints[0].getValueByteSize();
        for (const dataPoint of dataPoints)(0, $1rXfw.assert)(dataPoint.getValueByteSize() === expectedDataPointByteSize, "Values of all data points in a DataPackage must have the same number of bytes");
    }
}
module.exports.DataPackage = $2a28ab59f8c89f41$var$DataPackage;

});
parcelRegister("dxWQo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9dcc00a39e7f7954$export$1e71eb4bef00f6b0; });
function $9dcc00a39e7f7954$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("hbWVX", function(module, exports) {
"use strict";
var $c8412dc6d1edfef6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c8412dc6d1edfef6$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c8412dc6d1edfef6$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c8412dc6d1edfef6$var$__createBinding(result, mod, k);
    }
    $c8412dc6d1edfef6$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatBytes32String = module.exports.Utf8ErrorFuncs = module.exports.toUtf8String = module.exports.toUtf8CodePoints = module.exports.toUtf8Bytes = module.exports._toEscapedUtf8String = module.exports.nameprep = module.exports.hexDataSlice = module.exports.hexDataLength = module.exports.hexZeroPad = module.exports.hexValue = module.exports.hexStripZeros = module.exports.hexConcat = module.exports.isHexString = module.exports.hexlify = module.exports.base64 = module.exports.base58 = module.exports.TransactionDescription = module.exports.LogDescription = module.exports.Interface = module.exports.SigningKey = module.exports.HDNode = module.exports.defaultPath = module.exports.isBytesLike = module.exports.isBytes = module.exports.zeroPad = module.exports.stripZeros = module.exports.concat = module.exports.arrayify = module.exports.shallowCopy = module.exports.resolveProperties = module.exports.getStatic = module.exports.defineReadOnly = module.exports.deepCopy = module.exports.checkProperties = module.exports.poll = module.exports.fetchJson = module.exports._fetchData = module.exports.RLP = module.exports.Logger = module.exports.checkResultErrors = module.exports.FormatTypes = module.exports.ParamType = module.exports.FunctionFragment = module.exports.EventFragment = module.exports.ErrorFragment = module.exports.ConstructorFragment = module.exports.Fragment = module.exports.defaultAbiCoder = module.exports.AbiCoder = void 0;
module.exports.Indexed = module.exports.Utf8ErrorReason = module.exports.UnicodeNormalizationForm = module.exports.SupportedAlgorithm = module.exports.mnemonicToSeed = module.exports.isValidMnemonic = module.exports.entropyToMnemonic = module.exports.mnemonicToEntropy = module.exports.getAccountPath = module.exports.verifyTypedData = module.exports.verifyMessage = module.exports.recoverPublicKey = module.exports.computePublicKey = module.exports.recoverAddress = module.exports.computeAddress = module.exports.getJsonWalletAddress = module.exports.TransactionTypes = module.exports.serializeTransaction = module.exports.parseTransaction = module.exports.accessListify = module.exports.joinSignature = module.exports.splitSignature = module.exports.soliditySha256 = module.exports.solidityKeccak256 = module.exports.solidityPack = module.exports.shuffled = module.exports.randomBytes = module.exports.sha512 = module.exports.sha256 = module.exports.ripemd160 = module.exports.keccak256 = module.exports.computeHmac = module.exports.commify = module.exports.parseUnits = module.exports.formatUnits = module.exports.parseEther = module.exports.formatEther = module.exports.isAddress = module.exports.getCreate2Address = module.exports.getContractAddress = module.exports.getIcapAddress = module.exports.getAddress = module.exports._TypedDataEncoder = module.exports.id = module.exports.isValidName = module.exports.namehash = module.exports.hashMessage = module.exports.dnsEncode = module.exports.parseBytes32String = void 0;

var $yKVLS = parcelRequire("yKVLS");
var $ggjPf = parcelRequire("ggjPf");
var $6CFiK = parcelRequire("6CFiK");
var $9rkfU = parcelRequire("9rkfU");
Object.defineProperty(module.exports, "AbiCoder", {
    enumerable: true,
    get: function() {
        return $yKVLS.AbiCoder;
    }
});
Object.defineProperty(module.exports, "checkResultErrors", {
    enumerable: true,
    get: function() {
        return $ggjPf.checkResultErrors;
    }
});
Object.defineProperty(module.exports, "ConstructorFragment", {
    enumerable: true,
    get: function() {
        return $6CFiK.ConstructorFragment;
    }
});
Object.defineProperty(module.exports, "defaultAbiCoder", {
    enumerable: true,
    get: function() {
        return $yKVLS.defaultAbiCoder;
    }
});
Object.defineProperty(module.exports, "ErrorFragment", {
    enumerable: true,
    get: function() {
        return $6CFiK.ErrorFragment;
    }
});
Object.defineProperty(module.exports, "EventFragment", {
    enumerable: true,
    get: function() {
        return $6CFiK.EventFragment;
    }
});
Object.defineProperty(module.exports, "FormatTypes", {
    enumerable: true,
    get: function() {
        return $6CFiK.FormatTypes;
    }
});
Object.defineProperty(module.exports, "Fragment", {
    enumerable: true,
    get: function() {
        return $6CFiK.Fragment;
    }
});
Object.defineProperty(module.exports, "FunctionFragment", {
    enumerable: true,
    get: function() {
        return $6CFiK.FunctionFragment;
    }
});
Object.defineProperty(module.exports, "Indexed", {
    enumerable: true,
    get: function() {
        return $9rkfU.Indexed;
    }
});
Object.defineProperty(module.exports, "Interface", {
    enumerable: true,
    get: function() {
        return $9rkfU.Interface;
    }
});
Object.defineProperty(module.exports, "LogDescription", {
    enumerable: true,
    get: function() {
        return $9rkfU.LogDescription;
    }
});
Object.defineProperty(module.exports, "ParamType", {
    enumerable: true,
    get: function() {
        return $6CFiK.ParamType;
    }
});
Object.defineProperty(module.exports, "TransactionDescription", {
    enumerable: true,
    get: function() {
        return $9rkfU.TransactionDescription;
    }
});

var $e8NrM = parcelRequire("e8NrM");
Object.defineProperty(module.exports, "getAddress", {
    enumerable: true,
    get: function() {
        return $e8NrM.getAddress;
    }
});
Object.defineProperty(module.exports, "getCreate2Address", {
    enumerable: true,
    get: function() {
        return $e8NrM.getCreate2Address;
    }
});
Object.defineProperty(module.exports, "getContractAddress", {
    enumerable: true,
    get: function() {
        return $e8NrM.getContractAddress;
    }
});
Object.defineProperty(module.exports, "getIcapAddress", {
    enumerable: true,
    get: function() {
        return $e8NrM.getIcapAddress;
    }
});
Object.defineProperty(module.exports, "isAddress", {
    enumerable: true,
    get: function() {
        return $e8NrM.isAddress;
    }
});

var $c8412dc6d1edfef6$var$base64 = $c8412dc6d1edfef6$var$__importStar((parcelRequire("hk1je")));
module.exports.base64 = $c8412dc6d1edfef6$var$base64;

var $ebtr5 = parcelRequire("ebtr5");
Object.defineProperty(module.exports, "base58", {
    enumerable: true,
    get: function() {
        return $ebtr5.Base58;
    }
});

var $j2rU8 = parcelRequire("j2rU8");
Object.defineProperty(module.exports, "arrayify", {
    enumerable: true,
    get: function() {
        return $j2rU8.arrayify;
    }
});
Object.defineProperty(module.exports, "concat", {
    enumerable: true,
    get: function() {
        return $j2rU8.concat;
    }
});
Object.defineProperty(module.exports, "hexConcat", {
    enumerable: true,
    get: function() {
        return $j2rU8.hexConcat;
    }
});
Object.defineProperty(module.exports, "hexDataSlice", {
    enumerable: true,
    get: function() {
        return $j2rU8.hexDataSlice;
    }
});
Object.defineProperty(module.exports, "hexDataLength", {
    enumerable: true,
    get: function() {
        return $j2rU8.hexDataLength;
    }
});
Object.defineProperty(module.exports, "hexlify", {
    enumerable: true,
    get: function() {
        return $j2rU8.hexlify;
    }
});
Object.defineProperty(module.exports, "hexStripZeros", {
    enumerable: true,
    get: function() {
        return $j2rU8.hexStripZeros;
    }
});
Object.defineProperty(module.exports, "hexValue", {
    enumerable: true,
    get: function() {
        return $j2rU8.hexValue;
    }
});
Object.defineProperty(module.exports, "hexZeroPad", {
    enumerable: true,
    get: function() {
        return $j2rU8.hexZeroPad;
    }
});
Object.defineProperty(module.exports, "isBytes", {
    enumerable: true,
    get: function() {
        return $j2rU8.isBytes;
    }
});
Object.defineProperty(module.exports, "isBytesLike", {
    enumerable: true,
    get: function() {
        return $j2rU8.isBytesLike;
    }
});
Object.defineProperty(module.exports, "isHexString", {
    enumerable: true,
    get: function() {
        return $j2rU8.isHexString;
    }
});
Object.defineProperty(module.exports, "joinSignature", {
    enumerable: true,
    get: function() {
        return $j2rU8.joinSignature;
    }
});
Object.defineProperty(module.exports, "zeroPad", {
    enumerable: true,
    get: function() {
        return $j2rU8.zeroPad;
    }
});
Object.defineProperty(module.exports, "splitSignature", {
    enumerable: true,
    get: function() {
        return $j2rU8.splitSignature;
    }
});
Object.defineProperty(module.exports, "stripZeros", {
    enumerable: true,
    get: function() {
        return $j2rU8.stripZeros;
    }
});

var $kdj79 = parcelRequire("kdj79");
var $4JdI5 = parcelRequire("4JdI5");
var $7vZoR = parcelRequire("7vZoR");
var $4q6En = parcelRequire("4q6En");
Object.defineProperty(module.exports, "_TypedDataEncoder", {
    enumerable: true,
    get: function() {
        return $kdj79.TypedDataEncoder;
    }
});
Object.defineProperty(module.exports, "dnsEncode", {
    enumerable: true,
    get: function() {
        return $4JdI5.dnsEncode;
    }
});
Object.defineProperty(module.exports, "hashMessage", {
    enumerable: true,
    get: function() {
        return $7vZoR.hashMessage;
    }
});
Object.defineProperty(module.exports, "id", {
    enumerable: true,
    get: function() {
        return $4q6En.id;
    }
});
Object.defineProperty(module.exports, "isValidName", {
    enumerable: true,
    get: function() {
        return $4JdI5.isValidName;
    }
});
Object.defineProperty(module.exports, "namehash", {
    enumerable: true,
    get: function() {
        return $4JdI5.namehash;
    }
});

var $5iEGT = parcelRequire("5iEGT");
Object.defineProperty(module.exports, "defaultPath", {
    enumerable: true,
    get: function() {
        return $5iEGT.defaultPath;
    }
});
Object.defineProperty(module.exports, "entropyToMnemonic", {
    enumerable: true,
    get: function() {
        return $5iEGT.entropyToMnemonic;
    }
});
Object.defineProperty(module.exports, "getAccountPath", {
    enumerable: true,
    get: function() {
        return $5iEGT.getAccountPath;
    }
});
Object.defineProperty(module.exports, "HDNode", {
    enumerable: true,
    get: function() {
        return $5iEGT.HDNode;
    }
});
Object.defineProperty(module.exports, "isValidMnemonic", {
    enumerable: true,
    get: function() {
        return $5iEGT.isValidMnemonic;
    }
});
Object.defineProperty(module.exports, "mnemonicToEntropy", {
    enumerable: true,
    get: function() {
        return $5iEGT.mnemonicToEntropy;
    }
});
Object.defineProperty(module.exports, "mnemonicToSeed", {
    enumerable: true,
    get: function() {
        return $5iEGT.mnemonicToSeed;
    }
});

var $6jMeD = parcelRequire("6jMeD");
Object.defineProperty(module.exports, "getJsonWalletAddress", {
    enumerable: true,
    get: function() {
        return $6jMeD.getJsonWalletAddress;
    }
});

var $4ujqV = parcelRequire("4ujqV");
Object.defineProperty(module.exports, "keccak256", {
    enumerable: true,
    get: function() {
        return $4ujqV.keccak256;
    }
});

var $6M65e = parcelRequire("6M65e");
Object.defineProperty(module.exports, "Logger", {
    enumerable: true,
    get: function() {
        return $6M65e.Logger;
    }
});

var $7WUQV = parcelRequire("7WUQV");
var $aCF4U = parcelRequire("aCF4U");
Object.defineProperty(module.exports, "computeHmac", {
    enumerable: true,
    get: function() {
        return $7WUQV.computeHmac;
    }
});
Object.defineProperty(module.exports, "ripemd160", {
    enumerable: true,
    get: function() {
        return $7WUQV.ripemd160;
    }
});
Object.defineProperty(module.exports, "sha256", {
    enumerable: true,
    get: function() {
        return $7WUQV.sha256;
    }
});
Object.defineProperty(module.exports, "sha512", {
    enumerable: true,
    get: function() {
        return $7WUQV.sha512;
    }
});

var $ihTqz = parcelRequire("ihTqz");
Object.defineProperty(module.exports, "solidityKeccak256", {
    enumerable: true,
    get: function() {
        return $ihTqz.keccak256;
    }
});
Object.defineProperty(module.exports, "solidityPack", {
    enumerable: true,
    get: function() {
        return $ihTqz.pack;
    }
});
Object.defineProperty(module.exports, "soliditySha256", {
    enumerable: true,
    get: function() {
        return $ihTqz.sha256;
    }
});

var $4kSyQ = parcelRequire("4kSyQ");
var $5aKt1 = parcelRequire("5aKt1");
Object.defineProperty(module.exports, "randomBytes", {
    enumerable: true,
    get: function() {
        return $4kSyQ.randomBytes;
    }
});
Object.defineProperty(module.exports, "shuffled", {
    enumerable: true,
    get: function() {
        return $5aKt1.shuffled;
    }
});

var $2ax4w = parcelRequire("2ax4w");
Object.defineProperty(module.exports, "checkProperties", {
    enumerable: true,
    get: function() {
        return $2ax4w.checkProperties;
    }
});
Object.defineProperty(module.exports, "deepCopy", {
    enumerable: true,
    get: function() {
        return $2ax4w.deepCopy;
    }
});
Object.defineProperty(module.exports, "defineReadOnly", {
    enumerable: true,
    get: function() {
        return $2ax4w.defineReadOnly;
    }
});
Object.defineProperty(module.exports, "getStatic", {
    enumerable: true,
    get: function() {
        return $2ax4w.getStatic;
    }
});
Object.defineProperty(module.exports, "resolveProperties", {
    enumerable: true,
    get: function() {
        return $2ax4w.resolveProperties;
    }
});
Object.defineProperty(module.exports, "shallowCopy", {
    enumerable: true,
    get: function() {
        return $2ax4w.shallowCopy;
    }
});

var $c8412dc6d1edfef6$var$RLP = $c8412dc6d1edfef6$var$__importStar((parcelRequire("dQcqA")));
module.exports.RLP = $c8412dc6d1edfef6$var$RLP;

var $4LuuL = parcelRequire("4LuuL");
Object.defineProperty(module.exports, "computePublicKey", {
    enumerable: true,
    get: function() {
        return $4LuuL.computePublicKey;
    }
});
Object.defineProperty(module.exports, "recoverPublicKey", {
    enumerable: true,
    get: function() {
        return $4LuuL.recoverPublicKey;
    }
});
Object.defineProperty(module.exports, "SigningKey", {
    enumerable: true,
    get: function() {
        return $4LuuL.SigningKey;
    }
});

var $1Wmc7 = parcelRequire("1Wmc7");
var $9osRb = parcelRequire("9osRb");
var $eHcVC = parcelRequire("eHcVC");
Object.defineProperty(module.exports, "formatBytes32String", {
    enumerable: true,
    get: function() {
        return $9osRb.formatBytes32String;
    }
});
Object.defineProperty(module.exports, "nameprep", {
    enumerable: true,
    get: function() {
        return $eHcVC.nameprep;
    }
});
Object.defineProperty(module.exports, "parseBytes32String", {
    enumerable: true,
    get: function() {
        return $9osRb.parseBytes32String;
    }
});
Object.defineProperty(module.exports, "_toEscapedUtf8String", {
    enumerable: true,
    get: function() {
        return $1Wmc7._toEscapedUtf8String;
    }
});
Object.defineProperty(module.exports, "toUtf8Bytes", {
    enumerable: true,
    get: function() {
        return $1Wmc7.toUtf8Bytes;
    }
});
Object.defineProperty(module.exports, "toUtf8CodePoints", {
    enumerable: true,
    get: function() {
        return $1Wmc7.toUtf8CodePoints;
    }
});
Object.defineProperty(module.exports, "toUtf8String", {
    enumerable: true,
    get: function() {
        return $1Wmc7.toUtf8String;
    }
});
Object.defineProperty(module.exports, "Utf8ErrorFuncs", {
    enumerable: true,
    get: function() {
        return $1Wmc7.Utf8ErrorFuncs;
    }
});

var $hDQeE = parcelRequire("hDQeE");
Object.defineProperty(module.exports, "accessListify", {
    enumerable: true,
    get: function() {
        return $hDQeE.accessListify;
    }
});
Object.defineProperty(module.exports, "computeAddress", {
    enumerable: true,
    get: function() {
        return $hDQeE.computeAddress;
    }
});
Object.defineProperty(module.exports, "parseTransaction", {
    enumerable: true,
    get: function() {
        return $hDQeE.parse;
    }
});
Object.defineProperty(module.exports, "recoverAddress", {
    enumerable: true,
    get: function() {
        return $hDQeE.recoverAddress;
    }
});
Object.defineProperty(module.exports, "serializeTransaction", {
    enumerable: true,
    get: function() {
        return $hDQeE.serialize;
    }
});
Object.defineProperty(module.exports, "TransactionTypes", {
    enumerable: true,
    get: function() {
        return $hDQeE.TransactionTypes;
    }
});

var $41JdS = parcelRequire("41JdS");
Object.defineProperty(module.exports, "commify", {
    enumerable: true,
    get: function() {
        return $41JdS.commify;
    }
});
Object.defineProperty(module.exports, "formatEther", {
    enumerable: true,
    get: function() {
        return $41JdS.formatEther;
    }
});
Object.defineProperty(module.exports, "parseEther", {
    enumerable: true,
    get: function() {
        return $41JdS.parseEther;
    }
});
Object.defineProperty(module.exports, "formatUnits", {
    enumerable: true,
    get: function() {
        return $41JdS.formatUnits;
    }
});
Object.defineProperty(module.exports, "parseUnits", {
    enumerable: true,
    get: function() {
        return $41JdS.parseUnits;
    }
});

var $54wuV = parcelRequire("54wuV");
Object.defineProperty(module.exports, "verifyMessage", {
    enumerable: true,
    get: function() {
        return $54wuV.verifyMessage;
    }
});
Object.defineProperty(module.exports, "verifyTypedData", {
    enumerable: true,
    get: function() {
        return $54wuV.verifyTypedData;
    }
});

var $gqL7R = parcelRequire("gqL7R");
Object.defineProperty(module.exports, "_fetchData", {
    enumerable: true,
    get: function() {
        return $gqL7R._fetchData;
    }
});
Object.defineProperty(module.exports, "fetchJson", {
    enumerable: true,
    get: function() {
        return $gqL7R.fetchJson;
    }
});
Object.defineProperty(module.exports, "poll", {
    enumerable: true,
    get: function() {
        return $gqL7R.poll;
    }
});

var $7WUQV = parcelRequire("7WUQV");
var $aCF4U = parcelRequire("aCF4U");
Object.defineProperty(module.exports, "SupportedAlgorithm", {
    enumerable: true,
    get: function() {
        return $aCF4U.SupportedAlgorithm;
    }
});

var $1Wmc7 = parcelRequire("1Wmc7");
var $9osRb = parcelRequire("9osRb");
var $eHcVC = parcelRequire("eHcVC");
Object.defineProperty(module.exports, "UnicodeNormalizationForm", {
    enumerable: true,
    get: function() {
        return $1Wmc7.UnicodeNormalizationForm;
    }
});
Object.defineProperty(module.exports, "Utf8ErrorReason", {
    enumerable: true,
    get: function() {
        return $1Wmc7.Utf8ErrorReason;
    }
});

});
parcelRegister("yKVLS", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", function () { return $068794918994f80d$export$fe041e1a83d3efc6; });
$parcel$export(module.exports, "defaultAbiCoder", function () { return $068794918994f80d$export$51d1cfcdb913adff; });

var $j2rU8 = parcelRequire("j2rU8");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $ij6uS = parcelRequire("ij6uS");

var $ggjPf = parcelRequire("ggjPf");

var $3X3hC = parcelRequire("3X3hC");

var $6qcrc = parcelRequire("6qcrc");

var $2NwrY = parcelRequire("2NwrY");

var $fMSbI = parcelRequire("fMSbI");

var $jbYON = parcelRequire("jbYON");

var $3Sede = parcelRequire("3Sede");

var $ggBgc = parcelRequire("ggBgc");

var $4pr0F = parcelRequire("4pr0F");

var $i57uN = parcelRequire("i57uN");

var $6CFiK = parcelRequire("6CFiK");
"use strict";
const $068794918994f80d$var$logger = new (0, $6M65e.Logger)((0, $ij6uS.version));
const $068794918994f80d$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $068794918994f80d$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class $068794918994f80d$export$fe041e1a83d3efc6 {
    _getCoder(param) {
        switch(param.baseType){
            case "address":
                return new (0, $3X3hC.AddressCoder)(param.name);
            case "bool":
                return new (0, $2NwrY.BooleanCoder)(param.name);
            case "string":
                return new (0, $4pr0F.StringCoder)(param.name);
            case "bytes":
                return new (0, $fMSbI.BytesCoder)(param.name);
            case "array":
                return new (0, $6qcrc.ArrayCoder)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new (0, $i57uN.TupleCoder)((param.components || []).map((component)=>{
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new (0, $3Sede.NullCoder)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($068794918994f80d$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || size % 8 !== 0) $068794918994f80d$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            return new (0, $ggBgc.NumberCoder)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($068794918994f80d$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) $068794918994f80d$var$logger.throwArgumentError("invalid bytes length", "param", param);
            return new (0, $jbYON.FixedBytesCoder)(size, param.name);
        }
        return $068794918994f80d$var$logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() {
        return 32;
    }
    _getReader(data, allowLoose) {
        return new (0, $ggjPf.Reader)(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new (0, $ggjPf.Writer)(this._getWordSize());
    }
    getDefaultValue(types) {
        const coders = types.map((type)=>this._getCoder((0, $6CFiK.ParamType).from(type)));
        const coder = new (0, $i57uN.TupleCoder)(coders, "_");
        return coder.defaultValue();
    }
    encode(types, values) {
        if (types.length !== values.length) $068794918994f80d$var$logger.throwError("types/values length mismatch", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        const coders = types.map((type)=>this._getCoder((0, $6CFiK.ParamType).from(type)));
        const coder = new (0, $i57uN.TupleCoder)(coders, "_");
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type)=>this._getCoder((0, $6CFiK.ParamType).from(type)));
        const coder = new (0, $i57uN.TupleCoder)(coders, "_");
        return coder.decode(this._getReader((0, $j2rU8.arrayify)(data), loose));
    }
    constructor(coerceFunc){
        (0, $2ax4w.defineReadOnly)(this, "coerceFunc", coerceFunc || null);
    }
}
const $068794918994f80d$export$51d1cfcdb913adff = new $068794918994f80d$export$fe041e1a83d3efc6();

});
parcelRegister("2ax4w", function(module, exports) {

$parcel$export(module.exports, "defineReadOnly", function () { return $19462b55124983f4$export$104236534534f9be; });
$parcel$export(module.exports, "getStatic", function () { return $19462b55124983f4$export$f695fbbf3cdaaf47; });
$parcel$export(module.exports, "resolveProperties", function () { return $19462b55124983f4$export$d503dd157d963b60; });
$parcel$export(module.exports, "checkProperties", function () { return $19462b55124983f4$export$ae5a316ba623b73a; });
$parcel$export(module.exports, "shallowCopy", function () { return $19462b55124983f4$export$9c13236873b118a5; });
$parcel$export(module.exports, "deepCopy", function () { return $19462b55124983f4$export$6c40052bed430212; });
$parcel$export(module.exports, "Description", function () { return $19462b55124983f4$export$393edc798c47379d; });

var $6M65e = parcelRequire("6M65e");

var $2laPa = parcelRequire("2laPa");
"use strict";
var $19462b55124983f4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $19462b55124983f4$var$logger = new (0, $6M65e.Logger)((0, $2laPa.version));
function $19462b55124983f4$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $19462b55124983f4$export$f695fbbf3cdaaf47(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $19462b55124983f4$export$d503dd157d963b60(object) {
    return $19462b55124983f4$var$__awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function $19462b55124983f4$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $19462b55124983f4$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) $19462b55124983f4$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $19462b55124983f4$export$9c13236873b118a5(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const $19462b55124983f4$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $19462b55124983f4$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $19462b55124983f4$var$opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            let value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$19462b55124983f4$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $19462b55124983f4$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $19462b55124983f4$var$_deepCopy(object) {
    if ($19462b55124983f4$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>$19462b55124983f4$export$6c40052bed430212(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            $19462b55124983f4$export$104236534534f9be(result, key, $19462b55124983f4$export$6c40052bed430212(value));
        }
        return result;
    }
    return $19462b55124983f4$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function $19462b55124983f4$export$6c40052bed430212(object) {
    return $19462b55124983f4$var$_deepCopy(object);
}
class $19462b55124983f4$export$393edc798c47379d {
    constructor(info){
        for(const key in info)this[key] = $19462b55124983f4$export$6c40052bed430212(info[key]);
    }
}

});
parcelRegister("2laPa", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $1b45f0663293159e$export$83d89fbfd8236492; });
const $1b45f0663293159e$export$83d89fbfd8236492 = "properties/5.7.0";

});


parcelRegister("ij6uS", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $d53f0a8655f612f5$export$83d89fbfd8236492; });
const $d53f0a8655f612f5$export$83d89fbfd8236492 = "abi/5.7.0";

});

parcelRegister("ggjPf", function(module, exports) {

$parcel$export(module.exports, "checkResultErrors", function () { return $bd6d84ecef385088$export$5546b9ec21157cc2; });
$parcel$export(module.exports, "Coder", function () { return $bd6d84ecef385088$export$2c0c39526f8bad46; });
$parcel$export(module.exports, "Writer", function () { return $bd6d84ecef385088$export$d7a960146e1a269e; });
$parcel$export(module.exports, "Reader", function () { return $bd6d84ecef385088$export$2f7a2f0e90c07dc4; });

var $j2rU8 = parcelRequire("j2rU8");

var $gMArf = parcelRequire("gMArf");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $ij6uS = parcelRequire("ij6uS");
"use strict";
const $bd6d84ecef385088$var$logger = new (0, $6M65e.Logger)((0, $ij6uS.version));
function $bd6d84ecef385088$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class $bd6d84ecef385088$export$2c0c39526f8bad46 {
    _throwError(message, value) {
        $bd6d84ecef385088$var$logger.throwArgumentError(message, this.localName, value);
    }
    constructor(name, type, localName, dynamic){
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
}
class $bd6d84ecef385088$export$d7a960146e1a269e {
    get data() {
        return (0, $j2rU8.hexConcat)(this._data);
    }
    get length() {
        return this._dataLength;
    }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData((0, $j2rU8.concat)(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = (0, $j2rU8.arrayify)(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) bytes = (0, $j2rU8.concat)([
            bytes,
            this._padding.slice(paddingOffset)
        ]);
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = (0, $j2rU8.arrayify)((0, $gMArf.BigNumber).from(value));
        if (bytes.length > this.wordSize) $bd6d84ecef385088$var$logger.throwError("value out-of-bounds", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {
            length: this.wordSize,
            offset: bytes.length
        });
        if (bytes.length % this.wordSize) bytes = (0, $j2rU8.concat)([
            this._padding.slice(bytes.length % this.wordSize),
            bytes
        ]);
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value)=>{
            this._data[offset] = this._getValue(value);
        };
    }
    constructor(wordSize){
        (0, $2ax4w.defineReadOnly)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
}
class $bd6d84ecef385088$export$2f7a2f0e90c07dc4 {
    get data() {
        return (0, $j2rU8.hexlify)(this._data);
    }
    get consumed() {
        return this._offset;
    }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) value = value.toNumber();
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) return this._coerceFunc(name, value);
        return $bd6d84ecef385088$export$2f7a2f0e90c07dc4.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
            else $bd6d84ecef385088$var$logger.throwError("data out-of-bounds", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {
                length: this._data.length,
                offset: this._offset + alignedLength
            });
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new $bd6d84ecef385088$export$2f7a2f0e90c07dc4(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return (0, $gMArf.BigNumber).from(this.readBytes(this.wordSize));
    }
    constructor(data, wordSize, coerceFunc, allowLoose){
        (0, $2ax4w.defineReadOnly)(this, "_data", (0, $j2rU8.arrayify)(data));
        (0, $2ax4w.defineReadOnly)(this, "wordSize", wordSize || 32);
        (0, $2ax4w.defineReadOnly)(this, "_coerceFunc", coerceFunc);
        (0, $2ax4w.defineReadOnly)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
}

});
parcelRegister("gMArf", function(module, exports) {

$parcel$export(module.exports, "isBigNumberish", function () { return $c37d64fad2cf3dce$export$a3d0a7fa9b65683b; });
$parcel$export(module.exports, "BigNumber", function () { return $c37d64fad2cf3dce$export$d97aa349ed20696; });
$parcel$export(module.exports, "_base36To16", function () { return $c37d64fad2cf3dce$export$51e4a08295f7770f; });
$parcel$export(module.exports, "_base16To36", function () { return $c37d64fad2cf3dce$export$1293db5d29c264ff; });

var $jlWHo = parcelRequire("jlWHo");

var $j2rU8 = parcelRequire("j2rU8");

var $6M65e = parcelRequire("6M65e");

var $aLv3y = parcelRequire("aLv3y");
"use strict";
var $c37d64fad2cf3dce$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo))).BN;
const $c37d64fad2cf3dce$var$logger = new (0, $6M65e.Logger)((0, $aLv3y.version));
const $c37d64fad2cf3dce$var$_constructorGuard = {};
const $c37d64fad2cf3dce$var$MAX_SAFE = 0x1fffffffffffff;
function $c37d64fad2cf3dce$export$a3d0a7fa9b65683b(value) {
    return value != null && ($c37d64fad2cf3dce$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $j2rU8.isHexString)(value) || typeof value === "bigint" || (0, $j2rU8.isBytes)(value));
}
// Only warn about passing 10 into radix once
let $c37d64fad2cf3dce$var$_warnedToStringRadix = false;
class $c37d64fad2cf3dce$export$d97aa349ed20696 {
    fromTwos(value) {
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $c37d64fad2cf3dce$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).add($c37d64fad2cf3dce$var$toBN(other)));
    }
    sub(other) {
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).sub($c37d64fad2cf3dce$var$toBN(other)));
    }
    div(other) {
        const o = $c37d64fad2cf3dce$export$d97aa349ed20696.from(other);
        if (o.isZero()) $c37d64fad2cf3dce$var$throwFault("division-by-zero", "div");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).div($c37d64fad2cf3dce$var$toBN(other)));
    }
    mul(other) {
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).mul($c37d64fad2cf3dce$var$toBN(other)));
    }
    mod(other) {
        const value = $c37d64fad2cf3dce$var$toBN(other);
        if (value.isNeg()) $c37d64fad2cf3dce$var$throwFault("division-by-zero", "mod");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $c37d64fad2cf3dce$var$toBN(other);
        if (value.isNeg()) $c37d64fad2cf3dce$var$throwFault("negative-power", "pow");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $c37d64fad2cf3dce$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $c37d64fad2cf3dce$var$throwFault("unbound-bitwise-result", "and");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).and(value));
    }
    or(other) {
        const value = $c37d64fad2cf3dce$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $c37d64fad2cf3dce$var$throwFault("unbound-bitwise-result", "or");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $c37d64fad2cf3dce$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $c37d64fad2cf3dce$var$throwFault("unbound-bitwise-result", "xor");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $c37d64fad2cf3dce$var$throwFault("negative-width", "mask");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $c37d64fad2cf3dce$var$throwFault("negative-width", "shl");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $c37d64fad2cf3dce$var$throwFault("negative-width", "shr");
        return $c37d64fad2cf3dce$var$toBigNumber($c37d64fad2cf3dce$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $c37d64fad2cf3dce$var$toBN(this).eq($c37d64fad2cf3dce$var$toBN(other));
    }
    lt(other) {
        return $c37d64fad2cf3dce$var$toBN(this).lt($c37d64fad2cf3dce$var$toBN(other));
    }
    lte(other) {
        return $c37d64fad2cf3dce$var$toBN(this).lte($c37d64fad2cf3dce$var$toBN(other));
    }
    gt(other) {
        return $c37d64fad2cf3dce$var$toBN(this).gt($c37d64fad2cf3dce$var$toBN(other));
    }
    gte(other) {
        return $c37d64fad2cf3dce$var$toBN(this).gte($c37d64fad2cf3dce$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $c37d64fad2cf3dce$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $c37d64fad2cf3dce$var$toBN(this).toNumber();
        } catch (error) {
            $c37d64fad2cf3dce$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $c37d64fad2cf3dce$var$logger.throwError("this platform does not support BigInt", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$c37d64fad2cf3dce$var$_warnedToStringRadix) {
                    $c37d64fad2cf3dce$var$_warnedToStringRadix = true;
                    $c37d64fad2cf3dce$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $c37d64fad2cf3dce$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $6M65e.Logger).errors.UNEXPECTED_ARGUMENT, {});
            else $c37d64fad2cf3dce$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $6M65e.Logger).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $c37d64fad2cf3dce$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $c37d64fad2cf3dce$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $c37d64fad2cf3dce$export$d97aa349ed20696($c37d64fad2cf3dce$var$_constructorGuard, $c37d64fad2cf3dce$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $c37d64fad2cf3dce$export$d97aa349ed20696($c37d64fad2cf3dce$var$_constructorGuard, $c37d64fad2cf3dce$var$toHex(new $c37d64fad2cf3dce$var$BN(value)));
            return $c37d64fad2cf3dce$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $c37d64fad2cf3dce$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $c37d64fad2cf3dce$var$MAX_SAFE || value <= -$c37d64fad2cf3dce$var$MAX_SAFE) $c37d64fad2cf3dce$var$throwFault("overflow", "BigNumber.from", value);
            return $c37d64fad2cf3dce$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $c37d64fad2cf3dce$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $j2rU8.isBytes)(anyValue)) return $c37d64fad2cf3dce$export$d97aa349ed20696.from((0, $j2rU8.hexlify)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $c37d64fad2cf3dce$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $j2rU8.isHexString)(hex) || hex[0] === "-" && (0, $j2rU8.isHexString)(hex.substring(1))) return $c37d64fad2cf3dce$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $c37d64fad2cf3dce$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
    constructor(constructorGuard, hex){
        if (constructorGuard !== $c37d64fad2cf3dce$var$_constructorGuard) $c37d64fad2cf3dce$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
}
// Normalize the hex string
function $c37d64fad2cf3dce$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $c37d64fad2cf3dce$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $c37d64fad2cf3dce$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $c37d64fad2cf3dce$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $c37d64fad2cf3dce$var$toBigNumber(value) {
    return $c37d64fad2cf3dce$export$d97aa349ed20696.from($c37d64fad2cf3dce$var$toHex(value));
}
function $c37d64fad2cf3dce$var$toBN(value) {
    const hex = $c37d64fad2cf3dce$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $c37d64fad2cf3dce$var$BN("-" + hex.substring(3), 16);
    return new $c37d64fad2cf3dce$var$BN(hex.substring(2), 16);
}
function $c37d64fad2cf3dce$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $c37d64fad2cf3dce$var$logger.throwError(fault, (0, $6M65e.Logger).errors.NUMERIC_FAULT, params);
}
function $c37d64fad2cf3dce$export$51e4a08295f7770f(value) {
    return new $c37d64fad2cf3dce$var$BN(value, 36).toString(16);
}
function $c37d64fad2cf3dce$export$1293db5d29c264ff(value) {
    return new $c37d64fad2cf3dce$var$BN(value, 16).toString(36);
}

});
parcelRegister("aLv3y", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $7d66624d621f023f$export$83d89fbfd8236492; });
const $7d66624d621f023f$export$83d89fbfd8236492 = "bignumber/5.7.0";

});



parcelRegister("3X3hC", function(module, exports) {

$parcel$export(module.exports, "AddressCoder", function () { return $2e096dc236f9984b$export$59dbbded7775bfe7; });

var $e8NrM = parcelRequire("e8NrM");

var $j2rU8 = parcelRequire("j2rU8");

var $ggjPf = parcelRequire("ggjPf");
"use strict";
class $2e096dc236f9984b$export$59dbbded7775bfe7 extends (0, $ggjPf.Coder) {
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = (0, $e8NrM.getAddress)(value);
        } catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $e8NrM.getAddress)((0, $j2rU8.hexZeroPad)(reader.readValue().toHexString(), 20));
    }
    constructor(localName){
        super("address", "address", localName, false);
    }
}

});
parcelRegister("e8NrM", function(module, exports) {

$parcel$export(module.exports, "getAddress", function () { return $a4b82b374f356b4b$export$88411125f012957a; });
$parcel$export(module.exports, "isAddress", function () { return $a4b82b374f356b4b$export$977e255126d763d6; });
$parcel$export(module.exports, "getIcapAddress", function () { return $a4b82b374f356b4b$export$962c4ddada9f668f; });
$parcel$export(module.exports, "getContractAddress", function () { return $a4b82b374f356b4b$export$b7fbffef12272e40; });
$parcel$export(module.exports, "getCreate2Address", function () { return $a4b82b374f356b4b$export$e0b22d96621f73a2; });

var $j2rU8 = parcelRequire("j2rU8");

var $gMArf = parcelRequire("gMArf");

var $4ujqV = parcelRequire("4ujqV");

var $dQcqA = parcelRequire("dQcqA");

var $6M65e = parcelRequire("6M65e");

var $jZSk5 = parcelRequire("jZSk5");
"use strict";
const $a4b82b374f356b4b$var$logger = new (0, $6M65e.Logger)((0, $jZSk5.version));
function $a4b82b374f356b4b$var$getChecksumAddress(address) {
    if (!(0, $j2rU8.isHexString)(address, 20)) $a4b82b374f356b4b$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $j2rU8.arrayify)((0, $4ujqV.keccak256)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $a4b82b374f356b4b$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $a4b82b374f356b4b$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $a4b82b374f356b4b$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$a4b82b374f356b4b$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$a4b82b374f356b4b$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $a4b82b374f356b4b$var$safeDigits = Math.floor($a4b82b374f356b4b$var$log10($a4b82b374f356b4b$var$MAX_SAFE_INTEGER));
function $a4b82b374f356b4b$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $a4b82b374f356b4b$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $a4b82b374f356b4b$var$safeDigits){
        let block = expanded.substring(0, $a4b82b374f356b4b$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $a4b82b374f356b4b$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $a4b82b374f356b4b$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $a4b82b374f356b4b$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $a4b82b374f356b4b$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $a4b82b374f356b4b$var$ibanChecksum(address)) $a4b82b374f356b4b$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $gMArf._base36To16)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $a4b82b374f356b4b$var$getChecksumAddress("0x" + result);
    } else $a4b82b374f356b4b$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $a4b82b374f356b4b$export$977e255126d763d6(address) {
    try {
        $a4b82b374f356b4b$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $a4b82b374f356b4b$export$962c4ddada9f668f(address) {
    let base36 = (0, $gMArf._base16To36)($a4b82b374f356b4b$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $a4b82b374f356b4b$var$ibanChecksum("XE00" + base36) + base36;
}
function $a4b82b374f356b4b$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $a4b82b374f356b4b$export$88411125f012957a(transaction.from);
    } catch (error) {
        $a4b82b374f356b4b$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $j2rU8.stripZeros)((0, $j2rU8.arrayify)((0, $gMArf.BigNumber).from(transaction.nonce).toHexString()));
    return $a4b82b374f356b4b$export$88411125f012957a((0, $j2rU8.hexDataSlice)((0, $4ujqV.keccak256)((0, $dQcqA.encode)([
        from,
        nonce
    ])), 12));
}
function $a4b82b374f356b4b$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $j2rU8.hexDataLength)(salt) !== 32) $a4b82b374f356b4b$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $j2rU8.hexDataLength)(initCodeHash) !== 32) $a4b82b374f356b4b$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $a4b82b374f356b4b$export$88411125f012957a((0, $j2rU8.hexDataSlice)((0, $4ujqV.keccak256)((0, $j2rU8.concat)([
        "0xff",
        $a4b82b374f356b4b$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}

});
parcelRegister("4ujqV", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $344909d1f36347b2$export$f8151fce47ad1c35; });

var $cCjFr = parcelRequire("cCjFr");

var $j2rU8 = parcelRequire("j2rU8");
"use strict";
function $344909d1f36347b2$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($cCjFr))).keccak_256((0, $j2rU8.arrayify)(data));
}

});
parcelRegister("cCjFr", function(module, exports) {

var $aqbQf = parcelRequire("aqbQf");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $aqbQf === "object" && $aqbQf.versions && $aqbQf.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});


parcelRegister("jZSk5", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $03c1c59590656f19$export$83d89fbfd8236492; });
const $03c1c59590656f19$export$83d89fbfd8236492 = "address/5.7.0";

});



parcelRegister("6qcrc", function(module, exports) {

$parcel$export(module.exports, "pack", function () { return $4aced1a0cbed513e$export$2a703dbb0cb35339; });
$parcel$export(module.exports, "unpack", function () { return $4aced1a0cbed513e$export$417857010dc9287f; });
$parcel$export(module.exports, "ArrayCoder", function () { return $4aced1a0cbed513e$export$88bc419d2df11f54; });

var $6M65e = parcelRequire("6M65e");

var $ij6uS = parcelRequire("ij6uS");

var $ggjPf = parcelRequire("ggjPf");

var $ke4Rj = parcelRequire("ke4Rj");
"use strict";
const $4aced1a0cbed513e$var$logger = new (0, $6M65e.Logger)((0, $ij6uS.version));
function $4aced1a0cbed513e$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            if (!name) $4aced1a0cbed513e$var$logger.throwError("cannot encode object for signature with missing names", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $4aced1a0cbed513e$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $4aced1a0cbed513e$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $4aced1a0cbed513e$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $ggjPf.Writer)(writer.wordSize);
    let dynamicWriter = new (0, $ggjPf.Writer)(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $4aced1a0cbed513e$export$417857010dc9287f(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $6M65e.Logger).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $6M65e.Logger).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder)=>{
        const name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index)=>{
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        const value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
        else values[name] = value;
    });
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
    }
    return Object.freeze(values);
}
class $4aced1a0cbed513e$export$88bc419d2df11f54 extends (0, $ggjPf.Coder) {
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        $4aced1a0cbed513e$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $4aced1a0cbed513e$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readValue().toNumber();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            if (count * 32 > reader._data.length) $4aced1a0cbed513e$var$logger.throwError("insufficient data length", (0, $6M65e.Logger).errors.BUFFER_OVERRUN, {
                length: reader._data.length,
                count: count
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $ke4Rj.AnonymousCoder)(this.coder));
        return reader.coerce(this.name, $4aced1a0cbed513e$export$417857010dc9287f(reader, coders));
    }
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
}

});
parcelRegister("ke4Rj", function(module, exports) {

$parcel$export(module.exports, "AnonymousCoder", function () { return $eb98e254fcc8743b$export$87c41d1139a03fa2; });

var $ggjPf = parcelRequire("ggjPf");
"use strict";
class $eb98e254fcc8743b$export$87c41d1139a03fa2 extends (0, $ggjPf.Coder) {
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
    constructor(coder){
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
}

});


parcelRegister("2NwrY", function(module, exports) {

$parcel$export(module.exports, "BooleanCoder", function () { return $209954548c523c50$export$fe9118d6c093150c; });

var $ggjPf = parcelRequire("ggjPf");
"use strict";
class $209954548c523c50$export$fe9118d6c093150c extends (0, $ggjPf.Coder) {
    defaultValue() {
        return false;
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
    constructor(localName){
        super("bool", "bool", localName, false);
    }
}

});

parcelRegister("fMSbI", function(module, exports) {

$parcel$export(module.exports, "DynamicBytesCoder", function () { return $b7e55f4d821202a8$export$db9eadd8df12ad2e; });
$parcel$export(module.exports, "BytesCoder", function () { return $b7e55f4d821202a8$export$e5823e9574df18d2; });

var $j2rU8 = parcelRequire("j2rU8");

var $ggjPf = parcelRequire("ggjPf");
"use strict";
class $b7e55f4d821202a8$export$db9eadd8df12ad2e extends (0, $ggjPf.Coder) {
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $j2rU8.arrayify)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
    constructor(type, localName){
        super(type, type, localName, true);
    }
}
class $b7e55f4d821202a8$export$e5823e9574df18d2 extends $b7e55f4d821202a8$export$db9eadd8df12ad2e {
    decode(reader) {
        return reader.coerce(this.name, (0, $j2rU8.hexlify)(super.decode(reader)));
    }
    constructor(localName){
        super("bytes", localName);
    }
}

});

parcelRegister("jbYON", function(module, exports) {

$parcel$export(module.exports, "FixedBytesCoder", function () { return $df8e38a8c8e0bc75$export$7dec9db68e6bcf5a; });

var $j2rU8 = parcelRequire("j2rU8");

var $ggjPf = parcelRequire("ggjPf");
"use strict";
class $df8e38a8c8e0bc75$export$7dec9db68e6bcf5a extends (0, $ggjPf.Coder) {
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, value) {
        let data = (0, $j2rU8.arrayify)(value);
        if (data.length !== this.size) this._throwError("incorrect data length", value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $j2rU8.hexlify)(reader.readBytes(this.size)));
    }
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
}

});

parcelRegister("3Sede", function(module, exports) {

$parcel$export(module.exports, "NullCoder", function () { return $2d21708e754b0ab4$export$70982cadf2d6b4ec; });

var $ggjPf = parcelRequire("ggjPf");
"use strict";
class $2d21708e754b0ab4$export$70982cadf2d6b4ec extends (0, $ggjPf.Coder) {
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
    constructor(localName){
        super("null", "", localName, false);
    }
}

});

parcelRegister("ggBgc", function(module, exports) {

$parcel$export(module.exports, "NumberCoder", function () { return $bd7b0b14ce22a0d4$export$b934dc8cfe13938c; });

var $gMArf = parcelRequire("gMArf");

var $f2VSc = parcelRequire("f2VSc");

var $ggjPf = parcelRequire("ggjPf");
"use strict";
class $bd7b0b14ce22a0d4$export$b934dc8cfe13938c extends (0, $ggjPf.Coder) {
    defaultValue() {
        return 0;
    }
    encode(writer, value) {
        let v = (0, $gMArf.BigNumber).from(value);
        // Check bounds are safe for encoding
        let maxUintValue = (0, $f2VSc.MaxUint256).mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add((0, $f2VSc.One)).mul((0, $f2VSc.NegativeOne)))) this._throwError("value out-of-bounds", value);
        } else if (v.lt((0, $f2VSc.Zero)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) value = value.fromTwos(this.size * 8);
        return reader.coerce(this.name, value);
    }
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
}

});
parcelRegister("f2VSc", function(module, exports) {

$parcel$export(module.exports, "NegativeOne", function () { return $af43ef4e381177e0$export$c83ef0909a6ddeec; });
$parcel$export(module.exports, "Zero", function () { return $af43ef4e381177e0$export$aaef8a3eae948f03; });
$parcel$export(module.exports, "One", function () { return $af43ef4e381177e0$export$9aa05a5866350bcf; });
$parcel$export(module.exports, "Two", function () { return $af43ef4e381177e0$export$9276dd97bf62cc8d; });
$parcel$export(module.exports, "WeiPerEther", function () { return $af43ef4e381177e0$export$c8db55bd7405209e; });
$parcel$export(module.exports, "MaxUint256", function () { return $af43ef4e381177e0$export$1b53890de5aabdd0; });
$parcel$export(module.exports, "MinInt256", function () { return $af43ef4e381177e0$export$963c9b9317b80aaf; });
$parcel$export(module.exports, "MaxInt256", function () { return $af43ef4e381177e0$export$6f8dbb07ebe6d738; });

var $gMArf = parcelRequire("gMArf");
const $af43ef4e381177e0$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $gMArf.BigNumber).from(-1);
const $af43ef4e381177e0$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $gMArf.BigNumber).from(0);
const $af43ef4e381177e0$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $gMArf.BigNumber).from(1);
const $af43ef4e381177e0$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $gMArf.BigNumber).from(2);
const $af43ef4e381177e0$export$c8db55bd7405209e = /*#__PURE__*/ (0, $gMArf.BigNumber).from("1000000000000000000");
const $af43ef4e381177e0$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $gMArf.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $af43ef4e381177e0$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $gMArf.BigNumber).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $af43ef4e381177e0$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $gMArf.BigNumber).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");

});


parcelRegister("4pr0F", function(module, exports) {

$parcel$export(module.exports, "StringCoder", function () { return $335e72c6451b9b9a$export$2d1b854518731426; });

var $1Wmc7 = parcelRequire("1Wmc7");

var $fMSbI = parcelRequire("fMSbI");
"use strict";
class $335e72c6451b9b9a$export$2d1b854518731426 extends (0, $fMSbI.DynamicBytesCoder) {
    defaultValue() {
        return "";
    }
    encode(writer, value) {
        return super.encode(writer, (0, $1Wmc7.toUtf8Bytes)(value));
    }
    decode(reader) {
        return (0, $1Wmc7.toUtf8String)(super.decode(reader));
    }
    constructor(localName){
        super("string", localName);
    }
}

});
parcelRegister("1Wmc7", function(module, exports) {

$parcel$export(module.exports, "UnicodeNormalizationForm", function () { return $169c6c93221d2e48$export$c6986442964129f5; });
$parcel$export(module.exports, "Utf8ErrorReason", function () { return $169c6c93221d2e48$export$c285fa6ac15ff6a6; });
$parcel$export(module.exports, "Utf8ErrorFuncs", function () { return $169c6c93221d2e48$export$c6e2180c5bb5bc05; });
$parcel$export(module.exports, "toUtf8Bytes", function () { return $169c6c93221d2e48$export$8feeb310b4b4752f; });
$parcel$export(module.exports, "_toEscapedUtf8String", function () { return $169c6c93221d2e48$export$a7a0ec15960b9055; });
$parcel$export(module.exports, "_toUtf8String", function () { return $169c6c93221d2e48$export$232e1dab03132235; });
$parcel$export(module.exports, "toUtf8String", function () { return $169c6c93221d2e48$export$7643a1dc2c38d5eb; });
$parcel$export(module.exports, "toUtf8CodePoints", function () { return $169c6c93221d2e48$export$ae470a36a31b28c2; });

var $j2rU8 = parcelRequire("j2rU8");

var $6M65e = parcelRequire("6M65e");

var $ed1KV = parcelRequire("ed1KV");
"use strict";
const $169c6c93221d2e48$var$logger = new (0, $6M65e.Logger)((0, $ed1KV.version));
var $169c6c93221d2e48$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($169c6c93221d2e48$export$c6986442964129f5 || ($169c6c93221d2e48$export$c6986442964129f5 = {}));
var $169c6c93221d2e48$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($169c6c93221d2e48$export$c285fa6ac15ff6a6 || ($169c6c93221d2e48$export$c285fa6ac15ff6a6 = {}));
function $169c6c93221d2e48$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $169c6c93221d2e48$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $169c6c93221d2e48$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $169c6c93221d2e48$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $169c6c93221d2e48$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $169c6c93221d2e48$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $169c6c93221d2e48$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $169c6c93221d2e48$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $169c6c93221d2e48$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $169c6c93221d2e48$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $169c6c93221d2e48$var$errorFunc,
    ignore: $169c6c93221d2e48$var$ignoreFunc,
    replace: $169c6c93221d2e48$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $169c6c93221d2e48$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $169c6c93221d2e48$export$c6e2180c5bb5bc05.error;
    bytes = (0, $j2rU8.arrayify)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($169c6c93221d2e48$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $169c6c93221d2e48$export$8feeb310b4b4752f(str, form = $169c6c93221d2e48$export$c6986442964129f5.current) {
    if (form != $169c6c93221d2e48$export$c6986442964129f5.current) {
        $169c6c93221d2e48$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $j2rU8.arrayify)(result);
}
function $169c6c93221d2e48$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $169c6c93221d2e48$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $169c6c93221d2e48$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $169c6c93221d2e48$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $169c6c93221d2e48$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $169c6c93221d2e48$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $169c6c93221d2e48$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $169c6c93221d2e48$export$7643a1dc2c38d5eb(bytes, onError) {
    return $169c6c93221d2e48$export$232e1dab03132235($169c6c93221d2e48$var$getUtf8CodePoints(bytes, onError));
}
function $169c6c93221d2e48$export$ae470a36a31b28c2(str, form = $169c6c93221d2e48$export$c6986442964129f5.current) {
    return $169c6c93221d2e48$var$getUtf8CodePoints($169c6c93221d2e48$export$8feeb310b4b4752f(str, form));
}

});
parcelRegister("ed1KV", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $a583a447fefad3f0$export$83d89fbfd8236492; });
const $a583a447fefad3f0$export$83d89fbfd8236492 = "strings/5.7.0";

});



parcelRegister("i57uN", function(module, exports) {

$parcel$export(module.exports, "TupleCoder", function () { return $d29e821f1f0ced09$export$e9fceba8f110fea6; });

var $ggjPf = parcelRequire("ggjPf");

var $6qcrc = parcelRequire("6qcrc");
"use strict";
class $d29e821f1f0ced09$export$e9fceba8f110fea6 extends (0, $ggjPf.Coder) {
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, value) {
        return (0, $6qcrc.pack)(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $6qcrc.unpack)(reader, this.coders));
    }
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
}

});

parcelRegister("6CFiK", function(module, exports) {

$parcel$export(module.exports, "FormatTypes", function () { return $4d2654448f804eaa$export$f010f239efc4d445; });
$parcel$export(module.exports, "ParamType", function () { return $4d2654448f804eaa$export$426dc07f493a4c47; });
$parcel$export(module.exports, "Fragment", function () { return $4d2654448f804eaa$export$ffb0004e005737fa; });
$parcel$export(module.exports, "FunctionFragment", function () { return $4d2654448f804eaa$export$8d576c928b93668f; });
$parcel$export(module.exports, "EventFragment", function () { return $4d2654448f804eaa$export$958548f08bac2833; });
$parcel$export(module.exports, "ConstructorFragment", function () { return $4d2654448f804eaa$export$3ac5c9504f801ea4; });
$parcel$export(module.exports, "ErrorFragment", function () { return $4d2654448f804eaa$export$2c42c6d543aa9b59; });

var $gMArf = parcelRequire("gMArf");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $ij6uS = parcelRequire("ij6uS");
"use strict";
const $4d2654448f804eaa$var$logger = new (0, $6M65e.Logger)((0, $ij6uS.version));
const $4d2654448f804eaa$var$_constructorGuard = {};
let $4d2654448f804eaa$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
let $4d2654448f804eaa$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $4d2654448f804eaa$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($4d2654448f804eaa$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($4d2654448f804eaa$var$ModifiersNest[name]) return true;
    }
    if ($4d2654448f804eaa$var$ModifiersBytes[name] || name === "payable") $4d2654448f804eaa$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $4d2654448f804eaa$var$parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        $4d2654448f804eaa$var$logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    let parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    let node = parent;
    for(let i = 0; i < param.length; i++){
        let c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $4d2654448f804eaa$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($4d2654448f804eaa$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $4d2654448f804eaa$var$verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($4d2654448f804eaa$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $4d2654448f804eaa$var$verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $4d2654448f804eaa$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($4d2654448f804eaa$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $4d2654448f804eaa$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($4d2654448f804eaa$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $4d2654448f804eaa$var$verifyType(parent.type);
    return parent;
}
function $4d2654448f804eaa$var$populate(object, params) {
    for(let key in params)(0, $2ax4w.defineReadOnly)(object, key, params[key]);
}
const $4d2654448f804eaa$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const $4d2654448f804eaa$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class $4d2654448f804eaa$export$426dc07f493a4c47 {
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, address bar) indexed baz"
    format(format) {
        if (!format) format = $4d2654448f804eaa$export$f010f239efc4d445.sighash;
        if (!$4d2654448f804eaa$export$f010f239efc4d445[format]) $4d2654448f804eaa$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $4d2654448f804eaa$export$f010f239efc4d445.json) {
            let result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: this.name || undefined
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.components) result.components = this.components.map((comp)=>JSON.parse(comp.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        } else if (this.baseType === "tuple") {
            if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) result += this.type;
            result += "(" + this.components.map((comp)=>comp.format(format)).join(format === $4d2654448f804eaa$export$f010f239efc4d445.full ? ", " : ",") + ")";
        } else result += this.type;
        if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) {
            if (this.indexed === true) result += " indexed";
            if (format === $4d2654448f804eaa$export$f010f239efc4d445.full && this.name) result += " " + this.name;
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof value === "string") return $4d2654448f804eaa$export$426dc07f493a4c47.fromString(value, allowIndexed);
        return $4d2654448f804eaa$export$426dc07f493a4c47.fromObject(value);
    }
    static fromObject(value) {
        if ($4d2654448f804eaa$export$426dc07f493a4c47.isParamType(value)) return value;
        return new $4d2654448f804eaa$export$426dc07f493a4c47($4d2654448f804eaa$var$_constructorGuard, {
            name: value.name || null,
            type: $4d2654448f804eaa$var$verifyType(value.type),
            indexed: value.indexed == null ? null : !!value.indexed,
            components: value.components ? value.components.map($4d2654448f804eaa$export$426dc07f493a4c47.fromObject) : null
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return $4d2654448f804eaa$export$426dc07f493a4c47.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify($4d2654448f804eaa$var$parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
    constructor(constructorGuard, params){
        if (constructorGuard !== $4d2654448f804eaa$var$_constructorGuard) $4d2654448f804eaa$var$logger.throwError("use fromString", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $4d2654448f804eaa$var$populate(this, params);
        let match = this.type.match($4d2654448f804eaa$var$paramTypeArray);
        if (match) $4d2654448f804eaa$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: $4d2654448f804eaa$export$426dc07f493a4c47.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $4d2654448f804eaa$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
}
function $4d2654448f804eaa$var$parseParams(value, allowIndex) {
    return $4d2654448f804eaa$var$splitNesting(value).map((param)=>$4d2654448f804eaa$export$426dc07f493a4c47.fromString(param, allowIndex));
}
class $4d2654448f804eaa$export$ffb0004e005737fa {
    static from(value) {
        if ($4d2654448f804eaa$export$ffb0004e005737fa.isFragment(value)) return value;
        if (typeof value === "string") return $4d2654448f804eaa$export$ffb0004e005737fa.fromString(value);
        return $4d2654448f804eaa$export$ffb0004e005737fa.fromObject(value);
    }
    static fromObject(value) {
        if ($4d2654448f804eaa$export$ffb0004e005737fa.isFragment(value)) return value;
        switch(value.type){
            case "function":
                return $4d2654448f804eaa$export$8d576c928b93668f.fromObject(value);
            case "event":
                return $4d2654448f804eaa$export$958548f08bac2833.fromObject(value);
            case "constructor":
                return $4d2654448f804eaa$export$3ac5c9504f801ea4.fromObject(value);
            case "error":
                return $4d2654448f804eaa$export$2c42c6d543aa9b59.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return $4d2654448f804eaa$var$logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") return $4d2654448f804eaa$export$958548f08bac2833.fromString(value.substring(5).trim());
        else if (value.split(" ")[0] === "function") return $4d2654448f804eaa$export$8d576c928b93668f.fromString(value.substring(8).trim());
        else if (value.split("(")[0].trim() === "constructor") return $4d2654448f804eaa$export$3ac5c9504f801ea4.fromString(value.trim());
        else if (value.split(" ")[0] === "error") return $4d2654448f804eaa$export$2c42c6d543aa9b59.fromString(value.substring(5).trim());
        return $4d2654448f804eaa$var$logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
    constructor(constructorGuard, params){
        if (constructorGuard !== $4d2654448f804eaa$var$_constructorGuard) $4d2654448f804eaa$var$logger.throwError("use a static from method", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $4d2654448f804eaa$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
}
class $4d2654448f804eaa$export$958548f08bac2833 extends $4d2654448f804eaa$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $4d2654448f804eaa$export$f010f239efc4d445.sighash;
        if (!$4d2654448f804eaa$export$f010f239efc4d445[format]) $4d2654448f804eaa$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $4d2654448f804eaa$export$f010f239efc4d445.json) return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) result += "event ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $4d2654448f804eaa$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) {
            if (this.anonymous) result += "anonymous ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $4d2654448f804eaa$export$958548f08bac2833.fromString(value);
        return $4d2654448f804eaa$export$958548f08bac2833.fromObject(value);
    }
    static fromObject(value) {
        if ($4d2654448f804eaa$export$958548f08bac2833.isEventFragment(value)) return value;
        if (value.type !== "event") $4d2654448f804eaa$var$logger.throwArgumentError("invalid event object", "value", value);
        const params = {
            name: $4d2654448f804eaa$var$verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: value.inputs ? value.inputs.map($4d2654448f804eaa$export$426dc07f493a4c47.fromObject) : [],
            type: "event"
        };
        return new $4d2654448f804eaa$export$958548f08bac2833($4d2654448f804eaa$var$_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match($4d2654448f804eaa$var$regexParen);
        if (!match) $4d2654448f804eaa$var$logger.throwArgumentError("invalid event string", "value", value);
        let anonymous = false;
        match[3].split(" ").forEach((modifier)=>{
            switch(modifier.trim()){
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    $4d2654448f804eaa$var$logger.warn("unknown modifier: " + modifier);
            }
        });
        return $4d2654448f804eaa$export$958548f08bac2833.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: $4d2654448f804eaa$var$parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return value && value._isFragment && value.type === "event";
    }
}
function $4d2654448f804eaa$var$parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $4d2654448f804eaa$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $4d2654448f804eaa$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $gMArf.BigNumber).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $4d2654448f804eaa$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier)=>{
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $4d2654448f804eaa$var$verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $4d2654448f804eaa$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $4d2654448f804eaa$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $4d2654448f804eaa$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $4d2654448f804eaa$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $4d2654448f804eaa$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
class $4d2654448f804eaa$export$3ac5c9504f801ea4 extends $4d2654448f804eaa$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $4d2654448f804eaa$export$f010f239efc4d445.sighash;
        if (!$4d2654448f804eaa$export$f010f239efc4d445[format]) $4d2654448f804eaa$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $4d2654448f804eaa$export$f010f239efc4d445.json) return JSON.stringify({
            type: "constructor",
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        if (format === $4d2654448f804eaa$export$f010f239efc4d445.sighash) $4d2654448f804eaa$var$logger.throwError("cannot format a constructor for sighash", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "format(sighash)"
        });
        let result = "constructor(" + this.inputs.map((input)=>input.format(format)).join(format === $4d2654448f804eaa$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $4d2654448f804eaa$export$3ac5c9504f801ea4.fromString(value);
        return $4d2654448f804eaa$export$3ac5c9504f801ea4.fromObject(value);
    }
    static fromObject(value) {
        if ($4d2654448f804eaa$export$3ac5c9504f801ea4.isConstructorFragment(value)) return value;
        if (value.type !== "constructor") $4d2654448f804eaa$var$logger.throwArgumentError("invalid constructor object", "value", value);
        let state = $4d2654448f804eaa$var$verifyState(value);
        if (state.constant) $4d2654448f804eaa$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
        const params = {
            name: null,
            type: value.type,
            inputs: value.inputs ? value.inputs.map($4d2654448f804eaa$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $gMArf.BigNumber).from(value.gas) : null
        };
        return new $4d2654448f804eaa$export$3ac5c9504f801ea4($4d2654448f804eaa$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "constructor"
        };
        value = $4d2654448f804eaa$var$parseGas(value, params);
        let parens = value.match($4d2654448f804eaa$var$regexParen);
        if (!parens || parens[1].trim() !== "constructor") $4d2654448f804eaa$var$logger.throwArgumentError("invalid constructor string", "value", value);
        params.inputs = $4d2654448f804eaa$var$parseParams(parens[2].trim(), false);
        $4d2654448f804eaa$var$parseModifiers(parens[3].trim(), params);
        return $4d2654448f804eaa$export$3ac5c9504f801ea4.fromObject(params);
    }
    static isConstructorFragment(value) {
        return value && value._isFragment && value.type === "constructor";
    }
}
class $4d2654448f804eaa$export$8d576c928b93668f extends $4d2654448f804eaa$export$3ac5c9504f801ea4 {
    format(format) {
        if (!format) format = $4d2654448f804eaa$export$f010f239efc4d445.sighash;
        if (!$4d2654448f804eaa$export$f010f239efc4d445[format]) $4d2654448f804eaa$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $4d2654448f804eaa$export$f010f239efc4d445.json) return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format))),
            outputs: this.outputs.map((output)=>JSON.parse(output.format(format)))
        });
        let result = "";
        if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) result += "function ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $4d2654448f804eaa$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
            } else if (this.constant) result += "view ";
            if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map((output)=>output.format(format)).join(", ") + ") ";
            if (this.gas != null) result += "@" + this.gas.toString() + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $4d2654448f804eaa$export$8d576c928b93668f.fromString(value);
        return $4d2654448f804eaa$export$8d576c928b93668f.fromObject(value);
    }
    static fromObject(value) {
        if ($4d2654448f804eaa$export$8d576c928b93668f.isFunctionFragment(value)) return value;
        if (value.type !== "function") $4d2654448f804eaa$var$logger.throwArgumentError("invalid function object", "value", value);
        let state = $4d2654448f804eaa$var$verifyState(value);
        const params = {
            type: value.type,
            name: $4d2654448f804eaa$var$verifyIdentifier(value.name),
            constant: state.constant,
            inputs: value.inputs ? value.inputs.map($4d2654448f804eaa$export$426dc07f493a4c47.fromObject) : [],
            outputs: value.outputs ? value.outputs.map($4d2654448f804eaa$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $gMArf.BigNumber).from(value.gas) : null
        };
        return new $4d2654448f804eaa$export$8d576c928b93668f($4d2654448f804eaa$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "function"
        };
        value = $4d2654448f804eaa$var$parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) $4d2654448f804eaa$var$logger.throwArgumentError("invalid function string", "value", value);
        let parens = comps[0].match($4d2654448f804eaa$var$regexParen);
        if (!parens) $4d2654448f804eaa$var$logger.throwArgumentError("invalid function signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $4d2654448f804eaa$var$verifyIdentifier(params.name);
        params.inputs = $4d2654448f804eaa$var$parseParams(parens[2], false);
        $4d2654448f804eaa$var$parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match($4d2654448f804eaa$var$regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") $4d2654448f804eaa$var$logger.throwArgumentError("unexpected tokens", "value", value);
            params.outputs = $4d2654448f804eaa$var$parseParams(returns[2], false);
        } else params.outputs = [];
        return $4d2654448f804eaa$export$8d576c928b93668f.fromObject(params);
    }
    static isFunctionFragment(value) {
        return value && value._isFragment && value.type === "function";
    }
}
//export class StructFragment extends Fragment {
//}
function $4d2654448f804eaa$var$checkForbidden(fragment) {
    const sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") $4d2654448f804eaa$var$logger.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
    return fragment;
}
class $4d2654448f804eaa$export$2c42c6d543aa9b59 extends $4d2654448f804eaa$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $4d2654448f804eaa$export$f010f239efc4d445.sighash;
        if (!$4d2654448f804eaa$export$f010f239efc4d445[format]) $4d2654448f804eaa$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $4d2654448f804eaa$export$f010f239efc4d445.json) return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $4d2654448f804eaa$export$f010f239efc4d445.sighash) result += "error ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $4d2654448f804eaa$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $4d2654448f804eaa$export$2c42c6d543aa9b59.fromString(value);
        return $4d2654448f804eaa$export$2c42c6d543aa9b59.fromObject(value);
    }
    static fromObject(value) {
        if ($4d2654448f804eaa$export$2c42c6d543aa9b59.isErrorFragment(value)) return value;
        if (value.type !== "error") $4d2654448f804eaa$var$logger.throwArgumentError("invalid error object", "value", value);
        const params = {
            type: value.type,
            name: $4d2654448f804eaa$var$verifyIdentifier(value.name),
            inputs: value.inputs ? value.inputs.map($4d2654448f804eaa$export$426dc07f493a4c47.fromObject) : []
        };
        return $4d2654448f804eaa$var$checkForbidden(new $4d2654448f804eaa$export$2c42c6d543aa9b59($4d2654448f804eaa$var$_constructorGuard, params));
    }
    static fromString(value) {
        let params = {
            type: "error"
        };
        let parens = value.match($4d2654448f804eaa$var$regexParen);
        if (!parens) $4d2654448f804eaa$var$logger.throwArgumentError("invalid error signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $4d2654448f804eaa$var$verifyIdentifier(params.name);
        params.inputs = $4d2654448f804eaa$var$parseParams(parens[2], false);
        return $4d2654448f804eaa$var$checkForbidden($4d2654448f804eaa$export$2c42c6d543aa9b59.fromObject(params));
    }
    static isErrorFragment(value) {
        return value && value._isFragment && value.type === "error";
    }
}
function $4d2654448f804eaa$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
const $4d2654448f804eaa$var$regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function $4d2654448f804eaa$var$verifyIdentifier(value) {
    if (!value || !value.match($4d2654448f804eaa$var$regexIdentifier)) $4d2654448f804eaa$var$logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    return value;
}
const $4d2654448f804eaa$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $4d2654448f804eaa$var$splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for(let offset = 0; offset < value.length; offset++){
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $4d2654448f804eaa$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}

});


parcelRegister("9rkfU", function(module, exports) {

$parcel$export(module.exports, "LogDescription", function () { return $6df659078ac9448c$export$c2ab6499be98b3c5; });
$parcel$export(module.exports, "TransactionDescription", function () { return $6df659078ac9448c$export$7a3223b0fadb690b; });
$parcel$export(module.exports, "Indexed", function () { return $6df659078ac9448c$export$8ef99100a3c56f8c; });
$parcel$export(module.exports, "Interface", function () { return $6df659078ac9448c$export$48cefb51a4e315b2; });

var $e8NrM = parcelRequire("e8NrM");

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $4q6En = parcelRequire("4q6En");

var $4ujqV = parcelRequire("4ujqV");

var $2ax4w = parcelRequire("2ax4w");

var $yKVLS = parcelRequire("yKVLS");

var $ggjPf = parcelRequire("ggjPf");

var $6CFiK = parcelRequire("6CFiK");

var $6M65e = parcelRequire("6M65e");

var $ij6uS = parcelRequire("ij6uS");
"use strict";
const $6df659078ac9448c$var$logger = new (0, $6M65e.Logger)((0, $ij6uS.version));
class $6df659078ac9448c$export$c2ab6499be98b3c5 extends (0, $2ax4w.Description) {
}
class $6df659078ac9448c$export$7a3223b0fadb690b extends (0, $2ax4w.Description) {
}
class $6df659078ac9448c$export$cfba08fc0e40e2ab extends (0, $2ax4w.Description) {
}
class $6df659078ac9448c$export$8ef99100a3c56f8c extends (0, $2ax4w.Description) {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
const $6df659078ac9448c$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function $6df659078ac9448c$var$wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
class $6df659078ac9448c$export$48cefb51a4e315b2 {
    format(format) {
        if (!format) format = (0, $6CFiK.FormatTypes).full;
        if (format === (0, $6CFiK.FormatTypes).sighash) $6df659078ac9448c$var$logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        const abi = this.fragments.map((fragment)=>fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === (0, $6CFiK.FormatTypes).json) return JSON.stringify(abi.map((j)=>JSON.parse(j)));
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return 0, $yKVLS.defaultAbiCoder;
    }
    static getAddress(address) {
        return (0, $e8NrM.getAddress)(address);
    }
    static getSighash(fragment) {
        return (0, $j2rU8.hexDataSlice)((0, $4q6En.id)(fragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return (0, $4q6En.id)(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if ((0, $j2rU8.isHexString)(nameOrSignatureOrSighash)) {
            for(const name in this.functions){
                if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
            }
            $6df659078ac9448c$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $6df659078ac9448c$var$logger.throwArgumentError("no matching function", "name", name);
            else if (matching.length > 1) $6df659078ac9448c$var$logger.throwArgumentError("multiple matching functions", "name", name);
            return this.functions[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.functions[(0, $6CFiK.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $6df659078ac9448c$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if ((0, $j2rU8.isHexString)(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for(const name in this.events){
                if (topichash === this.getEventTopic(name)) return this.events[name];
            }
            $6df659078ac9448c$var$logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $6df659078ac9448c$var$logger.throwArgumentError("no matching event", "name", name);
            else if (matching.length > 1) $6df659078ac9448c$var$logger.throwArgumentError("multiple matching events", "name", name);
            return this.events[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.events[(0, $6CFiK.EventFragment).fromString(nameOrSignatureOrTopic).format()];
        if (!result) $6df659078ac9448c$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        return result;
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getError(nameOrSignatureOrSighash) {
        if ((0, $j2rU8.isHexString)(nameOrSignatureOrSighash)) {
            const getSighash = (0, $2ax4w.getStatic)(this.constructor, "getSighash");
            for(const name in this.errors){
                const error = this.errors[name];
                if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
            }
            $6df659078ac9448c$var$logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.errors).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $6df659078ac9448c$var$logger.throwArgumentError("no matching error", "name", name);
            else if (matching.length > 1) $6df659078ac9448c$var$logger.throwArgumentError("multiple matching errors", "name", name);
            return this.errors[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.errors[(0, $6CFiK.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $6df659078ac9448c$var$logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(fragment) {
        if (typeof fragment === "string") try {
            fragment = this.getFunction(fragment);
        } catch (error) {
            try {
                fragment = this.getError(fragment);
            } catch (_) {
                throw error;
            }
        }
        return (0, $2ax4w.getStatic)(this.constructor, "getSighash")(fragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        return (0, $2ax4w.getStatic)(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        const bytes = (0, $j2rU8.arrayify)(data);
        if ((0, $j2rU8.hexlify)(bytes.slice(0, 4)) !== this.getSighash(fragment)) $6df659078ac9448c$var$logger.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", (0, $j2rU8.hexlify)(bytes));
        return this._decodeParams(fragment.inputs, bytes.slice(4));
    }
    encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        return (0, $j2rU8.hexlify)((0, $j2rU8.concat)([
            this.getSighash(fragment),
            this._encodeParams(fragment.inputs, values || [])
        ]));
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        const bytes = (0, $j2rU8.arrayify)(data);
        if ((0, $j2rU8.hexlify)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $6df659078ac9448c$var$logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", (0, $j2rU8.hexlify)(bytes));
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $j2rU8.hexlify)((0, $j2rU8.concat)([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        let bytes = (0, $j2rU8.arrayify)(data);
        let reason = null;
        let message = "";
        let errorArgs = null;
        let errorName = null;
        let errorSignature = null;
        switch(bytes.length % this._abiCoder._getWordSize()){
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                } catch (error) {}
                break;
            case 4:
                {
                    const selector = (0, $j2rU8.hexlify)(bytes.slice(0, 4));
                    const builtin = $6df659078ac9448c$var$BuiltinErrors[selector];
                    if (builtin) {
                        errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                        errorName = builtin.name;
                        errorSignature = builtin.signature;
                        if (builtin.reason) reason = errorArgs[0];
                        if (errorName === "Error") message = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(errorArgs[0])}`;
                        else if (errorName === "Panic") message = `; VM Exception while processing transaction: reverted with panic code ${errorArgs[0]}`;
                    } else try {
                        const error = this.getError(selector);
                        errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                        errorName = error.name;
                        errorSignature = error.format();
                    } catch (error) {}
                    break;
                }
        }
        return $6df659078ac9448c$var$logger.throwError("call revert exception" + message, (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            data: (0, $j2rU8.hexlify)(data),
            errorArgs: errorArgs,
            errorName: errorName,
            errorSignature: errorSignature,
            reason: reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $j2rU8.hexlify)(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (values.length > eventFragment.inputs.length) $6df659078ac9448c$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $6M65e.Logger).errors.UNEXPECTED_ARGUMENT, {
            argument: "values",
            value: values
        });
        let topics = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $4q6En.id)(value);
            else if (param.type === "bytes") return (0, $4ujqV.keccak256)((0, $j2rU8.hexlify)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            if (param.type.match(/^u?int/)) value = (0, $gMArf.BigNumber).from(value).toHexString();
            // Check addresses are valid
            if (param.type === "address") this._abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $j2rU8.hexZeroPad)((0, $j2rU8.hexlify)(value), 32);
        };
        values.forEach((value, index)=>{
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) $6df659078ac9448c$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") $6df659078ac9448c$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        if (values.length !== eventFragment.inputs.length) $6df659078ac9448c$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
        eventFragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $4q6En.id)(value));
                else if (param.type === "bytes") topics.push((0, $4ujqV.keccak256)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this._abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!(0, $j2rU8.isHexString)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $6df659078ac9448c$var$logger.throwError("fragment/topic mismatch", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                argument: "topics[0]",
                expected: topicHash,
                value: topics[0]
            });
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $6CFiK.ParamType).fromObject({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $j2rU8.concat)(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (resultIndexed == null) result[index] = new $6df659078ac9448c$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: null
                });
                else if (dynamic[index]) result[index] = new $6df659078ac9448c$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: resultIndexed[indexedIndex++]
                });
                else try {
                    result[index] = resultIndexed[indexedIndex++];
                } catch (error) {
                    result[index] = error;
                }
            } else try {
                result[index] = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                result[index] = error;
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) Object.defineProperty(result, param.name, {
                    enumerable: true,
                    get: ()=>{
                        throw $6df659078ac9448c$var$wrapAccessError(`property ${JSON.stringify(param.name)}`, value);
                    }
                });
                else result[param.name] = value;
            }
        });
        // Make all error indexed values throw on access
        for(let i = 0; i < result.length; i++){
            const value = result[i];
            if (value instanceof Error) Object.defineProperty(result, i, {
                enumerable: true,
                get: ()=>{
                    throw $6df659078ac9448c$var$wrapAccessError(`index ${i}`, value);
                }
            });
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $6df659078ac9448c$export$7a3223b0fadb690b({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: (0, $gMArf.BigNumber).from(tx.value || "0")
        });
    }
    // @TODO
    //parseCallResult(data: BytesLike): ??
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $6df659078ac9448c$export$c2ab6499be98b3c5({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    parseError(data) {
        const hexData = (0, $j2rU8.hexlify)(data);
        let fragment = this.getError(hexData.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $6df659078ac9448c$export$cfba08fc0e40e2ab({
            args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
            errorFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment)
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ static isInterface(value) {
        return !!(value && value._isInterface);
    }
    constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $2ax4w.defineReadOnly)(this, "fragments", abi.map((fragment)=>{
            return (0, $6CFiK.Fragment).from(fragment);
        }).filter((fragment)=>fragment != null));
        (0, $2ax4w.defineReadOnly)(this, "_abiCoder", (0, $2ax4w.getStatic)(new.target, "getAbiCoder")());
        (0, $2ax4w.defineReadOnly)(this, "functions", {});
        (0, $2ax4w.defineReadOnly)(this, "errors", {});
        (0, $2ax4w.defineReadOnly)(this, "events", {});
        (0, $2ax4w.defineReadOnly)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment)=>{
            let bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        $6df659078ac9448c$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $2ax4w.defineReadOnly)(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                case "error":
                    bucket = this.errors;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                $6df659078ac9448c$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $2ax4w.defineReadOnly)(this, "deploy", (0, $6CFiK.ConstructorFragment).from({
            payable: false,
            type: "constructor"
        }));
        (0, $2ax4w.defineReadOnly)(this, "_isInterface", true);
    }
}

});
parcelRegister("4q6En", function(module, exports) {

$parcel$export(module.exports, "id", function () { return $337ebfbf1ce1b46f$export$d560c7e4a29451c2; });

var $4ujqV = parcelRequire("4ujqV");

var $1Wmc7 = parcelRequire("1Wmc7");
function $337ebfbf1ce1b46f$export$d560c7e4a29451c2(text) {
    return (0, $4ujqV.keccak256)((0, $1Wmc7.toUtf8Bytes)(text));
}

});


parcelRegister("ebtr5", function(module, exports) {

$parcel$export(module.exports, "Base58", function () { return $a538ed25248fff2d$export$45a587635c9954b2; });
/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */ 
var $j2rU8 = parcelRequire("j2rU8");

var $2ax4w = parcelRequire("2ax4w");
class $a538ed25248fff2d$export$240043ab8e806ec7 {
    encode(value) {
        let source = (0, $j2rU8.arrayify)(value);
        if (source.length === 0) return "";
        let digits = [
            0
        ];
        for(let i = 0; i < source.length; ++i){
            let carry = source[i];
            for(let j = 0; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % this.base;
                carry = carry / this.base | 0;
            }
            while(carry > 0){
                digits.push(carry % this.base);
                carry = carry / this.base | 0;
            }
        }
        let string = "";
        // deal with leading zeros
        for(let k = 0; source[k] === 0 && k < source.length - 1; ++k)string += this._leader;
        // convert digits to a string
        for(let q = digits.length - 1; q >= 0; --q)string += this.alphabet[digits[q]];
        return string;
    }
    decode(value) {
        if (typeof value !== "string") throw new TypeError("Expected String");
        let bytes = [];
        if (value.length === 0) return new Uint8Array(bytes);
        bytes.push(0);
        for(let i = 0; i < value.length; i++){
            let byte = this._alphabetMap[value[i]];
            if (byte === undefined) throw new Error("Non-base" + this.base + " character");
            let carry = byte;
            for(let j = 0; j < bytes.length; ++j){
                carry += bytes[j] * this.base;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while(carry > 0){
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for(let k = 0; value[k] === this._leader && k < value.length - 1; ++k)bytes.push(0);
        return (0, $j2rU8.arrayify)(new Uint8Array(bytes.reverse()));
    }
    constructor(alphabet){
        (0, $2ax4w.defineReadOnly)(this, "alphabet", alphabet);
        (0, $2ax4w.defineReadOnly)(this, "base", alphabet.length);
        (0, $2ax4w.defineReadOnly)(this, "_alphabetMap", {});
        (0, $2ax4w.defineReadOnly)(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for(let i = 0; i < alphabet.length; i++)this._alphabetMap[alphabet.charAt(i)] = i;
    }
}
const $a538ed25248fff2d$export$cfabb2852920f5ec = new $a538ed25248fff2d$export$240043ab8e806ec7("abcdefghijklmnopqrstuvwxyz234567");
const $a538ed25248fff2d$export$45a587635c9954b2 = new $a538ed25248fff2d$export$240043ab8e806ec7("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
 //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
 //console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))

});

parcelRegister("kdj79", function(module, exports) {

$parcel$export(module.exports, "TypedDataEncoder", function () { return $eb73d9441da70c0d$export$458ab927ae635c3; });

var $e8NrM = parcelRequire("e8NrM");

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $4ujqV = parcelRequire("4ujqV");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $jFZZp = parcelRequire("jFZZp");

var $4q6En = parcelRequire("4q6En");
var $eb73d9441da70c0d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $eb73d9441da70c0d$var$logger = new (0, $6M65e.Logger)((0, $jFZZp.version));
const $eb73d9441da70c0d$var$padding = new Uint8Array(32);
$eb73d9441da70c0d$var$padding.fill(0);
const $eb73d9441da70c0d$var$NegativeOne = (0, $gMArf.BigNumber).from(-1);
const $eb73d9441da70c0d$var$Zero = (0, $gMArf.BigNumber).from(0);
const $eb73d9441da70c0d$var$One = (0, $gMArf.BigNumber).from(1);
const $eb73d9441da70c0d$var$MaxUint256 = (0, $gMArf.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $eb73d9441da70c0d$var$hexPadRight(value) {
    const bytes = (0, $j2rU8.arrayify)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $j2rU8.hexConcat)([
        bytes,
        $eb73d9441da70c0d$var$padding.slice(padOffset)
    ]);
    return (0, $j2rU8.hexlify)(bytes);
}
const $eb73d9441da70c0d$var$hexTrue = (0, $j2rU8.hexZeroPad)($eb73d9441da70c0d$var$One.toHexString(), 32);
const $eb73d9441da70c0d$var$hexFalse = (0, $j2rU8.hexZeroPad)($eb73d9441da70c0d$var$Zero.toHexString(), 32);
const $eb73d9441da70c0d$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $eb73d9441da70c0d$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $eb73d9441da70c0d$var$checkString(key) {
    return function(value) {
        if (typeof value !== "string") $eb73d9441da70c0d$var$logger.throwArgumentError(`invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $eb73d9441da70c0d$var$domainChecks = {
    name: $eb73d9441da70c0d$var$checkString("name"),
    version: $eb73d9441da70c0d$var$checkString("version"),
    chainId: function(value) {
        try {
            return (0, $gMArf.BigNumber).from(value).toString();
        } catch (error) {}
        return $eb73d9441da70c0d$var$logger.throwArgumentError(`invalid domain value for "chainId"`, "domain.chainId", value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $e8NrM.getAddress)(value).toLowerCase();
        } catch (error) {}
        return $eb73d9441da70c0d$var$logger.throwArgumentError(`invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        try {
            const bytes = (0, $j2rU8.arrayify)(value);
            if (bytes.length !== 32) throw new Error("bad length");
            return (0, $j2rU8.hexlify)(bytes);
        } catch (error) {}
        return $eb73d9441da70c0d$var$logger.throwArgumentError(`invalid domain value "salt"`, "domain.salt", value);
    }
};
function $eb73d9441da70c0d$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || match[2] && match[2] !== String(width)) $eb73d9441da70c0d$var$logger.throwArgumentError("invalid numeric width", "type", type);
            const boundsUpper = $eb73d9441da70c0d$var$MaxUint256.mask(signed ? width - 1 : width);
            const boundsLower = signed ? boundsUpper.add($eb73d9441da70c0d$var$One).mul($eb73d9441da70c0d$var$NegativeOne) : $eb73d9441da70c0d$var$Zero;
            return function(value) {
                const v = (0, $gMArf.BigNumber).from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) $eb73d9441da70c0d$var$logger.throwArgumentError(`value out-of-bounds for ${type}`, "value", value);
                return (0, $j2rU8.hexZeroPad)(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            if (width === 0 || width > 32 || match[1] !== String(width)) $eb73d9441da70c0d$var$logger.throwArgumentError("invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $j2rU8.arrayify)(value);
                if (bytes.length !== width) $eb73d9441da70c0d$var$logger.throwArgumentError(`invalid length for ${type}`, "value", value);
                return $eb73d9441da70c0d$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $j2rU8.hexZeroPad)((0, $e8NrM.getAddress)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $eb73d9441da70c0d$var$hexFalse : $eb73d9441da70c0d$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $4ujqV.keccak256)(value);
            };
        case "string":
            return function(value) {
                return (0, $4q6En.id)(value);
            };
    }
    return null;
}
function $eb73d9441da70c0d$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
class $eb73d9441da70c0d$export$458ab927ae635c3 {
    getEncoder(type) {
        let encoder = this._encoderCache[type];
        if (!encoder) encoder = this._encoderCache[type] = this._getEncoder(type);
        return encoder;
    }
    _getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $eb73d9441da70c0d$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const subEncoder = this.getEncoder(subtype);
            const length = parseInt(match[3]);
            return (value)=>{
                if (length >= 0 && value.length !== length) $eb73d9441da70c0d$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                let result = value.map(subEncoder);
                if (this._types[subtype]) result = result.map((0, $4ujqV.keccak256));
                return (0, $4ujqV.keccak256)((0, $j2rU8.hexConcat)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $4q6En.id)(this._types[type]);
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this._types[type]) return (0, $4ujqV.keccak256)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $j2rU8.hexConcat)(values);
            };
        }
        return $eb73d9441da70c0d$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    encodeType(name) {
        const result = this._types[name];
        if (!result) $eb73d9441da70c0d$var$logger.throwArgumentError(`unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    hashStruct(name, value) {
        return (0, $4ujqV.keccak256)(this.encodeData(name, value));
    }
    encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $eb73d9441da70c0d$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const length = parseInt(match[3]);
            if (length >= 0 && value.length !== length) $eb73d9441da70c0d$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
            return value.map((v)=>this._visit(subtype, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        return $eb73d9441da70c0d$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    static from(types) {
        return new $eb73d9441da70c0d$export$458ab927ae635c3(types);
    }
    static getPrimaryType(types) {
        return $eb73d9441da70c0d$export$458ab927ae635c3.from(types).primaryType;
    }
    static hashStruct(name, types, value) {
        return $eb73d9441da70c0d$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            const type = $eb73d9441da70c0d$var$domainFieldTypes[name];
            if (!type) $eb73d9441da70c0d$var$logger.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $eb73d9441da70c0d$var$domainFieldNames.indexOf(a.name) - $eb73d9441da70c0d$var$domainFieldNames.indexOf(b.name);
        });
        return $eb73d9441da70c0d$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    static encode(domain, types, value) {
        return (0, $j2rU8.hexConcat)([
            "0x1901",
            $eb73d9441da70c0d$export$458ab927ae635c3.hashDomain(domain),
            $eb73d9441da70c0d$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    static hash(domain, types, value) {
        return (0, $4ujqV.keccak256)($eb73d9441da70c0d$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    static resolveNames(domain, types, value, resolveName) {
        return $eb73d9441da70c0d$var$__awaiter(this, void 0, void 0, function*() {
            // Make a copy to isolate it from the object passed in
            domain = (0, $2ax4w.shallowCopy)(domain);
            // Look up all ENS names
            const ensCache = {};
            // Do we need to look up the domain's verifyingContract?
            if (domain.verifyingContract && !(0, $j2rU8.isHexString)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
            // We are going to use the encoder to visit all the base values
            const encoder = $eb73d9441da70c0d$export$458ab927ae635c3.from(types);
            // Get a list of all the addresses
            encoder.visit(value, (type, value)=>{
                if (type === "address" && !(0, $j2rU8.isHexString)(value, 20)) ensCache[value] = "0x";
                return value;
            });
            // Lookup each name
            for(const name in ensCache)ensCache[name] = yield resolveName(name);
            // Replace the domain verifyingContract if needed
            if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
            // Replace all ENS names with their address
            value = encoder.visit(value, (type, value)=>{
                if (type === "address" && ensCache[value]) return ensCache[value];
                return value;
            });
            return {
                domain: domain,
                value: value
            };
        });
    }
    static getPayload(domain, types, value) {
        // Validate the domain fields
        $eb73d9441da70c0d$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $eb73d9441da70c0d$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $eb73d9441da70c0d$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $eb73d9441da70c0d$var$domainFieldTypes[name]
            });
        });
        const encoder = $eb73d9441da70c0d$export$458ab927ae635c3.from(types);
        const typesWithDomain = (0, $2ax4w.shallowCopy)(types);
        if (typesWithDomain.EIP712Domain) $eb73d9441da70c0d$var$logger.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
        else typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $j2rU8.hexlify)((0, $j2rU8.arrayify)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $gMArf.BigNumber).from(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        if (typeof value !== "string") $eb73d9441da70c0d$var$logger.throwArgumentError(`invalid string`, "value", value);
                        return value;
                }
                return $eb73d9441da70c0d$var$logger.throwArgumentError("unsupported type", "type", type);
            })
        };
    }
    constructor(types){
        (0, $2ax4w.defineReadOnly)(this, "types", Object.freeze((0, $2ax4w.deepCopy)(types)));
        (0, $2ax4w.defineReadOnly)(this, "_encoderCache", {});
        (0, $2ax4w.defineReadOnly)(this, "_types", {});
        // Link struct types to their direct child structs
        const links = {};
        // Link structs to structs which contain them as a child
        const parents = {};
        // Link all subtypes within a given struct
        const subtypes = {};
        Object.keys(types).forEach((type)=>{
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for(const name in types){
            const uniqueNames = {};
            types[name].forEach((field)=>{
                // Check each field has a unique name
                if (uniqueNames[field.name]) $eb73d9441da70c0d$var$logger.throwArgumentError(`duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", types);
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                const baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) $eb73d9441da70c0d$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(baseType)}`, "types", types);
                // Is this a base encoding type?
                const encoder = $eb73d9441da70c0d$var$getBaseEncoder(baseType);
                if (encoder) return;
                if (!parents[baseType]) $eb73d9441da70c0d$var$logger.throwArgumentError(`unknown type ${JSON.stringify(baseType)}`, "types", types);
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        }
        // Deduce the primary type
        const primaryTypes = Object.keys(parents).filter((n)=>parents[n].length === 0);
        if (primaryTypes.length === 0) $eb73d9441da70c0d$var$logger.throwArgumentError("missing primary type", "types", types);
        else if (primaryTypes.length > 1) $eb73d9441da70c0d$var$logger.throwArgumentError(`ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", types);
        (0, $2ax4w.defineReadOnly)(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) $eb73d9441da70c0d$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(type)}`, "types", types);
            found[type] = true;
            Object.keys(links[type]).forEach((child)=>{
                if (!parents[child]) return;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach((subtype)=>{
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for(const name in subtypes){
            const st = Object.keys(subtypes[name]);
            st.sort();
            this._types[name] = $eb73d9441da70c0d$var$encodeType(name, types[name]) + st.map((t)=>$eb73d9441da70c0d$var$encodeType(t, types[t])).join("");
        }
    }
}

});
parcelRegister("jFZZp", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $e531ee7873f6488e$export$83d89fbfd8236492; });
const $e531ee7873f6488e$export$83d89fbfd8236492 = "hash/5.7.0";

});


parcelRegister("4JdI5", function(module, exports) {

$parcel$export(module.exports, "isValidName", function () { return $3715ffed660cd02c$export$cce2300886e7ace6; });
$parcel$export(module.exports, "namehash", function () { return $3715ffed660cd02c$export$91d651ee363e1209; });
$parcel$export(module.exports, "dnsEncode", function () { return $3715ffed660cd02c$export$6c0a8cdae51cb512; });

var $j2rU8 = parcelRequire("j2rU8");

var $1Wmc7 = parcelRequire("1Wmc7");

var $4ujqV = parcelRequire("4ujqV");

var $6M65e = parcelRequire("6M65e");

var $jFZZp = parcelRequire("jFZZp");

var $kYWKf = parcelRequire("kYWKf");
const $3715ffed660cd02c$var$logger = new (0, $6M65e.Logger)((0, $jFZZp.version));
const $3715ffed660cd02c$var$Zeros = new Uint8Array(32);
$3715ffed660cd02c$var$Zeros.fill(0);
function $3715ffed660cd02c$var$checkComponent(comp) {
    if (comp.length === 0) throw new Error("invalid ENS name; empty component");
    return comp;
}
function $3715ffed660cd02c$var$ensNameSplit(name) {
    const bytes = (0, $1Wmc7.toUtf8Bytes)((0, $kYWKf.ens_normalize)(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($3715ffed660cd02c$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    if (last >= bytes.length) throw new Error("invalid ENS name; empty component");
    comps.push($3715ffed660cd02c$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $3715ffed660cd02c$export$5f232fd2f1a1e8ac(name) {
    return $3715ffed660cd02c$var$ensNameSplit(name).map((comp)=>(0, $1Wmc7.toUtf8String)(comp)).join(".");
}
function $3715ffed660cd02c$export$cce2300886e7ace6(name) {
    try {
        return $3715ffed660cd02c$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $3715ffed660cd02c$export$91d651ee363e1209(name) {
    /* istanbul ignore if */ if (typeof name !== "string") $3715ffed660cd02c$var$logger.throwArgumentError("invalid ENS name; not a string", "name", name);
    let result = $3715ffed660cd02c$var$Zeros;
    const comps = $3715ffed660cd02c$var$ensNameSplit(name);
    while(comps.length)result = (0, $4ujqV.keccak256)((0, $j2rU8.concat)([
        result,
        (0, $4ujqV.keccak256)(comps.pop())
    ]));
    return (0, $j2rU8.hexlify)(result);
}
function $3715ffed660cd02c$export$6c0a8cdae51cb512(name) {
    return (0, $j2rU8.hexlify)((0, $j2rU8.concat)($3715ffed660cd02c$var$ensNameSplit(name).map((comp)=>{
        // DNS does not allow components over 63 bytes in length
        if (comp.length > 63) throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}

});
parcelRegister("kYWKf", function(module, exports) {

$parcel$export(module.exports, "ens_normalize", function () { return $f466fac178eacead$export$499f715881831a51; });
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
var $1Wmc7 = parcelRequire("1Wmc7");

var $dgWym = parcelRequire("dgWym");

var $25x8z = parcelRequire("25x8z");
const $f466fac178eacead$var$r = (0, $dgWym.getData)();
// @TODO: This should be lazily loaded
const $f466fac178eacead$var$VALID = new Set((0, $25x8z.read_member_array)($f466fac178eacead$var$r));
const $f466fac178eacead$var$IGNORED = new Set((0, $25x8z.read_member_array)($f466fac178eacead$var$r));
const $f466fac178eacead$var$MAPPED = (0, $25x8z.read_mapped_map)($f466fac178eacead$var$r);
const $f466fac178eacead$var$EMOJI_ROOT = (0, $25x8z.read_emoji_trie)($f466fac178eacead$var$r);
//const NFC_CHECK = new Set(read_member_array(r, Array.from(VALID.values()).sort((a, b) => a - b)));
//const STOP = 0x2E;
const $f466fac178eacead$var$HYPHEN = 0x2D;
const $f466fac178eacead$var$UNDERSCORE = 0x5F;
function $f466fac178eacead$var$explode_cp(name) {
    return (0, $1Wmc7.toUtf8CodePoints)(name);
}
function $f466fac178eacead$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != 0xFE0F);
}
function $f466fac178eacead$export$5252e54b57fcf4fd(name) {
    for (let label of name.split(".")){
        let cps = $f466fac178eacead$var$explode_cp(label);
        try {
            for(let i = cps.lastIndexOf($f466fac178eacead$var$UNDERSCORE) - 1; i >= 0; i--){
                if (cps[i] !== $f466fac178eacead$var$UNDERSCORE) throw new Error(`underscore only allowed at start`);
            }
            if (cps.length >= 4 && cps.every((cp)=>cp < 0x80) && cps[2] === $f466fac178eacead$var$HYPHEN && cps[3] === $f466fac178eacead$var$HYPHEN) throw new Error(`invalid label extension`);
        } catch (err) {
            throw new Error(`Invalid label "${label}": ${err.message}`);
        }
    }
    return name;
}
function $f466fac178eacead$export$499f715881831a51(name) {
    return $f466fac178eacead$export$5252e54b57fcf4fd($f466fac178eacead$var$normalize(name, $f466fac178eacead$var$filter_fe0f));
}
function $f466fac178eacead$var$normalize(name, emoji_filter) {
    let input = $f466fac178eacead$var$explode_cp(name).reverse(); // flip for pop
    let output = [];
    while(input.length){
        let emoji = $f466fac178eacead$var$consume_emoji_reversed(input);
        if (emoji) {
            output.push(...emoji_filter(emoji));
            continue;
        }
        let cp = input.pop();
        if ($f466fac178eacead$var$VALID.has(cp)) {
            output.push(cp);
            continue;
        }
        if ($f466fac178eacead$var$IGNORED.has(cp)) continue;
        let cps = $f466fac178eacead$var$MAPPED[cp];
        if (cps) {
            output.push(...cps);
            continue;
        }
        throw new Error(`Disallowed codepoint: 0x${cp.toString(16).toUpperCase()}`);
    }
    return $f466fac178eacead$export$5252e54b57fcf4fd($f466fac178eacead$var$nfc(String.fromCodePoint(...output)));
}
function $f466fac178eacead$var$nfc(s) {
    return s.normalize("NFC");
}
function $f466fac178eacead$var$consume_emoji_reversed(cps, eaten) {
    var _a;
    let node = $f466fac178eacead$var$EMOJI_ROOT;
    let emoji;
    let saved;
    let stack = [];
    let pos = cps.length;
    if (eaten) eaten.length = 0; // clear input buffer (if needed)
    while(pos){
        let cp = cps[--pos];
        node = (_a = node.branches.find((x)=>x.set.has(cp))) === null || _a === void 0 ? void 0 : _a.node;
        if (!node) break;
        if (node.save) saved = cp;
        else if (node.check) {
            if (cp === saved) break;
        }
        stack.push(cp);
        if (node.fe0f) {
            stack.push(0xFE0F);
            if (pos > 0 && cps[pos - 1] == 0xFE0F) pos--; // consume optional FE0F
        }
        if (node.valid) {
            emoji = stack.slice(); // copy stack
            if (node.valid == 2) emoji.splice(1, 1); // delete FE0F at position 1 (RGI ZWJ don't follow spec!)
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // copy input (if needed)
            cps.length = pos; // truncate
        }
    }
    return emoji;
}

});
parcelRegister("dgWym", function(module, exports) {

$parcel$export(module.exports, "getData", function () { return $9a9a30743d5267a8$export$7a171f172be0782e; });
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
var $70PIu = parcelRequire("70PIu");

var $25x8z = parcelRequire("25x8z");
function $9a9a30743d5267a8$export$7a171f172be0782e() {
    return (0, $25x8z.read_compressed_payload)((0, $70PIu.decode)("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"));
}

});
parcelRegister("25x8z", function(module, exports) {

$parcel$export(module.exports, "read_compressed_payload", function () { return $1855c0be68a16a45$export$671d8b4ebc0c42ad; });
$parcel$export(module.exports, "read_member_array", function () { return $1855c0be68a16a45$export$9303bf4e1ede4914; });
$parcel$export(module.exports, "read_mapped_map", function () { return $1855c0be68a16a45$export$824d00fb01c38bd9; });
$parcel$export(module.exports, "read_emoji_trie", function () { return $1855c0be68a16a45$export$d7b24c6ce369e1b7; });
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ // https://github.com/behnammodi/polyfill/blob/master/array.polyfill.js
function $1855c0be68a16a45$var$flat(array, depth) {
    if (depth == null) depth = 1;
    const result = [];
    const forEach = result.forEach;
    const flatDeep = function(arr, depth) {
        forEach.call(arr, function(val) {
            if (depth > 0 && Array.isArray(val)) flatDeep(val, depth - 1);
            else result.push(val);
        });
    };
    flatDeep(array, depth);
    return result;
}
function $1855c0be68a16a45$var$fromEntries(array) {
    const result = {};
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        result[value[0]] = value[1];
    }
    return result;
}
function $1855c0be68a16a45$export$956eeed0f8f2ceff(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = Math.pow(2, N);
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
function $1855c0be68a16a45$export$2cda812f22276871(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $1855c0be68a16a45$export$671d8b4ebc0c42ad(bytes) {
    return $1855c0be68a16a45$export$2cda812f22276871($1855c0be68a16a45$export$956eeed0f8f2ceff(bytes));
}
function $1855c0be68a16a45$export$a785de3a2a8dd1aa(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $1855c0be68a16a45$var$read_counts(n, next) {
    let v = Array(n);
    for(let i = 0; i < n; i++)v[i] = 1 + next();
    return v;
}
function $1855c0be68a16a45$var$read_ascending(n, next) {
    let v = Array(n);
    for(let i = 0, x = -1; i < n; i++)v[i] = x += 1 + next();
    return v;
}
function $1855c0be68a16a45$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $1855c0be68a16a45$export$a785de3a2a8dd1aa(next());
    return v;
}
function $1855c0be68a16a45$export$9303bf4e1ede4914(next, lookup) {
    let v = $1855c0be68a16a45$var$read_ascending(next(), next);
    let n = next();
    let vX = $1855c0be68a16a45$var$read_ascending(n, next);
    let vN = $1855c0be68a16a45$var$read_counts(n, next);
    for(let i = 0; i < n; i++)for(let j = 0; j < vN[i]; j++)v.push(vX[i] + j);
    return lookup ? v.map((x)=>lookup[x]) : v;
}
function $1855c0be68a16a45$export$824d00fb01c38bd9(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($1855c0be68a16a45$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($1855c0be68a16a45$var$read_replacement_table(w, next));
    }
    return $1855c0be68a16a45$var$fromEntries($1855c0be68a16a45$var$flat(ret));
}
function $1855c0be68a16a45$export$e9011071590ab431(next) {
    let v = [];
    while(true){
        let i = next();
        if (i == 0) break;
        v.push(i);
    }
    return v;
}
function $1855c0be68a16a45$var$read_transposed(n, w, next) {
    let m = Array(n).fill(undefined).map(()=>[]);
    for(let i = 0; i < w; i++)$1855c0be68a16a45$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
function $1855c0be68a16a45$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $1855c0be68a16a45$export$e9011071590ab431(next);
    let m = $1855c0be68a16a45$var$read_transposed(vN.length, 1 + w, next);
    return $1855c0be68a16a45$var$flat(m.map((v, i)=>{
        const x = v[0], ys = v.slice(1);
        //let [x, ...ys] = v;
        //return Array(vN[i]).fill().map((_, j) => {
        return Array(vN[i]).fill(undefined).map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    }));
}
function $1855c0be68a16a45$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $1855c0be68a16a45$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $1855c0be68a16a45$export$d7b24c6ce369e1b7(next) {
    let sorted = $1855c0be68a16a45$export$9303bf4e1ede4914(next).sort((a, b)=>a - b);
    return read();
    function read() {
        let branches = [];
        while(true){
            let keys = $1855c0be68a16a45$export$9303bf4e1ede4914(next, sorted);
            if (keys.length == 0) break;
            branches.push({
                set: new Set(keys),
                node: read()
            });
        }
        branches.sort((a, b)=>b.set.size - a.set.size); // sort by likelihood
        let temp = next();
        let valid = temp % 3;
        temp = temp / 3 | 0;
        let fe0f = !!(temp & 1);
        temp >>= 1;
        let save = temp == 1;
        let check = temp == 2;
        return {
            branches: branches,
            valid: valid,
            fe0f: fe0f,
            save: save,
            check: check
        };
    }
}

});




parcelRegister("7vZoR", function(module, exports) {

$parcel$export(module.exports, "hashMessage", function () { return $578b0e6ea1b3b477$export$d4c241cec96564c1; });

var $j2rU8 = parcelRequire("j2rU8");

var $4ujqV = parcelRequire("4ujqV");

var $1Wmc7 = parcelRequire("1Wmc7");
const $578b0e6ea1b3b477$export$1ff3fdc4802a2ba6 = "\x19Ethereum Signed Message:\n";
function $578b0e6ea1b3b477$export$d4c241cec96564c1(message) {
    if (typeof message === "string") message = (0, $1Wmc7.toUtf8Bytes)(message);
    return (0, $4ujqV.keccak256)((0, $j2rU8.concat)([
        (0, $1Wmc7.toUtf8Bytes)($578b0e6ea1b3b477$export$1ff3fdc4802a2ba6),
        (0, $1Wmc7.toUtf8Bytes)(String(message.length)),
        message
    ]));
}

});

parcelRegister("5iEGT", function(module, exports) {

$parcel$export(module.exports, "defaultPath", function () { return $3dbe328f09720d4a$export$d48ad89f7e11a603; });
$parcel$export(module.exports, "HDNode", function () { return $3dbe328f09720d4a$export$b68640c53e22b952; });
$parcel$export(module.exports, "entropyToMnemonic", function () { return $3dbe328f09720d4a$export$4becd65eb23312e6; });
$parcel$export(module.exports, "mnemonicToEntropy", function () { return $3dbe328f09720d4a$export$135e090d58b310ca; });
$parcel$export(module.exports, "mnemonicToSeed", function () { return $3dbe328f09720d4a$export$3dee74f1204ab09f; });
$parcel$export(module.exports, "isValidMnemonic", function () { return $3dbe328f09720d4a$export$5eea3393c6119c80; });
$parcel$export(module.exports, "getAccountPath", function () { return $3dbe328f09720d4a$export$22b80e4f9eff636d; });

var $ebtr5 = parcelRequire("ebtr5");

var $j2rU8 = parcelRequire("j2rU8");

var $gMArf = parcelRequire("gMArf");

var $1Wmc7 = parcelRequire("1Wmc7");

var $eIQbV = parcelRequire("eIQbV");

var $2ax4w = parcelRequire("2ax4w");

var $4LuuL = parcelRequire("4LuuL");

var $7WUQV = parcelRequire("7WUQV");
var $aCF4U = parcelRequire("aCF4U");

var $hDQeE = parcelRequire("hDQeE");

var $1cpDB = parcelRequire("1cpDB");

var $6M65e = parcelRequire("6M65e");

var $4pr5p = parcelRequire("4pr5p");
"use strict";
const $3dbe328f09720d4a$var$logger = new (0, $6M65e.Logger)((0, $4pr5p.version));
const $3dbe328f09720d4a$var$N = (0, $gMArf.BigNumber).from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// "Bitcoin seed"
const $3dbe328f09720d4a$var$MasterSecret = (0, $1Wmc7.toUtf8Bytes)("Bitcoin seed");
const $3dbe328f09720d4a$var$HardenedBit = 0x80000000;
// Returns a byte with the MSB bits set
function $3dbe328f09720d4a$var$getUpperMask(bits) {
    return (1 << bits) - 1 << 8 - bits;
}
// Returns a byte with the LSB bits set
function $3dbe328f09720d4a$var$getLowerMask(bits) {
    return (1 << bits) - 1;
}
function $3dbe328f09720d4a$var$bytes32(value) {
    return (0, $j2rU8.hexZeroPad)((0, $j2rU8.hexlify)(value), 32);
}
function $3dbe328f09720d4a$var$base58check(data) {
    return (0, $ebtr5.Base58).encode((0, $j2rU8.concat)([
        data,
        (0, $j2rU8.hexDataSlice)((0, $7WUQV.sha256)((0, $7WUQV.sha256)(data)), 0, 4)
    ]));
}
function $3dbe328f09720d4a$var$getWordlist(wordlist) {
    if (wordlist == null) return (0, $1cpDB.wordlists)["en"];
    if (typeof wordlist === "string") {
        const words = (0, $1cpDB.wordlists)[wordlist];
        if (words == null) $3dbe328f09720d4a$var$logger.throwArgumentError("unknown locale", "wordlist", wordlist);
        return words;
    }
    return wordlist;
}
const $3dbe328f09720d4a$var$_constructorGuard = {};
const $3dbe328f09720d4a$export$d48ad89f7e11a603 = "m/44'/60'/0'/0/0";
class $3dbe328f09720d4a$export$b68640c53e22b952 {
    get extendedKey() {
        // We only support the mainnet values for now, but if anyone needs
        // testnet values, let me know. I believe current sentiment is that
        // we should always use mainnet, and use BIP-44 to derive the network
        //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
        //   - Testnet: public=0x043587CF, private=0x04358394
        if (this.depth >= 256) throw new Error("Depth too large!");
        return $3dbe328f09720d4a$var$base58check((0, $j2rU8.concat)([
            this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
            (0, $j2rU8.hexlify)(this.depth),
            this.parentFingerprint,
            (0, $j2rU8.hexZeroPad)((0, $j2rU8.hexlify)(this.index), 4),
            this.chainCode,
            this.privateKey != null ? (0, $j2rU8.concat)([
                "0x00",
                this.privateKey
            ]) : this.publicKey
        ]));
    }
    neuter() {
        return new $3dbe328f09720d4a$export$b68640c53e22b952($3dbe328f09720d4a$var$_constructorGuard, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
    }
    _derive(index) {
        if (index > 0xffffffff) throw new Error("invalid index - " + String(index));
        // Base path
        let path = this.path;
        if (path) path += "/" + (index & ~$3dbe328f09720d4a$var$HardenedBit);
        const data = new Uint8Array(37);
        if (index & $3dbe328f09720d4a$var$HardenedBit) {
            if (!this.privateKey) throw new Error("cannot derive child of neutered node");
            // Data = 0x00 || ser_256(k_par)
            data.set((0, $j2rU8.arrayify)(this.privateKey), 1);
            // Hardened path
            if (path) path += "'";
        } else // Data = ser_p(point(k_par))
        data.set((0, $j2rU8.arrayify)(this.publicKey));
        // Data += ser_32(i)
        for(let i = 24; i >= 0; i -= 8)data[33 + (i >> 3)] = index >> 24 - i & 0xff;
        const I = (0, $j2rU8.arrayify)((0, $7WUQV.computeHmac)((0, $aCF4U.SupportedAlgorithm).sha512, this.chainCode, data));
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // The private key
        let ki = null;
        // The public key
        let Ki = null;
        if (this.privateKey) ki = $3dbe328f09720d4a$var$bytes32((0, $gMArf.BigNumber).from(IL).add(this.privateKey).mod($3dbe328f09720d4a$var$N));
        else {
            const ek = new (0, $4LuuL.SigningKey)((0, $j2rU8.hexlify)(IL));
            Ki = ek._addPoint(this.publicKey);
        }
        let mnemonicOrPath = path;
        const srcMnemonic = this.mnemonic;
        if (srcMnemonic) mnemonicOrPath = Object.freeze({
            phrase: srcMnemonic.phrase,
            path: path,
            locale: srcMnemonic.locale || "en"
        });
        return new $3dbe328f09720d4a$export$b68640c53e22b952($3dbe328f09720d4a$var$_constructorGuard, ki, Ki, this.fingerprint, $3dbe328f09720d4a$var$bytes32(IR), index, this.depth + 1, mnemonicOrPath);
    }
    derivePath(path) {
        const components = path.split("/");
        if (components.length === 0 || components[0] === "m" && this.depth !== 0) throw new Error("invalid path - " + path);
        if (components[0] === "m") components.shift();
        let result = this;
        for(let i = 0; i < components.length; i++){
            const component = components[i];
            if (component.match(/^[0-9]+'$/)) {
                const index = parseInt(component.substring(0, component.length - 1));
                if (index >= $3dbe328f09720d4a$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive($3dbe328f09720d4a$var$HardenedBit + index);
            } else if (component.match(/^[0-9]+$/)) {
                const index = parseInt(component);
                if (index >= $3dbe328f09720d4a$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive(index);
            } else throw new Error("invalid path component - " + component);
        }
        return result;
    }
    static _fromSeed(seed, mnemonic) {
        const seedArray = (0, $j2rU8.arrayify)(seed);
        if (seedArray.length < 16 || seedArray.length > 64) throw new Error("invalid seed");
        const I = (0, $j2rU8.arrayify)((0, $7WUQV.computeHmac)((0, $aCF4U.SupportedAlgorithm).sha512, $3dbe328f09720d4a$var$MasterSecret, seedArray));
        return new $3dbe328f09720d4a$export$b68640c53e22b952($3dbe328f09720d4a$var$_constructorGuard, $3dbe328f09720d4a$var$bytes32(I.slice(0, 32)), null, "0x00000000", $3dbe328f09720d4a$var$bytes32(I.slice(32)), 0, 0, mnemonic);
    }
    static fromMnemonic(mnemonic, password, wordlist) {
        // If a locale name was passed in, find the associated wordlist
        wordlist = $3dbe328f09720d4a$var$getWordlist(wordlist);
        // Normalize the case and spacing in the mnemonic (throws if the mnemonic is invalid)
        mnemonic = $3dbe328f09720d4a$export$4becd65eb23312e6($3dbe328f09720d4a$export$135e090d58b310ca(mnemonic, wordlist), wordlist);
        return $3dbe328f09720d4a$export$b68640c53e22b952._fromSeed($3dbe328f09720d4a$export$3dee74f1204ab09f(mnemonic, password), {
            phrase: mnemonic,
            path: "m",
            locale: wordlist.locale
        });
    }
    static fromSeed(seed) {
        return $3dbe328f09720d4a$export$b68640c53e22b952._fromSeed(seed, null);
    }
    static fromExtendedKey(extendedKey) {
        const bytes = (0, $ebtr5.Base58).decode(extendedKey);
        if (bytes.length !== 82 || $3dbe328f09720d4a$var$base58check(bytes.slice(0, 78)) !== extendedKey) $3dbe328f09720d4a$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
        const depth = bytes[4];
        const parentFingerprint = (0, $j2rU8.hexlify)(bytes.slice(5, 9));
        const index = parseInt((0, $j2rU8.hexlify)(bytes.slice(9, 13)).substring(2), 16);
        const chainCode = (0, $j2rU8.hexlify)(bytes.slice(13, 45));
        const key = bytes.slice(45, 78);
        switch((0, $j2rU8.hexlify)(bytes.slice(0, 4))){
            // Public Key
            case "0x0488b21e":
            case "0x043587cf":
                return new $3dbe328f09720d4a$export$b68640c53e22b952($3dbe328f09720d4a$var$_constructorGuard, null, (0, $j2rU8.hexlify)(key), parentFingerprint, chainCode, index, depth, null);
            // Private Key
            case "0x0488ade4":
            case "0x04358394 ":
                if (key[0] !== 0) break;
                return new $3dbe328f09720d4a$export$b68640c53e22b952($3dbe328f09720d4a$var$_constructorGuard, (0, $j2rU8.hexlify)(key.slice(1)), null, parentFingerprint, chainCode, index, depth, null);
        }
        return $3dbe328f09720d4a$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
    }
    /**
     *  This constructor should not be called directly.
     *
     *  Please use:
     *   - fromMnemonic
     *   - fromSeed
     */ constructor(constructorGuard, privateKey, publicKey, parentFingerprint, chainCode, index, depth, mnemonicOrPath){
        /* istanbul ignore if */ if (constructorGuard !== $3dbe328f09720d4a$var$_constructorGuard) throw new Error("HDNode constructor cannot be called directly");
        if (privateKey) {
            const signingKey = new (0, $4LuuL.SigningKey)(privateKey);
            (0, $2ax4w.defineReadOnly)(this, "privateKey", signingKey.privateKey);
            (0, $2ax4w.defineReadOnly)(this, "publicKey", signingKey.compressedPublicKey);
        } else {
            (0, $2ax4w.defineReadOnly)(this, "privateKey", null);
            (0, $2ax4w.defineReadOnly)(this, "publicKey", (0, $j2rU8.hexlify)(publicKey));
        }
        (0, $2ax4w.defineReadOnly)(this, "parentFingerprint", parentFingerprint);
        (0, $2ax4w.defineReadOnly)(this, "fingerprint", (0, $j2rU8.hexDataSlice)((0, $7WUQV.ripemd160)((0, $7WUQV.sha256)(this.publicKey)), 0, 4));
        (0, $2ax4w.defineReadOnly)(this, "address", (0, $hDQeE.computeAddress)(this.publicKey));
        (0, $2ax4w.defineReadOnly)(this, "chainCode", chainCode);
        (0, $2ax4w.defineReadOnly)(this, "index", index);
        (0, $2ax4w.defineReadOnly)(this, "depth", depth);
        if (mnemonicOrPath == null) {
            // From a source that does not preserve the path (e.g. extended keys)
            (0, $2ax4w.defineReadOnly)(this, "mnemonic", null);
            (0, $2ax4w.defineReadOnly)(this, "path", null);
        } else if (typeof mnemonicOrPath === "string") {
            // From a source that does not preserve the mnemonic (e.g. neutered)
            (0, $2ax4w.defineReadOnly)(this, "mnemonic", null);
            (0, $2ax4w.defineReadOnly)(this, "path", mnemonicOrPath);
        } else {
            // From a fully qualified source
            (0, $2ax4w.defineReadOnly)(this, "mnemonic", mnemonicOrPath);
            (0, $2ax4w.defineReadOnly)(this, "path", mnemonicOrPath.path);
        }
    }
}
function $3dbe328f09720d4a$export$3dee74f1204ab09f(mnemonic, password) {
    if (!password) password = "";
    const salt = (0, $1Wmc7.toUtf8Bytes)("mnemonic" + password, (0, $1Wmc7.UnicodeNormalizationForm).NFKD);
    return (0, $eIQbV.pbkdf2)((0, $1Wmc7.toUtf8Bytes)(mnemonic, (0, $1Wmc7.UnicodeNormalizationForm).NFKD), salt, 2048, 64, "sha512");
}
function $3dbe328f09720d4a$export$135e090d58b310ca(mnemonic, wordlist) {
    wordlist = $3dbe328f09720d4a$var$getWordlist(wordlist);
    $3dbe328f09720d4a$var$logger.checkNormalize();
    const words = wordlist.split(mnemonic);
    if (words.length % 3 !== 0) throw new Error("invalid mnemonic");
    const entropy = (0, $j2rU8.arrayify)(new Uint8Array(Math.ceil(11 * words.length / 8)));
    let offset = 0;
    for(let i = 0; i < words.length; i++){
        let index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        if (index === -1) throw new Error("invalid mnemonic");
        for(let bit = 0; bit < 11; bit++){
            if (index & 1 << 10 - bit) entropy[offset >> 3] |= 1 << 7 - offset % 8;
            offset++;
        }
    }
    const entropyBits = 32 * words.length / 3;
    const checksumBits = words.length / 3;
    const checksumMask = $3dbe328f09720d4a$var$getUpperMask(checksumBits);
    const checksum = (0, $j2rU8.arrayify)((0, $7WUQV.sha256)(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    if (checksum !== (entropy[entropy.length - 1] & checksumMask)) throw new Error("invalid checksum");
    return (0, $j2rU8.hexlify)(entropy.slice(0, entropyBits / 8));
}
function $3dbe328f09720d4a$export$4becd65eb23312e6(entropy, wordlist) {
    wordlist = $3dbe328f09720d4a$var$getWordlist(wordlist);
    entropy = (0, $j2rU8.arrayify)(entropy);
    if (entropy.length % 4 !== 0 || entropy.length < 16 || entropy.length > 32) throw new Error("invalid entropy");
    const indices = [
        0
    ];
    let remainingBits = 11;
    for(let i = 0; i < entropy.length; i++)// Consume the whole byte (with still more to go)
    if (remainingBits > 8) {
        indices[indices.length - 1] <<= 8;
        indices[indices.length - 1] |= entropy[i];
        remainingBits -= 8;
    // This byte will complete an 11-bit index
    } else {
        indices[indices.length - 1] <<= remainingBits;
        indices[indices.length - 1] |= entropy[i] >> 8 - remainingBits;
        // Start the next word
        indices.push(entropy[i] & $3dbe328f09720d4a$var$getLowerMask(8 - remainingBits));
        remainingBits += 3;
    }
    // Compute the checksum bits
    const checksumBits = entropy.length / 4;
    const checksum = (0, $j2rU8.arrayify)((0, $7WUQV.sha256)(entropy))[0] & $3dbe328f09720d4a$var$getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= checksum >> 8 - checksumBits;
    return wordlist.join(indices.map((index)=>wordlist.getWord(index)));
}
function $3dbe328f09720d4a$export$5eea3393c6119c80(mnemonic, wordlist) {
    try {
        $3dbe328f09720d4a$export$135e090d58b310ca(mnemonic, wordlist);
        return true;
    } catch (error) {}
    return false;
}
function $3dbe328f09720d4a$export$22b80e4f9eff636d(index) {
    if (typeof index !== "number" || index < 0 || index >= $3dbe328f09720d4a$var$HardenedBit || index % 1) $3dbe328f09720d4a$var$logger.throwArgumentError("invalid account index", "index", index);
    return `m/44'/60'/${index}'/0/0`;
}

});
parcelRegister("eIQbV", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $ab7da8db31000bcc$export$448fa22aedc9dbca; });

var $j2rU8 = parcelRequire("j2rU8");

var $7WUQV = parcelRequire("7WUQV");
"use strict";
function $ab7da8db31000bcc$export$448fa22aedc9dbca(password, salt, iterations, keylen, hashAlgorithm) {
    password = (0, $j2rU8.arrayify)(password);
    salt = (0, $j2rU8.arrayify)(salt);
    let hLen;
    let l = 1;
    const DK = new Uint8Array(keylen);
    const block1 = new Uint8Array(salt.length + 4);
    block1.set(salt);
    //salt.copy(block1, 0, 0, salt.length)
    let r;
    let T;
    for(let i = 1; i <= l; i++){
        //block1.writeUInt32BE(i, salt.length)
        block1[salt.length] = i >> 24 & 0xff;
        block1[salt.length + 1] = i >> 16 & 0xff;
        block1[salt.length + 2] = i >> 8 & 0xff;
        block1[salt.length + 3] = i & 0xff;
        //let U = createHmac(password).update(block1).digest();
        let U = (0, $j2rU8.arrayify)((0, $7WUQV.computeHmac)(hashAlgorithm, password, block1));
        if (!hLen) {
            hLen = U.length;
            T = new Uint8Array(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
        }
        //U.copy(T, 0, 0, hLen)
        T.set(U);
        for(let j = 1; j < iterations; j++){
            //U = createHmac(password).update(U).digest();
            U = (0, $j2rU8.arrayify)((0, $7WUQV.computeHmac)(hashAlgorithm, password, U));
            for(let k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        const destPos = (i - 1) * hLen;
        const len = i === l ? r : hLen;
        //T.copy(DK, destPos, 0, len)
        DK.set((0, $j2rU8.arrayify)(T).slice(0, len), destPos);
    }
    return (0, $j2rU8.hexlify)(DK);
}

});
parcelRegister("7WUQV", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $5c9a0ceac3511c58$export$d1cea0ee4e3f0d3e; });
$parcel$export(module.exports, "sha256", function () { return $5c9a0ceac3511c58$export$bced8d2aada2d1c9; });
$parcel$export(module.exports, "sha512", function () { return $5c9a0ceac3511c58$export$a888d2532e6dc7bb; });
$parcel$export(module.exports, "computeHmac", function () { return $5c9a0ceac3511c58$export$967075d2f3b8e7ff; });

var $dMFrt = parcelRequire("dMFrt");

var $j2rU8 = parcelRequire("j2rU8");

var $aCF4U = parcelRequire("aCF4U");

var $6M65e = parcelRequire("6M65e");

var $ao76v = parcelRequire("ao76v");
"use strict";
const $5c9a0ceac3511c58$var$logger = new (0, $6M65e.Logger)((0, $ao76v.version));
function $5c9a0ceac3511c58$export$d1cea0ee4e3f0d3e(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).ripemd160().update((0, $j2rU8.arrayify)(data)).digest("hex");
}
function $5c9a0ceac3511c58$export$bced8d2aada2d1c9(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256().update((0, $j2rU8.arrayify)(data)).digest("hex");
}
function $5c9a0ceac3511c58$export$a888d2532e6dc7bb(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha512().update((0, $j2rU8.arrayify)(data)).digest("hex");
}
function $5c9a0ceac3511c58$export$967075d2f3b8e7ff(algorithm, key, data) {
    if (!(0, $aCF4U.SupportedAlgorithm)[algorithm]) $5c9a0ceac3511c58$var$logger.throwError("unsupported algorithm " + algorithm, (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).hmac((0, (/*@__PURE__*/$parcel$interopDefault($dMFrt)))[algorithm], (0, $j2rU8.arrayify)(key)).update((0, $j2rU8.arrayify)(data)).digest("hex");
}

});
parcelRegister("dMFrt", function(module, exports) {
var $a08fe79466179a86$var$hash = module.exports;

$a08fe79466179a86$var$hash.utils = (parcelRequire("cYl7t"));

$a08fe79466179a86$var$hash.common = (parcelRequire("1pS1U"));

$a08fe79466179a86$var$hash.sha = (parcelRequire("imuzp"));

$a08fe79466179a86$var$hash.ripemd = (parcelRequire("jAZNy"));

$a08fe79466179a86$var$hash.hmac = (parcelRequire("hC4jp"));
// Proxy hash functions to the main object
$a08fe79466179a86$var$hash.sha1 = $a08fe79466179a86$var$hash.sha.sha1;
$a08fe79466179a86$var$hash.sha256 = $a08fe79466179a86$var$hash.sha.sha256;
$a08fe79466179a86$var$hash.sha224 = $a08fe79466179a86$var$hash.sha.sha224;
$a08fe79466179a86$var$hash.sha384 = $a08fe79466179a86$var$hash.sha.sha384;
$a08fe79466179a86$var$hash.sha512 = $a08fe79466179a86$var$hash.sha.sha512;
$a08fe79466179a86$var$hash.ripemd160 = $a08fe79466179a86$var$hash.ripemd.ripemd160;

});

parcelRegister("aCF4U", function(module, exports) {

$parcel$export(module.exports, "SupportedAlgorithm", function () { return $7bbd5149c083ead5$export$d2a8849cfb277c; });
var $7bbd5149c083ead5$export$d2a8849cfb277c;
(function(SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})($7bbd5149c083ead5$export$d2a8849cfb277c || ($7bbd5149c083ead5$export$d2a8849cfb277c = {}));

});

parcelRegister("ao76v", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $7901a7f807ca448e$export$83d89fbfd8236492; });
const $7901a7f807ca448e$export$83d89fbfd8236492 = "sha2/5.7.0";

});



parcelRegister("4LuuL", function(module, exports) {

$parcel$export(module.exports, "SigningKey", function () { return $378334ead6ec6b6e$export$21643ca94aed3e83; });
$parcel$export(module.exports, "computePublicKey", function () { return $378334ead6ec6b6e$export$4a89473d39301224; });
$parcel$export(module.exports, "recoverPublicKey", function () { return $378334ead6ec6b6e$export$952dd09fbe0232b7; });

var $4wU5f = parcelRequire("4wU5f");

var $j2rU8 = parcelRequire("j2rU8");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $LonJE = parcelRequire("LonJE");
"use strict";
const $378334ead6ec6b6e$var$logger = new (0, $6M65e.Logger)((0, $LonJE.version));
let $378334ead6ec6b6e$var$_curve = null;
function $378334ead6ec6b6e$var$getCurve() {
    if (!$378334ead6ec6b6e$var$_curve) $378334ead6ec6b6e$var$_curve = new (0, $4wU5f.EC)("secp256k1");
    return $378334ead6ec6b6e$var$_curve;
}
class $378334ead6ec6b6e$export$21643ca94aed3e83 {
    _addPoint(other) {
        const p0 = $378334ead6ec6b6e$var$getCurve().keyFromPublic((0, $j2rU8.arrayify)(this.publicKey));
        const p1 = $378334ead6ec6b6e$var$getCurve().keyFromPublic((0, $j2rU8.arrayify)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = $378334ead6ec6b6e$var$getCurve().keyFromPrivate((0, $j2rU8.arrayify)(this.privateKey));
        const digestBytes = (0, $j2rU8.arrayify)(digest);
        if (digestBytes.length !== 32) $378334ead6ec6b6e$var$logger.throwArgumentError("bad digest length", "digest", digest);
        const signature = keyPair.sign(digestBytes, {
            canonical: true
        });
        return (0, $j2rU8.splitSignature)({
            recoveryParam: signature.recoveryParam,
            r: (0, $j2rU8.hexZeroPad)("0x" + signature.r.toString(16), 32),
            s: (0, $j2rU8.hexZeroPad)("0x" + signature.s.toString(16), 32)
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = $378334ead6ec6b6e$var$getCurve().keyFromPrivate((0, $j2rU8.arrayify)(this.privateKey));
        const otherKeyPair = $378334ead6ec6b6e$var$getCurve().keyFromPublic((0, $j2rU8.arrayify)($378334ead6ec6b6e$export$4a89473d39301224(otherKey)));
        return (0, $j2rU8.hexZeroPad)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
    constructor(privateKey){
        (0, $2ax4w.defineReadOnly)(this, "curve", "secp256k1");
        (0, $2ax4w.defineReadOnly)(this, "privateKey", (0, $j2rU8.hexlify)(privateKey));
        if ((0, $j2rU8.hexDataLength)(this.privateKey) !== 32) $378334ead6ec6b6e$var$logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        const keyPair = $378334ead6ec6b6e$var$getCurve().keyFromPrivate((0, $j2rU8.arrayify)(this.privateKey));
        (0, $2ax4w.defineReadOnly)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $2ax4w.defineReadOnly)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $2ax4w.defineReadOnly)(this, "_isSigningKey", true);
    }
}
function $378334ead6ec6b6e$export$952dd09fbe0232b7(digest, signature) {
    const sig = (0, $j2rU8.splitSignature)(signature);
    const rs = {
        r: (0, $j2rU8.arrayify)(sig.r),
        s: (0, $j2rU8.arrayify)(sig.s)
    };
    return "0x" + $378334ead6ec6b6e$var$getCurve().recoverPubKey((0, $j2rU8.arrayify)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $378334ead6ec6b6e$export$4a89473d39301224(key, compressed) {
    const bytes = (0, $j2rU8.arrayify)(key);
    if (bytes.length === 32) {
        const signingKey = new $378334ead6ec6b6e$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $378334ead6ec6b6e$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $j2rU8.hexlify)(bytes);
        return "0x" + $378334ead6ec6b6e$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $j2rU8.hexlify)(bytes);
        return "0x" + $378334ead6ec6b6e$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $378334ead6ec6b6e$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}

});
parcelRegister("4wU5f", function(module, exports) {

$parcel$export(module.exports, "EC", function () { return $34c5a7a115bc641e$export$129fe12d32abc311; });

var $jlWHo = parcelRequire("jlWHo");

var $dMFrt = parcelRequire("dMFrt");
var $34c5a7a115bc641e$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $34c5a7a115bc641e$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function $34c5a7a115bc641e$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return $34c5a7a115bc641e$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $34c5a7a115bc641e$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function $34c5a7a115bc641e$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function $34c5a7a115bc641e$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
function $34c5a7a115bc641e$var$commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $34c5a7a115bc641e$var$minimalisticAssert = $34c5a7a115bc641e$var$assert;
function $34c5a7a115bc641e$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$34c5a7a115bc641e$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var $34c5a7a115bc641e$var$utils_1 = $34c5a7a115bc641e$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var $34c5a7a115bc641e$var$utils_1$1 = $34c5a7a115bc641e$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    utils.assert = $34c5a7a115bc641e$var$minimalisticAssert;
    utils.toArray = $34c5a7a115bc641e$var$utils_1.toArray;
    utils.zero2 = $34c5a7a115bc641e$var$utils_1.zero2;
    utils.toHex = $34c5a7a115bc641e$var$utils_1.toHex;
    utils.encode = $34c5a7a115bc641e$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(bytes, "hex", "le");
    }
    utils.intFromLE = intFromLE;
});
"use strict";
var $34c5a7a115bc641e$var$getNAF = $34c5a7a115bc641e$var$utils_1$1.getNAF;
var $34c5a7a115bc641e$var$getJSF = $34c5a7a115bc641e$var$utils_1$1.getJSF;
var $34c5a7a115bc641e$var$assert$1 = $34c5a7a115bc641e$var$utils_1$1.assert;
function $34c5a7a115bc641e$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $34c5a7a115bc641e$var$base = $34c5a7a115bc641e$var$BaseCurve;
$34c5a7a115bc641e$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$34c5a7a115bc641e$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$34c5a7a115bc641e$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $34c5a7a115bc641e$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $34c5a7a115bc641e$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$34c5a7a115bc641e$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $34c5a7a115bc641e$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $34c5a7a115bc641e$var$assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$34c5a7a115bc641e$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $34c5a7a115bc641e$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $34c5a7a115bc641e$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $34c5a7a115bc641e$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $34c5a7a115bc641e$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$34c5a7a115bc641e$var$BaseCurve.BasePoint = $34c5a7a115bc641e$var$BasePoint;
$34c5a7a115bc641e$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$34c5a7a115bc641e$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$34c5a7a115bc641e$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $34c5a7a115bc641e$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $34c5a7a115bc641e$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $34c5a7a115bc641e$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$34c5a7a115bc641e$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$34c5a7a115bc641e$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$34c5a7a115bc641e$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $34c5a7a115bc641e$var$utils_1$1.encode(this._encode(compact), enc);
};
$34c5a7a115bc641e$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$34c5a7a115bc641e$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$34c5a7a115bc641e$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$34c5a7a115bc641e$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$34c5a7a115bc641e$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$34c5a7a115bc641e$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $34c5a7a115bc641e$var$inherits_browser = $34c5a7a115bc641e$var$createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var $34c5a7a115bc641e$var$assert$2 = $34c5a7a115bc641e$var$utils_1$1.assert;
function $34c5a7a115bc641e$var$ShortCurve(conf) {
    $34c5a7a115bc641e$var$base.call(this, "short", conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$34c5a7a115bc641e$var$inherits_browser($34c5a7a115bc641e$var$ShortCurve, $34c5a7a115bc641e$var$base);
var $34c5a7a115bc641e$var$short_1 = $34c5a7a115bc641e$var$ShortCurve;
$34c5a7a115bc641e$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $34c5a7a115bc641e$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$34c5a7a115bc641e$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$34c5a7a115bc641e$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$34c5a7a115bc641e$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$34c5a7a115bc641e$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$34c5a7a115bc641e$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$34c5a7a115bc641e$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $34c5a7a115bc641e$var$Point(curve, x, y, isRed) {
    $34c5a7a115bc641e$var$base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$34c5a7a115bc641e$var$inherits_browser($34c5a7a115bc641e$var$Point, $34c5a7a115bc641e$var$base.BasePoint);
$34c5a7a115bc641e$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $34c5a7a115bc641e$var$Point(this, x, y, isRed);
};
$34c5a7a115bc641e$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $34c5a7a115bc641e$var$Point.fromJSON(this, obj, red);
};
$34c5a7a115bc641e$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$34c5a7a115bc641e$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$34c5a7a115bc641e$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$34c5a7a115bc641e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$34c5a7a115bc641e$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$34c5a7a115bc641e$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$34c5a7a115bc641e$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$34c5a7a115bc641e$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$34c5a7a115bc641e$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$34c5a7a115bc641e$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$34c5a7a115bc641e$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$34c5a7a115bc641e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$34c5a7a115bc641e$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$34c5a7a115bc641e$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$34c5a7a115bc641e$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $34c5a7a115bc641e$var$JPoint(curve, x, y, z) {
    $34c5a7a115bc641e$var$base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$34c5a7a115bc641e$var$inherits_browser($34c5a7a115bc641e$var$JPoint, $34c5a7a115bc641e$var$base.BasePoint);
$34c5a7a115bc641e$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $34c5a7a115bc641e$var$JPoint(this, x, y, z);
};
$34c5a7a115bc641e$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$34c5a7a115bc641e$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$34c5a7a115bc641e$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$34c5a7a115bc641e$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$34c5a7a115bc641e$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$34c5a7a115bc641e$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$34c5a7a115bc641e$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$34c5a7a115bc641e$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$34c5a7a115bc641e$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$34c5a7a115bc641e$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $34c5a7a115bc641e$var$curve_1 = $34c5a7a115bc641e$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = $34c5a7a115bc641e$var$base;
    curve.short = $34c5a7a115bc641e$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $34c5a7a115bc641e$var$curves_1 = $34c5a7a115bc641e$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curves = exports;
    var assert = $34c5a7a115bc641e$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === "short") this.curve = new $34c5a7a115bc641e$var$curve_1.short(options);
        else if (options.type === "edwards") this.curve = new $34c5a7a115bc641e$var$curve_1.edwards(options);
        else this.curve = new $34c5a7a115bc641e$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        assert(this.g.validate(), "Invalid curve");
        assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function $34c5a7a115bc641e$var$HmacDRBG(options) {
    if (!(this instanceof $34c5a7a115bc641e$var$HmacDRBG)) return new $34c5a7a115bc641e$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $34c5a7a115bc641e$var$utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $34c5a7a115bc641e$var$utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $34c5a7a115bc641e$var$utils_1.toArray(options.pers, options.persEnc || "hex");
    $34c5a7a115bc641e$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var $34c5a7a115bc641e$var$hmacDrbg = $34c5a7a115bc641e$var$HmacDRBG;
$34c5a7a115bc641e$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$34c5a7a115bc641e$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($dMFrt))).hmac(this.hash, this.K);
};
$34c5a7a115bc641e$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$34c5a7a115bc641e$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $34c5a7a115bc641e$var$utils_1.toArray(entropy, entropyEnc);
    add = $34c5a7a115bc641e$var$utils_1.toArray(add, addEnc);
    $34c5a7a115bc641e$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$34c5a7a115bc641e$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $34c5a7a115bc641e$var$utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $34c5a7a115bc641e$var$utils_1.encode(res, enc);
};
"use strict";
var $34c5a7a115bc641e$var$assert$3 = $34c5a7a115bc641e$var$utils_1$1.assert;
function $34c5a7a115bc641e$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $34c5a7a115bc641e$var$key = $34c5a7a115bc641e$var$KeyPair;
$34c5a7a115bc641e$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $34c5a7a115bc641e$var$KeyPair) return pub;
    return new $34c5a7a115bc641e$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$34c5a7a115bc641e$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $34c5a7a115bc641e$var$KeyPair) return priv;
    return new $34c5a7a115bc641e$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$34c5a7a115bc641e$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$34c5a7a115bc641e$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$34c5a7a115bc641e$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$34c5a7a115bc641e$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$34c5a7a115bc641e$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $34c5a7a115bc641e$var$assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $34c5a7a115bc641e$var$assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$34c5a7a115bc641e$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $34c5a7a115bc641e$var$assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$34c5a7a115bc641e$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$34c5a7a115bc641e$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$34c5a7a115bc641e$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var $34c5a7a115bc641e$var$assert$4 = $34c5a7a115bc641e$var$utils_1$1.assert;
function $34c5a7a115bc641e$var$Signature(options, enc) {
    if (options instanceof $34c5a7a115bc641e$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $34c5a7a115bc641e$var$assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $34c5a7a115bc641e$var$signature = $34c5a7a115bc641e$var$Signature;
function $34c5a7a115bc641e$var$Position() {
    this.place = 0;
}
function $34c5a7a115bc641e$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $34c5a7a115bc641e$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$34c5a7a115bc641e$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $34c5a7a115bc641e$var$utils_1$1.toArray(data, enc);
    var p = new $34c5a7a115bc641e$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $34c5a7a115bc641e$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $34c5a7a115bc641e$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $34c5a7a115bc641e$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(s);
    this.recoveryParam = null;
    return true;
};
function $34c5a7a115bc641e$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$34c5a7a115bc641e$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $34c5a7a115bc641e$var$rmPadding(r);
    s = $34c5a7a115bc641e$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $34c5a7a115bc641e$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $34c5a7a115bc641e$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $34c5a7a115bc641e$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $34c5a7a115bc641e$var$utils_1$1.encode(res, enc);
};
"use strict";
var $34c5a7a115bc641e$var$rand = /*RicMoo:ethers:require(brorand)*/ function() {
    throw new Error("unsupported");
};
var $34c5a7a115bc641e$var$assert$5 = $34c5a7a115bc641e$var$utils_1$1.assert;
function $34c5a7a115bc641e$var$EC(options) {
    if (!(this instanceof $34c5a7a115bc641e$var$EC)) return new $34c5a7a115bc641e$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $34c5a7a115bc641e$var$assert$5(Object.prototype.hasOwnProperty.call($34c5a7a115bc641e$var$curves_1, options), "Unknown curve " + options);
        options = $34c5a7a115bc641e$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $34c5a7a115bc641e$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $34c5a7a115bc641e$var$ec = $34c5a7a115bc641e$var$EC;
$34c5a7a115bc641e$var$EC.prototype.keyPair = function keyPair(options) {
    return new $34c5a7a115bc641e$var$key(this, options);
};
$34c5a7a115bc641e$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $34c5a7a115bc641e$var$key.fromPrivate(this, priv, enc);
};
$34c5a7a115bc641e$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $34c5a7a115bc641e$var$key.fromPublic(this, pub, enc);
};
$34c5a7a115bc641e$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $34c5a7a115bc641e$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $34c5a7a115bc641e$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$34c5a7a115bc641e$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$34c5a7a115bc641e$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $34c5a7a115bc641e$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $34c5a7a115bc641e$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$34c5a7a115bc641e$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $34c5a7a115bc641e$var$signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$34c5a7a115bc641e$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $34c5a7a115bc641e$var$assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new $34c5a7a115bc641e$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($jlWHo)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$34c5a7a115bc641e$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $34c5a7a115bc641e$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $34c5a7a115bc641e$var$elliptic_1 = $34c5a7a115bc641e$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $34c5a7a115bc641e$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = $34c5a7a115bc641e$var$curve_1;
    elliptic.curves = $34c5a7a115bc641e$var$curves_1;
    // Protocols
    elliptic.ec = $34c5a7a115bc641e$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $34c5a7a115bc641e$export$129fe12d32abc311 = $34c5a7a115bc641e$var$elliptic_1.ec;

});

parcelRegister("LonJE", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $08e74d9fa9766383$export$83d89fbfd8236492; });
const $08e74d9fa9766383$export$83d89fbfd8236492 = "signing-key/5.7.0";

});


parcelRegister("hDQeE", function(module, exports) {

$parcel$export(module.exports, "TransactionTypes", function () { return $cd7e99036b8e7d03$export$80349e05e0724e11; });
$parcel$export(module.exports, "computeAddress", function () { return $cd7e99036b8e7d03$export$e67e2732ba9803f9; });
$parcel$export(module.exports, "recoverAddress", function () { return $cd7e99036b8e7d03$export$23cc18f96d8510e2; });
$parcel$export(module.exports, "accessListify", function () { return $cd7e99036b8e7d03$export$6c8662b1600dce2; });
$parcel$export(module.exports, "serialize", function () { return $cd7e99036b8e7d03$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "parse", function () { return $cd7e99036b8e7d03$export$98e6a39c04603d36; });

var $e8NrM = parcelRequire("e8NrM");

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $f2VSc = parcelRequire("f2VSc");

var $4ujqV = parcelRequire("4ujqV");

var $2ax4w = parcelRequire("2ax4w");

var $dQcqA = parcelRequire("dQcqA");

var $4LuuL = parcelRequire("4LuuL");

var $6M65e = parcelRequire("6M65e");

var $gKSLq = parcelRequire("gKSLq");
"use strict";
const $cd7e99036b8e7d03$var$logger = new (0, $6M65e.Logger)((0, $gKSLq.version));
var $cd7e99036b8e7d03$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($cd7e99036b8e7d03$export$80349e05e0724e11 || ($cd7e99036b8e7d03$export$80349e05e0724e11 = {}));
///////////////////////////////
function $cd7e99036b8e7d03$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $e8NrM.getAddress)(value);
}
function $cd7e99036b8e7d03$var$handleNumber(value) {
    if (value === "0x") return 0, $f2VSc.Zero;
    return (0, $gMArf.BigNumber).from(value);
}
// Legacy Transaction Fields
const $cd7e99036b8e7d03$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
const $cd7e99036b8e7d03$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $cd7e99036b8e7d03$export$e67e2732ba9803f9(key) {
    const publicKey = (0, $4LuuL.computePublicKey)(key);
    return (0, $e8NrM.getAddress)((0, $j2rU8.hexDataSlice)((0, $4ujqV.keccak256)((0, $j2rU8.hexDataSlice)(publicKey, 1)), 12));
}
function $cd7e99036b8e7d03$export$23cc18f96d8510e2(digest, signature) {
    return $cd7e99036b8e7d03$export$e67e2732ba9803f9((0, $4LuuL.recoverPublicKey)((0, $j2rU8.arrayify)(digest), signature));
}
function $cd7e99036b8e7d03$var$formatNumber(value, name) {
    const result = (0, $j2rU8.stripZeros)((0, $gMArf.BigNumber).from(value).toHexString());
    if (result.length > 32) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $cd7e99036b8e7d03$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $e8NrM.getAddress)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index)=>{
            if ((0, $j2rU8.hexDataLength)(storageKey) !== 32) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $cd7e99036b8e7d03$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            if (set.length > 2) $cd7e99036b8e7d03$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
            return $cd7e99036b8e7d03$var$accessSetify(set[0], set[1]);
        }
        return $cd7e99036b8e7d03$var$accessSetify(set.address, set.storageKeys);
    });
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $cd7e99036b8e7d03$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}
function $cd7e99036b8e7d03$var$formatAccessList(value) {
    return $cd7e99036b8e7d03$export$6c8662b1600dce2(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $cd7e99036b8e7d03$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = (0, $gMArf.BigNumber).from(transaction.gasPrice);
        const maxFeePerGas = (0, $gMArf.BigNumber).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $cd7e99036b8e7d03$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    const fields = [
        $cd7e99036b8e7d03$var$formatNumber(transaction.chainId || 0, "chainId"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.nonce || 0, "nonce"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $e8NrM.getAddress)(transaction.to) : "0x",
        $cd7e99036b8e7d03$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $cd7e99036b8e7d03$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $j2rU8.splitSignature)(signature);
        fields.push($cd7e99036b8e7d03$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $j2rU8.stripZeros)(sig.r));
        fields.push((0, $j2rU8.stripZeros)(sig.s));
    }
    return (0, $j2rU8.hexConcat)([
        "0x02",
        $dQcqA.encode(fields)
    ]);
}
function $cd7e99036b8e7d03$var$_serializeEip2930(transaction, signature) {
    const fields = [
        $cd7e99036b8e7d03$var$formatNumber(transaction.chainId || 0, "chainId"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.nonce || 0, "nonce"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $cd7e99036b8e7d03$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $e8NrM.getAddress)(transaction.to) : "0x",
        $cd7e99036b8e7d03$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $cd7e99036b8e7d03$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $j2rU8.splitSignature)(signature);
        fields.push($cd7e99036b8e7d03$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $j2rU8.stripZeros)(sig.r));
        fields.push((0, $j2rU8.stripZeros)(sig.s));
    }
    return (0, $j2rU8.hexConcat)([
        "0x01",
        $dQcqA.encode(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $cd7e99036b8e7d03$var$_serialize(transaction, signature) {
    (0, $2ax4w.checkProperties)(transaction, $cd7e99036b8e7d03$var$allowedTransactionKeys);
    const raw = [];
    $cd7e99036b8e7d03$var$transactionFields.forEach(function(fieldInfo) {
        let value = transaction[fieldInfo.name] || [];
        const options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $j2rU8.arrayify)((0, $j2rU8.hexlify)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $j2rU8.stripZeros)(value);
            if (value.length > fieldInfo.maxLength) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $j2rU8.hexlify)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $j2rU8.isBytesLike)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $j2rU8.hexlify)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $dQcqA.encode(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0, $j2rU8.splitSignature)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $cd7e99036b8e7d03$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $cd7e99036b8e7d03$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $j2rU8.hexlify)(v));
    raw.push((0, $j2rU8.stripZeros)((0, $j2rU8.arrayify)(sig.r)));
    raw.push((0, $j2rU8.stripZeros)((0, $j2rU8.arrayify)(sig.s)));
    return $dQcqA.encode(raw);
}
function $cd7e99036b8e7d03$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $cd7e99036b8e7d03$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $cd7e99036b8e7d03$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $cd7e99036b8e7d03$var$_serializeEip2930(transaction, signature);
        case 2:
            return $cd7e99036b8e7d03$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $cd7e99036b8e7d03$var$logger.throwError(`unsupported transaction type: ${transaction.type}`, (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $cd7e99036b8e7d03$var$_parseEipSignature(tx, fields, serialize) {
    try {
        const recid = $cd7e99036b8e7d03$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $j2rU8.hexZeroPad)(fields[1], 32);
    tx.s = (0, $j2rU8.hexZeroPad)(fields[2], 32);
    try {
        const digest = (0, $4ujqV.keccak256)(serialize(tx));
        tx.from = $cd7e99036b8e7d03$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {}
}
function $cd7e99036b8e7d03$var$_parseEip1559(payload) {
    const transaction = $dQcqA.decode(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $j2rU8.hexlify)(payload));
    const maxPriorityFeePerGas = $cd7e99036b8e7d03$var$handleNumber(transaction[2]);
    const maxFeePerGas = $cd7e99036b8e7d03$var$handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: $cd7e99036b8e7d03$var$handleNumber(transaction[0]).toNumber(),
        nonce: $cd7e99036b8e7d03$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $cd7e99036b8e7d03$var$handleNumber(transaction[4]),
        to: $cd7e99036b8e7d03$var$handleAddress(transaction[5]),
        value: $cd7e99036b8e7d03$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $cd7e99036b8e7d03$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $4ujqV.keccak256)(payload);
    $cd7e99036b8e7d03$var$_parseEipSignature(tx, transaction.slice(9), $cd7e99036b8e7d03$var$_serializeEip1559);
    return tx;
}
function $cd7e99036b8e7d03$var$_parseEip2930(payload) {
    const transaction = $dQcqA.decode(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $j2rU8.hexlify)(payload));
    const tx = {
        type: 1,
        chainId: $cd7e99036b8e7d03$var$handleNumber(transaction[0]).toNumber(),
        nonce: $cd7e99036b8e7d03$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $cd7e99036b8e7d03$var$handleNumber(transaction[2]),
        gasLimit: $cd7e99036b8e7d03$var$handleNumber(transaction[3]),
        to: $cd7e99036b8e7d03$var$handleAddress(transaction[4]),
        value: $cd7e99036b8e7d03$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $cd7e99036b8e7d03$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $4ujqV.keccak256)(payload);
    $cd7e99036b8e7d03$var$_parseEipSignature(tx, transaction.slice(8), $cd7e99036b8e7d03$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $cd7e99036b8e7d03$var$_parse(rawTransaction) {
    const transaction = $dQcqA.decode(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $cd7e99036b8e7d03$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    const tx = {
        nonce: $cd7e99036b8e7d03$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $cd7e99036b8e7d03$var$handleNumber(transaction[1]),
        gasLimit: $cd7e99036b8e7d03$var$handleNumber(transaction[2]),
        to: $cd7e99036b8e7d03$var$handleAddress(transaction[3]),
        value: $cd7e99036b8e7d03$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $gMArf.BigNumber).from(transaction[6]).toNumber();
    } catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = (0, $j2rU8.hexZeroPad)(transaction[7], 32);
    tx.s = (0, $j2rU8.hexZeroPad)(transaction[8], 32);
    if ((0, $gMArf.BigNumber).from(tx.r).isZero() && (0, $gMArf.BigNumber).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $j2rU8.hexlify)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0, $4ujqV.keccak256)($dQcqA.encode(raw));
        try {
            tx.from = $cd7e99036b8e7d03$export$23cc18f96d8510e2(digest, {
                r: (0, $j2rU8.hexlify)(tx.r),
                s: (0, $j2rU8.hexlify)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {}
        tx.hash = (0, $4ujqV.keccak256)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $cd7e99036b8e7d03$export$98e6a39c04603d36(rawTransaction) {
    const payload = (0, $j2rU8.arrayify)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $cd7e99036b8e7d03$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $cd7e99036b8e7d03$var$_parseEip2930(payload);
        case 2:
            return $cd7e99036b8e7d03$var$_parseEip1559(payload);
        default:
            break;
    }
    return $cd7e99036b8e7d03$var$logger.throwError(`unsupported transaction type: ${payload[0]}`, (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}

});
parcelRegister("gKSLq", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $c32b6c36440c9df1$export$83d89fbfd8236492; });
const $c32b6c36440c9df1$export$83d89fbfd8236492 = "transactions/5.7.0";

});


parcelRegister("1cpDB", function(module, exports) {

$parcel$export(module.exports, "wordlists", function () { return $0dfacc88dba7f7bc$export$e8e1b4711c2d1939; });

var $d1qbV = parcelRequire("d1qbV");
"use strict";
const $0dfacc88dba7f7bc$export$e8e1b4711c2d1939 = {
    en: (0, $d1qbV.langEn)
};

});
parcelRegister("d1qbV", function(module, exports) {

$parcel$export(module.exports, "langEn", function () { return $97afaf669a13bce7$export$a2c9518710cf1f49; });

var $hj32o = parcelRequire("hj32o");
"use strict";
const $97afaf669a13bce7$var$words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
let $97afaf669a13bce7$var$wordlist = null;
function $97afaf669a13bce7$var$loadWords(lang) {
    if ($97afaf669a13bce7$var$wordlist != null) return;
    $97afaf669a13bce7$var$wordlist = $97afaf669a13bce7$var$words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" ");
    // Verify the computed list matches the official list
    /* istanbul ignore if */ if ((0, $hj32o.Wordlist).check(lang) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60") {
        $97afaf669a13bce7$var$wordlist = null;
        throw new Error("BIP39 Wordlist for en (English) FAILED");
    }
}
class $97afaf669a13bce7$var$LangEn extends (0, $hj32o.Wordlist) {
    getWord(index) {
        $97afaf669a13bce7$var$loadWords(this);
        return $97afaf669a13bce7$var$wordlist[index];
    }
    getWordIndex(word) {
        $97afaf669a13bce7$var$loadWords(this);
        return $97afaf669a13bce7$var$wordlist.indexOf(word);
    }
    constructor(){
        super("en");
    }
}
const $97afaf669a13bce7$export$a2c9518710cf1f49 = new $97afaf669a13bce7$var$LangEn();
(0, $hj32o.Wordlist).register($97afaf669a13bce7$export$a2c9518710cf1f49);

});
parcelRegister("hj32o", function(module, exports) {

$parcel$export(module.exports, "Wordlist", function () { return $c996913613c064e5$export$4d9531a8ddb0ebca; });

var $4q6En = parcelRequire("4q6En");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $gRERe = parcelRequire("gRERe");
"use strict";
// This gets overridden by rollup
const $c996913613c064e5$var$exportWordlist = false;
const $c996913613c064e5$export$af88d00dbe7f521 = new (0, $6M65e.Logger)((0, $gRERe.version));
class $c996913613c064e5$export$4d9531a8ddb0ebca {
    // Subclasses may override this
    split(mnemonic) {
        return mnemonic.toLowerCase().split(/ +/g);
    }
    // Subclasses may override this
    join(words) {
        return words.join(" ");
    }
    static check(wordlist) {
        const words = [];
        for(let i = 0; i < 2048; i++){
            const word = wordlist.getWord(i);
            /* istanbul ignore if */ if (i !== wordlist.getWordIndex(word)) return "0x";
            words.push(word);
        }
        return (0, $4q6En.id)(words.join("\n") + "\n");
    }
    static register(lang, name) {
        if (!name) name = lang.locale;
        /* istanbul ignore if */ if ($c996913613c064e5$var$exportWordlist) try {
            const anyGlobal = window;
            if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
                if (!anyGlobal._ethers.wordlists[name]) (0, $2ax4w.defineReadOnly)(anyGlobal._ethers.wordlists, name, lang);
            }
        } catch (error) {}
    }
    constructor(locale){
        $c996913613c064e5$export$af88d00dbe7f521.checkAbstract(new.target, $c996913613c064e5$export$4d9531a8ddb0ebca);
        (0, $2ax4w.defineReadOnly)(this, "locale", locale);
    }
}

});
parcelRegister("gRERe", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $c4714a102efec208$export$83d89fbfd8236492; });
const $c4714a102efec208$export$83d89fbfd8236492 = "wordlists/5.7.0";

});




parcelRegister("4pr5p", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $335e81f973d32d11$export$83d89fbfd8236492; });
const $335e81f973d32d11$export$83d89fbfd8236492 = "hdnode/5.7.0";

});


parcelRegister("6jMeD", function(module, exports) {

$parcel$export(module.exports, "isCrowdsaleWallet", function () { return $4999eee0db3e68cf$export$724d6cf6b9fd8578; });
$parcel$export(module.exports, "isKeystoreWallet", function () { return $4999eee0db3e68cf$export$67dc926b8e68b2d8; });
$parcel$export(module.exports, "getJsonWalletAddress", function () { return $4999eee0db3e68cf$export$9a68ee9f8f3afd38; });

var $e8NrM = parcelRequire("e8NrM");
"use strict";
function $4999eee0db3e68cf$export$724d6cf6b9fd8578(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    return data.encseed && data.ethaddr;
}
function $4999eee0db3e68cf$export$67dc926b8e68b2d8(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    if (!data.version || parseInt(data.version) !== data.version || parseInt(data.version) !== 3) return false;
    // @TODO: Put more checks to make sure it has kdf, iv and all that good stuff
    return true;
}
function $4999eee0db3e68cf$export$9a68ee9f8f3afd38(json) {
    if ($4999eee0db3e68cf$export$724d6cf6b9fd8578(json)) try {
        return (0, $e8NrM.getAddress)(JSON.parse(json).ethaddr);
    } catch (error) {
        return null;
    }
    if ($4999eee0db3e68cf$export$67dc926b8e68b2d8(json)) try {
        return (0, $e8NrM.getAddress)(JSON.parse(json).address);
    } catch (error) {
        return null;
    }
    return null;
}

});

parcelRegister("ihTqz", function(module, exports) {

$parcel$export(module.exports, "pack", function () { return $d504cf4938ca3d9c$export$2a703dbb0cb35339; });
$parcel$export(module.exports, "keccak256", function () { return $d504cf4938ca3d9c$export$f8151fce47ad1c35; });
$parcel$export(module.exports, "sha256", function () { return $d504cf4938ca3d9c$export$bced8d2aada2d1c9; });

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $4ujqV = parcelRequire("4ujqV");

var $7WUQV = parcelRequire("7WUQV");

var $1Wmc7 = parcelRequire("1Wmc7");

var $6M65e = parcelRequire("6M65e");

var $5fA2u = parcelRequire("5fA2u");
"use strict";
const $d504cf4938ca3d9c$var$regexBytes = new RegExp("^bytes([0-9]+)$");
const $d504cf4938ca3d9c$var$regexNumber = new RegExp("^(u?int)([0-9]*)$");
const $d504cf4938ca3d9c$var$regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
const $d504cf4938ca3d9c$var$Zeros = "0000000000000000000000000000000000000000000000000000000000000000";
const $d504cf4938ca3d9c$var$logger = new (0, $6M65e.Logger)((0, $5fA2u.version));
function $d504cf4938ca3d9c$var$_pack(type, value, isArray) {
    switch(type){
        case "address":
            if (isArray) return (0, $j2rU8.zeroPad)(value, 32);
            return (0, $j2rU8.arrayify)(value);
        case "string":
            return (0, $1Wmc7.toUtf8Bytes)(value);
        case "bytes":
            return (0, $j2rU8.arrayify)(value);
        case "bool":
            value = value ? "0x01" : "0x00";
            if (isArray) return (0, $j2rU8.zeroPad)(value, 32);
            return (0, $j2rU8.arrayify)(value);
    }
    let match = type.match($d504cf4938ca3d9c$var$regexNumber);
    if (match) {
        //let signed = (match[1] === "int")
        let size = parseInt(match[2] || "256");
        if (match[2] && String(size) !== match[2] || size % 8 !== 0 || size === 0 || size > 256) $d504cf4938ca3d9c$var$logger.throwArgumentError("invalid number type", "type", type);
        if (isArray) size = 256;
        value = (0, $gMArf.BigNumber).from(value).toTwos(size);
        return (0, $j2rU8.zeroPad)(value, size / 8);
    }
    match = type.match($d504cf4938ca3d9c$var$regexBytes);
    if (match) {
        const size = parseInt(match[1]);
        if (String(size) !== match[1] || size === 0 || size > 32) $d504cf4938ca3d9c$var$logger.throwArgumentError("invalid bytes type", "type", type);
        if ((0, $j2rU8.arrayify)(value).byteLength !== size) $d504cf4938ca3d9c$var$logger.throwArgumentError(`invalid value for ${type}`, "value", value);
        if (isArray) return (0, $j2rU8.arrayify)((value + $d504cf4938ca3d9c$var$Zeros).substring(0, 66));
        return value;
    }
    match = type.match($d504cf4938ca3d9c$var$regexArray);
    if (match && Array.isArray(value)) {
        const baseType = match[1];
        const count = parseInt(match[2] || String(value.length));
        if (count != value.length) $d504cf4938ca3d9c$var$logger.throwArgumentError(`invalid array length for ${type}`, "value", value);
        const result = [];
        value.forEach(function(value) {
            result.push($d504cf4938ca3d9c$var$_pack(baseType, value, true));
        });
        return (0, $j2rU8.concat)(result);
    }
    return $d504cf4938ca3d9c$var$logger.throwArgumentError("invalid type", "type", type);
}
function $d504cf4938ca3d9c$export$2a703dbb0cb35339(types, values) {
    if (types.length != values.length) $d504cf4938ca3d9c$var$logger.throwArgumentError("wrong number of values; expected ${ types.length }", "values", values);
    const tight = [];
    types.forEach(function(type, index) {
        tight.push($d504cf4938ca3d9c$var$_pack(type, values[index]));
    });
    return (0, $j2rU8.hexlify)((0, $j2rU8.concat)(tight));
}
function $d504cf4938ca3d9c$export$f8151fce47ad1c35(types, values) {
    return (0, $4ujqV.keccak256)($d504cf4938ca3d9c$export$2a703dbb0cb35339(types, values));
}
function $d504cf4938ca3d9c$export$bced8d2aada2d1c9(types, values) {
    return (0, $7WUQV.sha256)($d504cf4938ca3d9c$export$2a703dbb0cb35339(types, values));
}

});
parcelRegister("5fA2u", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $3d2a4f1744e3e1a9$export$83d89fbfd8236492; });
const $3d2a4f1744e3e1a9$export$83d89fbfd8236492 = "solidity/5.7.0";

});


parcelRegister("4kSyQ", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $32835a60ff995f3a$export$5f828d93ff035aa8; });

var $j2rU8 = parcelRequire("j2rU8");

var $6M65e = parcelRequire("6M65e");

var $ftmT9 = parcelRequire("ftmT9");
"use strict";
const $32835a60ff995f3a$var$logger = new (0, $6M65e.Logger)((0, $ftmT9.version));
// Debugging line for testing browser lib in node
//const window = { crypto: { getRandomValues: () => { } } };
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $32835a60ff995f3a$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $32835a60ff995f3a$var$anyGlobal = $32835a60ff995f3a$var$getGlobal();
let $32835a60ff995f3a$var$crypto = $32835a60ff995f3a$var$anyGlobal.crypto || $32835a60ff995f3a$var$anyGlobal.msCrypto;
if (!$32835a60ff995f3a$var$crypto || !$32835a60ff995f3a$var$crypto.getRandomValues) {
    $32835a60ff995f3a$var$logger.warn("WARNING: Missing strong random number source");
    $32835a60ff995f3a$var$crypto = {
        getRandomValues: function(buffer) {
            return $32835a60ff995f3a$var$logger.throwError("no secure random source avaialble", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "crypto.getRandomValues"
            });
        }
    };
}
function $32835a60ff995f3a$export$5f828d93ff035aa8(length) {
    if (length <= 0 || length > 1024 || length % 1 || length != length) $32835a60ff995f3a$var$logger.throwArgumentError("invalid length", "length", length);
    const result = new Uint8Array(length);
    $32835a60ff995f3a$var$crypto.getRandomValues(result);
    return (0, $j2rU8.arrayify)(result);
}

});
parcelRegister("ftmT9", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $b43b519c9c02dc79$export$83d89fbfd8236492; });
const $b43b519c9c02dc79$export$83d89fbfd8236492 = "random/5.7.0";

});


parcelRegister("5aKt1", function(module, exports) {

$parcel$export(module.exports, "shuffled", function () { return $3c41ee55241bf87e$export$e6c7296801b9b341; });
"use strict";
function $3c41ee55241bf87e$export$e6c7296801b9b341(array) {
    array = array.slice();
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
    return array;
}

});

parcelRegister("9osRb", function(module, exports) {

$parcel$export(module.exports, "formatBytes32String", function () { return $6d6cbd4d8329f5fa$export$b97e949c0076e971; });
$parcel$export(module.exports, "parseBytes32String", function () { return $6d6cbd4d8329f5fa$export$49340cb8f3954db8; });

var $5OvKP = parcelRequire("5OvKP");

var $j2rU8 = parcelRequire("j2rU8");

var $1Wmc7 = parcelRequire("1Wmc7");
"use strict";
function $6d6cbd4d8329f5fa$export$b97e949c0076e971(text) {
    // Get the bytes
    const bytes = (0, $1Wmc7.toUtf8Bytes)(text);
    // Check we have room for null-termination
    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
    // Zero-pad (implicitly null-terminates)
    return (0, $j2rU8.hexlify)((0, $j2rU8.concat)([
        bytes,
        (0, $5OvKP.HashZero)
    ]).slice(0, 32));
}
function $6d6cbd4d8329f5fa$export$49340cb8f3954db8(bytes) {
    const data = (0, $j2rU8.arrayify)(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
    if (data[31] !== 0) throw new Error("invalid bytes32 string - no null terminator");
    // Find the null termination
    let length = 31;
    while(data[length - 1] === 0)length--;
    // Determine the string value
    return (0, $1Wmc7.toUtf8String)(data.slice(0, length));
}

});
parcelRegister("5OvKP", function(module, exports) {

$parcel$export(module.exports, "HashZero", function () { return $43ba40ff64f1a63e$export$71c2e4e213dcb7f2; });
const $43ba40ff64f1a63e$export$71c2e4e213dcb7f2 = "0x0000000000000000000000000000000000000000000000000000000000000000";

});


parcelRegister("eHcVC", function(module, exports) {

$parcel$export(module.exports, "nameprep", function () { return $ab2f1c24fdde7ddc$export$94f0b6f93c619bc; });

var $1Wmc7 = parcelRequire("1Wmc7");
"use strict";
function $ab2f1c24fdde7ddc$var$bytes2(data) {
    if (data.length % 4 !== 0) throw new Error("bad data");
    let result = [];
    for(let i = 0; i < data.length; i += 4)result.push(parseInt(data.substring(i, i + 4), 16));
    return result;
}
function $ab2f1c24fdde7ddc$var$createTable(data, func) {
    if (!func) func = function(value) {
        return [
            parseInt(value, 16)
        ];
    };
    let lo = 0;
    let result = {};
    data.split(",").forEach((pair)=>{
        let comps = pair.split(":");
        lo += parseInt(comps[0], 16);
        result[lo] = func(comps[1]);
    });
    return result;
}
function $ab2f1c24fdde7ddc$var$createRangeTable(data) {
    let hi = 0;
    return data.split(",").map((v)=>{
        let comps = v.split("-");
        if (comps.length === 1) comps[1] = "0";
        else if (comps[1] === "") comps[1] = "1";
        let lo = hi + parseInt(comps[0], 16);
        hi = parseInt(comps[1], 16);
        return {
            l: lo,
            h: hi
        };
    });
}
function $ab2f1c24fdde7ddc$var$matchMap(value, ranges) {
    let lo = 0;
    for(let i = 0; i < ranges.length; i++){
        let range = ranges[i];
        lo += range.l;
        if (value >= lo && value <= lo + range.h && (value - lo) % (range.d || 1) === 0) {
            if (range.e && range.e.indexOf(value - lo) !== -1) continue;
            return range;
        }
    }
    return null;
}
const $ab2f1c24fdde7ddc$var$Table_A_1_ranges = $ab2f1c24fdde7ddc$var$createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d");
// @TODO: Make this relative...
const $ab2f1c24fdde7ddc$var$Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((v)=>parseInt(v, 16));
const $ab2f1c24fdde7ddc$var$Table_B_2_ranges = [
    {
        h: 25,
        s: 32,
        l: 65
    },
    {
        h: 30,
        s: 32,
        e: [
            23
        ],
        l: 127
    },
    {
        h: 54,
        s: 1,
        e: [
            48
        ],
        l: 64,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 57,
        d: 2
    },
    {
        h: 44,
        s: 1,
        l: 17,
        d: 2
    },
    {
        h: 10,
        s: 1,
        e: [
            2,
            6,
            8
        ],
        l: 61,
        d: 2
    },
    {
        h: 16,
        s: 1,
        l: 68,
        d: 2
    },
    {
        h: 84,
        s: 1,
        e: [
            18,
            24,
            66
        ],
        l: 19,
        d: 2
    },
    {
        h: 26,
        s: 32,
        e: [
            17
        ],
        l: 435
    },
    {
        h: 22,
        s: 1,
        l: 71,
        d: 2
    },
    {
        h: 15,
        s: 80,
        l: 40
    },
    {
        h: 31,
        s: 32,
        l: 16
    },
    {
        h: 32,
        s: 1,
        l: 80,
        d: 2
    },
    {
        h: 52,
        s: 1,
        l: 42,
        d: 2
    },
    {
        h: 12,
        s: 1,
        l: 55,
        d: 2
    },
    {
        h: 40,
        s: 1,
        e: [
            38
        ],
        l: 15,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 48,
        d: 2
    },
    {
        h: 37,
        s: 48,
        l: 49
    },
    {
        h: 148,
        s: 1,
        l: 6351,
        d: 2
    },
    {
        h: 88,
        s: 1,
        l: 160,
        d: 2
    },
    {
        h: 15,
        s: 16,
        l: 704
    },
    {
        h: 25,
        s: 26,
        l: 854
    },
    {
        h: 25,
        s: 32,
        l: 55915
    },
    {
        h: 37,
        s: 40,
        l: 1247
    },
    {
        h: 25,
        s: -119711,
        l: 53248
    },
    {
        h: 25,
        s: -119763,
        l: 52
    },
    {
        h: 25,
        s: -119815,
        l: 52
    },
    {
        h: 25,
        s: -119867,
        e: [
            1,
            4,
            5,
            7,
            8,
            11,
            12,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -119919,
        l: 52
    },
    {
        h: 24,
        s: -119971,
        e: [
            2,
            7,
            8,
            17
        ],
        l: 52
    },
    {
        h: 24,
        s: -120023,
        e: [
            2,
            7,
            13,
            15,
            16,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -120075,
        l: 52
    },
    {
        h: 25,
        s: -120127,
        l: 52
    },
    {
        h: 25,
        s: -120179,
        l: 52
    },
    {
        h: 25,
        s: -120231,
        l: 52
    },
    {
        h: 25,
        s: -120283,
        l: 52
    },
    {
        h: 25,
        s: -120335,
        l: 52
    },
    {
        h: 24,
        s: -119543,
        e: [
            17
        ],
        l: 56
    },
    {
        h: 24,
        s: -119601,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119659,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119717,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119775,
        e: [
            17
        ],
        l: 58
    }
];
const $ab2f1c24fdde7ddc$var$Table_B_2_lut_abs = $ab2f1c24fdde7ddc$var$createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3");
const $ab2f1c24fdde7ddc$var$Table_B_2_lut_rel = $ab2f1c24fdde7ddc$var$createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7");
const $ab2f1c24fdde7ddc$var$Table_B_2_complex = $ab2f1c24fdde7ddc$var$createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $ab2f1c24fdde7ddc$var$bytes2);
const $ab2f1c24fdde7ddc$var$Table_C_ranges = $ab2f1c24fdde7ddc$var$createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function $ab2f1c24fdde7ddc$var$flatten(values) {
    return values.reduce((accum, value)=>{
        value.forEach((value)=>{
            accum.push(value);
        });
        return accum;
    }, []);
}
function $ab2f1c24fdde7ddc$export$d1ae0d802533bef0(codepoint) {
    return !!$ab2f1c24fdde7ddc$var$matchMap(codepoint, $ab2f1c24fdde7ddc$var$Table_A_1_ranges);
}
function $ab2f1c24fdde7ddc$export$9630a1f26a43b76c(codepoint) {
    let range = $ab2f1c24fdde7ddc$var$matchMap(codepoint, $ab2f1c24fdde7ddc$var$Table_B_2_ranges);
    if (range) return [
        codepoint + range.s
    ];
    let codes = $ab2f1c24fdde7ddc$var$Table_B_2_lut_abs[codepoint];
    if (codes) return codes;
    let shift = $ab2f1c24fdde7ddc$var$Table_B_2_lut_rel[codepoint];
    if (shift) return [
        codepoint + shift[0]
    ];
    let complex = $ab2f1c24fdde7ddc$var$Table_B_2_complex[codepoint];
    if (complex) return complex;
    return null;
}
function $ab2f1c24fdde7ddc$export$e07a548cae6d1553(codepoint) {
    return !!$ab2f1c24fdde7ddc$var$matchMap(codepoint, $ab2f1c24fdde7ddc$var$Table_C_ranges);
}
function $ab2f1c24fdde7ddc$export$94f0b6f93c619bc(value) {
    // This allows platforms with incomplete normalize to bypass
    // it for very basic names which the built-in toLowerCase
    // will certainly handle correctly
    if (value.match(/^[a-z0-9-]*$/i) && value.length <= 59) return value.toLowerCase();
    // Get the code points (keeping the current normalization)
    let codes = (0, $1Wmc7.toUtf8CodePoints)(value);
    codes = $ab2f1c24fdde7ddc$var$flatten(codes.map((code)=>{
        // Substitute Table B.1 (Maps to Nothing)
        if ($ab2f1c24fdde7ddc$var$Table_B_1_flags.indexOf(code) >= 0) return [];
        if (code >= 0xfe00 && code <= 0xfe0f) return [];
        // Substitute Table B.2 (Case Folding)
        let codesTableB2 = $ab2f1c24fdde7ddc$export$9630a1f26a43b76c(code);
        if (codesTableB2) return codesTableB2;
        // No Substitution
        return [
            code
        ];
    }));
    // Normalize using form KC
    codes = (0, $1Wmc7.toUtf8CodePoints)((0, $1Wmc7._toUtf8String)(codes), (0, $1Wmc7.UnicodeNormalizationForm).NFKC);
    // Prohibit Tables C.1.2, C.2.2, C.3, C.4, C.5, C.6, C.7, C.8, C.9
    codes.forEach((code)=>{
        if ($ab2f1c24fdde7ddc$export$e07a548cae6d1553(code)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
    });
    // Prohibit Unassigned Code Points (Table A.1)
    codes.forEach((code)=>{
        if ($ab2f1c24fdde7ddc$export$d1ae0d802533bef0(code)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
    });
    // IDNA extras
    let name = (0, $1Wmc7._toUtf8String)(codes);
    // IDNA: 4.2.3.1
    if (name.substring(0, 1) === "-" || name.substring(2, 4) === "--" || name.substring(name.length - 1) === "-") throw new Error("invalid hyphen");
    return name;
}

});

parcelRegister("41JdS", function(module, exports) {

$parcel$export(module.exports, "commify", function () { return $2eea55bfa3f06576$export$de1294767e6ef661; });
$parcel$export(module.exports, "formatUnits", function () { return $2eea55bfa3f06576$export$bd39b96f71da1885; });
$parcel$export(module.exports, "parseUnits", function () { return $2eea55bfa3f06576$export$203ae30b4f6490b3; });
$parcel$export(module.exports, "formatEther", function () { return $2eea55bfa3f06576$export$11bc63b4c03ea518; });
$parcel$export(module.exports, "parseEther", function () { return $2eea55bfa3f06576$export$642c4e67bbdc0bc7; });

var $15mVR = parcelRequire("15mVR");

var $6M65e = parcelRequire("6M65e");

var $149Bx = parcelRequire("149Bx");
"use strict";
const $2eea55bfa3f06576$var$logger = new (0, $6M65e.Logger)((0, $149Bx.version));
const $2eea55bfa3f06576$var$names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
];
function $2eea55bfa3f06576$export$de1294767e6ef661(value) {
    const comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || comps[1] && !comps[1].match(/^[0-9]*$/) || value === "." || value === "-.") $2eea55bfa3f06576$var$logger.throwArgumentError("invalid value", "value", value);
    // Make sure we have at least one whole digit (0 if none)
    let whole = comps[0];
    let negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while(whole.substring(0, 1) === "0")whole = whole.substring(1);
    if (whole === "") whole = "0";
    let suffix = "";
    if (comps.length === 2) suffix = "." + (comps[1] || "0");
    while(suffix.length > 2 && suffix[suffix.length - 1] === "0")suffix = suffix.substring(0, suffix.length - 1);
    const formatted = [];
    while(whole.length)if (whole.length <= 3) {
        formatted.unshift(whole);
        break;
    } else {
        const index = whole.length - 3;
        formatted.unshift(whole.substring(index));
        whole = whole.substring(0, index);
    }
    return negative + formatted.join(",") + suffix;
}
function $2eea55bfa3f06576$export$bd39b96f71da1885(value, unitName) {
    if (typeof unitName === "string") {
        const index = $2eea55bfa3f06576$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $15mVR.formatFixed)(value, unitName != null ? unitName : 18);
}
function $2eea55bfa3f06576$export$203ae30b4f6490b3(value, unitName) {
    if (typeof value !== "string") $2eea55bfa3f06576$var$logger.throwArgumentError("value must be a string", "value", value);
    if (typeof unitName === "string") {
        const index = $2eea55bfa3f06576$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $15mVR.parseFixed)(value, unitName != null ? unitName : 18);
}
function $2eea55bfa3f06576$export$11bc63b4c03ea518(wei) {
    return $2eea55bfa3f06576$export$bd39b96f71da1885(wei, 18);
}
function $2eea55bfa3f06576$export$642c4e67bbdc0bc7(ether) {
    return $2eea55bfa3f06576$export$203ae30b4f6490b3(ether, 18);
}

});
parcelRegister("15mVR", function(module, exports) {

$parcel$export(module.exports, "formatFixed", function () { return $0ca80bf34c50fe44$export$cc011b843b5d69f2; });
$parcel$export(module.exports, "parseFixed", function () { return $0ca80bf34c50fe44$export$1b039987e86d7269; });
$parcel$export(module.exports, "FixedNumber", function () { return $0ca80bf34c50fe44$export$d4693c66c2213e45; });

var $j2rU8 = parcelRequire("j2rU8");

var $6M65e = parcelRequire("6M65e");

var $aLv3y = parcelRequire("aLv3y");

var $gMArf = parcelRequire("gMArf");
"use strict";
const $0ca80bf34c50fe44$var$logger = new (0, $6M65e.Logger)((0, $aLv3y.version));
const $0ca80bf34c50fe44$var$_constructorGuard = {};
const $0ca80bf34c50fe44$var$Zero = (0, $gMArf.BigNumber).from(0);
const $0ca80bf34c50fe44$var$NegativeOne = (0, $gMArf.BigNumber).from(-1);
function $0ca80bf34c50fe44$var$throwFault(message, fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value !== undefined) params.value = value;
    return $0ca80bf34c50fe44$var$logger.throwError(message, (0, $6M65e.Logger).errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
let $0ca80bf34c50fe44$var$zeros = "0";
while($0ca80bf34c50fe44$var$zeros.length < 256)$0ca80bf34c50fe44$var$zeros += $0ca80bf34c50fe44$var$zeros;
// Returns a string "1" followed by decimal "0"s
function $0ca80bf34c50fe44$var$getMultiplier(decimals) {
    if (typeof decimals !== "number") try {
        decimals = (0, $gMArf.BigNumber).from(decimals).toNumber();
    } catch (e) {}
    if (typeof decimals === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) return "1" + $0ca80bf34c50fe44$var$zeros.substring(0, decimals);
    return $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function $0ca80bf34c50fe44$export$cc011b843b5d69f2(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $0ca80bf34c50fe44$var$getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = (0, $gMArf.BigNumber).from(value);
    const negative = value.lt($0ca80bf34c50fe44$var$Zero);
    if (negative) value = value.mul($0ca80bf34c50fe44$var$NegativeOne);
    let fraction = value.mod(multiplier).toString();
    while(fraction.length < multiplier.length - 1)fraction = "0" + fraction;
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const whole = value.div(multiplier).toString();
    if (multiplier.length === 1) value = whole;
    else value = whole + "." + fraction;
    if (negative) value = "-" + value;
    return value;
}
function $0ca80bf34c50fe44$export$1b039987e86d7269(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $0ca80bf34c50fe44$var$getMultiplier(decimals);
    if (typeof value !== "string" || !value.match(/^-?[0-9.]+$/)) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid decimal value", "value", value);
    // Is it negative?
    const negative = value.substring(0, 1) === "-";
    if (negative) value = value.substring(1);
    if (value === ".") $0ca80bf34c50fe44$var$logger.throwArgumentError("missing value", "value", value);
    // Split it into a whole and fractional part
    const comps = value.split(".");
    if (comps.length > 2) $0ca80bf34c50fe44$var$logger.throwArgumentError("too many decimal points", "value", value);
    let whole = comps[0], fraction = comps[1];
    if (!whole) whole = "0";
    if (!fraction) fraction = "0";
    // Trim trailing zeros
    while(fraction[fraction.length - 1] === "0")fraction = fraction.substring(0, fraction.length - 1);
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) $0ca80bf34c50fe44$var$throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") fraction = "0";
    // Fully pad the string with zeros to get to wei
    while(fraction.length < multiplier.length - 1)fraction += "0";
    const wholeValue = (0, $gMArf.BigNumber).from(whole);
    const fractionValue = (0, $gMArf.BigNumber).from(fraction);
    let wei = wholeValue.mul(multiplier).add(fractionValue);
    if (negative) wei = wei.mul($0ca80bf34c50fe44$var$NegativeOne);
    return wei;
}
class $0ca80bf34c50fe44$export$1f3ec5b8f47ebd4d {
    static from(value) {
        if (value instanceof $0ca80bf34c50fe44$export$1f3ec5b8f47ebd4d) return value;
        if (typeof value === "number") value = `fixed128x${value}`;
        let signed = true;
        let width = 128;
        let decimals = 18;
        if (typeof value === "string") {
            if (value === "fixed") ;
            else if (value === "ufixed") signed = false;
            else {
                const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                if (!match) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid fixed format", "format", value);
                signed = match[1] !== "u";
                width = parseInt(match[2]);
                decimals = parseInt(match[3]);
            }
        } else if (value) {
            const check = (key, type, defaultValue)=>{
                if (value[key] == null) return defaultValue;
                if (typeof value[key] !== type) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                return value[key];
            };
            signed = check("signed", "boolean", signed);
            width = check("width", "number", width);
            decimals = check("decimals", "number", decimals);
        }
        if (width % 8) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
        if (decimals > 80) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
        return new $0ca80bf34c50fe44$export$1f3ec5b8f47ebd4d($0ca80bf34c50fe44$var$_constructorGuard, signed, width, decimals);
    }
    constructor(constructorGuard, signed, width, decimals){
        if (constructorGuard !== $0ca80bf34c50fe44$var$_constructorGuard) $0ca80bf34c50fe44$var$logger.throwError("cannot use FixedFormat constructor; use FixedFormat.from", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = $0ca80bf34c50fe44$var$getMultiplier(decimals);
        Object.freeze(this);
    }
}
class $0ca80bf34c50fe44$export$d4693c66c2213e45 {
    _checkFormat(other) {
        if (this.format.name !== other.format.name) $0ca80bf34c50fe44$var$logger.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
    }
    addUnsafe(other) {
        this._checkFormat(other);
        const a = $0ca80bf34c50fe44$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $0ca80bf34c50fe44$export$1b039987e86d7269(other._value, other.format.decimals);
        return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromValue(a.add(b), this.format.decimals, this.format);
    }
    subUnsafe(other) {
        this._checkFormat(other);
        const a = $0ca80bf34c50fe44$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $0ca80bf34c50fe44$export$1b039987e86d7269(other._value, other.format.decimals);
        return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromValue(a.sub(b), this.format.decimals, this.format);
    }
    mulUnsafe(other) {
        this._checkFormat(other);
        const a = $0ca80bf34c50fe44$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $0ca80bf34c50fe44$export$1b039987e86d7269(other._value, other.format.decimals);
        return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(other) {
        this._checkFormat(other);
        const a = $0ca80bf34c50fe44$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $0ca80bf34c50fe44$export$1b039987e86d7269(other._value, other.format.decimals);
        return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
    }
    floor() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $0ca80bf34c50fe44$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (this.isNegative() && hasFraction) result = result.subUnsafe($0ca80bf34c50fe44$var$ONE.toFormat(result.format));
        return result;
    }
    ceiling() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $0ca80bf34c50fe44$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (!this.isNegative() && hasFraction) result = result.addUnsafe($0ca80bf34c50fe44$var$ONE.toFormat(result.format));
        return result;
    }
    // @TODO: Support other rounding algorithms
    round(decimals) {
        if (decimals == null) decimals = 0;
        // If we are already in range, we're done
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        if (decimals < 0 || decimals > 80 || decimals % 1) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid decimal count", "decimals", decimals);
        if (comps[1].length <= decimals) return this;
        const factor = $0ca80bf34c50fe44$export$d4693c66c2213e45.from("1" + $0ca80bf34c50fe44$var$zeros.substring(0, decimals), this.format);
        const bump = $0ca80bf34c50fe44$var$BUMP.toFormat(this.format);
        return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
    }
    isZero() {
        return this._value === "0.0" || this._value === "0";
    }
    isNegative() {
        return this._value[0] === "-";
    }
    toString() {
        return this._value;
    }
    toHexString(width) {
        if (width == null) return this._hex;
        if (width % 8) $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid byte width", "width", width);
        const hex = (0, $gMArf.BigNumber).from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
        return (0, $j2rU8.hexZeroPad)(hex, width / 8);
    }
    toUnsafeFloat() {
        return parseFloat(this.toString());
    }
    toFormat(format) {
        return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromString(this._value, format);
    }
    static fromValue(value, decimals, format) {
        // If decimals looks more like a format, and there is no format, shift the parameters
        if (format == null && decimals != null && !(0, $gMArf.isBigNumberish)(decimals)) {
            format = decimals;
            decimals = null;
        }
        if (decimals == null) decimals = 0;
        if (format == null) format = "fixed";
        return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromString($0ca80bf34c50fe44$export$cc011b843b5d69f2(value, decimals), $0ca80bf34c50fe44$export$1f3ec5b8f47ebd4d.from(format));
    }
    static fromString(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $0ca80bf34c50fe44$export$1f3ec5b8f47ebd4d.from(format);
        const numeric = $0ca80bf34c50fe44$export$1b039987e86d7269(value, fixedFormat.decimals);
        if (!fixedFormat.signed && numeric.lt($0ca80bf34c50fe44$var$Zero)) $0ca80bf34c50fe44$var$throwFault("unsigned value cannot be negative", "overflow", "value", value);
        let hex = null;
        if (fixedFormat.signed) hex = numeric.toTwos(fixedFormat.width).toHexString();
        else {
            hex = numeric.toHexString();
            hex = (0, $j2rU8.hexZeroPad)(hex, fixedFormat.width / 8);
        }
        const decimal = $0ca80bf34c50fe44$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $0ca80bf34c50fe44$export$d4693c66c2213e45($0ca80bf34c50fe44$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static fromBytes(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $0ca80bf34c50fe44$export$1f3ec5b8f47ebd4d.from(format);
        if ((0, $j2rU8.arrayify)(value).length > fixedFormat.width / 8) throw new Error("overflow");
        let numeric = (0, $gMArf.BigNumber).from(value);
        if (fixedFormat.signed) numeric = numeric.fromTwos(fixedFormat.width);
        const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
        const decimal = $0ca80bf34c50fe44$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $0ca80bf34c50fe44$export$d4693c66c2213e45($0ca80bf34c50fe44$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static from(value, format) {
        if (typeof value === "string") return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromString(value, format);
        if ((0, $j2rU8.isBytes)(value)) return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromBytes(value, format);
        try {
            return $0ca80bf34c50fe44$export$d4693c66c2213e45.fromValue(value, 0, format);
        } catch (error) {
            // Allow NUMERIC_FAULT to bubble up
            if (error.code !== (0, $6M65e.Logger).errors.INVALID_ARGUMENT) throw error;
        }
        return $0ca80bf34c50fe44$var$logger.throwArgumentError("invalid FixedNumber value", "value", value);
    }
    static isFixedNumber(value) {
        return !!(value && value._isFixedNumber);
    }
    constructor(constructorGuard, hex, value, format){
        if (constructorGuard !== $0ca80bf34c50fe44$var$_constructorGuard) $0ca80bf34c50fe44$var$logger.throwError("cannot use FixedNumber constructor; use FixedNumber.from", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
}
const $0ca80bf34c50fe44$var$ONE = $0ca80bf34c50fe44$export$d4693c66c2213e45.from(1);
const $0ca80bf34c50fe44$var$BUMP = $0ca80bf34c50fe44$export$d4693c66c2213e45.from("0.5");

});

parcelRegister("149Bx", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $0c6d9d62ef0f8aae$export$83d89fbfd8236492; });
const $0c6d9d62ef0f8aae$export$83d89fbfd8236492 = "units/5.7.0";

});


parcelRegister("54wuV", function(module, exports) {

$parcel$export(module.exports, "Wallet", function () { return $3b1688dbad3fbfea$export$bcca3ea514774656; });
$parcel$export(module.exports, "verifyMessage", function () { return $3b1688dbad3fbfea$export$228d0e772cc158cb; });
$parcel$export(module.exports, "verifyTypedData", function () { return $3b1688dbad3fbfea$export$3603b1c1bcd76798; });

var $e8NrM = parcelRequire("e8NrM");

var $lLovk = parcelRequire("lLovk");

var $iGUqv = parcelRequire("iGUqv");

var $j2rU8 = parcelRequire("j2rU8");

var $kdj79 = parcelRequire("kdj79");
var $7vZoR = parcelRequire("7vZoR");

var $5iEGT = parcelRequire("5iEGT");

var $4ujqV = parcelRequire("4ujqV");

var $2ax4w = parcelRequire("2ax4w");

var $4kSyQ = parcelRequire("4kSyQ");

var $4LuuL = parcelRequire("4LuuL");

var $fuKNC = parcelRequire("fuKNC");
var $7Ybyv = parcelRequire("7Ybyv");

var $hDQeE = parcelRequire("hDQeE");

var $6M65e = parcelRequire("6M65e");

var $eIckK = parcelRequire("eIckK");
"use strict";
var $3b1688dbad3fbfea$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $3b1688dbad3fbfea$var$logger = new (0, $6M65e.Logger)((0, $eIckK.version));
function $3b1688dbad3fbfea$var$isAccount(value) {
    return value != null && (0, $j2rU8.isHexString)(value.privateKey, 32) && value.address != null;
}
function $3b1688dbad3fbfea$var$hasMnemonic(value) {
    const mnemonic = value.mnemonic;
    return mnemonic && mnemonic.phrase;
}
class $3b1688dbad3fbfea$export$bcca3ea514774656 extends (0, $iGUqv.Signer) {
    get mnemonic() {
        return this._mnemonic();
    }
    get privateKey() {
        return this._signingKey().privateKey;
    }
    get publicKey() {
        return this._signingKey().publicKey;
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    connect(provider) {
        return new $3b1688dbad3fbfea$export$bcca3ea514774656(this, provider);
    }
    signTransaction(transaction) {
        return (0, $2ax4w.resolveProperties)(transaction).then((tx)=>{
            if (tx.from != null) {
                if ((0, $e8NrM.getAddress)(tx.from) !== this.address) $3b1688dbad3fbfea$var$logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
                delete tx.from;
            }
            const signature = this._signingKey().signDigest((0, $4ujqV.keccak256)((0, $hDQeE.serialize)(tx)));
            return (0, $hDQeE.serialize)(tx, signature);
        });
    }
    signMessage(message) {
        return $3b1688dbad3fbfea$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $j2rU8.joinSignature)(this._signingKey().signDigest((0, $7vZoR.hashMessage)(message)));
        });
    }
    _signTypedData(domain, types, value) {
        return $3b1688dbad3fbfea$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names
            const populated = yield (0, $kdj79.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                if (this.provider == null) $3b1688dbad3fbfea$var$logger.throwError("cannot resolve ENS names without a provider", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "resolveName",
                    value: name
                });
                return this.provider.resolveName(name);
            });
            return (0, $j2rU8.joinSignature)(this._signingKey().signDigest((0, $kdj79.TypedDataEncoder).hash(populated.domain, types, populated.value)));
        });
    }
    encrypt(password, options, progressCallback) {
        if (typeof options === "function" && !progressCallback) {
            progressCallback = options;
            options = {};
        }
        if (progressCallback && typeof progressCallback !== "function") throw new Error("invalid callback");
        if (!options) options = {};
        return (0, $7Ybyv.encrypt)(this, password, options, progressCallback);
    }
    /**
     *  Static methods to create Wallet instances.
     */ static createRandom(options) {
        let entropy = (0, $4kSyQ.randomBytes)(16);
        if (!options) options = {};
        if (options.extraEntropy) entropy = (0, $j2rU8.arrayify)((0, $j2rU8.hexDataSlice)((0, $4ujqV.keccak256)((0, $j2rU8.concat)([
            entropy,
            options.extraEntropy
        ])), 0, 16));
        const mnemonic = (0, $5iEGT.entropyToMnemonic)(entropy, options.locale);
        return $3b1688dbad3fbfea$export$bcca3ea514774656.fromMnemonic(mnemonic, options.path, options.locale);
    }
    static fromEncryptedJson(json, password, progressCallback) {
        return (0, $fuKNC.decryptJsonWallet)(json, password, progressCallback).then((account)=>{
            return new $3b1688dbad3fbfea$export$bcca3ea514774656(account);
        });
    }
    static fromEncryptedJsonSync(json, password) {
        return new $3b1688dbad3fbfea$export$bcca3ea514774656((0, $fuKNC.decryptJsonWalletSync)(json, password));
    }
    static fromMnemonic(mnemonic, path, wordlist) {
        if (!path) path = (0, $5iEGT.defaultPath);
        return new $3b1688dbad3fbfea$export$bcca3ea514774656((0, $5iEGT.HDNode).fromMnemonic(mnemonic, null, wordlist).derivePath(path));
    }
    constructor(privateKey, provider){
        super();
        if ($3b1688dbad3fbfea$var$isAccount(privateKey)) {
            const signingKey = new (0, $4LuuL.SigningKey)(privateKey.privateKey);
            (0, $2ax4w.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            (0, $2ax4w.defineReadOnly)(this, "address", (0, $hDQeE.computeAddress)(this.publicKey));
            if (this.address !== (0, $e8NrM.getAddress)(privateKey.address)) $3b1688dbad3fbfea$var$logger.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]");
            if ($3b1688dbad3fbfea$var$hasMnemonic(privateKey)) {
                const srcMnemonic = privateKey.mnemonic;
                (0, $2ax4w.defineReadOnly)(this, "_mnemonic", ()=>({
                        phrase: srcMnemonic.phrase,
                        path: srcMnemonic.path || (0, $5iEGT.defaultPath),
                        locale: srcMnemonic.locale || "en"
                    }));
                const mnemonic = this.mnemonic;
                const node = (0, $5iEGT.HDNode).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path);
                if ((0, $hDQeE.computeAddress)(node.privateKey) !== this.address) $3b1688dbad3fbfea$var$logger.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
            } else (0, $2ax4w.defineReadOnly)(this, "_mnemonic", ()=>null);
        } else {
            if ((0, $4LuuL.SigningKey).isSigningKey(privateKey)) {
                /* istanbul ignore if */ if (privateKey.curve !== "secp256k1") $3b1688dbad3fbfea$var$logger.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]");
                (0, $2ax4w.defineReadOnly)(this, "_signingKey", ()=>privateKey);
            } else {
                // A lot of common tools do not prefix private keys with a 0x (see: #1166)
                if (typeof privateKey === "string") {
                    if (privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) privateKey = "0x" + privateKey;
                }
                const signingKey = new (0, $4LuuL.SigningKey)(privateKey);
                (0, $2ax4w.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            }
            (0, $2ax4w.defineReadOnly)(this, "_mnemonic", ()=>null);
            (0, $2ax4w.defineReadOnly)(this, "address", (0, $hDQeE.computeAddress)(this.publicKey));
        }
        /* istanbul ignore if */ if (provider && !(0, $lLovk.Provider).isProvider(provider)) $3b1688dbad3fbfea$var$logger.throwArgumentError("invalid provider", "provider", provider);
        (0, $2ax4w.defineReadOnly)(this, "provider", provider || null);
    }
}
function $3b1688dbad3fbfea$export$228d0e772cc158cb(message, signature) {
    return (0, $hDQeE.recoverAddress)((0, $7vZoR.hashMessage)(message), signature);
}
function $3b1688dbad3fbfea$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $hDQeE.recoverAddress)((0, $kdj79.TypedDataEncoder).hash(domain, types, value), signature);
}

});
parcelRegister("lLovk", function(module, exports) {

$parcel$export(module.exports, "ForkEvent", function () { return $fd80fed41b6901ec$export$406ece1549ccd00e; });
$parcel$export(module.exports, "Provider", function () { return $fd80fed41b6901ec$export$2881499e37b75b9a; });

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $bxoXJ = parcelRequire("bxoXJ");
"use strict";
var $fd80fed41b6901ec$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $fd80fed41b6901ec$var$logger = new (0, $6M65e.Logger)((0, $bxoXJ.version));
class $fd80fed41b6901ec$export$406ece1549ccd00e extends (0, $2ax4w.Description) {
    static isForkEvent(value) {
        return !!(value && value._isForkEvent);
    }
}
class $fd80fed41b6901ec$export$5b2cada8494f9d99 extends $fd80fed41b6901ec$export$406ece1549ccd00e {
    constructor(blockHash, expiry){
        if (!(0, $j2rU8.isHexString)(blockHash, 32)) $fd80fed41b6901ec$var$logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
        super({
            _isForkEvent: true,
            _isBlockForkEvent: true,
            expiry: expiry || 0,
            blockHash: blockHash
        });
    }
}
class $fd80fed41b6901ec$export$26bcd61a55716c98 extends $fd80fed41b6901ec$export$406ece1549ccd00e {
    constructor(hash, expiry){
        if (!(0, $j2rU8.isHexString)(hash, 32)) $fd80fed41b6901ec$var$logger.throwArgumentError("invalid transaction hash", "hash", hash);
        super({
            _isForkEvent: true,
            _isTransactionForkEvent: true,
            expiry: expiry || 0,
            hash: hash
        });
    }
}
class $fd80fed41b6901ec$export$8f8609bfee47c93 extends $fd80fed41b6901ec$export$406ece1549ccd00e {
    constructor(beforeHash, afterHash, expiry){
        if (!(0, $j2rU8.isHexString)(beforeHash, 32)) $fd80fed41b6901ec$var$logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
        if (!(0, $j2rU8.isHexString)(afterHash, 32)) $fd80fed41b6901ec$var$logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
        super({
            _isForkEvent: true,
            _isTransactionOrderForkEvent: true,
            expiry: expiry || 0,
            beforeHash: beforeHash,
            afterHash: afterHash
        });
    }
}
class $fd80fed41b6901ec$export$2881499e37b75b9a {
    getFeeData() {
        return $fd80fed41b6901ec$var$__awaiter(this, void 0, void 0, function*() {
            const { block: block, gasPrice: gasPrice } = yield (0, $2ax4w.resolveProperties)({
                block: this.getBlock("latest"),
                gasPrice: this.getGasPrice().catch((error)=>{
                    // @TODO: Why is this now failing on Calaveras?
                    //console.log(error);
                    return null;
                })
            });
            let lastBaseFeePerGas = null, maxFeePerGas = null, maxPriorityFeePerGas = null;
            if (block && block.baseFeePerGas) {
                // We may want to compute this more accurately in the future,
                // using the formula "check if the base fee is correct".
                // See: https://eips.ethereum.org/EIPS/eip-1559
                lastBaseFeePerGas = block.baseFeePerGas;
                maxPriorityFeePerGas = (0, $gMArf.BigNumber).from("1500000000");
                maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
            }
            return {
                lastBaseFeePerGas: lastBaseFeePerGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                gasPrice: gasPrice
            };
        });
    }
    // Alias for "on"
    addListener(eventName, listener) {
        return this.on(eventName, listener);
    }
    // Alias for "off"
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    static isProvider(value) {
        return !!(value && value._isProvider);
    }
    constructor(){
        $fd80fed41b6901ec$var$logger.checkAbstract(new.target, $fd80fed41b6901ec$export$2881499e37b75b9a);
        (0, $2ax4w.defineReadOnly)(this, "_isProvider", true);
    }
}

});
parcelRegister("bxoXJ", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $866623cc4d757217$export$83d89fbfd8236492; });
const $866623cc4d757217$export$83d89fbfd8236492 = "abstract-provider/5.7.0";

});


parcelRegister("iGUqv", function(module, exports) {

$parcel$export(module.exports, "Signer", function () { return $d9b7eb644de5bd3c$export$fdf54fdde81cc9f0; });
$parcel$export(module.exports, "VoidSigner", function () { return $d9b7eb644de5bd3c$export$7dbc56d9b9612bad; });

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $kAaop = parcelRequire("kAaop");
"use strict";
var $d9b7eb644de5bd3c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d9b7eb644de5bd3c$var$logger = new (0, $6M65e.Logger)((0, $kAaop.version));
const $d9b7eb644de5bd3c$var$allowedTransactionKeys = [
    "accessList",
    "ccipReadEnabled",
    "chainId",
    "customData",
    "data",
    "from",
    "gasLimit",
    "gasPrice",
    "maxFeePerGas",
    "maxPriorityFeePerGas",
    "nonce",
    "to",
    "type",
    "value"
];
const $d9b7eb644de5bd3c$var$forwardErrors = [
    (0, $6M65e.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $6M65e.Logger).errors.NONCE_EXPIRED,
    (0, $6M65e.Logger).errors.REPLACEMENT_UNDERPRICED
];
class $d9b7eb644de5bd3c$export$fdf54fdde81cc9f0 {
    ///////////////////
    // Sub-classes MAY override these
    getBalance(blockTag) {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getBalance");
            return yield this.provider.getBalance(this.getAddress(), blockTag);
        });
    }
    getTransactionCount(blockTag) {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getTransactionCount");
            return yield this.provider.getTransactionCount(this.getAddress(), blockTag);
        });
    }
    // Populates "from" if unspecified, and estimates the gas for the transaction
    estimateGas(transaction) {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("estimateGas");
            const tx = yield (0, $2ax4w.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.estimateGas(tx);
        });
    }
    // Populates "from" if unspecified, and calls with the transaction
    call(transaction, blockTag) {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("call");
            const tx = yield (0, $2ax4w.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.call(tx, blockTag);
        });
    }
    // Populates all fields in a transaction, signs it and sends it to the network
    sendTransaction(transaction) {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("sendTransaction");
            const tx = yield this.populateTransaction(transaction);
            const signedTx = yield this.signTransaction(tx);
            return yield this.provider.sendTransaction(signedTx);
        });
    }
    getChainId() {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getChainId");
            const network = yield this.provider.getNetwork();
            return network.chainId;
        });
    }
    getGasPrice() {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getGasPrice");
            return yield this.provider.getGasPrice();
        });
    }
    getFeeData() {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getFeeData");
            return yield this.provider.getFeeData();
        });
    }
    resolveName(name) {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("resolveName");
            return yield this.provider.resolveName(name);
        });
    }
    // Checks a transaction does not contain invalid keys and if
    // no "from" is provided, populates it.
    // - does NOT require a provider
    // - adds "from" is not present
    // - returns a COPY (safe to mutate the result)
    // By default called from: (overriding these prevents it)
    //   - call
    //   - estimateGas
    //   - populateTransaction (and therefor sendTransaction)
    checkTransaction(transaction) {
        for(const key in transaction)if ($d9b7eb644de5bd3c$var$allowedTransactionKeys.indexOf(key) === -1) $d9b7eb644de5bd3c$var$logger.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
        const tx = (0, $2ax4w.shallowCopy)(transaction);
        if (tx.from == null) tx.from = this.getAddress();
        else // Make sure any provided address matches this signer
        tx.from = Promise.all([
            Promise.resolve(tx.from),
            this.getAddress()
        ]).then((result)=>{
            if (result[0].toLowerCase() !== result[1].toLowerCase()) $d9b7eb644de5bd3c$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            return result[0];
        });
        return tx;
    }
    // Populates ALL keys for a transaction and checks that "from" matches
    // this Signer. Should be used by sendTransaction but NOT by signTransaction.
    // By default called from: (overriding these prevents it)
    //   - sendTransaction
    //
    // Notes:
    //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
    populateTransaction(transaction) {
        return $d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
            const tx = yield (0, $2ax4w.resolveProperties)(this.checkTransaction(transaction));
            if (tx.to != null) {
                tx.to = Promise.resolve(tx.to).then((to)=>$d9b7eb644de5bd3c$var$__awaiter(this, void 0, void 0, function*() {
                        if (to == null) return null;
                        const address = yield this.resolveName(to);
                        if (address == null) $d9b7eb644de5bd3c$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                        return address;
                    }));
                // Prevent this error from causing an UnhandledPromiseException
                tx.to.catch((error)=>{});
            }
            // Do not allow mixing pre-eip-1559 and eip-1559 properties
            const hasEip1559 = tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null;
            if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) $d9b7eb644de5bd3c$var$logger.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
            else if ((tx.type === 0 || tx.type === 1) && hasEip1559) $d9b7eb644de5bd3c$var$logger.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
            if ((tx.type === 2 || tx.type == null) && tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
            tx.type = 2;
            else if (tx.type === 0 || tx.type === 1) // Explicit Legacy or EIP-2930 transaction
            // Populate missing gasPrice
            {
                if (tx.gasPrice == null) tx.gasPrice = this.getGasPrice();
            } else {
                // We need to get fee data to determine things
                const feeData = yield this.getFeeData();
                if (tx.type == null) {
                    // We need to auto-detect the intended type of this transaction...
                    if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                        // The network supports EIP-1559!
                        // Upgrade transaction from null to eip-1559
                        tx.type = 2;
                        if (tx.gasPrice != null) {
                            // Using legacy gasPrice property on an eip-1559 network,
                            // so use gasPrice as both fee properties
                            const gasPrice = tx.gasPrice;
                            delete tx.gasPrice;
                            tx.maxFeePerGas = gasPrice;
                            tx.maxPriorityFeePerGas = gasPrice;
                        } else {
                            // Populate missing fee data
                            if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                            if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                        }
                    } else if (feeData.gasPrice != null) {
                        // Network doesn't support EIP-1559...
                        // ...but they are trying to use EIP-1559 properties
                        if (hasEip1559) $d9b7eb644de5bd3c$var$logger.throwError("network does not support EIP-1559", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                            operation: "populateTransaction"
                        });
                        // Populate missing fee data
                        if (tx.gasPrice == null) tx.gasPrice = feeData.gasPrice;
                        // Explicitly set untyped transaction to legacy
                        tx.type = 0;
                    } else // getFeeData has failed us.
                    $d9b7eb644de5bd3c$var$logger.throwError("failed to get consistent fee data", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "signer.getFeeData"
                    });
                } else if (tx.type === 2) {
                    // Explicitly using EIP-1559
                    // Populate missing fee data
                    if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                    if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                }
            }
            if (tx.nonce == null) tx.nonce = this.getTransactionCount("pending");
            if (tx.gasLimit == null) tx.gasLimit = this.estimateGas(tx).catch((error)=>{
                if ($d9b7eb644de5bd3c$var$forwardErrors.indexOf(error.code) >= 0) throw error;
                return $d9b7eb644de5bd3c$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $6M65e.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
                    error: error,
                    tx: tx
                });
            });
            if (tx.chainId == null) tx.chainId = this.getChainId();
            else tx.chainId = Promise.all([
                Promise.resolve(tx.chainId),
                this.getChainId()
            ]).then((results)=>{
                if (results[1] !== 0 && results[0] !== results[1]) $d9b7eb644de5bd3c$var$logger.throwArgumentError("chainId address mismatch", "transaction", transaction);
                return results[0];
            });
            return yield (0, $2ax4w.resolveProperties)(tx);
        });
    }
    ///////////////////
    // Sub-classes SHOULD leave these alone
    _checkProvider(operation) {
        if (!this.provider) $d9b7eb644de5bd3c$var$logger.throwError("missing provider", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: operation || "_checkProvider"
        });
    }
    static isSigner(value) {
        return !!(value && value._isSigner);
    }
    ///////////////////
    // Sub-classes MUST call super
    constructor(){
        $d9b7eb644de5bd3c$var$logger.checkAbstract(new.target, $d9b7eb644de5bd3c$export$fdf54fdde81cc9f0);
        (0, $2ax4w.defineReadOnly)(this, "_isSigner", true);
    }
}
class $d9b7eb644de5bd3c$export$7dbc56d9b9612bad extends $d9b7eb644de5bd3c$export$fdf54fdde81cc9f0 {
    getAddress() {
        return Promise.resolve(this.address);
    }
    _fail(message, operation) {
        return Promise.resolve().then(()=>{
            $d9b7eb644de5bd3c$var$logger.throwError(message, (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: operation
            });
        });
    }
    signMessage(message) {
        return this._fail("VoidSigner cannot sign messages", "signMessage");
    }
    signTransaction(transaction) {
        return this._fail("VoidSigner cannot sign transactions", "signTransaction");
    }
    _signTypedData(domain, types, value) {
        return this._fail("VoidSigner cannot sign typed data", "signTypedData");
    }
    connect(provider) {
        return new $d9b7eb644de5bd3c$export$7dbc56d9b9612bad(this.address, provider);
    }
    constructor(address, provider){
        super();
        (0, $2ax4w.defineReadOnly)(this, "address", address);
        (0, $2ax4w.defineReadOnly)(this, "provider", provider || null);
    }
}

});
parcelRegister("kAaop", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $efbf3b320c61292d$export$83d89fbfd8236492; });
const $efbf3b320c61292d$export$83d89fbfd8236492 = "abstract-signer/5.7.0";

});


parcelRegister("fuKNC", function(module, exports) {

$parcel$export(module.exports, "decryptJsonWallet", function () { return $b47df5b3ead53646$export$e74fcde37488267a; });
$parcel$export(module.exports, "decryptJsonWalletSync", function () { return $b47df5b3ead53646$export$7a81c437a678891a; });

var $hnVpJ = parcelRequire("hnVpJ");

var $6jMeD = parcelRequire("6jMeD");

var $7Ybyv = parcelRequire("7Ybyv");
"use strict";
function $b47df5b3ead53646$export$e74fcde37488267a(json, password, progressCallback) {
    if ((0, $6jMeD.isCrowdsaleWallet)(json)) {
        if (progressCallback) progressCallback(0);
        const account = (0, $hnVpJ.decrypt)(json, password);
        if (progressCallback) progressCallback(1);
        return Promise.resolve(account);
    }
    if ((0, $6jMeD.isKeystoreWallet)(json)) return (0, $7Ybyv.decrypt)(json, password, progressCallback);
    return Promise.reject(new Error("invalid JSON wallet"));
}
function $b47df5b3ead53646$export$7a81c437a678891a(json, password) {
    if ((0, $6jMeD.isCrowdsaleWallet)(json)) return (0, $hnVpJ.decrypt)(json, password);
    if ((0, $6jMeD.isKeystoreWallet)(json)) return (0, $7Ybyv.decryptSync)(json, password);
    throw new Error("invalid JSON wallet");
}

});
parcelRegister("hnVpJ", function(module, exports) {

$parcel$export(module.exports, "decrypt", function () { return $ca811ee56d4e2b01$export$e85a0c9a1067c5d3; });

var $7MQUh = parcelRequire("7MQUh");

var $e8NrM = parcelRequire("e8NrM");

var $j2rU8 = parcelRequire("j2rU8");

var $4ujqV = parcelRequire("4ujqV");

var $eIQbV = parcelRequire("eIQbV");

var $1Wmc7 = parcelRequire("1Wmc7");

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $e8Zvl = parcelRequire("e8Zvl");

var $btS5Y = parcelRequire("btS5Y");
"use strict";
const $ca811ee56d4e2b01$var$logger = new (0, $6M65e.Logger)((0, $e8Zvl.version));
class $ca811ee56d4e2b01$export$93a76d16f88f2b3 extends (0, $2ax4w.Description) {
    isCrowdsaleAccount(value) {
        return !!(value && value._isCrowdsaleAccount);
    }
}
function $ca811ee56d4e2b01$export$e85a0c9a1067c5d3(json, password) {
    const data = JSON.parse(json);
    password = (0, $btS5Y.getPassword)(password);
    // Ethereum Address
    const ethaddr = (0, $e8NrM.getAddress)((0, $btS5Y.searchPath)(data, "ethaddr"));
    // Encrypted Seed
    const encseed = (0, $btS5Y.looseArrayify)((0, $btS5Y.searchPath)(data, "encseed"));
    if (!encseed || encseed.length % 16 !== 0) $ca811ee56d4e2b01$var$logger.throwArgumentError("invalid encseed", "json", json);
    const key = (0, $j2rU8.arrayify)((0, $eIQbV.pbkdf2)(password, password, 2000, 32, "sha256")).slice(0, 16);
    const iv = encseed.slice(0, 16);
    const encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    const aesCbc = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).ModeOfOperation.cbc(key, iv);
    const seed = (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).padding.pkcs7.strip((0, $j2rU8.arrayify)(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    let seedHex = "";
    for(let i = 0; i < seed.length; i++)seedHex += String.fromCharCode(seed[i]);
    const seedHexBytes = (0, $1Wmc7.toUtf8Bytes)(seedHex);
    const privateKey = (0, $4ujqV.keccak256)(seedHexBytes);
    return new $ca811ee56d4e2b01$export$93a76d16f88f2b3({
        _isCrowdsaleAccount: true,
        address: ethaddr,
        privateKey: privateKey
    });
}

});
parcelRegister("7MQUh", function(module, exports) {
"use strict";
(function(root) {
    function checkInt(value) {
        return parseInt(value) === value;
    }
    function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) return false;
        for(var i = 0; i < arrayish.length; i++){
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) return false;
        }
        return true;
    }
    function coerceArray(arg, copy) {
        // ArrayBuffer view
        if (arg.buffer && ArrayBuffer.isView(arg) && arg.name === "Uint8Array") {
            if (copy) {
                if (arg.slice) arg = arg.slice();
                else arg = Array.prototype.slice.call(arg);
            }
            return arg;
        }
        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) throw new Error("Array contains invalid value: " + arg);
            return new Uint8Array(arg);
        }
        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) return new Uint8Array(arg);
        throw new Error("unsupported array-like object");
    }
    function createArray(length) {
        return new Uint8Array(length);
    }
    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            else sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
        }
        targetArray.set(sourceArray, targetStart);
    }
    var convertUtf8 = function() {
        function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while(i < text.length){
                var c = text.charCodeAt(i++);
                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16));
                    i += 2;
                // otherwise, just the actual byte
                } else result.push(c);
            }
            return coerceArray(result);
        }
        function fromBytes(bytes) {
            var result = [], i = 0;
            while(i < bytes.length){
                var c = bytes[i];
                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode((c & 0x1f) << 6 | bytes[i + 1] & 0x3f));
                    i += 2;
                } else {
                    result.push(String.fromCharCode((c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f));
                    i += 3;
                }
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    var convertHex = function() {
        function toBytes(text) {
            var result = [];
            for(var i = 0; i < text.length; i += 2)result.push(parseInt(text.substr(i, 2), 16));
            return result;
        }
        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = "0123456789abcdef";
        function fromBytes(bytes) {
            var result = [];
            for(var i = 0; i < bytes.length; i++){
                var v = bytes[i];
                result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    // Number of rounds by keysize
    var numberOfRounds = {
        16: 10,
        24: 12,
        32: 14
    };
    // Round constant words
    var rcon = [
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1b,
        0x36,
        0x6c,
        0xd8,
        0xab,
        0x4d,
        0x9a,
        0x2f,
        0x5e,
        0xbc,
        0x63,
        0xc6,
        0x97,
        0x35,
        0x6a,
        0xd4,
        0xb3,
        0x7d,
        0xfa,
        0xef,
        0xc5,
        0x91
    ];
    // S-box and Inverse S-box (S is for Substitution)
    var S = [
        0x63,
        0x7c,
        0x77,
        0x7b,
        0xf2,
        0x6b,
        0x6f,
        0xc5,
        0x30,
        0x01,
        0x67,
        0x2b,
        0xfe,
        0xd7,
        0xab,
        0x76,
        0xca,
        0x82,
        0xc9,
        0x7d,
        0xfa,
        0x59,
        0x47,
        0xf0,
        0xad,
        0xd4,
        0xa2,
        0xaf,
        0x9c,
        0xa4,
        0x72,
        0xc0,
        0xb7,
        0xfd,
        0x93,
        0x26,
        0x36,
        0x3f,
        0xf7,
        0xcc,
        0x34,
        0xa5,
        0xe5,
        0xf1,
        0x71,
        0xd8,
        0x31,
        0x15,
        0x04,
        0xc7,
        0x23,
        0xc3,
        0x18,
        0x96,
        0x05,
        0x9a,
        0x07,
        0x12,
        0x80,
        0xe2,
        0xeb,
        0x27,
        0xb2,
        0x75,
        0x09,
        0x83,
        0x2c,
        0x1a,
        0x1b,
        0x6e,
        0x5a,
        0xa0,
        0x52,
        0x3b,
        0xd6,
        0xb3,
        0x29,
        0xe3,
        0x2f,
        0x84,
        0x53,
        0xd1,
        0x00,
        0xed,
        0x20,
        0xfc,
        0xb1,
        0x5b,
        0x6a,
        0xcb,
        0xbe,
        0x39,
        0x4a,
        0x4c,
        0x58,
        0xcf,
        0xd0,
        0xef,
        0xaa,
        0xfb,
        0x43,
        0x4d,
        0x33,
        0x85,
        0x45,
        0xf9,
        0x02,
        0x7f,
        0x50,
        0x3c,
        0x9f,
        0xa8,
        0x51,
        0xa3,
        0x40,
        0x8f,
        0x92,
        0x9d,
        0x38,
        0xf5,
        0xbc,
        0xb6,
        0xda,
        0x21,
        0x10,
        0xff,
        0xf3,
        0xd2,
        0xcd,
        0x0c,
        0x13,
        0xec,
        0x5f,
        0x97,
        0x44,
        0x17,
        0xc4,
        0xa7,
        0x7e,
        0x3d,
        0x64,
        0x5d,
        0x19,
        0x73,
        0x60,
        0x81,
        0x4f,
        0xdc,
        0x22,
        0x2a,
        0x90,
        0x88,
        0x46,
        0xee,
        0xb8,
        0x14,
        0xde,
        0x5e,
        0x0b,
        0xdb,
        0xe0,
        0x32,
        0x3a,
        0x0a,
        0x49,
        0x06,
        0x24,
        0x5c,
        0xc2,
        0xd3,
        0xac,
        0x62,
        0x91,
        0x95,
        0xe4,
        0x79,
        0xe7,
        0xc8,
        0x37,
        0x6d,
        0x8d,
        0xd5,
        0x4e,
        0xa9,
        0x6c,
        0x56,
        0xf4,
        0xea,
        0x65,
        0x7a,
        0xae,
        0x08,
        0xba,
        0x78,
        0x25,
        0x2e,
        0x1c,
        0xa6,
        0xb4,
        0xc6,
        0xe8,
        0xdd,
        0x74,
        0x1f,
        0x4b,
        0xbd,
        0x8b,
        0x8a,
        0x70,
        0x3e,
        0xb5,
        0x66,
        0x48,
        0x03,
        0xf6,
        0x0e,
        0x61,
        0x35,
        0x57,
        0xb9,
        0x86,
        0xc1,
        0x1d,
        0x9e,
        0xe1,
        0xf8,
        0x98,
        0x11,
        0x69,
        0xd9,
        0x8e,
        0x94,
        0x9b,
        0x1e,
        0x87,
        0xe9,
        0xce,
        0x55,
        0x28,
        0xdf,
        0x8c,
        0xa1,
        0x89,
        0x0d,
        0xbf,
        0xe6,
        0x42,
        0x68,
        0x41,
        0x99,
        0x2d,
        0x0f,
        0xb0,
        0x54,
        0xbb,
        0x16
    ];
    var Si = [
        0x52,
        0x09,
        0x6a,
        0xd5,
        0x30,
        0x36,
        0xa5,
        0x38,
        0xbf,
        0x40,
        0xa3,
        0x9e,
        0x81,
        0xf3,
        0xd7,
        0xfb,
        0x7c,
        0xe3,
        0x39,
        0x82,
        0x9b,
        0x2f,
        0xff,
        0x87,
        0x34,
        0x8e,
        0x43,
        0x44,
        0xc4,
        0xde,
        0xe9,
        0xcb,
        0x54,
        0x7b,
        0x94,
        0x32,
        0xa6,
        0xc2,
        0x23,
        0x3d,
        0xee,
        0x4c,
        0x95,
        0x0b,
        0x42,
        0xfa,
        0xc3,
        0x4e,
        0x08,
        0x2e,
        0xa1,
        0x66,
        0x28,
        0xd9,
        0x24,
        0xb2,
        0x76,
        0x5b,
        0xa2,
        0x49,
        0x6d,
        0x8b,
        0xd1,
        0x25,
        0x72,
        0xf8,
        0xf6,
        0x64,
        0x86,
        0x68,
        0x98,
        0x16,
        0xd4,
        0xa4,
        0x5c,
        0xcc,
        0x5d,
        0x65,
        0xb6,
        0x92,
        0x6c,
        0x70,
        0x48,
        0x50,
        0xfd,
        0xed,
        0xb9,
        0xda,
        0x5e,
        0x15,
        0x46,
        0x57,
        0xa7,
        0x8d,
        0x9d,
        0x84,
        0x90,
        0xd8,
        0xab,
        0x00,
        0x8c,
        0xbc,
        0xd3,
        0x0a,
        0xf7,
        0xe4,
        0x58,
        0x05,
        0xb8,
        0xb3,
        0x45,
        0x06,
        0xd0,
        0x2c,
        0x1e,
        0x8f,
        0xca,
        0x3f,
        0x0f,
        0x02,
        0xc1,
        0xaf,
        0xbd,
        0x03,
        0x01,
        0x13,
        0x8a,
        0x6b,
        0x3a,
        0x91,
        0x11,
        0x41,
        0x4f,
        0x67,
        0xdc,
        0xea,
        0x97,
        0xf2,
        0xcf,
        0xce,
        0xf0,
        0xb4,
        0xe6,
        0x73,
        0x96,
        0xac,
        0x74,
        0x22,
        0xe7,
        0xad,
        0x35,
        0x85,
        0xe2,
        0xf9,
        0x37,
        0xe8,
        0x1c,
        0x75,
        0xdf,
        0x6e,
        0x47,
        0xf1,
        0x1a,
        0x71,
        0x1d,
        0x29,
        0xc5,
        0x89,
        0x6f,
        0xb7,
        0x62,
        0x0e,
        0xaa,
        0x18,
        0xbe,
        0x1b,
        0xfc,
        0x56,
        0x3e,
        0x4b,
        0xc6,
        0xd2,
        0x79,
        0x20,
        0x9a,
        0xdb,
        0xc0,
        0xfe,
        0x78,
        0xcd,
        0x5a,
        0xf4,
        0x1f,
        0xdd,
        0xa8,
        0x33,
        0x88,
        0x07,
        0xc7,
        0x31,
        0xb1,
        0x12,
        0x10,
        0x59,
        0x27,
        0x80,
        0xec,
        0x5f,
        0x60,
        0x51,
        0x7f,
        0xa9,
        0x19,
        0xb5,
        0x4a,
        0x0d,
        0x2d,
        0xe5,
        0x7a,
        0x9f,
        0x93,
        0xc9,
        0x9c,
        0xef,
        0xa0,
        0xe0,
        0x3b,
        0x4d,
        0xae,
        0x2a,
        0xf5,
        0xb0,
        0xc8,
        0xeb,
        0xbb,
        0x3c,
        0x83,
        0x53,
        0x99,
        0x61,
        0x17,
        0x2b,
        0x04,
        0x7e,
        0xba,
        0x77,
        0xd6,
        0x26,
        0xe1,
        0x69,
        0x14,
        0x63,
        0x55,
        0x21,
        0x0c,
        0x7d
    ];
    // Transformations for encryption
    var T1 = [
        0xc66363a5,
        0xf87c7c84,
        0xee777799,
        0xf67b7b8d,
        0xfff2f20d,
        0xd66b6bbd,
        0xde6f6fb1,
        0x91c5c554,
        0x60303050,
        0x02010103,
        0xce6767a9,
        0x562b2b7d,
        0xe7fefe19,
        0xb5d7d762,
        0x4dababe6,
        0xec76769a,
        0x8fcaca45,
        0x1f82829d,
        0x89c9c940,
        0xfa7d7d87,
        0xeffafa15,
        0xb25959eb,
        0x8e4747c9,
        0xfbf0f00b,
        0x41adadec,
        0xb3d4d467,
        0x5fa2a2fd,
        0x45afafea,
        0x239c9cbf,
        0x53a4a4f7,
        0xe4727296,
        0x9bc0c05b,
        0x75b7b7c2,
        0xe1fdfd1c,
        0x3d9393ae,
        0x4c26266a,
        0x6c36365a,
        0x7e3f3f41,
        0xf5f7f702,
        0x83cccc4f,
        0x6834345c,
        0x51a5a5f4,
        0xd1e5e534,
        0xf9f1f108,
        0xe2717193,
        0xabd8d873,
        0x62313153,
        0x2a15153f,
        0x0804040c,
        0x95c7c752,
        0x46232365,
        0x9dc3c35e,
        0x30181828,
        0x379696a1,
        0x0a05050f,
        0x2f9a9ab5,
        0x0e070709,
        0x24121236,
        0x1b80809b,
        0xdfe2e23d,
        0xcdebeb26,
        0x4e272769,
        0x7fb2b2cd,
        0xea75759f,
        0x1209091b,
        0x1d83839e,
        0x582c2c74,
        0x341a1a2e,
        0x361b1b2d,
        0xdc6e6eb2,
        0xb45a5aee,
        0x5ba0a0fb,
        0xa45252f6,
        0x763b3b4d,
        0xb7d6d661,
        0x7db3b3ce,
        0x5229297b,
        0xdde3e33e,
        0x5e2f2f71,
        0x13848497,
        0xa65353f5,
        0xb9d1d168,
        0x00000000,
        0xc1eded2c,
        0x40202060,
        0xe3fcfc1f,
        0x79b1b1c8,
        0xb65b5bed,
        0xd46a6abe,
        0x8dcbcb46,
        0x67bebed9,
        0x7239394b,
        0x944a4ade,
        0x984c4cd4,
        0xb05858e8,
        0x85cfcf4a,
        0xbbd0d06b,
        0xc5efef2a,
        0x4faaaae5,
        0xedfbfb16,
        0x864343c5,
        0x9a4d4dd7,
        0x66333355,
        0x11858594,
        0x8a4545cf,
        0xe9f9f910,
        0x04020206,
        0xfe7f7f81,
        0xa05050f0,
        0x783c3c44,
        0x259f9fba,
        0x4ba8a8e3,
        0xa25151f3,
        0x5da3a3fe,
        0x804040c0,
        0x058f8f8a,
        0x3f9292ad,
        0x219d9dbc,
        0x70383848,
        0xf1f5f504,
        0x63bcbcdf,
        0x77b6b6c1,
        0xafdada75,
        0x42212163,
        0x20101030,
        0xe5ffff1a,
        0xfdf3f30e,
        0xbfd2d26d,
        0x81cdcd4c,
        0x180c0c14,
        0x26131335,
        0xc3ecec2f,
        0xbe5f5fe1,
        0x359797a2,
        0x884444cc,
        0x2e171739,
        0x93c4c457,
        0x55a7a7f2,
        0xfc7e7e82,
        0x7a3d3d47,
        0xc86464ac,
        0xba5d5de7,
        0x3219192b,
        0xe6737395,
        0xc06060a0,
        0x19818198,
        0x9e4f4fd1,
        0xa3dcdc7f,
        0x44222266,
        0x542a2a7e,
        0x3b9090ab,
        0x0b888883,
        0x8c4646ca,
        0xc7eeee29,
        0x6bb8b8d3,
        0x2814143c,
        0xa7dede79,
        0xbc5e5ee2,
        0x160b0b1d,
        0xaddbdb76,
        0xdbe0e03b,
        0x64323256,
        0x743a3a4e,
        0x140a0a1e,
        0x924949db,
        0x0c06060a,
        0x4824246c,
        0xb85c5ce4,
        0x9fc2c25d,
        0xbdd3d36e,
        0x43acacef,
        0xc46262a6,
        0x399191a8,
        0x319595a4,
        0xd3e4e437,
        0xf279798b,
        0xd5e7e732,
        0x8bc8c843,
        0x6e373759,
        0xda6d6db7,
        0x018d8d8c,
        0xb1d5d564,
        0x9c4e4ed2,
        0x49a9a9e0,
        0xd86c6cb4,
        0xac5656fa,
        0xf3f4f407,
        0xcfeaea25,
        0xca6565af,
        0xf47a7a8e,
        0x47aeaee9,
        0x10080818,
        0x6fbabad5,
        0xf0787888,
        0x4a25256f,
        0x5c2e2e72,
        0x381c1c24,
        0x57a6a6f1,
        0x73b4b4c7,
        0x97c6c651,
        0xcbe8e823,
        0xa1dddd7c,
        0xe874749c,
        0x3e1f1f21,
        0x964b4bdd,
        0x61bdbddc,
        0x0d8b8b86,
        0x0f8a8a85,
        0xe0707090,
        0x7c3e3e42,
        0x71b5b5c4,
        0xcc6666aa,
        0x904848d8,
        0x06030305,
        0xf7f6f601,
        0x1c0e0e12,
        0xc26161a3,
        0x6a35355f,
        0xae5757f9,
        0x69b9b9d0,
        0x17868691,
        0x99c1c158,
        0x3a1d1d27,
        0x279e9eb9,
        0xd9e1e138,
        0xebf8f813,
        0x2b9898b3,
        0x22111133,
        0xd26969bb,
        0xa9d9d970,
        0x078e8e89,
        0x339494a7,
        0x2d9b9bb6,
        0x3c1e1e22,
        0x15878792,
        0xc9e9e920,
        0x87cece49,
        0xaa5555ff,
        0x50282878,
        0xa5dfdf7a,
        0x038c8c8f,
        0x59a1a1f8,
        0x09898980,
        0x1a0d0d17,
        0x65bfbfda,
        0xd7e6e631,
        0x844242c6,
        0xd06868b8,
        0x824141c3,
        0x299999b0,
        0x5a2d2d77,
        0x1e0f0f11,
        0x7bb0b0cb,
        0xa85454fc,
        0x6dbbbbd6,
        0x2c16163a
    ];
    var T2 = [
        0xa5c66363,
        0x84f87c7c,
        0x99ee7777,
        0x8df67b7b,
        0x0dfff2f2,
        0xbdd66b6b,
        0xb1de6f6f,
        0x5491c5c5,
        0x50603030,
        0x03020101,
        0xa9ce6767,
        0x7d562b2b,
        0x19e7fefe,
        0x62b5d7d7,
        0xe64dabab,
        0x9aec7676,
        0x458fcaca,
        0x9d1f8282,
        0x4089c9c9,
        0x87fa7d7d,
        0x15effafa,
        0xebb25959,
        0xc98e4747,
        0x0bfbf0f0,
        0xec41adad,
        0x67b3d4d4,
        0xfd5fa2a2,
        0xea45afaf,
        0xbf239c9c,
        0xf753a4a4,
        0x96e47272,
        0x5b9bc0c0,
        0xc275b7b7,
        0x1ce1fdfd,
        0xae3d9393,
        0x6a4c2626,
        0x5a6c3636,
        0x417e3f3f,
        0x02f5f7f7,
        0x4f83cccc,
        0x5c683434,
        0xf451a5a5,
        0x34d1e5e5,
        0x08f9f1f1,
        0x93e27171,
        0x73abd8d8,
        0x53623131,
        0x3f2a1515,
        0x0c080404,
        0x5295c7c7,
        0x65462323,
        0x5e9dc3c3,
        0x28301818,
        0xa1379696,
        0x0f0a0505,
        0xb52f9a9a,
        0x090e0707,
        0x36241212,
        0x9b1b8080,
        0x3ddfe2e2,
        0x26cdebeb,
        0x694e2727,
        0xcd7fb2b2,
        0x9fea7575,
        0x1b120909,
        0x9e1d8383,
        0x74582c2c,
        0x2e341a1a,
        0x2d361b1b,
        0xb2dc6e6e,
        0xeeb45a5a,
        0xfb5ba0a0,
        0xf6a45252,
        0x4d763b3b,
        0x61b7d6d6,
        0xce7db3b3,
        0x7b522929,
        0x3edde3e3,
        0x715e2f2f,
        0x97138484,
        0xf5a65353,
        0x68b9d1d1,
        0x00000000,
        0x2cc1eded,
        0x60402020,
        0x1fe3fcfc,
        0xc879b1b1,
        0xedb65b5b,
        0xbed46a6a,
        0x468dcbcb,
        0xd967bebe,
        0x4b723939,
        0xde944a4a,
        0xd4984c4c,
        0xe8b05858,
        0x4a85cfcf,
        0x6bbbd0d0,
        0x2ac5efef,
        0xe54faaaa,
        0x16edfbfb,
        0xc5864343,
        0xd79a4d4d,
        0x55663333,
        0x94118585,
        0xcf8a4545,
        0x10e9f9f9,
        0x06040202,
        0x81fe7f7f,
        0xf0a05050,
        0x44783c3c,
        0xba259f9f,
        0xe34ba8a8,
        0xf3a25151,
        0xfe5da3a3,
        0xc0804040,
        0x8a058f8f,
        0xad3f9292,
        0xbc219d9d,
        0x48703838,
        0x04f1f5f5,
        0xdf63bcbc,
        0xc177b6b6,
        0x75afdada,
        0x63422121,
        0x30201010,
        0x1ae5ffff,
        0x0efdf3f3,
        0x6dbfd2d2,
        0x4c81cdcd,
        0x14180c0c,
        0x35261313,
        0x2fc3ecec,
        0xe1be5f5f,
        0xa2359797,
        0xcc884444,
        0x392e1717,
        0x5793c4c4,
        0xf255a7a7,
        0x82fc7e7e,
        0x477a3d3d,
        0xacc86464,
        0xe7ba5d5d,
        0x2b321919,
        0x95e67373,
        0xa0c06060,
        0x98198181,
        0xd19e4f4f,
        0x7fa3dcdc,
        0x66442222,
        0x7e542a2a,
        0xab3b9090,
        0x830b8888,
        0xca8c4646,
        0x29c7eeee,
        0xd36bb8b8,
        0x3c281414,
        0x79a7dede,
        0xe2bc5e5e,
        0x1d160b0b,
        0x76addbdb,
        0x3bdbe0e0,
        0x56643232,
        0x4e743a3a,
        0x1e140a0a,
        0xdb924949,
        0x0a0c0606,
        0x6c482424,
        0xe4b85c5c,
        0x5d9fc2c2,
        0x6ebdd3d3,
        0xef43acac,
        0xa6c46262,
        0xa8399191,
        0xa4319595,
        0x37d3e4e4,
        0x8bf27979,
        0x32d5e7e7,
        0x438bc8c8,
        0x596e3737,
        0xb7da6d6d,
        0x8c018d8d,
        0x64b1d5d5,
        0xd29c4e4e,
        0xe049a9a9,
        0xb4d86c6c,
        0xfaac5656,
        0x07f3f4f4,
        0x25cfeaea,
        0xafca6565,
        0x8ef47a7a,
        0xe947aeae,
        0x18100808,
        0xd56fbaba,
        0x88f07878,
        0x6f4a2525,
        0x725c2e2e,
        0x24381c1c,
        0xf157a6a6,
        0xc773b4b4,
        0x5197c6c6,
        0x23cbe8e8,
        0x7ca1dddd,
        0x9ce87474,
        0x213e1f1f,
        0xdd964b4b,
        0xdc61bdbd,
        0x860d8b8b,
        0x850f8a8a,
        0x90e07070,
        0x427c3e3e,
        0xc471b5b5,
        0xaacc6666,
        0xd8904848,
        0x05060303,
        0x01f7f6f6,
        0x121c0e0e,
        0xa3c26161,
        0x5f6a3535,
        0xf9ae5757,
        0xd069b9b9,
        0x91178686,
        0x5899c1c1,
        0x273a1d1d,
        0xb9279e9e,
        0x38d9e1e1,
        0x13ebf8f8,
        0xb32b9898,
        0x33221111,
        0xbbd26969,
        0x70a9d9d9,
        0x89078e8e,
        0xa7339494,
        0xb62d9b9b,
        0x223c1e1e,
        0x92158787,
        0x20c9e9e9,
        0x4987cece,
        0xffaa5555,
        0x78502828,
        0x7aa5dfdf,
        0x8f038c8c,
        0xf859a1a1,
        0x80098989,
        0x171a0d0d,
        0xda65bfbf,
        0x31d7e6e6,
        0xc6844242,
        0xb8d06868,
        0xc3824141,
        0xb0299999,
        0x775a2d2d,
        0x111e0f0f,
        0xcb7bb0b0,
        0xfca85454,
        0xd66dbbbb,
        0x3a2c1616
    ];
    var T3 = [
        0x63a5c663,
        0x7c84f87c,
        0x7799ee77,
        0x7b8df67b,
        0xf20dfff2,
        0x6bbdd66b,
        0x6fb1de6f,
        0xc55491c5,
        0x30506030,
        0x01030201,
        0x67a9ce67,
        0x2b7d562b,
        0xfe19e7fe,
        0xd762b5d7,
        0xabe64dab,
        0x769aec76,
        0xca458fca,
        0x829d1f82,
        0xc94089c9,
        0x7d87fa7d,
        0xfa15effa,
        0x59ebb259,
        0x47c98e47,
        0xf00bfbf0,
        0xadec41ad,
        0xd467b3d4,
        0xa2fd5fa2,
        0xafea45af,
        0x9cbf239c,
        0xa4f753a4,
        0x7296e472,
        0xc05b9bc0,
        0xb7c275b7,
        0xfd1ce1fd,
        0x93ae3d93,
        0x266a4c26,
        0x365a6c36,
        0x3f417e3f,
        0xf702f5f7,
        0xcc4f83cc,
        0x345c6834,
        0xa5f451a5,
        0xe534d1e5,
        0xf108f9f1,
        0x7193e271,
        0xd873abd8,
        0x31536231,
        0x153f2a15,
        0x040c0804,
        0xc75295c7,
        0x23654623,
        0xc35e9dc3,
        0x18283018,
        0x96a13796,
        0x050f0a05,
        0x9ab52f9a,
        0x07090e07,
        0x12362412,
        0x809b1b80,
        0xe23ddfe2,
        0xeb26cdeb,
        0x27694e27,
        0xb2cd7fb2,
        0x759fea75,
        0x091b1209,
        0x839e1d83,
        0x2c74582c,
        0x1a2e341a,
        0x1b2d361b,
        0x6eb2dc6e,
        0x5aeeb45a,
        0xa0fb5ba0,
        0x52f6a452,
        0x3b4d763b,
        0xd661b7d6,
        0xb3ce7db3,
        0x297b5229,
        0xe33edde3,
        0x2f715e2f,
        0x84971384,
        0x53f5a653,
        0xd168b9d1,
        0x00000000,
        0xed2cc1ed,
        0x20604020,
        0xfc1fe3fc,
        0xb1c879b1,
        0x5bedb65b,
        0x6abed46a,
        0xcb468dcb,
        0xbed967be,
        0x394b7239,
        0x4ade944a,
        0x4cd4984c,
        0x58e8b058,
        0xcf4a85cf,
        0xd06bbbd0,
        0xef2ac5ef,
        0xaae54faa,
        0xfb16edfb,
        0x43c58643,
        0x4dd79a4d,
        0x33556633,
        0x85941185,
        0x45cf8a45,
        0xf910e9f9,
        0x02060402,
        0x7f81fe7f,
        0x50f0a050,
        0x3c44783c,
        0x9fba259f,
        0xa8e34ba8,
        0x51f3a251,
        0xa3fe5da3,
        0x40c08040,
        0x8f8a058f,
        0x92ad3f92,
        0x9dbc219d,
        0x38487038,
        0xf504f1f5,
        0xbcdf63bc,
        0xb6c177b6,
        0xda75afda,
        0x21634221,
        0x10302010,
        0xff1ae5ff,
        0xf30efdf3,
        0xd26dbfd2,
        0xcd4c81cd,
        0x0c14180c,
        0x13352613,
        0xec2fc3ec,
        0x5fe1be5f,
        0x97a23597,
        0x44cc8844,
        0x17392e17,
        0xc45793c4,
        0xa7f255a7,
        0x7e82fc7e,
        0x3d477a3d,
        0x64acc864,
        0x5de7ba5d,
        0x192b3219,
        0x7395e673,
        0x60a0c060,
        0x81981981,
        0x4fd19e4f,
        0xdc7fa3dc,
        0x22664422,
        0x2a7e542a,
        0x90ab3b90,
        0x88830b88,
        0x46ca8c46,
        0xee29c7ee,
        0xb8d36bb8,
        0x143c2814,
        0xde79a7de,
        0x5ee2bc5e,
        0x0b1d160b,
        0xdb76addb,
        0xe03bdbe0,
        0x32566432,
        0x3a4e743a,
        0x0a1e140a,
        0x49db9249,
        0x060a0c06,
        0x246c4824,
        0x5ce4b85c,
        0xc25d9fc2,
        0xd36ebdd3,
        0xacef43ac,
        0x62a6c462,
        0x91a83991,
        0x95a43195,
        0xe437d3e4,
        0x798bf279,
        0xe732d5e7,
        0xc8438bc8,
        0x37596e37,
        0x6db7da6d,
        0x8d8c018d,
        0xd564b1d5,
        0x4ed29c4e,
        0xa9e049a9,
        0x6cb4d86c,
        0x56faac56,
        0xf407f3f4,
        0xea25cfea,
        0x65afca65,
        0x7a8ef47a,
        0xaee947ae,
        0x08181008,
        0xbad56fba,
        0x7888f078,
        0x256f4a25,
        0x2e725c2e,
        0x1c24381c,
        0xa6f157a6,
        0xb4c773b4,
        0xc65197c6,
        0xe823cbe8,
        0xdd7ca1dd,
        0x749ce874,
        0x1f213e1f,
        0x4bdd964b,
        0xbddc61bd,
        0x8b860d8b,
        0x8a850f8a,
        0x7090e070,
        0x3e427c3e,
        0xb5c471b5,
        0x66aacc66,
        0x48d89048,
        0x03050603,
        0xf601f7f6,
        0x0e121c0e,
        0x61a3c261,
        0x355f6a35,
        0x57f9ae57,
        0xb9d069b9,
        0x86911786,
        0xc15899c1,
        0x1d273a1d,
        0x9eb9279e,
        0xe138d9e1,
        0xf813ebf8,
        0x98b32b98,
        0x11332211,
        0x69bbd269,
        0xd970a9d9,
        0x8e89078e,
        0x94a73394,
        0x9bb62d9b,
        0x1e223c1e,
        0x87921587,
        0xe920c9e9,
        0xce4987ce,
        0x55ffaa55,
        0x28785028,
        0xdf7aa5df,
        0x8c8f038c,
        0xa1f859a1,
        0x89800989,
        0x0d171a0d,
        0xbfda65bf,
        0xe631d7e6,
        0x42c68442,
        0x68b8d068,
        0x41c38241,
        0x99b02999,
        0x2d775a2d,
        0x0f111e0f,
        0xb0cb7bb0,
        0x54fca854,
        0xbbd66dbb,
        0x163a2c16
    ];
    var T4 = [
        0x6363a5c6,
        0x7c7c84f8,
        0x777799ee,
        0x7b7b8df6,
        0xf2f20dff,
        0x6b6bbdd6,
        0x6f6fb1de,
        0xc5c55491,
        0x30305060,
        0x01010302,
        0x6767a9ce,
        0x2b2b7d56,
        0xfefe19e7,
        0xd7d762b5,
        0xababe64d,
        0x76769aec,
        0xcaca458f,
        0x82829d1f,
        0xc9c94089,
        0x7d7d87fa,
        0xfafa15ef,
        0x5959ebb2,
        0x4747c98e,
        0xf0f00bfb,
        0xadadec41,
        0xd4d467b3,
        0xa2a2fd5f,
        0xafafea45,
        0x9c9cbf23,
        0xa4a4f753,
        0x727296e4,
        0xc0c05b9b,
        0xb7b7c275,
        0xfdfd1ce1,
        0x9393ae3d,
        0x26266a4c,
        0x36365a6c,
        0x3f3f417e,
        0xf7f702f5,
        0xcccc4f83,
        0x34345c68,
        0xa5a5f451,
        0xe5e534d1,
        0xf1f108f9,
        0x717193e2,
        0xd8d873ab,
        0x31315362,
        0x15153f2a,
        0x04040c08,
        0xc7c75295,
        0x23236546,
        0xc3c35e9d,
        0x18182830,
        0x9696a137,
        0x05050f0a,
        0x9a9ab52f,
        0x0707090e,
        0x12123624,
        0x80809b1b,
        0xe2e23ddf,
        0xebeb26cd,
        0x2727694e,
        0xb2b2cd7f,
        0x75759fea,
        0x09091b12,
        0x83839e1d,
        0x2c2c7458,
        0x1a1a2e34,
        0x1b1b2d36,
        0x6e6eb2dc,
        0x5a5aeeb4,
        0xa0a0fb5b,
        0x5252f6a4,
        0x3b3b4d76,
        0xd6d661b7,
        0xb3b3ce7d,
        0x29297b52,
        0xe3e33edd,
        0x2f2f715e,
        0x84849713,
        0x5353f5a6,
        0xd1d168b9,
        0x00000000,
        0xeded2cc1,
        0x20206040,
        0xfcfc1fe3,
        0xb1b1c879,
        0x5b5bedb6,
        0x6a6abed4,
        0xcbcb468d,
        0xbebed967,
        0x39394b72,
        0x4a4ade94,
        0x4c4cd498,
        0x5858e8b0,
        0xcfcf4a85,
        0xd0d06bbb,
        0xefef2ac5,
        0xaaaae54f,
        0xfbfb16ed,
        0x4343c586,
        0x4d4dd79a,
        0x33335566,
        0x85859411,
        0x4545cf8a,
        0xf9f910e9,
        0x02020604,
        0x7f7f81fe,
        0x5050f0a0,
        0x3c3c4478,
        0x9f9fba25,
        0xa8a8e34b,
        0x5151f3a2,
        0xa3a3fe5d,
        0x4040c080,
        0x8f8f8a05,
        0x9292ad3f,
        0x9d9dbc21,
        0x38384870,
        0xf5f504f1,
        0xbcbcdf63,
        0xb6b6c177,
        0xdada75af,
        0x21216342,
        0x10103020,
        0xffff1ae5,
        0xf3f30efd,
        0xd2d26dbf,
        0xcdcd4c81,
        0x0c0c1418,
        0x13133526,
        0xecec2fc3,
        0x5f5fe1be,
        0x9797a235,
        0x4444cc88,
        0x1717392e,
        0xc4c45793,
        0xa7a7f255,
        0x7e7e82fc,
        0x3d3d477a,
        0x6464acc8,
        0x5d5de7ba,
        0x19192b32,
        0x737395e6,
        0x6060a0c0,
        0x81819819,
        0x4f4fd19e,
        0xdcdc7fa3,
        0x22226644,
        0x2a2a7e54,
        0x9090ab3b,
        0x8888830b,
        0x4646ca8c,
        0xeeee29c7,
        0xb8b8d36b,
        0x14143c28,
        0xdede79a7,
        0x5e5ee2bc,
        0x0b0b1d16,
        0xdbdb76ad,
        0xe0e03bdb,
        0x32325664,
        0x3a3a4e74,
        0x0a0a1e14,
        0x4949db92,
        0x06060a0c,
        0x24246c48,
        0x5c5ce4b8,
        0xc2c25d9f,
        0xd3d36ebd,
        0xacacef43,
        0x6262a6c4,
        0x9191a839,
        0x9595a431,
        0xe4e437d3,
        0x79798bf2,
        0xe7e732d5,
        0xc8c8438b,
        0x3737596e,
        0x6d6db7da,
        0x8d8d8c01,
        0xd5d564b1,
        0x4e4ed29c,
        0xa9a9e049,
        0x6c6cb4d8,
        0x5656faac,
        0xf4f407f3,
        0xeaea25cf,
        0x6565afca,
        0x7a7a8ef4,
        0xaeaee947,
        0x08081810,
        0xbabad56f,
        0x787888f0,
        0x25256f4a,
        0x2e2e725c,
        0x1c1c2438,
        0xa6a6f157,
        0xb4b4c773,
        0xc6c65197,
        0xe8e823cb,
        0xdddd7ca1,
        0x74749ce8,
        0x1f1f213e,
        0x4b4bdd96,
        0xbdbddc61,
        0x8b8b860d,
        0x8a8a850f,
        0x707090e0,
        0x3e3e427c,
        0xb5b5c471,
        0x6666aacc,
        0x4848d890,
        0x03030506,
        0xf6f601f7,
        0x0e0e121c,
        0x6161a3c2,
        0x35355f6a,
        0x5757f9ae,
        0xb9b9d069,
        0x86869117,
        0xc1c15899,
        0x1d1d273a,
        0x9e9eb927,
        0xe1e138d9,
        0xf8f813eb,
        0x9898b32b,
        0x11113322,
        0x6969bbd2,
        0xd9d970a9,
        0x8e8e8907,
        0x9494a733,
        0x9b9bb62d,
        0x1e1e223c,
        0x87879215,
        0xe9e920c9,
        0xcece4987,
        0x5555ffaa,
        0x28287850,
        0xdfdf7aa5,
        0x8c8c8f03,
        0xa1a1f859,
        0x89898009,
        0x0d0d171a,
        0xbfbfda65,
        0xe6e631d7,
        0x4242c684,
        0x6868b8d0,
        0x4141c382,
        0x9999b029,
        0x2d2d775a,
        0x0f0f111e,
        0xb0b0cb7b,
        0x5454fca8,
        0xbbbbd66d,
        0x16163a2c
    ];
    // Transformations for decryption
    var T5 = [
        0x51f4a750,
        0x7e416553,
        0x1a17a4c3,
        0x3a275e96,
        0x3bab6bcb,
        0x1f9d45f1,
        0xacfa58ab,
        0x4be30393,
        0x2030fa55,
        0xad766df6,
        0x88cc7691,
        0xf5024c25,
        0x4fe5d7fc,
        0xc52acbd7,
        0x26354480,
        0xb562a38f,
        0xdeb15a49,
        0x25ba1b67,
        0x45ea0e98,
        0x5dfec0e1,
        0xc32f7502,
        0x814cf012,
        0x8d4697a3,
        0x6bd3f9c6,
        0x038f5fe7,
        0x15929c95,
        0xbf6d7aeb,
        0x955259da,
        0xd4be832d,
        0x587421d3,
        0x49e06929,
        0x8ec9c844,
        0x75c2896a,
        0xf48e7978,
        0x99583e6b,
        0x27b971dd,
        0xbee14fb6,
        0xf088ad17,
        0xc920ac66,
        0x7dce3ab4,
        0x63df4a18,
        0xe51a3182,
        0x97513360,
        0x62537f45,
        0xb16477e0,
        0xbb6bae84,
        0xfe81a01c,
        0xf9082b94,
        0x70486858,
        0x8f45fd19,
        0x94de6c87,
        0x527bf8b7,
        0xab73d323,
        0x724b02e2,
        0xe31f8f57,
        0x6655ab2a,
        0xb2eb2807,
        0x2fb5c203,
        0x86c57b9a,
        0xd33708a5,
        0x302887f2,
        0x23bfa5b2,
        0x02036aba,
        0xed16825c,
        0x8acf1c2b,
        0xa779b492,
        0xf307f2f0,
        0x4e69e2a1,
        0x65daf4cd,
        0x0605bed5,
        0xd134621f,
        0xc4a6fe8a,
        0x342e539d,
        0xa2f355a0,
        0x058ae132,
        0xa4f6eb75,
        0x0b83ec39,
        0x4060efaa,
        0x5e719f06,
        0xbd6e1051,
        0x3e218af9,
        0x96dd063d,
        0xdd3e05ae,
        0x4de6bd46,
        0x91548db5,
        0x71c45d05,
        0x0406d46f,
        0x605015ff,
        0x1998fb24,
        0xd6bde997,
        0x894043cc,
        0x67d99e77,
        0xb0e842bd,
        0x07898b88,
        0xe7195b38,
        0x79c8eedb,
        0xa17c0a47,
        0x7c420fe9,
        0xf8841ec9,
        0x00000000,
        0x09808683,
        0x322bed48,
        0x1e1170ac,
        0x6c5a724e,
        0xfd0efffb,
        0x0f853856,
        0x3daed51e,
        0x362d3927,
        0x0a0fd964,
        0x685ca621,
        0x9b5b54d1,
        0x24362e3a,
        0x0c0a67b1,
        0x9357e70f,
        0xb4ee96d2,
        0x1b9b919e,
        0x80c0c54f,
        0x61dc20a2,
        0x5a774b69,
        0x1c121a16,
        0xe293ba0a,
        0xc0a02ae5,
        0x3c22e043,
        0x121b171d,
        0x0e090d0b,
        0xf28bc7ad,
        0x2db6a8b9,
        0x141ea9c8,
        0x57f11985,
        0xaf75074c,
        0xee99ddbb,
        0xa37f60fd,
        0xf701269f,
        0x5c72f5bc,
        0x44663bc5,
        0x5bfb7e34,
        0x8b432976,
        0xcb23c6dc,
        0xb6edfc68,
        0xb8e4f163,
        0xd731dcca,
        0x42638510,
        0x13972240,
        0x84c61120,
        0x854a247d,
        0xd2bb3df8,
        0xaef93211,
        0xc729a16d,
        0x1d9e2f4b,
        0xdcb230f3,
        0x0d8652ec,
        0x77c1e3d0,
        0x2bb3166c,
        0xa970b999,
        0x119448fa,
        0x47e96422,
        0xa8fc8cc4,
        0xa0f03f1a,
        0x567d2cd8,
        0x223390ef,
        0x87494ec7,
        0xd938d1c1,
        0x8ccaa2fe,
        0x98d40b36,
        0xa6f581cf,
        0xa57ade28,
        0xdab78e26,
        0x3fadbfa4,
        0x2c3a9de4,
        0x5078920d,
        0x6a5fcc9b,
        0x547e4662,
        0xf68d13c2,
        0x90d8b8e8,
        0x2e39f75e,
        0x82c3aff5,
        0x9f5d80be,
        0x69d0937c,
        0x6fd52da9,
        0xcf2512b3,
        0xc8ac993b,
        0x10187da7,
        0xe89c636e,
        0xdb3bbb7b,
        0xcd267809,
        0x6e5918f4,
        0xec9ab701,
        0x834f9aa8,
        0xe6956e65,
        0xaaffe67e,
        0x21bccf08,
        0xef15e8e6,
        0xbae79bd9,
        0x4a6f36ce,
        0xea9f09d4,
        0x29b07cd6,
        0x31a4b2af,
        0x2a3f2331,
        0xc6a59430,
        0x35a266c0,
        0x744ebc37,
        0xfc82caa6,
        0xe090d0b0,
        0x33a7d815,
        0xf104984a,
        0x41ecdaf7,
        0x7fcd500e,
        0x1791f62f,
        0x764dd68d,
        0x43efb04d,
        0xccaa4d54,
        0xe49604df,
        0x9ed1b5e3,
        0x4c6a881b,
        0xc12c1fb8,
        0x4665517f,
        0x9d5eea04,
        0x018c355d,
        0xfa877473,
        0xfb0b412e,
        0xb3671d5a,
        0x92dbd252,
        0xe9105633,
        0x6dd64713,
        0x9ad7618c,
        0x37a10c7a,
        0x59f8148e,
        0xeb133c89,
        0xcea927ee,
        0xb761c935,
        0xe11ce5ed,
        0x7a47b13c,
        0x9cd2df59,
        0x55f2733f,
        0x1814ce79,
        0x73c737bf,
        0x53f7cdea,
        0x5ffdaa5b,
        0xdf3d6f14,
        0x7844db86,
        0xcaaff381,
        0xb968c43e,
        0x3824342c,
        0xc2a3405f,
        0x161dc372,
        0xbce2250c,
        0x283c498b,
        0xff0d9541,
        0x39a80171,
        0x080cb3de,
        0xd8b4e49c,
        0x6456c190,
        0x7bcb8461,
        0xd532b670,
        0x486c5c74,
        0xd0b85742
    ];
    var T6 = [
        0x5051f4a7,
        0x537e4165,
        0xc31a17a4,
        0x963a275e,
        0xcb3bab6b,
        0xf11f9d45,
        0xabacfa58,
        0x934be303,
        0x552030fa,
        0xf6ad766d,
        0x9188cc76,
        0x25f5024c,
        0xfc4fe5d7,
        0xd7c52acb,
        0x80263544,
        0x8fb562a3,
        0x49deb15a,
        0x6725ba1b,
        0x9845ea0e,
        0xe15dfec0,
        0x02c32f75,
        0x12814cf0,
        0xa38d4697,
        0xc66bd3f9,
        0xe7038f5f,
        0x9515929c,
        0xebbf6d7a,
        0xda955259,
        0x2dd4be83,
        0xd3587421,
        0x2949e069,
        0x448ec9c8,
        0x6a75c289,
        0x78f48e79,
        0x6b99583e,
        0xdd27b971,
        0xb6bee14f,
        0x17f088ad,
        0x66c920ac,
        0xb47dce3a,
        0x1863df4a,
        0x82e51a31,
        0x60975133,
        0x4562537f,
        0xe0b16477,
        0x84bb6bae,
        0x1cfe81a0,
        0x94f9082b,
        0x58704868,
        0x198f45fd,
        0x8794de6c,
        0xb7527bf8,
        0x23ab73d3,
        0xe2724b02,
        0x57e31f8f,
        0x2a6655ab,
        0x07b2eb28,
        0x032fb5c2,
        0x9a86c57b,
        0xa5d33708,
        0xf2302887,
        0xb223bfa5,
        0xba02036a,
        0x5ced1682,
        0x2b8acf1c,
        0x92a779b4,
        0xf0f307f2,
        0xa14e69e2,
        0xcd65daf4,
        0xd50605be,
        0x1fd13462,
        0x8ac4a6fe,
        0x9d342e53,
        0xa0a2f355,
        0x32058ae1,
        0x75a4f6eb,
        0x390b83ec,
        0xaa4060ef,
        0x065e719f,
        0x51bd6e10,
        0xf93e218a,
        0x3d96dd06,
        0xaedd3e05,
        0x464de6bd,
        0xb591548d,
        0x0571c45d,
        0x6f0406d4,
        0xff605015,
        0x241998fb,
        0x97d6bde9,
        0xcc894043,
        0x7767d99e,
        0xbdb0e842,
        0x8807898b,
        0x38e7195b,
        0xdb79c8ee,
        0x47a17c0a,
        0xe97c420f,
        0xc9f8841e,
        0x00000000,
        0x83098086,
        0x48322bed,
        0xac1e1170,
        0x4e6c5a72,
        0xfbfd0eff,
        0x560f8538,
        0x1e3daed5,
        0x27362d39,
        0x640a0fd9,
        0x21685ca6,
        0xd19b5b54,
        0x3a24362e,
        0xb10c0a67,
        0x0f9357e7,
        0xd2b4ee96,
        0x9e1b9b91,
        0x4f80c0c5,
        0xa261dc20,
        0x695a774b,
        0x161c121a,
        0x0ae293ba,
        0xe5c0a02a,
        0x433c22e0,
        0x1d121b17,
        0x0b0e090d,
        0xadf28bc7,
        0xb92db6a8,
        0xc8141ea9,
        0x8557f119,
        0x4caf7507,
        0xbbee99dd,
        0xfda37f60,
        0x9ff70126,
        0xbc5c72f5,
        0xc544663b,
        0x345bfb7e,
        0x768b4329,
        0xdccb23c6,
        0x68b6edfc,
        0x63b8e4f1,
        0xcad731dc,
        0x10426385,
        0x40139722,
        0x2084c611,
        0x7d854a24,
        0xf8d2bb3d,
        0x11aef932,
        0x6dc729a1,
        0x4b1d9e2f,
        0xf3dcb230,
        0xec0d8652,
        0xd077c1e3,
        0x6c2bb316,
        0x99a970b9,
        0xfa119448,
        0x2247e964,
        0xc4a8fc8c,
        0x1aa0f03f,
        0xd8567d2c,
        0xef223390,
        0xc787494e,
        0xc1d938d1,
        0xfe8ccaa2,
        0x3698d40b,
        0xcfa6f581,
        0x28a57ade,
        0x26dab78e,
        0xa43fadbf,
        0xe42c3a9d,
        0x0d507892,
        0x9b6a5fcc,
        0x62547e46,
        0xc2f68d13,
        0xe890d8b8,
        0x5e2e39f7,
        0xf582c3af,
        0xbe9f5d80,
        0x7c69d093,
        0xa96fd52d,
        0xb3cf2512,
        0x3bc8ac99,
        0xa710187d,
        0x6ee89c63,
        0x7bdb3bbb,
        0x09cd2678,
        0xf46e5918,
        0x01ec9ab7,
        0xa8834f9a,
        0x65e6956e,
        0x7eaaffe6,
        0x0821bccf,
        0xe6ef15e8,
        0xd9bae79b,
        0xce4a6f36,
        0xd4ea9f09,
        0xd629b07c,
        0xaf31a4b2,
        0x312a3f23,
        0x30c6a594,
        0xc035a266,
        0x37744ebc,
        0xa6fc82ca,
        0xb0e090d0,
        0x1533a7d8,
        0x4af10498,
        0xf741ecda,
        0x0e7fcd50,
        0x2f1791f6,
        0x8d764dd6,
        0x4d43efb0,
        0x54ccaa4d,
        0xdfe49604,
        0xe39ed1b5,
        0x1b4c6a88,
        0xb8c12c1f,
        0x7f466551,
        0x049d5eea,
        0x5d018c35,
        0x73fa8774,
        0x2efb0b41,
        0x5ab3671d,
        0x5292dbd2,
        0x33e91056,
        0x136dd647,
        0x8c9ad761,
        0x7a37a10c,
        0x8e59f814,
        0x89eb133c,
        0xeecea927,
        0x35b761c9,
        0xede11ce5,
        0x3c7a47b1,
        0x599cd2df,
        0x3f55f273,
        0x791814ce,
        0xbf73c737,
        0xea53f7cd,
        0x5b5ffdaa,
        0x14df3d6f,
        0x867844db,
        0x81caaff3,
        0x3eb968c4,
        0x2c382434,
        0x5fc2a340,
        0x72161dc3,
        0x0cbce225,
        0x8b283c49,
        0x41ff0d95,
        0x7139a801,
        0xde080cb3,
        0x9cd8b4e4,
        0x906456c1,
        0x617bcb84,
        0x70d532b6,
        0x74486c5c,
        0x42d0b857
    ];
    var T7 = [
        0xa75051f4,
        0x65537e41,
        0xa4c31a17,
        0x5e963a27,
        0x6bcb3bab,
        0x45f11f9d,
        0x58abacfa,
        0x03934be3,
        0xfa552030,
        0x6df6ad76,
        0x769188cc,
        0x4c25f502,
        0xd7fc4fe5,
        0xcbd7c52a,
        0x44802635,
        0xa38fb562,
        0x5a49deb1,
        0x1b6725ba,
        0x0e9845ea,
        0xc0e15dfe,
        0x7502c32f,
        0xf012814c,
        0x97a38d46,
        0xf9c66bd3,
        0x5fe7038f,
        0x9c951592,
        0x7aebbf6d,
        0x59da9552,
        0x832dd4be,
        0x21d35874,
        0x692949e0,
        0xc8448ec9,
        0x896a75c2,
        0x7978f48e,
        0x3e6b9958,
        0x71dd27b9,
        0x4fb6bee1,
        0xad17f088,
        0xac66c920,
        0x3ab47dce,
        0x4a1863df,
        0x3182e51a,
        0x33609751,
        0x7f456253,
        0x77e0b164,
        0xae84bb6b,
        0xa01cfe81,
        0x2b94f908,
        0x68587048,
        0xfd198f45,
        0x6c8794de,
        0xf8b7527b,
        0xd323ab73,
        0x02e2724b,
        0x8f57e31f,
        0xab2a6655,
        0x2807b2eb,
        0xc2032fb5,
        0x7b9a86c5,
        0x08a5d337,
        0x87f23028,
        0xa5b223bf,
        0x6aba0203,
        0x825ced16,
        0x1c2b8acf,
        0xb492a779,
        0xf2f0f307,
        0xe2a14e69,
        0xf4cd65da,
        0xbed50605,
        0x621fd134,
        0xfe8ac4a6,
        0x539d342e,
        0x55a0a2f3,
        0xe132058a,
        0xeb75a4f6,
        0xec390b83,
        0xefaa4060,
        0x9f065e71,
        0x1051bd6e,
        0x8af93e21,
        0x063d96dd,
        0x05aedd3e,
        0xbd464de6,
        0x8db59154,
        0x5d0571c4,
        0xd46f0406,
        0x15ff6050,
        0xfb241998,
        0xe997d6bd,
        0x43cc8940,
        0x9e7767d9,
        0x42bdb0e8,
        0x8b880789,
        0x5b38e719,
        0xeedb79c8,
        0x0a47a17c,
        0x0fe97c42,
        0x1ec9f884,
        0x00000000,
        0x86830980,
        0xed48322b,
        0x70ac1e11,
        0x724e6c5a,
        0xfffbfd0e,
        0x38560f85,
        0xd51e3dae,
        0x3927362d,
        0xd9640a0f,
        0xa621685c,
        0x54d19b5b,
        0x2e3a2436,
        0x67b10c0a,
        0xe70f9357,
        0x96d2b4ee,
        0x919e1b9b,
        0xc54f80c0,
        0x20a261dc,
        0x4b695a77,
        0x1a161c12,
        0xba0ae293,
        0x2ae5c0a0,
        0xe0433c22,
        0x171d121b,
        0x0d0b0e09,
        0xc7adf28b,
        0xa8b92db6,
        0xa9c8141e,
        0x198557f1,
        0x074caf75,
        0xddbbee99,
        0x60fda37f,
        0x269ff701,
        0xf5bc5c72,
        0x3bc54466,
        0x7e345bfb,
        0x29768b43,
        0xc6dccb23,
        0xfc68b6ed,
        0xf163b8e4,
        0xdccad731,
        0x85104263,
        0x22401397,
        0x112084c6,
        0x247d854a,
        0x3df8d2bb,
        0x3211aef9,
        0xa16dc729,
        0x2f4b1d9e,
        0x30f3dcb2,
        0x52ec0d86,
        0xe3d077c1,
        0x166c2bb3,
        0xb999a970,
        0x48fa1194,
        0x642247e9,
        0x8cc4a8fc,
        0x3f1aa0f0,
        0x2cd8567d,
        0x90ef2233,
        0x4ec78749,
        0xd1c1d938,
        0xa2fe8cca,
        0x0b3698d4,
        0x81cfa6f5,
        0xde28a57a,
        0x8e26dab7,
        0xbfa43fad,
        0x9de42c3a,
        0x920d5078,
        0xcc9b6a5f,
        0x4662547e,
        0x13c2f68d,
        0xb8e890d8,
        0xf75e2e39,
        0xaff582c3,
        0x80be9f5d,
        0x937c69d0,
        0x2da96fd5,
        0x12b3cf25,
        0x993bc8ac,
        0x7da71018,
        0x636ee89c,
        0xbb7bdb3b,
        0x7809cd26,
        0x18f46e59,
        0xb701ec9a,
        0x9aa8834f,
        0x6e65e695,
        0xe67eaaff,
        0xcf0821bc,
        0xe8e6ef15,
        0x9bd9bae7,
        0x36ce4a6f,
        0x09d4ea9f,
        0x7cd629b0,
        0xb2af31a4,
        0x23312a3f,
        0x9430c6a5,
        0x66c035a2,
        0xbc37744e,
        0xcaa6fc82,
        0xd0b0e090,
        0xd81533a7,
        0x984af104,
        0xdaf741ec,
        0x500e7fcd,
        0xf62f1791,
        0xd68d764d,
        0xb04d43ef,
        0x4d54ccaa,
        0x04dfe496,
        0xb5e39ed1,
        0x881b4c6a,
        0x1fb8c12c,
        0x517f4665,
        0xea049d5e,
        0x355d018c,
        0x7473fa87,
        0x412efb0b,
        0x1d5ab367,
        0xd25292db,
        0x5633e910,
        0x47136dd6,
        0x618c9ad7,
        0x0c7a37a1,
        0x148e59f8,
        0x3c89eb13,
        0x27eecea9,
        0xc935b761,
        0xe5ede11c,
        0xb13c7a47,
        0xdf599cd2,
        0x733f55f2,
        0xce791814,
        0x37bf73c7,
        0xcdea53f7,
        0xaa5b5ffd,
        0x6f14df3d,
        0xdb867844,
        0xf381caaf,
        0xc43eb968,
        0x342c3824,
        0x405fc2a3,
        0xc372161d,
        0x250cbce2,
        0x498b283c,
        0x9541ff0d,
        0x017139a8,
        0xb3de080c,
        0xe49cd8b4,
        0xc1906456,
        0x84617bcb,
        0xb670d532,
        0x5c74486c,
        0x5742d0b8
    ];
    var T8 = [
        0xf4a75051,
        0x4165537e,
        0x17a4c31a,
        0x275e963a,
        0xab6bcb3b,
        0x9d45f11f,
        0xfa58abac,
        0xe303934b,
        0x30fa5520,
        0x766df6ad,
        0xcc769188,
        0x024c25f5,
        0xe5d7fc4f,
        0x2acbd7c5,
        0x35448026,
        0x62a38fb5,
        0xb15a49de,
        0xba1b6725,
        0xea0e9845,
        0xfec0e15d,
        0x2f7502c3,
        0x4cf01281,
        0x4697a38d,
        0xd3f9c66b,
        0x8f5fe703,
        0x929c9515,
        0x6d7aebbf,
        0x5259da95,
        0xbe832dd4,
        0x7421d358,
        0xe0692949,
        0xc9c8448e,
        0xc2896a75,
        0x8e7978f4,
        0x583e6b99,
        0xb971dd27,
        0xe14fb6be,
        0x88ad17f0,
        0x20ac66c9,
        0xce3ab47d,
        0xdf4a1863,
        0x1a3182e5,
        0x51336097,
        0x537f4562,
        0x6477e0b1,
        0x6bae84bb,
        0x81a01cfe,
        0x082b94f9,
        0x48685870,
        0x45fd198f,
        0xde6c8794,
        0x7bf8b752,
        0x73d323ab,
        0x4b02e272,
        0x1f8f57e3,
        0x55ab2a66,
        0xeb2807b2,
        0xb5c2032f,
        0xc57b9a86,
        0x3708a5d3,
        0x2887f230,
        0xbfa5b223,
        0x036aba02,
        0x16825ced,
        0xcf1c2b8a,
        0x79b492a7,
        0x07f2f0f3,
        0x69e2a14e,
        0xdaf4cd65,
        0x05bed506,
        0x34621fd1,
        0xa6fe8ac4,
        0x2e539d34,
        0xf355a0a2,
        0x8ae13205,
        0xf6eb75a4,
        0x83ec390b,
        0x60efaa40,
        0x719f065e,
        0x6e1051bd,
        0x218af93e,
        0xdd063d96,
        0x3e05aedd,
        0xe6bd464d,
        0x548db591,
        0xc45d0571,
        0x06d46f04,
        0x5015ff60,
        0x98fb2419,
        0xbde997d6,
        0x4043cc89,
        0xd99e7767,
        0xe842bdb0,
        0x898b8807,
        0x195b38e7,
        0xc8eedb79,
        0x7c0a47a1,
        0x420fe97c,
        0x841ec9f8,
        0x00000000,
        0x80868309,
        0x2bed4832,
        0x1170ac1e,
        0x5a724e6c,
        0x0efffbfd,
        0x8538560f,
        0xaed51e3d,
        0x2d392736,
        0x0fd9640a,
        0x5ca62168,
        0x5b54d19b,
        0x362e3a24,
        0x0a67b10c,
        0x57e70f93,
        0xee96d2b4,
        0x9b919e1b,
        0xc0c54f80,
        0xdc20a261,
        0x774b695a,
        0x121a161c,
        0x93ba0ae2,
        0xa02ae5c0,
        0x22e0433c,
        0x1b171d12,
        0x090d0b0e,
        0x8bc7adf2,
        0xb6a8b92d,
        0x1ea9c814,
        0xf1198557,
        0x75074caf,
        0x99ddbbee,
        0x7f60fda3,
        0x01269ff7,
        0x72f5bc5c,
        0x663bc544,
        0xfb7e345b,
        0x4329768b,
        0x23c6dccb,
        0xedfc68b6,
        0xe4f163b8,
        0x31dccad7,
        0x63851042,
        0x97224013,
        0xc6112084,
        0x4a247d85,
        0xbb3df8d2,
        0xf93211ae,
        0x29a16dc7,
        0x9e2f4b1d,
        0xb230f3dc,
        0x8652ec0d,
        0xc1e3d077,
        0xb3166c2b,
        0x70b999a9,
        0x9448fa11,
        0xe9642247,
        0xfc8cc4a8,
        0xf03f1aa0,
        0x7d2cd856,
        0x3390ef22,
        0x494ec787,
        0x38d1c1d9,
        0xcaa2fe8c,
        0xd40b3698,
        0xf581cfa6,
        0x7ade28a5,
        0xb78e26da,
        0xadbfa43f,
        0x3a9de42c,
        0x78920d50,
        0x5fcc9b6a,
        0x7e466254,
        0x8d13c2f6,
        0xd8b8e890,
        0x39f75e2e,
        0xc3aff582,
        0x5d80be9f,
        0xd0937c69,
        0xd52da96f,
        0x2512b3cf,
        0xac993bc8,
        0x187da710,
        0x9c636ee8,
        0x3bbb7bdb,
        0x267809cd,
        0x5918f46e,
        0x9ab701ec,
        0x4f9aa883,
        0x956e65e6,
        0xffe67eaa,
        0xbccf0821,
        0x15e8e6ef,
        0xe79bd9ba,
        0x6f36ce4a,
        0x9f09d4ea,
        0xb07cd629,
        0xa4b2af31,
        0x3f23312a,
        0xa59430c6,
        0xa266c035,
        0x4ebc3774,
        0x82caa6fc,
        0x90d0b0e0,
        0xa7d81533,
        0x04984af1,
        0xecdaf741,
        0xcd500e7f,
        0x91f62f17,
        0x4dd68d76,
        0xefb04d43,
        0xaa4d54cc,
        0x9604dfe4,
        0xd1b5e39e,
        0x6a881b4c,
        0x2c1fb8c1,
        0x65517f46,
        0x5eea049d,
        0x8c355d01,
        0x877473fa,
        0x0b412efb,
        0x671d5ab3,
        0xdbd25292,
        0x105633e9,
        0xd647136d,
        0xd7618c9a,
        0xa10c7a37,
        0xf8148e59,
        0x133c89eb,
        0xa927eece,
        0x61c935b7,
        0x1ce5ede1,
        0x47b13c7a,
        0xd2df599c,
        0xf2733f55,
        0x14ce7918,
        0xc737bf73,
        0xf7cdea53,
        0xfdaa5b5f,
        0x3d6f14df,
        0x44db8678,
        0xaff381ca,
        0x68c43eb9,
        0x24342c38,
        0xa3405fc2,
        0x1dc37216,
        0xe2250cbc,
        0x3c498b28,
        0x0d9541ff,
        0xa8017139,
        0x0cb3de08,
        0xb4e49cd8,
        0x56c19064,
        0xcb84617b,
        0x32b670d5,
        0x6c5c7448,
        0xb85742d0
    ];
    // Transformations for decryption key expansion
    var U1 = [
        0x00000000,
        0x0e090d0b,
        0x1c121a16,
        0x121b171d,
        0x3824342c,
        0x362d3927,
        0x24362e3a,
        0x2a3f2331,
        0x70486858,
        0x7e416553,
        0x6c5a724e,
        0x62537f45,
        0x486c5c74,
        0x4665517f,
        0x547e4662,
        0x5a774b69,
        0xe090d0b0,
        0xee99ddbb,
        0xfc82caa6,
        0xf28bc7ad,
        0xd8b4e49c,
        0xd6bde997,
        0xc4a6fe8a,
        0xcaaff381,
        0x90d8b8e8,
        0x9ed1b5e3,
        0x8ccaa2fe,
        0x82c3aff5,
        0xa8fc8cc4,
        0xa6f581cf,
        0xb4ee96d2,
        0xbae79bd9,
        0xdb3bbb7b,
        0xd532b670,
        0xc729a16d,
        0xc920ac66,
        0xe31f8f57,
        0xed16825c,
        0xff0d9541,
        0xf104984a,
        0xab73d323,
        0xa57ade28,
        0xb761c935,
        0xb968c43e,
        0x9357e70f,
        0x9d5eea04,
        0x8f45fd19,
        0x814cf012,
        0x3bab6bcb,
        0x35a266c0,
        0x27b971dd,
        0x29b07cd6,
        0x038f5fe7,
        0x0d8652ec,
        0x1f9d45f1,
        0x119448fa,
        0x4be30393,
        0x45ea0e98,
        0x57f11985,
        0x59f8148e,
        0x73c737bf,
        0x7dce3ab4,
        0x6fd52da9,
        0x61dc20a2,
        0xad766df6,
        0xa37f60fd,
        0xb16477e0,
        0xbf6d7aeb,
        0x955259da,
        0x9b5b54d1,
        0x894043cc,
        0x87494ec7,
        0xdd3e05ae,
        0xd33708a5,
        0xc12c1fb8,
        0xcf2512b3,
        0xe51a3182,
        0xeb133c89,
        0xf9082b94,
        0xf701269f,
        0x4de6bd46,
        0x43efb04d,
        0x51f4a750,
        0x5ffdaa5b,
        0x75c2896a,
        0x7bcb8461,
        0x69d0937c,
        0x67d99e77,
        0x3daed51e,
        0x33a7d815,
        0x21bccf08,
        0x2fb5c203,
        0x058ae132,
        0x0b83ec39,
        0x1998fb24,
        0x1791f62f,
        0x764dd68d,
        0x7844db86,
        0x6a5fcc9b,
        0x6456c190,
        0x4e69e2a1,
        0x4060efaa,
        0x527bf8b7,
        0x5c72f5bc,
        0x0605bed5,
        0x080cb3de,
        0x1a17a4c3,
        0x141ea9c8,
        0x3e218af9,
        0x302887f2,
        0x223390ef,
        0x2c3a9de4,
        0x96dd063d,
        0x98d40b36,
        0x8acf1c2b,
        0x84c61120,
        0xaef93211,
        0xa0f03f1a,
        0xb2eb2807,
        0xbce2250c,
        0xe6956e65,
        0xe89c636e,
        0xfa877473,
        0xf48e7978,
        0xdeb15a49,
        0xd0b85742,
        0xc2a3405f,
        0xccaa4d54,
        0x41ecdaf7,
        0x4fe5d7fc,
        0x5dfec0e1,
        0x53f7cdea,
        0x79c8eedb,
        0x77c1e3d0,
        0x65daf4cd,
        0x6bd3f9c6,
        0x31a4b2af,
        0x3fadbfa4,
        0x2db6a8b9,
        0x23bfa5b2,
        0x09808683,
        0x07898b88,
        0x15929c95,
        0x1b9b919e,
        0xa17c0a47,
        0xaf75074c,
        0xbd6e1051,
        0xb3671d5a,
        0x99583e6b,
        0x97513360,
        0x854a247d,
        0x8b432976,
        0xd134621f,
        0xdf3d6f14,
        0xcd267809,
        0xc32f7502,
        0xe9105633,
        0xe7195b38,
        0xf5024c25,
        0xfb0b412e,
        0x9ad7618c,
        0x94de6c87,
        0x86c57b9a,
        0x88cc7691,
        0xa2f355a0,
        0xacfa58ab,
        0xbee14fb6,
        0xb0e842bd,
        0xea9f09d4,
        0xe49604df,
        0xf68d13c2,
        0xf8841ec9,
        0xd2bb3df8,
        0xdcb230f3,
        0xcea927ee,
        0xc0a02ae5,
        0x7a47b13c,
        0x744ebc37,
        0x6655ab2a,
        0x685ca621,
        0x42638510,
        0x4c6a881b,
        0x5e719f06,
        0x5078920d,
        0x0a0fd964,
        0x0406d46f,
        0x161dc372,
        0x1814ce79,
        0x322bed48,
        0x3c22e043,
        0x2e39f75e,
        0x2030fa55,
        0xec9ab701,
        0xe293ba0a,
        0xf088ad17,
        0xfe81a01c,
        0xd4be832d,
        0xdab78e26,
        0xc8ac993b,
        0xc6a59430,
        0x9cd2df59,
        0x92dbd252,
        0x80c0c54f,
        0x8ec9c844,
        0xa4f6eb75,
        0xaaffe67e,
        0xb8e4f163,
        0xb6edfc68,
        0x0c0a67b1,
        0x02036aba,
        0x10187da7,
        0x1e1170ac,
        0x342e539d,
        0x3a275e96,
        0x283c498b,
        0x26354480,
        0x7c420fe9,
        0x724b02e2,
        0x605015ff,
        0x6e5918f4,
        0x44663bc5,
        0x4a6f36ce,
        0x587421d3,
        0x567d2cd8,
        0x37a10c7a,
        0x39a80171,
        0x2bb3166c,
        0x25ba1b67,
        0x0f853856,
        0x018c355d,
        0x13972240,
        0x1d9e2f4b,
        0x47e96422,
        0x49e06929,
        0x5bfb7e34,
        0x55f2733f,
        0x7fcd500e,
        0x71c45d05,
        0x63df4a18,
        0x6dd64713,
        0xd731dcca,
        0xd938d1c1,
        0xcb23c6dc,
        0xc52acbd7,
        0xef15e8e6,
        0xe11ce5ed,
        0xf307f2f0,
        0xfd0efffb,
        0xa779b492,
        0xa970b999,
        0xbb6bae84,
        0xb562a38f,
        0x9f5d80be,
        0x91548db5,
        0x834f9aa8,
        0x8d4697a3
    ];
    var U2 = [
        0x00000000,
        0x0b0e090d,
        0x161c121a,
        0x1d121b17,
        0x2c382434,
        0x27362d39,
        0x3a24362e,
        0x312a3f23,
        0x58704868,
        0x537e4165,
        0x4e6c5a72,
        0x4562537f,
        0x74486c5c,
        0x7f466551,
        0x62547e46,
        0x695a774b,
        0xb0e090d0,
        0xbbee99dd,
        0xa6fc82ca,
        0xadf28bc7,
        0x9cd8b4e4,
        0x97d6bde9,
        0x8ac4a6fe,
        0x81caaff3,
        0xe890d8b8,
        0xe39ed1b5,
        0xfe8ccaa2,
        0xf582c3af,
        0xc4a8fc8c,
        0xcfa6f581,
        0xd2b4ee96,
        0xd9bae79b,
        0x7bdb3bbb,
        0x70d532b6,
        0x6dc729a1,
        0x66c920ac,
        0x57e31f8f,
        0x5ced1682,
        0x41ff0d95,
        0x4af10498,
        0x23ab73d3,
        0x28a57ade,
        0x35b761c9,
        0x3eb968c4,
        0x0f9357e7,
        0x049d5eea,
        0x198f45fd,
        0x12814cf0,
        0xcb3bab6b,
        0xc035a266,
        0xdd27b971,
        0xd629b07c,
        0xe7038f5f,
        0xec0d8652,
        0xf11f9d45,
        0xfa119448,
        0x934be303,
        0x9845ea0e,
        0x8557f119,
        0x8e59f814,
        0xbf73c737,
        0xb47dce3a,
        0xa96fd52d,
        0xa261dc20,
        0xf6ad766d,
        0xfda37f60,
        0xe0b16477,
        0xebbf6d7a,
        0xda955259,
        0xd19b5b54,
        0xcc894043,
        0xc787494e,
        0xaedd3e05,
        0xa5d33708,
        0xb8c12c1f,
        0xb3cf2512,
        0x82e51a31,
        0x89eb133c,
        0x94f9082b,
        0x9ff70126,
        0x464de6bd,
        0x4d43efb0,
        0x5051f4a7,
        0x5b5ffdaa,
        0x6a75c289,
        0x617bcb84,
        0x7c69d093,
        0x7767d99e,
        0x1e3daed5,
        0x1533a7d8,
        0x0821bccf,
        0x032fb5c2,
        0x32058ae1,
        0x390b83ec,
        0x241998fb,
        0x2f1791f6,
        0x8d764dd6,
        0x867844db,
        0x9b6a5fcc,
        0x906456c1,
        0xa14e69e2,
        0xaa4060ef,
        0xb7527bf8,
        0xbc5c72f5,
        0xd50605be,
        0xde080cb3,
        0xc31a17a4,
        0xc8141ea9,
        0xf93e218a,
        0xf2302887,
        0xef223390,
        0xe42c3a9d,
        0x3d96dd06,
        0x3698d40b,
        0x2b8acf1c,
        0x2084c611,
        0x11aef932,
        0x1aa0f03f,
        0x07b2eb28,
        0x0cbce225,
        0x65e6956e,
        0x6ee89c63,
        0x73fa8774,
        0x78f48e79,
        0x49deb15a,
        0x42d0b857,
        0x5fc2a340,
        0x54ccaa4d,
        0xf741ecda,
        0xfc4fe5d7,
        0xe15dfec0,
        0xea53f7cd,
        0xdb79c8ee,
        0xd077c1e3,
        0xcd65daf4,
        0xc66bd3f9,
        0xaf31a4b2,
        0xa43fadbf,
        0xb92db6a8,
        0xb223bfa5,
        0x83098086,
        0x8807898b,
        0x9515929c,
        0x9e1b9b91,
        0x47a17c0a,
        0x4caf7507,
        0x51bd6e10,
        0x5ab3671d,
        0x6b99583e,
        0x60975133,
        0x7d854a24,
        0x768b4329,
        0x1fd13462,
        0x14df3d6f,
        0x09cd2678,
        0x02c32f75,
        0x33e91056,
        0x38e7195b,
        0x25f5024c,
        0x2efb0b41,
        0x8c9ad761,
        0x8794de6c,
        0x9a86c57b,
        0x9188cc76,
        0xa0a2f355,
        0xabacfa58,
        0xb6bee14f,
        0xbdb0e842,
        0xd4ea9f09,
        0xdfe49604,
        0xc2f68d13,
        0xc9f8841e,
        0xf8d2bb3d,
        0xf3dcb230,
        0xeecea927,
        0xe5c0a02a,
        0x3c7a47b1,
        0x37744ebc,
        0x2a6655ab,
        0x21685ca6,
        0x10426385,
        0x1b4c6a88,
        0x065e719f,
        0x0d507892,
        0x640a0fd9,
        0x6f0406d4,
        0x72161dc3,
        0x791814ce,
        0x48322bed,
        0x433c22e0,
        0x5e2e39f7,
        0x552030fa,
        0x01ec9ab7,
        0x0ae293ba,
        0x17f088ad,
        0x1cfe81a0,
        0x2dd4be83,
        0x26dab78e,
        0x3bc8ac99,
        0x30c6a594,
        0x599cd2df,
        0x5292dbd2,
        0x4f80c0c5,
        0x448ec9c8,
        0x75a4f6eb,
        0x7eaaffe6,
        0x63b8e4f1,
        0x68b6edfc,
        0xb10c0a67,
        0xba02036a,
        0xa710187d,
        0xac1e1170,
        0x9d342e53,
        0x963a275e,
        0x8b283c49,
        0x80263544,
        0xe97c420f,
        0xe2724b02,
        0xff605015,
        0xf46e5918,
        0xc544663b,
        0xce4a6f36,
        0xd3587421,
        0xd8567d2c,
        0x7a37a10c,
        0x7139a801,
        0x6c2bb316,
        0x6725ba1b,
        0x560f8538,
        0x5d018c35,
        0x40139722,
        0x4b1d9e2f,
        0x2247e964,
        0x2949e069,
        0x345bfb7e,
        0x3f55f273,
        0x0e7fcd50,
        0x0571c45d,
        0x1863df4a,
        0x136dd647,
        0xcad731dc,
        0xc1d938d1,
        0xdccb23c6,
        0xd7c52acb,
        0xe6ef15e8,
        0xede11ce5,
        0xf0f307f2,
        0xfbfd0eff,
        0x92a779b4,
        0x99a970b9,
        0x84bb6bae,
        0x8fb562a3,
        0xbe9f5d80,
        0xb591548d,
        0xa8834f9a,
        0xa38d4697
    ];
    var U3 = [
        0x00000000,
        0x0d0b0e09,
        0x1a161c12,
        0x171d121b,
        0x342c3824,
        0x3927362d,
        0x2e3a2436,
        0x23312a3f,
        0x68587048,
        0x65537e41,
        0x724e6c5a,
        0x7f456253,
        0x5c74486c,
        0x517f4665,
        0x4662547e,
        0x4b695a77,
        0xd0b0e090,
        0xddbbee99,
        0xcaa6fc82,
        0xc7adf28b,
        0xe49cd8b4,
        0xe997d6bd,
        0xfe8ac4a6,
        0xf381caaf,
        0xb8e890d8,
        0xb5e39ed1,
        0xa2fe8cca,
        0xaff582c3,
        0x8cc4a8fc,
        0x81cfa6f5,
        0x96d2b4ee,
        0x9bd9bae7,
        0xbb7bdb3b,
        0xb670d532,
        0xa16dc729,
        0xac66c920,
        0x8f57e31f,
        0x825ced16,
        0x9541ff0d,
        0x984af104,
        0xd323ab73,
        0xde28a57a,
        0xc935b761,
        0xc43eb968,
        0xe70f9357,
        0xea049d5e,
        0xfd198f45,
        0xf012814c,
        0x6bcb3bab,
        0x66c035a2,
        0x71dd27b9,
        0x7cd629b0,
        0x5fe7038f,
        0x52ec0d86,
        0x45f11f9d,
        0x48fa1194,
        0x03934be3,
        0x0e9845ea,
        0x198557f1,
        0x148e59f8,
        0x37bf73c7,
        0x3ab47dce,
        0x2da96fd5,
        0x20a261dc,
        0x6df6ad76,
        0x60fda37f,
        0x77e0b164,
        0x7aebbf6d,
        0x59da9552,
        0x54d19b5b,
        0x43cc8940,
        0x4ec78749,
        0x05aedd3e,
        0x08a5d337,
        0x1fb8c12c,
        0x12b3cf25,
        0x3182e51a,
        0x3c89eb13,
        0x2b94f908,
        0x269ff701,
        0xbd464de6,
        0xb04d43ef,
        0xa75051f4,
        0xaa5b5ffd,
        0x896a75c2,
        0x84617bcb,
        0x937c69d0,
        0x9e7767d9,
        0xd51e3dae,
        0xd81533a7,
        0xcf0821bc,
        0xc2032fb5,
        0xe132058a,
        0xec390b83,
        0xfb241998,
        0xf62f1791,
        0xd68d764d,
        0xdb867844,
        0xcc9b6a5f,
        0xc1906456,
        0xe2a14e69,
        0xefaa4060,
        0xf8b7527b,
        0xf5bc5c72,
        0xbed50605,
        0xb3de080c,
        0xa4c31a17,
        0xa9c8141e,
        0x8af93e21,
        0x87f23028,
        0x90ef2233,
        0x9de42c3a,
        0x063d96dd,
        0x0b3698d4,
        0x1c2b8acf,
        0x112084c6,
        0x3211aef9,
        0x3f1aa0f0,
        0x2807b2eb,
        0x250cbce2,
        0x6e65e695,
        0x636ee89c,
        0x7473fa87,
        0x7978f48e,
        0x5a49deb1,
        0x5742d0b8,
        0x405fc2a3,
        0x4d54ccaa,
        0xdaf741ec,
        0xd7fc4fe5,
        0xc0e15dfe,
        0xcdea53f7,
        0xeedb79c8,
        0xe3d077c1,
        0xf4cd65da,
        0xf9c66bd3,
        0xb2af31a4,
        0xbfa43fad,
        0xa8b92db6,
        0xa5b223bf,
        0x86830980,
        0x8b880789,
        0x9c951592,
        0x919e1b9b,
        0x0a47a17c,
        0x074caf75,
        0x1051bd6e,
        0x1d5ab367,
        0x3e6b9958,
        0x33609751,
        0x247d854a,
        0x29768b43,
        0x621fd134,
        0x6f14df3d,
        0x7809cd26,
        0x7502c32f,
        0x5633e910,
        0x5b38e719,
        0x4c25f502,
        0x412efb0b,
        0x618c9ad7,
        0x6c8794de,
        0x7b9a86c5,
        0x769188cc,
        0x55a0a2f3,
        0x58abacfa,
        0x4fb6bee1,
        0x42bdb0e8,
        0x09d4ea9f,
        0x04dfe496,
        0x13c2f68d,
        0x1ec9f884,
        0x3df8d2bb,
        0x30f3dcb2,
        0x27eecea9,
        0x2ae5c0a0,
        0xb13c7a47,
        0xbc37744e,
        0xab2a6655,
        0xa621685c,
        0x85104263,
        0x881b4c6a,
        0x9f065e71,
        0x920d5078,
        0xd9640a0f,
        0xd46f0406,
        0xc372161d,
        0xce791814,
        0xed48322b,
        0xe0433c22,
        0xf75e2e39,
        0xfa552030,
        0xb701ec9a,
        0xba0ae293,
        0xad17f088,
        0xa01cfe81,
        0x832dd4be,
        0x8e26dab7,
        0x993bc8ac,
        0x9430c6a5,
        0xdf599cd2,
        0xd25292db,
        0xc54f80c0,
        0xc8448ec9,
        0xeb75a4f6,
        0xe67eaaff,
        0xf163b8e4,
        0xfc68b6ed,
        0x67b10c0a,
        0x6aba0203,
        0x7da71018,
        0x70ac1e11,
        0x539d342e,
        0x5e963a27,
        0x498b283c,
        0x44802635,
        0x0fe97c42,
        0x02e2724b,
        0x15ff6050,
        0x18f46e59,
        0x3bc54466,
        0x36ce4a6f,
        0x21d35874,
        0x2cd8567d,
        0x0c7a37a1,
        0x017139a8,
        0x166c2bb3,
        0x1b6725ba,
        0x38560f85,
        0x355d018c,
        0x22401397,
        0x2f4b1d9e,
        0x642247e9,
        0x692949e0,
        0x7e345bfb,
        0x733f55f2,
        0x500e7fcd,
        0x5d0571c4,
        0x4a1863df,
        0x47136dd6,
        0xdccad731,
        0xd1c1d938,
        0xc6dccb23,
        0xcbd7c52a,
        0xe8e6ef15,
        0xe5ede11c,
        0xf2f0f307,
        0xfffbfd0e,
        0xb492a779,
        0xb999a970,
        0xae84bb6b,
        0xa38fb562,
        0x80be9f5d,
        0x8db59154,
        0x9aa8834f,
        0x97a38d46
    ];
    var U4 = [
        0x00000000,
        0x090d0b0e,
        0x121a161c,
        0x1b171d12,
        0x24342c38,
        0x2d392736,
        0x362e3a24,
        0x3f23312a,
        0x48685870,
        0x4165537e,
        0x5a724e6c,
        0x537f4562,
        0x6c5c7448,
        0x65517f46,
        0x7e466254,
        0x774b695a,
        0x90d0b0e0,
        0x99ddbbee,
        0x82caa6fc,
        0x8bc7adf2,
        0xb4e49cd8,
        0xbde997d6,
        0xa6fe8ac4,
        0xaff381ca,
        0xd8b8e890,
        0xd1b5e39e,
        0xcaa2fe8c,
        0xc3aff582,
        0xfc8cc4a8,
        0xf581cfa6,
        0xee96d2b4,
        0xe79bd9ba,
        0x3bbb7bdb,
        0x32b670d5,
        0x29a16dc7,
        0x20ac66c9,
        0x1f8f57e3,
        0x16825ced,
        0x0d9541ff,
        0x04984af1,
        0x73d323ab,
        0x7ade28a5,
        0x61c935b7,
        0x68c43eb9,
        0x57e70f93,
        0x5eea049d,
        0x45fd198f,
        0x4cf01281,
        0xab6bcb3b,
        0xa266c035,
        0xb971dd27,
        0xb07cd629,
        0x8f5fe703,
        0x8652ec0d,
        0x9d45f11f,
        0x9448fa11,
        0xe303934b,
        0xea0e9845,
        0xf1198557,
        0xf8148e59,
        0xc737bf73,
        0xce3ab47d,
        0xd52da96f,
        0xdc20a261,
        0x766df6ad,
        0x7f60fda3,
        0x6477e0b1,
        0x6d7aebbf,
        0x5259da95,
        0x5b54d19b,
        0x4043cc89,
        0x494ec787,
        0x3e05aedd,
        0x3708a5d3,
        0x2c1fb8c1,
        0x2512b3cf,
        0x1a3182e5,
        0x133c89eb,
        0x082b94f9,
        0x01269ff7,
        0xe6bd464d,
        0xefb04d43,
        0xf4a75051,
        0xfdaa5b5f,
        0xc2896a75,
        0xcb84617b,
        0xd0937c69,
        0xd99e7767,
        0xaed51e3d,
        0xa7d81533,
        0xbccf0821,
        0xb5c2032f,
        0x8ae13205,
        0x83ec390b,
        0x98fb2419,
        0x91f62f17,
        0x4dd68d76,
        0x44db8678,
        0x5fcc9b6a,
        0x56c19064,
        0x69e2a14e,
        0x60efaa40,
        0x7bf8b752,
        0x72f5bc5c,
        0x05bed506,
        0x0cb3de08,
        0x17a4c31a,
        0x1ea9c814,
        0x218af93e,
        0x2887f230,
        0x3390ef22,
        0x3a9de42c,
        0xdd063d96,
        0xd40b3698,
        0xcf1c2b8a,
        0xc6112084,
        0xf93211ae,
        0xf03f1aa0,
        0xeb2807b2,
        0xe2250cbc,
        0x956e65e6,
        0x9c636ee8,
        0x877473fa,
        0x8e7978f4,
        0xb15a49de,
        0xb85742d0,
        0xa3405fc2,
        0xaa4d54cc,
        0xecdaf741,
        0xe5d7fc4f,
        0xfec0e15d,
        0xf7cdea53,
        0xc8eedb79,
        0xc1e3d077,
        0xdaf4cd65,
        0xd3f9c66b,
        0xa4b2af31,
        0xadbfa43f,
        0xb6a8b92d,
        0xbfa5b223,
        0x80868309,
        0x898b8807,
        0x929c9515,
        0x9b919e1b,
        0x7c0a47a1,
        0x75074caf,
        0x6e1051bd,
        0x671d5ab3,
        0x583e6b99,
        0x51336097,
        0x4a247d85,
        0x4329768b,
        0x34621fd1,
        0x3d6f14df,
        0x267809cd,
        0x2f7502c3,
        0x105633e9,
        0x195b38e7,
        0x024c25f5,
        0x0b412efb,
        0xd7618c9a,
        0xde6c8794,
        0xc57b9a86,
        0xcc769188,
        0xf355a0a2,
        0xfa58abac,
        0xe14fb6be,
        0xe842bdb0,
        0x9f09d4ea,
        0x9604dfe4,
        0x8d13c2f6,
        0x841ec9f8,
        0xbb3df8d2,
        0xb230f3dc,
        0xa927eece,
        0xa02ae5c0,
        0x47b13c7a,
        0x4ebc3774,
        0x55ab2a66,
        0x5ca62168,
        0x63851042,
        0x6a881b4c,
        0x719f065e,
        0x78920d50,
        0x0fd9640a,
        0x06d46f04,
        0x1dc37216,
        0x14ce7918,
        0x2bed4832,
        0x22e0433c,
        0x39f75e2e,
        0x30fa5520,
        0x9ab701ec,
        0x93ba0ae2,
        0x88ad17f0,
        0x81a01cfe,
        0xbe832dd4,
        0xb78e26da,
        0xac993bc8,
        0xa59430c6,
        0xd2df599c,
        0xdbd25292,
        0xc0c54f80,
        0xc9c8448e,
        0xf6eb75a4,
        0xffe67eaa,
        0xe4f163b8,
        0xedfc68b6,
        0x0a67b10c,
        0x036aba02,
        0x187da710,
        0x1170ac1e,
        0x2e539d34,
        0x275e963a,
        0x3c498b28,
        0x35448026,
        0x420fe97c,
        0x4b02e272,
        0x5015ff60,
        0x5918f46e,
        0x663bc544,
        0x6f36ce4a,
        0x7421d358,
        0x7d2cd856,
        0xa10c7a37,
        0xa8017139,
        0xb3166c2b,
        0xba1b6725,
        0x8538560f,
        0x8c355d01,
        0x97224013,
        0x9e2f4b1d,
        0xe9642247,
        0xe0692949,
        0xfb7e345b,
        0xf2733f55,
        0xcd500e7f,
        0xc45d0571,
        0xdf4a1863,
        0xd647136d,
        0x31dccad7,
        0x38d1c1d9,
        0x23c6dccb,
        0x2acbd7c5,
        0x15e8e6ef,
        0x1ce5ede1,
        0x07f2f0f3,
        0x0efffbfd,
        0x79b492a7,
        0x70b999a9,
        0x6bae84bb,
        0x62a38fb5,
        0x5d80be9f,
        0x548db591,
        0x4f9aa883,
        0x4697a38d
    ];
    function convertToInt32(bytes) {
        var result = [];
        for(var i = 0; i < bytes.length; i += 4)result.push(bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]);
        return result;
    }
    var AES = function(key) {
        if (!(this instanceof AES)) throw Error("AES must be instanitated with `new`");
        Object.defineProperty(this, "key", {
            value: coerceArray(key, true)
        });
        this._prepare();
    };
    AES.prototype._prepare = function() {
        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
        // encryption round keys
        this._Ke = [];
        // decryption round keys
        this._Kd = [];
        for(var i = 0; i <= rounds; i++){
            this._Ke.push([
                0,
                0,
                0,
                0
            ]);
            this._Kd.push([
                0,
                0,
                0,
                0
            ]);
        }
        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;
        // convert the key into ints
        var tk = convertToInt32(this.key);
        // copy values into round key arrays
        var index;
        for(var i = 0; i < KC; i++){
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }
        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while(t < roundKeyCount){
            tt = tk[KC - 1];
            tk[0] ^= S[tt >> 16 & 0xFF] << 24 ^ S[tt >> 8 & 0xFF] << 16 ^ S[tt & 0xFF] << 8 ^ S[tt >> 24 & 0xFF] ^ rcon[rconpointer] << 24;
            rconpointer += 1;
            // key expansion (for non-256 bit)
            if (KC != 8) for(var i = 1; i < KC; i++)tk[i] ^= tk[i - 1];
            else {
                for(var i = 1; i < KC / 2; i++)tk[i] ^= tk[i - 1];
                tt = tk[KC / 2 - 1];
                tk[KC / 2] ^= S[tt & 0xFF] ^ S[tt >> 8 & 0xFF] << 8 ^ S[tt >> 16 & 0xFF] << 16 ^ S[tt >> 24 & 0xFF] << 24;
                for(var i = KC / 2 + 1; i < KC; i++)tk[i] ^= tk[i - 1];
            }
            // copy values into round key arrays
            var i = 0, r, c;
            while(i < KC && t < roundKeyCount){
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }
        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for(var r = 1; r < rounds; r++)for(var c = 0; c < 4; c++){
            tt = this._Kd[r][c];
            this._Kd[r][c] = U1[tt >> 24 & 0xFF] ^ U2[tt >> 16 & 0xFF] ^ U3[tt >> 8 & 0xFF] ^ U4[tt & 0xFF];
        }
    };
    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) throw new Error("invalid plaintext size (must be 16 bytes)");
        var rounds = this._Ke.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Ke[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T1[t[i] >> 24 & 0xff] ^ T2[t[(i + 1) % 4] >> 16 & 0xff] ^ T3[t[(i + 2) % 4] >> 8 & 0xff] ^ T4[t[(i + 3) % 4] & 0xff] ^ this._Ke[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Ke[rounds][i];
            result[4 * i] = (S[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (S[t[(i + 1) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (S[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (S[t[(i + 3) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) throw new Error("invalid ciphertext size (must be 16 bytes)");
        var rounds = this._Kd.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Kd[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T5[t[i] >> 24 & 0xff] ^ T6[t[(i + 3) % 4] >> 16 & 0xff] ^ T7[t[(i + 2) % 4] >> 8 & 0xff] ^ T8[t[(i + 1) % 4] & 0xff] ^ this._Kd[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Kd[rounds][i];
            result[4 * i] = (Si[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (Si[t[(i + 3) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (Si[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (Si[t[(i + 1) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */ var ModeOfOperationECB = function(key) {
        if (!(this instanceof ModeOfOperationECB)) throw Error("AES must be instanitated with `new`");
        this.description = "Electronic Code Block";
        this.name = "ecb";
        this._aes = new AES(key);
    };
    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */ var ModeOfOperationCBC = function(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Block Chaining";
        this.name = "cbc";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastCipherblock = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            for(var j = 0; j < 16; j++)block[j] ^= this._lastCipherblock[j];
            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            for(var j = 0; j < 16; j++)plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */ var ModeOfOperationCFB = function(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Feedback";
        this.name = "cfb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 size)");
        if (!segmentSize) segmentSize = 1;
        this.segmentSize = segmentSize;
        this._shiftRegister = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if (plaintext.length % this.segmentSize != 0) throw new Error("invalid plaintext size (must be segmentSize bytes)");
        var encrypted = coerceArray(plaintext, true);
        var xorSegment;
        for(var i = 0; i < encrypted.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)encrypted[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return encrypted;
    };
    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length % this.segmentSize != 0) throw new Error("invalid ciphertext size (must be segmentSize bytes)");
        var plaintext = coerceArray(ciphertext, true);
        var xorSegment;
        for(var i = 0; i < plaintext.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)plaintext[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */ var ModeOfOperationOFB = function(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Output Feedback";
        this.name = "ofb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;
    /**
     *  Counter object for CTR common mode of operation
     */ var Counter = function(initialValue) {
        if (!(this instanceof Counter)) throw Error("Counter must be instanitated with `new`");
        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) initialValue = 1;
        if (typeof initialValue === "number") {
            this._counter = createArray(16);
            this.setValue(initialValue);
        } else this.setBytes(initialValue);
    };
    Counter.prototype.setValue = function(value) {
        if (typeof value !== "number" || parseInt(value) != value) throw new Error("invalid counter value (must be an integer)");
        for(var index = 15; index >= 0; --index){
            this._counter[index] = value % 256;
            value = value >> 8;
        }
    };
    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);
        if (bytes.length != 16) throw new Error("invalid counter bytes size (must be 16 bytes)");
        this._counter = bytes;
    };
    Counter.prototype.increment = function() {
        for(var i = 15; i >= 0; i--)if (this._counter[i] === 255) this._counter[i] = 0;
        else {
            this._counter[i]++;
            break;
        }
    };
    /**
     *  Mode Of Operation - Counter (CTR)
     */ var ModeOfOperationCTR = function(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) throw Error("AES must be instanitated with `new`");
        this.description = "Counter";
        this.name = "ctr";
        if (!(counter instanceof Counter)) counter = new Counter(counter);
        this._counter = counter;
        this._remainingCounter = null;
        this._remainingCounterIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;
    ///////////////////////
    // Padding
    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - data.length % 16;
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for(var i = data.length; i < result.length; i++)result[i] = padder;
        return result;
    }
    function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) throw new Error("PKCS#7 invalid length");
        var padder = data[data.length - 1];
        if (padder > 16) throw new Error("PKCS#7 padding byte out of range");
        var length = data.length - padder;
        for(var i = 0; i < padder; i++){
            if (data[length + i] !== padder) throw new Error("PKCS#7 invalid padding byte");
        }
        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    }
    ///////////////////////
    // Exporting
    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,
        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },
        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },
        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },
        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray
        }
    };
    module.exports = aesjs;
})(module.exports);

});

parcelRegister("e8Zvl", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $a4c18596bcdbd717$export$83d89fbfd8236492; });
const $a4c18596bcdbd717$export$83d89fbfd8236492 = "json-wallets/5.7.0";

});

parcelRegister("btS5Y", function(module, exports) {

$parcel$export(module.exports, "looseArrayify", function () { return $85bc5d60031db318$export$2cde08bde0cfd932; });
$parcel$export(module.exports, "zpad", function () { return $85bc5d60031db318$export$67752b99d3bc61c6; });
$parcel$export(module.exports, "getPassword", function () { return $85bc5d60031db318$export$350bd33120f7413e; });
$parcel$export(module.exports, "searchPath", function () { return $85bc5d60031db318$export$5a5c1dbd910e2c32; });
$parcel$export(module.exports, "uuidV4", function () { return $85bc5d60031db318$export$ec7b18ebad55a3a9; });

var $j2rU8 = parcelRequire("j2rU8");

var $1Wmc7 = parcelRequire("1Wmc7");
"use strict";
function $85bc5d60031db318$export$2cde08bde0cfd932(hexString) {
    if (typeof hexString === "string" && hexString.substring(0, 2) !== "0x") hexString = "0x" + hexString;
    return (0, $j2rU8.arrayify)(hexString);
}
function $85bc5d60031db318$export$67752b99d3bc61c6(value, length) {
    value = String(value);
    while(value.length < length)value = "0" + value;
    return value;
}
function $85bc5d60031db318$export$350bd33120f7413e(password) {
    if (typeof password === "string") return (0, $1Wmc7.toUtf8Bytes)(password, (0, $1Wmc7.UnicodeNormalizationForm).NFKC);
    return (0, $j2rU8.arrayify)(password);
}
function $85bc5d60031db318$export$5a5c1dbd910e2c32(object, path) {
    let currentChild = object;
    const comps = path.toLowerCase().split("/");
    for(let i = 0; i < comps.length; i++){
        // Search for a child object with a case-insensitive matching key
        let matchingChild = null;
        for(const key in currentChild)if (key.toLowerCase() === comps[i]) {
            matchingChild = currentChild[key];
            break;
        }
        // Didn't find one. :'(
        if (matchingChild === null) return null;
        // Now check this child...
        currentChild = matchingChild;
    }
    return currentChild;
}
function $85bc5d60031db318$export$ec7b18ebad55a3a9(randomBytes) {
    const bytes = (0, $j2rU8.arrayify)(randomBytes);
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = bytes[6] & 0x0f | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = bytes[8] & 0x3f | 0x80;
    const value = (0, $j2rU8.hexlify)(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34)
    ].join("-");
}

});


parcelRegister("7Ybyv", function(module, exports) {

$parcel$export(module.exports, "decryptSync", function () { return $5cd719aa79671b4c$export$9bd2c37889ee5e36; });
$parcel$export(module.exports, "decrypt", function () { return $5cd719aa79671b4c$export$e85a0c9a1067c5d3; });
$parcel$export(module.exports, "encrypt", function () { return $5cd719aa79671b4c$export$5b0f6292f11d1d18; });

var $7MQUh = parcelRequire("7MQUh");

var $e9e3c = parcelRequire("e9e3c");

var $e8NrM = parcelRequire("e8NrM");

var $j2rU8 = parcelRequire("j2rU8");

var $5iEGT = parcelRequire("5iEGT");

var $4ujqV = parcelRequire("4ujqV");

var $eIQbV = parcelRequire("eIQbV");

var $4kSyQ = parcelRequire("4kSyQ");

var $2ax4w = parcelRequire("2ax4w");

var $hDQeE = parcelRequire("hDQeE");

var $btS5Y = parcelRequire("btS5Y");

var $6M65e = parcelRequire("6M65e");

var $e8Zvl = parcelRequire("e8Zvl");
"use strict";
var $5cd719aa79671b4c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $5cd719aa79671b4c$var$logger = new (0, $6M65e.Logger)((0, $e8Zvl.version));
// Exported Types
function $5cd719aa79671b4c$var$hasMnemonic(value) {
    return value != null && value.mnemonic && value.mnemonic.phrase;
}
class $5cd719aa79671b4c$export$cf9dc4fd6dde0315 extends (0, $2ax4w.Description) {
    isKeystoreAccount(value) {
        return !!(value && value._isKeystoreAccount);
    }
}
function $5cd719aa79671b4c$var$_decrypt(data, key, ciphertext) {
    const cipher = (0, $btS5Y.searchPath)(data, "crypto/cipher");
    if (cipher === "aes-128-ctr") {
        const iv = (0, $btS5Y.looseArrayify)((0, $btS5Y.searchPath)(data, "crypto/cipherparams/iv"));
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).ModeOfOperation.ctr(key, counter);
        return (0, $j2rU8.arrayify)(aesCtr.decrypt(ciphertext));
    }
    return null;
}
function $5cd719aa79671b4c$var$_getAccount(data, key) {
    const ciphertext = (0, $btS5Y.looseArrayify)((0, $btS5Y.searchPath)(data, "crypto/ciphertext"));
    const computedMAC = (0, $j2rU8.hexlify)((0, $4ujqV.keccak256)((0, $j2rU8.concat)([
        key.slice(16, 32),
        ciphertext
    ]))).substring(2);
    if (computedMAC !== (0, $btS5Y.searchPath)(data, "crypto/mac").toLowerCase()) throw new Error("invalid password");
    const privateKey = $5cd719aa79671b4c$var$_decrypt(data, key.slice(0, 16), ciphertext);
    if (!privateKey) $5cd719aa79671b4c$var$logger.throwError("unsupported cipher", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "decrypt"
    });
    const mnemonicKey = key.slice(32, 64);
    const address = (0, $hDQeE.computeAddress)(privateKey);
    if (data.address) {
        let check = data.address.toLowerCase();
        if (check.substring(0, 2) !== "0x") check = "0x" + check;
        if ((0, $e8NrM.getAddress)(check) !== address) throw new Error("address mismatch");
    }
    const account = {
        _isKeystoreAccount: true,
        address: address,
        privateKey: (0, $j2rU8.hexlify)(privateKey)
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    if ((0, $btS5Y.searchPath)(data, "x-ethers/version") === "0.1") {
        const mnemonicCiphertext = (0, $btS5Y.looseArrayify)((0, $btS5Y.searchPath)(data, "x-ethers/mnemonicCiphertext"));
        const mnemonicIv = (0, $btS5Y.looseArrayify)((0, $btS5Y.searchPath)(data, "x-ethers/mnemonicCounter"));
        const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).Counter(mnemonicIv);
        const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
        const path = (0, $btS5Y.searchPath)(data, "x-ethers/path") || (0, $5iEGT.defaultPath);
        const locale = (0, $btS5Y.searchPath)(data, "x-ethers/locale") || "en";
        const entropy = (0, $j2rU8.arrayify)(mnemonicAesCtr.decrypt(mnemonicCiphertext));
        try {
            const mnemonic = (0, $5iEGT.entropyToMnemonic)(entropy, locale);
            const node = (0, $5iEGT.HDNode).fromMnemonic(mnemonic, null, locale).derivePath(path);
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
            account.mnemonic = node.mnemonic;
        } catch (error) {
            // If we don't have the locale wordlist installed to
            // read this mnemonic, just bail and don't set the
            // mnemonic
            if (error.code !== (0, $6M65e.Logger).errors.INVALID_ARGUMENT || error.argument !== "wordlist") throw error;
        }
    }
    return new $5cd719aa79671b4c$export$cf9dc4fd6dde0315(account);
}
function $5cd719aa79671b4c$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc) {
    return (0, $j2rU8.arrayify)((0, $eIQbV.pbkdf2)(passwordBytes, salt, count, dkLen, prfFunc));
}
function $5cd719aa79671b4c$var$pbkdf2(passwordBytes, salt, count, dkLen, prfFunc) {
    return Promise.resolve($5cd719aa79671b4c$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc));
}
function $5cd719aa79671b4c$var$_computeKdfKey(data, password, pbkdf2Func, scryptFunc, progressCallback) {
    const passwordBytes = (0, $btS5Y.getPassword)(password);
    const kdf = (0, $btS5Y.searchPath)(data, "crypto/kdf");
    if (kdf && typeof kdf === "string") {
        const throwError = function(name, value) {
            return $5cd719aa79671b4c$var$logger.throwArgumentError("invalid key-derivation function parameters", name, value);
        };
        if (kdf.toLowerCase() === "scrypt") {
            const salt = (0, $btS5Y.looseArrayify)((0, $btS5Y.searchPath)(data, "crypto/kdfparams/salt"));
            const N = parseInt((0, $btS5Y.searchPath)(data, "crypto/kdfparams/n"));
            const r = parseInt((0, $btS5Y.searchPath)(data, "crypto/kdfparams/r"));
            const p = parseInt((0, $btS5Y.searchPath)(data, "crypto/kdfparams/p"));
            // Check for all required parameters
            if (!N || !r || !p) throwError("kdf", kdf);
            // Make sure N is a power of 2
            if ((N & N - 1) !== 0) throwError("N", N);
            const dkLen = parseInt((0, $btS5Y.searchPath)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return scryptFunc(passwordBytes, salt, N, r, p, 64, progressCallback);
        } else if (kdf.toLowerCase() === "pbkdf2") {
            const salt = (0, $btS5Y.looseArrayify)((0, $btS5Y.searchPath)(data, "crypto/kdfparams/salt"));
            let prfFunc = null;
            const prf = (0, $btS5Y.searchPath)(data, "crypto/kdfparams/prf");
            if (prf === "hmac-sha256") prfFunc = "sha256";
            else if (prf === "hmac-sha512") prfFunc = "sha512";
            else throwError("prf", prf);
            const count = parseInt((0, $btS5Y.searchPath)(data, "crypto/kdfparams/c"));
            const dkLen = parseInt((0, $btS5Y.searchPath)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return pbkdf2Func(passwordBytes, salt, count, dkLen, prfFunc);
        }
    }
    return $5cd719aa79671b4c$var$logger.throwArgumentError("unsupported key-derivation function", "kdf", kdf);
}
function $5cd719aa79671b4c$export$9bd2c37889ee5e36(json, password) {
    const data = JSON.parse(json);
    const key = $5cd719aa79671b4c$var$_computeKdfKey(data, password, $5cd719aa79671b4c$var$pbkdf2Sync, (0, (/*@__PURE__*/$parcel$interopDefault($e9e3c))).syncScrypt);
    return $5cd719aa79671b4c$var$_getAccount(data, key);
}
function $5cd719aa79671b4c$export$e85a0c9a1067c5d3(json, password, progressCallback) {
    return $5cd719aa79671b4c$var$__awaiter(this, void 0, void 0, function*() {
        const data = JSON.parse(json);
        const key = yield $5cd719aa79671b4c$var$_computeKdfKey(data, password, $5cd719aa79671b4c$var$pbkdf2, (0, (/*@__PURE__*/$parcel$interopDefault($e9e3c))).scrypt, progressCallback);
        return $5cd719aa79671b4c$var$_getAccount(data, key);
    });
}
function $5cd719aa79671b4c$export$5b0f6292f11d1d18(account, password, options, progressCallback) {
    try {
        // Check the address matches the private key
        if ((0, $e8NrM.getAddress)(account.address) !== (0, $hDQeE.computeAddress)(account.privateKey)) throw new Error("address/privateKey mismatch");
        // Check the mnemonic (if any) matches the private key
        if ($5cd719aa79671b4c$var$hasMnemonic(account)) {
            const mnemonic = account.mnemonic;
            const node = (0, $5iEGT.HDNode).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path || (0, $5iEGT.defaultPath));
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
        }
    } catch (e) {
        return Promise.reject(e);
    }
    // The options are optional, so adjust the call as needed
    if (typeof options === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
    }
    if (!options) options = {};
    const privateKey = (0, $j2rU8.arrayify)(account.privateKey);
    const passwordBytes = (0, $btS5Y.getPassword)(password);
    let entropy = null;
    let path = null;
    let locale = null;
    if ($5cd719aa79671b4c$var$hasMnemonic(account)) {
        const srcMnemonic = account.mnemonic;
        entropy = (0, $j2rU8.arrayify)((0, $5iEGT.mnemonicToEntropy)(srcMnemonic.phrase, srcMnemonic.locale || "en"));
        path = srcMnemonic.path || (0, $5iEGT.defaultPath);
        locale = srcMnemonic.locale || "en";
    }
    let client = options.client;
    if (!client) client = "ethers.js";
    // Check/generate the salt
    let salt = null;
    if (options.salt) salt = (0, $j2rU8.arrayify)(options.salt);
    else salt = (0, $4kSyQ.randomBytes)(32);
    // Override initialization vector
    let iv = null;
    if (options.iv) {
        iv = (0, $j2rU8.arrayify)(options.iv);
        if (iv.length !== 16) throw new Error("invalid iv");
    } else iv = (0, $4kSyQ.randomBytes)(16);
    // Override the uuid
    let uuidRandom = null;
    if (options.uuid) {
        uuidRandom = (0, $j2rU8.arrayify)(options.uuid);
        if (uuidRandom.length !== 16) throw new Error("invalid uuid");
    } else uuidRandom = (0, $4kSyQ.randomBytes)(16);
    // Override the scrypt password-based key derivation function parameters
    let N = 131072, r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) N = options.scrypt.N;
        if (options.scrypt.r) r = options.scrypt.r;
        if (options.scrypt.p) p = options.scrypt.p;
    }
    // We take 64 bytes:
    //   - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    //   - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    return (0, (/*@__PURE__*/$parcel$interopDefault($e9e3c))).scrypt(passwordBytes, salt, N, r, p, 64, progressCallback).then((key)=>{
        key = (0, $j2rU8.arrayify)(key);
        // This will be used to encrypt the wallet (as per Web3 secret storage)
        const derivedKey = key.slice(0, 16);
        const macPrefix = key.slice(16, 32);
        // This will be used to encrypt the mnemonic phrase (if any)
        const mnemonicKey = key.slice(32, 64);
        // Encrypt the private key
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).ModeOfOperation.ctr(derivedKey, counter);
        const ciphertext = (0, $j2rU8.arrayify)(aesCtr.encrypt(privateKey));
        // Compute the message authentication code, used to check the password
        const mac = (0, $4ujqV.keccak256)((0, $j2rU8.concat)([
            macPrefix,
            ciphertext
        ]));
        // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
        const data = {
            address: account.address.substring(2).toLowerCase(),
            id: (0, $btS5Y.uuidV4)(uuidRandom),
            version: 3,
            crypto: {
                cipher: "aes-128-ctr",
                cipherparams: {
                    iv: (0, $j2rU8.hexlify)(iv).substring(2)
                },
                ciphertext: (0, $j2rU8.hexlify)(ciphertext).substring(2),
                kdf: "scrypt",
                kdfparams: {
                    salt: (0, $j2rU8.hexlify)(salt).substring(2),
                    n: N,
                    dklen: 32,
                    p: p,
                    r: r
                },
                mac: mac.substring(2)
            }
        };
        // If we have a mnemonic, encrypt it into the JSON wallet
        if (entropy) {
            const mnemonicIv = (0, $4kSyQ.randomBytes)(16);
            const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).Counter(mnemonicIv);
            const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($7MQUh))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
            const mnemonicCiphertext = (0, $j2rU8.arrayify)(mnemonicAesCtr.encrypt(entropy));
            const now = new Date();
            const timestamp = now.getUTCFullYear() + "-" + (0, $btS5Y.zpad)(now.getUTCMonth() + 1, 2) + "-" + (0, $btS5Y.zpad)(now.getUTCDate(), 2) + "T" + (0, $btS5Y.zpad)(now.getUTCHours(), 2) + "-" + (0, $btS5Y.zpad)(now.getUTCMinutes(), 2) + "-" + (0, $btS5Y.zpad)(now.getUTCSeconds(), 2) + ".0Z";
            data["x-ethers"] = {
                client: client,
                gethFilename: "UTC--" + timestamp + "--" + data.address,
                mnemonicCounter: (0, $j2rU8.hexlify)(mnemonicIv).substring(2),
                mnemonicCiphertext: (0, $j2rU8.hexlify)(mnemonicCiphertext).substring(2),
                path: path,
                locale: locale,
                version: "0.1"
            };
        }
        return JSON.stringify(data);
    });
}

});
parcelRegister("e9e3c", function(module, exports) {
"use strict";
(function(root) {
    const MAX_VALUE = 0x7fffffff;
    // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    // See: https://github.com/dchest/scrypt-async-js
    function SHA256(m) {
        const K = new Uint32Array([
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ]);
        let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
        let h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
        const w = new Uint32Array(64);
        function blocks(p) {
            let off = 0, len = p.length;
            while(len >= 64){
                let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u, i, j, t1, t2;
                for(i = 0; i < 16; i++){
                    j = off + i * 4;
                    w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
                }
                for(i = 16; i < 64; i++){
                    u = w[i - 2];
                    t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                    u = w[i - 15];
                    t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                    w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0) | 0;
                }
                for(i = 0; i < 64; i++){
                    t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
                    t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                h0 = h0 + a | 0;
                h1 = h1 + b | 0;
                h2 = h2 + c | 0;
                h3 = h3 + d | 0;
                h4 = h4 + e | 0;
                h5 = h5 + f | 0;
                h6 = h6 + g | 0;
                h7 = h7 + h | 0;
                off += 64;
                len -= 64;
            }
        }
        blocks(m);
        let i, bytesLeft = m.length % 64, bitLenHi = m.length / 0x20000000 | 0, bitLenLo = m.length << 3, numZeros = bytesLeft < 56 ? 56 : 120, p = m.slice(m.length - bytesLeft, m.length);
        p.push(0x80);
        for(i = bytesLeft + 1; i < numZeros; i++)p.push(0);
        p.push(bitLenHi >>> 24 & 0xff);
        p.push(bitLenHi >>> 16 & 0xff);
        p.push(bitLenHi >>> 8 & 0xff);
        p.push(bitLenHi >>> 0 & 0xff);
        p.push(bitLenLo >>> 24 & 0xff);
        p.push(bitLenLo >>> 16 & 0xff);
        p.push(bitLenLo >>> 8 & 0xff);
        p.push(bitLenLo >>> 0 & 0xff);
        blocks(p);
        return [
            h0 >>> 24 & 0xff,
            h0 >>> 16 & 0xff,
            h0 >>> 8 & 0xff,
            h0 >>> 0 & 0xff,
            h1 >>> 24 & 0xff,
            h1 >>> 16 & 0xff,
            h1 >>> 8 & 0xff,
            h1 >>> 0 & 0xff,
            h2 >>> 24 & 0xff,
            h2 >>> 16 & 0xff,
            h2 >>> 8 & 0xff,
            h2 >>> 0 & 0xff,
            h3 >>> 24 & 0xff,
            h3 >>> 16 & 0xff,
            h3 >>> 8 & 0xff,
            h3 >>> 0 & 0xff,
            h4 >>> 24 & 0xff,
            h4 >>> 16 & 0xff,
            h4 >>> 8 & 0xff,
            h4 >>> 0 & 0xff,
            h5 >>> 24 & 0xff,
            h5 >>> 16 & 0xff,
            h5 >>> 8 & 0xff,
            h5 >>> 0 & 0xff,
            h6 >>> 24 & 0xff,
            h6 >>> 16 & 0xff,
            h6 >>> 8 & 0xff,
            h6 >>> 0 & 0xff,
            h7 >>> 24 & 0xff,
            h7 >>> 16 & 0xff,
            h7 >>> 8 & 0xff,
            h7 >>> 0 & 0xff
        ];
    }
    function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
        // compress password if it's longer than hash block length
        password = password.length <= 64 ? password : SHA256(password);
        const innerLen = 64 + salt.length + 4;
        const inner = new Array(innerLen);
        const outerKey = new Array(64);
        let i;
        let dk = [];
        // inner = (password ^ ipad) || salt || counter
        for(i = 0; i < 64; i++)inner[i] = 0x36;
        for(i = 0; i < password.length; i++)inner[i] ^= password[i];
        for(i = 0; i < salt.length; i++)inner[64 + i] = salt[i];
        for(i = innerLen - 4; i < innerLen; i++)inner[i] = 0;
        // outerKey = password ^ opad
        for(i = 0; i < 64; i++)outerKey[i] = 0x5c;
        for(i = 0; i < password.length; i++)outerKey[i] ^= password[i];
        // increments counter inside inner
        function incrementCounter() {
            for(let i = innerLen - 1; i >= innerLen - 4; i--){
                inner[i]++;
                if (inner[i] <= 0xff) return;
                inner[i] = 0;
            }
        }
        // output blocks = SHA256(outerKey || SHA256(inner)) ...
        while(dkLen >= 32){
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
            dkLen -= 32;
        }
        if (dkLen > 0) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
        }
        return dk;
    }
    // The following is an adaptation of scryptsy
    // See: https://www.npmjs.com/package/scryptsy
    function blockmix_salsa8(BY, Yi, r, x, _X) {
        let i;
        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
        for(i = 0; i < 2 * r; i++){
            blockxor(BY, i * 16, _X, 16);
            salsa20_8(_X, x);
            arraycopy(_X, 0, BY, Yi + i * 16, 16);
        }
        for(i = 0; i < r; i++)arraycopy(BY, Yi + i * 32, BY, i * 16, 16);
        for(i = 0; i < r; i++)arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
    }
    function R(a, b) {
        return a << b | a >>> 32 - b;
    }
    function salsa20_8(B, x) {
        arraycopy(B, 0, x, 0, 16);
        for(let i = 8; i > 0; i -= 2){
            x[4] ^= R(x[0] + x[12], 7);
            x[8] ^= R(x[4] + x[0], 9);
            x[12] ^= R(x[8] + x[4], 13);
            x[0] ^= R(x[12] + x[8], 18);
            x[9] ^= R(x[5] + x[1], 7);
            x[13] ^= R(x[9] + x[5], 9);
            x[1] ^= R(x[13] + x[9], 13);
            x[5] ^= R(x[1] + x[13], 18);
            x[14] ^= R(x[10] + x[6], 7);
            x[2] ^= R(x[14] + x[10], 9);
            x[6] ^= R(x[2] + x[14], 13);
            x[10] ^= R(x[6] + x[2], 18);
            x[3] ^= R(x[15] + x[11], 7);
            x[7] ^= R(x[3] + x[15], 9);
            x[11] ^= R(x[7] + x[3], 13);
            x[15] ^= R(x[11] + x[7], 18);
            x[1] ^= R(x[0] + x[3], 7);
            x[2] ^= R(x[1] + x[0], 9);
            x[3] ^= R(x[2] + x[1], 13);
            x[0] ^= R(x[3] + x[2], 18);
            x[6] ^= R(x[5] + x[4], 7);
            x[7] ^= R(x[6] + x[5], 9);
            x[4] ^= R(x[7] + x[6], 13);
            x[5] ^= R(x[4] + x[7], 18);
            x[11] ^= R(x[10] + x[9], 7);
            x[8] ^= R(x[11] + x[10], 9);
            x[9] ^= R(x[8] + x[11], 13);
            x[10] ^= R(x[9] + x[8], 18);
            x[12] ^= R(x[15] + x[14], 7);
            x[13] ^= R(x[12] + x[15], 9);
            x[14] ^= R(x[13] + x[12], 13);
            x[15] ^= R(x[14] + x[13], 18);
        }
        for(let i = 0; i < 16; ++i)B[i] += x[i];
    }
    // naive approach... going back to loop unrolling may yield additional performance
    function blockxor(S, Si, D, len) {
        for(let i = 0; i < len; i++)D[i] ^= S[Si + i];
    }
    function arraycopy(src, srcPos, dest, destPos, length) {
        while(length--)dest[destPos++] = src[srcPos++];
    }
    function checkBufferish(o) {
        if (!o || typeof o.length !== "number") return false;
        for(let i = 0; i < o.length; i++){
            const v = o[i];
            if (typeof v !== "number" || v % 1 || v < 0 || v >= 256) return false;
        }
        return true;
    }
    function ensureInteger(value, name) {
        if (typeof value !== "number" || value % 1) throw new Error("invalid " + name);
        return value;
    }
    // N = Cpu cost, r = Memory cost, p = parallelization cost
    // callback(error, progress, key)
    function _scrypt(password, salt, N, r, p, dkLen, callback) {
        N = ensureInteger(N, "N");
        r = ensureInteger(r, "r");
        p = ensureInteger(p, "p");
        dkLen = ensureInteger(dkLen, "dkLen");
        if (N === 0 || (N & N - 1) !== 0) throw new Error("N must be power of 2");
        if (N > MAX_VALUE / 128 / r) throw new Error("N too large");
        if (r > MAX_VALUE / 128 / p) throw new Error("r too large");
        if (!checkBufferish(password)) throw new Error("password must be an array or buffer");
        password = Array.prototype.slice.call(password);
        if (!checkBufferish(salt)) throw new Error("salt must be an array or buffer");
        salt = Array.prototype.slice.call(salt);
        let b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
        const B = new Uint32Array(p * 32 * r);
        for(let i = 0; i < B.length; i++){
            const j = i * 4;
            B[i] = (b[j + 3] & 0xff) << 24 | (b[j + 2] & 0xff) << 16 | (b[j + 1] & 0xff) << 8 | (b[j + 0] & 0xff) << 0;
        }
        const XY = new Uint32Array(64 * r);
        const V = new Uint32Array(32 * r * N);
        const Yi = 32 * r;
        // scratch space
        const x = new Uint32Array(16); // salsa20_8
        const _X = new Uint32Array(16); // blockmix_salsa8
        const totalOps = p * N * 2;
        let currentOp = 0;
        let lastPercent10 = null;
        // Set this to true to abandon the scrypt on the next step
        let stop = false;
        // State information
        let state = 0;
        let i0 = 0, i1;
        let Bi;
        // How many blockmix_salsa8 can we do per step?
        const limit = callback ? parseInt(1000 / r) : 0xffffffff;
        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
        const nextTick = typeof setImmediate !== "undefined" ? setImmediate : setTimeout;
        // This is really all I changed; making scryptsy a state machine so we occasionally
        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
        const incrementalSMix = function() {
            if (stop) return callback(new Error("cancelled"), currentOp / totalOps);
            let steps;
            switch(state){
                case 0:
                    // for (var i = 0; i < p; i++)...
                    Bi = i0 * 32 * r;
                    arraycopy(B, Bi, XY, 0, Yi); // ROMix - 1
                    state = 1; // Move to ROMix 2
                    i1 = 0;
                // Fall through
                case 1:
                    // Run up to 1000 steps of the first inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi) // ROMix - 3
                        ;
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 4
                    }
                    // for (var i = 0; i < N; i++)
                    i1 += steps;
                    currentOp += steps;
                    if (callback) {
                        // Call the callback with the progress (optionally stopping us)
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    i1 = 0; // Move to ROMix 6
                    state = 2;
                // Fall through
                case 2:
                    // Run up to 1000 steps of the second inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        const offset = (2 * r - 1) * 16; // ROMix - 7
                        const j = XY[offset] & N - 1;
                        blockxor(V, j * Yi, XY, Yi); // ROMix - 8 (inner)
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 9 (outer)
                    }
                    // for (var i = 0; i < N; i++)...
                    i1 += steps;
                    currentOp += steps;
                    // Call the callback with the progress (optionally stopping us)
                    if (callback) {
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    arraycopy(XY, 0, B, Bi, Yi); // ROMix - 10
                    // for (var i = 0; i < p; i++)...
                    i0++;
                    if (i0 < p) {
                        state = 0;
                        break;
                    }
                    b = [];
                    for(let i = 0; i < B.length; i++){
                        b.push(B[i] >> 0 & 0xff);
                        b.push(B[i] >> 8 & 0xff);
                        b.push(B[i] >> 16 & 0xff);
                        b.push(B[i] >> 24 & 0xff);
                    }
                    const derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);
                    // Send the result to the callback
                    if (callback) callback(null, 1.0, derivedKey);
                    // Done; don't break (which would reschedule)
                    return derivedKey;
            }
            // Schedule the next steps
            if (callback) nextTick(incrementalSMix);
        };
        // Run the smix state machine until completion
        if (!callback) while(true){
            const derivedKey = incrementalSMix();
            if (derivedKey != undefined) return derivedKey;
        }
        // Bootstrap the async incremental smix
        incrementalSMix();
    }
    const lib = {
        scrypt: function(password, salt, N, r, p, dkLen, progressCallback) {
            return new Promise(function(resolve, reject) {
                let lastProgress = 0;
                if (progressCallback) progressCallback(0);
                _scrypt(password, salt, N, r, p, dkLen, function(error, progress, key) {
                    if (error) reject(error);
                    else if (key) {
                        if (progressCallback && lastProgress !== 1) progressCallback(1);
                        resolve(new Uint8Array(key));
                    } else if (progressCallback && progress !== lastProgress) {
                        lastProgress = progress;
                        return progressCallback(progress);
                    }
                });
            });
        },
        syncScrypt: function(password, salt, N, r, p, dkLen) {
            return new Uint8Array(_scrypt(password, salt, N, r, p, dkLen));
        }
    };
    // node.js
    if (typeof module.exports !== "undefined") module.exports = lib;
    else if (typeof define === "function" && define.amd) define(lib);
    else if (root) {
        // If there was an existing library "scrypt", make sure it is still available
        if (root.scrypt) root._scrypt = root.scrypt;
        root.scrypt = lib;
    }
})(module.exports);

});



parcelRegister("eIckK", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $ab5ebdfa7aaeb9e4$export$83d89fbfd8236492; });
const $ab5ebdfa7aaeb9e4$export$83d89fbfd8236492 = "wallet/5.7.0";

});


parcelRegister("gqL7R", function(module, exports) {

$parcel$export(module.exports, "_fetchData", function () { return $bf63a14489d0132f$export$e37fa27017c6c012; });
$parcel$export(module.exports, "fetchJson", function () { return $bf63a14489d0132f$export$6d71b655afe1638d; });
$parcel$export(module.exports, "poll", function () { return $bf63a14489d0132f$export$e0c10349b2c5e1d4; });

var $70PIu = parcelRequire("70PIu");

var $j2rU8 = parcelRequire("j2rU8");

var $2ax4w = parcelRequire("2ax4w");

var $1Wmc7 = parcelRequire("1Wmc7");

var $6M65e = parcelRequire("6M65e");

var $ePgwe = parcelRequire("ePgwe");

var $fPoRB = parcelRequire("fPoRB");
"use strict";
var $bf63a14489d0132f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $bf63a14489d0132f$var$logger = new (0, $6M65e.Logger)((0, $ePgwe.version));
function $bf63a14489d0132f$var$staller(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $bf63a14489d0132f$var$bodyify(value, type) {
    if (value == null) return null;
    if (typeof value === "string") return value;
    if ((0, $j2rU8.isBytesLike)(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) try {
            return (0, $1Wmc7.toUtf8String)(value);
        } catch (error) {}
        return (0, $j2rU8.hexlify)(value);
    }
    return value;
}
function $bf63a14489d0132f$var$unpercent(value) {
    return (0, $1Wmc7.toUtf8Bytes)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $bf63a14489d0132f$export$e37fa27017c6c012(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    const attemptLimit = typeof connection === "object" && connection.throttleLimit != null ? connection.throttleLimit : 12;
    $bf63a14489d0132f$var$logger.assertArgument(attemptLimit > 0 && attemptLimit % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    const throttleCallback = typeof connection === "object" ? connection.throttleCallback : null;
    const throttleSlotInterval = typeof connection === "object" && typeof connection.throttleSlotInterval === "number" ? connection.throttleSlotInterval : 100;
    $bf63a14489d0132f$var$logger.assertArgument(throttleSlotInterval > 0 && throttleSlotInterval % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    const errorPassThrough = typeof connection === "object" ? !!connection.errorPassThrough : false;
    const headers = {};
    let url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    const options = {
        method: "GET"
    };
    let allow304 = false;
    let timeout = 120000;
    if (typeof connection === "string") url = connection;
    else if (typeof connection === "object") {
        if (connection == null || connection.url == null) $bf63a14489d0132f$var$logger.throwArgumentError("missing URL", "connection.url", connection);
        url = connection.url;
        if (typeof connection.timeout === "number" && connection.timeout > 0) timeout = connection.timeout;
        if (connection.headers) for(const key in connection.headers){
            headers[key.toLowerCase()] = {
                key: key,
                value: String(connection.headers[key])
            };
            if ([
                "if-none-match",
                "if-modified-since"
            ].indexOf(key.toLowerCase()) >= 0) allow304 = true;
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) $bf63a14489d0132f$var$logger.throwError("basic authentication requires a secure https url", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                argument: "url",
                url: url,
                user: connection.user,
                password: "[REDACTED]"
            });
            const authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + (0, $70PIu.encode)((0, $1Wmc7.toUtf8Bytes)(authorization))
            };
        }
        if (connection.skipFetchSetup != null) options.skipFetchSetup = !!connection.skipFetchSetup;
        if (connection.fetchOptions != null) options.fetchOptions = (0, $2ax4w.shallowCopy)(connection.fetchOptions);
    }
    const reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
    const dataMatch = url ? url.match(reData) : null;
    if (dataMatch) try {
        const response = {
            statusCode: 200,
            statusMessage: "OK",
            headers: {
                "content-type": dataMatch[1] || "text/plain"
            },
            body: dataMatch[2] ? (0, $70PIu.decode)(dataMatch[3]) : $bf63a14489d0132f$var$unpercent(dataMatch[3])
        };
        let result = response.body;
        if (processFunc) result = processFunc(response.body, response);
        return Promise.resolve(result);
    } catch (error) {
        $bf63a14489d0132f$var$logger.throwError("processing response error", (0, $6M65e.Logger).errors.SERVER_ERROR, {
            body: $bf63a14489d0132f$var$bodyify(dataMatch[1], dataMatch[2]),
            error: error,
            requestBody: null,
            requestMethod: "GET",
            url: url
        });
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) headers["content-type"] = {
            key: "Content-Type",
            value: "application/octet-stream"
        };
        if (headers["content-length"] == null) headers["content-length"] = {
            key: "Content-Length",
            value: String(body.length)
        };
    }
    const flatHeaders = {};
    Object.keys(headers).forEach((key)=>{
        const header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    const runningTimeout = function() {
        let timer = null;
        const promise = new Promise(function(resolve, reject) {
            if (timeout) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                reject($bf63a14489d0132f$var$logger.makeError("timeout", (0, $6M65e.Logger).errors.TIMEOUT, {
                    requestBody: $bf63a14489d0132f$var$bodyify(options.body, flatHeaders["content-type"]),
                    requestMethod: options.method,
                    timeout: timeout,
                    url: url
                }));
            }, timeout);
        });
        const cancel = function() {
            if (timer == null) return;
            clearTimeout(timer);
            timer = null;
        };
        return {
            promise: promise,
            cancel: cancel
        };
    }();
    const runningFetch = function() {
        return $bf63a14489d0132f$var$__awaiter(this, void 0, void 0, function*() {
            for(let attempt = 0; attempt < attemptLimit; attempt++){
                let response = null;
                try {
                    response = yield (0, $fPoRB.getUrl)(url, options);
                    if (attempt < attemptLimit) {
                        if (response.statusCode === 301 || response.statusCode === 302) {
                            // Redirection; for now we only support absolute locataions
                            const location = response.headers.location || "";
                            if (options.method === "GET" && location.match(/^https:/)) {
                                url = response.headers.location;
                                continue;
                            }
                        } else if (response.statusCode === 429) {
                            // Exponential back-off throttling
                            let tryAgain = true;
                            if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                            if (tryAgain) {
                                let stall = 0;
                                const retryAfter = response.headers["retry-after"];
                                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) stall = parseInt(retryAfter) * 1000;
                                else stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                //console.log("Stalling 429");
                                yield $bf63a14489d0132f$var$staller(stall);
                                continue;
                            }
                        }
                    }
                } catch (error) {
                    response = error.response;
                    if (response == null) {
                        runningTimeout.cancel();
                        $bf63a14489d0132f$var$logger.throwError("missing response", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                            requestBody: $bf63a14489d0132f$var$bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            serverError: error,
                            url: url
                        });
                    }
                }
                let body = response.body;
                if (allow304 && response.statusCode === 304) body = null;
                else if (!errorPassThrough && (response.statusCode < 200 || response.statusCode >= 300)) {
                    runningTimeout.cancel();
                    $bf63a14489d0132f$var$logger.throwError("bad response", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                        status: response.statusCode,
                        headers: response.headers,
                        body: $bf63a14489d0132f$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        requestBody: $bf63a14489d0132f$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                if (processFunc) try {
                    const result = yield processFunc(body, response);
                    runningTimeout.cancel();
                    return result;
                } catch (error) {
                    // Allow the processFunc to trigger a throttle
                    if (error.throttleRetry && attempt < attemptLimit) {
                        let tryAgain = true;
                        if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                        if (tryAgain) {
                            const timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                            //console.log("Stalling callback");
                            yield $bf63a14489d0132f$var$staller(timeout);
                            continue;
                        }
                    }
                    runningTimeout.cancel();
                    $bf63a14489d0132f$var$logger.throwError("processing response error", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                        body: $bf63a14489d0132f$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        error: error,
                        requestBody: $bf63a14489d0132f$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                runningTimeout.cancel();
                // If we had a processFunc, it either returned a T or threw above.
                // The "body" is now a Uint8Array.
                return body;
            }
            return $bf63a14489d0132f$var$logger.throwError("failed response", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                requestBody: $bf63a14489d0132f$var$bodyify(options.body, flatHeaders["content-type"]),
                requestMethod: options.method,
                url: url
            });
        });
    }();
    return Promise.race([
        runningTimeout.promise,
        runningFetch
    ]);
}
function $bf63a14489d0132f$export$6d71b655afe1638d(connection, json, processFunc) {
    let processJsonFunc = (value, response)=>{
        let result = null;
        if (value != null) try {
            result = JSON.parse((0, $1Wmc7.toUtf8String)(value));
        } catch (error) {
            $bf63a14489d0132f$var$logger.throwError("invalid JSON", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                body: value,
                error: error
            });
        }
        if (processFunc) result = processFunc(result, response);
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    let body = null;
    if (json != null) {
        body = (0, $1Wmc7.toUtf8Bytes)(json);
        // Create a connection with the content-type set for JSON
        const updated = typeof connection === "string" ? {
            url: connection
        } : (0, $2ax4w.shallowCopy)(connection);
        if (updated.headers) {
            const hasContentType = Object.keys(updated.headers).filter((k)=>k.toLowerCase() === "content-type").length !== 0;
            if (!hasContentType) {
                updated.headers = (0, $2ax4w.shallowCopy)(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        } else updated.headers = {
            "content-type": "application/json"
        };
        connection = updated;
    }
    return $bf63a14489d0132f$export$e37fa27017c6c012(connection, body, processJsonFunc);
}
function $bf63a14489d0132f$export$e0c10349b2c5e1d4(func, options) {
    if (!options) options = {};
    options = (0, $2ax4w.shallowCopy)(options);
    if (options.floor == null) options.floor = 0;
    if (options.ceiling == null) options.ceiling = 10000;
    if (options.interval == null) options.interval = 250;
    return new Promise(function(resolve, reject) {
        let timer = null;
        let done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        const cancel = ()=>{
            if (done) return false;
            done = true;
            if (timer) clearTimeout(timer);
            return true;
        };
        if (options.timeout) timer = setTimeout(()=>{
            if (cancel()) reject(new Error("timeout"));
        }, options.timeout);
        const retryLimit = options.retryLimit;
        let attempt = 0;
        function check() {
            return func().then(function(result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) resolve(result);
                } else if (options.oncePoll) options.oncePoll.once("poll", check);
                else if (options.onceBlock) options.onceBlock.once("block", check);
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) reject(new Error("retry limit reached"));
                        return;
                    }
                    let timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) timeout = options.floor;
                    if (timeout > options.ceiling) timeout = options.ceiling;
                    setTimeout(check, timeout);
                }
                return null;
            }, function(error) {
                if (cancel()) reject(error);
            });
        }
        check();
    });
}

});
parcelRegister("ePgwe", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $acb2a463b6dabef3$export$83d89fbfd8236492; });
const $acb2a463b6dabef3$export$83d89fbfd8236492 = "web/5.7.1";

});

parcelRegister("fPoRB", function(module, exports) {

$parcel$export(module.exports, "getUrl", function () { return $b85ee7d721e8a835$export$94df0e59ebebf4a7; });

var $j2rU8 = parcelRequire("j2rU8");
"use strict";
var $b85ee7d721e8a835$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $b85ee7d721e8a835$export$94df0e59ebebf4a7(href, options) {
    return $b85ee7d721e8a835$var$__awaiter(this, void 0, void 0, function*() {
        if (options == null) options = {};
        const request = {
            method: options.method || "GET",
            headers: options.headers || {},
            body: options.body || undefined
        };
        if (options.skipFetchSetup !== true) {
            request.mode = "cors"; // no-cors, cors, *same-origin
            request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
            request.credentials = "same-origin"; // include, *same-origin, omit
            request.redirect = "follow"; // manual, *follow, error
            request.referrer = "client"; // no-referrer, *client
        }
        if (options.fetchOptions != null) {
            const opts = options.fetchOptions;
            if (opts.mode) request.mode = opts.mode;
            if (opts.cache) request.cache = opts.cache;
            if (opts.credentials) request.credentials = opts.credentials;
            if (opts.redirect) request.redirect = opts.redirect;
            if (opts.referrer) request.referrer = opts.referrer;
        }
        const response = yield fetch(href, request);
        const body = yield response.arrayBuffer();
        const headers = {};
        if (response.headers.forEach) response.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        else response.headers.keys().forEach((key)=>{
            headers[key.toLowerCase()] = response.headers.get(key);
        });
        return {
            headers: headers,
            statusCode: response.status,
            statusMessage: response.statusText,
            body: (0, $j2rU8.arrayify)(new Uint8Array(body))
        };
    });
}

});



parcelRegister("4nqB9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ALL_FEEDS_KEY = module.exports.DATA_FEED_ID_BS = module.exports.SIGNATURE_BS = module.exports.REDSTONE_MARKER_BS = module.exports.REDSTONE_MARKER_HEX = module.exports.UNSIGNED_METADATA_BYTE_SIZE_BS = module.exports.DATA_PACKAGES_COUNT_BS = module.exports.DEFAULT_NUM_VALUE_DECIMALS = module.exports.DEFAULT_NUM_VALUE_BS = module.exports.DATA_POINT_VALUE_BYTE_SIZE_BS = module.exports.DATA_POINTS_COUNT_BS = module.exports.TIMESTAMP_BS = void 0;
module.exports.TIMESTAMP_BS = 6;
module.exports.DATA_POINTS_COUNT_BS = 3;
module.exports.DATA_POINT_VALUE_BYTE_SIZE_BS = 4;
module.exports.DEFAULT_NUM_VALUE_BS = 32;
module.exports.DEFAULT_NUM_VALUE_DECIMALS = 8;
module.exports.DATA_PACKAGES_COUNT_BS = 2;
module.exports.UNSIGNED_METADATA_BYTE_SIZE_BS = 3;
module.exports.REDSTONE_MARKER_HEX = "0x000002ed57011e0000";
module.exports.REDSTONE_MARKER_BS = module.exports.REDSTONE_MARKER_HEX.length / 2 - 1;
module.exports.SIGNATURE_BS = 65;
module.exports.DATA_FEED_ID_BS = 32;
module.exports.ALL_FEEDS_KEY = "___ALL_FEEDS___";

});

parcelRegister("t9PVr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Serializable = void 0;
parcelRequire("blIpd");
var $3A3Dv = parcelRequire("3A3Dv");

var $1rXfw = parcelRequire("1rXfw");
class $057a56dfbc47e6aa$var$Serializable {
    toBytesHex() {
        const serializedBytes = this.toBytes();
        return $3A3Dv.utils.hexlify(serializedBytes);
    }
    toBytesHexWithout0xPrefix() {
        const serializedBytes = this.toBytes();
        return (0, $1rXfw.hexlifyWithout0xPrefix)(serializedBytes);
    }
    toJSON() {
        const serializedPlainObj = this.toObj();
        return JSON.stringify(serializedPlainObj);
    }
}
module.exports.Serializable = $057a56dfbc47e6aa$var$Serializable;

});
parcelRegister("blIpd", function(module, exports) {

$parcel$export(module.exports, "ethers", function () { return (parcelRequire("3A3Dv")); });

var $3A3Dv = parcelRequire("3A3Dv");
var $iGUqv = parcelRequire("iGUqv");
var $54wuV = parcelRequire("54wuV");
var $ldxXU = parcelRequire("ldxXU");
var $lHP19 = parcelRequire("lHP19");
var $gMArf = parcelRequire("gMArf");
var $15mVR = parcelRequire("15mVR");
var $3mObr = parcelRequire("3mObr");
var $6M65e = parcelRequire("6M65e");
var $e5s6c = parcelRequire("e5s6c");
var $1cpDB = parcelRequire("1cpDB");
var $d7X94 = parcelRequire("d7X94");
var $hj32o = parcelRequire("hj32o");
"use strict";
try {
    const anyGlobal = window;
    if (anyGlobal._ethers == null) anyGlobal._ethers = $3A3Dv;
} catch (error) {}

});
parcelRegister("3A3Dv", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $29b78df16cc81472$export$af88d00dbe7f521; });
$parcel$export(module.exports, "Signer", function () { return (parcelRequire("iGUqv")).Signer; });
$parcel$export(module.exports, "Wallet", function () { return (parcelRequire("54wuV")).Wallet; });
$parcel$export(module.exports, "VoidSigner", function () { return (parcelRequire("iGUqv")).VoidSigner; });
$parcel$export(module.exports, "getDefaultProvider", function () { return (parcelRequire("ldxXU")).getDefaultProvider; });
$parcel$export(module.exports, "providers", function () { return (parcelRequire("ldxXU")); });
$parcel$export(module.exports, "BaseContract", function () { return (parcelRequire("lHP19")).BaseContract; });
$parcel$export(module.exports, "Contract", function () { return (parcelRequire("lHP19")).Contract; });
$parcel$export(module.exports, "ContractFactory", function () { return (parcelRequire("lHP19")).ContractFactory; });
$parcel$export(module.exports, "BigNumber", function () { return (parcelRequire("gMArf")).BigNumber; });
$parcel$export(module.exports, "FixedNumber", function () { return (parcelRequire("15mVR")).FixedNumber; });
$parcel$export(module.exports, "constants", function () { return (parcelRequire("3mObr")); });
$parcel$export(module.exports, "errors", function () { return (parcelRequire("6M65e")).ErrorCode; });
$parcel$export(module.exports, "utils", function () { return (parcelRequire("e5s6c")); });
$parcel$export(module.exports, "wordlists", function () { return (parcelRequire("1cpDB")).wordlists; });
$parcel$export(module.exports, "version", function () { return (parcelRequire("d7X94")).version; });
$parcel$export(module.exports, "Wordlist", function () { return (parcelRequire("hj32o")).Wordlist; });

var $lHP19 = parcelRequire("lHP19");

var $gMArf = parcelRequire("gMArf");
var $15mVR = parcelRequire("15mVR");

var $iGUqv = parcelRequire("iGUqv");

var $54wuV = parcelRequire("54wuV");

var $3mObr = parcelRequire("3mObr");

var $ldxXU = parcelRequire("ldxXU");

var $hj32o = parcelRequire("hj32o");
var $1cpDB = parcelRequire("1cpDB");

var $e5s6c = parcelRequire("e5s6c");

var $6M65e = parcelRequire("6M65e");

var $d7X94 = parcelRequire("d7X94");
"use strict";
const $29b78df16cc81472$export$af88d00dbe7f521 = new (0, $6M65e.Logger)((0, $d7X94.version));

});
parcelRegister("lHP19", function(module, exports) {

$parcel$export(module.exports, "BaseContract", function () { return $fcd53023be51494b$export$304faa4fc17528db; });
$parcel$export(module.exports, "Contract", function () { return $fcd53023be51494b$export$8517d80acf00e19a; });
$parcel$export(module.exports, "ContractFactory", function () { return $fcd53023be51494b$export$505569a6bf584fd9; });

var $ggjPf = parcelRequire("ggjPf");
var $9rkfU = parcelRequire("9rkfU");

var $lLovk = parcelRequire("lLovk");

var $iGUqv = parcelRequire("iGUqv");

var $e8NrM = parcelRequire("e8NrM");

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $2ax4w = parcelRequire("2ax4w");

var $hDQeE = parcelRequire("hDQeE");

var $6M65e = parcelRequire("6M65e");

var $hLRMu = parcelRequire("hLRMu");
"use strict";
var $fcd53023be51494b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $fcd53023be51494b$var$logger = new (0, $6M65e.Logger)((0, $hLRMu.version));
///////////////////////////////
const $fcd53023be51494b$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    from: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true,
    customData: true,
    ccipReadEnabled: true
};
function $fcd53023be51494b$var$resolveName(resolver, nameOrPromise) {
    return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function*() {
        const name = yield nameOrPromise;
        if (typeof name !== "string") $fcd53023be51494b$var$logger.throwArgumentError("invalid address or ENS name", "name", name);
        // If it is already an address, just use it (after adding checksum)
        try {
            return (0, $e8NrM.getAddress)(name);
        } catch (error) {}
        if (!resolver) $fcd53023be51494b$var$logger.throwError("a provider or signer is needed to resolve ENS names", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "resolveName"
        });
        const address = yield resolver.resolveName(name);
        if (address == null) $fcd53023be51494b$var$logger.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
        return address;
    });
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function $fcd53023be51494b$var$resolveAddresses(resolver, value, paramType) {
    return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function*() {
        if (Array.isArray(paramType)) return yield Promise.all(paramType.map((paramType, index)=>{
            return $fcd53023be51494b$var$resolveAddresses(resolver, Array.isArray(value) ? value[index] : value[paramType.name], paramType);
        }));
        if (paramType.type === "address") return yield $fcd53023be51494b$var$resolveName(resolver, value);
        if (paramType.type === "tuple") return yield $fcd53023be51494b$var$resolveAddresses(resolver, value, paramType.components);
        if (paramType.baseType === "array") {
            if (!Array.isArray(value)) return Promise.reject($fcd53023be51494b$var$logger.makeError("invalid value for array", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                argument: "value",
                value: value
            }));
            return yield Promise.all(value.map((v)=>$fcd53023be51494b$var$resolveAddresses(resolver, v, paramType.arrayChildren)));
        }
        return value;
    });
}
function $fcd53023be51494b$var$populateTransaction(contract, fragment, args) {
    return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function*() {
        // If an extra argument is given, it is overrides
        let overrides = {};
        if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") overrides = (0, $2ax4w.shallowCopy)(args.pop());
        // Make sure the parameter count matches
        $fcd53023be51494b$var$logger.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
        // Populate "from" override (allow promises)
        if (contract.signer) {
            if (overrides.from) // Contracts with a Signer are from the Signer's frame-of-reference;
            // but we allow overriding "from" if it matches the signer
            overrides.from = (0, $2ax4w.resolveProperties)({
                override: $fcd53023be51494b$var$resolveName(contract.signer, overrides.from),
                signer: contract.signer.getAddress()
            }).then((check)=>$fcd53023be51494b$var$__awaiter(this, void 0, void 0, function*() {
                    if ((0, $e8NrM.getAddress)(check.signer) !== check.override) $fcd53023be51494b$var$logger.throwError("Contract with a Signer cannot override from", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "overrides.from"
                    });
                    return check.override;
                }));
            else overrides.from = contract.signer.getAddress();
        } else if (overrides.from) overrides.from = $fcd53023be51494b$var$resolveName(contract.provider, overrides.from);
        // Wait for all dependencies to be resolved (prefer the signer over the provider)
        const resolved = yield (0, $2ax4w.resolveProperties)({
            args: $fcd53023be51494b$var$resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
            address: contract.resolvedAddress,
            overrides: (0, $2ax4w.resolveProperties)(overrides) || {}
        });
        // The ABI coded transaction
        const data = contract.interface.encodeFunctionData(fragment, resolved.args);
        const tx = {
            data: data,
            to: resolved.address
        };
        // Resolved Overrides
        const ro = resolved.overrides;
        // Populate simple overrides
        if (ro.nonce != null) tx.nonce = (0, $gMArf.BigNumber).from(ro.nonce).toNumber();
        if (ro.gasLimit != null) tx.gasLimit = (0, $gMArf.BigNumber).from(ro.gasLimit);
        if (ro.gasPrice != null) tx.gasPrice = (0, $gMArf.BigNumber).from(ro.gasPrice);
        if (ro.maxFeePerGas != null) tx.maxFeePerGas = (0, $gMArf.BigNumber).from(ro.maxFeePerGas);
        if (ro.maxPriorityFeePerGas != null) tx.maxPriorityFeePerGas = (0, $gMArf.BigNumber).from(ro.maxPriorityFeePerGas);
        if (ro.from != null) tx.from = ro.from;
        if (ro.type != null) tx.type = ro.type;
        if (ro.accessList != null) tx.accessList = (0, $hDQeE.accessListify)(ro.accessList);
        // If there was no "gasLimit" override, but the ABI specifies a default, use it
        if (tx.gasLimit == null && fragment.gas != null) {
            // Compute the intrinsic gas cost for this transaction
            // @TODO: This is based on the yellow paper as of Petersburg; this is something
            // we may wish to parameterize in v6 as part of the Network object. Since this
            // is always a non-nil to address, we can ignore G_create, but may wish to add
            // similar logic to the ContractFactory.
            let intrinsic = 21000;
            const bytes = (0, $j2rU8.arrayify)(data);
            for(let i = 0; i < bytes.length; i++){
                intrinsic += 4;
                if (bytes[i]) intrinsic += 64;
            }
            tx.gasLimit = (0, $gMArf.BigNumber).from(fragment.gas).add(intrinsic);
        }
        // Populate "value" override
        if (ro.value) {
            const roValue = (0, $gMArf.BigNumber).from(ro.value);
            if (!roValue.isZero() && !fragment.payable) $fcd53023be51494b$var$logger.throwError("non-payable method cannot override value", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: overrides.value
            });
            tx.value = roValue;
        }
        if (ro.customData) tx.customData = (0, $2ax4w.shallowCopy)(ro.customData);
        if (ro.ccipReadEnabled) tx.ccipReadEnabled = !!ro.ccipReadEnabled;
        // Remove the overrides
        delete overrides.nonce;
        delete overrides.gasLimit;
        delete overrides.gasPrice;
        delete overrides.from;
        delete overrides.value;
        delete overrides.type;
        delete overrides.accessList;
        delete overrides.maxFeePerGas;
        delete overrides.maxPriorityFeePerGas;
        delete overrides.customData;
        delete overrides.ccipReadEnabled;
        // Make sure there are no stray overrides, which may indicate a
        // typo or using an unsupported key.
        const leftovers = Object.keys(overrides).filter((key)=>overrides[key] != null);
        if (leftovers.length) $fcd53023be51494b$var$logger.throwError(`cannot override ${leftovers.map((l)=>JSON.stringify(l)).join(",")}`, (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "overrides",
            overrides: leftovers
        });
        return tx;
    });
}
function $fcd53023be51494b$var$buildPopulate(contract, fragment) {
    return function(...args) {
        return $fcd53023be51494b$var$populateTransaction(contract, fragment, args);
    };
}
function $fcd53023be51494b$var$buildEstimate(contract, fragment) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function*() {
            if (!signerOrProvider) $fcd53023be51494b$var$logger.throwError("estimate require a provider or signer", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "estimateGas"
            });
            const tx = yield $fcd53023be51494b$var$populateTransaction(contract, fragment, args);
            return yield signerOrProvider.estimateGas(tx);
        });
    };
}
function $fcd53023be51494b$var$addContractWait(contract, tx) {
    const wait = tx.wait.bind(tx);
    tx.wait = (confirmations)=>{
        return wait(confirmations).then((receipt)=>{
            receipt.events = receipt.logs.map((log)=>{
                let event = (0, $2ax4w.deepCopy)(log);
                let parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                } catch (e) {}
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = (data, topics)=>{
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = ()=>{
                    return contract.provider;
                };
                event.getBlock = ()=>{
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = ()=>{
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = ()=>{
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
}
function $fcd53023be51494b$var$buildCall(contract, fragment, collapseSimple) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function*() {
            // Extract the "blockTag" override if present
            let blockTag = undefined;
            if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") {
                const overrides = (0, $2ax4w.shallowCopy)(args.pop());
                if (overrides.blockTag != null) blockTag = yield overrides.blockTag;
                delete overrides.blockTag;
                args.push(overrides);
            }
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed(blockTag);
            // Call a node and get the result
            const tx = yield $fcd53023be51494b$var$populateTransaction(contract, fragment, args);
            const result = yield signerOrProvider.call(tx, blockTag);
            try {
                let value = contract.interface.decodeFunctionResult(fragment, result);
                if (collapseSimple && fragment.outputs.length === 1) value = value[0];
                return value;
            } catch (error) {
                if (error.code === (0, $6M65e.Logger).errors.CALL_EXCEPTION) {
                    error.address = contract.address;
                    error.args = args;
                    error.transaction = tx;
                }
                throw error;
            }
        });
    };
}
function $fcd53023be51494b$var$buildSend(contract, fragment) {
    return function(...args) {
        return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function*() {
            if (!contract.signer) $fcd53023be51494b$var$logger.throwError("sending a transaction requires a signer", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "sendTransaction"
            });
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed();
            const txRequest = yield $fcd53023be51494b$var$populateTransaction(contract, fragment, args);
            const tx = yield contract.signer.sendTransaction(txRequest);
            // Tweak the tx.wait so the receipt has extra properties
            $fcd53023be51494b$var$addContractWait(contract, tx);
            return tx;
        });
    };
}
function $fcd53023be51494b$var$buildDefault(contract, fragment, collapseSimple) {
    if (fragment.constant) return $fcd53023be51494b$var$buildCall(contract, fragment, collapseSimple);
    return $fcd53023be51494b$var$buildSend(contract, fragment);
}
function $fcd53023be51494b$var$getEventTag(filter) {
    if (filter.address && (filter.topics == null || filter.topics.length === 0)) return "*";
    return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map((topic)=>{
        if (Array.isArray(topic)) return topic.join("|");
        return topic;
    }).join(":") : "");
}
class $fcd53023be51494b$var$RunningEvent {
    addListener(listener, once) {
        this._listeners.push({
            listener: listener,
            once: once
        });
    }
    removeListener(listener) {
        let done = false;
        this._listeners = this._listeners.filter((item)=>{
            if (done || item.listener !== listener) return true;
            done = true;
            return false;
        });
    }
    removeAllListeners() {
        this._listeners = [];
    }
    listeners() {
        return this._listeners.map((i)=>i.listener);
    }
    listenerCount() {
        return this._listeners.length;
    }
    run(args) {
        const listenerCount = this.listenerCount();
        this._listeners = this._listeners.filter((item)=>{
            const argsCopy = args.slice();
            // Call the callback in the next event loop
            setTimeout(()=>{
                item.listener.apply(this, argsCopy);
            }, 0);
            // Reschedule it if it not "once"
            return !item.once;
        });
        return listenerCount;
    }
    prepareEvent(event) {}
    // Returns the array that will be applied to an emit
    getEmit(event) {
        return [
            event
        ];
    }
    constructor(tag, filter){
        (0, $2ax4w.defineReadOnly)(this, "tag", tag);
        (0, $2ax4w.defineReadOnly)(this, "filter", filter);
        this._listeners = [];
    }
}
class $fcd53023be51494b$var$ErrorRunningEvent extends $fcd53023be51494b$var$RunningEvent {
    constructor(){
        super("error", null);
    }
}
// @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
class $fcd53023be51494b$var$FragmentRunningEvent extends $fcd53023be51494b$var$RunningEvent {
    prepareEvent(event) {
        super.prepareEvent(event);
        event.event = this.fragment.name;
        event.eventSignature = this.fragment.format();
        event.decode = (data, topics)=>{
            return this.interface.decodeEventLog(this.fragment, data, topics);
        };
        try {
            event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
        } catch (error) {
            event.args = null;
            event.decodeError = error;
        }
    }
    getEmit(event) {
        const errors = (0, $ggjPf.checkResultErrors)(event.args);
        if (errors.length) throw errors[0].error;
        const args = (event.args || []).slice();
        args.push(event);
        return args;
    }
    constructor(address, contractInterface, fragment, topics){
        const filter = {
            address: address
        };
        let topic = contractInterface.getEventTopic(fragment);
        if (topics) {
            if (topic !== topics[0]) $fcd53023be51494b$var$logger.throwArgumentError("topic mismatch", "topics", topics);
            filter.topics = topics.slice();
        } else filter.topics = [
            topic
        ];
        super($fcd53023be51494b$var$getEventTag(filter), filter);
        (0, $2ax4w.defineReadOnly)(this, "address", address);
        (0, $2ax4w.defineReadOnly)(this, "interface", contractInterface);
        (0, $2ax4w.defineReadOnly)(this, "fragment", fragment);
    }
}
// A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
class $fcd53023be51494b$var$WildcardRunningEvent extends $fcd53023be51494b$var$RunningEvent {
    prepareEvent(event) {
        super.prepareEvent(event);
        try {
            const parsed = this.interface.parseLog(event);
            event.event = parsed.name;
            event.eventSignature = parsed.signature;
            event.decode = (data, topics)=>{
                return this.interface.decodeEventLog(parsed.eventFragment, data, topics);
            };
            event.args = parsed.args;
        } catch (error) {
        // No matching event
        }
    }
    constructor(address, contractInterface){
        super("*", {
            address: address
        });
        (0, $2ax4w.defineReadOnly)(this, "address", address);
        (0, $2ax4w.defineReadOnly)(this, "interface", contractInterface);
    }
}
class $fcd53023be51494b$export$304faa4fc17528db {
    static getContractAddress(transaction) {
        return (0, $e8NrM.getContractAddress)(transaction);
    }
    static getInterface(contractInterface) {
        if ((0, $9rkfU.Interface).isInterface(contractInterface)) return contractInterface;
        return new (0, $9rkfU.Interface)(contractInterface);
    }
    // @TODO: Allow timeout?
    deployed() {
        return this._deployed();
    }
    _deployed(blockTag) {
        if (!this._deployedPromise) {
            // If we were just deployed, we know the transaction we should occur in
            if (this.deployTransaction) this._deployedPromise = this.deployTransaction.wait().then(()=>{
                return this;
            });
            else // @TODO: Once we allow a timeout to be passed in, we will wait
            // up to that many blocks for getCode
            // Otherwise, poll for our code to be deployed
            this._deployedPromise = this.provider.getCode(this.address, blockTag).then((code)=>{
                if (code === "0x") $fcd53023be51494b$var$logger.throwError("contract not deployed", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                    contractAddress: this.address,
                    operation: "getDeployed"
                });
                return this;
            });
        }
        return this._deployedPromise;
    }
    // @TODO:
    // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
    // @TODO:
    // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
    fallback(overrides) {
        if (!this.signer) $fcd53023be51494b$var$logger.throwError("sending a transactions require a signer", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "sendTransaction(fallback)"
        });
        const tx = (0, $2ax4w.shallowCopy)(overrides || {});
        [
            "from",
            "to"
        ].forEach(function(key) {
            if (tx[key] == null) return;
            $fcd53023be51494b$var$logger.throwError("cannot override " + key, (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        tx.to = this.resolvedAddress;
        return this.deployed().then(()=>{
            return this.signer.sendTransaction(tx);
        });
    }
    // Reconnect to a different signer or provider
    connect(signerOrProvider) {
        if (typeof signerOrProvider === "string") signerOrProvider = new (0, $iGUqv.VoidSigner)(signerOrProvider, this.provider);
        const contract = new this.constructor(this.address, this.interface, signerOrProvider);
        if (this.deployTransaction) (0, $2ax4w.defineReadOnly)(contract, "deployTransaction", this.deployTransaction);
        return contract;
    }
    // Re-attach to a different on-chain instance of this contract
    attach(addressOrName) {
        return new this.constructor(addressOrName, this.interface, this.signer || this.provider);
    }
    static isIndexed(value) {
        return (0, $9rkfU.Indexed).isIndexed(value);
    }
    _normalizeRunningEvent(runningEvent) {
        // Already have an instance of this event running; we can re-use it
        if (this._runningEvents[runningEvent.tag]) return this._runningEvents[runningEvent.tag];
        return runningEvent;
    }
    _getRunningEvent(eventName) {
        if (typeof eventName === "string") {
            // Listen for "error" events (if your contract has an error event, include
            // the full signature to bypass this special event keyword)
            if (eventName === "error") return this._normalizeRunningEvent(new $fcd53023be51494b$var$ErrorRunningEvent());
            // Listen for any event that is registered
            if (eventName === "event") return this._normalizeRunningEvent(new $fcd53023be51494b$var$RunningEvent("event", null));
            // Listen for any event
            if (eventName === "*") return this._normalizeRunningEvent(new $fcd53023be51494b$var$WildcardRunningEvent(this.address, this.interface));
            // Get the event Fragment (throws if ambiguous/unknown event)
            const fragment = this.interface.getEvent(eventName);
            return this._normalizeRunningEvent(new $fcd53023be51494b$var$FragmentRunningEvent(this.address, this.interface, fragment));
        }
        // We have topics to filter by...
        if (eventName.topics && eventName.topics.length > 0) {
            // Is it a known topichash? (throws if no matching topichash)
            try {
                const topic = eventName.topics[0];
                if (typeof topic !== "string") throw new Error("invalid topic"); // @TODO: May happen for anonymous events
                const fragment = this.interface.getEvent(topic);
                return this._normalizeRunningEvent(new $fcd53023be51494b$var$FragmentRunningEvent(this.address, this.interface, fragment, eventName.topics));
            } catch (error) {}
            // Filter by the unknown topichash
            const filter = {
                address: this.address,
                topics: eventName.topics
            };
            return this._normalizeRunningEvent(new $fcd53023be51494b$var$RunningEvent($fcd53023be51494b$var$getEventTag(filter), filter));
        }
        return this._normalizeRunningEvent(new $fcd53023be51494b$var$WildcardRunningEvent(this.address, this.interface));
    }
    _checkRunningEvents(runningEvent) {
        if (runningEvent.listenerCount() === 0) {
            delete this._runningEvents[runningEvent.tag];
            // If we have a poller for this, remove it
            const emit = this._wrappedEmits[runningEvent.tag];
            if (emit && runningEvent.filter) {
                this.provider.off(runningEvent.filter, emit);
                delete this._wrappedEmits[runningEvent.tag];
            }
        }
    }
    // Subclasses can override this to gracefully recover
    // from parse errors if they wish
    _wrapEvent(runningEvent, log, listener) {
        const event = (0, $2ax4w.deepCopy)(log);
        event.removeListener = ()=>{
            if (!listener) return;
            runningEvent.removeListener(listener);
            this._checkRunningEvents(runningEvent);
        };
        event.getBlock = ()=>{
            return this.provider.getBlock(log.blockHash);
        };
        event.getTransaction = ()=>{
            return this.provider.getTransaction(log.transactionHash);
        };
        event.getTransactionReceipt = ()=>{
            return this.provider.getTransactionReceipt(log.transactionHash);
        };
        // This may throw if the topics and data mismatch the signature
        runningEvent.prepareEvent(event);
        return event;
    }
    _addEventListener(runningEvent, listener, once) {
        if (!this.provider) $fcd53023be51494b$var$logger.throwError("events require a provider or a signer with a provider", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "once"
        });
        runningEvent.addListener(listener, once);
        // Track this running event and its listeners (may already be there; but no hard in updating)
        this._runningEvents[runningEvent.tag] = runningEvent;
        // If we are not polling the provider, start polling
        if (!this._wrappedEmits[runningEvent.tag]) {
            const wrappedEmit = (log)=>{
                let event = this._wrapEvent(runningEvent, log, listener);
                // Try to emit the result for the parameterized event...
                if (event.decodeError == null) try {
                    const args = runningEvent.getEmit(event);
                    this.emit(runningEvent.filter, ...args);
                } catch (error) {
                    event.decodeError = error.error;
                }
                // Always emit "event" for fragment-base events
                if (runningEvent.filter != null) this.emit("event", event);
                // Emit "error" if there was an error
                if (event.decodeError != null) this.emit("error", event.decodeError, event);
            };
            this._wrappedEmits[runningEvent.tag] = wrappedEmit;
            // Special events, like "error" do not have a filter
            if (runningEvent.filter != null) this.provider.on(runningEvent.filter, wrappedEmit);
        }
    }
    queryFilter(event, fromBlockOrBlockhash, toBlock) {
        const runningEvent = this._getRunningEvent(event);
        const filter = (0, $2ax4w.shallowCopy)(runningEvent.filter);
        if (typeof fromBlockOrBlockhash === "string" && (0, $j2rU8.isHexString)(fromBlockOrBlockhash, 32)) {
            if (toBlock != null) $fcd53023be51494b$var$logger.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
            filter.blockHash = fromBlockOrBlockhash;
        } else {
            filter.fromBlock = fromBlockOrBlockhash != null ? fromBlockOrBlockhash : 0;
            filter.toBlock = toBlock != null ? toBlock : "latest";
        }
        return this.provider.getLogs(filter).then((logs)=>{
            return logs.map((log)=>this._wrapEvent(runningEvent, log, null));
        });
    }
    on(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, false);
        return this;
    }
    once(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, true);
        return this;
    }
    emit(eventName, ...args) {
        if (!this.provider) return false;
        const runningEvent = this._getRunningEvent(eventName);
        const result = runningEvent.run(args) > 0;
        // May have drained all the "once" events; check for living events
        this._checkRunningEvents(runningEvent);
        return result;
    }
    listenerCount(eventName) {
        if (!this.provider) return 0;
        if (eventName == null) return Object.keys(this._runningEvents).reduce((accum, key)=>{
            return accum + this._runningEvents[key].listenerCount();
        }, 0);
        return this._getRunningEvent(eventName).listenerCount();
    }
    listeners(eventName) {
        if (!this.provider) return [];
        if (eventName == null) {
            const result = [];
            for(let tag in this._runningEvents)this._runningEvents[tag].listeners().forEach((listener)=>{
                result.push(listener);
            });
            return result;
        }
        return this._getRunningEvent(eventName).listeners();
    }
    removeAllListeners(eventName) {
        if (!this.provider) return this;
        if (eventName == null) {
            for(const tag in this._runningEvents){
                const runningEvent = this._runningEvents[tag];
                runningEvent.removeAllListeners();
                this._checkRunningEvents(runningEvent);
            }
            return this;
        }
        // Delete any listeners
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeAllListeners();
        this._checkRunningEvents(runningEvent);
        return this;
    }
    off(eventName, listener) {
        if (!this.provider) return this;
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeListener(listener);
        this._checkRunningEvents(runningEvent);
        return this;
    }
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    constructor(addressOrName, contractInterface, signerOrProvider){
        // @TODO: Maybe still check the addressOrName looks like a valid address or name?
        //address = getAddress(address);
        (0, $2ax4w.defineReadOnly)(this, "interface", (0, $2ax4w.getStatic)(new.target, "getInterface")(contractInterface));
        if (signerOrProvider == null) {
            (0, $2ax4w.defineReadOnly)(this, "provider", null);
            (0, $2ax4w.defineReadOnly)(this, "signer", null);
        } else if ((0, $iGUqv.Signer).isSigner(signerOrProvider)) {
            (0, $2ax4w.defineReadOnly)(this, "provider", signerOrProvider.provider || null);
            (0, $2ax4w.defineReadOnly)(this, "signer", signerOrProvider);
        } else if ((0, $lLovk.Provider).isProvider(signerOrProvider)) {
            (0, $2ax4w.defineReadOnly)(this, "provider", signerOrProvider);
            (0, $2ax4w.defineReadOnly)(this, "signer", null);
        } else $fcd53023be51494b$var$logger.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
        (0, $2ax4w.defineReadOnly)(this, "callStatic", {});
        (0, $2ax4w.defineReadOnly)(this, "estimateGas", {});
        (0, $2ax4w.defineReadOnly)(this, "functions", {});
        (0, $2ax4w.defineReadOnly)(this, "populateTransaction", {});
        (0, $2ax4w.defineReadOnly)(this, "filters", {});
        {
            const uniqueFilters = {};
            Object.keys(this.interface.events).forEach((eventSignature)=>{
                const event = this.interface.events[eventSignature];
                (0, $2ax4w.defineReadOnly)(this.filters, eventSignature, (...args)=>{
                    return {
                        address: this.address,
                        topics: this.interface.encodeFilterTopics(event, args)
                    };
                });
                if (!uniqueFilters[event.name]) uniqueFilters[event.name] = [];
                uniqueFilters[event.name].push(eventSignature);
            });
            Object.keys(uniqueFilters).forEach((name)=>{
                const filters = uniqueFilters[name];
                if (filters.length === 1) (0, $2ax4w.defineReadOnly)(this.filters, name, this.filters[filters[0]]);
                else $fcd53023be51494b$var$logger.warn(`Duplicate definition of ${name} (${filters.join(", ")})`);
            });
        }
        (0, $2ax4w.defineReadOnly)(this, "_runningEvents", {});
        (0, $2ax4w.defineReadOnly)(this, "_wrappedEmits", {});
        if (addressOrName == null) $fcd53023be51494b$var$logger.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
        (0, $2ax4w.defineReadOnly)(this, "address", addressOrName);
        if (this.provider) (0, $2ax4w.defineReadOnly)(this, "resolvedAddress", $fcd53023be51494b$var$resolveName(this.provider, addressOrName));
        else try {
            (0, $2ax4w.defineReadOnly)(this, "resolvedAddress", Promise.resolve((0, $e8NrM.getAddress)(addressOrName)));
        } catch (error) {
            // Without a provider, we cannot use ENS names
            $fcd53023be51494b$var$logger.throwError("provider is required to use ENS name as contract address", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "new Contract"
            });
        }
        // Swallow bad ENS names to prevent Unhandled Exceptions
        this.resolvedAddress.catch((e)=>{});
        const uniqueNames = {};
        const uniqueSignatures = {};
        Object.keys(this.interface.functions).forEach((signature)=>{
            const fragment = this.interface.functions[signature];
            // Check that the signature is unique; if not the ABI generation has
            // not been cleaned or may be incorrectly generated
            if (uniqueSignatures[signature]) {
                $fcd53023be51494b$var$logger.warn(`Duplicate ABI entry for ${JSON.stringify(signature)}`);
                return;
            }
            uniqueSignatures[signature] = true;
            // Track unique names; we only expose bare named functions if they
            // are ambiguous
            {
                const name = fragment.name;
                if (!uniqueNames[`%${name}`]) uniqueNames[`%${name}`] = [];
                uniqueNames[`%${name}`].push(signature);
            }
            if (this[signature] == null) (0, $2ax4w.defineReadOnly)(this, signature, $fcd53023be51494b$var$buildDefault(this, fragment, true));
            // We do not collapse simple calls on this bucket, which allows
            // frameworks to safely use this without introspection as well as
            // allows decoding error recovery.
            if (this.functions[signature] == null) (0, $2ax4w.defineReadOnly)(this.functions, signature, $fcd53023be51494b$var$buildDefault(this, fragment, false));
            if (this.callStatic[signature] == null) (0, $2ax4w.defineReadOnly)(this.callStatic, signature, $fcd53023be51494b$var$buildCall(this, fragment, true));
            if (this.populateTransaction[signature] == null) (0, $2ax4w.defineReadOnly)(this.populateTransaction, signature, $fcd53023be51494b$var$buildPopulate(this, fragment));
            if (this.estimateGas[signature] == null) (0, $2ax4w.defineReadOnly)(this.estimateGas, signature, $fcd53023be51494b$var$buildEstimate(this, fragment));
        });
        Object.keys(uniqueNames).forEach((name)=>{
            // Ambiguous names to not get attached as bare names
            const signatures = uniqueNames[name];
            if (signatures.length > 1) return;
            // Strip off the leading "%" used for prototype protection
            name = name.substring(1);
            const signature = signatures[0];
            // If overwriting a member property that is null, swallow the error
            try {
                if (this[name] == null) (0, $2ax4w.defineReadOnly)(this, name, this[signature]);
            } catch (e) {}
            if (this.functions[name] == null) (0, $2ax4w.defineReadOnly)(this.functions, name, this.functions[signature]);
            if (this.callStatic[name] == null) (0, $2ax4w.defineReadOnly)(this.callStatic, name, this.callStatic[signature]);
            if (this.populateTransaction[name] == null) (0, $2ax4w.defineReadOnly)(this.populateTransaction, name, this.populateTransaction[signature]);
            if (this.estimateGas[name] == null) (0, $2ax4w.defineReadOnly)(this.estimateGas, name, this.estimateGas[signature]);
        });
    }
}
class $fcd53023be51494b$export$8517d80acf00e19a extends $fcd53023be51494b$export$304faa4fc17528db {
}
class $fcd53023be51494b$export$505569a6bf584fd9 {
    // @TODO: Future; rename to populateTransaction?
    getDeployTransaction(...args) {
        let tx = {};
        // If we have 1 additional argument, we allow transaction overrides
        if (args.length === this.interface.deploy.inputs.length + 1 && typeof args[args.length - 1] === "object") {
            tx = (0, $2ax4w.shallowCopy)(args.pop());
            for(const key in tx){
                if (!$fcd53023be51494b$var$allowedTransactionKeys[key]) throw new Error("unknown transaction override " + key);
            }
        }
        // Do not allow these to be overridden in a deployment transaction
        [
            "data",
            "from",
            "to"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            $fcd53023be51494b$var$logger.throwError("cannot override " + key, (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        if (tx.value) {
            const value = (0, $gMArf.BigNumber).from(tx.value);
            if (!value.isZero() && !this.interface.deploy.payable) $fcd53023be51494b$var$logger.throwError("non-payable constructor cannot override value", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: tx.value
            });
        }
        // Make sure the call matches the constructor signature
        $fcd53023be51494b$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
        // Set the data to the bytecode + the encoded constructor arguments
        tx.data = (0, $j2rU8.hexlify)((0, $j2rU8.concat)([
            this.bytecode,
            this.interface.encodeDeploy(args)
        ]));
        return tx;
    }
    deploy(...args) {
        return $fcd53023be51494b$var$__awaiter(this, void 0, void 0, function*() {
            let overrides = {};
            // If 1 extra parameter was passed in, it contains overrides
            if (args.length === this.interface.deploy.inputs.length + 1) overrides = args.pop();
            // Make sure the call matches the constructor signature
            $fcd53023be51494b$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
            // Resolve ENS names and promises in the arguments
            const params = yield $fcd53023be51494b$var$resolveAddresses(this.signer, args, this.interface.deploy.inputs);
            params.push(overrides);
            // Get the deployment transaction (with optional overrides)
            const unsignedTx = this.getDeployTransaction(...params);
            // Send the deployment transaction
            const tx = yield this.signer.sendTransaction(unsignedTx);
            const address = (0, $2ax4w.getStatic)(this.constructor, "getContractAddress")(tx);
            const contract = (0, $2ax4w.getStatic)(this.constructor, "getContract")(address, this.interface, this.signer);
            // Add the modified wait that wraps events
            $fcd53023be51494b$var$addContractWait(contract, tx);
            (0, $2ax4w.defineReadOnly)(contract, "deployTransaction", tx);
            return contract;
        });
    }
    attach(address) {
        return this.constructor.getContract(address, this.interface, this.signer);
    }
    connect(signer) {
        return new this.constructor(this.interface, this.bytecode, signer);
    }
    static fromSolidity(compilerOutput, signer) {
        if (compilerOutput == null) $fcd53023be51494b$var$logger.throwError("missing compiler output", (0, $6M65e.Logger).errors.MISSING_ARGUMENT, {
            argument: "compilerOutput"
        });
        if (typeof compilerOutput === "string") compilerOutput = JSON.parse(compilerOutput);
        const abi = compilerOutput.abi;
        let bytecode = null;
        if (compilerOutput.bytecode) bytecode = compilerOutput.bytecode;
        else if (compilerOutput.evm && compilerOutput.evm.bytecode) bytecode = compilerOutput.evm.bytecode;
        return new this(abi, bytecode, signer);
    }
    static getInterface(contractInterface) {
        return $fcd53023be51494b$export$8517d80acf00e19a.getInterface(contractInterface);
    }
    static getContractAddress(tx) {
        return (0, $e8NrM.getContractAddress)(tx);
    }
    static getContract(address, contractInterface, signer) {
        return new $fcd53023be51494b$export$8517d80acf00e19a(address, contractInterface, signer);
    }
    constructor(contractInterface, bytecode, signer){
        let bytecodeHex = null;
        if (typeof bytecode === "string") bytecodeHex = bytecode;
        else if ((0, $j2rU8.isBytes)(bytecode)) bytecodeHex = (0, $j2rU8.hexlify)(bytecode);
        else if (bytecode && typeof bytecode.object === "string") // Allow the bytecode object from the Solidity compiler
        bytecodeHex = bytecode.object;
        else // Crash in the next verification step
        bytecodeHex = "!";
        // Make sure it is 0x prefixed
        if (bytecodeHex.substring(0, 2) !== "0x") bytecodeHex = "0x" + bytecodeHex;
        // Make sure the final result is valid bytecode
        if (!(0, $j2rU8.isHexString)(bytecodeHex) || bytecodeHex.length % 2) $fcd53023be51494b$var$logger.throwArgumentError("invalid bytecode", "bytecode", bytecode);
        // If we have a signer, make sure it is valid
        if (signer && !(0, $iGUqv.Signer).isSigner(signer)) $fcd53023be51494b$var$logger.throwArgumentError("invalid signer", "signer", signer);
        (0, $2ax4w.defineReadOnly)(this, "bytecode", bytecodeHex);
        (0, $2ax4w.defineReadOnly)(this, "interface", (0, $2ax4w.getStatic)(new.target, "getInterface")(contractInterface));
        (0, $2ax4w.defineReadOnly)(this, "signer", signer || null);
    }
}

});
parcelRegister("hLRMu", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $cf008b3f8bbab545$export$83d89fbfd8236492; });
const $cf008b3f8bbab545$export$83d89fbfd8236492 = "contracts/5.7.0";

});


parcelRegister("3mObr", function(module, exports) {

$parcel$export(module.exports, "AddressZero", function () { return (parcelRequire("5f6Sj")).AddressZero; });
$parcel$export(module.exports, "NegativeOne", function () { return (parcelRequire("f2VSc")).NegativeOne; });
$parcel$export(module.exports, "Zero", function () { return (parcelRequire("f2VSc")).Zero; });
$parcel$export(module.exports, "One", function () { return (parcelRequire("f2VSc")).One; });
$parcel$export(module.exports, "Two", function () { return (parcelRequire("f2VSc")).Two; });
$parcel$export(module.exports, "WeiPerEther", function () { return (parcelRequire("f2VSc")).WeiPerEther; });
$parcel$export(module.exports, "MaxUint256", function () { return (parcelRequire("f2VSc")).MaxUint256; });
$parcel$export(module.exports, "MinInt256", function () { return (parcelRequire("f2VSc")).MinInt256; });
$parcel$export(module.exports, "MaxInt256", function () { return (parcelRequire("f2VSc")).MaxInt256; });
$parcel$export(module.exports, "HashZero", function () { return (parcelRequire("5OvKP")).HashZero; });
$parcel$export(module.exports, "EtherSymbol", function () { return (parcelRequire("kvJKj")).EtherSymbol; });

var $5f6Sj = parcelRequire("5f6Sj");

var $f2VSc = parcelRequire("f2VSc");

var $5OvKP = parcelRequire("5OvKP");

var $kvJKj = parcelRequire("kvJKj");
"use strict";

});
parcelRegister("5f6Sj", function(module, exports) {

$parcel$export(module.exports, "AddressZero", function () { return $3d13afb7ba7a6bb7$export$badd13187c087617; });
const $3d13afb7ba7a6bb7$export$badd13187c087617 = "0x0000000000000000000000000000000000000000";

});

parcelRegister("kvJKj", function(module, exports) {

$parcel$export(module.exports, "EtherSymbol", function () { return $eeea301a94b49b51$export$c7e79fcb6f8ac048; });
// NFKC (composed)             // (decomposed)
const $eeea301a94b49b51$export$c7e79fcb6f8ac048 = "\u039E"; // "\uD835\uDF63";

});


parcelRegister("ldxXU", function(module, exports) {

$parcel$export(module.exports, "getDefaultProvider", function () { return $f72528ab54eeaef8$export$4f77a1d3c1ac6642; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("lLovk")).Provider; });
$parcel$export(module.exports, "BaseProvider", function () { return (parcelRequire("96Por")).BaseProvider; });
$parcel$export(module.exports, "Resolver", function () { return (parcelRequire("96Por")).Resolver; });
$parcel$export(module.exports, "UrlJsonRpcProvider", function () { return (parcelRequire("jLiNX")).UrlJsonRpcProvider; });
$parcel$export(module.exports, "FallbackProvider", function () { return (parcelRequire("h5Sdm")).FallbackProvider; });
$parcel$export(module.exports, "AlchemyProvider", function () { return (parcelRequire("d8HAg")).AlchemyProvider; });
$parcel$export(module.exports, "AlchemyWebSocketProvider", function () { return (parcelRequire("d8HAg")).AlchemyWebSocketProvider; });
$parcel$export(module.exports, "AnkrProvider", function () { return (parcelRequire("4xYP9")).AnkrProvider; });
$parcel$export(module.exports, "CloudflareProvider", function () { return (parcelRequire("cHe68")).CloudflareProvider; });
$parcel$export(module.exports, "EtherscanProvider", function () { return (parcelRequire("8c6ML")).EtherscanProvider; });
$parcel$export(module.exports, "InfuraProvider", function () { return (parcelRequire("eGbhc")).InfuraProvider; });
$parcel$export(module.exports, "InfuraWebSocketProvider", function () { return (parcelRequire("eGbhc")).InfuraWebSocketProvider; });
$parcel$export(module.exports, "JsonRpcProvider", function () { return (parcelRequire("aDPpa")).JsonRpcProvider; });
$parcel$export(module.exports, "JsonRpcBatchProvider", function () { return (parcelRequire("fcnNv")).JsonRpcBatchProvider; });
$parcel$export(module.exports, "NodesmithProvider", function () { return (parcelRequire("7bZQB")).NodesmithProvider; });
$parcel$export(module.exports, "PocketProvider", function () { return (parcelRequire("lc6pB")).PocketProvider; });
$parcel$export(module.exports, "StaticJsonRpcProvider", function () { return (parcelRequire("jLiNX")).StaticJsonRpcProvider; });
$parcel$export(module.exports, "Web3Provider", function () { return (parcelRequire("lh9ZS")).Web3Provider; });
$parcel$export(module.exports, "WebSocketProvider", function () { return (parcelRequire("dCAfX")).WebSocketProvider; });
$parcel$export(module.exports, "IpcProvider", function () { return (parcelRequire("9FSRo")).IpcProvider; });
$parcel$export(module.exports, "JsonRpcSigner", function () { return (parcelRequire("aDPpa")).JsonRpcSigner; });
$parcel$export(module.exports, "getNetwork", function () { return (parcelRequire("1TEfp")).getNetwork; });
$parcel$export(module.exports, "isCommunityResource", function () { return (parcelRequire("f1MgE")).isCommunityResource; });
$parcel$export(module.exports, "isCommunityResourcable", function () { return (parcelRequire("f1MgE")).isCommunityResourcable; });
$parcel$export(module.exports, "showThrottleMessage", function () { return (parcelRequire("f1MgE")).showThrottleMessage; });
$parcel$export(module.exports, "Formatter", function () { return (parcelRequire("f1MgE")).Formatter; });

var $lLovk = parcelRequire("lLovk");

var $1TEfp = parcelRequire("1TEfp");

var $96Por = parcelRequire("96Por");

var $d8HAg = parcelRequire("d8HAg");

var $4xYP9 = parcelRequire("4xYP9");

var $cHe68 = parcelRequire("cHe68");

var $8c6ML = parcelRequire("8c6ML");

var $h5Sdm = parcelRequire("h5Sdm");

var $9FSRo = parcelRequire("9FSRo");

var $eGbhc = parcelRequire("eGbhc");

var $aDPpa = parcelRequire("aDPpa");

var $fcnNv = parcelRequire("fcnNv");

var $7bZQB = parcelRequire("7bZQB");

var $lc6pB = parcelRequire("lc6pB");

var $jLiNX = parcelRequire("jLiNX");

var $lh9ZS = parcelRequire("lh9ZS");

var $dCAfX = parcelRequire("dCAfX");

var $f1MgE = parcelRequire("f1MgE");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");
"use strict";
const $f72528ab54eeaef8$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
////////////////////////
// Helper Functions
function $f72528ab54eeaef8$export$4f77a1d3c1ac6642(network, options) {
    if (network == null) network = "homestead";
    // If passed a URL, figure out the right type of provider based on the scheme
    if (typeof network === "string") {
        // @TODO: Add support for IpcProvider; maybe if it ends in ".ipc"?
        // Handle http and ws (and their secure variants)
        const match = network.match(/^(ws|http)s?:/i);
        if (match) switch(match[1].toLowerCase()){
            case "http":
            case "https":
                return new (0, $aDPpa.JsonRpcProvider)(network);
            case "ws":
            case "wss":
                return new (0, $dCAfX.WebSocketProvider)(network);
            default:
                $f72528ab54eeaef8$var$logger.throwArgumentError("unsupported URL scheme", "network", network);
        }
    }
    const n = (0, $1TEfp.getNetwork)(network);
    if (!n || !n._defaultProvider) $f72528ab54eeaef8$var$logger.throwError("unsupported getDefaultProvider network", (0, $6M65e.Logger).errors.NETWORK_ERROR, {
        operation: "getDefaultProvider",
        network: network
    });
    return n._defaultProvider({
        FallbackProvider: $h5Sdm.FallbackProvider,
        AlchemyProvider: $d8HAg.AlchemyProvider,
        AnkrProvider: $4xYP9.AnkrProvider,
        CloudflareProvider: $cHe68.CloudflareProvider,
        EtherscanProvider: $8c6ML.EtherscanProvider,
        InfuraProvider: $eGbhc.InfuraProvider,
        JsonRpcProvider: $aDPpa.JsonRpcProvider,
        NodesmithProvider: $7bZQB.NodesmithProvider,
        PocketProvider: $lc6pB.PocketProvider,
        Web3Provider: $lh9ZS.Web3Provider,
        IpcProvider: $9FSRo.IpcProvider
    }, options);
}

});
parcelRegister("1TEfp", function(module, exports) {

$parcel$export(module.exports, "getNetwork", function () { return $161a25d62c52de9c$export$7de4970ebfd8206d; });

var $6M65e = parcelRequire("6M65e");

var $aql2M = parcelRequire("aql2M");
"use strict";
const $161a25d62c52de9c$var$logger = new (0, $6M65e.Logger)((0, $aql2M.version));
function $161a25d62c52de9c$var$isRenetworkable(value) {
    return value && typeof value.renetwork === "function";
}
function $161a25d62c52de9c$var$ethDefaultProvider(network) {
    const func = function(providers, options) {
        if (options == null) options = {};
        const providerList = [];
        if (providers.InfuraProvider && options.infura !== "-") try {
            providerList.push(new providers.InfuraProvider(network, options.infura));
        } catch (error) {}
        if (providers.EtherscanProvider && options.etherscan !== "-") try {
            providerList.push(new providers.EtherscanProvider(network, options.etherscan));
        } catch (error) {}
        if (providers.AlchemyProvider && options.alchemy !== "-") try {
            providerList.push(new providers.AlchemyProvider(network, options.alchemy));
        } catch (error) {}
        if (providers.PocketProvider && options.pocket !== "-") {
            // These networks are currently faulty on Pocket as their
            // network does not handle the Berlin hardfork, which is
            // live on these ones.
            // @TODO: This goes away once Pocket has upgraded their nodes
            const skip = [
                "goerli",
                "ropsten",
                "rinkeby",
                "sepolia"
            ];
            try {
                const provider = new providers.PocketProvider(network, options.pocket);
                if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
            } catch (error) {}
        }
        if (providers.CloudflareProvider && options.cloudflare !== "-") try {
            providerList.push(new providers.CloudflareProvider(network));
        } catch (error) {}
        if (providers.AnkrProvider && options.ankr !== "-") try {
            const skip = [
                "ropsten"
            ];
            const provider = new providers.AnkrProvider(network, options.ankr);
            if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
        } catch (error) {}
        if (providerList.length === 0) return null;
        if (providers.FallbackProvider) {
            let quorum = 1;
            if (options.quorum != null) quorum = options.quorum;
            else if (network === "homestead") quorum = 2;
            return new providers.FallbackProvider(providerList, quorum);
        }
        return providerList[0];
    };
    func.renetwork = function(network) {
        return $161a25d62c52de9c$var$ethDefaultProvider(network);
    };
    return func;
}
function $161a25d62c52de9c$var$etcDefaultProvider(url, network) {
    const func = function(providers, options) {
        if (providers.JsonRpcProvider) return new providers.JsonRpcProvider(url, network);
        return null;
    };
    func.renetwork = function(network) {
        return $161a25d62c52de9c$var$etcDefaultProvider(url, network);
    };
    return func;
}
const $161a25d62c52de9c$var$homestead = {
    chainId: 1,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "homestead",
    _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("homestead")
};
const $161a25d62c52de9c$var$ropsten = {
    chainId: 3,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "ropsten",
    _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("ropsten")
};
const $161a25d62c52de9c$var$classicMordor = {
    chainId: 63,
    name: "classicMordor",
    _defaultProvider: $161a25d62c52de9c$var$etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
};
// See: https://chainlist.org
const $161a25d62c52de9c$var$networks = {
    unspecified: {
        chainId: 0,
        name: "unspecified"
    },
    homestead: $161a25d62c52de9c$var$homestead,
    mainnet: $161a25d62c52de9c$var$homestead,
    morden: {
        chainId: 2,
        name: "morden"
    },
    ropsten: $161a25d62c52de9c$var$ropsten,
    testnet: $161a25d62c52de9c$var$ropsten,
    rinkeby: {
        chainId: 4,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "rinkeby",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("rinkeby")
    },
    kovan: {
        chainId: 42,
        name: "kovan",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("kovan")
    },
    goerli: {
        chainId: 5,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "goerli",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("goerli")
    },
    kintsugi: {
        chainId: 1337702,
        name: "kintsugi"
    },
    sepolia: {
        chainId: 11155111,
        name: "sepolia",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("sepolia")
    },
    // ETC (See: #351)
    classic: {
        chainId: 61,
        name: "classic",
        _defaultProvider: $161a25d62c52de9c$var$etcDefaultProvider("https://www.ethercluster.com/etc", "classic")
    },
    classicMorden: {
        chainId: 62,
        name: "classicMorden"
    },
    classicMordor: $161a25d62c52de9c$var$classicMordor,
    classicTestnet: $161a25d62c52de9c$var$classicMordor,
    classicKotti: {
        chainId: 6,
        name: "classicKotti",
        _defaultProvider: $161a25d62c52de9c$var$etcDefaultProvider("https://www.ethercluster.com/kotti", "classicKotti")
    },
    xdai: {
        chainId: 100,
        name: "xdai"
    },
    matic: {
        chainId: 137,
        name: "matic",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("matic")
    },
    maticmum: {
        chainId: 80001,
        name: "maticmum"
    },
    optimism: {
        chainId: 10,
        name: "optimism",
        _defaultProvider: $161a25d62c52de9c$var$ethDefaultProvider("optimism")
    },
    "optimism-kovan": {
        chainId: 69,
        name: "optimism-kovan"
    },
    "optimism-goerli": {
        chainId: 420,
        name: "optimism-goerli"
    },
    arbitrum: {
        chainId: 42161,
        name: "arbitrum"
    },
    "arbitrum-rinkeby": {
        chainId: 421611,
        name: "arbitrum-rinkeby"
    },
    "arbitrum-goerli": {
        chainId: 421613,
        name: "arbitrum-goerli"
    },
    bnb: {
        chainId: 56,
        name: "bnb"
    },
    bnbt: {
        chainId: 97,
        name: "bnbt"
    }
};
function $161a25d62c52de9c$export$7de4970ebfd8206d(network) {
    // No network (null)
    if (network == null) return null;
    if (typeof network === "number") {
        for(const name in $161a25d62c52de9c$var$networks){
            const standard = $161a25d62c52de9c$var$networks[name];
            if (standard.chainId === network) return {
                name: standard.name,
                chainId: standard.chainId,
                ensAddress: standard.ensAddress || null,
                _defaultProvider: standard._defaultProvider || null
            };
        }
        return {
            chainId: network,
            name: "unknown"
        };
    }
    if (typeof network === "string") {
        const standard = $161a25d62c52de9c$var$networks[network];
        if (standard == null) return null;
        return {
            name: standard.name,
            chainId: standard.chainId,
            ensAddress: standard.ensAddress,
            _defaultProvider: standard._defaultProvider || null
        };
    }
    const standard = $161a25d62c52de9c$var$networks[network.name];
    // Not a standard network; check that it is a valid network in general
    if (!standard) {
        if (typeof network.chainId !== "number") $161a25d62c52de9c$var$logger.throwArgumentError("invalid network chainId", "network", network);
        return network;
    }
    // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)
    if (network.chainId !== 0 && network.chainId !== standard.chainId) $161a25d62c52de9c$var$logger.throwArgumentError("network chainId mismatch", "network", network);
    // @TODO: In the next major version add an attach function to a defaultProvider
    // class and move the _defaultProvider internal to this file (extend Network)
    let defaultProvider = network._defaultProvider || null;
    if (defaultProvider == null && standard._defaultProvider) {
        if ($161a25d62c52de9c$var$isRenetworkable(standard._defaultProvider)) defaultProvider = standard._defaultProvider.renetwork(network);
        else defaultProvider = standard._defaultProvider;
    }
    // Standard Network (allow overriding the ENS address)
    return {
        name: network.name,
        chainId: standard.chainId,
        ensAddress: network.ensAddress || standard.ensAddress || null,
        _defaultProvider: defaultProvider
    };
}

});
parcelRegister("aql2M", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $796ca7f59363f800$export$83d89fbfd8236492; });
const $796ca7f59363f800$export$83d89fbfd8236492 = "networks/5.7.1";

});


parcelRegister("96Por", function(module, exports) {

$parcel$export(module.exports, "Resolver", function () { return $6a1c8a35900dd937$export$8b4c839865b08288; });
$parcel$export(module.exports, "BaseProvider", function () { return $6a1c8a35900dd937$export$ff3f6dd83125ac45; });

var $lLovk = parcelRequire("lLovk");

var $70PIu = parcelRequire("70PIu");

var $ebtr5 = parcelRequire("ebtr5");

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $5OvKP = parcelRequire("5OvKP");

var $4JdI5 = parcelRequire("4JdI5");

var $1TEfp = parcelRequire("1TEfp");

var $2ax4w = parcelRequire("2ax4w");

var $7WUQV = parcelRequire("7WUQV");

var $1Wmc7 = parcelRequire("1Wmc7");

var $gqL7R = parcelRequire("gqL7R");

var $guCs7 = parcelRequire("guCs7");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");

var $f1MgE = parcelRequire("f1MgE");
"use strict";
var $6a1c8a35900dd937$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $6a1c8a35900dd937$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
const $6a1c8a35900dd937$var$MAX_CCIP_REDIRECTS = 10;
//////////////////////////////
// Event Serializeing
function $6a1c8a35900dd937$var$checkTopic(topic) {
    if (topic == null) return "null";
    if ((0, $j2rU8.hexDataLength)(topic) !== 32) $6a1c8a35900dd937$var$logger.throwArgumentError("invalid topic", "topic", topic);
    return topic.toLowerCase();
}
function $6a1c8a35900dd937$var$serializeTopics(topics) {
    // Remove trailing null AND-topics; they are redundant
    topics = topics.slice();
    while(topics.length > 0 && topics[topics.length - 1] == null)topics.pop();
    return topics.map((topic)=>{
        if (Array.isArray(topic)) {
            // Only track unique OR-topics
            const unique = {};
            topic.forEach((topic)=>{
                unique[$6a1c8a35900dd937$var$checkTopic(topic)] = true;
            });
            // The order of OR-topics does not matter
            const sorted = Object.keys(unique);
            sorted.sort();
            return sorted.join("|");
        } else return $6a1c8a35900dd937$var$checkTopic(topic);
    }).join("&");
}
function $6a1c8a35900dd937$var$deserializeTopics(data) {
    if (data === "") return [];
    return data.split(/&/g).map((topic)=>{
        if (topic === "") return [];
        const comps = topic.split("|").map((topic)=>{
            return topic === "null" ? null : topic;
        });
        return comps.length === 1 ? comps[0] : comps;
    });
}
function $6a1c8a35900dd937$var$getEventTag(eventName) {
    if (typeof eventName === "string") {
        eventName = eventName.toLowerCase();
        if ((0, $j2rU8.hexDataLength)(eventName) === 32) return "tx:" + eventName;
        if (eventName.indexOf(":") === -1) return eventName;
    } else if (Array.isArray(eventName)) return "filter:*:" + $6a1c8a35900dd937$var$serializeTopics(eventName);
    else if ((0, $lLovk.ForkEvent).isForkEvent(eventName)) {
        $6a1c8a35900dd937$var$logger.warn("not implemented");
        throw new Error("not implemented");
    } else if (eventName && typeof eventName === "object") return "filter:" + (eventName.address || "*") + ":" + $6a1c8a35900dd937$var$serializeTopics(eventName.topics || []);
    throw new Error("invalid event - " + eventName);
}
//////////////////////////////
// Helper Object
function $6a1c8a35900dd937$var$getTime() {
    return new Date().getTime();
}
function $6a1c8a35900dd937$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
//////////////////////////////
// Provider Object
/**
 *  EventType
 *   - "block"
 *   - "poll"
 *   - "didPoll"
 *   - "pending"
 *   - "error"
 *   - "network"
 *   - filter
 *   - topics array
 *   - transaction hash
 */ const $6a1c8a35900dd937$var$PollableEvents = [
    "block",
    "network",
    "pending",
    "poll"
];
class $6a1c8a35900dd937$export$d61e24a684f9e51 {
    get event() {
        switch(this.type){
            case "tx":
                return this.hash;
            case "filter":
                return this.filter;
        }
        return this.tag;
    }
    get type() {
        return this.tag.split(":")[0];
    }
    get hash() {
        const comps = this.tag.split(":");
        if (comps[0] !== "tx") return null;
        return comps[1];
    }
    get filter() {
        const comps = this.tag.split(":");
        if (comps[0] !== "filter") return null;
        const address = comps[1];
        const topics = $6a1c8a35900dd937$var$deserializeTopics(comps[2]);
        const filter = {};
        if (topics.length > 0) filter.topics = topics;
        if (address && address !== "*") filter.address = address;
        return filter;
    }
    pollable() {
        return this.tag.indexOf(":") >= 0 || $6a1c8a35900dd937$var$PollableEvents.indexOf(this.tag) >= 0;
    }
    constructor(tag, listener, once){
        (0, $2ax4w.defineReadOnly)(this, "tag", tag);
        (0, $2ax4w.defineReadOnly)(this, "listener", listener);
        (0, $2ax4w.defineReadOnly)(this, "once", once);
        this._lastBlockNumber = -2;
        this._inflight = false;
    }
}
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
const $6a1c8a35900dd937$var$coinInfos = {
    "0": {
        symbol: "btc",
        p2pkh: 0x00,
        p2sh: 0x05,
        prefix: "bc"
    },
    "2": {
        symbol: "ltc",
        p2pkh: 0x30,
        p2sh: 0x32,
        prefix: "ltc"
    },
    "3": {
        symbol: "doge",
        p2pkh: 0x1e,
        p2sh: 0x16
    },
    "60": {
        symbol: "eth",
        ilk: "eth"
    },
    "61": {
        symbol: "etc",
        ilk: "eth"
    },
    "700": {
        symbol: "xdai",
        ilk: "eth"
    }
};
function $6a1c8a35900dd937$var$bytes32ify(value) {
    return (0, $j2rU8.hexZeroPad)((0, $gMArf.BigNumber).from(value).toHexString(), 32);
}
// Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)
function $6a1c8a35900dd937$var$base58Encode(data) {
    return (0, $ebtr5.Base58).encode((0, $j2rU8.concat)([
        data,
        (0, $j2rU8.hexDataSlice)((0, $7WUQV.sha256)((0, $7WUQV.sha256)(data)), 0, 4)
    ]));
}
const $6a1c8a35900dd937$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $6a1c8a35900dd937$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $6a1c8a35900dd937$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
function $6a1c8a35900dd937$var$_parseString(result, start) {
    try {
        return (0, $1Wmc7.toUtf8String)($6a1c8a35900dd937$var$_parseBytes(result, start));
    } catch (error) {}
    return null;
}
function $6a1c8a35900dd937$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    const offset = (0, $gMArf.BigNumber).from((0, $j2rU8.hexDataSlice)(result, start, start + 32)).toNumber();
    const length = (0, $gMArf.BigNumber).from((0, $j2rU8.hexDataSlice)(result, offset, offset + 32)).toNumber();
    return (0, $j2rU8.hexDataSlice)(result, offset + 32, offset + 32 + length);
}
// Trim off the ipfs:// prefix and return the default gateway URL
function $6a1c8a35900dd937$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else $6a1c8a35900dd937$var$logger.throwArgumentError("unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
function $6a1c8a35900dd937$var$numPad(value) {
    const result = (0, $j2rU8.arrayify)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $6a1c8a35900dd937$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
// ABI Encodes a series of (bytes, bytes, ...)
function $6a1c8a35900dd937$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push(null);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $j2rU8.arrayify)(datas[i]);
        // Update the bytes offset
        result[i] = $6a1c8a35900dd937$var$numPad(byteCount);
        // The length and padded value of data
        result.push($6a1c8a35900dd937$var$numPad(data.length));
        result.push($6a1c8a35900dd937$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $j2rU8.hexConcat)(result);
}
class $6a1c8a35900dd937$export$8b4c839865b08288 {
    supportsWildcard() {
        if (!this._supportsEip2544) // supportsInterface(bytes4 = selector("resolve(bytes,bytes)"))
        this._supportsEip2544 = this.provider.call({
            to: this.address,
            data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
        }).then((result)=>{
            return (0, $gMArf.BigNumber).from(result).eq(1);
        }).catch((error)=>{
            if (error.code === (0, $6M65e.Logger).errors.CALL_EXCEPTION) return false;
            // Rethrow the error: link is down, etc. Let future attempts retry.
            this._supportsEip2544 = null;
            throw error;
        });
        return this._supportsEip2544;
    }
    _fetch(selector, parameters) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            // e.g. keccak256("addr(bytes32,uint256)")
            const tx = {
                to: this.address,
                ccipReadEnabled: true,
                data: (0, $j2rU8.hexConcat)([
                    selector,
                    (0, $4JdI5.namehash)(this.name),
                    parameters || "0x"
                ])
            };
            // Wildcard support; use EIP-2544 to resolve the request
            let parseBytes = false;
            if (yield this.supportsWildcard()) {
                parseBytes = true;
                // selector("resolve(bytes,bytes)")
                tx.data = (0, $j2rU8.hexConcat)([
                    "0x9061b923",
                    $6a1c8a35900dd937$var$encodeBytes([
                        (0, $4JdI5.dnsEncode)(this.name),
                        tx.data
                    ])
                ]);
            }
            try {
                let result = yield this.provider.call(tx);
                if ((0, $j2rU8.arrayify)(result).length % 32 === 4) $6a1c8a35900dd937$var$logger.throwError("resolver threw error", (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
                    transaction: tx,
                    data: result
                });
                if (parseBytes) result = $6a1c8a35900dd937$var$_parseBytes(result, 0);
                return result;
            } catch (error) {
                if (error.code === (0, $6M65e.Logger).errors.CALL_EXCEPTION) return null;
                throw error;
            }
        });
    }
    _fetchBytes(selector, parameters) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._fetch(selector, parameters);
            if (result != null) return $6a1c8a35900dd937$var$_parseBytes(result, 0);
            return null;
        });
    }
    _getAddress(coinType, hexBytes) {
        const coinInfo = $6a1c8a35900dd937$var$coinInfos[String(coinType)];
        if (coinInfo == null) $6a1c8a35900dd937$var$logger.throwError(`unsupported coin type: ${coinType}`, (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: `getAddress(${coinType})`
        });
        if (coinInfo.ilk === "eth") return this.provider.formatter.address(hexBytes);
        const bytes = (0, $j2rU8.arrayify)(hexBytes);
        // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
        if (coinInfo.p2pkh != null) {
            const p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
            if (p2pkh) {
                const length = parseInt(p2pkh[1], 16);
                if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) return $6a1c8a35900dd937$var$base58Encode((0, $j2rU8.concat)([
                    [
                        coinInfo.p2pkh
                    ],
                    "0x" + p2pkh[2]
                ]));
            }
        }
        // P2SH: OP_HASH160 <scriptHash> OP_EQUAL
        if (coinInfo.p2sh != null) {
            const p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
            if (p2sh) {
                const length = parseInt(p2sh[1], 16);
                if (p2sh[2].length === length * 2 && length >= 1 && length <= 75) return $6a1c8a35900dd937$var$base58Encode((0, $j2rU8.concat)([
                    [
                        coinInfo.p2sh
                    ],
                    "0x" + p2sh[2]
                ]));
            }
        }
        // Bech32
        if (coinInfo.prefix != null) {
            const length = bytes[1];
            // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program
            let version = bytes[0];
            if (version === 0x00) {
                if (length !== 20 && length !== 32) version = -1;
            } else version = -1;
            if (version >= 0 && bytes.length === 2 + length && length >= 1 && length <= 75) {
                const words = (0, (/*@__PURE__*/$parcel$interopDefault($guCs7))).toWords(bytes.slice(2));
                words.unshift(version);
                return (0, (/*@__PURE__*/$parcel$interopDefault($guCs7))).encode(coinInfo.prefix, words);
            }
        }
        return null;
    }
    getAddress(coinType) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            if (coinType == null) coinType = 60;
            // If Ethereum, use the standard `addr(bytes32)`
            if (coinType === 60) try {
                // keccak256("addr(bytes32)")
                const result = yield this._fetch("0x3b3b57de");
                // No address
                if (result === "0x" || result === (0, $5OvKP.HashZero)) return null;
                return this.provider.formatter.callAddress(result);
            } catch (error) {
                if (error.code === (0, $6M65e.Logger).errors.CALL_EXCEPTION) return null;
                throw error;
            }
            // keccak256("addr(bytes32,uint256")
            const hexBytes = yield this._fetchBytes("0xf1cb7e06", $6a1c8a35900dd937$var$bytes32ify(coinType));
            // No address
            if (hexBytes == null || hexBytes === "0x") return null;
            // Compute the address
            const address = this._getAddress(coinType, hexBytes);
            if (address == null) $6a1c8a35900dd937$var$logger.throwError(`invalid or unsupported coin data`, (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: `getAddress(${coinType})`,
                coinType: coinType,
                data: hexBytes
            });
            return address;
        });
    }
    getAvatar() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            const linkage = [
                {
                    type: "name",
                    content: this.name
                }
            ];
            try {
                // test data for ricmoo.eth
                //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
                const avatar = yield this.getText("avatar");
                if (avatar == null) return null;
                for(let i = 0; i < $6a1c8a35900dd937$var$matchers.length; i++){
                    const match = avatar.match($6a1c8a35900dd937$var$matchers[i]);
                    if (match == null) continue;
                    const scheme = match[1].toLowerCase();
                    switch(scheme){
                        case "https":
                            linkage.push({
                                type: "url",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "data":
                            linkage.push({
                                type: "data",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "ipfs":
                            linkage.push({
                                type: "ipfs",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: $6a1c8a35900dd937$var$getIpfsLink(avatar)
                            };
                        case "erc721":
                        case "erc1155":
                            {
                                // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                                const selector = scheme === "erc721" ? "0xc87b56dd" : "0x0e89341c";
                                linkage.push({
                                    type: scheme,
                                    content: avatar
                                });
                                // The owner of this name
                                const owner = this._resolvedAddress || (yield this.getAddress());
                                const comps = (match[2] || "").split("/");
                                if (comps.length !== 2) return null;
                                const addr = yield this.provider.formatter.address(comps[0]);
                                const tokenId = (0, $j2rU8.hexZeroPad)((0, $gMArf.BigNumber).from(comps[1]).toHexString(), 32);
                                // Check that this account owns the token
                                if (scheme === "erc721") {
                                    // ownerOf(uint256 tokenId)
                                    const tokenOwner = this.provider.formatter.callAddress((yield this.provider.call({
                                        to: addr,
                                        data: (0, $j2rU8.hexConcat)([
                                            "0x6352211e",
                                            tokenId
                                        ])
                                    })));
                                    if (owner !== tokenOwner) return null;
                                    linkage.push({
                                        type: "owner",
                                        content: tokenOwner
                                    });
                                } else if (scheme === "erc1155") {
                                    // balanceOf(address owner, uint256 tokenId)
                                    const balance = (0, $gMArf.BigNumber).from((yield this.provider.call({
                                        to: addr,
                                        data: (0, $j2rU8.hexConcat)([
                                            "0x00fdd58e",
                                            (0, $j2rU8.hexZeroPad)(owner, 32),
                                            tokenId
                                        ])
                                    })));
                                    if (balance.isZero()) return null;
                                    linkage.push({
                                        type: "balance",
                                        content: balance.toString()
                                    });
                                }
                                // Call the token contract for the metadata URL
                                const tx = {
                                    to: this.provider.formatter.address(comps[0]),
                                    data: (0, $j2rU8.hexConcat)([
                                        selector,
                                        tokenId
                                    ])
                                };
                                let metadataUrl = $6a1c8a35900dd937$var$_parseString((yield this.provider.call(tx)), 0);
                                if (metadataUrl == null) return null;
                                linkage.push({
                                    type: "metadata-url-base",
                                    content: metadataUrl
                                });
                                // ERC-1155 allows a generic {id} in the URL
                                if (scheme === "erc1155") {
                                    metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
                                    linkage.push({
                                        type: "metadata-url-expanded",
                                        content: metadataUrl
                                    });
                                }
                                // Transform IPFS metadata links
                                if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $6a1c8a35900dd937$var$getIpfsLink(metadataUrl);
                                linkage.push({
                                    type: "metadata-url",
                                    content: metadataUrl
                                });
                                // Get the token metadata
                                const metadata = yield (0, $gqL7R.fetchJson)(metadataUrl);
                                if (!metadata) return null;
                                linkage.push({
                                    type: "metadata",
                                    content: JSON.stringify(metadata)
                                });
                                // Pull the image URL out
                                let imageUrl = metadata.image;
                                if (typeof imageUrl !== "string") return null;
                                if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                                else {
                                    // Transform IPFS link to gateway
                                    const ipfs = imageUrl.match($6a1c8a35900dd937$var$matcherIpfs);
                                    if (ipfs == null) return null;
                                    linkage.push({
                                        type: "url-ipfs",
                                        content: imageUrl
                                    });
                                    imageUrl = $6a1c8a35900dd937$var$getIpfsLink(imageUrl);
                                }
                                linkage.push({
                                    type: "url",
                                    content: imageUrl
                                });
                                return {
                                    linkage: linkage,
                                    url: imageUrl
                                };
                            }
                    }
                }
            } catch (error) {}
            return null;
        });
    }
    getContentHash() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            // keccak256("contenthash()")
            const hexBytes = yield this._fetchBytes("0xbc1c58d1");
            // No contenthash
            if (hexBytes == null || hexBytes === "0x") return null;
            // IPFS (CID: 1, Type: DAG-PB)
            const ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipfs) {
                const length = parseInt(ipfs[3], 16);
                if (ipfs[4].length === length * 2) return "ipfs://" + (0, $ebtr5.Base58).encode("0x" + ipfs[1]);
            }
            // IPNS (CID: 1, Type: libp2p-key)
            const ipns = hexBytes.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipns) {
                const length = parseInt(ipns[3], 16);
                if (ipns[4].length === length * 2) return "ipns://" + (0, $ebtr5.Base58).encode("0x" + ipns[1]);
            }
            // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
            const swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);
            if (swarm) {
                if (swarm[1].length === 64) return "bzz://" + swarm[1];
            }
            const skynet = hexBytes.match(/^0x90b2c605([0-9a-f]*)$/);
            if (skynet) {
                if (skynet[1].length === 68) {
                    // URL Safe base64; https://datatracker.ietf.org/doc/html/rfc4648#section-5
                    const urlSafe = {
                        "=": "",
                        "+": "-",
                        "/": "_"
                    };
                    const hash = (0, $70PIu.encode)("0x" + skynet[1]).replace(/[=+\/]/g, (a)=>urlSafe[a]);
                    return "sia://" + hash;
                }
            }
            return $6a1c8a35900dd937$var$logger.throwError(`invalid or unsupported content hash data`, (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "getContentHash()",
                data: hexBytes
            });
        });
    }
    getText(key) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            // The key encoded as parameter to fetchBytes
            let keyBytes = (0, $1Wmc7.toUtf8Bytes)(key);
            // The nodehash consumes the first slot, so the string pointer targets
            // offset 64, with the length at offset 64 and data starting at offset 96
            keyBytes = (0, $j2rU8.concat)([
                $6a1c8a35900dd937$var$bytes32ify(64),
                $6a1c8a35900dd937$var$bytes32ify(keyBytes.length),
                keyBytes
            ]);
            // Pad to word-size (32 bytes)
            if (keyBytes.length % 32 !== 0) keyBytes = (0, $j2rU8.concat)([
                keyBytes,
                (0, $j2rU8.hexZeroPad)("0x", 32 - key.length % 32)
            ]);
            const hexBytes = yield this._fetchBytes("0x59d1d43c", (0, $j2rU8.hexlify)(keyBytes));
            if (hexBytes == null || hexBytes === "0x") return null;
            return (0, $1Wmc7.toUtf8String)(hexBytes);
        });
    }
    // The resolvedAddress is only for creating a ReverseLookup resolver
    constructor(provider, address, name, resolvedAddress){
        (0, $2ax4w.defineReadOnly)(this, "provider", provider);
        (0, $2ax4w.defineReadOnly)(this, "name", name);
        (0, $2ax4w.defineReadOnly)(this, "address", provider.formatter.address(address));
        (0, $2ax4w.defineReadOnly)(this, "_resolvedAddress", resolvedAddress);
    }
}
let $6a1c8a35900dd937$var$defaultFormatter = null;
let $6a1c8a35900dd937$var$nextPollId = 1;
class $6a1c8a35900dd937$export$ff3f6dd83125ac45 extends (0, $lLovk.Provider) {
    _ready() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            if (this._network == null) {
                let network = null;
                if (this._networkPromise) try {
                    network = yield this._networkPromise;
                } catch (error) {}
                // Try the Provider's network detection (this MUST throw if it cannot)
                if (network == null) network = yield this.detectNetwork();
                // This should never happen; every Provider sub-class should have
                // suggested a network by here (or have thrown).
                if (!network) $6a1c8a35900dd937$var$logger.throwError("no network detected", (0, $6M65e.Logger).errors.UNKNOWN_ERROR, {});
                // Possible this call stacked so do not call defineReadOnly again
                if (this._network == null) {
                    if (this.anyNetwork) this._network = network;
                    else (0, $2ax4w.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return this._network;
        });
    }
    // This will always return the most recently established network.
    // For "any", this can change (a "network" event is emitted before
    // any change is reflected); otherwise this cannot change
    get ready() {
        return (0, $gqL7R.poll)(()=>{
            return this._ready().then((network)=>{
                return network;
            }, (error)=>{
                // If the network isn't running yet, we will wait
                if (error.code === (0, $6M65e.Logger).errors.NETWORK_ERROR && error.event === "noNetwork") return undefined;
                throw error;
            });
        });
    }
    // @TODO: Remove this and just create a singleton formatter
    static getFormatter() {
        if ($6a1c8a35900dd937$var$defaultFormatter == null) $6a1c8a35900dd937$var$defaultFormatter = new (0, $f1MgE.Formatter)();
        return $6a1c8a35900dd937$var$defaultFormatter;
    }
    // @TODO: Remove this and just use getNetwork
    static getNetwork(network) {
        return (0, $1TEfp.getNetwork)(network == null ? "homestead" : network);
    }
    ccipReadFetch(tx, calldata, urls) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            if (this.disableCcipRead || urls.length === 0) return null;
            const sender = tx.to.toLowerCase();
            const data = calldata.toLowerCase();
            const errorMessages = [];
            for(let i = 0; i < urls.length; i++){
                const url = urls[i];
                // URL expansion
                const href = url.replace("{sender}", sender).replace("{data}", data);
                // If no {data} is present, use POST; otherwise GET
                const json = url.indexOf("{data}") >= 0 ? null : JSON.stringify({
                    data: data,
                    sender: sender
                });
                const result = yield (0, $gqL7R.fetchJson)({
                    url: href,
                    errorPassThrough: true
                }, json, (value, response)=>{
                    value.status = response.statusCode;
                    return value;
                });
                if (result.data) return result.data;
                const errorMessage = result.message || "unknown error";
                // 4xx indicates the result is not present; stop
                if (result.status >= 400 && result.status < 500) return $6a1c8a35900dd937$var$logger.throwError(`response not found during CCIP fetch: ${errorMessage}`, (0, $6M65e.Logger).errors.SERVER_ERROR, {
                    url: url,
                    errorMessage: errorMessage
                });
                // 5xx indicates server issue; try the next url
                errorMessages.push(errorMessage);
            }
            return $6a1c8a35900dd937$var$logger.throwError(`error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, (0, $6M65e.Logger).errors.SERVER_ERROR, {
                urls: urls,
                errorMessages: errorMessages
            });
        });
    }
    // Fetches the blockNumber, but will reuse any result that is less
    // than maxAge old or has been requested since the last request
    _getInternalBlockNumber(maxAge) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this._ready();
            // Allowing stale data up to maxAge old
            if (maxAge > 0) // While there are pending internal block requests...
            while(this._internalBlockNumber){
                // ..."remember" which fetch we started with
                const internalBlockNumber = this._internalBlockNumber;
                try {
                    // Check the result is not too stale
                    const result = yield internalBlockNumber;
                    if ($6a1c8a35900dd937$var$getTime() - result.respTime <= maxAge) return result.blockNumber;
                    break;
                } catch (error) {
                    // The fetch rejected; if we are the first to get the
                    // rejection, drop through so we replace it with a new
                    // fetch; all others blocked will then get that fetch
                    // which won't match the one they "remembered" and loop
                    if (this._internalBlockNumber === internalBlockNumber) break;
                }
            }
            const reqTime = $6a1c8a35900dd937$var$getTime();
            const checkInternalBlockNumber = (0, $2ax4w.resolveProperties)({
                blockNumber: this.perform("getBlockNumber", {}),
                networkError: this.getNetwork().then((network)=>null, (error)=>error)
            }).then(({ blockNumber: blockNumber, networkError: networkError })=>{
                if (networkError) {
                    // Unremember this bad internal block number
                    if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
                    throw networkError;
                }
                const respTime = $6a1c8a35900dd937$var$getTime();
                blockNumber = (0, $gMArf.BigNumber).from(blockNumber).toNumber();
                if (blockNumber < this._maxInternalBlockNumber) blockNumber = this._maxInternalBlockNumber;
                this._maxInternalBlockNumber = blockNumber;
                this._setFastBlockNumber(blockNumber); // @TODO: Still need this?
                return {
                    blockNumber: blockNumber,
                    reqTime: reqTime,
                    respTime: respTime
                };
            });
            this._internalBlockNumber = checkInternalBlockNumber;
            // Swallow unhandled exceptions; if needed they are handled else where
            checkInternalBlockNumber.catch((error)=>{
                // Don't null the dead (rejected) fetch, if it has already been updated
                if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
            });
            return (yield checkInternalBlockNumber).blockNumber;
        });
    }
    poll() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            const pollId = $6a1c8a35900dd937$var$nextPollId++;
            // Track all running promises, so we can trigger a post-poll once they are complete
            const runners = [];
            let blockNumber = null;
            try {
                blockNumber = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
            } catch (error) {
                this.emit("error", error);
                return;
            }
            this._setFastBlockNumber(blockNumber);
            // Emit a poll event after we have the latest (fast) block number
            this.emit("poll", pollId, blockNumber);
            // If the block has not changed, meh.
            if (blockNumber === this._lastBlockNumber) {
                this.emit("didPoll", pollId);
                return;
            }
            // First polling cycle, trigger a "block" events
            if (this._emitted.block === -2) this._emitted.block = blockNumber - 1;
            if (Math.abs(this._emitted.block - blockNumber) > 1000) {
                $6a1c8a35900dd937$var$logger.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${blockNumber})`);
                this.emit("error", $6a1c8a35900dd937$var$logger.makeError("network block skew detected", (0, $6M65e.Logger).errors.NETWORK_ERROR, {
                    blockNumber: blockNumber,
                    event: "blockSkew",
                    previousBlockNumber: this._emitted.block
                }));
                this.emit("block", blockNumber);
            } else // Notify all listener for each block that has passed
            for(let i = this._emitted.block + 1; i <= blockNumber; i++)this.emit("block", i);
            // The emitted block was updated, check for obsolete events
            if (this._emitted.block !== blockNumber) {
                this._emitted.block = blockNumber;
                Object.keys(this._emitted).forEach((key)=>{
                    // The block event does not expire
                    if (key === "block") return;
                    // The block we were at when we emitted this event
                    const eventBlockNumber = this._emitted[key];
                    // We cannot garbage collect pending transactions or blocks here
                    // They should be garbage collected by the Provider when setting
                    // "pending" events
                    if (eventBlockNumber === "pending") return;
                    // Evict any transaction hashes or block hashes over 12 blocks
                    // old, since they should not return null anyways
                    if (blockNumber - eventBlockNumber > 12) delete this._emitted[key];
                });
            }
            // First polling cycle
            if (this._lastBlockNumber === -2) this._lastBlockNumber = blockNumber - 1;
            // Find all transaction hashes we are waiting on
            this._events.forEach((event)=>{
                switch(event.type){
                    case "tx":
                        {
                            const hash = event.hash;
                            let runner = this.getTransactionReceipt(hash).then((receipt)=>{
                                if (!receipt || receipt.blockNumber == null) return null;
                                this._emitted["t:" + hash] = receipt.blockNumber;
                                this.emit(hash, receipt);
                                return null;
                            }).catch((error)=>{
                                this.emit("error", error);
                            });
                            runners.push(runner);
                            break;
                        }
                    case "filter":
                        // We only allow a single getLogs to be in-flight at a time
                        if (!event._inflight) {
                            event._inflight = true;
                            // This is the first filter for this event, so we want to
                            // restrict events to events that happened no earlier than now
                            if (event._lastBlockNumber === -2) event._lastBlockNumber = blockNumber - 1;
                            // Filter from the last *known* event; due to load-balancing
                            // and some nodes returning updated block numbers before
                            // indexing events, a logs result with 0 entries cannot be
                            // trusted and we must retry a range which includes it again
                            const filter = event.filter;
                            filter.fromBlock = event._lastBlockNumber + 1;
                            filter.toBlock = blockNumber;
                            // Prevent fitler ranges from growing too wild, since it is quite
                            // likely there just haven't been any events to move the lastBlockNumber.
                            const minFromBlock = filter.toBlock - this._maxFilterBlockRange;
                            if (minFromBlock > filter.fromBlock) filter.fromBlock = minFromBlock;
                            if (filter.fromBlock < 0) filter.fromBlock = 0;
                            const runner = this.getLogs(filter).then((logs)=>{
                                // Allow the next getLogs
                                event._inflight = false;
                                if (logs.length === 0) return;
                                logs.forEach((log)=>{
                                    // Only when we get an event for a given block number
                                    // can we trust the events are indexed
                                    if (log.blockNumber > event._lastBlockNumber) event._lastBlockNumber = log.blockNumber;
                                    // Make sure we stall requests to fetch blocks and txs
                                    this._emitted["b:" + log.blockHash] = log.blockNumber;
                                    this._emitted["t:" + log.transactionHash] = log.blockNumber;
                                    this.emit(filter, log);
                                });
                            }).catch((error)=>{
                                this.emit("error", error);
                                // Allow another getLogs (the range was not updated)
                                event._inflight = false;
                            });
                            runners.push(runner);
                        }
                        break;
                }
            });
            this._lastBlockNumber = blockNumber;
            // Once all events for this loop have been processed, emit "didPoll"
            Promise.all(runners).then(()=>{
                this.emit("didPoll", pollId);
            }).catch((error)=>{
                this.emit("error", error);
            });
            return;
        });
    }
    // Deprecated; do not use this
    resetEventsBlock(blockNumber) {
        this._lastBlockNumber = blockNumber - 1;
        if (this.polling) this.poll();
    }
    get network() {
        return this._network;
    }
    // This method should query the network if the underlying network
    // can change, such as when connected to a JSON-RPC backend
    detectNetwork() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            return $6a1c8a35900dd937$var$logger.throwError("provider does not support network detection", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "provider.detectNetwork"
            });
        });
    }
    getNetwork() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            const network = yield this._ready();
            // Make sure we are still connected to the same network; this is
            // only an external call for backends which can have the underlying
            // network change spontaneously
            const currentNetwork = yield this.detectNetwork();
            if (network.chainId !== currentNetwork.chainId) {
                // We are allowing network changes, things can get complex fast;
                // make sure you know what you are doing if you use "any"
                if (this.anyNetwork) {
                    this._network = currentNetwork;
                    // Reset all internal block number guards and caches
                    this._lastBlockNumber = -2;
                    this._fastBlockNumber = null;
                    this._fastBlockNumberPromise = null;
                    this._fastQueryDate = 0;
                    this._emitted.block = -2;
                    this._maxInternalBlockNumber = -1024;
                    this._internalBlockNumber = null;
                    // The "network" event MUST happen before this method resolves
                    // so any events have a chance to unregister, so we stall an
                    // additional event loop before returning from /this/ call
                    this.emit("network", currentNetwork, network);
                    yield $6a1c8a35900dd937$var$stall(0);
                    return this._network;
                }
                const error = $6a1c8a35900dd937$var$logger.makeError("underlying network changed", (0, $6M65e.Logger).errors.NETWORK_ERROR, {
                    event: "changed",
                    network: network,
                    detectedNetwork: currentNetwork
                });
                this.emit("error", error);
                throw error;
            }
            return network;
        });
    }
    get blockNumber() {
        this._getInternalBlockNumber(100 + this.pollingInterval / 2).then((blockNumber)=>{
            this._setFastBlockNumber(blockNumber);
        }, (error)=>{});
        return this._fastBlockNumber != null ? this._fastBlockNumber : -1;
    }
    get polling() {
        return this._poller != null;
    }
    set polling(value) {
        if (value && !this._poller) {
            this._poller = setInterval(()=>{
                this.poll();
            }, this.pollingInterval);
            if (!this._bootstrapPoll) this._bootstrapPoll = setTimeout(()=>{
                this.poll();
                // We block additional polls until the polling interval
                // is done, to prevent overwhelming the poll function
                this._bootstrapPoll = setTimeout(()=>{
                    // If polling was disabled, something may require a poke
                    // since starting the bootstrap poll and it was disabled
                    if (!this._poller) this.poll();
                    // Clear out the bootstrap so we can do another
                    this._bootstrapPoll = null;
                }, this.pollingInterval);
            }, 0);
        } else if (!value && this._poller) {
            clearInterval(this._poller);
            this._poller = null;
        }
    }
    get pollingInterval() {
        return this._pollingInterval;
    }
    set pollingInterval(value) {
        if (typeof value !== "number" || value <= 0 || parseInt(String(value)) != value) throw new Error("invalid polling interval");
        this._pollingInterval = value;
        if (this._poller) {
            clearInterval(this._poller);
            this._poller = setInterval(()=>{
                this.poll();
            }, this._pollingInterval);
        }
    }
    _getFastBlockNumber() {
        const now = $6a1c8a35900dd937$var$getTime();
        // Stale block number, request a newer value
        if (now - this._fastQueryDate > 2 * this._pollingInterval) {
            this._fastQueryDate = now;
            this._fastBlockNumberPromise = this.getBlockNumber().then((blockNumber)=>{
                if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) this._fastBlockNumber = blockNumber;
                return this._fastBlockNumber;
            });
        }
        return this._fastBlockNumberPromise;
    }
    _setFastBlockNumber(blockNumber) {
        // Older block, maybe a stale request
        if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) return;
        // Update the time we updated the blocknumber
        this._fastQueryDate = $6a1c8a35900dd937$var$getTime();
        // Newer block number, use  it
        if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
            this._fastBlockNumber = blockNumber;
            this._fastBlockNumberPromise = Promise.resolve(blockNumber);
        }
    }
    waitForTransaction(transactionHash, confirmations, timeout) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            return this._waitForTransaction(transactionHash, confirmations == null ? 1 : confirmations, timeout || 0, null);
        });
    }
    _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            const receipt = yield this.getTransactionReceipt(transactionHash);
            // Receipt is already good
            if ((receipt ? receipt.confirmations : 0) >= confirmations) return receipt;
            // Poll until the receipt is good...
            return new Promise((resolve, reject)=>{
                const cancelFuncs = [];
                let done = false;
                const alreadyDone = function() {
                    if (done) return true;
                    done = true;
                    cancelFuncs.forEach((func)=>{
                        func();
                    });
                    return false;
                };
                const minedHandler = (receipt)=>{
                    if (receipt.confirmations < confirmations) return;
                    if (alreadyDone()) return;
                    resolve(receipt);
                };
                this.on(transactionHash, minedHandler);
                cancelFuncs.push(()=>{
                    this.removeListener(transactionHash, minedHandler);
                });
                if (replaceable) {
                    let lastBlockNumber = replaceable.startBlock;
                    let scannedBlock = null;
                    const replaceHandler = (blockNumber)=>$6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
                            if (done) return;
                            // Wait 1 second; this is only used in the case of a fault, so
                            // we will trade off a little bit of latency for more consistent
                            // results and fewer JSON-RPC calls
                            yield $6a1c8a35900dd937$var$stall(1000);
                            this.getTransactionCount(replaceable.from).then((nonce)=>$6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
                                    if (done) return;
                                    if (nonce <= replaceable.nonce) lastBlockNumber = blockNumber;
                                    else {
                                        // First check if the transaction was mined
                                        {
                                            const mined = yield this.getTransaction(transactionHash);
                                            if (mined && mined.blockNumber != null) return;
                                        }
                                        // First time scanning. We start a little earlier for some
                                        // wiggle room here to handle the eventually consistent nature
                                        // of blockchain (e.g. the getTransactionCount was for a
                                        // different block)
                                        if (scannedBlock == null) {
                                            scannedBlock = lastBlockNumber - 3;
                                            if (scannedBlock < replaceable.startBlock) scannedBlock = replaceable.startBlock;
                                        }
                                        while(scannedBlock <= blockNumber){
                                            if (done) return;
                                            const block = yield this.getBlockWithTransactions(scannedBlock);
                                            for(let ti = 0; ti < block.transactions.length; ti++){
                                                const tx = block.transactions[ti];
                                                // Successfully mined!
                                                if (tx.hash === transactionHash) return;
                                                // Matches our transaction from and nonce; its a replacement
                                                if (tx.from === replaceable.from && tx.nonce === replaceable.nonce) {
                                                    if (done) return;
                                                    // Get the receipt of the replacement
                                                    const receipt = yield this.waitForTransaction(tx.hash, confirmations);
                                                    // Already resolved or rejected (prolly a timeout)
                                                    if (alreadyDone()) return;
                                                    // The reason we were replaced
                                                    let reason = "replaced";
                                                    if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) reason = "repriced";
                                                    else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) reason = "cancelled";
                                                    // Explain why we were replaced
                                                    reject($6a1c8a35900dd937$var$logger.makeError("transaction was replaced", (0, $6M65e.Logger).errors.TRANSACTION_REPLACED, {
                                                        cancelled: reason === "replaced" || reason === "cancelled",
                                                        reason: reason,
                                                        replacement: this._wrapTransaction(tx),
                                                        hash: transactionHash,
                                                        receipt: receipt
                                                    }));
                                                    return;
                                                }
                                            }
                                            scannedBlock++;
                                        }
                                    }
                                    if (done) return;
                                    this.once("block", replaceHandler);
                                }), (error)=>{
                                if (done) return;
                                this.once("block", replaceHandler);
                            });
                        });
                    if (done) return;
                    this.once("block", replaceHandler);
                    cancelFuncs.push(()=>{
                        this.removeListener("block", replaceHandler);
                    });
                }
                if (typeof timeout === "number" && timeout > 0) {
                    const timer = setTimeout(()=>{
                        if (alreadyDone()) return;
                        reject($6a1c8a35900dd937$var$logger.makeError("timeout exceeded", (0, $6M65e.Logger).errors.TIMEOUT, {
                            timeout: timeout
                        }));
                    }, timeout);
                    if (timer.unref) timer.unref();
                    cancelFuncs.push(()=>{
                        clearTimeout(timer);
                    });
                }
            });
        });
    }
    getBlockNumber() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            return this._getInternalBlockNumber(0);
        });
    }
    getGasPrice() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const result = yield this.perform("getGasPrice", {});
            try {
                return (0, $gMArf.BigNumber).from(result);
            } catch (error) {
                return $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                    method: "getGasPrice",
                    result: result,
                    error: error
                });
            }
        });
    }
    getBalance(addressOrName, blockTag) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $2ax4w.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getBalance", params);
            try {
                return (0, $gMArf.BigNumber).from(result);
            } catch (error) {
                return $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                    method: "getBalance",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getTransactionCount(addressOrName, blockTag) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $2ax4w.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getTransactionCount", params);
            try {
                return (0, $gMArf.BigNumber).from(result).toNumber();
            } catch (error) {
                return $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                    method: "getTransactionCount",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getCode(addressOrName, blockTag) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $2ax4w.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getCode", params);
            try {
                return (0, $j2rU8.hexlify)(result);
            } catch (error) {
                return $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                    method: "getCode",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getStorageAt(addressOrName, position, blockTag) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $2ax4w.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag),
                position: Promise.resolve(position).then((p)=>(0, $j2rU8.hexValue)(p))
            });
            const result = yield this.perform("getStorageAt", params);
            try {
                return (0, $j2rU8.hexlify)(result);
            } catch (error) {
                return $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                    method: "getStorageAt",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    // This should be called by any subclass wrapping a TransactionResponse
    _wrapTransaction(tx, hash, startBlock) {
        if (hash != null && (0, $j2rU8.hexDataLength)(hash) !== 32) throw new Error("invalid response - sendTransaction");
        const result = tx;
        // Check the hash we expect is the same as the hash the server reported
        if (hash != null && tx.hash !== hash) $6a1c8a35900dd937$var$logger.throwError("Transaction hash mismatch from Provider.sendTransaction.", (0, $6M65e.Logger).errors.UNKNOWN_ERROR, {
            expectedHash: tx.hash,
            returnedHash: hash
        });
        result.wait = (confirms, timeout)=>$6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
                if (confirms == null) confirms = 1;
                if (timeout == null) timeout = 0;
                // Get the details to detect replacement
                let replacement = undefined;
                if (confirms !== 0 && startBlock != null) replacement = {
                    data: tx.data,
                    from: tx.from,
                    nonce: tx.nonce,
                    to: tx.to,
                    value: tx.value,
                    startBlock: startBlock
                };
                const receipt = yield this._waitForTransaction(tx.hash, confirms, timeout, replacement);
                if (receipt == null && confirms === 0) return null;
                // No longer pending, allow the polling loop to garbage collect this
                this._emitted["t:" + tx.hash] = receipt.blockNumber;
                if (receipt.status === 0) $6a1c8a35900dd937$var$logger.throwError("transaction failed", (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
                    transactionHash: tx.hash,
                    transaction: tx,
                    receipt: receipt
                });
                return receipt;
            });
        return result;
    }
    sendTransaction(signedTransaction) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const hexTx = yield Promise.resolve(signedTransaction).then((t)=>(0, $j2rU8.hexlify)(t));
            const tx = this.formatter.transaction(signedTransaction);
            if (tx.confirmations == null) tx.confirmations = 0;
            const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
            try {
                const hash = yield this.perform("sendTransaction", {
                    signedTransaction: hexTx
                });
                return this._wrapTransaction(tx, hash, blockNumber);
            } catch (error) {
                error.transaction = tx;
                error.transactionHash = tx.hash;
                throw error;
            }
        });
    }
    _getTransactionRequest(transaction) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            const values = yield transaction;
            const tx = {};
            [
                "from",
                "to"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? this._getAddress(v) : null);
            });
            [
                "gasLimit",
                "gasPrice",
                "maxFeePerGas",
                "maxPriorityFeePerGas",
                "value"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $gMArf.BigNumber).from(v) : null);
            });
            [
                "type"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v != null ? v : null);
            });
            if (values.accessList) tx.accessList = this.formatter.accessList(values.accessList);
            [
                "data"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $j2rU8.hexlify)(v) : null);
            });
            return this.formatter.transactionRequest((yield (0, $2ax4w.resolveProperties)(tx)));
        });
    }
    _getFilter(filter) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            filter = yield filter;
            const result = {};
            if (filter.address != null) result.address = this._getAddress(filter.address);
            [
                "blockHash",
                "topics"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = filter[key];
            });
            [
                "fromBlock",
                "toBlock"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = this._getBlockTag(filter[key]);
            });
            return this.formatter.filter((yield (0, $2ax4w.resolveProperties)(result)));
        });
    }
    _call(transaction, blockTag, attempt) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            if (attempt >= $6a1c8a35900dd937$var$MAX_CCIP_REDIRECTS) $6a1c8a35900dd937$var$logger.throwError("CCIP read exceeded maximum redirections", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                redirects: attempt,
                transaction: transaction
            });
            const txSender = transaction.to;
            const result = yield this.perform("call", {
                transaction: transaction,
                blockTag: blockTag
            });
            // CCIP Read request via OffchainLookup(address,string[],bytes,bytes4,bytes)
            if (attempt >= 0 && blockTag === "latest" && txSender != null && result.substring(0, 10) === "0x556f1830" && (0, $j2rU8.hexDataLength)(result) % 32 === 4) try {
                const data = (0, $j2rU8.hexDataSlice)(result, 4);
                // Check the sender of the OffchainLookup matches the transaction
                const sender = (0, $j2rU8.hexDataSlice)(data, 0, 32);
                if (!(0, $gMArf.BigNumber).from(sender).eq(txSender)) $6a1c8a35900dd937$var$logger.throwError("CCIP Read sender did not match", (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                // Read the URLs from the response
                const urls = [];
                const urlsOffset = (0, $gMArf.BigNumber).from((0, $j2rU8.hexDataSlice)(data, 32, 64)).toNumber();
                const urlsLength = (0, $gMArf.BigNumber).from((0, $j2rU8.hexDataSlice)(data, urlsOffset, urlsOffset + 32)).toNumber();
                const urlsData = (0, $j2rU8.hexDataSlice)(data, urlsOffset + 32);
                for(let u = 0; u < urlsLength; u++){
                    const url = $6a1c8a35900dd937$var$_parseString(urlsData, u * 32);
                    if (url == null) $6a1c8a35900dd937$var$logger.throwError("CCIP Read contained corrupt URL string", (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
                        name: "OffchainLookup",
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        transaction: transaction,
                        data: result
                    });
                    urls.push(url);
                }
                // Get the CCIP calldata to forward
                const calldata = $6a1c8a35900dd937$var$_parseBytes(data, 64);
                // Get the callbackSelector (bytes4)
                if (!(0, $gMArf.BigNumber).from((0, $j2rU8.hexDataSlice)(data, 100, 128)).isZero()) $6a1c8a35900dd937$var$logger.throwError("CCIP Read callback selector included junk", (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const callbackSelector = (0, $j2rU8.hexDataSlice)(data, 96, 100);
                // Get the extra data to send back to the contract as context
                const extraData = $6a1c8a35900dd937$var$_parseBytes(data, 128);
                const ccipResult = yield this.ccipReadFetch(transaction, calldata, urls);
                if (ccipResult == null) $6a1c8a35900dd937$var$logger.throwError("CCIP Read disabled or provided no URLs", (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const tx = {
                    to: txSender,
                    data: (0, $j2rU8.hexConcat)([
                        callbackSelector,
                        $6a1c8a35900dd937$var$encodeBytes([
                            ccipResult,
                            extraData
                        ])
                    ])
                };
                return this._call(tx, blockTag, attempt + 1);
            } catch (error) {
                if (error.code === (0, $6M65e.Logger).errors.SERVER_ERROR) throw error;
            }
            try {
                return (0, $j2rU8.hexlify)(result);
            } catch (error) {
                return $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                    method: "call",
                    params: {
                        transaction: transaction,
                        blockTag: blockTag
                    },
                    result: result,
                    error: error
                });
            }
        });
    }
    call(transaction, blockTag) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const resolved = yield (0, $2ax4w.resolveProperties)({
                transaction: this._getTransactionRequest(transaction),
                blockTag: this._getBlockTag(blockTag),
                ccipReadEnabled: Promise.resolve(transaction.ccipReadEnabled)
            });
            return this._call(resolved.transaction, resolved.blockTag, resolved.ccipReadEnabled ? 0 : -1);
        });
    }
    estimateGas(transaction) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $2ax4w.resolveProperties)({
                transaction: this._getTransactionRequest(transaction)
            });
            const result = yield this.perform("estimateGas", params);
            try {
                return (0, $gMArf.BigNumber).from(result);
            } catch (error) {
                return $6a1c8a35900dd937$var$logger.throwError("bad result from backend", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                    method: "estimateGas",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    _getAddress(addressOrName) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            addressOrName = yield addressOrName;
            if (typeof addressOrName !== "string") $6a1c8a35900dd937$var$logger.throwArgumentError("invalid address or ENS name", "name", addressOrName);
            const address = yield this.resolveName(addressOrName);
            if (address == null) $6a1c8a35900dd937$var$logger.throwError("ENS name not configured", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: `resolveName(${JSON.stringify(addressOrName)})`
            });
            return address;
        });
    }
    _getBlock(blockHashOrBlockTag, includeTransactions) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            blockHashOrBlockTag = yield blockHashOrBlockTag;
            // If blockTag is a number (not "latest", etc), this is the block number
            let blockNumber = -128;
            const params = {
                includeTransactions: !!includeTransactions
            };
            if ((0, $j2rU8.isHexString)(blockHashOrBlockTag, 32)) params.blockHash = blockHashOrBlockTag;
            else try {
                params.blockTag = yield this._getBlockTag(blockHashOrBlockTag);
                if ((0, $j2rU8.isHexString)(params.blockTag)) blockNumber = parseInt(params.blockTag.substring(2), 16);
            } catch (error) {
                $6a1c8a35900dd937$var$logger.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
            }
            return (0, $gqL7R.poll)(()=>$6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
                    const block = yield this.perform("getBlock", params);
                    // Block was not found
                    if (block == null) {
                        // For blockhashes, if we didn't say it existed, that blockhash may
                        // not exist. If we did see it though, perhaps from a log, we know
                        // it exists, and this node is just not caught up yet.
                        if (params.blockHash != null) {
                            if (this._emitted["b:" + params.blockHash] == null) return null;
                        }
                        // For block tags, if we are asking for a future block, we return null
                        if (params.blockTag != null) {
                            if (blockNumber > this._emitted.block) return null;
                        }
                        // Retry on the next block
                        return undefined;
                    }
                    // Add transactions
                    if (includeTransactions) {
                        let blockNumber = null;
                        for(let i = 0; i < block.transactions.length; i++){
                            const tx = block.transactions[i];
                            if (tx.blockNumber == null) tx.confirmations = 0;
                            else if (tx.confirmations == null) {
                                if (blockNumber == null) blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                                // Add the confirmations using the fast block number (pessimistic)
                                let confirmations = blockNumber - tx.blockNumber + 1;
                                if (confirmations <= 0) confirmations = 1;
                                tx.confirmations = confirmations;
                            }
                        }
                        const blockWithTxs = this.formatter.blockWithTransactions(block);
                        blockWithTxs.transactions = blockWithTxs.transactions.map((tx)=>this._wrapTransaction(tx));
                        return blockWithTxs;
                    }
                    return this.formatter.block(block);
                }), {
                oncePoll: this
            });
        });
    }
    getBlock(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, false);
    }
    getBlockWithTransactions(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, true);
    }
    getTransaction(transactionHash) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $gqL7R.poll)(()=>$6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransaction", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    const tx = this.formatter.transactionResponse(result);
                    if (tx.blockNumber == null) tx.confirmations = 0;
                    else if (tx.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - tx.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        tx.confirmations = confirmations;
                    }
                    return this._wrapTransaction(tx);
                }), {
                oncePoll: this
            });
        });
    }
    getTransactionReceipt(transactionHash) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $gqL7R.poll)(()=>$6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransactionReceipt", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    // "geth-etc" returns receipts before they are ready
                    if (result.blockHash == null) return undefined;
                    const receipt = this.formatter.receipt(result);
                    if (receipt.blockNumber == null) receipt.confirmations = 0;
                    else if (receipt.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - receipt.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        receipt.confirmations = confirmations;
                    }
                    return receipt;
                }), {
                oncePoll: this
            });
        });
    }
    getLogs(filter) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $2ax4w.resolveProperties)({
                filter: this._getFilter(filter)
            });
            const logs = yield this.perform("getLogs", params);
            logs.forEach((log)=>{
                if (log.removed == null) log.removed = false;
            });
            return (0, $f1MgE.Formatter).arrayOf(this.formatter.filterLog.bind(this.formatter))(logs);
        });
    }
    getEtherPrice() {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            return this.perform("getEtherPrice", {});
        });
    }
    _getBlockTag(blockTag) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            blockTag = yield blockTag;
            if (typeof blockTag === "number" && blockTag < 0) {
                if (blockTag % 1) $6a1c8a35900dd937$var$logger.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
                let blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                blockNumber += blockTag;
                if (blockNumber < 0) blockNumber = 0;
                return this.formatter.blockTag(blockNumber);
            }
            return this.formatter.blockTag(blockTag);
        });
    }
    getResolver(name) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            let currentName = name;
            while(true){
                if (currentName === "" || currentName === ".") return null;
                // Optimization since the eth node cannot change and does
                // not have a wildcard resolver
                if (name !== "eth" && currentName === "eth") return null;
                // Check the current node for a resolver
                const addr = yield this._getResolver(currentName, "getResolver");
                // Found a resolver!
                if (addr != null) {
                    const resolver = new $6a1c8a35900dd937$export$8b4c839865b08288(this, addr, name);
                    // Legacy resolver found, using EIP-2544 so it isn't safe to use
                    if (currentName !== name && !(yield resolver.supportsWildcard())) return null;
                    return resolver;
                }
                // Get the parent node
                currentName = currentName.split(".").slice(1).join(".");
            }
        });
    }
    _getResolver(name, operation) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            if (operation == null) operation = "ENS";
            const network = yield this.getNetwork();
            // No ENS...
            if (!network.ensAddress) $6a1c8a35900dd937$var$logger.throwError("network does not support ENS", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: operation,
                network: network.name
            });
            try {
                // keccak256("resolver(bytes32)")
                const addrData = yield this.call({
                    to: network.ensAddress,
                    data: "0x0178b8bf" + (0, $4JdI5.namehash)(name).substring(2)
                });
                return this.formatter.callAddress(addrData);
            } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32)
            }
            return null;
        });
    }
    resolveName(name) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            name = yield name;
            // If it is already an address, nothing to resolve
            try {
                return Promise.resolve(this.formatter.address(name));
            } catch (error) {
                // If is is a hexstring, the address is bad (See #694)
                if ((0, $j2rU8.isHexString)(name)) throw error;
            }
            if (typeof name !== "string") $6a1c8a35900dd937$var$logger.throwArgumentError("invalid ENS name", "name", name);
            // Get the addr from the resolver
            const resolver = yield this.getResolver(name);
            if (!resolver) return null;
            return yield resolver.getAddress();
        });
    }
    lookupAddress(address) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            address = yield address;
            address = this.formatter.address(address);
            const node = address.substring(2).toLowerCase() + ".addr.reverse";
            const resolverAddr = yield this._getResolver(node, "lookupAddress");
            if (resolverAddr == null) return null;
            // keccak("name(bytes32)")
            const name = $6a1c8a35900dd937$var$_parseString((yield this.call({
                to: resolverAddr,
                data: "0x691f3431" + (0, $4JdI5.namehash)(node).substring(2)
            })), 0);
            const addr = yield this.resolveName(name);
            if (addr != address) return null;
            return name;
        });
    }
    getAvatar(nameOrAddress) {
        return $6a1c8a35900dd937$var$__awaiter(this, void 0, void 0, function*() {
            let resolver = null;
            if ((0, $j2rU8.isHexString)(nameOrAddress)) {
                // Address; reverse lookup
                const address = this.formatter.address(nameOrAddress);
                const node = address.substring(2).toLowerCase() + ".addr.reverse";
                const resolverAddress = yield this._getResolver(node, "getAvatar");
                if (!resolverAddress) return null;
                // Try resolving the avatar against the addr.reverse resolver
                resolver = new $6a1c8a35900dd937$export$8b4c839865b08288(this, resolverAddress, node);
                try {
                    const avatar = yield resolver.getAvatar();
                    if (avatar) return avatar.url;
                } catch (error) {
                    if (error.code !== (0, $6M65e.Logger).errors.CALL_EXCEPTION) throw error;
                }
                // Try getting the name and performing forward lookup; allowing wildcards
                try {
                    // keccak("name(bytes32)")
                    const name = $6a1c8a35900dd937$var$_parseString((yield this.call({
                        to: resolverAddress,
                        data: "0x691f3431" + (0, $4JdI5.namehash)(node).substring(2)
                    })), 0);
                    resolver = yield this.getResolver(name);
                } catch (error) {
                    if (error.code !== (0, $6M65e.Logger).errors.CALL_EXCEPTION) throw error;
                    return null;
                }
            } else {
                // ENS name; forward lookup with wildcard
                resolver = yield this.getResolver(nameOrAddress);
                if (!resolver) return null;
            }
            const avatar = yield resolver.getAvatar();
            if (avatar == null) return null;
            return avatar.url;
        });
    }
    perform(method, params) {
        return $6a1c8a35900dd937$var$logger.throwError(method + " not implemented", (0, $6M65e.Logger).errors.NOT_IMPLEMENTED, {
            operation: method
        });
    }
    _startEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _stopEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _addEventListener(eventName, listener, once) {
        const event = new $6a1c8a35900dd937$export$d61e24a684f9e51($6a1c8a35900dd937$var$getEventTag(eventName), listener, once);
        this._events.push(event);
        this._startEvent(event);
        return this;
    }
    on(eventName, listener) {
        return this._addEventListener(eventName, listener, false);
    }
    once(eventName, listener) {
        return this._addEventListener(eventName, listener, true);
    }
    emit(eventName, ...args) {
        let result = false;
        let stopped = [];
        let eventTag = $6a1c8a35900dd937$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag) return true;
            setTimeout(()=>{
                event.listener.apply(this, args);
            }, 0);
            result = true;
            if (event.once) {
                stopped.push(event);
                return false;
            }
            return true;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return result;
    }
    listenerCount(eventName) {
        if (!eventName) return this._events.length;
        let eventTag = $6a1c8a35900dd937$var$getEventTag(eventName);
        return this._events.filter((event)=>{
            return event.tag === eventTag;
        }).length;
    }
    listeners(eventName) {
        if (eventName == null) return this._events.map((event)=>event.listener);
        let eventTag = $6a1c8a35900dd937$var$getEventTag(eventName);
        return this._events.filter((event)=>event.tag === eventTag).map((event)=>event.listener);
    }
    off(eventName, listener) {
        if (listener == null) return this.removeAllListeners(eventName);
        const stopped = [];
        let found = false;
        let eventTag = $6a1c8a35900dd937$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag || event.listener != listener) return true;
            if (found) return true;
            found = true;
            stopped.push(event);
            return false;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
    removeAllListeners(eventName) {
        let stopped = [];
        if (eventName == null) {
            stopped = this._events;
            this._events = [];
        } else {
            const eventTag = $6a1c8a35900dd937$var$getEventTag(eventName);
            this._events = this._events.filter((event)=>{
                if (event.tag !== eventTag) return true;
                stopped.push(event);
                return false;
            });
        }
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
    /**
     *  ready
     *
     *  A Promise<Network> that resolves only once the provider is ready.
     *
     *  Sub-classes that call the super with a network without a chainId
     *  MUST set this. Standard named networks have a known chainId.
     *
     */ constructor(network){
        super();
        // Events being listened to
        this._events = [];
        this._emitted = {
            block: -2
        };
        this.disableCcipRead = false;
        this.formatter = new.target.getFormatter();
        // If network is any, this Provider allows the underlying
        // network to change dynamically, and we auto-detect the
        // current network
        (0, $2ax4w.defineReadOnly)(this, "anyNetwork", network === "any");
        if (this.anyNetwork) network = this.detectNetwork();
        if (network instanceof Promise) {
            this._networkPromise = network;
            // Squash any "unhandled promise" errors; that do not need to be handled
            network.catch((error)=>{});
            // Trigger initial network setting (async)
            this._ready().catch((error)=>{});
        } else {
            const knownNetwork = (0, $2ax4w.getStatic)(new.target, "getNetwork")(network);
            if (knownNetwork) {
                (0, $2ax4w.defineReadOnly)(this, "_network", knownNetwork);
                this.emit("network", knownNetwork, null);
            } else $6a1c8a35900dd937$var$logger.throwArgumentError("invalid network", "network", network);
        }
        this._maxInternalBlockNumber = -1024;
        this._lastBlockNumber = -2;
        this._maxFilterBlockRange = 10;
        this._pollingInterval = 4000;
        this._fastQueryDate = 0;
    }
}

});
parcelRegister("guCs7", function(module, exports) {
"use strict";
var $c01d4687d4f4d3ac$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
// pre-compute lookup table
var $c01d4687d4f4d3ac$var$ALPHABET_MAP = {};
for(var $c01d4687d4f4d3ac$var$z = 0; $c01d4687d4f4d3ac$var$z < $c01d4687d4f4d3ac$var$ALPHABET.length; $c01d4687d4f4d3ac$var$z++){
    var $c01d4687d4f4d3ac$var$x = $c01d4687d4f4d3ac$var$ALPHABET.charAt($c01d4687d4f4d3ac$var$z);
    if ($c01d4687d4f4d3ac$var$ALPHABET_MAP[$c01d4687d4f4d3ac$var$x] !== undefined) throw new TypeError($c01d4687d4f4d3ac$var$x + " is ambiguous");
    $c01d4687d4f4d3ac$var$ALPHABET_MAP[$c01d4687d4f4d3ac$var$x] = $c01d4687d4f4d3ac$var$z;
}
function $c01d4687d4f4d3ac$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $c01d4687d4f4d3ac$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $c01d4687d4f4d3ac$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $c01d4687d4f4d3ac$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $c01d4687d4f4d3ac$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $c01d4687d4f4d3ac$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $c01d4687d4f4d3ac$var$prefixChk(prefix);
    if (typeof chk === "string") throw new Error(chk);
    var result = prefix + "1";
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error("Non 5-bit word");
        chk = $c01d4687d4f4d3ac$var$polymodStep(chk) ^ x;
        result += $c01d4687d4f4d3ac$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $c01d4687d4f4d3ac$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $c01d4687d4f4d3ac$var$ALPHABET.charAt(v);
    }
    return result;
}
function $c01d4687d4f4d3ac$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + " too short";
    if (str.length > LIMIT) return "Exceeds length limit";
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
    str = lowered;
    var split = str.lastIndexOf("1");
    if (split === -1) return "No separator character for " + str;
    if (split === 0) return "Missing prefix for " + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return "Data too short";
    var chk = $c01d4687d4f4d3ac$var$prefixChk(prefix);
    if (typeof chk === "string") return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $c01d4687d4f4d3ac$var$ALPHABET_MAP[c];
        if (v === undefined) return "Unknown character " + c;
        chk = $c01d4687d4f4d3ac$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return "Invalid checksum for " + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $c01d4687d4f4d3ac$var$decodeUnsafe() {
    var res = $c01d4687d4f4d3ac$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
}
function $c01d4687d4f4d3ac$var$decode(str) {
    var res = $c01d4687d4f4d3ac$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
    throw new Error(res);
}
function $c01d4687d4f4d3ac$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $c01d4687d4f4d3ac$var$toWordsUnsafe(bytes) {
    var res = $c01d4687d4f4d3ac$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $c01d4687d4f4d3ac$var$toWords(bytes) {
    var res = $c01d4687d4f4d3ac$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $c01d4687d4f4d3ac$var$fromWordsUnsafe(words) {
    var res = $c01d4687d4f4d3ac$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $c01d4687d4f4d3ac$var$fromWords(words) {
    var res = $c01d4687d4f4d3ac$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
module.exports = {
    decodeUnsafe: $c01d4687d4f4d3ac$var$decodeUnsafe,
    decode: $c01d4687d4f4d3ac$var$decode,
    encode: $c01d4687d4f4d3ac$var$encode,
    toWordsUnsafe: $c01d4687d4f4d3ac$var$toWordsUnsafe,
    toWords: $c01d4687d4f4d3ac$var$toWords,
    fromWordsUnsafe: $c01d4687d4f4d3ac$var$fromWordsUnsafe,
    fromWords: $c01d4687d4f4d3ac$var$fromWords
};

});

parcelRegister("iEaZ1", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $d9347b79faa289ba$export$83d89fbfd8236492; });
const $d9347b79faa289ba$export$83d89fbfd8236492 = "providers/5.7.2";

});

parcelRegister("f1MgE", function(module, exports) {

$parcel$export(module.exports, "Formatter", function () { return $af0c63f6ba6ab466$export$a06636add2a09fd8; });
$parcel$export(module.exports, "isCommunityResourcable", function () { return $af0c63f6ba6ab466$export$3091239f5b20b896; });
$parcel$export(module.exports, "isCommunityResource", function () { return $af0c63f6ba6ab466$export$d93d5f61c2498b6; });
$parcel$export(module.exports, "showThrottleMessage", function () { return $af0c63f6ba6ab466$export$4c41bd49e82e82ab; });

var $e8NrM = parcelRequire("e8NrM");

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $5f6Sj = parcelRequire("5f6Sj");

var $2ax4w = parcelRequire("2ax4w");

var $hDQeE = parcelRequire("hDQeE");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");
"use strict";
const $af0c63f6ba6ab466$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
class $af0c63f6ba6ab466$export$a06636add2a09fd8 {
    getDefaultFormats() {
        const formats = {};
        const address = this.address.bind(this);
        const bigNumber = this.bigNumber.bind(this);
        const blockTag = this.blockTag.bind(this);
        const data = this.data.bind(this);
        const hash = this.hash.bind(this);
        const hex = this.hex.bind(this);
        const number = this.number.bind(this);
        const type = this.type.bind(this);
        const strictData = (v)=>{
            return this.data(v, true);
        };
        formats.transaction = {
            hash: hash,
            type: type,
            accessList: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null),
            blockHash: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(hash, null),
            blockNumber: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number, null),
            transactionIndex: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number, null),
            confirmations: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number, null),
            from: address,
            // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
            // must be set
            gasPrice: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            gasLimit: bigNumber,
            to: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(address, null),
            value: bigNumber,
            nonce: number,
            data: data,
            r: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(this.uint256),
            s: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(this.uint256),
            v: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number),
            creates: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(address, null),
            raw: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(data)
        };
        formats.transactionRequest = {
            from: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(address),
            nonce: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number),
            gasLimit: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            gasPrice: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            to: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(address),
            value: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            data: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(strictData),
            type: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number),
            accessList: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null)
        };
        formats.receiptLog = {
            transactionIndex: number,
            blockNumber: number,
            transactionHash: hash,
            address: address,
            topics: $af0c63f6ba6ab466$export$a06636add2a09fd8.arrayOf(hash),
            data: data,
            logIndex: number,
            blockHash: hash
        };
        formats.receipt = {
            to: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(this.address, null),
            from: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(this.address, null),
            contractAddress: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(address, null),
            transactionIndex: number,
            // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
            root: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(hex),
            gasUsed: bigNumber,
            logsBloom: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(data),
            blockHash: hash,
            transactionHash: hash,
            logs: $af0c63f6ba6ab466$export$a06636add2a09fd8.arrayOf(this.receiptLog.bind(this)),
            blockNumber: number,
            confirmations: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number, null),
            cumulativeGasUsed: bigNumber,
            effectiveGasPrice: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber),
            status: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number),
            type: type
        };
        formats.block = {
            hash: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(hash),
            parentHash: hash,
            number: number,
            timestamp: number,
            nonce: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(hex),
            difficulty: this.difficulty.bind(this),
            gasLimit: bigNumber,
            gasUsed: bigNumber,
            miner: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(address),
            extraData: data,
            transactions: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull($af0c63f6ba6ab466$export$a06636add2a09fd8.arrayOf(hash)),
            baseFeePerGas: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(bigNumber)
        };
        formats.blockWithTransactions = (0, $2ax4w.shallowCopy)(formats.block);
        formats.blockWithTransactions.transactions = $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull($af0c63f6ba6ab466$export$a06636add2a09fd8.arrayOf(this.transactionResponse.bind(this)));
        formats.filter = {
            fromBlock: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            toBlock: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            blockHash: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(hash, undefined),
            address: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(address, undefined),
            topics: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(this.topics.bind(this), undefined)
        };
        formats.filterLog = {
            blockNumber: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(number),
            blockHash: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(hash),
            transactionIndex: number,
            removed: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowNull(this.boolean.bind(this)),
            address: address,
            data: $af0c63f6ba6ab466$export$a06636add2a09fd8.allowFalsish(data, "0x"),
            topics: $af0c63f6ba6ab466$export$a06636add2a09fd8.arrayOf(hash),
            transactionHash: hash,
            logIndex: number
        };
        return formats;
    }
    accessList(accessList) {
        return (0, $hDQeE.accessListify)(accessList || []);
    }
    // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
    // Strict! Used on input.
    number(number) {
        if (number === "0x") return 0;
        return (0, $gMArf.BigNumber).from(number).toNumber();
    }
    type(number) {
        if (number === "0x" || number == null) return 0;
        return (0, $gMArf.BigNumber).from(number).toNumber();
    }
    // Strict! Used on input.
    bigNumber(value) {
        return (0, $gMArf.BigNumber).from(value);
    }
    // Requires a boolean, "true" or  "false"; returns a boolean
    boolean(value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "string") {
            value = value.toLowerCase();
            if (value === "true") return true;
            if (value === "false") return false;
        }
        throw new Error("invalid boolean - " + value);
    }
    hex(value, strict) {
        if (typeof value === "string") {
            if (!strict && value.substring(0, 2) !== "0x") value = "0x" + value;
            if ((0, $j2rU8.isHexString)(value)) return value.toLowerCase();
        }
        return $af0c63f6ba6ab466$var$logger.throwArgumentError("invalid hash", "value", value);
    }
    data(value, strict) {
        const result = this.hex(value, strict);
        if (result.length % 2 !== 0) throw new Error("invalid data; odd-length - " + value);
        return result;
    }
    // Requires an address
    // Strict! Used on input.
    address(value) {
        return (0, $e8NrM.getAddress)(value);
    }
    callAddress(value) {
        if (!(0, $j2rU8.isHexString)(value, 32)) return null;
        const address = (0, $e8NrM.getAddress)((0, $j2rU8.hexDataSlice)(value, 12));
        return address === (0, $5f6Sj.AddressZero) ? null : address;
    }
    contractAddress(value) {
        return (0, $e8NrM.getContractAddress)(value);
    }
    // Strict! Used on input.
    blockTag(blockTag) {
        if (blockTag == null) return "latest";
        if (blockTag === "earliest") return "0x0";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "latest":
            case "pending":
            case "safe":
            case "finalized":
                return blockTag;
        }
        if (typeof blockTag === "number" || (0, $j2rU8.isHexString)(blockTag)) return (0, $j2rU8.hexValue)(blockTag);
        throw new Error("invalid blockTag");
    }
    // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
    hash(value, strict) {
        const result = this.hex(value, strict);
        if ((0, $j2rU8.hexDataLength)(result) !== 32) return $af0c63f6ba6ab466$var$logger.throwArgumentError("invalid hash", "value", value);
        return result;
    }
    // Returns the difficulty as a number, or if too large (i.e. PoA network) null
    difficulty(value) {
        if (value == null) return null;
        const v = (0, $gMArf.BigNumber).from(value);
        try {
            return v.toNumber();
        } catch (error) {}
        return null;
    }
    uint256(value) {
        if (!(0, $j2rU8.isHexString)(value)) throw new Error("invalid uint256");
        return (0, $j2rU8.hexZeroPad)(value, 32);
    }
    _block(value, format) {
        if (value.author != null && value.miner == null) value.miner = value.author;
        // The difficulty may need to come from _difficulty in recursed blocks
        const difficulty = value._difficulty != null ? value._difficulty : value.difficulty;
        const result = $af0c63f6ba6ab466$export$a06636add2a09fd8.check(format, value);
        result._difficulty = difficulty == null ? null : (0, $gMArf.BigNumber).from(difficulty);
        return result;
    }
    block(value) {
        return this._block(value, this.formats.block);
    }
    blockWithTransactions(value) {
        return this._block(value, this.formats.blockWithTransactions);
    }
    // Strict! Used on input.
    transactionRequest(value) {
        return $af0c63f6ba6ab466$export$a06636add2a09fd8.check(this.formats.transactionRequest, value);
    }
    transactionResponse(transaction) {
        // Rename gas to gasLimit
        if (transaction.gas != null && transaction.gasLimit == null) transaction.gasLimit = transaction.gas;
        // Some clients (TestRPC) do strange things like return 0x0 for the
        // 0 address; correct this to be a real address
        if (transaction.to && (0, $gMArf.BigNumber).from(transaction.to).isZero()) transaction.to = "0x0000000000000000000000000000000000000000";
        // Rename input to data
        if (transaction.input != null && transaction.data == null) transaction.data = transaction.input;
        // If to and creates are empty, populate the creates from the transaction
        if (transaction.to == null && transaction.creates == null) transaction.creates = this.contractAddress(transaction);
        if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) transaction.accessList = [];
        const result = $af0c63f6ba6ab466$export$a06636add2a09fd8.check(this.formats.transaction, transaction);
        if (transaction.chainId != null) {
            let chainId = transaction.chainId;
            if ((0, $j2rU8.isHexString)(chainId)) chainId = (0, $gMArf.BigNumber).from(chainId).toNumber();
            result.chainId = chainId;
        } else {
            let chainId = transaction.networkId;
            // geth-etc returns chainId
            if (chainId == null && result.v == null) chainId = transaction.chainId;
            if ((0, $j2rU8.isHexString)(chainId)) chainId = (0, $gMArf.BigNumber).from(chainId).toNumber();
            if (typeof chainId !== "number" && result.v != null) {
                chainId = (result.v - 35) / 2;
                if (chainId < 0) chainId = 0;
                chainId = parseInt(chainId);
            }
            if (typeof chainId !== "number") chainId = 0;
            result.chainId = chainId;
        }
        // 0x0000... should actually be null
        if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") result.blockHash = null;
        return result;
    }
    transaction(value) {
        return (0, $hDQeE.parse)(value);
    }
    receiptLog(value) {
        return $af0c63f6ba6ab466$export$a06636add2a09fd8.check(this.formats.receiptLog, value);
    }
    receipt(value) {
        const result = $af0c63f6ba6ab466$export$a06636add2a09fd8.check(this.formats.receipt, value);
        // RSK incorrectly implemented EIP-658, so we munge things a bit here for it
        if (result.root != null) {
            if (result.root.length <= 4) {
                // Could be 0x00, 0x0, 0x01 or 0x1
                const value = (0, $gMArf.BigNumber).from(result.root).toNumber();
                if (value === 0 || value === 1) {
                    // Make sure if both are specified, they match
                    if (result.status != null && result.status !== value) $af0c63f6ba6ab466$var$logger.throwArgumentError("alt-root-status/status mismatch", "value", {
                        root: result.root,
                        status: result.status
                    });
                    result.status = value;
                    delete result.root;
                } else $af0c63f6ba6ab466$var$logger.throwArgumentError("invalid alt-root-status", "value.root", result.root);
            } else if (result.root.length !== 66) // Must be a valid bytes32
            $af0c63f6ba6ab466$var$logger.throwArgumentError("invalid root hash", "value.root", result.root);
        }
        if (result.status != null) result.byzantium = true;
        return result;
    }
    topics(value) {
        if (Array.isArray(value)) return value.map((v)=>this.topics(v));
        else if (value != null) return this.hash(value, true);
        return null;
    }
    filter(value) {
        return $af0c63f6ba6ab466$export$a06636add2a09fd8.check(this.formats.filter, value);
    }
    filterLog(value) {
        return $af0c63f6ba6ab466$export$a06636add2a09fd8.check(this.formats.filterLog, value);
    }
    static check(format, object) {
        const result = {};
        for(const key in format)try {
            const value = format[key](object[key]);
            if (value !== undefined) result[key] = value;
        } catch (error) {
            error.checkKey = key;
            error.checkValue = object[key];
            throw error;
        }
        return result;
    }
    // if value is null-ish, nullValue is returned
    static allowNull(format, nullValue) {
        return function(value) {
            if (value == null) return nullValue;
            return format(value);
        };
    }
    // If value is false-ish, replaceValue is returned
    static allowFalsish(format, replaceValue) {
        return function(value) {
            if (!value) return replaceValue;
            return format(value);
        };
    }
    // Requires an Array satisfying check
    static arrayOf(format) {
        return function(array) {
            if (!Array.isArray(array)) throw new Error("not an array");
            const result = [];
            array.forEach(function(value) {
                result.push(format(value));
            });
            return result;
        };
    }
    constructor(){
        this.formats = this.getDefaultFormats();
    }
}
function $af0c63f6ba6ab466$export$3091239f5b20b896(value) {
    return value && typeof value.isCommunityResource === "function";
}
function $af0c63f6ba6ab466$export$d93d5f61c2498b6(value) {
    return $af0c63f6ba6ab466$export$3091239f5b20b896(value) && value.isCommunityResource();
}
// Show the throttle message only once
let $af0c63f6ba6ab466$var$throttleMessage = false;
function $af0c63f6ba6ab466$export$4c41bd49e82e82ab() {
    if ($af0c63f6ba6ab466$var$throttleMessage) return;
    $af0c63f6ba6ab466$var$throttleMessage = true;
    console.log("========= NOTICE =========");
    console.log("Request-Rate Exceeded  (this message will not be repeated)");
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https://docs.ethers.io/api-keys/");
    console.log("==========================");
}

});


parcelRegister("d8HAg", function(module, exports) {

$parcel$export(module.exports, "AlchemyWebSocketProvider", function () { return $990dd48e125b1d3c$export$f6c13301c7b76371; });
$parcel$export(module.exports, "AlchemyProvider", function () { return $990dd48e125b1d3c$export$999cc40da3fbc6f; });

var $2ax4w = parcelRequire("2ax4w");

var $f1MgE = parcelRequire("f1MgE");

var $dCAfX = parcelRequire("dCAfX");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");

var $jLiNX = parcelRequire("jLiNX");
"use strict";
const $990dd48e125b1d3c$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
// This key was provided to ethers.js by Alchemy to be used by the
// default provider, but it is recommended that for your own
// production environments, that you acquire your own API key at:
//   https://dashboard.alchemyapi.io
const $990dd48e125b1d3c$var$defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
class $990dd48e125b1d3c$export$f6c13301c7b76371 extends (0, $dCAfX.WebSocketProvider) {
    isCommunityResource() {
        return this.apiKey === $990dd48e125b1d3c$var$defaultApiKey;
    }
    constructor(network, apiKey){
        const provider = new $990dd48e125b1d3c$export$999cc40da3fbc6f(network, apiKey);
        const url = provider.connection.url.replace(/^http/i, "ws").replace(".alchemyapi.", ".ws.alchemyapi.");
        super(url, provider.network);
        (0, $2ax4w.defineReadOnly)(this, "apiKey", provider.apiKey);
    }
}
class $990dd48e125b1d3c$export$999cc40da3fbc6f extends (0, $jLiNX.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $990dd48e125b1d3c$export$f6c13301c7b76371(network, apiKey);
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $990dd48e125b1d3c$var$defaultApiKey;
        if (apiKey && typeof apiKey !== "string") $990dd48e125b1d3c$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "eth-mainnet.alchemyapi.io/v2/";
                break;
            case "goerli":
                host = "eth-goerli.g.alchemy.com/v2/";
                break;
            case "matic":
                host = "polygon-mainnet.g.alchemy.com/v2/";
                break;
            case "maticmum":
                host = "polygon-mumbai.g.alchemy.com/v2/";
                break;
            case "arbitrum":
                host = "arb-mainnet.g.alchemy.com/v2/";
                break;
            case "arbitrum-goerli":
                host = "arb-goerli.g.alchemy.com/v2/";
                break;
            case "optimism":
                host = "opt-mainnet.g.alchemy.com/v2/";
                break;
            case "optimism-goerli":
                host = "opt-goerli.g.alchemy.com/v2/";
                break;
            default:
                $990dd48e125b1d3c$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return {
            allowGzip: true,
            url: "https://" + host + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey === $990dd48e125b1d3c$var$defaultApiKey) (0, $f1MgE.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
    }
    isCommunityResource() {
        return this.apiKey === $990dd48e125b1d3c$var$defaultApiKey;
    }
}

});
parcelRegister("dCAfX", function(module, exports) {

$parcel$export(module.exports, "WebSocketProvider", function () { return $9eaaf2b70511b007$export$bfafe629242f30bd; });

var $gMArf = parcelRequire("gMArf");

var $2ax4w = parcelRequire("2ax4w");

var $aDPpa = parcelRequire("aDPpa");

var $hiXBj = parcelRequire("hiXBj");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");
"use strict";
var $9eaaf2b70511b007$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $9eaaf2b70511b007$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
/**
 *  Notes:
 *
 *  This provider differs a bit from the polling providers. One main
 *  difference is how it handles consistency. The polling providers
 *  will stall responses to ensure a consistent state, while this
 *  WebSocket provider assumes the connected backend will manage this.
 *
 *  For example, if a polling provider emits an event which indicates
 *  the event occurred in blockhash XXX, a call to fetch that block by
 *  its hash XXX, if not present will retry until it is present. This
 *  can occur when querying a pool of nodes that are mildly out of sync
 *  with each other.
 */ let $9eaaf2b70511b007$var$NextId = 1;
class $9eaaf2b70511b007$export$bfafe629242f30bd extends (0, $aDPpa.JsonRpcProvider) {
    // Cannot narrow the type of _websocket, as that is not backwards compatible
    // so we add a getter and let the WebSocket be a public API.
    get websocket() {
        return this._websocket;
    }
    detectNetwork() {
        return this._detectNetwork;
    }
    get pollingInterval() {
        return 0;
    }
    resetEventsBlock(blockNumber) {
        $9eaaf2b70511b007$var$logger.throwError("cannot reset events block on WebSocketProvider", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "resetEventBlock"
        });
    }
    set pollingInterval(value) {
        $9eaaf2b70511b007$var$logger.throwError("cannot set polling interval on WebSocketProvider", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "setPollingInterval"
        });
    }
    poll() {
        return $9eaaf2b70511b007$var$__awaiter(this, void 0, void 0, function*() {
            return null;
        });
    }
    set polling(value) {
        if (!value) return;
        $9eaaf2b70511b007$var$logger.throwError("cannot set polling on WebSocketProvider", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "setPolling"
        });
    }
    send(method, params) {
        const rid = $9eaaf2b70511b007$var$NextId++;
        return new Promise((resolve, reject)=>{
            function callback(error, result) {
                if (error) return reject(error);
                return resolve(result);
            }
            const payload = JSON.stringify({
                method: method,
                params: params,
                id: rid,
                jsonrpc: "2.0"
            });
            this.emit("debug", {
                action: "request",
                request: JSON.parse(payload),
                provider: this
            });
            this._requests[String(rid)] = {
                callback: callback,
                payload: payload
            };
            if (this._wsReady) this.websocket.send(payload);
        });
    }
    static defaultUrl() {
        return "ws://localhost:8546";
    }
    _subscribe(tag, param, processFunc) {
        return $9eaaf2b70511b007$var$__awaiter(this, void 0, void 0, function*() {
            let subIdPromise = this._subIds[tag];
            if (subIdPromise == null) {
                subIdPromise = Promise.all(param).then((param)=>{
                    return this.send("eth_subscribe", param);
                });
                this._subIds[tag] = subIdPromise;
            }
            const subId = yield subIdPromise;
            this._subs[subId] = {
                tag: tag,
                processFunc: processFunc
            };
        });
    }
    _startEvent(event) {
        switch(event.type){
            case "block":
                this._subscribe("block", [
                    "newHeads"
                ], (result)=>{
                    const blockNumber = (0, $gMArf.BigNumber).from(result.number).toNumber();
                    this._emitted.block = blockNumber;
                    this.emit("block", blockNumber);
                });
                break;
            case "pending":
                this._subscribe("pending", [
                    "newPendingTransactions"
                ], (result)=>{
                    this.emit("pending", result);
                });
                break;
            case "filter":
                this._subscribe(event.tag, [
                    "logs",
                    this._getFilter(event.filter)
                ], (result)=>{
                    if (result.removed == null) result.removed = false;
                    this.emit(event.filter, this.formatter.filterLog(result));
                });
                break;
            case "tx":
                {
                    const emitReceipt = (event)=>{
                        const hash = event.hash;
                        this.getTransactionReceipt(hash).then((receipt)=>{
                            if (!receipt) return;
                            this.emit(hash, receipt);
                        });
                    };
                    // In case it is already mined
                    emitReceipt(event);
                    // To keep things simple, we start up a single newHeads subscription
                    // to keep an eye out for transactions we are watching for.
                    // Starting a subscription for an event (i.e. "tx") that is already
                    // running is (basically) a nop.
                    this._subscribe("tx", [
                        "newHeads"
                    ], (result)=>{
                        this._events.filter((e)=>e.type === "tx").forEach(emitReceipt);
                    });
                    break;
                }
            // Nothing is needed
            case "debug":
            case "poll":
            case "willPoll":
            case "didPoll":
            case "error":
                break;
            default:
                console.log("unhandled:", event);
                break;
        }
    }
    _stopEvent(event) {
        let tag = event.tag;
        if (event.type === "tx") {
            // There are remaining transaction event listeners
            if (this._events.filter((e)=>e.type === "tx").length) return;
            tag = "tx";
        } else if (this.listenerCount(event.event)) // There are remaining event listeners
        return;
        const subId = this._subIds[tag];
        if (!subId) return;
        delete this._subIds[tag];
        subId.then((subId)=>{
            if (!this._subs[subId]) return;
            delete this._subs[subId];
            this.send("eth_unsubscribe", [
                subId
            ]);
        });
    }
    destroy() {
        return $9eaaf2b70511b007$var$__awaiter(this, void 0, void 0, function*() {
            // Wait until we have connected before trying to disconnect
            if (this.websocket.readyState === (0, $hiXBj.WebSocket).CONNECTING) yield new Promise((resolve)=>{
                this.websocket.onopen = function() {
                    resolve(true);
                };
                this.websocket.onerror = function() {
                    resolve(false);
                };
            });
            // Hangup
            // See: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
            this.websocket.close(1000);
        });
    }
    constructor(url, network){
        // This will be added in the future; please open an issue to expedite
        if (network === "any") $9eaaf2b70511b007$var$logger.throwError("WebSocketProvider does not support 'any' network yet", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "network:any"
        });
        if (typeof url === "string") super(url, network);
        else super("_websocket", network);
        this._pollingInterval = -1;
        this._wsReady = false;
        if (typeof url === "string") (0, $2ax4w.defineReadOnly)(this, "_websocket", new (0, $hiXBj.WebSocket)(this.connection.url));
        else (0, $2ax4w.defineReadOnly)(this, "_websocket", url);
        (0, $2ax4w.defineReadOnly)(this, "_requests", {});
        (0, $2ax4w.defineReadOnly)(this, "_subs", {});
        (0, $2ax4w.defineReadOnly)(this, "_subIds", {});
        (0, $2ax4w.defineReadOnly)(this, "_detectNetwork", super.detectNetwork());
        // Stall sending requests until the socket is open...
        this.websocket.onopen = ()=>{
            this._wsReady = true;
            Object.keys(this._requests).forEach((id)=>{
                this.websocket.send(this._requests[id].payload);
            });
        };
        this.websocket.onmessage = (messageEvent)=>{
            const data = messageEvent.data;
            const result = JSON.parse(data);
            if (result.id != null) {
                const id = String(result.id);
                const request = this._requests[id];
                delete this._requests[id];
                if (result.result !== undefined) {
                    request.callback(null, result.result);
                    this.emit("debug", {
                        action: "response",
                        request: JSON.parse(request.payload),
                        response: result.result,
                        provider: this
                    });
                } else {
                    let error = null;
                    if (result.error) {
                        error = new Error(result.error.message || "unknown error");
                        (0, $2ax4w.defineReadOnly)(error, "code", result.error.code || null);
                        (0, $2ax4w.defineReadOnly)(error, "response", data);
                    } else error = new Error("unknown error");
                    request.callback(error, undefined);
                    this.emit("debug", {
                        action: "response",
                        error: error,
                        request: JSON.parse(request.payload),
                        provider: this
                    });
                }
            } else if (result.method === "eth_subscription") {
                // Subscription...
                const sub = this._subs[result.params.subscription];
                if (sub) //this.emit.apply(this,                  );
                sub.processFunc(result.params.result);
            } else console.warn("this should not happen");
        };
        // This Provider does not actually poll, but we want to trigger
        // poll events for things that depend on them (like stalling for
        // block and transaction lookups)
        const fauxPoll = setInterval(()=>{
            this.emit("poll");
        }, 1000);
        if (fauxPoll.unref) fauxPoll.unref();
    }
}

});
parcelRegister("aDPpa", function(module, exports) {

$parcel$export(module.exports, "JsonRpcSigner", function () { return $7bf56bd7b17e0046$export$5f7b5fca3508545a; });
$parcel$export(module.exports, "JsonRpcProvider", function () { return $7bf56bd7b17e0046$export$da28308012bf6748; });

var $iGUqv = parcelRequire("iGUqv");

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $kdj79 = parcelRequire("kdj79");

var $2ax4w = parcelRequire("2ax4w");

var $1Wmc7 = parcelRequire("1Wmc7");

var $hDQeE = parcelRequire("hDQeE");

var $gqL7R = parcelRequire("gqL7R");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");

var $96Por = parcelRequire("96Por");
"use strict";
var $7bf56bd7b17e0046$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $7bf56bd7b17e0046$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
const $7bf56bd7b17e0046$var$errorGas = [
    "call",
    "estimateGas"
];
function $7bf56bd7b17e0046$var$spelunk(value, requireData) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match("reverted")) {
        const data = (0, $j2rU8.isHexString)(value.data) ? value.data : null;
        if (!requireData || data) return {
            message: value.message,
            data: data
        };
    }
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $7bf56bd7b17e0046$var$spelunk(value[key], requireData);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $7bf56bd7b17e0046$var$spelunk(JSON.parse(value), requireData);
    } catch (error) {}
    return null;
}
function $7bf56bd7b17e0046$var$checkError(method, error, params) {
    const transaction = params.transaction || params.signedTransaction;
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call") {
        const result = $7bf56bd7b17e0046$var$spelunk(error, true);
        if (result) return result.data;
        // Nothing descriptive..
        $7bf56bd7b17e0046$var$logger.throwError("missing revert data in call exception; Transaction reverted without a reason string", (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
            data: "0x",
            transaction: transaction,
            error: error
        });
    }
    if (method === "estimateGas") {
        // Try to find something, with a preference on SERVER_ERROR body
        let result = $7bf56bd7b17e0046$var$spelunk(error.body, false);
        if (result == null) result = $7bf56bd7b17e0046$var$spelunk(error, false);
        // Found "reverted", this is a CALL_EXCEPTION
        if (result) $7bf56bd7b17e0046$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $6M65e.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
            reason: result.message,
            method: method,
            transaction: transaction,
            error: error
        });
    }
    // @TODO: Should we spelunk for message too?
    let message = error.message;
    if (error.code === (0, $6M65e.Logger).errors.SERVER_ERROR && error.error && typeof error.error.message === "string") message = error.error.message;
    else if (typeof error.body === "string") message = error.body;
    else if (typeof error.responseText === "string") message = error.responseText;
    message = (message || "").toLowerCase();
    // "insufficient funds for gas * price + value + cost(data)"
    if (message.match(/insufficient funds|base fee exceeds gas limit|InsufficientFunds/i)) $7bf56bd7b17e0046$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $6M65e.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "nonce too low"
    if (message.match(/nonce (is )?too low/i)) $7bf56bd7b17e0046$var$logger.throwError("nonce has already been used", (0, $6M65e.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/replacement transaction underpriced|transaction gas price.*too low/i)) $7bf56bd7b17e0046$var$logger.throwError("replacement fee too low", (0, $6M65e.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/only replay-protected/i)) $7bf56bd7b17e0046$var$logger.throwError("legacy pre-eip-155 transactions not supported", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
        error: error,
        method: method,
        transaction: transaction
    });
    if ($7bf56bd7b17e0046$var$errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted|revert/)) $7bf56bd7b17e0046$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $6M65e.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
function $7bf56bd7b17e0046$var$timer(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $7bf56bd7b17e0046$var$getResult(payload) {
    if (payload.error) {
        // @TODO: not any
        const error = new Error(payload.error.message);
        error.code = payload.error.code;
        error.data = payload.error.data;
        throw error;
    }
    return payload.result;
}
function $7bf56bd7b17e0046$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
const $7bf56bd7b17e0046$var$_constructorGuard = {};
class $7bf56bd7b17e0046$export$5f7b5fca3508545a extends (0, $iGUqv.Signer) {
    connect(provider) {
        return $7bf56bd7b17e0046$var$logger.throwError("cannot alter JSON-RPC Signer connection", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "connect"
        });
    }
    connectUnchecked() {
        return new $7bf56bd7b17e0046$var$UncheckedJsonRpcSigner($7bf56bd7b17e0046$var$_constructorGuard, this.provider, this._address || this._index);
    }
    getAddress() {
        if (this._address) return Promise.resolve(this._address);
        return this.provider.send("eth_accounts", []).then((accounts)=>{
            if (accounts.length <= this._index) $7bf56bd7b17e0046$var$logger.throwError("unknown account #" + this._index, (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "getAddress"
            });
            return this.provider.formatter.address(accounts[this._index]);
        });
    }
    sendUncheckedTransaction(transaction) {
        transaction = (0, $2ax4w.shallowCopy)(transaction);
        const fromAddress = this.getAddress().then((address)=>{
            if (address) address = address.toLowerCase();
            return address;
        });
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (transaction.gasLimit == null) {
            const estimate = (0, $2ax4w.shallowCopy)(transaction);
            estimate.from = fromAddress;
            transaction.gasLimit = this.provider.estimateGas(estimate);
        }
        if (transaction.to != null) transaction.to = Promise.resolve(transaction.to).then((to)=>$7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
                if (to == null) return null;
                const address = yield this.provider.resolveName(to);
                if (address == null) $7bf56bd7b17e0046$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                return address;
            }));
        return (0, $2ax4w.resolveProperties)({
            tx: (0, $2ax4w.resolveProperties)(transaction),
            sender: fromAddress
        }).then(({ tx: tx, sender: sender })=>{
            if (tx.from != null) {
                if (tx.from.toLowerCase() !== sender) $7bf56bd7b17e0046$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            } else tx.from = sender;
            const hexTx = this.provider.constructor.hexlifyTransaction(tx, {
                from: true
            });
            return this.provider.send("eth_sendTransaction", [
                hexTx
            ]).then((hash)=>{
                return hash;
            }, (error)=>{
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $7bf56bd7b17e0046$var$logger.throwError("user rejected transaction", (0, $6M65e.Logger).errors.ACTION_REJECTED, {
                    action: "sendTransaction",
                    transaction: tx
                });
                return $7bf56bd7b17e0046$var$checkError("sendTransaction", error, hexTx);
            });
        });
    }
    signTransaction(transaction) {
        return $7bf56bd7b17e0046$var$logger.throwError("signing transactions is unsupported", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "signTransaction"
        });
    }
    sendTransaction(transaction) {
        return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
            // This cannot be mined any earlier than any recent block
            const blockNumber = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval);
            // Send the transaction
            const hash = yield this.sendUncheckedTransaction(transaction);
            try {
                // Unfortunately, JSON-RPC only provides and opaque transaction hash
                // for a response, and we need the actual transaction, so we poll
                // for it; it should show up very quickly
                return yield (0, $gqL7R.poll)(()=>$7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
                        const tx = yield this.provider.getTransaction(hash);
                        if (tx === null) return undefined;
                        return this.provider._wrapTransaction(tx, hash, blockNumber);
                    }), {
                    oncePoll: this.provider
                });
            } catch (error) {
                error.transactionHash = hash;
                throw error;
            }
        });
    }
    signMessage(message) {
        return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $1Wmc7.toUtf8Bytes)(message) : message;
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("personal_sign", [
                    (0, $j2rU8.hexlify)(data),
                    address.toLowerCase()
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $7bf56bd7b17e0046$var$logger.throwError("user rejected signing", (0, $6M65e.Logger).errors.ACTION_REJECTED, {
                    action: "signMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _legacySignMessage(message) {
        return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $1Wmc7.toUtf8Bytes)(message) : message;
            const address = yield this.getAddress();
            try {
                // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
                return yield this.provider.send("eth_sign", [
                    address.toLowerCase(),
                    (0, $j2rU8.hexlify)(data)
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $7bf56bd7b17e0046$var$logger.throwError("user rejected signing", (0, $6M65e.Logger).errors.ACTION_REJECTED, {
                    action: "_legacySignMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _signTypedData(domain, types, value) {
        return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names (in-place)
            const populated = yield (0, $kdj79.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                return this.provider.resolveName(name);
            });
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("eth_signTypedData_v4", [
                    address.toLowerCase(),
                    JSON.stringify((0, $kdj79.TypedDataEncoder).getPayload(populated.domain, types, populated.value))
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $7bf56bd7b17e0046$var$logger.throwError("user rejected signing", (0, $6M65e.Logger).errors.ACTION_REJECTED, {
                    action: "_signTypedData",
                    from: address,
                    messageData: {
                        domain: populated.domain,
                        types: types,
                        value: populated.value
                    }
                });
                throw error;
            }
        });
    }
    unlock(password) {
        return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
            const provider = this.provider;
            const address = yield this.getAddress();
            return provider.send("personal_unlockAccount", [
                address.toLowerCase(),
                password,
                null
            ]);
        });
    }
    constructor(constructorGuard, provider, addressOrIndex){
        super();
        if (constructorGuard !== $7bf56bd7b17e0046$var$_constructorGuard) throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
        (0, $2ax4w.defineReadOnly)(this, "provider", provider);
        if (addressOrIndex == null) addressOrIndex = 0;
        if (typeof addressOrIndex === "string") {
            (0, $2ax4w.defineReadOnly)(this, "_address", this.provider.formatter.address(addressOrIndex));
            (0, $2ax4w.defineReadOnly)(this, "_index", null);
        } else if (typeof addressOrIndex === "number") {
            (0, $2ax4w.defineReadOnly)(this, "_index", addressOrIndex);
            (0, $2ax4w.defineReadOnly)(this, "_address", null);
        } else $7bf56bd7b17e0046$var$logger.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
    }
}
class $7bf56bd7b17e0046$var$UncheckedJsonRpcSigner extends $7bf56bd7b17e0046$export$5f7b5fca3508545a {
    sendTransaction(transaction) {
        return this.sendUncheckedTransaction(transaction).then((hash)=>{
            return {
                hash: hash,
                nonce: null,
                gasLimit: null,
                gasPrice: null,
                data: null,
                value: null,
                chainId: null,
                confirmations: 0,
                from: null,
                wait: (confirmations)=>{
                    return this.provider.waitForTransaction(hash, confirmations);
                }
            };
        });
    }
}
const $7bf56bd7b17e0046$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true
};
class $7bf56bd7b17e0046$export$da28308012bf6748 extends (0, $96Por.BaseProvider) {
    get _cache() {
        if (this._eventLoopCache == null) this._eventLoopCache = {};
        return this._eventLoopCache;
    }
    static defaultUrl() {
        return "http://localhost:8545";
    }
    detectNetwork() {
        if (!this._cache["detectNetwork"]) {
            this._cache["detectNetwork"] = this._uncachedDetectNetwork();
            // Clear this cache at the beginning of the next event loop
            setTimeout(()=>{
                this._cache["detectNetwork"] = null;
            }, 0);
        }
        return this._cache["detectNetwork"];
    }
    _uncachedDetectNetwork() {
        return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
            yield $7bf56bd7b17e0046$var$timer(0);
            let chainId = null;
            try {
                chainId = yield this.send("eth_chainId", []);
            } catch (error) {
                try {
                    chainId = yield this.send("net_version", []);
                } catch (error) {}
            }
            if (chainId != null) {
                const getNetwork = (0, $2ax4w.getStatic)(this.constructor, "getNetwork");
                try {
                    return getNetwork((0, $gMArf.BigNumber).from(chainId).toNumber());
                } catch (error) {
                    return $7bf56bd7b17e0046$var$logger.throwError("could not detect network", (0, $6M65e.Logger).errors.NETWORK_ERROR, {
                        chainId: chainId,
                        event: "invalidNetwork",
                        serverError: error
                    });
                }
            }
            return $7bf56bd7b17e0046$var$logger.throwError("could not detect network", (0, $6M65e.Logger).errors.NETWORK_ERROR, {
                event: "noNetwork"
            });
        });
    }
    getSigner(addressOrIndex) {
        return new $7bf56bd7b17e0046$export$5f7b5fca3508545a($7bf56bd7b17e0046$var$_constructorGuard, this, addressOrIndex);
    }
    getUncheckedSigner(addressOrIndex) {
        return this.getSigner(addressOrIndex).connectUnchecked();
    }
    listAccounts() {
        return this.send("eth_accounts", []).then((accounts)=>{
            return accounts.map((a)=>this.formatter.address(a));
        });
    }
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        this.emit("debug", {
            action: "request",
            request: (0, $2ax4w.deepCopy)(request),
            provider: this
        });
        // We can expand this in the future to any call, but for now these
        // are the biggest wins and do not require any serializing parameters.
        const cache = [
            "eth_chainId",
            "eth_blockNumber"
        ].indexOf(method) >= 0;
        if (cache && this._cache[method]) return this._cache[method];
        const result = (0, $gqL7R.fetchJson)(this.connection, JSON.stringify(request), $7bf56bd7b17e0046$var$getResult).then((result)=>{
            this.emit("debug", {
                action: "response",
                request: request,
                response: result,
                provider: this
            });
            return result;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                error: error,
                request: request,
                provider: this
            });
            throw error;
        });
        // Cache the fetch, but clear it on the next event loop
        if (cache) {
            this._cache[method] = result;
            setTimeout(()=>{
                this._cache[method] = null;
            }, 0);
        }
        return result;
    }
    prepareRequest(method, params) {
        switch(method){
            case "getBlockNumber":
                return [
                    "eth_blockNumber",
                    []
                ];
            case "getGasPrice":
                return [
                    "eth_gasPrice",
                    []
                ];
            case "getBalance":
                return [
                    "eth_getBalance",
                    [
                        $7bf56bd7b17e0046$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getTransactionCount":
                return [
                    "eth_getTransactionCount",
                    [
                        $7bf56bd7b17e0046$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getCode":
                return [
                    "eth_getCode",
                    [
                        $7bf56bd7b17e0046$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getStorageAt":
                return [
                    "eth_getStorageAt",
                    [
                        $7bf56bd7b17e0046$var$getLowerCase(params.address),
                        (0, $j2rU8.hexZeroPad)(params.position, 32),
                        params.blockTag
                    ]
                ];
            case "sendTransaction":
                return [
                    "eth_sendRawTransaction",
                    [
                        params.signedTransaction
                    ]
                ];
            case "getBlock":
                if (params.blockTag) return [
                    "eth_getBlockByNumber",
                    [
                        params.blockTag,
                        !!params.includeTransactions
                    ]
                ];
                else if (params.blockHash) return [
                    "eth_getBlockByHash",
                    [
                        params.blockHash,
                        !!params.includeTransactions
                    ]
                ];
                return null;
            case "getTransaction":
                return [
                    "eth_getTransactionByHash",
                    [
                        params.transactionHash
                    ]
                ];
            case "getTransactionReceipt":
                return [
                    "eth_getTransactionReceipt",
                    [
                        params.transactionHash
                    ]
                ];
            case "call":
                {
                    const hexlifyTransaction = (0, $2ax4w.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_call",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            }),
                            params.blockTag
                        ]
                    ];
                }
            case "estimateGas":
                {
                    const hexlifyTransaction = (0, $2ax4w.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_estimateGas",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            })
                        ]
                    ];
                }
            case "getLogs":
                if (params.filter && params.filter.address != null) params.filter.address = $7bf56bd7b17e0046$var$getLowerCase(params.filter.address);
                return [
                    "eth_getLogs",
                    [
                        params.filter
                    ]
                ];
            default:
                break;
        }
        return null;
    }
    perform(method, params) {
        return $7bf56bd7b17e0046$var$__awaiter(this, void 0, void 0, function*() {
            // Legacy networks do not like the type field being passed along (which
            // is fair), so we delete type if it is 0 and a non-EIP-1559 network
            if (method === "call" || method === "estimateGas") {
                const tx = params.transaction;
                if (tx && tx.type != null && (0, $gMArf.BigNumber).from(tx.type).isZero()) // If there are no EIP-1559 properties, it might be non-EIP-1559
                {
                    if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                        const feeData = yield this.getFeeData();
                        if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
                            // Network doesn't know about EIP-1559 (and hence type)
                            params = (0, $2ax4w.shallowCopy)(params);
                            params.transaction = (0, $2ax4w.shallowCopy)(tx);
                            delete params.transaction.type;
                        }
                    }
                }
            }
            const args = this.prepareRequest(method, params);
            if (args == null) $7bf56bd7b17e0046$var$logger.throwError(method + " not implemented", (0, $6M65e.Logger).errors.NOT_IMPLEMENTED, {
                operation: method
            });
            try {
                return yield this.send(args[0], args[1]);
            } catch (error) {
                return $7bf56bd7b17e0046$var$checkError(method, error, params);
            }
        });
    }
    _startEvent(event) {
        if (event.tag === "pending") this._startPending();
        super._startEvent(event);
    }
    _startPending() {
        if (this._pendingFilter != null) return;
        const self = this;
        const pendingFilter = this.send("eth_newPendingTransactionFilter", []);
        this._pendingFilter = pendingFilter;
        pendingFilter.then(function(filterId) {
            function poll() {
                self.send("eth_getFilterChanges", [
                    filterId
                ]).then(function(hashes) {
                    if (self._pendingFilter != pendingFilter) return null;
                    let seq = Promise.resolve();
                    hashes.forEach(function(hash) {
                        // @TODO: This should be garbage collected at some point... How? When?
                        self._emitted["t:" + hash.toLowerCase()] = "pending";
                        seq = seq.then(function() {
                            return self.getTransaction(hash).then(function(tx) {
                                self.emit("pending", tx);
                                return null;
                            });
                        });
                    });
                    return seq.then(function() {
                        return $7bf56bd7b17e0046$var$timer(1000);
                    });
                }).then(function() {
                    if (self._pendingFilter != pendingFilter) {
                        self.send("eth_uninstallFilter", [
                            filterId
                        ]);
                        return;
                    }
                    setTimeout(function() {
                        poll();
                    }, 0);
                    return null;
                }).catch((error)=>{});
            }
            poll();
            return filterId;
        }).catch((error)=>{});
    }
    _stopEvent(event) {
        if (event.tag === "pending" && this.listenerCount("pending") === 0) this._pendingFilter = null;
        super._stopEvent(event);
    }
    // Convert an ethers.js transaction into a JSON-RPC transaction
    //  - gasLimit => gas
    //  - All values hexlified
    //  - All numeric values zero-striped
    //  - All addresses are lowercased
    // NOTE: This allows a TransactionRequest, but all values should be resolved
    //       before this is called
    // @TODO: This will likely be removed in future versions and prepareRequest
    //        will be the preferred method for this.
    static hexlifyTransaction(transaction, allowExtra) {
        // Check only allowed properties are given
        const allowed = (0, $2ax4w.shallowCopy)($7bf56bd7b17e0046$var$allowedTransactionKeys);
        if (allowExtra) {
            for(const key in allowExtra)if (allowExtra[key]) allowed[key] = true;
        }
        (0, $2ax4w.checkProperties)(transaction, allowed);
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            const value = (0, $j2rU8.hexValue)((0, $gMArf.BigNumber).from(transaction[key]));
            if (key === "gasLimit") key = "gas";
            result[key] = value;
        });
        [
            "from",
            "to",
            "data"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            result[key] = (0, $j2rU8.hexlify)(transaction[key]);
        });
        if (transaction.accessList) result["accessList"] = (0, $hDQeE.accessListify)(transaction.accessList);
        return result;
    }
    constructor(url, network){
        let networkOrReady = network;
        // The network is unknown, query the JSON-RPC for it
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then((network)=>{
                    resolve(network);
                }, (error)=>{
                    reject(error);
                });
            }, 0);
        });
        super(networkOrReady);
        // Default URL
        if (!url) url = (0, $2ax4w.getStatic)(this.constructor, "defaultUrl")();
        if (typeof url === "string") (0, $2ax4w.defineReadOnly)(this, "connection", Object.freeze({
            url: url
        }));
        else (0, $2ax4w.defineReadOnly)(this, "connection", Object.freeze((0, $2ax4w.shallowCopy)(url)));
        this._nextId = 42;
    }
}

});

parcelRegister("hiXBj", function(module, exports) {

$parcel$export(module.exports, "WebSocket", function () { return $c9925991f78188b7$export$3909fb301d3dc8c9; });

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");
"use strict";
let $c9925991f78188b7$export$3909fb301d3dc8c9 = null;
try {
    $c9925991f78188b7$export$3909fb301d3dc8c9 = WebSocket;
    if ($c9925991f78188b7$export$3909fb301d3dc8c9 == null) throw new Error("inject please");
} catch (error) {
    const logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
    $c9925991f78188b7$export$3909fb301d3dc8c9 = function() {
        logger.throwError("WebSockets not supported in this environment", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new WebSocket()"
        });
    };
}

});


parcelRegister("jLiNX", function(module, exports) {

$parcel$export(module.exports, "StaticJsonRpcProvider", function () { return $e630fe5b56031581$export$b3d647c1c29df44d; });
$parcel$export(module.exports, "UrlJsonRpcProvider", function () { return $e630fe5b56031581$export$664128d6239ccf96; });

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");

var $aDPpa = parcelRequire("aDPpa");
"use strict";
var $e630fe5b56031581$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $e630fe5b56031581$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
class $e630fe5b56031581$export$b3d647c1c29df44d extends (0, $aDPpa.JsonRpcProvider) {
    detectNetwork() {
        const _super = Object.create(null, {
            detectNetwork: {
                get: ()=>super.detectNetwork
            }
        });
        return $e630fe5b56031581$var$__awaiter(this, void 0, void 0, function*() {
            let network = this.network;
            if (network == null) {
                network = yield _super.detectNetwork.call(this);
                if (!network) $e630fe5b56031581$var$logger.throwError("no network detected", (0, $6M65e.Logger).errors.UNKNOWN_ERROR, {});
                // If still not set, set it
                if (this._network == null) {
                    // A static network does not support "any"
                    (0, $2ax4w.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return network;
        });
    }
}
class $e630fe5b56031581$export$664128d6239ccf96 extends $e630fe5b56031581$export$b3d647c1c29df44d {
    _startPending() {
        $e630fe5b56031581$var$logger.warn("WARNING: API provider does not support pending filters");
    }
    isCommunityResource() {
        return false;
    }
    getSigner(address) {
        return $e630fe5b56031581$var$logger.throwError("API provider does not support signing", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "getSigner"
        });
    }
    listAccounts() {
        return Promise.resolve([]);
    }
    // Return a defaultApiKey if null, otherwise validate the API key
    static getApiKey(apiKey) {
        return apiKey;
    }
    // Returns the url or connection for the given network and API key. The
    // API key will have been sanitized by the getApiKey first, so any validation
    // or transformations can be done there.
    static getUrl(network, apiKey) {
        return $e630fe5b56031581$var$logger.throwError("not implemented; sub-classes must override getUrl", (0, $6M65e.Logger).errors.NOT_IMPLEMENTED, {
            operation: "getUrl"
        });
    }
    constructor(network, apiKey){
        $e630fe5b56031581$var$logger.checkAbstract(new.target, $e630fe5b56031581$export$664128d6239ccf96);
        // Normalize the Network and API Key
        network = (0, $2ax4w.getStatic)(new.target, "getNetwork")(network);
        apiKey = (0, $2ax4w.getStatic)(new.target, "getApiKey")(apiKey);
        const connection = (0, $2ax4w.getStatic)(new.target, "getUrl")(network, apiKey);
        super(connection, network);
        if (typeof apiKey === "string") (0, $2ax4w.defineReadOnly)(this, "apiKey", apiKey);
        else if (apiKey != null) Object.keys(apiKey).forEach((key)=>{
            (0, $2ax4w.defineReadOnly)(this, key, apiKey[key]);
        });
    }
}

});


parcelRegister("4xYP9", function(module, exports) {

$parcel$export(module.exports, "AnkrProvider", function () { return $34f96cdeb0f3f720$export$72783b2aefa72a45; });

var $f1MgE = parcelRequire("f1MgE");

var $jLiNX = parcelRequire("jLiNX");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");
const $34f96cdeb0f3f720$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
const $34f96cdeb0f3f720$var$defaultApiKey = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function $34f96cdeb0f3f720$var$getHost(name) {
    switch(name){
        case "homestead":
            return "rpc.ankr.com/eth/";
        case "ropsten":
            return "rpc.ankr.com/eth_ropsten/";
        case "rinkeby":
            return "rpc.ankr.com/eth_rinkeby/";
        case "goerli":
            return "rpc.ankr.com/eth_goerli/";
        case "matic":
            return "rpc.ankr.com/polygon/";
        case "arbitrum":
            return "rpc.ankr.com/arbitrum/";
    }
    return $34f96cdeb0f3f720$var$logger.throwArgumentError("unsupported network", "name", name);
}
class $34f96cdeb0f3f720$export$72783b2aefa72a45 extends (0, $jLiNX.UrlJsonRpcProvider) {
    isCommunityResource() {
        return this.apiKey === $34f96cdeb0f3f720$var$defaultApiKey;
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $34f96cdeb0f3f720$var$defaultApiKey;
        return apiKey;
    }
    static getUrl(network, apiKey) {
        if (apiKey == null) apiKey = $34f96cdeb0f3f720$var$defaultApiKey;
        const connection = {
            allowGzip: true,
            url: "https://" + $34f96cdeb0f3f720$var$getHost(network.name) + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey.apiKey === $34f96cdeb0f3f720$var$defaultApiKey) (0, $f1MgE.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
}

});

parcelRegister("cHe68", function(module, exports) {

$parcel$export(module.exports, "CloudflareProvider", function () { return $93e46fc4025aa2f3$export$7113381f8f264fc0; });

var $jLiNX = parcelRequire("jLiNX");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");
"use strict";
var $93e46fc4025aa2f3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $93e46fc4025aa2f3$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
class $93e46fc4025aa2f3$export$7113381f8f264fc0 extends (0, $jLiNX.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey != null) $93e46fc4025aa2f3$var$logger.throwArgumentError("apiKey not supported for cloudflare", "apiKey", apiKey);
        return null;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://cloudflare-eth.com/";
                break;
            default:
                $93e46fc4025aa2f3$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host;
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $93e46fc4025aa2f3$var$__awaiter(this, void 0, void 0, function*() {
            // The Cloudflare provider does not support eth_blockNumber,
            // so we get the latest block and pull it from that
            if (method === "getBlockNumber") {
                const block = yield _super.perform.call(this, "getBlock", {
                    blockTag: "latest"
                });
                return block.number;
            }
            return _super.perform.call(this, method, params);
        });
    }
}

});

parcelRegister("8c6ML", function(module, exports) {

$parcel$export(module.exports, "EtherscanProvider", function () { return $5f74b530f183cf41$export$dd1d942a536c7912; });

var $j2rU8 = parcelRequire("j2rU8");

var $2ax4w = parcelRequire("2ax4w");

var $hDQeE = parcelRequire("hDQeE");

var $gqL7R = parcelRequire("gqL7R");

var $f1MgE = parcelRequire("f1MgE");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");

var $96Por = parcelRequire("96Por");
"use strict";
var $5f74b530f183cf41$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $5f74b530f183cf41$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
// The transaction has already been sanitized by the calls in Provider
function $5f74b530f183cf41$var$getTransactionPostData(transaction) {
    const result = {};
    for(let key in transaction){
        if (transaction[key] == null) continue;
        let value = transaction[key];
        if (key === "type" && value === 0) continue;
        // Quantity-types require no leading zero, unless 0
        if (({
            type: true,
            gasLimit: true,
            gasPrice: true,
            maxFeePerGs: true,
            maxPriorityFeePerGas: true,
            nonce: true,
            value: true
        })[key]) value = (0, $j2rU8.hexValue)((0, $j2rU8.hexlify)(value));
        else if (key === "accessList") value = "[" + (0, $hDQeE.accessListify)(value).map((set)=>{
            return `{address:"${set.address}",storageKeys:["${set.storageKeys.join('","')}"]}`;
        }).join(",") + "]";
        else value = (0, $j2rU8.hexlify)(value);
        result[key] = value;
    }
    return result;
}
function $5f74b530f183cf41$var$getResult(result) {
    // getLogs, getHistory have weird success responses
    if (result.status == 0 && (result.message === "No records found" || result.message === "No transactions found")) return result.result;
    if (result.status != 1 || typeof result.message !== "string" || !result.message.match(/^OK/)) {
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        if ((result.result || "").toLowerCase().indexOf("rate limit") >= 0) error.throttleRetry = true;
        throw error;
    }
    return result.result;
}
function $5f74b530f183cf41$var$getJsonResult(result) {
    // This response indicates we are being throttled
    if (result && result.status == 0 && result.message == "NOTOK" && (result.result || "").toLowerCase().indexOf("rate limit") >= 0) {
        const error = new Error("throttled response");
        error.result = JSON.stringify(result);
        error.throttleRetry = true;
        throw error;
    }
    if (result.jsonrpc != "2.0") {
        // @TODO: not any
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        throw error;
    }
    if (result.error) {
        // @TODO: not any
        const error = new Error(result.error.message || "unknown error");
        if (result.error.code) error.code = result.error.code;
        if (result.error.data) error.data = result.error.data;
        throw error;
    }
    return result.result;
}
// The blockTag was normalized as a string by the Provider pre-perform operations
function $5f74b530f183cf41$var$checkLogTag(blockTag) {
    if (blockTag === "pending") throw new Error("pending not supported");
    if (blockTag === "latest") return blockTag;
    return parseInt(blockTag.substring(2), 16);
}
function $5f74b530f183cf41$var$checkError(method, error, transaction) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call" && error.code === (0, $6M65e.Logger).errors.SERVER_ERROR) {
        const e = error.error;
        // Etherscan keeps changing their string
        if (e && (e.message.match(/reverted/i) || e.message.match(/VM execution error/i))) {
            // Etherscan prefixes the data like "Reverted 0x1234"
            let data = e.data;
            if (data) data = "0x" + data.replace(/^.*0x/i, "");
            if ((0, $j2rU8.isHexString)(data)) return data;
            $5f74b530f183cf41$var$logger.throwError("missing revert data in call exception", (0, $6M65e.Logger).errors.CALL_EXCEPTION, {
                error: error,
                data: "0x"
            });
        }
    }
    // Get the message from any nested error structure
    let message = error.message;
    if (error.code === (0, $6M65e.Logger).errors.SERVER_ERROR) {
        if (error.error && typeof error.error.message === "string") message = error.error.message;
        else if (typeof error.body === "string") message = error.body;
        else if (typeof error.responseText === "string") message = error.responseText;
    }
    message = (message || "").toLowerCase();
    // "Insufficient funds. The account you tried to send transaction from does not have enough funds. Required 21464000000000 and got: 0"
    if (message.match(/insufficient funds/)) $5f74b530f183cf41$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $6M65e.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction with the same hash was already imported."
    if (message.match(/same hash was already imported|transaction nonce is too low|nonce too low/)) $5f74b530f183cf41$var$logger.throwError("nonce has already been used", (0, $6M65e.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction gas price is too low. There is another transaction with same nonce in the queue. Try increasing the gas price or incrementing the nonce."
    if (message.match(/another transaction with same nonce/)) $5f74b530f183cf41$var$logger.throwError("replacement fee too low", (0, $6M65e.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    if (message.match(/execution failed due to an exception|execution reverted/)) $5f74b530f183cf41$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $6M65e.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
class $5f74b530f183cf41$export$dd1d942a536c7912 extends (0, $96Por.BaseProvider) {
    getBaseUrl() {
        switch(this.network ? this.network.name : "invalid"){
            case "homestead":
                return "https://api.etherscan.io";
            case "goerli":
                return "https://api-goerli.etherscan.io";
            case "sepolia":
                return "https://api-sepolia.etherscan.io";
            case "matic":
                return "https://api.polygonscan.com";
            case "maticmum":
                return "https://api-testnet.polygonscan.com";
            case "arbitrum":
                return "https://api.arbiscan.io";
            case "arbitrum-goerli":
                return "https://api-goerli.arbiscan.io";
            case "optimism":
                return "https://api-optimistic.etherscan.io";
            case "optimism-goerli":
                return "https://api-goerli-optimistic.etherscan.io";
            default:
        }
        return $5f74b530f183cf41$var$logger.throwArgumentError("unsupported network", "network", this.network.name);
    }
    getUrl(module, params) {
        const query = Object.keys(params).reduce((accum, key)=>{
            const value = params[key];
            if (value != null) accum += `&${key}=${value}`;
            return accum;
        }, "");
        const apiKey = this.apiKey ? `&apikey=${this.apiKey}` : "";
        return `${this.baseUrl}/api?module=${module}${query}${apiKey}`;
    }
    getPostUrl() {
        return `${this.baseUrl}/api`;
    }
    getPostData(module, params) {
        params.module = module;
        params.apikey = this.apiKey;
        return params;
    }
    fetch(module, params, post) {
        return $5f74b530f183cf41$var$__awaiter(this, void 0, void 0, function*() {
            const url = post ? this.getPostUrl() : this.getUrl(module, params);
            const payload = post ? this.getPostData(module, params) : null;
            const procFunc = module === "proxy" ? $5f74b530f183cf41$var$getJsonResult : $5f74b530f183cf41$var$getResult;
            this.emit("debug", {
                action: "request",
                request: url,
                provider: this
            });
            const connection = {
                url: url,
                throttleSlotInterval: 1000,
                throttleCallback: (attempt, url)=>{
                    if (this.isCommunityResource()) (0, $f1MgE.showThrottleMessage)();
                    return Promise.resolve(true);
                }
            };
            let payloadStr = null;
            if (payload) {
                connection.headers = {
                    "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                };
                payloadStr = Object.keys(payload).map((key)=>{
                    return `${key}=${payload[key]}`;
                }).join("&");
            }
            const result = yield (0, $gqL7R.fetchJson)(connection, payloadStr, procFunc || $5f74b530f183cf41$var$getJsonResult);
            this.emit("debug", {
                action: "response",
                request: url,
                response: (0, $2ax4w.deepCopy)(result),
                provider: this
            });
            return result;
        });
    }
    detectNetwork() {
        return $5f74b530f183cf41$var$__awaiter(this, void 0, void 0, function*() {
            return this.network;
        });
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $5f74b530f183cf41$var$__awaiter(this, void 0, void 0, function*() {
            switch(method){
                case "getBlockNumber":
                    return this.fetch("proxy", {
                        action: "eth_blockNumber"
                    });
                case "getGasPrice":
                    return this.fetch("proxy", {
                        action: "eth_gasPrice"
                    });
                case "getBalance":
                    // Returns base-10 result
                    return this.fetch("account", {
                        action: "balance",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getTransactionCount":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionCount",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getCode":
                    return this.fetch("proxy", {
                        action: "eth_getCode",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getStorageAt":
                    return this.fetch("proxy", {
                        action: "eth_getStorageAt",
                        address: params.address,
                        position: params.position,
                        tag: params.blockTag
                    });
                case "sendTransaction":
                    return this.fetch("proxy", {
                        action: "eth_sendRawTransaction",
                        hex: params.signedTransaction
                    }, true).catch((error)=>{
                        return $5f74b530f183cf41$var$checkError("sendTransaction", error, params.signedTransaction);
                    });
                case "getBlock":
                    if (params.blockTag) return this.fetch("proxy", {
                        action: "eth_getBlockByNumber",
                        tag: params.blockTag,
                        boolean: params.includeTransactions ? "true" : "false"
                    });
                    throw new Error("getBlock by blockHash not implemented");
                case "getTransaction":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionByHash",
                        txhash: params.transactionHash
                    });
                case "getTransactionReceipt":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionReceipt",
                        txhash: params.transactionHash
                    });
                case "call":
                    {
                        if (params.blockTag !== "latest") throw new Error("EtherscanProvider does not support blockTag for call");
                        const postData = $5f74b530f183cf41$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_call";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $5f74b530f183cf41$var$checkError("call", error, params.transaction);
                        }
                    }
                case "estimateGas":
                    {
                        const postData = $5f74b530f183cf41$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_estimateGas";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $5f74b530f183cf41$var$checkError("estimateGas", error, params.transaction);
                        }
                    }
                case "getLogs":
                    {
                        const args = {
                            action: "getLogs"
                        };
                        if (params.filter.fromBlock) args.fromBlock = $5f74b530f183cf41$var$checkLogTag(params.filter.fromBlock);
                        if (params.filter.toBlock) args.toBlock = $5f74b530f183cf41$var$checkLogTag(params.filter.toBlock);
                        if (params.filter.address) args.address = params.filter.address;
                        // @TODO: We can handle slightly more complicated logs using the logs API
                        if (params.filter.topics && params.filter.topics.length > 0) {
                            if (params.filter.topics.length > 1) $5f74b530f183cf41$var$logger.throwError("unsupported topic count", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                                topics: params.filter.topics
                            });
                            if (params.filter.topics.length === 1) {
                                const topic0 = params.filter.topics[0];
                                if (typeof topic0 !== "string" || topic0.length !== 66) $5f74b530f183cf41$var$logger.throwError("unsupported topic format", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
                                    topic0: topic0
                                });
                                args.topic0 = topic0;
                            }
                        }
                        const logs = yield this.fetch("logs", args);
                        // Cache txHash => blockHash
                        let blocks = {};
                        // Add any missing blockHash to the logs
                        for(let i = 0; i < logs.length; i++){
                            const log = logs[i];
                            if (log.blockHash != null) continue;
                            if (blocks[log.blockNumber] == null) {
                                const block = yield this.getBlock(log.blockNumber);
                                if (block) blocks[log.blockNumber] = block.hash;
                            }
                            log.blockHash = blocks[log.blockNumber];
                        }
                        return logs;
                    }
                case "getEtherPrice":
                    if (this.network.name !== "homestead") return 0.0;
                    return parseFloat((yield this.fetch("stats", {
                        action: "ethprice"
                    })).ethusd);
                default:
                    break;
            }
            return _super.perform.call(this, method, params);
        });
    }
    // Note: The `page` page parameter only allows pagination within the
    //       10,000 window available without a page and offset parameter
    //       Error: Result window is too large, PageNo x Offset size must
    //              be less than or equal to 10000
    getHistory(addressOrName, startBlock, endBlock) {
        return $5f74b530f183cf41$var$__awaiter(this, void 0, void 0, function*() {
            const params = {
                action: "txlist",
                address: yield this.resolveName(addressOrName),
                startblock: startBlock == null ? 0 : startBlock,
                endblock: endBlock == null ? 99999999 : endBlock,
                sort: "asc"
            };
            const result = yield this.fetch("account", params);
            return result.map((tx)=>{
                [
                    "contractAddress",
                    "to"
                ].forEach(function(key) {
                    if (tx[key] == "") delete tx[key];
                });
                if (tx.creates == null && tx.contractAddress != null) tx.creates = tx.contractAddress;
                const item = this.formatter.transactionResponse(tx);
                if (tx.timeStamp) item.timestamp = parseInt(tx.timeStamp);
                return item;
            });
        });
    }
    isCommunityResource() {
        return this.apiKey == null;
    }
    constructor(network, apiKey){
        super(network);
        (0, $2ax4w.defineReadOnly)(this, "baseUrl", this.getBaseUrl());
        (0, $2ax4w.defineReadOnly)(this, "apiKey", apiKey || null);
    }
}

});

parcelRegister("h5Sdm", function(module, exports) {

$parcel$export(module.exports, "FallbackProvider", function () { return $c71cf52c680b1470$export$cb1d0beacb55feb7; });

var $lLovk = parcelRequire("lLovk");

var $gMArf = parcelRequire("gMArf");

var $j2rU8 = parcelRequire("j2rU8");

var $2ax4w = parcelRequire("2ax4w");

var $5aKt1 = parcelRequire("5aKt1");

var $gqL7R = parcelRequire("gqL7R");

var $96Por = parcelRequire("96Por");

var $f1MgE = parcelRequire("f1MgE");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");
"use strict";
var $c71cf52c680b1470$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $c71cf52c680b1470$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
function $c71cf52c680b1470$var$now() {
    return new Date().getTime();
}
// Returns to network as long as all agree, or null if any is null.
// Throws an error if any two networks do not match.
function $c71cf52c680b1470$var$checkNetworks(networks) {
    let result = null;
    for(let i = 0; i < networks.length; i++){
        const network = networks[i];
        // Null! We do not know our network; bail.
        if (network == null) return null;
        if (result) // Make sure the network matches the previous networks
        {
            if (!(result.name === network.name && result.chainId === network.chainId && (result.ensAddress === network.ensAddress || result.ensAddress == null && network.ensAddress == null))) $c71cf52c680b1470$var$logger.throwArgumentError("provider mismatch", "networks", networks);
        } else result = network;
    }
    return result;
}
function $c71cf52c680b1470$var$median(values, maxDelta) {
    values = values.slice().sort();
    const middle = Math.floor(values.length / 2);
    // Odd length; take the middle
    if (values.length % 2) return values[middle];
    // Even length; take the average of the two middle
    const a = values[middle - 1], b = values[middle];
    if (maxDelta != null && Math.abs(a - b) > maxDelta) return null;
    return (a + b) / 2;
}
function $c71cf52c680b1470$var$serialize(value) {
    if (value === null) return "null";
    else if (typeof value === "number" || typeof value === "boolean") return JSON.stringify(value);
    else if (typeof value === "string") return value;
    else if ((0, $gMArf.BigNumber).isBigNumber(value)) return value.toString();
    else if (Array.isArray(value)) return JSON.stringify(value.map((i)=>$c71cf52c680b1470$var$serialize(i)));
    else if (typeof value === "object") {
        const keys = Object.keys(value);
        keys.sort();
        return "{" + keys.map((key)=>{
            let v = value[key];
            if (typeof v === "function") v = "[function]";
            else v = $c71cf52c680b1470$var$serialize(v);
            return JSON.stringify(key) + ":" + v;
        }).join(",") + "}";
    }
    throw new Error("unknown value type: " + typeof value);
}
// Next request ID to use for emitting debug info
let $c71cf52c680b1470$var$nextRid = 1;
function $c71cf52c680b1470$var$stall(duration) {
    let cancel = null;
    let timer = null;
    let promise = new Promise((resolve)=>{
        cancel = function() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            resolve();
        };
        timer = setTimeout(cancel, duration);
    });
    const wait = (func)=>{
        promise = promise.then(func);
        return promise;
    };
    function getPromise() {
        return promise;
    }
    return {
        cancel: cancel,
        getPromise: getPromise,
        wait: wait
    };
}
const $c71cf52c680b1470$var$ForwardErrors = [
    (0, $6M65e.Logger).errors.CALL_EXCEPTION,
    (0, $6M65e.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $6M65e.Logger).errors.NONCE_EXPIRED,
    (0, $6M65e.Logger).errors.REPLACEMENT_UNDERPRICED,
    (0, $6M65e.Logger).errors.UNPREDICTABLE_GAS_LIMIT
];
const $c71cf52c680b1470$var$ForwardProperties = [
    "address",
    "args",
    "errorArgs",
    "errorSignature",
    "method",
    "transaction"
];
function $c71cf52c680b1470$var$exposeDebugConfig(config, now) {
    const result = {
        weight: config.weight
    };
    Object.defineProperty(result, "provider", {
        get: ()=>config.provider
    });
    if (config.start) result.start = config.start;
    if (now) result.duration = now - config.start;
    if (config.done) {
        if (config.error) result.error = config.error;
        else result.result = config.result || null;
    }
    return result;
}
function $c71cf52c680b1470$var$normalizedTally(normalize, quorum) {
    return function(configs) {
        // Count the votes for each result
        const tally = {};
        configs.forEach((c)=>{
            const value = normalize(c.result);
            if (!tally[value]) tally[value] = {
                count: 0,
                result: c.result
            };
            tally[value].count++;
        });
        // Check for a quorum on any given result
        const keys = Object.keys(tally);
        for(let i = 0; i < keys.length; i++){
            const check = tally[keys[i]];
            if (check.count >= quorum) return check.result;
        }
        // No quroum
        return undefined;
    };
}
function $c71cf52c680b1470$var$getProcessFunc(provider, method, params) {
    let normalize = $c71cf52c680b1470$var$serialize;
    switch(method){
        case "getBlockNumber":
            // Return the median value, unless there is (median + 1) is also
            // present, in which case that is probably true and the median
            // is going to be stale soon. In the event of a malicious node,
            // the lie will be true soon enough.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                // Get the median block number
                let blockNumber = $c71cf52c680b1470$var$median(configs.map((c)=>c.result), 2);
                if (blockNumber == null) return undefined;
                blockNumber = Math.ceil(blockNumber);
                // If the next block height is present, its prolly safe to use
                if (values.indexOf(blockNumber + 1) >= 0) blockNumber++;
                // Don't ever roll back the blockNumber
                if (blockNumber >= provider._highestBlockNumber) provider._highestBlockNumber = blockNumber;
                return provider._highestBlockNumber;
            };
        case "getGasPrice":
            // Return the middle (round index up) value, similar to median
            // but do not average even entries and choose the higher.
            // Malicious actors must compromise 50% of the nodes to lie.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                values.sort();
                return values[Math.floor(values.length / 2)];
            };
        case "getEtherPrice":
            // Returns the median price. Malicious actors must compromise at
            // least 50% of the nodes to lie (in a meaningful way).
            return function(configs) {
                return $c71cf52c680b1470$var$median(configs.map((c)=>c.result));
            };
        // No additional normalizing required; serialize is enough
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorageAt":
        case "call":
        case "estimateGas":
        case "getLogs":
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getTransaction":
        case "getTransactionReceipt":
            normalize = function(tx) {
                if (tx == null) return null;
                tx = (0, $2ax4w.shallowCopy)(tx);
                tx.confirmations = -1;
                return $c71cf52c680b1470$var$serialize(tx);
            };
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getBlock":
            // We drop the confirmations from transactions as it is approximate
            if (params.includeTransactions) normalize = function(block) {
                if (block == null) return null;
                block = (0, $2ax4w.shallowCopy)(block);
                block.transactions = block.transactions.map((tx)=>{
                    tx = (0, $2ax4w.shallowCopy)(tx);
                    tx.confirmations = -1;
                    return tx;
                });
                return $c71cf52c680b1470$var$serialize(block);
            };
            else normalize = function(block) {
                if (block == null) return null;
                return $c71cf52c680b1470$var$serialize(block);
            };
            break;
        default:
            throw new Error("unknown method: " + method);
    }
    // Return the result if and only if the expected quorum is
    // satisfied and agreed upon for the final result.
    return $c71cf52c680b1470$var$normalizedTally(normalize, provider.quorum);
}
// If we are doing a blockTag query, we need to make sure the backend is
// caught up to the FallbackProvider, before sending a request to it.
function $c71cf52c680b1470$var$waitForSync(config, blockNumber) {
    return $c71cf52c680b1470$var$__awaiter(this, void 0, void 0, function*() {
        const provider = config.provider;
        if (provider.blockNumber != null && provider.blockNumber >= blockNumber || blockNumber === -1) return provider;
        return (0, $gqL7R.poll)(()=>{
            return new Promise((resolve, reject)=>{
                setTimeout(function() {
                    // We are synced
                    if (provider.blockNumber >= blockNumber) return resolve(provider);
                    // We're done; just quit
                    if (config.cancelled) return resolve(null);
                    // Try again, next block
                    return resolve(undefined);
                }, 0);
            });
        }, {
            oncePoll: provider
        });
    });
}
function $c71cf52c680b1470$var$getRunner(config, currentBlockNumber, method, params) {
    return $c71cf52c680b1470$var$__awaiter(this, void 0, void 0, function*() {
        let provider = config.provider;
        switch(method){
            case "getBlockNumber":
            case "getGasPrice":
                return provider[method]();
            case "getEtherPrice":
                if (provider.getEtherPrice) return provider.getEtherPrice();
                break;
            case "getBalance":
            case "getTransactionCount":
            case "getCode":
                if (params.blockTag && (0, $j2rU8.isHexString)(params.blockTag)) provider = yield $c71cf52c680b1470$var$waitForSync(config, currentBlockNumber);
                return provider[method](params.address, params.blockTag || "latest");
            case "getStorageAt":
                if (params.blockTag && (0, $j2rU8.isHexString)(params.blockTag)) provider = yield $c71cf52c680b1470$var$waitForSync(config, currentBlockNumber);
                return provider.getStorageAt(params.address, params.position, params.blockTag || "latest");
            case "getBlock":
                if (params.blockTag && (0, $j2rU8.isHexString)(params.blockTag)) provider = yield $c71cf52c680b1470$var$waitForSync(config, currentBlockNumber);
                return provider[params.includeTransactions ? "getBlockWithTransactions" : "getBlock"](params.blockTag || params.blockHash);
            case "call":
            case "estimateGas":
                if (params.blockTag && (0, $j2rU8.isHexString)(params.blockTag)) provider = yield $c71cf52c680b1470$var$waitForSync(config, currentBlockNumber);
                if (method === "call" && params.blockTag) return provider[method](params.transaction, params.blockTag);
                return provider[method](params.transaction);
            case "getTransaction":
            case "getTransactionReceipt":
                return provider[method](params.transactionHash);
            case "getLogs":
                {
                    let filter = params.filter;
                    if (filter.fromBlock && (0, $j2rU8.isHexString)(filter.fromBlock) || filter.toBlock && (0, $j2rU8.isHexString)(filter.toBlock)) provider = yield $c71cf52c680b1470$var$waitForSync(config, currentBlockNumber);
                    return provider.getLogs(filter);
                }
        }
        return $c71cf52c680b1470$var$logger.throwError("unknown method error", (0, $6M65e.Logger).errors.UNKNOWN_ERROR, {
            method: method,
            params: params
        });
    });
}
class $c71cf52c680b1470$export$cb1d0beacb55feb7 extends (0, $96Por.BaseProvider) {
    detectNetwork() {
        return $c71cf52c680b1470$var$__awaiter(this, void 0, void 0, function*() {
            const networks = yield Promise.all(this.providerConfigs.map((c)=>c.provider.getNetwork()));
            return $c71cf52c680b1470$var$checkNetworks(networks);
        });
    }
    perform(method, params) {
        return $c71cf52c680b1470$var$__awaiter(this, void 0, void 0, function*() {
            // Sending transactions is special; always broadcast it to all backends
            if (method === "sendTransaction") {
                const results = yield Promise.all(this.providerConfigs.map((c)=>{
                    return c.provider.sendTransaction(params.signedTransaction).then((result)=>{
                        return result.hash;
                    }, (error)=>{
                        return error;
                    });
                }));
                // Any success is good enough (other errors are likely "already seen" errors
                for(let i = 0; i < results.length; i++){
                    const result = results[i];
                    if (typeof result === "string") return result;
                }
                // They were all an error; pick the first error
                throw results[0];
            }
            // We need to make sure we are in sync with our backends, so we need
            // to know this before we can make a lot of calls
            if (this._highestBlockNumber === -1 && method !== "getBlockNumber") yield this.getBlockNumber();
            const processFunc = $c71cf52c680b1470$var$getProcessFunc(this, method, params);
            // Shuffle the providers and then sort them by their priority; we
            // shallowCopy them since we will store the result in them too
            const configs = (0, $5aKt1.shuffled)(this.providerConfigs.map((0, $2ax4w.shallowCopy)));
            configs.sort((a, b)=>a.priority - b.priority);
            const currentBlockNumber = this._highestBlockNumber;
            let i = 0;
            let first = true;
            while(true){
                const t0 = $c71cf52c680b1470$var$now();
                // Compute the inflight weight (exclude anything past)
                let inflightWeight = configs.filter((c)=>c.runner && t0 - c.start < c.stallTimeout).reduce((accum, c)=>accum + c.weight, 0);
                // Start running enough to meet quorum
                while(inflightWeight < this.quorum && i < configs.length){
                    const config = configs[i++];
                    const rid = $c71cf52c680b1470$var$nextRid++;
                    config.start = $c71cf52c680b1470$var$now();
                    config.staller = $c71cf52c680b1470$var$stall(config.stallTimeout);
                    config.staller.wait(()=>{
                        config.staller = null;
                    });
                    config.runner = $c71cf52c680b1470$var$getRunner(config, currentBlockNumber, method, params).then((result)=>{
                        config.done = true;
                        config.result = result;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $c71cf52c680b1470$var$exposeDebugConfig(config, $c71cf52c680b1470$var$now()),
                            request: {
                                method: method,
                                params: (0, $2ax4w.deepCopy)(params)
                            },
                            provider: this
                        });
                    }, (error)=>{
                        config.done = true;
                        config.error = error;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $c71cf52c680b1470$var$exposeDebugConfig(config, $c71cf52c680b1470$var$now()),
                            request: {
                                method: method,
                                params: (0, $2ax4w.deepCopy)(params)
                            },
                            provider: this
                        });
                    });
                    if (this.listenerCount("debug")) this.emit("debug", {
                        action: "request",
                        rid: rid,
                        backend: $c71cf52c680b1470$var$exposeDebugConfig(config, null),
                        request: {
                            method: method,
                            params: (0, $2ax4w.deepCopy)(params)
                        },
                        provider: this
                    });
                    inflightWeight += config.weight;
                }
                // Wait for anything meaningful to finish or stall out
                const waiting = [];
                configs.forEach((c)=>{
                    if (c.done || !c.runner) return;
                    waiting.push(c.runner);
                    if (c.staller) waiting.push(c.staller.getPromise());
                });
                if (waiting.length) yield Promise.race(waiting);
                // Check the quorum and process the results; the process function
                // may additionally decide the quorum is not met
                const results = configs.filter((c)=>c.done && c.error == null);
                if (results.length >= this.quorum) {
                    const result = processFunc(results);
                    if (result !== undefined) {
                        // Shut down any stallers
                        configs.forEach((c)=>{
                            if (c.staller) c.staller.cancel();
                            c.cancelled = true;
                        });
                        return result;
                    }
                    if (!first) yield $c71cf52c680b1470$var$stall(100).getPromise();
                    first = false;
                }
                // No result, check for errors that should be forwarded
                const errors = configs.reduce((accum, c)=>{
                    if (!c.done || c.error == null) return accum;
                    const code = c.error.code;
                    if ($c71cf52c680b1470$var$ForwardErrors.indexOf(code) >= 0) {
                        if (!accum[code]) accum[code] = {
                            error: c.error,
                            weight: 0
                        };
                        accum[code].weight += c.weight;
                    }
                    return accum;
                }, {});
                Object.keys(errors).forEach((errorCode)=>{
                    const tally = errors[errorCode];
                    if (tally.weight < this.quorum) return;
                    // Shut down any stallers
                    configs.forEach((c)=>{
                        if (c.staller) c.staller.cancel();
                        c.cancelled = true;
                    });
                    const e = tally.error;
                    const props = {};
                    $c71cf52c680b1470$var$ForwardProperties.forEach((name)=>{
                        if (e[name] == null) return;
                        props[name] = e[name];
                    });
                    $c71cf52c680b1470$var$logger.throwError(e.reason || e.message, errorCode, props);
                });
                // All configs have run to completion; we will never get more data
                if (configs.filter((c)=>!c.done).length === 0) break;
            }
            // Shut down any stallers; shouldn't be any
            configs.forEach((c)=>{
                if (c.staller) c.staller.cancel();
                c.cancelled = true;
            });
            return $c71cf52c680b1470$var$logger.throwError("failed to meet quorum", (0, $6M65e.Logger).errors.SERVER_ERROR, {
                method: method,
                params: params,
                //results: configs.map((c) => c.result),
                //errors: configs.map((c) => c.error),
                results: configs.map((c)=>$c71cf52c680b1470$var$exposeDebugConfig(c)),
                provider: this
            });
        });
    }
    constructor(providers, quorum){
        if (providers.length === 0) $c71cf52c680b1470$var$logger.throwArgumentError("missing providers", "providers", providers);
        const providerConfigs = providers.map((configOrProvider, index)=>{
            if ((0, $lLovk.Provider).isProvider(configOrProvider)) {
                const stallTimeout = (0, $f1MgE.isCommunityResource)(configOrProvider) ? 2000 : 750;
                const priority = 1;
                return Object.freeze({
                    provider: configOrProvider,
                    weight: 1,
                    stallTimeout: stallTimeout,
                    priority: priority
                });
            }
            const config = (0, $2ax4w.shallowCopy)(configOrProvider);
            if (config.priority == null) config.priority = 1;
            if (config.stallTimeout == null) config.stallTimeout = (0, $f1MgE.isCommunityResource)(configOrProvider) ? 2000 : 750;
            if (config.weight == null) config.weight = 1;
            const weight = config.weight;
            if (weight % 1 || weight > 512 || weight < 1) $c71cf52c680b1470$var$logger.throwArgumentError("invalid weight; must be integer in [1, 512]", `providers[${index}].weight`, weight);
            return Object.freeze(config);
        });
        const total = providerConfigs.reduce((accum, c)=>accum + c.weight, 0);
        if (quorum == null) quorum = total / 2;
        else if (quorum > total) $c71cf52c680b1470$var$logger.throwArgumentError("quorum will always fail; larger than total weight", "quorum", quorum);
        // Are all providers' networks are known
        let networkOrReady = $c71cf52c680b1470$var$checkNetworks(providerConfigs.map((c)=>c.provider.network));
        // Not all networks are known; we must stall
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then(resolve, reject);
            }, 0);
        });
        super(networkOrReady);
        // Preserve a copy, so we do not get mutated
        (0, $2ax4w.defineReadOnly)(this, "providerConfigs", Object.freeze(providerConfigs));
        (0, $2ax4w.defineReadOnly)(this, "quorum", quorum);
        this._highestBlockNumber = -1;
    }
}

});

parcelRegister("9FSRo", function(module, exports) {

$parcel$export(module.exports, "IpcProvider", function () { return $70b27f74974a2dd3$export$fbe151f90a1ece01; });
"use strict";
const $70b27f74974a2dd3$export$fbe151f90a1ece01 = null;

});

parcelRegister("eGbhc", function(module, exports) {

$parcel$export(module.exports, "InfuraWebSocketProvider", function () { return $aafdbc33abd5222f$export$dd168a807d60da4f; });
$parcel$export(module.exports, "InfuraProvider", function () { return $aafdbc33abd5222f$export$60ff1a559b5c6ebd; });

var $2ax4w = parcelRequire("2ax4w");

var $dCAfX = parcelRequire("dCAfX");

var $f1MgE = parcelRequire("f1MgE");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");

var $jLiNX = parcelRequire("jLiNX");
"use strict";
const $aafdbc33abd5222f$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
const $aafdbc33abd5222f$var$defaultProjectId = "84842078b09946638c03157f83405213";
class $aafdbc33abd5222f$export$dd168a807d60da4f extends (0, $dCAfX.WebSocketProvider) {
    isCommunityResource() {
        return this.projectId === $aafdbc33abd5222f$var$defaultProjectId;
    }
    constructor(network, apiKey){
        const provider = new $aafdbc33abd5222f$export$60ff1a559b5c6ebd(network, apiKey);
        const connection = provider.connection;
        if (connection.password) $aafdbc33abd5222f$var$logger.throwError("INFURA WebSocket project secrets unsupported", (0, $6M65e.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "InfuraProvider.getWebSocketProvider()"
        });
        const url = connection.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
        super(url, network);
        (0, $2ax4w.defineReadOnly)(this, "apiKey", provider.projectId);
        (0, $2ax4w.defineReadOnly)(this, "projectId", provider.projectId);
        (0, $2ax4w.defineReadOnly)(this, "projectSecret", provider.projectSecret);
    }
}
class $aafdbc33abd5222f$export$60ff1a559b5c6ebd extends (0, $jLiNX.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $aafdbc33abd5222f$export$dd168a807d60da4f(network, apiKey);
    }
    static getApiKey(apiKey) {
        const apiKeyObj = {
            apiKey: $aafdbc33abd5222f$var$defaultProjectId,
            projectId: $aafdbc33abd5222f$var$defaultProjectId,
            projectSecret: null
        };
        if (apiKey == null) return apiKeyObj;
        if (typeof apiKey === "string") apiKeyObj.projectId = apiKey;
        else if (apiKey.projectSecret != null) {
            $aafdbc33abd5222f$var$logger.assertArgument(typeof apiKey.projectId === "string", "projectSecret requires a projectId", "projectId", apiKey.projectId);
            $aafdbc33abd5222f$var$logger.assertArgument(typeof apiKey.projectSecret === "string", "invalid projectSecret", "projectSecret", "[REDACTED]");
            apiKeyObj.projectId = apiKey.projectId;
            apiKeyObj.projectSecret = apiKey.projectSecret;
        } else if (apiKey.projectId) apiKeyObj.projectId = apiKey.projectId;
        apiKeyObj.apiKey = apiKeyObj.projectId;
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "homestead":
                host = "mainnet.infura.io";
                break;
            case "goerli":
                host = "goerli.infura.io";
                break;
            case "sepolia":
                host = "sepolia.infura.io";
                break;
            case "matic":
                host = "polygon-mainnet.infura.io";
                break;
            case "maticmum":
                host = "polygon-mumbai.infura.io";
                break;
            case "optimism":
                host = "optimism-mainnet.infura.io";
                break;
            case "optimism-goerli":
                host = "optimism-goerli.infura.io";
                break;
            case "arbitrum":
                host = "arbitrum-mainnet.infura.io";
                break;
            case "arbitrum-goerli":
                host = "arbitrum-goerli.infura.io";
                break;
            default:
                $aafdbc33abd5222f$var$logger.throwError("unsupported network", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const connection = {
            allowGzip: true,
            url: "https://" + host + "/v3/" + apiKey.projectId,
            throttleCallback: (attempt, url)=>{
                if (apiKey.projectId === $aafdbc33abd5222f$var$defaultProjectId) (0, $f1MgE.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
    isCommunityResource() {
        return this.projectId === $aafdbc33abd5222f$var$defaultProjectId;
    }
}

});

parcelRegister("fcnNv", function(module, exports) {

$parcel$export(module.exports, "JsonRpcBatchProvider", function () { return $b10a6faa86d631b8$export$5a16092bf20edf97; });

var $2ax4w = parcelRequire("2ax4w");

var $gqL7R = parcelRequire("gqL7R");

var $aDPpa = parcelRequire("aDPpa");
class $b10a6faa86d631b8$export$5a16092bf20edf97 extends (0, $aDPpa.JsonRpcProvider) {
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        if (this._pendingBatch == null) this._pendingBatch = [];
        const inflightRequest = {
            request: request,
            resolve: null,
            reject: null
        };
        const promise = new Promise((resolve, reject)=>{
            inflightRequest.resolve = resolve;
            inflightRequest.reject = reject;
        });
        this._pendingBatch.push(inflightRequest);
        if (!this._pendingBatchAggregator) // Schedule batch for next event loop + short duration
        this._pendingBatchAggregator = setTimeout(()=>{
            // Get teh current batch and clear it, so new requests
            // go into the next batch
            const batch = this._pendingBatch;
            this._pendingBatch = null;
            this._pendingBatchAggregator = null;
            // Get the request as an array of requests
            const request = batch.map((inflight)=>inflight.request);
            this.emit("debug", {
                action: "requestBatch",
                request: (0, $2ax4w.deepCopy)(request),
                provider: this
            });
            return (0, $gqL7R.fetchJson)(this.connection, JSON.stringify(request)).then((result)=>{
                this.emit("debug", {
                    action: "response",
                    request: request,
                    response: result,
                    provider: this
                });
                // For each result, feed it to the correct Promise, depending
                // on whether it was a success or error
                batch.forEach((inflightRequest, index)=>{
                    const payload = result[index];
                    if (payload.error) {
                        const error = new Error(payload.error.message);
                        error.code = payload.error.code;
                        error.data = payload.error.data;
                        inflightRequest.reject(error);
                    } else inflightRequest.resolve(payload.result);
                });
            }, (error)=>{
                this.emit("debug", {
                    action: "response",
                    error: error,
                    request: request,
                    provider: this
                });
                batch.forEach((inflightRequest)=>{
                    inflightRequest.reject(error);
                });
            });
        }, 10);
        return promise;
    }
}

});

parcelRegister("7bZQB", function(module, exports) {

$parcel$export(module.exports, "NodesmithProvider", function () { return $53c9891537aa720d$export$8235cbce3ce273bd; });
/* istanbul ignore file */ 
var $jLiNX = parcelRequire("jLiNX");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");
"use strict";
const $53c9891537aa720d$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
// Special API key provided by Nodesmith for ethers.js
const $53c9891537aa720d$var$defaultApiKey = "ETHERS_JS_SHARED";
class $53c9891537aa720d$export$8235cbce3ce273bd extends (0, $jLiNX.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey && typeof apiKey !== "string") $53c9891537aa720d$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey || $53c9891537aa720d$var$defaultApiKey;
    }
    static getUrl(network, apiKey) {
        $53c9891537aa720d$var$logger.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
                break;
            case "ropsten":
                host = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
                break;
            case "rinkeby":
                host = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
                break;
            case "goerli":
                host = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
                break;
            case "kovan":
                host = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
                break;
            default:
                $53c9891537aa720d$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host + "?apiKey=" + apiKey;
    }
}

});

parcelRegister("lc6pB", function(module, exports) {

$parcel$export(module.exports, "PocketProvider", function () { return $f6dfb138e1bee94a$export$58bb47e42f6b092e; });

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");

var $jLiNX = parcelRequire("jLiNX");
"use strict";
const $f6dfb138e1bee94a$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
const $f6dfb138e1bee94a$var$defaultApplicationId = "62e1ad51b37b8e00394bda3b";
class $f6dfb138e1bee94a$export$58bb47e42f6b092e extends (0, $jLiNX.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        const apiKeyObj = {
            applicationId: null,
            loadBalancer: true,
            applicationSecretKey: null
        };
        // Parse applicationId and applicationSecretKey
        if (apiKey == null) apiKeyObj.applicationId = $f6dfb138e1bee94a$var$defaultApplicationId;
        else if (typeof apiKey === "string") apiKeyObj.applicationId = apiKey;
        else if (apiKey.applicationSecretKey != null) {
            apiKeyObj.applicationId = apiKey.applicationId;
            apiKeyObj.applicationSecretKey = apiKey.applicationSecretKey;
        } else if (apiKey.applicationId) apiKeyObj.applicationId = apiKey.applicationId;
        else $f6dfb138e1bee94a$var$logger.throwArgumentError("unsupported PocketProvider apiKey", "apiKey", apiKey);
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "goerli":
                host = "eth-goerli.gateway.pokt.network";
                break;
            case "homestead":
                host = "eth-mainnet.gateway.pokt.network";
                break;
            case "kovan":
                host = "poa-kovan.gateway.pokt.network";
                break;
            case "matic":
                host = "poly-mainnet.gateway.pokt.network";
                break;
            case "maticmum":
                host = "polygon-mumbai-rpc.gateway.pokt.network";
                break;
            case "rinkeby":
                host = "eth-rinkeby.gateway.pokt.network";
                break;
            case "ropsten":
                host = "eth-ropsten.gateway.pokt.network";
                break;
            default:
                $f6dfb138e1bee94a$var$logger.throwError("unsupported network", (0, $6M65e.Logger).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const url = `https:/\/${host}/v1/lb/${apiKey.applicationId}`;
        const connection = {
            headers: {},
            url: url
        };
        if (apiKey.applicationSecretKey != null) {
            connection.user = "";
            connection.password = apiKey.applicationSecretKey;
        }
        return connection;
    }
    isCommunityResource() {
        return this.applicationId === $f6dfb138e1bee94a$var$defaultApplicationId;
    }
}

});

parcelRegister("lh9ZS", function(module, exports) {

$parcel$export(module.exports, "Web3Provider", function () { return $f7d2f0b1fa262e29$export$d05096c9fd9d936d; });

var $2ax4w = parcelRequire("2ax4w");

var $6M65e = parcelRequire("6M65e");

var $iEaZ1 = parcelRequire("iEaZ1");

var $aDPpa = parcelRequire("aDPpa");
"use strict";
const $f7d2f0b1fa262e29$var$logger = new (0, $6M65e.Logger)((0, $iEaZ1.version));
let $f7d2f0b1fa262e29$var$_nextId = 1;
function $f7d2f0b1fa262e29$var$buildWeb3LegacyFetcher(provider, sendFunc) {
    const fetcher = "Web3LegacyFetcher";
    return function(method, params) {
        const request = {
            method: method,
            params: params,
            id: $f7d2f0b1fa262e29$var$_nextId++,
            jsonrpc: "2.0"
        };
        return new Promise((resolve, reject)=>{
            this.emit("debug", {
                action: "request",
                fetcher: fetcher,
                request: (0, $2ax4w.deepCopy)(request),
                provider: this
            });
            sendFunc(request, (error, response)=>{
                if (error) {
                    this.emit("debug", {
                        action: "response",
                        fetcher: fetcher,
                        error: error,
                        request: request,
                        provider: this
                    });
                    return reject(error);
                }
                this.emit("debug", {
                    action: "response",
                    fetcher: fetcher,
                    request: request,
                    response: response,
                    provider: this
                });
                if (response.error) {
                    const error = new Error(response.error.message);
                    error.code = response.error.code;
                    error.data = response.error.data;
                    return reject(error);
                }
                resolve(response.result);
            });
        });
    };
}
function $f7d2f0b1fa262e29$var$buildEip1193Fetcher(provider) {
    return function(method, params) {
        if (params == null) params = [];
        const request = {
            method: method,
            params: params
        };
        this.emit("debug", {
            action: "request",
            fetcher: "Eip1193Fetcher",
            request: (0, $2ax4w.deepCopy)(request),
            provider: this
        });
        return provider.request(request).then((response)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                response: response,
                provider: this
            });
            return response;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                error: error,
                provider: this
            });
            throw error;
        });
    };
}
class $f7d2f0b1fa262e29$export$d05096c9fd9d936d extends (0, $aDPpa.JsonRpcProvider) {
    send(method, params) {
        return this.jsonRpcFetchFunc(method, params);
    }
    constructor(provider, network){
        if (provider == null) $f7d2f0b1fa262e29$var$logger.throwArgumentError("missing provider", "provider", provider);
        let path = null;
        let jsonRpcFetchFunc = null;
        let subprovider = null;
        if (typeof provider === "function") {
            path = "unknown:";
            jsonRpcFetchFunc = provider;
        } else {
            path = provider.host || provider.path || "";
            if (!path && provider.isMetaMask) path = "metamask";
            subprovider = provider;
            if (provider.request) {
                if (path === "") path = "eip-1193:";
                jsonRpcFetchFunc = $f7d2f0b1fa262e29$var$buildEip1193Fetcher(provider);
            } else if (provider.sendAsync) jsonRpcFetchFunc = $f7d2f0b1fa262e29$var$buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
            else if (provider.send) jsonRpcFetchFunc = $f7d2f0b1fa262e29$var$buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
            else $f7d2f0b1fa262e29$var$logger.throwArgumentError("unsupported provider", "provider", provider);
            if (!path) path = "unknown:";
        }
        super(path, network);
        (0, $2ax4w.defineReadOnly)(this, "jsonRpcFetchFunc", jsonRpcFetchFunc);
        (0, $2ax4w.defineReadOnly)(this, "provider", subprovider);
    }
}

});


parcelRegister("e5s6c", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", function () { return (parcelRequire("yKVLS")).AbiCoder; });
$parcel$export(module.exports, "defaultAbiCoder", function () { return (parcelRequire("yKVLS")).defaultAbiCoder; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("6CFiK")).Fragment; });
$parcel$export(module.exports, "ConstructorFragment", function () { return (parcelRequire("6CFiK")).ConstructorFragment; });
$parcel$export(module.exports, "ErrorFragment", function () { return (parcelRequire("6CFiK")).ErrorFragment; });
$parcel$export(module.exports, "EventFragment", function () { return (parcelRequire("6CFiK")).EventFragment; });
$parcel$export(module.exports, "FunctionFragment", function () { return (parcelRequire("6CFiK")).FunctionFragment; });
$parcel$export(module.exports, "ParamType", function () { return (parcelRequire("6CFiK")).ParamType; });
$parcel$export(module.exports, "FormatTypes", function () { return (parcelRequire("6CFiK")).FormatTypes; });
$parcel$export(module.exports, "checkResultErrors", function () { return (parcelRequire("ggjPf")).checkResultErrors; });
$parcel$export(module.exports, "Logger", function () { return (parcelRequire("6M65e")).Logger; });
$parcel$export(module.exports, "RLP", function () { return (parcelRequire("dQcqA")); });
$parcel$export(module.exports, "_fetchData", function () { return (parcelRequire("gqL7R"))._fetchData; });
$parcel$export(module.exports, "fetchJson", function () { return (parcelRequire("gqL7R")).fetchJson; });
$parcel$export(module.exports, "poll", function () { return (parcelRequire("gqL7R")).poll; });
$parcel$export(module.exports, "checkProperties", function () { return (parcelRequire("2ax4w")).checkProperties; });
$parcel$export(module.exports, "deepCopy", function () { return (parcelRequire("2ax4w")).deepCopy; });
$parcel$export(module.exports, "defineReadOnly", function () { return (parcelRequire("2ax4w")).defineReadOnly; });
$parcel$export(module.exports, "getStatic", function () { return (parcelRequire("2ax4w")).getStatic; });
$parcel$export(module.exports, "resolveProperties", function () { return (parcelRequire("2ax4w")).resolveProperties; });
$parcel$export(module.exports, "shallowCopy", function () { return (parcelRequire("2ax4w")).shallowCopy; });
$parcel$export(module.exports, "arrayify", function () { return (parcelRequire("j2rU8")).arrayify; });
$parcel$export(module.exports, "concat", function () { return (parcelRequire("j2rU8")).concat; });
$parcel$export(module.exports, "stripZeros", function () { return (parcelRequire("j2rU8")).stripZeros; });
$parcel$export(module.exports, "zeroPad", function () { return (parcelRequire("j2rU8")).zeroPad; });
$parcel$export(module.exports, "isBytes", function () { return (parcelRequire("j2rU8")).isBytes; });
$parcel$export(module.exports, "isBytesLike", function () { return (parcelRequire("j2rU8")).isBytesLike; });
$parcel$export(module.exports, "defaultPath", function () { return (parcelRequire("5iEGT")).defaultPath; });
$parcel$export(module.exports, "HDNode", function () { return (parcelRequire("5iEGT")).HDNode; });
$parcel$export(module.exports, "SigningKey", function () { return (parcelRequire("4LuuL")).SigningKey; });
$parcel$export(module.exports, "Interface", function () { return (parcelRequire("9rkfU")).Interface; });
$parcel$export(module.exports, "LogDescription", function () { return (parcelRequire("9rkfU")).LogDescription; });
$parcel$export(module.exports, "TransactionDescription", function () { return (parcelRequire("9rkfU")).TransactionDescription; });
$parcel$export(module.exports, "base58", function () { return (parcelRequire("ebtr5")).Base58; });
$parcel$export(module.exports, "base64", function () { return (parcelRequire("hk1je")); });
$parcel$export(module.exports, "hexlify", function () { return (parcelRequire("j2rU8")).hexlify; });
$parcel$export(module.exports, "isHexString", function () { return (parcelRequire("j2rU8")).isHexString; });
$parcel$export(module.exports, "hexConcat", function () { return (parcelRequire("j2rU8")).hexConcat; });
$parcel$export(module.exports, "hexStripZeros", function () { return (parcelRequire("j2rU8")).hexStripZeros; });
$parcel$export(module.exports, "hexValue", function () { return (parcelRequire("j2rU8")).hexValue; });
$parcel$export(module.exports, "hexZeroPad", function () { return (parcelRequire("j2rU8")).hexZeroPad; });
$parcel$export(module.exports, "hexDataLength", function () { return (parcelRequire("j2rU8")).hexDataLength; });
$parcel$export(module.exports, "hexDataSlice", function () { return (parcelRequire("j2rU8")).hexDataSlice; });
$parcel$export(module.exports, "nameprep", function () { return (parcelRequire("eHcVC")).nameprep; });
$parcel$export(module.exports, "_toEscapedUtf8String", function () { return (parcelRequire("1Wmc7"))._toEscapedUtf8String; });
$parcel$export(module.exports, "toUtf8Bytes", function () { return (parcelRequire("1Wmc7")).toUtf8Bytes; });
$parcel$export(module.exports, "toUtf8CodePoints", function () { return (parcelRequire("1Wmc7")).toUtf8CodePoints; });
$parcel$export(module.exports, "toUtf8String", function () { return (parcelRequire("1Wmc7")).toUtf8String; });
$parcel$export(module.exports, "Utf8ErrorFuncs", function () { return (parcelRequire("1Wmc7")).Utf8ErrorFuncs; });
$parcel$export(module.exports, "formatBytes32String", function () { return (parcelRequire("9osRb")).formatBytes32String; });
$parcel$export(module.exports, "parseBytes32String", function () { return (parcelRequire("9osRb")).parseBytes32String; });
$parcel$export(module.exports, "dnsEncode", function () { return (parcelRequire("4JdI5")).dnsEncode; });
$parcel$export(module.exports, "hashMessage", function () { return (parcelRequire("7vZoR")).hashMessage; });
$parcel$export(module.exports, "namehash", function () { return (parcelRequire("4JdI5")).namehash; });
$parcel$export(module.exports, "isValidName", function () { return (parcelRequire("4JdI5")).isValidName; });
$parcel$export(module.exports, "id", function () { return (parcelRequire("4q6En")).id; });
$parcel$export(module.exports, "_TypedDataEncoder", function () { return (parcelRequire("kdj79")).TypedDataEncoder; });
$parcel$export(module.exports, "getAddress", function () { return (parcelRequire("e8NrM")).getAddress; });
$parcel$export(module.exports, "getIcapAddress", function () { return (parcelRequire("e8NrM")).getIcapAddress; });
$parcel$export(module.exports, "getContractAddress", function () { return (parcelRequire("e8NrM")).getContractAddress; });
$parcel$export(module.exports, "getCreate2Address", function () { return (parcelRequire("e8NrM")).getCreate2Address; });
$parcel$export(module.exports, "isAddress", function () { return (parcelRequire("e8NrM")).isAddress; });
$parcel$export(module.exports, "formatEther", function () { return (parcelRequire("41JdS")).formatEther; });
$parcel$export(module.exports, "parseEther", function () { return (parcelRequire("41JdS")).parseEther; });
$parcel$export(module.exports, "formatUnits", function () { return (parcelRequire("41JdS")).formatUnits; });
$parcel$export(module.exports, "parseUnits", function () { return (parcelRequire("41JdS")).parseUnits; });
$parcel$export(module.exports, "commify", function () { return (parcelRequire("41JdS")).commify; });
$parcel$export(module.exports, "computeHmac", function () { return (parcelRequire("7WUQV")).computeHmac; });
$parcel$export(module.exports, "keccak256", function () { return (parcelRequire("4ujqV")).keccak256; });
$parcel$export(module.exports, "ripemd160", function () { return (parcelRequire("7WUQV")).ripemd160; });
$parcel$export(module.exports, "sha256", function () { return (parcelRequire("7WUQV")).sha256; });
$parcel$export(module.exports, "sha512", function () { return (parcelRequire("7WUQV")).sha512; });
$parcel$export(module.exports, "randomBytes", function () { return (parcelRequire("4kSyQ")).randomBytes; });
$parcel$export(module.exports, "shuffled", function () { return (parcelRequire("5aKt1")).shuffled; });
$parcel$export(module.exports, "solidityPack", function () { return (parcelRequire("ihTqz")).pack; });
$parcel$export(module.exports, "solidityKeccak256", function () { return (parcelRequire("ihTqz")).keccak256; });
$parcel$export(module.exports, "soliditySha256", function () { return (parcelRequire("ihTqz")).sha256; });
$parcel$export(module.exports, "splitSignature", function () { return (parcelRequire("j2rU8")).splitSignature; });
$parcel$export(module.exports, "joinSignature", function () { return (parcelRequire("j2rU8")).joinSignature; });
$parcel$export(module.exports, "accessListify", function () { return (parcelRequire("hDQeE")).accessListify; });
$parcel$export(module.exports, "parseTransaction", function () { return (parcelRequire("hDQeE")).parse; });
$parcel$export(module.exports, "serializeTransaction", function () { return (parcelRequire("hDQeE")).serialize; });
$parcel$export(module.exports, "TransactionTypes", function () { return (parcelRequire("hDQeE")).TransactionTypes; });
$parcel$export(module.exports, "getJsonWalletAddress", function () { return (parcelRequire("6jMeD")).getJsonWalletAddress; });
$parcel$export(module.exports, "computeAddress", function () { return (parcelRequire("hDQeE")).computeAddress; });
$parcel$export(module.exports, "recoverAddress", function () { return (parcelRequire("hDQeE")).recoverAddress; });
$parcel$export(module.exports, "computePublicKey", function () { return (parcelRequire("4LuuL")).computePublicKey; });
$parcel$export(module.exports, "recoverPublicKey", function () { return (parcelRequire("4LuuL")).recoverPublicKey; });
$parcel$export(module.exports, "verifyMessage", function () { return (parcelRequire("54wuV")).verifyMessage; });
$parcel$export(module.exports, "verifyTypedData", function () { return (parcelRequire("54wuV")).verifyTypedData; });
$parcel$export(module.exports, "getAccountPath", function () { return (parcelRequire("5iEGT")).getAccountPath; });
$parcel$export(module.exports, "mnemonicToEntropy", function () { return (parcelRequire("5iEGT")).mnemonicToEntropy; });
$parcel$export(module.exports, "entropyToMnemonic", function () { return (parcelRequire("5iEGT")).entropyToMnemonic; });
$parcel$export(module.exports, "isValidMnemonic", function () { return (parcelRequire("5iEGT")).isValidMnemonic; });
$parcel$export(module.exports, "mnemonicToSeed", function () { return (parcelRequire("5iEGT")).mnemonicToSeed; });
$parcel$export(module.exports, "SupportedAlgorithm", function () { return (parcelRequire("aCF4U")).SupportedAlgorithm; });
$parcel$export(module.exports, "UnicodeNormalizationForm", function () { return (parcelRequire("1Wmc7")).UnicodeNormalizationForm; });
$parcel$export(module.exports, "Utf8ErrorReason", function () { return (parcelRequire("1Wmc7")).Utf8ErrorReason; });
$parcel$export(module.exports, "Indexed", function () { return (parcelRequire("9rkfU")).Indexed; });

var $yKVLS = parcelRequire("yKVLS");
var $ggjPf = parcelRequire("ggjPf");
var $6CFiK = parcelRequire("6CFiK");
var $9rkfU = parcelRequire("9rkfU");

var $e8NrM = parcelRequire("e8NrM");

var $hk1je = parcelRequire("hk1je");

var $ebtr5 = parcelRequire("ebtr5");

var $j2rU8 = parcelRequire("j2rU8");

var $kdj79 = parcelRequire("kdj79");
var $4JdI5 = parcelRequire("4JdI5");
var $7vZoR = parcelRequire("7vZoR");
var $4q6En = parcelRequire("4q6En");

var $5iEGT = parcelRequire("5iEGT");

var $6jMeD = parcelRequire("6jMeD");

var $4ujqV = parcelRequire("4ujqV");

var $6M65e = parcelRequire("6M65e");

var $7WUQV = parcelRequire("7WUQV");
var $aCF4U = parcelRequire("aCF4U");

var $ihTqz = parcelRequire("ihTqz");

var $4kSyQ = parcelRequire("4kSyQ");
var $5aKt1 = parcelRequire("5aKt1");

var $2ax4w = parcelRequire("2ax4w");

var $dQcqA = parcelRequire("dQcqA");

var $4LuuL = parcelRequire("4LuuL");

var $1Wmc7 = parcelRequire("1Wmc7");
var $9osRb = parcelRequire("9osRb");
var $eHcVC = parcelRequire("eHcVC");

var $hDQeE = parcelRequire("hDQeE");

var $41JdS = parcelRequire("41JdS");

var $54wuV = parcelRequire("54wuV");

var $gqL7R = parcelRequire("gqL7R");
"use strict";

});

parcelRegister("d7X94", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $98e9ced0691461ae$export$83d89fbfd8236492; });
const $98e9ced0691461ae$export$83d89fbfd8236492 = "ethers/5.7.2";

});



parcelRegister("1rXfw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useDefaultIfUndefined = module.exports.hexlifyWithout0xPrefix = module.exports.convertBytesToNumber = module.exports.convertIntegerNumberToBytes = module.exports.convertNumberToBytes = module.exports.convertStringToBytes32 = module.exports.assert = void 0;

var $gMArf = parcelRequire("gMArf");

var $hbWVX = parcelRequire("hbWVX");
const $10e645bbba44065c$var$ZERO_EX_PREFIX_LENGTH = 2;
const $10e645bbba44065c$var$assert = (condition, errMsg)=>{
    if (!condition) {
        const errText = `Assertion failed` + (errMsg ? `: ${errMsg}` : "");
        throw new Error(errText);
    }
};
module.exports.assert = $10e645bbba44065c$var$assert;
const $10e645bbba44065c$var$convertStringToBytes32 = (str)=>{
    let bytes32Str;
    if (str.length > 31) bytes32Str = (0, $hbWVX.keccak256)((0, $hbWVX.isHexString)(str) ? str : (0, $hbWVX.toUtf8Bytes)(str));
    else bytes32Str = (0, $hbWVX.formatBytes32String)(str);
    return (0, $hbWVX.arrayify)(bytes32Str);
};
module.exports.convertStringToBytes32 = $10e645bbba44065c$var$convertStringToBytes32;
const $10e645bbba44065c$var$convertNumberToBytes = (value, decimals, byteSize, roundFractionalComponentIfExceedsDecimals = true)=>{
    let stringifiedNumber = roundFractionalComponentIfExceedsDecimals ? Number(value).toFixed(decimals) : String(value);
    if (stringifiedNumber.includes("e")) stringifiedNumber = Number(stringifiedNumber).toLocaleString("fullwide", {
        useGrouping: false
    });
    const bigNumberValue = (0, $hbWVX.parseUnits)(stringifiedNumber, decimals);
    const bytesValue = (0, $hbWVX.arrayify)(bigNumberValue.toHexString());
    if (byteSize < bytesValue.length) throw new Error(`Overflow: ` + `value: ${value}, ` + `decimals: ${decimals}, ` + `byteSize: ${byteSize}`);
    else return (0, $hbWVX.zeroPad)(bytesValue, byteSize);
};
module.exports.convertNumberToBytes = $10e645bbba44065c$var$convertNumberToBytes;
const $10e645bbba44065c$var$convertIntegerNumberToBytes = (value, byteSize)=>{
    (0, module.exports.assert)(Number.isInteger(Number(value)), "convertIntegerNumberToBytes expects integer as input");
    const decimals = 0;
    return (0, module.exports.convertNumberToBytes)(value, decimals, byteSize);
};
module.exports.convertIntegerNumberToBytes = $10e645bbba44065c$var$convertIntegerNumberToBytes;
const $10e645bbba44065c$var$convertBytesToNumber = (bytes)=>$gMArf.BigNumber.from(bytes).toNumber();
module.exports.convertBytesToNumber = $10e645bbba44065c$var$convertBytesToNumber;
const $10e645bbba44065c$var$hexlifyWithout0xPrefix = (value)=>{
    return (0, $hbWVX.hexlify)(value).slice($10e645bbba44065c$var$ZERO_EX_PREFIX_LENGTH);
};
module.exports.hexlifyWithout0xPrefix = $10e645bbba44065c$var$hexlifyWithout0xPrefix;
function $10e645bbba44065c$var$useDefaultIfUndefined(value, defaultValue) {
    return value === undefined ? defaultValue : value;
}
module.exports.useDefaultIfUndefined = $10e645bbba44065c$var$useDefaultIfUndefined;

});


parcelRegister("1B1Kl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.deserializeDataPointFromObj = void 0;

var $hbWVX = parcelRequire("hbWVX");

var $57RSt = parcelRequire("57RSt");

var $hHFIh = parcelRequire("hHFIh");
const $129a99faf45467c6$var$deserializeDataPointFromObj = (plainObject)=>{
    if (typeof plainObject.value == "number") return new $hHFIh.NumericDataPoint(plainObject);
    else return new $57RSt.DataPoint(plainObject.dataFeedId, $hbWVX.base64.decode(plainObject.value), plainObject.metadata);
};
module.exports.deserializeDataPointFromObj = $129a99faf45467c6$var$deserializeDataPointFromObj;

});
parcelRegister("57RSt", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataPoint = void 0;

var $hbWVX = parcelRequire("hbWVX");

var $t9PVr = parcelRequire("t9PVr");

var $1rXfw = parcelRequire("1rXfw");
class $3bb7662f59c92700$var$DataPoint extends $t9PVr.Serializable {
    serializeDataFeedId() {
        return (0, $1rXfw.convertStringToBytes32)(this.dataFeedId);
    }
    toObj() {
        return {
            dataFeedId: this.dataFeedId,
            value: $hbWVX.base64.encode(this.value),
            metadata: this.metadata
        };
    }
    getValueByteSize() {
        return this.value.length;
    }
    toBytes() {
        const serializedDataFeedId = this.serializeDataFeedId();
        return (0, $hbWVX.concat)([
            serializedDataFeedId,
            this.value
        ]);
    }
    constructor(dataFeedId, value, metadata){
        super();
        (0, $dxWQo._)(this, "dataFeedId", void 0);
        (0, $dxWQo._)(this, "value", void 0);
        (0, $dxWQo._)(this, "metadata", void 0);
        this.dataFeedId = dataFeedId;
        this.value = value;
        this.metadata = metadata;
    }
}
module.exports.DataPoint = $3bb7662f59c92700$var$DataPoint;

});

parcelRegister("hHFIh", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NumericDataPoint = module.exports.getNumericDataPointDecimals = void 0;

var $4nqB9 = parcelRequire("4nqB9");

var $1rXfw = parcelRequire("1rXfw");

var $57RSt = parcelRequire("57RSt");
const $ce36cf3073fa61b7$var$getNumericDataPointDecimals = (dataPoint)=>{
    var _dataPoint_decimals;
    return (_dataPoint_decimals = dataPoint.decimals) !== null && _dataPoint_decimals !== void 0 ? _dataPoint_decimals : $4nqB9.DEFAULT_NUM_VALUE_DECIMALS;
};
module.exports.getNumericDataPointDecimals = $ce36cf3073fa61b7$var$getNumericDataPointDecimals;
class $ce36cf3073fa61b7$var$NumericDataPoint extends $57RSt.DataPoint {
    toObj() {
        return {
            ...this.numericDataPointArgs
        };
    }
    constructor(numericDataPointArgs){
        const decimals = (0, $1rXfw.useDefaultIfUndefined)(numericDataPointArgs.decimals, $4nqB9.DEFAULT_NUM_VALUE_DECIMALS);
        const valueByteSize = (0, $1rXfw.useDefaultIfUndefined)(numericDataPointArgs.valueByteSize, $4nqB9.DEFAULT_NUM_VALUE_BS);
        const valueBytes = (0, $1rXfw.convertNumberToBytes)(numericDataPointArgs.value, decimals, valueByteSize);
        super(numericDataPointArgs.dataFeedId, valueBytes, numericDataPointArgs.metadata);
        (0, $dxWQo._)(this, "numericDataPointArgs", void 0);
        this.numericDataPointArgs = numericDataPointArgs;
    }
}
module.exports.NumericDataPoint = $ce36cf3073fa61b7$var$NumericDataPoint;

});


parcelRegister("872HT", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignedDataPackage = void 0;

var $hbWVX = parcelRequire("hbWVX");

var $t9PVr = parcelRequire("t9PVr");

var $dnpyO = parcelRequire("dnpyO");
class $5e8113b24f1e3e11$var$SignedDataPackage extends $t9PVr.Serializable {
    serializeSignatureToBytes() {
        return (0, $hbWVX.arrayify)(this.serializeSignatureToHex());
    }
    serializeSignatureToHex() {
        return (0, $hbWVX.joinSignature)(this.signature);
    }
    recoverSignerPublicKey() {
        return (0, $dnpyO.recoverSignerPublicKey)(this);
    }
    recoverSignerAddress() {
        return (0, $dnpyO.recoverSignerAddress)(this);
    }
    toBytes() {
        return (0, $hbWVX.concat)([
            this.dataPackage.toBytes(),
            this.serializeSignatureToBytes()
        ]);
    }
    toObj() {
        const signatureHex = this.serializeSignatureToHex();
        return {
            ...this.dataPackage.toObj(),
            signature: $hbWVX.base64.encode(signatureHex)
        };
    }
    static fromObj(plainObject) {
        return $5e8113b24f1e3e11$var$SignedDataPackage.fromObjLikeThis((0, $dnpyO.deserializeSignedPackage)(plainObject));
    }
    static fromObjLikeThis(object) {
        return new $5e8113b24f1e3e11$var$SignedDataPackage(object.dataPackage, object.signature);
    }
    constructor(dataPackage, signature){
        super();
        (0, $dxWQo._)(this, "dataPackage", void 0);
        (0, $dxWQo._)(this, "signature", void 0);
        this.dataPackage = dataPackage;
        if (typeof signature === "string") this.signature = (0, $hbWVX.splitSignature)(signature);
        else this.signature = signature;
    }
}
module.exports.SignedDataPackage = $5e8113b24f1e3e11$var$SignedDataPackage;

});
parcelRegister("dnpyO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.recoverDeserializedSignerAddress = module.exports.recoverSignerAddress = module.exports.recoverSignerPublicKey = module.exports.deserializeSignedPackage = void 0;

var $hbWVX = parcelRequire("hbWVX");

var $3Cpsw = parcelRequire("3Cpsw");
function $9bd1402277e08f24$var$deserializeSignedPackage(plainObject) {
    const signatureBase64 = plainObject.signature;
    if (!signatureBase64) throw new Error("Signature can not be empty");
    const signatureBytes = $hbWVX.base64.decode(signatureBase64);
    const parsedSignature = (0, $hbWVX.splitSignature)(signatureBytes);
    const { signature: _, ...unsignedDataPackagePlainObj } = plainObject;
    const unsignedDataPackage = $3Cpsw.DataPackage.fromObj(unsignedDataPackagePlainObj);
    return {
        signature: parsedSignature,
        dataPackage: unsignedDataPackage
    };
}
module.exports.deserializeSignedPackage = $9bd1402277e08f24$var$deserializeSignedPackage;
function $9bd1402277e08f24$var$recoverSignerPublicKey(object) {
    const digest = object.dataPackage.getSignableHash();
    const publicKeyHex = (0, $hbWVX.recoverPublicKey)(digest, object.signature);
    return (0, $hbWVX.arrayify)(publicKeyHex);
}
module.exports.recoverSignerPublicKey = $9bd1402277e08f24$var$recoverSignerPublicKey;
function $9bd1402277e08f24$var$recoverSignerAddress(object) {
    const signerPublicKeyBytes = $9bd1402277e08f24$var$recoverSignerPublicKey(object);
    return (0, $hbWVX.computeAddress)(signerPublicKeyBytes);
}
module.exports.recoverSignerAddress = $9bd1402277e08f24$var$recoverSignerAddress;
function $9bd1402277e08f24$var$recoverDeserializedSignerAddress(plainObj) {
    return $9bd1402277e08f24$var$recoverSignerAddress($9bd1402277e08f24$var$deserializeSignedPackage(plainObj));
}
module.exports.recoverDeserializedSignerAddress = $9bd1402277e08f24$var$recoverDeserializedSignerAddress;

});



parcelRegister("fCX2N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StringDataPoint = void 0;

var $hbWVX = parcelRequire("hbWVX");

var $57RSt = parcelRequire("57RSt");
class $b608348b3c893aa0$var$StringDataPoint extends $57RSt.DataPoint {
    constructor(stringDataPointArgs){
        const valueBytes = (0, $hbWVX.toUtf8Bytes)(stringDataPointArgs.value);
        super(stringDataPointArgs.dataFeedId, valueBytes);
    }
}
module.exports.StringDataPoint = $b608348b3c893aa0$var$StringDataPoint;

});

parcelRegister("2klN4", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RedstonePayload = void 0;

var $hbWVX = parcelRequire("hbWVX");

var $4nqB9 = parcelRequire("4nqB9");

var $t9PVr = parcelRequire("t9PVr");

var $1rXfw = parcelRequire("1rXfw");

var $ldQYL = parcelRequire("ldQYL");
class $1b1e5a29c074299c$var$RedstonePayload extends $t9PVr.Serializable {
    static prepare(signedDataPackages, unsignedMetadata) {
        return new $1b1e5a29c074299c$var$RedstonePayload(signedDataPackages, unsignedMetadata).toBytesHexWithout0xPrefix();
    }
    toObj() {
        return {
            signedDataPackages: this.signedDataPackages.map((signedDataPackage)=>signedDataPackage.toObj()),
            unsignedMetadata: this.unsignedMetadata
        };
    }
    toBytes() {
        return (0, $hbWVX.concat)([
            this.serializeSignedDataPackages(),
            this.serializeUnsignedMetadata(),
            $4nqB9.REDSTONE_MARKER_HEX
        ]);
    }
    serializeUnsignedMetadata() {
        const unsignedMetadataBytes = (0, $hbWVX.toUtf8Bytes)(this.unsignedMetadata);
        const unsignedMetadataByteSizeBytes = (0, $1rXfw.convertIntegerNumberToBytes)(unsignedMetadataBytes.length, $4nqB9.UNSIGNED_METADATA_BYTE_SIZE_BS);
        return (0, $hbWVX.concat)([
            unsignedMetadataBytes,
            unsignedMetadataByteSizeBytes
        ]);
    }
    serializeSignedDataPackages() {
        return (0, $hbWVX.concat)([
            ...this.signedDataPackages.map((signedDataPackage)=>signedDataPackage.toBytes()),
            (0, $1rXfw.convertIntegerNumberToBytes)(this.signedDataPackages.length, $4nqB9.DATA_PACKAGES_COUNT_BS)
        ]);
    }
    static parse(bytesWithRedstonePayloadInTheEnd) {
        return new $ldQYL.RedstonePayloadParser(bytesWithRedstonePayloadInTheEnd).parse();
    }
    constructor(signedDataPackages, unsignedMetadata){
        super();
        (0, $dxWQo._)(this, "signedDataPackages", void 0);
        (0, $dxWQo._)(this, "unsignedMetadata", void 0);
        this.signedDataPackages = signedDataPackages;
        this.unsignedMetadata = unsignedMetadata;
    }
}
module.exports.RedstonePayload = $1b1e5a29c074299c$var$RedstonePayload;

});
parcelRegister("ldQYL", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.convertDataPointToNumericDataPoint = module.exports.RedstonePayloadParser = void 0;

var $gMArf = parcelRequire("gMArf");

var $hbWVX = parcelRequire("hbWVX");

var $4nqB9 = parcelRequire("4nqB9");

var $1rXfw = parcelRequire("1rXfw");

var $3Cpsw = parcelRequire("3Cpsw");

var $872HT = parcelRequire("872HT");

var $57RSt = parcelRequire("57RSt");

var $hHFIh = parcelRequire("hHFIh");
class $f733e867da338d3a$var$RedstonePayloadParser {
    parse() {
        this.assertValidRedstoneMarker();
        const unsignedMetadata = this.extractUnsignedMetadata();
        let negativeOffset = unsignedMetadata.length + $4nqB9.UNSIGNED_METADATA_BYTE_SIZE_BS + $4nqB9.REDSTONE_MARKER_BS;
        const numberOfDataPackages = this.extractNumber({
            negativeOffset: negativeOffset,
            length: $4nqB9.DATA_PACKAGES_COUNT_BS
        });
        negativeOffset += $4nqB9.DATA_PACKAGES_COUNT_BS;
        const signedDataPackages = [];
        for(let i = 0; i < numberOfDataPackages; i++){
            const signedDataPackage = this.extractSignedDataPackage(negativeOffset);
            signedDataPackages.push(signedDataPackage);
            negativeOffset += signedDataPackage.toBytes().length;
        }
        const remainderPrefix = this.slice({
            negativeOffset: negativeOffset,
            length: this.bytesData.length - negativeOffset
        });
        return {
            signedDataPackages: signedDataPackages.reverse(),
            unsignedMetadata: unsignedMetadata,
            remainderPrefix: remainderPrefix
        };
    }
    extractUnsignedMetadata() {
        const unsignedMetadataSize = this.extractNumber({
            negativeOffset: $4nqB9.REDSTONE_MARKER_BS,
            length: $4nqB9.UNSIGNED_METADATA_BYTE_SIZE_BS
        });
        return this.slice({
            negativeOffset: $4nqB9.REDSTONE_MARKER_BS + $4nqB9.UNSIGNED_METADATA_BYTE_SIZE_BS,
            length: unsignedMetadataSize
        });
    }
    assertValidRedstoneMarker() {
        const redstoneMarker = this.slice({
            negativeOffset: 0,
            length: $4nqB9.REDSTONE_MARKER_BS
        });
        const redstoneMarkerHex = (0, $hbWVX.hexlify)(redstoneMarker);
        if (redstoneMarkerHex !== $4nqB9.REDSTONE_MARKER_HEX) throw new Error(`Received invalid redstone marker: ${redstoneMarkerHex}`);
    }
    extractSignedDataPackage(initialNegativeOffset) {
        let negativeOffset = initialNegativeOffset;
        const signature = this.slice({
            negativeOffset: negativeOffset,
            length: $4nqB9.SIGNATURE_BS
        });
        negativeOffset += $4nqB9.SIGNATURE_BS;
        const dataPointsCount = this.extractNumber({
            negativeOffset: negativeOffset,
            length: $4nqB9.DATA_POINTS_COUNT_BS
        });
        negativeOffset += $4nqB9.DATA_POINTS_COUNT_BS;
        const dataPointsValueSize = this.extractNumber({
            negativeOffset: negativeOffset,
            length: $4nqB9.DATA_POINT_VALUE_BYTE_SIZE_BS
        });
        negativeOffset += $4nqB9.DATA_POINT_VALUE_BYTE_SIZE_BS;
        const timestamp = this.extractNumber({
            negativeOffset: negativeOffset,
            length: $4nqB9.TIMESTAMP_BS
        });
        negativeOffset += $4nqB9.TIMESTAMP_BS;
        const dataPoints = [];
        for(let i = 0; i < dataPointsCount; i++){
            const dataPointValue = this.slice({
                negativeOffset: negativeOffset,
                length: dataPointsValueSize
            });
            negativeOffset += dataPointsValueSize;
            const dataFeedId = this.slice({
                negativeOffset: negativeOffset,
                length: $4nqB9.DATA_FEED_ID_BS
            });
            negativeOffset += $4nqB9.DATA_FEED_ID_BS;
            const dataPoint = $f733e867da338d3a$var$RedstonePayloadParser.createDataPoint(dataFeedId, dataPointValue);
            dataPoints.unshift(dataPoint);
        }
        return new $872HT.SignedDataPackage(new $3Cpsw.DataPackage(dataPoints, timestamp), (0, $hbWVX.hexlify)(signature));
    }
    static createDataPoint(dataFeedId, dataPointValue) {
        return new $57RSt.DataPoint((0, $hbWVX.toUtf8String)(dataFeedId).replaceAll("\0", ""), dataPointValue);
    }
    extractNumber(sliceConfig) {
        const bytesArr = this.slice(sliceConfig);
        return (0, $1rXfw.convertBytesToNumber)(bytesArr);
    }
    slice(sliceConfig) {
        const { negativeOffset: negativeOffset, length: length } = sliceConfig;
        const end = this.bytesData.length - negativeOffset;
        const start = end - length;
        return this.bytesData.slice(start, end);
    }
    constructor(bytesData){
        (0, $dxWQo._)(this, "bytesData", void 0);
        this.bytesData = bytesData;
    }
}
module.exports.RedstonePayloadParser = $f733e867da338d3a$var$RedstonePayloadParser;
const $f733e867da338d3a$var$convertDataPointToNumericDataPoint = (dataPoint, decimals)=>new $hHFIh.NumericDataPoint({
        value: Number((0, $hbWVX.formatUnits)($gMArf.BigNumber.from(dataPoint.value), decimals !== null && decimals !== void 0 ? decimals : $4nqB9.DEFAULT_NUM_VALUE_DECIMALS)),
        dataFeedId: dataPoint.dataFeedId,
        decimals: decimals
    });
module.exports.convertDataPointToNumericDataPoint = $f733e867da338d3a$var$convertDataPointToNumericDataPoint;

});


parcelRegister("3VZzj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UniversalSigner = void 0;

var $hbWVX = parcelRequire("hbWVX");
class $2dd67432541d7d0f$var$UniversalSigner {
    static getDigestForData(data) {
        const message = JSON.stringify(data);
        const digest = (0, $hbWVX.keccak256)((0, $hbWVX.toUtf8Bytes)(message));
        return digest;
    }
    static signStringifiableData(data, privateKey) {
        const digest = $2dd67432541d7d0f$var$UniversalSigner.getDigestForData(data);
        const signingKey = new $hbWVX.SigningKey(privateKey);
        const fullSignature = signingKey.signDigest(digest);
        return (0, $hbWVX.joinSignature)(fullSignature);
    }
    static recoverSigner(data, signature) {
        const digest = $2dd67432541d7d0f$var$UniversalSigner.getDigestForData(data);
        const publicKey = (0, $hbWVX.recoverPublicKey)(digest, signature);
        return (0, $hbWVX.computeAddress)(publicKey);
    }
    static signWithEthereumHashMessage(signerOrWallet, message) {
        return signerOrWallet.signMessage(message);
    }
    static recoverAddressFromEthereumHashMessage(message, signature) {
        return (0, $hbWVX.verifyMessage)(message, signature);
    }
}
module.exports.UniversalSigner = $2dd67432541d7d0f$var$UniversalSigner;

});

parcelRegister("eVP1d", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ScoreType = void 0;
var $02ce292433503852$var$ScoreType;
(function(ScoreType) {
    ScoreType["coinbaseKYD"] = "coinbase-kyd";
})($02ce292433503852$var$ScoreType || (module.exports.ScoreType = $02ce292433503852$var$ScoreType = {}));

});

parcelRegister("04HNS", function(module, exports) {
"use strict";
var $0003a69e0a33136e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0003a69e0a33136e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0003a69e0a33136e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0003a69e0a33136e$var$__exportStar((parcelRequire("BqXUd")), module.exports);

});
parcelRegister("BqXUd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.prepareMessageToSign = module.exports.signOnDemandDataPackage = void 0;

var $3Cpsw = parcelRequire("3Cpsw");

var $hHFIh = parcelRequire("hHFIh");
const $07085f8c327d2911$var$signOnDemandDataPackage = (address, score, timestamp, privateKey)=>{
    const dataPoint = new $hHFIh.NumericDataPoint({
        dataFeedId: address,
        value: score,
        decimals: 0
    });
    const dataPackage = new $3Cpsw.DataPackage([
        dataPoint
    ], timestamp);
    return dataPackage.sign(privateKey);
};
module.exports.signOnDemandDataPackage = $07085f8c327d2911$var$signOnDemandDataPackage;
const $07085f8c327d2911$var$prepareMessageToSign = (timestamp)=>{
    const utcDate = new Date(timestamp).toUTCString();
    return `Allow verification of my account on ${utcDate}`;
};
module.exports.prepareMessageToSign = $07085f8c327d2911$var$prepareMessageToSign;

});


parcelRegister("28feZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Axios", function () { return $18d826a12788a23d$export$1c00760e9e5a4e95; });
$parcel$export(module.exports, "AxiosError", function () { return $18d826a12788a23d$export$c1fbed17c2f6a328; });
$parcel$export(module.exports, "CanceledError", function () { return $18d826a12788a23d$export$1ab0c6b20d94fa14; });
$parcel$export(module.exports, "isCancel", function () { return $18d826a12788a23d$export$3b22524397b493c6; });
$parcel$export(module.exports, "CancelToken", function () { return $18d826a12788a23d$export$fd08e3cb425f0d61; });
$parcel$export(module.exports, "VERSION", function () { return $18d826a12788a23d$export$a4ad2735b021c132; });
$parcel$export(module.exports, "all", function () { return $18d826a12788a23d$export$84bf76cd7afc7469; });
$parcel$export(module.exports, "Cancel", function () { return $18d826a12788a23d$export$848c9b7ead0df967; });
$parcel$export(module.exports, "isAxiosError", function () { return $18d826a12788a23d$export$fbafdbe06a5b5a9a; });
$parcel$export(module.exports, "spread", function () { return $18d826a12788a23d$export$3ae0fd4797ed47c8; });
$parcel$export(module.exports, "toFormData", function () { return $18d826a12788a23d$export$10ae0d317ea97f8b; });
$parcel$export(module.exports, "AxiosHeaders", function () { return $18d826a12788a23d$export$4e7d6ff0f3e6520; });
$parcel$export(module.exports, "HttpStatusCode", function () { return $18d826a12788a23d$export$a972f69c851492b3; });
$parcel$export(module.exports, "formToJSON", function () { return $18d826a12788a23d$export$86d7c59254d6a2c9; });
$parcel$export(module.exports, "getAdapter", function () { return $18d826a12788a23d$export$17ddc20a97d669e2; });
$parcel$export(module.exports, "mergeConfig", function () { return $18d826a12788a23d$export$7ec1ebcfa9d8bd6a; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("hjpZr")).default; });

var $hjpZr = parcelRequire("hjpZr");
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $18d826a12788a23d$export$1c00760e9e5a4e95, AxiosError: $18d826a12788a23d$export$c1fbed17c2f6a328, CanceledError: $18d826a12788a23d$export$1ab0c6b20d94fa14, isCancel: $18d826a12788a23d$export$3b22524397b493c6, CancelToken: $18d826a12788a23d$export$fd08e3cb425f0d61, VERSION: $18d826a12788a23d$export$a4ad2735b021c132, all: $18d826a12788a23d$export$84bf76cd7afc7469, Cancel: $18d826a12788a23d$export$848c9b7ead0df967, isAxiosError: $18d826a12788a23d$export$fbafdbe06a5b5a9a, spread: $18d826a12788a23d$export$3ae0fd4797ed47c8, toFormData: $18d826a12788a23d$export$10ae0d317ea97f8b, AxiosHeaders: $18d826a12788a23d$export$4e7d6ff0f3e6520, HttpStatusCode: $18d826a12788a23d$export$a972f69c851492b3, formToJSON: $18d826a12788a23d$export$86d7c59254d6a2c9, getAdapter: $18d826a12788a23d$export$17ddc20a97d669e2, mergeConfig: $18d826a12788a23d$export$7ec1ebcfa9d8bd6a } = (0, $hjpZr.default);

});
parcelRegister("hjpZr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9a85f19e57c70f8$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $fsZzp = parcelRequire("fsZzp");

var $i7HGk = parcelRequire("i7HGk");

var $1JsgI = parcelRequire("1JsgI");

var $l9ONg = parcelRequire("l9ONg");

var $ewfix = parcelRequire("ewfix");

var $bmfYM = parcelRequire("bmfYM");

var $hku8v = parcelRequire("hku8v");

var $89Krh = parcelRequire("89Krh");

var $14YCA = parcelRequire("14YCA");

var $82Z9B = parcelRequire("82Z9B");

var $knwVc = parcelRequire("knwVc");

var $hvvj9 = parcelRequire("hvvj9");

var $6bEux = parcelRequire("6bEux");

var $d08Yt = parcelRequire("d08Yt");

var $kRQVA = parcelRequire("kRQVA");

var $dGtr4 = parcelRequire("dGtr4");
"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $c9a85f19e57c70f8$var$createInstance(defaultConfig) {
    const context = new (0, $i7HGk.default)(defaultConfig);
    const instance = (0, $fsZzp.default)((0, $i7HGk.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $5RN2x.default).extend(instance, (0, $i7HGk.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $5RN2x.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $c9a85f19e57c70f8$var$createInstance((0, $1JsgI.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $c9a85f19e57c70f8$var$axios = $c9a85f19e57c70f8$var$createInstance((0, $l9ONg.default));
// Expose Axios class to allow class inheritance
$c9a85f19e57c70f8$var$axios.Axios = (0, $i7HGk.default);
// Expose Cancel & CancelToken
$c9a85f19e57c70f8$var$axios.CanceledError = (0, $bmfYM.default);
$c9a85f19e57c70f8$var$axios.CancelToken = (0, $hku8v.default);
$c9a85f19e57c70f8$var$axios.isCancel = (0, $89Krh.default);
$c9a85f19e57c70f8$var$axios.VERSION = (0, $14YCA.VERSION);
$c9a85f19e57c70f8$var$axios.toFormData = (0, $82Z9B.default);
// Expose AxiosError class
$c9a85f19e57c70f8$var$axios.AxiosError = (0, $knwVc.default);
// alias for CanceledError for backward compatibility
$c9a85f19e57c70f8$var$axios.Cancel = $c9a85f19e57c70f8$var$axios.CanceledError;
// Expose all/spread
$c9a85f19e57c70f8$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$c9a85f19e57c70f8$var$axios.spread = (0, $hvvj9.default);
// Expose isAxiosError
$c9a85f19e57c70f8$var$axios.isAxiosError = (0, $6bEux.default);
// Expose mergeConfig
$c9a85f19e57c70f8$var$axios.mergeConfig = (0, $1JsgI.default);
$c9a85f19e57c70f8$var$axios.AxiosHeaders = (0, $d08Yt.default);
$c9a85f19e57c70f8$var$axios.formToJSON = (thing)=>(0, $ewfix.default)((0, $5RN2x.default).isHTMLForm(thing) ? new FormData(thing) : thing);
$c9a85f19e57c70f8$var$axios.getAdapter = (0, $kRQVA.default).getAdapter;
$c9a85f19e57c70f8$var$axios.HttpStatusCode = (0, $dGtr4.default);
$c9a85f19e57c70f8$var$axios.default = $c9a85f19e57c70f8$var$axios;
var // this module should only have a default export
$c9a85f19e57c70f8$export$2e2bcd8739ae039 = $c9a85f19e57c70f8$var$axios;

});
parcelRegister("5RN2x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4457f145f4fd6a49$export$2e2bcd8739ae039; });

var $fsZzp = parcelRequire("fsZzp");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $4457f145f4fd6a49$var$toString } = Object.prototype;
const { getPrototypeOf: $4457f145f4fd6a49$var$getPrototypeOf } = Object;
const $4457f145f4fd6a49$var$kindOf = ((cache)=>(thing)=>{
        const str = $4457f145f4fd6a49$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $4457f145f4fd6a49$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$4457f145f4fd6a49$var$kindOf(thing) === type;
};
const $4457f145f4fd6a49$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $4457f145f4fd6a49$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $4457f145f4fd6a49$var$isUndefined = $4457f145f4fd6a49$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $4457f145f4fd6a49$var$isBuffer(val) {
    return val !== null && !$4457f145f4fd6a49$var$isUndefined(val) && val.constructor !== null && !$4457f145f4fd6a49$var$isUndefined(val.constructor) && $4457f145f4fd6a49$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $4457f145f4fd6a49$var$isArrayBuffer = $4457f145f4fd6a49$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $4457f145f4fd6a49$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $4457f145f4fd6a49$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $4457f145f4fd6a49$var$isString = $4457f145f4fd6a49$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $4457f145f4fd6a49$var$isFunction = $4457f145f4fd6a49$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $4457f145f4fd6a49$var$isNumber = $4457f145f4fd6a49$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $4457f145f4fd6a49$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $4457f145f4fd6a49$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $4457f145f4fd6a49$var$isPlainObject = (val)=>{
    if ($4457f145f4fd6a49$var$kindOf(val) !== "object") return false;
    const prototype = $4457f145f4fd6a49$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $4457f145f4fd6a49$var$isDate = $4457f145f4fd6a49$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4457f145f4fd6a49$var$isFile = $4457f145f4fd6a49$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $4457f145f4fd6a49$var$isBlob = $4457f145f4fd6a49$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $4457f145f4fd6a49$var$isFileList = $4457f145f4fd6a49$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $4457f145f4fd6a49$var$isStream = (val)=>$4457f145f4fd6a49$var$isObject(val) && $4457f145f4fd6a49$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $4457f145f4fd6a49$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $4457f145f4fd6a49$var$isFunction(thing.append) && ((kind = $4457f145f4fd6a49$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $4457f145f4fd6a49$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $4457f145f4fd6a49$var$isURLSearchParams = $4457f145f4fd6a49$var$kindOfTest("URLSearchParams");
const [$4457f145f4fd6a49$var$isReadableStream, $4457f145f4fd6a49$var$isRequest, $4457f145f4fd6a49$var$isResponse, $4457f145f4fd6a49$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($4457f145f4fd6a49$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $4457f145f4fd6a49$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $4457f145f4fd6a49$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($4457f145f4fd6a49$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $4457f145f4fd6a49$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $4457f145f4fd6a49$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $4457f145f4fd6a49$var$isContextDefined = (context)=>!$4457f145f4fd6a49$var$isUndefined(context) && context !== $4457f145f4fd6a49$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $4457f145f4fd6a49$var$merge() {
    const { caseless: caseless } = $4457f145f4fd6a49$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $4457f145f4fd6a49$var$findKey(result, key) || key;
        if ($4457f145f4fd6a49$var$isPlainObject(result[targetKey]) && $4457f145f4fd6a49$var$isPlainObject(val)) result[targetKey] = $4457f145f4fd6a49$var$merge(result[targetKey], val);
        else if ($4457f145f4fd6a49$var$isPlainObject(val)) result[targetKey] = $4457f145f4fd6a49$var$merge({}, val);
        else if ($4457f145f4fd6a49$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $4457f145f4fd6a49$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $4457f145f4fd6a49$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $4457f145f4fd6a49$var$forEach(b, (val, key)=>{
        if (thisArg && $4457f145f4fd6a49$var$isFunction(val)) a[key] = (0, $fsZzp.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $4457f145f4fd6a49$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $4457f145f4fd6a49$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $4457f145f4fd6a49$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $4457f145f4fd6a49$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $4457f145f4fd6a49$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $4457f145f4fd6a49$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($4457f145f4fd6a49$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$4457f145f4fd6a49$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $4457f145f4fd6a49$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $4457f145f4fd6a49$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $4457f145f4fd6a49$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $4457f145f4fd6a49$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $4457f145f4fd6a49$var$isHTMLForm = $4457f145f4fd6a49$var$kindOfTest("HTMLFormElement");
const $4457f145f4fd6a49$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $4457f145f4fd6a49$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $4457f145f4fd6a49$var$isRegExp = $4457f145f4fd6a49$var$kindOfTest("RegExp");
const $4457f145f4fd6a49$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $4457f145f4fd6a49$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $4457f145f4fd6a49$var$freezeMethods = (obj)=>{
    $4457f145f4fd6a49$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($4457f145f4fd6a49$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$4457f145f4fd6a49$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $4457f145f4fd6a49$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $4457f145f4fd6a49$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $4457f145f4fd6a49$var$noop = ()=>{};
const $4457f145f4fd6a49$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $4457f145f4fd6a49$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $4457f145f4fd6a49$var$DIGIT = "0123456789";
const $4457f145f4fd6a49$var$ALPHABET = {
    DIGIT: $4457f145f4fd6a49$var$DIGIT,
    ALPHA: $4457f145f4fd6a49$var$ALPHA,
    ALPHA_DIGIT: $4457f145f4fd6a49$var$ALPHA + $4457f145f4fd6a49$var$ALPHA.toUpperCase() + $4457f145f4fd6a49$var$DIGIT
};
const $4457f145f4fd6a49$var$generateString = (size = 16, alphabet = $4457f145f4fd6a49$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $4457f145f4fd6a49$var$isSpecCompliantForm(thing) {
    return !!(thing && $4457f145f4fd6a49$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $4457f145f4fd6a49$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($4457f145f4fd6a49$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $4457f145f4fd6a49$var$isArray(source) ? [] : {};
                $4457f145f4fd6a49$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$4457f145f4fd6a49$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $4457f145f4fd6a49$var$isAsyncFn = $4457f145f4fd6a49$var$kindOfTest("AsyncFunction");
const $4457f145f4fd6a49$var$isThenable = (thing)=>thing && ($4457f145f4fd6a49$var$isObject(thing) || $4457f145f4fd6a49$var$isFunction(thing)) && $4457f145f4fd6a49$var$isFunction(thing.then) && $4457f145f4fd6a49$var$isFunction(thing.catch);
var $4457f145f4fd6a49$export$2e2bcd8739ae039 = {
    isArray: $4457f145f4fd6a49$var$isArray,
    isArrayBuffer: $4457f145f4fd6a49$var$isArrayBuffer,
    isBuffer: $4457f145f4fd6a49$var$isBuffer,
    isFormData: $4457f145f4fd6a49$var$isFormData,
    isArrayBufferView: $4457f145f4fd6a49$var$isArrayBufferView,
    isString: $4457f145f4fd6a49$var$isString,
    isNumber: $4457f145f4fd6a49$var$isNumber,
    isBoolean: $4457f145f4fd6a49$var$isBoolean,
    isObject: $4457f145f4fd6a49$var$isObject,
    isPlainObject: $4457f145f4fd6a49$var$isPlainObject,
    isReadableStream: $4457f145f4fd6a49$var$isReadableStream,
    isRequest: $4457f145f4fd6a49$var$isRequest,
    isResponse: $4457f145f4fd6a49$var$isResponse,
    isHeaders: $4457f145f4fd6a49$var$isHeaders,
    isUndefined: $4457f145f4fd6a49$var$isUndefined,
    isDate: $4457f145f4fd6a49$var$isDate,
    isFile: $4457f145f4fd6a49$var$isFile,
    isBlob: $4457f145f4fd6a49$var$isBlob,
    isRegExp: $4457f145f4fd6a49$var$isRegExp,
    isFunction: $4457f145f4fd6a49$var$isFunction,
    isStream: $4457f145f4fd6a49$var$isStream,
    isURLSearchParams: $4457f145f4fd6a49$var$isURLSearchParams,
    isTypedArray: $4457f145f4fd6a49$var$isTypedArray,
    isFileList: $4457f145f4fd6a49$var$isFileList,
    forEach: $4457f145f4fd6a49$var$forEach,
    merge: $4457f145f4fd6a49$var$merge,
    extend: $4457f145f4fd6a49$var$extend,
    trim: $4457f145f4fd6a49$var$trim,
    stripBOM: $4457f145f4fd6a49$var$stripBOM,
    inherits: $4457f145f4fd6a49$var$inherits,
    toFlatObject: $4457f145f4fd6a49$var$toFlatObject,
    kindOf: $4457f145f4fd6a49$var$kindOf,
    kindOfTest: $4457f145f4fd6a49$var$kindOfTest,
    endsWith: $4457f145f4fd6a49$var$endsWith,
    toArray: $4457f145f4fd6a49$var$toArray,
    forEachEntry: $4457f145f4fd6a49$var$forEachEntry,
    matchAll: $4457f145f4fd6a49$var$matchAll,
    isHTMLForm: $4457f145f4fd6a49$var$isHTMLForm,
    hasOwnProperty: $4457f145f4fd6a49$var$hasOwnProperty,
    hasOwnProp: $4457f145f4fd6a49$var$hasOwnProperty,
    reduceDescriptors: $4457f145f4fd6a49$var$reduceDescriptors,
    freezeMethods: $4457f145f4fd6a49$var$freezeMethods,
    toObjectSet: $4457f145f4fd6a49$var$toObjectSet,
    toCamelCase: $4457f145f4fd6a49$var$toCamelCase,
    noop: $4457f145f4fd6a49$var$noop,
    toFiniteNumber: $4457f145f4fd6a49$var$toFiniteNumber,
    findKey: $4457f145f4fd6a49$var$findKey,
    global: $4457f145f4fd6a49$var$_global,
    isContextDefined: $4457f145f4fd6a49$var$isContextDefined,
    ALPHABET: $4457f145f4fd6a49$var$ALPHABET,
    generateString: $4457f145f4fd6a49$var$generateString,
    isSpecCompliantForm: $4457f145f4fd6a49$var$isSpecCompliantForm,
    toJSONObject: $4457f145f4fd6a49$var$toJSONObject,
    isAsyncFn: $4457f145f4fd6a49$var$isAsyncFn,
    isThenable: $4457f145f4fd6a49$var$isThenable
};

});
parcelRegister("fsZzp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4293b0eb4c07151$export$2e2bcd8739ae039; });
"use strict";
function $b4293b0eb4c07151$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

});


parcelRegister("i7HGk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d31ac3bc8d454bec$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $1BRyf = parcelRequire("1BRyf");

var $hm5Wj = parcelRequire("hm5Wj");

var $2n9mB = parcelRequire("2n9mB");

var $1JsgI = parcelRequire("1JsgI");

var $7lViM = parcelRequire("7lViM");

var $1P3Mn = parcelRequire("1P3Mn");

var $d08Yt = parcelRequire("d08Yt");
"use strict";
const $d31ac3bc8d454bec$var$validators = (0, $1P3Mn.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $d31ac3bc8d454bec$var$Axios {
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $1JsgI.default)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $1P3Mn.default).assertOptions(transitional, {
            silentJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
            forcedJSONParsing: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean),
            clarifyTimeoutError: $d31ac3bc8d454bec$var$validators.transitional($d31ac3bc8d454bec$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $5RN2x.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $1P3Mn.default).assertOptions(paramsSerializer, {
                encode: $d31ac3bc8d454bec$var$validators.function,
                serialize: $d31ac3bc8d454bec$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $5RN2x.default).merge(headers.common, headers[config.method]);
        headers && (0, $5RN2x.default).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $d08Yt.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $2n9mB.default).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $2n9mB.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $1JsgI.default)(this.defaults, config);
        const fullPath = (0, $7lViM.default)(config.baseURL, config.url);
        return (0, $1BRyf.default)(fullPath, config.params, config.paramsSerializer);
    }
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $hm5Wj.default)(),
            response: new (0, $hm5Wj.default)()
        };
    }
}
// Provide aliases for supported request methods
(0, $5RN2x.default).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $d31ac3bc8d454bec$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $1JsgI.default)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $5RN2x.default).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $1JsgI.default)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $d31ac3bc8d454bec$var$Axios.prototype[method] = generateHTTPMethod();
    $d31ac3bc8d454bec$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $d31ac3bc8d454bec$export$2e2bcd8739ae039 = $d31ac3bc8d454bec$var$Axios;

});
parcelRegister("1BRyf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12c2c95c1ed3c980$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $33LIl = parcelRequire("33LIl");
"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $12c2c95c1ed3c980$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $12c2c95c1ed3c980$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $12c2c95c1ed3c980$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $5RN2x.default).isURLSearchParams(params) ? params.toString() : new (0, $33LIl.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}

});
parcelRegister("33LIl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23a6a9f2f50fe381$export$2e2bcd8739ae039; });

var $82Z9B = parcelRequire("82Z9B");
"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $23a6a9f2f50fe381$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $23a6a9f2f50fe381$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $82Z9B.default)(params, this, options);
}
const $23a6a9f2f50fe381$var$prototype = $23a6a9f2f50fe381$var$AxiosURLSearchParams.prototype;
$23a6a9f2f50fe381$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$23a6a9f2f50fe381$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $23a6a9f2f50fe381$var$encode);
    } : $23a6a9f2f50fe381$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $23a6a9f2f50fe381$export$2e2bcd8739ae039 = $23a6a9f2f50fe381$var$AxiosURLSearchParams;

});
parcelRegister("82Z9B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5dbdf283f7ef4044$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $knwVc = parcelRequire("knwVc");

var $2lBR5 = parcelRequire("2lBR5");

var $gzLuY = parcelRequire("gzLuY");
var $5dbdf283f7ef4044$require$Buffer = $gzLuY.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $5dbdf283f7ef4044$var$isVisitable(thing) {
    return (0, $5RN2x.default).isPlainObject(thing) || (0, $5RN2x.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $5dbdf283f7ef4044$var$removeBrackets(key) {
    return (0, $5RN2x.default).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $5dbdf283f7ef4044$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $5dbdf283f7ef4044$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $5dbdf283f7ef4044$var$isFlatArray(arr) {
    return (0, $5RN2x.default).isArray(arr) && !arr.some($5dbdf283f7ef4044$var$isVisitable);
}
const $5dbdf283f7ef4044$var$predicates = (0, $5RN2x.default).toFlatObject((0, $5RN2x.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $5dbdf283f7ef4044$var$toFormData(obj, formData, options) {
    if (!(0, $5RN2x.default).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $2lBR5.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $5RN2x.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $5RN2x.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $5RN2x.default).isSpecCompliantForm(formData);
    if (!(0, $5RN2x.default).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $5RN2x.default).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $5RN2x.default).isBlob(value)) throw new (0, $knwVc.default)("Blob is not supported. Use a Buffer instead.");
        if ((0, $5RN2x.default).isArrayBuffer(value) || (0, $5RN2x.default).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $5dbdf283f7ef4044$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $5RN2x.default).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $5RN2x.default).isArray(value) && $5dbdf283f7ef4044$var$isFlatArray(value) || ((0, $5RN2x.default).isFileList(value) || (0, $5RN2x.default).endsWith(key, "[]")) && (arr = (0, $5RN2x.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $5dbdf283f7ef4044$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $5RN2x.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $5dbdf283f7ef4044$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($5dbdf283f7ef4044$var$isVisitable(value)) return true;
        formData.append($5dbdf283f7ef4044$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($5dbdf283f7ef4044$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $5dbdf283f7ef4044$var$isVisitable
    });
    function build(value, path) {
        if ((0, $5RN2x.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $5RN2x.default).forEach(value, function each(el, key) {
            const result = !((0, $5RN2x.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $5RN2x.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $5RN2x.default).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $5dbdf283f7ef4044$export$2e2bcd8739ae039 = $5dbdf283f7ef4044$var$toFormData;

});
parcelRegister("knwVc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed5f7e2522a0b703$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");
"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $ed5f7e2522a0b703$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $5RN2x.default).inherits($ed5f7e2522a0b703$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $5RN2x.default).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $ed5f7e2522a0b703$var$prototype = $ed5f7e2522a0b703$var$AxiosError.prototype;
const $ed5f7e2522a0b703$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $ed5f7e2522a0b703$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($ed5f7e2522a0b703$var$AxiosError, $ed5f7e2522a0b703$var$descriptors);
Object.defineProperty($ed5f7e2522a0b703$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$ed5f7e2522a0b703$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($ed5f7e2522a0b703$var$prototype);
    (0, $5RN2x.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $ed5f7e2522a0b703$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $ed5f7e2522a0b703$export$2e2bcd8739ae039 = $ed5f7e2522a0b703$var$AxiosError;

});

parcelRegister("2lBR5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1b5ae82d1edb0249$export$2e2bcd8739ae039; });
// eslint-disable-next-line strict
var $1b5ae82d1edb0249$export$2e2bcd8739ae039 = null;

});

parcelRegister("gzLuY", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $c114c26e12685207$export$a143d493d941bafc; }, function (v) { return $c114c26e12685207$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $c114c26e12685207$export$f99ded8fe4b79145; }, function (v) { return $c114c26e12685207$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $c114c26e12685207$export$a143d493d941bafc;
var $c114c26e12685207$export$e4cf37d7f6fb9e0a;
var $c114c26e12685207$export$f99ded8fe4b79145;
var $c114c26e12685207$export$599f31c3813fae4d;
"use strict";

var $7LFKz = parcelRequire("7LFKz");

var $69U7b = parcelRequire("69U7b");
var $c114c26e12685207$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$c114c26e12685207$export$a143d493d941bafc = $c114c26e12685207$var$Buffer;
$c114c26e12685207$export$e4cf37d7f6fb9e0a = $c114c26e12685207$var$SlowBuffer;
$c114c26e12685207$export$f99ded8fe4b79145 = 50;
var $c114c26e12685207$var$K_MAX_LENGTH = 0x7fffffff;
$c114c26e12685207$export$599f31c3813fae4d = $c114c26e12685207$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT = $c114c26e12685207$var$typedArraySupport();
if (!$c114c26e12685207$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $c114c26e12685207$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($c114c26e12685207$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$c114c26e12685207$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $c114c26e12685207$var$createBuffer(length) {
    if (length > $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $c114c26e12685207$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $c114c26e12685207$var$allocUnsafe(arg);
    }
    return $c114c26e12685207$var$from(arg, encodingOrOffset, length);
}
$c114c26e12685207$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $c114c26e12685207$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $c114c26e12685207$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $c114c26e12685207$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($c114c26e12685207$var$isInstance(value, ArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, ArrayBuffer)) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($c114c26e12685207$var$isInstance(value, SharedArrayBuffer) || value && $c114c26e12685207$var$isInstance(value.buffer, SharedArrayBuffer))) return $c114c26e12685207$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $c114c26e12685207$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $c114c26e12685207$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $c114c26e12685207$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $c114c26e12685207$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $c114c26e12685207$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($c114c26e12685207$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($c114c26e12685207$var$Buffer, Uint8Array);
function $c114c26e12685207$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $c114c26e12685207$var$alloc(size, fill, encoding) {
    $c114c26e12685207$var$assertSize(size);
    if (size <= 0) return $c114c26e12685207$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $c114c26e12685207$var$createBuffer(size).fill(fill, encoding) : $c114c26e12685207$var$createBuffer(size).fill(fill);
    return $c114c26e12685207$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $c114c26e12685207$var$Buffer.alloc = function(size, fill, encoding) {
    return $c114c26e12685207$var$alloc(size, fill, encoding);
};
function $c114c26e12685207$var$allocUnsafe(size) {
    $c114c26e12685207$var$assertSize(size);
    return $c114c26e12685207$var$createBuffer(size < 0 ? 0 : $c114c26e12685207$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $c114c26e12685207$var$Buffer.allocUnsafe = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $c114c26e12685207$var$Buffer.allocUnsafeSlow = function(size) {
    return $c114c26e12685207$var$allocUnsafe(size);
};
function $c114c26e12685207$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $c114c26e12685207$var$byteLength(string, encoding) | 0;
    var buf = $c114c26e12685207$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $c114c26e12685207$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $c114c26e12685207$var$checked(array.length) | 0;
    var buf = $c114c26e12685207$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $c114c26e12685207$var$fromArrayView(arrayView) {
    if ($c114c26e12685207$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $c114c26e12685207$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $c114c26e12685207$var$fromArrayLike(arrayView);
}
function $c114c26e12685207$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $c114c26e12685207$var$Buffer.prototype);
    return buf;
}
function $c114c26e12685207$var$fromObject(obj) {
    if ($c114c26e12685207$var$Buffer.isBuffer(obj)) {
        var len = $c114c26e12685207$var$checked(obj.length) | 0;
        var buf = $c114c26e12685207$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $c114c26e12685207$var$numberIsNaN(obj.length)) return $c114c26e12685207$var$createBuffer(0);
        return $c114c26e12685207$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $c114c26e12685207$var$fromArrayLike(obj.data);
}
function $c114c26e12685207$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $c114c26e12685207$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $c114c26e12685207$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $c114c26e12685207$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $c114c26e12685207$var$Buffer.alloc(+length);
}
$c114c26e12685207$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $c114c26e12685207$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$c114c26e12685207$var$Buffer.compare = function compare(a, b) {
    if ($c114c26e12685207$var$isInstance(a, Uint8Array)) a = $c114c26e12685207$var$Buffer.from(a, a.offset, a.byteLength);
    if ($c114c26e12685207$var$isInstance(b, Uint8Array)) b = $c114c26e12685207$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(a) || !$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$c114c26e12685207$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$c114c26e12685207$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $c114c26e12685207$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $c114c26e12685207$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($c114c26e12685207$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $c114c26e12685207$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $c114c26e12685207$var$byteLength(string, encoding) {
    if ($c114c26e12685207$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $c114c26e12685207$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $c114c26e12685207$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $c114c26e12685207$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$c114c26e12685207$var$Buffer.byteLength = $c114c26e12685207$var$byteLength;
function $c114c26e12685207$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $c114c26e12685207$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8Slice(this, start, end);
        case "ascii":
            return $c114c26e12685207$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $c114c26e12685207$var$latin1Slice(this, start, end);
        case "base64":
            return $c114c26e12685207$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c114c26e12685207$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$c114c26e12685207$var$Buffer.prototype._isBuffer = true;
function $c114c26e12685207$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$c114c26e12685207$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$c114c26e12685207$var$swap(this, i, i + 1);
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $c114c26e12685207$var$swap(this, i, i + 3);
        $c114c26e12685207$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $c114c26e12685207$var$swap(this, i, i + 7);
        $c114c26e12685207$var$swap(this, i + 1, i + 6);
        $c114c26e12685207$var$swap(this, i + 2, i + 5);
        $c114c26e12685207$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$c114c26e12685207$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $c114c26e12685207$var$utf8Slice(this, 0, length);
    return $c114c26e12685207$var$slowToString.apply(this, arguments);
};
$c114c26e12685207$var$Buffer.prototype.toLocaleString = $c114c26e12685207$var$Buffer.prototype.toString;
$c114c26e12685207$var$Buffer.prototype.equals = function equals(b) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $c114c26e12685207$var$Buffer.compare(this, b) === 0;
};
$c114c26e12685207$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $c114c26e12685207$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($c114c26e12685207$var$customInspectSymbol) $c114c26e12685207$var$Buffer.prototype[$c114c26e12685207$var$customInspectSymbol] = $c114c26e12685207$var$Buffer.prototype.inspect;
$c114c26e12685207$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($c114c26e12685207$var$isInstance(target, Uint8Array)) target = $c114c26e12685207$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $c114c26e12685207$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($c114c26e12685207$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $c114c26e12685207$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($c114c26e12685207$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $c114c26e12685207$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $c114c26e12685207$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $c114c26e12685207$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$c114c26e12685207$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$c114c26e12685207$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$c114c26e12685207$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $c114c26e12685207$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $c114c26e12685207$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($c114c26e12685207$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $c114c26e12685207$var$utf8Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $c114c26e12685207$var$asciiWrite(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$asciiToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$base64Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$base64ToBytes(string), buf, offset, length);
}
function $c114c26e12685207$var$ucs2Write(buf, string, offset, length) {
    return $c114c26e12685207$var$blitBuffer($c114c26e12685207$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$c114c26e12685207$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $c114c26e12685207$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $c114c26e12685207$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $c114c26e12685207$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $c114c26e12685207$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $c114c26e12685207$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$c114c26e12685207$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $c114c26e12685207$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7LFKz.fromByteArray(buf);
    else return $7LFKz.fromByteArray(buf.slice(start, end));
}
function $c114c26e12685207$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $c114c26e12685207$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $c114c26e12685207$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $c114c26e12685207$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $c114c26e12685207$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $c114c26e12685207$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $c114c26e12685207$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $c114c26e12685207$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $c114c26e12685207$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$c114c26e12685207$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $c114c26e12685207$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $c114c26e12685207$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$c114c26e12685207$var$Buffer.prototype.readUintLE = $c114c26e12685207$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUintBE = $c114c26e12685207$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readUint8 = $c114c26e12685207$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$c114c26e12685207$var$Buffer.prototype.readUint16LE = $c114c26e12685207$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$c114c26e12685207$var$Buffer.prototype.readUint16BE = $c114c26e12685207$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$c114c26e12685207$var$Buffer.prototype.readUint32LE = $c114c26e12685207$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$c114c26e12685207$var$Buffer.prototype.readUint32BE = $c114c26e12685207$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$c114c26e12685207$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$c114c26e12685207$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$c114c26e12685207$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$c114c26e12685207$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$c114c26e12685207$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$c114c26e12685207$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $69U7b.read(this, offset, true, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 4, this.length);
    return $69U7b.read(this, offset, false, 23, 4);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $69U7b.read(this, offset, true, 52, 8);
};
$c114c26e12685207$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkOffset(offset, 8, this.length);
    return $69U7b.read(this, offset, false, 52, 8);
};
function $c114c26e12685207$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$c114c26e12685207$var$Buffer.prototype.writeUintLE = $c114c26e12685207$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUintBE = $c114c26e12685207$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeUint8 = $c114c26e12685207$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16LE = $c114c26e12685207$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint16BE = $c114c26e12685207$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32LE = $c114c26e12685207$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeUint32BE = $c114c26e12685207$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $c114c26e12685207$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$c114c26e12685207$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$c114c26e12685207$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $c114c26e12685207$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $c114c26e12685207$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $69U7b.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$c114c26e12685207$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeFloat(this, value, offset, false, noAssert);
};
function $c114c26e12685207$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $c114c26e12685207$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $69U7b.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$c114c26e12685207$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, true, noAssert);
};
$c114c26e12685207$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $c114c26e12685207$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$c114c26e12685207$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$c114c26e12685207$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$c114c26e12685207$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$c114c26e12685207$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $c114c26e12685207$var$Buffer.isBuffer(val) ? val : $c114c26e12685207$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $c114c26e12685207$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $c114c26e12685207$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($c114c26e12685207$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $c114c26e12685207$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $c114c26e12685207$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $c114c26e12685207$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $c114c26e12685207$var$base64ToBytes(str) {
    return $7LFKz.toByteArray($c114c26e12685207$var$base64clean(str));
}
function $c114c26e12685207$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $c114c26e12685207$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $c114c26e12685207$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $c114c26e12685207$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("7LFKz", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $5a7d4ee62d502cb1$export$d622b2ad8d90c771; }, function (v) { return $5a7d4ee62d502cb1$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $5a7d4ee62d502cb1$export$6100ba28696e12de; }, function (v) { return $5a7d4ee62d502cb1$export$6100ba28696e12de = v; });
var $5a7d4ee62d502cb1$export$a48f0734ac7c2329;
var $5a7d4ee62d502cb1$export$d622b2ad8d90c771;
var $5a7d4ee62d502cb1$export$6100ba28696e12de;
"use strict";
$5a7d4ee62d502cb1$export$a48f0734ac7c2329 = $5a7d4ee62d502cb1$var$byteLength;
$5a7d4ee62d502cb1$export$d622b2ad8d90c771 = $5a7d4ee62d502cb1$var$toByteArray;
$5a7d4ee62d502cb1$export$6100ba28696e12de = $5a7d4ee62d502cb1$var$fromByteArray;
var $5a7d4ee62d502cb1$var$lookup = [];
var $5a7d4ee62d502cb1$var$revLookup = [];
var $5a7d4ee62d502cb1$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $5a7d4ee62d502cb1$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $5a7d4ee62d502cb1$var$i = 0, $5a7d4ee62d502cb1$var$len = $5a7d4ee62d502cb1$var$code.length; $5a7d4ee62d502cb1$var$i < $5a7d4ee62d502cb1$var$len; ++$5a7d4ee62d502cb1$var$i){
    $5a7d4ee62d502cb1$var$lookup[$5a7d4ee62d502cb1$var$i] = $5a7d4ee62d502cb1$var$code[$5a7d4ee62d502cb1$var$i];
    $5a7d4ee62d502cb1$var$revLookup[$5a7d4ee62d502cb1$var$code.charCodeAt($5a7d4ee62d502cb1$var$i)] = $5a7d4ee62d502cb1$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$5a7d4ee62d502cb1$var$revLookup["-".charCodeAt(0)] = 62;
$5a7d4ee62d502cb1$var$revLookup["_".charCodeAt(0)] = 63;
function $5a7d4ee62d502cb1$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $5a7d4ee62d502cb1$var$byteLength(b64) {
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $5a7d4ee62d502cb1$var$toByteArray(b64) {
    var tmp;
    var lens = $5a7d4ee62d502cb1$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $5a7d4ee62d502cb1$var$Arr($5a7d4ee62d502cb1$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 18 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 2 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i)] << 10 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $5a7d4ee62d502cb1$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $5a7d4ee62d502cb1$var$tripletToBase64(num) {
    return $5a7d4ee62d502cb1$var$lookup[num >> 18 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 12 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num >> 6 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[num & 0x3F];
}
function $5a7d4ee62d502cb1$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($5a7d4ee62d502cb1$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $5a7d4ee62d502cb1$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($5a7d4ee62d502cb1$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 2] + $5a7d4ee62d502cb1$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($5a7d4ee62d502cb1$var$lookup[tmp >> 10] + $5a7d4ee62d502cb1$var$lookup[tmp >> 4 & 0x3F] + $5a7d4ee62d502cb1$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("69U7b", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942; }, function (v) { return $47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $47bf1c92b6d3ec4f$export$68d8715fc104d294; }, function (v) { return $47bf1c92b6d3ec4f$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $47bf1c92b6d3ec4f$export$aafa59e2e03f2942;
var $47bf1c92b6d3ec4f$export$68d8715fc104d294;
$47bf1c92b6d3ec4f$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$47bf1c92b6d3ec4f$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});





parcelRegister("hm5Wj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca291930ae00924d$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");
"use strict";
class $ca291930ae00924d$var$InterceptorManager {
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $5RN2x.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
    constructor(){
        this.handlers = [];
    }
}
var $ca291930ae00924d$export$2e2bcd8739ae039 = $ca291930ae00924d$var$InterceptorManager;

});

parcelRegister("2n9mB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ba4fe270146b4e2$export$2e2bcd8739ae039; });

var $3HPYp = parcelRequire("3HPYp");

var $89Krh = parcelRequire("89Krh");

var $l9ONg = parcelRequire("l9ONg");

var $bmfYM = parcelRequire("bmfYM");

var $d08Yt = parcelRequire("d08Yt");

var $kRQVA = parcelRequire("kRQVA");
"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $1ba4fe270146b4e2$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $bmfYM.default)(null, config);
}
function $1ba4fe270146b4e2$export$2e2bcd8739ae039(config) {
    $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
    config.headers = (0, $d08Yt.default).from(config.headers);
    // Transform request data
    config.data = (0, $3HPYp.default).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $kRQVA.default).getAdapter(config.adapter || (0, $l9ONg.default).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $3HPYp.default).call(config, config.transformResponse, response);
        response.headers = (0, $d08Yt.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $89Krh.default)(reason)) {
            $1ba4fe270146b4e2$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $3HPYp.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $d08Yt.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

});
parcelRegister("3HPYp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b2db412c73efddc$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $l9ONg = parcelRequire("l9ONg");

var $d08Yt = parcelRequire("d08Yt");
"use strict";
function $2b2db412c73efddc$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $l9ONg.default);
    const context = response || config;
    const headers = (0, $d08Yt.default).from(context.headers);
    let data = context.data;
    (0, $5RN2x.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

});
parcelRegister("l9ONg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f671d6c34fc96548$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $knwVc = parcelRequire("knwVc");

var $aqkjV = parcelRequire("aqkjV");

var $82Z9B = parcelRequire("82Z9B");

var $h1Gqs = parcelRequire("h1Gqs");

var $aCs4O = parcelRequire("aCs4O");

var $ewfix = parcelRequire("ewfix");
"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $f671d6c34fc96548$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $5RN2x.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $5RN2x.default).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $f671d6c34fc96548$var$defaults = {
    transitional: (0, $aqkjV.default),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $5RN2x.default).isObject(data);
            if (isObjectPayload && (0, $5RN2x.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $5RN2x.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $ewfix.default)(data)) : data;
            if ((0, $5RN2x.default).isArrayBuffer(data) || (0, $5RN2x.default).isBuffer(data) || (0, $5RN2x.default).isStream(data) || (0, $5RN2x.default).isFile(data) || (0, $5RN2x.default).isBlob(data) || (0, $5RN2x.default).isReadableStream(data)) return data;
            if ((0, $5RN2x.default).isArrayBufferView(data)) return data.buffer;
            if ((0, $5RN2x.default).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $h1Gqs.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, $5RN2x.default).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $82Z9B.default)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $f671d6c34fc96548$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $f671d6c34fc96548$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $5RN2x.default).isResponse(data) || (0, $5RN2x.default).isReadableStream(data)) return data;
            if (data && (0, $5RN2x.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $knwVc.default).from(e, (0, $knwVc.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $aCs4O.default).classes.FormData,
        Blob: (0, $aCs4O.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $5RN2x.default).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $f671d6c34fc96548$var$defaults.headers[method] = {};
});
var $f671d6c34fc96548$export$2e2bcd8739ae039 = $f671d6c34fc96548$var$defaults;

});
parcelRegister("aqkjV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $796c18463ea25502$export$2e2bcd8739ae039; });
"use strict";
var $796c18463ea25502$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("h1Gqs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6537084d1761b1c$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $82Z9B = parcelRequire("82Z9B");

var $aCs4O = parcelRequire("aCs4O");
"use strict";
function $c6537084d1761b1c$export$2e2bcd8739ae039(data, options) {
    return (0, $82Z9B.default)(data, new (0, $aCs4O.default).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $aCs4O.default).isNode && (0, $5RN2x.default).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}

});
parcelRegister("aCs4O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7bb33b7264aaaf86$export$2e2bcd8739ae039; });

var $cDuf1 = parcelRequire("cDuf1");

var $jUJQD = parcelRequire("jUJQD");
var $7bb33b7264aaaf86$export$2e2bcd8739ae039 = {
    ...$jUJQD,
    ...(0, $cDuf1.default)
};

});
parcelRegister("cDuf1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $933095d2c2007f0e$export$2e2bcd8739ae039; });

var $dMreV = parcelRequire("dMreV");

var $6BVH8 = parcelRequire("6BVH8");

var $9SPek = parcelRequire("9SPek");
var $933095d2c2007f0e$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $dMreV.default,
        FormData: $6BVH8.default,
        Blob: $9SPek.default
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};

});
parcelRegister("dMreV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a084e346ccf1414e$export$2e2bcd8739ae039; });

var $33LIl = parcelRequire("33LIl");
"use strict";
var $a084e346ccf1414e$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $33LIl.default);

});

parcelRegister("6BVH8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d02f3c5e9d23987$export$2e2bcd8739ae039; });
"use strict";
var $4d02f3c5e9d23987$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;

});

parcelRegister("9SPek", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7320e56e0494b653$export$2e2bcd8739ae039; });
"use strict";
var $7320e56e0494b653$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;

});


parcelRegister("jUJQD", function(module, exports) {

$parcel$export(module.exports, "hasBrowserEnv", function () { return $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf; });
$parcel$export(module.exports, "hasStandardBrowserEnv", function () { return $e7f6cfbce8ef57c2$export$c0bcc9250309d66; });
$parcel$export(module.exports, "hasStandardBrowserWebWorkerEnv", function () { return $e7f6cfbce8ef57c2$export$c81692cf5af97dac; });
$parcel$export(module.exports, "origin", function () { return $e7f6cfbce8ef57c2$export$f710a83a91838a36; });
const $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $e7f6cfbce8ef57c2$export$c0bcc9250309d66 = ((product)=>{
    return $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $e7f6cfbce8ef57c2$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $e7f6cfbce8ef57c2$export$f710a83a91838a36 = $e7f6cfbce8ef57c2$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";

});



parcelRegister("ewfix", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a91febb88049dece$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");
"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $a91febb88049dece$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $5RN2x.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $a91febb88049dece$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $a91febb88049dece$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $5RN2x.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $5RN2x.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $5RN2x.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $5RN2x.default).isArray(target[name])) target[name] = $a91febb88049dece$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $5RN2x.default).isFormData(formData) && (0, $5RN2x.default).isFunction(formData.entries)) {
        const obj = {};
        (0, $5RN2x.default).forEachEntry(formData, (name, value)=>{
            buildPath($a91febb88049dece$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $a91febb88049dece$export$2e2bcd8739ae039 = $a91febb88049dece$var$formDataToJSON;

});


parcelRegister("d08Yt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97723c9940354b38$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $d9FXx = parcelRequire("d9FXx");
"use strict";
const $97723c9940354b38$var$$internals = Symbol("internals");
function $97723c9940354b38$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $97723c9940354b38$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $5RN2x.default).isArray(value) ? value.map($97723c9940354b38$var$normalizeValue) : String(value);
}
function $97723c9940354b38$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $97723c9940354b38$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $97723c9940354b38$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $5RN2x.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $5RN2x.default).isString(value)) return;
    if ((0, $5RN2x.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $5RN2x.default).isRegExp(filter)) return filter.test(value);
}
function $97723c9940354b38$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $97723c9940354b38$var$buildAccessors(obj, header) {
    const accessorName = (0, $5RN2x.default).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $97723c9940354b38$var$AxiosHeaders {
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $97723c9940354b38$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $5RN2x.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $97723c9940354b38$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $5RN2x.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $5RN2x.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $5RN2x.default).isString(header) && (header = header.trim()) && !$97723c9940354b38$var$isValidHeaderName(header)) setHeaders((0, $d9FXx.default)(header), valueOrRewrite);
        else if ((0, $5RN2x.default).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $97723c9940354b38$var$normalizeHeader(header);
        if (header) {
            const key = (0, $5RN2x.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $97723c9940354b38$var$parseTokens(value);
                if ((0, $5RN2x.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $5RN2x.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $97723c9940354b38$var$normalizeHeader(header);
        if (header) {
            const key = (0, $5RN2x.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $97723c9940354b38$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $97723c9940354b38$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $5RN2x.default).findKey(self, _header);
                if (key && (!matcher || $97723c9940354b38$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $5RN2x.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $97723c9940354b38$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $5RN2x.default).forEach(this, (value, header)=>{
            const key = (0, $5RN2x.default).findKey(headers, header);
            if (key) {
                self[key] = $97723c9940354b38$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $97723c9940354b38$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $97723c9940354b38$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $5RN2x.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $5RN2x.default).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$97723c9940354b38$var$$internals] = this[$97723c9940354b38$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $97723c9940354b38$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $97723c9940354b38$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $5RN2x.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
    constructor(headers){
        headers && this.set(headers);
    }
}
$97723c9940354b38$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $5RN2x.default).reduceDescriptors($97723c9940354b38$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $5RN2x.default).freezeMethods($97723c9940354b38$var$AxiosHeaders);
var $97723c9940354b38$export$2e2bcd8739ae039 = $97723c9940354b38$var$AxiosHeaders;

});
parcelRegister("d9FXx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $993ca9e2d6767cd4$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");
"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $993ca9e2d6767cd4$var$ignoreDuplicateOf = (0, $5RN2x.default).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $993ca9e2d6767cd4$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $993ca9e2d6767cd4$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};

});



parcelRegister("89Krh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f032fd5b915e863$export$2e2bcd8739ae039; });
"use strict";
function $5f032fd5b915e863$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}

});

parcelRegister("bmfYM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $844e24f044f60b67$export$2e2bcd8739ae039; });

var $knwVc = parcelRequire("knwVc");

var $5RN2x = parcelRequire("5RN2x");
"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $844e24f044f60b67$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $knwVc.default).call(this, message == null ? "canceled" : message, (0, $knwVc.default).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $5RN2x.default).inherits($844e24f044f60b67$var$CanceledError, (0, $knwVc.default), {
    __CANCEL__: true
});
var $844e24f044f60b67$export$2e2bcd8739ae039 = $844e24f044f60b67$var$CanceledError;

});

parcelRegister("kRQVA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f311d0388b14bc21$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $2lBR5 = parcelRequire("2lBR5");

var $JCH7L = parcelRequire("JCH7L");

var $4w3Qc = parcelRequire("4w3Qc");

var $knwVc = parcelRequire("knwVc");
const $f311d0388b14bc21$var$knownAdapters = {
    http: (0, $2lBR5.default),
    xhr: (0, $JCH7L.default),
    fetch: (0, $4w3Qc.default)
};
(0, $5RN2x.default).forEach($f311d0388b14bc21$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $f311d0388b14bc21$var$renderReason = (reason)=>`- ${reason}`;
const $f311d0388b14bc21$var$isResolvedHandle = (adapter)=>(0, $5RN2x.default).isFunction(adapter) || adapter === null || adapter === false;
var $f311d0388b14bc21$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $5RN2x.default).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$f311d0388b14bc21$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $f311d0388b14bc21$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $knwVc.default)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($f311d0388b14bc21$var$renderReason).join("\n") : " " + $f311d0388b14bc21$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $knwVc.default)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $f311d0388b14bc21$var$knownAdapters
};

});
parcelRegister("JCH7L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $089238041fc30567$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $fhocg = parcelRequire("fhocg");

var $aqkjV = parcelRequire("aqkjV");

var $knwVc = parcelRequire("knwVc");

var $bmfYM = parcelRequire("bmfYM");

var $deXzT = parcelRequire("deXzT");

var $aCs4O = parcelRequire("aCs4O");

var $d08Yt = parcelRequire("d08Yt");

var $eGzDO = parcelRequire("eGzDO");

var $hgCPq = parcelRequire("hgCPq");
const $089238041fc30567$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $089238041fc30567$export$2e2bcd8739ae039 = $089238041fc30567$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $hgCPq.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $d08Yt.default).from(_config.headers).normalize();
        let { responseType: responseType } = _config;
        let onCanceled;
        function done() {
            if (_config.cancelToken) _config.cancelToken.unsubscribe(onCanceled);
            if (_config.signal) _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $d08Yt.default).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $fhocg.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $knwVc.default)("Request aborted", (0, $knwVc.default).ECONNABORTED, _config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $knwVc.default)("Network Error", (0, $knwVc.default).ERR_NETWORK, _config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $aqkjV.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $knwVc.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $knwVc.default).ETIMEDOUT : (0, $knwVc.default).ECONNABORTED, _config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $5RN2x.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $5RN2x.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (typeof _config.onDownloadProgress === "function") request.addEventListener("progress", (0, $eGzDO.default)(_config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof _config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", (0, $eGzDO.default)(_config.onUploadProgress));
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $bmfYM.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $deXzT.default)(_config.url);
        if (protocol && (0, $aCs4O.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, $knwVc.default)("Unsupported protocol " + protocol + ":", (0, $knwVc.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

});
parcelRegister("fhocg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b1fb368c37c1823a$export$2e2bcd8739ae039; });

var $knwVc = parcelRequire("knwVc");
"use strict";
function $b1fb368c37c1823a$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $knwVc.default)("Request failed with status code " + response.status, [
        (0, $knwVc.default).ERR_BAD_REQUEST,
        (0, $knwVc.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

});

parcelRegister("deXzT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9a3acc13c385c3d9$export$2e2bcd8739ae039; });
"use strict";
function $9a3acc13c385c3d9$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}

});

parcelRegister("eGzDO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab10a2828cd1e7bc$export$2e2bcd8739ae039; });

var $5u3tc = parcelRequire("5u3tc");

var $4xgI1 = parcelRequire("4xgI1");
var $ab10a2828cd1e7bc$export$2e2bcd8739ae039 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $5u3tc.default)(50, 250);
    return (0, $4xgI1.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    }, freq);
};

});
parcelRegister("5u3tc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fe2722b85f27cc8$export$2e2bcd8739ae039; });
"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $3fe2722b85f27cc8$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $3fe2722b85f27cc8$export$2e2bcd8739ae039 = $3fe2722b85f27cc8$var$speedometer;

});

parcelRegister("4xgI1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34d7348ceccb5142$export$2e2bcd8739ae039; });
"use strict";
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $34d7348ceccb5142$var$throttle(fn, freq) {
    let timestamp = 0;
    const threshold = 1000 / freq;
    let timer = null;
    return function throttled() {
        const force = this === true;
        const now = Date.now();
        if (force || now - timestamp > threshold) {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            timestamp = now;
            return fn.apply(null, arguments);
        }
        if (!timer) timer = setTimeout(()=>{
            timer = null;
            timestamp = Date.now();
            return fn.apply(null, arguments);
        }, threshold - (now - timestamp));
    };
}
var $34d7348ceccb5142$export$2e2bcd8739ae039 = $34d7348ceccb5142$var$throttle;

});


parcelRegister("hgCPq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9220cd357bb9355$export$2e2bcd8739ae039; });

var $aCs4O = parcelRequire("aCs4O");

var $5RN2x = parcelRequire("5RN2x");

var $3TcEI = parcelRequire("3TcEI");

var $bd2wb = parcelRequire("bd2wb");

var $7lViM = parcelRequire("7lViM");

var $1JsgI = parcelRequire("1JsgI");

var $d08Yt = parcelRequire("d08Yt");

var $1BRyf = parcelRequire("1BRyf");
var $c9220cd357bb9355$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $1JsgI.default)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $d08Yt.default).from(headers);
    newConfig.url = (0, $1BRyf.default)((0, $7lViM.default)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $5RN2x.default).isFormData(data)) {
        if ((0, $aCs4O.default).hasStandardBrowserEnv || (0, $aCs4O.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $aCs4O.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, $5RN2x.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $3TcEI.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $bd2wb.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

});
parcelRegister("3TcEI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d50534f56617a3d$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $aCs4O = parcelRequire("aCs4O");
"use strict";
var $2d50534f56617a3d$export$2e2bcd8739ae039 = (0, $aCs4O.default).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $5RN2x.default).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("bd2wb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8292dca2fe19e2c0$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $aCs4O = parcelRequire("aCs4O");
var $8292dca2fe19e2c0$export$2e2bcd8739ae039 = (0, $aCs4O.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $5RN2x.default).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $5RN2x.default).isString(path) && cookie.push("path=" + path);
        (0, $5RN2x.default).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

});

parcelRegister("7lViM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55a6f18683d9f888$export$2e2bcd8739ae039; });

var $j3J1d = parcelRequire("j3J1d");

var $5G723 = parcelRequire("5G723");
"use strict";
function $55a6f18683d9f888$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $j3J1d.default)(requestedURL)) return (0, $5G723.default)(baseURL, requestedURL);
    return requestedURL;
}

});
parcelRegister("j3J1d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de0137e96012432b$export$2e2bcd8739ae039; });
"use strict";
function $de0137e96012432b$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

});

parcelRegister("5G723", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4226547004fa4063$export$2e2bcd8739ae039; });
"use strict";
function $4226547004fa4063$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

});


parcelRegister("1JsgI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $142febf2fa493ec7$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");

var $d08Yt = parcelRequire("d08Yt");
"use strict";
const $142febf2fa493ec7$var$headersToObject = (thing)=>thing instanceof (0, $d08Yt.default) ? {
        ...thing
    } : thing;
function $142febf2fa493ec7$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $5RN2x.default).isPlainObject(target) && (0, $5RN2x.default).isPlainObject(source)) return (0, $5RN2x.default).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $5RN2x.default).isPlainObject(source)) return (0, $5RN2x.default).merge({}, source);
        else if ((0, $5RN2x.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $5RN2x.default).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $5RN2x.default).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $5RN2x.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $5RN2x.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $5RN2x.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($142febf2fa493ec7$var$headersToObject(a), $142febf2fa493ec7$var$headersToObject(b), true)
    };
    (0, $5RN2x.default).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $5RN2x.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

});



parcelRegister("4w3Qc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $349d2151eec20aad$export$2e2bcd8739ae039; });

var $aCs4O = parcelRequire("aCs4O");

var $5RN2x = parcelRequire("5RN2x");

var $knwVc = parcelRequire("knwVc");

var $4FqZ2 = parcelRequire("4FqZ2");

var $9x5PT = parcelRequire("9x5PT");

var $d08Yt = parcelRequire("d08Yt");

var $eGzDO = parcelRequire("eGzDO");

var $hgCPq = parcelRequire("hgCPq");

var $fhocg = parcelRequire("fhocg");
const $349d2151eec20aad$var$fetchProgressDecorator = (total, fn)=>{
    const lengthComputable = total != null;
    return (loaded)=>setTimeout(()=>fn({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }));
};
const $349d2151eec20aad$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $349d2151eec20aad$var$isReadableStreamSupported = $349d2151eec20aad$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $349d2151eec20aad$var$encodeText = $349d2151eec20aad$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $349d2151eec20aad$var$supportsRequestStream = $349d2151eec20aad$var$isReadableStreamSupported && (()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $aCs4O.default).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
})();
const $349d2151eec20aad$var$DEFAULT_CHUNK_SIZE = 65536;
const $349d2151eec20aad$var$supportsResponseStream = $349d2151eec20aad$var$isReadableStreamSupported && !!(()=>{
    try {
        return (0, $5RN2x.default).isReadableStream(new Response("").body);
    } catch (err) {
    // return undefined
    }
})();
const $349d2151eec20aad$var$resolvers = {
    stream: $349d2151eec20aad$var$supportsResponseStream && ((res)=>res.body)
};
$349d2151eec20aad$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$349d2151eec20aad$var$resolvers[type] && ($349d2151eec20aad$var$resolvers[type] = (0, $5RN2x.default).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $knwVc.default)(`Response type '${type}' is not supported`, (0, $knwVc.default).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $349d2151eec20aad$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $5RN2x.default).isBlob(body)) return body.size;
    if ((0, $5RN2x.default).isSpecCompliantForm(body)) return (await new Request(body).arrayBuffer()).byteLength;
    if ((0, $5RN2x.default).isArrayBufferView(body)) return body.byteLength;
    if ((0, $5RN2x.default).isURLSearchParams(body)) body = body + "";
    if ((0, $5RN2x.default).isString(body)) return (await $349d2151eec20aad$var$encodeText(body)).byteLength;
};
const $349d2151eec20aad$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $5RN2x.default).toFiniteNumber(headers.getContentLength());
    return length == null ? $349d2151eec20aad$var$getBodyLength(body) : length;
};
var $349d2151eec20aad$export$2e2bcd8739ae039 = $349d2151eec20aad$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $hgCPq.default)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let [composedSignal, stopTimeout] = signal || cancelToken || timeout ? (0, $4FqZ2.default)([
        signal,
        cancelToken
    ], timeout) : [];
    let finished, request;
    const onFinish = ()=>{
        !finished && setTimeout(()=>{
            composedSignal && composedSignal.unsubscribe();
        });
        finished = true;
    };
    let requestContentLength;
    try {
        if (onUploadProgress && $349d2151eec20aad$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $349d2151eec20aad$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $5RN2x.default).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) data = (0, $9x5PT.trackStream)(_request.body, $349d2151eec20aad$var$DEFAULT_CHUNK_SIZE, $349d2151eec20aad$var$fetchProgressDecorator(requestContentLength, (0, $eGzDO.default)(onUploadProgress)), null, $349d2151eec20aad$var$encodeText);
        }
        if (!(0, $5RN2x.default).isString(withCredentials)) withCredentials = withCredentials ? "cors" : "omit";
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            withCredentials: withCredentials
        });
        let response = await fetch(request);
        const isStreamResponse = $349d2151eec20aad$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($349d2151eec20aad$var$supportsResponseStream && (onDownloadProgress || isStreamResponse)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $5RN2x.default).toFiniteNumber(response.headers.get("content-length"));
            response = new Response((0, $9x5PT.trackStream)(response.body, $349d2151eec20aad$var$DEFAULT_CHUNK_SIZE, onDownloadProgress && $349d2151eec20aad$var$fetchProgressDecorator(responseContentLength, (0, $eGzDO.default)(onDownloadProgress, true)), isStreamResponse && onFinish, $349d2151eec20aad$var$encodeText), options);
        }
        responseType = responseType || "text";
        let responseData = await $349d2151eec20aad$var$resolvers[(0, $5RN2x.default).findKey($349d2151eec20aad$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && onFinish();
        stopTimeout && stopTimeout();
        return await new Promise((resolve, reject)=>{
            (0, $fhocg.default)(resolve, reject, {
                data: responseData,
                headers: (0, $d08Yt.default).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        onFinish();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $knwVc.default)("Network Error", (0, $knwVc.default).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $knwVc.default).from(err, err && err.code, config, request);
    }
});

});
parcelRegister("4FqZ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $365fec1ad2e63ba9$export$2e2bcd8739ae039; });

var $bmfYM = parcelRequire("bmfYM");

var $knwVc = parcelRequire("knwVc");
const $365fec1ad2e63ba9$var$composeSignals = (signals, timeout)=>{
    let controller = new AbortController();
    let aborted;
    const onabort = function(cancel) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = cancel instanceof Error ? cancel : this.reason;
            controller.abort(err instanceof (0, $knwVc.default) ? err : new (0, $bmfYM.default)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        onabort(new (0, $knwVc.default)(`timeout ${timeout} of ms exceeded`, (0, $knwVc.default).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (signals) {
            timer && clearTimeout(timer);
            timer = null;
            signals.forEach((signal)=>{
                signal && (signal.removeEventListener ? signal.removeEventListener("abort", onabort) : signal.unsubscribe(onabort));
            });
            signals = null;
        }
    };
    signals.forEach((signal)=>signal && signal.addEventListener && signal.addEventListener("abort", onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = unsubscribe;
    return [
        signal,
        ()=>{
            timer && clearTimeout(timer);
            timer = null;
        }
    ];
};
var $365fec1ad2e63ba9$export$2e2bcd8739ae039 = $365fec1ad2e63ba9$var$composeSignals;

});

parcelRegister("9x5PT", function(module, exports) {

$parcel$export(module.exports, "trackStream", function () { return $01ca82fc0600dc5f$export$b0119225647bd83; });
const $01ca82fc0600dc5f$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $01ca82fc0600dc5f$export$f9f241124ee3198e = async function*(iterable, chunkSize, encode) {
    for await (const chunk of iterable)yield* $01ca82fc0600dc5f$export$71b051935044bd5d(ArrayBuffer.isView(chunk) ? chunk : await encode(String(chunk)), chunkSize);
};
const $01ca82fc0600dc5f$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish, encode)=>{
    const iterator = $01ca82fc0600dc5f$export$f9f241124ee3198e(stream, chunkSize, encode);
    let bytes = 0;
    return new ReadableStream({
        type: "bytes",
        async pull (controller) {
            const { done: done, value: value } = await iterator.next();
            if (done) {
                controller.close();
                onFinish();
                return;
            }
            let len = value.byteLength;
            onProgress && onProgress(bytes += len);
            controller.enqueue(new Uint8Array(value));
        },
        cancel (reason) {
            onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

});




parcelRegister("1P3Mn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $153d7c57f809624c$export$2e2bcd8739ae039; });

var $14YCA = parcelRequire("14YCA");

var $knwVc = parcelRequire("knwVc");
"use strict";
const $153d7c57f809624c$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $153d7c57f809624c$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $153d7c57f809624c$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $153d7c57f809624c$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $14YCA.VERSION) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $knwVc.default)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $knwVc.default).ERR_DEPRECATED);
        if (version && !$153d7c57f809624c$var$deprecatedWarnings[opt]) {
            $153d7c57f809624c$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $153d7c57f809624c$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $knwVc.default)("options must be an object", (0, $knwVc.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $knwVc.default)("option " + opt + " must be " + result, (0, $knwVc.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $knwVc.default)("Unknown option " + opt, (0, $knwVc.default).ERR_BAD_OPTION);
    }
}
var $153d7c57f809624c$export$2e2bcd8739ae039 = {
    assertOptions: $153d7c57f809624c$var$assertOptions,
    validators: $153d7c57f809624c$var$validators
};

});
parcelRegister("14YCA", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $0c953052fb93d857$export$a4ad2735b021c132; });
const $0c953052fb93d857$export$a4ad2735b021c132 = "1.7.2";

});



parcelRegister("hku8v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9dbae5aa50ec7c7$export$2e2bcd8739ae039; });

var $bmfYM = parcelRequire("bmfYM");
"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $c9dbae5aa50ec7c7$var$CancelToken {
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $c9dbae5aa50ec7c7$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $bmfYM.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
}
var $c9dbae5aa50ec7c7$export$2e2bcd8739ae039 = $c9dbae5aa50ec7c7$var$CancelToken;

});

parcelRegister("hvvj9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbed9dfdab194748$export$2e2bcd8739ae039; });
"use strict";
function $cbed9dfdab194748$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

});

parcelRegister("6bEux", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48132dea419dd2c0$export$2e2bcd8739ae039; });

var $5RN2x = parcelRequire("5RN2x");
"use strict";
function $48132dea419dd2c0$export$2e2bcd8739ae039(payload) {
    return (0, $5RN2x.default).isObject(payload) && payload.isAxiosError === true;
}

});

parcelRegister("dGtr4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f6607e590634381$export$2e2bcd8739ae039; });
const $9f6607e590634381$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($9f6607e590634381$var$HttpStatusCode).forEach(([key, value])=>{
    $9f6607e590634381$var$HttpStatusCode[value] = key;
});
var $9f6607e590634381$export$2e2bcd8739ae039 = $9f6607e590634381$var$HttpStatusCode;

});



parcelRegister("hacYN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveDataServiceUrls = module.exports.REDSTONE_DATA_SERVICES_URLS = void 0;
const $033981cfc5a76036$var$DEV_GWS = [
    "https://oracle-gateway-1.b.redstone.finance",
    "https://oracle-gateway-1.b.redstone.vip"
];
const $033981cfc5a76036$var$PROD_GWS = [
    "https://oracle-gateway-1.a.redstone.finance",
    "https://oracle-gateway-2.a.redstone.finance",
    "https://oracle-gateway-1.a.redstone.vip"
];
module.exports.REDSTONE_DATA_SERVICES_URLS = {
    "redstone-primary-prod": $033981cfc5a76036$var$PROD_GWS,
    "redstone-avalanche-prod": $033981cfc5a76036$var$PROD_GWS,
    "redstone-arbitrum-prod": $033981cfc5a76036$var$PROD_GWS,
    "redstone-primary-demo": $033981cfc5a76036$var$DEV_GWS,
    "redstone-main-demo": $033981cfc5a76036$var$DEV_GWS,
    "redstone-rapid-demo": $033981cfc5a76036$var$DEV_GWS,
    "redstone-fast-demo": $033981cfc5a76036$var$DEV_GWS,
    "redstone-stocks-demo": $033981cfc5a76036$var$DEV_GWS,
    "redstone-avalanche-demo": $033981cfc5a76036$var$DEV_GWS,
    "redstone-arbitrum-demo": $033981cfc5a76036$var$DEV_GWS,
    "mock-data-service": [
        "http://localhost:3000"
    ],
    "mock-data-service-tests": [
        "http://valid-cache.com"
    ]
};
const $033981cfc5a76036$var$resolveDataServiceUrls = (dataServiceId)=>{
    const urls = module.exports.REDSTONE_DATA_SERVICES_URLS[dataServiceId];
    if (!urls) throw Error(`Data service ${dataServiceId} is not configured by RedStone protocol`);
    return urls;
};
module.exports.resolveDataServiceUrls = $033981cfc5a76036$var$resolveDataServiceUrls;

});

parcelRegister("jgUgs", function(module, exports) {
"use strict";
var $e07b27e9aeea7fb8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e07b27e9aeea7fb8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e07b27e9aeea7fb8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$e07b27e9aeea7fb8$var$__exportStar((parcelRequire("3JmMG")), module.exports);

$e07b27e9aeea7fb8$var$__exportStar((parcelRequire("9vpsX")), module.exports);

$e07b27e9aeea7fb8$var$__exportStar((parcelRequire("7KLhj")), module.exports);

$e07b27e9aeea7fb8$var$__exportStar((parcelRequire("kuEs5")), module.exports);

$e07b27e9aeea7fb8$var$__exportStar((parcelRequire("28Ini")), module.exports);

});
parcelRegister("3JmMG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9vpsX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SafeOne = module.exports.SafeZero = module.exports.createSafeNumber = void 0;

var $28Ini = parcelRequire("28Ini");
const $6ebac354024c229f$var$createSafeNumber = (numberLike)=>$28Ini.JsNativeSafeNumber.from(numberLike);
module.exports.createSafeNumber = $6ebac354024c229f$var$createSafeNumber;
module.exports.SafeZero = (0, module.exports.createSafeNumber)(0);
module.exports.SafeOne = (0, module.exports.createSafeNumber)(1);

});
parcelRegister("28Ini", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsNativeSafeNumber = module.exports.JsNativeSafeNumberConfig = module.exports.NumberValidationResult = void 0;
var $18eec00d55ac9da4$var$NumberValidationResult;
(function(NumberValidationResult) {
    NumberValidationResult[NumberValidationResult["isOk"] = 0] = "isOk";
    NumberValidationResult[NumberValidationResult["isNaN"] = 1] = "isNaN";
    NumberValidationResult[NumberValidationResult["isNotFinite"] = 2] = "isNotFinite";
    NumberValidationResult[NumberValidationResult["isOverflow"] = 3] = "isOverflow";
    NumberValidationResult[NumberValidationResult["isUnderflow"] = 4] = "isUnderflow";
})($18eec00d55ac9da4$var$NumberValidationResult || (module.exports.NumberValidationResult = $18eec00d55ac9da4$var$NumberValidationResult = {}));
module.exports.JsNativeSafeNumberConfig = {
    MAX_NUMBER: Number.MAX_SAFE_INTEGER,
    MIN_NUMBER: 1e-14,
    MAX_DECIMALS: 14,
    DIGIT_REGEXP: /^[-+]?(\d+(\.\d{1,63})?|\.\d{1,63})([eE][-+]?\d+)?$/,
    ON_NUMBER_VALIDATION_ERROR: {
        [$18eec00d55ac9da4$var$NumberValidationResult.isNaN]: (msg)=>{
            throw new Error(msg);
        },
        [$18eec00d55ac9da4$var$NumberValidationResult.isNotFinite]: (msg)=>{
            throw new Error(msg);
        },
        [$18eec00d55ac9da4$var$NumberValidationResult.isOverflow]: console.error,
        [$18eec00d55ac9da4$var$NumberValidationResult.isUnderflow]: ()=>{}
    },
    EPSILON: 1e-14
};
class $18eec00d55ac9da4$var$JsNativeSafeNumber {
    static from(numberLike) {
        if (numberLike instanceof $18eec00d55ac9da4$var$JsNativeSafeNumber) return new $18eec00d55ac9da4$var$JsNativeSafeNumber(numberLike.unsafeToNumber());
        else if (typeof numberLike === "number" || typeof numberLike === "string") return new $18eec00d55ac9da4$var$JsNativeSafeNumber($18eec00d55ac9da4$var$parseToSafeNumber(numberLike));
        else throw new Error(`Invalid number format: Tried to create JsNativeSafeNumber from ${String(numberLike)}`);
    }
    decimals() {
        return module.exports.JsNativeSafeNumberConfig.MAX_DECIMALS;
    }
    toString() {
        return this._value.toString();
    }
    isSafeNumber() {
        return true;
    }
    abs() {
        const result = Math.abs(this._value);
        return this.produceNewSafeNumber(result);
    }
    log2() {
        const result = Math.log2(this._value);
        return this.produceNewSafeNumber(result);
    }
    add(numberLike) {
        const result = this._value + $18eec00d55ac9da4$var$JsNativeSafeNumber.from(numberLike).unsafeToNumber();
        return this.produceNewSafeNumber(result);
    }
    sub(numberLike) {
        const result = this._value - $18eec00d55ac9da4$var$JsNativeSafeNumber.from(numberLike).unsafeToNumber();
        return this.produceNewSafeNumber(result);
    }
    div(numberLike) {
        const result = this._value / $18eec00d55ac9da4$var$JsNativeSafeNumber.from(numberLike).unsafeToNumber();
        return this.produceNewSafeNumber(result);
    }
    mul(numberLike) {
        const result = this._value * $18eec00d55ac9da4$var$JsNativeSafeNumber.from(numberLike).unsafeToNumber();
        return this.produceNewSafeNumber(result);
    }
    assertNonNegative() {
        if (this._value < 0) throw new Error("Assert non negative failed");
    }
    assertPositive() {
        if (this._value <= 0) throw new Error("Assert non positive failed");
    }
    unsafeToNumber() {
        return this._value;
    }
    eq(numberArg) {
        const number = $18eec00d55ac9da4$var$JsNativeSafeNumber.from(numberArg);
        return Math.abs(number.unsafeToNumber() - this._value) < module.exports.JsNativeSafeNumberConfig.EPSILON;
    }
    lt(numberArg) {
        return this._value < $18eec00d55ac9da4$var$JsNativeSafeNumber.from(numberArg).unsafeToNumber();
    }
    lte(numberArg) {
        return this.lt(numberArg) || this.eq(numberArg);
    }
    gt(numberArg) {
        return this._value > $18eec00d55ac9da4$var$JsNativeSafeNumber.from(numberArg).unsafeToNumber();
    }
    gte(numberArg) {
        return this.gt(numberArg) || this.eq(numberArg);
    }
    toJSON() {
        return this.unsafeToNumber();
    }
    produceNewSafeNumber(result) {
        const newNumber = new $18eec00d55ac9da4$var$JsNativeSafeNumber(result);
        newNumber.assertValidAndRound();
        return newNumber;
    }
    assertValidAndRound() {
        const { result: validationResult, message: message } = $18eec00d55ac9da4$var$validateNumber(this._value);
        if (validationResult !== $18eec00d55ac9da4$var$NumberValidationResult.isOk) module.exports.JsNativeSafeNumberConfig.ON_NUMBER_VALIDATION_ERROR[validationResult](message);
        this._value = Number(this._value.toFixed(module.exports.JsNativeSafeNumberConfig.MAX_DECIMALS));
    }
    constructor(value){
        (0, $dxWQo._)(this, "_value", void 0);
        this._value = value;
    }
}
module.exports.JsNativeSafeNumber = $18eec00d55ac9da4$var$JsNativeSafeNumber;
const $18eec00d55ac9da4$var$validateNumber = (number)=>{
    if (Number.isNaN(number)) return {
        result: $18eec00d55ac9da4$var$NumberValidationResult.isNaN,
        message: "Invalid number format: number is NaN"
    };
    else if (!Number.isFinite(number)) return {
        result: $18eec00d55ac9da4$var$NumberValidationResult.isNotFinite,
        message: "Invalid number format: number is not finite"
    };
    if (Math.abs(number) > module.exports.JsNativeSafeNumberConfig.MAX_NUMBER) return {
        result: $18eec00d55ac9da4$var$NumberValidationResult.isOverflow,
        message: `Invalid number format: Number is bigger than max number acceptable by REDSTONE ${number}`
    };
    if (Math.abs(number) < module.exports.JsNativeSafeNumberConfig.MIN_NUMBER && number !== 0) return {
        result: $18eec00d55ac9da4$var$NumberValidationResult.isUnderflow,
        message: `Invalid number format: Number is smaller than min number acceptable by REDSTONE ${number}`
    };
    return {
        result: $18eec00d55ac9da4$var$NumberValidationResult.isOk,
        message: ""
    };
};
const $18eec00d55ac9da4$var$parseToSafeNumber = (value)=>{
    let number;
    if (typeof value === "string") {
        if (!module.exports.JsNativeSafeNumberConfig.DIGIT_REGEXP.test(value)) throw new Error(`Invalid number format: ${value}, not matching regexp: ${module.exports.JsNativeSafeNumberConfig.DIGIT_REGEXP}`);
        number = Number(value);
    } else if (typeof value === "number") number = Number(value);
    else throw new Error(`Invalid number format, expected: string or number`);
    const { result: validationResult, message: message } = $18eec00d55ac9da4$var$validateNumber(number);
    if (validationResult !== $18eec00d55ac9da4$var$NumberValidationResult.isOk) module.exports.JsNativeSafeNumberConfig.ON_NUMBER_VALIDATION_ERROR[validationResult](message);
    return number;
};

});


parcelRegister("7KLhj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMedian = module.exports.calculateDeviationPercent = module.exports.calculateAverageValue = module.exports.calculateSum = void 0;

var $9vpsX = parcelRequire("9vpsX");
const $5a5180bca3f52f69$var$calculateSum = (numbers)=>numbers.reduce((prev, curr)=>prev.add(curr), $9vpsX.SafeZero);
module.exports.calculateSum = $5a5180bca3f52f69$var$calculateSum;
const $5a5180bca3f52f69$var$calculateAverageValue = (numbers)=>{
    if (numbers.length === 0) throw new Error("Can not calculate an average value for an empty array");
    const result = (0, module.exports.calculateSum)(numbers).div(numbers.length);
    return result;
};
module.exports.calculateAverageValue = $5a5180bca3f52f69$var$calculateAverageValue;
const $5a5180bca3f52f69$var$calculateDeviationPercent = (args)=>{
    const { baseValue: baseValue, deviatedValue: deviatedValue } = args;
    if (baseValue.eq(0)) return (0, $9vpsX.createSafeNumber)(Number.MAX_SAFE_INTEGER);
    const result = deviatedValue.sub(baseValue).div(baseValue).abs().mul(100);
    return result;
};
module.exports.calculateDeviationPercent = $5a5180bca3f52f69$var$calculateDeviationPercent;
function $5a5180bca3f52f69$var$getMedian(numbers) {
    if (numbers.length === 0) throw new Error("Cannot get median value of an empty array");
    numbers = numbers.sort((a, b)=>a.lt(b) ? -1 : 1);
    const middle = Math.floor(numbers.length / 2);
    if (numbers.length % 2 === 0) return numbers[middle].add(numbers[middle - 1]).div(2);
    else return numbers[middle];
}
module.exports.getMedian = $5a5180bca3f52f69$var$getMedian;

});

parcelRegister("kuEs5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.normalizeWeightedValues = module.exports.logarithmicWeighting = module.exports.getWeightedMedian = void 0;

var $jgUgs = parcelRequire("jgUgs");
const $eeb5fce68d9b85a0$var$getWeightedMedian = (weightedValues)=>{
    if (weightedValues.length === 0) throw new Error("Cannot get weighted median value of an empty array");
    const sortedValues = [
        ...weightedValues
    ].sort((a, b)=>a.value.lt(b.value) ? -1 : 1);
    const halfTotalWeight = (0, $jgUgs.calculateSum)(sortedValues.map((wv)=>wv.weight)).div(2);
    let cumulativeWeight = $jgUgs.SafeZero;
    for(let i = 0; i < sortedValues.length; i++){
        const weightedValue = sortedValues[i];
        cumulativeWeight = cumulativeWeight.add(weightedValue.weight);
        if (cumulativeWeight.gt(halfTotalWeight)) return weightedValue.value;
        else if (cumulativeWeight.eq(halfTotalWeight)) return weightedValue.value.add(sortedValues[i + 1].value).div(2);
    }
    throw new Error("This should not happen: the accumulated weight did not exceed half of the sum of the weights");
};
module.exports.getWeightedMedian = $eeb5fce68d9b85a0$var$getWeightedMedian;
const $eeb5fce68d9b85a0$var$logarithmicWeighting = (weightedValues)=>{
    const medianWeight = (0, $jgUgs.getMedian)(weightedValues.map((v)=>v.weight));
    return weightedValues.map((weightedValue)=>({
            value: weightedValue.value,
            weight: weightedValue.weight.div(medianWeight).add(1).log2()
        }));
};
module.exports.logarithmicWeighting = $eeb5fce68d9b85a0$var$logarithmicWeighting;
const $eeb5fce68d9b85a0$var$normalizeWeightedValues = (weightedValues)=>{
    const sum = (0, $jgUgs.calculateSum)(weightedValues.map((value)=>value.weight));
    return weightedValues.map((weightedValue)=>({
            value: weightedValue.value,
            weight: weightedValue.weight.div(sum)
        }));
};
module.exports.normalizeWeightedValues = $eeb5fce68d9b85a0$var$normalizeWeightedValues;

});


parcelRegister("l6nB2", function(module, exports) {
"use strict";
var $f5cc764022b0c61b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f5cc764022b0c61b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $f5cc764022b0c61b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f5cc764022b0c61b$var$__exportStar((parcelRequire("7WmTU")), module.exports);

$f5cc764022b0c61b$var$__exportStar((parcelRequire("feOAI")), module.exports);

$f5cc764022b0c61b$var$__exportStar((parcelRequire("flD7D")), module.exports);

$f5cc764022b0c61b$var$__exportStar((parcelRequire("d2Y3Q")), module.exports);

$f5cc764022b0c61b$var$__exportStar((parcelRequire("goUYX")), module.exports);

$f5cc764022b0c61b$var$__exportStar((parcelRequire("hqUmi")), module.exports);

$f5cc764022b0c61b$var$__exportStar((parcelRequire("h2l10")), module.exports);

$f5cc764022b0c61b$var$__exportStar((parcelRequire("k3Doz")), module.exports);

$f5cc764022b0c61b$var$__exportStar((parcelRequire("2PgI4")), module.exports);

$f5cc764022b0c61b$var$__exportStar((parcelRequire("9szYY")), module.exports);

$f5cc764022b0c61b$var$__exportStar((parcelRequire("35eh6")), module.exports);

});
parcelRegister("7WmTU", function(module, exports) {
"use strict";
var $5c7fb6c67f6b2158$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.axiosGetWithRetries = void 0;

const $5c7fb6c67f6b2158$var$axios_1 = $5c7fb6c67f6b2158$var$__importDefault((parcelRequire("28feZ")));

var $h2l10 = parcelRequire("h2l10");
async function $5c7fb6c67f6b2158$var$axiosGetWithRetries(args) {
    return await (0, $h2l10.retry)({
        fn: async ()=>await $5c7fb6c67f6b2158$var$axios_1.default.get(args.url, {
                timeout: args.timeout
            }),
        fnName: `axios.get`,
        maxRetries: args.retryLimit,
        waitBetweenMs: args.retryDelayMilliseconds
    })();
}
module.exports.axiosGetWithRetries = $5c7fb6c67f6b2158$var$axiosGetWithRetries;

});
parcelRegister("h2l10", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.retry = void 0;

var $d2Y3Q = parcelRequire("d2Y3Q");

var $k3Doz = parcelRequire("k3Doz");
function $c672ecc5c02d87ee$var$retry(config) {
    if (config.maxRetries === 0) throw new Error(`Setting 'config.maxRetries' to 0 will never call the underlying function`);
    return async (...args)=>{
        var _config_fnName;
        const fnName = (_config_fnName = config.fnName) !== null && _config_fnName !== void 0 ? _config_fnName : config.fn.name;
        const error = new AggregateError([], `Retry failed after ${config.maxRetries} attempts of ${fnName}`);
        for(let i = 0; i < config.maxRetries; i++)try {
            return await config.fn(...args);
        } catch (e) {
            error.errors.push(e);
            if (!config.disableLog) console.log(`Retry ${i + 1}/${config.maxRetries}; Function ${fnName} failed.`, (0, $d2Y3Q.stringifyError)(e));
            if (config.waitBetweenMs && i !== config.maxRetries - 1) {
                const sleepTimeBackOffMultiplier = config.backOff ? Math.pow(config.backOff.backOffBase, i) : 1;
                const sleepTime = config.waitBetweenMs * sleepTimeBackOffMultiplier;
                if (!config.disableLog) console.log(`Waiting ${sleepTime / 1000} s. for the next retry...`);
                await (0, $k3Doz.sleep)(sleepTime);
            }
        }
        throw error;
    };
}
module.exports.retry = $c672ecc5c02d87ee$var$retry;

});
parcelRegister("d2Y3Q", function(module, exports) {
"use strict";
var $97fa0d25c3bc4c8e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringifyError = module.exports.assertWithLog = module.exports.assertThenReturn = module.exports.assert = void 0;

const $97fa0d25c3bc4c8e$var$axios_1 = $97fa0d25c3bc4c8e$var$__importDefault((parcelRequire("28feZ")));
function $97fa0d25c3bc4c8e$var$assert(value, errMsg) {
    if (!value) throw new Error(`Assertion failed: ${errMsg}`);
}
module.exports.assert = $97fa0d25c3bc4c8e$var$assert;
function $97fa0d25c3bc4c8e$var$assertThenReturn(value, errMsg) {
    if (!value) throw new Error(`Assertion failed: ${errMsg}`);
    return value;
}
module.exports.assertThenReturn = $97fa0d25c3bc4c8e$var$assertThenReturn;
const $97fa0d25c3bc4c8e$var$assertWithLog = (condition, errMsg)=>{
    if (!condition) console.error(`Assertion failed: ${errMsg}`);
};
module.exports.assertWithLog = $97fa0d25c3bc4c8e$var$assertWithLog;
const $97fa0d25c3bc4c8e$var$STACK_LENGTH = 200;
const $97fa0d25c3bc4c8e$var$stringifyStack = (stack)=>{
    if (!stack) return "";
    const suffix = stack.length > $97fa0d25c3bc4c8e$var$STACK_LENGTH ? "..." : "";
    return stack.substring(0, $97fa0d25c3bc4c8e$var$STACK_LENGTH - suffix.length) + suffix;
};
function $97fa0d25c3bc4c8e$var$stringifyError(e) {
    var _error_response;
    const error = e;
    if (error === undefined) return "undefined";
    else if (error instanceof AggregateError) {
        const errorMessages = error.errors.map($97fa0d25c3bc4c8e$var$stringifyError);
        return `AggregateError: ${error.message}, errors: ${errorMessages.join("; ")}`;
    } else if ($97fa0d25c3bc4c8e$var$axios_1.default.isAxiosError(error)) return JSON.stringify((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data) + $97fa0d25c3bc4c8e$var$stringifyStack(error.stack);
    else if (error instanceof Error) return $97fa0d25c3bc4c8e$var$stringifyStack(error.stack);
    else if (typeof error.toJSON === "function") return JSON.stringify(error.toJSON());
    else return `Error couldn't be handled by the stringifyError function: ${String(e)}`;
}
module.exports.stringifyError = $97fa0d25c3bc4c8e$var$stringifyError;

});

parcelRegister("k3Doz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.msToHours = module.exports.hourToMs = module.exports.minToMs = module.exports.msToMin = module.exports.sleep = module.exports.timeout = void 0;
const $e9a2a589372a917f$var$timeout = (prom, timeoutMS, customErrorMessage, timeoutCallback)=>{
    let timer;
    return Promise.race([
        prom,
        new Promise((resolve, reject)=>timer = setTimeout(()=>{
                if (timeoutCallback) return timeoutCallback(resolve, reject);
                reject(new Error(customErrorMessage !== null && customErrorMessage !== void 0 ? customErrorMessage : `Timeout error ${timeoutMS} [MS]`));
            }, timeoutMS))
    ]).finally(()=>clearTimeout(timer));
};
module.exports.timeout = $e9a2a589372a917f$var$timeout;
const $e9a2a589372a917f$var$sleep = (ms)=>new Promise((resolve, _rejects)=>setTimeout(resolve, ms));
module.exports.sleep = $e9a2a589372a917f$var$sleep;
const $e9a2a589372a917f$var$msToMin = (ms)=>ms / 60000;
module.exports.msToMin = $e9a2a589372a917f$var$msToMin;
const $e9a2a589372a917f$var$minToMs = (min)=>min * 60000;
module.exports.minToMs = $e9a2a589372a917f$var$minToMs;
const $e9a2a589372a917f$var$hourToMs = (hours)=>hours * 3600000;
module.exports.hourToMs = $e9a2a589372a917f$var$hourToMs;
const $e9a2a589372a917f$var$msToHours = (ms)=>ms / 3600000;
module.exports.msToHours = $e9a2a589372a917f$var$msToHours;

});



parcelRegister("feOAI", function(module, exports) {
"use strict";
var $b17f68285a50496e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bignumberishToDecimal = void 0;

const $b17f68285a50496e$var$decimal_js_1 = $b17f68285a50496e$var$__importDefault((parcelRequire("4qPUL")));

var $gMArf = parcelRequire("gMArf");
const $b17f68285a50496e$var$bignumberishToDecimal = (value)=>new $b17f68285a50496e$var$decimal_js_1.default($gMArf.BigNumber.from(value).toHexString());
module.exports.bignumberishToDecimal = $b17f68285a50496e$var$bignumberishToDecimal;

});
parcelRegister("4qPUL", function(module, exports) {
(function(globalScope) {
    "use strict";
    /*!
   *  decimal.js v10.4.3
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js
   *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The maximum exponent magnitude.
    // The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
    var EXP_LIMIT = 9e15, // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    MAX_DIGITS = 1e9, // Base conversion alphabet.
    NUMERALS = "0123456789abcdef", // The natural logarithm of 10 (1025 digits).
    LN10 = "2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058", // Pi (1025 digits).
    PI = "3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789", // The initial configuration properties of the Decimal constructor.
    DEFAULTS = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed at run-time using the `Decimal.config` method.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used when rounding to `precision`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP         0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
        // FLOOR      3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN  6 The IEEE 754 remainder function.
        // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
        //
        // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
        // division (9) are commonly used for the modulus operation. The other rounding modes can also
        // be used, but they may not give useful results.
        modulo: 1,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The minimum exponent value, beneath which underflow to zero occurs.
        // JavaScript numbers: -324  (5e-324)
        minE: -EXP_LIMIT,
        // The maximum exponent value, above which overflow to Infinity occurs.
        // JavaScript numbers: 308  (1.7976931348623157e+308)
        maxE: EXP_LIMIT,
        // Whether to use cryptographically-secure random number generation, if available.
        crypto: false // true/false
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    Decimal, inexact, noConflict, quadrant, external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", precisionLimitExceeded = decimalError + "Precision limit exceeded", cryptoUnavailable = decimalError + "crypto unavailable", tag = "[object Decimal]", mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, // Decimal.prototype object
    P = {
        toStringTag: tag
    };
    // Decimal prototype methods
    /*
   *  absoluteValue             abs
   *  ceil
   *  clampedTo                 clamp
   *  comparedTo                cmp
   *  cosine                    cos
   *  cubeRoot                  cbrt
   *  decimalPlaces             dp
   *  dividedBy                 div
   *  dividedToIntegerBy        divToInt
   *  equals                    eq
   *  floor
   *  greaterThan               gt
   *  greaterThanOrEqualTo      gte
   *  hyperbolicCosine          cosh
   *  hyperbolicSine            sinh
   *  hyperbolicTangent         tanh
   *  inverseCosine             acos
   *  inverseHyperbolicCosine   acosh
   *  inverseHyperbolicSine     asinh
   *  inverseHyperbolicTangent  atanh
   *  inverseSine               asin
   *  inverseTangent            atan
   *  isFinite
   *  isInteger                 isInt
   *  isNaN
   *  isNegative                isNeg
   *  isPositive                isPos
   *  isZero
   *  lessThan                  lt
   *  lessThanOrEqualTo         lte
   *  logarithm                 log
   *  [maximum]                 [max]
   *  [minimum]                 [min]
   *  minus                     sub
   *  modulo                    mod
   *  naturalExponential        exp
   *  naturalLogarithm          ln
   *  negated                   neg
   *  plus                      add
   *  precision                 sd
   *  round
   *  sine                      sin
   *  squareRoot                sqrt
   *  tangent                   tan
   *  times                     mul
   *  toBinary
   *  toDecimalPlaces           toDP
   *  toExponential
   *  toFixed
   *  toFraction
   *  toHexadecimal             toHex
   *  toNearest
   *  toNumber
   *  toOctal
   *  toPower                   pow
   *  toPrecision
   *  toSignificantDigits       toSD
   *  toString
   *  truncated                 trunc
   *  valueOf                   toJSON
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s < 0) x.s = 1;
        return finalise(x);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of positive Infinity.
   *
   */ P.ceil = function() {
        return finalise(new this.constructor(this), this.e + 1, 2);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal clamped to the range
   * delineated by `min` and `max`.
   *
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */ P.clampedTo = P.clamp = function(min, max) {
        var k, x = this, Ctor = x.constructor;
        min = new Ctor(min);
        max = new Ctor(max);
        if (!min.s || !max.s) return new Ctor(NaN);
        if (min.gt(max)) throw Error(invalidArgument + max);
        k = x.cmp(min);
        return k < 0 ? min : x.cmp(max) > 0 ? max : new Ctor(x);
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value,
   *   NaN  if the value of either Decimal is NaN.
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this, xd = x.d, yd = (y = new x.constructor(y)).d, xs = x.s, ys = y.s;
        // Either NaN or ±Infinity?
        if (!xd || !yd) return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
        // Either zero?
        if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;
        // Signs differ?
        if (xs !== ys) return xs;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;
        xdL = xd.length;
        ydL = yd.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
    };
    /*
   * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * cos(0)         = 1
   * cos(-0)        = 1
   * cos(Infinity)  = NaN
   * cos(-Infinity) = NaN
   * cos(NaN)       = NaN
   *
   */ P.cosine = P.cos = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.d) return new Ctor(NaN);
        // cos(0) = cos(-0) = 1
        if (!x.d[0]) return new Ctor(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = cosine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
    };
    /*
   *
   * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   *  cbrt(0)  =  0
   *  cbrt(-0) = -0
   *  cbrt(1)  =  1
   *  cbrt(-1) = -1
   *  cbrt(N)  =  N
   *  cbrt(-I) = -I
   *  cbrt(I)  =  I
   *
   * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
   *
   */ P.cubeRoot = P.cbrt = function() {
        var e, m, n, r, rep, s, sd, t, t3, t3plusx, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        external = false;
        // Initial estimate.
        s = x.s * mathpow(x.s * x, 1 / 3);
        // Math.cbrt underflow/overflow?
        // Pass x to Math.pow as integer, then adjust the exponent of the result.
        if (!s || Math.abs(s) == 1 / 0) {
            n = digitsToString(x.d);
            e = x.e;
            // Adjust n exponent so it is a multiple of 3 away from x exponent.
            if (s = (e - n.length + 1) % 3) n += s == 1 || s == -2 ? "0" : "00";
            s = mathpow(n, 1 / 3);
            // Rarely, e may be one less than the result exponent value.
            e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
            r.s = x.s;
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Halley's method.
        // TODO? Compare Newton's method.
        for(;;){
            t = r;
            t3 = t.times(t).times(t);
            t3plusx = t3.plus(x);
            r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
                // , i.e. approaching a rounding boundary, continue the iteration.
                if (n == "9999" || !rep && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var w, d = this.d, n = NaN;
        if (d) {
            w = d.length - 1;
            n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last word.
            w = d[w];
            if (w) for(; w % 10 == 0; w /= 10)n--;
            if (n < 0) n = 0;
        }
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.dividedToIntegerBy = P.divToInt = function(y) {
        var x = this, Ctor = x.constructor;
        return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return this.cmp(y) === 0;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of negative Infinity.
   *
   */ P.floor = function() {
        return finalise(new this.constructor(this), this.e + 1, 3);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        var k = this.cmp(y);
        return k == 1 || k === 0;
    };
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [1, Infinity]
   *
   * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
   *
   * cosh(0)         = 1
   * cosh(-0)        = 1
   * cosh(Infinity)  = Infinity
   * cosh(-Infinity) = Infinity
   * cosh(NaN)       = NaN
   *
   *  x        time taken (ms)   result
   * 1000      9                 9.8503555700852349694e+433
   * 10000     25                4.4034091128314607936e+4342
   * 100000    171               1.4033316802130615897e+43429
   * 1000000   3817              1.5166076984010437725e+434294
   * 10000000  abandoned after 2 minute wait
   *
   * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
   *
   */ P.hyperbolicCosine = P.cosh = function() {
        var k, n, pr, rm, len, x = this, Ctor = x.constructor, one = new Ctor(1);
        if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
        if (x.isZero()) return one;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
        // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))
        // Estimate the optimum number of times to use the argument reduction.
        // TODO? Estimation reused from cosine() and may not be optimal here.
        if (len < 32) {
            k = Math.ceil(len / 3);
            n = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            n = "2.3283064365386962890625e-10";
        }
        x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);
        // Reverse argument reduction
        var cosh2_x, i = k, d8 = new Ctor(8);
        for(; i--;){
            cosh2_x = x.times(x);
            x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
        }
        return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
   *
   * sinh(0)         = 0
   * sinh(-0)        = -0
   * sinh(Infinity)  = Infinity
   * sinh(-Infinity) = -Infinity
   * sinh(NaN)       = NaN
   *
   * x        time taken (ms)
   * 10       2 ms
   * 100      5 ms
   * 1000     14 ms
   * 10000    82 ms
   * 100000   886 ms            1.4033316802130615897e+43429
   * 200000   2613 ms
   * 300000   5407 ms
   * 400000   8824 ms
   * 500000   13026 ms          8.7080643612718084129e+217146
   * 1000000  48543 ms
   *
   * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
   *
   */ P.hyperbolicSine = P.sinh = function() {
        var k, pr, rm, len, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
        Ctor.rounding = 1;
        len = x.d.length;
        if (len < 3) x = taylorSeries(Ctor, 2, x, x, true);
        else {
            // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
            // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
            // 3 multiplications and 1 addition
            // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
            // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
            // 4 multiplications and 2 additions
            // Estimate the optimum number of times to use the argument reduction.
            k = 1.4 * Math.sqrt(len);
            k = k > 16 ? 16 : k | 0;
            x = x.times(1 / tinyPow(5, k));
            x = taylorSeries(Ctor, 2, x, x, true);
            // Reverse argument reduction
            var sinh2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
            for(; k--;){
                sinh2_x = x.times(x);
                x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
            }
        }
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * tanh(x) = sinh(x) / cosh(x)
   *
   * tanh(0)         = 0
   * tanh(-0)        = -0
   * tanh(Infinity)  = 1
   * tanh(-Infinity) = -1
   * tanh(NaN)       = NaN
   *
   */ P.hyperbolicTangent = P.tanh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(x.s);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 7;
        Ctor.rounding = 1;
        return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
    };
    /*
   * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
   * this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [0, pi]
   *
   * acos(x) = pi/2 - asin(x)
   *
   * acos(0)       = pi/2
   * acos(-0)      = pi/2
   * acos(1)       = 0
   * acos(-1)      = pi
   * acos(1/2)     = pi/3
   * acos(-1/2)    = 2*pi/3
   * acos(|x| > 1) = NaN
   * acos(NaN)     = NaN
   *
   */ P.inverseCosine = P.acos = function() {
        var halfPi, x = this, Ctor = x.constructor, k = x.abs().cmp(1), pr = Ctor.precision, rm = Ctor.rounding;
        if (k !== -1) return k === 0 ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0) : new Ctor(NaN);
        if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);
        // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.asin();
        halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return halfPi.minus(x);
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
   * value of this Decimal.
   *
   * Domain: [1, Infinity]
   * Range: [0, Infinity]
   *
   * acosh(x) = ln(x + sqrt(x^2 - 1))
   *
   * acosh(x < 1)     = NaN
   * acosh(NaN)       = NaN
   * acosh(Infinity)  = Infinity
   * acosh(-Infinity) = NaN
   * acosh(0)         = NaN
   * acosh(-0)        = NaN
   * acosh(1)         = 0
   * acosh(-1)        = NaN
   *
   */ P.inverseHyperbolicCosine = P.acosh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
        if (!x.isFinite()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).minus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * asinh(x) = ln(x + sqrt(x^2 + 1))
   *
   * asinh(NaN)       = NaN
   * asinh(Infinity)  = Infinity
   * asinh(-Infinity) = -Infinity
   * asinh(0)         = 0
   * asinh(-0)        = -0
   *
   */ P.inverseHyperbolicSine = P.asinh = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite() || x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
        Ctor.rounding = 1;
        external = false;
        x = x.times(x).plus(1).sqrt().plus(x);
        external = true;
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.ln();
    };
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
   * value of this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [-Infinity, Infinity]
   *
   * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
   *
   * atanh(|x| > 1)   = NaN
   * atanh(NaN)       = NaN
   * atanh(Infinity)  = NaN
   * atanh(-Infinity) = NaN
   * atanh(0)         = 0
   * atanh(-0)        = -0
   * atanh(1)         = Infinity
   * atanh(-1)        = -Infinity
   *
   */ P.inverseHyperbolicTangent = P.atanh = function() {
        var pr, rm, wpr, xsd, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        xsd = x.sd();
        if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);
        Ctor.precision = wpr = xsd - x.e;
        x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);
        Ctor.precision = pr + 4;
        Ctor.rounding = 1;
        x = x.ln();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(0.5);
    };
    /*
   * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
   *
   * asin(0)       = 0
   * asin(-0)      = -0
   * asin(1/2)     = pi/6
   * asin(-1/2)    = -pi/6
   * asin(1)       = pi/2
   * asin(-1)      = -pi/2
   * asin(|x| > 1) = NaN
   * asin(NaN)     = NaN
   *
   * TODO? Compare performance of Taylor series.
   *
   */ P.inverseSine = P.asin = function() {
        var halfPi, k, pr, rm, x = this, Ctor = x.constructor;
        if (x.isZero()) return new Ctor(x);
        k = x.abs().cmp(1);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (k !== -1) {
            // |x| is 1
            if (k === 0) {
                halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
                halfPi.s = x.s;
                return halfPi;
            }
            // |x| > 1 or x is NaN
            return new Ctor(NaN);
        }
        // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6
        Ctor.precision = pr + 6;
        Ctor.rounding = 1;
        x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return x.times(2);
    };
    /*
   * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
   *
   * atan(0)         = 0
   * atan(-0)        = -0
   * atan(1)         = pi/4
   * atan(-1)        = -pi/4
   * atan(Infinity)  = pi/2
   * atan(-Infinity) = -pi/2
   * atan(NaN)       = NaN
   *
   */ P.inverseTangent = P.atan = function() {
        var i, j, k, n, px, t, r, wpr, x2, x = this, Ctor = x.constructor, pr = Ctor.precision, rm = Ctor.rounding;
        if (!x.isFinite()) {
            if (!x.s) return new Ctor(NaN);
            if (pr + 4 <= PI_PRECISION) {
                r = getPi(Ctor, pr + 4, rm).times(0.5);
                r.s = x.s;
                return r;
            }
        } else if (x.isZero()) return new Ctor(x);
        else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
            r = getPi(Ctor, pr + 4, rm).times(0.25);
            r.s = x.s;
            return r;
        }
        Ctor.precision = wpr = pr + 10;
        Ctor.rounding = 1;
        // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);
        // Argument reduction
        // Ensure |x| < 0.42
        // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))
        k = Math.min(28, wpr / LOG_BASE + 2 | 0);
        for(i = k; i; --i)x = x.div(x.times(x).plus(1).sqrt().plus(1));
        external = false;
        j = Math.ceil(wpr / LOG_BASE);
        n = 1;
        x2 = x.times(x);
        r = new Ctor(x);
        px = x;
        // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
        for(; i !== -1;){
            px = px.times(x2);
            t = r.minus(px.div(n += 2));
            px = px.times(x2);
            r = t.plus(px.div(n += 2));
            if (r.d[j] !== void 0) for(i = j; r.d[i] === t.d[i] && i--;);
        }
        if (k) r = r.times(2 << k - 1);
        external = true;
        return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
    };
    /*
   * Return true if the value of this Decimal is a finite number, otherwise return false.
   *
   */ P.isFinite = function() {
        return !!this.d;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isInt = function() {
        return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is NaN, otherwise return false.
   *
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isNeg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.isPos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0 or -0, otherwise return false.
   *
   */ P.isZero = function() {
        return !!this.d && this.d[0] === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * If no base is specified, return log[10](arg).
   *
   * log[base](arg) = ln(arg) / ln(base)
   *
   * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
   * otherwise:
   *
   * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
   * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
   * between the result and the correctly rounded result will be one ulp (unit in the last place).
   *
   * log[-b](a)       = NaN
   * log[0](a)        = NaN
   * log[1](a)        = NaN
   * log[NaN](a)      = NaN
   * log[Infinity](a) = NaN
   * log[b](0)        = -Infinity
   * log[b](-0)       = -Infinity
   * log[b](-a)       = NaN
   * log[b](1)        = 0
   * log[b](Infinity) = Infinity
   * log[b](NaN)      = NaN
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var isBase10, d, denominator, k, inf, num, sd, r, arg = this, Ctor = arg.constructor, pr = Ctor.precision, rm = Ctor.rounding, guard = 5;
        // Default base is 10.
        if (base == null) {
            base = new Ctor(10);
            isBase10 = true;
        } else {
            base = new Ctor(base);
            d = base.d;
            // Return NaN if base is negative, or non-finite, or is 0 or 1.
            if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);
            isBase10 = base.eq(10);
        }
        d = arg.d;
        // Is arg negative, non-finite, 0 or 1?
        if (arg.s < 0 || !d || !d[0] || arg.eq(1)) return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
        // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
        // integer power of 10.
        if (isBase10) {
            if (d.length > 1) inf = true;
            else {
                for(k = d[0]; k % 10 === 0;)k /= 10;
                inf = k !== 1;
            }
        }
        external = false;
        sd = pr + guard;
        num = naturalLogarithm(arg, sd);
        denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
        // The result will have 5 rounding digits.
        r = divide(num, denominator, sd, 1);
        // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
        // calculate 10 further digits.
        //
        // If the result is known to have an infinite decimal expansion, repeat this until it is clear
        // that the result is above or below the boundary. Otherwise, if after calculating the 10
        // further digits, the last 14 are nines, round up and assume the result is exact.
        // Also assume the result is exact if the last 14 are zero.
        //
        // Example of a result that will be incorrectly rounded:
        // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
        // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
        // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
        // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
        // place is still 2.6.
        if (checkRoundingDigits(r.d, k = pr, rm)) do {
            sd += 10;
            num = naturalLogarithm(arg, sd);
            denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
            r = divide(num, denominator, sd, 1);
            if (!inf) {
                // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
                if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
                break;
            }
        }while (checkRoundingDigits(r.d, k += 10, rm));
        external = true;
        return finalise(r, pr, rm);
    };
    /*
   * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.max = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'lt');
  };
   */ /*
   * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.min = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'gt');
  };
   */ /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.minus = P.sub = function(y) {
        var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (x.d) y.s = -y.s;
            else y = new Ctor(y.d || x.s !== y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.plus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return y negated if x is zero and y is non-zero.
            if (yd[0]) y.s = -y.s;
            else if (xd[0]) y = new Ctor(x);
            else return new Ctor(rm === 3 ? -0 : 0);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        e = mathfloor(y.e / LOG_BASE);
        xe = mathfloor(x.e / LOG_BASE);
        xd = xd.slice();
        k = xe - e;
        // If base 1e7 exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of
            // zeros needing to be prepended, but this can be avoided while still ensuring correct
            // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to `xd` if shorter.
        // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * The result depends on the modulo mode.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
        if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);
        // Return x if y is ±Infinity or x is ±0.
        if (!y.d || x.d && !x.d[0]) return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
        // Prevent rounding of intermediate calculations.
        external = false;
        if (Ctor.modulo == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // result = x - q * y    where  0 <= result < abs(y)
            q = divide(x, y.abs(), 0, 3, 1);
            q.s *= y.s;
        } else q = divide(x, y, 0, Ctor.modulo, 1);
        q = q.times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.naturalExponential = P.exp = function() {
        return naturalExponential(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return naturalLogarithm(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s;
        return finalise(x);
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */ P.plus = P.add = function(y) {
        var carry, d, e, i, k, len, pr, rm, xd, yd, x = this, Ctor = x.constructor;
        y = new Ctor(y);
        // If either is not finite...
        if (!x.d || !y.d) {
            // Return NaN if either is NaN.
            if (!x.s || !y.s) y = new Ctor(NaN);
            else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);
            return y;
        }
        // If signs differ...
        if (x.s != y.s) {
            y.s = -y.s;
            return x.minus(y);
        }
        xd = x.d;
        yd = y.d;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        // If either is zero...
        if (!xd[0] || !yd[0]) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!yd[0]) y = new Ctor(x);
            return external ? finalise(y, pr, rm) : y;
        }
        // x and y are finite, non-zero numbers with the same sign.
        // Calculate base 1e7 exponents.
        k = mathfloor(x.e / LOG_BASE);
        e = mathfloor(y.e / LOG_BASE);
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = getBase10Exponent(xd, e);
        return external ? finalise(y, pr, rm) : y;
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var k, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        if (x.d) {
            k = getPrecision(x.d);
            if (z && x.e + 1 > k) k = x.e + 1;
        } else k = NaN;
        return k;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.round = function() {
        var x = this, Ctor = x.constructor;
        return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
    };
    /*
   * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * sin(x) = x - x^3/3! + x^5/5! - ...
   *
   * sin(0)         = 0
   * sin(-0)        = -0
   * sin(Infinity)  = NaN
   * sin(-Infinity) = NaN
   * sin(NaN)       = NaN
   *
   */ P.sine = P.sin = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
        Ctor.rounding = 1;
        x = sine(Ctor, toLessThanHalfPi(Ctor, x));
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   *  sqrt(-n) =  N
   *  sqrt(N)  =  N
   *  sqrt(-I) =  N
   *  sqrt(I)  =  I
   *  sqrt(0)  =  0
   *  sqrt(-0) = -0
   *
   */ P.squareRoot = P.sqrt = function() {
        var m, n, sd, r, rep, t, x = this, d = x.d, e = x.e, s = x.s, Ctor = x.constructor;
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !d || !d[0]) return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(d);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        sd = (e = Ctor.precision) + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);
            // TODO? Replace with for-loop and checkRoundingDigits.
            if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
                n = n.slice(sd - 3, sd + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (n == "9999" || !rep && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    if (!rep) {
                        finalise(t, e + 1, 0);
                        if (t.times(t).eq(x)) {
                            r = t;
                            break;
                        }
                    }
                    sd += 4;
                    rep = 1;
                } else {
                    // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
                    // If not, then there are further digits and m will be truthy.
                    if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                        // Truncate to the first rounding digit.
                        finalise(r, e + 1, 1);
                        m = !r.times(r).eq(x);
                    }
                    break;
                }
            }
        }
        external = true;
        return finalise(r, e, Ctor.rounding, m);
    };
    /*
   * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * tan(0)         = 0
   * tan(-0)        = -0
   * tan(Infinity)  = NaN
   * tan(-Infinity) = NaN
   * tan(NaN)       = NaN
   *
   */ P.tangent = P.tan = function() {
        var pr, rm, x = this, Ctor = x.constructor;
        if (!x.isFinite()) return new Ctor(NaN);
        if (x.isZero()) return new Ctor(x);
        pr = Ctor.precision;
        rm = Ctor.rounding;
        Ctor.precision = pr + 10;
        Ctor.rounding = 1;
        x = x.sin();
        x.s = 1;
        x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);
        Ctor.precision = pr;
        Ctor.rounding = rm;
        return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        y.s *= x.s;
        // If either is NaN, ±Infinity or ±0...
        if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd ? NaN : !xd || !yd ? y.s / 0 : y.s * 0);
        e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = getBase10Exponent(r, e);
        return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
    };
    /*
   * Return a string representing the value of this Decimal in base 2, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toBinary = function(sd, rm) {
        return toStringBinary(this, 2, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.toDP = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return finalise(x, dp + x.e + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), dp + 1, rm);
            str = finiteToString(x, true, dp + 1);
        }
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) str = finiteToString(x);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            y = finalise(new Ctor(x), dp + x.e + 1, rm);
            str = finiteToString(y, false, dp + y.e + 1);
        }
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return an array representing the value of this Decimal as a simple fraction with an integer
   * numerator and an integer denominator.
   *
   * The denominator will be a positive non-zero value less than or equal to the specified maximum
   * denominator. If a maximum denominator is not specified, the denominator will be the lowest
   * value necessary to represent the number exactly.
   *
   * [maxD] {number|string|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
   *
   */ P.toFraction = function(maxD) {
        var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r, x = this, xd = x.d, Ctor = x.constructor;
        if (!xd) return new Ctor(x);
        n1 = d0 = new Ctor(1);
        d1 = n0 = new Ctor(0);
        d = new Ctor(d1);
        e = d.e = getPrecision(xd) - x.e - 1;
        k = e % LOG_BASE;
        d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);
        if (maxD == null) // d is 10**e, the minimum max-denominator needed.
        maxD = e > 0 ? d : n1;
        else {
            n = new Ctor(maxD);
            if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
            maxD = n.gt(d) ? e > 0 ? d : n1 : n;
        }
        external = false;
        n = new Ctor(digitsToString(xd));
        pr = Ctor.precision;
        Ctor.precision = e = xd.length * LOG_BASE * 2;
        for(;;){
            q = divide(n, d, 0, 1, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.cmp(maxD) == 1) break;
            d0 = d1;
            d1 = d2;
            d2 = n1;
            n1 = n0.plus(q.times(d2));
            n0 = d2;
            d2 = d;
            d = n.minus(q.times(d2));
            n = d2;
        }
        d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        // Determine which fraction is closer to x, n0/d0 or n1/d1?
        r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        Ctor.precision = pr;
        external = true;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal in base 16, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toHexadecimal = P.toHex = function(sd, rm) {
        return toStringBinary(this, 16, sd, rm);
    };
    /*
   * Returns a new Decimal whose value is the nearest multiple of `y` in the direction of rounding
   * mode `rm`, or `Decimal.rounding` if `rm` is omitted, to the value of this Decimal.
   *
   * The return value will always have the same sign as this Decimal, unless either this Decimal
   * or `y` is NaN, in which case the return value will be also be NaN.
   *
   * The return value is not affected by the value of `precision`.
   *
   * y {number|string|Decimal} The magnitude to round to a multiple of.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toNearest() rounding mode not an integer: {rm}'
   * 'toNearest() rounding mode out of range: {rm}'
   *
   */ P.toNearest = function(y, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (y == null) {
            // If x is not finite, return x.
            if (!x.d) return x;
            y = new Ctor(1);
            rm = Ctor.rounding;
        } else {
            y = new Ctor(y);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            // If x is not finite, return x if y is not NaN, else NaN.
            if (!x.d) return y.s ? x : y;
            // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
            if (!y.d) {
                if (y.s) y.s = x.s;
                return y;
            }
        }
        // If y is not zero, calculate the nearest multiple of y to x.
        if (y.d[0]) {
            external = false;
            x = divide(x, y, 0, rm, 1).times(y);
            external = true;
            finalise(x);
        // If y is zero, return zero with the sign of x.
        } else {
            y.s = x.s;
            x = y;
        }
        return x;
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   * Zero keeps its sign.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a string representing the value of this Decimal in base 8, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toOctal = function(sd, rm) {
        return toStringBinary(this, 8, sd, rm);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
   * to `precision` significant digits using rounding mode `rounding`.
   *
   * ECMAScript compliant.
   *
   *   pow(x, NaN)                           = NaN
   *   pow(x, ±0)                            = 1

   *   pow(NaN, non-zero)                    = NaN
   *   pow(abs(x) > 1, +Infinity)            = +Infinity
   *   pow(abs(x) > 1, -Infinity)            = +0
   *   pow(abs(x) == 1, ±Infinity)           = NaN
   *   pow(abs(x) < 1, +Infinity)            = +0
   *   pow(abs(x) < 1, -Infinity)            = +Infinity
   *   pow(+Infinity, y > 0)                 = +Infinity
   *   pow(+Infinity, y < 0)                 = +0
   *   pow(-Infinity, odd integer > 0)       = -Infinity
   *   pow(-Infinity, even integer > 0)      = +Infinity
   *   pow(-Infinity, odd integer < 0)       = -0
   *   pow(-Infinity, even integer < 0)      = +0
   *   pow(+0, y > 0)                        = +0
   *   pow(+0, y < 0)                        = +Infinity
   *   pow(-0, odd integer > 0)              = -0
   *   pow(-0, even integer > 0)             = +0
   *   pow(-0, odd integer < 0)              = -Infinity
   *   pow(-0, even integer < 0)             = +Infinity
   *   pow(finite x < 0, finite non-integer) = NaN
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
   * probability of an incorrectly rounded result
   * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
   * i.e. 1 in 250,000,000,000,000
   *
   * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, rm, s, x = this, Ctor = x.constructor, yn = +(y = new Ctor(y));
        // Either ±Infinity, NaN or ±0?
        if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor(mathpow(+x, yn));
        x = new Ctor(x);
        if (x.eq(1)) return x;
        pr = Ctor.precision;
        rm = Ctor.rounding;
        if (y.eq(1)) return finalise(x, pr, rm);
        // y exponent
        e = mathfloor(y.e / LOG_BASE);
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = intPow(Ctor, x, k, pr);
            return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
        }
        s = x.s;
        // if x is negative
        if (s < 0) {
            // if y is not an integer
            if (e < y.d.length - 1) return new Ctor(NaN);
            // Result is positive if x is negative and the last digit of integer y is even.
            if ((y.d[e] & 1) == 0) s = 1;
            // if x.eq(-1)
            if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
                x.s = s;
                return x;
            }
        }
        // Estimate result exponent.
        // x^y = 10^e,  where e = y * log10(x)
        // log10(x) = log10(x_significand) + x_exponent
        // log10(x_significand) = ln(x_significand) / ln(10)
        k = mathpow(+x, yn);
        e = k == 0 || !isFinite(k) ? mathfloor(yn * (Math.log("0." + digitsToString(x.d)) / Math.LN10 + x.e + 1)) : new Ctor(k + "").e;
        // Exponent estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.
        // Overflow/underflow?
        if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);
        external = false;
        Ctor.rounding = x.s = 1;
        // Estimate the extra guard digits needed to ensure five correct rounding digits from
        // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
        // new Decimal(2.32456).pow('2087987436534566.46411')
        // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
        k = Math.min(12, (e + "").length);
        // r = x^y = exp(y*ln(x))
        r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);
        // r may be Infinity, e.g. (0.9999999999999999).pow(-1e+40)
        if (r.d) {
            // Truncate to the required precision plus five rounding digits.
            r = finalise(r, pr + 5, 1);
            // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
            // the result.
            if (checkRoundingDigits(r.d, pr, rm)) {
                e = pr + 10;
                // Truncate to the increased precision plus five rounding digits.
                r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);
                // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
                if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) r = finalise(r, pr + 1, 0);
            }
        }
        r.s = s;
        external = true;
        Ctor.rounding = rm;
        return finalise(r, pr, rm);
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var str, x = this, Ctor = x.constructor;
        if (sd === void 0) str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = finalise(new Ctor(x), sd, rm);
            str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
        }
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toSD() digits out of range: {sd}'
   * 'toSD() digits not an integer: {sd}'
   * 'toSD() rounding mode not an integer: {rm}'
   * 'toSD() rounding mode out of range: {rm}'
   *
   */ P.toSignificantDigits = P.toSD = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return finalise(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
   *
   */ P.truncated = P.trunc = function() {
        return finalise(new this.constructor(this), this.e + 1, 1);
    };
    /*
   * Return a string representing the value of this Decimal.
   * Unlike `toString`, negative zero will include the minus sign.
   *
   */ P.valueOf = P.toJSON = function() {
        var x = this, Ctor = x.constructor, str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
        return x.isNeg() ? "-" + str : str;
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
   *                           finiteToString, naturalExponential, naturalLogarithm
   *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
   *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
   *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
   *  convertBase              toStringBinary, parseOther
   *  cos                      P.cos
   *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
   *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
   *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
   *                           taylorSeries, atan2, parseOther
   *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
   *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
   *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
   *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
   *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
   *                           P.truncated, divide, getLn10, getPi, naturalExponential,
   *                           naturalLogarithm, ceil, floor, round, trunc
   *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
   *                           toStringBinary
   *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
   *  getLn10                  P.logarithm, naturalLogarithm
   *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
   *  getPrecision             P.precision, P.toFraction
   *  getZeroString            digitsToString, finiteToString
   *  intPow                   P.toPower, parseOther
   *  isOdd                    toLessThanHalfPi
   *  maxOrMin                 max, min
   *  naturalExponential       P.naturalExponential, P.toPower
   *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
   *                           P.toPower, naturalExponential
   *  nonFiniteToString        finiteToString, toStringBinary
   *  parseDecimal             Decimal
   *  parseOther               Decimal
   *  sin                      P.sin
   *  taylorSeries             P.cosh, P.sinh, cos, sin
   *  toLessThanHalfPi         P.cos, P.sin
   *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
   *  truncate                 intPow
   *
   *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
   *                           naturalLogarithm, config, parseOther, random, Decimal
   */ function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + "";
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return "0";
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    /*
   * Check 5 rounding digits if `repeating` is null, 4 otherwise.
   * `repeating == null` if caller is `log` or `pow`,
   * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
   */ function checkRoundingDigits(d, i, rm, repeating) {
        var di, k, r, rd;
        // Get the length of the first word of the array d.
        for(k = d[0]; k >= 10; k /= 10)--i;
        // Is the rounding digit in the first word of d?
        if (--i < 0) {
            i += LOG_BASE;
            di = 0;
        } else {
            di = Math.ceil((i + 1) / LOG_BASE);
            i %= LOG_BASE;
        }
        // i is the index (0 - 6) of the rounding digit.
        // E.g. if within the word 3487563 the first rounding digit is 5,
        // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
        k = mathpow(10, LOG_BASE - i);
        rd = d[di] % k | 0;
        if (repeating == null) {
            if (i < 3) {
                if (i == 0) rd = rd / 100 | 0;
                else if (i == 1) rd = rd / 10 | 0;
                r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 50000 || rd == 0;
            } else r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 || (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
        } else if (i < 4) {
            if (i == 0) rd = rd / 1000 | 0;
            else if (i == 1) rd = rd / 100 | 0;
            else if (i == 2) rd = rd / 10 | 0;
            r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
        } else r = ((repeating || rm < 4) && rd + 1 == k || !repeating && rm > 3 && rd + 1 == k / 2) && (d[di + 1] / k / 1000 | 0) == mathpow(10, i - 3) - 1;
        return r;
    }
    // Convert string of `baseIn` to an array of numbers of `baseOut`.
    // Eg. convertBase('255', 10, 16) returns [15, 15].
    // Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
    function convertBase(str, baseIn, baseOut) {
        var j, arr = [
            0
        ], arrL, i = 0, strL = str.length;
        for(; i < strL;){
            for(arrL = arr.length; arrL--;)arr[arrL] *= baseIn;
            arr[0] += NUMERALS.indexOf(str.charAt(i++));
            for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                if (arr[j + 1] === void 0) arr[j + 1] = 0;
                arr[j + 1] += arr[j] / baseOut | 0;
                arr[j] %= baseOut;
            }
        }
        return arr.reverse();
    }
    /*
   * cos(x) = 1 - x^2/2! + x^4/4! - ...
   * |x| < pi/2
   *
   */ function cosine(Ctor, x) {
        var k, len, y;
        if (x.isZero()) return x;
        // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
        // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1
        // Estimate the optimum number of times to use the argument reduction.
        len = x.d.length;
        if (len < 32) {
            k = Math.ceil(len / 3);
            y = (1 / tinyPow(4, k)).toString();
        } else {
            k = 16;
            y = "2.3283064365386962890625e-10";
        }
        Ctor.precision += k;
        x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));
        // Reverse argument reduction
        for(var i = k; i--;){
            var cos2x = x.times(x);
            x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
        }
        Ctor.precision -= k;
        return x;
    }
    /*
   * Perform division in the specified base.
   */ var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k, base) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % base | 0;
                carry = temp / base | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, rm, dp, base) {
            var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either NaN, Infinity or 0?
            if (!xd || !xd[0] || !yd || !yd[0]) return new Ctor(!x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN : // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
            xd && xd[0] == 0 || !yd ? sign * 0 : sign / 0);
            if (base) {
                logBase = 1;
                e = x.e - y.e;
            } else {
                base = BASE;
                logBase = LOG_BASE;
                e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
            }
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            // The digit array of a Decimal from toStringBinary may have trailing zeros.
            for(i = 0; yd[i] == (xd[i] || 0); i++);
            if (yd[i] > (xd[i] || 0)) e--;
            if (pr == null) {
                sd = pr = Ctor.precision;
                rm = Ctor.rounding;
            } else if (dp) sd = pr + (x.e - y.e) + 1;
            else sd = pr;
            if (sd < 0) {
                qd.push(1);
                more = true;
            } else {
                // Convert precision in number of base 10 digits to base 1e7 digits.
                sd = sd / logBase + 2 | 0;
                i = 0;
                // divisor < 1e7
                if (yL == 1) {
                    k = 0;
                    yd = yd[0];
                    sd++;
                    // k is the carry.
                    for(; (i < xL || k) && sd--; i++){
                        t = k * base + (xd[i] || 0);
                        qd[i] = t / yd | 0;
                        k = t % yd | 0;
                    }
                    more = k || i < xL;
                // divisor >= 1e7
                } else {
                    // Normalise xd and yd so highest order digit of yd is >= base/2
                    k = base / (yd[0] + 1) | 0;
                    if (k > 1) {
                        yd = multiplyInteger(yd, k, base);
                        xd = multiplyInteger(xd, k, base);
                        yL = yd.length;
                        xL = xd.length;
                    }
                    xi = yL;
                    rem = xd.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL;)rem[remL++] = 0;
                    yz = yd.slice();
                    yz.unshift(0);
                    yd0 = yd[0];
                    if (yd[1] >= base / 2) ++yd0;
                    do {
                        k = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yd, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, k.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // k will be how many times the divisor goes into the current remainder.
                            k = rem0 / yd0 | 0;
                            //  Algorithm:
                            //  1. product = divisor * trial digit (k)
                            //  2. if product > remainder: product -= divisor, k--
                            //  3. remainder -= product
                            //  4. if product was < remainder at 2:
                            //    5. compare new remainder and divisor
                            //    6. If remainder > divisor: remainder -= divisor, k++
                            if (k > 1) {
                                if (k >= base) k = base - 1;
                                // product = divisor * trial digit.
                                prod = multiplyInteger(yd, k, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                cmp = compare(prod, rem, prodL, remL);
                                // product > remainder.
                                if (cmp == 1) {
                                    k--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yd, prodL, base);
                                }
                            } else {
                                // cmp is -1.
                                // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                                // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                                if (k == 0) cmp = k = 1;
                                prod = yd.slice();
                            }
                            prodL = prod.length;
                            if (prodL < remL) prod.unshift(0);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            // If product was < previous remainder.
                            if (cmp == -1) {
                                remL = rem.length;
                                // Compare divisor and new remainder.
                                cmp = compare(yd, rem, yL, remL);
                                // If divisor < new remainder, subtract divisor from remainder.
                                if (cmp < 1) {
                                    k++;
                                    // Subtract divisor from remainder.
                                    subtract(rem, yL < remL ? yz : yd, remL, base);
                                }
                            }
                            remL = rem.length;
                        } else if (cmp === 0) {
                            k++;
                            rem = [
                                0
                            ];
                        } // if cmp === 1, k will be 0
                        // Add the next digit, k, to the result array.
                        qd[i++] = k;
                        // Update the remainder.
                        if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                        else {
                            rem = [
                                xd[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] !== void 0) && sd--);
                    more = rem[0] !== void 0;
                }
                // Leading zero?
                if (!qd[0]) qd.shift();
            }
            // logBase is 1 when divide is being used for base conversion.
            if (logBase == 1) {
                q.e = e;
                inexact = more;
            } else {
                // To calculate q.e, first get the number of digits of qd[0].
                for(i = 1, k = qd[0]; k >= 10; k /= 10)i++;
                q.e = i + e * logBase - 1;
                finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
            }
            return q;
        };
    }();
    /*
   * Round `x` to `sd` significant digits using rounding mode `rm`.
   * Check for over/under-flow.
   */ function finalise(x, sd, rm, isTruncated) {
        var digits, i, j, k, rd, roundUp, w, xd, xdi, Ctor = x.constructor;
        // Don't round if sd is null or undefined.
        out: if (sd != null) {
            xd = x.d;
            // Infinity/NaN.
            if (!xd) return x;
            // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
            // w: the word of xd containing rd, a base 1e7 number.
            // xdi: the index of w within xd.
            // digits: the number of digits of w.
            // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
            // they had leading zeros)
            // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
            // Get the length of the first word of the digits array xd.
            for(digits = 1, k = xd[0]; k >= 10; k /= 10)digits++;
            i = sd - digits;
            // Is the rounding digit in the first word of xd?
            if (i < 0) {
                i += LOG_BASE;
                j = sd;
                w = xd[xdi = 0];
                // Get the rounding digit at index j of w.
                rd = w / mathpow(10, digits - j - 1) % 10 | 0;
            } else {
                xdi = Math.ceil((i + 1) / LOG_BASE);
                k = xd.length;
                if (xdi >= k) {
                    if (isTruncated) {
                        // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
                        for(; k++ <= xdi;)xd.push(0);
                        w = rd = 0;
                        digits = 1;
                        i %= LOG_BASE;
                        j = i - LOG_BASE + 1;
                    } else break out;
                } else {
                    w = k = xd[xdi];
                    // Get the number of digits of w.
                    for(digits = 1; k >= 10; k /= 10)digits++;
                    // Get the index of rd within w.
                    i %= LOG_BASE;
                    // Get the index of rd within w, adjusted for leading zeros.
                    // The number of leading zeros of w is given by LOG_BASE - digits.
                    j = i - LOG_BASE + digits;
                    // Get the rounding digit at index j of w.
                    rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
                }
            }
            // Are there any non-zero digits after the rounding digit?
            isTruncated = isTruncated || sd < 0 || xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));
            // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
            // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
            // will give 714.
            roundUp = rm < 4 ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
            if (sd < 1 || !xd[0]) {
                xd.length = 0;
                if (roundUp) {
                    // Convert sd to decimal places.
                    sd -= x.e + 1;
                    // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                    xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                    x.e = -sd || 0;
                } else // Zero.
                xd[0] = x.e = 0;
                return x;
            }
            // Remove excess digits.
            if (i == 0) {
                xd.length = xdi;
                k = 1;
                xdi--;
            } else {
                xd.length = xdi + 1;
                k = mathpow(10, LOG_BASE - i);
                // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                // j > 0 means i > number of leading zeros of w.
                xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
            }
            if (roundUp) {
                for(;;)// Is the digit to be rounded up in the first word of xd?
                if (xdi == 0) {
                    // i will be the length of xd[0] before k is added.
                    for(i = 1, j = xd[0]; j >= 10; j /= 10)i++;
                    j = xd[0] += k;
                    for(k = 1; j >= 10; j /= 10)k++;
                    // if i != k the length has increased.
                    if (i != k) {
                        x.e++;
                        if (xd[0] == BASE) xd[0] = 1;
                    }
                    break;
                } else {
                    xd[xdi] += k;
                    if (xd[xdi] != BASE) break;
                    xd[xdi--] = 0;
                    k = 1;
                }
            }
            // Remove trailing zeros.
            for(i = xd.length; xd[--i] === 0;)xd.pop();
        }
        if (external) {
            // Overflow?
            if (x.e > Ctor.maxE) {
                // Infinity.
                x.d = null;
                x.e = NaN;
            // Underflow?
            } else if (x.e < Ctor.minE) {
                // Zero.
                x.e = 0;
                x.d = [
                    0
                ];
            // Ctor.underflow = true;
            } // else Ctor.underflow = false;
        }
        return x;
    }
    function finiteToString(x, isExp, sd) {
        if (!x.isFinite()) return nonFiniteToString(x);
        var k, e = x.e, str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
            str = str + (x.e < 0 ? "e" : "e+") + x.e;
        } else if (e < 0) {
            str = "0." + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += ".";
                str += getZeroString(k);
            }
        }
        return str;
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(digits, e) {
        var w = digits[0];
        // Add the number of digits of the first word of the digits array.
        for(e *= LOG_BASE; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > LN10_PRECISION) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(precisionLimitExceeded);
        }
        return finalise(new Ctor(LN10), sd, 1, true);
    }
    function getPi(Ctor, sd, rm) {
        if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
        return finalise(new Ctor(PI), sd, rm, true);
    }
    function getPrecision(digits) {
        var w = digits.length - 1, len = w * LOG_BASE + 1;
        w = digits[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)len--;
            // Add the number of digits of the first word.
            for(w = digits[0]; w >= 10; w /= 10)len++;
        }
        return len;
    }
    function getZeroString(k) {
        var zs = "";
        for(; k--;)zs += "0";
        return zs;
    }
    /*
   * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
   * integer of type number.
   *
   * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
   *
   */ function intPow(Ctor, x, n, pr) {
        var isTruncated, r = new Ctor(1), // Max n of 9007199254740991 takes 53 loop iterations.
        // Maximum digits array length; leaves [28, 34] guard digits.
        k = Math.ceil(pr / LOG_BASE + 4);
        external = false;
        for(;;){
            if (n % 2) {
                r = r.times(x);
                if (truncate(r.d, k)) isTruncated = true;
            }
            n = mathfloor(n / 2);
            if (n === 0) {
                // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
                n = r.d.length - 1;
                if (isTruncated && r.d[n] === 0) ++r.d[n];
                break;
            }
            x = x.times(x);
            truncate(x.d, k);
        }
        external = true;
        return r;
    }
    function isOdd(n) {
        return n.d[n.d.length - 1] & 1;
    }
    /*
   * Handle `max` and `min`. `ltgt` is 'lt' or 'gt'.
   */ function maxOrMin(Ctor, args, ltgt) {
        var y, x = new Ctor(args[0]), i = 0;
        for(; ++i < args.length;){
            y = new Ctor(args[i]);
            if (!y.s) {
                x = y;
                break;
            } else if (x[ltgt](y)) x = y;
        }
        return x;
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
   * digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
   * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(Infinity)  = Infinity
   *  exp(-Infinity) = 0
   *  exp(NaN)       = NaN
   *  exp(±0)        = 1
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   *  The result will always be correctly rounded.
   *
   */ function naturalExponential(x, sd) {
        var denominator, guard, j, pow, sum, t, wpr, rep = 0, i = 0, k = 0, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // 0/NaN/Infinity?
        if (!x.d || !x.d[0] || x.e > 17) return new Ctor(x.d ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0 : x.s ? x.s < 0 ? 0 : x : 0 / 0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        // while abs(x) >= 0.1
        while(x.e > -2){
            // x = x / 2^5
            x = x.times(t);
            k += 5;
        }
        // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
        // necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(1);
        Ctor.precision = wpr;
        for(;;){
            pow = finalise(pow.times(x), wpr, 1);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                j = k;
                while(j--)sum = finalise(sum.times(sum), wpr, 1);
                // Check to see if the first 4 rounding digits are [49]999.
                // If so, repeat the summation with a higher precision, otherwise
                // e.g. with precision: 18, rounding: 1
                // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (rep < 3 && checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += 10;
                        denominator = pow = t = new Ctor(1);
                        i = 0;
                        rep++;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
        }
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
   * digits.
   *
   *  ln(-n)        = NaN
   *  ln(0)         = -Infinity
   *  ln(-0)        = -Infinity
   *  ln(1)         = 0
   *  ln(Infinity)  = Infinity
   *  ln(-Infinity) = NaN
   *  ln(NaN)       = NaN
   *
   *  ln(n) (n != 1) is non-terminating.
   *
   */ function naturalLogarithm(y, sd) {
        var c, c0, denominator, e, numerator, rep, sum, t, wpr, x1, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, rm = Ctor.rounding, pr = Ctor.precision;
        // Is x negative or Infinity, NaN, 0 or 1?
        if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        Ctor.precision = wpr += guard;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        if (Math.abs(e = x.e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = x.e;
            if (c0 > 1) {
                x = new Ctor("0." + c);
                e++;
            } else x = new Ctor(c0 + "." + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + "");
            x = naturalLogarithm(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? finalise(x, pr, rm, external = true) : x;
        }
        // x1 is x reduced to a value near 1.
        x1 = x;
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
        x2 = finalise(x.times(x), wpr, 1);
        denominator = 3;
        for(;;){
            numerator = finalise(numerator.times(x2), wpr, 1);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr, 1));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
                // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                sum = divide(sum, new Ctor(n), wpr, 1);
                // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
                // been repeated previously) and the first 4 rounding digits 9999?
                // If so, restart the summation with a higher precision, otherwise
                // e.g. with precision: 12, rounding: 1
                // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
                // `wpr - guard` is the index of first rounding digit.
                if (sd == null) {
                    if (checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
                        Ctor.precision = wpr += guard;
                        t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
                        x2 = finalise(x.times(x), wpr, 1);
                        denominator = rep = 1;
                    } else return finalise(sum, Ctor.precision = pr, rm, external = true);
                } else {
                    Ctor.precision = pr;
                    return sum;
                }
            }
            sum = t;
            denominator += 2;
        }
    }
    // ±Infinity, NaN.
    function nonFiniteToString(x) {
        // Unsigned.
        return String(x.s * x.s / 0);
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48; --len);
        str = str.slice(i, len);
        if (str) {
            len -= i;
            x.e = e = e - i - 1;
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += "0";
            x.d.push(+str);
            if (external) {
                // Overflow?
                if (x.e > x.constructor.maxE) {
                    // Infinity.
                    x.d = null;
                    x.e = NaN;
                // Underflow?
                } else if (x.e < x.constructor.minE) {
                    // Zero.
                    x.e = 0;
                    x.d = [
                        0
                    ];
                // x.constructor.underflow = true;
                } // else x.constructor.underflow = false;
            }
        } else {
            // Zero.
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
   */ function parseOther(x, str) {
        var base, Ctor, divisor, i, isFloat, len, p, xd, xe;
        if (str.indexOf("_") > -1) {
            str = str.replace(/(\d)_(?=\d)/g, "$1");
            if (isDecimal.test(str)) return parseDecimal(x, str);
        } else if (str === "Infinity" || str === "NaN") {
            if (!+str) x.s = NaN;
            x.e = NaN;
            x.d = null;
            return x;
        }
        if (isHex.test(str)) {
            base = 16;
            str = str.toLowerCase();
        } else if (isBinary.test(str)) base = 2;
        else if (isOctal.test(str)) base = 8;
        else throw Error(invalidArgument + str);
        // Is there a binary exponent part?
        i = str.search(/p/i);
        if (i > 0) {
            p = +str.slice(i + 1);
            str = str.substring(2, i);
        } else str = str.slice(2);
        // Convert `str` as an integer then divide the result by `base` raised to a power such that the
        // fraction part will be restored.
        i = str.indexOf(".");
        isFloat = i >= 0;
        Ctor = x.constructor;
        if (isFloat) {
            str = str.replace(".", "");
            len = str.length;
            i = len - i;
            // log[10](16) = 1.2041... , log[10](88) = 1.9444....
            divisor = intPow(Ctor, new Ctor(base), i, i * 2);
        }
        xd = convertBase(str, base, BASE);
        xe = xd.length - 1;
        // Remove trailing zeros.
        for(i = xe; xd[i] === 0; --i)xd.pop();
        if (i < 0) return new Ctor(x.s * 0);
        x.e = getBase10Exponent(xd, xe);
        x.d = xd;
        external = false;
        // At what precision to perform the division to ensure exact conversion?
        // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
        // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
        // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
        // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
        // Therefore using 4 * the number of digits of str will always be enough.
        if (isFloat) x = divide(x, divisor, len * 4);
        // Multiply by the binary exponent part if present.
        if (p) x = x.times(Math.abs(p) < 54 ? mathpow(2, p) : Decimal.pow(2, p));
        external = true;
        return x;
    }
    /*
   * sin(x) = x - x^3/3! + x^5/5! - ...
   * |x| < pi/2
   *
   */ function sine(Ctor, x) {
        var k, len = x.d.length;
        if (len < 3) return x.isZero() ? x : taylorSeries(Ctor, 2, x, x);
        // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
        // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
        // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))
        // Estimate the optimum number of times to use the argument reduction.
        k = 1.4 * Math.sqrt(len);
        k = k > 16 ? 16 : k | 0;
        x = x.times(1 / tinyPow(5, k));
        x = taylorSeries(Ctor, 2, x, x);
        // Reverse argument reduction
        var sin2_x, d5 = new Ctor(5), d16 = new Ctor(16), d20 = new Ctor(20);
        for(; k--;){
            sin2_x = x.times(x);
            x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
        }
        return x;
    }
    // Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
    function taylorSeries(Ctor, n, x, y, isHyperbolic) {
        var j, t, u, x2, i = 1, pr = Ctor.precision, k = Math.ceil(pr / LOG_BASE);
        external = false;
        x2 = x.times(x);
        u = new Ctor(y);
        for(;;){
            t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
            u = isHyperbolic ? y.plus(t) : y.minus(t);
            y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
            t = u.plus(y);
            if (t.d[k] !== void 0) {
                for(j = k; t.d[j] === u.d[j] && j--;);
                if (j == -1) break;
            }
            j = u;
            u = y;
            y = t;
            t = j;
            i++;
        }
        external = true;
        t.d.length = k + 1;
        return t;
    }
    // Exponent e must be positive and non-zero.
    function tinyPow(b, e) {
        var n = b;
        while(--e)n *= b;
        return n;
    }
    // Return the absolute value of `x` reduced to less than or equal to half pi.
    function toLessThanHalfPi(Ctor, x) {
        var t, isNeg = x.s < 0, pi = getPi(Ctor, Ctor.precision, 1), halfPi = pi.times(0.5);
        x = x.abs();
        if (x.lte(halfPi)) {
            quadrant = isNeg ? 4 : 1;
            return x;
        }
        t = x.divToInt(pi);
        if (t.isZero()) quadrant = isNeg ? 3 : 2;
        else {
            x = x.minus(t.times(pi));
            // 0 <= x < pi
            if (x.lte(halfPi)) {
                quadrant = isOdd(t) ? isNeg ? 2 : 3 : isNeg ? 4 : 1;
                return x;
            }
            quadrant = isOdd(t) ? isNeg ? 1 : 4 : isNeg ? 3 : 2;
        }
        return x.minus(pi).abs();
    }
    /*
   * Return the value of Decimal `x` as a string in base `baseOut`.
   *
   * If the optional `sd` argument is present include a binary exponent suffix.
   */ function toStringBinary(x, baseOut, sd, rm) {
        var base, e, i, k, len, roundUp, str, xd, y, Ctor = x.constructor, isExp = sd !== void 0;
        if (isExp) {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        } else {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        }
        if (!x.isFinite()) str = nonFiniteToString(x);
        else {
            str = finiteToString(x);
            i = str.indexOf(".");
            // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
            // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
            // minBinaryExponent = floor(decimalExponent * log[2](10))
            // log[2](10) = 3.321928094887362347870319429489390175864
            if (isExp) {
                base = 2;
                if (baseOut == 16) sd = sd * 4 - 3;
                else if (baseOut == 8) sd = sd * 3 - 2;
            } else base = baseOut;
            // Convert the number as an integer then divide the result by its base raised to a power such
            // that the fraction part will be restored.
            // Non-integer.
            if (i >= 0) {
                str = str.replace(".", "");
                y = new Ctor(1);
                y.e = str.length - i;
                y.d = convertBase(finiteToString(y), 10, base);
                y.e = y.d.length;
            }
            xd = convertBase(str, 10, base);
            e = len = xd.length;
            // Remove trailing zeros.
            for(; xd[--len] == 0;)xd.pop();
            if (!xd[0]) str = isExp ? "0p+0" : "0";
            else {
                if (i < 0) e--;
                else {
                    x = new Ctor(x);
                    x.d = xd;
                    x.e = e;
                    x = divide(x, y, sd, rm, 0, base);
                    xd = x.d;
                    e = x.e;
                    roundUp = inexact;
                }
                // The rounding digit, i.e. the digit after the digit that may be rounded up.
                i = xd[sd];
                k = base / 2;
                roundUp = roundUp || xd[sd + 1] !== void 0;
                roundUp = rm < 4 ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2)) : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 || rm === (x.s < 0 ? 8 : 7));
                xd.length = sd;
                if (roundUp) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(; ++xd[--sd] > base - 1;){
                    xd[sd] = 0;
                    if (!sd) {
                        ++e;
                        xd.unshift(1);
                    }
                }
                // Determine trailing zeros.
                for(len = xd.length; !xd[len - 1]; --len);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ""; i < len; i++)str += NUMERALS.charAt(xd[i]);
                // Add binary exponent suffix?
                if (isExp) {
                    if (len > 1) {
                        if (baseOut == 16 || baseOut == 8) {
                            i = baseOut == 16 ? 4 : 3;
                            for(--len; len % i; len++)str += "0";
                            xd = convertBase(str, base, baseOut);
                            for(len = xd.length; !xd[len - 1]; --len);
                            // xd[0] will always be be 1
                            for(i = 1, str = "1."; i < len; i++)str += NUMERALS.charAt(xd[i]);
                        } else str = str.charAt(0) + "." + str.slice(1);
                    }
                    str = str + (e < 0 ? "p" : "p+") + e;
                } else if (e < 0) {
                    for(; ++e;)str = "0" + str;
                    str = "0." + str;
                } else {
                    if (++e > len) for(e -= len; e--;)str += "0";
                    else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
                }
            }
            str = (baseOut == 16 ? "0x" : baseOut == 2 ? "0b" : baseOut == 8 ? "0o" : "") + str;
        }
        return x.s < 0 ? "-" + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  abs
   *  acos
   *  acosh
   *  add
   *  asin
   *  asinh
   *  atan
   *  atanh
   *  atan2
   *  cbrt
   *  ceil
   *  clamp
   *  clone
   *  config
   *  cos
   *  cosh
   *  div
   *  exp
   *  floor
   *  hypot
   *  ln
   *  log
   *  log2
   *  log10
   *  max
   *  min
   *  mod
   *  mul
   *  pow
   *  random
   *  round
   *  set
   *  sign
   *  sin
   *  sinh
   *  sqrt
   *  sub
   *  sum
   *  tan
   *  tanh
   *  trunc
   */ /*
   * Return a new Decimal whose value is the absolute value of `x`.
   *
   * x {number|string|Decimal}
   *
   */ function abs(x) {
        return new this(x).abs();
    }
    /*
   * Return a new Decimal whose value is the arccosine in radians of `x`.
   *
   * x {number|string|Decimal}
   *
   */ function acos(x) {
        return new this(x).acos();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function acosh(x) {
        return new this(x).acosh();
    }
    /*
   * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function add(x, y) {
        return new this(x).plus(y);
    }
    /*
   * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function asin(x) {
        return new this(x).asin();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function asinh(x) {
        return new this(x).asinh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function atan(x) {
        return new this(x).atan();
    }
    /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function atanh(x) {
        return new this(x).atanh();
    }
    /*
   * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
   * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi, pi]
   *
   * y {number|string|Decimal} The y-coordinate.
   * x {number|string|Decimal} The x-coordinate.
   *
   * atan2(±0, -0)               = ±pi
   * atan2(±0, +0)               = ±0
   * atan2(±0, -x)               = ±pi for x > 0
   * atan2(±0, x)                = ±0 for x > 0
   * atan2(-y, ±0)               = -pi/2 for y > 0
   * atan2(y, ±0)                = pi/2 for y > 0
   * atan2(±y, -Infinity)        = ±pi for finite y > 0
   * atan2(±y, +Infinity)        = ±0 for finite y > 0
   * atan2(±Infinity, x)         = ±pi/2 for finite x
   * atan2(±Infinity, -Infinity) = ±3*pi/4
   * atan2(±Infinity, +Infinity) = ±pi/4
   * atan2(NaN, x) = NaN
   * atan2(y, NaN) = NaN
   *
   */ function atan2(y, x) {
        y = new this(y);
        x = new this(x);
        var r, pr = this.precision, rm = this.rounding, wpr = pr + 4;
        // Either NaN
        if (!y.s || !x.s) r = new this(NaN);
        else if (!y.d && !x.d) {
            r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
            r.s = y.s;
        // x is ±Infinity or y is ±0
        } else if (!x.d || y.isZero()) {
            r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
            r.s = y.s;
        // y is ±Infinity or x is ±0
        } else if (!y.d || x.isZero()) {
            r = getPi(this, wpr, 1).times(0.5);
            r.s = y.s;
        // Both non-zero and finite
        } else if (x.s < 0) {
            this.precision = wpr;
            this.rounding = 1;
            r = this.atan(divide(y, x, wpr, 1));
            x = getPi(this, wpr, 1);
            this.precision = pr;
            this.rounding = rm;
            r = y.s < 0 ? r.minus(x) : r.plus(x);
        } else r = this.atan(divide(y, x, wpr, 1));
        return r;
    }
    /*
   * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function cbrt(x) {
        return new this(x).cbrt();
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
   *
   * x {number|string|Decimal}
   *
   */ function ceil(x) {
        return finalise(x = new this(x), x.e + 1, 2);
    }
    /*
   * Return a new Decimal whose value is `x` clamped to the range delineated by `min` and `max`.
   *
   * x {number|string|Decimal}
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */ function clamp(x, min, max) {
        return new this(x).clamp(min, max);
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *   maxE       {number}
   *   minE       {number}
   *   modulo     {number}
   *   crypto     {boolean|number}
   *   defaults   {true}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
        var i, p, v, useDefaults = obj.defaults === true, ps = [
            "precision",
            1,
            MAX_DIGITS,
            "rounding",
            0,
            8,
            "toExpNeg",
            -EXP_LIMIT,
            0,
            "toExpPos",
            0,
            EXP_LIMIT,
            "maxE",
            0,
            EXP_LIMIT,
            "minE",
            -EXP_LIMIT,
            0,
            "modulo",
            0,
            9
        ];
        for(i = 0; i < ps.length; i += 3){
            if (p = ps[i], useDefaults) this[p] = DEFAULTS[p];
            if ((v = obj[p]) !== void 0) {
                if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
                else throw Error(invalidArgument + p + ": " + v);
            }
        }
        if (p = "crypto", useDefaults) this[p] = DEFAULTS[p];
        if ((v = obj[p]) !== void 0) {
            if (v === true || v === false || v === 0 || v === 1) {
                if (v) {
                    if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[p] = true;
                    else throw Error(cryptoUnavailable);
                } else this[p] = false;
            } else throw Error(invalidArgument + p + ": " + v);
        }
        return this;
    }
    /*
   * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function cos(x) {
        return new this(x).cos();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function cosh(x) {
        return new this(x).cosh();
    }
    /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * v {number|string|Decimal} A numeric value.
     *
     */ function Decimal(v) {
            var e, i, t, x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(v);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (isDecimalInstance(v)) {
                x.s = v.s;
                if (external) {
                    if (!v.d || v.e > Decimal.maxE) {
                        // Infinity.
                        x.e = NaN;
                        x.d = null;
                    } else if (v.e < Decimal.minE) {
                        // Zero.
                        x.e = 0;
                        x.d = [
                            0
                        ];
                    } else {
                        x.e = v.e;
                        x.d = v.d.slice();
                    }
                } else {
                    x.e = v.e;
                    x.d = v.d ? v.d.slice() : v.d;
                }
                return;
            }
            t = typeof v;
            if (t === "number") {
                if (v === 0) {
                    x.s = 1 / v < 0 ? -1 : 1;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                if (v < 0) {
                    v = -v;
                    x.s = -1;
                } else x.s = 1;
                // Fast path for small integers.
                if (v === ~~v && v < 1e7) {
                    for(e = 0, i = v; i >= 10; i /= 10)e++;
                    if (external) {
                        if (e > Decimal.maxE) {
                            x.e = NaN;
                            x.d = null;
                        } else if (e < Decimal.minE) {
                            x.e = 0;
                            x.d = [
                                0
                            ];
                        } else {
                            x.e = e;
                            x.d = [
                                v
                            ];
                        }
                    } else {
                        x.e = e;
                        x.d = [
                            v
                        ];
                    }
                    return;
                // Infinity, NaN.
                } else if (v * 0 !== 0) {
                    if (!v) x.s = NaN;
                    x.e = NaN;
                    x.d = null;
                    return;
                }
                return parseDecimal(x, v.toString());
            } else if (t !== "string") throw Error(invalidArgument + v);
            // Minus sign?
            if ((i = v.charCodeAt(0)) === 45) {
                v = v.slice(1);
                x.s = -1;
            } else {
                // Plus sign?
                if (i === 43) v = v.slice(1);
                x.s = 1;
            }
            return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.EUCLID = 9;
        Decimal.config = Decimal.set = config;
        Decimal.clone = clone;
        Decimal.isDecimal = isDecimalInstance;
        Decimal.abs = abs;
        Decimal.acos = acos;
        Decimal.acosh = acosh; // ES6
        Decimal.add = add;
        Decimal.asin = asin;
        Decimal.asinh = asinh; // ES6
        Decimal.atan = atan;
        Decimal.atanh = atanh; // ES6
        Decimal.atan2 = atan2;
        Decimal.cbrt = cbrt; // ES6
        Decimal.ceil = ceil;
        Decimal.clamp = clamp;
        Decimal.cos = cos;
        Decimal.cosh = cosh; // ES6
        Decimal.div = div;
        Decimal.exp = exp;
        Decimal.floor = floor;
        Decimal.hypot = hypot; // ES6
        Decimal.ln = ln;
        Decimal.log = log;
        Decimal.log10 = log10; // ES6
        Decimal.log2 = log2; // ES6
        Decimal.max = max;
        Decimal.min = min;
        Decimal.mod = mod;
        Decimal.mul = mul;
        Decimal.pow = pow;
        Decimal.random = random;
        Decimal.round = round;
        Decimal.sign = sign; // ES6
        Decimal.sin = sin;
        Decimal.sinh = sinh; // ES6
        Decimal.sqrt = sqrt;
        Decimal.sub = sub;
        Decimal.sum = sum;
        Decimal.tan = tan;
        Decimal.tanh = tanh; // ES6
        Decimal.trunc = trunc; // ES6
        if (obj === void 0) obj = {};
        if (obj) {
            if (obj.defaults !== true) {
                ps = [
                    "precision",
                    "rounding",
                    "toExpNeg",
                    "toExpPos",
                    "maxE",
                    "minE",
                    "modulo",
                    "crypto"
                ];
                for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
            }
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function div(x, y) {
        return new this(x).div(y);
    }
    /*
   * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The power to which to raise the base of the natural log.
   *
   */ function exp(x) {
        return new this(x).exp();
    }
    /*
   * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
   *
   * x {number|string|Decimal}
   *
   */ function floor(x) {
        return finalise(x = new this(x), x.e + 1, 3);
    }
    /*
   * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
   *
   * arguments {number|string|Decimal}
   *
   */ function hypot() {
        var i, n, t = new this(0);
        external = false;
        for(i = 0; i < arguments.length;){
            n = new this(arguments[i++]);
            if (!n.d) {
                if (n.s) {
                    external = true;
                    return new this(1 / 0);
                }
                t = n;
            } else if (t.d) t = t.plus(n.times(n));
        }
        external = true;
        return t.sqrt();
    }
    /*
   * Return true if object is a Decimal instance (where Decimal is any Decimal constructor),
   * otherwise return false.
   *
   */ function isDecimalInstance(obj) {
        return obj instanceof Decimal || obj && obj.toStringTag === tag || false;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function ln(x) {
        return new this(x).ln();
    }
    /*
   * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
   * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * log[y](x)
   *
   * x {number|string|Decimal} The argument of the logarithm.
   * y {number|string|Decimal} The base of the logarithm.
   *
   */ function log(x, y) {
        return new this(x).log(y);
    }
    /*
   * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function log2(x) {
        return new this(x).log(2);
    }
    /*
   * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function log10(x) {
        return new this(x).log(10);
    }
    /*
   * Return a new Decimal whose value is the maximum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */ function max() {
        return maxOrMin(this, arguments, "lt");
    }
    /*
   * Return a new Decimal whose value is the minimum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */ function min() {
        return maxOrMin(this, arguments, "gt");
    }
    /*
   * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function mod(x, y) {
        return new this(x).mod(y);
    }
    /*
   * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function mul(x, y) {
        return new this(x).mul(y);
    }
    /*
   * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The base.
   * y {number|string|Decimal} The exponent.
   *
   */ function pow(x, y) {
        return new this(x).pow(y);
    }
    /*
   * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
   * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
   * are produced).
   *
   * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
   *
   */ function random(sd) {
        var d, e, k, n, i = 0, r = new this(1), rd = [];
        if (sd === void 0) sd = this.precision;
        else checkInt32(sd, 1, MAX_DIGITS);
        k = Math.ceil(sd / LOG_BASE);
        if (!this.crypto) for(; i < k;)rd[i++] = Math.random() * 1e7 | 0;
        else if (crypto.getRandomValues) {
            d = crypto.getRandomValues(new Uint32Array(k));
            for(; i < k;){
                n = d[i];
                // 0 <= n < 4294967296
                // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
                if (n >= 4.29e9) d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
                else // 0 <= n <= 4289999999
                // 0 <= (n % 1e7) <= 9999999
                rd[i++] = n % 1e7;
            }
        // Node.js supporting crypto.randomBytes.
        } else if (crypto.randomBytes) {
            // buffer
            d = crypto.randomBytes(k *= 4);
            for(; i < k;){
                // 0 <= n < 2147483648
                n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 0x7f) << 24);
                // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
                if (n >= 2.14e9) crypto.randomBytes(4).copy(d, i);
                else {
                    // 0 <= n <= 2139999999
                    // 0 <= (n % 1e7) <= 9999999
                    rd.push(n % 1e7);
                    i += 4;
                }
            }
            i = k / 4;
        } else throw Error(cryptoUnavailable);
        k = rd[--i];
        sd %= LOG_BASE;
        // Convert trailing digits to zeros according to sd.
        if (k && sd) {
            n = mathpow(10, LOG_BASE - sd);
            rd[i] = (k / n | 0) * n;
        }
        // Remove trailing words which are zero.
        for(; rd[i] === 0; i--)rd.pop();
        // Zero?
        if (i < 0) {
            e = 0;
            rd = [
                0
            ];
        } else {
            e = -1;
            // Remove leading words which are zero and adjust exponent accordingly.
            for(; rd[0] === 0; e -= LOG_BASE)rd.shift();
            // Count the digits of the first word of rd to determine leading zeros.
            for(k = 1, n = rd[0]; n >= 10; n /= 10)k++;
            // Adjust the exponent for leading zeros of the first word of rd.
            if (k < LOG_BASE) e -= LOG_BASE - k;
        }
        r.e = e;
        r.d = rd;
        return r;
    }
    /*
   * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
   *
   * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
   *
   * x {number|string|Decimal}
   *
   */ function round(x) {
        return finalise(x = new this(x), x.e + 1, this.rounding);
    }
    /*
   * Return
   *   1    if x > 0,
   *  -1    if x < 0,
   *   0    if x is 0,
   *  -0    if x is -0,
   *   NaN  otherwise
   *
   * x {number|string|Decimal}
   *
   */ function sign(x) {
        x = new this(x);
        return x.d ? x.d[0] ? x.s : 0 * x.s : x.s || NaN;
    }
    /*
   * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function sin(x) {
        return new this(x).sin();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function sinh(x) {
        return new this(x).sinh();
    }
    /*
   * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */ function sqrt(x) {
        return new this(x).sqrt();
    }
    /*
   * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */ function sub(x, y) {
        return new this(x).sub(y);
    }
    /*
   * Return a new Decimal whose value is the sum of the arguments, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * Only the result is rounded, not the intermediate calculations.
   *
   * arguments {number|string|Decimal}
   *
   */ function sum() {
        var i = 0, args = arguments, x = new this(args[i]);
        external = false;
        for(; x.s && ++i < args.length;)x = x.plus(args[i]);
        external = true;
        return finalise(x, this.precision, this.rounding);
    }
    /*
   * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function tan(x) {
        return new this(x).tan();
    }
    /*
   * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */ function tanh(x) {
        return new this(x).tanh();
    }
    /*
   * Return a new Decimal whose value is `x` truncated to an integer.
   *
   * x {number|string|Decimal}
   *
   */ function trunc(x) {
        return finalise(x = new this(x), x.e + 1, 1);
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(DEFAULTS);
    Decimal.prototype.constructor = Decimal;
    Decimal["default"] = Decimal.Decimal = Decimal;
    // Create the internal constants from their string values.
    LN10 = new Decimal(LN10);
    PI = new Decimal(PI);
    // Export.
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return Decimal;
    });
    else if (0, module.exports) {
        if (typeof Symbol == "function" && typeof Symbol.iterator == "symbol") {
            P[Symbol["for"]("nodejs.util.inspect.custom")] = P.toString;
            P[Symbol.toStringTag] = "Decimal";
        }
        module.exports = Decimal;
    // Browser.
    } else {
        if (!globalScope) globalScope = typeof self != "undefined" && self && self.self == self ? self : window;
        noConflict = globalScope.Decimal;
        Decimal.noConflict = function() {
            globalScope.Decimal = noConflict;
            return Decimal;
        };
        globalScope.Decimal = Decimal;
    }
})(module.exports);

});


parcelRegister("flD7D", function(module, exports) {

var $aqbQf = parcelRequire("aqbQf");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFromEnv = void 0;

var $6lD4c = parcelRequire("6lD4c");
const $b2c72a0476cccaf4$var$getFromEnv = (name, schema, parseAsJSON = !!schema)=>{
    const envValue = $aqbQf.env[name];
    let envValueParsed = envValue;
    if (parseAsJSON && envValue) try {
        envValueParsed = JSON.parse(envValue);
    } catch (e) {}
    try {
        return (schema !== null && schema !== void 0 ? schema : $6lD4c.z.string()).parse(envValueParsed);
    } catch (e) {
        console.log(`failed to parse ${name} env variable, value ${envValue}`);
        throw new Error(`failed to parse ${name} env variable`, {
            cause: e
        });
    }
};
module.exports.getFromEnv = $b2c72a0476cccaf4$var$getFromEnv;

});
parcelRegister("6lD4c", function(module, exports) {

$parcel$export(module.exports, "z", function () { return $bc80ebcf21bfccd0$export$2e2bcd8739ae039; });
var $bc80ebcf21bfccd0$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($bc80ebcf21bfccd0$export$7debb50ef11d5e0b || ($bc80ebcf21bfccd0$export$7debb50ef11d5e0b = {}));
var $bc80ebcf21bfccd0$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($bc80ebcf21bfccd0$export$4aa2142c225fd5c7 || ($bc80ebcf21bfccd0$export$4aa2142c225fd5c7 = {}));
const $bc80ebcf21bfccd0$export$5716da67bfaa244d = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $bc80ebcf21bfccd0$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined;
        case "string":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $bc80ebcf21bfccd0$export$5716da67bfaa244d.nan : $bc80ebcf21bfccd0$export$5716da67bfaa244d.number;
        case "boolean":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.boolean;
        case "function":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.function;
        case "bigint":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $bc80ebcf21bfccd0$export$5716da67bfaa244d.array;
            if (data === null) return $bc80ebcf21bfccd0$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $bc80ebcf21bfccd0$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $bc80ebcf21bfccd0$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $bc80ebcf21bfccd0$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $bc80ebcf21bfccd0$export$5716da67bfaa244d.date;
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.object;
        default:
            return $bc80ebcf21bfccd0$export$5716da67bfaa244d.unknown;
    }
};
const $bc80ebcf21bfccd0$export$5ba560653e4a1035 = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $bc80ebcf21bfccd0$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $bc80ebcf21bfccd0$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $bc80ebcf21bfccd0$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
}
$bc80ebcf21bfccd0$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $bc80ebcf21bfccd0$export$f98dac4b251ab333(issues);
    return error;
};
const $bc80ebcf21bfccd0$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$bc80ebcf21bfccd0$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$bc80ebcf21bfccd0$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$bc80ebcf21bfccd0$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $bc80ebcf21bfccd0$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $bc80ebcf21bfccd0$var$overrideErrorMap = $bc80ebcf21bfccd0$export$341b0b6e0a6f5099;
function $bc80ebcf21bfccd0$export$1097a8289cfd22d7(map) {
    $bc80ebcf21bfccd0$var$overrideErrorMap = map;
}
function $bc80ebcf21bfccd0$export$32f27c719778d4c4() {
    return $bc80ebcf21bfccd0$var$overrideErrorMap;
}
const $bc80ebcf21bfccd0$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $bc80ebcf21bfccd0$export$1526d2e05f74572 = [];
function $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $bc80ebcf21bfccd0$export$32f27c719778d4c4();
    const issue = $bc80ebcf21bfccd0$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $bc80ebcf21bfccd0$export$341b0b6e0a6f5099 ? undefined : $bc80ebcf21bfccd0$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f {
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
    constructor(){
        this.value = "valid";
    }
}
const $bc80ebcf21bfccd0$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $bc80ebcf21bfccd0$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $bc80ebcf21bfccd0$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $bc80ebcf21bfccd0$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $bc80ebcf21bfccd0$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $bc80ebcf21bfccd0$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $bc80ebcf21bfccd0$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $bc80ebcf21bfccd0$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $bc80ebcf21bfccd0$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $bc80ebcf21bfccd0$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($bc80ebcf21bfccd0$var$errorUtil || ($bc80ebcf21bfccd0$var$errorUtil = {}));
var $bc80ebcf21bfccd0$var$_ZodEnum_cache, $bc80ebcf21bfccd0$var$_ZodNativeEnum_cache;
class $bc80ebcf21bfccd0$var$ParseInputLazyPath {
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
}
const $bc80ebcf21bfccd0$var$handleResult = (ctx, result)=>{
    if ($bc80ebcf21bfccd0$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $bc80ebcf21bfccd0$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $bc80ebcf21bfccd0$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($bc80ebcf21bfccd0$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $bc80ebcf21bfccd0$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($bc80ebcf21bfccd0$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $bc80ebcf21bfccd0$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $bc80ebcf21bfccd0$export$a60af00cc0ce2582({
            schema: this,
            typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $bc80ebcf21bfccd0$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $bc80ebcf21bfccd0$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $bc80ebcf21bfccd0$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $bc80ebcf21bfccd0$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $bc80ebcf21bfccd0$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $bc80ebcf21bfccd0$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $bc80ebcf21bfccd0$export$a60af00cc0ce2582({
            ...$bc80ebcf21bfccd0$var$processCreateParams(this._def),
            schema: this,
            typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $bc80ebcf21bfccd0$export$bb19b37874861e7e({
            ...$bc80ebcf21bfccd0$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $bc80ebcf21bfccd0$export$66b0c798a395271f({
            typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$bc80ebcf21bfccd0$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $bc80ebcf21bfccd0$export$75a44ec6249ac76b({
            ...$bc80ebcf21bfccd0$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $bc80ebcf21bfccd0$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $bc80ebcf21bfccd0$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
}
const $bc80ebcf21bfccd0$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $bc80ebcf21bfccd0$var$cuid2Regex = /^[0-9a-z]+$/;
const $bc80ebcf21bfccd0$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $bc80ebcf21bfccd0$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $bc80ebcf21bfccd0$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $bc80ebcf21bfccd0$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $bc80ebcf21bfccd0$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $bc80ebcf21bfccd0$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $bc80ebcf21bfccd0$var$emojiRegex;
// faster, simpler, safer
const $bc80ebcf21bfccd0$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $bc80ebcf21bfccd0$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $bc80ebcf21bfccd0$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $bc80ebcf21bfccd0$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $bc80ebcf21bfccd0$var$dateRegex = new RegExp(`^${$bc80ebcf21bfccd0$var$dateRegexSource}$`);
function $bc80ebcf21bfccd0$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $bc80ebcf21bfccd0$var$timeRegex(args) {
    return new RegExp(`^${$bc80ebcf21bfccd0$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $bc80ebcf21bfccd0$export$a4b563879add27a(args) {
    let regex = `${$bc80ebcf21bfccd0$var$dateRegexSource}T${$bc80ebcf21bfccd0$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $bc80ebcf21bfccd0$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $bc80ebcf21bfccd0$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $bc80ebcf21bfccd0$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $bc80ebcf21bfccd0$export$1230eb29b8d3b502 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        const status = new $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$bc80ebcf21bfccd0$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$bc80ebcf21bfccd0$var$emojiRegex) $bc80ebcf21bfccd0$var$emojiRegex = new RegExp($bc80ebcf21bfccd0$var$_emojiRegex, "u");
                if (!$bc80ebcf21bfccd0$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$bc80ebcf21bfccd0$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$bc80ebcf21bfccd0$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$bc80ebcf21bfccd0$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$bc80ebcf21bfccd0$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$bc80ebcf21bfccd0$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $bc80ebcf21bfccd0$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $bc80ebcf21bfccd0$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $bc80ebcf21bfccd0$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$bc80ebcf21bfccd0$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$bc80ebcf21bfccd0$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$bc80ebcf21bfccd0$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_string,
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $bc80ebcf21bfccd0$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$bc80ebcf21bfccd0$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $bc80ebcf21bfccd0$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $bc80ebcf21bfccd0$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $bc80ebcf21bfccd0$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $bc80ebcf21bfccd0$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$bc80ebcf21bfccd0$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $bc80ebcf21bfccd0$export$1230eb29b8d3b502({
        checks: [],
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $bc80ebcf21bfccd0$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $bc80ebcf21bfccd0$export$5b070a55c0c43e09 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$bc80ebcf21bfccd0$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($bc80ebcf21bfccd0$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $bc80ebcf21bfccd0$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $bc80ebcf21bfccd0$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
}
$bc80ebcf21bfccd0$export$5b070a55c0c43e09.create = (params)=>{
    return new $bc80ebcf21bfccd0$export$5b070a55c0c43e09({
        checks: [],
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$67d741fd70ff98f4 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $bc80ebcf21bfccd0$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $bc80ebcf21bfccd0$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $bc80ebcf21bfccd0$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
}
$bc80ebcf21bfccd0$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $bc80ebcf21bfccd0$export$67d741fd70ff98f4({
        checks: [],
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$723d146f80596191 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
    }
}
$bc80ebcf21bfccd0$export$723d146f80596191.create = (params)=>{
    return new $bc80ebcf21bfccd0$export$723d146f80596191({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$e974be33bdc55521 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_date
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        const status = new $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $bc80ebcf21bfccd0$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$bc80ebcf21bfccd0$export$e974be33bdc55521.create = (params)=>{
    return new $bc80ebcf21bfccd0$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodDate,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$bcc3b40f6b638044 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
    }
}
$bc80ebcf21bfccd0$export$bcc3b40f6b638044.create = (params)=>{
    return new $bc80ebcf21bfccd0$export$bcc3b40f6b638044({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodSymbol,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$4e780e961c30340d extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
    }
}
$bc80ebcf21bfccd0$export$4e780e961c30340d.create = (params)=>{
    return new $bc80ebcf21bfccd0$export$4e780e961c30340d({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodUndefined,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$a96281f914484f2d extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
    }
}
$bc80ebcf21bfccd0$export$a96281f914484f2d.create = (params)=>{
    return new $bc80ebcf21bfccd0$export$a96281f914484f2d({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNull,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
}
$bc80ebcf21bfccd0$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodAny,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$ef3b1bb1630977ae extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
}
$bc80ebcf21bfccd0$export$ef3b1bb1630977ae.create = (params)=>{
    return new $bc80ebcf21bfccd0$export$ef3b1bb1630977ae({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodUnknown,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
            code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
            expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
    }
}
$bc80ebcf21bfccd0$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNever,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$7d39f5df85f21031 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
    }
}
$bc80ebcf21bfccd0$export$7d39f5df85f21031.create = (params)=>{
    return new $bc80ebcf21bfccd0$export$7d39f5df85f21031({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodVoid,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$7acfc3e64785411 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.array) {
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big : $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $bc80ebcf21bfccd0$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $bc80ebcf21bfccd0$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $bc80ebcf21bfccd0$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$bc80ebcf21bfccd0$export$7acfc3e64785411.create = (schema, params)=>{
    return new $bc80ebcf21bfccd0$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodArray,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
function $bc80ebcf21bfccd0$var$deepPartialify(schema) {
    if (schema instanceof $bc80ebcf21bfccd0$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $bc80ebcf21bfccd0$export$aa56fec1e9d629b8.create($bc80ebcf21bfccd0$var$deepPartialify(fieldSchema));
        }
        return new $bc80ebcf21bfccd0$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $bc80ebcf21bfccd0$export$7acfc3e64785411) return new $bc80ebcf21bfccd0$export$7acfc3e64785411({
        ...schema._def,
        type: $bc80ebcf21bfccd0$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $bc80ebcf21bfccd0$export$aa56fec1e9d629b8) return $bc80ebcf21bfccd0$export$aa56fec1e9d629b8.create($bc80ebcf21bfccd0$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $bc80ebcf21bfccd0$export$aaac0b8b429cef5) return $bc80ebcf21bfccd0$export$aaac0b8b429cef5.create($bc80ebcf21bfccd0$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3) return $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$bc80ebcf21bfccd0$var$deepPartialify(item)));
    else return schema;
}
class $bc80ebcf21bfccd0$export$736315c5b55efbad extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                        code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $bc80ebcf21bfccd0$var$errorUtil.errToObj;
        return new $bc80ebcf21bfccd0$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $bc80ebcf21bfccd0$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $bc80ebcf21bfccd0$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $bc80ebcf21bfccd0$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $bc80ebcf21bfccd0$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $bc80ebcf21bfccd0$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $bc80ebcf21bfccd0$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $bc80ebcf21bfccd0$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $bc80ebcf21bfccd0$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $bc80ebcf21bfccd0$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $bc80ebcf21bfccd0$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $bc80ebcf21bfccd0$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $bc80ebcf21bfccd0$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $bc80ebcf21bfccd0$var$createZodEnum($bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
}
$bc80ebcf21bfccd0$export$736315c5b55efbad.create = (shape, params)=>{
    return new $bc80ebcf21bfccd0$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5.create(),
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodObject,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
$bc80ebcf21bfccd0$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $bc80ebcf21bfccd0$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5.create(),
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodObject,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
$bc80ebcf21bfccd0$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $bc80ebcf21bfccd0$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5.create(),
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodObject,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$a8b236cb5070a311 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $bc80ebcf21bfccd0$export$f98dac4b251ab333(result.ctx.common.issues));
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $bc80ebcf21bfccd0$export$f98dac4b251ab333(issues));
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$bc80ebcf21bfccd0$export$a8b236cb5070a311.create = (types, params)=>{
    return new $bc80ebcf21bfccd0$export$a8b236cb5070a311({
        options: types,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodUnion,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $bc80ebcf21bfccd0$var$getDiscriminator = (type)=>{
    if (type instanceof $bc80ebcf21bfccd0$export$378d0cfce37406e6) return $bc80ebcf21bfccd0$var$getDiscriminator(type.schema);
    else if (type instanceof $bc80ebcf21bfccd0$export$a60af00cc0ce2582) return $bc80ebcf21bfccd0$var$getDiscriminator(type.innerType());
    else if (type instanceof $bc80ebcf21bfccd0$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $bc80ebcf21bfccd0$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $bc80ebcf21bfccd0$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $bc80ebcf21bfccd0$export$bb19b37874861e7e) return $bc80ebcf21bfccd0$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $bc80ebcf21bfccd0$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $bc80ebcf21bfccd0$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $bc80ebcf21bfccd0$export$aa56fec1e9d629b8) return [
        undefined,
        ...$bc80ebcf21bfccd0$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $bc80ebcf21bfccd0$export$aaac0b8b429cef5) return [
        null,
        ...$bc80ebcf21bfccd0$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $bc80ebcf21bfccd0$export$66b0c798a395271f) return $bc80ebcf21bfccd0$var$getDiscriminator(type.unwrap());
    else if (type instanceof $bc80ebcf21bfccd0$export$5d1f7ef05c4e493a) return $bc80ebcf21bfccd0$var$getDiscriminator(type.unwrap());
    else if (type instanceof $bc80ebcf21bfccd0$export$75a44ec6249ac76b) return $bc80ebcf21bfccd0$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $bc80ebcf21bfccd0$export$5ef2424805ac76a3 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.object) {
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $bc80ebcf21bfccd0$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $bc80ebcf21bfccd0$export$5ef2424805ac76a3({
            typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$bc80ebcf21bfccd0$var$processCreateParams(params)
        });
    }
}
function $bc80ebcf21bfccd0$var$mergeValues(a, b) {
    const aType = $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(a);
    const bType = $bc80ebcf21bfccd0$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.object && bType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.object) {
        const bKeys = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $bc80ebcf21bfccd0$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.array && bType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $bc80ebcf21bfccd0$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.date && bType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $bc80ebcf21bfccd0$export$c02deaf0bb5203d4 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($bc80ebcf21bfccd0$export$afa861e3c5730743(parsedLeft) || $bc80ebcf21bfccd0$export$afa861e3c5730743(parsedRight)) return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
            const merged = $bc80ebcf21bfccd0$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
            }
            if ($bc80ebcf21bfccd0$export$910b6cdd390341b3(parsedLeft) || $bc80ebcf21bfccd0$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$bc80ebcf21bfccd0$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $bc80ebcf21bfccd0$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodIntersection,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.array) {
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$bc80ebcf21bfccd0$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$a2acc09968cb4b7f extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.object) {
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $bc80ebcf21bfccd0$export$19342e026b58ebb7) return new $bc80ebcf21bfccd0$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodRecord,
            ...$bc80ebcf21bfccd0$var$processCreateParams(third)
        });
        return new $bc80ebcf21bfccd0$export$a2acc09968cb4b7f({
            keyType: $bc80ebcf21bfccd0$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodRecord,
            ...$bc80ebcf21bfccd0$var$processCreateParams(second)
        });
    }
}
class $bc80ebcf21bfccd0$export$163b6a2b712d9542 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.map) {
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$bc80ebcf21bfccd0$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $bc80ebcf21bfccd0$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodMap,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$977057706f816712 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.set) {
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $bc80ebcf21bfccd0$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $bc80ebcf21bfccd0$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $bc80ebcf21bfccd0$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $bc80ebcf21bfccd0$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$bc80ebcf21bfccd0$export$977057706f816712.create = (valueType, params)=>{
    return new $bc80ebcf21bfccd0$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodSet,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$d4602ba55673f53c extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.function) {
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $bc80ebcf21bfccd0$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $bc80ebcf21bfccd0$export$32f27c719778d4c4(),
                    $bc80ebcf21bfccd0$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $bc80ebcf21bfccd0$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $bc80ebcf21bfccd0$export$32f27c719778d4c4(),
                    $bc80ebcf21bfccd0$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $bc80ebcf21bfccd0$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $bc80ebcf21bfccd0$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $bc80ebcf21bfccd0$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $bc80ebcf21bfccd0$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $bc80ebcf21bfccd0$export$d4602ba55673f53c({
            ...this._def,
            args: $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3.create(items).rest($bc80ebcf21bfccd0$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $bc80ebcf21bfccd0$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $bc80ebcf21bfccd0$export$d4602ba55673f53c({
            args: args ? args : $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3.create([]).rest($bc80ebcf21bfccd0$export$ef3b1bb1630977ae.create()),
            returns: returns || $bc80ebcf21bfccd0$export$ef3b1bb1630977ae.create(),
            typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodFunction,
            ...$bc80ebcf21bfccd0$var$processCreateParams(params)
        });
    }
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
}
class $bc80ebcf21bfccd0$export$378d0cfce37406e6 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$bc80ebcf21bfccd0$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $bc80ebcf21bfccd0$export$378d0cfce37406e6({
        getter: getter,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodLazy,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$7e44096782a165d3 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$bc80ebcf21bfccd0$export$7e44096782a165d3.create = (value, params)=>{
    return new $bc80ebcf21bfccd0$export$7e44096782a165d3({
        value: value,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodLiteral,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
function $bc80ebcf21bfccd0$var$createZodEnum(values, params) {
    return new $bc80ebcf21bfccd0$export$d325d1f0e1c20179({
        values: values,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEnum,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
}
class $bc80ebcf21bfccd0$export$d325d1f0e1c20179 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                expected: $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        if (!$bc80ebcf21bfccd0$var$__classPrivateFieldGet(this, $bc80ebcf21bfccd0$var$_ZodEnum_cache, "f")) $bc80ebcf21bfccd0$var$__classPrivateFieldSet(this, $bc80ebcf21bfccd0$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$bc80ebcf21bfccd0$var$__classPrivateFieldGet(this, $bc80ebcf21bfccd0$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $bc80ebcf21bfccd0$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $bc80ebcf21bfccd0$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
    constructor(){
        super(...arguments);
        $bc80ebcf21bfccd0$var$_ZodEnum_cache.set(this, void 0);
    }
}
$bc80ebcf21bfccd0$var$_ZodEnum_cache = new WeakMap();
$bc80ebcf21bfccd0$export$d325d1f0e1c20179.create = $bc80ebcf21bfccd0$var$createZodEnum;
class $bc80ebcf21bfccd0$export$370b2e8d6d6f5c56 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.string && ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.number) {
            const expectedValues = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                expected: $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        if (!$bc80ebcf21bfccd0$var$__classPrivateFieldGet(this, $bc80ebcf21bfccd0$var$_ZodNativeEnum_cache, "f")) $bc80ebcf21bfccd0$var$__classPrivateFieldSet(this, $bc80ebcf21bfccd0$var$_ZodNativeEnum_cache, new Set($bc80ebcf21bfccd0$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$bc80ebcf21bfccd0$var$__classPrivateFieldGet(this, $bc80ebcf21bfccd0$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
    constructor(){
        super(...arguments);
        $bc80ebcf21bfccd0$var$_ZodNativeEnum_cache.set(this, void 0);
    }
}
$bc80ebcf21bfccd0$var$_ZodNativeEnum_cache = new WeakMap();
$bc80ebcf21bfccd0$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $bc80ebcf21bfccd0$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNativeEnum,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$3f196b0127d6e50a extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$bc80ebcf21bfccd0$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $bc80ebcf21bfccd0$export$3f196b0127d6e50a({
        type: schema,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodPromise,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$a60af00cc0ce2582 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $bc80ebcf21bfccd0$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $bc80ebcf21bfccd0$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $bc80ebcf21bfccd0$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $bc80ebcf21bfccd0$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$bc80ebcf21bfccd0$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$bc80ebcf21bfccd0$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $bc80ebcf21bfccd0$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$bc80ebcf21bfccd0$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $bc80ebcf21bfccd0$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
$bc80ebcf21bfccd0$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $bc80ebcf21bfccd0$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodEffects,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$aa56fec1e9d629b8 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined) return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$bc80ebcf21bfccd0$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $bc80ebcf21bfccd0$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodOptional,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$aaac0b8b429cef5 extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.null) return $bc80ebcf21bfccd0$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$bc80ebcf21bfccd0$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $bc80ebcf21bfccd0$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNullable,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$bb19b37874861e7e extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $bc80ebcf21bfccd0$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$bc80ebcf21bfccd0$export$bb19b37874861e7e.create = (type, params)=>{
    return new $bc80ebcf21bfccd0$export$bb19b37874861e7e({
        innerType: type,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$75a44ec6249ac76b extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($bc80ebcf21bfccd0$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $bc80ebcf21bfccd0$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $bc80ebcf21bfccd0$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$bc80ebcf21bfccd0$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $bc80ebcf21bfccd0$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
class $bc80ebcf21bfccd0$export$26ccfa0145e8511f extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $bc80ebcf21bfccd0$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $bc80ebcf21bfccd0$export$db7caee60e5d514d(ctx, {
                code: $bc80ebcf21bfccd0$export$5ba560653e4a1035.invalid_type,
                expected: $bc80ebcf21bfccd0$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$bc80ebcf21bfccd0$export$26ccfa0145e8511f.create = (params)=>{
    return new $bc80ebcf21bfccd0$export$26ccfa0145e8511f({
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodNaN,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
const $bc80ebcf21bfccd0$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $bc80ebcf21bfccd0$export$66b0c798a395271f extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $bc80ebcf21bfccd0$export$a3c3ef8a0e95c6da extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $bc80ebcf21bfccd0$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $bc80ebcf21bfccd0$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $bc80ebcf21bfccd0$export$5d1f7ef05c4e493a extends $bc80ebcf21bfccd0$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($bc80ebcf21bfccd0$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $bc80ebcf21bfccd0$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$bc80ebcf21bfccd0$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $bc80ebcf21bfccd0$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $bc80ebcf21bfccd0$export$558106ce543bd011.ZodReadonly,
        ...$bc80ebcf21bfccd0$var$processCreateParams(params)
    });
};
function $bc80ebcf21bfccd0$export$4c00f665f0d4b443(check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb.create();
}
const $bc80ebcf21bfccd0$export$1ee8ee30835eab8b = {
    object: $bc80ebcf21bfccd0$export$736315c5b55efbad.lazycreate
};
var $bc80ebcf21bfccd0$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($bc80ebcf21bfccd0$export$558106ce543bd011 || ($bc80ebcf21bfccd0$export$558106ce543bd011 = {}));
const $bc80ebcf21bfccd0$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$bc80ebcf21bfccd0$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $bc80ebcf21bfccd0$export$22b082955e083ec3 = $bc80ebcf21bfccd0$export$1230eb29b8d3b502.create;
const $bc80ebcf21bfccd0$export$98e628dec113755e = $bc80ebcf21bfccd0$export$5b070a55c0c43e09.create;
const $bc80ebcf21bfccd0$export$9e06de0973666692 = $bc80ebcf21bfccd0$export$26ccfa0145e8511f.create;
const $bc80ebcf21bfccd0$export$a0f65b52274bcc00 = $bc80ebcf21bfccd0$export$67d741fd70ff98f4.create;
const $bc80ebcf21bfccd0$export$4a21f16c33752377 = $bc80ebcf21bfccd0$export$723d146f80596191.create;
const $bc80ebcf21bfccd0$export$324d90190a8b822a = $bc80ebcf21bfccd0$export$e974be33bdc55521.create;
const $bc80ebcf21bfccd0$export$8f701197936bc2a6 = $bc80ebcf21bfccd0$export$bcc3b40f6b638044.create;
const $bc80ebcf21bfccd0$export$1db45310990710a5 = $bc80ebcf21bfccd0$export$4e780e961c30340d.create;
const $bc80ebcf21bfccd0$export$7b1b591b262c240 = $bc80ebcf21bfccd0$export$a96281f914484f2d.create;
const $bc80ebcf21bfccd0$export$4154a199d7d90455 = $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb.create;
const $bc80ebcf21bfccd0$export$19282c40b967aec6 = $bc80ebcf21bfccd0$export$ef3b1bb1630977ae.create;
const $bc80ebcf21bfccd0$export$b3e22bcfd64c1022 = $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5.create;
const $bc80ebcf21bfccd0$export$490e536ee7389aeb = $bc80ebcf21bfccd0$export$7d39f5df85f21031.create;
const $bc80ebcf21bfccd0$export$2f23118c22fb2630 = $bc80ebcf21bfccd0$export$7acfc3e64785411.create;
const $bc80ebcf21bfccd0$export$be5493f9613cbbe = $bc80ebcf21bfccd0$export$736315c5b55efbad.create;
const $bc80ebcf21bfccd0$export$8fb0df5f40d0b477 = $bc80ebcf21bfccd0$export$736315c5b55efbad.strictCreate;
const $bc80ebcf21bfccd0$export$971dd5b0dfd021b6 = $bc80ebcf21bfccd0$export$a8b236cb5070a311.create;
const $bc80ebcf21bfccd0$export$4b888e40c4ee26dd = $bc80ebcf21bfccd0$export$5ef2424805ac76a3.create;
const $bc80ebcf21bfccd0$export$bc86dfbf7795668c = $bc80ebcf21bfccd0$export$c02deaf0bb5203d4.create;
const $bc80ebcf21bfccd0$export$65e3907585753458 = $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3.create;
const $bc80ebcf21bfccd0$export$e5185e241753e543 = $bc80ebcf21bfccd0$export$a2acc09968cb4b7f.create;
const $bc80ebcf21bfccd0$export$871de8747c9eaa88 = $bc80ebcf21bfccd0$export$163b6a2b712d9542.create;
const $bc80ebcf21bfccd0$export$adaa4cf7ef1b65be = $bc80ebcf21bfccd0$export$977057706f816712.create;
const $bc80ebcf21bfccd0$export$44e51c8aac7c2deb = $bc80ebcf21bfccd0$export$d4602ba55673f53c.create;
const $bc80ebcf21bfccd0$export$488013bae63b21da = $bc80ebcf21bfccd0$export$378d0cfce37406e6.create;
const $bc80ebcf21bfccd0$export$c8ec6e1ec9fefcb0 = $bc80ebcf21bfccd0$export$7e44096782a165d3.create;
const $bc80ebcf21bfccd0$export$78a99c8d44d72635 = $bc80ebcf21bfccd0$export$d325d1f0e1c20179.create;
const $bc80ebcf21bfccd0$export$6fe7eca19ebe5199 = $bc80ebcf21bfccd0$export$370b2e8d6d6f5c56.create;
const $bc80ebcf21bfccd0$export$c957ef27a0ebfd4 = $bc80ebcf21bfccd0$export$3f196b0127d6e50a.create;
const $bc80ebcf21bfccd0$export$dc573d8a6576cdb3 = $bc80ebcf21bfccd0$export$a60af00cc0ce2582.create;
const $bc80ebcf21bfccd0$export$516e28dec6a4b6d4 = $bc80ebcf21bfccd0$export$aa56fec1e9d629b8.create;
const $bc80ebcf21bfccd0$export$133fc36489ac9add = $bc80ebcf21bfccd0$export$aaac0b8b429cef5.create;
const $bc80ebcf21bfccd0$export$fc37fe19dfda43ee = $bc80ebcf21bfccd0$export$a60af00cc0ce2582.createWithPreprocess;
const $bc80ebcf21bfccd0$export$43f28b24e1eb8181 = $bc80ebcf21bfccd0$export$a3c3ef8a0e95c6da.create;
const $bc80ebcf21bfccd0$export$3b3d07727c5b702c = ()=>$bc80ebcf21bfccd0$export$22b082955e083ec3().optional();
const $bc80ebcf21bfccd0$export$eb150471a61fced6 = ()=>$bc80ebcf21bfccd0$export$98e628dec113755e().optional();
const $bc80ebcf21bfccd0$export$269251733cdcbbf1 = ()=>$bc80ebcf21bfccd0$export$4a21f16c33752377().optional();
const $bc80ebcf21bfccd0$export$8c14e57e778d3873 = {
    string: (arg)=>$bc80ebcf21bfccd0$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$bc80ebcf21bfccd0$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$bc80ebcf21bfccd0$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$bc80ebcf21bfccd0$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$bc80ebcf21bfccd0$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $bc80ebcf21bfccd0$export$96c94437c95d7862 = $bc80ebcf21bfccd0$export$9a105a556e65c2c0;
var $bc80ebcf21bfccd0$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $bc80ebcf21bfccd0$export$341b0b6e0a6f5099,
    setErrorMap: $bc80ebcf21bfccd0$export$1097a8289cfd22d7,
    getErrorMap: $bc80ebcf21bfccd0$export$32f27c719778d4c4,
    makeIssue: $bc80ebcf21bfccd0$export$244a85fde9c419ed,
    EMPTY_PATH: $bc80ebcf21bfccd0$export$1526d2e05f74572,
    addIssueToContext: $bc80ebcf21bfccd0$export$db7caee60e5d514d,
    ParseStatus: $bc80ebcf21bfccd0$export$5b20a5c3d05c1f6f,
    INVALID: $bc80ebcf21bfccd0$export$9a105a556e65c2c0,
    DIRTY: $bc80ebcf21bfccd0$export$325a211da9693fcf,
    OK: $bc80ebcf21bfccd0$export$c6813a8d51f77eaf,
    isAborted: $bc80ebcf21bfccd0$export$afa861e3c5730743,
    isDirty: $bc80ebcf21bfccd0$export$910b6cdd390341b3,
    isValid: $bc80ebcf21bfccd0$export$1ea939691cdc45b8,
    isAsync: $bc80ebcf21bfccd0$export$aefee5ebe1dcfd9e,
    get util () {
        return $bc80ebcf21bfccd0$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $bc80ebcf21bfccd0$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $bc80ebcf21bfccd0$export$5716da67bfaa244d,
    getParsedType: $bc80ebcf21bfccd0$export$3e9057828ebd5c7a,
    ZodType: $bc80ebcf21bfccd0$export$19342e026b58ebb7,
    datetimeRegex: $bc80ebcf21bfccd0$export$a4b563879add27a,
    ZodString: $bc80ebcf21bfccd0$export$1230eb29b8d3b502,
    ZodNumber: $bc80ebcf21bfccd0$export$5b070a55c0c43e09,
    ZodBigInt: $bc80ebcf21bfccd0$export$67d741fd70ff98f4,
    ZodBoolean: $bc80ebcf21bfccd0$export$723d146f80596191,
    ZodDate: $bc80ebcf21bfccd0$export$e974be33bdc55521,
    ZodSymbol: $bc80ebcf21bfccd0$export$bcc3b40f6b638044,
    ZodUndefined: $bc80ebcf21bfccd0$export$4e780e961c30340d,
    ZodNull: $bc80ebcf21bfccd0$export$a96281f914484f2d,
    ZodAny: $bc80ebcf21bfccd0$export$b9d1edb536b4e4eb,
    ZodUnknown: $bc80ebcf21bfccd0$export$ef3b1bb1630977ae,
    ZodNever: $bc80ebcf21bfccd0$export$1e576a20c3ce9fb5,
    ZodVoid: $bc80ebcf21bfccd0$export$7d39f5df85f21031,
    ZodArray: $bc80ebcf21bfccd0$export$7acfc3e64785411,
    ZodObject: $bc80ebcf21bfccd0$export$736315c5b55efbad,
    ZodUnion: $bc80ebcf21bfccd0$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $bc80ebcf21bfccd0$export$5ef2424805ac76a3,
    ZodIntersection: $bc80ebcf21bfccd0$export$c02deaf0bb5203d4,
    ZodTuple: $bc80ebcf21bfccd0$export$e2a18bb771d8e6a3,
    ZodRecord: $bc80ebcf21bfccd0$export$a2acc09968cb4b7f,
    ZodMap: $bc80ebcf21bfccd0$export$163b6a2b712d9542,
    ZodSet: $bc80ebcf21bfccd0$export$977057706f816712,
    ZodFunction: $bc80ebcf21bfccd0$export$d4602ba55673f53c,
    ZodLazy: $bc80ebcf21bfccd0$export$378d0cfce37406e6,
    ZodLiteral: $bc80ebcf21bfccd0$export$7e44096782a165d3,
    ZodEnum: $bc80ebcf21bfccd0$export$d325d1f0e1c20179,
    ZodNativeEnum: $bc80ebcf21bfccd0$export$370b2e8d6d6f5c56,
    ZodPromise: $bc80ebcf21bfccd0$export$3f196b0127d6e50a,
    ZodEffects: $bc80ebcf21bfccd0$export$a60af00cc0ce2582,
    ZodTransformer: $bc80ebcf21bfccd0$export$a60af00cc0ce2582,
    ZodOptional: $bc80ebcf21bfccd0$export$aa56fec1e9d629b8,
    ZodNullable: $bc80ebcf21bfccd0$export$aaac0b8b429cef5,
    ZodDefault: $bc80ebcf21bfccd0$export$bb19b37874861e7e,
    ZodCatch: $bc80ebcf21bfccd0$export$75a44ec6249ac76b,
    ZodNaN: $bc80ebcf21bfccd0$export$26ccfa0145e8511f,
    BRAND: $bc80ebcf21bfccd0$export$cf2deea74cde46b4,
    ZodBranded: $bc80ebcf21bfccd0$export$66b0c798a395271f,
    ZodPipeline: $bc80ebcf21bfccd0$export$a3c3ef8a0e95c6da,
    ZodReadonly: $bc80ebcf21bfccd0$export$5d1f7ef05c4e493a,
    custom: $bc80ebcf21bfccd0$export$4c00f665f0d4b443,
    Schema: $bc80ebcf21bfccd0$export$19342e026b58ebb7,
    ZodSchema: $bc80ebcf21bfccd0$export$19342e026b58ebb7,
    late: $bc80ebcf21bfccd0$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $bc80ebcf21bfccd0$export$558106ce543bd011;
    },
    coerce: $bc80ebcf21bfccd0$export$8c14e57e778d3873,
    any: $bc80ebcf21bfccd0$export$4154a199d7d90455,
    array: $bc80ebcf21bfccd0$export$2f23118c22fb2630,
    bigint: $bc80ebcf21bfccd0$export$a0f65b52274bcc00,
    boolean: $bc80ebcf21bfccd0$export$4a21f16c33752377,
    date: $bc80ebcf21bfccd0$export$324d90190a8b822a,
    discriminatedUnion: $bc80ebcf21bfccd0$export$4b888e40c4ee26dd,
    effect: $bc80ebcf21bfccd0$export$dc573d8a6576cdb3,
    "enum": $bc80ebcf21bfccd0$export$78a99c8d44d72635,
    "function": $bc80ebcf21bfccd0$export$44e51c8aac7c2deb,
    "instanceof": $bc80ebcf21bfccd0$export$3d916e7c22dbd8b5,
    intersection: $bc80ebcf21bfccd0$export$bc86dfbf7795668c,
    lazy: $bc80ebcf21bfccd0$export$488013bae63b21da,
    literal: $bc80ebcf21bfccd0$export$c8ec6e1ec9fefcb0,
    map: $bc80ebcf21bfccd0$export$871de8747c9eaa88,
    nan: $bc80ebcf21bfccd0$export$9e06de0973666692,
    nativeEnum: $bc80ebcf21bfccd0$export$6fe7eca19ebe5199,
    never: $bc80ebcf21bfccd0$export$b3e22bcfd64c1022,
    "null": $bc80ebcf21bfccd0$export$7b1b591b262c240,
    nullable: $bc80ebcf21bfccd0$export$133fc36489ac9add,
    number: $bc80ebcf21bfccd0$export$98e628dec113755e,
    object: $bc80ebcf21bfccd0$export$be5493f9613cbbe,
    oboolean: $bc80ebcf21bfccd0$export$269251733cdcbbf1,
    onumber: $bc80ebcf21bfccd0$export$eb150471a61fced6,
    optional: $bc80ebcf21bfccd0$export$516e28dec6a4b6d4,
    ostring: $bc80ebcf21bfccd0$export$3b3d07727c5b702c,
    pipeline: $bc80ebcf21bfccd0$export$43f28b24e1eb8181,
    preprocess: $bc80ebcf21bfccd0$export$fc37fe19dfda43ee,
    promise: $bc80ebcf21bfccd0$export$c957ef27a0ebfd4,
    record: $bc80ebcf21bfccd0$export$e5185e241753e543,
    set: $bc80ebcf21bfccd0$export$adaa4cf7ef1b65be,
    strictObject: $bc80ebcf21bfccd0$export$8fb0df5f40d0b477,
    string: $bc80ebcf21bfccd0$export$22b082955e083ec3,
    symbol: $bc80ebcf21bfccd0$export$8f701197936bc2a6,
    transformer: $bc80ebcf21bfccd0$export$dc573d8a6576cdb3,
    tuple: $bc80ebcf21bfccd0$export$65e3907585753458,
    "undefined": $bc80ebcf21bfccd0$export$1db45310990710a5,
    union: $bc80ebcf21bfccd0$export$971dd5b0dfd021b6,
    unknown: $bc80ebcf21bfccd0$export$19282c40b967aec6,
    "void": $bc80ebcf21bfccd0$export$490e536ee7389aeb,
    NEVER: $bc80ebcf21bfccd0$export$96c94437c95d7862,
    ZodIssueCode: $bc80ebcf21bfccd0$export$5ba560653e4a1035,
    quotelessJson: $bc80ebcf21bfccd0$export$913eddeaf297cfea,
    ZodError: $bc80ebcf21bfccd0$export$f98dac4b251ab333
});

});


parcelRegister("goUYX", function(module, exports) {
"use strict";
var $bf0b16b539f8ea05$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetchWithFallbacks = void 0;

const $bf0b16b539f8ea05$var$axios_1 = $bf0b16b539f8ea05$var$__importDefault((parcelRequire("28feZ")));
const $bf0b16b539f8ea05$var$fetchWithFallbacks = (args)=>{
    const requests = args.urls.map((url)=>$bf0b16b539f8ea05$var$axios_1.default.get(url, args.axiosConfig));
    return Promise.any(requests);
};
module.exports.fetchWithFallbacks = $bf0b16b539f8ea05$var$fetchWithFallbacks;

});

parcelRegister("hqUmi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.memoize = void 0;

var $d2Y3Q = parcelRequire("d2Y3Q");
const $cb10950ba20480b8$var$EXPECTED_MAX_CACHE_ENTRIES_PER_FN = 10000;
const $cb10950ba20480b8$var$EXPECTED_MAX_CACHE_KEY_LENGTH_PER_FN = 10000;
function $cb10950ba20480b8$var$memoize({ functionToMemoize: functionToMemoize, ttl: ttl, cacheKeyBuilder: cacheKeyBuilder = (...args)=>JSON.stringify(args) }) {
    const cache = {};
    return async (...args)=>{
        const cacheKey = await cacheKeyBuilder(...args);
        (0, $d2Y3Q.assertWithLog)(cacheKey.length < $cb10950ba20480b8$var$EXPECTED_MAX_CACHE_KEY_LENGTH_PER_FN, `Assumed cache key will not be longer than ${$cb10950ba20480b8$var$EXPECTED_MAX_CACHE_KEY_LENGTH_PER_FN}. Suspicious key ${cacheKey}`);
        $cb10950ba20480b8$var$cleanStaleCacheEntries(cache, ttl);
        if (!cache[cacheKey] || Date.now() - cache[cacheKey].lastSet > ttl) cache[cacheKey] = {
            lastSet: Date.now(),
            promise: functionToMemoize(...args).catch((err)=>{
                delete cache[cacheKey];
                throw err;
            })
        };
        return await cache[cacheKey].promise;
    };
}
module.exports.memoize = $cb10950ba20480b8$var$memoize;
const $cb10950ba20480b8$var$cleanStaleCacheEntries = (cache, ttl)=>{
    const now = Date.now();
    const cacheKeys = Object.keys(cache);
    (0, $d2Y3Q.assertWithLog)(cacheKeys.length < $cb10950ba20480b8$var$EXPECTED_MAX_CACHE_ENTRIES_PER_FN, `Assumed cache key space will not grow over ${$cb10950ba20480b8$var$EXPECTED_MAX_CACHE_ENTRIES_PER_FN} but is ${cacheKeys.length}`);
    if (cacheKeys.length > 1000) {
        for (const key of cacheKeys)if (now - cache[key].lastSet > ttl) delete cache[key];
    }
};

});

parcelRegister("2PgI4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zodAssert = void 0;
function $20ed4e6e997a5e85$var$zodAssert(schema, data) {
    const result = schema.safeParse(data);
    if (!result.success) throw new Error(`Zod validation error: ${result.error.toString()}`);
}
module.exports.zodAssert = $20ed4e6e997a5e85$var$zodAssert;

});

parcelRegister("9szYY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cloneClassInstance = void 0;
function $01c702a4dc3ae10b$var$cloneClassInstance(instance) {
    return Object.assign(Object.create(Object.getPrototypeOf(instance)), instance);
}
module.exports.cloneClassInstance = $01c702a4dc3ae10b$var$cloneClassInstance;

});

parcelRegister("35eh6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toSafeRecord = void 0;
const $23ece96eaf2cb402$var$toSafeRecord = (record, errorFn)=>new Proxy(record, {
        get: (target, p)=>{
            if (p === "then" || p === "toJSON") return target[p];
            else if (!Reflect.has(target, p) || target[p] === undefined) throw errorFn(p);
            return target[p];
        }
    });
module.exports.toSafeRecord = $23ece96eaf2cb402$var$toSafeRecord;

});


parcelRegister("emKzm", function(module, exports) {
"use strict";
var $a7573e79b92f917f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a7573e79b92f917f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a7573e79b92f917f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a7573e79b92f917f$var$__exportStar((parcelRequire("fowlm")), module.exports);

});
parcelRegister("fowlm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha256ToHex = void 0;

var $hbWVX = parcelRequire("hbWVX");
const $b3522fa8525bdf1f$var$sha256ToHex = (data)=>(0, $hbWVX.sha256)(data);
module.exports.sha256ToHex = $b3522fa8525bdf1f$var$sha256ToHex;

});


parcelRegister("9or5m", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
var $6d6b5d89cdd8fd41$var$__createBinding = undefined && undefined.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6d6b5d89cdd8fd41$var$__setModuleDefault = undefined && undefined.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $6d6b5d89cdd8fd41$var$__importStar = undefined && undefined.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6d6b5d89cdd8fd41$var$__createBinding(result, mod, k);
    }
    $6d6b5d89cdd8fd41$var$__setModuleDefault(result, mod);
    return result;
};
var $6d6b5d89cdd8fd41$var$__exportStar = undefined && undefined.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6d6b5d89cdd8fd41$var$__createBinding(exports1, m, p);
};
var $6d6b5d89cdd8fd41$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.weightedRandom = module.exports.filterOutliers = module.exports.PrecisionScaler = module.exports.getMedian = module.exports.calculateDeviationPercent = module.exports.calculateSum = module.exports.castToISafeNumber = void 0;

const $6d6b5d89cdd8fd41$var$decimal_js_1 = $6d6b5d89cdd8fd41$var$__importDefault((parcelRequire("4qPUL")));

var $gMArf = parcelRequire("gMArf");

const $6d6b5d89cdd8fd41$var$ISafeNumberMath = $6d6b5d89cdd8fd41$var$__importStar((parcelRequire("jgUgs")));


var $l6nB2 = parcelRequire("l6nB2");

$6d6b5d89cdd8fd41$var$__exportStar((parcelRequire("6rgxD")), module.exports);
const $6d6b5d89cdd8fd41$var$castToISafeNumber = (numberLike)=>{
    if (typeof numberLike === "string" || typeof numberLike === "number") return (0, (parcelRequire("jgUgs")).createSafeNumber)(numberLike.toString());
    else if (numberLike instanceof $6d6b5d89cdd8fd41$var$decimal_js_1.default) return (0, (parcelRequire("jgUgs")).createSafeNumber)(numberLike.toString());
    else if (numberLike instanceof $gMArf.BigNumber) return (0, (parcelRequire("jgUgs")).createSafeNumber)((0, $l6nB2.bignumberishToDecimal)(numberLike).toString());
    else if (numberLike.isSafeNumber()) return numberLike;
    else throw new Error(`Can not cast ${String(numberLike)} to ISafeNumber`);
};
module.exports.castToISafeNumber = $6d6b5d89cdd8fd41$var$castToISafeNumber;
const $6d6b5d89cdd8fd41$var$calculateSum = (numbers)=>$6d6b5d89cdd8fd41$var$ISafeNumberMath.calculateSum(numbers.map(module.exports.castToISafeNumber)).unsafeToNumber();
module.exports.calculateSum = $6d6b5d89cdd8fd41$var$calculateSum;
const $6d6b5d89cdd8fd41$var$calculateDeviationPercent = (args)=>$6d6b5d89cdd8fd41$var$ISafeNumberMath.calculateDeviationPercent({
        baseValue: (0, module.exports.castToISafeNumber)(args.baseValue),
        deviatedValue: (0, module.exports.castToISafeNumber)(args.deviatedValue)
    }).unsafeToNumber();
module.exports.calculateDeviationPercent = $6d6b5d89cdd8fd41$var$calculateDeviationPercent;
const $6d6b5d89cdd8fd41$var$getMedian = (numbers)=>$6d6b5d89cdd8fd41$var$ISafeNumberMath.getMedian(numbers.map(module.exports.castToISafeNumber)).unsafeToNumber();
module.exports.getMedian = $6d6b5d89cdd8fd41$var$getMedian;
class $6d6b5d89cdd8fd41$var$PrecisionScaler {
    toSolidityValue(floatNumber) {
        return new $6d6b5d89cdd8fd41$var$decimal_js_1.default(floatNumber).mul(this.tokenDecimalsScaler).toString();
    }
    fromSolidityValue(contractValue) {
        return (0, $l6nB2.bignumberishToDecimal)(contractValue).div(this.tokenDecimalsScaler);
    }
    constructor(tokenDecimals){
        (0, $dxWQo._)(this, "tokenDecimals", void 0);
        (0, $dxWQo._)(this, "tokenDecimalsScaler", void 0);
        this.tokenDecimals = tokenDecimals;
        this.tokenDecimalsScaler = new $6d6b5d89cdd8fd41$var$decimal_js_1.default(10).pow(tokenDecimals);
    }
}
module.exports.PrecisionScaler = $6d6b5d89cdd8fd41$var$PrecisionScaler;
const $6d6b5d89cdd8fd41$var$filterOutliers = (numbers, maxDiscrepancy)=>{
    if (numbers.length < 2) return {
        representativeGroup: [
            ...numbers
        ],
        outliers: []
    };
    const sortedNumbers = [
        ...numbers
    ];
    sortedNumbers.sort((a, b)=>a - b);
    let bestGroup = {
        startIndex: 0,
        endIndex: 0
    };
    for(let startIndex = bestGroup.startIndex; startIndex < sortedNumbers.length; startIndex++)for(let endIndex = sortedNumbers.length; startIndex < endIndex; endIndex--){
        const firstElementValue = sortedNumbers[startIndex];
        const lastElementValue = sortedNumbers[endIndex - 1];
        if (lastElementValue - firstElementValue < maxDiscrepancy) {
            if (endIndex - startIndex > bestGroup.endIndex - bestGroup.startIndex) bestGroup = {
                startIndex: startIndex,
                endIndex: endIndex
            };
        }
    }
    return {
        representativeGroup: sortedNumbers.slice(bestGroup.startIndex, bestGroup.endIndex),
        outliers: [
            ...sortedNumbers.slice(0, bestGroup.startIndex),
            ...sortedNumbers.slice(bestGroup.endIndex, sortedNumbers.length)
        ]
    };
};
module.exports.filterOutliers = $6d6b5d89cdd8fd41$var$filterOutliers;
const $6d6b5d89cdd8fd41$var$weightedRandom = (weights)=>{
    let totalWeight = 0;
    for(let i = 0; i < weights.length; i++)totalWeight += weights[i];
    let random = Math.random() * totalWeight;
    for(let i = 0; i < weights.length; i++){
        random -= weights[i];
        if (random < 0) return i;
    }
    return weights.length - 1;
};
module.exports.weightedRandom = $6d6b5d89cdd8fd41$var$weightedRandom;

});
parcelRegister("6rgxD", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneCubicInterpolation = module.exports.CubicInterpolation = void 0;
class $4b021882cd39587a$var$CubicInterpolation {
    forX(x) {
        if (x < this.firstX) return this.firstY - this.firstSlope * (this.firstX - x);
        else if (x > this.lastX) return this.lastY + this.lastSlope * (x - this.lastX);
        else return this.fun(x);
    }
    forY(y, precision) {
        if (y < this.firstY) return this.firstX - (this.firstY - y) / this.firstSlope;
        else if (y > this.lastY) return this.lastX + (y - this.lastY) / this.lastSlope;
        else {
            let lowX = this.firstX;
            let highX = this.lastX;
            let tries = 50;
            while(lowX <= highX && tries > 0){
                const midX = (lowX + highX) / 2;
                if (Math.abs(highX - lowX) < precision) return midX;
                const midY = this.forX(midX);
                if (Math.abs(midY - y) < precision) return midX;
                if (midY < y) lowX = midX;
                else highX = midX;
                tries--;
            }
            throw new Error(`X was not found for Y = ${y.toString()}`);
        }
    }
    constructor(firstX, lastX, firstY, lastY, firstSlope, lastSlope, fun){
        (0, $dxWQo._)(this, "firstX", void 0);
        (0, $dxWQo._)(this, "lastX", void 0);
        (0, $dxWQo._)(this, "firstY", void 0);
        (0, $dxWQo._)(this, "lastY", void 0);
        (0, $dxWQo._)(this, "firstSlope", void 0);
        (0, $dxWQo._)(this, "lastSlope", void 0);
        (0, $dxWQo._)(this, "fun", void 0);
        this.firstX = firstX;
        this.lastX = lastX;
        this.firstY = firstY;
        this.lastY = lastY;
        this.firstSlope = firstSlope;
        this.lastSlope = lastSlope;
        this.fun = fun;
    }
}
module.exports.CubicInterpolation = $4b021882cd39587a$var$CubicInterpolation;
const $4b021882cd39587a$var$monotoneCubicInterpolation = (xs, ys)=>{
    const { fun: fun, firstSlope: firstSlope, lastSlope: lastSlope } = $4b021882cd39587a$var$createInterpolant(xs, ys);
    return new $4b021882cd39587a$var$CubicInterpolation(xs[0], xs[xs.length - 1], ys[0], ys[ys.length - 1], firstSlope, lastSlope, fun);
};
module.exports.monotoneCubicInterpolation = $4b021882cd39587a$var$monotoneCubicInterpolation;
const $4b021882cd39587a$var$createInterpolant = (xs, ys)=>{
    if (xs.length != ys.length) throw new Error("The number of xs and ys should be equal");
    if (xs.length === 0) throw new Error("Empty array of xs");
    if (xs.length === 1) throw new Error("Interpolation cannot be performed for a single point");
    const [sortedXs, sortedYs] = $4b021882cd39587a$var$sortPoints(xs, ys);
    if (!$4b021882cd39587a$var$isStrictlyMonotonic(sortedYs)) throw new Error("The given points are not monotonic");
    const dys = [], dxs = [], ms = [];
    for(let i = 0; i < sortedXs.length - 1; i++){
        const dx = sortedXs[i + 1] - sortedXs[i];
        const dy = sortedYs[i + 1] - sortedYs[i];
        dxs[i] = dx;
        dys[i] = dy;
        ms[i] = dy / dx;
    }
    const c1s = [
        ms[0]
    ];
    for(let i = 0; i < dxs.length - 1; i++){
        const m = ms[i], mNext = ms[i + 1];
        if (m * mNext <= 0) c1s.push(0);
        else {
            const dx = dxs[i], dxNext = dxs[i + 1], common = dx + dxNext;
            c1s.push(3 * common / ((common + dxNext) / m + (common + dx) / mNext));
        }
    }
    c1s.push(ms[ms.length - 1]);
    const c2s = [], c3s = [];
    for(let i = 0; i < c1s.length - 1; i++){
        const c1 = c1s[i], m = ms[i], invDx = 1 / dxs[i], common = c1 + c1s[i + 1] - 2 * m;
        c2s.push((m - c1 - common) * invDx);
        c3s.push(common * invDx * invDx);
    }
    return {
        fun: $4b021882cd39587a$var$createInterpolantFunction(sortedXs, sortedYs, c1s, c2s, c3s),
        firstSlope: ms[0],
        lastSlope: ms[ms.length - 1]
    };
};
const $4b021882cd39587a$var$sortPoints = (xs, ys)=>{
    const indexes = [
        ...Array(xs.length).keys()
    ];
    indexes.sort((a, b)=>{
        return xs[a] - xs[b];
    });
    const sortedXs = [];
    const sortedYs = [];
    for(let i = 0; i < xs.length; i++){
        sortedXs[i] = xs[indexes[i]];
        sortedYs[i] = ys[indexes[i]];
    }
    return [
        sortedXs,
        sortedYs
    ];
};
const $4b021882cd39587a$var$isStrictlyMonotonic = (ys)=>{
    if (ys.length < 2) return true;
    let direction = "undefined";
    let previous = ys[0];
    for(let i = 1; i < ys.length; i++){
        const current = ys[i];
        if (current > previous) {
            if (direction === "decreasing") return false;
            direction = "increasing";
        } else if (current < previous) {
            if (direction === "increasing") return false;
            direction = "decreasing";
        } else return false;
        previous = current;
    }
    return true;
};
const $4b021882cd39587a$var$createInterpolantFunction = (xs, ys, c1s, c2s, c3s)=>(x)=>{
        if (x < xs[0] || x > xs[xs.length - 1]) throw new Error(`The function only handles arguments in the range [${xs[0].toString()},${xs[xs.length - 1].toString()}]`);
        if (x === xs[xs.length - 1]) return ys[xs.length - 1];
        let low = 0, high = c3s.length - 1;
        while(low <= high){
            const middle = Math.floor(0.5 * (low + high));
            const middleX = xs[middle];
            if (middleX < x) low = middle + 1;
            else if (middleX > x) high = middle - 1;
            else return ys[middle];
        }
        const i = Math.max(0, high);
        const diff = x - xs[i];
        return ys[i] + diff * (c1s[i] + diff * (c2s[i] + diff * c3s[i]));
    };

});


parcelRegister("aKlLZ", function(module, exports) {
"use strict";
var $7d2f16ebac603645$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7d2f16ebac603645$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7d2f16ebac603645$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7d2f16ebac603645$var$__exportStar((parcelRequire("2pBMY")), module.exports);

});
parcelRegister("2pBMY", function(module, exports) {
"use strict";
var $1c1b3aadcf85d68b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sendHealthcheckPing = void 0;

const $1c1b3aadcf85d68b$var$axios_1 = $1c1b3aadcf85d68b$var$__importDefault((parcelRequire("28feZ")));
const $1c1b3aadcf85d68b$var$sendHealthcheckPing = async (healthcheckPingUrl)=>{
    if (healthcheckPingUrl) try {
        await $1c1b3aadcf85d68b$var$axios_1.default.get(healthcheckPingUrl);
    } catch (e) {
        const error = e;
        if (error.code === "ENOTFOUND") console.error("Healthcheck address not found. Configure your `HEALTHCHECK_PING_URL` properly");
        else console.error("Unknown error occurred, when trying to health check ping", error);
    }
};
module.exports.sendHealthcheckPing = $1c1b3aadcf85d68b$var$sendHealthcheckPing;

});


parcelRegister("3NWhe", function(module, exports) {
"use strict";
var $2c532742e59551e0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2c532742e59551e0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2c532742e59551e0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2c532742e59551e0$var$__exportStar((parcelRequire("k7MJT")), module.exports);

$2c532742e59551e0$var$__exportStar((parcelRequire("4Rw0r")), module.exports);

$2c532742e59551e0$var$__exportStar((parcelRequire("jCZxw")), module.exports);

});
parcelRegister("k7MJT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4Rw0r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LAST_UPDATED_TIMESTAMP_SYMBOL = void 0;
module.exports.LAST_UPDATED_TIMESTAMP_SYMBOL = "__lastUpdatedTimestamp";

});

parcelRegister("jCZxw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TradeDirection = void 0;
var $e4a14d737cd0b48c$var$TradeDirection;
(function(TradeDirection) {
    TradeDirection["BUY"] = "buy";
    TradeDirection["SELL"] = "sell";
})($e4a14d737cd0b48c$var$TradeDirection || (module.exports.TradeDirection = $e4a14d737cd0b48c$var$TradeDirection = {}));

});


parcelRegister("laJbA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_LATEST_DATA_PACKAGES_MAX_DELAY_MS = void 0;

var $72fYR = parcelRequire("72fYR");
module.exports.DEFAULT_LATEST_DATA_PACKAGES_MAX_DELAY_MS = $72fYR.RedstoneCommon.minToMs(1);

});
parcelRegister("72fYR", function(module, exports) {
"use strict";
var $51f51db892e99d08$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $51f51db892e99d08$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $51f51db892e99d08$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $51f51db892e99d08$var$__createBinding(result, mod, k);
    }
    $51f51db892e99d08$var$__setModuleDefault(result, mod);
    return result;
};
var $51f51db892e99d08$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $51f51db892e99d08$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RedstoneConstants = module.exports.RedstoneTypes = module.exports.MathUtils = module.exports.RedstoneCrypto = module.exports.RedstoneCommon = module.exports.SafeNumber = void 0;

module.exports.SafeNumber = $51f51db892e99d08$var$__importStar((parcelRequire("jgUgs")));

module.exports.RedstoneCommon = $51f51db892e99d08$var$__importStar((parcelRequire("l6nB2")));

module.exports.RedstoneCrypto = $51f51db892e99d08$var$__importStar((parcelRequire("emKzm")));

module.exports.MathUtils = $51f51db892e99d08$var$__importStar((parcelRequire("9or5m")));

$51f51db892e99d08$var$__exportStar((parcelRequire("aKlLZ")), module.exports);

module.exports.RedstoneTypes = $51f51db892e99d08$var$__importStar((parcelRequire("3NWhe")));

module.exports.RedstoneConstants = $51f51db892e99d08$var$__importStar((parcelRequire("laJbA")));

});


parcelRegister("dC18G", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContractParamsProvider = void 0;

var $j2rU8 = parcelRequire("j2rU8");

var $ji93N = parcelRequire("ji93N");

var $hbWVX = parcelRequire("hbWVX");

var $5zREg = parcelRequire("5zREg");
class $9e8fb5251d44c06d$var$ContractParamsProvider {
    async getPayloadHex(withPrefix = true) {
        return (withPrefix ? "0x" : "") + await this.requestPayload(this.requestParams);
    }
    async getPayloadData() {
        return Array.from((0, $hbWVX.arrayify)(await this.getPayloadHex(true)));
    }
    getHexlifiedFeedIds() {
        return this.getDataFeedIds().map((feed)=>(0, $j2rU8.hexlify)((0, $ji93N.toUtf8Bytes)(feed)));
    }
    getDataFeedIds() {
        if (!this.requestParams.dataFeeds) throw new Error("That invocation requires non-empty dataFeeds");
        return this.requestParams.dataFeeds;
    }
    async requestPayload(requestParams) {
        return await (0, $5zREg.requestRedstonePayload)(requestParams);
    }
    constructor(requestParams){
        (0, $dxWQo._)(this, "requestParams", void 0);
        this.requestParams = requestParams;
    }
}
module.exports.ContractParamsProvider = $9e8fb5251d44c06d$var$ContractParamsProvider;

});
parcelRegister("ji93N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toUtf8CodePoints = module.exports.toUtf8String = module.exports._toUtf8String = module.exports._toEscapedUtf8String = module.exports.toUtf8Bytes = module.exports.Utf8ErrorFuncs = module.exports.Utf8ErrorReason = module.exports.UnicodeNormalizationForm = void 0;

var $j2rU8 = parcelRequire("j2rU8");

var $6M65e = parcelRequire("6M65e");

var $3hPAa = parcelRequire("3hPAa");
var $e0b6b9eb661749d3$var$logger = new $6M65e.Logger($3hPAa.version);
///////////////////////////////
var $e0b6b9eb661749d3$var$UnicodeNormalizationForm;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($e0b6b9eb661749d3$var$UnicodeNormalizationForm = module.exports.UnicodeNormalizationForm || (module.exports.UnicodeNormalizationForm = {}));
var $e0b6b9eb661749d3$var$Utf8ErrorReason;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($e0b6b9eb661749d3$var$Utf8ErrorReason = module.exports.Utf8ErrorReason || (module.exports.Utf8ErrorReason = {}));
function $e0b6b9eb661749d3$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $e0b6b9eb661749d3$var$logger.throwArgumentError("invalid codepoint at offset " + offset + "; " + reason, "bytes", bytes);
}
function $e0b6b9eb661749d3$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $e0b6b9eb661749d3$var$Utf8ErrorReason.BAD_PREFIX || reason === $e0b6b9eb661749d3$var$Utf8ErrorReason.UNEXPECTED_CONTINUE) {
        var i = 0;
        for(var o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $e0b6b9eb661749d3$var$Utf8ErrorReason.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $e0b6b9eb661749d3$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $e0b6b9eb661749d3$var$Utf8ErrorReason.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $e0b6b9eb661749d3$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
// Common error handing strategies
module.exports.Utf8ErrorFuncs = Object.freeze({
    error: $e0b6b9eb661749d3$var$errorFunc,
    ignore: $e0b6b9eb661749d3$var$ignoreFunc,
    replace: $e0b6b9eb661749d3$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $e0b6b9eb661749d3$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = module.exports.Utf8ErrorFuncs.error;
    bytes = (0, $j2rU8.arrayify)(bytes);
    var result = [];
    var i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        var c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        var extraLength = null;
        var overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($e0b6b9eb661749d3$var$Utf8ErrorReason.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($e0b6b9eb661749d3$var$Utf8ErrorReason.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($e0b6b9eb661749d3$var$Utf8ErrorReason.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        var res = c & (1 << 8 - extraLength - 1) - 1;
        for(var j = 0; j < extraLength; j++){
            var nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($e0b6b9eb661749d3$var$Utf8ErrorReason.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($e0b6b9eb661749d3$var$Utf8ErrorReason.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($e0b6b9eb661749d3$var$Utf8ErrorReason.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($e0b6b9eb661749d3$var$Utf8ErrorReason.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
// http://stackoverflow.com/questions/18729405/how-to-convert-utf8-string-to-byte-array
function $e0b6b9eb661749d3$var$toUtf8Bytes(str, form) {
    if (form === void 0) form = $e0b6b9eb661749d3$var$UnicodeNormalizationForm.current;
    if (form != $e0b6b9eb661749d3$var$UnicodeNormalizationForm.current) {
        $e0b6b9eb661749d3$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    var result = [];
    for(var i = 0; i < str.length; i++){
        var c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            var c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            var pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $j2rU8.arrayify)(result);
}
module.exports.toUtf8Bytes = $e0b6b9eb661749d3$var$toUtf8Bytes;
function $e0b6b9eb661749d3$var$escapeChar(value) {
    var hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $e0b6b9eb661749d3$var$_toEscapedUtf8String(bytes, onError) {
    return '"' + $e0b6b9eb661749d3$var$getUtf8CodePoints(bytes, onError).map(function(codePoint) {
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $e0b6b9eb661749d3$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $e0b6b9eb661749d3$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $e0b6b9eb661749d3$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
module.exports._toEscapedUtf8String = $e0b6b9eb661749d3$var$_toEscapedUtf8String;
function $e0b6b9eb661749d3$var$_toUtf8String(codePoints) {
    return codePoints.map(function(codePoint) {
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
module.exports._toUtf8String = $e0b6b9eb661749d3$var$_toUtf8String;
function $e0b6b9eb661749d3$var$toUtf8String(bytes, onError) {
    return $e0b6b9eb661749d3$var$_toUtf8String($e0b6b9eb661749d3$var$getUtf8CodePoints(bytes, onError));
}
module.exports.toUtf8String = $e0b6b9eb661749d3$var$toUtf8String;
function $e0b6b9eb661749d3$var$toUtf8CodePoints(str, form) {
    if (form === void 0) form = $e0b6b9eb661749d3$var$UnicodeNormalizationForm.current;
    return $e0b6b9eb661749d3$var$getUtf8CodePoints($e0b6b9eb661749d3$var$toUtf8Bytes(str, form));
}
module.exports.toUtf8CodePoints = $e0b6b9eb661749d3$var$toUtf8CodePoints;

});
parcelRegister("3hPAa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = void 0;
module.exports.version = "strings/5.7.0";

});


parcelRegister("5zREg", function(module, exports) {
"use strict";
var $40f9d61e3993db42$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $40f9d61e3993db42$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $40f9d61e3993db42$var$__createBinding(exports1, m, p);
};
var $40f9d61e3993db42$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUrlsForDataServiceId = module.exports.requestRedstonePayload = module.exports.getDecimalsForDataFeedId = module.exports.parseDataPackagesResponse = module.exports.requestDataPackages = module.exports.calculateHistoricalPackagesTimestamp = module.exports.getDataServiceIdForSigner = module.exports.getOracleRegistryState = void 0;

var $au4Wk = parcelRequire("au4Wk");

var $6vSZI = parcelRequire("6vSZI");

const $40f9d61e3993db42$var$axios_1 = $40f9d61e3993db42$var$__importDefault((parcelRequire("28feZ")));


var $72fYR = parcelRequire("72fYR");

var $6lD4c = parcelRequire("6lD4c");
const $40f9d61e3993db42$var$GET_REQUEST_TIMEOUT = 10000;
const $40f9d61e3993db42$var$WAIT_FOR_ALL_GATEWAYS_TIME = 600;
const $40f9d61e3993db42$var$MILLISECONDS_IN_ONE_MINUTE = 60000;
const $40f9d61e3993db42$var$GwResponseSchema = $6lD4c.z.record($6lD4c.z.string(), $6lD4c.z.array($6lD4c.z.object({
    dataPoints: $6lD4c.z.array($6lD4c.z.object({
        dataFeedId: $6lD4c.z.string(),
        value: $6lD4c.z.number(),
        decimals: $6lD4c.z.number().optional()
    }).or($6lD4c.z.object({
        dataFeedId: $6lD4c.z.string(),
        value: $6lD4c.z.string(),
        decimals: $6lD4c.z.number().optional()
    }))).min(1),
    timestampMilliseconds: $6lD4c.z.number(),
    signature: $6lD4c.z.string(),
    dataFeedId: $6lD4c.z.string()
})));
const $40f9d61e3993db42$var$getOracleRegistryState = async ()=>{
    return await Promise.resolve($au4Wk.redstoneOraclesInitialState);
};
module.exports.getOracleRegistryState = $40f9d61e3993db42$var$getOracleRegistryState;
const $40f9d61e3993db42$var$getDataServiceIdForSigner = (oracleState, signerAddress)=>{
    for (const nodeDetails of Object.values(oracleState.nodes)){
        if (nodeDetails.evmAddress.toLowerCase() === signerAddress.toLowerCase()) return nodeDetails.dataServiceId;
    }
    throw new Error(`Data service not found for ${signerAddress}`);
};
module.exports.getDataServiceIdForSigner = $40f9d61e3993db42$var$getDataServiceIdForSigner;
const $40f9d61e3993db42$var$calculateHistoricalPackagesTimestamp = (deviationCheckOffsetInMinutes, baseTimestamp = Date.now())=>{
    if (deviationCheckOffsetInMinutes > 0) return Math.floor(baseTimestamp / $40f9d61e3993db42$var$MILLISECONDS_IN_ONE_MINUTE - deviationCheckOffsetInMinutes) * $40f9d61e3993db42$var$MILLISECONDS_IN_ONE_MINUTE;
    return undefined;
};
module.exports.calculateHistoricalPackagesTimestamp = $40f9d61e3993db42$var$calculateHistoricalPackagesTimestamp;
const $40f9d61e3993db42$var$requestDataPackages = async (reqParams)=>{
    try {
        const promises = $40f9d61e3993db42$var$prepareDataPackagePromises(reqParams);
        if (reqParams.historicalTimestamp) return await Promise.any(promises);
        return await $40f9d61e3993db42$var$getTheMostRecentDataPackages(promises);
    } catch (e) {
        const errMessage = `Request failed ${JSON.stringify({
            reqParams: reqParams
        })}, Original error: ${$72fYR.RedstoneCommon.stringifyError(e)}`;
        throw new Error(errMessage);
    }
};
module.exports.requestDataPackages = $40f9d61e3993db42$var$requestDataPackages;
const $40f9d61e3993db42$var$getTheMostRecentDataPackages = (promises)=>{
    return new Promise((resolve, reject)=>{
        const collectedResponses = [];
        const errors = [];
        let waitForAll = true;
        const timer = setTimeout(()=>{
            waitForAll = false;
            checkResults();
        }, $40f9d61e3993db42$var$WAIT_FOR_ALL_GATEWAYS_TIME);
        const checkResults = ()=>{
            if (errors.length === promises.length) {
                clearTimeout(timer);
                reject(new AggregateError(errors));
            } else if (collectedResponses.length + errors.length === promises.length || !waitForAll && collectedResponses.length !== 0) {
                const newestPackage = collectedResponses.reduce((a, b)=>{
                    var _Object_values_at_at, _Object_values_at, _Object_values_at_at1, _Object_values_at1;
                    var _Object_values_at_at_dataPackage_timestampMilliseconds;
                    const aTimestamp = (_Object_values_at_at_dataPackage_timestampMilliseconds = (_Object_values_at = Object.values(a).at(0)) === null || _Object_values_at === void 0 ? void 0 : (_Object_values_at_at = _Object_values_at.at(0)) === null || _Object_values_at_at === void 0 ? void 0 : _Object_values_at_at.dataPackage.timestampMilliseconds) !== null && _Object_values_at_at_dataPackage_timestampMilliseconds !== void 0 ? _Object_values_at_at_dataPackage_timestampMilliseconds : 0;
                    var _Object_values_at_at_dataPackage_timestampMilliseconds1;
                    const bTimestamp = (_Object_values_at_at_dataPackage_timestampMilliseconds1 = (_Object_values_at1 = Object.values(b).at(0)) === null || _Object_values_at1 === void 0 ? void 0 : (_Object_values_at_at1 = _Object_values_at1.at(0)) === null || _Object_values_at_at1 === void 0 ? void 0 : _Object_values_at_at1.dataPackage.timestampMilliseconds) !== null && _Object_values_at_at_dataPackage_timestampMilliseconds1 !== void 0 ? _Object_values_at_at_dataPackage_timestampMilliseconds1 : 0;
                    return bTimestamp > aTimestamp ? b : a;
                });
                clearTimeout(timer);
                resolve(newestPackage);
            }
        };
        for (const promise of promises)promise.then((r)=>collectedResponses.push(r)).catch((e)=>errors.push(e)).finally(checkResults);
    });
};
const $40f9d61e3993db42$var$prepareDataPackagePromises = (reqParams)=>{
    const urls = (0, module.exports.getUrlsForDataServiceId)(reqParams);
    const pathComponents = [
        "data-packages",
        reqParams.historicalTimestamp ? "historical" : "latest",
        reqParams.dataServiceId
    ];
    if (reqParams.historicalTimestamp) pathComponents.push(`${reqParams.historicalTimestamp}`);
    return urls.map((url)=>$40f9d61e3993db42$var$axios_1.default.get([
            url.replace(/\/+$/, "")
        ].concat(pathComponents).join("/"), {
            timeout: $40f9d61e3993db42$var$GET_REQUEST_TIMEOUT
        }).then((response)=>(0, module.exports.parseDataPackagesResponse)(response.data, reqParams)));
};
const $40f9d61e3993db42$var$parseDataPackagesResponse = (responseData, reqParams)=>{
    const parsedResponse = {};
    $72fYR.RedstoneCommon.zodAssert($40f9d61e3993db42$var$GwResponseSchema, responseData);
    var _reqParams_dataFeeds;
    const requestedDataFeedIds = (_reqParams_dataFeeds = reqParams.dataFeeds) !== null && _reqParams_dataFeeds !== void 0 ? _reqParams_dataFeeds : [
        $6vSZI.consts.ALL_FEEDS_KEY
    ];
    for (const dataFeedId of requestedDataFeedIds){
        const dataFeedPackages = responseData[dataFeedId];
        if (!dataFeedPackages) throw new Error(`Requested data feed id is not included in response: ${dataFeedId}`);
        if (dataFeedPackages.length < reqParams.uniqueSignersCount) throw new Error(`Too few unique signers for the data feed: ${dataFeedId}. ` + `Expected: ${reqParams.uniqueSignersCount}. ` + `Received: ${dataFeedPackages.length}`);
        parsedResponse[dataFeedId] = $40f9d61e3993db42$var$pickDataFeedPackagesClosestToMedian(dataFeedPackages, reqParams.uniqueSignersCount);
    }
    return parsedResponse;
};
module.exports.parseDataPackagesResponse = $40f9d61e3993db42$var$parseDataPackagesResponse;
const $40f9d61e3993db42$var$pickDataFeedPackagesClosestToMedian = (dataFeedPackages, count)=>{
    const median = $72fYR.MathUtils.getMedian(dataFeedPackages.map((dp)=>dp.dataPoints[0].value));
    return $40f9d61e3993db42$var$sortByDistanceFromMedian(dataFeedPackages, median).map((diff)=>$6vSZI.SignedDataPackage.fromObj(diff.dp)).slice(0, count);
};
function $40f9d61e3993db42$var$sortByDistanceFromMedian(dataFeedPackages, median) {
    return dataFeedPackages.map((dp)=>({
            dp: dp,
            diff: $72fYR.SafeNumber.createSafeNumber(dp.dataPoints[0].value).sub(median).abs()
        })).sort((first, second)=>first.diff.sub(second.diff).unsafeToNumber());
}
const $40f9d61e3993db42$var$getDecimalsForDataFeedId = (dataPackages)=>{
    const firstDecimal = dataPackages[0].dataPoints[0].decimals;
    const areAllDecimalsEqual = dataPackages.every((dataPackage)=>dataPackage.dataPoints.every((dataPoint)=>dataPoint.decimals === firstDecimal));
    if (!areAllDecimalsEqual) throw new Error("Decimals from data points in data packages are not equal");
    return firstDecimal;
};
module.exports.getDecimalsForDataFeedId = $40f9d61e3993db42$var$getDecimalsForDataFeedId;
const $40f9d61e3993db42$var$requestRedstonePayload = async (reqParams, format = "hex", unsignedMetadataMsg)=>{
    const signedDataPackagesResponse = await (0, module.exports.requestDataPackages)(reqParams);
    const signedDataPackages = Object.values(signedDataPackagesResponse).flat();
    const payload = new $6vSZI.RedstonePayload(signedDataPackages, unsignedMetadataMsg !== null && unsignedMetadataMsg !== void 0 ? unsignedMetadataMsg : "");
    switch(format){
        case "json":
            return JSON.stringify(payload.toObj(), null, 2);
        case "bytes":
            return JSON.stringify(Array.from(payload.toBytes()));
        default:
            return payload.toBytesHexWithout0xPrefix();
    }
};
module.exports.requestRedstonePayload = $40f9d61e3993db42$var$requestRedstonePayload;
const $40f9d61e3993db42$var$getUrlsForDataServiceId = (reqParams)=>{
    if (reqParams.urls) return reqParams.urls;
    return (0, (parcelRequire("hacYN")).resolveDataServiceUrls)(reqParams.dataServiceId);
};
module.exports.getUrlsForDataServiceId = $40f9d61e3993db42$var$getUrlsForDataServiceId;
module.exports.default = {
    getOracleRegistryState: module.exports.getOracleRegistryState,
    requestDataPackages: module.exports.requestDataPackages,
    getDataServiceIdForSigner: module.exports.getDataServiceIdForSigner,
    requestRedstonePayload: module.exports.requestRedstonePayload,
    resolveDataServiceUrls: (parcelRequire("hacYN")).resolveDataServiceUrls,
    getDecimalsForDataFeedId: module.exports.getDecimalsForDataFeedId
};

$40f9d61e3993db42$var$__exportStar((parcelRequire("dC18G")), module.exports);

$40f9d61e3993db42$var$__exportStar((parcelRequire("gbByN")), module.exports);

$40f9d61e3993db42$var$__exportStar((parcelRequire("aToIW")), module.exports);

$40f9d61e3993db42$var$__exportStar((parcelRequire("eSakG")), module.exports);

$40f9d61e3993db42$var$__exportStar((parcelRequire("d0cPf")), module.exports);

$40f9d61e3993db42$var$__exportStar((parcelRequire("hacYN")), module.exports);

$40f9d61e3993db42$var$__exportStar((parcelRequire("2Cggk")), module.exports);

$40f9d61e3993db42$var$__exportStar((parcelRequire("8hx3Q")), module.exports);

$40f9d61e3993db42$var$__exportStar((parcelRequire("7Re1c")), module.exports);

$40f9d61e3993db42$var$__exportStar((parcelRequire("fXHzY")), module.exports);

});
parcelRegister("au4Wk", function(module, exports) {
"use strict";
var $7a2089a6098798cb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7a2089a6098798cb$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7a2089a6098798cb$var$__createBinding(exports1, m, p);
};
var $7a2089a6098798cb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.redstoneOraclesInitialState = void 0;

var $fWiCj = parcelRequire("fWiCj");
Object.defineProperty(module.exports, "redstoneOraclesInitialState", {
    enumerable: true,
    get: function() {
        return $7a2089a6098798cb$var$__importDefault($fWiCj).default;
    }
});

$7a2089a6098798cb$var$__exportStar((parcelRequire("ae8dF")), module.exports);

});
parcelRegister("fWiCj", function(module, exports) {
module.exports = JSON.parse('{"nodes":{"I-5rWUehEv-MjdK9gFw09RxfSLQX9DIHxG614Wf8qo0":{"url":"https://redstone.finance","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"redstone","ipAddress":"0.0.0.0","dataServiceId":"redstone-main-demo","evmAddress":"0x0C39486f770B26F5527BBBf942726537986Cd7eb","description":"Main RedStone Provider with all available tokens.","arweavePublicKey":"xyTvKiCST8bAT6sxrgkLh8UCX2N1eKvawODuxwq4qOHIdDAZFU_3N2m59rkZ0E7m77GsJuf1I8u0oEJEbxAdT7uD2JTwoYEHauXSxyJYvF0RCcZOhl5P1PJwImd44SJYa_9My7L84D5KXB9SKs8_VThe7ZyOb5HSGLNvMIK6A8IJ4Hr_tg9GYm65CRmtcu18S9mhun8vgw2wi7Gw6oR6mc4vU1I-hrU66Fi7YlXwFieP6YSy01JqoLPhU84EunPQzXPouVSbXjgRU5kFVxtdRy4GK2fzEBFYsQwCQgFrySCrFKHV8AInu9jerfof_DxNKiXkBzlB8nc22CrYnvvio_BWyh-gN0hQHZT0gwMR-A7sbXNCQJfReaIZzX_jP6XoB82PnpzmL_j1mJ2lnv2Rn001flBAx9AYxtGXd9s07pA-FggTbEG3Y2UnlWW6l3EJ93E0IfxL0PqGEUlp217mxUHvmTw9fkGDWa8rT9RPmsTyji-kMFSefclw80cBm_iOsIEutGP4S3LDbP-ZVJWDeJOBQQpSgwbisl8qbjl2sMQLQihoG2TQyNbmLwfyq-XSULkXjUi1_6BH36wnDBLWBKF-bS2bLKcGtn3Vjet72lNHxJJilcj8vpauwJG0078S_lO5uGt6oicdGR6eh_NSn6_8za_tXg0G_fohz4Yb1z8","ecdsaPublicKey":"0x04009dd87eb41d96ce8ad94aa22ea8b0ba4ac20c45e42f71726d6b180f93c3f298e333ae7591fe1c9d88234575639be9e81e35ba2fe5ad2c2260f07db49ccb9d0d"},"Yba8IVc_01bFxutKNJAZ7CmTD5AVi2GcWXf1NajPAsc":{"url":"https://redstone.finance","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"redstone-stocks","ipAddress":"0.0.0.0","dataServiceId":"redstone-stocks-demo","evmAddress":"0x926E370fD53c23f8B71ad2B3217b227E41A92b12","description":"Stocks, ETFs, Livestocks, Metals, Energies...","arweavePublicKey":"wOoClMPZ_maAoE6OhCC8svn_9gu8rjuWPi3Grf05zpQnCzeFjzUocJUr0ta-muJDqfiTd4t5KR2qNxn3nkN2_kXsn5AcXnlI4UgnRdcEvsDh6yPMoMlAiAD6c0_CIgdiMFku5OTijNMtFYOybPKrd9Xdf_7_lnRZhU9qQXeBclVjmIzftwNaTFYI1sgApWKMxJ6301CY7VN9SOD9KBrFQJ3QjWqLrLwAyAu_Q6aBeQF_L-cZSFCiTfwyDptiMCdLAjzU9s55LNAg65pZ_OfFsvqylwiXEVIEDLUI3nmcM6OUHfyAG2TxoeXeem9nCpA96MiM8MyTWtOApGA3GW__j3fxutD0wt3_uGnVRZoypPqNuPjb5BraF0owTDYJQNML9Ddx1Hy6gMXjvjxn-MbAV7tI4KnDynrbtXPSZYjRpTpxcH9Rlr-bQAZWGpYF7OWpsZlPuE4MdxpQYhqLj6wfGCxTyzIjyt_t4zR28gWIGT5SfM-etcuXyy_chspsIqisSj781AP7YMTIxzyrY_LAAm-u5gz5VwnD8xDKIrYcsxLpC4V30HFWRc5vYtBQ0cAZYnp9AGGFD-6A7PnqQ1EYSSEHzSAqoYHaqxuAvxJEhG5AECdXBS3-FpgbGgVFEeQxIH7v9Js6-Uk85t23MjRUJFNo2JIlvyolmtkd3mf88qc","ecdsaPublicKey":"0x04a628e8c2ef7d3b768b75404a48adcd667d0d59ae457bf19552ff670d2c95630480752e90b0c9fe8127feeb9e8f9e694919c730327bd368c985f1a5b26c2d60ba"},"zYqPZuALSPa_f5Agvf8g2JHv94cqMn9aBtnH7GFHbuA":{"url":"https://redstone.finance","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"redstone-rapid","ipAddress":"0.0.0.0","dataServiceId":"redstone-rapid-demo","evmAddress":"0xf786a909D559F5Dee2dc6706d8e5A81728a39aE9","description":"Most popular tokens with frequent updates","arweavePublicKey":"tfkkt6lHR3lSEBNvjistpdGb8pR9UJoOVO-IuXRXD9PckAqY7TAVuDVhrcQDM56GZ_EUh6Eg_NRYd-EGW8SEQLHXtY_CM4P8563xUpw0XcZJbpOeScFcN5JdN47gq8vllOheO6-v4nRPLVabRVJqkXEqzdEwxQNYDkmPL-gxE0ziZcQRQZdJUzL5mI9DzwpPC86JBVwsBK71iuRlstABciIu8u77qyArkNu0pPig9OFQvT3Vg4OPuWXd83EhqEuN5gqVufyomkmL8X7agiEjDf-UQIfZrSYqgiJsWiVJ2aKHRhLZN17wdX51L21Cg2Sbyb3B1Roy5EgUUTdJ2MY7LnI-CTbBBJLKUHSvN67MDhj1OSBwUULc8bgVCzmfVQryIFmb4tucKvz7TRAWseXNO2MtMlggXa42Hx0sOTopbFTmT_r9glRLYw3QLzyJVH7Ltqr8QldoU-VMWtpo5cmOGh8jwVknSHqWNURbRCoDfAuwh8lpWXBjL_V8haaY0OKFT9Lpi1VW8o4Kfx7ED1VAnLcpVIoV5CkPs_L0Qy_G7XpgA02OAbJH2KvwxZPeSSymdupmr1KMc8iGz5B4a1HEcKggk5ETFfeGz5r0hDha3dwDj-dOv1jbADcdgk7e2xaLgw1CpS1XEHhAnhBJgAzJDJpcHKrxPkD6cUc7FbnsBCE","ecdsaPublicKey":"0x041d45589c5055c867e857d8437e7d5745027d0a455801bc78cc856840510e76d8ffe578296a11a03e744d7a953e0f1e36c3a93f74268859e480203ab4d2f5718e"},"f1Ipos2fVPbxPVO65GBygkMyW0tkAhp2hdprRPPBBN8":{"url":"https://redstone.finance","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"redstone-avalanche-node-1","ipAddress":"0.0.0.0","dataServiceId":"redstone-avalanche-demo","evmAddress":"0x3a7d971De367FE15D164CDD952F64205F2D9f10c","description":"Most popular tokens from the Avalanche ecosystem - demo node 1","arweavePublicKey":"nehHT9-CMWscteR3COOU455AmDI8VihUPG05kDryVl8wjv4iE_7MttV2rz3MTIicL1BNDQ246EnyIL_4qsqu8a_B3dZT8sVdfOtHqh48pDgA0MJ8ifFVUtyabr3D2ZSc2M4re79wm2SQ_S74ZNHV7zBIBS8pUHB20TfrKhrOWi-W0hfkxrqz4jIngXIPmE1ycYbaj9OHSVRFIB-EZN-1LmLZuy2EAAN0nOqJ-aYoblcGOu4WfZDpTXTfj-6-GRRBgeHen3MYnQuDneEYYrtzoCnimWGYrqRnpM654mJTW7gp_NIqLnXn3yG2aS2pbhn1_I0CavtKuE4PSACoP0UwZaGXEtanIaSuMDkeRdu-zhrr8yXZSW1inWdC0lhWPxAhzTYWQ00_OD6oj2FUtbXbAk_F-aPnT1Teb-LcNn6q-HbHSeZ_VV0ge5nn3zvBCc77z-Qfbgyd_a7dNwfy8sVkQc4-gvDJIftzxVXbUWnc3ipvL-PHfLsajg5Jkhteuvf8bIS0cNFS5u9pu3qnutskQxSymPzhkVmSyMWNe48Xp3ok4mUA9SuWTb6AskyoDVR9APh7JNDgeYINctgduqawzJQFxcVDuoW-1b8Gy79EYXW8yHowpAaDm6eYGTPQjnMpttThZwFiC_81JTXHXmDneKm677F2kO-1f6o4UWTBOEk","ecdsaPublicKey":"0x0455e7c699a153e02de0e6d3c3dcdb34d1e57a9456205b0e124e2cac29b58be83c4faa2081d39b38aa3c41fa3350f50dcf87d40ab695c9c86709040d39d5ba9be3"},"6bZ3yxPYy0LHPqo7MNqw0PHTeIM2PR-RmfTPYLltsfw":{"url":"https://redstone.finance","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"redstone-avalanche-node-2","ipAddress":"0.0.0.0","dataServiceId":"redstone-avalanche-demo","evmAddress":"0x41ed5321B76C045f5439eCf9e73F96c6c25B1D75","description":"Most popular tokens from the Avalanche ecosystem - demo node 2","arweavePublicKey":"TODO: find and add","ecdsaPublicKey":"0x0428082ee0046157d0fba27aa9391f5651c41b9dc8b12011ed72622c05e55d56ae503039f912de7345dab28ae68d80b055082f74286b82ffc2c09c07d8b2e22378"},"OxQ-vLXcwTZdcdlCziC95duFylo8Aj9xBJ4XsC3xlGk":{"name":"redstone-arbitrum-dev-node-1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Data feeds from arbitrum redstone nodes - dev 1","dataServiceId":"redstone-arbitrum-demo","evmAddress":"0x16883583647260AB2e2BA63c4c38D9807Fd7296e","ipAddress":"0.0.0.0","url":"https://redstone.finance/","ecdsaPublicKey":"0x041aea25f013dee918d88063daca2d0113fa41a95b66440d8d8edf09a3d397045f5b9d391c1e50e6998d3b2f95918899e382f444714e64d9fd689c92d4a2535ea1"},"LtVolyIqpjhCr8fw_ue_-Y9xaH5IURpKZclyJbsu4SE":{"name":"redstone-arbitrum-dev-node-2","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Data feeds from arbitrum redstone nodes - dev 2","dataServiceId":"redstone-arbitrum-demo","evmAddress":"0x1053d519Cc8C8cd7e53FecbFb13B6F0ffbD4c8C5","ipAddress":"0.0.0.0","url":"https://redstone.finance/","ecdsaPublicKey":"0x04d0f2bb463dfe89778fc6fe68ed6945bbf13f1391369942d78607cc4eac906aa63d082caf6c81c3c191daf4bbb7cfabbf5fca1ca762e02529cf700a15ac0cd828"},"tTTthGBknPG4MWH5y-zDKO2dEF3Fxo0gPbzV6PLNlNQ":{"name":"redstone-avalanche-prod-node-1","description":"Most popular tokens from the Avalanche ecosystem - prod node 1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-avalanche-prod","evmAddress":"0x1eA62d73EdF8AC05DfceA1A34b9796E937a29EfF","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04ea48ca25db5d352ec62c4f92e8c115068e92a327f3536479a0185ec6e0f8d26db4409bffdc8c6ea898743f908861a47fdb4a52e44d129a56418a1c08008fd425","arweavePublicKey":"26hxzuODmUGbc3c52ZFz1zLeKdasZdcd2EmcLBl1PNGD75S9F5J4a0WDLeklG0YZEIU25besIa5bvinF8vCp_ebdJZUnhvheQBv_0-aoR2DBBoxe5Og942NMLEDzQl9mSP3y4_qGKnf3XQc4tzP5C6HRDI3b8L9Is4sAckEVaR5NXVAoOsg-YST-2g-Uoqkw1-ZavjL30ABSDejQLNRyZ36uzxRe5PzXtG9Oy8-t_Tz5SafMnzb68dbyBTCD2172fjxP8pXsIS-a6fNvMdjIR9BKcGHXh2_xvC0-TeR_48HOw0UHLIRqW6C6XkgWLz_DDJdVuv91f6RA_-BJPmST89tlI2S-Nma4XOZrBAB7A9X6OMoiHZfxKH1b5qs3UuTWBJgx5A9GEJ-urxYAfC41-WvfadlRFOPkgtS-4rwnq1u2pWj2Q2jxyY7O-Pj4pZSNjJe4yNhHR8mbgm58zeI_mZU_Y7RcH8W9IU5RClfuaBSSJ48GfkTU2cXYIr263heAblt8pcRfNbtEw58iWtJ7wFeEgkcsyi7A-1B1o3a61xqbH3wZ42qAMe133AGXrdYHoJpVXuxk8Ei0QUYFdrlkwCCzkALG-GYavaG_0HAg74KIHsNEvmbeLpl-SDqQFk3t4_DAsTEKNbjhGX58SRFgQ15oyp_lEIC6JydNHwDNjq8"},"azkge6PQ_40JzMdcgkpj21jxhl0JaQg1o6yPSCekJ4Q":{"name":"redstone-avalanche-prod-node-2","description":"Most popular tokens from the Avalanche ecosystem - prod node 2","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-avalanche-prod","evmAddress":"0x2c59617248994D12816EE1Fa77CE0a64eEB456BF","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04f5f035588502146774d0ccfd62ee5bf1d7f1dbb96aae33a79765c636b8ec75a36f5121931b5cc37215a7d4280c5700ca92daaaf93c32b06ca9f98b1f4ece624e","arweavePublicKey":"uw79mR1O15fps5uWLsvMTiE65cAzRJs1T3uvdmEksGINCsZ1yxJJhu9PYY_OniQEl-Z3JZ1cF42Vpwxaz2JF_lY1kPXO72prefyF4ew-Q2c3WgHg75nODMZ6Xq1xlIYKfEetDvEX-MhIvm454TnHOgbvmZNyi54XT5SNnmjvtQoEfKeJ1RRRXcOubt0NgDDpWbEmvQTSFlUT_m14-H0gM7yHT5C2UjS_wCM41THFs-Aw6Uce8ROKy1rAznAI2eS3O7t3evI4f3qHQxQXuTOOUqGUn6A2Oeys0CJqnb5bJrhk3j30VxBpotDwAyOLfaLB4NEjAkuBxHWIzI-34RmIgTOQEmZ3e4cOu7ymYSx2R92z-59bOleIpfzzmagTYw7nMxbvEyb75U1B3Mz3iK-YjY7EHOb953l_QcQwqhlSqFNTXjbZgchDD1GrMULolGh1DFeUflTHg-s6XGi273Ri4hhTyLDFQTUw18J39ON6D5IAg9z6PoyTOW1MjvdLoeY3zVXH7NGq-bmwFup_9v3gd-h7ZCnnu0qWQzxDepBySA7fIo5FFAwL7KoUOC1wnc62rocwlFJ3J9vp1mvFUpkSJxCOtYR7xLEZhcMBxnrewcbx5iImdPx8N3M_94D6osrKxxmH8GwE5RScsW2ws2jfruNhIxgQkY00d_q5HZ4XLws"},"WMUjPDhwoYvDqw5BNAaCt6-iLs8fhzwC0L_rT4lTxFg":{"name":"redstone-avalanche-prod-node-3","description":"Most popular tokens from the Avalanche ecosystem - prod node 3","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-avalanche-prod","evmAddress":"0x12470f7aBA85c8b81D63137DD5925D6EE114952b","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04626f2ad2cfb0b41a24276d78de8959bcf45fc5e80804416e660aab2089d15e98206526e639ee19d17c8f9ae0ce3a6ff1a8ea4ab773d0fb4214e08aad7ba978c8","arweavePublicKey":"5f6on6vYsq3Qgp-c-yuV0SRzfjKHaRTcfKNCsXnB1dkfKHCncr5gFTIT7244Nco413xRMtKxmU7-05Z4cRhVgq-zlzdRFj-7VedtH0WlJpxILSevGILdAcklt6K6q2DDZWmvNlbCIXfXYum_ajNo41toc1FXq-f5AXc3FJEU1sWLxwAfDjrPvEdj67QlFAIvviM_uwATmjWyVTk48CLec-53_nsf-cGA3euLkhozLswTSEs_Mn9T7RSRVZ3VlpwGFhvzwidKclRsoSTUJGV_c3AsRfu_zRsURxMz_p6UDF1MaSo7RP-NgupW9EQ2itGVTMcNHKalT3dKeMUHiCjnxldAkZCjOzfL9t053R_Zi6pXJ_fCD2I9ysZgp1yL3yJyfbGg6uxgNIAeSo8epMZQzXJpFxKB-VEVWEFic4loMX-wCYpulMp--azq7NBAt5UPcFtqs688Ox9CmeCNrMuo82w-1qZCUtwU_orLo8K7QSwPOmitd1pUVuCZMyFL05zRmJB3cxu-PCncpiqVN0g9v3MOpGa5WVCNHNKAXtuM_y-6s3XmraBsV21o0Dpc_sxX2BU-4WHmkToH9jfHGVozMiNCM26F9cEdFy4ptz8eOIuYgqhfksgfw0zB3jJwBwPJuDqhH6n-5SqysyzOkzWAzm3reVAEXuj1MAUx3C5qScc"},"POU2msUaCzhDq32_hSsKrCH37hHlUvbqfK0-Wjuz3Is":{"name":"redstone-avalanche-prod-node-4","description":"Most popular tokens from the Avalanche ecosystem - prod node 4","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-avalanche-prod","evmAddress":"0x109B4a318A4F5ddcbCA6349B45f881B4137deaFB","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x047cea60b650ac5e72ca9991cd3c365c17db58cc6c0f385af0b05056a2d6068480093b603efcb47410e8092d60c5b85d27a3e43dc6ddc4077994e6eabd9a8ab9cb","arweavePublicKey":"2IQy3vmXQDDGJRXK7Pock02VBxtoVR7HNXMAv7QugQkZJhEYqIq4n4TANbSo0JsMVDg0NsqtPjaRSbStr-guSlvi9behNVOj6HEzcri6YMXq80MIOw8FrCWTp9M3co1mcZS8nGE82MCK9PYa8JAlVQTnZ8ahovGT39Qc3K0q5hgyR0a6auliDMAALtaPYfH60Kt2IwDlYv67UkTjarKdbQG7LZDMwdG_0PIFpfbgzW41cxcLymPmnHO1UY14UD-HuyeMclx215MhtH9RcfCIaTZZAxpGcTU06nCxyqNiff7EufaahBg5e1D4tl_3nBzUOs4OOvfk6nDts1t4_lDO_KtdxeLSp0ADLBTMZ68TKqx53Z5Rlo8PZzO85CEAQVsKb3JX-dMl0BvoRzq7lvkxo0916YQUJQgbl7ryO6m5kuekk3j6xu3ccLDdfeHmLbnfacHBoRnPbJRXM1Yx11ovsywdixyAqLCf_Gr_gGP_Sb4TunN_-_M2JVvXKsK70TtO0AUWp6nXUiN_I9dCNS3f2Asu4yWxw61dXpAiBnJEHBEKY4ctflsg1JhV1abLOuAW7xd4v7mt_XBkEmz9zNodRQux23aj_m_79wucbxkq04s3WsL6NmkoRPJ02vDdUKYUHZ7x4JkkLFmdC5kI0P9NzOMkl1s5dKAF-TD_PFVT6R8"},"9QvwJVg8PapGD6VaGPffcYajExbnJWG3HH5hG76-5xM":{"name":"redstone-avalanche-prod-node-5","description":"Most popular tokens from the Avalanche ecosystem - prod node 5","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-avalanche-prod","evmAddress":"0x83cbA8c619fb629b81A65C2e67fE15cf3E3C9747","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04a66e3eb25f4110aa9f9cae8864b39b249568c094123737541e897d924253c84279bfd0f500e85f75a0943c41ca03c95fe0c3c7339e0499b5d6993a3f580aef85","arweavePublicKey":"7RqQRi3ft2uHow196B23oBCy8og5BEe_I-VEJ3vb21hTHy_ayICIrc3FOcrjJ32i9ExWlLy9EuqsqWCczk2G34OS-N6mn9U7TlxE9BiqNydGCC7nEZ_fYj8DHPCwr6IEEWe-47uY5wHQZPstzIoAN4_zEKQT5douEctfZCaT_SN5-I9soj5Qe7iirpijQmSMfRVLvFQtVNqM_GxJWE48uYzZ9owUrYwUUvxgGFB9EfQi1dVjxThpuImughyB7KWc_Qv226TSMCLPLD3nbtAmWBxIM5SCF2nWSScB_-rGNiugXil3QZKa2CJ6zgXgdigGlufdJkOfN7DT9DocfutUtjN4Z3Z_FeliiWs-6klhYUP5RdEAZrF7Kf7E2fvpijEfsDbeFK2ZjpNrNND1F6gLIzfC7kT-bBpRqpkRQuP2Bu7O3fgnsYG5EF94KwCBeCwB3MYVW5v0S26SGRtvN_qU6knkIxiOBMsTDJaFeEKfRtW7tnLdMCyM5xIJ3Lzk566TeiOq4ivmtMRs6PT_8cN6B1crqYstuRhoYPTggIiO0WJdIKfbOMHRXbfSwgyXsvADfoEu7SywQtWnKAG7K8tOwIdEl4GJb-6yZD__Z_jpO-oLFLSszDxz_Fbba_gU7U93MwEbtMfq9Sekfqq9Syl98D4KR8ZtJdgkQTatUCc4Oj0"},"HebMpM4xI07ev3jbEWamFNmRxu2ojflQfh0b2lpjFoM":{"name":"redstone-primary-demo-node-1","description":"Data feeds from primary redstone nodes - demo node 1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-demo","evmAddress":"0xdE13FdEE7a9B483129a81794d02FCB4021069f0C","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x041c320fdaca2d381101d85f2e0fcf9c6d6ebb88f2a3b71a20ecf229c1cd0e81b541d6960b58666fce5abba84a460590c72f4e871d87b451f0b7823f98d0c41970","arweavePublicKey":"sfTEXB9ljPagrv7XodJlTs0fM1pQdsCZ5iHC6mWsFpYgNUIPX6vkA4yoEjGh3naoLz5qKYtML3RIyI6z-syI2JV7TFUyEGunSDyzWg7ZZDxeG16RwpUhsPSJ7z7eSA91YAVAYJOqzgcOI_RsdgAHrtH64apLp_8uJcndJ_oXpEuoKRO2SjE2wSnwkHodHK6F-koov8rNY6edBLfmfjtKzzS-8X8g0oKSVzNdiov_WZ0UlUelsVhd-KoC6S65QT1yg7TbVRQP0ZBhfMvtpoZh8y8ftj9VaTsIaZcu77LR1tc6zCLThZAbclGYPM1EWxJ8vUDp5XYSxF6AvTFAj2NpvHDW94Mln3ZYTv2a4UobOruO9rA4npduHlo-5klgFxJGVjGsK-w18pk13KozmW5P_DZPwK_5rcKwvUakUYY2OCF_lismG7UiIPRGtQkoWffaZDfuMI2ONidtGskqFBjgySFsdMt07Wt10h5WbLI5xmUoBpdrxQarfzECCyQ4QT--GOmtaS8G7PUbYMtpgGk4nxZnqqzNidRez_0bQLQbsIMMej9HTNvkiwW9w5e374Ek8JjiCw77yUcE2e1vUAr-IqrHD5LFSmB-H5JM_GoIGhTEjYU_-v3RkeiklwmuWBPzLdyL2mMZPANacW6cOWt4g6DyXTjRKSLY0UiPuGsJT1c"},"-qrcZLkqrgS9cNhLvy0c7gzpkGlAgwbZ6C3_hk2vvJQ":{"name":"redstone-primary-demo-node-2","description":"Data feeds from primary redstone nodes - demo node 2","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-demo","evmAddress":"0xad05Ce43E0bCD11345f08a28995951DEc30D5226","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04440a1d2f497db99d7282bf6ccaf133995ed05f992c177c1eaf7b861a9e64261d1da123bcefa6bed232755197fc5082d42696e72aaf42b45771eba336d693b9b3","arweavePublicKey":"1OgIYqYOFlYr-Yo_cFdnWisxRv8B-2x2zroc0Kcn6_f8yiD7yZBVFQOBOh-kVfcmVrCuBYPywvJevmMgIkg2t4xOsoG0y_liTYAYKjhT2tiV8xta1ykq0xvLiOVOQY4g7GCzcCV-ZPE9xc4bI9ozYnpS4NRjJM8_mOnS9I1lrefx7pjHsrTyrB3YGmmW2WJm9o1MS225PFzDmPSEghw3jlVsf-KtDXqxCCpRZGTI1kKZJ-Snm9k_19tK9MHGfVGsmT8pZJjsJmLJXHrLl1KVgDXsjxxcU2f6ZycSj5imP024Dc5w65aV1JXEey9a0wLz4y1DpxPbrUN617zL1-6xA3PyQBbbI2tpM808UILlYAYWZPBeS9-87j9Abn7wDtBuqGGribdYH-KT61lF14xozCWj8SwKk9ZiMsuk8XhTlmzWa2_xwMpDFX_GVwyueZWR4lx1PK3AMWOVfITj8xU9iPHA2msL9AZ9Hj1R12k0DXGn7pjHwUgSNXCe46nIBbjEoUVtihDGAddwXAyhBVSFriDsfqWDftYEigGbNccQh8JVfRJraP20saJLlwnFL5rYhd1nSFzEwi3yIFA2X-PjudxWHa2mTGwZYCtTMkOa2E5ucQUp8eA-N-fQJF1YNNeznv5IA-yN4e35zuVUC7dNq364bUogDAqTMojRFMzhpas"},"R4ih95AvybIzz3uKuEmpBee17J73CGkSk4bvzU_IZ_I":{"name":"redstone-primary-prod-node-1","description":"Data feeds from primary redstone nodes - prod node 1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-prod","evmAddress":"0x8BB8F32Df04c8b654987DAaeD53D6B6091e3B774","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x049a0e6cada7938a0fc616578aff2b11337d90ec4e99e9fee95e57e9d8371562b31698225fb73c666ba586842b913e67ad289f374f7a46fc873342f805a8683d4e","arweavePublicKey":"nLzSke0nHxv_kp-NVMrjlXQtVZpNlFyUybEIVZx17IAwIBRrqNJBJ5pR0_nbgtJTwXg32YiLs_1ETBaazj1HL22au_kSxa5zkHsomEi7wmioAYGN2LGcaeUWlrPq8zwDk5IniSHkGdJ7wuCLig2OyVoYpINGvRchy9NOpWylAyJjHdcOkEDTAFHKeKWAs0SeAo-VSr_V53yyRSQ-ecOpcSAMWtx-jOkxgNoMPHAX-79arV206Q-sFjGNobceNl-NhCKOEOy4BjHCQm0XVUApXQx_hVrej_j-DE3QbCGCcgskrvpYFrB7ZGfCVYToH3GDe-orbCH_Qa9Q88uIR9-hIRWnTcES3RDdb-72bvVdJVyvMqKWXdtjB-3aYS6Klyx6H7l2hYdesQzEv4IqOFctoyUqq3ECZkW5ZTZzo-vg2QatwquY12kkOB7PAkZRYjc6HEoWnZy2qv4M4RnpMiYpgjww4kcryXBBZqy4X-xAkJAjWt-XDTpIWmLBtgu9plZiOhmqgARyMtuF0NspFZCu7g5PfeQVo5lzv16CPXimXpPLhxiVoOxjSKHTeuv0xIPA9cNO_6K0XTSdUYlzkDdcnQIg5SKI3b9kE3JSkiVjjk0EfhZdrBaWolS__NNEBzqjMU5TR4bk9BQ5CTOaqXDIbCEK2_GMaJ6pzjGPfRZaMu0"},"WM9CHZ6CKf95z47krdOFFKX6kuOusBlyIVSJmcjdrEQ":{"name":"redstone-primary-prod-node-2","description":"Data feeds from primary redstone nodes - prod node 2","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-prod","evmAddress":"0xdEB22f54738d54976C4c0fe5ce6d408E40d88499","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04683f7100d67fbaccae68db4d146f7bc3090c5cbcb1351e333efd58d42f609ceeada12b0af28a6e789d6edfe25fe784dd1e86798240d4cee9f60e56848cb55965","arweavePublicKey":"yE4SZn6OcwBG0Zb4Awm9bS6rqJMcy3ldVosxCiI7bwCYsRjA_fArgtuDG9b-B6xxEC1pY0TBAJSN3HKo8XIDGJNh_xHoA__Yi_Q4OGmtFqGWbQmP78piaJ3vn9nR-vwFGPnZPLzKinzKxHKNGH16gkhblszX59oUlUQP1o2slFmD6UsJX-K3LqWSN5u_1snW4eNpyPY0UbtuNvVvSNJeaT4D7zPYhZhpt5WrYZBzmTq8HoK290wb1L-Okik072aw9XMrFNBiyyQd0thAAobferTm8Ch-lcfigwkaHDEtwD2GoJIJZ69oTX810OFz-m4JomEBck4B1dSou3aPJhjK_bnsgLztiG6N7DHps7XOyD6vVo2rJpYWMPmxLtWeXIgmNSDjypUuDH4hJOT_kp3FO5YvHBhL__RY__wNBvJ5XizilD6Rrom3PQMKmu4QWY84JDE7L1QHrwsEo7UKYpT3aNF-rrFiYYTn77fLN6iKkzouLf21etNoTqRAo-ftzTiiUtJ9ubBnYd4ne7AKRzZTS-dEOImA8w6MGjN0rkqaI78ihgIO9Zu_BClOZdWqRg3j-nwyzGcOcQeKjOU3HAWiotuioLBy603utiC7lRl8g-0VprAZfWOpJhfTX1EHyoI3AAY92joj4U_Cig8-9tCRh06BN3HaNobdQgkLeEk5KpU"},"9syjTFZp0__CsqnMjKEo6sjl6_yRWYm7TQjcD0hFEN8":{"name":"redstone-primary-prod-node-3","description":"Data feeds from primary redstone nodes - prod node 3","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-prod","evmAddress":"0x51Ce04Be4b3E32572C4Ec9135221d0691Ba7d202","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04490f08821dea02d23683f170459aa6317dd65b544aac1df514f2e657f87ac00b81757edce3e78785e00dcd92e2dc8ddd9a680dc929a0c91062d87ae000a217ce","arweavePublicKey":"uFmwr5_2RAokGbqABO6edwcbsVhctDmKWG-velfxBvqjGU9YUc3QIentdWPBEaA4xcXlQC1fz8-woXEqqUjTjYyDpZ_1FEaftIVgQFyxzT2OW--8Mnox7uwqvmtAZLejxRibj4YYyqxO81tF4m5MVpgewoBBep0p_nCsBtN50iV4VtG6oPOOiFa9p1Hk-h2ja8K57qfn3Pxh6g2jmk2FVCo9JAgHCoSat8IT_QQ9BRw4pOTyZbTzM-7K28FjKHJqaQ8fRK0bZkMmzt8LhXUZVQCqHWeaLaMoNFikDTWZ_ia-SEr6_T_QlybPoj07TIwkMpVNDMAFcmltHBoLtNDfXG3fyDAQe9fZPp4H4ER5VLi_MoEB0UM2feLZNIpiwSCWEtOUvamBaCbtRBObdQZPphbP3Iof2VZvavnwHRE5FHnLFuXpnwMPmJADDwIdetUxNKW42QGl5nG43IC18ufYBH-hV6rEdlxd5hHPqw7wknGQ9fW_686Z_qE2U7Lc37OO0a1tT6877IuOYpO8GGm5YOS0lc0A7jP5RBO5EWsS_8xZyKKo2aUP5f39-WZid6lRAtwseSvr9oJbRLS5jfCGb9WTJ0VzQEgCpcp1eVaMSDBvXb-4p6lOr1Z7OD0loSHiAsNZWUdAqmRLAZROZsXI6r_z5J_vrW82ZkFTRIeNdeE"},"4dRTLZeJPaDMhGE2jUndt-3KIOQxO6Y_BCV-3KIiPhI":{"name":"redstone-primary-prod-node-4","description":"Data feeds from primary redstone nodes - prod node 4","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-prod","evmAddress":"0xDD682daEC5A90dD295d14DA4b0bec9281017b5bE","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04a221496ff2436da121796c11f888cc4e2155da7e36bd1148c9466fb54627f15e42d4cfed06b1570b7ebe0c589acf91fd314cfd95303c9894c0be43432aba619f","arweavePublicKey":"3gACwmU3yQTUU4eHYWvWYzXh96royDi3Uce7shiBk0TeK2aaKGqR0pswjbWLUF1A22JmfuD-ItrkKKAfX5Mhj7GgFrDcPA0D2soA0hRQGh5qkLi4iSxXb8BdD4suG-dN2y2_Zn1zMmcoWHHxgxmr-mtD5t4H1CrIxFF4dLQWJ44ydFwTmIxvVaZzSYA8sC5z2Q_hIzr90Z1DdEJUcJomXbKPeymeuVeKxCfPab93czr5-wm11I_sNx9dTTzRW90_jiZ99aSbSVY_R6jWQ2vAfbCqoHIqsHEk7Yc4WNjXlh7aZMBi5hPW3zrnN-ZnDDLXgBu4KrBqAFH-8jL4sfwe51ifKkosRu0DLx0kItpp3mgkKVUcsR513kQE49bxmFhhy3dbyUoJktetrWqg6iMPHMMB4ybXHsoqOHXou1vPtLTCxtNvTZJvUes3v47fs-04ThebpyAPPEDrVqt4mNCYzapvDE-RgWrnQrKLAIbXJspcggro5u_rdNl4hSDGgmFJhXTu2AIVoAjNTk9ARXtgo4K8RWcQKjZ8qotq30NNwqNE9GVk2EEJDnj-Jj_1_Dtkd0jozE0VyjaA9eT5NyZ2s1tfVS2pbNCC18sezte0PGeAwD7EqoJoYxgbmX6MPQhfyanSc3KSYi9fi_YYYmHT0n_uCUy9QR2Zvz5895QETB0"},"wZv_gFZgozLm2xjUaMZPzvgr6E4VcUlRZMXZOILfBXw":{"name":"redstone-primary-prod-node-5","description":"Data feeds from primary redstone nodes - prod node 5","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-primary-prod","evmAddress":"0x9c5AE89C4Af6aA32cE58588DBaF90d18a855B6de","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04f23aa199aeda6e55628e0ec88194c47713ba260898aae4483fb2f166c7e29b1664f817922059736358de71bdf374b3354db58d15f928a6fac9d1f61e284019b7","arweavePublicKey":"2p14sG942MfNwRQnPPF78vdxXovnz0hSTUYiSmCvPlQHojPQyDdfX2fbML09kbkeq8TNQel7BzShDVDpfhM21lXDQhvW8kQTSk6I2qilZIbYRi4i0omgHLw6QnUOGPBdxUdbRSq63gH5A0aR_ATPgzKNwSZpViG3CODgOVRUWtzWlaHKGx3D5oloKnS9nnJJlZSh2sbDfq7MIOlZEHDpunERLByLlsxi33oj1YsrcV2rP_tUUDbuDNLWhwHorAjZqDKmPP0FEy38oABrB-NbDNihPs06V2wMNb4U6tlLiEcsfNTagWpQ8re6K3WpK5XKBOcaOhVqcmo2axP1go35pjV6RuISCQWGGqvnyeAsKdGjDANtSk5RYqjqy6cQTJfEKrHZbv2MaiLr5EUsnzP_9u4ZCo8vcVXj4BLLDIYNvm4b_Ik2j8ZoA432u2hAMtQYZNqfencj9kiKzBRoeDQF4nsJOQ5YUHkyS_a1Vnq0KPslPbACApJZntCz3LR2Te_ZxJePM_v9O6jtX2bTsRgkjGF5dWD4OFda89mFSKn9ZBzgysMTWiJsLYnnqPVW8zIP2PjG7VgfkpEIDzWFbCJiX2aevGT94P5pTuI9AF1cyKMX0kxeDibbqg6m9LixPqY0Kdm6pOwGa1RWP2tprPoQuS9uepP1vyzJEzk6jAyaQqU"},"ckah_Yc4ZhzQbx27Lgo1Ad1yePneQdkusER_c49KVK0":{"name":"redstone-arbitrum-prod-node-1","description":"Data feeds from arbitrum redstone nodes - prod 1","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-arbitrum-prod","evmAddress":"0x345Efd26098e173F811e3B9Af1B0e0a11872B38b","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x0437026448b1a69e4be9bcee0789199c50e93446c75eb697efbeb732fa3b51d130f92d6597de811106511ba39f712f8cf025b82e0003a611b9f78804e66caf46d8"},"3HHevuTyFGYJJ-nBPonvDaB5oGIZbCbZtF0CAeFB13s":{"name":"redstone-arbitrum-prod-node-2","description":"Data feeds from arbitrum redstone nodes - prod 2","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-arbitrum-prod","evmAddress":"0xbD0c5ccd85D5831B10E3e49527B8Cd67e2EFAf39","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x046ecbc2bcca15fb4a44b88e85e1433b22ad09b7960370c9dba379e09f37ebea0cbc3fb9a60f39df2c4b7cd8b885717ca1dafeac35e9edc5b550d0b61c4a7e581f"},"AkT1al4MbVqV8w9LXIvdsE-2xm_moP1ARaImUlqgDZA":{"name":"redstone-arbitrum-prod-node-3","description":"Data feeds from arbitrum redstone nodes - prod 3","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-arbitrum-prod","evmAddress":"0x2F3E8EC88C01593d10ca9461c807660fF2D8DB28","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x047f0ac528b5b5f306b6488965bcd86cce263487320caaab7703171c8cf461eb692cd35837ff91d243d2972fc4c4598d08d8e1f5795ecbb1cb974087970a5783d8"},"k9ke_oPBAy4bt-Vu0_kwRcSx4HwcQl3Jd8h7dmomfrc":{"name":"redstone-arbitrum-prod-node-4","description":"Data feeds from arbitrum redstone nodes - prod 4","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-arbitrum-prod","evmAddress":"0xb7f154bB5491565D215F4EB1c3fe3e84960627aF","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04e051f36116b6bc953f2a94825a4931f6fe6e3a3f218e1dab2712a2a31fff450d1e8f82dcb3cba9dce6dd382d6b0e259d2a896f8a10947a234c08e6f424d272c9"},"7zqOor2CATpcOq_DduEAsJ_8us4FJ0BTZbMjLAH4MsU":{"name":"redstone-arbitrum-prod-node-5","description":"Data feeds from arbitrum redstone nodes - prod 5","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","dataServiceId":"redstone-arbitrum-prod","evmAddress":"0xE6b0De8F4B31F137d3c59b5a0A71e66e7D504Ef9","url":"https://redstone.finance","ipAddress":"0.0.0.0","ecdsaPublicKey":"0x04b41ed2eaf2b8b15232ab7d25458d1b2cc1ef02200ab50f912307cf832f619aadf89800ac17b1c3e40c4bebc7b4305bbec558ca5e60acb034dbb6c09273e29fbe"},"00HZS36ZwzP43q25-T_UV7pYlNXe9ChwDpNiM7A708c":{"url":"https://redstone.finance","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"redstone-fast-demo","ipAddress":"0.0.0.0","dataServiceId":"redstone-fast-demo","description":"Very frequent updates from the fastest sources","evmAddress":"0x69f70Aa9828Ed876d49e83Ee006b9d333BB406d8","ecdsaPublicKey":"0x04d048bea3bcf01b82162703a7f59cf51d91a95a8fd3921b5a858a8ff1c1b858dd337918cb7969c695711f590779ffb9a1028d0205074f11d9fd40e905f6670d0a"}},"evolve":null,"canEvolve":true,"dataServices":{"redstone-main-demo":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Main Demo","admin":"I-5rWUehEv-MjdK9gFw09RxfSLQX9DIHxG614Wf8qo0","description":"Main RedStone Provider with all available tokens.","manifestTxId":"kXYM3AezlROPoEDCt_802-k9ZxeceAWzHtrERmR2zEg"},"redstone-rapid-demo":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Rapid Demo","admin":"zYqPZuALSPa_f5Agvf8g2JHv94cqMn9aBtnH7GFHbuA","description":"Most popular tokens with frequent updates","manifestTxId":"5iQ5tPebRcdB4OjLZvaCMftREpP_P-V-F0J0WAgyLFI"},"redstone-stocks-demo":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Stocks Demo","admin":"Yba8IVc_01bFxutKNJAZ7CmTD5AVi2GcWXf1NajPAsc","description":"Stocks, ETFs, Livestocks, Metals, Energies...","manifestTxId":"MmWSoOPdKoyRlJ7Qhrvp3odBu0881Ou379e19SxDxKg"},"redstone-avalanche-demo":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Avalanche Demo","admin":"f1Ipos2fVPbxPVO65GBygkMyW0tkAhp2hdprRPPBBN8","description":"Most popular tokens from the Avalanche ecosystem - demo","manifestTxId":"erTjNqoLYB9Jw9zZXJPYxmijE5ElEhDM_52quvK83ws"},"redstone-avalanche-prod":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Avalanche Prod","admin":"TEHhCDWy-vGmPSZsYJyM0aP_MM4xESgyIZdf5mVODzg","description":"Most popular tokens from the Avalanche ecosystem - prod","manifestTxId":"y7ppr6m9MuP65Fiivd9CX84qcPLoYBMifUrFK3jXw2k"},"redstone-primary-demo":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Primary Demo","admin":"TEHhCDWy-vGmPSZsYJyM0aP_MM4xESgyIZdf5mVODzg","description":"Data feeds from primary RedStone nodes - demo","manifestTxId":""},"redstone-primary-prod":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Primary Prod","admin":"TEHhCDWy-vGmPSZsYJyM0aP_MM4xESgyIZdf5mVODzg","description":"Data feeds from primary RedStone nodes - prod","manifestTxId":""},"redstone-arbitrum-demo":{"name":"RedStone arbitrum demo","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Data feeds from dev arbitrum redstone nodes"},"redstone-arbitrum-prod":{"name":"RedStone arbitrum prod","logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","description":"Data feeds from arbitrum prod redstone nodes"},"redstone-fast-demo":{"logo":"https://redstone.finance/assets/img/redstone-logo-full.svg","name":"RedStone Fast Demo","admin":"00HZS36ZwzP43q25-T_UV7pYlNXe9ChwDpNiM7A708c","description":"Most popular tokens with fast updates","manifestTxId":""}},"contractAdmins":["I-5rWUehEv-MjdK9gFw09RxfSLQX9DIHxG614Wf8qo0","zYqPZuALSPa_f5Agvf8g2JHv94cqMn9aBtnH7GFHbuA","Yba8IVc_01bFxutKNJAZ7CmTD5AVi2GcWXf1NajPAsc","33F0QHcb22W7LwWR1iRC8Az1ntZG09XQ03YWuw2ABqA","BitVOfTwSSod-tUSla4nM77sUuHC4XFcT0Zlg-RZ-tI"]}');

});


parcelRegister("6vSZI", function(module, exports) {
"use strict";
var $4be04c11a142b278$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4be04c11a142b278$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4be04c11a142b278$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4be04c11a142b278$var$__createBinding(exports1, m, p);
};
var $4be04c11a142b278$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4be04c11a142b278$var$__createBinding(result, mod, k);
    }
    $4be04c11a142b278$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.consts = module.exports.utils = module.exports.Serializable = void 0;

$4be04c11a142b278$var$__exportStar((parcelRequire("3Cpsw")), module.exports);

$4be04c11a142b278$var$__exportStar((parcelRequire("872HT")), module.exports);

$4be04c11a142b278$var$__exportStar((parcelRequire("dnpyO")), module.exports);

$4be04c11a142b278$var$__exportStar((parcelRequire("57RSt")), module.exports);

$4be04c11a142b278$var$__exportStar((parcelRequire("hHFIh")), module.exports);

$4be04c11a142b278$var$__exportStar((parcelRequire("fCX2N")), module.exports);

$4be04c11a142b278$var$__exportStar((parcelRequire("2klN4")), module.exports);

$4be04c11a142b278$var$__exportStar((parcelRequire("ldQYL")), module.exports);

$4be04c11a142b278$var$__exportStar((parcelRequire("3VZzj")), module.exports);

var $t9PVr = parcelRequire("t9PVr");
Object.defineProperty(module.exports, "Serializable", {
    enumerable: true,
    get: function() {
        return $t9PVr.Serializable;
    }
});

module.exports.utils = $4be04c11a142b278$var$__importStar((parcelRequire("1rXfw")));

module.exports.consts = $4be04c11a142b278$var$__importStar((parcelRequire("4nqB9")));

$4be04c11a142b278$var$__exportStar((parcelRequire("eVP1d")), module.exports);

$4be04c11a142b278$var$__exportStar((parcelRequire("04HNS")), module.exports);

});

parcelRegister("gbByN", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ContractParamsProviderMock = void 0;

var $j2rU8 = parcelRequire("j2rU8");

var $ji93N = parcelRequire("ji93N");

var $dC18G = parcelRequire("dC18G");
class $bc8acf1436779a5c$var$ContractParamsProviderMock extends $dC18G.ContractParamsProvider {
    requestPayload(_) {
        return Promise.resolve(this.fileReader(this.filePath).toString());
    }
    getHexlifiedFeedIds() {
        var _this_overriddenFeedIds;
        return ((_this_overriddenFeedIds = this.overriddenFeedIds) === null || _this_overriddenFeedIds === void 0 ? void 0 : _this_overriddenFeedIds.map((feed)=>(0, $j2rU8.hexlify)((0, $ji93N.toUtf8Bytes)(feed)))) || super.getHexlifiedFeedIds();
    }
    constructor(dataFeeds, filePath, fileReader){
        super({
            uniqueSignersCount: 0,
            dataServiceId: "",
            dataFeeds: dataFeeds
        });
        (0, $dxWQo._)(this, "filePath", void 0);
        (0, $dxWQo._)(this, "fileReader", void 0);
        (0, $dxWQo._)(this, "overriddenFeedIds", void 0);
        this.filePath = filePath;
        this.fileReader = fileReader;
    }
}
module.exports.ContractParamsProviderMock = $bc8acf1436779a5c$var$ContractParamsProviderMock;

});

parcelRegister("aToIW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eSakG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("d0cPf", function(module, exports) {
"use strict";
var $9775395385070320$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.aggregateValues = module.exports.getDataFeedValues = void 0;

var $72fYR = parcelRequire("72fYR");

const $9775395385070320$var$axios_1 = $9775395385070320$var$__importDefault((parcelRequire("28feZ")));

var $hacYN = parcelRequire("hacYN");
const $9775395385070320$var$DEFAULT_DATA_SERVICE_ID = "redstone-main-demo";
const $9775395385070320$var$DEFAULT_AGGREGATION_ALGORITHM = "median";
const $9775395385070320$var$getDataFeedValues = async (args = {})=>{
    var _args_dataServiceId;
    const dataServiceId = (_args_dataServiceId = args.dataServiceId) !== null && _args_dataServiceId !== void 0 ? _args_dataServiceId : $9775395385070320$var$DEFAULT_DATA_SERVICE_ID;
    var _args_aggregationAlgorithm;
    const aggregationAlgorithm = (_args_aggregationAlgorithm = args.aggregationAlgorithm) !== null && _args_aggregationAlgorithm !== void 0 ? _args_aggregationAlgorithm : $9775395385070320$var$DEFAULT_AGGREGATION_ALGORITHM;
    var _args_gatewayUrls;
    const gatewayUrls = (_args_gatewayUrls = args.gatewayUrls) !== null && _args_gatewayUrls !== void 0 ? _args_gatewayUrls : (0, $hacYN.resolveDataServiceUrls)(dataServiceId);
    const dataPackagesPerFeed = await Promise.any(gatewayUrls.map((url)=>$9775395385070320$var$getDataPackagesFromGateway(url, dataServiceId)));
    const result = {};
    for (const [dataFeedId, dataPackages] of Object.entries(dataPackagesPerFeed)){
        const plainValues = dataPackages.filter((dp)=>dp.dataPoints.length === 1).map((dp)=>Number(dp.dataPoints[0].value));
        if (plainValues.length === 0) continue;
        result[dataFeedId] = (0, module.exports.aggregateValues)(plainValues, aggregationAlgorithm);
    }
    return result;
};
module.exports.getDataFeedValues = $9775395385070320$var$getDataFeedValues;
const $9775395385070320$var$getDataPackagesFromGateway = async (url, dataServiceId)=>{
    const response = await $9775395385070320$var$axios_1.default.get(`${url}/data-packages/latest/${dataServiceId}`);
    if (typeof response.data === "string") throw new Error(`Failed to fetch data package from ${url}. Data service ID responded with: ${String(response.data)}`);
    return response.data;
};
const $9775395385070320$var$aggregateValues = (plainValues, aggregationAlgorithm)=>{
    switch(aggregationAlgorithm){
        case "max":
            return Math.max(...plainValues);
        case "min":
            return Math.min(...plainValues);
        case "median":
            return $72fYR.MathUtils.getMedian(plainValues);
        default:
            throw new Error(`Unsupported aggregationAlgorithm ${String(aggregationAlgorithm)}`);
    }
};
module.exports.aggregateValues = $9775395385070320$var$aggregateValues;

});

parcelRegister("2Cggk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetchDataPackages = void 0;

var $72fYR = parcelRequire("72fYR");

var $hacYN = parcelRequire("hacYN");
const $1e7bbebe28837dba$var$fetchDataPackages = async ({ dataServiceId: dataServiceId, gatewayUrls: gatewayUrls })=>{
    const resolvedGatewayUrls = gatewayUrls !== null && gatewayUrls !== void 0 ? gatewayUrls : (0, $hacYN.resolveDataServiceUrls)(dataServiceId);
    const urls = resolvedGatewayUrls.map((baseUrl)=>`${baseUrl}/data-packages/latest/${dataServiceId}`);
    const responseFromGateway = await $72fYR.RedstoneCommon.fetchWithFallbacks({
        urls: urls
    });
    return responseFromGateway.data;
};
module.exports.fetchDataPackages = $1e7bbebe28837dba$var$fetchDataPackages;

});

parcelRegister("8hx3Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7Re1c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("fXHzY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.startSimpleRelayer = void 0;

var $72fYR = parcelRequire("72fYR");
async function $b9ee2b9ab4aff3d3$var$startSimpleRelayer(config, connector) {
    const relayerIterationInterval = Number(config.relayerIterationInterval);
    const updatePriceInterval = Number(config.updatePriceInterval);
    const adapter = await connector.getAdapter();
    let pendingTransactionHash;
    console.log(`Starting contract prices updater with interval ${relayerIterationInterval / 1000} s.`);
    setInterval(async ()=>{
        {
            (0, $72fYR.sendHealthcheckPing)(config.healthcheckPingUrl);
            let txHash;
            try {
                if (pendingTransactionHash != undefined) return console.log(`Skipping, because there exists a pending transaction: ${pendingTransactionHash}`);
                const timestampAndRound = await adapter.readTimestampAndRound();
                const currentTimestamp = Date.now();
                const timestampDelta = currentTimestamp - timestampAndRound.payload_timestamp;
                const isEnoughTimeElapsedSinceLastUpdate = timestampDelta >= updatePriceInterval;
                if (!isEnoughTimeElapsedSinceLastUpdate) return console.log(`Skipping, because not enough time has passed to update prices (${timestampDelta / 1000} s. of ${updatePriceInterval / 1000} s.)`);
                var _timestampAndRound_round;
                const round = (_timestampAndRound_round = timestampAndRound.round) !== null && _timestampAndRound_round !== void 0 ? _timestampAndRound_round : -1;
                pendingTransactionHash = "...";
                txHash = await adapter.writePrices(round + 1);
                console.log(`Started updating prices (round: ${round + 1}) with transaction: ${txHash}`);
                pendingTransactionHash = txHash;
                console.log(`Waiting for the transaction's status changes...`);
                await connector.waitForTransaction(txHash);
            } catch (error) {
                console.error(error.stack || error);
            } finally{
                if (pendingTransactionHash === txHash || pendingTransactionHash === "...") pendingTransactionHash = undefined;
            }
        }
    }, relayerIterationInterval);
}
module.exports.startSimpleRelayer = $b9ee2b9ab4aff3d3$var$startSimpleRelayer;

});



parcelRegister("kHc9u", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StarknetContractConnector = module.exports.FEE_MULTIPLIER = void 0;

var $3GDHM = parcelRequire("3GDHM");
module.exports.FEE_MULTIPLIER = 1000000000000000000;
class $f1113ff551ce102d$var$StarknetContractConnector {
    async waitForTransaction(txHash) {
        var _result_status;
        const successState = $3GDHM.TransactionFinalityStatus.ACCEPTED_ON_L2;
        const result = await this.provider.waitForTransaction(txHash, {
            successStates: [
                successState
            ]
        });
        const successfulResult = result;
        let logText = `Transaction ${txHash} finished with status: ${successfulResult.execution_status}`;
        logText += `, fee: ${parseInt(successfulResult.actual_fee.amount) / module.exports.FEE_MULTIPLIER} ETH`;
        console.log(logText);
        return ((_result_status = result.status) === null || _result_status === void 0 ? void 0 : _result_status.toString()) === successState.toString();
    }
    getContract() {
        return new $3GDHM.Contract(this.abi, this.contractAddress, this.provider);
    }
    async getBlockNumber() {
        return (await this.provider.getBlock($3GDHM.BlockTag.latest)).block_number;
    }
    constructor(provider, contractAddress, abi){
        (0, $dxWQo._)(this, "provider", void 0);
        (0, $dxWQo._)(this, "contractAddress", void 0);
        (0, $dxWQo._)(this, "abi", void 0);
        this.provider = provider;
        this.contractAddress = contractAddress;
        this.abi = abi;
    }
}
module.exports.StarknetContractConnector = $f1113ff551ce102d$var$StarknetContractConnector;

});
parcelRegister("3GDHM", function(module, exports) {

$parcel$export(module.exports, "constants", function () { return $facb0cbc5626d02c$export$1a988e7317c65621; });
$parcel$export(module.exports, "encode", function () { return $facb0cbc5626d02c$export$c564cdbbe6da493; });
$parcel$export(module.exports, "types", function () { return $facb0cbc5626d02c$export$b14ad400b1d09e0f; });
$parcel$export(module.exports, "BlockStatus", function () { return $facb0cbc5626d02c$export$551bfb62fbe5f7ab; });
$parcel$export(module.exports, "BlockTag", function () { return $facb0cbc5626d02c$export$472371b62fbd4d78; });
$parcel$export(module.exports, "EntryPointType", function () { return $facb0cbc5626d02c$export$c5a05fb778755707; });
$parcel$export(module.exports, "Literal", function () { return $facb0cbc5626d02c$export$e175ae9e414693bc; });
$parcel$export(module.exports, "RPC", function () { return $facb0cbc5626d02c$export$83f82714246b5968; });
$parcel$export(module.exports, "SIMULATION_FLAG", function () { return $facb0cbc5626d02c$export$2dc1f918d7b47fd1; });
$parcel$export(module.exports, "Sequencer", function () { return $facb0cbc5626d02c$export$f195f25b42d46a8c; });
$parcel$export(module.exports, "TransactionExecutionStatus", function () { return $facb0cbc5626d02c$export$8b96ee174325dd47; });
$parcel$export(module.exports, "TransactionFinalityStatus", function () { return $facb0cbc5626d02c$export$be404a55d98e2f85; });
$parcel$export(module.exports, "TransactionStatus", function () { return $facb0cbc5626d02c$export$7c391bd3b61d2374; });
$parcel$export(module.exports, "TransactionType", function () { return $facb0cbc5626d02c$export$d513b00599f845d4; });
$parcel$export(module.exports, "TypedDataRevision", function () { return $facb0cbc5626d02c$export$c66c875ce2a199f3; });
$parcel$export(module.exports, "Uint", function () { return $facb0cbc5626d02c$export$f5013dbad57df7b8; });
$parcel$export(module.exports, "ValidateType", function () { return $facb0cbc5626d02c$export$7699f7ca8780a690; });
$parcel$export(module.exports, "num", function () { return $facb0cbc5626d02c$export$61cc6a0be4938a2a; });
$parcel$export(module.exports, "selector", function () { return $facb0cbc5626d02c$export$aea217a45095ce11; });
$parcel$export(module.exports, "shortString", function () { return $facb0cbc5626d02c$export$bcef2cf0ec329fbf; });
$parcel$export(module.exports, "cairo", function () { return $facb0cbc5626d02c$export$3973b1d14008fbc3; });
$parcel$export(module.exports, "uint256", function () { return $facb0cbc5626d02c$export$fa66cedfaa3c10f3; });
$parcel$export(module.exports, "CairoCustomEnum", function () { return $facb0cbc5626d02c$export$275e96c4fd8075e5; });
$parcel$export(module.exports, "CairoOptionVariant", function () { return $facb0cbc5626d02c$export$af05e77076421fd9; });
$parcel$export(module.exports, "CairoOption", function () { return $facb0cbc5626d02c$export$b8ecf101591c7ba8; });
$parcel$export(module.exports, "CairoResultVariant", function () { return $facb0cbc5626d02c$export$1ae9a7bcb35c2aee; });
$parcel$export(module.exports, "CairoResult", function () { return $facb0cbc5626d02c$export$9c95511f15ff4e93; });
$parcel$export(module.exports, "CallData", function () { return $facb0cbc5626d02c$export$ac0e6ca389c6ad0e; });
$parcel$export(module.exports, "hash", function () { return $facb0cbc5626d02c$export$d6af199866bfb566; });
$parcel$export(module.exports, "ec", function () { return $facb0cbc5626d02c$export$6be572eb25b0fc90; });
$parcel$export(module.exports, "json", function () { return $facb0cbc5626d02c$export$7b419323e6ed4f31; });
$parcel$export(module.exports, "stark", function () { return $facb0cbc5626d02c$export$56c09bfdffd6a7c6; });
$parcel$export(module.exports, "isSierra", function () { return $facb0cbc5626d02c$export$6050805ab301367e; });
$parcel$export(module.exports, "extractContractHashes", function () { return $facb0cbc5626d02c$export$dae6fc4ab9af26b8; });
$parcel$export(module.exports, "contractClassResponseToLegacyCompiledContract", function () { return $facb0cbc5626d02c$export$ad96edd8d0a43d0; });
$parcel$export(module.exports, "provider", function () { return $facb0cbc5626d02c$export$ca328f169d304df4; });
$parcel$export(module.exports, "fixStack", function () { return $facb0cbc5626d02c$export$7b03f7b96cafe5bf; });
$parcel$export(module.exports, "fixProto", function () { return $facb0cbc5626d02c$export$81ffe03534f80f3; });
$parcel$export(module.exports, "CustomError", function () { return $facb0cbc5626d02c$export$f7a70f5f17339408; });
$parcel$export(module.exports, "LibraryError", function () { return $facb0cbc5626d02c$export$8c05b2dc6219e90a; });
$parcel$export(module.exports, "GatewayError", function () { return $facb0cbc5626d02c$export$8ef93724ecb8bcb7; });
$parcel$export(module.exports, "HttpError", function () { return $facb0cbc5626d02c$export$65bd6083489bd8bb; });
$parcel$export(module.exports, "starknetId", function () { return $facb0cbc5626d02c$export$b55e51a2a2c4239a; });
$parcel$export(module.exports, "getDefaultNodeUrl", function () { return $facb0cbc5626d02c$export$f891d455a8552325; });
$parcel$export(module.exports, "RpcProvider", function () { return $facb0cbc5626d02c$export$578ebb3f1f89cda2; });
$parcel$export(module.exports, "isUrl", function () { return $facb0cbc5626d02c$export$8304a22d431f958; });
$parcel$export(module.exports, "buildUrl", function () { return $facb0cbc5626d02c$export$b5cd97dee32de81d; });
$parcel$export(module.exports, "SequencerProvider", function () { return $facb0cbc5626d02c$export$257d155889fba954; });
$parcel$export(module.exports, "Provider", function () { return $facb0cbc5626d02c$export$2881499e37b75b9a; });
$parcel$export(module.exports, "SignerInterface", function () { return $facb0cbc5626d02c$export$c7f3abef082132e7; });
$parcel$export(module.exports, "transaction", function () { return $facb0cbc5626d02c$export$2d62d2646dd2fb3c; });
$parcel$export(module.exports, "typedData", function () { return $facb0cbc5626d02c$export$2ebe69e89b76b6ec; });
$parcel$export(module.exports, "merkle", function () { return $facb0cbc5626d02c$export$483e047521be7129; });
$parcel$export(module.exports, "Signer", function () { return $facb0cbc5626d02c$export$fdf54fdde81cc9f0; });
$parcel$export(module.exports, "parseUDCEvent", function () { return $facb0cbc5626d02c$export$6ca6f6e3d378ddec; });
$parcel$export(module.exports, "Account", function () { return $facb0cbc5626d02c$export$1ed4b10e4aba04a7; });
$parcel$export(module.exports, "ProviderInterface", function () { return $facb0cbc5626d02c$export$8efff2d796cdea69; });
$parcel$export(module.exports, "defaultProvider", function () { return $facb0cbc5626d02c$export$dc63293f8fab0911; });
$parcel$export(module.exports, "AccountInterface", function () { return $facb0cbc5626d02c$export$73debe15cf2a7ba5; });
$parcel$export(module.exports, "events", function () { return $facb0cbc5626d02c$export$4bf9923669ad6c63; });
$parcel$export(module.exports, "splitArgsAndOptions", function () { return $facb0cbc5626d02c$export$b1054f420eacbc82; });
$parcel$export(module.exports, "getCalldata", function () { return $facb0cbc5626d02c$export$6129b52a695a0660; });
$parcel$export(module.exports, "Contract", function () { return $facb0cbc5626d02c$export$8517d80acf00e19a; });
$parcel$export(module.exports, "ContractInterface", function () { return $facb0cbc5626d02c$export$c16ebf97b4a8324a; });
$parcel$export(module.exports, "ContractFactory", function () { return $facb0cbc5626d02c$export$505569a6bf584fd9; });
$parcel$export(module.exports, "addAddressPadding", function () { return $facb0cbc5626d02c$export$74cf7857f9f0313c; });
$parcel$export(module.exports, "validateAndParseAddress", function () { return $facb0cbc5626d02c$export$5049782b602a3e5d; });
$parcel$export(module.exports, "getChecksumAddress", function () { return $facb0cbc5626d02c$export$c696806606bb1429; });
$parcel$export(module.exports, "validateChecksumAddress", function () { return $facb0cbc5626d02c$export$26bc63e5b5463ece; });
$parcel$export(module.exports, "number", function () { return $facb0cbc5626d02c$export$98e628dec113755e; });

var $dxWQo = parcelRequire("dxWQo");

var $dGHtD = parcelRequire("dGHtD");

var $85BMf = parcelRequire("85BMf");

var $5GNKL = parcelRequire("5GNKL");

var $2XPJl = parcelRequire("2XPJl");

var $8fWHv = parcelRequire("8fWHv");

var $kCOjY = parcelRequire("kCOjY");

var $kGJ2Q = parcelRequire("kGJ2Q");

var $jxHwd = parcelRequire("jxHwd");

var $4oIhN = parcelRequire("4oIhN");
var $facb0cbc5626d02c$var$__defProp = Object.defineProperty;
var $facb0cbc5626d02c$var$__export = (target, all)=>{
    for(var name in all)$facb0cbc5626d02c$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/constants.ts
var $facb0cbc5626d02c$export$1a988e7317c65621 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$1a988e7317c65621, {
    ADDR_BOUND: ()=>$facb0cbc5626d02c$var$ADDR_BOUND,
    API_VERSION: ()=>$facb0cbc5626d02c$var$API_VERSION,
    BN_FEE_TRANSACTION_VERSION_1: ()=>$facb0cbc5626d02c$var$BN_FEE_TRANSACTION_VERSION_1,
    BN_FEE_TRANSACTION_VERSION_2: ()=>$facb0cbc5626d02c$var$BN_FEE_TRANSACTION_VERSION_2,
    BN_TRANSACTION_VERSION_1: ()=>$facb0cbc5626d02c$var$BN_TRANSACTION_VERSION_1,
    BN_TRANSACTION_VERSION_2: ()=>$facb0cbc5626d02c$var$BN_TRANSACTION_VERSION_2,
    BaseUrl: ()=>$facb0cbc5626d02c$var$BaseUrl,
    HEX_STR_TRANSACTION_VERSION_1: ()=>$facb0cbc5626d02c$var$HEX_STR_TRANSACTION_VERSION_1,
    HEX_STR_TRANSACTION_VERSION_2: ()=>$facb0cbc5626d02c$var$HEX_STR_TRANSACTION_VERSION_2,
    IS_BROWSER: ()=>$facb0cbc5626d02c$var$IS_BROWSER,
    MASK_250: ()=>$facb0cbc5626d02c$var$MASK_250,
    MAX_STORAGE_ITEM_SIZE: ()=>$facb0cbc5626d02c$var$MAX_STORAGE_ITEM_SIZE,
    NetworkName: ()=>$facb0cbc5626d02c$var$NetworkName,
    RPC_DEFAULT_VERSION: ()=>$facb0cbc5626d02c$var$RPC_DEFAULT_VERSION,
    RPC_NODES: ()=>$facb0cbc5626d02c$var$RPC_NODES,
    StarknetChainId: ()=>$facb0cbc5626d02c$var$StarknetChainId,
    TEXT_TO_FELT_MAX_LEN: ()=>$facb0cbc5626d02c$var$TEXT_TO_FELT_MAX_LEN,
    TransactionHashPrefix: ()=>$facb0cbc5626d02c$var$TransactionHashPrefix,
    UDC: ()=>$facb0cbc5626d02c$var$UDC,
    ZERO: ()=>$facb0cbc5626d02c$var$ZERO
});
// src/utils/encode.ts
var $facb0cbc5626d02c$export$c564cdbbe6da493 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$c564cdbbe6da493, {
    IS_BROWSER: ()=>$facb0cbc5626d02c$var$IS_BROWSER,
    addHexPrefix: ()=>$facb0cbc5626d02c$var$addHexPrefix,
    arrayBufferToString: ()=>$facb0cbc5626d02c$var$arrayBufferToString,
    atobUniversal: ()=>$facb0cbc5626d02c$var$atobUniversal,
    btoaUniversal: ()=>$facb0cbc5626d02c$var$btoaUniversal,
    buf2hex: ()=>$facb0cbc5626d02c$var$buf2hex,
    calcByteLength: ()=>$facb0cbc5626d02c$var$calcByteLength,
    padLeft: ()=>$facb0cbc5626d02c$var$padLeft,
    pascalToSnake: ()=>$facb0cbc5626d02c$var$pascalToSnake,
    removeHexPrefix: ()=>$facb0cbc5626d02c$var$removeHexPrefix,
    sanitizeBytes: ()=>$facb0cbc5626d02c$var$sanitizeBytes,
    sanitizeHex: ()=>$facb0cbc5626d02c$var$sanitizeHex,
    stringToArrayBuffer: ()=>$facb0cbc5626d02c$var$stringToArrayBuffer,
    utf8ToArray: ()=>$facb0cbc5626d02c$var$utf8ToArray
});
var $facb0cbc5626d02c$var$IS_BROWSER = typeof window !== "undefined";
var $facb0cbc5626d02c$var$STRING_ZERO = "0";
function $facb0cbc5626d02c$var$arrayBufferToString(array) {
    return new Uint8Array(array).reduce((data, byte)=>data + String.fromCharCode(byte), "");
}
function $facb0cbc5626d02c$var$utf8ToArray(str) {
    return new TextEncoder().encode(str);
}
function $facb0cbc5626d02c$var$stringToArrayBuffer(str) {
    return $facb0cbc5626d02c$var$utf8ToArray(str);
}
function $facb0cbc5626d02c$var$atobUniversal(a) {
    return (0, $dGHtD.base64).decode(a);
}
function $facb0cbc5626d02c$var$btoaUniversal(b) {
    return (0, $dGHtD.base64).encode(new Uint8Array(b));
}
function $facb0cbc5626d02c$var$buf2hex(buffer) {
    return buffer.reduce((r, x)=>r + x.toString(16).padStart(2, "0"), "");
}
function $facb0cbc5626d02c$var$removeHexPrefix(hex) {
    return hex.replace(/^0x/i, "");
}
function $facb0cbc5626d02c$var$addHexPrefix(hex) {
    return `0x${$facb0cbc5626d02c$var$removeHexPrefix(hex)}`;
}
function $facb0cbc5626d02c$var$padString(str, length, left, padding = $facb0cbc5626d02c$var$STRING_ZERO) {
    const diff = length - str.length;
    let result = str;
    if (diff > 0) {
        const pad = padding.repeat(diff);
        result = left ? pad + str : str + pad;
    }
    return result;
}
function $facb0cbc5626d02c$var$padLeft(str, length, padding = $facb0cbc5626d02c$var$STRING_ZERO) {
    return $facb0cbc5626d02c$var$padString(str, length, true, padding);
}
function $facb0cbc5626d02c$var$calcByteLength(str, byteSize = 8) {
    const { length: length } = str;
    const remainder = length % byteSize;
    return remainder ? (length - remainder) / byteSize * byteSize + byteSize : length;
}
function $facb0cbc5626d02c$var$sanitizeBytes(str, byteSize = 8, padding = $facb0cbc5626d02c$var$STRING_ZERO) {
    return $facb0cbc5626d02c$var$padLeft(str, $facb0cbc5626d02c$var$calcByteLength(str, byteSize), padding);
}
function $facb0cbc5626d02c$var$sanitizeHex(hex) {
    hex = $facb0cbc5626d02c$var$removeHexPrefix(hex);
    hex = $facb0cbc5626d02c$var$sanitizeBytes(hex, 2);
    if (hex) hex = $facb0cbc5626d02c$var$addHexPrefix(hex);
    return hex;
}
var $facb0cbc5626d02c$var$pascalToSnake = (text)=>/[a-z]/.test(text) ? text.split(/(?=[A-Z])/).join("_").toUpperCase() : text;
// src/constants.ts
var $facb0cbc5626d02c$var$TEXT_TO_FELT_MAX_LEN = 31;
var $facb0cbc5626d02c$var$HEX_STR_TRANSACTION_VERSION_1 = "0x1";
var $facb0cbc5626d02c$var$HEX_STR_TRANSACTION_VERSION_2 = "0x2";
var $facb0cbc5626d02c$var$BN_TRANSACTION_VERSION_1 = 1n;
var $facb0cbc5626d02c$var$BN_TRANSACTION_VERSION_2 = 2n;
var $facb0cbc5626d02c$var$BN_FEE_TRANSACTION_VERSION_1 = 2n ** 128n + $facb0cbc5626d02c$var$BN_TRANSACTION_VERSION_1;
var $facb0cbc5626d02c$var$BN_FEE_TRANSACTION_VERSION_2 = 2n ** 128n + $facb0cbc5626d02c$var$BN_TRANSACTION_VERSION_2;
var $facb0cbc5626d02c$var$ZERO = 0n;
var $facb0cbc5626d02c$var$MASK_250 = 2n ** 250n - 1n;
var $facb0cbc5626d02c$var$API_VERSION = $facb0cbc5626d02c$var$ZERO;
var $facb0cbc5626d02c$var$MAX_STORAGE_ITEM_SIZE = 256n;
var $facb0cbc5626d02c$var$ADDR_BOUND = 2n ** 251n - $facb0cbc5626d02c$var$MAX_STORAGE_ITEM_SIZE;
var $facb0cbc5626d02c$var$BaseUrl = /* @__PURE__ */ ((BaseUrl2)=>{
    BaseUrl2["SN_MAIN"] = "https://alpha-mainnet.starknet.io";
    BaseUrl2["SN_GOERLI"] = "https://alpha4.starknet.io";
    BaseUrl2["SN_SEPOLIA"] = "https://alpha-sepolia.starknet.io";
    return BaseUrl2;
})($facb0cbc5626d02c$var$BaseUrl || {});
var $facb0cbc5626d02c$var$NetworkName = /* @__PURE__ */ ((NetworkName2)=>{
    NetworkName2["SN_MAIN"] = "SN_MAIN";
    NetworkName2["SN_GOERLI"] = "SN_GOERLI";
    NetworkName2["SN_SEPOLIA"] = "SN_SEPOLIA";
    return NetworkName2;
})($facb0cbc5626d02c$var$NetworkName || {});
var $facb0cbc5626d02c$var$StarknetChainId = /* @__PURE__ */ ((StarknetChainId4)=>{
    StarknetChainId4["SN_MAIN"] = "0x534e5f4d41494e";
    StarknetChainId4["SN_GOERLI"] = "0x534e5f474f45524c49";
    StarknetChainId4["SN_SEPOLIA"] = "0x534e5f5345504f4c4941";
    return StarknetChainId4;
})($facb0cbc5626d02c$var$StarknetChainId || {});
var $facb0cbc5626d02c$var$TransactionHashPrefix = /* @__PURE__ */ ((TransactionHashPrefix2)=>{
    TransactionHashPrefix2["DECLARE"] = "0x6465636c617265";
    TransactionHashPrefix2["DEPLOY"] = "0x6465706c6f79";
    TransactionHashPrefix2["DEPLOY_ACCOUNT"] = "0x6465706c6f795f6163636f756e74";
    TransactionHashPrefix2["INVOKE"] = "0x696e766f6b65";
    TransactionHashPrefix2["L1_HANDLER"] = "0x6c315f68616e646c6572";
    return TransactionHashPrefix2;
})($facb0cbc5626d02c$var$TransactionHashPrefix || {});
var $facb0cbc5626d02c$var$UDC = {
    ADDRESS: "0x041a78e741e5af2fec34b695679bc6891742439f7afb8484ecd7766661ad02bf",
    ENTRYPOINT: "deployContract"
};
var $facb0cbc5626d02c$var$RPC_DEFAULT_VERSION = "v0_5";
var $facb0cbc5626d02c$var$RPC_NODES = {
    SN_GOERLI: [
        `https://starknet-testnet.public.blastapi.io/rpc/`,
        `https://free-rpc.nethermind.io/goerli-juno/`
    ],
    SN_MAIN: [
        `https://starknet-mainnet.public.blastapi.io/rpc/`,
        `https://free-rpc.nethermind.io/mainnet-juno/`
    ],
    SN_SEPOLIA: [
        `https://starknet-sepolia.public.blastapi.io/rpc/`,
        `https://free-rpc.nethermind.io/sepolia-juno/`
    ]
};
// src/types/index.ts
var $facb0cbc5626d02c$export$b14ad400b1d09e0f = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$b14ad400b1d09e0f, {
    BlockStatus: ()=>$facb0cbc5626d02c$export$551bfb62fbe5f7ab,
    BlockTag: ()=>$facb0cbc5626d02c$export$472371b62fbd4d78,
    EntryPointType: ()=>$facb0cbc5626d02c$export$c5a05fb778755707,
    Literal: ()=>$facb0cbc5626d02c$export$e175ae9e414693bc,
    RPC: ()=>$facb0cbc5626d02c$export$83f82714246b5968,
    SIMULATION_FLAG: ()=>$facb0cbc5626d02c$export$2dc1f918d7b47fd1,
    Sequencer: ()=>$facb0cbc5626d02c$export$f195f25b42d46a8c,
    TransactionExecutionStatus: ()=>$facb0cbc5626d02c$export$8b96ee174325dd47,
    TransactionFinalityStatus: ()=>$facb0cbc5626d02c$export$be404a55d98e2f85,
    TransactionStatus: ()=>$facb0cbc5626d02c$export$7c391bd3b61d2374,
    TransactionType: ()=>$facb0cbc5626d02c$export$d513b00599f845d4,
    TypedDataRevision: ()=>$facb0cbc5626d02c$export$c66c875ce2a199f3,
    Uint: ()=>$facb0cbc5626d02c$export$f5013dbad57df7b8,
    ValidateType: ()=>$facb0cbc5626d02c$export$7699f7ca8780a690
});
// src/types/account.ts
var $facb0cbc5626d02c$export$2dc1f918d7b47fd1 = /* @__PURE__ */ ((SIMULATION_FLAG2)=>{
    SIMULATION_FLAG2["SKIP_VALIDATE"] = "SKIP_VALIDATE";
    SIMULATION_FLAG2["SKIP_EXECUTE"] = "SKIP_EXECUTE";
    return SIMULATION_FLAG2;
})($facb0cbc5626d02c$export$2dc1f918d7b47fd1 || {});
// src/types/calldata.ts
var $facb0cbc5626d02c$export$7699f7ca8780a690 = /* @__PURE__ */ ((ValidateType2)=>{
    ValidateType2["DEPLOY"] = "DEPLOY";
    ValidateType2["CALL"] = "CALL";
    ValidateType2["INVOKE"] = "INVOKE";
    return ValidateType2;
})($facb0cbc5626d02c$export$7699f7ca8780a690 || {});
var $facb0cbc5626d02c$export$f5013dbad57df7b8 = /* @__PURE__ */ ((Uint2)=>{
    Uint2["u8"] = "core::integer::u8";
    Uint2["u16"] = "core::integer::u16";
    Uint2["u32"] = "core::integer::u32";
    Uint2["u64"] = "core::integer::u64";
    Uint2["u128"] = "core::integer::u128";
    Uint2["u256"] = "core::integer::u256";
    return Uint2;
})($facb0cbc5626d02c$export$f5013dbad57df7b8 || {});
var $facb0cbc5626d02c$export$e175ae9e414693bc = /* @__PURE__ */ ((Literal2)=>{
    Literal2["ClassHash"] = "core::starknet::class_hash::ClassHash";
    Literal2["ContractAddress"] = "core::starknet::contract_address::ContractAddress";
    return Literal2;
})($facb0cbc5626d02c$export$e175ae9e414693bc || {});
// src/types/lib/contract/index.ts
var $facb0cbc5626d02c$export$c5a05fb778755707 = /* @__PURE__ */ ((EntryPointType2)=>{
    EntryPointType2["EXTERNAL"] = "EXTERNAL";
    EntryPointType2["L1_HANDLER"] = "L1_HANDLER";
    EntryPointType2["CONSTRUCTOR"] = "CONSTRUCTOR";
    return EntryPointType2;
})($facb0cbc5626d02c$export$c5a05fb778755707 || {});
// src/types/lib/index.ts
var $facb0cbc5626d02c$export$d513b00599f845d4 = /* @__PURE__ */ ((TransactionType2)=>{
    TransactionType2["DECLARE"] = "DECLARE";
    TransactionType2["DEPLOY"] = "DEPLOY";
    TransactionType2["DEPLOY_ACCOUNT"] = "DEPLOY_ACCOUNT";
    TransactionType2["INVOKE"] = "INVOKE_FUNCTION";
    return TransactionType2;
})($facb0cbc5626d02c$export$d513b00599f845d4 || {});
var $facb0cbc5626d02c$export$7c391bd3b61d2374 = /* @__PURE__ */ ((TransactionStatus2)=>{
    TransactionStatus2["NOT_RECEIVED"] = "NOT_RECEIVED";
    TransactionStatus2["RECEIVED"] = "RECEIVED";
    TransactionStatus2["ACCEPTED_ON_L2"] = "ACCEPTED_ON_L2";
    TransactionStatus2["ACCEPTED_ON_L1"] = "ACCEPTED_ON_L1";
    TransactionStatus2["REJECTED"] = "REJECTED";
    TransactionStatus2["REVERTED"] = "REVERTED";
    return TransactionStatus2;
})($facb0cbc5626d02c$export$7c391bd3b61d2374 || {});
var $facb0cbc5626d02c$export$be404a55d98e2f85 = /* @__PURE__ */ ((TransactionFinalityStatus2)=>{
    TransactionFinalityStatus2["NOT_RECEIVED"] = "NOT_RECEIVED";
    TransactionFinalityStatus2["RECEIVED"] = "RECEIVED";
    TransactionFinalityStatus2["ACCEPTED_ON_L2"] = "ACCEPTED_ON_L2";
    TransactionFinalityStatus2["ACCEPTED_ON_L1"] = "ACCEPTED_ON_L1";
    return TransactionFinalityStatus2;
})($facb0cbc5626d02c$export$be404a55d98e2f85 || {});
var $facb0cbc5626d02c$export$8b96ee174325dd47 = /* @__PURE__ */ ((TransactionExecutionStatus2)=>{
    TransactionExecutionStatus2["REJECTED"] = "REJECTED";
    TransactionExecutionStatus2["REVERTED"] = "REVERTED";
    TransactionExecutionStatus2["SUCCEEDED"] = "SUCCEEDED";
    return TransactionExecutionStatus2;
})($facb0cbc5626d02c$export$8b96ee174325dd47 || {});
var $facb0cbc5626d02c$export$551bfb62fbe5f7ab = /* @__PURE__ */ ((BlockStatus2)=>{
    BlockStatus2["PENDING"] = "PENDING";
    BlockStatus2["ACCEPTED_ON_L1"] = "ACCEPTED_ON_L1";
    BlockStatus2["ACCEPTED_ON_L2"] = "ACCEPTED_ON_L2";
    BlockStatus2["REJECTED"] = "REJECTED";
    return BlockStatus2;
})($facb0cbc5626d02c$export$551bfb62fbe5f7ab || {});
var $facb0cbc5626d02c$export$472371b62fbd4d78 = /* @__PURE__ */ ((BlockTag2)=>{
    BlockTag2["pending"] = "pending";
    BlockTag2["latest"] = "latest";
    return BlockTag2;
})($facb0cbc5626d02c$export$472371b62fbd4d78 || {});
// src/types/typedData.ts
var $facb0cbc5626d02c$export$c66c875ce2a199f3 = /* @__PURE__ */ ((TypedDataRevision2)=>{
    TypedDataRevision2["Active"] = "1";
    TypedDataRevision2["Legacy"] = "0";
    return TypedDataRevision2;
})($facb0cbc5626d02c$export$c66c875ce2a199f3 || {});
// src/types/api/rpc.ts
var $facb0cbc5626d02c$export$83f82714246b5968 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$83f82714246b5968, {
    EBlockTag: ()=>$facb0cbc5626d02c$var$EBlockTag,
    EDataAvailabilityMode: ()=>$facb0cbc5626d02c$var$EDataAvailabilityMode,
    ESimulationFlag: ()=>$facb0cbc5626d02c$var$ESimulationFlag,
    ETransactionExecutionStatus: ()=>$facb0cbc5626d02c$var$ETransactionExecutionStatus,
    ETransactionFinalityStatus: ()=>$facb0cbc5626d02c$var$ETransactionFinalityStatus,
    ETransactionStatus: ()=>$facb0cbc5626d02c$var$ETransactionStatus,
    ETransactionType: ()=>$facb0cbc5626d02c$var$ETransactionType,
    Errors: ()=>$facb0cbc5626d02c$var$errors_exports,
    JRPC: ()=>$facb0cbc5626d02c$var$jsonrpc_exports,
    SPEC: ()=>$facb0cbc5626d02c$var$components_exports
});
// src/types/api/jsonrpc/index.ts
var $facb0cbc5626d02c$var$jsonrpc_exports = {};
// src/types/api/rpcspec/errors.ts
var $facb0cbc5626d02c$var$errors_exports = {};
// src/types/api/rpcspec/components.ts
var $facb0cbc5626d02c$var$components_exports = {};
// src/types/api/rpcspec/nonspec.ts
var $facb0cbc5626d02c$var$ETransactionType = /* @__PURE__ */ ((ETransactionType2)=>{
    ETransactionType2["DECLARE"] = "DECLARE";
    ETransactionType2["DEPLOY"] = "DEPLOY";
    ETransactionType2["DEPLOY_ACCOUNT"] = "DEPLOY_ACCOUNT";
    ETransactionType2["INVOKE"] = "INVOKE";
    ETransactionType2["L1_HANDLER"] = "L1_HANDLER";
    return ETransactionType2;
})($facb0cbc5626d02c$var$ETransactionType || {});
var $facb0cbc5626d02c$var$ESimulationFlag = /* @__PURE__ */ ((ESimulationFlag2)=>{
    ESimulationFlag2["SKIP_VALIDATE"] = "SKIP_VALIDATE";
    ESimulationFlag2["SKIP_FEE_CHARGE"] = "SKIP_FEE_CHARGE";
    return ESimulationFlag2;
})($facb0cbc5626d02c$var$ESimulationFlag || {});
var $facb0cbc5626d02c$var$ETransactionStatus = /* @__PURE__ */ ((ETransactionStatus2)=>{
    ETransactionStatus2["RECEIVED"] = "RECEIVED";
    ETransactionStatus2["REJECTED"] = "REJECTED";
    ETransactionStatus2["ACCEPTED_ON_L2"] = "ACCEPTED_ON_L2";
    ETransactionStatus2["ACCEPTED_ON_L1"] = "ACCEPTED_ON_L1";
    return ETransactionStatus2;
})($facb0cbc5626d02c$var$ETransactionStatus || {});
var $facb0cbc5626d02c$var$ETransactionFinalityStatus = /* @__PURE__ */ ((ETransactionFinalityStatus2)=>{
    ETransactionFinalityStatus2["ACCEPTED_ON_L2"] = "ACCEPTED_ON_L2";
    ETransactionFinalityStatus2["ACCEPTED_ON_L1"] = "ACCEPTED_ON_L1";
    return ETransactionFinalityStatus2;
})($facb0cbc5626d02c$var$ETransactionFinalityStatus || {});
var $facb0cbc5626d02c$var$ETransactionExecutionStatus = /* @__PURE__ */ ((ETransactionExecutionStatus2)=>{
    ETransactionExecutionStatus2["SUCCEEDED"] = "SUCCEEDED";
    ETransactionExecutionStatus2["REVERTED"] = "REVERTED";
    return ETransactionExecutionStatus2;
})($facb0cbc5626d02c$var$ETransactionExecutionStatus || {});
var $facb0cbc5626d02c$var$EBlockTag = /* @__PURE__ */ ((EBlockTag2)=>{
    EBlockTag2["LATEST"] = "latest";
    EBlockTag2["PENDING"] = "pending";
    return EBlockTag2;
})($facb0cbc5626d02c$var$EBlockTag || {});
var $facb0cbc5626d02c$var$EDataAvailabilityMode = /* @__PURE__ */ ((EDataAvailabilityMode2)=>{
    EDataAvailabilityMode2["L1"] = "L1";
    EDataAvailabilityMode2["L2"] = "L2";
    return EDataAvailabilityMode2;
})($facb0cbc5626d02c$var$EDataAvailabilityMode || {});
// src/types/api/sequencer.ts
var $facb0cbc5626d02c$export$f195f25b42d46a8c = {};
// src/utils/assert.ts
function $facb0cbc5626d02c$var$assert(condition, message) {
    if (!condition) throw new Error(message || "Assertion failure");
}
// src/utils/num.ts
var $facb0cbc5626d02c$export$61cc6a0be4938a2a = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$61cc6a0be4938a2a, {
    assertInRange: ()=>$facb0cbc5626d02c$var$assertInRange,
    bigNumberishArrayToDecimalStringArray: ()=>$facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray,
    bigNumberishArrayToHexadecimalStringArray: ()=>$facb0cbc5626d02c$var$bigNumberishArrayToHexadecimalStringArray,
    cleanHex: ()=>$facb0cbc5626d02c$var$cleanHex,
    getDecimalString: ()=>$facb0cbc5626d02c$var$getDecimalString,
    getHexString: ()=>$facb0cbc5626d02c$var$getHexString,
    getHexStringArray: ()=>$facb0cbc5626d02c$var$getHexStringArray,
    hexToBytes: ()=>$facb0cbc5626d02c$var$hexToBytes,
    hexToDecimalString: ()=>$facb0cbc5626d02c$var$hexToDecimalString,
    isBigInt: ()=>$facb0cbc5626d02c$var$isBigInt,
    isHex: ()=>$facb0cbc5626d02c$var$isHex,
    isStringWholeNumber: ()=>$facb0cbc5626d02c$var$isStringWholeNumber,
    toBigInt: ()=>$facb0cbc5626d02c$var$toBigInt,
    toCairoBool: ()=>$facb0cbc5626d02c$var$toCairoBool,
    toHex: ()=>$facb0cbc5626d02c$var$toHex,
    toHexString: ()=>$facb0cbc5626d02c$var$toHexString,
    toStorageKey: ()=>$facb0cbc5626d02c$var$toStorageKey
});
function $facb0cbc5626d02c$var$isHex(hex) {
    return /^0x[0-9a-f]*$/i.test(hex);
}
function $facb0cbc5626d02c$var$toBigInt(value) {
    return BigInt(value);
}
function $facb0cbc5626d02c$var$isBigInt(value) {
    return typeof value === "bigint";
}
function $facb0cbc5626d02c$var$toHex(number2) {
    return $facb0cbc5626d02c$var$addHexPrefix($facb0cbc5626d02c$var$toBigInt(number2).toString(16));
}
var $facb0cbc5626d02c$var$toHexString = $facb0cbc5626d02c$var$toHex;
function $facb0cbc5626d02c$var$toStorageKey(number2) {
    const res = $facb0cbc5626d02c$var$addHexPrefix($facb0cbc5626d02c$var$toBigInt(number2).toString(16).padStart(64, "0"));
    return res;
}
function $facb0cbc5626d02c$var$hexToDecimalString(hex) {
    return BigInt($facb0cbc5626d02c$var$addHexPrefix(hex)).toString(10);
}
var $facb0cbc5626d02c$var$cleanHex = (hex)=>hex.toLowerCase().replace(/^(0x)0+/, "$1");
function $facb0cbc5626d02c$var$assertInRange(input, lowerBound, upperBound, inputName = "") {
    const messageSuffix = inputName === "" ? "invalid length" : `invalid ${inputName} length`;
    const inputBigInt = BigInt(input);
    const lowerBoundBigInt = BigInt(lowerBound);
    const upperBoundBigInt = BigInt(upperBound);
    $facb0cbc5626d02c$var$assert(inputBigInt >= lowerBoundBigInt && inputBigInt <= upperBoundBigInt, `Message not signable, ${messageSuffix}.`);
}
function $facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray(rawCalldata) {
    return rawCalldata.map((x)=>$facb0cbc5626d02c$var$toBigInt(x).toString(10));
}
function $facb0cbc5626d02c$var$bigNumberishArrayToHexadecimalStringArray(rawCalldata) {
    return rawCalldata.map((x)=>$facb0cbc5626d02c$var$toHex(x));
}
var $facb0cbc5626d02c$var$isStringWholeNumber = (value)=>/^\d+$/.test(value);
function $facb0cbc5626d02c$var$getDecimalString(value) {
    if ($facb0cbc5626d02c$var$isHex(value)) return $facb0cbc5626d02c$var$hexToDecimalString(value);
    if ($facb0cbc5626d02c$var$isStringWholeNumber(value)) return value;
    throw new Error(`${value} need to be hex-string or whole-number-string`);
}
function $facb0cbc5626d02c$var$getHexString(value) {
    if ($facb0cbc5626d02c$var$isHex(value)) return value;
    if ($facb0cbc5626d02c$var$isStringWholeNumber(value)) return $facb0cbc5626d02c$var$toHexString(value);
    throw new Error(`${value} need to be hex-string or whole-number-string`);
}
function $facb0cbc5626d02c$var$getHexStringArray(value) {
    return value.map((el)=>$facb0cbc5626d02c$var$getHexString(el));
}
var $facb0cbc5626d02c$var$toCairoBool = (value)=>(+value).toString();
function $facb0cbc5626d02c$var$hexToBytes(value) {
    if (!$facb0cbc5626d02c$var$isHex(value)) throw new Error(`${value} need to be a hex-string`);
    let adaptedValue = $facb0cbc5626d02c$var$removeHexPrefix(value);
    if (adaptedValue.length % 2 !== 0) adaptedValue = `0${adaptedValue}`;
    return (0, $85BMf.hexToBytes)(adaptedValue);
}
// src/utils/selector.ts
var $facb0cbc5626d02c$export$aea217a45095ce11 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$aea217a45095ce11, {
    getSelector: ()=>$facb0cbc5626d02c$var$getSelector,
    getSelectorFromName: ()=>$facb0cbc5626d02c$var$getSelectorFromName,
    keccakBn: ()=>$facb0cbc5626d02c$var$keccakBn,
    starknetKeccak: ()=>$facb0cbc5626d02c$var$starknetKeccak
});
function $facb0cbc5626d02c$var$keccakBn(value) {
    const hexWithoutPrefix = $facb0cbc5626d02c$var$removeHexPrefix($facb0cbc5626d02c$var$toHex(BigInt(value)));
    const evenHex = hexWithoutPrefix.length % 2 === 0 ? hexWithoutPrefix : `0${hexWithoutPrefix}`;
    return $facb0cbc5626d02c$var$addHexPrefix((0, $5GNKL.keccak)($facb0cbc5626d02c$var$hexToBytes($facb0cbc5626d02c$var$addHexPrefix(evenHex))).toString(16));
}
function $facb0cbc5626d02c$var$keccakHex(str) {
    return $facb0cbc5626d02c$var$addHexPrefix((0, $5GNKL.keccak)($facb0cbc5626d02c$var$utf8ToArray(str)).toString(16));
}
function $facb0cbc5626d02c$var$starknetKeccak(str) {
    const hash = BigInt($facb0cbc5626d02c$var$keccakHex(str));
    return hash & $facb0cbc5626d02c$var$MASK_250;
}
function $facb0cbc5626d02c$var$getSelectorFromName(funcName) {
    return $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$starknetKeccak(funcName));
}
function $facb0cbc5626d02c$var$getSelector(value) {
    if ($facb0cbc5626d02c$var$isHex(value)) return value;
    if ($facb0cbc5626d02c$var$isStringWholeNumber(value)) return $facb0cbc5626d02c$var$toHexString(value);
    return $facb0cbc5626d02c$var$getSelectorFromName(value);
}
// src/utils/shortString.ts
var $facb0cbc5626d02c$export$bcef2cf0ec329fbf = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$bcef2cf0ec329fbf, {
    decodeShortString: ()=>$facb0cbc5626d02c$var$decodeShortString,
    encodeShortString: ()=>$facb0cbc5626d02c$var$encodeShortString,
    isASCII: ()=>$facb0cbc5626d02c$var$isASCII,
    isDecimalString: ()=>$facb0cbc5626d02c$var$isDecimalString,
    isLongText: ()=>$facb0cbc5626d02c$var$isLongText,
    isShortString: ()=>$facb0cbc5626d02c$var$isShortString,
    isShortText: ()=>$facb0cbc5626d02c$var$isShortText,
    isText: ()=>$facb0cbc5626d02c$var$isText,
    splitLongString: ()=>$facb0cbc5626d02c$var$splitLongString
});
function $facb0cbc5626d02c$var$isASCII(str) {
    return /^[\x00-\x7F]*$/.test(str);
}
function $facb0cbc5626d02c$var$isShortString(str) {
    return str.length <= $facb0cbc5626d02c$var$TEXT_TO_FELT_MAX_LEN;
}
function $facb0cbc5626d02c$var$isDecimalString(str) {
    return /^[0-9]*$/i.test(str);
}
function $facb0cbc5626d02c$var$isText(val) {
    return typeof val === "string" && !$facb0cbc5626d02c$var$isHex(val) && !$facb0cbc5626d02c$var$isStringWholeNumber(val);
}
var $facb0cbc5626d02c$var$isShortText = (val)=>$facb0cbc5626d02c$var$isText(val) && $facb0cbc5626d02c$var$isShortString(val);
var $facb0cbc5626d02c$var$isLongText = (val)=>$facb0cbc5626d02c$var$isText(val) && !$facb0cbc5626d02c$var$isShortString(val);
function $facb0cbc5626d02c$var$splitLongString(longStr) {
    const regex = RegExp(`[^]{1,${$facb0cbc5626d02c$var$TEXT_TO_FELT_MAX_LEN}}`, "g");
    return longStr.match(regex) || [];
}
function $facb0cbc5626d02c$var$encodeShortString(str) {
    if (!$facb0cbc5626d02c$var$isASCII(str)) throw new Error(`${str} is not an ASCII string`);
    if (!$facb0cbc5626d02c$var$isShortString(str)) throw new Error(`${str} is too long`);
    return $facb0cbc5626d02c$var$addHexPrefix(str.replace(/./g, (char)=>char.charCodeAt(0).toString(16)));
}
function $facb0cbc5626d02c$var$decodeShortString(str) {
    if (!$facb0cbc5626d02c$var$isASCII(str)) throw new Error(`${str} is not an ASCII string`);
    if ($facb0cbc5626d02c$var$isHex(str)) return $facb0cbc5626d02c$var$removeHexPrefix(str).replace(/.{2}/g, (hex)=>String.fromCharCode(parseInt(hex, 16)));
    if ($facb0cbc5626d02c$var$isDecimalString(str)) return $facb0cbc5626d02c$var$decodeShortString("0X".concat(BigInt(str).toString(16)));
    throw new Error(`${str} is not Hex or decimal`);
}
// src/utils/calldata/cairo.ts
var $facb0cbc5626d02c$export$3973b1d14008fbc3 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$3973b1d14008fbc3, {
    felt: ()=>$facb0cbc5626d02c$var$felt,
    getAbiContractVersion: ()=>$facb0cbc5626d02c$var$getAbiContractVersion,
    getArrayType: ()=>$facb0cbc5626d02c$var$getArrayType,
    isCairo1Abi: ()=>$facb0cbc5626d02c$var$isCairo1Abi,
    isCairo1Type: ()=>$facb0cbc5626d02c$var$isCairo1Type,
    isLen: ()=>$facb0cbc5626d02c$var$isLen,
    isTypeArray: ()=>$facb0cbc5626d02c$var$isTypeArray,
    isTypeBool: ()=>$facb0cbc5626d02c$var$isTypeBool,
    isTypeContractAddress: ()=>$facb0cbc5626d02c$var$isTypeContractAddress,
    isTypeEnum: ()=>$facb0cbc5626d02c$var$isTypeEnum,
    isTypeEthAddress: ()=>$facb0cbc5626d02c$var$isTypeEthAddress,
    isTypeFelt: ()=>$facb0cbc5626d02c$var$isTypeFelt,
    isTypeLiteral: ()=>$facb0cbc5626d02c$var$isTypeLiteral,
    isTypeNamedTuple: ()=>$facb0cbc5626d02c$var$isTypeNamedTuple,
    isTypeOption: ()=>$facb0cbc5626d02c$var$isTypeOption,
    isTypeResult: ()=>$facb0cbc5626d02c$var$isTypeResult,
    isTypeStruct: ()=>$facb0cbc5626d02c$var$isTypeStruct,
    isTypeTuple: ()=>$facb0cbc5626d02c$var$isTypeTuple,
    isTypeUint: ()=>$facb0cbc5626d02c$var$isTypeUint,
    isTypeUint256: ()=>$facb0cbc5626d02c$var$isTypeUint256,
    tuple: ()=>$facb0cbc5626d02c$var$tuple,
    uint256: ()=>$facb0cbc5626d02c$var$uint256
});
// src/utils/uint256.ts
var $facb0cbc5626d02c$export$fa66cedfaa3c10f3 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$fa66cedfaa3c10f3, {
    UINT_128_MAX: ()=>$facb0cbc5626d02c$var$UINT_128_MAX,
    UINT_256_MAX: ()=>$facb0cbc5626d02c$var$UINT_256_MAX,
    bnToUint256: ()=>$facb0cbc5626d02c$var$bnToUint256,
    isUint256: ()=>$facb0cbc5626d02c$var$isUint256,
    uint256ToBN: ()=>$facb0cbc5626d02c$var$uint256ToBN
});
var $facb0cbc5626d02c$var$UINT_128_MAX = (1n << 128n) - 1n;
var $facb0cbc5626d02c$var$UINT_256_MAX = (1n << 256n) - 1n;
function $facb0cbc5626d02c$var$uint256ToBN(uint2562) {
    return ($facb0cbc5626d02c$var$toBigInt(uint2562.high) << 128n) + $facb0cbc5626d02c$var$toBigInt(uint2562.low);
}
function $facb0cbc5626d02c$var$isUint256(bn) {
    return $facb0cbc5626d02c$var$toBigInt(bn) <= $facb0cbc5626d02c$var$UINT_256_MAX;
}
function $facb0cbc5626d02c$var$bnToUint256(bn) {
    const bi = $facb0cbc5626d02c$var$toBigInt(bn);
    if (!$facb0cbc5626d02c$var$isUint256(bi)) throw new Error("Number is too large");
    return {
        low: $facb0cbc5626d02c$var$addHexPrefix((bi & $facb0cbc5626d02c$var$UINT_128_MAX).toString(16)),
        high: $facb0cbc5626d02c$var$addHexPrefix((bi >> 128n).toString(16))
    };
}
// src/utils/calldata/cairo.ts
var $facb0cbc5626d02c$var$isLen = (name)=>/_len$/.test(name);
var $facb0cbc5626d02c$var$isTypeFelt = (type)=>type === "felt" || type === "core::felt252";
var $facb0cbc5626d02c$var$isTypeArray = (type)=>/\*/.test(type) || type.startsWith("core::array::Array::") || type.startsWith("core::array::Span::");
var $facb0cbc5626d02c$var$isTypeTuple = (type)=>/^\(.*\)$/i.test(type);
var $facb0cbc5626d02c$var$isTypeNamedTuple = (type)=>/\(.*\)/i.test(type) && type.includes(":");
var $facb0cbc5626d02c$var$isTypeStruct = (type, structs)=>type in structs;
var $facb0cbc5626d02c$var$isTypeEnum = (type, enums)=>type in enums;
var $facb0cbc5626d02c$var$isTypeOption = (type)=>type.startsWith("core::option::Option::");
var $facb0cbc5626d02c$var$isTypeResult = (type)=>type.startsWith("core::result::Result::");
var $facb0cbc5626d02c$var$isTypeUint = (type)=>Object.values($facb0cbc5626d02c$export$f5013dbad57df7b8).includes(type);
var $facb0cbc5626d02c$var$isTypeLiteral = (type)=>Object.values($facb0cbc5626d02c$export$e175ae9e414693bc).includes(type);
var $facb0cbc5626d02c$var$isTypeUint256 = (type)=>type === "core::integer::u256";
var $facb0cbc5626d02c$var$isTypeBool = (type)=>type === "core::bool";
var $facb0cbc5626d02c$var$isTypeContractAddress = (type)=>type === "core::starknet::contract_address::ContractAddress";
var $facb0cbc5626d02c$var$isTypeEthAddress = (type)=>type === "core::starknet::eth_address::EthAddress";
var $facb0cbc5626d02c$var$isCairo1Type = (type)=>type.includes("::");
var $facb0cbc5626d02c$var$getArrayType = (type)=>{
    if ($facb0cbc5626d02c$var$isCairo1Type(type)) return type.substring(type.indexOf("<") + 1, type.lastIndexOf(">"));
    return type.replace("*", "");
};
function $facb0cbc5626d02c$var$isCairo1Abi(abi) {
    const { cairo: cairo } = $facb0cbc5626d02c$var$getAbiContractVersion(abi);
    if (cairo === void 0) throw Error("Unable to determine Cairo version");
    return cairo === "1";
}
function $facb0cbc5626d02c$var$getAbiContractVersion(abi) {
    if (abi.find((it)=>it.type === "interface")) return {
        cairo: "1",
        compiler: "2"
    };
    const testFunction = abi.find((it)=>it.type === "function" && (it.inputs.length || it.outputs.length));
    if (!testFunction) return {
        cairo: void 0,
        compiler: void 0
    };
    const io = testFunction.inputs.length ? testFunction.inputs : testFunction.outputs;
    if ($facb0cbc5626d02c$var$isCairo1Type(io[0].type)) return {
        cairo: "1",
        compiler: "1"
    };
    return {
        cairo: "0",
        compiler: "0"
    };
}
var $facb0cbc5626d02c$var$uint256 = (it)=>{
    const bn = BigInt(it);
    if (!$facb0cbc5626d02c$var$isUint256(bn)) throw new Error("Number is too large");
    return {
        // eslint-disable-next-line no-bitwise
        low: (bn & $facb0cbc5626d02c$var$UINT_128_MAX).toString(10),
        // eslint-disable-next-line no-bitwise
        high: (bn >> 128n).toString(10)
    };
};
var $facb0cbc5626d02c$var$tuple = (...args)=>({
        ...args
    });
function $facb0cbc5626d02c$var$felt(it) {
    if ($facb0cbc5626d02c$var$isBigInt(it) || typeof it === "number" && Number.isInteger(it)) return it.toString();
    if ($facb0cbc5626d02c$var$isText(it)) {
        if (!$facb0cbc5626d02c$var$isShortString(it)) throw new Error(`${it} is a long string > 31 chars, felt can store short strings, split it to array of short strings`);
        const encoded = $facb0cbc5626d02c$var$encodeShortString(it);
        return BigInt(encoded).toString();
    }
    if (typeof it === "string" && $facb0cbc5626d02c$var$isHex(it)) return BigInt(it).toString();
    if (typeof it === "string" && $facb0cbc5626d02c$var$isStringWholeNumber(it)) return it;
    if (typeof it === "boolean") return `${+it}`;
    throw new Error(`${it} can't be computed by felt()`);
}
// src/utils/calldata/enum/CairoCustomEnum.ts
var $facb0cbc5626d02c$export$275e96c4fd8075e5 = class {
    /**
   *
   * @returns the content of the valid variant of a Cairo custom Enum.
   */ unwrap() {
        const variants = Object.entries(this.variant);
        const activeVariant = variants.find((item)=>typeof item[1] !== "undefined");
        if (typeof activeVariant === "undefined") return void 0;
        return activeVariant[1];
    }
    /**
   *
   * @returns the name of the valid variant of a Cairo custom Enum.
   */ activeVariant() {
        const variants = Object.entries(this.variant);
        const activeVariant = variants.find((item)=>typeof item[1] !== "undefined");
        if (typeof activeVariant === "undefined") return "";
        return activeVariant[0];
    }
    /**
   * @param enumContent an object with the variants as keys and the content as value. Only one content shall be defined.
   */ constructor(enumContent){
        /**
   * direct readonly access to variants of the Cairo Custom Enum.
   * @returns a value of type any
   * @example
   * ```typescript
   * const successValue = myCairoEnum.variant.Success;
   */ (0, $dxWQo._)(this, "variant", void 0);
        const variantsList = Object.values(enumContent);
        if (variantsList.length === 0) throw new Error("This Enum must have at least 1 variant");
        const nbActiveVariants = variantsList.filter((content)=>typeof content !== "undefined").length;
        if (nbActiveVariants !== 1) throw new Error("This Enum must have exactly one active variant");
        this.variant = enumContent;
    }
};
// src/utils/calldata/enum/CairoOption.ts
var $facb0cbc5626d02c$export$af05e77076421fd9 = /* @__PURE__ */ ((CairoOptionVariant2)=>{
    CairoOptionVariant2[CairoOptionVariant2["Some"] = 0] = "Some";
    CairoOptionVariant2[CairoOptionVariant2["None"] = 1] = "None";
    return CairoOptionVariant2;
})($facb0cbc5626d02c$export$af05e77076421fd9 || {});
var $facb0cbc5626d02c$export$b8ecf101591c7ba8 = class {
    /**
   *
   * @returns the content of the valid variant of a Cairo custom Enum.
   *  If None, returns 'undefined'.
   */ unwrap() {
        if (this.None) return void 0;
        return this.Some;
    }
    /**
   *
   * @returns true if the valid variant is 'isSome'.
   */ isSome() {
        return !(typeof this.Some === "undefined");
    }
    /**
   *
   * @returns true if the valid variant is 'isNone'.
   */ isNone() {
        return this.None === true;
    }
    constructor(variant, someContent){
        (0, $dxWQo._)(this, "Some", void 0);
        (0, $dxWQo._)(this, "None", void 0);
        if (!(variant in $facb0cbc5626d02c$export$af05e77076421fd9)) throw new Error("Wrong variant : should be CairoOptionVariant.Some or .None.");
        if (variant === 0 /* Some */ ) {
            if (typeof someContent === "undefined") throw new Error('The creation of a Cairo Option with "Some" variant needs a content as input.');
            this.Some = someContent;
            this.None = void 0;
        } else {
            this.Some = void 0;
            this.None = true;
        }
    }
};
// src/utils/calldata/enum/CairoResult.ts
var $facb0cbc5626d02c$export$1ae9a7bcb35c2aee = /* @__PURE__ */ ((CairoResultVariant2)=>{
    CairoResultVariant2[CairoResultVariant2["Ok"] = 0] = "Ok";
    CairoResultVariant2[CairoResultVariant2["Err"] = 1] = "Err";
    return CairoResultVariant2;
})($facb0cbc5626d02c$export$1ae9a7bcb35c2aee || {});
var $facb0cbc5626d02c$export$9c95511f15ff4e93 = class {
    /**
   *
   * @returns the content of the valid variant of a Cairo Result.
   */ unwrap() {
        if (typeof this.Ok !== "undefined") return this.Ok;
        if (typeof this.Err !== "undefined") return this.Err;
        throw new Error("Both Result.Ok and .Err are undefined. Not authorized.");
    }
    /**
   *
   * @returns true if the valid variant is 'Ok'.
   */ isOk() {
        return !(typeof this.Ok === "undefined");
    }
    /**
   *
   * @returns true if the valid variant is 'isErr'.
   */ isErr() {
        return !(typeof this.Err === "undefined");
    }
    constructor(variant, resultContent){
        (0, $dxWQo._)(this, "Ok", void 0);
        (0, $dxWQo._)(this, "Err", void 0);
        if (!(variant in $facb0cbc5626d02c$export$1ae9a7bcb35c2aee)) throw new Error("Wrong variant : should be CairoResultVariant.Ok or .Err.");
        if (variant === 0 /* Ok */ ) {
            this.Ok = resultContent;
            this.Err = void 0;
        } else {
            this.Ok = void 0;
            this.Err = resultContent;
        }
    }
};
// src/utils/calldata/formatter.ts
var $facb0cbc5626d02c$var$guard = {
    isBN: (data, type, key)=>{
        if (!$facb0cbc5626d02c$var$isBigInt(data[key])) throw new Error(`Data and formatter mismatch on ${key}:${type[key]}, expected response data ${key}:${data[key]} to be BN instead it is ${typeof data[key]}`);
    },
    unknown: (data, type, key)=>{
        throw new Error(`Unhandled formatter type on ${key}:${type[key]} for data ${key}:${data[key]}`);
    }
};
function $facb0cbc5626d02c$var$formatter(data, type, sameType) {
    return Object.entries(data).reduce((acc, [key, value])=>{
        const elType = sameType !== null && sameType !== void 0 ? sameType : type[key];
        if (!(key in type) && !sameType) {
            acc[key] = value;
            return acc;
        }
        if (elType === "string") {
            if (Array.isArray(data[key])) {
                const arrayStr = $facb0cbc5626d02c$var$formatter(data[key], data[key].map((_)=>elType));
                acc[key] = Object.values(arrayStr).join("");
                return acc;
            }
            $facb0cbc5626d02c$var$guard.isBN(data, type, key);
            acc[key] = $facb0cbc5626d02c$var$decodeShortString(value);
            return acc;
        }
        if (elType === "number") {
            $facb0cbc5626d02c$var$guard.isBN(data, type, key);
            acc[key] = Number(value);
            return acc;
        }
        if (typeof elType === "function") {
            acc[key] = elType(value);
            return acc;
        }
        if (Array.isArray(elType)) {
            const arrayObj = $facb0cbc5626d02c$var$formatter(data[key], elType, elType[0]);
            acc[key] = Object.values(arrayObj);
            return acc;
        }
        if (typeof elType === "object") {
            acc[key] = $facb0cbc5626d02c$var$formatter(data[key], elType);
            return acc;
        }
        $facb0cbc5626d02c$var$guard.unknown(data, type, key);
        return acc;
    }, {});
}
// src/utils/calldata/parser/parser-0-1.1.0.ts
var $facb0cbc5626d02c$var$AbiParser1 = class {
    /**
   * abi method inputs length without '_len' inputs
   * cairo 0 reducer
   * @param abiMethod FunctionAbi
   * @returns number
   */ methodInputsLength(abiMethod) {
        return abiMethod.inputs.reduce((acc, input)=>!$facb0cbc5626d02c$var$isLen(input.name) ? acc + 1 : acc, 0);
    }
    /**
   * get method definition from abi
   * @param name string
   * @returns FunctionAbi | undefined
   */ getMethod(name) {
        return this.abi.find((it)=>it.name === name);
    }
    /**
   * Get Abi in legacy format
   * @returns Abi
   */ getLegacyFormat() {
        return this.abi;
    }
    constructor(abi){
        (0, $dxWQo._)(this, "abi", void 0);
        this.abi = abi;
    }
};
// src/utils/calldata/parser/parser-2.0.0.ts
var $facb0cbc5626d02c$var$AbiParser2 = class {
    /**
   * abi method inputs length
   * @param abiMethod FunctionAbi
   * @returns number
   */ methodInputsLength(abiMethod) {
        return abiMethod.inputs.length;
    }
    /**
   * get method definition from abi
   * @param name string
   * @returns FunctionAbi | undefined
   */ getMethod(name) {
        const intf = this.abi.find((it)=>it.type === "interface");
        return intf.items.find((it)=>it.name === name);
    }
    /**
   * Get Abi in legacy format
   * @returns Abi
   */ getLegacyFormat() {
        return this.abi.flatMap((e)=>{
            if (e.type === "interface") return e.items;
            return e;
        });
    }
    constructor(abi){
        (0, $dxWQo._)(this, "abi", void 0);
        this.abi = abi;
    }
};
// src/utils/calldata/parser/index.ts
function $facb0cbc5626d02c$var$createAbiParser(abi) {
    const version = $facb0cbc5626d02c$var$getAbiVersion(abi);
    if (version === 0 || version === 1) return new $facb0cbc5626d02c$var$AbiParser1(abi);
    if (version === 2) return new $facb0cbc5626d02c$var$AbiParser2(abi);
    throw Error(`Unsupported ABI version ${version}`);
}
function $facb0cbc5626d02c$var$getAbiVersion(abi) {
    if (abi.find((it)=>it.type === "interface")) return 2;
    if ($facb0cbc5626d02c$var$isCairo1Abi(abi)) return 1;
    return 0;
}
function $facb0cbc5626d02c$var$isNoConstructorValid(method, argsCalldata, abiMethod) {
    return method === "constructor" && !abiMethod && !argsCalldata.length;
}
// src/utils/calldata/tuple.ts
function $facb0cbc5626d02c$var$parseNamedTuple(namedTuple) {
    const name = namedTuple.substring(0, namedTuple.indexOf(":"));
    const type = namedTuple.substring(name.length + 1);
    return {
        name: name,
        type: type
    };
}
function $facb0cbc5626d02c$var$parseSubTuple(s) {
    if (!s.includes("(")) return {
        subTuple: [],
        result: s
    };
    const subTuple = [];
    let result = "";
    let i = 0;
    while(i < s.length){
        if (s[i] === "(") {
            let counter = 1;
            const lBracket = i;
            i++;
            while(counter){
                if (s[i] === ")") counter--;
                if (s[i] === "(") counter++;
                i++;
            }
            subTuple.push(s.substring(lBracket, i));
            result += " ";
            i--;
        } else result += s[i];
        i++;
    }
    return {
        subTuple: subTuple,
        result: result
    };
}
function $facb0cbc5626d02c$var$extractCairo0Tuple(type) {
    const cleanType = type.replace(/\s/g, "").slice(1, -1);
    const { subTuple: subTuple, result: result } = $facb0cbc5626d02c$var$parseSubTuple(cleanType);
    let recomposed = result.split(",").map((it)=>{
        return subTuple.length ? it.replace(" ", subTuple.shift()) : it;
    });
    if ($facb0cbc5626d02c$var$isTypeNamedTuple(type)) recomposed = recomposed.reduce((acc, it)=>{
        return acc.concat($facb0cbc5626d02c$var$parseNamedTuple(it));
    }, []);
    return recomposed;
}
function $facb0cbc5626d02c$var$extractCairo1Tuple(type) {
    const cleanType = type.replace(/\s/g, "").slice(1, -1);
    const { subTuple: subTuple, result: result } = $facb0cbc5626d02c$var$parseSubTuple(cleanType);
    const recomposed = result.split(",").map((it)=>{
        return subTuple.length ? it.replace(" ", subTuple.shift()) : it;
    });
    return recomposed;
}
function $facb0cbc5626d02c$var$extractTupleMemberTypes(type) {
    if ($facb0cbc5626d02c$var$isCairo1Type(type)) return $facb0cbc5626d02c$var$extractCairo1Tuple(type);
    return $facb0cbc5626d02c$var$extractCairo0Tuple(type);
}
// src/utils/calldata/propertyOrder.ts
function $facb0cbc5626d02c$var$errorU256(key) {
    return Error(`Your object includes the property : ${key}, containing an Uint256 object without the 'low' and 'high' keys.`);
}
function $facb0cbc5626d02c$var$orderPropsByAbi(unorderedObject, abiOfObject, structs, enums) {
    const orderInput = (unorderedItem, abiType)=>{
        if ($facb0cbc5626d02c$var$isTypeArray(abiType)) return orderArray(unorderedItem, abiType);
        if ($facb0cbc5626d02c$var$isTypeEnum(abiType, enums)) {
            const abiObj = enums[abiType];
            return orderEnum(unorderedItem, abiObj);
        }
        if ($facb0cbc5626d02c$var$isTypeTuple(abiType)) return orderTuple(unorderedItem, abiType);
        if ($facb0cbc5626d02c$var$isTypeEthAddress(abiType)) return unorderedItem;
        if ($facb0cbc5626d02c$var$isTypeUint256(abiType)) {
            const u256 = unorderedItem;
            if (typeof u256 !== "object") return u256;
            if (!("low" in u256 && "high" in u256)) throw $facb0cbc5626d02c$var$errorU256(abiType);
            return {
                low: u256.low,
                high: u256.high
            };
        }
        if ($facb0cbc5626d02c$var$isTypeStruct(abiType, structs)) {
            const abiOfStruct = structs[abiType].members;
            return orderStruct(unorderedItem, abiOfStruct);
        }
        return unorderedItem;
    };
    const orderStruct = (unorderedObject2, abiObject)=>{
        const orderedObject2 = abiObject.reduce((orderedObject, abiParam)=>{
            const setProperty = (value)=>Object.defineProperty(orderedObject, abiParam.name, {
                    enumerable: true,
                    value: value !== null && value !== void 0 ? value : unorderedObject2[abiParam.name]
                });
            if (unorderedObject2[abiParam.name] === "undefined") {
                if ($facb0cbc5626d02c$var$isCairo1Type(abiParam.type) || !$facb0cbc5626d02c$var$isLen(abiParam.name)) throw Error(`Your object needs a property with key : ${abiParam.name} .`);
            }
            setProperty(orderInput(unorderedObject2[abiParam.name], abiParam.type));
            return orderedObject;
        }, {});
        return orderedObject2;
    };
    function orderArray(myArray, abiParam) {
        const typeInArray = $facb0cbc5626d02c$var$getArrayType(abiParam);
        if (typeof myArray === "string") return myArray;
        return myArray.map((myElem)=>orderInput(myElem, typeInArray));
    }
    function orderTuple(unorderedObject2, abiParam) {
        const typeList = $facb0cbc5626d02c$var$extractTupleMemberTypes(abiParam);
        const orderedObject2 = typeList.reduce((orderedObject, abiTypeCairoX, index)=>{
            const myObjKeys = Object.keys(unorderedObject2);
            const setProperty = (value)=>Object.defineProperty(orderedObject, index.toString(), {
                    enumerable: true,
                    value: value !== null && value !== void 0 ? value : unorderedObject2[myObjKeys[index]]
                });
            const abiType = (abiTypeCairoX === null || abiTypeCairoX === void 0 ? void 0 : abiTypeCairoX.type) ? abiTypeCairoX.type : abiTypeCairoX;
            setProperty(orderInput(unorderedObject2[myObjKeys[index]], abiType));
            return orderedObject;
        }, {});
        return orderedObject2;
    }
    const orderEnum = (unorderedObject2, abiObject)=>{
        if ($facb0cbc5626d02c$var$isTypeResult(abiObject.name)) {
            const unorderedResult = unorderedObject2;
            const resultOkType = abiObject.name.substring(abiObject.name.indexOf("<") + 1, abiObject.name.lastIndexOf(","));
            const resultErrType = abiObject.name.substring(abiObject.name.indexOf(",") + 1, abiObject.name.lastIndexOf(">"));
            if (unorderedResult.isOk()) return new $facb0cbc5626d02c$export$9c95511f15ff4e93(0 /* Ok */ , orderInput(unorderedObject2.unwrap(), resultOkType));
            return new $facb0cbc5626d02c$export$9c95511f15ff4e93(1 /* Err */ , orderInput(unorderedObject2.unwrap(), resultErrType));
        }
        if ($facb0cbc5626d02c$var$isTypeOption(abiObject.name)) {
            const unorderedOption = unorderedObject2;
            const resultSomeType = abiObject.name.substring(abiObject.name.indexOf("<") + 1, abiObject.name.lastIndexOf(">"));
            if (unorderedOption.isSome()) return new $facb0cbc5626d02c$export$b8ecf101591c7ba8(0 /* Some */ , orderInput(unorderedOption.unwrap(), resultSomeType));
            return new $facb0cbc5626d02c$export$b8ecf101591c7ba8(1 /* None */ , {});
        }
        const unorderedCustomEnum = unorderedObject2;
        const variants = Object.entries(unorderedCustomEnum.variant);
        const newEntries = variants.map((variant)=>{
            if (typeof variant[1] === "undefined") return variant;
            const variantType = abiObject.type.substring(abiObject.type.lastIndexOf("<") + 1, abiObject.type.lastIndexOf(">"));
            if (variantType === "()") return variant;
            return [
                variant[0],
                orderInput(unorderedCustomEnum.unwrap(), variantType)
            ];
        });
        return new $facb0cbc5626d02c$export$275e96c4fd8075e5(Object.fromEntries(newEntries));
    };
    const finalOrderedObject = abiOfObject.reduce((orderedObject, abiParam)=>{
        const setProperty = (value)=>Object.defineProperty(orderedObject, abiParam.name, {
                enumerable: true,
                value: value
            });
        if ($facb0cbc5626d02c$var$isLen(abiParam.name) && !$facb0cbc5626d02c$var$isCairo1Type(abiParam.type)) return orderedObject;
        setProperty(orderInput(unorderedObject[abiParam.name], abiParam.type));
        return orderedObject;
    }, {});
    return finalOrderedObject;
}
// src/utils/calldata/requestParser.ts
function $facb0cbc5626d02c$var$parseBaseTypes(type, val) {
    switch(true){
        case $facb0cbc5626d02c$var$isTypeUint256(type):
            const el_uint256 = $facb0cbc5626d02c$var$uint256(val);
            return [
                $facb0cbc5626d02c$var$felt(el_uint256.low),
                $facb0cbc5626d02c$var$felt(el_uint256.high)
            ];
        default:
            return $facb0cbc5626d02c$var$felt(val);
    }
}
function $facb0cbc5626d02c$var$parseTuple(element, typeStr) {
    const memberTypes = $facb0cbc5626d02c$var$extractTupleMemberTypes(typeStr);
    const elements = Object.values(element);
    if (elements.length !== memberTypes.length) throw Error(`ParseTuple: provided and expected abi tuple size do not match.
      provided: ${elements} 
      expected: ${memberTypes}`);
    return memberTypes.map((it, dx)=>{
        var _it_type;
        return {
            element: elements[dx],
            type: (_it_type = it.type) !== null && _it_type !== void 0 ? _it_type : it
        };
    });
}
function $facb0cbc5626d02c$var$parseUint256(element) {
    if (typeof element === "object") {
        const { low: low, high: high } = element;
        return [
            $facb0cbc5626d02c$var$felt(low),
            $facb0cbc5626d02c$var$felt(high)
        ];
    }
    const el_uint256 = $facb0cbc5626d02c$var$uint256(element);
    return [
        $facb0cbc5626d02c$var$felt(el_uint256.low),
        $facb0cbc5626d02c$var$felt(el_uint256.high)
    ];
}
function $facb0cbc5626d02c$var$parseCalldataValue(element, type, structs, enums) {
    if (element === void 0) throw Error(`Missing parameter for type ${type}`);
    if (Array.isArray(element)) {
        const result = [];
        result.push($facb0cbc5626d02c$var$felt(element.length));
        const arrayType = $facb0cbc5626d02c$var$getArrayType(type);
        return element.reduce((acc, it)=>{
            return acc.concat($facb0cbc5626d02c$var$parseCalldataValue(it, arrayType, structs, enums));
        }, result);
    }
    if (structs[type] && structs[type].members.length) {
        if ($facb0cbc5626d02c$var$isTypeUint256(type)) return $facb0cbc5626d02c$var$parseUint256(element);
        if (type === "core::starknet::eth_address::EthAddress") return $facb0cbc5626d02c$var$parseBaseTypes(type, element);
        const { members: members } = structs[type];
        const subElement = element;
        return members.reduce((acc, it)=>{
            return acc.concat($facb0cbc5626d02c$var$parseCalldataValue(subElement[it.name], it.type, structs, enums));
        }, []);
    }
    if ($facb0cbc5626d02c$var$isTypeTuple(type)) {
        const tupled = $facb0cbc5626d02c$var$parseTuple(element, type);
        return tupled.reduce((acc, it)=>{
            const parsedData = $facb0cbc5626d02c$var$parseCalldataValue(it.element, it.type, structs, enums);
            return acc.concat(parsedData);
        }, []);
    }
    if ($facb0cbc5626d02c$var$isTypeUint256(type)) return $facb0cbc5626d02c$var$parseUint256(element);
    if ($facb0cbc5626d02c$var$isTypeEnum(type, enums)) {
        const { variants: variants } = enums[type];
        if ($facb0cbc5626d02c$var$isTypeOption(type)) {
            const myOption = element;
            if (myOption.isSome()) {
                const listTypeVariant2 = variants.find((variant)=>variant.name === "Some");
                if (typeof listTypeVariant2 === "undefined") throw Error(`Error in abi : Option has no 'Some' variant.`);
                const typeVariantSome = listTypeVariant2.type;
                if (typeVariantSome === "()") return 0..toString();
                const parsedParameter2 = $facb0cbc5626d02c$var$parseCalldataValue(myOption.unwrap(), typeVariantSome, structs, enums);
                if (Array.isArray(parsedParameter2)) return [
                    0..toString(),
                    ...parsedParameter2
                ];
                return [
                    0..toString(),
                    parsedParameter2
                ];
            }
            return 1..toString();
        }
        if ($facb0cbc5626d02c$var$isTypeResult(type)) {
            const myResult = element;
            if (myResult.isOk()) {
                const listTypeVariant3 = variants.find((variant)=>variant.name === "Ok");
                if (typeof listTypeVariant3 === "undefined") throw Error(`Error in abi : Result has no 'Ok' variant.`);
                const typeVariantOk = listTypeVariant3.type;
                if (typeVariantOk === "()") return 0..toString();
                const parsedParameter3 = $facb0cbc5626d02c$var$parseCalldataValue(myResult.unwrap(), typeVariantOk, structs, enums);
                if (Array.isArray(parsedParameter3)) return [
                    0..toString(),
                    ...parsedParameter3
                ];
                return [
                    0..toString(),
                    parsedParameter3
                ];
            }
            const listTypeVariant2 = variants.find((variant)=>variant.name === "Err");
            if (typeof listTypeVariant2 === "undefined") throw Error(`Error in abi : Result has no 'Err' variant.`);
            const typeVariantErr = listTypeVariant2.type;
            if (typeVariantErr === "()") return 1..toString();
            const parsedParameter2 = $facb0cbc5626d02c$var$parseCalldataValue(myResult.unwrap(), typeVariantErr, structs, enums);
            if (Array.isArray(parsedParameter2)) return [
                1..toString(),
                ...parsedParameter2
            ];
            return [
                1..toString(),
                parsedParameter2
            ];
        }
        const myEnum = element;
        const activeVariant = myEnum.activeVariant();
        const listTypeVariant = variants.find((variant)=>variant.name === activeVariant);
        if (typeof listTypeVariant === "undefined") throw Error(`Not find in abi : Enum has no '${activeVariant}' variant.`);
        const typeActiveVariant = listTypeVariant.type;
        const numActiveVariant = variants.findIndex((variant)=>variant.name === activeVariant);
        if (typeActiveVariant === "()") return numActiveVariant.toString();
        const parsedParameter = $facb0cbc5626d02c$var$parseCalldataValue(myEnum.unwrap(), typeActiveVariant, structs, enums);
        if (Array.isArray(parsedParameter)) return [
            numActiveVariant.toString(),
            ...parsedParameter
        ];
        return [
            numActiveVariant.toString(),
            parsedParameter
        ];
    }
    if (typeof element === "object") throw Error(`Parameter ${element} do not align with abi parameter ${type}`);
    return $facb0cbc5626d02c$var$parseBaseTypes(type, element);
}
function $facb0cbc5626d02c$var$parseCalldataField(argsIterator, input, structs, enums) {
    const { name: name, type: type } = input;
    let { value: value } = argsIterator.next();
    switch(true){
        case $facb0cbc5626d02c$var$isTypeArray(type):
            if (!Array.isArray(value) && !$facb0cbc5626d02c$var$isText(value)) throw Error(`ABI expected parameter ${name} to be array or long string, got ${value}`);
            if (typeof value === "string") value = $facb0cbc5626d02c$var$splitLongString(value);
            return $facb0cbc5626d02c$var$parseCalldataValue(value, input.type, structs, enums);
        case type === "core::starknet::eth_address::EthAddress":
            return $facb0cbc5626d02c$var$parseBaseTypes(type, value);
        case $facb0cbc5626d02c$var$isTypeStruct(type, structs) || $facb0cbc5626d02c$var$isTypeTuple(type) || $facb0cbc5626d02c$var$isTypeUint256(type):
            return $facb0cbc5626d02c$var$parseCalldataValue(value, type, structs, enums);
        case $facb0cbc5626d02c$var$isTypeEnum(type, enums):
            return $facb0cbc5626d02c$var$parseCalldataValue(value, type, structs, enums);
        default:
            return $facb0cbc5626d02c$var$parseBaseTypes(type, value);
    }
}
// src/utils/calldata/responseParser.ts
function $facb0cbc5626d02c$var$parseBaseTypes2(type, it) {
    let temp;
    switch(true){
        case $facb0cbc5626d02c$var$isTypeBool(type):
            temp = it.next().value;
            return Boolean(BigInt(temp));
        case $facb0cbc5626d02c$var$isTypeUint256(type):
            const low = it.next().value;
            const high = it.next().value;
            return $facb0cbc5626d02c$var$uint256ToBN({
                low: low,
                high: high
            });
        case type === "core::starknet::eth_address::EthAddress":
            temp = it.next().value;
            return BigInt(temp);
        default:
            temp = it.next().value;
            return BigInt(temp);
    }
}
function $facb0cbc5626d02c$var$parseResponseValue(responseIterator, element, structs, enums) {
    if (element.type === "()") return {};
    if ($facb0cbc5626d02c$var$isTypeUint256(element.type)) {
        const low = responseIterator.next().value;
        const high = responseIterator.next().value;
        return $facb0cbc5626d02c$var$uint256ToBN({
            low: low,
            high: high
        });
    }
    if ($facb0cbc5626d02c$var$isTypeArray(element.type)) {
        const parsedDataArr = [];
        const el = {
            name: "",
            type: $facb0cbc5626d02c$var$getArrayType(element.type)
        };
        const len = BigInt(responseIterator.next().value);
        while(parsedDataArr.length < len)parsedDataArr.push($facb0cbc5626d02c$var$parseResponseValue(responseIterator, el, structs, enums));
        return parsedDataArr;
    }
    if (structs && element.type in structs && structs[element.type]) {
        if (element.type === "core::starknet::eth_address::EthAddress") return $facb0cbc5626d02c$var$parseBaseTypes2(element.type, responseIterator);
        return structs[element.type].members.reduce((acc, el)=>{
            acc[el.name] = $facb0cbc5626d02c$var$parseResponseValue(responseIterator, el, structs, enums);
            return acc;
        }, {});
    }
    if (enums && element.type in enums && enums[element.type]) {
        const variantNum = Number(responseIterator.next().value);
        const rawEnum = enums[element.type].variants.reduce((acc, variant, num)=>{
            if (num === variantNum) {
                acc[variant.name] = $facb0cbc5626d02c$var$parseResponseValue(responseIterator, {
                    name: "",
                    type: variant.type
                }, structs, enums);
                return acc;
            }
            acc[variant.name] = void 0;
            return acc;
        }, {});
        if (element.type.startsWith("core::option::Option")) {
            const content = variantNum === 0 /* Some */  ? rawEnum.Some : void 0;
            return new $facb0cbc5626d02c$export$b8ecf101591c7ba8(variantNum, content);
        }
        if (element.type.startsWith("core::result::Result")) {
            let content;
            if (variantNum === 0 /* Ok */ ) content = rawEnum.Ok;
            else content = rawEnum.Err;
            return new $facb0cbc5626d02c$export$9c95511f15ff4e93(variantNum, content);
        }
        const customEnum = new $facb0cbc5626d02c$export$275e96c4fd8075e5(rawEnum);
        return customEnum;
    }
    if ($facb0cbc5626d02c$var$isTypeTuple(element.type)) {
        const memberTypes = $facb0cbc5626d02c$var$extractTupleMemberTypes(element.type);
        return memberTypes.reduce((acc, it, idx)=>{
            const name = (it === null || it === void 0 ? void 0 : it.name) ? it.name : idx;
            const type = (it === null || it === void 0 ? void 0 : it.type) ? it.type : it;
            const el = {
                name: name,
                type: type
            };
            acc[name] = $facb0cbc5626d02c$var$parseResponseValue(responseIterator, el, structs, enums);
            return acc;
        }, {});
    }
    if ($facb0cbc5626d02c$var$isTypeArray(element.type)) {
        const parsedDataArr = [];
        const el = {
            name: "",
            type: $facb0cbc5626d02c$var$getArrayType(element.type)
        };
        const len = BigInt(responseIterator.next().value);
        while(parsedDataArr.length < len)parsedDataArr.push($facb0cbc5626d02c$var$parseResponseValue(responseIterator, el, structs, enums));
        return parsedDataArr;
    }
    return $facb0cbc5626d02c$var$parseBaseTypes2(element.type, responseIterator);
}
function $facb0cbc5626d02c$var$responseParser(responseIterator, output, structs, enums, parsedResult) {
    const { name: name, type: type } = output;
    let temp;
    switch(true){
        case $facb0cbc5626d02c$var$isLen(name):
            temp = responseIterator.next().value;
            return BigInt(temp);
        case structs && type in structs || $facb0cbc5626d02c$var$isTypeTuple(type):
            return $facb0cbc5626d02c$var$parseResponseValue(responseIterator, output, structs, enums);
        case enums && $facb0cbc5626d02c$var$isTypeEnum(type, enums):
            return $facb0cbc5626d02c$var$parseResponseValue(responseIterator, output, structs, enums);
        case $facb0cbc5626d02c$var$isTypeArray(type):
            if ($facb0cbc5626d02c$var$isCairo1Type(type)) return $facb0cbc5626d02c$var$parseResponseValue(responseIterator, output, structs, enums);
            const parsedDataArr = [];
            if (parsedResult && parsedResult[`${name}_len`]) {
                const arrLen = parsedResult[`${name}_len`];
                while(parsedDataArr.length < arrLen)parsedDataArr.push($facb0cbc5626d02c$var$parseResponseValue(responseIterator, {
                    name: name,
                    type: output.type.replace("*", "")
                }, structs, enums));
            }
            return parsedDataArr;
        default:
            return $facb0cbc5626d02c$var$parseBaseTypes2(type, responseIterator);
    }
}
// src/utils/calldata/validate.ts
var $facb0cbc5626d02c$var$validateFelt = (parameter, input)=>{
    $facb0cbc5626d02c$var$assert(typeof parameter === "string" || typeof parameter === "number" || typeof parameter === "bigint", `Validate: arg ${input.name} should be a felt typed as (String, Number or BigInt)`);
    if (typeof parameter === "string" && !$facb0cbc5626d02c$var$isHex(parameter)) return;
    const param = BigInt(parameter.toString(10));
    $facb0cbc5626d02c$var$assert(// from : https://github.com/starkware-libs/starknet-specs/blob/29bab650be6b1847c92d4461d4c33008b5e50b1a/api/starknet_api_openrpc.json#L1266
    param >= 0n && param <= 2n ** 252n - 1n, `Validate: arg ${input.name} cairo typed ${input.type} should be in range [0, 2^252-1]`);
};
var $facb0cbc5626d02c$var$validateUint = (parameter, input)=>{
    if (typeof parameter === "number") $facb0cbc5626d02c$var$assert(parameter <= Number.MAX_SAFE_INTEGER, `Validation: Parameter is to large to be typed as Number use (BigInt or String)`);
    $facb0cbc5626d02c$var$assert(typeof parameter === "string" || typeof parameter === "number" || typeof parameter === "bigint" || typeof parameter === "object" && "low" in parameter && "high" in parameter, `Validate: arg ${input.name} of cairo type ${input.type} should be type (String, Number or BigInt), but is ${typeof parameter} ${parameter}.`);
    const param = typeof parameter === "object" ? $facb0cbc5626d02c$var$uint256ToBN(parameter) : $facb0cbc5626d02c$var$toBigInt(parameter);
    switch(input.type){
        case "core::integer::u8" /* u8 */ :
            $facb0cbc5626d02c$var$assert(param >= 0n && param <= 255n, `Validate: arg ${input.name} cairo typed ${input.type} should be in range [0 - 255]`);
            break;
        case "core::integer::u16" /* u16 */ :
            $facb0cbc5626d02c$var$assert(param >= 0n && param <= 65535n, `Validate: arg ${input.name} cairo typed ${input.type} should be in range [0, 65535]`);
            break;
        case "core::integer::u32" /* u32 */ :
            $facb0cbc5626d02c$var$assert(param >= 0n && param <= 4294967295n, `Validate: arg ${input.name} cairo typed ${input.type} should be in range [0, 4294967295]`);
            break;
        case "core::integer::u64" /* u64 */ :
            $facb0cbc5626d02c$var$assert(param >= 0n && param <= 2n ** 64n - 1n, `Validate: arg ${input.name} cairo typed ${input.type} should be in range [0, 2^64-1]`);
            break;
        case "core::integer::u128" /* u128 */ :
            $facb0cbc5626d02c$var$assert(param >= 0n && param <= 2n ** 128n - 1n, `Validate: arg ${input.name} cairo typed ${input.type} should be in range [0, 2^128-1]`);
            break;
        case "core::integer::u256" /* u256 */ :
            $facb0cbc5626d02c$var$assert(param >= 0n && param <= 2n ** 256n - 1n, `Validate: arg ${input.name} is ${input.type} 0 - 2^256-1`);
            break;
        case "core::starknet::class_hash::ClassHash" /* ClassHash */ :
            $facb0cbc5626d02c$var$assert(// from : https://github.com/starkware-libs/starknet-specs/blob/29bab650be6b1847c92d4461d4c33008b5e50b1a/api/starknet_api_openrpc.json#L1670
            param >= 0n && param <= 2n ** 252n - 1n, `Validate: arg ${input.name} cairo typed ${input.type} should be in range [0, 2^252-1]`);
            break;
        case "core::starknet::contract_address::ContractAddress" /* ContractAddress */ :
            $facb0cbc5626d02c$var$assert(// from : https://github.com/starkware-libs/starknet-specs/blob/29bab650be6b1847c92d4461d4c33008b5e50b1a/api/starknet_api_openrpc.json#L1245
            param >= 0n && param <= 2n ** 252n - 1n, `Validate: arg ${input.name} cairo typed ${input.type} should be in range [0, 2^252-1]`);
            break;
        default:
            break;
    }
};
var $facb0cbc5626d02c$var$validateBool = (parameter, input)=>{
    $facb0cbc5626d02c$var$assert(typeof parameter === "boolean", `Validate: arg ${input.name} of cairo type ${input.type} should be type (Boolean)`);
};
var $facb0cbc5626d02c$var$validateStruct = (parameter, input, structs)=>{
    if (input.type === "core::integer::u256" /* u256 */ ) {
        $facb0cbc5626d02c$var$validateUint(parameter, input);
        return;
    }
    if (input.type === "core::starknet::eth_address::EthAddress") {
        $facb0cbc5626d02c$var$assert(typeof parameter !== "object", `EthAddress type is waiting a BigNumberish. Got ${parameter}`);
        const param = BigInt(parameter.toString(10));
        $facb0cbc5626d02c$var$assert(// from : https://github.com/starkware-libs/starknet-specs/blob/29bab650be6b1847c92d4461d4c33008b5e50b1a/api/starknet_api_openrpc.json#L1259
        param >= 0n && param <= 2n ** 160n - 1n, `Validate: arg ${input.name} cairo typed ${input.type} should be in range [0, 2^160-1]`);
        return;
    }
    $facb0cbc5626d02c$var$assert(typeof parameter === "object" && !Array.isArray(parameter), `Validate: arg ${input.name} is cairo type struct (${input.type}), and should be defined as js object (not array)`);
    structs[input.type].members.forEach(({ name: name })=>{
        $facb0cbc5626d02c$var$assert(Object.keys(parameter).includes(name), `Validate: arg ${input.name} should have a property ${name}`);
    });
};
var $facb0cbc5626d02c$var$validateEnum = (parameter, input)=>{
    $facb0cbc5626d02c$var$assert(typeof parameter === "object" && !Array.isArray(parameter), `Validate: arg ${input.name} is cairo type Enum (${input.type}), and should be defined as js object (not array)`);
    const methodsKeys = Object.getOwnPropertyNames(Object.getPrototypeOf(parameter));
    const keys = [
        ...Object.getOwnPropertyNames(parameter),
        ...methodsKeys
    ];
    if ($facb0cbc5626d02c$var$isTypeOption(input.type) && keys.includes("isSome") && keys.includes("isNone")) return;
    if ($facb0cbc5626d02c$var$isTypeResult(input.type) && keys.includes("isOk") && keys.includes("isErr")) return;
    if (keys.includes("variant") && keys.includes("activeVariant")) return;
    throw new Error(`Validate Enum: argument ${input.name}, type ${input.type}, value received ${parameter}, is not an Enum.`);
};
var $facb0cbc5626d02c$var$validateTuple = (parameter, input)=>{
    $facb0cbc5626d02c$var$assert(typeof parameter === "object" && !Array.isArray(parameter), `Validate: arg ${input.name} should be a tuple (defined as object)`);
};
var $facb0cbc5626d02c$var$validateArray = (parameter, input, structs, enums)=>{
    const baseType = $facb0cbc5626d02c$var$getArrayType(input.type);
    if ($facb0cbc5626d02c$var$isTypeFelt(baseType) && $facb0cbc5626d02c$var$isLongText(parameter)) return;
    $facb0cbc5626d02c$var$assert(Array.isArray(parameter), `Validate: arg ${input.name} should be an Array`);
    switch(true){
        case $facb0cbc5626d02c$var$isTypeFelt(baseType):
            parameter.forEach((param)=>$facb0cbc5626d02c$var$validateFelt(param, input));
            break;
        case $facb0cbc5626d02c$var$isTypeTuple(baseType):
            parameter.forEach((it)=>$facb0cbc5626d02c$var$validateTuple(it, {
                    name: input.name,
                    type: baseType
                }));
            break;
        case $facb0cbc5626d02c$var$isTypeArray(baseType):
            parameter.forEach((param)=>$facb0cbc5626d02c$var$validateArray(param, {
                    name: "",
                    type: baseType
                }, structs, enums));
            break;
        case $facb0cbc5626d02c$var$isTypeStruct(baseType, structs):
            parameter.forEach((it)=>$facb0cbc5626d02c$var$validateStruct(it, {
                    name: input.name,
                    type: baseType
                }, structs));
            break;
        case $facb0cbc5626d02c$var$isTypeEnum(baseType, enums):
            parameter.forEach((it)=>$facb0cbc5626d02c$var$validateEnum(it, {
                    name: input.name,
                    type: baseType
                }));
            break;
        case $facb0cbc5626d02c$var$isTypeUint(baseType) || $facb0cbc5626d02c$var$isTypeLiteral(baseType):
            parameter.forEach((param)=>$facb0cbc5626d02c$var$validateUint(param, input));
            break;
        case $facb0cbc5626d02c$var$isTypeBool(baseType):
            parameter.forEach((param)=>$facb0cbc5626d02c$var$validateBool(param, input));
            break;
        default:
            throw new Error(`Validate Unhandled: argument ${input.name}, type ${input.type}, value ${parameter}`);
    }
};
function $facb0cbc5626d02c$var$validateFields(abiMethod, args, structs, enums) {
    abiMethod.inputs.reduce((acc, input)=>{
        const parameter = args[acc];
        switch(true){
            case $facb0cbc5626d02c$var$isLen(input.name):
                return acc;
            case $facb0cbc5626d02c$var$isTypeFelt(input.type):
                $facb0cbc5626d02c$var$validateFelt(parameter, input);
                break;
            case $facb0cbc5626d02c$var$isTypeUint(input.type) || $facb0cbc5626d02c$var$isTypeLiteral(input.type):
                $facb0cbc5626d02c$var$validateUint(parameter, input);
                break;
            case $facb0cbc5626d02c$var$isTypeBool(input.type):
                $facb0cbc5626d02c$var$validateBool(parameter, input);
                break;
            case $facb0cbc5626d02c$var$isTypeArray(input.type):
                $facb0cbc5626d02c$var$validateArray(parameter, input, structs, enums);
                break;
            case $facb0cbc5626d02c$var$isTypeStruct(input.type, structs):
                $facb0cbc5626d02c$var$validateStruct(parameter, input, structs);
                break;
            case $facb0cbc5626d02c$var$isTypeEnum(input.type, enums):
                $facb0cbc5626d02c$var$validateEnum(parameter, input);
                break;
            case $facb0cbc5626d02c$var$isTypeTuple(input.type):
                $facb0cbc5626d02c$var$validateTuple(parameter, input);
                break;
            default:
                throw new Error(`Validate Unhandled: argument ${input.name}, type ${input.type}, value ${parameter}`);
        }
        return acc + 1;
    }, 0);
}
// src/utils/calldata/index.ts
var $facb0cbc5626d02c$export$ac0e6ca389c6ad0e = class {
    /**
   * Validate arguments passed to the method as corresponding to the ones in the abi
   * @param type ValidateType - type of the method
   * @param method string - name of the method
   * @param args ArgsOrCalldata - arguments that are passed to the method
   */ validate(type, method, args = []) {
        if (type !== "DEPLOY" /* DEPLOY */ ) {
            const invocableFunctionNames = this.abi.filter((abi)=>{
                if (abi.type !== "function") return false;
                const isView = abi.stateMutability === "view" || abi.state_mutability === "view";
                return type === "INVOKE" /* INVOKE */  ? !isView : isView;
            }).map((abi)=>abi.name);
            $facb0cbc5626d02c$var$assert(invocableFunctionNames.includes(method), `${type === "INVOKE" /* INVOKE */  ? "invocable" : "viewable"} method not found in abi`);
        }
        const abiMethod = this.abi.find((abi)=>type === "DEPLOY" /* DEPLOY */  ? abi.name === method && abi.type === "constructor" : abi.name === method && abi.type === "function");
        if ($facb0cbc5626d02c$var$isNoConstructorValid(method, args, abiMethod)) return;
        const inputsLength = this.parser.methodInputsLength(abiMethod);
        if (args.length !== inputsLength) throw Error(`Invalid number of arguments, expected ${inputsLength} arguments, but got ${args.length}`);
        $facb0cbc5626d02c$var$validateFields(abiMethod, args, this.structs, this.enums);
    }
    /**
   * Compile contract callData with abi
   * Parse the calldata by using input fields from the abi for that method
   * @param method string - method name
   * @param args RawArgs - arguments passed to the method. Can be an array of arguments (in the order of abi definition), or an object constructed in conformity with abi (in this case, the parameter can be in a wrong order).
   * @return Calldata - parsed arguments in format that contract is expecting
   * @example
   * ```typescript
   * const calldata = myCallData.compile("constructor", ["0x34a", [1, 3n]]);
   * ```
   * ```typescript
   * const calldata2 = myCallData.compile("constructor", {list:[1, 3n], balance:"0x34"}); // wrong order is valid
   * ```
   */ compile(method, argsCalldata) {
        const abiMethod = this.abi.find((abiFunction)=>abiFunction.name === method);
        if ($facb0cbc5626d02c$var$isNoConstructorValid(method, argsCalldata, abiMethod)) return [];
        let args;
        if (Array.isArray(argsCalldata)) args = argsCalldata;
        else {
            const orderedObject = $facb0cbc5626d02c$var$orderPropsByAbi(argsCalldata, abiMethod.inputs, this.structs, this.enums);
            args = Object.values(orderedObject);
            $facb0cbc5626d02c$var$validateFields(abiMethod, args, this.structs, this.enums);
        }
        const argsIterator = args[Symbol.iterator]();
        const callArray = abiMethod.inputs.reduce((acc, input)=>$facb0cbc5626d02c$var$isLen(input.name) && !$facb0cbc5626d02c$var$isCairo1Type(input.type) ? acc : acc.concat($facb0cbc5626d02c$var$parseCalldataField(argsIterator, input, this.structs, this.enums)), []);
        Object.defineProperty(callArray, "__compiled__", {
            enumerable: false,
            writable: false,
            value: true
        });
        return callArray;
    }
    /**
   * Compile contract callData without abi
   * @param rawArgs RawArgs representing cairo method arguments or string array of compiled data
   * @returns Calldata
   */ static compile(rawArgs) {
        const createTree = (obj)=>{
            const getEntries = (o, prefix = ".")=>{
                const oe = Array.isArray(o) ? [
                    o.length.toString(),
                    ...o
                ] : o;
                return Object.entries(oe).flatMap(([k, v])=>{
                    let value = v;
                    if (k === "entrypoint") value = $facb0cbc5626d02c$var$getSelectorFromName(value);
                    else if ($facb0cbc5626d02c$var$isLongText(value)) value = $facb0cbc5626d02c$var$splitLongString(value);
                    const kk = Array.isArray(oe) && k === "0" ? "$$len" : k;
                    if ($facb0cbc5626d02c$var$isBigInt(value)) return [
                        [
                            `${prefix}${kk}`,
                            $facb0cbc5626d02c$var$felt(value)
                        ]
                    ];
                    if (Object(value) === value) {
                        const methodsKeys = Object.getOwnPropertyNames(Object.getPrototypeOf(value));
                        const keys = [
                            ...Object.getOwnPropertyNames(value),
                            ...methodsKeys
                        ];
                        if (keys.includes("isSome") && keys.includes("isNone")) {
                            const myOption = value;
                            const variantNb = myOption.isSome() ? 0 /* Some */  : 1 /* None */ ;
                            if (myOption.isSome()) return getEntries({
                                0: variantNb,
                                1: myOption.unwrap()
                            }, `${prefix}${kk}.`);
                            return [
                                [
                                    `${prefix}${kk}`,
                                    $facb0cbc5626d02c$var$felt(variantNb)
                                ]
                            ];
                        }
                        if (keys.includes("isOk") && keys.includes("isErr")) {
                            const myResult = value;
                            const variantNb = myResult.isOk() ? 0 /* Ok */  : 1 /* Err */ ;
                            return getEntries({
                                0: variantNb,
                                1: myResult.unwrap()
                            }, `${prefix}${kk}.`);
                        }
                        if (keys.includes("variant") && keys.includes("activeVariant")) {
                            const myEnum = value;
                            const activeVariant = myEnum.activeVariant();
                            const listVariants = Object.keys(myEnum.variant);
                            const activeVariantNb = listVariants.findIndex((variant)=>variant === activeVariant);
                            if (typeof myEnum.unwrap() === "object" && Object.keys(myEnum.unwrap()).length === 0) return [
                                [
                                    `${prefix}${kk}`,
                                    $facb0cbc5626d02c$var$felt(activeVariantNb)
                                ]
                            ];
                            return getEntries({
                                0: activeVariantNb,
                                1: myEnum.unwrap()
                            }, `${prefix}${kk}.`);
                        }
                        return getEntries(value, `${prefix}${kk}.`);
                    }
                    return [
                        [
                            `${prefix}${kk}`,
                            $facb0cbc5626d02c$var$felt(value)
                        ]
                    ];
                });
            };
            const result = Object.fromEntries(getEntries(obj));
            return result;
        };
        let callTreeArray;
        if (!Array.isArray(rawArgs)) {
            const callTree = createTree(rawArgs);
            callTreeArray = Object.values(callTree);
        } else {
            const callObj = {
                ...rawArgs
            };
            const callTree = createTree(callObj);
            callTreeArray = Object.values(callTree);
        }
        Object.defineProperty(callTreeArray, "__compiled__", {
            enumerable: false,
            writable: false,
            value: true
        });
        return callTreeArray;
    }
    /**
   * Parse elements of the response array and structuring them into response object
   * @param method string - method name
   * @param response string[] - response from the method
   * @return Result - parsed response corresponding to the abi
   */ parse(method, response) {
        const { outputs: outputs } = this.abi.find((abi)=>abi.name === method);
        const responseIterator = response.flat()[Symbol.iterator]();
        const parsed = outputs.flat().reduce((acc, output, idx)=>{
            var _output_name;
            const propName = (_output_name = output.name) !== null && _output_name !== void 0 ? _output_name : idx;
            acc[propName] = $facb0cbc5626d02c$var$responseParser(responseIterator, output, this.structs, this.enums, acc);
            if (acc[propName] && acc[`${propName}_len`]) delete acc[`${propName}_len`];
            return acc;
        }, {});
        return Object.keys(parsed).length === 1 && 0 in parsed ? parsed[0] : parsed;
    }
    /**
   * Format cairo method response data to native js values based on provided format schema
   * @param method string - cairo method name
   * @param response string[] - cairo method response
   * @param format object - formatter object schema
   * @returns Result - parsed and formatted response object
   */ format(method, response, format) {
        const parsed = this.parse(method, response);
        return $facb0cbc5626d02c$var$formatter(parsed, format);
    }
    /**
   * Helper to extract structs from abi
   * @param abi Abi
   * @returns AbiStructs - structs from abi
   */ static getAbiStruct(abi) {
        return abi.filter((abiEntry)=>abiEntry.type === "struct").reduce((acc, abiEntry)=>({
                ...acc,
                [abiEntry.name]: abiEntry
            }), {});
    }
    /**
   * Helper to extract enums from abi
   * @param abi Abi
   * @returns AbiEnums - enums from abi
   */ static getAbiEnum(abi) {
        const fullEnumList = abi.filter((abiEntry)=>abiEntry.type === "enum").reduce((acc, abiEntry)=>({
                ...acc,
                [abiEntry.name]: abiEntry
            }), {});
        delete fullEnumList["core::bool"];
        return fullEnumList;
    }
    /**
   * Helper: Compile HexCalldata | RawCalldata | RawArgs
   * @param rawCalldata HexCalldata | RawCalldata | RawArgs
   * @returns Calldata
   */ static toCalldata(rawCalldata = []) {
        return $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile(rawCalldata);
    }
    /**
   * Helper: Convert raw to HexCalldata
   * @param raw HexCalldata | RawCalldata | RawArgs
   * @returns HexCalldata
   */ static toHex(raw = []) {
        const calldata = $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile(raw);
        return calldata.map((it)=>$facb0cbc5626d02c$var$toHex(it));
    }
    /**
   * Parse the elements of a contract response and structure them into one or several Result.
   * In Cairo 0, arrays are not supported.
   * @param typeCairo string or string[] - Cairo type name, ex : "hello::hello::UserData"
   * @param response string[] - serialized data corresponding to typeCairo.
   * @return Result or Result[] - parsed response corresponding to typeData.
   * @example
   * const res2=helloCallData.decodeParameters("hello::hello::UserData",["0x123456","0x1"]);
   * result = { address: 1193046n, is_claimed: true }
   */ decodeParameters(typeCairo, response) {
        const typeCairoArray = Array.isArray(typeCairo) ? typeCairo : [
            typeCairo
        ];
        const responseIterator = response.flat()[Symbol.iterator]();
        const decodedArray = typeCairoArray.map((typeParam)=>$facb0cbc5626d02c$var$responseParser(responseIterator, {
                name: "",
                type: typeParam
            }, this.structs, this.enums));
        return decodedArray.length === 1 ? decodedArray[0] : decodedArray;
    }
    constructor(abi){
        (0, $dxWQo._)(this, "abi", void 0);
        (0, $dxWQo._)(this, "parser", void 0);
        (0, $dxWQo._)(this, "structs", void 0);
        (0, $dxWQo._)(this, "enums", void 0);
        this.structs = $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.getAbiStruct(abi);
        this.enums = $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.getAbiEnum(abi);
        this.parser = $facb0cbc5626d02c$var$createAbiParser(abi);
        this.abi = this.parser.getLegacyFormat();
    }
};
// src/utils/hash.ts
var $facb0cbc5626d02c$export$d6af199866bfb566 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$d6af199866bfb566, {
    calculateContractAddressFromHash: ()=>$facb0cbc5626d02c$var$calculateContractAddressFromHash,
    calculateDeclareTransactionHash: ()=>$facb0cbc5626d02c$var$calculateDeclareTransactionHash,
    calculateDeployAccountTransactionHash: ()=>$facb0cbc5626d02c$var$calculateDeployAccountTransactionHash,
    calculateDeployTransactionHash: ()=>$facb0cbc5626d02c$var$calculateDeployTransactionHash,
    calculateTransactionHash: ()=>$facb0cbc5626d02c$var$calculateTransactionHash,
    calculateTransactionHashCommon: ()=>$facb0cbc5626d02c$var$calculateTransactionHashCommon,
    computeCompiledClassHash: ()=>$facb0cbc5626d02c$var$computeCompiledClassHash,
    computeContractClassHash: ()=>$facb0cbc5626d02c$var$computeContractClassHash,
    computeHashOnElements: ()=>$facb0cbc5626d02c$var$computeHashOnElements,
    computeLegacyContractClassHash: ()=>$facb0cbc5626d02c$var$computeLegacyContractClassHash,
    computePedersenHash: ()=>$facb0cbc5626d02c$var$computePedersenHash,
    computePedersenHashOnElements: ()=>$facb0cbc5626d02c$var$computePedersenHashOnElements,
    computePoseidonHash: ()=>$facb0cbc5626d02c$var$computePoseidonHash,
    computePoseidonHashOnElements: ()=>$facb0cbc5626d02c$var$computePoseidonHashOnElements,
    computeSierraContractClassHash: ()=>$facb0cbc5626d02c$var$computeSierraContractClassHash,
    default: ()=>$facb0cbc5626d02c$var$computeHintedClassHash,
    feeTransactionVersion: ()=>$facb0cbc5626d02c$var$feeTransactionVersion,
    feeTransactionVersion_2: ()=>$facb0cbc5626d02c$var$feeTransactionVersion_2,
    formatSpaces: ()=>$facb0cbc5626d02c$var$formatSpaces,
    getSelector: ()=>$facb0cbc5626d02c$var$getSelector,
    getSelectorFromName: ()=>$facb0cbc5626d02c$var$getSelectorFromName,
    getVersionsByType: ()=>$facb0cbc5626d02c$var$getVersionsByType,
    keccakBn: ()=>$facb0cbc5626d02c$var$keccakBn,
    poseidon: ()=>$kCOjY,
    starknetKeccak: ()=>$facb0cbc5626d02c$var$starknetKeccak,
    transactionVersion: ()=>$facb0cbc5626d02c$var$transactionVersion,
    transactionVersion_2: ()=>$facb0cbc5626d02c$var$transactionVersion_2
});
// src/utils/ec.ts
var $facb0cbc5626d02c$export$6be572eb25b0fc90 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$6be572eb25b0fc90, {
    starkCurve: ()=>$5GNKL,
    weierstrass: ()=>$2XPJl
});
// src/utils/json.ts
var $facb0cbc5626d02c$export$7b419323e6ed4f31 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$7b419323e6ed4f31, {
    parse: ()=>$facb0cbc5626d02c$var$parse2,
    parseAlwaysAsBig: ()=>$facb0cbc5626d02c$var$parseAlwaysAsBig,
    stringify: ()=>$facb0cbc5626d02c$var$stringify2,
    stringifyAlwaysAsBig: ()=>$facb0cbc5626d02c$var$stringifyAlwaysAsBig
});
var $facb0cbc5626d02c$var$parseIntAsNumberOrBigInt = (x)=>{
    if (!$8fWHv.isInteger(x)) return parseFloat(x);
    const v = parseInt(x, 10);
    return Number.isSafeInteger(v) ? v : BigInt(x);
};
var $facb0cbc5626d02c$var$parse2 = (x)=>$8fWHv.parse(String(x), void 0, $facb0cbc5626d02c$var$parseIntAsNumberOrBigInt);
var $facb0cbc5626d02c$var$parseAlwaysAsBig = (x)=>$8fWHv.parse(String(x), void 0, $8fWHv.parseNumberAndBigInt);
var $facb0cbc5626d02c$var$stringify2 = (value, replacer, space, numberStringifiers)=>$8fWHv.stringify(value, replacer, space, numberStringifiers);
var $facb0cbc5626d02c$var$stringifyAlwaysAsBig = $facb0cbc5626d02c$var$stringify2;
var $facb0cbc5626d02c$var$transactionVersion = $facb0cbc5626d02c$var$BN_TRANSACTION_VERSION_1;
var $facb0cbc5626d02c$var$transactionVersion_2 = $facb0cbc5626d02c$var$BN_TRANSACTION_VERSION_2;
var $facb0cbc5626d02c$var$feeTransactionVersion = $facb0cbc5626d02c$var$BN_FEE_TRANSACTION_VERSION_1;
var $facb0cbc5626d02c$var$feeTransactionVersion_2 = $facb0cbc5626d02c$var$BN_FEE_TRANSACTION_VERSION_2;
function $facb0cbc5626d02c$var$getVersionsByType(versionType) {
    return versionType === "fee" ? {
        v1: $facb0cbc5626d02c$var$feeTransactionVersion,
        v2: $facb0cbc5626d02c$var$feeTransactionVersion_2
    } : {
        v1: $facb0cbc5626d02c$var$transactionVersion,
        v2: $facb0cbc5626d02c$var$transactionVersion_2
    };
}
function $facb0cbc5626d02c$var$computePedersenHash(a, b) {
    return $5GNKL.pedersen(BigInt(a), BigInt(b));
}
function $facb0cbc5626d02c$var$computePoseidonHash(a, b) {
    return $facb0cbc5626d02c$var$toHex($5GNKL.poseidonHash(BigInt(a), BigInt(b)));
}
function $facb0cbc5626d02c$var$computeHashOnElements(data) {
    return [
        ...data,
        data.length
    ].reduce((x, y)=>$5GNKL.pedersen(BigInt(x), BigInt(y)), 0).toString();
}
var $facb0cbc5626d02c$var$computePedersenHashOnElements = $facb0cbc5626d02c$var$computeHashOnElements;
function $facb0cbc5626d02c$var$computePoseidonHashOnElements(data) {
    return $facb0cbc5626d02c$var$toHex((0, $5GNKL.poseidonHashMany)(data.map((x)=>BigInt(x))));
}
function $facb0cbc5626d02c$var$calculateTransactionHashCommon(txHashPrefix, version, contractAddress, entryPointSelector, calldata, maxFee, chainId, additionalData = []) {
    const calldataHash = $facb0cbc5626d02c$var$computeHashOnElements(calldata);
    const dataToHash = [
        txHashPrefix,
        version,
        contractAddress,
        entryPointSelector,
        calldataHash,
        maxFee,
        chainId,
        ...additionalData
    ];
    return $facb0cbc5626d02c$var$computeHashOnElements(dataToHash);
}
function $facb0cbc5626d02c$var$calculateDeployTransactionHash(contractAddress, constructorCalldata, version, chainId, constructorName = "constructor") {
    return $facb0cbc5626d02c$var$calculateTransactionHashCommon("0x6465706c6f79" /* DEPLOY */ , version, contractAddress, $facb0cbc5626d02c$var$getSelectorFromName(constructorName), constructorCalldata, 0, chainId);
}
function $facb0cbc5626d02c$var$calculateDeclareTransactionHash(classHash, senderAddress, version, maxFee, chainId, nonce, compiledClassHash) {
    return $facb0cbc5626d02c$var$calculateTransactionHashCommon("0x6465636c617265" /* DECLARE */ , version, senderAddress, 0, [
        classHash
    ], maxFee, chainId, [
        nonce,
        ...compiledClassHash ? [
            compiledClassHash
        ] : []
    ]);
}
function $facb0cbc5626d02c$var$calculateDeployAccountTransactionHash(contractAddress, classHash, constructorCalldata, salt, version, maxFee, chainId, nonce) {
    const calldata = [
        classHash,
        salt,
        ...constructorCalldata
    ];
    return $facb0cbc5626d02c$var$calculateTransactionHashCommon("0x6465706c6f795f6163636f756e74" /* DEPLOY_ACCOUNT */ , version, contractAddress, 0, calldata, maxFee, chainId, [
        nonce
    ]);
}
function $facb0cbc5626d02c$var$calculateTransactionHash(contractAddress, version, calldata, maxFee, chainId, nonce) {
    return $facb0cbc5626d02c$var$calculateTransactionHashCommon("0x696e766f6b65" /* INVOKE */ , version, contractAddress, 0, calldata, maxFee, chainId, [
        nonce
    ]);
}
function $facb0cbc5626d02c$var$calculateContractAddressFromHash(salt, classHash, constructorCalldata, deployerAddress) {
    const compiledCalldata = $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile(constructorCalldata);
    const constructorCalldataHash = $facb0cbc5626d02c$var$computeHashOnElements(compiledCalldata);
    const CONTRACT_ADDRESS_PREFIX = $facb0cbc5626d02c$var$felt("0x535441524b4e45545f434f4e54524143545f41444452455353");
    const hash = $facb0cbc5626d02c$var$computeHashOnElements([
        CONTRACT_ADDRESS_PREFIX,
        deployerAddress,
        salt,
        classHash,
        constructorCalldataHash
    ]);
    return $facb0cbc5626d02c$var$toHex(BigInt(hash) % $facb0cbc5626d02c$var$ADDR_BOUND);
}
function $facb0cbc5626d02c$var$nullSkipReplacer(key, value) {
    if (key === "attributes" || key === "accessible_scopes") return Array.isArray(value) && value.length === 0 ? void 0 : value;
    if (key === "debug_info") return null;
    return value === null ? void 0 : value;
}
function $facb0cbc5626d02c$var$formatSpaces(json2) {
    let insideQuotes = false;
    const newString = [];
    for (const char of json2){
        if (char === '"' && (newString.length > 0 && newString.slice(-1)[0] === "\\") === false) insideQuotes = !insideQuotes;
        if (insideQuotes) newString.push(char);
        else newString.push(char === ":" ? ": " : char === "," ? ", " : char);
    }
    return newString.join("");
}
function $facb0cbc5626d02c$var$computeHintedClassHash(compiledContract) {
    const { abi: abi, program: program } = compiledContract;
    const contractClass = {
        abi: abi,
        program: program
    };
    const serializedJson = $facb0cbc5626d02c$var$formatSpaces($facb0cbc5626d02c$var$stringify2(contractClass, $facb0cbc5626d02c$var$nullSkipReplacer));
    return $facb0cbc5626d02c$var$addHexPrefix($5GNKL.keccak($facb0cbc5626d02c$var$utf8ToArray(serializedJson)).toString(16));
}
function $facb0cbc5626d02c$var$computeLegacyContractClassHash(contract) {
    const compiledContract = typeof contract === "string" ? $facb0cbc5626d02c$var$parse2(contract) : contract;
    const apiVersion = $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$API_VERSION);
    const externalEntryPointsHash = $facb0cbc5626d02c$var$computeHashOnElements(compiledContract.entry_points_by_type.EXTERNAL.flatMap((e)=>[
            e.selector,
            e.offset
        ]));
    const l1HandlerEntryPointsHash = $facb0cbc5626d02c$var$computeHashOnElements(compiledContract.entry_points_by_type.L1_HANDLER.flatMap((e)=>[
            e.selector,
            e.offset
        ]));
    const constructorEntryPointHash = $facb0cbc5626d02c$var$computeHashOnElements(compiledContract.entry_points_by_type.CONSTRUCTOR.flatMap((e)=>[
            e.selector,
            e.offset
        ]));
    const builtinsHash = $facb0cbc5626d02c$var$computeHashOnElements(compiledContract.program.builtins.map((s)=>$facb0cbc5626d02c$var$encodeShortString(s)));
    const hintedClassHash = $facb0cbc5626d02c$var$computeHintedClassHash(compiledContract);
    const dataHash = $facb0cbc5626d02c$var$computeHashOnElements(compiledContract.program.data);
    return $facb0cbc5626d02c$var$computeHashOnElements([
        apiVersion,
        externalEntryPointsHash,
        l1HandlerEntryPointsHash,
        constructorEntryPointHash,
        builtinsHash,
        hintedClassHash,
        dataHash
    ]);
}
function $facb0cbc5626d02c$var$hashBuiltins(builtins) {
    return (0, $5GNKL.poseidonHashMany)(builtins.flatMap((it)=>{
        return BigInt($facb0cbc5626d02c$var$encodeShortString(it));
    }));
}
function $facb0cbc5626d02c$var$hashEntryPoint(data) {
    const base = data.flatMap((it)=>{
        return [
            BigInt(it.selector),
            BigInt(it.offset),
            $facb0cbc5626d02c$var$hashBuiltins(it.builtins)
        ];
    });
    return (0, $5GNKL.poseidonHashMany)(base);
}
function $facb0cbc5626d02c$var$computeCompiledClassHash(casm) {
    const COMPILED_CLASS_VERSION = "COMPILED_CLASS_V1";
    const compiledClassVersion = BigInt($facb0cbc5626d02c$var$encodeShortString(COMPILED_CLASS_VERSION));
    const externalEntryPointsHash = $facb0cbc5626d02c$var$hashEntryPoint(casm.entry_points_by_type.EXTERNAL);
    const l1Handlers = $facb0cbc5626d02c$var$hashEntryPoint(casm.entry_points_by_type.L1_HANDLER);
    const constructor = $facb0cbc5626d02c$var$hashEntryPoint(casm.entry_points_by_type.CONSTRUCTOR);
    const bytecode = (0, $5GNKL.poseidonHashMany)(casm.bytecode.map((it)=>BigInt(it)));
    return $facb0cbc5626d02c$var$toHex((0, $5GNKL.poseidonHashMany)([
        compiledClassVersion,
        externalEntryPointsHash,
        l1Handlers,
        constructor,
        bytecode
    ]));
}
function $facb0cbc5626d02c$var$hashEntryPointSierra(data) {
    const base = data.flatMap((it)=>{
        return [
            BigInt(it.selector),
            BigInt(it.function_idx)
        ];
    });
    return (0, $5GNKL.poseidonHashMany)(base);
}
function $facb0cbc5626d02c$var$hashAbi(sierra) {
    const indentString = $facb0cbc5626d02c$var$formatSpaces($facb0cbc5626d02c$var$stringify2(sierra.abi, null));
    return BigInt($facb0cbc5626d02c$var$addHexPrefix($5GNKL.keccak($facb0cbc5626d02c$var$utf8ToArray(indentString)).toString(16)));
}
function $facb0cbc5626d02c$var$computeSierraContractClassHash(sierra) {
    const CONTRACT_CLASS_VERSION = "CONTRACT_CLASS_V0.1.0";
    const compiledClassVersion = BigInt($facb0cbc5626d02c$var$encodeShortString(CONTRACT_CLASS_VERSION));
    const externalEntryPointsHash = $facb0cbc5626d02c$var$hashEntryPointSierra(sierra.entry_points_by_type.EXTERNAL);
    const l1Handlers = $facb0cbc5626d02c$var$hashEntryPointSierra(sierra.entry_points_by_type.L1_HANDLER);
    const constructor = $facb0cbc5626d02c$var$hashEntryPointSierra(sierra.entry_points_by_type.CONSTRUCTOR);
    const abiHash = $facb0cbc5626d02c$var$hashAbi(sierra);
    const sierraProgram = (0, $5GNKL.poseidonHashMany)(sierra.sierra_program.map((it)=>BigInt(it)));
    return $facb0cbc5626d02c$var$toHex((0, $5GNKL.poseidonHashMany)([
        compiledClassVersion,
        externalEntryPointsHash,
        l1Handlers,
        constructor,
        abiHash,
        sierraProgram
    ]));
}
function $facb0cbc5626d02c$var$computeContractClassHash(contract) {
    const compiledContract = typeof contract === "string" ? $facb0cbc5626d02c$var$parse2(contract) : contract;
    if ("sierra_program" in compiledContract) return $facb0cbc5626d02c$var$computeSierraContractClassHash(compiledContract);
    return $facb0cbc5626d02c$var$computeLegacyContractClassHash(compiledContract);
}
// src/utils/stark.ts
var $facb0cbc5626d02c$export$56c09bfdffd6a7c6 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$56c09bfdffd6a7c6, {
    compressProgram: ()=>$facb0cbc5626d02c$var$compressProgram,
    decompressProgram: ()=>$facb0cbc5626d02c$var$decompressProgram,
    estimatedFeeToMaxFee: ()=>$facb0cbc5626d02c$var$estimatedFeeToMaxFee,
    formatSignature: ()=>$facb0cbc5626d02c$var$formatSignature,
    makeAddress: ()=>$facb0cbc5626d02c$var$makeAddress,
    randomAddress: ()=>$facb0cbc5626d02c$var$randomAddress,
    signatureToDecimalArray: ()=>$facb0cbc5626d02c$var$signatureToDecimalArray,
    signatureToHexArray: ()=>$facb0cbc5626d02c$var$signatureToHexArray
});
function $facb0cbc5626d02c$var$compressProgram(jsonProgram) {
    const stringified = typeof jsonProgram === "string" ? jsonProgram : $facb0cbc5626d02c$var$stringify2(jsonProgram);
    const compressedProgram = (0, $kGJ2Q.gzip)(stringified);
    return $facb0cbc5626d02c$var$btoaUniversal(compressedProgram);
}
function $facb0cbc5626d02c$var$decompressProgram(base642) {
    if (Array.isArray(base642)) return base642;
    const decompressed = $facb0cbc5626d02c$var$arrayBufferToString((0, $kGJ2Q.ungzip)($facb0cbc5626d02c$var$atobUniversal(base642)));
    return $facb0cbc5626d02c$var$parse2(decompressed);
}
function $facb0cbc5626d02c$var$randomAddress() {
    const randomKeyPair = (0, $5GNKL.utils).randomPrivateKey();
    return (0, $5GNKL.getStarkKey)(randomKeyPair);
}
function $facb0cbc5626d02c$var$makeAddress(input) {
    return $facb0cbc5626d02c$var$addHexPrefix(input).toLowerCase();
}
function $facb0cbc5626d02c$var$formatSignature(sig) {
    if (!sig) throw Error("formatSignature: provided signature is undefined");
    if (Array.isArray(sig)) return sig.map((it)=>$facb0cbc5626d02c$var$toHex(it));
    try {
        const { r: r, s: s } = sig;
        return [
            $facb0cbc5626d02c$var$toHex(r),
            $facb0cbc5626d02c$var$toHex(s)
        ];
    } catch (e) {
        throw new Error("Signature need to be weierstrass.SignatureType or an array for custom");
    }
}
function $facb0cbc5626d02c$var$signatureToDecimalArray(sig) {
    return $facb0cbc5626d02c$var$bigNumberishArrayToDecimalStringArray($facb0cbc5626d02c$var$formatSignature(sig));
}
function $facb0cbc5626d02c$var$signatureToHexArray(sig) {
    return $facb0cbc5626d02c$var$bigNumberishArrayToHexadecimalStringArray($facb0cbc5626d02c$var$formatSignature(sig));
}
function $facb0cbc5626d02c$var$estimatedFeeToMaxFee(estimatedFee, overhead = 0.5) {
    const overHeadPercent = Math.round((1 + overhead) * 100);
    return $facb0cbc5626d02c$var$toBigInt(estimatedFee) * $facb0cbc5626d02c$var$toBigInt(overHeadPercent) / 100n;
}
// src/utils/contract.ts
function $facb0cbc5626d02c$export$6050805ab301367e(contract) {
    const compiledContract = typeof contract === "string" ? $facb0cbc5626d02c$var$parse2(contract) : contract;
    return "sierra_program" in compiledContract;
}
function $facb0cbc5626d02c$export$dae6fc4ab9af26b8(payload) {
    const response = {
        ...payload
    };
    if ($facb0cbc5626d02c$export$6050805ab301367e(payload.contract)) {
        if (!payload.compiledClassHash && payload.casm) response.compiledClassHash = $facb0cbc5626d02c$var$computeCompiledClassHash(payload.casm);
        if (!response.compiledClassHash) throw new Error("Extract compiledClassHash failed, provide (CairoAssembly).casm file or compiledClassHash");
    }
    var _payload_classHash;
    response.classHash = (_payload_classHash = payload.classHash) !== null && _payload_classHash !== void 0 ? _payload_classHash : $facb0cbc5626d02c$var$computeContractClassHash(payload.contract);
    if (!response.classHash) throw new Error("Extract classHash failed, provide (CompiledContract).json file or classHash");
    return response;
}
function $facb0cbc5626d02c$export$ad96edd8d0a43d0(ccr) {
    if ($facb0cbc5626d02c$export$6050805ab301367e(ccr)) throw Error("ContractClassResponse need to be LegacyContractClass (cairo0 response class)");
    const contract = ccr;
    return {
        ...contract,
        program: $facb0cbc5626d02c$var$decompressProgram(contract.program)
    };
}
var $facb0cbc5626d02c$var$fetchPonyfill_default = typeof window !== "undefined" && window.fetch || // use buildin fetch in browser if available
typeof $parcel$global !== "undefined" && $parcel$global.fetch || // use buildin fetch in node, react-native and service worker if available
(0, (/*@__PURE__*/$parcel$interopDefault($jxHwd)));
// src/utils/provider.ts
var $facb0cbc5626d02c$export$ca328f169d304df4 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$ca328f169d304df4, {
    createSierraContractClass: ()=>$facb0cbc5626d02c$var$createSierraContractClass,
    parseContract: ()=>$facb0cbc5626d02c$var$parseContract,
    wait: ()=>$facb0cbc5626d02c$var$wait
});
function $facb0cbc5626d02c$var$wait(delay) {
    return new Promise((res)=>{
        setTimeout(res, delay);
    });
}
function $facb0cbc5626d02c$var$createSierraContractClass(contract) {
    const result = {
        ...contract
    };
    delete result.sierra_program_debug_info;
    result.abi = $facb0cbc5626d02c$var$formatSpaces($facb0cbc5626d02c$var$stringify2(contract.abi));
    result.sierra_program = $facb0cbc5626d02c$var$formatSpaces($facb0cbc5626d02c$var$stringify2(contract.sierra_program));
    result.sierra_program = $facb0cbc5626d02c$var$compressProgram(result.sierra_program);
    return result;
}
function $facb0cbc5626d02c$var$parseContract(contract) {
    const parsedContract = typeof contract === "string" ? $facb0cbc5626d02c$var$parse2(contract) : contract;
    if (!$facb0cbc5626d02c$export$6050805ab301367e(contract)) return {
        ...parsedContract,
        ..."program" in parsedContract && {
            program: $facb0cbc5626d02c$var$compressProgram(parsedContract.program)
        }
    };
    return $facb0cbc5626d02c$var$createSierraContractClass(parsedContract);
}
// src/utils/responseParser/rpc.ts
var $facb0cbc5626d02c$var$RPCResponseParser = class {
    parseGetBlockResponse(res) {
        return {
            timestamp: res.timestamp,
            block_hash: "block_hash" in res ? res.block_hash : "",
            block_number: "block_number" in res ? res.block_number : -1,
            new_root: "new_root" in res ? res.new_root : "",
            parent_hash: res.parent_hash,
            status: "status" in res ? res.status : "PENDING" /* PENDING */ ,
            transactions: res.transactions
        };
    }
    parseGetTransactionResponse(res) {
        return {
            calldata: "calldata" in res ? res.calldata : [],
            contract_address: "contract_address" in res ? res.contract_address : "",
            sender_address: "sender_address" in res ? res.sender_address : "",
            max_fee: "max_fee" in res ? res.max_fee : "",
            nonce: "nonce" in res ? res.nonce : "",
            signature: "signature" in res ? res.signature : [],
            transaction_hash: res.transaction_hash,
            version: res.version
        };
    }
    parseFeeEstimateResponse(res) {
        return {
            overall_fee: $facb0cbc5626d02c$var$toBigInt(res[0].overall_fee),
            gas_consumed: $facb0cbc5626d02c$var$toBigInt(res[0].gas_consumed),
            gas_price: $facb0cbc5626d02c$var$toBigInt(res[0].gas_price)
        };
    }
    parseFeeEstimateBulkResponse(res) {
        return res.map((val)=>({
                overall_fee: $facb0cbc5626d02c$var$toBigInt(val.overall_fee),
                gas_consumed: $facb0cbc5626d02c$var$toBigInt(val.gas_consumed),
                gas_price: $facb0cbc5626d02c$var$toBigInt(val.gas_price)
            }));
    }
    parseCallContractResponse(res) {
        return {
            result: res
        };
    }
    parseSimulateTransactionResponse(res) {
        return res.map((it)=>{
            return {
                ...it,
                suggestedMaxFee: $facb0cbc5626d02c$var$estimatedFeeToMaxFee(BigInt(it.fee_estimation.overall_fee))
            };
        });
    }
    parseContractClassResponse(res) {
        return {
            ...res,
            abi: typeof res.abi === "string" ? JSON.parse(res.abi) : res.abi
        };
    }
};
// src/provider/errors.ts
function $facb0cbc5626d02c$export$7b03f7b96cafe5bf(target, fn = target.constructor) {
    const { captureStackTrace: captureStackTrace } = Error;
    captureStackTrace && captureStackTrace(target, fn);
}
function $facb0cbc5626d02c$export$81ffe03534f80f3(target, prototype) {
    const { setPrototypeOf: setPrototypeOf } = Object;
    setPrototypeOf ? setPrototypeOf(target, prototype) : target.__proto__ = prototype;
}
var $facb0cbc5626d02c$export$f7a70f5f17339408 = class extends Error {
    constructor(message){
        super(message);
        (0, $dxWQo._)(this, "name", void 0);
        Object.defineProperty(this, "name", {
            value: new.target.name,
            enumerable: false,
            configurable: true
        });
        $facb0cbc5626d02c$export$81ffe03534f80f3(this, new.target.prototype);
        $facb0cbc5626d02c$export$7b03f7b96cafe5bf(this);
    }
};
var $facb0cbc5626d02c$export$8c05b2dc6219e90a = class extends $facb0cbc5626d02c$export$f7a70f5f17339408 {
};
var $facb0cbc5626d02c$export$8ef93724ecb8bcb7 = class extends $facb0cbc5626d02c$export$8c05b2dc6219e90a {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
};
var $facb0cbc5626d02c$export$65bd6083489bd8bb = class extends $facb0cbc5626d02c$export$8c05b2dc6219e90a {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
};
// src/utils/starknetId.ts
var $facb0cbc5626d02c$export$b55e51a2a2c4239a = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$b55e51a2a2c4239a, {
    StarknetIdContract: ()=>$facb0cbc5626d02c$var$StarknetIdContract,
    getStarknetIdContract: ()=>$facb0cbc5626d02c$var$getStarknetIdContract,
    useDecoded: ()=>$facb0cbc5626d02c$var$useDecoded,
    useEncoded: ()=>$facb0cbc5626d02c$var$useEncoded
});
var $facb0cbc5626d02c$var$basicAlphabet = "abcdefghijklmnopqrstuvwxyz0123456789-";
var $facb0cbc5626d02c$var$basicSizePlusOne = BigInt($facb0cbc5626d02c$var$basicAlphabet.length + 1);
var $facb0cbc5626d02c$var$bigAlphabet = "\u8FD9\u6765";
var $facb0cbc5626d02c$var$basicAlphabetSize = BigInt($facb0cbc5626d02c$var$basicAlphabet.length);
var $facb0cbc5626d02c$var$bigAlphabetSize = BigInt($facb0cbc5626d02c$var$bigAlphabet.length);
var $facb0cbc5626d02c$var$bigAlphabetSizePlusOne = BigInt($facb0cbc5626d02c$var$bigAlphabet.length + 1);
function $facb0cbc5626d02c$var$extractStars(str) {
    let k = 0;
    while(str.endsWith($facb0cbc5626d02c$var$bigAlphabet[$facb0cbc5626d02c$var$bigAlphabet.length - 1])){
        str = str.substring(0, str.length - 1);
        k += 1;
    }
    return [
        str,
        k
    ];
}
function $facb0cbc5626d02c$var$useDecoded(encoded) {
    let decoded = "";
    encoded.forEach((subdomain)=>{
        while(subdomain !== $facb0cbc5626d02c$var$ZERO){
            const code = subdomain % $facb0cbc5626d02c$var$basicSizePlusOne;
            subdomain /= $facb0cbc5626d02c$var$basicSizePlusOne;
            if (code === BigInt($facb0cbc5626d02c$var$basicAlphabet.length)) {
                const nextSubdomain = subdomain / $facb0cbc5626d02c$var$bigAlphabetSizePlusOne;
                if (nextSubdomain === $facb0cbc5626d02c$var$ZERO) {
                    const code2 = subdomain % $facb0cbc5626d02c$var$bigAlphabetSizePlusOne;
                    subdomain = nextSubdomain;
                    if (code2 === $facb0cbc5626d02c$var$ZERO) decoded += $facb0cbc5626d02c$var$basicAlphabet[0];
                    else decoded += $facb0cbc5626d02c$var$bigAlphabet[Number(code2) - 1];
                } else {
                    const code2 = subdomain % $facb0cbc5626d02c$var$bigAlphabetSize;
                    decoded += $facb0cbc5626d02c$var$bigAlphabet[Number(code2)];
                    subdomain /= $facb0cbc5626d02c$var$bigAlphabetSize;
                }
            } else decoded += $facb0cbc5626d02c$var$basicAlphabet[Number(code)];
        }
        const [str, k] = $facb0cbc5626d02c$var$extractStars(decoded);
        if (k) decoded = str + (k % 2 === 0 ? $facb0cbc5626d02c$var$bigAlphabet[$facb0cbc5626d02c$var$bigAlphabet.length - 1].repeat(k / 2 - 1) + $facb0cbc5626d02c$var$bigAlphabet[0] + $facb0cbc5626d02c$var$basicAlphabet[1] : $facb0cbc5626d02c$var$bigAlphabet[$facb0cbc5626d02c$var$bigAlphabet.length - 1].repeat((k - 1) / 2 + 1));
        decoded += ".";
    });
    if (!decoded) return decoded;
    return decoded.concat("stark");
}
function $facb0cbc5626d02c$var$useEncoded(decoded) {
    let encoded = BigInt(0);
    let multiplier = BigInt(1);
    if (decoded.endsWith($facb0cbc5626d02c$var$bigAlphabet[0] + $facb0cbc5626d02c$var$basicAlphabet[1])) {
        const [str, k] = $facb0cbc5626d02c$var$extractStars(decoded.substring(0, decoded.length - 2));
        decoded = str + $facb0cbc5626d02c$var$bigAlphabet[$facb0cbc5626d02c$var$bigAlphabet.length - 1].repeat(2 * (k + 1));
    } else {
        const [str, k] = $facb0cbc5626d02c$var$extractStars(decoded);
        if (k) decoded = str + $facb0cbc5626d02c$var$bigAlphabet[$facb0cbc5626d02c$var$bigAlphabet.length - 1].repeat(1 + 2 * (k - 1));
    }
    for(let i = 0; i < decoded.length; i += 1){
        const char = decoded[i];
        const index = $facb0cbc5626d02c$var$basicAlphabet.indexOf(char);
        const bnIndex = BigInt($facb0cbc5626d02c$var$basicAlphabet.indexOf(char));
        if (index !== -1) {
            if (i === decoded.length - 1 && decoded[i] === $facb0cbc5626d02c$var$basicAlphabet[0]) {
                encoded += multiplier * $facb0cbc5626d02c$var$basicAlphabetSize;
                multiplier *= $facb0cbc5626d02c$var$basicSizePlusOne;
                multiplier *= $facb0cbc5626d02c$var$basicSizePlusOne;
            } else {
                encoded += multiplier * bnIndex;
                multiplier *= $facb0cbc5626d02c$var$basicSizePlusOne;
            }
        } else if ($facb0cbc5626d02c$var$bigAlphabet.indexOf(char) !== -1) {
            encoded += multiplier * $facb0cbc5626d02c$var$basicAlphabetSize;
            multiplier *= $facb0cbc5626d02c$var$basicSizePlusOne;
            const newid = (i === decoded.length - 1 ? 1 : 0) + $facb0cbc5626d02c$var$bigAlphabet.indexOf(char);
            encoded += multiplier * BigInt(newid);
            multiplier *= $facb0cbc5626d02c$var$bigAlphabetSize;
        }
    }
    return encoded;
}
var $facb0cbc5626d02c$var$StarknetIdContract = /* @__PURE__ */ ((StarknetIdContract2)=>{
    StarknetIdContract2["MAINNET"] = "0x6ac597f8116f886fa1c97a23fa4e08299975ecaf6b598873ca6792b9bbfb678";
    StarknetIdContract2["TESTNET"] = "0x3bab268e932d2cecd1946f100ae67ce3dff9fd234119ea2f6da57d16d29fce";
    return StarknetIdContract2;
})($facb0cbc5626d02c$var$StarknetIdContract || {});
function $facb0cbc5626d02c$var$getStarknetIdContract(chainId) {
    switch(chainId){
        case "0x534e5f4d41494e" /* SN_MAIN */ :
            return "0x6ac597f8116f886fa1c97a23fa4e08299975ecaf6b598873ca6792b9bbfb678" /* MAINNET */ ;
        case "0x534e5f474f45524c49" /* SN_GOERLI */ :
            return "0x3bab268e932d2cecd1946f100ae67ce3dff9fd234119ea2f6da57d16d29fce" /* TESTNET */ ;
        default:
            throw new Error("Starknet.id is not yet deployed on this network");
    }
}
// src/provider/starknetId.ts
async function $facb0cbc5626d02c$var$getStarkName(provider, address, StarknetIdContract2) {
    const chainId = await provider.getChainId();
    const contract = StarknetIdContract2 !== null && StarknetIdContract2 !== void 0 ? StarknetIdContract2 : $facb0cbc5626d02c$var$getStarknetIdContract(chainId);
    try {
        const hexDomain = await provider.callContract({
            contractAddress: contract,
            entrypoint: "address_to_domain",
            calldata: $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile({
                address: address
            })
        });
        const decimalDomain = hexDomain.result.map((element)=>BigInt(element)).slice(1);
        const stringDomain = $facb0cbc5626d02c$var$useDecoded(decimalDomain);
        if (!stringDomain) throw Error("Starkname not found");
        return stringDomain;
    } catch (e) {
        if (e instanceof Error && e.message === "Starkname not found") throw e;
        throw Error("Could not get stark name");
    }
}
async function $facb0cbc5626d02c$var$getAddressFromStarkName(provider, name, StarknetIdContract2) {
    const chainId = await provider.getChainId();
    const contract = StarknetIdContract2 !== null && StarknetIdContract2 !== void 0 ? StarknetIdContract2 : $facb0cbc5626d02c$var$getStarknetIdContract(chainId);
    try {
        const addressData = await provider.callContract({
            contractAddress: contract,
            entrypoint: "domain_to_address",
            calldata: $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile({
                domain: [
                    $facb0cbc5626d02c$var$useEncoded(name.replace(".stark", "")).toString(10)
                ]
            })
        });
        return addressData.result[0];
    } catch  {
        throw Error("Could not get address from stark name");
    }
}
// src/provider/utils.ts
var $facb0cbc5626d02c$var$validBlockTags = Object.values($facb0cbc5626d02c$export$472371b62fbd4d78);
var $facb0cbc5626d02c$var$Block = class {
    setIdentifier(__identifier) {
        if (typeof __identifier === "string" && $facb0cbc5626d02c$var$isHex(__identifier)) this.hash = __identifier;
        else if (typeof __identifier === "bigint") this.hash = $facb0cbc5626d02c$var$toHex(__identifier);
        else if (typeof __identifier === "number") this.number = __identifier;
        else if (typeof __identifier === "string" && $facb0cbc5626d02c$var$validBlockTags.includes(__identifier)) this.tag = __identifier;
        else this.tag = "pending" /* pending */ ;
    }
    // TODO: fix any
    get queryIdentifier() {
        if (this.number !== null) return `blockNumber=${this.number}`;
        if (this.hash !== null) return `blockHash=${this.hash}`;
        return `blockNumber=${this.tag}`;
    }
    // TODO: fix any
    get identifier() {
        if (this.number !== null) return {
            block_number: this.number
        };
        if (this.hash !== null) return {
            block_hash: this.hash
        };
        return this.tag;
    }
    set identifier(_identifier) {
        this.setIdentifier(_identifier);
    }
    get sequencerIdentifier() {
        var _this_number;
        return this.hash !== null ? {
            blockHash: this.hash
        } : {
            blockNumber: (_this_number = this.number) !== null && _this_number !== void 0 ? _this_number : this.tag
        };
    }
    constructor(_identifier){
        (0, $dxWQo._)(this, "hash", null);
        (0, $dxWQo._)(this, "number", null);
        (0, $dxWQo._)(this, "tag", null);
        (0, $dxWQo._)(this, "valueOf", ()=>this.number);
        (0, $dxWQo._)(this, "toString", ()=>this.hash);
        this.setIdentifier(_identifier);
    }
};
// src/provider/rpc.ts
var $facb0cbc5626d02c$export$f891d455a8552325 = (networkName, mute = false, version = $facb0cbc5626d02c$var$RPC_DEFAULT_VERSION)=>{
    if (!mute) console.warn("Using default public node url, please provide nodeUrl in provider options!");
    const nodes = $facb0cbc5626d02c$var$RPC_NODES[networkName !== null && networkName !== void 0 ? networkName : "SN_GOERLI" /* SN_GOERLI */ ];
    const randIdx = Math.floor(Math.random() * nodes.length);
    return `${nodes[randIdx]}${version}`;
};
var $facb0cbc5626d02c$var$defaultOptions = {
    headers: {
        "Content-Type": "application/json"
    },
    blockIdentifier: "pending" /* pending */ ,
    retries: 200
};
var $facb0cbc5626d02c$export$578ebb3f1f89cda2 = class {
    fetch(method, params, id = 0) {
        const rpcRequestBody = {
            id: id,
            jsonrpc: "2.0",
            method: method,
            ...params && {
                params: params
            }
        };
        return $facb0cbc5626d02c$var$fetchPonyfill_default(this.nodeUrl, {
            method: "POST",
            body: $facb0cbc5626d02c$var$stringify2(rpcRequestBody),
            headers: this.headers
        });
    }
    errorHandler(method, params, rpcError, otherError) {
        if (rpcError) {
            const { code: code, message: message, data: data } = rpcError;
            throw new $facb0cbc5626d02c$export$8c05b2dc6219e90a(`RPC: ${method} with params ${$facb0cbc5626d02c$var$stringify2(params)}
 ${code}: ${message}: ${$facb0cbc5626d02c$var$stringify2(data)}`);
        }
        if (otherError instanceof $facb0cbc5626d02c$export$8c05b2dc6219e90a) throw otherError;
        if (otherError) throw Error(otherError.message);
    }
    async fetchEndpoint(method, params) {
        try {
            const rawResult = await this.fetch(method, params);
            const { error: error, result: result } = await rawResult.json();
            this.errorHandler(method, params, error);
            return result;
        } catch (error) {
            var _error_response;
            this.errorHandler(method, params, error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.data, error);
            throw error;
        }
    }
    async getChainId() {
        var _this_chainId;
        (_this_chainId = this.chainId) !== null && _this_chainId !== void 0 ? _this_chainId : this.chainId = await this.fetchEndpoint("starknet_chainId");
        return this.chainId;
    }
    /**
   * NEW: Returns the version of the Starknet JSON-RPC specification being used
   */ async getSpecVersion() {
        return this.fetchEndpoint("starknet_specVersion");
    }
    async getNonceForAddress(contractAddress, blockIdentifier = this.blockIdentifier) {
        const contract_address = $facb0cbc5626d02c$var$toHex(contractAddress);
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        return this.fetchEndpoint("starknet_getNonce", {
            contract_address: contract_address,
            block_id: block_id
        });
    }
    /**
   * @deprecated use getBlockWithTxHashes or getBlockWithTxs (will be removed on sequencer deprecation)
   */ async getBlock(blockIdentifier = this.blockIdentifier) {
        return this.getBlockWithTxHashes(blockIdentifier).then(this.responseParser.parseGetBlockResponse);
    }
    /**
   * Get the most recent accepted block hash and number
   */ async getBlockLatestAccepted() {
        return this.fetchEndpoint("starknet_blockHashAndNumber");
    }
    /**
   * @deprecated redundant use getBlockLatestAccepted();
   * Get the most recent accepted block number
   * @returns Number of the latest block
   */ async getBlockNumber() {
        return this.fetchEndpoint("starknet_blockNumber");
    }
    async getBlockWithTxHashes(blockIdentifier = this.blockIdentifier) {
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        return this.fetchEndpoint("starknet_getBlockWithTxHashes", {
            block_id: block_id
        });
    }
    async getBlockWithTxs(blockIdentifier = this.blockIdentifier) {
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        return this.fetchEndpoint("starknet_getBlockWithTxs", {
            block_id: block_id
        });
    }
    async getBlockStateUpdate(blockIdentifier = this.blockIdentifier) {
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        return this.fetchEndpoint("starknet_getStateUpdate", {
            block_id: block_id
        });
    }
    async getBlockTransactionsTraces(blockIdentifier = this.blockIdentifier) {
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        return this.fetchEndpoint("starknet_traceBlockTransactions", {
            block_id: block_id
        });
    }
    async getBlockTransactionCount(blockIdentifier = this.blockIdentifier) {
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        return this.fetchEndpoint("starknet_getBlockTransactionCount", {
            block_id: block_id
        });
    }
    /**
   * Return transactions from pending block
   * @deprecated Instead use getBlock(BlockTag.pending); (will be removed in next minor version)
   */ async getPendingTransactions() {
        const { transactions: transactions } = await this.getBlock("pending" /* pending */ );
        return Promise.all(transactions.map((it)=>this.getTransactionByHash(it)));
    }
    /**
   * @deprecated use getTransactionByHash or getTransactionByBlockIdAndIndex (will be removed on sequencer deprecation)
   */ async getTransaction(txHash) {
        return this.getTransactionByHash(txHash).then(this.responseParser.parseGetTransactionResponse);
    }
    async getTransactionByHash(txHash) {
        const transaction_hash = $facb0cbc5626d02c$var$toHex(txHash);
        return this.fetchEndpoint("starknet_getTransactionByHash", {
            transaction_hash: transaction_hash
        });
    }
    async getTransactionByBlockIdAndIndex(blockIdentifier, index) {
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        return this.fetchEndpoint("starknet_getTransactionByBlockIdAndIndex", {
            block_id: block_id,
            index: index
        });
    }
    async getTransactionReceipt(txHash) {
        const transaction_hash = $facb0cbc5626d02c$var$toHex(txHash);
        return this.fetchEndpoint("starknet_getTransactionReceipt", {
            transaction_hash: transaction_hash
        });
    }
    async getTransactionTrace(txHash) {
        const transaction_hash = $facb0cbc5626d02c$var$toHex(txHash);
        return this.fetchEndpoint("starknet_traceTransaction", {
            transaction_hash: transaction_hash
        });
    }
    /**
   * NEW: Get the status of a transaction
   */ async getTransactionStatus(transactionHash) {
        const transaction_hash = $facb0cbc5626d02c$var$toHex(transactionHash);
        return this.fetchEndpoint("starknet_getTransactionStatus", {
            transaction_hash: transaction_hash
        });
    }
    /**
   * @param invocations AccountInvocations
   * @param simulateTransactionOptions blockIdentifier and flags to skip validation and fee charge<br/>
   * - blockIdentifier<br/>
   * - skipValidate (default false)<br/>
   * - skipFeeCharge (default true)<br/>
   */ async simulateTransaction(invocations, { blockIdentifier: blockIdentifier = this.blockIdentifier, skipValidate: skipValidate = false, skipFeeCharge: skipFeeCharge = true }) {
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        const simulationFlags = [];
        if (skipValidate) simulationFlags.push($facb0cbc5626d02c$export$83f82714246b5968.ESimulationFlag.SKIP_VALIDATE);
        if (skipFeeCharge) simulationFlags.push($facb0cbc5626d02c$export$83f82714246b5968.ESimulationFlag.SKIP_FEE_CHARGE);
        return this.fetchEndpoint("starknet_simulateTransactions", {
            block_id: block_id,
            transactions: invocations.map((it)=>this.buildTransaction(it)),
            simulation_flags: simulationFlags
        }).then(this.responseParser.parseSimulateTransactionResponse);
    }
    async waitForTransaction(txHash, options) {
        const transactionHash = $facb0cbc5626d02c$var$toHex(txHash);
        let { retries: retries } = this;
        let onchain = false;
        let isErrorState = false;
        var _options_retryInterval;
        const retryInterval = (_options_retryInterval = options === null || options === void 0 ? void 0 : options.retryInterval) !== null && _options_retryInterval !== void 0 ? _options_retryInterval : 5e3;
        var _options_errorStates;
        const errorStates = (_options_errorStates = options === null || options === void 0 ? void 0 : options.errorStates) !== null && _options_errorStates !== void 0 ? _options_errorStates : [
            $facb0cbc5626d02c$export$83f82714246b5968.ETransactionStatus.REJECTED
        ];
        var _options_successStates;
        const successStates = (_options_successStates = options === null || options === void 0 ? void 0 : options.successStates) !== null && _options_successStates !== void 0 ? _options_successStates : [
            $facb0cbc5626d02c$export$83f82714246b5968.ETransactionExecutionStatus.SUCCEEDED,
            $facb0cbc5626d02c$export$83f82714246b5968.ETransactionStatus.ACCEPTED_ON_L2,
            $facb0cbc5626d02c$export$83f82714246b5968.ETransactionStatus.ACCEPTED_ON_L1
        ];
        let txStatus;
        while(!onchain){
            await $facb0cbc5626d02c$var$wait(retryInterval);
            try {
                txStatus = await this.getTransactionStatus(transactionHash);
                const executionStatus = txStatus.execution_status;
                const finalityStatus = txStatus.finality_status;
                if (!finalityStatus) {
                    const error = new Error("waiting for transaction status");
                    throw error;
                }
                if (errorStates.includes(executionStatus) || errorStates.includes(finalityStatus)) {
                    const message = `${executionStatus}: ${finalityStatus}`;
                    const error = new Error(message);
                    error.response = txStatus;
                    isErrorState = true;
                    throw error;
                } else if (successStates.includes(executionStatus) || successStates.includes(finalityStatus)) onchain = true;
            } catch (error) {
                if (error instanceof Error && isErrorState) throw error;
                if (retries <= 0) throw new Error(`waitForTransaction timed-out with retries ${this.retries}`);
            }
            retries -= 1;
        }
        let txReceipt = null;
        while(txReceipt === null){
            try {
                txReceipt = await this.getTransactionReceipt(transactionHash);
            } catch (error) {
                if (retries <= 0) throw new Error(`waitForTransaction timed-out with retries ${this.retries}`);
            }
            retries -= 1;
            await $facb0cbc5626d02c$var$wait(retryInterval);
        }
        return txReceipt;
    }
    async getStorageAt(contractAddress, key, blockIdentifier = this.blockIdentifier) {
        const contract_address = $facb0cbc5626d02c$var$toHex(contractAddress);
        const parsedKey = $facb0cbc5626d02c$var$toStorageKey(key);
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        return this.fetchEndpoint("starknet_getStorageAt", {
            contract_address: contract_address,
            key: parsedKey,
            block_id: block_id
        });
    }
    async getClassHashAt(contractAddress, blockIdentifier = this.blockIdentifier) {
        const contract_address = $facb0cbc5626d02c$var$toHex(contractAddress);
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        return this.fetchEndpoint("starknet_getClassHashAt", {
            block_id: block_id,
            contract_address: contract_address
        });
    }
    async getClassByHash(classHash) {
        return this.getClass(classHash);
    }
    async getClass(classHash, blockIdentifier = this.blockIdentifier) {
        const class_hash = $facb0cbc5626d02c$var$toHex(classHash);
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        return this.fetchEndpoint("starknet_getClass", {
            class_hash: class_hash,
            block_id: block_id
        }).then(this.responseParser.parseContractClassResponse);
    }
    async getClassAt(contractAddress, blockIdentifier = this.blockIdentifier) {
        const contract_address = $facb0cbc5626d02c$var$toHex(contractAddress);
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        return this.fetchEndpoint("starknet_getClassAt", {
            block_id: block_id,
            contract_address: contract_address
        }).then(this.responseParser.parseContractClassResponse);
    }
    async getCode(_contractAddress, _blockIdentifier) {
        throw new Error("RPC does not implement getCode function");
    }
    async getContractVersion(contractAddress, classHash, { blockIdentifier: blockIdentifier = this.blockIdentifier, compiler: compiler = true } = {}) {
        let contractClass;
        if (contractAddress) contractClass = await this.getClassAt(contractAddress, blockIdentifier);
        else if (classHash) contractClass = await this.getClass(classHash, blockIdentifier);
        else throw Error("getContractVersion require contractAddress or classHash");
        if ($facb0cbc5626d02c$export$6050805ab301367e(contractClass)) {
            if (compiler) {
                const abiTest = $facb0cbc5626d02c$var$getAbiContractVersion(contractClass.abi);
                return {
                    cairo: "1",
                    compiler: abiTest.compiler
                };
            }
            return {
                cairo: "1",
                compiler: void 0
            };
        }
        return {
            cairo: "0",
            compiler: "0"
        };
    }
    /**
   * @deprecated use get*type*EstimateFee (will be refactored based on type after sequencer deprecation)
   */ async getEstimateFee(invocation, invocationDetails, blockIdentifier = this.blockIdentifier) {
        return this.getInvokeEstimateFee(invocation, invocationDetails, blockIdentifier);
    }
    async getInvokeEstimateFee(invocation, invocationDetails, blockIdentifier = this.blockIdentifier) {
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        const transaction = this.buildTransaction({
            type: "INVOKE_FUNCTION" /* INVOKE */ ,
            ...invocation,
            ...invocationDetails
        }, "fee");
        return this.fetchEndpoint("starknet_estimateFee", {
            request: [
                transaction
            ],
            block_id: block_id
        }).then(this.responseParser.parseFeeEstimateResponse);
    }
    async getDeclareEstimateFee(invocation, details, blockIdentifier = this.blockIdentifier) {
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        const transaction = this.buildTransaction({
            type: "DECLARE" /* DECLARE */ ,
            ...invocation,
            ...details
        }, "fee");
        return this.fetchEndpoint("starknet_estimateFee", {
            request: [
                transaction
            ],
            block_id: block_id
        }).then(this.responseParser.parseFeeEstimateResponse);
    }
    async getDeployAccountEstimateFee(invocation, details, blockIdentifier = this.blockIdentifier) {
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        const transaction = this.buildTransaction({
            type: "DEPLOY_ACCOUNT" /* DEPLOY_ACCOUNT */ ,
            ...invocation,
            ...details
        }, "fee");
        return this.fetchEndpoint("starknet_estimateFee", {
            request: [
                transaction
            ],
            block_id: block_id
        }).then(this.responseParser.parseFeeEstimateResponse);
    }
    async getEstimateFeeBulk(invocations, { blockIdentifier: blockIdentifier = this.blockIdentifier, skipValidate: skipValidate = false }) {
        if (skipValidate) console.warn("getEstimateFeeBulk RPC does not support skipValidate");
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        return this.fetchEndpoint("starknet_estimateFee", {
            request: invocations.map((it)=>this.buildTransaction(it, "fee")),
            block_id: block_id
        }).then(this.responseParser.parseFeeEstimateBulkResponse);
    }
    async invokeFunction(functionInvocation, details) {
        return this.fetchEndpoint("starknet_addInvokeTransaction", {
            invoke_transaction: {
                sender_address: functionInvocation.contractAddress,
                calldata: $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.toHex(functionInvocation.calldata),
                type: $facb0cbc5626d02c$export$83f82714246b5968.ETransactionType.INVOKE,
                max_fee: $facb0cbc5626d02c$var$toHex(details.maxFee || 0),
                version: "0x1",
                signature: $facb0cbc5626d02c$var$signatureToHexArray(functionInvocation.signature),
                nonce: $facb0cbc5626d02c$var$toHex(details.nonce)
            }
        });
    }
    async declareContract({ contract: contract, signature: signature, senderAddress: senderAddress, compiledClassHash: compiledClassHash }, details) {
        if (!$facb0cbc5626d02c$export$6050805ab301367e(contract)) return this.fetchEndpoint("starknet_addDeclareTransaction", {
            declare_transaction: {
                type: $facb0cbc5626d02c$export$83f82714246b5968.ETransactionType.DECLARE,
                contract_class: {
                    program: contract.program,
                    entry_points_by_type: contract.entry_points_by_type,
                    abi: contract.abi
                },
                version: $facb0cbc5626d02c$var$HEX_STR_TRANSACTION_VERSION_1,
                max_fee: $facb0cbc5626d02c$var$toHex(details.maxFee || 0),
                signature: $facb0cbc5626d02c$var$signatureToHexArray(signature),
                sender_address: senderAddress,
                nonce: $facb0cbc5626d02c$var$toHex(details.nonce)
            }
        });
        return this.fetchEndpoint("starknet_addDeclareTransaction", {
            declare_transaction: {
                type: $facb0cbc5626d02c$export$83f82714246b5968.ETransactionType.DECLARE,
                contract_class: {
                    sierra_program: $facb0cbc5626d02c$var$decompressProgram(contract.sierra_program),
                    contract_class_version: contract.contract_class_version,
                    entry_points_by_type: contract.entry_points_by_type,
                    abi: contract.abi
                },
                compiled_class_hash: compiledClassHash || "",
                version: $facb0cbc5626d02c$var$HEX_STR_TRANSACTION_VERSION_2,
                max_fee: $facb0cbc5626d02c$var$toHex(details.maxFee || 0),
                signature: $facb0cbc5626d02c$var$signatureToHexArray(signature),
                sender_address: senderAddress,
                nonce: $facb0cbc5626d02c$var$toHex(details.nonce)
            }
        });
    }
    async deployAccountContract({ classHash: classHash, constructorCalldata: constructorCalldata, addressSalt: addressSalt, signature: signature }, details) {
        return this.fetchEndpoint("starknet_addDeployAccountTransaction", {
            deploy_account_transaction: {
                constructor_calldata: $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.toHex(constructorCalldata || []),
                class_hash: $facb0cbc5626d02c$var$toHex(classHash),
                contract_address_salt: $facb0cbc5626d02c$var$toHex(addressSalt || 0),
                type: $facb0cbc5626d02c$export$83f82714246b5968.ETransactionType.DEPLOY_ACCOUNT,
                max_fee: $facb0cbc5626d02c$var$toHex(details.maxFee || 0),
                version: $facb0cbc5626d02c$var$toHex(details.version || 0),
                signature: $facb0cbc5626d02c$var$signatureToHexArray(signature),
                nonce: $facb0cbc5626d02c$var$toHex(details.nonce)
            }
        });
    }
    async callContract(call, blockIdentifier = this.blockIdentifier) {
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        const result = await this.fetchEndpoint("starknet_call", {
            request: {
                contract_address: call.contractAddress,
                entry_point_selector: $facb0cbc5626d02c$var$getSelectorFromName(call.entrypoint),
                calldata: $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.toHex(call.calldata)
            },
            block_id: block_id
        });
        return this.responseParser.parseCallContractResponse(result);
    }
    /**
   * NEW: Estimate the fee for a message from L1
   * @param message Message From L1
   */ async estimateMessageFee(message, blockIdentifier = this.blockIdentifier) {
        const { from_address: from_address, to_address: to_address, entry_point_selector: entry_point_selector, payload: payload } = message;
        const formattedMessage = {
            from_address: $facb0cbc5626d02c$var$toHex(from_address),
            to_address: $facb0cbc5626d02c$var$toHex(to_address),
            entry_point_selector: $facb0cbc5626d02c$var$getSelector(entry_point_selector),
            payload: $facb0cbc5626d02c$var$getHexStringArray(payload)
        };
        const block_id = new $facb0cbc5626d02c$var$Block(blockIdentifier).identifier;
        return this.fetchEndpoint("starknet_estimateMessageFee", {
            message: formattedMessage,
            block_id: block_id
        });
    }
    /**
   * Returns an object about the sync status, or false if the node is not synching
   * @returns Object with the stats data
   */ async getSyncingStats() {
        return this.fetchEndpoint("starknet_syncing");
    }
    /**
   * Returns all events matching the given filter
   * @returns events and the pagination of the events
   */ async getEvents(eventFilter) {
        return this.fetchEndpoint("starknet_getEvents", {
            filter: eventFilter
        });
    }
    /**
   * StarknetId Endpoint (get name from address)
   */ async getStarkName(address, StarknetIdContract2) {
        return $facb0cbc5626d02c$var$getStarkName(this, address, StarknetIdContract2);
    }
    /**
   * StarknetId Endpoint (get address from name)
   */ async getAddressFromStarkName(name, StarknetIdContract2) {
        return $facb0cbc5626d02c$var$getAddressFromStarkName(this, name, StarknetIdContract2);
    }
    buildTransaction(invocation, versionType) {
        const defaultVersions = $facb0cbc5626d02c$var$getVersionsByType(versionType);
        const details = {
            signature: $facb0cbc5626d02c$var$signatureToHexArray(invocation.signature),
            nonce: $facb0cbc5626d02c$var$toHex(invocation.nonce),
            max_fee: $facb0cbc5626d02c$var$toHex(invocation.maxFee || 0)
        };
        if (invocation.type === "INVOKE_FUNCTION" /* INVOKE */ ) return {
            type: $facb0cbc5626d02c$export$83f82714246b5968.ETransactionType.INVOKE,
            // Diff between sequencer and rpc invoke type
            sender_address: invocation.contractAddress,
            calldata: $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.toHex(invocation.calldata),
            version: $facb0cbc5626d02c$var$toHex(invocation.version || defaultVersions.v1),
            ...details
        };
        if (invocation.type === "DECLARE" /* DECLARE */ ) {
            if (!$facb0cbc5626d02c$export$6050805ab301367e(invocation.contract)) return {
                type: invocation.type,
                contract_class: invocation.contract,
                sender_address: invocation.senderAddress,
                version: $facb0cbc5626d02c$var$toHex(invocation.version || defaultVersions.v1),
                ...details
            };
            return {
                // compiled_class_hash
                type: invocation.type,
                contract_class: {
                    ...invocation.contract,
                    sierra_program: $facb0cbc5626d02c$var$decompressProgram(invocation.contract.sierra_program)
                },
                compiled_class_hash: invocation.compiledClassHash || "",
                sender_address: invocation.senderAddress,
                version: $facb0cbc5626d02c$var$toHex(invocation.version || defaultVersions.v2),
                ...details
            };
        }
        if (invocation.type === "DEPLOY_ACCOUNT" /* DEPLOY_ACCOUNT */ ) return {
            type: invocation.type,
            constructor_calldata: $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.toHex(invocation.constructorCalldata || []),
            class_hash: $facb0cbc5626d02c$var$toHex(invocation.classHash),
            contract_address_salt: $facb0cbc5626d02c$var$toHex(invocation.addressSalt || 0),
            version: $facb0cbc5626d02c$var$toHex(invocation.version || defaultVersions.v1),
            ...details
        };
        throw Error("RPC buildTransaction received unknown TransactionType");
    }
    constructor(optionsOrProvider){
        (0, $dxWQo._)(this, "nodeUrl", void 0);
        (0, $dxWQo._)(this, "headers", void 0);
        (0, $dxWQo._)(this, "responseParser", new $facb0cbc5626d02c$var$RPCResponseParser());
        (0, $dxWQo._)(this, "retries", void 0);
        (0, $dxWQo._)(this, "blockIdentifier", void 0);
        (0, $dxWQo._)(this, "chainId", void 0);
        /**
   * @deprecated renamed to getBlockLatestAccepted(); (will be removed in next minor version)
   */ (0, $dxWQo._)(this, "getBlockHashAndNumber", this.getBlockLatestAccepted);
        /**
   * @deprecated renamed to getBlockStateUpdate();
   */ (0, $dxWQo._)(this, "getStateUpdate", this.getBlockStateUpdate);
        /**
   * Returns the execution traces of all transactions included in the given block
   * @deprecated renamed to getBlockTransactionsTraces()
   */ (0, $dxWQo._)(this, "traceBlockTransactions", this.getBlockTransactionsTraces);
        /**
   * Get the number of transactions in a block given a block id
   * @deprecated renamed to getBlockTransactionCount()
   * @returns Number of transactions
   */ (0, $dxWQo._)(this, "getTransactionCount", this.getBlockTransactionCount);
        /**
   * @deprecated renamed to getTransactionTrace();
   * For a given executed transaction, return the trace of its execution, including internal calls
   */ (0, $dxWQo._)(this, "traceTransaction", this.getTransactionTrace);
        /**
   * @deprecated renamed to simulateTransaction();
   */ (0, $dxWQo._)(this, "getSimulateTransaction", this.simulateTransaction);
        const { nodeUrl: nodeUrl, retries: retries, headers: headers, blockIdentifier: blockIdentifier, chainId: chainId, rpcVersion: rpcVersion } = optionsOrProvider || {};
        if (Object.values($facb0cbc5626d02c$var$NetworkName).includes(nodeUrl)) this.nodeUrl = $facb0cbc5626d02c$export$f891d455a8552325(nodeUrl, optionsOrProvider === null || optionsOrProvider === void 0 ? void 0 : optionsOrProvider.default, rpcVersion);
        else if (nodeUrl) this.nodeUrl = nodeUrl;
        else this.nodeUrl = $facb0cbc5626d02c$export$f891d455a8552325(void 0, optionsOrProvider === null || optionsOrProvider === void 0 ? void 0 : optionsOrProvider.default, rpcVersion);
        this.retries = retries || $facb0cbc5626d02c$var$defaultOptions.retries;
        this.headers = {
            ...$facb0cbc5626d02c$var$defaultOptions.headers,
            ...headers
        };
        this.blockIdentifier = blockIdentifier || $facb0cbc5626d02c$var$defaultOptions.blockIdentifier;
        this.chainId = chainId;
    }
};
// src/utils/responseParser/index.ts
var $facb0cbc5626d02c$var$ResponseParser = class {
};
// src/utils/responseParser/sequencer.ts
var $facb0cbc5626d02c$var$SequencerAPIResponseParser = class extends $facb0cbc5626d02c$var$ResponseParser {
    parseGetBlockResponse(res) {
        return {
            ...res,
            new_root: res.state_root,
            parent_hash: res.parent_block_hash,
            transactions: Object.values(res.transactions).map((value)=>"transaction_hash" in value && value.transaction_hash).filter(Boolean)
        };
    }
    parseGetTransactionResponse(res) {
        if (res.status === "NOT_RECEIVED" /* NOT_RECEIVED */  && res.finality_status === "NOT_RECEIVED" /* NOT_RECEIVED */ ) throw new $facb0cbc5626d02c$export$8c05b2dc6219e90a();
        return {
            ...res,
            calldata: "calldata" in res.transaction ? res.transaction.calldata : [],
            contract_class: "contract_class" in res.transaction ? res.transaction.contract_class : void 0,
            entry_point_selector: "entry_point_selector" in res.transaction ? res.transaction.entry_point_selector : void 0,
            max_fee: "max_fee" in res.transaction ? res.transaction.max_fee : void 0,
            nonce: res.transaction.nonce,
            sender_address: "sender_address" in res.transaction ? res.transaction.sender_address : void 0,
            signature: "signature" in res.transaction ? res.transaction.signature : void 0,
            transaction_hash: "transaction_hash" in res.transaction ? res.transaction.transaction_hash : void 0,
            version: "version" in res.transaction ? res.transaction.version : void 0
        };
    }
    parseGetTransactionReceiptResponse(res) {
        return {
            ...res,
            messages_sent: res.l2_to_l1_messages,
            ..."revert_error" in res && {
                revert_reason: res.revert_error
            }
        };
    }
    parseFeeEstimateResponse(res) {
        if ("overall_fee" in res) {
            let gasInfo = {};
            try {
                gasInfo = {
                    gas_consumed: $facb0cbc5626d02c$var$toBigInt(res.gas_usage),
                    gas_price: $facb0cbc5626d02c$var$toBigInt(res.gas_price)
                };
            } catch  {}
            return {
                overall_fee: $facb0cbc5626d02c$var$toBigInt(res.overall_fee),
                ...gasInfo
            };
        }
        return {
            overall_fee: $facb0cbc5626d02c$var$toBigInt(res.amount)
        };
    }
    parseFeeEstimateBulkResponse(res) {
        return [].concat(res).map((item)=>{
            if ("overall_fee" in item) {
                let gasInfo = {};
                try {
                    gasInfo = {
                        gas_consumed: $facb0cbc5626d02c$var$toBigInt(item.gas_usage),
                        gas_price: $facb0cbc5626d02c$var$toBigInt(item.gas_price)
                    };
                } catch  {}
                return {
                    overall_fee: $facb0cbc5626d02c$var$toBigInt(item.overall_fee),
                    ...gasInfo
                };
            }
            return {
                overall_fee: $facb0cbc5626d02c$var$toBigInt(item.amount)
            };
        });
    }
    parseSimulateTransactionResponse(res) {
        const suggestedMaxFee = "overall_fee" in res.fee_estimation ? res.fee_estimation.overall_fee : res.fee_estimation.amount;
        return [
            {
                transaction_trace: res.trace,
                fee_estimation: res.fee_estimation,
                suggestedMaxFee: $facb0cbc5626d02c$var$estimatedFeeToMaxFee(BigInt(suggestedMaxFee))
            }
        ];
    }
    parseCallContractResponse(res) {
        return {
            result: res.result
        };
    }
    parseInvokeFunctionResponse(res) {
        return {
            transaction_hash: res.transaction_hash
        };
    }
    parseDeployContractResponse(res) {
        return {
            transaction_hash: res.transaction_hash,
            contract_address: res.address
        };
    }
    parseDeclareContractResponse(res) {
        return {
            transaction_hash: res.transaction_hash,
            class_hash: res.class_hash
        };
    }
    parseGetStateUpdateResponse(res) {
        const nonces = Object.entries(res.state_diff.nonces).map(([contract_address, nonce])=>({
                contract_address: contract_address,
                nonce: nonce
            }));
        const storage_diffs = Object.entries(res.state_diff.storage_diffs).map(([address, storage_entries])=>({
                address: address,
                storage_entries: storage_entries
            }));
        return {
            ...res,
            state_diff: {
                ...res.state_diff,
                storage_diffs: storage_diffs,
                nonces: nonces
            }
        };
    }
    parseContractClassResponse(res) {
        const response = $facb0cbc5626d02c$export$6050805ab301367e(res) ? res : $facb0cbc5626d02c$var$parseContract(res);
        return {
            ...response,
            abi: typeof response.abi === "string" ? JSON.parse(response.abi) : response.abi
        };
    }
};
var $facb0cbc5626d02c$var$protocolAndDomainRE = /^(?:\w+:)?\/\/(\S+)$/;
var $facb0cbc5626d02c$var$localhostDomainRE = /^localhost[:?\d]*(?:[^:?\d]\S*)?$/;
var $facb0cbc5626d02c$var$nonLocalhostDomainRE = /^[^\s.]+\.\S{2,}$/;
function $facb0cbc5626d02c$export$8304a22d431f958(s) {
    if (!s) return false;
    if (typeof s !== "string") return false;
    const match = s.match($facb0cbc5626d02c$var$protocolAndDomainRE);
    if (!match) return false;
    const everythingAfterProtocol = match[1];
    if (!everythingAfterProtocol) return false;
    if ($facb0cbc5626d02c$var$localhostDomainRE.test(everythingAfterProtocol) || $facb0cbc5626d02c$var$nonLocalhostDomainRE.test(everythingAfterProtocol)) return true;
    return false;
}
function $facb0cbc5626d02c$export$b5cd97dee32de81d(baseUrl, defaultPath, urlOrPath) {
    return $facb0cbc5626d02c$export$8304a22d431f958(urlOrPath) ? urlOrPath : (0, (/*@__PURE__*/$parcel$interopDefault($4oIhN)))(baseUrl, urlOrPath !== null && urlOrPath !== void 0 ? urlOrPath : defaultPath);
}
// src/provider/sequencer.ts
function $facb0cbc5626d02c$var$isEmptyQueryObject(obj) {
    return obj === void 0 || Object.keys(obj).length === 0 || Object.keys(obj).length === 1 && Object.entries(obj).every(([k, v])=>k === "blockIdentifier" && v === null);
}
var $facb0cbc5626d02c$var$defaultOptions2 = {
    network: "SN_GOERLI" /* SN_GOERLI */ ,
    blockIdentifier: "pending" /* pending */ 
};
var $facb0cbc5626d02c$export$257d155889fba954 = class {
    static getNetworkFromName(name) {
        switch(name){
            case "SN_MAIN" /* SN_MAIN */ :
            case "0x534e5f4d41494e" /* SN_MAIN */ :
                return "https://alpha-mainnet.starknet.io" /* SN_MAIN */ ;
            case "SN_GOERLI" /* SN_GOERLI */ :
            case "0x534e5f474f45524c49" /* SN_GOERLI */ :
                return "https://alpha4.starknet.io" /* SN_GOERLI */ ;
            default:
                throw new Error("Could not detect base url from NetworkName");
        }
    }
    static getChainIdFromBaseUrl(baseUrl) {
        try {
            const url = new URL(baseUrl);
            if (url.host.includes("mainnet.starknet.io")) return "0x534e5f4d41494e" /* SN_MAIN */ ;
            return "0x534e5f474f45524c49" /* SN_GOERLI */ ;
        } catch  {
            console.error(`Could not parse baseUrl: ${baseUrl}`);
            return "0x534e5f474f45524c49" /* SN_GOERLI */ ;
        }
    }
    getFetchUrl(endpoint) {
        const gatewayUrlEndpoints = [
            "add_transaction"
        ];
        return gatewayUrlEndpoints.includes(endpoint) ? this.gatewayUrl : this.feederGatewayUrl;
    }
    getFetchMethod(endpoint) {
        const postMethodEndpoints = [
            "add_transaction",
            "call_contract",
            "estimate_fee",
            "estimate_message_fee",
            "estimate_fee_bulk",
            "simulate_transaction"
        ];
        return postMethodEndpoints.includes(endpoint) ? "POST" : "GET";
    }
    getQueryString(query) {
        if ($facb0cbc5626d02c$var$isEmptyQueryObject(query)) return "";
        const queryString = Object.entries(query).map(([key, value])=>{
            if (key === "blockIdentifier") {
                const block = new $facb0cbc5626d02c$var$Block(value);
                return `${block.queryIdentifier}`;
            }
            return `${key}=${value}`;
        }).join("&");
        return `?${queryString}`;
    }
    getHeaders(method) {
        if (method === "POST") return {
            "Content-Type": "application/json",
            ...this.headers
        };
        return this.headers;
    }
    // typesafe fetch
    async fetchEndpoint(endpoint, ...[query, request]) {
        const baseUrl = this.getFetchUrl(endpoint);
        const method = this.getFetchMethod(endpoint);
        const queryString = this.getQueryString(query);
        const url = (0, (/*@__PURE__*/$parcel$interopDefault($4oIhN)))(baseUrl, endpoint, queryString);
        return this.fetch(url, {
            method: method,
            body: request
        });
    }
    async fetch(endpoint, options) {
        const url = $facb0cbc5626d02c$export$b5cd97dee32de81d(this.baseUrl, "", endpoint);
        var _options_method;
        const method = (_options_method = options === null || options === void 0 ? void 0 : options.method) !== null && _options_method !== void 0 ? _options_method : "GET";
        const headers = this.getHeaders(method);
        const body = $facb0cbc5626d02c$var$stringify2(options === null || options === void 0 ? void 0 : options.body);
        try {
            const response = await $facb0cbc5626d02c$var$fetchPonyfill_default(url, {
                method: method,
                body: body,
                headers: headers
            });
            const textResponse = await response.text();
            if (!response.ok) {
                let responseBody;
                try {
                    responseBody = $facb0cbc5626d02c$var$parse2(textResponse);
                } catch  {
                    throw new $facb0cbc5626d02c$export$65bd6083489bd8bb(response.statusText, response.status);
                }
                throw new $facb0cbc5626d02c$export$8ef93724ecb8bcb7(responseBody.message, responseBody.code);
            }
            const parseChoice = (options === null || options === void 0 ? void 0 : options.parseAlwaysAsBigInt) ? $facb0cbc5626d02c$var$parseAlwaysAsBig : $facb0cbc5626d02c$var$parse2;
            return parseChoice(textResponse);
        } catch (error) {
            if (error instanceof Error && !(error instanceof $facb0cbc5626d02c$export$8c05b2dc6219e90a)) throw Error(`Could not ${method} from endpoint \`${url}\`: ${error.message}`);
            throw error;
        }
    }
    async getChainId() {
        return Promise.resolve(this.chainId);
    }
    async callContract({ contractAddress: contractAddress, entrypoint: entryPointSelector, calldata: calldata = [] }, blockIdentifier = this.blockIdentifier) {
        return this.fetchEndpoint("call_contract", {
            blockIdentifier: blockIdentifier
        }, {
            // TODO - determine best choice once both are fully supported in devnet
            // signature: [],
            // sender_address: contractAddress,
            contract_address: contractAddress,
            entry_point_selector: $facb0cbc5626d02c$var$getSelectorFromName(entryPointSelector),
            calldata: $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile(calldata)
        }).then(this.responseParser.parseCallContractResponse);
    }
    async getBlock(blockIdentifier = this.blockIdentifier) {
        return this.fetchEndpoint("get_block", {
            blockIdentifier: blockIdentifier
        }).then(this.responseParser.parseGetBlockResponse);
    }
    async getNonceForAddress(contractAddress, blockIdentifier = this.blockIdentifier) {
        return this.fetchEndpoint("get_nonce", {
            contractAddress: contractAddress,
            blockIdentifier: blockIdentifier
        });
    }
    async getStorageAt(contractAddress, key, blockIdentifier = this.blockIdentifier) {
        const parsedKey = $facb0cbc5626d02c$var$toBigInt(key).toString(10);
        return this.fetchEndpoint("get_storage_at", {
            blockIdentifier: blockIdentifier,
            contractAddress: contractAddress,
            key: parsedKey
        });
    }
    async getTransaction(txHash) {
        const txHashHex = $facb0cbc5626d02c$var$toHex(txHash);
        return this.fetchEndpoint("get_transaction", {
            transactionHash: txHashHex
        }).then((result)=>{
            if (Object.values(result).length === 1) throw new $facb0cbc5626d02c$export$8c05b2dc6219e90a(result.status);
            return this.responseParser.parseGetTransactionResponse(result);
        });
    }
    async getTransactionReceipt(txHash) {
        const txHashHex = $facb0cbc5626d02c$var$toHex(txHash);
        return this.fetchEndpoint("get_transaction_receipt", {
            transactionHash: txHashHex
        }).then(this.responseParser.parseGetTransactionReceiptResponse);
    }
    async getClassAt(contractAddress, blockIdentifier = this.blockIdentifier) {
        return this.fetchEndpoint("get_full_contract", {
            blockIdentifier: blockIdentifier,
            contractAddress: contractAddress
        }).then(this.responseParser.parseContractClassResponse);
    }
    async getClassHashAt(contractAddress, blockIdentifier = this.blockIdentifier) {
        return this.fetchEndpoint("get_class_hash_at", {
            blockIdentifier: blockIdentifier,
            contractAddress: contractAddress
        });
    }
    async getClassByHash(classHash, blockIdentifier = this.blockIdentifier) {
        return this.fetchEndpoint("get_class_by_hash", {
            classHash: classHash,
            blockIdentifier: blockIdentifier
        }).then(this.responseParser.parseContractClassResponse);
    }
    async getCompiledClassByClassHash(classHash, blockIdentifier = this.blockIdentifier) {
        return this.fetchEndpoint("get_compiled_class_by_class_hash", {
            classHash: classHash,
            blockIdentifier: blockIdentifier
        });
    }
    async getContractVersion(contractAddress, classHash, { blockIdentifier: blockIdentifier = this.blockIdentifier, compiler: compiler = true } = {}) {
        let contractClass;
        if (contractAddress) contractClass = await this.getClassAt(contractAddress, blockIdentifier);
        else if (classHash) contractClass = await this.getClassByHash(classHash, blockIdentifier);
        else throw Error("getContractVersion requires contractAddress or classHash");
        if ($facb0cbc5626d02c$export$6050805ab301367e(contractClass)) {
            if (compiler) {
                const abiTest = $facb0cbc5626d02c$var$getAbiContractVersion(contractClass.abi);
                return {
                    cairo: "1",
                    compiler: abiTest.compiler
                };
            }
            return {
                cairo: "1",
                compiler: void 0
            };
        }
        return {
            cairo: "0",
            compiler: "0"
        };
    }
    async invokeFunction(functionInvocation, details) {
        var _functionInvocation_calldata;
        return this.fetchEndpoint("add_transaction", void 0, {
            type: "INVOKE_FUNCTION" /* INVOKE */ ,
            sender_address: functionInvocation.contractAddress,
            calldata: $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile((_functionInvocation_calldata = functionInvocation.calldata) !== null && _functionInvocation_calldata !== void 0 ? _functionInvocation_calldata : []),
            signature: $facb0cbc5626d02c$var$signatureToDecimalArray(functionInvocation.signature),
            nonce: $facb0cbc5626d02c$var$toHex(details.nonce),
            max_fee: $facb0cbc5626d02c$var$toHex(details.maxFee || 0),
            version: "0x1"
        }).then(this.responseParser.parseInvokeFunctionResponse);
    }
    async deployAccountContract({ classHash: classHash, constructorCalldata: constructorCalldata, addressSalt: addressSalt, signature: signature }, details) {
        return this.fetchEndpoint("add_transaction", void 0, {
            type: "DEPLOY_ACCOUNT" /* DEPLOY_ACCOUNT */ ,
            contract_address_salt: addressSalt !== null && addressSalt !== void 0 ? addressSalt : $facb0cbc5626d02c$var$randomAddress(),
            constructor_calldata: $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile(constructorCalldata !== null && constructorCalldata !== void 0 ? constructorCalldata : []),
            class_hash: $facb0cbc5626d02c$var$toHex(classHash),
            max_fee: $facb0cbc5626d02c$var$toHex(details.maxFee || 0),
            version: $facb0cbc5626d02c$var$toHex(details.version || 0),
            nonce: $facb0cbc5626d02c$var$toHex(details.nonce),
            signature: $facb0cbc5626d02c$var$signatureToDecimalArray(signature)
        }).then(this.responseParser.parseDeployContractResponse);
    }
    async declareContract({ senderAddress: senderAddress, contract: contract, signature: signature, compiledClassHash: compiledClassHash }, details) {
        if (!$facb0cbc5626d02c$export$6050805ab301367e(contract)) return this.fetchEndpoint("add_transaction", void 0, {
            type: "DECLARE" /* DECLARE */ ,
            contract_class: contract,
            nonce: $facb0cbc5626d02c$var$toHex(details.nonce),
            signature: $facb0cbc5626d02c$var$signatureToDecimalArray(signature),
            sender_address: senderAddress,
            max_fee: $facb0cbc5626d02c$var$toHex(details.maxFee || 0),
            version: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$transactionVersion)
        }).then(this.responseParser.parseDeclareContractResponse);
        return this.fetchEndpoint("add_transaction", void 0, {
            type: "DECLARE" /* DECLARE */ ,
            sender_address: senderAddress,
            compiled_class_hash: compiledClassHash,
            contract_class: contract,
            nonce: $facb0cbc5626d02c$var$toHex(details.nonce),
            signature: $facb0cbc5626d02c$var$signatureToDecimalArray(signature),
            max_fee: $facb0cbc5626d02c$var$toHex(details.maxFee || 0),
            version: $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$transactionVersion_2)
        }).then(this.responseParser.parseDeclareContractResponse);
    }
    async getEstimateFee(invocation, invocationDetails, blockIdentifier = this.blockIdentifier, skipValidate = false) {
        return this.getInvokeEstimateFee(invocation, invocationDetails, blockIdentifier, skipValidate);
    }
    async getInvokeEstimateFee(invocation, invocationDetails, blockIdentifier = this.blockIdentifier, skipValidate = false) {
        const transaction = this.buildTransaction({
            type: "INVOKE_FUNCTION" /* INVOKE */ ,
            ...invocation,
            ...invocationDetails
        }, "fee");
        return this.fetchEndpoint("estimate_fee", {
            blockIdentifier: blockIdentifier,
            skipValidate: skipValidate
        }, transaction).then(this.responseParser.parseFeeEstimateResponse);
    }
    async getDeclareEstimateFee(invocation, details, blockIdentifier = this.blockIdentifier, skipValidate = false) {
        const transaction = this.buildTransaction({
            type: "DECLARE" /* DECLARE */ ,
            ...invocation,
            ...details
        }, "fee");
        return this.fetchEndpoint("estimate_fee", {
            blockIdentifier: blockIdentifier,
            skipValidate: skipValidate
        }, transaction).then(this.responseParser.parseFeeEstimateResponse);
    }
    async getDeployAccountEstimateFee(invocation, details, blockIdentifier = this.blockIdentifier, skipValidate = false) {
        const transaction = this.buildTransaction({
            type: "DEPLOY_ACCOUNT" /* DEPLOY_ACCOUNT */ ,
            ...invocation,
            ...details
        }, "fee");
        return this.fetchEndpoint("estimate_fee", {
            blockIdentifier: blockIdentifier,
            skipValidate: skipValidate
        }, transaction).then(this.responseParser.parseFeeEstimateResponse);
    }
    async getEstimateFeeBulk(invocations, { blockIdentifier: blockIdentifier = this.blockIdentifier, skipValidate: skipValidate = false }) {
        const transactions = invocations.map((it)=>this.buildTransaction(it, "fee"));
        return this.fetchEndpoint("estimate_fee_bulk", {
            blockIdentifier: blockIdentifier,
            skipValidate: skipValidate
        }, transactions).then(this.responseParser.parseFeeEstimateBulkResponse);
    }
    async getCode(contractAddress, blockIdentifier = this.blockIdentifier) {
        return this.fetchEndpoint("get_code", {
            contractAddress: contractAddress,
            blockIdentifier: blockIdentifier
        });
    }
    async waitForTransaction(txHash, options) {
        let res;
        let completed = false;
        let retries = 0;
        var _options_retryInterval;
        const retryInterval = (_options_retryInterval = options === null || options === void 0 ? void 0 : options.retryInterval) !== null && _options_retryInterval !== void 0 ? _options_retryInterval : 5e3;
        var _options_errorStates;
        const errorStates = (_options_errorStates = options === null || options === void 0 ? void 0 : options.errorStates) !== null && _options_errorStates !== void 0 ? _options_errorStates : [
            "REJECTED" /* REJECTED */ ,
            "NOT_RECEIVED" /* NOT_RECEIVED */ ,
            "REVERTED" /* REVERTED */ 
        ];
        var _options_successStates;
        const successStates = (_options_successStates = options === null || options === void 0 ? void 0 : options.successStates) !== null && _options_successStates !== void 0 ? _options_successStates : [
            "SUCCEEDED" /* SUCCEEDED */ ,
            "ACCEPTED_ON_L1" /* ACCEPTED_ON_L1 */ ,
            "ACCEPTED_ON_L2" /* ACCEPTED_ON_L2 */ 
        ];
        while(!completed){
            await $facb0cbc5626d02c$var$wait(retryInterval);
            res = await this.getTransactionStatus(txHash);
            if ("NOT_RECEIVED" /* NOT_RECEIVED */  === res.finality_status && retries < 3) retries += 1;
            else if (successStates.includes(res.finality_status) || successStates.includes(res.execution_status)) completed = true;
            else if (errorStates.includes(res.finality_status) || errorStates.includes(res.execution_status)) {
                let message;
                if (res.tx_failure_reason) message = `${res.tx_status}: ${res.tx_failure_reason.code}
${res.tx_failure_reason.error_message}`;
                else if (res.tx_revert_reason) message = `${res.tx_status}: ${res.tx_revert_reason}`;
                else message = res.tx_status;
                const error = new Error(message);
                error.response = res;
                throw error;
            }
        }
        const txReceipt = await this.getTransactionReceipt(txHash);
        return txReceipt;
    }
    /**
   * Gets the status of a transaction.
   * @param txHash BigNumberish
   * @returns GetTransactionStatusResponse - the transaction status object
   */ async getTransactionStatus(txHash) {
        const txHashHex = $facb0cbc5626d02c$var$toHex(txHash);
        return this.fetchEndpoint("get_transaction_status", {
            transactionHash: txHashHex
        });
    }
    /**
   * Gets the smart contract address on the goerli testnet.
   * @returns GetContractAddressesResponse - starknet smart contract addresses
   */ async getContractAddresses() {
        return this.fetchEndpoint("get_contract_addresses");
    }
    /**
   * Gets the transaction trace from a tx id.
   * @param txHash BigNumberish
   * @returns TransactionTraceResponse - the transaction trace
   */ async getTransactionTrace(txHash) {
        const txHashHex = $facb0cbc5626d02c$var$toHex(txHash);
        return this.fetchEndpoint("get_transaction_trace", {
            transactionHash: txHashHex
        });
    }
    async estimateMessageFee({ from_address: from_address, to_address: to_address, entry_point_selector: entry_point_selector, payload: payload }, blockIdentifier = this.blockIdentifier) {
        const validCallL1Handler = {
            from_address: $facb0cbc5626d02c$var$getDecimalString(from_address),
            to_address: $facb0cbc5626d02c$var$getHexString(to_address),
            entry_point_selector: $facb0cbc5626d02c$var$getSelector(entry_point_selector),
            payload: $facb0cbc5626d02c$var$getHexStringArray(payload)
        };
        return this.fetchEndpoint("estimate_message_fee", {
            blockIdentifier: blockIdentifier
        }, validCallL1Handler);
    }
    /**
   * Simulate transaction using Sequencer provider
   * WARNING!: Sequencer will process only first element from invocations array
   *
   * @param invocations Array of invocations, but only first invocation will be processed
   * @param blockIdentifier block identifier, default 'latest'
   * @param skipValidate Skip Account __validate__ method
   * @returns
   */ async getSimulateTransaction(invocations, { blockIdentifier: blockIdentifier = this.blockIdentifier, skipValidate: skipValidate = false, skipExecute: skipExecute = false }) {
        if (invocations.length > 1) console.warn("Sequencer simulate process only first element from invocations list");
        if (skipExecute) console.warn("Sequencer can't skip account __execute__");
        const transaction = this.buildTransaction(invocations[0]);
        return this.fetchEndpoint("simulate_transaction", {
            blockIdentifier: blockIdentifier,
            skipValidate: skipValidate !== null && skipValidate !== void 0 ? skipValidate : false
        }, transaction).then(this.responseParser.parseSimulateTransactionResponse);
    }
    async getStateUpdate(blockIdentifier = this.blockIdentifier) {
        const args = new $facb0cbc5626d02c$var$Block(blockIdentifier).sequencerIdentifier;
        return this.fetchEndpoint("get_state_update", {
            ...args
        }).then(this.responseParser.parseGetStateUpdateResponse);
    }
    // consider adding an optional trace retrieval parameter to the getBlock method
    async getBlockTraces(blockIdentifier = this.blockIdentifier) {
        const args = new $facb0cbc5626d02c$var$Block(blockIdentifier).sequencerIdentifier;
        return this.fetchEndpoint("get_block_traces", {
            ...args
        });
    }
    async getStarkName(address, StarknetIdContract2) {
        return $facb0cbc5626d02c$var$getStarkName(this, address, StarknetIdContract2);
    }
    async getAddressFromStarkName(name, StarknetIdContract2) {
        return $facb0cbc5626d02c$var$getAddressFromStarkName(this, name, StarknetIdContract2);
    }
    /**
   * Build Single AccountTransaction from Single AccountInvocation
   * @param invocation AccountInvocationItem
   * @param versionType 'fee' | 'transaction' - used to determine default versions
   * @returns AccountTransactionItem
   */ buildTransaction(invocation, versionType) {
        const defaultVersions = $facb0cbc5626d02c$var$getVersionsByType(versionType);
        const details = {
            signature: $facb0cbc5626d02c$var$signatureToDecimalArray(invocation.signature),
            nonce: $facb0cbc5626d02c$var$toHex(invocation.nonce)
        };
        var _invocation_calldata;
        if (invocation.type === "INVOKE_FUNCTION" /* INVOKE */ ) return {
            type: invocation.type,
            sender_address: invocation.contractAddress,
            calldata: $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile((_invocation_calldata = invocation.calldata) !== null && _invocation_calldata !== void 0 ? _invocation_calldata : []),
            version: $facb0cbc5626d02c$var$toHex(invocation.version || defaultVersions.v1),
            ...details
        };
        if (invocation.type === "DECLARE" /* DECLARE */ ) {
            if (!$facb0cbc5626d02c$export$6050805ab301367e(invocation.contract)) return {
                type: invocation.type,
                contract_class: invocation.contract,
                sender_address: invocation.senderAddress,
                version: $facb0cbc5626d02c$var$toHex(invocation.version || defaultVersions.v1),
                // fee from getDeclareEstimateFee use t.v. instead of feet.v.
                ...details
            };
            return {
                type: invocation.type,
                contract_class: invocation.contract,
                compiled_class_hash: invocation.compiledClassHash,
                sender_address: invocation.senderAddress,
                version: $facb0cbc5626d02c$var$toHex(invocation.version || defaultVersions.v2),
                // fee on getDeclareEstimateFee use t.v. instead of feet.v.
                ...details
            };
        }
        if (invocation.type === "DEPLOY_ACCOUNT" /* DEPLOY_ACCOUNT */ ) return {
            type: invocation.type,
            constructor_calldata: $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile(invocation.constructorCalldata || []),
            class_hash: $facb0cbc5626d02c$var$toHex(invocation.classHash),
            contract_address_salt: $facb0cbc5626d02c$var$toHex(invocation.addressSalt || 0),
            version: $facb0cbc5626d02c$var$toHex(invocation.version || defaultVersions.v1),
            ...details
        };
        throw Error("Sequencer buildTransaction received unknown TransactionType");
    }
    constructor(optionsOrProvider = $facb0cbc5626d02c$var$defaultOptions2){
        (0, $dxWQo._)(this, "baseUrl", void 0);
        (0, $dxWQo._)(this, "feederGatewayUrl", void 0);
        (0, $dxWQo._)(this, "gatewayUrl", void 0);
        (0, $dxWQo._)(this, "headers", void 0);
        (0, $dxWQo._)(this, "blockIdentifier", void 0);
        (0, $dxWQo._)(this, "chainId", void 0);
        (0, $dxWQo._)(this, "responseParser", new $facb0cbc5626d02c$var$SequencerAPIResponseParser());
        if ("network" in optionsOrProvider) {
            this.baseUrl = $facb0cbc5626d02c$export$257d155889fba954.getNetworkFromName(optionsOrProvider.network);
            this.feederGatewayUrl = $facb0cbc5626d02c$export$b5cd97dee32de81d(this.baseUrl, "feeder_gateway");
            this.gatewayUrl = $facb0cbc5626d02c$export$b5cd97dee32de81d(this.baseUrl, "gateway");
        } else {
            this.baseUrl = optionsOrProvider.baseUrl;
            this.feederGatewayUrl = $facb0cbc5626d02c$export$b5cd97dee32de81d(this.baseUrl, "feeder_gateway", optionsOrProvider.feederGatewayUrl);
            this.gatewayUrl = $facb0cbc5626d02c$export$b5cd97dee32de81d(this.baseUrl, "gateway", optionsOrProvider.gatewayUrl);
        }
        var _optionsOrProvider_chainId;
        this.chainId = (_optionsOrProvider_chainId = optionsOrProvider === null || optionsOrProvider === void 0 ? void 0 : optionsOrProvider.chainId) !== null && _optionsOrProvider_chainId !== void 0 ? _optionsOrProvider_chainId : $facb0cbc5626d02c$export$257d155889fba954.getChainIdFromBaseUrl(this.baseUrl);
        this.headers = optionsOrProvider.headers;
        this.blockIdentifier = (optionsOrProvider === null || optionsOrProvider === void 0 ? void 0 : optionsOrProvider.blockIdentifier) || $facb0cbc5626d02c$var$defaultOptions2.blockIdentifier;
    }
};
// src/provider/default.ts
var $facb0cbc5626d02c$export$2881499e37b75b9a = class {
    async getChainId() {
        return this.provider.getChainId();
    }
    async getBlock(blockIdentifier) {
        return this.provider.getBlock(blockIdentifier);
    }
    async getClassAt(contractAddress, blockIdentifier) {
        return this.provider.getClassAt(contractAddress, blockIdentifier);
    }
    async getClassHashAt(contractAddress, blockIdentifier) {
        return this.provider.getClassHashAt(contractAddress, blockIdentifier);
    }
    getClassByHash(classHash) {
        return this.provider.getClassByHash(classHash);
    }
    async getEstimateFee(invocationWithTxType, invocationDetails, blockIdentifier) {
        return this.provider.getEstimateFee(invocationWithTxType, invocationDetails, blockIdentifier);
    }
    async getInvokeEstimateFee(invocationWithTxType, invocationDetails, blockIdentifier, skipValidate) {
        return this.provider.getInvokeEstimateFee(invocationWithTxType, invocationDetails, blockIdentifier, skipValidate);
    }
    async getEstimateFeeBulk(invocations, options) {
        return this.provider.getEstimateFeeBulk(invocations, options);
    }
    async getNonceForAddress(contractAddress, blockIdentifier) {
        return this.provider.getNonceForAddress(contractAddress, blockIdentifier);
    }
    async getStorageAt(contractAddress, key, blockIdentifier) {
        return this.provider.getStorageAt(contractAddress, key, blockIdentifier);
    }
    async getTransaction(txHash) {
        return this.provider.getTransaction(txHash);
    }
    async getTransactionReceipt(txHash) {
        return this.provider.getTransactionReceipt(txHash);
    }
    async callContract(request, blockIdentifier) {
        return this.provider.callContract(request, blockIdentifier);
    }
    async invokeFunction(functionInvocation, details) {
        return this.provider.invokeFunction(functionInvocation, details);
    }
    async deployAccountContract(payload, details) {
        return this.provider.deployAccountContract(payload, details);
    }
    async declareContract(transaction, details) {
        return this.provider.declareContract(transaction, details);
    }
    async getDeclareEstimateFee(transaction, details, blockIdentifier, skipValidate) {
        return this.provider.getDeclareEstimateFee(transaction, details, blockIdentifier, skipValidate);
    }
    getDeployAccountEstimateFee(transaction, details, blockIdentifier, skipValidate) {
        return this.provider.getDeployAccountEstimateFee(transaction, details, blockIdentifier, skipValidate);
    }
    async getCode(contractAddress, blockIdentifier) {
        return this.provider.getCode(contractAddress, blockIdentifier);
    }
    async waitForTransaction(txHash, options) {
        return this.provider.waitForTransaction(txHash, options);
    }
    async getSimulateTransaction(invocations, options) {
        return this.provider.getSimulateTransaction(invocations, options);
    }
    async getStateUpdate(blockIdentifier) {
        return this.provider.getStateUpdate(blockIdentifier);
    }
    async getStarkName(address, StarknetIdContract2) {
        return $facb0cbc5626d02c$var$getStarkName(this, address, StarknetIdContract2);
    }
    async getAddressFromStarkName(name, StarknetIdContract2) {
        return $facb0cbc5626d02c$var$getAddressFromStarkName(this, name, StarknetIdContract2);
    }
    async getContractVersion(contractAddress, classHash, options) {
        return this.provider.getContractVersion(contractAddress, classHash, options);
    }
    constructor(providerOrOptions){
        (0, $dxWQo._)(this, "provider", void 0);
        if (providerOrOptions instanceof $facb0cbc5626d02c$export$2881499e37b75b9a) this.provider = providerOrOptions.provider;
        else if (providerOrOptions instanceof $facb0cbc5626d02c$export$578ebb3f1f89cda2 || providerOrOptions instanceof $facb0cbc5626d02c$export$257d155889fba954) this.provider = providerOrOptions;
        else if (providerOrOptions && "rpc" in providerOrOptions) this.provider = new $facb0cbc5626d02c$export$578ebb3f1f89cda2(providerOrOptions.rpc);
        else if (providerOrOptions && "sequencer" in providerOrOptions) this.provider = new $facb0cbc5626d02c$export$257d155889fba954(providerOrOptions.sequencer);
        else this.provider = new $facb0cbc5626d02c$export$578ebb3f1f89cda2();
    }
};
// src/signer/interface.ts
var $facb0cbc5626d02c$export$c7f3abef082132e7 = class {
};
// src/utils/transaction.ts
var $facb0cbc5626d02c$export$2d62d2646dd2fb3c = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$2d62d2646dd2fb3c, {
    fromCallsToExecuteCalldata: ()=>$facb0cbc5626d02c$var$fromCallsToExecuteCalldata,
    fromCallsToExecuteCalldataWithNonce: ()=>$facb0cbc5626d02c$var$fromCallsToExecuteCalldataWithNonce,
    fromCallsToExecuteCalldata_cairo1: ()=>$facb0cbc5626d02c$var$fromCallsToExecuteCalldata_cairo1,
    getExecuteCalldata: ()=>$facb0cbc5626d02c$var$getExecuteCalldata,
    transformCallsToMulticallArrays: ()=>$facb0cbc5626d02c$var$transformCallsToMulticallArrays,
    transformCallsToMulticallArrays_cairo1: ()=>$facb0cbc5626d02c$var$transformCallsToMulticallArrays_cairo1
});
var $facb0cbc5626d02c$var$transformCallsToMulticallArrays = (calls)=>{
    const callArray = [];
    const calldata = [];
    calls.forEach((call)=>{
        const data = $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile(call.calldata || []);
        callArray.push({
            to: $facb0cbc5626d02c$var$toBigInt(call.contractAddress).toString(10),
            selector: $facb0cbc5626d02c$var$toBigInt($facb0cbc5626d02c$var$getSelectorFromName(call.entrypoint)).toString(10),
            data_offset: calldata.length.toString(),
            data_len: data.length.toString()
        });
        calldata.push(...data);
    });
    return {
        callArray: callArray,
        calldata: $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile({
            calldata: calldata
        })
    };
};
var $facb0cbc5626d02c$var$fromCallsToExecuteCalldata = (calls)=>{
    const { callArray: callArray, calldata: calldata } = $facb0cbc5626d02c$var$transformCallsToMulticallArrays(calls);
    const compiledCalls = $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile({
        callArray: callArray
    });
    return [
        ...compiledCalls,
        ...calldata
    ];
};
var $facb0cbc5626d02c$var$fromCallsToExecuteCalldataWithNonce = (calls, nonce)=>{
    return [
        ...$facb0cbc5626d02c$var$fromCallsToExecuteCalldata(calls),
        $facb0cbc5626d02c$var$toBigInt(nonce).toString()
    ];
};
var $facb0cbc5626d02c$var$transformCallsToMulticallArrays_cairo1 = (calls)=>{
    const callArray = calls.map((call)=>({
            to: $facb0cbc5626d02c$var$toBigInt(call.contractAddress).toString(10),
            selector: $facb0cbc5626d02c$var$toBigInt($facb0cbc5626d02c$var$getSelectorFromName(call.entrypoint)).toString(10),
            calldata: $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile(call.calldata || [])
        }));
    return callArray;
};
var $facb0cbc5626d02c$var$fromCallsToExecuteCalldata_cairo1 = (calls)=>{
    const orderCalls = calls.map((call)=>({
            contractAddress: call.contractAddress,
            entrypoint: call.entrypoint,
            calldata: Array.isArray(call.calldata) && "__compiled__" in call.calldata ? call.calldata : $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile(call.calldata)
        }));
    return $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile({
        orderCalls: orderCalls
    });
};
var $facb0cbc5626d02c$var$getExecuteCalldata = (calls, cairoVersion = "0")=>{
    if (cairoVersion === "1") return $facb0cbc5626d02c$var$fromCallsToExecuteCalldata_cairo1(calls);
    return $facb0cbc5626d02c$var$fromCallsToExecuteCalldata(calls);
};
// src/utils/typedData.ts
var $facb0cbc5626d02c$export$2ebe69e89b76b6ec = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$2ebe69e89b76b6ec, {
    TypedDataRevision: ()=>$facb0cbc5626d02c$export$c66c875ce2a199f3,
    byteArrayFromString: ()=>$facb0cbc5626d02c$var$byteArrayFromString,
    encodeData: ()=>$facb0cbc5626d02c$var$encodeData,
    encodeType: ()=>$facb0cbc5626d02c$var$encodeType,
    encodeValue: ()=>$facb0cbc5626d02c$var$encodeValue,
    getDependencies: ()=>$facb0cbc5626d02c$var$getDependencies,
    getMessageHash: ()=>$facb0cbc5626d02c$var$getMessageHash,
    getStructHash: ()=>$facb0cbc5626d02c$var$getStructHash,
    getTypeHash: ()=>$facb0cbc5626d02c$var$getTypeHash,
    isMerkleTreeType: ()=>$facb0cbc5626d02c$var$isMerkleTreeType,
    prepareSelector: ()=>$facb0cbc5626d02c$var$prepareSelector
});
// src/utils/merkle.ts
var $facb0cbc5626d02c$export$483e047521be7129 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$483e047521be7129, {
    MerkleTree: ()=>$facb0cbc5626d02c$var$MerkleTree,
    proofMerklePath: ()=>$facb0cbc5626d02c$var$proofMerklePath
});
var $facb0cbc5626d02c$var$MerkleTree = class {
    /**
   * Create Merkle tree
   * @param leaves hex-string array
   * @returns format: hex-string; Merkle tree root
   */ build(leaves) {
        if (leaves.length === 1) return leaves[0];
        if (leaves.length !== this.leaves.length) this.branches.push(leaves);
        const newLeaves = [];
        for(let i = 0; i < leaves.length; i += 2)if (i + 1 === leaves.length) newLeaves.push($facb0cbc5626d02c$var$MerkleTree.hash(leaves[i], "0x0", this.hashMethod));
        else newLeaves.push($facb0cbc5626d02c$var$MerkleTree.hash(leaves[i], leaves[i + 1], this.hashMethod));
        return this.build(newLeaves);
    }
    /**
   * Create hash from ordered a and b, Pedersen hash default
   * @returns format: hex-string
   */ static hash(a, b, hashMethod = $facb0cbc5626d02c$var$computePedersenHash) {
        const [aSorted, bSorted] = [
            BigInt(a),
            BigInt(b)
        ].sort((x, y)=>x >= y ? 1 : -1);
        return hashMethod(aSorted, bSorted);
    }
    /**
   * Return path to leaf
   * @param leaf hex-string
   * @param branch hex-string array
   * @param hashPath hex-string array
   * @returns format: hex-string array
   */ getProof(leaf, branch = this.leaves, hashPath = []) {
        const index = branch.indexOf(leaf);
        if (index === -1) throw new Error("leaf not found");
        if (branch.length === 1) return hashPath;
        const isLeft = index % 2 === 0;
        var _ref;
        const neededBranch = (_ref = isLeft ? branch[index + 1] : branch[index - 1]) !== null && _ref !== void 0 ? _ref : "0x0";
        const newHashPath = [
            ...hashPath,
            neededBranch
        ];
        const currentBranchLevelIndex = this.leaves.length === branch.length ? -1 : this.branches.findIndex((b)=>b.length === branch.length);
        var _this_branches_;
        const nextBranch = (_this_branches_ = this.branches[currentBranchLevelIndex + 1]) !== null && _this_branches_ !== void 0 ? _this_branches_ : [
            this.root
        ];
        return this.getProof($facb0cbc5626d02c$var$MerkleTree.hash(isLeft ? leaf : neededBranch, isLeft ? neededBranch : leaf, this.hashMethod), nextBranch, newHashPath);
    }
    constructor(leafHashes, hashMethod = $facb0cbc5626d02c$var$computePedersenHash){
        (0, $dxWQo._)(this, "leaves", void 0);
        (0, $dxWQo._)(this, "branches", []);
        (0, $dxWQo._)(this, "root", void 0);
        (0, $dxWQo._)(this, "hashMethod", void 0);
        this.hashMethod = hashMethod;
        this.leaves = leafHashes;
        this.root = this.build(leafHashes);
    }
};
function $facb0cbc5626d02c$var$proofMerklePath(root, leaf, path, hashMethod = $facb0cbc5626d02c$var$computePedersenHash) {
    if (path.length === 0) return root === leaf;
    const [next, ...rest] = path;
    return $facb0cbc5626d02c$var$proofMerklePath(root, $facb0cbc5626d02c$var$MerkleTree.hash(leaf, next, hashMethod), rest, hashMethod);
}
// src/utils/typedData.ts
var $facb0cbc5626d02c$var$presetTypes = {
    u256: JSON.parse('[{ "name": "low", "type": "u128" }, { "name": "high", "type": "u128" }]'),
    TokenAmount: JSON.parse('[{ "name": "token_address", "type": "ContractAddress" }, { "name": "amount", "type": "u256" }]'),
    NftId: JSON.parse('[{ "name": "collection_address", "type": "ContractAddress" }, { "name": "token_id", "type": "u256" }]')
};
var $facb0cbc5626d02c$var$revisionConfiguration = {
    ["1" /* Active */ ]: {
        domain: "StarknetDomain",
        hashMethod: $facb0cbc5626d02c$var$computePoseidonHashOnElements,
        hashMerkleMethod: $facb0cbc5626d02c$var$computePoseidonHash,
        escapeTypeString: (s)=>`"${s}"`,
        presetTypes: $facb0cbc5626d02c$var$presetTypes
    },
    ["0" /* Legacy */ ]: {
        domain: "StarkNetDomain",
        hashMethod: $facb0cbc5626d02c$var$computePedersenHashOnElements,
        hashMerkleMethod: $facb0cbc5626d02c$var$computePedersenHash,
        escapeTypeString: (s)=>s,
        presetTypes: {}
    }
};
function $facb0cbc5626d02c$var$byteArrayFromString(targetString) {
    const shortStrings = $facb0cbc5626d02c$var$splitLongString(targetString);
    const remainder = shortStrings[shortStrings.length - 1];
    const shortStringsEncoded = shortStrings.map($facb0cbc5626d02c$var$encodeShortString);
    const [pendingWord, pendingWordLength] = remainder === void 0 || remainder.length === 31 ? [
        "0x00",
        0
    ] : [
        shortStringsEncoded.pop(),
        remainder.length
    ];
    return {
        data: shortStringsEncoded.length === 0 ? [
            "0x00"
        ] : shortStringsEncoded,
        pending_word: pendingWord,
        pending_word_len: pendingWordLength
    };
}
function $facb0cbc5626d02c$var$identifyRevision({ types: types, domain: domain }) {
    if ($facb0cbc5626d02c$var$revisionConfiguration["1" /* Active */ ].domain in types && domain.revision === "1" /* Active */ ) return "1" /* Active */ ;
    var _domain_revision;
    if ($facb0cbc5626d02c$var$revisionConfiguration["0" /* Legacy */ ].domain in types && ((_domain_revision = domain.revision) !== null && _domain_revision !== void 0 ? _domain_revision : "0" /* Legacy */ ) === "0" /* Legacy */ ) return "0" /* Legacy */ ;
    return void 0;
}
function $facb0cbc5626d02c$var$getHex(value) {
    try {
        return $facb0cbc5626d02c$var$toHex(value);
    } catch (e) {
        if (typeof value === "string") return $facb0cbc5626d02c$var$toHex($facb0cbc5626d02c$var$encodeShortString(value));
        throw new Error(`Invalid BigNumberish: ${value}`);
    }
}
function $facb0cbc5626d02c$var$validateTypedData(data) {
    const typedData = data;
    return Boolean(typedData.message && typedData.primaryType && typedData.types && $facb0cbc5626d02c$var$identifyRevision(typedData));
}
function $facb0cbc5626d02c$var$prepareSelector(selector) {
    return $facb0cbc5626d02c$var$isHex(selector) ? selector : $facb0cbc5626d02c$var$getSelectorFromName(selector);
}
function $facb0cbc5626d02c$var$isMerkleTreeType(type) {
    return type.type === "merkletree";
}
function $facb0cbc5626d02c$var$getDependencies(types, type, dependencies = [], contains = "", revision = "0" /* Legacy */ ) {
    if (type[type.length - 1] === "*") type = type.slice(0, -1);
    else if (revision === "1" /* Active */ ) {
        if (type === "enum") type = contains;
        else if (type.match(/^\(.*\)$/)) type = type.slice(1, -1);
    }
    if (dependencies.includes(type) || !types[type]) return dependencies;
    return [
        type,
        ...types[type].reduce((previous, t)=>[
                ...previous,
                ...$facb0cbc5626d02c$var$getDependencies(types, t.type, previous, t.contains, revision).filter((dependency)=>!previous.includes(dependency))
            ], [])
    ];
}
function $facb0cbc5626d02c$var$getMerkleTreeType(types, ctx) {
    if (ctx.parent && ctx.key) {
        const parentType = types[ctx.parent];
        const merkleType = parentType.find((t)=>t.name === ctx.key);
        const isMerkleTree = $facb0cbc5626d02c$var$isMerkleTreeType(merkleType);
        if (!isMerkleTree) throw new Error(`${ctx.key} is not a merkle tree`);
        if (merkleType.contains.endsWith("*")) throw new Error(`Merkle tree contain property must not be an array but was given ${ctx.key}`);
        return merkleType.contains;
    }
    return "raw";
}
function $facb0cbc5626d02c$var$encodeType(types, type, revision = "0" /* Legacy */ ) {
    const [primary, ...dependencies] = $facb0cbc5626d02c$var$getDependencies(types, type, void 0, void 0, revision);
    const newTypes = !primary ? [] : [
        primary,
        ...dependencies.sort()
    ];
    const esc = $facb0cbc5626d02c$var$revisionConfiguration[revision].escapeTypeString;
    return newTypes.map((dependency)=>{
        const dependencyElements = types[dependency].map((t)=>{
            const targetType = t.type === "enum" && revision === "1" /* Active */  ? t.contains : t.type;
            const typeString = targetType.match(/^\(.*\)$/) ? `(${targetType.slice(1, -1).split(",").map((e)=>e ? esc(e) : e).join(",")})` : esc(targetType);
            return `${esc(t.name)}:${typeString}`;
        });
        return `${esc(dependency)}(${dependencyElements})`;
    }).join("");
}
function $facb0cbc5626d02c$var$getTypeHash(types, type, revision = "0" /* Legacy */ ) {
    return $facb0cbc5626d02c$var$getSelectorFromName($facb0cbc5626d02c$var$encodeType(types, type, revision));
}
function $facb0cbc5626d02c$var$encodeValue(types, type, data, ctx = {}, revision = "0" /* Legacy */ ) {
    if (types[type]) return [
        type,
        $facb0cbc5626d02c$var$getStructHash(types, type, data, revision)
    ];
    if ($facb0cbc5626d02c$var$revisionConfiguration[revision].presetTypes[type]) return [
        type,
        $facb0cbc5626d02c$var$getStructHash($facb0cbc5626d02c$var$revisionConfiguration[revision].presetTypes, type, data, revision)
    ];
    if (type.endsWith("*")) {
        const hashes = data.map((entry)=>$facb0cbc5626d02c$var$encodeValue(types, type.slice(0, -1), entry, void 0, revision)[1]);
        return [
            type,
            $facb0cbc5626d02c$var$revisionConfiguration[revision].hashMethod(hashes)
        ];
    }
    switch(type){
        case "enum":
            if (revision === "1" /* Active */ ) {
                const [variantKey, variantData] = Object.entries(data)[0];
                const parentType = types[ctx.parent][0];
                const enumType = types[parentType.contains];
                const variantType = enumType.find((t)=>t.name === variantKey);
                const variantIndex = enumType.indexOf(variantType);
                const encodedSubtypes = variantType.type.slice(1, -1).split(",").map((subtype, index)=>{
                    if (!subtype) return subtype;
                    const subtypeData = variantData[index];
                    return $facb0cbc5626d02c$var$encodeValue(types, subtype, subtypeData, void 0, revision)[1];
                });
                return [
                    type,
                    $facb0cbc5626d02c$var$revisionConfiguration[revision].hashMethod([
                        variantIndex,
                        ...encodedSubtypes
                    ])
                ];
            }
            return [
                type,
                $facb0cbc5626d02c$var$getHex(data)
            ];
        case "merkletree":
            {
                const merkleTreeType = $facb0cbc5626d02c$var$getMerkleTreeType(types, ctx);
                const structHashes = data.map((struct)=>{
                    return $facb0cbc5626d02c$var$encodeValue(types, merkleTreeType, struct, void 0, revision)[1];
                });
                const { root: root } = new $facb0cbc5626d02c$var$MerkleTree(structHashes, $facb0cbc5626d02c$var$revisionConfiguration[revision].hashMerkleMethod);
                return [
                    "felt",
                    root
                ];
            }
        case "selector":
            return [
                "felt",
                $facb0cbc5626d02c$var$prepareSelector(data)
            ];
        case "string":
            if (revision === "1" /* Active */ ) {
                const byteArray = $facb0cbc5626d02c$var$byteArrayFromString(data);
                const elements = [
                    byteArray.data.length,
                    ...byteArray.data,
                    byteArray.pending_word,
                    byteArray.pending_word_len
                ];
                return [
                    type,
                    $facb0cbc5626d02c$var$revisionConfiguration[revision].hashMethod(elements)
                ];
            }
            return [
                type,
                $facb0cbc5626d02c$var$getHex(data)
            ];
        case "felt":
        case "bool":
        case "u128":
        case "i128":
        case "ContractAddress":
        case "ClassHash":
        case "timestamp":
        case "shortstring":
            return [
                type,
                $facb0cbc5626d02c$var$getHex(data)
            ];
        default:
            if (revision === "1" /* Active */ ) throw new Error(`Unsupported type: ${type}`);
            return [
                type,
                $facb0cbc5626d02c$var$getHex(data)
            ];
    }
}
function $facb0cbc5626d02c$var$encodeData(types, type, data, revision = "0" /* Legacy */ ) {
    var _types_type;
    const targetType = (_types_type = types[type]) !== null && _types_type !== void 0 ? _types_type : $facb0cbc5626d02c$var$revisionConfiguration[revision].presetTypes[type];
    const [returnTypes, values] = targetType.reduce(([ts, vs], field)=>{
        if (data[field.name] === void 0 || data[field.name] === null && field.type !== "enum") throw new Error(`Cannot encode data: missing data for '${field.name}'`);
        const value = data[field.name];
        const ctx = {
            parent: type,
            key: field.name
        };
        const [t, encodedValue] = $facb0cbc5626d02c$var$encodeValue(types, field.type, value, ctx, revision);
        return [
            [
                ...ts,
                t
            ],
            [
                ...vs,
                encodedValue
            ]
        ];
    }, [
        [
            "felt"
        ],
        [
            $facb0cbc5626d02c$var$getTypeHash(types, type, revision)
        ]
    ]);
    return [
        returnTypes,
        values
    ];
}
function $facb0cbc5626d02c$var$getStructHash(types, type, data, revision = "0" /* Legacy */ ) {
    return $facb0cbc5626d02c$var$revisionConfiguration[revision].hashMethod($facb0cbc5626d02c$var$encodeData(types, type, data, revision)[1]);
}
function $facb0cbc5626d02c$var$getMessageHash(typedData, account) {
    if (!$facb0cbc5626d02c$var$validateTypedData(typedData)) throw new Error("Typed data does not match JSON schema");
    const revision = $facb0cbc5626d02c$var$identifyRevision(typedData);
    const { domain: domain, hashMethod: hashMethod } = $facb0cbc5626d02c$var$revisionConfiguration[revision];
    const message = [
        $facb0cbc5626d02c$var$encodeShortString("StarkNet Message"),
        $facb0cbc5626d02c$var$getStructHash(typedData.types, domain, typedData.domain, revision),
        account,
        $facb0cbc5626d02c$var$getStructHash(typedData.types, typedData.primaryType, typedData.message, revision)
    ];
    return hashMethod(message);
}
// src/signer/default.ts
var $facb0cbc5626d02c$export$fdf54fdde81cc9f0 = class {
    async getPubKey() {
        return $5GNKL.getStarkKey(this.pk);
    }
    async signMessage(typedData, accountAddress) {
        const msgHash = $facb0cbc5626d02c$var$getMessageHash(typedData, accountAddress);
        return $5GNKL.sign(msgHash, this.pk);
    }
    async signTransaction(transactions, transactionsDetail, abis) {
        if (abis && abis.length !== transactions.length) throw new Error("ABI must be provided for each transaction or no transaction");
        const calldata = $facb0cbc5626d02c$var$getExecuteCalldata(transactions, transactionsDetail.cairoVersion);
        const msgHash = $facb0cbc5626d02c$var$calculateTransactionHash(transactionsDetail.walletAddress, transactionsDetail.version, calldata, transactionsDetail.maxFee, transactionsDetail.chainId, transactionsDetail.nonce);
        return $5GNKL.sign(msgHash, this.pk);
    }
    async signDeployAccountTransaction({ classHash: classHash, contractAddress: contractAddress, constructorCalldata: constructorCalldata, addressSalt: addressSalt, maxFee: maxFee, version: version, chainId: chainId, nonce: nonce }) {
        const msgHash = $facb0cbc5626d02c$var$calculateDeployAccountTransactionHash(contractAddress, classHash, $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile(constructorCalldata), addressSalt, version, maxFee, chainId, nonce);
        return $5GNKL.sign(msgHash, this.pk);
    }
    async signDeclareTransaction({ classHash: classHash, senderAddress: senderAddress, chainId: chainId, maxFee: maxFee, version: version, nonce: nonce, compiledClassHash: compiledClassHash }) {
        const msgHash = $facb0cbc5626d02c$var$calculateDeclareTransactionHash(classHash, senderAddress, version, maxFee, chainId, nonce, compiledClassHash);
        return $5GNKL.sign(msgHash, this.pk);
    }
    constructor(pk = $5GNKL.utils.randomPrivateKey()){
        (0, $dxWQo._)(this, "pk", void 0);
        this.pk = pk instanceof Uint8Array ? $facb0cbc5626d02c$var$buf2hex(pk) : $facb0cbc5626d02c$var$toHex(pk);
    }
};
// src/utils/events.ts
function $facb0cbc5626d02c$export$6ca6f6e3d378ddec(txReceipt) {
    if (!txReceipt.events) throw new Error("UDC emitted event is empty");
    const event = txReceipt.events.find((it)=>$facb0cbc5626d02c$var$cleanHex(it.from_address) === $facb0cbc5626d02c$var$cleanHex($facb0cbc5626d02c$var$UDC.ADDRESS)) || {
        data: []
    };
    return {
        transaction_hash: txReceipt.transaction_hash,
        contract_address: event.data[0],
        address: event.data[0],
        deployer: event.data[1],
        unique: event.data[2],
        classHash: event.data[3],
        calldata_len: event.data[4],
        calldata: event.data.slice(5, 5 + parseInt(event.data[4], 16)),
        salt: event.data[event.data.length - 1]
    };
}
// src/account/default.ts
var $facb0cbc5626d02c$export$1ed4b10e4aba04a7 = class extends $facb0cbc5626d02c$export$2881499e37b75b9a {
    async getNonce(blockIdentifier) {
        return super.getNonceForAddress(this.address, blockIdentifier);
    }
    async getNonceSafe(nonce) {
        try {
            return $facb0cbc5626d02c$var$toBigInt(nonce !== null && nonce !== void 0 ? nonce : await this.getNonce());
        } catch (error) {
            return 0n;
        }
    }
    /**
   * Retrieves the Cairo version from the network and sets `cairoVersion` if not already set in the constructor
   * @param classHash if provided detects Cairo version from classHash, otherwise from the account address
   */ async getCairoVersion(classHash) {
        if (!this.cairoVersion) {
            const { cairo: cairo } = classHash ? await super.getContractVersion(void 0, classHash) : await super.getContractVersion(this.address);
            this.cairoVersion = cairo;
        }
        return this.cairoVersion;
    }
    async estimateFee(calls, estimateFeeDetails) {
        return this.estimateInvokeFee(calls, estimateFeeDetails);
    }
    async estimateInvokeFee(calls, { nonce: providedNonce, blockIdentifier: blockIdentifier, skipValidate: skipValidate } = {}) {
        const transactions = Array.isArray(calls) ? calls : [
            calls
        ];
        const nonce = $facb0cbc5626d02c$var$toBigInt(providedNonce !== null && providedNonce !== void 0 ? providedNonce : await this.getNonce());
        const version = $facb0cbc5626d02c$var$toBigInt($facb0cbc5626d02c$var$feeTransactionVersion);
        const chainId = await this.getChainId();
        const signerDetails = {
            walletAddress: this.address,
            nonce: nonce,
            maxFee: $facb0cbc5626d02c$var$ZERO,
            version: version,
            chainId: chainId,
            cairoVersion: await this.getCairoVersion()
        };
        const invocation = await this.buildInvocation(transactions, signerDetails);
        const response = await super.getInvokeEstimateFee({
            ...invocation
        }, {
            version: version,
            nonce: nonce
        }, blockIdentifier, skipValidate);
        const suggestedMaxFee = $facb0cbc5626d02c$var$estimatedFeeToMaxFee(response.overall_fee);
        return {
            ...response,
            suggestedMaxFee: suggestedMaxFee
        };
    }
    async estimateDeclareFee({ contract: contract, classHash: providedClassHash, casm: casm, compiledClassHash: compiledClassHash }, { blockIdentifier: blockIdentifier, nonce: providedNonce, skipValidate: skipValidate } = {}) {
        const nonce = $facb0cbc5626d02c$var$toBigInt(providedNonce !== null && providedNonce !== void 0 ? providedNonce : await this.getNonce());
        const version = !$facb0cbc5626d02c$export$6050805ab301367e(contract) ? $facb0cbc5626d02c$var$feeTransactionVersion : $facb0cbc5626d02c$var$feeTransactionVersion_2;
        const chainId = await this.getChainId();
        const declareContractTransaction = await this.buildDeclarePayload({
            classHash: providedClassHash,
            contract: contract,
            casm: casm,
            compiledClassHash: compiledClassHash
        }, {
            nonce: nonce,
            chainId: chainId,
            version: version,
            walletAddress: this.address,
            maxFee: $facb0cbc5626d02c$var$ZERO,
            cairoVersion: void 0
        });
        const response = await super.getDeclareEstimateFee(declareContractTransaction, {
            version: version,
            nonce: nonce
        }, blockIdentifier, skipValidate);
        const suggestedMaxFee = $facb0cbc5626d02c$var$estimatedFeeToMaxFee(response.overall_fee);
        return {
            ...response,
            suggestedMaxFee: suggestedMaxFee
        };
    }
    async estimateAccountDeployFee({ classHash: classHash, addressSalt: addressSalt = 0, constructorCalldata: constructorCalldata = [], contractAddress: providedContractAddress }, { blockIdentifier: blockIdentifier, skipValidate: skipValidate } = {}) {
        const version = $facb0cbc5626d02c$var$toBigInt($facb0cbc5626d02c$var$feeTransactionVersion);
        const nonce = $facb0cbc5626d02c$var$ZERO;
        const chainId = await this.getChainId();
        const payload = await this.buildAccountDeployPayload({
            classHash: classHash,
            addressSalt: addressSalt,
            constructorCalldata: constructorCalldata,
            contractAddress: providedContractAddress
        }, {
            nonce: nonce,
            chainId: chainId,
            version: version,
            walletAddress: this.address,
            // unused parameter
            maxFee: $facb0cbc5626d02c$var$ZERO,
            cairoVersion: void 0
        });
        const response = await super.getDeployAccountEstimateFee({
            ...payload
        }, {
            version: version,
            nonce: nonce
        }, blockIdentifier, skipValidate);
        const suggestedMaxFee = $facb0cbc5626d02c$var$estimatedFeeToMaxFee(response.overall_fee);
        return {
            ...response,
            suggestedMaxFee: suggestedMaxFee
        };
    }
    async estimateDeployFee(payload, transactionsDetail) {
        const calls = this.buildUDCContractPayload(payload);
        return this.estimateInvokeFee(calls, transactionsDetail);
    }
    async estimateFeeBulk(invocations, { nonce: nonce, blockIdentifier: blockIdentifier, skipValidate: skipValidate } = {}) {
        const accountInvocations = await this.accountInvocationsFactory(invocations, {
            versions: [
                $facb0cbc5626d02c$var$feeTransactionVersion,
                $facb0cbc5626d02c$var$feeTransactionVersion_2
            ],
            nonce: nonce,
            blockIdentifier: blockIdentifier
        });
        const response = await super.getEstimateFeeBulk(accountInvocations, {
            blockIdentifier: blockIdentifier,
            skipValidate: skipValidate
        });
        return [].concat(response).map((elem)=>{
            const suggestedMaxFee = $facb0cbc5626d02c$var$estimatedFeeToMaxFee(elem.overall_fee);
            return {
                ...elem,
                suggestedMaxFee: suggestedMaxFee
            };
        });
    }
    async buildInvocation(call, signerDetails) {
        const calldata = $facb0cbc5626d02c$var$getExecuteCalldata(call, await this.getCairoVersion());
        const signature = await this.signer.signTransaction(call, signerDetails);
        return {
            contractAddress: this.address,
            calldata: calldata,
            signature: signature
        };
    }
    async execute(calls, abis, transactionsDetail = {}) {
        const transactions = Array.isArray(calls) ? calls : [
            calls
        ];
        var _transactionsDetail_nonce;
        const nonce = $facb0cbc5626d02c$var$toBigInt((_transactionsDetail_nonce = transactionsDetail.nonce) !== null && _transactionsDetail_nonce !== void 0 ? _transactionsDetail_nonce : await this.getNonce());
        var _transactionsDetail_maxFee;
        const maxFee = (_transactionsDetail_maxFee = transactionsDetail.maxFee) !== null && _transactionsDetail_maxFee !== void 0 ? _transactionsDetail_maxFee : await this.getSuggestedMaxFee({
            type: "INVOKE_FUNCTION" /* INVOKE */ ,
            payload: calls
        }, transactionsDetail);
        const version = $facb0cbc5626d02c$var$toBigInt($facb0cbc5626d02c$var$transactionVersion);
        const chainId = await this.getChainId();
        const signerDetails = {
            walletAddress: this.address,
            nonce: nonce,
            maxFee: maxFee,
            version: version,
            chainId: chainId,
            cairoVersion: await this.getCairoVersion()
        };
        const signature = await this.signer.signTransaction(transactions, signerDetails, abis);
        const calldata = $facb0cbc5626d02c$var$getExecuteCalldata(transactions, await this.getCairoVersion());
        return this.invokeFunction({
            contractAddress: this.address,
            calldata: calldata,
            signature: signature
        }, {
            nonce: nonce,
            maxFee: maxFee,
            version: version
        });
    }
    /**
   * First check if contract is already declared, if not declare it
   * If contract already declared returned transaction_hash is ''.
   * Method will pass even if contract is already declared
   * @param transactionsDetail (optional)
   */ async declareIfNot(payload, transactionsDetail = {}) {
        const declareContractPayload = $facb0cbc5626d02c$export$dae6fc4ab9af26b8(payload);
        try {
            await this.getClassByHash(declareContractPayload.classHash);
        } catch (error) {
            return this.declare(payload, transactionsDetail);
        }
        return {
            transaction_hash: "",
            class_hash: declareContractPayload.classHash
        };
    }
    async declare(payload, transactionsDetail = {}) {
        const declareContractPayload = $facb0cbc5626d02c$export$dae6fc4ab9af26b8(payload);
        const details = {};
        var _transactionsDetail_nonce;
        details.nonce = $facb0cbc5626d02c$var$toBigInt((_transactionsDetail_nonce = transactionsDetail.nonce) !== null && _transactionsDetail_nonce !== void 0 ? _transactionsDetail_nonce : await this.getNonce());
        var _transactionsDetail_maxFee;
        details.maxFee = (_transactionsDetail_maxFee = transactionsDetail.maxFee) !== null && _transactionsDetail_maxFee !== void 0 ? _transactionsDetail_maxFee : await this.getSuggestedMaxFee({
            type: "DECLARE" /* DECLARE */ ,
            payload: declareContractPayload
        }, transactionsDetail);
        details.version = !$facb0cbc5626d02c$export$6050805ab301367e(payload.contract) ? $facb0cbc5626d02c$var$transactionVersion : $facb0cbc5626d02c$var$transactionVersion_2;
        details.chainId = await this.getChainId();
        const declareContractTransaction = await this.buildDeclarePayload(declareContractPayload, {
            ...details,
            walletAddress: this.address,
            cairoVersion: void 0
        });
        return this.declareContract(declareContractTransaction, details);
    }
    async deploy(payload, details) {
        const params = [].concat(payload).map((it)=>{
            const { classHash: classHash, salt: salt, unique: unique = true, constructorCalldata: constructorCalldata = [] } = it;
            const compiledConstructorCallData = $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile(constructorCalldata);
            const deploySalt = salt !== null && salt !== void 0 ? salt : $facb0cbc5626d02c$var$randomAddress();
            return {
                call: {
                    contractAddress: $facb0cbc5626d02c$var$UDC.ADDRESS,
                    entrypoint: $facb0cbc5626d02c$var$UDC.ENTRYPOINT,
                    calldata: [
                        classHash,
                        deploySalt,
                        $facb0cbc5626d02c$var$toCairoBool(unique),
                        compiledConstructorCallData.length,
                        ...compiledConstructorCallData
                    ]
                },
                address: $facb0cbc5626d02c$var$calculateContractAddressFromHash(unique ? $5GNKL.pedersen(this.address, deploySalt) : deploySalt, classHash, compiledConstructorCallData, unique ? $facb0cbc5626d02c$var$UDC.ADDRESS : 0)
            };
        });
        const calls = params.map((it)=>it.call);
        const addresses = params.map((it)=>it.address);
        const invokeResponse = await this.execute(calls, void 0, details);
        return {
            ...invokeResponse,
            contract_address: addresses
        };
    }
    async deployContract(payload, details) {
        const deployTx = await this.deploy(payload, details);
        const txReceipt = await this.waitForTransaction(deployTx.transaction_hash);
        return $facb0cbc5626d02c$export$6ca6f6e3d378ddec(txReceipt);
    }
    async declareAndDeploy(payload, details) {
        const { constructorCalldata: constructorCalldata, salt: salt, unique: unique } = payload;
        let declare = await this.declareIfNot(payload, details);
        if (declare.transaction_hash !== "") {
            const tx = await this.waitForTransaction(declare.transaction_hash);
            declare = {
                ...declare,
                ...tx
            };
        }
        const deploy = await this.deployContract({
            classHash: declare.class_hash,
            salt: salt,
            unique: unique,
            constructorCalldata: constructorCalldata
        }, details);
        return {
            declare: {
                ...declare
            },
            deploy: deploy
        };
    }
    async deployAccount({ classHash: classHash, constructorCalldata: constructorCalldata = [], addressSalt: addressSalt = 0, contractAddress: providedContractAddress }, transactionsDetail = {}) {
        const version = $facb0cbc5626d02c$var$toBigInt($facb0cbc5626d02c$var$transactionVersion);
        const nonce = $facb0cbc5626d02c$var$ZERO;
        const chainId = await this.getChainId();
        const compiledCalldata = $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile(constructorCalldata);
        const contractAddress = providedContractAddress !== null && providedContractAddress !== void 0 ? providedContractAddress : $facb0cbc5626d02c$var$calculateContractAddressFromHash(addressSalt, classHash, compiledCalldata, 0);
        var _transactionsDetail_maxFee;
        const maxFee = (_transactionsDetail_maxFee = transactionsDetail.maxFee) !== null && _transactionsDetail_maxFee !== void 0 ? _transactionsDetail_maxFee : await this.getSuggestedMaxFee({
            type: "DEPLOY_ACCOUNT" /* DEPLOY_ACCOUNT */ ,
            payload: {
                classHash: classHash,
                constructorCalldata: compiledCalldata,
                addressSalt: addressSalt,
                contractAddress: contractAddress
            }
        }, transactionsDetail);
        const signature = await this.signer.signDeployAccountTransaction({
            classHash: classHash,
            constructorCalldata: compiledCalldata,
            contractAddress: contractAddress,
            addressSalt: addressSalt,
            chainId: chainId,
            maxFee: maxFee,
            version: version,
            nonce: nonce
        });
        return this.deployAccountContract({
            classHash: classHash,
            addressSalt: addressSalt,
            constructorCalldata: constructorCalldata,
            signature: signature
        }, {
            nonce: nonce,
            maxFee: maxFee,
            version: version
        });
    }
    async signMessage(typedData) {
        return this.signer.signMessage(typedData, this.address);
    }
    async hashMessage(typedData) {
        return $facb0cbc5626d02c$var$getMessageHash(typedData, this.address);
    }
    async verifyMessageHash(hash, signature) {
        try {
            await this.callContract({
                contractAddress: this.address,
                entrypoint: "isValidSignature",
                calldata: $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile({
                    hash: $facb0cbc5626d02c$var$toBigInt(hash).toString(),
                    signature: $facb0cbc5626d02c$var$formatSignature(signature)
                })
            });
            return true;
        } catch  {
            return false;
        }
    }
    async verifyMessage(typedData, signature) {
        const hash = await this.hashMessage(typedData);
        return this.verifyMessageHash(hash, signature);
    }
    async getSuggestedMaxFee({ type: type, payload: payload }, details) {
        let feeEstimate;
        switch(type){
            case "INVOKE_FUNCTION" /* INVOKE */ :
                feeEstimate = await this.estimateInvokeFee(payload, details);
                break;
            case "DECLARE" /* DECLARE */ :
                feeEstimate = await this.estimateDeclareFee(payload, details);
                break;
            case "DEPLOY_ACCOUNT" /* DEPLOY_ACCOUNT */ :
                feeEstimate = await this.estimateAccountDeployFee(payload, details);
                break;
            case "DEPLOY" /* DEPLOY */ :
                feeEstimate = await this.estimateDeployFee(payload, details);
                break;
            default:
                feeEstimate = {
                    suggestedMaxFee: $facb0cbc5626d02c$var$ZERO,
                    overall_fee: $facb0cbc5626d02c$var$ZERO
                };
                break;
        }
        return feeEstimate.suggestedMaxFee;
    }
    /**
   * will be renamed to buildDeclareContractTransaction
   */ async buildDeclarePayload(payload, { nonce: nonce, chainId: chainId, version: version, walletAddress: walletAddress, maxFee: maxFee }) {
        const { classHash: classHash, contract: contract, compiledClassHash: compiledClassHash } = $facb0cbc5626d02c$export$dae6fc4ab9af26b8(payload);
        const compressedCompiledContract = $facb0cbc5626d02c$var$parseContract(contract);
        const signature = await this.signer.signDeclareTransaction({
            classHash: classHash,
            compiledClassHash: compiledClassHash,
            senderAddress: walletAddress,
            chainId: chainId,
            maxFee: maxFee,
            version: version,
            nonce: nonce
        });
        return {
            senderAddress: walletAddress,
            signature: signature,
            contract: compressedCompiledContract,
            compiledClassHash: compiledClassHash
        };
    }
    async buildAccountDeployPayload({ classHash: classHash, addressSalt: addressSalt = 0, constructorCalldata: constructorCalldata = [], contractAddress: providedContractAddress }, { nonce: nonce, chainId: chainId, version: version, maxFee: maxFee }) {
        const compiledCalldata = $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile(constructorCalldata);
        const contractAddress = providedContractAddress !== null && providedContractAddress !== void 0 ? providedContractAddress : $facb0cbc5626d02c$var$calculateContractAddressFromHash(addressSalt, classHash, compiledCalldata, 0);
        const signature = await this.signer.signDeployAccountTransaction({
            classHash: classHash,
            contractAddress: contractAddress,
            chainId: chainId,
            maxFee: maxFee,
            version: version,
            nonce: nonce,
            addressSalt: addressSalt,
            constructorCalldata: compiledCalldata
        });
        return {
            classHash: classHash,
            addressSalt: addressSalt,
            constructorCalldata: compiledCalldata,
            signature: signature
        };
    }
    buildUDCContractPayload(payload) {
        const calls = [].concat(payload).map((it)=>{
            const { classHash: classHash, salt: salt = "0", unique: unique = true, constructorCalldata: constructorCalldata = [] } = it;
            const compiledConstructorCallData = $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.compile(constructorCalldata);
            return {
                contractAddress: $facb0cbc5626d02c$var$UDC.ADDRESS,
                entrypoint: $facb0cbc5626d02c$var$UDC.ENTRYPOINT,
                calldata: [
                    classHash,
                    salt,
                    $facb0cbc5626d02c$var$toCairoBool(unique),
                    compiledConstructorCallData.length,
                    ...compiledConstructorCallData
                ]
            };
        });
        return calls;
    }
    async simulateTransaction(invocations, { nonce: nonce, blockIdentifier: blockIdentifier, skipValidate: skipValidate, skipExecute: skipExecute } = {}) {
        const accountInvocations = await this.accountInvocationsFactory(invocations, {
            versions: [
                $facb0cbc5626d02c$var$transactionVersion,
                $facb0cbc5626d02c$var$transactionVersion_2
            ],
            nonce: nonce,
            blockIdentifier: blockIdentifier
        });
        return super.getSimulateTransaction(accountInvocations, {
            blockIdentifier: blockIdentifier,
            skipValidate: skipValidate,
            skipExecute: skipExecute
        });
    }
    async accountInvocationsFactory(invocations, { versions: versions, nonce: nonce, blockIdentifier: blockIdentifier }) {
        const version = versions[0];
        const safeNonce = await this.getNonceSafe(nonce);
        const chainId = await this.getChainId();
        const tx0Payload = "payload" in invocations[0] ? invocations[0].payload : invocations[0];
        const cairoVersion = invocations[0].type === "DEPLOY_ACCOUNT" /* DEPLOY_ACCOUNT */  ? await this.getCairoVersion(tx0Payload.classHash) : await this.getCairoVersion();
        return Promise.all([].concat(invocations).map(async (transaction, index)=>{
            const txPayload = "payload" in transaction ? transaction.payload : transaction;
            const signerDetails = {
                walletAddress: this.address,
                nonce: $facb0cbc5626d02c$var$toBigInt(Number(safeNonce) + index),
                maxFee: $facb0cbc5626d02c$var$ZERO,
                version: version,
                chainId: chainId,
                cairoVersion: cairoVersion
            };
            const common = {
                type: transaction.type,
                version: version,
                nonce: $facb0cbc5626d02c$var$toBigInt(Number(safeNonce) + index),
                blockIdentifier: blockIdentifier
            };
            if (transaction.type === "INVOKE_FUNCTION" /* INVOKE */ ) {
                const payload = await this.buildInvocation([].concat(txPayload), signerDetails);
                return {
                    ...common,
                    ...payload
                };
            }
            if (transaction.type === "DECLARE" /* DECLARE */ ) {
                signerDetails.version = !$facb0cbc5626d02c$export$6050805ab301367e(txPayload.contract) ? $facb0cbc5626d02c$var$toBigInt(versions[0]) : $facb0cbc5626d02c$var$toBigInt(versions[1]);
                const payload = await this.buildDeclarePayload(txPayload, signerDetails);
                return {
                    ...common,
                    ...payload,
                    version: signerDetails.version
                };
            }
            if (transaction.type === "DEPLOY_ACCOUNT" /* DEPLOY_ACCOUNT */ ) {
                const payload = await this.buildAccountDeployPayload(txPayload, signerDetails);
                return {
                    ...common,
                    ...payload
                };
            }
            if (transaction.type === "DEPLOY" /* DEPLOY */ ) {
                const calls = this.buildUDCContractPayload(txPayload);
                const payload = await this.buildInvocation(calls, signerDetails);
                return {
                    ...common,
                    ...payload,
                    type: "INVOKE_FUNCTION" /* INVOKE */ 
                };
            }
            throw Error(`accountInvocationsFactory: unsupported transaction type: ${transaction}`);
        }));
    }
    async getStarkName(address = this.address, StarknetIdContract2) {
        return super.getStarkName(address, StarknetIdContract2);
    }
    constructor(providerOrOptions, address, pkOrSigner, cairoVersion){
        super(providerOrOptions);
        (0, $dxWQo._)(this, "signer", void 0);
        (0, $dxWQo._)(this, "address", void 0);
        (0, $dxWQo._)(this, "cairoVersion", void 0);
        (0, $dxWQo._)(this, "deploySelf", this.deployAccount);
        this.address = address.toLowerCase();
        this.signer = typeof pkOrSigner === "string" || pkOrSigner instanceof Uint8Array ? new $facb0cbc5626d02c$export$fdf54fdde81cc9f0(pkOrSigner) : pkOrSigner;
        if (cairoVersion) this.cairoVersion = cairoVersion.toString();
    }
};
// src/provider/interface.ts
var $facb0cbc5626d02c$export$8efff2d796cdea69 = class {
};
// src/provider/index.ts
var $facb0cbc5626d02c$export$dc63293f8fab0911 = new $facb0cbc5626d02c$export$2881499e37b75b9a({
    rpc: {
        default: true
    }
});
// src/account/interface.ts
var $facb0cbc5626d02c$export$73debe15cf2a7ba5 = class extends $facb0cbc5626d02c$export$8efff2d796cdea69 {
};
// src/utils/events/index.ts
var $facb0cbc5626d02c$export$4bf9923669ad6c63 = {};
$facb0cbc5626d02c$var$__export($facb0cbc5626d02c$export$4bf9923669ad6c63, {
    getAbiEvents: ()=>$facb0cbc5626d02c$var$getAbiEvents,
    parseEvents: ()=>$facb0cbc5626d02c$var$parseEvents
});
function $facb0cbc5626d02c$var$getAbiEvents(abi) {
    return abi.filter((abiEntry)=>abiEntry.type === "event" && (abiEntry.size || abiEntry.kind !== "enum")).reduce((acc, abiEntry)=>{
        const entryName = abiEntry.name.slice(abiEntry.name.lastIndexOf(":") + 1);
        const abiEntryMod = {
            ...abiEntry
        };
        abiEntryMod.name = entryName;
        return {
            ...acc,
            [$facb0cbc5626d02c$var$addHexPrefix($5GNKL.keccak($facb0cbc5626d02c$var$utf8ToArray(entryName)).toString(16))]: abiEntryMod
        };
    }, {});
}
function $facb0cbc5626d02c$var$parseEvents(providerReceivedEvents, abiEvents, abiStructs, abiEnums) {
    const ret = providerReceivedEvents.flat().reduce((acc, recEvent)=>{
        var _abiEvent_members, _abiEvent_members1;
        const abiEvent = abiEvents[recEvent.keys[0]];
        if (!abiEvent) return acc;
        const parsedEvent = {};
        parsedEvent[abiEvent.name] = {};
        recEvent.keys.shift();
        const keysIter = recEvent.keys[Symbol.iterator]();
        const dataIter = recEvent.data[Symbol.iterator]();
        const abiEventKeys = ((_abiEvent_members = abiEvent.members) === null || _abiEvent_members === void 0 ? void 0 : _abiEvent_members.filter((it)=>it.kind === "key")) || abiEvent.keys;
        const abiEventData = ((_abiEvent_members1 = abiEvent.members) === null || _abiEvent_members1 === void 0 ? void 0 : _abiEvent_members1.filter((it)=>it.kind === "data")) || abiEvent.data;
        abiEventKeys.forEach((key)=>{
            parsedEvent[abiEvent.name][key.name] = $facb0cbc5626d02c$var$responseParser(keysIter, key, abiStructs, abiEnums, parsedEvent[abiEvent.name]);
        });
        abiEventData.forEach((data)=>{
            parsedEvent[abiEvent.name][data.name] = $facb0cbc5626d02c$var$responseParser(dataIter, data, abiStructs, abiEnums, parsedEvent[abiEvent.name]);
        });
        acc.push(parsedEvent);
        return acc;
    }, []);
    return ret;
}
// src/contract/default.ts
var $facb0cbc5626d02c$export$b1054f420eacbc82 = (args)=>{
    const options = [
        "blockIdentifier",
        "parseRequest",
        "parseResponse",
        "formatResponse",
        "maxFee",
        "nonce",
        "signature",
        "addressSalt"
    ];
    const lastArg = args[args.length - 1];
    if (typeof lastArg === "object" && options.some((x)=>x in lastArg)) return {
        args: args,
        options: args.pop()
    };
    return {
        args: args
    };
};
function $facb0cbc5626d02c$var$buildCall(contract, functionAbi) {
    return async function(...args) {
        const params = $facb0cbc5626d02c$export$b1054f420eacbc82(args);
        return contract.call(functionAbi.name, params.args, {
            parseRequest: true,
            parseResponse: true,
            ...params.options
        });
    };
}
function $facb0cbc5626d02c$var$buildInvoke(contract, functionAbi) {
    return async function(...args) {
        const params = $facb0cbc5626d02c$export$b1054f420eacbc82(args);
        return contract.invoke(functionAbi.name, params.args, {
            parseRequest: true,
            ...params.options
        });
    };
}
function $facb0cbc5626d02c$var$buildDefault(contract, functionAbi) {
    if (functionAbi.stateMutability === "view" || functionAbi.state_mutability === "view") return $facb0cbc5626d02c$var$buildCall(contract, functionAbi);
    return $facb0cbc5626d02c$var$buildInvoke(contract, functionAbi);
}
function $facb0cbc5626d02c$var$buildPopulate(contract, functionAbi) {
    return function(...args) {
        return contract.populate(functionAbi.name, args);
    };
}
function $facb0cbc5626d02c$var$buildEstimate(contract, functionAbi) {
    return function(...args) {
        return contract.estimate(functionAbi.name, args);
    };
}
function $facb0cbc5626d02c$export$6129b52a695a0660(args, callback) {
    if (Array.isArray(args) && "__compiled__" in args) return args;
    if (Array.isArray(args) && Array.isArray(args[0]) && "__compiled__" in args[0]) return args[0];
    return callback();
}
var $facb0cbc5626d02c$export$8517d80acf00e19a = class {
    attach(address) {
        this.address = address;
    }
    connect(providerOrAccount) {
        this.providerOrAccount = providerOrAccount;
    }
    async deployed() {
        if (this.deployTransactionHash) {
            await this.providerOrAccount.waitForTransaction(this.deployTransactionHash);
            this.deployTransactionHash = void 0;
        }
        return this;
    }
    async call(method, args = [], { parseRequest: parseRequest = true, parseResponse: parseResponse = true, formatResponse: formatResponse, blockIdentifier: blockIdentifier } = {}) {
        $facb0cbc5626d02c$var$assert(this.address !== null, "contract is not connected to an address");
        const calldata = $facb0cbc5626d02c$export$6129b52a695a0660(args, ()=>{
            if (parseRequest) {
                this.callData.validate("CALL" /* CALL */ , method, args);
                return this.callData.compile(method, args);
            }
            console.warn("Call skipped parsing but provided rawArgs, possible malfunction request");
            return args;
        });
        return this.providerOrAccount.callContract({
            contractAddress: this.address,
            calldata: calldata,
            entrypoint: method
        }, blockIdentifier).then((x)=>{
            if (!parseResponse) return x.result;
            if (formatResponse) return this.callData.format(method, x.result, formatResponse);
            return this.callData.parse(method, x.result);
        });
    }
    invoke(method, args = [], { parseRequest: parseRequest = true, maxFee: maxFee, nonce: nonce, signature: signature } = {}) {
        $facb0cbc5626d02c$var$assert(this.address !== null, "contract is not connected to an address");
        const calldata = $facb0cbc5626d02c$export$6129b52a695a0660(args, ()=>{
            if (parseRequest) {
                this.callData.validate("INVOKE" /* INVOKE */ , method, args);
                return this.callData.compile(method, args);
            }
            console.warn("Invoke skipped parsing but provided rawArgs, possible malfunction request");
            return args;
        });
        const invocation = {
            contractAddress: this.address,
            calldata: calldata,
            entrypoint: method
        };
        if ("execute" in this.providerOrAccount) return this.providerOrAccount.execute(invocation, void 0, {
            maxFee: maxFee,
            nonce: nonce
        });
        if (!nonce) throw new Error(`Nonce is required when invoking a function without an account`);
        console.warn(`Invoking ${method} without an account. This will not work on a public node.`);
        return this.providerOrAccount.invokeFunction({
            ...invocation,
            signature: signature
        }, {
            nonce: nonce
        });
    }
    async estimate(method, args = []) {
        $facb0cbc5626d02c$var$assert(this.address !== null, "contract is not connected to an address");
        if (!$facb0cbc5626d02c$export$6129b52a695a0660(args, ()=>false)) this.callData.validate("INVOKE" /* INVOKE */ , method, args);
        const invocation = this.populate(method, args);
        if ("estimateInvokeFee" in this.providerOrAccount) return this.providerOrAccount.estimateInvokeFee(invocation);
        throw Error("Contract must be connected to the account contract to estimate");
    }
    populate(method, args = []) {
        const calldata = $facb0cbc5626d02c$export$6129b52a695a0660(args, ()=>this.callData.compile(method, args));
        return {
            contractAddress: this.address,
            entrypoint: method,
            calldata: calldata
        };
    }
    parseEvents(receipt) {
        var _receipt_events;
        return $facb0cbc5626d02c$var$parseEvents(((_receipt_events = receipt.events) === null || _receipt_events === void 0 ? void 0 : _receipt_events.filter((event)=>$facb0cbc5626d02c$var$cleanHex(event.from_address) === $facb0cbc5626d02c$var$cleanHex(this.address), [])) || [], this.events, this.structs, $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.getAbiEnum(this.abi));
    }
    isCairo1() {
        return $facb0cbc5626d02c$export$3973b1d14008fbc3.isCairo1Abi(this.abi);
    }
    async getVersion() {
        return this.providerOrAccount.getContractVersion(this.address);
    }
    typedv1(tAbi) {
        return this;
    }
    typedv2(tAbi) {
        return this;
    }
    /**
   * Contract class to handle contract methods
   *
   * @param abi - Abi of the contract object
   * @param address (optional) - address to connect to
   * @param providerOrAccount (optional) - Provider or Account to attach to
   */ constructor(abi, address, providerOrAccount = $facb0cbc5626d02c$export$dc63293f8fab0911){
        (0, $dxWQo._)(this, "abi", void 0);
        (0, $dxWQo._)(this, "address", void 0);
        (0, $dxWQo._)(this, "providerOrAccount", void 0);
        (0, $dxWQo._)(this, "deployTransactionHash", void 0);
        (0, $dxWQo._)(this, "structs", void 0);
        (0, $dxWQo._)(this, "events", void 0);
        (0, $dxWQo._)(this, "functions", void 0);
        (0, $dxWQo._)(this, "callStatic", void 0);
        (0, $dxWQo._)(this, "populateTransaction", void 0);
        (0, $dxWQo._)(this, "estimateFee", void 0);
        (0, $dxWQo._)(this, "callData", void 0);
        this.address = address && address.toLowerCase();
        this.providerOrAccount = providerOrAccount;
        this.callData = new $facb0cbc5626d02c$export$ac0e6ca389c6ad0e(abi);
        this.structs = $facb0cbc5626d02c$export$ac0e6ca389c6ad0e.getAbiStruct(abi);
        this.events = $facb0cbc5626d02c$var$getAbiEvents(abi);
        const parser = $facb0cbc5626d02c$var$createAbiParser(abi);
        this.abi = parser.getLegacyFormat();
        const options = {
            enumerable: true,
            value: {},
            writable: false
        };
        Object.defineProperties(this, {
            functions: {
                enumerable: true,
                value: {},
                writable: false
            },
            callStatic: {
                enumerable: true,
                value: {},
                writable: false
            },
            populateTransaction: {
                enumerable: true,
                value: {},
                writable: false
            },
            estimateFee: {
                enumerable: true,
                value: {},
                writable: false
            }
        });
        this.abi.forEach((abiElement)=>{
            if (abiElement.type !== "function") return;
            const signature = abiElement.name;
            if (!this[signature]) Object.defineProperty(this, signature, {
                ...options,
                value: $facb0cbc5626d02c$var$buildDefault(this, abiElement)
            });
            if (!this.functions[signature]) Object.defineProperty(this.functions, signature, {
                ...options,
                value: $facb0cbc5626d02c$var$buildDefault(this, abiElement)
            });
            if (!this.callStatic[signature]) Object.defineProperty(this.callStatic, signature, {
                ...options,
                value: $facb0cbc5626d02c$var$buildCall(this, abiElement)
            });
            if (!this.populateTransaction[signature]) Object.defineProperty(this.populateTransaction, signature, {
                ...options,
                value: $facb0cbc5626d02c$var$buildPopulate(this, abiElement)
            });
            if (!this.estimateFee[signature]) Object.defineProperty(this.estimateFee, signature, {
                ...options,
                value: $facb0cbc5626d02c$var$buildEstimate(this, abiElement)
            });
        });
    }
};
// src/contract/interface.ts
var $facb0cbc5626d02c$export$c16ebf97b4a8324a = class {
    constructor(){
        (0, $dxWQo._)(this, "functions", void 0);
        (0, $dxWQo._)(this, "callStatic", void 0);
        (0, $dxWQo._)(this, "populateTransaction", void 0);
        (0, $dxWQo._)(this, "estimateFee", void 0);
    }
};
// src/contract/contractFactory.ts
var $facb0cbc5626d02c$export$505569a6bf584fd9 = class {
    /**
   * Deploys contract and returns new instance of the Contract
   *
   * If contract is not declared it will first declare it, and then deploy
   */ async deploy(...args) {
        const { args: param, options: options = {
            parseRequest: true
        } } = $facb0cbc5626d02c$export$b1054f420eacbc82(args);
        const constructorCalldata = $facb0cbc5626d02c$export$6129b52a695a0660(param, ()=>{
            if (options.parseRequest) {
                this.CallData.validate("DEPLOY" /* DEPLOY */ , "constructor", param);
                return this.CallData.compile("constructor", param);
            }
            console.warn("Call skipped parsing but provided rawArgs, possible malfunction request");
            return param;
        });
        const { deploy: { contract_address: contract_address, transaction_hash: transaction_hash } } = await this.account.declareAndDeploy({
            contract: this.compiledContract,
            casm: this.casm,
            classHash: this.classHash,
            compiledClassHash: this.compiledClassHash,
            constructorCalldata: constructorCalldata,
            salt: options.addressSalt
        });
        $facb0cbc5626d02c$var$assert(Boolean(contract_address), "Deployment of the contract failed");
        const contractInstance = new $facb0cbc5626d02c$export$8517d80acf00e19a(this.compiledContract.abi, contract_address, this.account);
        contractInstance.deployTransactionHash = transaction_hash;
        return contractInstance;
    }
    /**
   * Attaches to new Account
   *
   * @param account - new Account to attach to
   */ connect(account) {
        this.account = account;
        return this;
    }
    /**
   * Attaches current abi and account to the new address
   */ attach(address) {
        return new $facb0cbc5626d02c$export$8517d80acf00e19a(this.abi, address, this.account);
    }
    /**
   * @param params CFParams
   *  - compiledContract: CompiledContract;
   *  - account: AccountInterface;
   *  - casm?: CairoAssembly;
   *  - classHash?: string;
   *  - compiledClassHash?: string;
   *  - abi?: Abi;
   */ constructor(params){
        (0, $dxWQo._)(this, "compiledContract", void 0);
        (0, $dxWQo._)(this, "account", void 0);
        (0, $dxWQo._)(this, "abi", void 0);
        (0, $dxWQo._)(this, "classHash", void 0);
        (0, $dxWQo._)(this, "casm", void 0);
        (0, $dxWQo._)(this, "compiledClassHash", void 0);
        (0, $dxWQo._)(this, "CallData", void 0);
        this.compiledContract = params.compiledContract;
        this.account = params.account;
        this.casm = params.casm;
        var _params_abi;
        this.abi = (_params_abi = params.abi) !== null && _params_abi !== void 0 ? _params_abi : params.compiledContract.abi;
        this.classHash = params.classHash;
        this.compiledClassHash = params.compiledClassHash;
        this.CallData = new $facb0cbc5626d02c$export$ac0e6ca389c6ad0e(this.abi);
    }
};
function $facb0cbc5626d02c$export$74cf7857f9f0313c(address) {
    return $facb0cbc5626d02c$var$addHexPrefix($facb0cbc5626d02c$var$removeHexPrefix($facb0cbc5626d02c$var$toHex(address)).padStart(64, "0"));
}
function $facb0cbc5626d02c$export$5049782b602a3e5d(address) {
    $facb0cbc5626d02c$var$assertInRange(address, $facb0cbc5626d02c$var$ZERO, $facb0cbc5626d02c$var$ADDR_BOUND - 1n, "Starknet Address");
    const result = $facb0cbc5626d02c$export$74cf7857f9f0313c(address);
    if (!result.match(/^(0x)?[0-9a-fA-F]{64}$/)) throw new Error("Invalid Address Format");
    return result;
}
function $facb0cbc5626d02c$export$c696806606bb1429(address) {
    const chars = $facb0cbc5626d02c$var$removeHexPrefix($facb0cbc5626d02c$export$5049782b602a3e5d(address)).toLowerCase().split("");
    const hex = $facb0cbc5626d02c$var$removeHexPrefix($facb0cbc5626d02c$var$keccakBn(address));
    const hashed = (0, $85BMf.hexToBytes)(hex.padStart(64, "0"));
    for(let i = 0; i < chars.length; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 15) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return $facb0cbc5626d02c$var$addHexPrefix(chars.join(""));
}
function $facb0cbc5626d02c$export$26bc63e5b5463ece(address) {
    return $facb0cbc5626d02c$export$c696806606bb1429(address) === address;
}
// src/index.ts
var $facb0cbc5626d02c$export$98e628dec113755e = $facb0cbc5626d02c$export$61cc6a0be4938a2a;

});
parcelRegister("dGHtD", function(module, exports) {

$parcel$export(module.exports, "base64", function () { return $9f70ec386af813db$export$b3b2de96497acc47; });
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities
/**
 * @__NO_SIDE_EFFECTS__
 */ function $9f70ec386af813db$export$dfbcecb440255e4a(n) {
    if (!Number.isSafeInteger(n)) throw new Error(`Wrong integer: ${n}`);
}
function $9f70ec386af813db$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $9f70ec386af813db$var$chain(...args) {
    const id = (a)=>a;
    // Wrap call in closure so JIT can inline calls
    const wrap = (a, b)=>(c)=>a(b(c));
    // Construct chain of args[-1].encode(args[-2].encode([...]))
    const encode = args.map((x)=>x.encode).reduceRight(wrap, id);
    // Construct chain of args[0].decode(args[1].decode(...))
    const decode = args.map((x)=>x.decode).reduce(wrap, id);
    return {
        encode: encode,
        decode: decode
    };
}
/**
 * Encodes integer radix representation to array of strings using alphabet and back
 * @__NO_SIDE_EFFECTS__
 */ function $9f70ec386af813db$var$alphabet(alphabet) {
    return {
        encode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("alphabet.encode input should be an array of numbers");
            return digits.map((i)=>{
                $9f70ec386af813db$export$dfbcecb440255e4a(i);
                if (i < 0 || i >= alphabet.length) throw new Error(`Digit index outside alphabet: ${i} (alphabet: ${alphabet.length})`);
                return alphabet[i];
            });
        },
        decode: (input)=>{
            if (!Array.isArray(input) || input.length && typeof input[0] !== "string") throw new Error("alphabet.decode input should be array of strings");
            return input.map((letter)=>{
                if (typeof letter !== "string") throw new Error(`alphabet.decode: not string element=${letter}`);
                const index = alphabet.indexOf(letter);
                if (index === -1) throw new Error(`Unknown letter: "${letter}". Allowed: ${alphabet}`);
                return index;
            });
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $9f70ec386af813db$var$join(separator = "") {
    if (typeof separator !== "string") throw new Error("join separator should be string");
    return {
        encode: (from)=>{
            if (!Array.isArray(from) || from.length && typeof from[0] !== "string") throw new Error("join.encode input should be array of strings");
            for (let i of from)if (typeof i !== "string") throw new Error(`join.encode: non-string input=${i}`);
            return from.join(separator);
        },
        decode: (to)=>{
            if (typeof to !== "string") throw new Error("join.decode input should be string");
            return to.split(separator);
        }
    };
}
/**
 * Pad strings array so it has integer number of bits
 * @__NO_SIDE_EFFECTS__
 */ function $9f70ec386af813db$var$padding(bits, chr = "=") {
    $9f70ec386af813db$export$dfbcecb440255e4a(bits);
    if (typeof chr !== "string") throw new Error("padding chr should be string");
    return {
        encode (data) {
            if (!Array.isArray(data) || data.length && typeof data[0] !== "string") throw new Error("padding.encode input should be array of strings");
            for (let i of data)if (typeof i !== "string") throw new Error(`padding.encode: non-string input=${i}`);
            while(data.length * bits % 8)data.push(chr);
            return data;
        },
        decode (input) {
            if (!Array.isArray(input) || input.length && typeof input[0] !== "string") throw new Error("padding.encode input should be array of strings");
            for (let i of input)if (typeof i !== "string") throw new Error(`padding.decode: non-string input=${i}`);
            let end = input.length;
            if (end * bits % 8) throw new Error("Invalid padding: string should have whole number of bytes");
            for(; end > 0 && input[end - 1] === chr; end--){
                if (!((end - 1) * bits % 8)) throw new Error("Invalid padding: string has too much padding");
            }
            return input.slice(0, end);
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $9f70ec386af813db$var$normalize(fn) {
    if (typeof fn !== "function") throw new Error("normalize fn should be function");
    return {
        encode: (from)=>from,
        decode: (to)=>fn(to)
    };
}
/**
 * Slow: O(n^2) time complexity
 * @__NO_SIDE_EFFECTS__
 */ function $9f70ec386af813db$var$convertRadix(data, from, to) {
    // base 1 is impossible
    if (from < 2) throw new Error(`convertRadix: wrong from=${from}, base cannot be less than 2`);
    if (to < 2) throw new Error(`convertRadix: wrong to=${to}, base cannot be less than 2`);
    if (!Array.isArray(data)) throw new Error("convertRadix: data should be array");
    if (!data.length) return [];
    let pos = 0;
    const res = [];
    const digits = Array.from(data);
    digits.forEach((d)=>{
        $9f70ec386af813db$export$dfbcecb440255e4a(d);
        if (d < 0 || d >= from) throw new Error(`Wrong integer: ${d}`);
    });
    while(true){
        let carry = 0;
        let done = true;
        for(let i = pos; i < digits.length; i++){
            const digit = digits[i];
            const digitBase = from * carry + digit;
            if (!Number.isSafeInteger(digitBase) || from * carry / from !== carry || digitBase - digit !== from * carry) throw new Error("convertRadix: carry overflow");
            carry = digitBase % to;
            const rounded = Math.floor(digitBase / to);
            digits[i] = rounded;
            if (!Number.isSafeInteger(rounded) || rounded * to + carry !== digitBase) throw new Error("convertRadix: carry overflow");
            if (!done) continue;
            else if (!rounded) pos = i;
            else done = false;
        }
        res.push(carry);
        if (done) break;
    }
    for(let i = 0; i < data.length - 1 && data[i] === 0; i++)res.push(0);
    return res.reverse();
}
const $9f70ec386af813db$var$gcd = /* @__NO_SIDE_EFFECTS__ */ (a, b)=>!b ? a : $9f70ec386af813db$var$gcd(b, a % b);
const $9f70ec386af813db$var$radix2carry = /*@__NO_SIDE_EFFECTS__ */ (from, to)=>from + (to - $9f70ec386af813db$var$gcd(from, to));
/**
 * Implemented with numbers, because BigInt is 5x slower
 * @__NO_SIDE_EFFECTS__
 */ function $9f70ec386af813db$var$convertRadix2(data, from, to, padding) {
    if (!Array.isArray(data)) throw new Error("convertRadix2: data should be array");
    if (from <= 0 || from > 32) throw new Error(`convertRadix2: wrong from=${from}`);
    if (to <= 0 || to > 32) throw new Error(`convertRadix2: wrong to=${to}`);
    if ($9f70ec386af813db$var$radix2carry(from, to) > 32) throw new Error(`convertRadix2: carry overflow from=${from} to=${to} carryBits=${$9f70ec386af813db$var$radix2carry(from, to)}`);
    let carry = 0;
    let pos = 0; // bitwise position in current element
    const mask = 2 ** to - 1;
    const res = [];
    for (const n of data){
        $9f70ec386af813db$export$dfbcecb440255e4a(n);
        if (n >= 2 ** from) throw new Error(`convertRadix2: invalid data word=${n} from=${from}`);
        carry = carry << from | n;
        if (pos + from > 32) throw new Error(`convertRadix2: carry overflow pos=${pos} from=${from}`);
        pos += from;
        for(; pos >= to; pos -= to)res.push((carry >> pos - to & mask) >>> 0);
        carry &= 2 ** pos - 1; // clean carry, otherwise it will cause overflow
    }
    carry = carry << to - pos & mask;
    if (!padding && pos >= from) throw new Error("Excess padding");
    if (!padding && carry) throw new Error(`Non-zero padding: ${carry}`);
    if (padding && pos > 0) res.push(carry >>> 0);
    return res;
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $9f70ec386af813db$var$radix(num) {
    $9f70ec386af813db$export$dfbcecb440255e4a(num);
    return {
        encode: (bytes)=>{
            if (!$9f70ec386af813db$var$isBytes(bytes)) throw new Error("radix.encode input should be Uint8Array");
            return $9f70ec386af813db$var$convertRadix(Array.from(bytes), 256, num);
        },
        decode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("radix.decode input should be array of numbers");
            return Uint8Array.from($9f70ec386af813db$var$convertRadix(digits, num, 256));
        }
    };
}
/**
 * If both bases are power of same number (like `2**8 <-> 2**64`),
 * there is a linear algorithm. For now we have implementation for power-of-two bases only.
 * @__NO_SIDE_EFFECTS__
 */ function $9f70ec386af813db$var$radix2(bits, revPadding = false) {
    $9f70ec386af813db$export$dfbcecb440255e4a(bits);
    if (bits <= 0 || bits > 32) throw new Error("radix2: bits should be in (0..32]");
    if ($9f70ec386af813db$var$radix2carry(8, bits) > 32 || $9f70ec386af813db$var$radix2carry(bits, 8) > 32) throw new Error("radix2: carry overflow");
    return {
        encode: (bytes)=>{
            if (!$9f70ec386af813db$var$isBytes(bytes)) throw new Error("radix2.encode input should be Uint8Array");
            return $9f70ec386af813db$var$convertRadix2(Array.from(bytes), 8, bits, !revPadding);
        },
        decode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("radix2.decode input should be array of numbers");
            return Uint8Array.from($9f70ec386af813db$var$convertRadix2(digits, bits, 8, revPadding));
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $9f70ec386af813db$var$unsafeWrapper(fn) {
    if (typeof fn !== "function") throw new Error("unsafeWrapper fn should be function");
    return function(...args) {
        try {
            return fn.apply(null, args);
        } catch (e) {}
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $9f70ec386af813db$var$checksum(len, fn) {
    $9f70ec386af813db$export$dfbcecb440255e4a(len);
    if (typeof fn !== "function") throw new Error("checksum fn should be function");
    return {
        encode (data) {
            if (!$9f70ec386af813db$var$isBytes(data)) throw new Error("checksum.encode: input should be Uint8Array");
            const checksum = fn(data).slice(0, len);
            const res = new Uint8Array(data.length + len);
            res.set(data);
            res.set(checksum, data.length);
            return res;
        },
        decode (data) {
            if (!$9f70ec386af813db$var$isBytes(data)) throw new Error("checksum.decode: input should be Uint8Array");
            const payload = data.slice(0, -len);
            const newChecksum = fn(payload).slice(0, len);
            const oldChecksum = data.slice(-len);
            for(let i = 0; i < len; i++)if (newChecksum[i] !== oldChecksum[i]) throw new Error("Invalid checksum");
            return payload;
        }
    };
}
const $9f70ec386af813db$export$eab97d15b1788b8d = {
    alphabet: $9f70ec386af813db$var$alphabet,
    chain: $9f70ec386af813db$var$chain,
    checksum: $9f70ec386af813db$var$checksum,
    convertRadix: $9f70ec386af813db$var$convertRadix,
    convertRadix2: $9f70ec386af813db$var$convertRadix2,
    radix: $9f70ec386af813db$var$radix,
    radix2: $9f70ec386af813db$var$radix2,
    join: $9f70ec386af813db$var$join,
    padding: $9f70ec386af813db$var$padding
};
const $9f70ec386af813db$export$586f61c71cb02fe4 = /* @__PURE__ */ $9f70ec386af813db$var$chain($9f70ec386af813db$var$radix2(4), $9f70ec386af813db$var$alphabet("0123456789ABCDEF"), $9f70ec386af813db$var$join(""));
const $9f70ec386af813db$export$4a4d5965e2738b2a = /* @__PURE__ */ $9f70ec386af813db$var$chain($9f70ec386af813db$var$radix2(5), $9f70ec386af813db$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), $9f70ec386af813db$var$padding(5), $9f70ec386af813db$var$join(""));
const $9f70ec386af813db$export$c57d6760d519c8ac = /* @__PURE__ */ $9f70ec386af813db$var$chain($9f70ec386af813db$var$radix2(5), $9f70ec386af813db$var$alphabet("0123456789ABCDEFGHIJKLMNOPQRSTUV"), $9f70ec386af813db$var$padding(5), $9f70ec386af813db$var$join(""));
const $9f70ec386af813db$export$5fbcb08925249358 = /* @__PURE__ */ $9f70ec386af813db$var$chain($9f70ec386af813db$var$radix2(5), $9f70ec386af813db$var$alphabet("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), $9f70ec386af813db$var$join(""), $9f70ec386af813db$var$normalize((s)=>s.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1")));
const $9f70ec386af813db$export$b3b2de96497acc47 = /* @__PURE__ */ $9f70ec386af813db$var$chain($9f70ec386af813db$var$radix2(6), $9f70ec386af813db$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), $9f70ec386af813db$var$padding(6), $9f70ec386af813db$var$join(""));
const $9f70ec386af813db$export$c907e660b9401ec7 = /* @__PURE__ */ $9f70ec386af813db$var$chain($9f70ec386af813db$var$radix2(6), $9f70ec386af813db$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), $9f70ec386af813db$var$join(""));
const $9f70ec386af813db$export$7d21597c7bc64465 = /* @__PURE__ */ $9f70ec386af813db$var$chain($9f70ec386af813db$var$radix2(6), $9f70ec386af813db$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), $9f70ec386af813db$var$padding(6), $9f70ec386af813db$var$join(""));
const $9f70ec386af813db$export$963cd24a38dd2f90 = /* @__PURE__ */ $9f70ec386af813db$var$chain($9f70ec386af813db$var$radix2(6), $9f70ec386af813db$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), $9f70ec386af813db$var$join(""));
// base58 code
// -----------
const $9f70ec386af813db$var$genBase58 = (abc)=>$9f70ec386af813db$var$chain($9f70ec386af813db$var$radix(58), $9f70ec386af813db$var$alphabet(abc), $9f70ec386af813db$var$join(""));
const $9f70ec386af813db$export$61f53211c069eefb = /* @__PURE__ */ $9f70ec386af813db$var$genBase58("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
const $9f70ec386af813db$export$c6a7baed2941aad2 = /* @__PURE__ */ $9f70ec386af813db$var$genBase58("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ");
const $9f70ec386af813db$export$cbd4c72942a9201d = /* @__PURE__ */ $9f70ec386af813db$var$genBase58("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
// xmr ver is done in 8-byte blocks (which equals 11 chars in decoding). Last (non-full) block padded with '1' to size in XMR_BLOCK_LEN.
// Block encoding significantly reduces quadratic complexity of base58.
// Data len (index) -> encoded block len
const $9f70ec386af813db$var$XMR_BLOCK_LEN = [
    0,
    2,
    3,
    5,
    6,
    7,
    9,
    10,
    11
];
const $9f70ec386af813db$export$e86cd8e7f8cff4a6 = {
    encode (data) {
        let res = "";
        for(let i = 0; i < data.length; i += 8){
            const block = data.subarray(i, i + 8);
            res += $9f70ec386af813db$export$61f53211c069eefb.encode(block).padStart($9f70ec386af813db$var$XMR_BLOCK_LEN[block.length], "1");
        }
        return res;
    },
    decode (str) {
        let res = [];
        for(let i = 0; i < str.length; i += 11){
            const slice = str.slice(i, i + 11);
            const blockLen = $9f70ec386af813db$var$XMR_BLOCK_LEN.indexOf(slice.length);
            const block = $9f70ec386af813db$export$61f53211c069eefb.decode(slice);
            for(let j = 0; j < block.length - blockLen; j++){
                if (block[j] !== 0) throw new Error("base58xmr: wrong padding");
            }
            res = res.concat(Array.from(block.slice(block.length - blockLen)));
        }
        return Uint8Array.from(res);
    }
};
const $9f70ec386af813db$export$2217e0412f7b06b6 = /* @__PURE__ */ (sha256)=>$9f70ec386af813db$var$chain($9f70ec386af813db$var$checksum(4, (data)=>sha256(sha256(data))), $9f70ec386af813db$export$61f53211c069eefb);
const $9f70ec386af813db$export$fff625c574161df6 = $9f70ec386af813db$export$2217e0412f7b06b6;
const $9f70ec386af813db$var$BECH_ALPHABET = /* @__PURE__ */ $9f70ec386af813db$var$chain($9f70ec386af813db$var$alphabet("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), $9f70ec386af813db$var$join(""));
const $9f70ec386af813db$var$POLYMOD_GENERATORS = [
    0x3b6a57b2,
    0x26508e6d,
    0x1ea119fa,
    0x3d4233dd,
    0x2a1462b3
];
/**
 * @__NO_SIDE_EFFECTS__
 */ function $9f70ec386af813db$var$bech32Polymod(pre) {
    const b = pre >> 25;
    let chk = (pre & 0x1ffffff) << 5;
    for(let i = 0; i < $9f70ec386af813db$var$POLYMOD_GENERATORS.length; i++)if ((b >> i & 1) === 1) chk ^= $9f70ec386af813db$var$POLYMOD_GENERATORS[i];
    return chk;
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $9f70ec386af813db$var$bechChecksum(prefix, words, encodingConst = 1) {
    const len = prefix.length;
    let chk = 1;
    for(let i = 0; i < len; i++){
        const c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) throw new Error(`Invalid prefix (${prefix})`);
        chk = $9f70ec386af813db$var$bech32Polymod(chk) ^ c >> 5;
    }
    chk = $9f70ec386af813db$var$bech32Polymod(chk);
    for(let i = 0; i < len; i++)chk = $9f70ec386af813db$var$bech32Polymod(chk) ^ prefix.charCodeAt(i) & 0x1f;
    for (let v of words)chk = $9f70ec386af813db$var$bech32Polymod(chk) ^ v;
    for(let i = 0; i < 6; i++)chk = $9f70ec386af813db$var$bech32Polymod(chk);
    chk ^= encodingConst;
    return $9f70ec386af813db$var$BECH_ALPHABET.encode($9f70ec386af813db$var$convertRadix2([
        chk % 2 ** 30
    ], 30, 5, false));
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $9f70ec386af813db$var$genBech32(encoding) {
    const ENCODING_CONST = encoding === "bech32" ? 1 : 0x2bc830a3;
    const _words = $9f70ec386af813db$var$radix2(5);
    const fromWords = _words.decode;
    const toWords = _words.encode;
    const fromWordsUnsafe = $9f70ec386af813db$var$unsafeWrapper(fromWords);
    function encode(prefix, words, limit = 90) {
        if (typeof prefix !== "string") throw new Error(`bech32.encode prefix should be string, not ${typeof prefix}`);
        if (!Array.isArray(words) || words.length && typeof words[0] !== "number") throw new Error(`bech32.encode words should be array of numbers, not ${typeof words}`);
        if (prefix.length === 0) throw new TypeError(`Invalid prefix length ${prefix.length}`);
        const actualLength = prefix.length + 7 + words.length;
        if (limit !== false && actualLength > limit) throw new TypeError(`Length ${actualLength} exceeds limit ${limit}`);
        const lowered = prefix.toLowerCase();
        const sum = $9f70ec386af813db$var$bechChecksum(lowered, words, ENCODING_CONST);
        return `${lowered}1${$9f70ec386af813db$var$BECH_ALPHABET.encode(words)}${sum}`;
    }
    function decode(str, limit = 90) {
        if (typeof str !== "string") throw new Error(`bech32.decode input should be string, not ${typeof str}`);
        if (str.length < 8 || limit !== false && str.length > limit) throw new TypeError(`Wrong string length: ${str.length} (${str}). Expected (8..${limit})`);
        // don't allow mixed case
        const lowered = str.toLowerCase();
        if (str !== lowered && str !== str.toUpperCase()) throw new Error(`String must be lowercase or uppercase`);
        const sepIndex = lowered.lastIndexOf("1");
        if (sepIndex === 0 || sepIndex === -1) throw new Error(`Letter "1" must be present between prefix and data only`);
        const prefix = lowered.slice(0, sepIndex);
        const data = lowered.slice(sepIndex + 1);
        if (data.length < 6) throw new Error("Data must be at least 6 characters long");
        const words = $9f70ec386af813db$var$BECH_ALPHABET.decode(data).slice(0, -6);
        const sum = $9f70ec386af813db$var$bechChecksum(prefix, words, ENCODING_CONST);
        if (!data.endsWith(sum)) throw new Error(`Invalid checksum in ${str}: expected "${sum}"`);
        return {
            prefix: prefix,
            words: words
        };
    }
    const decodeUnsafe = $9f70ec386af813db$var$unsafeWrapper(decode);
    function decodeToBytes(str) {
        const { prefix: prefix, words: words } = decode(str, false);
        return {
            prefix: prefix,
            words: words,
            bytes: fromWords(words)
        };
    }
    return {
        encode: encode,
        decode: decode,
        decodeToBytes: decodeToBytes,
        decodeUnsafe: decodeUnsafe,
        fromWords: fromWords,
        fromWordsUnsafe: fromWordsUnsafe,
        toWords: toWords
    };
}
const $9f70ec386af813db$export$27c42482533637da = /* @__PURE__ */ $9f70ec386af813db$var$genBech32("bech32");
const $9f70ec386af813db$export$4963f7e473ccf819 = /* @__PURE__ */ $9f70ec386af813db$var$genBech32("bech32m");
const $9f70ec386af813db$export$74329b762b589566 = {
    encode: (data)=>new TextDecoder().decode(data),
    decode: (str)=>new TextEncoder().encode(str)
};
const $9f70ec386af813db$export$834dfc94dde4b3d8 = /* @__PURE__ */ $9f70ec386af813db$var$chain($9f70ec386af813db$var$radix2(4), $9f70ec386af813db$var$alphabet("0123456789abcdef"), $9f70ec386af813db$var$join(""), $9f70ec386af813db$var$normalize((s)=>{
    if (typeof s !== "string" || s.length % 2) throw new TypeError(`hex.decode: expected string, got ${typeof s} with length ${s.length}`);
    return s.toLowerCase();
}));
// prettier-ignore
const $9f70ec386af813db$var$CODERS = {
    utf8: $9f70ec386af813db$export$74329b762b589566,
    hex: $9f70ec386af813db$export$834dfc94dde4b3d8,
    base16: $9f70ec386af813db$export$586f61c71cb02fe4,
    base32: $9f70ec386af813db$export$4a4d5965e2738b2a,
    base64: $9f70ec386af813db$export$b3b2de96497acc47,
    base64url: $9f70ec386af813db$export$7d21597c7bc64465,
    base58: $9f70ec386af813db$export$61f53211c069eefb,
    base58xmr: $9f70ec386af813db$export$e86cd8e7f8cff4a6
};
const $9f70ec386af813db$var$coderTypeError = "Invalid encoding type. Available types: utf8, hex, base16, base32, base64, base64url, base58, base58xmr";
const $9f70ec386af813db$export$7c746b75f47c9c7d = (type, bytes)=>{
    if (typeof type !== "string" || !$9f70ec386af813db$var$CODERS.hasOwnProperty(type)) throw new TypeError($9f70ec386af813db$var$coderTypeError);
    if (!$9f70ec386af813db$var$isBytes(bytes)) throw new TypeError("bytesToString() expects Uint8Array");
    return $9f70ec386af813db$var$CODERS[type].encode(bytes);
};
const $9f70ec386af813db$export$42d51816ce590c93 = $9f70ec386af813db$export$7c746b75f47c9c7d; // as in python, but for bytes only
const $9f70ec386af813db$export$c8dd6bc66a63753c = (type, str)=>{
    if (!$9f70ec386af813db$var$CODERS.hasOwnProperty(type)) throw new TypeError($9f70ec386af813db$var$coderTypeError);
    if (typeof str !== "string") throw new TypeError("stringToBytes() expects string");
    return $9f70ec386af813db$var$CODERS[type].decode(str);
};
const $9f70ec386af813db$export$b3317979f9250576 = $9f70ec386af813db$export$c8dd6bc66a63753c; //# sourceMappingURL=index.js.map

});

parcelRegister("85BMf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateObject = module.exports.createHmacDrbg = module.exports.bitMask = module.exports.bitSet = module.exports.bitGet = module.exports.bitLen = module.exports.utf8ToBytes = module.exports.equalBytes = module.exports.concatBytes = module.exports.ensureBytes = module.exports.numberToVarBytesBE = module.exports.numberToBytesLE = module.exports.numberToBytesBE = module.exports.bytesToNumberLE = module.exports.bytesToNumberBE = module.exports.hexToBytes = module.exports.hexToNumber = module.exports.numberToHexUnpadded = module.exports.bytesToHex = module.exports.isBytes = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $01851929d3789020$var$_0n = BigInt(0);
const $01851929d3789020$var$_1n = BigInt(1);
const $01851929d3789020$var$_2n = BigInt(2);
function $01851929d3789020$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
module.exports.isBytes = $01851929d3789020$var$isBytes;
// Array where index 0xf0 (240) is mapped to string 'f0'
const $01851929d3789020$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $01851929d3789020$var$bytesToHex(bytes) {
    if (!$01851929d3789020$var$isBytes(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $01851929d3789020$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $01851929d3789020$var$bytesToHex;
function $01851929d3789020$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
module.exports.numberToHexUnpadded = $01851929d3789020$var$numberToHexUnpadded;
function $01851929d3789020$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
module.exports.hexToNumber = $01851929d3789020$var$hexToNumber;
// We use optimized technique to convert hex string to byte array
const $01851929d3789020$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $01851929d3789020$var$asciiToBase16(char) {
    if (char >= $01851929d3789020$var$asciis._0 && char <= $01851929d3789020$var$asciis._9) return char - $01851929d3789020$var$asciis._0;
    if (char >= $01851929d3789020$var$asciis._A && char <= $01851929d3789020$var$asciis._F) return char - ($01851929d3789020$var$asciis._A - 10);
    if (char >= $01851929d3789020$var$asciis._a && char <= $01851929d3789020$var$asciis._f) return char - ($01851929d3789020$var$asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $01851929d3789020$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $01851929d3789020$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $01851929d3789020$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
module.exports.hexToBytes = $01851929d3789020$var$hexToBytes;
// BE: Big Endian, LE: Little Endian
function $01851929d3789020$var$bytesToNumberBE(bytes) {
    return $01851929d3789020$var$hexToNumber($01851929d3789020$var$bytesToHex(bytes));
}
module.exports.bytesToNumberBE = $01851929d3789020$var$bytesToNumberBE;
function $01851929d3789020$var$bytesToNumberLE(bytes) {
    if (!$01851929d3789020$var$isBytes(bytes)) throw new Error("Uint8Array expected");
    return $01851929d3789020$var$hexToNumber($01851929d3789020$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
module.exports.bytesToNumberLE = $01851929d3789020$var$bytesToNumberLE;
function $01851929d3789020$var$numberToBytesBE(n, len) {
    return $01851929d3789020$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
module.exports.numberToBytesBE = $01851929d3789020$var$numberToBytesBE;
function $01851929d3789020$var$numberToBytesLE(n, len) {
    return $01851929d3789020$var$numberToBytesBE(n, len).reverse();
}
module.exports.numberToBytesLE = $01851929d3789020$var$numberToBytesLE;
// Unpadded, rarely used
function $01851929d3789020$var$numberToVarBytesBE(n) {
    return $01851929d3789020$var$hexToBytes($01851929d3789020$var$numberToHexUnpadded(n));
}
module.exports.numberToVarBytesBE = $01851929d3789020$var$numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $01851929d3789020$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $01851929d3789020$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($01851929d3789020$var$isBytes(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
module.exports.ensureBytes = $01851929d3789020$var$ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $01851929d3789020$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        if (!$01851929d3789020$var$isBytes(a)) throw new Error("Uint8Array expected");
        sum += a.length;
    }
    let res = new Uint8Array(sum);
    let pad = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
module.exports.concatBytes = $01851929d3789020$var$concatBytes;
// Compares 2 u8a-s in kinda constant time
function $01851929d3789020$var$equalBytes(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
module.exports.equalBytes = $01851929d3789020$var$equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $01851929d3789020$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $01851929d3789020$var$utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $01851929d3789020$var$bitLen(n) {
    let len;
    for(len = 0; n > $01851929d3789020$var$_0n; n >>= $01851929d3789020$var$_1n, len += 1);
    return len;
}
module.exports.bitLen = $01851929d3789020$var$bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $01851929d3789020$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $01851929d3789020$var$_1n;
}
module.exports.bitGet = $01851929d3789020$var$bitGet;
/**
 * Sets single bit at position.
 */ const $01851929d3789020$var$bitSet = (n, pos, value)=>{
    return n | (value ? $01851929d3789020$var$_1n : $01851929d3789020$var$_0n) << BigInt(pos);
};
module.exports.bitSet = $01851929d3789020$var$bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $01851929d3789020$var$bitMask = (n)=>($01851929d3789020$var$_2n << BigInt(n - 1)) - $01851929d3789020$var$_1n;
module.exports.bitMask = $01851929d3789020$var$bitMask;
// DRBG
const $01851929d3789020$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $01851929d3789020$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $01851929d3789020$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $01851929d3789020$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $01851929d3789020$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $01851929d3789020$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($01851929d3789020$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($01851929d3789020$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $01851929d3789020$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
module.exports.createHmacDrbg = $01851929d3789020$var$createHmacDrbg;
// Validating curves and fields
const $01851929d3789020$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || $01851929d3789020$var$isBytes(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $01851929d3789020$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $01851929d3789020$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
module.exports.validateObject = $01851929d3789020$var$validateObject; // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});

parcelRegister("5GNKL", function(module, exports) {

$parcel$export(module.exports, "MAX_VALUE", function () { return $424777ee174dd885$export$e5fd331eb7ecbb12; });
$parcel$export(module.exports, "_starkCurve", function () { return $424777ee174dd885$export$e83e3e9737aefa14; });
$parcel$export(module.exports, "getPublicKey", function () { return $424777ee174dd885$export$889def73691f9837; });
$parcel$export(module.exports, "getSharedSecret", function () { return $424777ee174dd885$export$151f26f9d84a2c64; });
$parcel$export(module.exports, "sign", function () { return $424777ee174dd885$export$c5552dfdbc7cec71; });
$parcel$export(module.exports, "verify", function () { return $424777ee174dd885$export$532244b5b8b0b4b6; });
$parcel$export(module.exports, "Signature", function () { return $424777ee174dd885$export$848620f5f2f26e86; });
$parcel$export(module.exports, "CURVE", function () { return $424777ee174dd885$export$8ff8607b70325343; });
$parcel$export(module.exports, "ProjectivePoint", function () { return $424777ee174dd885$export$ca1fbc58807e8424; });
$parcel$export(module.exports, "utils", function () { return $424777ee174dd885$export$eab97d15b1788b8d; });
$parcel$export(module.exports, "grindKey", function () { return $424777ee174dd885$export$c841c9ab84b47551; });
$parcel$export(module.exports, "getStarkKey", function () { return $424777ee174dd885$export$d248334923715ad1; });
$parcel$export(module.exports, "ethSigToPrivate", function () { return $424777ee174dd885$export$84294b46921e9a71; });
$parcel$export(module.exports, "getAccountPath", function () { return $424777ee174dd885$export$22b80e4f9eff636d; });
$parcel$export(module.exports, "pedersen", function () { return $424777ee174dd885$export$9ad7fbb14b08028e; });
$parcel$export(module.exports, "computeHashOnElements", function () { return $424777ee174dd885$export$9f8169d1fa7e848f; });
$parcel$export(module.exports, "keccak", function () { return $424777ee174dd885$export$5c976938b424edc7; });
$parcel$export(module.exports, "Fp251", function () { return $424777ee174dd885$export$a2c3d1e8492dcee1; });
$parcel$export(module.exports, "_poseidonMDS", function () { return $424777ee174dd885$export$5a8df641d50f97b3; });
$parcel$export(module.exports, "poseidonBasic", function () { return $424777ee174dd885$export$7dfbada8e5c757c9; });
$parcel$export(module.exports, "poseidonCreate", function () { return $424777ee174dd885$export$aa6224e6e0ffe14a; });
$parcel$export(module.exports, "poseidonSmall", function () { return $424777ee174dd885$export$d9497fbdcd8db6b4; });
$parcel$export(module.exports, "poseidonHash", function () { return $424777ee174dd885$export$88834090e77da4b5; });
$parcel$export(module.exports, "poseidonHashFunc", function () { return $424777ee174dd885$export$2f0f7cd509792f67; });
$parcel$export(module.exports, "poseidonHashSingle", function () { return $424777ee174dd885$export$afe330c39d41ca1d; });
$parcel$export(module.exports, "poseidonHashMany", function () { return $424777ee174dd885$export$4c634ca7b22d6598; });

var $dMfPH = parcelRequire("dMfPH");

var $HGYq1 = parcelRequire("HGYq1");

var $bdetq = parcelRequire("bdetq");

var $72AvD = parcelRequire("72AvD");

var $kCOjY = parcelRequire("kCOjY");

var $2XPJl = parcelRequire("2XPJl");

var $85BMf = parcelRequire("85BMf");

var $dVBXd = parcelRequire("dVBXd");
const $424777ee174dd885$var$CURVE_ORDER = BigInt("3618502788666131213697322783095070105526743751716087489154079457884512865583");
const $424777ee174dd885$export$e5fd331eb7ecbb12 = BigInt("0x800000000000000000000000000000000000000000000000000000000000000");
const $424777ee174dd885$var$nBitLength = 252;
function $424777ee174dd885$var$bits2int(bytes) {
    while(bytes[0] === 0)bytes = bytes.subarray(1);
    const delta = bytes.length * 8 - $424777ee174dd885$var$nBitLength;
    const num = $85BMf.bytesToNumberBE(bytes);
    return delta > 0 ? num >> BigInt(delta) : num;
}
function $424777ee174dd885$var$hex0xToBytes(hex) {
    if (typeof hex === "string") {
        hex = $424777ee174dd885$var$strip0x(hex);
        if (hex.length & 1) hex = "0" + hex;
    }
    return $85BMf.hexToBytes(hex);
}
const $424777ee174dd885$var$curve = (0, $2XPJl.weierstrass)({
    a: BigInt(1),
    b: BigInt("3141592653589793238462643383279502884197169399375105820974944592307816406665"),
    Fp: (0, $72AvD.Field)(BigInt("0x800000000000011000000000000000000000000000000000000000000000001")),
    n: $424777ee174dd885$var$CURVE_ORDER,
    nBitLength: $424777ee174dd885$var$nBitLength,
    Gx: BigInt("874739451078007766457464989774322083649278607533249481151382481072868806602"),
    Gy: BigInt("152666792071518830868575557812948353041420400780739481342941381225525861407"),
    h: BigInt(1),
    lowS: false,
    ...(0, $dVBXd.getHash)((0, $HGYq1.sha256)),
    bits2int: $424777ee174dd885$var$bits2int,
    bits2int_modN: (bytes)=>{
        const hex = $85BMf.bytesToNumberBE(bytes).toString(16);
        if (hex.length === 63) bytes = $424777ee174dd885$var$hex0xToBytes(hex + "0");
        return (0, $72AvD.mod)($424777ee174dd885$var$bits2int(bytes), $424777ee174dd885$var$CURVE_ORDER);
    }
});
const $424777ee174dd885$export$e83e3e9737aefa14 = $424777ee174dd885$var$curve;
function $424777ee174dd885$var$ensureBytes(hex) {
    return $85BMf.ensureBytes("", typeof hex === "string" ? $424777ee174dd885$var$hex0xToBytes(hex) : hex);
}
function $424777ee174dd885$var$normPrivKey(privKey) {
    return $85BMf.bytesToHex($424777ee174dd885$var$ensureBytes(privKey)).padStart(64, "0");
}
function $424777ee174dd885$export$889def73691f9837(privKey, isCompressed = false) {
    return $424777ee174dd885$var$curve.getPublicKey($424777ee174dd885$var$normPrivKey(privKey), isCompressed);
}
function $424777ee174dd885$export$151f26f9d84a2c64(privKeyA, pubKeyB) {
    return $424777ee174dd885$var$curve.getSharedSecret($424777ee174dd885$var$normPrivKey(privKeyA), pubKeyB);
}
function $424777ee174dd885$var$checkSignature(signature) {
    const { r: r, s: s } = signature;
    if (r < 0n || r >= $424777ee174dd885$export$e5fd331eb7ecbb12) throw new Error(`Signature.r should be [1, ${$424777ee174dd885$export$e5fd331eb7ecbb12})`);
    const w = (0, $72AvD.invert)(s, $424777ee174dd885$var$CURVE_ORDER);
    if (w < 0n || w >= $424777ee174dd885$export$e5fd331eb7ecbb12) throw new Error(`inv(Signature.s) should be [1, ${$424777ee174dd885$export$e5fd331eb7ecbb12})`);
}
function $424777ee174dd885$var$checkMessage(msgHash) {
    const bytes = $424777ee174dd885$var$ensureBytes(msgHash);
    const num = $85BMf.bytesToNumberBE(bytes);
    if (num >= $424777ee174dd885$export$e5fd331eb7ecbb12) throw new Error(`msgHash should be [0, ${$424777ee174dd885$export$e5fd331eb7ecbb12})`);
    return bytes;
}
function $424777ee174dd885$export$c5552dfdbc7cec71(msgHash, privKey, opts) {
    const sig = $424777ee174dd885$var$curve.sign($424777ee174dd885$var$checkMessage(msgHash), $424777ee174dd885$var$normPrivKey(privKey), opts);
    $424777ee174dd885$var$checkSignature(sig);
    return sig;
}
function $424777ee174dd885$export$532244b5b8b0b4b6(signature, msgHash, pubKey) {
    if (!(signature instanceof $424777ee174dd885$export$848620f5f2f26e86)) {
        const bytes = $424777ee174dd885$var$ensureBytes(signature);
        try {
            signature = $424777ee174dd885$export$848620f5f2f26e86.fromDER(bytes);
        } catch (derError) {
            if (!(derError instanceof (0, $2XPJl.DER).Err)) throw derError;
            signature = $424777ee174dd885$export$848620f5f2f26e86.fromCompact(bytes);
        }
    }
    $424777ee174dd885$var$checkSignature(signature);
    return $424777ee174dd885$var$curve.verify(signature, $424777ee174dd885$var$checkMessage(msgHash), $424777ee174dd885$var$ensureBytes(pubKey));
}
const { CURVE: $424777ee174dd885$export$8ff8607b70325343, ProjectivePoint: $424777ee174dd885$export$ca1fbc58807e8424, Signature: $424777ee174dd885$export$848620f5f2f26e86, utils: $424777ee174dd885$export$eab97d15b1788b8d } = $424777ee174dd885$var$curve;
function $424777ee174dd885$var$extractX(bytes) {
    const hex = $85BMf.bytesToHex(bytes.subarray(1));
    const stripped = hex.replace(/^0+/gm, "");
    return `0x${stripped}`;
}
function $424777ee174dd885$var$strip0x(hex) {
    return hex.replace(/^0x/i, "");
}
function $424777ee174dd885$export$c841c9ab84b47551(seed) {
    const _seed = $424777ee174dd885$var$ensureBytes(seed);
    const sha256mask = 2n ** 256n;
    const limit = sha256mask - (0, $72AvD.mod)(sha256mask, $424777ee174dd885$var$CURVE_ORDER);
    for(let i = 0;; i++){
        const key = $424777ee174dd885$var$sha256Num($85BMf.concatBytes(_seed, $85BMf.numberToVarBytesBE(BigInt(i))));
        if (key < limit) return (0, $72AvD.mod)(key, $424777ee174dd885$var$CURVE_ORDER).toString(16);
        if (i === 100000) throw new Error("grindKey is broken: tried 100k vals");
    }
}
function $424777ee174dd885$export$d248334923715ad1(privateKey) {
    return $424777ee174dd885$var$extractX($424777ee174dd885$export$889def73691f9837(privateKey, true));
}
function $424777ee174dd885$export$84294b46921e9a71(signature) {
    signature = $424777ee174dd885$var$strip0x(signature);
    if (signature.length !== 130) throw new Error("Wrong ethereum signature");
    return $424777ee174dd885$export$c841c9ab84b47551(signature.substring(0, 64));
}
const $424777ee174dd885$var$MASK_31 = 2n ** 31n - 1n;
const $424777ee174dd885$var$int31 = (n)=>Number(n & $424777ee174dd885$var$MASK_31);
function $424777ee174dd885$export$22b80e4f9eff636d(layer, application, ethereumAddress, index) {
    const layerNum = $424777ee174dd885$var$int31($424777ee174dd885$var$sha256Num(layer));
    const applicationNum = $424777ee174dd885$var$int31($424777ee174dd885$var$sha256Num(application));
    const eth = $85BMf.hexToNumber($424777ee174dd885$var$strip0x(ethereumAddress));
    return `m/2645'/${layerNum}'/${applicationNum}'/${$424777ee174dd885$var$int31(eth)}'/${$424777ee174dd885$var$int31(eth >> 31n)}'/${index}`;
}
const $424777ee174dd885$var$PEDERSEN_POINTS = [
    new $424777ee174dd885$export$ca1fbc58807e8424(2089986280348253421170679821480865132823066470938446095505822317253594081284n, 1713931329540660377023406109199410414810705867260802078187082345529207694986n, 1n),
    new $424777ee174dd885$export$ca1fbc58807e8424(996781205833008774514500082376783249102396023663454813447423147977397232763n, 1668503676786377725805489344771023921079126552019160156920634619255970485781n, 1n),
    new $424777ee174dd885$export$ca1fbc58807e8424(2251563274489750535117886426533222435294046428347329203627021249169616184184n, 1798716007562728905295480679789526322175868328062420237419143593021674992973n, 1n),
    new $424777ee174dd885$export$ca1fbc58807e8424(2138414695194151160943305727036575959195309218611738193261179310511854807447n, 113410276730064486255102093846540133784865286929052426931474106396135072156n, 1n),
    new $424777ee174dd885$export$ca1fbc58807e8424(2379962749567351885752724891227938183011949129833673362440656643086021394946n, 776496453633298175483985398648758586525933812536653089401905292063708816422n, 1n)
];
function $424777ee174dd885$var$pedersenPrecompute(p1, p2) {
    const out = [];
    let p = p1;
    for(let i = 0; i < 248; i++){
        out.push(p);
        p = p.double();
    }
    p = p2;
    for(let i = 0; i < 4; i++){
        out.push(p);
        p = p.double();
    }
    return out;
}
const $424777ee174dd885$var$PEDERSEN_POINTS1 = $424777ee174dd885$var$pedersenPrecompute($424777ee174dd885$var$PEDERSEN_POINTS[1], $424777ee174dd885$var$PEDERSEN_POINTS[2]);
const $424777ee174dd885$var$PEDERSEN_POINTS2 = $424777ee174dd885$var$pedersenPrecompute($424777ee174dd885$var$PEDERSEN_POINTS[3], $424777ee174dd885$var$PEDERSEN_POINTS[4]);
function $424777ee174dd885$var$pedersenArg(arg) {
    let value;
    if (typeof arg === "bigint") value = arg;
    else if (typeof arg === "number") {
        if (!Number.isSafeInteger(arg)) throw new Error(`Invalid pedersenArg: ${arg}`);
        value = BigInt(arg);
    } else value = $85BMf.bytesToNumberBE($424777ee174dd885$var$ensureBytes(arg));
    if (!(0n <= value && value < $424777ee174dd885$var$curve.CURVE.Fp.ORDER)) throw new Error(`PedersenArg should be 0 <= value < CURVE.P: ${value}`);
    return value;
}
function $424777ee174dd885$var$pedersenSingle(point, value, constants) {
    let x = $424777ee174dd885$var$pedersenArg(value);
    for(let j = 0; j < 252; j++){
        const pt = constants[j];
        if (pt.equals(point)) throw new Error("Same point");
        if ((x & 1n) !== 0n) point = point.add(pt);
        x >>= 1n;
    }
    return point;
}
function $424777ee174dd885$export$9ad7fbb14b08028e(x, y) {
    let point = $424777ee174dd885$var$PEDERSEN_POINTS[0];
    point = $424777ee174dd885$var$pedersenSingle(point, x, $424777ee174dd885$var$PEDERSEN_POINTS1);
    point = $424777ee174dd885$var$pedersenSingle(point, y, $424777ee174dd885$var$PEDERSEN_POINTS2);
    return $424777ee174dd885$var$extractX(point.toRawBytes(true));
}
const $424777ee174dd885$export$9f8169d1fa7e848f = (data, fn = $424777ee174dd885$export$9ad7fbb14b08028e)=>[
        0,
        ...data,
        data.length
    ].reduce((x, y)=>fn(x, y));
const $424777ee174dd885$var$MASK_250 = $85BMf.bitMask(250);
const $424777ee174dd885$export$5c976938b424edc7 = (data)=>$85BMf.bytesToNumberBE((0, $dMfPH.keccak_256)(data)) & $424777ee174dd885$var$MASK_250;
const $424777ee174dd885$var$sha256Num = (data)=>$85BMf.bytesToNumberBE((0, $HGYq1.sha256)(data));
const $424777ee174dd885$export$a2c3d1e8492dcee1 = (0, $72AvD.Field)(BigInt("3618502788666131213697322783095070105623107215331596699973092056135872020481"));
function $424777ee174dd885$var$poseidonRoundConstant(Fp, name, idx) {
    const val = Fp.fromBytes((0, $HGYq1.sha256)((0, $bdetq.utf8ToBytes)(`${name}${idx}`)));
    return Fp.create(val);
}
function $424777ee174dd885$export$5a8df641d50f97b3(Fp, name, m, attempt = 0) {
    const x_values = [];
    const y_values = [];
    for(let i = 0; i < m; i++){
        x_values.push($424777ee174dd885$var$poseidonRoundConstant(Fp, `${name}x`, attempt * m + i));
        y_values.push($424777ee174dd885$var$poseidonRoundConstant(Fp, `${name}y`, attempt * m + i));
    }
    if (new Set([
        ...x_values,
        ...y_values
    ]).size !== 2 * m) throw new Error("X and Y values are not distinct");
    return x_values.map((x)=>y_values.map((y)=>Fp.inv(Fp.sub(x, y))));
}
const $424777ee174dd885$var$MDS_SMALL = [
    [
        3,
        1,
        1
    ],
    [
        1,
        -1,
        1
    ],
    [
        1,
        1,
        -2
    ]
].map((i)=>i.map(BigInt));
function $424777ee174dd885$export$7dfbada8e5c757c9(opts, mds) {
    (0, $72AvD.validateField)(opts.Fp);
    if (!Number.isSafeInteger(opts.rate) || !Number.isSafeInteger(opts.capacity)) throw new Error(`Wrong poseidon opts: ${opts}`);
    const m = opts.rate + opts.capacity;
    const rounds = opts.roundsFull + opts.roundsPartial;
    const roundConstants = [];
    for(let i = 0; i < rounds; i++){
        const row = [];
        for(let j = 0; j < m; j++)row.push($424777ee174dd885$var$poseidonRoundConstant(opts.Fp, "Hades", m * i + j));
        roundConstants.push(row);
    }
    const res = (0, $kCOjY.poseidon)({
        ...opts,
        t: m,
        sboxPower: 3,
        reversePartialPowIdx: true,
        mds: mds,
        roundConstants: roundConstants
    });
    res.m = m;
    res.rate = opts.rate;
    res.capacity = opts.capacity;
    return res;
}
function $424777ee174dd885$export$aa6224e6e0ffe14a(opts, mdsAttempt = 0) {
    const m = opts.rate + opts.capacity;
    if (!Number.isSafeInteger(mdsAttempt)) throw new Error(`Wrong mdsAttempt=${mdsAttempt}`);
    return $424777ee174dd885$export$7dfbada8e5c757c9(opts, $424777ee174dd885$export$5a8df641d50f97b3(opts.Fp, "HadesMDS", m, mdsAttempt));
}
const $424777ee174dd885$export$d9497fbdcd8db6b4 = $424777ee174dd885$export$7dfbada8e5c757c9({
    Fp: $424777ee174dd885$export$a2c3d1e8492dcee1,
    rate: 2,
    capacity: 1,
    roundsFull: 8,
    roundsPartial: 83
}, $424777ee174dd885$var$MDS_SMALL);
function $424777ee174dd885$export$88834090e77da4b5(x, y, fn = $424777ee174dd885$export$d9497fbdcd8db6b4) {
    return fn([
        x,
        y,
        2n
    ])[0];
}
function $424777ee174dd885$export$2f0f7cd509792f67(x, y, fn = $424777ee174dd885$export$d9497fbdcd8db6b4) {
    return $85BMf.numberToVarBytesBE($424777ee174dd885$export$88834090e77da4b5($85BMf.bytesToNumberBE(x), $85BMf.bytesToNumberBE(y), fn));
}
function $424777ee174dd885$export$afe330c39d41ca1d(x, fn = $424777ee174dd885$export$d9497fbdcd8db6b4) {
    return fn([
        x,
        0n,
        1n
    ])[0];
}
function $424777ee174dd885$export$4c634ca7b22d6598(values, fn = $424777ee174dd885$export$d9497fbdcd8db6b4) {
    const { m: m, rate: rate } = fn;
    if (!Array.isArray(values)) throw new Error("bigint array expected in values");
    const padded = Array.from(values);
    padded.push(1n);
    while(padded.length % rate !== 0)padded.push(0n);
    let state = new Array(m).fill(0n);
    for(let i = 0; i < padded.length; i += rate){
        for(let j = 0; j < rate; j++)state[j] += padded[i + j];
        state = fn(state);
    }
    return state[0];
}

});
parcelRegister("dMfPH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $4hg6I = parcelRequire("4hg6I");

var $4cMch = parcelRequire("4cMch");

var $bdetq = parcelRequire("bdetq");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$a07c0a27998e1113$var$SHA3_PI, $a07c0a27998e1113$var$SHA3_ROTL, $a07c0a27998e1113$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $a07c0a27998e1113$var$_0n = /* @__PURE__ */ BigInt(0);
const $a07c0a27998e1113$var$_1n = /* @__PURE__ */ BigInt(1);
const $a07c0a27998e1113$var$_2n = /* @__PURE__ */ BigInt(2);
const $a07c0a27998e1113$var$_7n = /* @__PURE__ */ BigInt(7);
const $a07c0a27998e1113$var$_256n = /* @__PURE__ */ BigInt(256);
const $a07c0a27998e1113$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $a07c0a27998e1113$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $a07c0a27998e1113$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $a07c0a27998e1113$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $a07c0a27998e1113$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $a07c0a27998e1113$var$_1n ^ (R >> $a07c0a27998e1113$var$_7n) * $a07c0a27998e1113$var$_0x71n) % $a07c0a27998e1113$var$_256n;
        if (R & $a07c0a27998e1113$var$_2n) t ^= $a07c0a27998e1113$var$_1n << ($a07c0a27998e1113$var$_1n << /* @__PURE__ */ BigInt(j)) - $a07c0a27998e1113$var$_1n;
    }
    $a07c0a27998e1113$var$_SHA3_IOTA.push(t);
}
const [$a07c0a27998e1113$var$SHA3_IOTA_H, $a07c0a27998e1113$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $4cMch.split)($a07c0a27998e1113$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $a07c0a27998e1113$var$rotlH = (h, l, s)=>s > 32 ? (0, $4cMch.rotlBH)(h, l, s) : (0, $4cMch.rotlSH)(h, l, s);
const $a07c0a27998e1113$var$rotlL = (h, l, s)=>s > 32 ? (0, $4cMch.rotlBL)(h, l, s) : (0, $4cMch.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $a07c0a27998e1113$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $a07c0a27998e1113$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $a07c0a27998e1113$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $a07c0a27998e1113$var$SHA3_ROTL[t];
            const Th = $a07c0a27998e1113$var$rotlH(curH, curL, shift);
            const Tl = $a07c0a27998e1113$var$rotlL(curH, curL, shift);
            const PI = $a07c0a27998e1113$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $a07c0a27998e1113$var$SHA3_IOTA_H[round];
        s[1] ^= $a07c0a27998e1113$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $a07c0a27998e1113$var$keccakP;
class $a07c0a27998e1113$var$Keccak extends $bdetq.Hash {
    keccak() {
        $a07c0a27998e1113$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $4hg6I.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $bdetq.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $4hg6I.exists)(this, false);
        (0, $4hg6I.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $4hg6I.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $4hg6I.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $a07c0a27998e1113$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $4hg6I.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $bdetq.u32)(this.state);
    }
}
module.exports.Keccak = $a07c0a27998e1113$var$Keccak;
const $a07c0a27998e1113$var$gen = (suffix, blockLen, outputLen)=>(0, $bdetq.wrapConstructor)(()=>new $a07c0a27998e1113$var$Keccak(blockLen, suffix, outputLen));
module.exports.sha3_224 = $a07c0a27998e1113$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $a07c0a27998e1113$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $a07c0a27998e1113$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $a07c0a27998e1113$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $a07c0a27998e1113$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $a07c0a27998e1113$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $a07c0a27998e1113$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $a07c0a27998e1113$var$gen(0x01, 72, 64);
const $a07c0a27998e1113$var$genShake = (suffix, blockLen, outputLen)=>(0, $bdetq.wrapXOFConstructorWithOpts)((opts = {})=>new $a07c0a27998e1113$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
module.exports.shake128 = $a07c0a27998e1113$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $a07c0a27998e1113$var$genShake(0x1f, 136, 32);

});
parcelRegister("4hg6I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $31d53e86a08baf8f$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
module.exports.number = $31d53e86a08baf8f$var$number;
function $31d53e86a08baf8f$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
module.exports.bool = $31d53e86a08baf8f$var$bool;
// copied from utils
function $31d53e86a08baf8f$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $31d53e86a08baf8f$var$bytes(b, ...lengths) {
    if (!$31d53e86a08baf8f$var$isBytes(b)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $31d53e86a08baf8f$var$bytes;
function $31d53e86a08baf8f$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $31d53e86a08baf8f$var$number(hash.outputLen);
    $31d53e86a08baf8f$var$number(hash.blockLen);
}
module.exports.hash = $31d53e86a08baf8f$var$hash;
function $31d53e86a08baf8f$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $31d53e86a08baf8f$var$exists;
function $31d53e86a08baf8f$var$output(out, instance) {
    $31d53e86a08baf8f$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $31d53e86a08baf8f$var$output;
const $31d53e86a08baf8f$var$assert = {
    number: $31d53e86a08baf8f$var$number,
    bool: $31d53e86a08baf8f$var$bool,
    bytes: $31d53e86a08baf8f$var$bytes,
    hash: $31d53e86a08baf8f$var$hash,
    exists: $31d53e86a08baf8f$var$exists,
    output: $31d53e86a08baf8f$var$output
};
module.exports.default = $31d53e86a08baf8f$var$assert;

});

parcelRegister("4cMch", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $30fdab52992ac0ce$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $30fdab52992ac0ce$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $30fdab52992ac0ce$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $30fdab52992ac0ce$var$U32_MASK64),
        l: Number(n >> $30fdab52992ac0ce$var$_32n & $30fdab52992ac0ce$var$U32_MASK64)
    };
    return {
        h: Number(n >> $30fdab52992ac0ce$var$_32n & $30fdab52992ac0ce$var$U32_MASK64) | 0,
        l: Number(n & $30fdab52992ac0ce$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $30fdab52992ac0ce$var$fromBig;
function $30fdab52992ac0ce$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $30fdab52992ac0ce$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $30fdab52992ac0ce$var$split;
const $30fdab52992ac0ce$var$toBig = (h, l)=>BigInt(h >>> 0) << $30fdab52992ac0ce$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $30fdab52992ac0ce$var$toBig;
// for Shift in [0, 32)
const $30fdab52992ac0ce$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $30fdab52992ac0ce$var$shrSH;
const $30fdab52992ac0ce$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $30fdab52992ac0ce$var$shrSL;
// Right rotate for Shift in [1, 32)
const $30fdab52992ac0ce$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $30fdab52992ac0ce$var$rotrSH;
const $30fdab52992ac0ce$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $30fdab52992ac0ce$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $30fdab52992ac0ce$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $30fdab52992ac0ce$var$rotrBH;
const $30fdab52992ac0ce$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $30fdab52992ac0ce$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $30fdab52992ac0ce$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $30fdab52992ac0ce$var$rotr32H;
const $30fdab52992ac0ce$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $30fdab52992ac0ce$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $30fdab52992ac0ce$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $30fdab52992ac0ce$var$rotlSH;
const $30fdab52992ac0ce$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $30fdab52992ac0ce$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $30fdab52992ac0ce$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $30fdab52992ac0ce$var$rotlBH;
const $30fdab52992ac0ce$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $30fdab52992ac0ce$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $30fdab52992ac0ce$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $30fdab52992ac0ce$var$add;
// Addition with more than 2 elements
const $30fdab52992ac0ce$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $30fdab52992ac0ce$var$add3L;
const $30fdab52992ac0ce$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $30fdab52992ac0ce$var$add3H;
const $30fdab52992ac0ce$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $30fdab52992ac0ce$var$add4L;
const $30fdab52992ac0ce$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $30fdab52992ac0ce$var$add4H;
const $30fdab52992ac0ce$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $30fdab52992ac0ce$var$add5L;
const $30fdab52992ac0ce$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $30fdab52992ac0ce$var$add5H;
// prettier-ignore
const $30fdab52992ac0ce$var$u64 = {
    fromBig: $30fdab52992ac0ce$var$fromBig,
    split: $30fdab52992ac0ce$var$split,
    toBig: $30fdab52992ac0ce$var$toBig,
    shrSH: $30fdab52992ac0ce$var$shrSH,
    shrSL: $30fdab52992ac0ce$var$shrSL,
    rotrSH: $30fdab52992ac0ce$var$rotrSH,
    rotrSL: $30fdab52992ac0ce$var$rotrSL,
    rotrBH: $30fdab52992ac0ce$var$rotrBH,
    rotrBL: $30fdab52992ac0ce$var$rotrBL,
    rotr32H: $30fdab52992ac0ce$var$rotr32H,
    rotr32L: $30fdab52992ac0ce$var$rotr32L,
    rotlSH: $30fdab52992ac0ce$var$rotlSH,
    rotlSL: $30fdab52992ac0ce$var$rotlSL,
    rotlBH: $30fdab52992ac0ce$var$rotlBH,
    rotlBL: $30fdab52992ac0ce$var$rotlBL,
    add: $30fdab52992ac0ce$var$add,
    add3L: $30fdab52992ac0ce$var$add3L,
    add3H: $30fdab52992ac0ce$var$add3H,
    add4L: $30fdab52992ac0ce$var$add4L,
    add4H: $30fdab52992ac0ce$var$add4H,
    add5H: $30fdab52992ac0ce$var$add5H,
    add5L: $30fdab52992ac0ce$var$add5L
};
module.exports.default = $30fdab52992ac0ce$var$u64;

});

parcelRegister("bdetq", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $4l7Pc = parcelRequire("4l7Pc");
// Cast array to different type
const $829c22c8ec251a06$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $829c22c8ec251a06$var$u8;
const $829c22c8ec251a06$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $829c22c8ec251a06$var$u32;
function $829c22c8ec251a06$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
// Cast array to view
const $829c22c8ec251a06$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $829c22c8ec251a06$var$createView;
// The rotate right (circular right shift) operation for uint32
const $829c22c8ec251a06$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $829c22c8ec251a06$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
// Other libraries would silently corrupt the data instead of throwing an error,
// when they don't support it.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
// Array where index 0xf0 (240) is mapped to string 'f0'
const $829c22c8ec251a06$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $829c22c8ec251a06$var$bytesToHex(bytes) {
    if (!$829c22c8ec251a06$var$isBytes(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $829c22c8ec251a06$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $829c22c8ec251a06$var$bytesToHex;
// We use optimized technique to convert hex string to byte array
const $829c22c8ec251a06$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $829c22c8ec251a06$var$asciiToBase16(char) {
    if (char >= $829c22c8ec251a06$var$asciis._0 && char <= $829c22c8ec251a06$var$asciis._9) return char - $829c22c8ec251a06$var$asciis._0;
    if (char >= $829c22c8ec251a06$var$asciis._A && char <= $829c22c8ec251a06$var$asciis._F) return char - ($829c22c8ec251a06$var$asciis._A - 10);
    if (char >= $829c22c8ec251a06$var$asciis._a && char <= $829c22c8ec251a06$var$asciis._f) return char - ($829c22c8ec251a06$var$asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $829c22c8ec251a06$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $829c22c8ec251a06$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $829c22c8ec251a06$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
module.exports.hexToBytes = $829c22c8ec251a06$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $829c22c8ec251a06$var$nextTick = async ()=>{};
module.exports.nextTick = $829c22c8ec251a06$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $829c22c8ec251a06$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $829c22c8ec251a06$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $829c22c8ec251a06$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $829c22c8ec251a06$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $829c22c8ec251a06$var$toBytes(data) {
    if (typeof data === "string") data = $829c22c8ec251a06$var$utf8ToBytes(data);
    if (!$829c22c8ec251a06$var$isBytes(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
module.exports.toBytes = $829c22c8ec251a06$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $829c22c8ec251a06$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        if (!$829c22c8ec251a06$var$isBytes(a)) throw new Error("Uint8Array expected");
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
module.exports.concatBytes = $829c22c8ec251a06$var$concatBytes;
// For runtime check if class implements interface
class $829c22c8ec251a06$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $829c22c8ec251a06$var$Hash;
const $829c22c8ec251a06$var$toStr = {}.toString;
function $829c22c8ec251a06$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $829c22c8ec251a06$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $829c22c8ec251a06$var$checkOpts;
function $829c22c8ec251a06$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($829c22c8ec251a06$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $829c22c8ec251a06$var$wrapConstructor;
function $829c22c8ec251a06$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($829c22c8ec251a06$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $829c22c8ec251a06$var$wrapConstructorWithOpts;
function $829c22c8ec251a06$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($829c22c8ec251a06$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $829c22c8ec251a06$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $829c22c8ec251a06$var$randomBytes(bytesLength = 32) {
    if ($4l7Pc.crypto && typeof $4l7Pc.crypto.getRandomValues === "function") return $4l7Pc.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $829c22c8ec251a06$var$randomBytes;

});
parcelRegister("4l7Pc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});



parcelRegister("HGYq1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.sha256 = void 0;

var $jOnpb = parcelRequire("jOnpb");

var $bdetq = parcelRequire("bdetq");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $083559e8591830d8$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $083559e8591830d8$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $083559e8591830d8$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $083559e8591830d8$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $083559e8591830d8$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $083559e8591830d8$var$SHA256 extends $jOnpb.SHA2 {
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$083559e8591830d8$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $083559e8591830d8$var$SHA256_W[i - 15];
            const W2 = $083559e8591830d8$var$SHA256_W[i - 2];
            const s0 = (0, $bdetq.rotr)(W15, 7) ^ (0, $bdetq.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $bdetq.rotr)(W2, 17) ^ (0, $bdetq.rotr)(W2, 19) ^ W2 >>> 10;
            $083559e8591830d8$var$SHA256_W[i] = s1 + $083559e8591830d8$var$SHA256_W[i - 7] + s0 + $083559e8591830d8$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $bdetq.rotr)(E, 6) ^ (0, $bdetq.rotr)(E, 11) ^ (0, $bdetq.rotr)(E, 25);
            const T1 = H + sigma1 + $083559e8591830d8$var$Chi(E, F, G) + $083559e8591830d8$var$SHA256_K[i] + $083559e8591830d8$var$SHA256_W[i] | 0;
            const sigma0 = (0, $bdetq.rotr)(A, 2) ^ (0, $bdetq.rotr)(A, 13) ^ (0, $bdetq.rotr)(A, 22);
            const T2 = sigma0 + $083559e8591830d8$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $083559e8591830d8$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $083559e8591830d8$var$IV[0] | 0;
        this.B = $083559e8591830d8$var$IV[1] | 0;
        this.C = $083559e8591830d8$var$IV[2] | 0;
        this.D = $083559e8591830d8$var$IV[3] | 0;
        this.E = $083559e8591830d8$var$IV[4] | 0;
        this.F = $083559e8591830d8$var$IV[5] | 0;
        this.G = $083559e8591830d8$var$IV[6] | 0;
        this.H = $083559e8591830d8$var$IV[7] | 0;
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $083559e8591830d8$var$SHA224 extends $083559e8591830d8$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ module.exports.sha256 = (0, $bdetq.wrapConstructor)(()=>new $083559e8591830d8$var$SHA256());
module.exports.sha224 = (0, $bdetq.wrapConstructor)(()=>new $083559e8591830d8$var$SHA224());

});
parcelRegister("jOnpb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SHA2 = void 0;

var $4hg6I = parcelRequire("4hg6I");

var $bdetq = parcelRequire("bdetq");
// Polyfill for Safari 14
function $e6c4d7978e8321d9$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $e6c4d7978e8321d9$var$SHA2 extends $bdetq.Hash {
    update(data) {
        (0, $4hg6I.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $bdetq.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $bdetq.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $4hg6I.exists)(this);
        (0, $4hg6I.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $e6c4d7978e8321d9$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $bdetq.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $bdetq.createView)(this.buffer);
    }
}
module.exports.SHA2 = $e6c4d7978e8321d9$var$SHA2;

});


parcelRegister("72AvD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapHashToField = module.exports.getMinHashLength = module.exports.getFieldBytesLength = module.exports.hashToPrivateScalar = module.exports.FpSqrtEven = module.exports.FpSqrtOdd = module.exports.Field = module.exports.nLength = module.exports.FpIsSquare = module.exports.FpDiv = module.exports.FpInvertBatch = module.exports.FpPow = module.exports.validateField = module.exports.isNegativeLE = module.exports.FpSqrt = module.exports.tonelliShanks = module.exports.invert = module.exports.pow2 = module.exports.pow = module.exports.mod = void 0;

var $85BMf = parcelRequire("85BMf");
// prettier-ignore
const $52050a4aabb35930$var$_0n = BigInt(0), $52050a4aabb35930$var$_1n = BigInt(1), $52050a4aabb35930$var$_2n = BigInt(2), $52050a4aabb35930$var$_3n = BigInt(3);
// prettier-ignore
const $52050a4aabb35930$var$_4n = BigInt(4), $52050a4aabb35930$var$_5n = BigInt(5), $52050a4aabb35930$var$_8n = BigInt(8);
// prettier-ignore
const $52050a4aabb35930$var$_9n = BigInt(9), $52050a4aabb35930$var$_16n = BigInt(16);
// Calculates a modulo b
function $52050a4aabb35930$var$mod(a, b) {
    const result = a % b;
    return result >= $52050a4aabb35930$var$_0n ? result : b + result;
}
module.exports.mod = $52050a4aabb35930$var$mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function $52050a4aabb35930$var$pow(num, power, modulo) {
    if (modulo <= $52050a4aabb35930$var$_0n || power < $52050a4aabb35930$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $52050a4aabb35930$var$_1n) return $52050a4aabb35930$var$_0n;
    let res = $52050a4aabb35930$var$_1n;
    while(power > $52050a4aabb35930$var$_0n){
        if (power & $52050a4aabb35930$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $52050a4aabb35930$var$_1n;
    }
    return res;
}
module.exports.pow = $52050a4aabb35930$var$pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function $52050a4aabb35930$var$pow2(x, power, modulo) {
    let res = x;
    while(power-- > $52050a4aabb35930$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
module.exports.pow2 = $52050a4aabb35930$var$pow2;
// Inverses number over modulo
function $52050a4aabb35930$var$invert(number, modulo) {
    if (number === $52050a4aabb35930$var$_0n || modulo <= $52050a4aabb35930$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $52050a4aabb35930$var$mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $52050a4aabb35930$var$_0n, y = $52050a4aabb35930$var$_1n, u = $52050a4aabb35930$var$_1n, v = $52050a4aabb35930$var$_0n;
    while(a !== $52050a4aabb35930$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $52050a4aabb35930$var$_1n) throw new Error("invert: does not exist");
    return $52050a4aabb35930$var$mod(x, modulo);
}
module.exports.invert = $52050a4aabb35930$var$invert;
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function $52050a4aabb35930$var$tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $52050a4aabb35930$var$_1n) / $52050a4aabb35930$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $52050a4aabb35930$var$_1n, S = 0; Q % $52050a4aabb35930$var$_2n === $52050a4aabb35930$var$_0n; Q /= $52050a4aabb35930$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $52050a4aabb35930$var$_2n; Z < P && $52050a4aabb35930$var$pow(Z, legendreC, P) !== P - $52050a4aabb35930$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $52050a4aabb35930$var$_1n) / $52050a4aabb35930$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $52050a4aabb35930$var$_1n) / $52050a4aabb35930$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $52050a4aabb35930$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
module.exports.tonelliShanks = $52050a4aabb35930$var$tonelliShanks;
function $52050a4aabb35930$var$FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $52050a4aabb35930$var$_4n === $52050a4aabb35930$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $52050a4aabb35930$var$_1n) / $52050a4aabb35930$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $52050a4aabb35930$var$_8n === $52050a4aabb35930$var$_5n) {
        const c1 = (P - $52050a4aabb35930$var$_5n) / $52050a4aabb35930$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $52050a4aabb35930$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $52050a4aabb35930$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $52050a4aabb35930$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $52050a4aabb35930$var$tonelliShanks(P);
}
module.exports.FpSqrt = $52050a4aabb35930$var$FpSqrt;
// Little-endian check for first LE bit (last BE bit);
const $52050a4aabb35930$var$isNegativeLE = (num, modulo)=>($52050a4aabb35930$var$mod(num, modulo) & $52050a4aabb35930$var$_1n) === $52050a4aabb35930$var$_1n;
module.exports.isNegativeLE = $52050a4aabb35930$var$isNegativeLE;
// prettier-ignore
const $52050a4aabb35930$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $52050a4aabb35930$var$validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $52050a4aabb35930$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $85BMf.validateObject)(field, opts);
}
module.exports.validateField = $52050a4aabb35930$var$validateField;
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function $52050a4aabb35930$var$FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $52050a4aabb35930$var$_0n) throw new Error("Expected power > 0");
    if (power === $52050a4aabb35930$var$_0n) return f.ONE;
    if (power === $52050a4aabb35930$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $52050a4aabb35930$var$_0n){
        if (power & $52050a4aabb35930$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $52050a4aabb35930$var$_1n;
    }
    return p;
}
module.exports.FpPow = $52050a4aabb35930$var$FpPow;
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function $52050a4aabb35930$var$FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
module.exports.FpInvertBatch = $52050a4aabb35930$var$FpInvertBatch;
function $52050a4aabb35930$var$FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $52050a4aabb35930$var$invert(rhs, f.ORDER) : f.inv(rhs));
}
module.exports.FpDiv = $52050a4aabb35930$var$FpDiv;
// This function returns True whenever the value x is a square in the field F.
function $52050a4aabb35930$var$FpIsSquare(f) {
    const legendreConst = (f.ORDER - $52050a4aabb35930$var$_1n) / $52050a4aabb35930$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
module.exports.FpIsSquare = $52050a4aabb35930$var$FpIsSquare;
// CURVE.n lengths
function $52050a4aabb35930$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
module.exports.nLength = $52050a4aabb35930$var$nLength;
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $52050a4aabb35930$var$Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $52050a4aabb35930$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $52050a4aabb35930$var$nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $52050a4aabb35930$var$FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $85BMf.bitMask)(BITS),
        ZERO: $52050a4aabb35930$var$_0n,
        ONE: $52050a4aabb35930$var$_1n,
        create: (num)=>$52050a4aabb35930$var$mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $52050a4aabb35930$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $52050a4aabb35930$var$_0n,
        isOdd: (num)=>(num & $52050a4aabb35930$var$_1n) === $52050a4aabb35930$var$_1n,
        neg: (num)=>$52050a4aabb35930$var$mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$52050a4aabb35930$var$mod(num * num, ORDER),
        add: (lhs, rhs)=>$52050a4aabb35930$var$mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$52050a4aabb35930$var$mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$52050a4aabb35930$var$mod(lhs * rhs, ORDER),
        pow: (num, power)=>$52050a4aabb35930$var$FpPow(f, num, power),
        div: (lhs, rhs)=>$52050a4aabb35930$var$mod(lhs * $52050a4aabb35930$var$invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$52050a4aabb35930$var$invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$52050a4aabb35930$var$FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $85BMf.numberToBytesLE)(num, BYTES) : (0, $85BMf.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $85BMf.bytesToNumberLE)(bytes) : (0, $85BMf.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
module.exports.Field = $52050a4aabb35930$var$Field;
function $52050a4aabb35930$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
module.exports.FpSqrtOdd = $52050a4aabb35930$var$FpSqrtOdd;
function $52050a4aabb35930$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
module.exports.FpSqrtEven = $52050a4aabb35930$var$FpSqrtEven;
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */ function $52050a4aabb35930$var$hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, $85BMf.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $52050a4aabb35930$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $85BMf.bytesToNumberLE)(hash) : (0, $85BMf.bytesToNumberBE)(hash);
    return $52050a4aabb35930$var$mod(num, groupOrder - $52050a4aabb35930$var$_1n) + $52050a4aabb35930$var$_1n;
}
module.exports.hashToPrivateScalar = $52050a4aabb35930$var$hashToPrivateScalar;
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function $52050a4aabb35930$var$getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
module.exports.getFieldBytesLength = $52050a4aabb35930$var$getFieldBytesLength;
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function $52050a4aabb35930$var$getMinHashLength(fieldOrder) {
    const length = $52050a4aabb35930$var$getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
module.exports.getMinHashLength = $52050a4aabb35930$var$getMinHashLength;
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $52050a4aabb35930$var$mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $52050a4aabb35930$var$getFieldBytesLength(fieldOrder);
    const minLen = $52050a4aabb35930$var$getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $85BMf.bytesToNumberBE)(key) : (0, $85BMf.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $52050a4aabb35930$var$mod(num, fieldOrder - $52050a4aabb35930$var$_1n) + $52050a4aabb35930$var$_1n;
    return isLE ? (0, $85BMf.numberToBytesLE)(reduced, fieldLen) : (0, $85BMf.numberToBytesBE)(reduced, fieldLen);
}
module.exports.mapHashToField = $52050a4aabb35930$var$mapHashToField;

});

parcelRegister("kCOjY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.poseidon = module.exports.splitConstants = module.exports.validateOpts = void 0;

var $72AvD = parcelRequire("72AvD");
function $f03e63f7c56bf90a$var$validateOpts(opts) {
    const { Fp: Fp, mds: mds, reversePartialPowIdx: rev, roundConstants: rc } = opts;
    const { roundsFull: roundsFull, roundsPartial: roundsPartial, sboxPower: sboxPower, t: t } = opts;
    (0, $72AvD.validateField)(Fp);
    for (const i of [
        "t",
        "roundsFull",
        "roundsPartial"
    ]){
        if (typeof opts[i] !== "number" || !Number.isSafeInteger(opts[i])) throw new Error(`Poseidon: invalid param ${i}=${opts[i]} (${typeof opts[i]})`);
    }
    // MDS is TxT matrix
    if (!Array.isArray(mds) || mds.length !== t) throw new Error("Poseidon: wrong MDS matrix");
    const _mds = mds.map((mdsRow)=>{
        if (!Array.isArray(mdsRow) || mdsRow.length !== t) throw new Error(`Poseidon MDS matrix row: ${mdsRow}`);
        return mdsRow.map((i)=>{
            if (typeof i !== "bigint") throw new Error(`Poseidon MDS matrix value=${i}`);
            return Fp.create(i);
        });
    });
    if (rev !== undefined && typeof rev !== "boolean") throw new Error(`Poseidon: invalid param reversePartialPowIdx=${rev}`);
    if (roundsFull % 2 !== 0) throw new Error(`Poseidon roundsFull is not even: ${roundsFull}`);
    const rounds = roundsFull + roundsPartial;
    if (!Array.isArray(rc) || rc.length !== rounds) throw new Error("Poseidon: wrong round constants");
    const roundConstants = rc.map((rc)=>{
        if (!Array.isArray(rc) || rc.length !== t) throw new Error(`Poseidon wrong round constants: ${rc}`);
        return rc.map((i)=>{
            if (typeof i !== "bigint" || !Fp.isValid(i)) throw new Error(`Poseidon wrong round constant=${i}`);
            return Fp.create(i);
        });
    });
    if (!sboxPower || ![
        3,
        5,
        7
    ].includes(sboxPower)) throw new Error(`Poseidon wrong sboxPower=${sboxPower}`);
    const _sboxPower = BigInt(sboxPower);
    let sboxFn = (n)=>(0, $72AvD.FpPow)(Fp, n, _sboxPower);
    // Unwrapped sbox power for common cases (195->142μs)
    if (sboxPower === 3) sboxFn = (n)=>Fp.mul(Fp.sqrN(n), n);
    else if (sboxPower === 5) sboxFn = (n)=>Fp.mul(Fp.sqrN(Fp.sqrN(n)), n);
    return Object.freeze({
        ...opts,
        rounds: rounds,
        sboxFn: sboxFn,
        roundConstants: roundConstants,
        mds: _mds
    });
}
module.exports.validateOpts = $f03e63f7c56bf90a$var$validateOpts;
function $f03e63f7c56bf90a$var$splitConstants(rc, t) {
    if (typeof t !== "number") throw new Error("poseidonSplitConstants: wrong t");
    if (!Array.isArray(rc) || rc.length % t) throw new Error("poseidonSplitConstants: wrong rc");
    const res = [];
    let tmp = [];
    for(let i = 0; i < rc.length; i++){
        tmp.push(rc[i]);
        if (tmp.length === t) {
            res.push(tmp);
            tmp = [];
        }
    }
    return res;
}
module.exports.splitConstants = $f03e63f7c56bf90a$var$splitConstants;
function $f03e63f7c56bf90a$var$poseidon(opts) {
    const _opts = $f03e63f7c56bf90a$var$validateOpts(opts);
    const { Fp: Fp, mds: mds, roundConstants: roundConstants, rounds: rounds, roundsPartial: roundsPartial, sboxFn: sboxFn, t: t } = _opts;
    const halfRoundsFull = _opts.roundsFull / 2;
    const partialIdx = _opts.reversePartialPowIdx ? t - 1 : 0;
    const poseidonRound = (values, isFull, idx)=>{
        values = values.map((i, j)=>Fp.add(i, roundConstants[idx][j]));
        if (isFull) values = values.map((i)=>sboxFn(i));
        else values[partialIdx] = sboxFn(values[partialIdx]);
        // Matrix multiplication
        values = mds.map((i)=>i.reduce((acc, i, j)=>Fp.add(acc, Fp.mulN(i, values[j])), Fp.ZERO));
        return values;
    };
    const poseidonHash = function poseidonHash(values) {
        if (!Array.isArray(values) || values.length !== t) throw new Error(`Poseidon: wrong values (expected array of bigints with length ${t})`);
        values = values.map((i)=>{
            if (typeof i !== "bigint") throw new Error(`Poseidon: wrong value=${i} (${typeof i})`);
            return Fp.create(i);
        });
        let round = 0;
        // Apply r_f/2 full rounds.
        for(let i = 0; i < halfRoundsFull; i++)values = poseidonRound(values, true, round++);
        // Apply r_p partial rounds.
        for(let i = 0; i < roundsPartial; i++)values = poseidonRound(values, false, round++);
        // Apply r_f/2 full rounds.
        for(let i = 0; i < halfRoundsFull; i++)values = poseidonRound(values, true, round++);
        if (round !== rounds) throw new Error(`Poseidon: wrong number of rounds: last round=${round}, total=${rounds}`);
        return values;
    };
    // For verification in tests
    poseidonHash.roundConstants = roundConstants;
    return poseidonHash;
}
module.exports.poseidon = $f03e63f7c56bf90a$var$poseidon;

});

parcelRegister("2XPJl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapToCurveSimpleSWU = module.exports.SWUFpSqrtRatio = module.exports.weierstrass = module.exports.weierstrassPoints = module.exports.DER = void 0;

var $72AvD = parcelRequire("72AvD");

var $85BMf = parcelRequire("85BMf");

var $85BMf = parcelRequire("85BMf");

var $96Knp = parcelRequire("96Knp");
function $22893804bc1ec99e$var$validatePointOpts(curve) {
    const opts = (0, $96Knp.validateBasic)(curve);
    $85BMf.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $22893804bc1ec99e$var$b2n, hexToBytes: $22893804bc1ec99e$var$h2b } = $85BMf;
module.exports.DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = module.exports.DER;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $22893804bc1ec99e$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = module.exports.DER;
        const data = typeof hex === "string" ? $22893804bc1ec99e$var$h2b(hex) : hex;
        if (!$85BMf.isBytes(data)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = module.exports.DER._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = module.exports.DER._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $22893804bc1ec99e$var$_0n = BigInt(0), $22893804bc1ec99e$var$_1n = BigInt(1), $22893804bc1ec99e$var$_2n = BigInt(2), $22893804bc1ec99e$var$_3n = BigInt(3), $22893804bc1ec99e$var$_4n = BigInt(4);
function $22893804bc1ec99e$var$weierstrassPoints(opts) {
    const CURVE = $22893804bc1ec99e$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $85BMf.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $22893804bc1ec99e$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if ($85BMf.isBytes(key)) key = $85BMf.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $85BMf.bytesToNumberBE((0, $85BMf.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $72AvD.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $85BMf.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $22893804bc1ec99e$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $22893804bc1ec99e$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $22893804bc1ec99e$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $22893804bc1ec99e$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $22893804bc1ec99e$var$_0n || k2 > $22893804bc1ec99e$var$_0n){
                if (k1 & $22893804bc1ec99e$var$_1n) k1p = k1p.add(d);
                if (k2 & $22893804bc1ec99e$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $22893804bc1ec99e$var$_1n;
                k2 >>= $22893804bc1ec99e$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $22893804bc1ec99e$var$_0n || a === $22893804bc1ec99e$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $22893804bc1ec99e$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $22893804bc1ec99e$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $85BMf.bytesToHex(this.toRawBytes(isCompressed));
        }
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $96Knp.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
module.exports.weierstrassPoints = $22893804bc1ec99e$var$weierstrassPoints;
function $22893804bc1ec99e$var$validateOpts(curve) {
    const opts = (0, $96Knp.validateBasic)(curve);
    $85BMf.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $22893804bc1ec99e$var$weierstrass(curveDef) {
    const CURVE = $22893804bc1ec99e$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $22893804bc1ec99e$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $72AvD.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $72AvD.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $22893804bc1ec99e$var$weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $85BMf.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $85BMf.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $22893804bc1ec99e$var$_1n) === $22893804bc1ec99e$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$85BMf.bytesToHex($85BMf.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $22893804bc1ec99e$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$85BMf.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $85BMf.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = module.exports.DER.toSig((0, $85BMf.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $85BMf.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $85BMf.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return module.exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $85BMf.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $72AvD.getMinHashLength(CURVE.n);
            return $72AvD.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = $85BMf.isBytes(item);
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $85BMf.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $85BMf.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($22893804bc1ec99e$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $85BMf.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $85BMf.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $85BMf.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $85BMf.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $85BMf.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $22893804bc1ec99e$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $22893804bc1ec99e$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $22893804bc1ec99e$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $85BMf.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        var _Point_BASE_multiplyAndAddUnsafe;
        const sg = signature;
        msgHash = (0, $85BMf.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $85BMf.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || $85BMf.isBytes(sg)) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof module.exports.DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = (_Point_BASE_multiplyAndAddUnsafe = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)) === null || _Point_BASE_multiplyAndAddUnsafe === void 0 ? void 0 : _Point_BASE_multiplyAndAddUnsafe.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
module.exports.weierstrass = $22893804bc1ec99e$var$weierstrass;
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function $22893804bc1ec99e$var$SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $22893804bc1ec99e$var$_0n;
    for(let o = q - $22893804bc1ec99e$var$_1n; o % $22893804bc1ec99e$var$_2n === $22893804bc1ec99e$var$_0n; o /= $22893804bc1ec99e$var$_2n)l += $22893804bc1ec99e$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $22893804bc1ec99e$var$_2n << c1 - $22893804bc1ec99e$var$_1n - $22893804bc1ec99e$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $22893804bc1ec99e$var$_2n;
    const c2 = (q - $22893804bc1ec99e$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $22893804bc1ec99e$var$_1n) / $22893804bc1ec99e$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $22893804bc1ec99e$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $22893804bc1ec99e$var$_1n) / $22893804bc1ec99e$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $22893804bc1ec99e$var$_1n; i--){
            let tv5 = i - $22893804bc1ec99e$var$_2n; // 18.    tv5 = i - 2
            tv5 = $22893804bc1ec99e$var$_2n << tv5 - $22893804bc1ec99e$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $22893804bc1ec99e$var$_4n === $22893804bc1ec99e$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $22893804bc1ec99e$var$_3n) / $22893804bc1ec99e$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
module.exports.SWUFpSqrtRatio = $22893804bc1ec99e$var$SWUFpSqrtRatio;
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function $22893804bc1ec99e$var$mapToCurveSimpleSWU(Fp, opts) {
    $72AvD.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $22893804bc1ec99e$var$SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}
module.exports.mapToCurveSimpleSWU = $22893804bc1ec99e$var$mapToCurveSimpleSWU;

});
parcelRegister("96Knp", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateBasic = exports.wNAF = void 0;

var $72AvD = parcelRequire("72AvD");

var $85BMf = parcelRequire("85BMf");
const _0n = BigInt(0);
const _1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
exports.wNAF = wNAF;
function validateBasic(curve) {
    (0, $72AvD.validateField)(curve.Fp);
    (0, $85BMf.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $72AvD.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
exports.validateBasic = validateBasic;

});


parcelRegister("dVBXd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createCurve = module.exports.getHash = void 0;

var $a6NnD = parcelRequire("a6NnD");

var $bdetq = parcelRequire("bdetq");

var $2XPJl = parcelRequire("2XPJl");
// connects noble-curves to noble-hashes
function $029de763977315b2$var$getHash(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $a6NnD.hmac)(hash, key, (0, $bdetq.concatBytes)(...msgs)),
        randomBytes: $bdetq.randomBytes
    };
}
module.exports.getHash = $029de763977315b2$var$getHash;
function $029de763977315b2$var$createCurve(curveDef, defHash) {
    const create = (hash)=>(0, $2XPJl.weierstrass)({
            ...curveDef,
            ...$029de763977315b2$var$getHash(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}
module.exports.createCurve = $029de763977315b2$var$createCurve;

});
parcelRegister("a6NnD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac = module.exports.HMAC = void 0;

var $4hg6I = parcelRequire("4hg6I");

var $bdetq = parcelRequire("bdetq");
// HMAC (RFC 2104)
class $75c0c4c6f45ed63f$var$HMAC extends $bdetq.Hash {
    update(buf) {
        (0, $4hg6I.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $4hg6I.exists)(this);
        (0, $4hg6I.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $4hg6I.hash)(hash);
        const key = (0, $bdetq.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
}
module.exports.HMAC = $75c0c4c6f45ed63f$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const $75c0c4c6f45ed63f$var$hmac = (hash, key, message)=>new $75c0c4c6f45ed63f$var$HMAC(hash, key).update(message).digest();
module.exports.hmac = $75c0c4c6f45ed63f$var$hmac;
module.exports.hmac.create = (hash, key)=>new $75c0c4c6f45ed63f$var$HMAC(hash, key);

});



parcelRegister("8fWHv", function(module, exports) {
!function(t, r) {
    r(module.exports);
}(module.exports, function(t) {
    "use strict";
    function r(t) {
        return n.test(t);
    }
    var n = /^-?[0-9]+$/;
    function e(t) {
        return o.test(t);
    }
    var o = /^-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?$/;
    function i(t, n) {
        var e = parseFloat(t), o = String(e), i = u(t), a = u(o);
        if (i === a) return !0;
        if (!0 === (null == n ? void 0 : n.approx)) {
            if (!r(t) && a.length >= 14 && i.startsWith(a.substring(0, 14))) return !0;
        }
        return !1;
    }
    var a = function(t) {
        return t.underflow = "underflow", t.overflow = "overflow", t.truncate_integer = "truncate_integer", t.truncate_float = "truncate_float", t;
    }({});
    function c(t) {
        if (!i(t, {
            approx: !1
        })) {
            if (r(t)) return a.truncate_integer;
            var n = parseFloat(t);
            return isFinite(n) ? 0 === n ? a.underflow : a.truncate_float : a.overflow;
        }
    }
    function u(t) {
        return t.replace(f, "").replace(s, "").replace(y, "").replace(l, "");
    }
    var f = /[eE][+-]?\d+$/, l = /^-?(0*)?/, s = /\./, y = /0+$/;
    function d(t) {
        return d = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t;
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, d(t);
    }
    function p(t, r) {
        for(var n = 0; n < r.length; n++){
            var e = r[n];
            e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(t, v(e.key), e);
        }
    }
    function v(t) {
        var r = function(t, r) {
            if ("object" !== d(t) || null === t) return t;
            var n = t[Symbol.toPrimitive];
            if (void 0 !== n) {
                var e = n.call(t, r || "default");
                if ("object" !== d(e)) return e;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === r ? String : Number)(t);
        }(t, "string");
        return "symbol" === d(r) ? r : String(r);
    }
    var b = function() {
        function t(r) {
            if (function(t, r) {
                if (!(t instanceof r)) throw new TypeError("Cannot call a class as a function");
            }(this, t), function(t, r, n) {
                (r = v(r)) in t ? Object.defineProperty(t, r, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[r] = n;
            }(this, "isLosslessNumber", !0), !e(r)) throw new Error('Invalid number (value: "' + r + '")');
            this.value = r;
        }
        var n, o, i;
        return n = t, o = [
            {
                key: "valueOf",
                value: function() {
                    var t = c(this.value);
                    if (void 0 === t || t === a.truncate_float) return parseFloat(this.value);
                    if (r(this.value)) return BigInt(this.value);
                    throw new Error("Cannot safely convert to number: " + "the value '".concat(this.value, "' would ").concat(t, " and become ").concat(parseFloat(this.value)));
                }
            },
            {
                key: "toString",
                value: function() {
                    return this.value;
                }
            }
        ], p(n.prototype, o), i && p(n, i), Object.defineProperty(n, "prototype", {
            writable: !1
        }), t;
    }();
    function h(t) {
        return t && "object" === d(t) && !0 === t.isLosslessNumber || !1;
    }
    function m(t) {
        return new b(t);
    }
    function w(t) {
        return w = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t;
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, w(t);
    }
    function g(t, r, n, e) {
        return Array.isArray(n) ? e.call(t, r, function(t, r) {
            for(var n = 0; n < t.length; n++)t[n] = g(t, n + "", t[n], r);
            return t;
        }(n, e)) : n && "object" === w(n) && !h(n) ? e.call(t, r, function(t, r) {
            return Object.keys(t).forEach(function(n) {
                var e = g(t, n, t[n], r);
                void 0 !== e ? t[n] = e : delete t[n];
            }), t;
        }(n, e)) : e.call(t, r, n);
    }
    function S(t) {
        return S = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t;
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, S(t);
    }
    function A(t) {
        return function(t) {
            if (Array.isArray(t)) return C(t);
        }(t) || function(t) {
            if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
        }(t) || function(t, r) {
            if (!t) return;
            if ("string" == typeof t) return C(t, r);
            var n = Object.prototype.toString.call(t).slice(8, -1);
            "Object" === n && t.constructor && (n = t.constructor.name);
            if ("Map" === n || "Set" === n) return Array.from(t);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return C(t, r);
        }(t) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function C(t, r) {
        (null == r || r > t.length) && (r = t.length);
        for(var n = 0, e = new Array(r); n < r; n++)e[n] = t[n];
        return e;
    }
    function x(t) {
        return t >= U && t <= M || t >= z && t <= V || t >= G && t <= X;
    }
    function E(t) {
        return t >= U && t <= M;
    }
    function N(t, r) {
        return t === r || (Array.isArray(t) && Array.isArray(r) ? t.length === r.length && t.every(function(t, n) {
            return N(t, r[n]);
        }) : !(!j(t) || !j(r)) && A(new Set([].concat(A(Object.keys(t)), A(Object.keys(r))))).every(function(n) {
            return N(t[n], r[n]);
        }));
    }
    function j(t) {
        return "object" === S(t) && null !== t;
    }
    var O = {
        '"': '"',
        "\\": "\\",
        "/": "/",
        b: "\b",
        f: "\f",
        n: "\n",
        r: "\r",
        t: "	"
    }, I = 92, k = 123, _ = 125, F = 91, J = 93, L = 32, T = 10, $ = 9, P = 13, B = 34, D = 43, R = 45, U = 48, Q = 49, M = 57, W = 44, Z = 46, q = 58, z = 65, G = 97, H = 69, K = 101, V = 70, X = 102;
    function Y(t) {
        return Y = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t;
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, Y(t);
    }
    var tt = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
    t.LosslessNumber = b, t.UnsafeNumberReason = a, t.config = function(t) {
        throw new Error("config is deprecated, support for circularRefs is removed from the library. If you encounter circular references in your data structures, please rethink your datastructures: better prevent circular references in the first place.");
    }, t.getUnsafeNumberReason = c, t.isInteger = r, t.isLosslessNumber = h, t.isNumber = e, t.isSafeNumber = i, t.parse = function(t, r) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : m, e = 0, o = c();
        return function(t) {
            if (void 0 === t) throw new SyntaxError("JSON value expected ".concat(j()));
        }(o), function() {
            if (e < t.length) throw new SyntaxError("Expected end of input ".concat(j()));
        }(), r ? function(t, r) {
            return g({
                "": t
            }, "", t, r);
        }(o, r) : o;
        function i() {
            if (t.charCodeAt(e) === k) {
                e++, f();
                for(var r = {}, n = !0; e < t.length && t.charCodeAt(e) !== _;){
                    n ? n = !1 : (s(), f());
                    var o = e, i = l();
                    void 0 === i && v(), f(), y();
                    var a = c();
                    void 0 === a && S(), Object.prototype.hasOwnProperty.call(r, i) && !N(a, r[i]) && b(i, o + 1), r[i] = a;
                }
                return t.charCodeAt(e) !== _ && function() {
                    throw new SyntaxError("Quoted object key or end of object '}' expected ".concat(j()));
                }(), e++, r;
            }
        }
        function a() {
            if (t.charCodeAt(e) === F) {
                e++, f();
                for(var r = [], n = !0; e < t.length && t.charCodeAt(e) !== J;){
                    n ? n = !1 : s();
                    var o = c();
                    d(o), r.push(o);
                }
                return t.charCodeAt(e) !== J && function() {
                    throw new SyntaxError("Array item or end of array ']' expected ".concat(j()));
                }(), e++, r;
            }
        }
        function c() {
            var r, o, c, s, y, d;
            f();
            var v = null !== (r = null !== (o = null !== (c = null !== (s = null !== (y = null !== (d = l()) && void 0 !== d ? d : function() {
                var r = e;
                t.charCodeAt(e) === R && (e++, p(r));
                if (t.charCodeAt(e) === U) e++;
                else if (o = t.charCodeAt(e), o >= Q && o <= M) for(e++; E(t.charCodeAt(e));)e++;
                var o;
                if (t.charCodeAt(e) === Z) for(e++, p(r); E(t.charCodeAt(e));)e++;
                if (t.charCodeAt(e) === K || t.charCodeAt(e) === H) for(e++, t.charCodeAt(e) !== R && t.charCodeAt(e) !== D || e++, p(r); E(t.charCodeAt(e));)e++;
                if (e > r) return n(t.slice(r, e));
            }()) && void 0 !== y ? y : i()) && void 0 !== s ? s : a()) && void 0 !== c ? c : u("true", !0)) && void 0 !== o ? o : u("false", !1)) && void 0 !== r ? r : u("null", null);
            return f(), v;
        }
        function u(r, n) {
            if (t.slice(e, e + r.length) === r) return e += r.length, n;
        }
        function f() {
            for(; (r = t.charCodeAt(e)) === L || r === T || r === $ || r === P;)e++;
            var r;
        }
        function l() {
            if (t.charCodeAt(e) === B) {
                e++;
                for(var r = ""; e < t.length && t.charCodeAt(e) !== B;){
                    if (t.charCodeAt(e) === I) {
                        var n = t[e + 1], o = O[n];
                        void 0 !== o ? (r += o, e++) : "u" === n ? x(t.charCodeAt(e + 2)) && x(t.charCodeAt(e + 3)) && x(t.charCodeAt(e + 4)) && x(t.charCodeAt(e + 5)) ? (r += String.fromCharCode(parseInt(t.slice(e + 2, e + 6), 16)), e += 5) : A(e) : w(e);
                    } else (i = t.charCodeAt(e)) >= 32 && i <= 1114111 ? r += t[e] : h(t[e]);
                    e++;
                }
                return function() {
                    if (t.charCodeAt(e) !== B) throw new SyntaxError("End of string '\"' expected ".concat(j()));
                }(), e++, r;
            }
            var i;
        }
        function s() {
            if (t.charCodeAt(e) !== W) throw new SyntaxError("Comma ',' expected after value ".concat(j()));
            e++;
        }
        function y() {
            if (t.charCodeAt(e) !== q) throw new SyntaxError("Colon ':' expected after property name ".concat(j()));
            e++;
        }
        function d(t) {
            if (void 0 === t) throw new SyntaxError("Array item expected ".concat(j()));
        }
        function p(r) {
            if (!E(t.charCodeAt(e))) {
                var n = t.slice(r, e);
                throw new SyntaxError("Invalid number '".concat(n, "', expecting a digit ").concat(j()));
            }
        }
        function v() {
            throw new SyntaxError("Quoted object key expected ".concat(j()));
        }
        function b(t, r) {
            throw new SyntaxError("Duplicate key '".concat(t, "' encountered at position ").concat(r));
        }
        function h(t) {
            throw new SyntaxError("Invalid character '".concat(t, "' ").concat(C()));
        }
        function w(r) {
            var n = t.slice(r, r + 2);
            throw new SyntaxError("Invalid escape character '".concat(n, "' ").concat(C()));
        }
        function S() {
            throw new SyntaxError("Object value expected after ':' ".concat(C()));
        }
        function A(r) {
            for(var n = r + 2; /\w/.test(t[n]);)n++;
            var e = t.slice(r, n);
            throw new SyntaxError("Invalid unicode character '".concat(e, "' ").concat(C()));
        }
        function C() {
            return "at position ".concat(e);
        }
        function j() {
            return (e < t.length ? "but got '".concat(t[e], "'") : "but reached end of input") + " " + C();
        }
    }, t.parseLosslessNumber = m, t.parseNumberAndBigInt = function(t) {
        return r(t) ? BigInt(t) : parseFloat(t);
    }, t.reviveDate = function(t, r) {
        return "string" == typeof r && tt.test(r) ? new Date(r) : r;
    }, t.stringify = function t(r, n, o, i) {
        var a = function(t) {
            if ("number" == typeof t) return " ".repeat(t);
            if ("string" == typeof t && "" !== t) return t;
            return;
        }(o);
        return c("function" == typeof n ? n.call({
            "": r
        }, "", r) : r, "");
        function c(r, u) {
            if (Array.isArray(i)) {
                var f = i.find(function(t) {
                    return t.test(r);
                });
                if (f) {
                    var l = f.stringify(r);
                    if ("string" != typeof l || !e(l)) throw new Error("Invalid JSON number: output of a number stringifier must be a string containing a JSON number " + "(output: ".concat(l, ")"));
                    return l;
                }
            }
            return "boolean" == typeof r || "number" == typeof r || "string" == typeof r || null === r || r instanceof Date || r instanceof Boolean || r instanceof Number || r instanceof String ? JSON.stringify(r) : r && r.isLosslessNumber || "bigint" == typeof r ? r.toString() : Array.isArray(r) ? function(t, r) {
                if (0 === t.length) return "[]";
                for(var e = a ? r + a : void 0, o = a ? "[\n" : "[", i = 0; i < t.length; i++){
                    var u = "function" == typeof n ? n.call(t, String(i), t[i]) : t[i];
                    a && (o += e), o += void 0 !== u && "function" != typeof u ? c(u, e) : "null", i < t.length - 1 && (o += a ? ",\n" : ",");
                }
                return o += a ? "\n" + r + "]" : "]", o;
            }(r, u) : r && "object" === Y(r) ? function(r, e) {
                if ("function" == typeof r.toJSON) return t(r.toJSON(), n, o, void 0);
                var i = Array.isArray(n) ? n.map(String) : Object.keys(r);
                if (0 === i.length) return "{}";
                var u = a ? e + a : void 0, f = !0, l = a ? "{\n" : "{";
                return i.forEach(function(t) {
                    var e = "function" == typeof n ? n.call(r, t, r[t]) : r[t];
                    if (function(t, r) {
                        return void 0 !== r && "function" != typeof r && "symbol" !== Y(r);
                    }(0, e)) {
                        f ? f = !1 : l += a ? ",\n" : ",";
                        var o = JSON.stringify(t);
                        l += a ? u + o + ": " : o + ":", l += c(e, u);
                    }
                }), l += a ? "\n" + e + "}" : "}", l;
            }(r, u) : void 0;
        }
    }, t.toLosslessNumber = function(t) {
        if (u(t + "").length > 15) throw new Error("Invalid number: contains more than 15 digits and is most likely truncated and unsafe by itself " + "(value: ".concat(t, ")"));
        if (isNaN(t)) throw new Error("Invalid number: NaN");
        if (!isFinite(t)) throw new Error("Invalid number: " + t);
        return new b(String(t));
    }, t.toSafeNumberOrThrow = function(t, r) {
        var n = parseFloat(t), e = c(t);
        if (!0 === (null == r ? void 0 : r.approx) ? e && e !== a.truncate_float : e) {
            var o = e.replace(/_\w+$/, "");
            throw new Error("Cannot safely convert to number: " + "the value '".concat(t, "' would ").concat(o, " and become ").concat(n));
        }
        return n;
    };
});

});

parcelRegister("kGJ2Q", function(module, exports) {

$parcel$export(module.exports, "gzip", function () { return $ae290cc08e298ace$export$69f0ea7cf3a331a8; });
$parcel$export(module.exports, "ungzip", function () { return $ae290cc08e298ace$export$95adf9d270383091; });
/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */ // (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const $ae290cc08e298ace$var$Z_FIXED$1 = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ const $ae290cc08e298ace$var$Z_BINARY = 0;
const $ae290cc08e298ace$var$Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const $ae290cc08e298ace$var$Z_UNKNOWN$1 = 2;
/*============================================================================*/ function $ae290cc08e298ace$var$zero$1(buf) {
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
const $ae290cc08e298ace$var$STORED_BLOCK = 0;
const $ae290cc08e298ace$var$STATIC_TREES = 1;
const $ae290cc08e298ace$var$DYN_TREES = 2;
/* The three kinds of block type */ const $ae290cc08e298ace$var$MIN_MATCH$1 = 3;
const $ae290cc08e298ace$var$MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ const $ae290cc08e298ace$var$LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $ae290cc08e298ace$var$LITERALS$1 = 256;
/* number of literal bytes 0..255 */ const $ae290cc08e298ace$var$L_CODES$1 = $ae290cc08e298ace$var$LITERALS$1 + 1 + $ae290cc08e298ace$var$LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ const $ae290cc08e298ace$var$D_CODES$1 = 30;
/* number of distance codes */ const $ae290cc08e298ace$var$BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ const $ae290cc08e298ace$var$HEAP_SIZE$1 = 2 * $ae290cc08e298ace$var$L_CODES$1 + 1;
/* maximum heap size */ const $ae290cc08e298ace$var$MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ const $ae290cc08e298ace$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ const $ae290cc08e298ace$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ const $ae290cc08e298ace$var$END_BLOCK = 256;
/* end of block literal code */ const $ae290cc08e298ace$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ const $ae290cc08e298ace$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ const $ae290cc08e298ace$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ const $ae290cc08e298ace$var$extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
const $ae290cc08e298ace$var$extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
const $ae290cc08e298ace$var$extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
const $ae290cc08e298ace$var$bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
const $ae290cc08e298ace$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const $ae290cc08e298ace$var$static_ltree = new Array(($ae290cc08e298ace$var$L_CODES$1 + 2) * 2);
$ae290cc08e298ace$var$zero$1($ae290cc08e298ace$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ const $ae290cc08e298ace$var$static_dtree = new Array($ae290cc08e298ace$var$D_CODES$1 * 2);
$ae290cc08e298ace$var$zero$1($ae290cc08e298ace$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ const $ae290cc08e298ace$var$_dist_code = new Array($ae290cc08e298ace$var$DIST_CODE_LEN);
$ae290cc08e298ace$var$zero$1($ae290cc08e298ace$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ const $ae290cc08e298ace$var$_length_code = new Array($ae290cc08e298ace$var$MAX_MATCH$1 - $ae290cc08e298ace$var$MIN_MATCH$1 + 1);
$ae290cc08e298ace$var$zero$1($ae290cc08e298ace$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ const $ae290cc08e298ace$var$base_length = new Array($ae290cc08e298ace$var$LENGTH_CODES$1);
$ae290cc08e298ace$var$zero$1($ae290cc08e298ace$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ const $ae290cc08e298ace$var$base_dist = new Array($ae290cc08e298ace$var$D_CODES$1);
$ae290cc08e298ace$var$zero$1($ae290cc08e298ace$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $ae290cc08e298ace$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
let $ae290cc08e298ace$var$static_l_desc;
let $ae290cc08e298ace$var$static_d_desc;
let $ae290cc08e298ace$var$static_bl_desc;
function $ae290cc08e298ace$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
const $ae290cc08e298ace$var$d_code = (dist)=>{
    return dist < 256 ? $ae290cc08e298ace$var$_dist_code[dist] : $ae290cc08e298ace$var$_dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ const $ae290cc08e298ace$var$put_short = (s, w)=>{
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ const $ae290cc08e298ace$var$send_bits = (s, value, length)=>{
    if (s.bi_valid > $ae290cc08e298ace$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $ae290cc08e298ace$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $ae290cc08e298ace$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $ae290cc08e298ace$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
const $ae290cc08e298ace$var$send_code = (s, c, tree)=>{
    $ae290cc08e298ace$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ const $ae290cc08e298ace$var$bi_reverse = (code, len)=>{
    let res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ const $ae290cc08e298ace$var$bi_flush = (s)=>{
    if (s.bi_valid === 16) {
        $ae290cc08e298ace$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ const $ae290cc08e298ace$var$gen_bitlen = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */
    const tree = desc.dyn_tree;
    const max_code = desc.max_code;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const extra = desc.stat_desc.extra_bits;
    const base = desc.stat_desc.extra_base;
    const max_length = desc.stat_desc.max_length;
    let h; /* heap index */ 
    let n, m; /* iterate over the tree elements */ 
    let bits; /* bit length */ 
    let xbits; /* extra bits */ 
    let f; /* frequency */ 
    let overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $ae290cc08e298ace$var$MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $ae290cc08e298ace$var$HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Tracev((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ const $ae290cc08e298ace$var$gen_codes = (tree, max_code, bl_count)=>{
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    const next_code = new Array($ae290cc08e298ace$var$MAX_BITS$1 + 1); /* next code value for each bit length */ 
    let code = 0; /* running code value */ 
    let bits; /* bit index */ 
    let n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $ae290cc08e298ace$var$MAX_BITS$1; bits++){
        code = code + bl_count[bits - 1] << 1;
        next_code[bits] = code;
    }
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        let len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $ae290cc08e298ace$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ const $ae290cc08e298ace$var$tr_static_init = ()=>{
    let n; /* iterates over tree elements */ 
    let bits; /* bit counter */ 
    let length; /* length value */ 
    let code; /* code value */ 
    let dist; /* distance index */ 
    const bl_count = new Array($ae290cc08e298ace$var$MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $ae290cc08e298ace$var$LENGTH_CODES$1 - 1; code++){
        $ae290cc08e298ace$var$base_length[code] = length;
        for(n = 0; n < 1 << $ae290cc08e298ace$var$extra_lbits[code]; n++)$ae290cc08e298ace$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $ae290cc08e298ace$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $ae290cc08e298ace$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $ae290cc08e298ace$var$extra_dbits[code]; n++)$ae290cc08e298ace$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $ae290cc08e298ace$var$D_CODES$1; code++){
        $ae290cc08e298ace$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $ae290cc08e298ace$var$extra_dbits[code] - 7; n++)$ae290cc08e298ace$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $ae290cc08e298ace$var$MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $ae290cc08e298ace$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $ae290cc08e298ace$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $ae290cc08e298ace$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $ae290cc08e298ace$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $ae290cc08e298ace$var$gen_codes($ae290cc08e298ace$var$static_ltree, $ae290cc08e298ace$var$L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $ae290cc08e298ace$var$D_CODES$1; n++){
        $ae290cc08e298ace$var$static_dtree[n * 2 + 1] = 5;
        $ae290cc08e298ace$var$static_dtree[n * 2] = $ae290cc08e298ace$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $ae290cc08e298ace$var$static_l_desc = new $ae290cc08e298ace$var$StaticTreeDesc($ae290cc08e298ace$var$static_ltree, $ae290cc08e298ace$var$extra_lbits, $ae290cc08e298ace$var$LITERALS$1 + 1, $ae290cc08e298ace$var$L_CODES$1, $ae290cc08e298ace$var$MAX_BITS$1);
    $ae290cc08e298ace$var$static_d_desc = new $ae290cc08e298ace$var$StaticTreeDesc($ae290cc08e298ace$var$static_dtree, $ae290cc08e298ace$var$extra_dbits, 0, $ae290cc08e298ace$var$D_CODES$1, $ae290cc08e298ace$var$MAX_BITS$1);
    $ae290cc08e298ace$var$static_bl_desc = new $ae290cc08e298ace$var$StaticTreeDesc(new Array(0), $ae290cc08e298ace$var$extra_blbits, 0, $ae290cc08e298ace$var$BL_CODES$1, $ae290cc08e298ace$var$MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ const $ae290cc08e298ace$var$init_block = (s)=>{
    let n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $ae290cc08e298ace$var$L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $ae290cc08e298ace$var$D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $ae290cc08e298ace$var$BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$ae290cc08e298ace$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.sym_next = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ const $ae290cc08e298ace$var$bi_windup = (s)=>{
    if (s.bi_valid > 8) $ae290cc08e298ace$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ const $ae290cc08e298ace$var$smaller = (tree, n, m, depth)=>{
    const _n2 = n * 2;
    const _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ const $ae290cc08e298ace$var$pqdownheap = (s, tree, k)=>{
    //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */
    const v = s.heap[k];
    let j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $ae290cc08e298ace$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($ae290cc08e298ace$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ const $ae290cc08e298ace$var$compress_block = (s, ltree, dtree)=>{
    //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */
    let dist; /* distance of matched string */ 
    let lc; /* match length or unmatched char (if dist == 0) */ 
    let sx = 0; /* running index in sym_buf */ 
    let code; /* the code to send */ 
    let extra; /* number of extra bits to send */ 
    if (s.sym_next !== 0) do {
        dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
        dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
        lc = s.pending_buf[s.sym_buf + sx++];
        if (dist === 0) $ae290cc08e298ace$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $ae290cc08e298ace$var$_length_code[lc];
            $ae290cc08e298ace$var$send_code(s, code + $ae290cc08e298ace$var$LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = $ae290cc08e298ace$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $ae290cc08e298ace$var$base_length[code];
                $ae290cc08e298ace$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $ae290cc08e298ace$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $ae290cc08e298ace$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $ae290cc08e298ace$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $ae290cc08e298ace$var$base_dist[code];
                $ae290cc08e298ace$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and sym_buf is ok: */ //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
    }while (sx < s.sym_next);
    $ae290cc08e298ace$var$send_code(s, $ae290cc08e298ace$var$END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ const $ae290cc08e298ace$var$build_tree = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc; /* the tree descriptor */
    const tree = desc.dyn_tree;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const elems = desc.stat_desc.elems;
    let n, m; /* iterate over heap elements */ 
    let max_code = -1; /* largest code with non zero frequency */ 
    let node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $ae290cc08e298ace$var$HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$ae290cc08e298ace$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $ae290cc08e298ace$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $ae290cc08e298ace$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $ae290cc08e298ace$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $ae290cc08e298ace$var$gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ const $ae290cc08e298ace$var$scan_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$ae290cc08e298ace$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$ae290cc08e298ace$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$ae290cc08e298ace$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ const $ae290cc08e298ace$var$send_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $ae290cc08e298ace$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $ae290cc08e298ace$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $ae290cc08e298ace$var$send_code(s, $ae290cc08e298ace$var$REP_3_6, s.bl_tree);
            $ae290cc08e298ace$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $ae290cc08e298ace$var$send_code(s, $ae290cc08e298ace$var$REPZ_3_10, s.bl_tree);
            $ae290cc08e298ace$var$send_bits(s, count - 3, 3);
        } else {
            $ae290cc08e298ace$var$send_code(s, $ae290cc08e298ace$var$REPZ_11_138, s.bl_tree);
            $ae290cc08e298ace$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ const $ae290cc08e298ace$var$build_bl_tree = (s)=>{
    let max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $ae290cc08e298ace$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $ae290cc08e298ace$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $ae290cc08e298ace$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $ae290cc08e298ace$var$BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$ae290cc08e298ace$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ const $ae290cc08e298ace$var$send_all_trees = (s, lcodes, dcodes, blcodes)=>{
    //    deflate_state *s;
    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
    let rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $ae290cc08e298ace$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $ae290cc08e298ace$var$send_bits(s, dcodes - 1, 5);
    $ae290cc08e298ace$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $ae290cc08e298ace$var$send_bits(s, s.bl_tree[$ae290cc08e298ace$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $ae290cc08e298ace$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $ae290cc08e298ace$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ const $ae290cc08e298ace$var$detect_data_type = (s)=>{
    /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ let block_mask = 0xf3ffc07f;
    let n;
    /* Check for non-textual ("block-listed") bytes. */ for(n = 0; n <= 31; n++, block_mask >>>= 1){
        if (block_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $ae290cc08e298ace$var$Z_BINARY;
    }
    /* Check for textual ("allow-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $ae290cc08e298ace$var$Z_TEXT;
    for(n = 32; n < $ae290cc08e298ace$var$LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $ae290cc08e298ace$var$Z_TEXT;
    }
    /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $ae290cc08e298ace$var$Z_BINARY;
};
let $ae290cc08e298ace$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ const $ae290cc08e298ace$var$_tr_init$1 = (s)=>{
    if (!$ae290cc08e298ace$var$static_init_done) {
        $ae290cc08e298ace$var$tr_static_init();
        $ae290cc08e298ace$var$static_init_done = true;
    }
    s.l_desc = new $ae290cc08e298ace$var$TreeDesc(s.dyn_ltree, $ae290cc08e298ace$var$static_l_desc);
    s.d_desc = new $ae290cc08e298ace$var$TreeDesc(s.dyn_dtree, $ae290cc08e298ace$var$static_d_desc);
    s.bl_desc = new $ae290cc08e298ace$var$TreeDesc(s.bl_tree, $ae290cc08e298ace$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $ae290cc08e298ace$var$init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ const $ae290cc08e298ace$var$_tr_stored_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    $ae290cc08e298ace$var$send_bits(s, ($ae290cc08e298ace$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $ae290cc08e298ace$var$bi_windup(s); /* align on byte boundary */ 
    $ae290cc08e298ace$var$put_short(s, stored_len);
    $ae290cc08e298ace$var$put_short(s, ~stored_len);
    if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
    s.pending += stored_len;
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ const $ae290cc08e298ace$var$_tr_align$1 = (s)=>{
    $ae290cc08e298ace$var$send_bits(s, $ae290cc08e298ace$var$STATIC_TREES << 1, 3);
    $ae290cc08e298ace$var$send_code(s, $ae290cc08e298ace$var$END_BLOCK, $ae290cc08e298ace$var$static_ltree);
    $ae290cc08e298ace$var$bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */ const $ae290cc08e298ace$var$_tr_flush_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block, or NULL if too old */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    let opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    let max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $ae290cc08e298ace$var$Z_UNKNOWN$1) s.strm.data_type = $ae290cc08e298ace$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $ae290cc08e298ace$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $ae290cc08e298ace$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $ae290cc08e298ace$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->sym_next / 3));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $ae290cc08e298ace$var$_tr_stored_block$1(s, buf, stored_len, last);
    else if (s.strategy === $ae290cc08e298ace$var$Z_FIXED$1 || static_lenb === opt_lenb) {
        $ae290cc08e298ace$var$send_bits(s, ($ae290cc08e298ace$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $ae290cc08e298ace$var$compress_block(s, $ae290cc08e298ace$var$static_ltree, $ae290cc08e298ace$var$static_dtree);
    } else {
        $ae290cc08e298ace$var$send_bits(s, ($ae290cc08e298ace$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $ae290cc08e298ace$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $ae290cc08e298ace$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $ae290cc08e298ace$var$init_block(s);
    if (last) $ae290cc08e298ace$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ const $ae290cc08e298ace$var$_tr_tally$1 = (s, dist, lc)=>{
    //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
    s.pending_buf[s.sym_buf + s.sym_next++] = dist;
    s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
    s.pending_buf[s.sym_buf + s.sym_next++] = lc;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($ae290cc08e298ace$var$_length_code[lc] + $ae290cc08e298ace$var$LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[$ae290cc08e298ace$var$d_code(dist) * 2]++;
    }
    return s.sym_next === s.sym_end;
};
var $ae290cc08e298ace$var$_tr_init_1 = $ae290cc08e298ace$var$_tr_init$1;
var $ae290cc08e298ace$var$_tr_stored_block_1 = $ae290cc08e298ace$var$_tr_stored_block$1;
var $ae290cc08e298ace$var$_tr_flush_block_1 = $ae290cc08e298ace$var$_tr_flush_block$1;
var $ae290cc08e298ace$var$_tr_tally_1 = $ae290cc08e298ace$var$_tr_tally$1;
var $ae290cc08e298ace$var$_tr_align_1 = $ae290cc08e298ace$var$_tr_align$1;
var $ae290cc08e298ace$var$trees = {
    _tr_init: $ae290cc08e298ace$var$_tr_init_1,
    _tr_stored_block: $ae290cc08e298ace$var$_tr_stored_block_1,
    _tr_flush_block: $ae290cc08e298ace$var$_tr_flush_block_1,
    _tr_tally: $ae290cc08e298ace$var$_tr_tally_1,
    _tr_align: $ae290cc08e298ace$var$_tr_align_1
};
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $ae290cc08e298ace$var$adler32 = (adler, buf, len, pos)=>{
    let s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
var $ae290cc08e298ace$var$adler32_1 = $ae290cc08e298ace$var$adler32;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
const $ae290cc08e298ace$var$makeTable = ()=>{
    let c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
const $ae290cc08e298ace$var$crcTable = new Uint32Array($ae290cc08e298ace$var$makeTable());
const $ae290cc08e298ace$var$crc32 = (crc, buf, len, pos)=>{
    const t = $ae290cc08e298ace$var$crcTable;
    const end = pos + len;
    crc ^= -1;
    for(let i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
var $ae290cc08e298ace$var$crc32_1 = $ae290cc08e298ace$var$crc32;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $ae290cc08e298ace$var$messages = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $ae290cc08e298ace$var$constants$2 = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const { _tr_init: $ae290cc08e298ace$var$_tr_init, _tr_stored_block: $ae290cc08e298ace$var$_tr_stored_block, _tr_flush_block: $ae290cc08e298ace$var$_tr_flush_block, _tr_tally: $ae290cc08e298ace$var$_tr_tally, _tr_align: $ae290cc08e298ace$var$_tr_align } = $ae290cc08e298ace$var$trees;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $ae290cc08e298ace$var$Z_NO_FLUSH$2, Z_PARTIAL_FLUSH: $ae290cc08e298ace$var$Z_PARTIAL_FLUSH, Z_FULL_FLUSH: $ae290cc08e298ace$var$Z_FULL_FLUSH$1, Z_FINISH: $ae290cc08e298ace$var$Z_FINISH$3, Z_BLOCK: $ae290cc08e298ace$var$Z_BLOCK$1, Z_OK: $ae290cc08e298ace$var$Z_OK$3, Z_STREAM_END: $ae290cc08e298ace$var$Z_STREAM_END$3, Z_STREAM_ERROR: $ae290cc08e298ace$var$Z_STREAM_ERROR$2, Z_DATA_ERROR: $ae290cc08e298ace$var$Z_DATA_ERROR$2, Z_BUF_ERROR: $ae290cc08e298ace$var$Z_BUF_ERROR$1, Z_DEFAULT_COMPRESSION: $ae290cc08e298ace$var$Z_DEFAULT_COMPRESSION$1, Z_FILTERED: $ae290cc08e298ace$var$Z_FILTERED, Z_HUFFMAN_ONLY: $ae290cc08e298ace$var$Z_HUFFMAN_ONLY, Z_RLE: $ae290cc08e298ace$var$Z_RLE, Z_FIXED: $ae290cc08e298ace$var$Z_FIXED, Z_DEFAULT_STRATEGY: $ae290cc08e298ace$var$Z_DEFAULT_STRATEGY$1, Z_UNKNOWN: $ae290cc08e298ace$var$Z_UNKNOWN, Z_DEFLATED: $ae290cc08e298ace$var$Z_DEFLATED$2 } = $ae290cc08e298ace$var$constants$2;
/*============================================================================*/ const $ae290cc08e298ace$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ const $ae290cc08e298ace$var$MAX_WBITS$1 = 15;
/* 32K LZ77 window */ const $ae290cc08e298ace$var$DEF_MEM_LEVEL = 8;
const $ae290cc08e298ace$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $ae290cc08e298ace$var$LITERALS = 256;
/* number of literal bytes 0..255 */ const $ae290cc08e298ace$var$L_CODES = $ae290cc08e298ace$var$LITERALS + 1 + $ae290cc08e298ace$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const $ae290cc08e298ace$var$D_CODES = 30;
/* number of distance codes */ const $ae290cc08e298ace$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const $ae290cc08e298ace$var$HEAP_SIZE = 2 * $ae290cc08e298ace$var$L_CODES + 1;
/* maximum heap size */ const $ae290cc08e298ace$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const $ae290cc08e298ace$var$MIN_MATCH = 3;
const $ae290cc08e298ace$var$MAX_MATCH = 258;
const $ae290cc08e298ace$var$MIN_LOOKAHEAD = $ae290cc08e298ace$var$MAX_MATCH + $ae290cc08e298ace$var$MIN_MATCH + 1;
const $ae290cc08e298ace$var$PRESET_DICT = 0x20;
const $ae290cc08e298ace$var$INIT_STATE = 42; /* zlib header -> BUSY_STATE */ 
//#ifdef GZIP
const $ae290cc08e298ace$var$GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */ 
//#endif
const $ae290cc08e298ace$var$EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */ 
const $ae290cc08e298ace$var$NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */ 
const $ae290cc08e298ace$var$COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */ 
const $ae290cc08e298ace$var$HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */ 
const $ae290cc08e298ace$var$BUSY_STATE = 113; /* deflate -> FINISH_STATE */ 
const $ae290cc08e298ace$var$FINISH_STATE = 666; /* stream complete */ 
const $ae290cc08e298ace$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
const $ae290cc08e298ace$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
const $ae290cc08e298ace$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
const $ae290cc08e298ace$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
const $ae290cc08e298ace$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
const $ae290cc08e298ace$var$err = (strm, errorCode)=>{
    strm.msg = $ae290cc08e298ace$var$messages[errorCode];
    return errorCode;
};
const $ae290cc08e298ace$var$rank = (f)=>{
    return f * 2 - (f > 4 ? 9 : 0);
};
const $ae290cc08e298ace$var$zero = (buf)=>{
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */ const $ae290cc08e298ace$var$slide_hash = (s)=>{
    let n, m;
    let p;
    let wsize = s.w_size;
    n = s.hash_size;
    p = n;
    do {
        m = s.head[--p];
        s.head[p] = m >= wsize ? m - wsize : 0;
    }while (--n);
    n = wsize;
    //#ifndef FASTEST
    p = n;
    do {
        m = s.prev[--p];
        s.prev[p] = m >= wsize ? m - wsize : 0;
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */ }while (--n);
//#endif
};
/* eslint-disable new-cap */ let $ae290cc08e298ace$var$HASH_ZLIB = (s, prev, data)=>(prev << s.hash_shift ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let $ae290cc08e298ace$var$HASH = $ae290cc08e298ace$var$HASH_ZLIB;
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */ const $ae290cc08e298ace$var$flush_pending = (strm)=>{
    const s = strm.state;
    //_tr_flush_bits(s);
    let len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
const $ae290cc08e298ace$var$flush_block_only = (s, last)=>{
    $ae290cc08e298ace$var$_tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $ae290cc08e298ace$var$flush_pending(s.strm);
};
const $ae290cc08e298ace$var$put_byte = (s, b)=>{
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ const $ae290cc08e298ace$var$putShortMSB = (s, b)=>{
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ const $ae290cc08e298ace$var$read_buf = (strm, buf, start, size)=>{
    let len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = $ae290cc08e298ace$var$adler32_1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $ae290cc08e298ace$var$crc32_1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ const $ae290cc08e298ace$var$longest_match = (s, cur_match)=>{
    let chain_length = s.max_chain_length; /* max hash chain length */ 
    let scan = s.strstart; /* current string */ 
    let match; /* matched string */ 
    let len; /* length of current match */ 
    let best_len = s.prev_length; /* best match length so far */ 
    let nice_match = s.nice_match; /* stop if match long enough */ 
    const limit = s.strstart > s.w_size - $ae290cc08e298ace$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $ae290cc08e298ace$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    const _win = s.window; // shortcut
    const wmask = s.w_mask;
    const prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ const strend = s.strstart + $ae290cc08e298ace$var$MAX_MATCH;
    let scan_end1 = _win[scan + best_len - 1];
    let scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $ae290cc08e298ace$var$MAX_MATCH - (strend - scan);
        scan = strend - $ae290cc08e298ace$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ const $ae290cc08e298ace$var$fill_window = (s)=>{
    const _w_size = s.w_size;
    let n, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $ae290cc08e298ace$var$MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            if (s.insert > s.strstart) s.insert = s.strstart;
            $ae290cc08e298ace$var$slide_hash(s);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $ae290cc08e298ace$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $ae290cc08e298ace$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = $ae290cc08e298ace$var$HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $ae290cc08e298ace$var$HASH(s, s.ins_h, s.window[str + $ae290cc08e298ace$var$MIN_MATCH - 1]);
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $ae290cc08e298ace$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $ae290cc08e298ace$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */ const $ae290cc08e298ace$var$deflate_stored = (s, flush)=>{
    /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */ let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
    /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */ let len, left, have, last = 0;
    let used = s.strm.avail_in;
    do {
        /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */ len = 65535 /* MAX_STORED */ ; /* maximum deflate stored block length */ 
        have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
        if (s.strm.avail_out < have) break;
        /* maximum stored block length that will fit in avail_out: */ have = s.strm.avail_out - have;
        left = s.strstart - s.block_start; /* bytes left in window */ 
        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in; /* limit len to the input */ 
        if (len > have) len = have; /* limit len to the output */ 
        /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */ if (len < min_block && (len === 0 && flush !== $ae290cc08e298ace$var$Z_FINISH$3 || flush === $ae290cc08e298ace$var$Z_NO_FLUSH$2 || len !== left + s.strm.avail_in)) break;
        /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */ last = flush === $ae290cc08e298ace$var$Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
        $ae290cc08e298ace$var$_tr_stored_block(s, 0, 0, last);
        /* Replace the lengths in the dummy stored block with len. */ s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;
        /* Write the stored block header bytes. */ $ae290cc08e298ace$var$flush_pending(s.strm);
        //#ifdef ZLIB_DEBUG
        //    /* Update debugging counts for the data about to be copied. */
        //    s->compressed_len += len << 3;
        //    s->bits_sent += len << 3;
        //#endif
        /* Copy uncompressed bytes from the window to next_out. */ if (left) {
            if (left > len) left = len;
            //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
            s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
            s.strm.next_out += left;
            s.strm.avail_out -= left;
            s.strm.total_out += left;
            s.block_start += left;
            len -= left;
        }
        /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */ if (len) {
            $ae290cc08e298ace$var$read_buf(s.strm, s.strm.output, s.strm.next_out, len);
            s.strm.next_out += len;
            s.strm.avail_out -= len;
            s.strm.total_out += len;
        }
    }while (last === 0);
    /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */ used -= s.strm.avail_in; /* number of input bytes directly copied */ 
    if (used) {
        /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */ if (used >= s.w_size) {
            s.matches = 2; /* clear hash */ 
            //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
            s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
            s.strstart = s.w_size;
            s.insert = s.strstart;
        } else {
            if (s.window_size - s.strstart <= used) {
                /* Slide the window down. */ s.strstart -= s.w_size;
                //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                if (s.insert > s.strstart) s.insert = s.strstart;
            }
            //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
            s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
            s.strstart += used;
            s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* If the last block was written to next_out, then done. */ if (last) return $ae290cc08e298ace$var$BS_FINISH_DONE;
    /* If flushing and all input has been consumed, then done. */ if (flush !== $ae290cc08e298ace$var$Z_NO_FLUSH$2 && flush !== $ae290cc08e298ace$var$Z_FINISH$3 && s.strm.avail_in === 0 && s.strstart === s.block_start) return $ae290cc08e298ace$var$BS_BLOCK_DONE;
    /* Fill the window with any remaining input. */ have = s.window_size - s.strstart;
    if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        /* Slide the window down. */ s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
        have += s.w_size; /* more space now */ 
        if (s.insert > s.strstart) s.insert = s.strstart;
    }
    if (have > s.strm.avail_in) have = s.strm.avail_in;
    if (have) {
        $ae290cc08e298ace$var$read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */ have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
    /* maximum stored block length that will fit in pending: */ have = s.pending_buf_size - have > 65535 /* MAX_STORED */  ? 65535 /* MAX_STORED */  : s.pending_buf_size - have;
    min_block = have > s.w_size ? s.w_size : have;
    left = s.strstart - s.block_start;
    if (left >= min_block || (left || flush === $ae290cc08e298ace$var$Z_FINISH$3) && flush !== $ae290cc08e298ace$var$Z_NO_FLUSH$2 && s.strm.avail_in === 0 && left <= have) {
        len = left > have ? have : left;
        last = flush === $ae290cc08e298ace$var$Z_FINISH$3 && s.strm.avail_in === 0 && len === left ? 1 : 0;
        $ae290cc08e298ace$var$_tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        $ae290cc08e298ace$var$flush_pending(s.strm);
    }
    /* We've done all we can with the available input and output. */ return last ? $ae290cc08e298ace$var$BS_FINISH_STARTED : $ae290cc08e298ace$var$BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ const $ae290cc08e298ace$var$deflate_fast = (s, flush)=>{
    let hash_head; /* head of the hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $ae290cc08e298ace$var$MIN_LOOKAHEAD) {
            $ae290cc08e298ace$var$fill_window(s);
            if (s.lookahead < $ae290cc08e298ace$var$MIN_LOOKAHEAD && flush === $ae290cc08e298ace$var$Z_NO_FLUSH$2) return $ae290cc08e298ace$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $ae290cc08e298ace$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $ae290cc08e298ace$var$HASH(s, s.ins_h, s.window[s.strstart + $ae290cc08e298ace$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $ae290cc08e298ace$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $ae290cc08e298ace$var$longest_match(s, hash_head);
        if (s.match_length >= $ae290cc08e298ace$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $ae290cc08e298ace$var$_tr_tally(s, s.strstart - s.match_start, s.match_length - $ae290cc08e298ace$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $ae290cc08e298ace$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $ae290cc08e298ace$var$HASH(s, s.ins_h, s.window[s.strstart + $ae290cc08e298ace$var$MIN_MATCH - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = $ae290cc08e298ace$var$HASH(s, s.ins_h, s.window[s.strstart + 1]);
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $ae290cc08e298ace$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $ae290cc08e298ace$var$MIN_MATCH - 1 ? s.strstart : $ae290cc08e298ace$var$MIN_MATCH - 1;
    if (flush === $ae290cc08e298ace$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $ae290cc08e298ace$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_FINISH_STARTED;
        /***/ return $ae290cc08e298ace$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
    /***/ }
    return $ae290cc08e298ace$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ const $ae290cc08e298ace$var$deflate_slow = (s, flush)=>{
    let hash_head; /* head of hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    let max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $ae290cc08e298ace$var$MIN_LOOKAHEAD) {
            $ae290cc08e298ace$var$fill_window(s);
            if (s.lookahead < $ae290cc08e298ace$var$MIN_LOOKAHEAD && flush === $ae290cc08e298ace$var$Z_NO_FLUSH$2) return $ae290cc08e298ace$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $ae290cc08e298ace$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $ae290cc08e298ace$var$HASH(s, s.ins_h, s.window[s.strstart + $ae290cc08e298ace$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $ae290cc08e298ace$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $ae290cc08e298ace$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $ae290cc08e298ace$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $ae290cc08e298ace$var$Z_FILTERED || s.match_length === $ae290cc08e298ace$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $ae290cc08e298ace$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $ae290cc08e298ace$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $ae290cc08e298ace$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $ae290cc08e298ace$var$_tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $ae290cc08e298ace$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $ae290cc08e298ace$var$HASH(s, s.ins_h, s.window[s.strstart + $ae290cc08e298ace$var$MIN_MATCH - 1]);
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $ae290cc08e298ace$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $ae290cc08e298ace$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $ae290cc08e298ace$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $ae290cc08e298ace$var$MIN_MATCH - 1 ? s.strstart : $ae290cc08e298ace$var$MIN_MATCH - 1;
    if (flush === $ae290cc08e298ace$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $ae290cc08e298ace$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_FINISH_STARTED;
        /***/ return $ae290cc08e298ace$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
    /***/ }
    return $ae290cc08e298ace$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ const $ae290cc08e298ace$var$deflate_rle = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    let prev; /* byte at distance one to match */ 
    let scan, strend; /* scan goes up to strend for length of run */ 
    const _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $ae290cc08e298ace$var$MAX_MATCH) {
            $ae290cc08e298ace$var$fill_window(s);
            if (s.lookahead <= $ae290cc08e298ace$var$MAX_MATCH && flush === $ae290cc08e298ace$var$Z_NO_FLUSH$2) return $ae290cc08e298ace$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $ae290cc08e298ace$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $ae290cc08e298ace$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $ae290cc08e298ace$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $ae290cc08e298ace$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $ae290cc08e298ace$var$_tr_tally(s, 1, s.match_length - $ae290cc08e298ace$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $ae290cc08e298ace$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $ae290cc08e298ace$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $ae290cc08e298ace$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_FINISH_STARTED;
        /***/ return $ae290cc08e298ace$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
    /***/ }
    return $ae290cc08e298ace$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ const $ae290cc08e298ace$var$deflate_huff = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $ae290cc08e298ace$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $ae290cc08e298ace$var$Z_NO_FLUSH$2) return $ae290cc08e298ace$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $ae290cc08e298ace$var$_tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $ae290cc08e298ace$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $ae290cc08e298ace$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_FINISH_STARTED;
        /***/ return $ae290cc08e298ace$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $ae290cc08e298ace$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $ae290cc08e298ace$var$BS_NEED_MORE;
    /***/ }
    return $ae290cc08e298ace$var$BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $ae290cc08e298ace$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
const $ae290cc08e298ace$var$configuration_table = [
    /*      good lazy nice chain */ new $ae290cc08e298ace$var$Config(0, 0, 0, 0, $ae290cc08e298ace$var$deflate_stored),
    /* 0 store only */ new $ae290cc08e298ace$var$Config(4, 4, 8, 4, $ae290cc08e298ace$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $ae290cc08e298ace$var$Config(4, 5, 16, 8, $ae290cc08e298ace$var$deflate_fast),
    /* 2 */ new $ae290cc08e298ace$var$Config(4, 6, 32, 32, $ae290cc08e298ace$var$deflate_fast),
    /* 3 */ new $ae290cc08e298ace$var$Config(4, 4, 16, 16, $ae290cc08e298ace$var$deflate_slow),
    /* 4 lazy matches */ new $ae290cc08e298ace$var$Config(8, 16, 32, 32, $ae290cc08e298ace$var$deflate_slow),
    /* 5 */ new $ae290cc08e298ace$var$Config(8, 16, 128, 128, $ae290cc08e298ace$var$deflate_slow),
    /* 6 */ new $ae290cc08e298ace$var$Config(8, 32, 128, 256, $ae290cc08e298ace$var$deflate_slow),
    /* 7 */ new $ae290cc08e298ace$var$Config(32, 128, 258, 1024, $ae290cc08e298ace$var$deflate_slow),
    /* 8 */ new $ae290cc08e298ace$var$Config(32, 258, 258, 4096, $ae290cc08e298ace$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ const $ae290cc08e298ace$var$lm_init = (s)=>{
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $ae290cc08e298ace$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $ae290cc08e298ace$var$configuration_table[s.level].max_lazy;
    s.good_match = $ae290cc08e298ace$var$configuration_table[s.level].good_length;
    s.nice_match = $ae290cc08e298ace$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $ae290cc08e298ace$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $ae290cc08e298ace$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function $ae290cc08e298ace$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $ae290cc08e298ace$var$Z_DEFLATED$2; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array($ae290cc08e298ace$var$HEAP_SIZE * 2);
    this.dyn_dtree = new Uint16Array((2 * $ae290cc08e298ace$var$D_CODES + 1) * 2);
    this.bl_tree = new Uint16Array((2 * $ae290cc08e298ace$var$BL_CODES + 1) * 2);
    $ae290cc08e298ace$var$zero(this.dyn_ltree);
    $ae290cc08e298ace$var$zero(this.dyn_dtree);
    $ae290cc08e298ace$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array($ae290cc08e298ace$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * $ae290cc08e298ace$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $ae290cc08e298ace$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * $ae290cc08e298ace$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $ae290cc08e298ace$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.sym_buf = 0; /* buffer for distances and literals/lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.sym_next = 0; /* running index in sym_buf */ 
    this.sym_end = 0; /* symbol table full when sym_next reaches this */ 
    this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */ const $ae290cc08e298ace$var$deflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const s = strm.state;
    if (!s || s.strm !== strm || s.status !== $ae290cc08e298ace$var$INIT_STATE && //#ifdef GZIP
    s.status !== $ae290cc08e298ace$var$GZIP_STATE && //#endif
    s.status !== $ae290cc08e298ace$var$EXTRA_STATE && s.status !== $ae290cc08e298ace$var$NAME_STATE && s.status !== $ae290cc08e298ace$var$COMMENT_STATE && s.status !== $ae290cc08e298ace$var$HCRC_STATE && s.status !== $ae290cc08e298ace$var$BUSY_STATE && s.status !== $ae290cc08e298ace$var$FINISH_STATE) return 1;
    return 0;
};
const $ae290cc08e298ace$var$deflateResetKeep = (strm)=>{
    if ($ae290cc08e298ace$var$deflateStateCheck(strm)) return $ae290cc08e298ace$var$err(strm, $ae290cc08e298ace$var$Z_STREAM_ERROR$2);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $ae290cc08e298ace$var$Z_UNKNOWN;
    const s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = //#ifdef GZIP
    s.wrap === 2 ? $ae290cc08e298ace$var$GZIP_STATE : //#endif
    s.wrap ? $ae290cc08e298ace$var$INIT_STATE : $ae290cc08e298ace$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = -2;
    $ae290cc08e298ace$var$_tr_init(s);
    return $ae290cc08e298ace$var$Z_OK$3;
};
const $ae290cc08e298ace$var$deflateReset = (strm)=>{
    const ret = $ae290cc08e298ace$var$deflateResetKeep(strm);
    if (ret === $ae290cc08e298ace$var$Z_OK$3) $ae290cc08e298ace$var$lm_init(strm.state);
    return ret;
};
const $ae290cc08e298ace$var$deflateSetHeader = (strm, head)=>{
    if ($ae290cc08e298ace$var$deflateStateCheck(strm) || strm.state.wrap !== 2) return $ae290cc08e298ace$var$Z_STREAM_ERROR$2;
    strm.state.gzhead = head;
    return $ae290cc08e298ace$var$Z_OK$3;
};
const $ae290cc08e298ace$var$deflateInit2 = (strm, level, method, windowBits, memLevel, strategy)=>{
    if (!strm) return $ae290cc08e298ace$var$Z_STREAM_ERROR$2;
    let wrap = 1;
    if (level === $ae290cc08e298ace$var$Z_DEFAULT_COMPRESSION$1) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $ae290cc08e298ace$var$MAX_MEM_LEVEL || method !== $ae290cc08e298ace$var$Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $ae290cc08e298ace$var$Z_FIXED || windowBits === 8 && wrap !== 1) return $ae290cc08e298ace$var$err(strm, $ae290cc08e298ace$var$Z_STREAM_ERROR$2);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ const s = new $ae290cc08e298ace$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.status = $ae290cc08e298ace$var$INIT_STATE; /* to pass state test in deflateReset() */ 
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $ae290cc08e298ace$var$MIN_MATCH - 1) / $ae290cc08e298ace$var$MIN_MATCH);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */ s.pending_buf_size = s.lit_bufsize * 4;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->sym_buf = s->pending_buf + s->lit_bufsize;
    s.sym_buf = s.lit_bufsize;
    //s->sym_end = (s->lit_bufsize - 1) * 3;
    s.sym_end = (s.lit_bufsize - 1) * 3;
    /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $ae290cc08e298ace$var$deflateReset(strm);
};
const $ae290cc08e298ace$var$deflateInit = (strm, level)=>{
    return $ae290cc08e298ace$var$deflateInit2(strm, level, $ae290cc08e298ace$var$Z_DEFLATED$2, $ae290cc08e298ace$var$MAX_WBITS$1, $ae290cc08e298ace$var$DEF_MEM_LEVEL, $ae290cc08e298ace$var$Z_DEFAULT_STRATEGY$1);
};
/* ========================================================================= */ const $ae290cc08e298ace$var$deflate$2 = (strm, flush)=>{
    if ($ae290cc08e298ace$var$deflateStateCheck(strm) || flush > $ae290cc08e298ace$var$Z_BLOCK$1 || flush < 0) return strm ? $ae290cc08e298ace$var$err(strm, $ae290cc08e298ace$var$Z_STREAM_ERROR$2) : $ae290cc08e298ace$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === $ae290cc08e298ace$var$FINISH_STATE && flush !== $ae290cc08e298ace$var$Z_FINISH$3) return $ae290cc08e298ace$var$err(strm, strm.avail_out === 0 ? $ae290cc08e298ace$var$Z_BUF_ERROR$1 : $ae290cc08e298ace$var$Z_STREAM_ERROR$2);
    const old_flush = s.last_flush;
    s.last_flush = flush;
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $ae290cc08e298ace$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $ae290cc08e298ace$var$Z_OK$3;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $ae290cc08e298ace$var$rank(flush) <= $ae290cc08e298ace$var$rank(old_flush) && flush !== $ae290cc08e298ace$var$Z_FINISH$3) return $ae290cc08e298ace$var$err(strm, $ae290cc08e298ace$var$Z_BUF_ERROR$1);
    /* User must not provide more input after the first FINISH: */ if (s.status === $ae290cc08e298ace$var$FINISH_STATE && strm.avail_in !== 0) return $ae290cc08e298ace$var$err(strm, $ae290cc08e298ace$var$Z_BUF_ERROR$1);
    /* Write the header */ if (s.status === $ae290cc08e298ace$var$INIT_STATE && s.wrap === 0) s.status = $ae290cc08e298ace$var$BUSY_STATE;
    if (s.status === $ae290cc08e298ace$var$INIT_STATE) {
        /* zlib header */ let header = $ae290cc08e298ace$var$Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
        let level_flags = -1;
        if (s.strategy >= $ae290cc08e298ace$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
        else if (s.level < 6) level_flags = 1;
        else if (s.level === 6) level_flags = 2;
        else level_flags = 3;
        header |= level_flags << 6;
        if (s.strstart !== 0) header |= $ae290cc08e298ace$var$PRESET_DICT;
        header += 31 - header % 31;
        $ae290cc08e298ace$var$putShortMSB(s, header);
        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
            $ae290cc08e298ace$var$putShortMSB(s, strm.adler >>> 16);
            $ae290cc08e298ace$var$putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1; // adler32(0L, Z_NULL, 0);
        s.status = $ae290cc08e298ace$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $ae290cc08e298ace$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $ae290cc08e298ace$var$Z_OK$3;
        }
    }
    //#ifdef GZIP
    if (s.status === $ae290cc08e298ace$var$GZIP_STATE) {
        /* gzip header */ strm.adler = 0; //crc32(0L, Z_NULL, 0);
        $ae290cc08e298ace$var$put_byte(s, 31);
        $ae290cc08e298ace$var$put_byte(s, 139);
        $ae290cc08e298ace$var$put_byte(s, 8);
        if (!s.gzhead) {
            $ae290cc08e298ace$var$put_byte(s, 0);
            $ae290cc08e298ace$var$put_byte(s, 0);
            $ae290cc08e298ace$var$put_byte(s, 0);
            $ae290cc08e298ace$var$put_byte(s, 0);
            $ae290cc08e298ace$var$put_byte(s, 0);
            $ae290cc08e298ace$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $ae290cc08e298ace$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $ae290cc08e298ace$var$put_byte(s, $ae290cc08e298ace$var$OS_CODE);
            s.status = $ae290cc08e298ace$var$BUSY_STATE;
            /* Compression must start with an empty pending buffer */ $ae290cc08e298ace$var$flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return $ae290cc08e298ace$var$Z_OK$3;
            }
        } else {
            $ae290cc08e298ace$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
            $ae290cc08e298ace$var$put_byte(s, s.gzhead.time & 0xff);
            $ae290cc08e298ace$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
            $ae290cc08e298ace$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
            $ae290cc08e298ace$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
            $ae290cc08e298ace$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $ae290cc08e298ace$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $ae290cc08e298ace$var$put_byte(s, s.gzhead.os & 0xff);
            if (s.gzhead.extra && s.gzhead.extra.length) {
                $ae290cc08e298ace$var$put_byte(s, s.gzhead.extra.length & 0xff);
                $ae290cc08e298ace$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
            }
            if (s.gzhead.hcrc) strm.adler = $ae290cc08e298ace$var$crc32_1(strm.adler, s.pending_buf, s.pending, 0);
            s.gzindex = 0;
            s.status = $ae290cc08e298ace$var$EXTRA_STATE;
        }
    }
    if (s.status === $ae290cc08e298ace$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
            while(s.pending + left > s.pending_buf_size){
                let copy = s.pending_buf_size - s.pending;
                // zmemcpy(s.pending_buf + s.pending,
                //    s.gzhead.extra + s.gzindex, copy);
                s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
                s.pending = s.pending_buf_size;
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) strm.adler = $ae290cc08e298ace$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                //---//
                s.gzindex += copy;
                $ae290cc08e298ace$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $ae290cc08e298ace$var$Z_OK$3;
                }
                beg = 0;
                left -= copy;
            }
            // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
            //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
            let gzhead_extra = new Uint8Array(s.gzhead.extra);
            // zmemcpy(s->pending_buf + s->pending,
            //     s->gzhead->extra + s->gzindex, left);
            s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
            s.pending += left;
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $ae290cc08e298ace$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $ae290cc08e298ace$var$NAME_STATE;
    }
    if (s.status === $ae290cc08e298ace$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $ae290cc08e298ace$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $ae290cc08e298ace$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $ae290cc08e298ace$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $ae290cc08e298ace$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $ae290cc08e298ace$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $ae290cc08e298ace$var$COMMENT_STATE;
    }
    if (s.status === $ae290cc08e298ace$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $ae290cc08e298ace$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $ae290cc08e298ace$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $ae290cc08e298ace$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $ae290cc08e298ace$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $ae290cc08e298ace$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
        //---//
        }
        s.status = $ae290cc08e298ace$var$HCRC_STATE;
    }
    if (s.status === $ae290cc08e298ace$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
                $ae290cc08e298ace$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $ae290cc08e298ace$var$Z_OK$3;
                }
            }
            $ae290cc08e298ace$var$put_byte(s, strm.adler & 0xff);
            $ae290cc08e298ace$var$put_byte(s, strm.adler >> 8 & 0xff);
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
        }
        s.status = $ae290cc08e298ace$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $ae290cc08e298ace$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $ae290cc08e298ace$var$Z_OK$3;
        }
    }
    //#endif
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $ae290cc08e298ace$var$Z_NO_FLUSH$2 && s.status !== $ae290cc08e298ace$var$FINISH_STATE) {
        let bstate = s.level === 0 ? $ae290cc08e298ace$var$deflate_stored(s, flush) : s.strategy === $ae290cc08e298ace$var$Z_HUFFMAN_ONLY ? $ae290cc08e298ace$var$deflate_huff(s, flush) : s.strategy === $ae290cc08e298ace$var$Z_RLE ? $ae290cc08e298ace$var$deflate_rle(s, flush) : $ae290cc08e298ace$var$configuration_table[s.level].func(s, flush);
        if (bstate === $ae290cc08e298ace$var$BS_FINISH_STARTED || bstate === $ae290cc08e298ace$var$BS_FINISH_DONE) s.status = $ae290cc08e298ace$var$FINISH_STATE;
        if (bstate === $ae290cc08e298ace$var$BS_NEED_MORE || bstate === $ae290cc08e298ace$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $ae290cc08e298ace$var$Z_OK$3;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $ae290cc08e298ace$var$BS_BLOCK_DONE) {
            if (flush === $ae290cc08e298ace$var$Z_PARTIAL_FLUSH) $ae290cc08e298ace$var$_tr_align(s);
            else if (flush !== $ae290cc08e298ace$var$Z_BLOCK$1) {
                $ae290cc08e298ace$var$_tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $ae290cc08e298ace$var$Z_FULL_FLUSH$1) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $ae290cc08e298ace$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $ae290cc08e298ace$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $ae290cc08e298ace$var$Z_OK$3;
            }
        }
    }
    if (flush !== $ae290cc08e298ace$var$Z_FINISH$3) return $ae290cc08e298ace$var$Z_OK$3;
    if (s.wrap <= 0) return $ae290cc08e298ace$var$Z_STREAM_END$3;
    /* Write the trailer */ if (s.wrap === 2) {
        $ae290cc08e298ace$var$put_byte(s, strm.adler & 0xff);
        $ae290cc08e298ace$var$put_byte(s, strm.adler >> 8 & 0xff);
        $ae290cc08e298ace$var$put_byte(s, strm.adler >> 16 & 0xff);
        $ae290cc08e298ace$var$put_byte(s, strm.adler >> 24 & 0xff);
        $ae290cc08e298ace$var$put_byte(s, strm.total_in & 0xff);
        $ae290cc08e298ace$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $ae290cc08e298ace$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $ae290cc08e298ace$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $ae290cc08e298ace$var$putShortMSB(s, strm.adler >>> 16);
        $ae290cc08e298ace$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $ae290cc08e298ace$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $ae290cc08e298ace$var$Z_OK$3 : $ae290cc08e298ace$var$Z_STREAM_END$3;
};
const $ae290cc08e298ace$var$deflateEnd = (strm)=>{
    if ($ae290cc08e298ace$var$deflateStateCheck(strm)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$2;
    const status = strm.state.status;
    strm.state = null;
    return status === $ae290cc08e298ace$var$BUSY_STATE ? $ae290cc08e298ace$var$err(strm, $ae290cc08e298ace$var$Z_DATA_ERROR$2) : $ae290cc08e298ace$var$Z_OK$3;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ const $ae290cc08e298ace$var$deflateSetDictionary = (strm, dictionary)=>{
    let dictLength = dictionary.length;
    if ($ae290cc08e298ace$var$deflateStateCheck(strm)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    const wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $ae290cc08e298ace$var$INIT_STATE || s.lookahead) return $ae290cc08e298ace$var$Z_STREAM_ERROR$2;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $ae290cc08e298ace$var$adler32_1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $ae290cc08e298ace$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ const avail = strm.avail_in;
    const next = strm.next_in;
    const input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $ae290cc08e298ace$var$fill_window(s);
    while(s.lookahead >= $ae290cc08e298ace$var$MIN_MATCH){
        let str = s.strstart;
        let n = s.lookahead - ($ae290cc08e298ace$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $ae290cc08e298ace$var$HASH(s, s.ins_h, s.window[str + $ae290cc08e298ace$var$MIN_MATCH - 1]);
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $ae290cc08e298ace$var$MIN_MATCH - 1;
        $ae290cc08e298ace$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $ae290cc08e298ace$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $ae290cc08e298ace$var$Z_OK$3;
};
var $ae290cc08e298ace$var$deflateInit_1 = $ae290cc08e298ace$var$deflateInit;
var $ae290cc08e298ace$var$deflateInit2_1 = $ae290cc08e298ace$var$deflateInit2;
var $ae290cc08e298ace$var$deflateReset_1 = $ae290cc08e298ace$var$deflateReset;
var $ae290cc08e298ace$var$deflateResetKeep_1 = $ae290cc08e298ace$var$deflateResetKeep;
var $ae290cc08e298ace$var$deflateSetHeader_1 = $ae290cc08e298ace$var$deflateSetHeader;
var $ae290cc08e298ace$var$deflate_2$1 = $ae290cc08e298ace$var$deflate$2;
var $ae290cc08e298ace$var$deflateEnd_1 = $ae290cc08e298ace$var$deflateEnd;
var $ae290cc08e298ace$var$deflateSetDictionary_1 = $ae290cc08e298ace$var$deflateSetDictionary;
var $ae290cc08e298ace$var$deflateInfo = "pako deflate (from Nodeca project)";
/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ var $ae290cc08e298ace$var$deflate_1$2 = {
    deflateInit: $ae290cc08e298ace$var$deflateInit_1,
    deflateInit2: $ae290cc08e298ace$var$deflateInit2_1,
    deflateReset: $ae290cc08e298ace$var$deflateReset_1,
    deflateResetKeep: $ae290cc08e298ace$var$deflateResetKeep_1,
    deflateSetHeader: $ae290cc08e298ace$var$deflateSetHeader_1,
    deflate: $ae290cc08e298ace$var$deflate_2$1,
    deflateEnd: $ae290cc08e298ace$var$deflateEnd_1,
    deflateSetDictionary: $ae290cc08e298ace$var$deflateSetDictionary_1,
    deflateInfo: $ae290cc08e298ace$var$deflateInfo
};
const $ae290cc08e298ace$var$_has = (obj, key)=>{
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var $ae290cc08e298ace$var$assign = function(obj /*from1, from2, from3, ...*/ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        const source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(const p in source)if ($ae290cc08e298ace$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// Join array of chunks to single array.
var $ae290cc08e298ace$var$flattenChunks = (chunks)=>{
    // calculate data length
    let len = 0;
    for(let i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
    // join chunks
    const result = new Uint8Array(len);
    for(let i = 0, pos = 0, l = chunks.length; i < l; i++){
        let chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
    }
    return result;
};
var $ae290cc08e298ace$var$common = {
    assign: $ae290cc08e298ace$var$assign,
    flattenChunks: $ae290cc08e298ace$var$flattenChunks
};
// String encode/decode helpers
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let $ae290cc08e298ace$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $ae290cc08e298ace$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const $ae290cc08e298ace$var$_utf8len = new Uint8Array(256);
for(let q = 0; q < 256; q++)$ae290cc08e298ace$var$_utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
$ae290cc08e298ace$var$_utf8len[254] = $ae290cc08e298ace$var$_utf8len[254] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
var $ae290cc08e298ace$var$string2buf = (str)=>{
    if (typeof TextEncoder === "function" && TextEncoder.prototype.encode) return new TextEncoder().encode(str);
    let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new Uint8Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper
const $ae290cc08e298ace$var$buf2binstring = (buf, len)=>{
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $ae290cc08e298ace$var$STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
    let result = "";
    for(let i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
};
// convert array to string
var $ae290cc08e298ace$var$buf2string = (buf, max)=>{
    const len = max || buf.length;
    if (typeof TextDecoder === "function" && TextDecoder.prototype.decode) return new TextDecoder().decode(buf.subarray(0, max));
    let i, out;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    const utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        let c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        let c_len = $ae290cc08e298ace$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $ae290cc08e298ace$var$buf2binstring(utf16buf, out);
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $ae290cc08e298ace$var$utf8border = (buf, max)=>{
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    let pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $ae290cc08e298ace$var$_utf8len[buf[pos]] > max ? pos : max;
};
var $ae290cc08e298ace$var$strings = {
    string2buf: $ae290cc08e298ace$var$string2buf,
    buf2string: $ae290cc08e298ace$var$buf2string,
    utf8border: $ae290cc08e298ace$var$utf8border
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $ae290cc08e298ace$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var $ae290cc08e298ace$var$zstream = $ae290cc08e298ace$var$ZStream;
const $ae290cc08e298ace$var$toString$1 = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $ae290cc08e298ace$var$Z_NO_FLUSH$1, Z_SYNC_FLUSH: $ae290cc08e298ace$var$Z_SYNC_FLUSH, Z_FULL_FLUSH: $ae290cc08e298ace$var$Z_FULL_FLUSH, Z_FINISH: $ae290cc08e298ace$var$Z_FINISH$2, Z_OK: $ae290cc08e298ace$var$Z_OK$2, Z_STREAM_END: $ae290cc08e298ace$var$Z_STREAM_END$2, Z_DEFAULT_COMPRESSION: $ae290cc08e298ace$var$Z_DEFAULT_COMPRESSION, Z_DEFAULT_STRATEGY: $ae290cc08e298ace$var$Z_DEFAULT_STRATEGY, Z_DEFLATED: $ae290cc08e298ace$var$Z_DEFLATED$1 } = $ae290cc08e298ace$var$constants$2;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $ae290cc08e298ace$var$Deflate$1(options) {
    this.options = $ae290cc08e298ace$var$common.assign({
        level: $ae290cc08e298ace$var$Z_DEFAULT_COMPRESSION,
        method: $ae290cc08e298ace$var$Z_DEFLATED$1,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $ae290cc08e298ace$var$Z_DEFAULT_STRATEGY
    }, options || {});
    let opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $ae290cc08e298ace$var$zstream();
    this.strm.avail_out = 0;
    let status = $ae290cc08e298ace$var$deflate_1$2.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $ae290cc08e298ace$var$Z_OK$2) throw new Error($ae290cc08e298ace$var$messages[status]);
    if (opt.header) $ae290cc08e298ace$var$deflate_1$2.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        let dict;
        // Convert data if needed
        if (typeof opt.dictionary === "string") // If we need to compress text, change encoding to utf8.
        dict = $ae290cc08e298ace$var$strings.string2buf(opt.dictionary);
        else if ($ae290cc08e298ace$var$toString$1.call(opt.dictionary) === "[object ArrayBuffer]") dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $ae290cc08e298ace$var$deflate_1$2.deflateSetDictionary(this.strm, dict);
        if (status !== $ae290cc08e298ace$var$Z_OK$2) throw new Error($ae290cc08e298ace$var$messages[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $ae290cc08e298ace$var$Deflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    let status, _flush_mode;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $ae290cc08e298ace$var$Z_FINISH$2 : $ae290cc08e298ace$var$Z_NO_FLUSH$1;
    // Convert data if needed
    if (typeof data === "string") // If we need to compress text, change encoding to utf8.
    strm.input = $ae290cc08e298ace$var$strings.string2buf(data);
    else if ($ae290cc08e298ace$var$toString$1.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === $ae290cc08e298ace$var$Z_SYNC_FLUSH || _flush_mode === $ae290cc08e298ace$var$Z_FULL_FLUSH) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        status = $ae290cc08e298ace$var$deflate_1$2.deflate(strm, _flush_mode);
        // Ended => flush and finish
        if (status === $ae290cc08e298ace$var$Z_STREAM_END$2) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = $ae290cc08e298ace$var$deflate_1$2.deflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return status === $ae290cc08e298ace$var$Z_OK$2;
        }
        // Flush if out buffer full
        if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
        }
        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $ae290cc08e298ace$var$Deflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $ae290cc08e298ace$var$Deflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $ae290cc08e298ace$var$Z_OK$2) this.result = $ae290cc08e298ace$var$common.flattenChunks(this.chunks);
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $ae290cc08e298ace$var$deflate$1(input, options) {
    const deflator = new $ae290cc08e298ace$var$Deflate$1(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $ae290cc08e298ace$var$messages[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $ae290cc08e298ace$var$deflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $ae290cc08e298ace$var$deflate$1(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $ae290cc08e298ace$var$gzip$1(input, options) {
    options = options || {};
    options.gzip = true;
    return $ae290cc08e298ace$var$deflate$1(input, options);
}
var $ae290cc08e298ace$var$Deflate_1$1 = $ae290cc08e298ace$var$Deflate$1;
var $ae290cc08e298ace$var$deflate_2 = $ae290cc08e298ace$var$deflate$1;
var $ae290cc08e298ace$var$deflateRaw_1$1 = $ae290cc08e298ace$var$deflateRaw$1;
var $ae290cc08e298ace$var$gzip_1$1 = $ae290cc08e298ace$var$gzip$1;
var $ae290cc08e298ace$var$constants$1 = $ae290cc08e298ace$var$constants$2;
var $ae290cc08e298ace$var$deflate_1$1 = {
    Deflate: $ae290cc08e298ace$var$Deflate_1$1,
    deflate: $ae290cc08e298ace$var$deflate_2,
    deflateRaw: $ae290cc08e298ace$var$deflateRaw_1$1,
    gzip: $ae290cc08e298ace$var$gzip_1$1,
    constants: $ae290cc08e298ace$var$constants$1
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
const $ae290cc08e298ace$var$BAD$1 = 16209; /* got a data error -- remain here until reset */ 
const $ae290cc08e298ace$var$TYPE$1 = 16191; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var $ae290cc08e298ace$var$inffast = function inflate_fast(strm, start) {
    let _in; /* local strm.input */ 
    let last; /* have enough input while in < last */ 
    let _out; /* local strm.output */ 
    let beg; /* inflate()'s initial strm.output */ 
    let end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    let dmax; /* maximum distance from zlib header */ 
    //#endif
    let wsize; /* window size or zero if not using window */ 
    let whave; /* valid bytes in the window */ 
    let wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    let s_window; /* allocated sliding window, if wsize != 0 */ 
    let hold; /* local strm.hold */ 
    let bits; /* local strm.bits */ 
    let lcode; /* local strm.lencode */ 
    let dcode; /* local strm.distcode */ 
    let lmask; /* mask for first level of length codes */ 
    let dmask; /* mask for first level of distance codes */ 
    let here; /* retrieved table entry */ 
    let op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ let len; /* match length, unused bytes */ 
    let dist; /* match distance */ 
    let from; /* where to copy match from */ 
    let from_source;
    let input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ const state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = $ae290cc08e298ace$var$BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = $ae290cc08e298ace$var$BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = $ae290cc08e298ace$var$BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $ae290cc08e298ace$var$TYPE$1;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = $ae290cc08e298ace$var$BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $ae290cc08e298ace$var$MAXBITS = 15;
const $ae290cc08e298ace$var$ENOUGH_LENS$1 = 852;
const $ae290cc08e298ace$var$ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
const $ae290cc08e298ace$var$CODES$1 = 0;
const $ae290cc08e298ace$var$LENS$1 = 1;
const $ae290cc08e298ace$var$DISTS$1 = 2;
const $ae290cc08e298ace$var$lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
const $ae290cc08e298ace$var$lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
]);
const $ae290cc08e298ace$var$dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
const $ae290cc08e298ace$var$dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
const $ae290cc08e298ace$var$inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts)=>{
    const bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    let len = 0; /* a code's length in bits */ 
    let sym = 0; /* index of code symbols */ 
    let min = 0, max = 0; /* minimum and maximum code lengths */ 
    let root = 0; /* number of index bits for root table */ 
    let curr = 0; /* number of index bits for current table */ 
    let drop = 0; /* code bits to drop for sub-table */ 
    let left = 0; /* number of prefix codes available */ 
    let used = 0; /* code entries in table used */ 
    let huff = 0; /* Huffman code */ 
    let incr; /* for incrementing code, index */ 
    let fill; /* index for replicating entries */ 
    let low; /* low bits for current root entry */ 
    let mask; /* mask for low root bits */ 
    let next; /* next available space in table */ 
    let base = null; /* base value table to use */ 
    //  let shoextra;    /* extra bits table to use */
    let match; /* use base and extra for symbol >= match */ 
    const count = new Uint16Array($ae290cc08e298ace$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    const offs = new Uint16Array($ae290cc08e298ace$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    let extra = null;
    let here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $ae290cc08e298ace$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $ae290cc08e298ace$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $ae290cc08e298ace$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $ae290cc08e298ace$var$CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $ae290cc08e298ace$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $ae290cc08e298ace$var$CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        match = 20;
    } else if (type === $ae290cc08e298ace$var$LENS$1) {
        base = $ae290cc08e298ace$var$lbase;
        extra = $ae290cc08e298ace$var$lext;
        match = 257;
    } else {
        base = $ae290cc08e298ace$var$dbase;
        extra = $ae290cc08e298ace$var$dext;
        match = 0;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $ae290cc08e298ace$var$LENS$1 && used > $ae290cc08e298ace$var$ENOUGH_LENS$1 || type === $ae290cc08e298ace$var$DISTS$1 && used > $ae290cc08e298ace$var$ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] + 1 < match) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] >= match) {
            here_op = extra[work[sym] - match];
            here_val = base[work[sym] - match];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $ae290cc08e298ace$var$LENS$1 && used > $ae290cc08e298ace$var$ENOUGH_LENS$1 || type === $ae290cc08e298ace$var$DISTS$1 && used > $ae290cc08e298ace$var$ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
var $ae290cc08e298ace$var$inftrees = $ae290cc08e298ace$var$inflate_table;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $ae290cc08e298ace$var$CODES = 0;
const $ae290cc08e298ace$var$LENS = 1;
const $ae290cc08e298ace$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_FINISH: $ae290cc08e298ace$var$Z_FINISH$1, Z_BLOCK: $ae290cc08e298ace$var$Z_BLOCK, Z_TREES: $ae290cc08e298ace$var$Z_TREES, Z_OK: $ae290cc08e298ace$var$Z_OK$1, Z_STREAM_END: $ae290cc08e298ace$var$Z_STREAM_END$1, Z_NEED_DICT: $ae290cc08e298ace$var$Z_NEED_DICT$1, Z_STREAM_ERROR: $ae290cc08e298ace$var$Z_STREAM_ERROR$1, Z_DATA_ERROR: $ae290cc08e298ace$var$Z_DATA_ERROR$1, Z_MEM_ERROR: $ae290cc08e298ace$var$Z_MEM_ERROR$1, Z_BUF_ERROR: $ae290cc08e298ace$var$Z_BUF_ERROR, Z_DEFLATED: $ae290cc08e298ace$var$Z_DEFLATED } = $ae290cc08e298ace$var$constants$2;
/* STATES ====================================================================*/ /* ===========================================================================*/ const $ae290cc08e298ace$var$HEAD = 16180; /* i: waiting for magic header */ 
const $ae290cc08e298ace$var$FLAGS = 16181; /* i: waiting for method and flags (gzip) */ 
const $ae290cc08e298ace$var$TIME = 16182; /* i: waiting for modification time (gzip) */ 
const $ae290cc08e298ace$var$OS = 16183; /* i: waiting for extra flags and operating system (gzip) */ 
const $ae290cc08e298ace$var$EXLEN = 16184; /* i: waiting for extra length (gzip) */ 
const $ae290cc08e298ace$var$EXTRA = 16185; /* i: waiting for extra bytes (gzip) */ 
const $ae290cc08e298ace$var$NAME = 16186; /* i: waiting for end of file name (gzip) */ 
const $ae290cc08e298ace$var$COMMENT = 16187; /* i: waiting for end of comment (gzip) */ 
const $ae290cc08e298ace$var$HCRC = 16188; /* i: waiting for header crc (gzip) */ 
const $ae290cc08e298ace$var$DICTID = 16189; /* i: waiting for dictionary check value */ 
const $ae290cc08e298ace$var$DICT = 16190; /* waiting for inflateSetDictionary() call */ 
const $ae290cc08e298ace$var$TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
const $ae290cc08e298ace$var$TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */ 
const $ae290cc08e298ace$var$STORED = 16193; /* i: waiting for stored size (length and complement) */ 
const $ae290cc08e298ace$var$COPY_ = 16194; /* i/o: same as COPY below, but only first time in */ 
const $ae290cc08e298ace$var$COPY = 16195; /* i/o: waiting for input or output to copy stored block */ 
const $ae290cc08e298ace$var$TABLE = 16196; /* i: waiting for dynamic block table lengths */ 
const $ae290cc08e298ace$var$LENLENS = 16197; /* i: waiting for code length code lengths */ 
const $ae290cc08e298ace$var$CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */ 
const $ae290cc08e298ace$var$LEN_ = 16199; /* i: same as LEN below, but only first time in */ 
const $ae290cc08e298ace$var$LEN = 16200; /* i: waiting for length/lit/eob code */ 
const $ae290cc08e298ace$var$LENEXT = 16201; /* i: waiting for length extra bits */ 
const $ae290cc08e298ace$var$DIST = 16202; /* i: waiting for distance code */ 
const $ae290cc08e298ace$var$DISTEXT = 16203; /* i: waiting for distance extra bits */ 
const $ae290cc08e298ace$var$MATCH = 16204; /* o: waiting for output space to copy string */ 
const $ae290cc08e298ace$var$LIT = 16205; /* o: waiting for output space to write literal */ 
const $ae290cc08e298ace$var$CHECK = 16206; /* i: waiting for 32-bit check value */ 
const $ae290cc08e298ace$var$LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */ 
const $ae290cc08e298ace$var$DONE = 16208; /* finished check, done -- remain here until reset */ 
const $ae290cc08e298ace$var$BAD = 16209; /* got a data error -- remain here until reset */ 
const $ae290cc08e298ace$var$MEM = 16210; /* got an inflate() memory error -- remain here until reset */ 
const $ae290cc08e298ace$var$SYNC = 16211; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ const $ae290cc08e298ace$var$ENOUGH_LENS = 852;
const $ae290cc08e298ace$var$ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
const $ae290cc08e298ace$var$MAX_WBITS = 15;
/* 32K LZ77 window */ const $ae290cc08e298ace$var$DEF_WBITS = $ae290cc08e298ace$var$MAX_WBITS;
const $ae290cc08e298ace$var$zswap32 = (q)=>{
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function $ae290cc08e298ace$var$InflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
const $ae290cc08e298ace$var$inflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const state = strm.state;
    if (!state || state.strm !== strm || state.mode < $ae290cc08e298ace$var$HEAD || state.mode > $ae290cc08e298ace$var$SYNC) return 1;
    return 0;
};
const $ae290cc08e298ace$var$inflateResetKeep = (strm)=>{
    if ($ae290cc08e298ace$var$inflateStateCheck(strm)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $ae290cc08e298ace$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.flags = -1;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array($ae290cc08e298ace$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new Int32Array($ae290cc08e298ace$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $ae290cc08e298ace$var$Z_OK$1;
};
const $ae290cc08e298ace$var$inflateReset = (strm)=>{
    if ($ae290cc08e298ace$var$inflateStateCheck(strm)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $ae290cc08e298ace$var$inflateResetKeep(strm);
};
const $ae290cc08e298ace$var$inflateReset2 = (strm, windowBits)=>{
    let wrap;
    /* get the state */ if ($ae290cc08e298ace$var$inflateStateCheck(strm)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $ae290cc08e298ace$var$inflateReset(strm);
};
const $ae290cc08e298ace$var$inflateInit2 = (strm, windowBits)=>{
    if (!strm) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    const state = new $ae290cc08e298ace$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.strm = strm;
    state.window = null /*Z_NULL*/ ;
    state.mode = $ae290cc08e298ace$var$HEAD; /* to pass state test in inflateReset2() */ 
    const ret = $ae290cc08e298ace$var$inflateReset2(strm, windowBits);
    if (ret !== $ae290cc08e298ace$var$Z_OK$1) strm.state = null /*Z_NULL*/ ;
    return ret;
};
const $ae290cc08e298ace$var$inflateInit = (strm)=>{
    return $ae290cc08e298ace$var$inflateInit2(strm, $ae290cc08e298ace$var$DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ let $ae290cc08e298ace$var$virgin = true;
let $ae290cc08e298ace$var$lenfix, $ae290cc08e298ace$var$distfix; // We have no pointers in JS, so keep tables separate
const $ae290cc08e298ace$var$fixedtables = (state)=>{
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($ae290cc08e298ace$var$virgin) {
        $ae290cc08e298ace$var$lenfix = new Int32Array(512);
        $ae290cc08e298ace$var$distfix = new Int32Array(32);
        /* literal/length table */ let sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $ae290cc08e298ace$var$inftrees($ae290cc08e298ace$var$LENS, state.lens, 0, 288, $ae290cc08e298ace$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $ae290cc08e298ace$var$inftrees($ae290cc08e298ace$var$DISTS, state.lens, 0, 32, $ae290cc08e298ace$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $ae290cc08e298ace$var$virgin = false;
    }
    state.lencode = $ae290cc08e298ace$var$lenfix;
    state.lenbits = 9;
    state.distcode = $ae290cc08e298ace$var$distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ const $ae290cc08e298ace$var$updatewindow = (strm, src, end, copy)=>{
    let dist;
    const state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new Uint8Array(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
const $ae290cc08e298ace$var$inflate$2 = (strm, flush)=>{
    let state;
    let input, output; // input/output buffers
    let next; /* next input INDEX */ 
    let put; /* next output INDEX */ 
    let have, left; /* available input and output */ 
    let hold; /* bit buffer */ 
    let bits; /* bits in bit buffer */ 
    let _in, _out; /* save starting available input and output */ 
    let copy; /* number of stored or match bytes to copy */ 
    let from; /* where to copy match bytes from */ 
    let from_source;
    let here = 0; /* current decoding table entry */ 
    let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    let len; /* length to copy for repeats, bits to drop */ 
    let ret; /* return code */ 
    const hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    let opts;
    let n; // temporary variable for NEED_BITS
    const order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if ($ae290cc08e298ace$var$inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.mode === $ae290cc08e298ace$var$TYPE) state.mode = $ae290cc08e298ace$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $ae290cc08e298ace$var$Z_OK$1;
    inf_leave: for(;;)switch(state.mode){
        case $ae290cc08e298ace$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $ae290cc08e298ace$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                if (state.wbits === 0) state.wbits = 15;
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $ae290cc08e298ace$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $ae290cc08e298ace$var$FLAGS;
                break;
            }
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $ae290cc08e298ace$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            if (len > 15 || len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            state.flags = 0; /* indicate zlib header */ 
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $ae290cc08e298ace$var$DICTID : $ae290cc08e298ace$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $ae290cc08e298ace$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $ae290cc08e298ace$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $ae290cc08e298ace$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ae290cc08e298ace$var$TIME;
        /* falls through */ case $ae290cc08e298ace$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $ae290cc08e298ace$var$crc32_1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ae290cc08e298ace$var$OS;
        /* falls through */ case $ae290cc08e298ace$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $ae290cc08e298ace$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ae290cc08e298ace$var$EXLEN;
        /* falls through */ case $ae290cc08e298ace$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200 && state.wrap & 4) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $ae290cc08e298ace$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $ae290cc08e298ace$var$EXTRA;
        /* falls through */ case $ae290cc08e298ace$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) state.check = $ae290cc08e298ace$var$crc32_1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $ae290cc08e298ace$var$NAME;
        /* falls through */ case $ae290cc08e298ace$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $ae290cc08e298ace$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $ae290cc08e298ace$var$COMMENT;
        /* falls through */ case $ae290cc08e298ace$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $ae290cc08e298ace$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $ae290cc08e298ace$var$HCRC;
        /* falls through */ case $ae290cc08e298ace$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = $ae290cc08e298ace$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $ae290cc08e298ace$var$TYPE;
            break;
        case $ae290cc08e298ace$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $ae290cc08e298ace$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ae290cc08e298ace$var$DICT;
        /* falls through */ case $ae290cc08e298ace$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $ae290cc08e298ace$var$Z_NEED_DICT$1;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $ae290cc08e298ace$var$TYPE;
        /* falls through */ case $ae290cc08e298ace$var$TYPE:
            if (flush === $ae290cc08e298ace$var$Z_BLOCK || flush === $ae290cc08e298ace$var$Z_TREES) break inf_leave;
        /* falls through */ case $ae290cc08e298ace$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $ae290cc08e298ace$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $ae290cc08e298ace$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $ae290cc08e298ace$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $ae290cc08e298ace$var$LEN_; /* decode codes */ 
                    if (flush === $ae290cc08e298ace$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $ae290cc08e298ace$var$TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = $ae290cc08e298ace$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $ae290cc08e298ace$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $ae290cc08e298ace$var$COPY_;
            if (flush === $ae290cc08e298ace$var$Z_TREES) break inf_leave;
        /* falls through */ case $ae290cc08e298ace$var$COPY_:
            state.mode = $ae290cc08e298ace$var$COPY;
        /* falls through */ case $ae290cc08e298ace$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $ae290cc08e298ace$var$TYPE;
            break;
        case $ae290cc08e298ace$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $ae290cc08e298ace$var$LENLENS;
        /* falls through */ case $ae290cc08e298ace$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $ae290cc08e298ace$var$inftrees($ae290cc08e298ace$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $ae290cc08e298ace$var$CODELENS;
        /* falls through */ case $ae290cc08e298ace$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = $ae290cc08e298ace$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = $ae290cc08e298ace$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $ae290cc08e298ace$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $ae290cc08e298ace$var$inftrees($ae290cc08e298ace$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $ae290cc08e298ace$var$inftrees($ae290cc08e298ace$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $ae290cc08e298ace$var$LEN_;
            if (flush === $ae290cc08e298ace$var$Z_TREES) break inf_leave;
        /* falls through */ case $ae290cc08e298ace$var$LEN_:
            state.mode = $ae290cc08e298ace$var$LEN;
        /* falls through */ case $ae290cc08e298ace$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $ae290cc08e298ace$var$inffast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $ae290cc08e298ace$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $ae290cc08e298ace$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $ae290cc08e298ace$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $ae290cc08e298ace$var$LENEXT;
        /* falls through */ case $ae290cc08e298ace$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $ae290cc08e298ace$var$DIST;
        /* falls through */ case $ae290cc08e298ace$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $ae290cc08e298ace$var$DISTEXT;
        /* falls through */ case $ae290cc08e298ace$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = $ae290cc08e298ace$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $ae290cc08e298ace$var$MATCH;
        /* falls through */ case $ae290cc08e298ace$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = $ae290cc08e298ace$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $ae290cc08e298ace$var$LEN;
            break;
        case $ae290cc08e298ace$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $ae290cc08e298ace$var$LEN;
            break;
        case $ae290cc08e298ace$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/ state.flags ? $ae290cc08e298ace$var$crc32_1(state.check, output, _out, put - _out) : $ae290cc08e298ace$var$adler32_1(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if (state.wrap & 4 && (state.flags ? hold : $ae290cc08e298ace$var$zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = $ae290cc08e298ace$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $ae290cc08e298ace$var$LENGTH;
        /* falls through */ case $ae290cc08e298ace$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = $ae290cc08e298ace$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $ae290cc08e298ace$var$DONE;
        /* falls through */ case $ae290cc08e298ace$var$DONE:
            ret = $ae290cc08e298ace$var$Z_STREAM_END$1;
            break inf_leave;
        case $ae290cc08e298ace$var$BAD:
            ret = $ae290cc08e298ace$var$Z_DATA_ERROR$1;
            break inf_leave;
        case $ae290cc08e298ace$var$MEM:
            return $ae290cc08e298ace$var$Z_MEM_ERROR$1;
        case $ae290cc08e298ace$var$SYNC:
        /* falls through */ default:
            return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $ae290cc08e298ace$var$BAD && (state.mode < $ae290cc08e298ace$var$CHECK || flush !== $ae290cc08e298ace$var$Z_FINISH$1)) $ae290cc08e298ace$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/ state.flags ? $ae290cc08e298ace$var$crc32_1(state.check, output, _out, strm.next_out - _out) : $ae290cc08e298ace$var$adler32_1(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $ae290cc08e298ace$var$TYPE ? 128 : 0) + (state.mode === $ae290cc08e298ace$var$LEN_ || state.mode === $ae290cc08e298ace$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $ae290cc08e298ace$var$Z_FINISH$1) && ret === $ae290cc08e298ace$var$Z_OK$1) ret = $ae290cc08e298ace$var$Z_BUF_ERROR;
    return ret;
};
const $ae290cc08e298ace$var$inflateEnd = (strm)=>{
    if ($ae290cc08e298ace$var$inflateStateCheck(strm)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    let state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $ae290cc08e298ace$var$Z_OK$1;
};
const $ae290cc08e298ace$var$inflateGetHeader = (strm, head)=>{
    /* check state */ if ($ae290cc08e298ace$var$inflateStateCheck(strm)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    if ((state.wrap & 2) === 0) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    /* save header structure */ state.head = head;
    head.done = false;
    return $ae290cc08e298ace$var$Z_OK$1;
};
const $ae290cc08e298ace$var$inflateSetDictionary = (strm, dictionary)=>{
    const dictLength = dictionary.length;
    let state;
    let dictid;
    let ret;
    /* check state */ if ($ae290cc08e298ace$var$inflateStateCheck(strm)) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $ae290cc08e298ace$var$DICT) return $ae290cc08e298ace$var$Z_STREAM_ERROR$1;
    /* check for correct dictionary identifier */ if (state.mode === $ae290cc08e298ace$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $ae290cc08e298ace$var$adler32_1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $ae290cc08e298ace$var$Z_DATA_ERROR$1;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $ae290cc08e298ace$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $ae290cc08e298ace$var$MEM;
        return $ae290cc08e298ace$var$Z_MEM_ERROR$1;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $ae290cc08e298ace$var$Z_OK$1;
};
var $ae290cc08e298ace$var$inflateReset_1 = $ae290cc08e298ace$var$inflateReset;
var $ae290cc08e298ace$var$inflateReset2_1 = $ae290cc08e298ace$var$inflateReset2;
var $ae290cc08e298ace$var$inflateResetKeep_1 = $ae290cc08e298ace$var$inflateResetKeep;
var $ae290cc08e298ace$var$inflateInit_1 = $ae290cc08e298ace$var$inflateInit;
var $ae290cc08e298ace$var$inflateInit2_1 = $ae290cc08e298ace$var$inflateInit2;
var $ae290cc08e298ace$var$inflate_2$1 = $ae290cc08e298ace$var$inflate$2;
var $ae290cc08e298ace$var$inflateEnd_1 = $ae290cc08e298ace$var$inflateEnd;
var $ae290cc08e298ace$var$inflateGetHeader_1 = $ae290cc08e298ace$var$inflateGetHeader;
var $ae290cc08e298ace$var$inflateSetDictionary_1 = $ae290cc08e298ace$var$inflateSetDictionary;
var $ae290cc08e298ace$var$inflateInfo = "pako inflate (from Nodeca project)";
/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/ var $ae290cc08e298ace$var$inflate_1$2 = {
    inflateReset: $ae290cc08e298ace$var$inflateReset_1,
    inflateReset2: $ae290cc08e298ace$var$inflateReset2_1,
    inflateResetKeep: $ae290cc08e298ace$var$inflateResetKeep_1,
    inflateInit: $ae290cc08e298ace$var$inflateInit_1,
    inflateInit2: $ae290cc08e298ace$var$inflateInit2_1,
    inflate: $ae290cc08e298ace$var$inflate_2$1,
    inflateEnd: $ae290cc08e298ace$var$inflateEnd_1,
    inflateGetHeader: $ae290cc08e298ace$var$inflateGetHeader_1,
    inflateSetDictionary: $ae290cc08e298ace$var$inflateSetDictionary_1,
    inflateInfo: $ae290cc08e298ace$var$inflateInfo
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $ae290cc08e298ace$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = "";
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = "";
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
var $ae290cc08e298ace$var$gzheader = $ae290cc08e298ace$var$GZheader;
const $ae290cc08e298ace$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $ae290cc08e298ace$var$Z_NO_FLUSH, Z_FINISH: $ae290cc08e298ace$var$Z_FINISH, Z_OK: $ae290cc08e298ace$var$Z_OK, Z_STREAM_END: $ae290cc08e298ace$var$Z_STREAM_END, Z_NEED_DICT: $ae290cc08e298ace$var$Z_NEED_DICT, Z_STREAM_ERROR: $ae290cc08e298ace$var$Z_STREAM_ERROR, Z_DATA_ERROR: $ae290cc08e298ace$var$Z_DATA_ERROR, Z_MEM_ERROR: $ae290cc08e298ace$var$Z_MEM_ERROR } = $ae290cc08e298ace$var$constants$2;
/* ===========================================================================*/ /**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $ae290cc08e298ace$var$Inflate$1(options) {
    this.options = $ae290cc08e298ace$var$common.assign({
        chunkSize: 65536,
        windowBits: 15,
        to: ""
    }, options || {});
    const opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $ae290cc08e298ace$var$zstream();
    this.strm.avail_out = 0;
    let status = $ae290cc08e298ace$var$inflate_1$2.inflateInit2(this.strm, opt.windowBits);
    if (status !== $ae290cc08e298ace$var$Z_OK) throw new Error($ae290cc08e298ace$var$messages[status]);
    this.header = new $ae290cc08e298ace$var$gzheader();
    $ae290cc08e298ace$var$inflate_1$2.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === "string") opt.dictionary = $ae290cc08e298ace$var$strings.string2buf(opt.dictionary);
        else if ($ae290cc08e298ace$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $ae290cc08e298ace$var$inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $ae290cc08e298ace$var$Z_OK) throw new Error($ae290cc08e298ace$var$messages[status]);
        }
    }
}
/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $ae290cc08e298ace$var$Inflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    const dictionary = this.options.dictionary;
    let status, _flush_mode, last_avail_out;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $ae290cc08e298ace$var$Z_FINISH : $ae290cc08e298ace$var$Z_NO_FLUSH;
    // Convert data if needed
    if ($ae290cc08e298ace$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $ae290cc08e298ace$var$inflate_1$2.inflate(strm, _flush_mode);
        if (status === $ae290cc08e298ace$var$Z_NEED_DICT && dictionary) {
            status = $ae290cc08e298ace$var$inflate_1$2.inflateSetDictionary(strm, dictionary);
            if (status === $ae290cc08e298ace$var$Z_OK) status = $ae290cc08e298ace$var$inflate_1$2.inflate(strm, _flush_mode);
            else if (status === $ae290cc08e298ace$var$Z_DATA_ERROR) // Replace code with more verbose
            status = $ae290cc08e298ace$var$Z_NEED_DICT;
        }
        // Skip snyc markers if more data follows and not raw mode
        while(strm.avail_in > 0 && status === $ae290cc08e298ace$var$Z_STREAM_END && strm.state.wrap > 0 && data[strm.next_in] !== 0){
            $ae290cc08e298ace$var$inflate_1$2.inflateReset(strm);
            status = $ae290cc08e298ace$var$inflate_1$2.inflate(strm, _flush_mode);
        }
        switch(status){
            case $ae290cc08e298ace$var$Z_STREAM_ERROR:
            case $ae290cc08e298ace$var$Z_DATA_ERROR:
            case $ae290cc08e298ace$var$Z_NEED_DICT:
            case $ae290cc08e298ace$var$Z_MEM_ERROR:
                this.onEnd(status);
                this.ended = true;
                return false;
        }
        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $ae290cc08e298ace$var$Z_STREAM_END) {
                if (this.options.to === "string") {
                    let next_out_utf8 = $ae290cc08e298ace$var$strings.utf8border(strm.output, strm.next_out);
                    let tail = strm.next_out - next_out_utf8;
                    let utf8str = $ae290cc08e298ace$var$strings.buf2string(strm.output, next_out_utf8);
                    // move tail & realign counters
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                    this.onData(utf8str);
                } else this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
            }
        }
        // Must repeat iteration if out buffer is full
        if (status === $ae290cc08e298ace$var$Z_OK && last_avail_out === 0) continue;
        // Finalize if end of stream reached.
        if (status === $ae290cc08e298ace$var$Z_STREAM_END) {
            status = $ae290cc08e298ace$var$inflate_1$2.inflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return true;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $ae290cc08e298ace$var$Inflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $ae290cc08e298ace$var$Inflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $ae290cc08e298ace$var$Z_OK) {
        if (this.options.to === "string") this.result = this.chunks.join("");
        else this.result = $ae290cc08e298ace$var$common.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/ function $ae290cc08e298ace$var$inflate$1(input, options) {
    const inflator = new $ae290cc08e298ace$var$Inflate$1(options);
    inflator.push(input);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $ae290cc08e298ace$var$messages[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $ae290cc08e298ace$var$inflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $ae290cc08e298ace$var$inflate$1(input, options);
}
/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $ae290cc08e298ace$var$Inflate_1$1 = $ae290cc08e298ace$var$Inflate$1;
var $ae290cc08e298ace$var$inflate_2 = $ae290cc08e298ace$var$inflate$1;
var $ae290cc08e298ace$var$inflateRaw_1$1 = $ae290cc08e298ace$var$inflateRaw$1;
var $ae290cc08e298ace$var$ungzip$1 = $ae290cc08e298ace$var$inflate$1;
var $ae290cc08e298ace$var$constants = $ae290cc08e298ace$var$constants$2;
var $ae290cc08e298ace$var$inflate_1$1 = {
    Inflate: $ae290cc08e298ace$var$Inflate_1$1,
    inflate: $ae290cc08e298ace$var$inflate_2,
    inflateRaw: $ae290cc08e298ace$var$inflateRaw_1$1,
    ungzip: $ae290cc08e298ace$var$ungzip$1,
    constants: $ae290cc08e298ace$var$constants
};
const { Deflate: $ae290cc08e298ace$var$Deflate, deflate: $ae290cc08e298ace$var$deflate, deflateRaw: $ae290cc08e298ace$var$deflateRaw, gzip: $ae290cc08e298ace$var$gzip } = $ae290cc08e298ace$var$deflate_1$1;
const { Inflate: $ae290cc08e298ace$var$Inflate, inflate: $ae290cc08e298ace$var$inflate, inflateRaw: $ae290cc08e298ace$var$inflateRaw, ungzip: $ae290cc08e298ace$var$ungzip } = $ae290cc08e298ace$var$inflate_1$1;
var $ae290cc08e298ace$export$ae157b6234afe138 = $ae290cc08e298ace$var$Deflate;
var $ae290cc08e298ace$export$2316623ecd1285ab = $ae290cc08e298ace$var$deflate;
var $ae290cc08e298ace$export$e95d6a8f69fb340a = $ae290cc08e298ace$var$deflateRaw;
var $ae290cc08e298ace$export$69f0ea7cf3a331a8 = $ae290cc08e298ace$var$gzip;
var $ae290cc08e298ace$export$d1de70a877d6e43c = $ae290cc08e298ace$var$Inflate;
var $ae290cc08e298ace$export$cae1ce83fe4a1782 = $ae290cc08e298ace$var$inflate;
var $ae290cc08e298ace$export$d0f0aa2d05c905c5 = $ae290cc08e298ace$var$inflateRaw;
var $ae290cc08e298ace$export$95adf9d270383091 = $ae290cc08e298ace$var$ungzip;
var $ae290cc08e298ace$export$1a988e7317c65621 = $ae290cc08e298ace$var$constants$2;
var $ae290cc08e298ace$export$2e2bcd8739ae039 = {
    Deflate: $ae290cc08e298ace$export$ae157b6234afe138,
    deflate: $ae290cc08e298ace$export$2316623ecd1285ab,
    deflateRaw: $ae290cc08e298ace$export$e95d6a8f69fb340a,
    gzip: $ae290cc08e298ace$export$69f0ea7cf3a331a8,
    Inflate: $ae290cc08e298ace$export$d1de70a877d6e43c,
    inflate: $ae290cc08e298ace$export$cae1ce83fe4a1782,
    inflateRaw: $ae290cc08e298ace$export$d0f0aa2d05c905c5,
    ungzip: $ae290cc08e298ace$export$95adf9d270383091,
    constants: $ae290cc08e298ace$export$1a988e7317c65621
};

});

parcelRegister("jxHwd", function(module, exports) {
// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
parcelRequire("eRv67");
module.exports = self.fetch.bind(self);

});
parcelRegister("eRv67", function(module, exports) {
/* eslint-disable no-prototype-builtins */ var $ad1e23473b0550f0$var$g = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== "undefined" && $parcel$global || {};
var $ad1e23473b0550f0$var$support = {
    searchParams: "URLSearchParams" in $ad1e23473b0550f0$var$g,
    iterable: "Symbol" in $ad1e23473b0550f0$var$g && "iterator" in Symbol,
    blob: "FileReader" in $ad1e23473b0550f0$var$g && "Blob" in $ad1e23473b0550f0$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: "FormData" in $ad1e23473b0550f0$var$g,
    arrayBuffer: "ArrayBuffer" in $ad1e23473b0550f0$var$g
};
function $ad1e23473b0550f0$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($ad1e23473b0550f0$var$support.arrayBuffer) {
    var $ad1e23473b0550f0$var$viewClasses = [
        "[object Int8Array]",
        "[object Uint8Array]",
        "[object Uint8ClampedArray]",
        "[object Int16Array]",
        "[object Uint16Array]",
        "[object Int32Array]",
        "[object Uint32Array]",
        "[object Float32Array]",
        "[object Float64Array]"
    ];
    var $ad1e23473b0550f0$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $ad1e23473b0550f0$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $ad1e23473b0550f0$var$normalizeName(name) {
    if (typeof name !== "string") name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $ad1e23473b0550f0$var$normalizeValue(value) {
    if (typeof value !== "string") value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $ad1e23473b0550f0$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($ad1e23473b0550f0$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $ad1e23473b0550f0$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $ad1e23473b0550f0$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $ad1e23473b0550f0$var$normalizeName(name);
    value = $ad1e23473b0550f0$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ", " + value : value;
};
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype["delete"] = function(name) {
    delete this.map[$ad1e23473b0550f0$var$normalizeName(name)];
};
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $ad1e23473b0550f0$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($ad1e23473b0550f0$var$normalizeName(name));
};
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$ad1e23473b0550f0$var$normalizeName(name)] = $ad1e23473b0550f0$var$normalizeValue(value);
};
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $ad1e23473b0550f0$var$iteratorFor(items);
};
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $ad1e23473b0550f0$var$iteratorFor(items);
};
$ad1e23473b0550f0$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $ad1e23473b0550f0$var$iteratorFor(items);
};
if ($ad1e23473b0550f0$var$support.iterable) $ad1e23473b0550f0$export$79b704688b15c0f4.prototype[Symbol.iterator] = $ad1e23473b0550f0$export$79b704688b15c0f4.prototype.entries;
function $ad1e23473b0550f0$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
    body.bodyUsed = true;
}
function $ad1e23473b0550f0$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $ad1e23473b0550f0$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $ad1e23473b0550f0$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $ad1e23473b0550f0$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $ad1e23473b0550f0$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : "utf-8";
    reader.readAsText(blob, encoding);
    return promise;
}
function $ad1e23473b0550f0$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join("");
}
function $ad1e23473b0550f0$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $ad1e23473b0550f0$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = "";
        } else if (typeof body === "string") this._bodyText = body;
        else if ($ad1e23473b0550f0$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($ad1e23473b0550f0$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($ad1e23473b0550f0$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($ad1e23473b0550f0$var$support.arrayBuffer && $ad1e23473b0550f0$var$support.blob && $ad1e23473b0550f0$var$isDataView(body)) {
            this._bodyArrayBuffer = $ad1e23473b0550f0$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($ad1e23473b0550f0$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $ad1e23473b0550f0$var$isArrayBufferView(body))) this._bodyArrayBuffer = $ad1e23473b0550f0$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get("content-type")) {
            if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
            else if ($ad1e23473b0550f0$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
        }
    };
    if ($ad1e23473b0550f0$var$support.blob) this.blob = function() {
        var rejected = $ad1e23473b0550f0$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $ad1e23473b0550f0$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($ad1e23473b0550f0$var$support.blob) return this.blob().then($ad1e23473b0550f0$var$readBlobAsArrayBuffer);
        else throw new Error("could not read as ArrayBuffer");
    };
    this.text = function() {
        var rejected = $ad1e23473b0550f0$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $ad1e23473b0550f0$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($ad1e23473b0550f0$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error("could not read FormData body as text");
        else return Promise.resolve(this._bodyText);
    };
    if ($ad1e23473b0550f0$var$support.formData) this.formData = function() {
        return this.text().then($ad1e23473b0550f0$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $ad1e23473b0550f0$var$methods = [
    "CONNECT",
    "DELETE",
    "GET",
    "HEAD",
    "OPTIONS",
    "PATCH",
    "POST",
    "PUT",
    "TRACE"
];
function $ad1e23473b0550f0$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $ad1e23473b0550f0$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $ad1e23473b0550f0$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $ad1e23473b0550f0$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $ad1e23473b0550f0$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError("Already read");
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $ad1e23473b0550f0$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || "same-origin";
    if (options.headers || !this.headers) this.headers = new $ad1e23473b0550f0$export$79b704688b15c0f4(options.headers);
    this.method = $ad1e23473b0550f0$var$normalizeMethod(options.method || this.method || "GET");
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ("AbortController" in $ad1e23473b0550f0$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
    this._initBody(body);
    if (this.method === "GET" || this.method === "HEAD") {
        if (options.cache === "no-store" || options.cache === "no-cache") {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
            }
        }
    }
}
$ad1e23473b0550f0$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $ad1e23473b0550f0$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $ad1e23473b0550f0$var$decode(body) {
    var form = new FormData();
    body.trim().split("&").forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split("=");
            var name = split.shift().replace(/\+/g, " ");
            var value = split.join("=").replace(/\+/g, " ");
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $ad1e23473b0550f0$var$parseHeaders(rawHeaders) {
    var headers = new $ad1e23473b0550f0$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split("\r").map(function(header) {
        return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(":");
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(":").trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn("Response " + error.message);
            }
        }
    });
    return headers;
}
$ad1e23473b0550f0$var$Body.call($ad1e23473b0550f0$export$7fa6c5b6f8193917.prototype);
function $ad1e23473b0550f0$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $ad1e23473b0550f0$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = "default";
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? "" : "" + options.statusText;
    this.headers = new $ad1e23473b0550f0$export$79b704688b15c0f4(options.headers);
    this.url = options.url || "";
    this._initBody(bodyInit);
}
$ad1e23473b0550f0$var$Body.call($ad1e23473b0550f0$export$9f633d56d7ec90d3.prototype);
$ad1e23473b0550f0$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $ad1e23473b0550f0$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $ad1e23473b0550f0$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$ad1e23473b0550f0$export$9f633d56d7ec90d3.error = function() {
    var response = new $ad1e23473b0550f0$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ""
    });
    response.ok = false;
    response.status = 0;
    response.type = "error";
    return response;
};
var $ad1e23473b0550f0$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$ad1e23473b0550f0$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($ad1e23473b0550f0$var$redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
    return new $ad1e23473b0550f0$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $ad1e23473b0550f0$export$fe58bcf938607f6a = $ad1e23473b0550f0$var$g.DOMException;
try {
    new $ad1e23473b0550f0$export$fe58bcf938607f6a();
} catch (err) {
    $ad1e23473b0550f0$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $ad1e23473b0550f0$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $ad1e23473b0550f0$export$fe58bcf938607f6a.prototype.constructor = $ad1e23473b0550f0$export$fe58bcf938607f6a;
}
function $ad1e23473b0550f0$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $ad1e23473b0550f0$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $ad1e23473b0550f0$export$fe58bcf938607f6a("Aborted", "AbortError"));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $ad1e23473b0550f0$var$parseHeaders(xhr.getAllResponseHeaders() || "")
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf("file://") === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
            var body = "response" in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $ad1e23473b0550f0$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError("Network request failed"));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError("Network request timed out"));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $ad1e23473b0550f0$export$fe58bcf938607f6a("Aborted", "AbortError"));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === "" && $ad1e23473b0550f0$var$g.location.href ? $ad1e23473b0550f0$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === "include") xhr.withCredentials = true;
        else if (request.credentials === "omit") xhr.withCredentials = false;
        if ("responseType" in xhr) {
            if ($ad1e23473b0550f0$var$support.blob) xhr.responseType = "blob";
            else if ($ad1e23473b0550f0$var$support.arrayBuffer) xhr.responseType = "arraybuffer";
        }
        if (init && typeof init.headers === "object" && !(init.headers instanceof $ad1e23473b0550f0$export$79b704688b15c0f4 || $ad1e23473b0550f0$var$g.Headers && init.headers instanceof $ad1e23473b0550f0$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($ad1e23473b0550f0$var$normalizeName(name));
                xhr.setRequestHeader(name, $ad1e23473b0550f0$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener("abort", abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
    });
}
$ad1e23473b0550f0$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$ad1e23473b0550f0$var$g.fetch) {
    $ad1e23473b0550f0$var$g.fetch = $ad1e23473b0550f0$export$e7aa7bc5c1b3cfb3;
    $ad1e23473b0550f0$var$g.Headers = $ad1e23473b0550f0$export$79b704688b15c0f4;
    $ad1e23473b0550f0$var$g.Request = $ad1e23473b0550f0$export$7fa6c5b6f8193917;
    $ad1e23473b0550f0$var$g.Response = $ad1e23473b0550f0$export$9f633d56d7ec90d3;
}

});


parcelRegister("4oIhN", function(module, exports) {
(function(name, context, definition) {
    if (0, module.exports) module.exports = definition();
    else if (typeof define === "function" && define.amd) define(definition);
    else context[name] = definition();
})("urljoin", module.exports, function() {
    function normalize(strArray) {
        var resultArray = [];
        if (strArray.length === 0) return "";
        if (typeof strArray[0] !== "string") throw new TypeError("Url must be a string. Received " + strArray[0]);
        // If the first part is a plain protocol, we combine it with the next part.
        if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
            var first = strArray.shift();
            strArray[0] = first + strArray[0];
        }
        // There must be two or three slashes in the file protocol, two slashes in anything else.
        if (strArray[0].match(/^file:\/\/\//)) strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1:///");
        else strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, "$1://");
        for(var i = 0; i < strArray.length; i++){
            var component = strArray[i];
            if (typeof component !== "string") throw new TypeError("Url must be a string. Received " + component);
            if (component === "") continue;
            if (i > 0) // Removing the starting slashes for each component but the first.
            component = component.replace(/^[\/]+/, "");
            if (i < strArray.length - 1) // Removing the ending slashes for each component but the last.
            component = component.replace(/[\/]+$/, "");
            else // For the last component we will combine multiple slashes to a single one.
            component = component.replace(/[\/]+$/, "/");
            resultArray.push(component);
        }
        var str = resultArray.join("/");
        // Each input component is now separated by a single slash except the possible first plain protocol part.
        // remove trailing slash before parameters or hash
        str = str.replace(/\/(\?|&|#[^!])/g, "$1");
        // replace ? in parameters with &
        var parts = str.split("?");
        str = parts.shift() + (parts.length > 0 ? "?" : "") + parts.join("&");
        return str;
    }
    return function() {
        var input;
        if (typeof arguments[0] === "object") input = arguments[0];
        else input = [].slice.call(arguments);
        return normalize(input);
    };
});

});



parcelRegister("lnWdi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAccount = void 0;

var $3GDHM = parcelRequire("3GDHM");
function $f918e6ec2833f93f$var$getAccount(config) {
    return new $3GDHM.Account(new $3GDHM.RpcProvider({
        nodeUrl: config.rpcUrl
    }), config.ownerAddress, new $3GDHM.Signer(config.privateKey));
}
module.exports.getAccount = $f918e6ec2833f93f$var$getAccount;

});

parcelRegister("lTZjH", function(module, exports) {
"use strict";
var $ff1e4c3a7b608ee4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PriceAdapterStarknetContractConnector = void 0;

var $kHc9u = parcelRequire("kHc9u");

var $4PMBh = parcelRequire("4PMBh");

const $ff1e4c3a7b608ee4$var$price_adapter_abi_json_1 = $ff1e4c3a7b608ee4$var$__importDefault((parcelRequire("bqKoW")));
class $ff1e4c3a7b608ee4$var$PriceAdapterStarknetContractConnector extends $kHc9u.StarknetContractConnector {
    getAdapter() {
        return Promise.resolve(new $4PMBh.PriceAdapterStarknetContractAdapter(this.getContract()));
    }
    constructor(provider, contractAddress){
        super(provider, contractAddress, $ff1e4c3a7b608ee4$var$price_adapter_abi_json_1.default);
    }
}
module.exports.PriceAdapterStarknetContractConnector = $ff1e4c3a7b608ee4$var$PriceAdapterStarknetContractConnector;

});
parcelRegister("4PMBh", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PriceAdapterStarknetContractAdapter = void 0;

var $kHc9u = parcelRequire("kHc9u");

var $iyjmS = parcelRequire("iyjmS");
class $38519fdf9e435afb$var$PriceAdapterStarknetContractAdapter {
    async writePricesFromPayloadToContract(paramsProvider) {
        return (await this.contract.invoke("write_prices", [
            paramsProvider.getHexlifiedFeedIds(),
            await paramsProvider.getPayloadData()
        ], {
            maxFee: 0.004 * $kHc9u.FEE_MULTIPLIER,
            parseRequest: true
        })).transaction_hash;
    }
    async getPricesFromPayload(paramsProvider) {
        return (0, $iyjmS.extractNumbers)(await this.contract.call("get_prices", [
            paramsProvider.getHexlifiedFeedIds(),
            await paramsProvider.getPayloadData()
        ]));
    }
    async readPricesFromContract(paramsProvider) {
        return (0, $iyjmS.extractNumbers)(await this.contract.call("read_prices", [
            paramsProvider.getHexlifiedFeedIds()
        ]));
    }
    async readTimestampFromContract() {
        return (0, $iyjmS.getNumberFromStarknetResult)(await this.contract.call("read_timestamp"));
    }
    constructor(contract){
        (0, $dxWQo._)(this, "contract", void 0);
        this.contract = contract;
    }
}
module.exports.PriceAdapterStarknetContractAdapter = $38519fdf9e435afb$var$PriceAdapterStarknetContractAdapter;

});
parcelRegister("iyjmS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extractNumbers = module.exports.getNumberFromStarknetResult = void 0;
function $d81a6d07c86c9378$var$getNumberFromStarknetResult(value) {
    return Number(value);
}
module.exports.getNumberFromStarknetResult = $d81a6d07c86c9378$var$getNumberFromStarknetResult;
function $d81a6d07c86c9378$var$extractNumbers(response) {
    return response.map($d81a6d07c86c9378$var$getNumberFromStarknetResult);
}
module.exports.extractNumbers = $d81a6d07c86c9378$var$extractNumbers;

});


parcelRegister("bqKoW", function(module, exports) {
module.exports = JSON.parse('[{"name":"constructor","type":"constructor","inputs":[{"name":"signer_count_threshold","type":"core::felt252"},{"name":"signer_addresses","type":"core::array::Array::<core::felt252>"}]},{"name":"get_prices","type":"function","inputs":[{"name":"feed_ids","type":"core::array::Array::<core::felt252>"},{"name":"payload_bytes","type":"core::array::Array::<core::integer::u8>"}],"outputs":[{"type":"core::array::Array::<core::felt252>"}],"state_mutability":"view"},{"name":"read_timestamp","type":"function","inputs":[],"outputs":[{"type":"core::felt252"}],"state_mutability":"view"},{"name":"read_prices","type":"function","inputs":[{"name":"feed_ids","type":"core::array::Array::<core::felt252>"}],"outputs":[{"type":"core::array::Array::<core::felt252>"}],"state_mutability":"view"},{"name":"write_prices","type":"function","inputs":[{"name":"feed_ids","type":"core::array::Array::<core::felt252>"},{"name":"payload_bytes","type":"core::array::Array::<core::integer::u8>"}],"outputs":[],"state_mutability":"external"},{"kind":"enum","name":"price_adapter::price_adapter::PriceAdapter::Event","type":"event","variants":[]}]');

});


parcelRegister("hzheU", function(module, exports) {
"use strict";
var $cca313ee01061e22$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PriceFeedStarknetContractConnector = void 0;

var $kHc9u = parcelRequire("kHc9u");

const $cca313ee01061e22$var$price_feed_abi_json_1 = $cca313ee01061e22$var$__importDefault((parcelRequire("jd6Vp")));

var $eHKKD = parcelRequire("eHKKD");
class $cca313ee01061e22$var$PriceFeedStarknetContractConnector extends $kHc9u.StarknetContractConnector {
    getAdapter() {
        return Promise.resolve(new $eHKKD.PriceFeedStarknetContractAdapter(this.getContract()));
    }
    constructor(provider, contractAddress){
        super(provider, contractAddress, $cca313ee01061e22$var$price_feed_abi_json_1.default);
    }
}
module.exports.PriceFeedStarknetContractConnector = $cca313ee01061e22$var$PriceFeedStarknetContractConnector;

});
parcelRegister("jd6Vp", function(module, exports) {
module.exports = JSON.parse('[{"name":"constructor","type":"constructor","inputs":[{"name":"manager_address","type":"core::felt252"},{"name":"feed_id","type":"core::felt252"}]},{"name":"read_price_and_timestamp","type":"function","inputs":[],"outputs":[{"type":"(core::felt252, core::felt252)"}],"state_mutability":"view"},{"kind":"enum","name":"price_feed::price_feed::PriceFeed::Event","type":"event","variants":[]}]');

});

parcelRegister("eHKKD", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PriceFeedStarknetContractAdapter = void 0;

var $iyjmS = parcelRequire("iyjmS");
class $ab4958a2fc163c93$var$PriceFeedStarknetContractAdapter {
    async getPriceAndTimestamp() {
        const response = await this.contract.call("read_price_and_timestamp");
        const values = (0, $iyjmS.extractNumbers)(Object.values(response));
        return {
            value: values[0],
            timestamp: values[1]
        };
    }
    constructor(contract){
        (0, $dxWQo._)(this, "contract", void 0);
        this.contract = contract;
    }
}
module.exports.PriceFeedStarknetContractAdapter = $ab4958a2fc163c93$var$PriceFeedStarknetContractAdapter;

});


parcelRegister("a787O", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
var $75d0dc449bcd39dc$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PriceRoundsAdapterStarknetContractConnector = void 0;

const $75d0dc449bcd39dc$var$price_rounds_adapter_abi_json_1 = $75d0dc449bcd39dc$var$__importDefault((parcelRequire("84fmo")));

var $exEPU = parcelRequire("exEPU");

var $kHc9u = parcelRequire("kHc9u");
class $75d0dc449bcd39dc$var$PriceRoundsAdapterStarknetContractConnector extends $kHc9u.StarknetContractConnector {
    getAdapter() {
        return Promise.resolve(new $exEPU.PriceRoundsAdapterStarknetContractAdapter(this.getContract(), this.paramsProvider));
    }
    constructor(provider, address, paramsProvider){
        super(provider, address, $75d0dc449bcd39dc$var$price_rounds_adapter_abi_json_1.default);
        (0, $dxWQo._)(this, "paramsProvider", void 0);
        this.paramsProvider = paramsProvider;
    }
}
module.exports.PriceRoundsAdapterStarknetContractConnector = $75d0dc449bcd39dc$var$PriceRoundsAdapterStarknetContractConnector;

});
parcelRegister("84fmo", function(module, exports) {
module.exports = JSON.parse('[{"name":"constructor","type":"constructor","inputs":[{"name":"owner_address","type":"core::felt252"},{"name":"signer_count_threshold","type":"core::felt252"},{"name":"signer_addresses","type":"core::array::Array::<core::felt252>"}]},{"name":"read_price","type":"function","inputs":[{"name":"feed_id","type":"core::felt252"}],"outputs":[{"type":"core::felt252"}],"state_mutability":"view"},{"name":"interface::round_data::RoundData","type":"struct","members":[{"name":"round_number","type":"core::integer::u64"},{"name":"payload_timestamp","type":"core::integer::u64"},{"name":"block_number","type":"core::integer::u64"},{"name":"block_timestamp","type":"core::integer::u64"}]},{"name":"read_round_data","type":"function","inputs":[],"outputs":[{"type":"interface::round_data::RoundData"}],"state_mutability":"view"},{"name":"read_round_data_and_price","type":"function","inputs":[{"name":"feed_id","type":"core::felt252"}],"outputs":[{"type":"(interface::round_data::RoundData, core::felt252)"}],"state_mutability":"view"},{"name":"write_prices","type":"function","inputs":[{"name":"round_number","type":"core::felt252"},{"name":"feed_ids","type":"core::array::Array::<core::felt252>"},{"name":"payload_bytes","type":"core::array::Array::<core::integer::u8>"}],"outputs":[],"state_mutability":"external"},{"name":"write_price_values","type":"function","inputs":[{"name":"round_number","type":"core::felt252"},{"name":"feed_ids","type":"core::array::Array::<core::felt252>"},{"name":"prices","type":"core::array::Array::<core::felt252>"},{"name":"payload_timestamp","type":"core::felt252"}],"outputs":[],"state_mutability":"external"},{"kind":"enum","name":"price_rounds_adapter::price_rounds_adapter::PriceRoundsAdapter::Event","type":"event","variants":[]}]');

});

parcelRegister("exEPU", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PriceRoundsAdapterStarknetContractAdapter = void 0;

var $iyjmS = parcelRequire("iyjmS");

var $kHc9u = parcelRequire("kHc9u");
class $a963d2fadfd7279d$var$PriceRoundsAdapterStarknetContractAdapter {
    async readTimestampAndRound() {
        const result = await this.contract.call("read_round_data");
        return {
            payload_timestamp: (0, $iyjmS.getNumberFromStarknetResult)(result.payload_timestamp) * 1000,
            round: (0, $iyjmS.getNumberFromStarknetResult)(result.round_number),
            block_number: (0, $iyjmS.getNumberFromStarknetResult)(result.block_number),
            block_timestamp: (0, $iyjmS.getNumberFromStarknetResult)(result.block_timestamp) * 1000
        };
    }
    async writePrices(round) {
        return (await this.contract.invoke("write_prices", [
            round,
            this.paramsProvider.getHexlifiedFeedIds(),
            await this.paramsProvider.getPayloadData()
        ], {
            maxFee: this.maxEthFee * $kHc9u.FEE_MULTIPLIER,
            parseRequest: true
        })).transaction_hash;
    }
    constructor(contract, paramsProvider, maxEthFee = 0.004){
        (0, $dxWQo._)(this, "contract", void 0);
        (0, $dxWQo._)(this, "paramsProvider", void 0);
        (0, $dxWQo._)(this, "maxEthFee", void 0);
        this.contract = contract;
        this.paramsProvider = paramsProvider;
        this.maxEthFee = maxEthFee;
    }
}
module.exports.PriceRoundsAdapterStarknetContractAdapter = $a963d2fadfd7279d$var$PriceRoundsAdapterStarknetContractAdapter;

});


parcelRegister("1uXqT", function(module, exports) {
"use strict";
var $1176b1df9a9fdffd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PriceRoundsFeedStarknetContractConnector = void 0;

const $1176b1df9a9fdffd$var$price_rounds_feed_abi_json_1 = $1176b1df9a9fdffd$var$__importDefault((parcelRequire("efqZt")));

var $5DtAb = parcelRequire("5DtAb");

var $kHc9u = parcelRequire("kHc9u");
class $1176b1df9a9fdffd$var$PriceRoundsFeedStarknetContractConnector extends $kHc9u.StarknetContractConnector {
    async getAdapter() {
        return await Promise.resolve(new $5DtAb.PriceRoundsFeedStarknetContractAdapter(this.getContract()));
    }
    constructor(provider, feedContractAddress){
        super(provider, feedContractAddress, $1176b1df9a9fdffd$var$price_rounds_feed_abi_json_1.default);
    }
}
module.exports.PriceRoundsFeedStarknetContractConnector = $1176b1df9a9fdffd$var$PriceRoundsFeedStarknetContractConnector;

});
parcelRegister("efqZt", function(module, exports) {
module.exports = JSON.parse('[{"name":"NameRegistry","type":"impl","interface_name":"price_rounds_feed::price_rounds_feed::IPriceRoundsFeed"},{"name":"price_rounds_feed::round::Round","type":"struct","members":[{"name":"round_id","type":"core::felt252"},{"name":"answer","type":"core::felt252"},{"name":"block_num","type":"core::felt252"},{"name":"started_at","type":"core::felt252"},{"name":"updated_at","type":"core::felt252"}]},{"name":"price_rounds_feed::price_rounds_feed::IPriceRoundsFeed","type":"interface","items":[{"name":"latest_round_data","type":"function","inputs":[],"outputs":[{"type":"price_rounds_feed::round::Round"}],"state_mutability":"view"},{"name":"round_data","type":"function","inputs":[{"name":"round_id","type":"core::felt252"}],"outputs":[{"type":"price_rounds_feed::round::Round"}],"state_mutability":"view"},{"name":"description","type":"function","inputs":[],"outputs":[{"type":"core::felt252"}],"state_mutability":"view"},{"name":"decimals","type":"function","inputs":[],"outputs":[{"type":"core::felt252"}],"state_mutability":"view"},{"name":"type_and_version","type":"function","inputs":[],"outputs":[{"type":"core::felt252"}],"state_mutability":"view"}]},{"name":"constructor","type":"constructor","inputs":[{"name":"manager_address","type":"core::felt252"},{"name":"feed_id","type":"core::felt252"}]},{"kind":"enum","name":"price_rounds_feed::price_rounds_feed::PriceRoundsFeed::Event","type":"event","variants":[]}]');

});

parcelRegister("5DtAb", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PriceRoundsFeedStarknetContractAdapter = void 0;
class $41a78ac16080a5c6$var$PriceRoundsFeedStarknetContractAdapter {
    async readLatestRoundData() {
        return await this.contract.call("latest_round_data");
    }
    constructor(contract){
        (0, $dxWQo._)(this, "contract", void 0);
        this.contract = contract;
    }
}
module.exports.PriceRoundsFeedStarknetContractAdapter = $41a78ac16080a5c6$var$PriceRoundsFeedStarknetContractAdapter;

});


parcelRegister("fIBDJ", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WrapperBuilder = void 0;

var $dHSfA = parcelRequire("dHSfA");

var $cp01f = parcelRequire("cp01f");

var $eqe9p = parcelRequire("eqe9p");

var $efDrj = parcelRequire("efDrj");

var $cwzTA = parcelRequire("cwzTA");
class $b71829935a79d4a5$var$WrapperBuilder {
    static wrap(contract) {
        return new $b71829935a79d4a5$var$WrapperBuilder(contract);
    }
    usingDataService(dataPackagesRequestInput) {
        return new $cp01f.DataServiceWrapper(dataPackagesRequestInput).overwriteEthersContract(this.baseContract);
    }
    usingMockDataPackages(mockDataPackages) {
        return new $eqe9p.MockWrapper(mockDataPackages).overwriteEthersContract(this.baseContract);
    }
    usingSimpleNumericMock(simpleNumericMockConfig) {
        return new $cwzTA.SimpleNumericMockWrapper(simpleNumericMockConfig).overwriteEthersContract(this.baseContract);
    }
    usingOnDemandRequest(nodeUrls, scoreType) {
        return new $efDrj.OnDemandRequestWrapper({
            signer: this.baseContract.signer,
            scoreType: scoreType
        }, nodeUrls).overwriteEthersContract(this.baseContract);
    }
    usingDataPackages(dataPackages) {
        return new $dHSfA.DataPackagesWrapper(dataPackages).overwriteEthersContract(this.baseContract);
    }
    constructor(baseContract){
        (0, $dxWQo._)(this, "baseContract", void 0);
        this.baseContract = baseContract;
    }
}
module.exports.WrapperBuilder = $b71829935a79d4a5$var$WrapperBuilder;

});
parcelRegister("dHSfA", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataPackagesWrapper = void 0;

var $fsQXA = parcelRequire("fsQXA");

var $b3J9M = parcelRequire("b3J9M");
class $9fa95f881887f0af$var$DataPackagesWrapper extends $fsQXA.BaseWrapper {
    getUnsignedMetadata() {
        return `${this.getMetadataTimestamp()}#${$b3J9M.version}#data-packages-wrapper`;
    }
    async getDataPackagesForPayload() {
        return Object.values(this.dataPackages).flat();
    }
    constructor(dataPackages){
        super();
        (0, $dxWQo._)(this, "dataPackages", void 0);
        this.dataPackages = dataPackages;
    }
}
module.exports.DataPackagesWrapper = $9fa95f881887f0af$var$DataPackagesWrapper;

});
parcelRegister("fsQXA", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseWrapper = void 0;

var $iGUqv = parcelRequire("iGUqv");

var $7cve4 = parcelRequire("7cve4");

var $6vSZI = parcelRequire("6vSZI");
class $b4228d52b46737ae$var$BaseWrapper {
    async getBytesDataForAppending() {
        const shouldBeMultipleOf32 = false;
        return await this.prepareRedstonePayload(shouldBeMultipleOf32);
    }
    async getRedstonePayloadForManualUsage(contract) {
        this.setContractForFetchingDefaultParams(contract);
        const shouldBeMultipleOf32 = true;
        const payloadWithoutZeroExPrefix = await this.prepareRedstonePayload(shouldBeMultipleOf32);
        return "0x" + payloadWithoutZeroExPrefix;
    }
    async prepareRedstonePayload(shouldBeMultipleOf32) {
        const signedDataPackages = await this.getDataPackagesForPayload();
        let unsignedMetadata = this.getUnsignedMetadata();
        const originalPayload = $6vSZI.RedstonePayload.prepare(signedDataPackages, unsignedMetadata);
        if (!shouldBeMultipleOf32) return originalPayload;
        const originalPayloadLength = originalPayload.length / 2;
        const bytesToAdd = 32 - originalPayloadLength % 32;
        unsignedMetadata += "_".repeat(bytesToAdd);
        return $6vSZI.RedstonePayload.prepare(signedDataPackages, unsignedMetadata);
    }
    setContractForFetchingDefaultParams(contract) {
        this.contract = contract;
    }
    overwriteEthersContract(contract) {
        this.setContractForFetchingDefaultParams(contract);
        const contractPrototype = Object.getPrototypeOf(contract);
        const wrappedContract = Object.assign(Object.create(contractPrototype), contract, {
            populateTransaction: {}
        });
        const functionNames = Object.keys(contract.functions);
        functionNames.forEach((functionName)=>{
            if (!functionName.includes("(")) {
                this.overwritePopulateTransaction({
                    wrappedContract: wrappedContract,
                    contract: contract,
                    functionName: functionName
                });
                this.overwriteFunction({
                    wrappedContract: wrappedContract,
                    contract: contract,
                    functionName: functionName
                });
            }
        });
        return wrappedContract;
    }
    overwritePopulateTransaction({ wrappedContract: wrappedContract, contract: contract, functionName: functionName }) {
        wrappedContract.populateTransaction[functionName] = async (...args)=>{
            const originalTx = await contract.populateTransaction[functionName](...args);
            const dataToAppend = await this.getBytesDataForAppending();
            originalTx.data += dataToAppend;
            return originalTx;
        };
    }
    overwriteFunction({ wrappedContract: wrappedContract, contract: contract, functionName: functionName }) {
        const isCall = contract.interface.getFunction(functionName).constant;
        const isDryRun = functionName.endsWith("DryRun");
        wrappedContract[functionName] = async (...args)=>{
            const tx = await wrappedContract.populateTransaction[functionName](...args);
            if (isCall || isDryRun) {
                const shouldUseSigner = $iGUqv.Signer.isSigner(contract.signer);
                const result = await contract[shouldUseSigner ? "signer" : "provider"].call(tx);
                const decoded = contract.interface.decodeFunctionResult(functionName, result);
                return decoded.length == 1 ? decoded[0] : decoded;
            } else {
                const sentTx = await contract.signer.sendTransaction(tx);
                (0, $7cve4.addContractWait)(contract, sentTx);
                return sentTx;
            }
        };
    }
    setMetadataTimestamp(timestamp) {
        this.explicitMetadataTimestamp = timestamp;
    }
    getMetadataTimestamp() {
        var _this_explicitMetadataTimestamp;
        return (_this_explicitMetadataTimestamp = this.explicitMetadataTimestamp) !== null && _this_explicitMetadataTimestamp !== void 0 ? _this_explicitMetadataTimestamp : Date.now();
    }
    constructor(){
        (0, $dxWQo._)(this, "contract", void 0);
        (0, $dxWQo._)(this, "explicitMetadataTimestamp", void 0);
    }
}
module.exports.BaseWrapper = $b4228d52b46737ae$var$BaseWrapper;

});
parcelRegister("7cve4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addContractWait = void 0;

var $hbWVX = parcelRequire("hbWVX");
const $53e1e0328263279c$var$addContractWait = (contract, tx)=>{
    const wait = tx.wait.bind(tx);
    tx.wait = (confirmations)=>{
        return wait(confirmations).then((receipt)=>{
            receipt.events = receipt.logs.map((log)=>{
                const event = (0, $hbWVX.deepCopy)(log);
                let parsed;
                try {
                    parsed = contract.interface.parseLog(log);
                } catch (e) {}
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = (data, topics)=>{
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                event.removeListener = ()=>{
                    return contract.provider;
                };
                event.getBlock = ()=>{
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = ()=>{
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = ()=>{
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
};
module.exports.addContractWait = $53e1e0328263279c$var$addContractWait;

});


parcelRegister("b3J9M", function(module, exports) {
module.exports = JSON.parse('{"name":"@redstone-finance/evm-connector","version":"0.4.0","prettier":"redstone-prettier-config","description":"A tool to inject RedStone data into EVM compatible smart contracts","main":"dist/src/index.js","license":"MIT","scripts":{"test":"hardhat test","build":"rm -rf dist && yarn compile && yarn global:tsc --build tsconfig.build.json","benchmark":"hardhat test benchmarks/run-benchmarks.ts","compile":"hardhat compile","preversion":"yarn build","lint":"yarn global:eslint ."},"dependencies":{"@chainlink/contracts":"^0.6.1","@openzeppelin/contracts":"^4.8.1","@redstone-finance/protocol":"^0.4.0","@redstone-finance/sdk":"^0.4.0","axios":"^1.6.2","ethers":"^5.7.2"},"devDependencies":{"@ethersproject/abi":"^5.6.3","@ethersproject/bytes":"^5.6.1","@ethersproject/providers":"^5.6.8","@nomiclabs/hardhat-ethers":"^2.0.6","@nomiclabs/hardhat-waffle":"^2.0.5","@openzeppelin/contracts-upgradeable":"^4.8.3","@typechain/ethers-v5":"^10.2.0","@typechain/hardhat":"^6.1.2","@types/chai":"^4.3.4","@types/chai-as-promised":"^7.1.5","@types/mocha":"^10.0.1","@types/sinon-chai":"^3.2.12","chai":"^4.3.10","chai-as-promised":"^7.1.1","ethereum-waffle":"^4.0.10","hardhat":"^2.17.2","hardhat-gas-reporter":"^1.0.9","msw":"^1.2.3","typechain":"^8.1.1","typescript":"^5.2.2"},"files":["dist/**/*","contracts/**/*"],"publishConfig":{"access":"public"},"gitHead":"9e459938cfa6b8a512c9ffcc28503307482d08fe"}');

});


parcelRegister("cp01f", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataServiceWrapper = void 0;

var $5zREg = parcelRequire("5zREg");

var $fsQXA = parcelRequire("fsQXA");

var $b3J9M = parcelRequire("b3J9M");

var $5zREg = parcelRequire("5zREg");

var $72fYR = parcelRequire("72fYR");
class $9077d5a5e87b769c$var$DataServiceWrapper extends $fsQXA.BaseWrapper {
    getUnsignedMetadata() {
        return `${this.getMetadataTimestamp()}#${$b3J9M.version}#${this.dataPackagesRequestParams.dataServiceId}`;
    }
    async getDataPackagesForPayload() {
        const dataPackagesRequestParams = await this.resolveDataPackagesRequestParams();
        const dpResponse = await (0, $5zREg.requestDataPackages)(dataPackagesRequestParams);
        return Object.values(dpResponse).flat();
    }
    async resolveDataPackagesRequestParams() {
        const fetchedParams = {
            ...this.dataPackagesRequestParams
        };
        if (!this.dataPackagesRequestParams.uniqueSignersCount) fetchedParams.uniqueSignersCount = await this.getUniqueSignersThresholdFromContract();
        if (!this.dataPackagesRequestParams.dataServiceId) fetchedParams.dataServiceId = await this.getDataServiceIdFromContract();
        var _fetchedParams_dataServiceId;
        if (!this.dataPackagesRequestParams.urls) fetchedParams.urls = (0, $5zREg.resolveDataServiceUrls)((_fetchedParams_dataServiceId = fetchedParams.dataServiceId) !== null && _fetchedParams_dataServiceId !== void 0 ? _fetchedParams_dataServiceId : this.dataPackagesRequestParams.dataServiceId);
        return fetchedParams;
    }
    async getDataServiceIdFromContract() {
        try {
            const dataServiceId = await this.contract.getDataServiceId();
            return dataServiceId;
        } catch (e) {
            throw new Error(`DataServiceId not provided and failed to get it from underlying contract. Error: ` + $72fYR.RedstoneCommon.stringifyError(e));
        }
    }
    async getUniqueSignersThresholdFromContract() {
        try {
            return await this.contract.getUniqueSignersThreshold();
        } catch (e) {
            throw new Error(`UniqueSignersCount not provided and failed to get it from underlying contract. Error: ` + $72fYR.RedstoneCommon.stringifyError(e));
        }
    }
    constructor(dataPackagesRequestParams){
        super();
        (0, $dxWQo._)(this, "dataPackagesRequestParams", void 0);
        this.dataPackagesRequestParams = dataPackagesRequestParams;
    }
}
module.exports.DataServiceWrapper = $9077d5a5e87b769c$var$DataServiceWrapper;

});

parcelRegister("eqe9p", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MockWrapper = void 0;

var $8pMIN = parcelRequire("8pMIN");

var $fsQXA = parcelRequire("fsQXA");

var $b3J9M = parcelRequire("b3J9M");
class $a7fe7873ae2a5566$var$MockWrapper extends $fsQXA.BaseWrapper {
    getUnsignedMetadata() {
        return `${$b3J9M.version}#mock`;
    }
    async getDataPackagesForPayload() {
        const signedDataPackages = [];
        for (const mockDataPackage of this.mockDataPackages){
            const privateKey = (0, $8pMIN.getMockSignerPrivateKey)(mockDataPackage.signer);
            const signedDataPackage = mockDataPackage.dataPackage.sign(privateKey);
            signedDataPackages.push(signedDataPackage);
        }
        return signedDataPackages;
    }
    async dryRunToVerifyPayload(payloads) {
        return payloads[0];
    }
    constructor(mockDataPackages){
        super();
        (0, $dxWQo._)(this, "mockDataPackages", void 0);
        this.mockDataPackages = mockDataPackages;
    }
}
module.exports.MockWrapper = $a7fe7873ae2a5566$var$MockWrapper;

});
parcelRegister("8pMIN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRange = module.exports.getMockPackageWithOneBytesDataPoint = module.exports.getMockPackageWithOneNumericDataPoint = module.exports.getMockStringPackage = module.exports.getMockNumericPackage = module.exports.getMockSignedDataPackageObj = module.exports.getMockPackage = module.exports.getMockSignerAddress = module.exports.getMockSignerPrivateKey = module.exports.MOCK_SIGNERS = module.exports.MOCK_PRIVATE_KEYS = module.exports.DEFAULT_DATA_FEED_ID_BYTES_32 = module.exports.DEFAULT_DATA_FEED_ID = module.exports.DEFAULT_TIMESTAMP_FOR_TESTS = module.exports.MAX_MOCK_SIGNERS_COUNT = void 0;

var $j2rU8 = parcelRequire("j2rU8");
parcelRequire("blIpd");
var $3A3Dv = parcelRequire("3A3Dv");

var $6vSZI = parcelRequire("6vSZI");
module.exports.MAX_MOCK_SIGNERS_COUNT = 19;
module.exports.DEFAULT_TIMESTAMP_FOR_TESTS = 1654353400000;
module.exports.DEFAULT_DATA_FEED_ID = "SOME LONG STRING FOR DATA FEED ID TO TRIGGER SYMBOL HASHING";
module.exports.DEFAULT_DATA_FEED_ID_BYTES_32 = $6vSZI.utils.convertStringToBytes32(module.exports.DEFAULT_DATA_FEED_ID);
module.exports.MOCK_PRIVATE_KEYS = [];
module.exports.MOCK_PRIVATE_KEYS[0] = "0xac0974bec39a17e36ba4a6b4d238ff944bacb478cbed5efcae784d7bf4f2ff80";
module.exports.MOCK_PRIVATE_KEYS[1] = "0x59c6995e998f97a5a0044966f0945389dc9e86dae88c7a8412f4603b6b78690d";
module.exports.MOCK_PRIVATE_KEYS[2] = "0x5de4111afa1a4b94908f83103eb1f1706367c2e68ca870fc3fb9a804cdab365a";
module.exports.MOCK_PRIVATE_KEYS[3] = "0x7c852118294e51e653712a81e05800f419141751be58f605c371e15141b007a6";
module.exports.MOCK_PRIVATE_KEYS[4] = "0x47e179ec197488593b187f80a00eb0da91f1b9d0b13f8733639f19c30a34926a";
module.exports.MOCK_PRIVATE_KEYS[5] = "0x8b3a350cf5c34c9194ca85829a2df0ec3153be0318b5e2d3348e872092edffba";
module.exports.MOCK_PRIVATE_KEYS[6] = "0x92db14e403b83dfe3df233f83dfa3a0d7096f21ca9b0d6d6b8d88b2b4ec1564e";
module.exports.MOCK_PRIVATE_KEYS[7] = "0x4bbbf85ce3377467afe5d46f804f221813b2bb87f24d81f60f1fcdbf7cbf4356";
module.exports.MOCK_PRIVATE_KEYS[8] = "0xdbda1821b80551c9d65939329250298aa3472ba22feea921c0cf5d620ea67b97";
module.exports.MOCK_PRIVATE_KEYS[9] = "0x2a871d0798f97d79848a013d4936a73bf4cc922c825d33c1cf7073dff6d409c6";
module.exports.MOCK_PRIVATE_KEYS[10] = "0xf214f2b2cd398c806f84e317254e0f0b801d0643303237d97a22a48e01628897";
module.exports.MOCK_PRIVATE_KEYS[11] = "0x701b615bbdfb9de65240bc28bd21bbc0d996645a3dd57e7b12bc2bdf6f192c82";
module.exports.MOCK_PRIVATE_KEYS[12] = "0xa267530f49f8280200edf313ee7af6b827f2a8bce2897751d06a843f644967b1";
module.exports.MOCK_PRIVATE_KEYS[13] = "0x47c99abed3324a2707c28affff1267e45918ec8c3f20b8aa892e8b065d2942dd";
module.exports.MOCK_PRIVATE_KEYS[14] = "0xc526ee95bf44d8fc405a158bb884d9d1238d99f0612e9f33d006bb0789009aaa";
module.exports.MOCK_PRIVATE_KEYS[15] = "0x8166f546bab6da521a8369cab06c5d2b9e46670292d85c875ee9ec20e84ffb61";
module.exports.MOCK_PRIVATE_KEYS[16] = "0xea6c44ac03bff858b476bba40716402b03e41b8e97e276d1baec7c37d42484a0";
module.exports.MOCK_PRIVATE_KEYS[17] = "0x689af8efa8c651a91ad287602527f3af2fe9f6501a7ac4b061667b5a93e037fd";
module.exports.MOCK_PRIVATE_KEYS[18] = "0xde9be858da4a475276426320d5e9262ecfc3ba460bfac56360bfa6c4c28b4ee0";
module.exports.MOCK_PRIVATE_KEYS[19] = "0xdf57089febbacf7ba0bc227dafbffa9fc08a93fdc68e1e42411a14efcf23656e";
module.exports.MOCK_SIGNERS = module.exports.MOCK_PRIVATE_KEYS.map((privateKey)=>new $3A3Dv.Wallet(privateKey));
const $620673a217d323be$var$getMockSignerPrivateKey = (mockSignerAddress)=>{
    for (const privateKey of module.exports.MOCK_PRIVATE_KEYS){
        const address = new $3A3Dv.Wallet(privateKey).address;
        if (address === mockSignerAddress) return privateKey;
    }
    throw new Error(`Invalid mock signer address: ${mockSignerAddress}`);
};
module.exports.getMockSignerPrivateKey = $620673a217d323be$var$getMockSignerPrivateKey;
const $620673a217d323be$var$getMockSignerAddress = (signerIndex)=>{
    const address = new $3A3Dv.Wallet(module.exports.MOCK_PRIVATE_KEYS[signerIndex]).address;
    return address;
};
module.exports.getMockSignerAddress = $620673a217d323be$var$getMockSignerAddress;
const $620673a217d323be$var$getMockPackage = (opts, dataPoints)=>{
    const timestampMilliseconds = opts.timestampMilliseconds || module.exports.DEFAULT_TIMESTAMP_FOR_TESTS;
    return {
        signer: module.exports.MOCK_SIGNERS[opts.mockSignerIndex].address,
        dataPackage: new $6vSZI.DataPackage(dataPoints, timestampMilliseconds)
    };
};
module.exports.getMockPackage = $620673a217d323be$var$getMockPackage;
const $620673a217d323be$var$getMockSignedDataPackageObj = (args)=>{
    const numericDataPoints = args.dataPoints.map((dp)=>new $6vSZI.NumericDataPoint(dp));
    const mockPackage = (0, module.exports.getMockPackage)(args, numericDataPoints);
    return {
        ...mockPackage.dataPackage.sign(module.exports.MOCK_SIGNERS[args.mockSignerIndex].privateKey).toObj()
    };
};
module.exports.getMockSignedDataPackageObj = $620673a217d323be$var$getMockSignedDataPackageObj;
const $620673a217d323be$var$getMockNumericPackage = (args)=>{
    const numericDataPoints = args.dataPoints.map((dp)=>new $6vSZI.NumericDataPoint(dp));
    return (0, module.exports.getMockPackage)(args, numericDataPoints);
};
module.exports.getMockNumericPackage = $620673a217d323be$var$getMockNumericPackage;
const $620673a217d323be$var$getMockStringPackage = (args)=>{
    const stringDataPoints = args.dataPoints.map((dp)=>new $6vSZI.StringDataPoint(dp));
    return (0, module.exports.getMockPackage)(args, stringDataPoints);
};
module.exports.getMockStringPackage = $620673a217d323be$var$getMockStringPackage;
const $620673a217d323be$var$getMockPackageWithOneNumericDataPoint = (args)=>{
    const numericDataPoint = new $6vSZI.NumericDataPoint({
        ...args,
        dataFeedId: args.dataFeedId || module.exports.DEFAULT_DATA_FEED_ID
    });
    return (0, module.exports.getMockPackage)(args, [
        numericDataPoint
    ]);
};
module.exports.getMockPackageWithOneNumericDataPoint = $620673a217d323be$var$getMockPackageWithOneNumericDataPoint;
const $620673a217d323be$var$getMockPackageWithOneBytesDataPoint = (args)=>{
    const dataPoint = new $6vSZI.DataPoint(args.dataFeedId || module.exports.DEFAULT_DATA_FEED_ID, (0, $j2rU8.arrayify)(args.hexValue));
    return (0, module.exports.getMockPackage)(args, [
        dataPoint
    ]);
};
module.exports.getMockPackageWithOneBytesDataPoint = $620673a217d323be$var$getMockPackageWithOneBytesDataPoint;
const $620673a217d323be$var$getRange = (rangeArgs)=>{
    return [
        ...Array(rangeArgs.length).keys()
    ].map((i)=>i += rangeArgs.start);
};
module.exports.getRange = $620673a217d323be$var$getRange;

});


parcelRegister("efDrj", function(module, exports) {

var $dxWQo = parcelRequire("dxWQo");
"use strict";
var $a6010f49d9913fe8$var$__importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OnDemandRequestWrapper = void 0;

const $a6010f49d9913fe8$var$axios_1 = $a6010f49d9913fe8$var$__importDefault((parcelRequire("28feZ")));

var $6vSZI = parcelRequire("6vSZI");

var $fsQXA = parcelRequire("fsQXA");

var $b3J9M = parcelRequire("b3J9M");
class $a6010f49d9913fe8$var$OnDemandRequestWrapper extends $fsQXA.BaseWrapper {
    getUnsignedMetadata() {
        return `${$b3J9M.version}#on-demand-request`;
    }
    async dryRunToVerifyPayload(payloads) {
        return payloads[0];
    }
    async getDataPackagesForPayload() {
        const timestamp = Date.now();
        const message = (0, $6vSZI.prepareMessageToSign)(timestamp);
        const { signer: signer, scoreType: scoreType } = this.requestParams;
        const signature = await $6vSZI.UniversalSigner.signWithEthereumHashMessage(signer, message);
        const promises = this.nodeUrls.map((url)=>$a6010f49d9913fe8$var$axios_1.default.get(url, {
                params: {
                    timestamp: timestamp,
                    signature: signature,
                    scoreType: scoreType
                }
            }));
        const responses = await Promise.all(promises);
        const signedDataPackages = responses.map((response)=>$6vSZI.SignedDataPackage.fromObj(response.data));
        return signedDataPackages;
    }
    constructor(requestParams, nodeUrls){
        super();
        (0, $dxWQo._)(this, "requestParams", void 0);
        (0, $dxWQo._)(this, "nodeUrls", void 0);
        this.requestParams = requestParams;
        this.nodeUrls = nodeUrls;
    }
}
module.exports.OnDemandRequestWrapper = $a6010f49d9913fe8$var$OnDemandRequestWrapper;

});

parcelRegister("cwzTA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SimpleNumericMockWrapper = void 0;

var $6vSZI = parcelRequire("6vSZI");

var $8pMIN = parcelRequire("8pMIN");

var $b3J9M = parcelRequire("b3J9M");

var $eqe9p = parcelRequire("eqe9p");
class $91e4514b1894a4a1$var$SimpleNumericMockWrapper extends $eqe9p.MockWrapper {
    getUnsignedMetadata() {
        return `${$b3J9M.version}#simple-numeric-mock`;
    }
    constructor(simpleNumericMockConfig){
        if (simpleNumericMockConfig.mockSignersCount > $8pMIN.MAX_MOCK_SIGNERS_COUNT) throw new Error(`mockSignersCount should be <= ${$8pMIN.MAX_MOCK_SIGNERS_COUNT}`);
        const mockDataPackages = [];
        for(let signerIndex = 0; signerIndex < simpleNumericMockConfig.mockSignersCount; signerIndex++)for (const dataPointObj of simpleNumericMockConfig.dataPoints){
            const dataPoint = new $6vSZI.NumericDataPoint(dataPointObj);
            const timestampMilliseconds = simpleNumericMockConfig.timestampMilliseconds || $8pMIN.DEFAULT_TIMESTAMP_FOR_TESTS;
            const mockDataPackage = {
                signer: (0, $8pMIN.getMockSignerAddress)(signerIndex),
                dataPackage: new $6vSZI.DataPackage([
                    dataPoint
                ], timestampMilliseconds)
            };
            mockDataPackages.push(mockDataPackage);
        }
        super(mockDataPackages);
    }
}
module.exports.SimpleNumericMockWrapper = $91e4514b1894a4a1$var$SimpleNumericMockWrapper;

});


parcelRegister("aqROd", function(module, exports) {
"use strict";
var $7986126a39afe4ee$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7986126a39afe4ee$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $7986126a39afe4ee$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$7986126a39afe4ee$var$__exportStar((parcelRequire("fsQXA")), module.exports);

$7986126a39afe4ee$var$__exportStar((parcelRequire("dHSfA")), module.exports);

$7986126a39afe4ee$var$__exportStar((parcelRequire("cp01f")), module.exports);

$7986126a39afe4ee$var$__exportStar((parcelRequire("efDrj")), module.exports);

$7986126a39afe4ee$var$__exportStar((parcelRequire("eqe9p")), module.exports);

$7986126a39afe4ee$var$__exportStar((parcelRequire("cwzTA")), module.exports);

});

var $fba0f23e9e6a11bb$exports = {};
"use strict";

$fba0f23e9e6a11bb$exports = (parcelRequire("a58XM"));



var $6cds3 = parcelRequire("6cds3");
var $64d0b1ebdd6bcffe$exports = {};

$parcel$export($64d0b1ebdd6bcffe$exports, "createRoot", function () { return $64d0b1ebdd6bcffe$export$882461b6382ed46c; }, function (v) { return $64d0b1ebdd6bcffe$export$882461b6382ed46c = v; });
$parcel$export($64d0b1ebdd6bcffe$exports, "hydrateRoot", function () { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e; }, function (v) { return $64d0b1ebdd6bcffe$export$757ceba2d55c277e = v; });
var $64d0b1ebdd6bcffe$export$882461b6382ed46c;
var $64d0b1ebdd6bcffe$export$757ceba2d55c277e;
"use strict";
var $6d4849ee44552f5f$exports = {};
"use strict";
function $6d4849ee44552f5f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6d4849ee44552f5f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6d4849ee44552f5f$var$checkDCE();

$6d4849ee44552f5f$exports = (parcelRequire("jZA9I"));


var $64d0b1ebdd6bcffe$var$i;
$64d0b1ebdd6bcffe$export$882461b6382ed46c = $6d4849ee44552f5f$exports.createRoot;
$64d0b1ebdd6bcffe$export$757ceba2d55c277e = $6d4849ee44552f5f$exports.hydrateRoot;




var $53602a63d686b67f$exports = {};

$53602a63d686b67f$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "redstone-logo.315042f7.svg";


const $ca9b163af4bfc596$export$8b251419efc915eb = ()=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("nav", {
        className: "flex items-center justify-between gap-16 p-3",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "flex items-center align-center gap-16",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                    href: "/",
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                        className: "cursor-pointer",
                        width: "180",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($53602a63d686b67f$exports))),
                        alt: "RedStone logo"
                    })
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                className: "bg-white hover:opacity-75 text-redstone py-2 px-4 rounded-full border border-redstone",
                href: "https://discord.com/invite/PVxBZKFr46",
                target: "_blank",
                children: "Contact us"
            })
        ]
    });



var $44bc37a04f4077dd$exports = {};

$44bc37a04f4077dd$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "mail.8c605da2.svg";


var $f72880665b755274$exports = {};

$f72880665b755274$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "twitter.54fc3f61.svg";


var $eebc79f3c0b9b217$exports = {};

$eebc79f3c0b9b217$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "github.a3b34a38.svg";


var $020f1a03cfb47626$exports = {};

$020f1a03cfb47626$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "discord.a369cd76.svg";


const $1d10e2dedeefcec7$export$a06f1c675e846f6f = ()=>{
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("footer", {
        className: "flex mt-auto mb-5 w-full justify-center gap-6",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("span", {
                    className: "flex text-sm text-gray-500",
                    children: "\xa9 RedStone 2022"
                })
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "flex gap-3",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                        href: "https://discord.com/invite/PVxBZKFr46",
                        target: "_blank",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($020f1a03cfb47626$exports))),
                            alt: "Discord logo"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                        href: "https://twitter.com/redstone_defi",
                        target: "_blank",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($f72880665b755274$exports))),
                            alt: "Twitter logo"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                        href: "mailto:hello@redstone.finance",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($44bc37a04f4077dd$exports))),
                            alt: "Mail logo"
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                        href: "https://github.com/redstone-finance",
                        target: "_blank",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($eebc79f3c0b9b217$exports))),
                            alt: "Github logo"
                        })
                    })
                ]
            })
        ]
    });
};




var $6cds3 = parcelRequire("6cds3");

var $ldxXU = parcelRequire("ldxXU");
var $5f6146cb2a3d4ecb$exports = {};
!function(e, t) {
    $5f6146cb2a3d4ecb$exports = t();
}($5f6146cb2a3d4ecb$exports, function() {
    return function(e) {
        var t = {};
        function n(i) {
            if (t[i]) return t[i].exports;
            var r = t[i] = {
                i: i,
                l: !1,
                exports: {}
            };
            return e[i].call(r.exports, r, r.exports, n), r.l = !0, r.exports;
        }
        return n.m = e, n.c = t, n.d = function(e, t, i) {
            n.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: i
            });
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, n.t = function(e, t) {
            if (1 & t && (e = n(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var i = Object.create(null);
            if (n.r(i), Object.defineProperty(i, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var r in e)n.d(i, r, (function(t) {
                return e[t];
            }).bind(null, r));
            return i;
        }, n.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return n.d(t, "a", t), t;
        }, n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 25);
    }([
        function(e, t, n) {
            "use strict";
            n.r(t), n.d(t, "__extends", function() {
                return r;
            }), n.d(t, "__assign", function() {
                return M;
            }), n.d(t, "__rest", function() {
                return u;
            }), n.d(t, "__decorate", function() {
                return o;
            }), n.d(t, "__param", function() {
                return c;
            }), n.d(t, "__metadata", function() {
                return a;
            }), n.d(t, "__awaiter", function() {
                return I;
            }), n.d(t, "__generator", function() {
                return l;
            }), n.d(t, "__createBinding", function() {
                return N;
            }), n.d(t, "__exportStar", function() {
                return j;
            }), n.d(t, "__values", function() {
                return g;
            }), n.d(t, "__read", function() {
                return s;
            }), n.d(t, "__spread", function() {
                return A;
            }), n.d(t, "__spreadArrays", function() {
                return D;
            }), n.d(t, "__spreadArray", function() {
                return d;
            }), n.d(t, "__await", function() {
                return T;
            }), n.d(t, "__asyncGenerator", function() {
                return y;
            }), n.d(t, "__asyncDelegator", function() {
                return z;
            }), n.d(t, "__asyncValues", function() {
                return w;
            }), n.d(t, "__makeTemplateObject", function() {
                return f;
            }), n.d(t, "__importStar", function() {
                return E;
            }), n.d(t, "__importDefault", function() {
                return C;
            }), n.d(t, "__classPrivateFieldGet", function() {
                return x;
            }), n.d(t, "__classPrivateFieldSet", function() {
                return p;
            });
            /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var i = function(e, t) {
                return (i = Object.setPrototypeOf || ({
                    __proto__: []
                }) instanceof Array && function(e, t) {
                    e.__proto__ = t;
                } || function(e, t) {
                    for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                })(e, t);
            };
            function r(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                function n() {
                    this.constructor = e;
                }
                i(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n);
            }
            var M = function() {
                return (M = Object.assign || function(e) {
                    for(var t, n = 1, i = arguments.length; n < i; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
                    return e;
                }).apply(this, arguments);
            };
            function u(e, t) {
                var n = {};
                for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (n[i] = e[i]);
                if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                    var r = 0;
                    for(i = Object.getOwnPropertySymbols(e); r < i.length; r++)t.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[r]) && (n[i[r]] = e[i[r]]);
                }
                return n;
            }
            function o(e, t, n, i) {
                var r, M = arguments.length, u = M < 3 ? t : null === i ? i = Object.getOwnPropertyDescriptor(t, n) : i;
                if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) u = Reflect.decorate(e, t, n, i);
                else for(var o = e.length - 1; o >= 0; o--)(r = e[o]) && (u = (M < 3 ? r(u) : M > 3 ? r(t, n, u) : r(t, n)) || u);
                return M > 3 && u && Object.defineProperty(t, n, u), u;
            }
            function c(e, t) {
                return function(n, i) {
                    t(n, i, e);
                };
            }
            function a(e, t) {
                if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
            }
            function I(e, t, n, i) {
                return new (n || (n = Promise))(function(r, M) {
                    function u(e) {
                        try {
                            c(i.next(e));
                        } catch (e) {
                            M(e);
                        }
                    }
                    function o(e) {
                        try {
                            c(i.throw(e));
                        } catch (e) {
                            M(e);
                        }
                    }
                    function c(e) {
                        var t;
                        e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                            e(t);
                        })).then(u, o);
                    }
                    c((i = i.apply(e, t || [])).next());
                });
            }
            function l(e, t) {
                var n, i, r, M, u = {
                    label: 0,
                    sent: function() {
                        if (1 & r[0]) throw r[1];
                        return r[1];
                    },
                    trys: [],
                    ops: []
                };
                return M = {
                    next: o(0),
                    throw: o(1),
                    return: o(2)
                }, "function" == typeof Symbol && (M[Symbol.iterator] = function() {
                    return this;
                }), M;
                function o(M) {
                    return function(o) {
                        return function(M) {
                            if (n) throw new TypeError("Generator is already executing.");
                            for(; u;)try {
                                if (n = 1, i && (r = 2 & M[0] ? i.return : M[0] ? i.throw || ((r = i.return) && r.call(i), 0) : i.next) && !(r = r.call(i, M[1])).done) return r;
                                switch(i = 0, r && (M = [
                                    2 & M[0],
                                    r.value
                                ]), M[0]){
                                    case 0:
                                    case 1:
                                        r = M;
                                        break;
                                    case 4:
                                        return u.label++, {
                                            value: M[1],
                                            done: !1
                                        };
                                    case 5:
                                        u.label++, i = M[1], M = [
                                            0
                                        ];
                                        continue;
                                    case 7:
                                        M = u.ops.pop(), u.trys.pop();
                                        continue;
                                    default:
                                        if (!(r = u.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== M[0] && 2 !== M[0])) {
                                            u = 0;
                                            continue;
                                        }
                                        if (3 === M[0] && (!r || M[1] > r[0] && M[1] < r[3])) {
                                            u.label = M[1];
                                            break;
                                        }
                                        if (6 === M[0] && u.label < r[1]) {
                                            u.label = r[1], r = M;
                                            break;
                                        }
                                        if (r && u.label < r[2]) {
                                            u.label = r[2], u.ops.push(M);
                                            break;
                                        }
                                        r[2] && u.ops.pop(), u.trys.pop();
                                        continue;
                                }
                                M = t.call(e, u);
                            } catch (e) {
                                M = [
                                    6,
                                    e
                                ], i = 0;
                            } finally{
                                n = r = 0;
                            }
                            if (5 & M[0]) throw M[1];
                            return {
                                value: M[0] ? M[1] : void 0,
                                done: !0
                            };
                        }([
                            M,
                            o
                        ]);
                    };
                }
            }
            var N = Object.create ? function(e, t, n, i) {
                void 0 === i && (i = n), Object.defineProperty(e, i, {
                    enumerable: !0,
                    get: function() {
                        return t[n];
                    }
                });
            } : function(e, t, n, i) {
                void 0 === i && (i = n), e[i] = t[n];
            };
            function j(e, t) {
                for(var n in e)"default" === n || Object.prototype.hasOwnProperty.call(t, n) || N(t, e, n);
            }
            function g(e) {
                var t = "function" == typeof Symbol && Symbol.iterator, n = t && e[t], i = 0;
                if (n) return n.call(e);
                if (e && "number" == typeof e.length) return {
                    next: function() {
                        return e && i >= e.length && (e = void 0), {
                            value: e && e[i++],
                            done: !e
                        };
                    }
                };
                throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
            }
            function s(e, t) {
                var n = "function" == typeof Symbol && e[Symbol.iterator];
                if (!n) return e;
                var i, r, M = n.call(e), u = [];
                try {
                    for(; (void 0 === t || t-- > 0) && !(i = M.next()).done;)u.push(i.value);
                } catch (e) {
                    r = {
                        error: e
                    };
                } finally{
                    try {
                        i && !i.done && (n = M.return) && n.call(M);
                    } finally{
                        if (r) throw r.error;
                    }
                }
                return u;
            }
            function A() {
                for(var e = [], t = 0; t < arguments.length; t++)e = e.concat(s(arguments[t]));
                return e;
            }
            function D() {
                for(var e = 0, t = 0, n = arguments.length; t < n; t++)e += arguments[t].length;
                var i = Array(e), r = 0;
                for(t = 0; t < n; t++)for(var M = arguments[t], u = 0, o = M.length; u < o; u++, r++)i[r] = M[u];
                return i;
            }
            function d(e, t, n) {
                if (n || 2 === arguments.length) for(var i, r = 0, M = t.length; r < M; r++)!i && r in t || (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
                return e.concat(i || Array.prototype.slice.call(t));
            }
            function T(e) {
                return this instanceof T ? (this.v = e, this) : new T(e);
            }
            function y(e, t, n) {
                if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                var i, r = n.apply(e, t || []), M = [];
                return i = {}, u("next"), u("throw"), u("return"), i[Symbol.asyncIterator] = function() {
                    return this;
                }, i;
                function u(e) {
                    r[e] && (i[e] = function(t) {
                        return new Promise(function(n, i) {
                            M.push([
                                e,
                                t,
                                n,
                                i
                            ]) > 1 || o(e, t);
                        });
                    });
                }
                function o(e, t) {
                    try {
                        (n = r[e](t)).value instanceof T ? Promise.resolve(n.value.v).then(c, a) : I(M[0][2], n);
                    } catch (e) {
                        I(M[0][3], e);
                    }
                    var n;
                }
                function c(e) {
                    o("next", e);
                }
                function a(e) {
                    o("throw", e);
                }
                function I(e, t) {
                    e(t), M.shift(), M.length && o(M[0][0], M[0][1]);
                }
            }
            function z(e) {
                var t, n;
                return t = {}, i("next"), i("throw", function(e) {
                    throw e;
                }), i("return"), t[Symbol.iterator] = function() {
                    return this;
                }, t;
                function i(i, r) {
                    t[i] = e[i] ? function(t) {
                        return (n = !n) ? {
                            value: T(e[i](t)),
                            done: "return" === i
                        } : r ? r(t) : t;
                    } : r;
                }
            }
            function w(e) {
                if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
                var t, n = e[Symbol.asyncIterator];
                return n ? n.call(e) : (e = g(e), t = {}, i("next"), i("throw"), i("return"), t[Symbol.asyncIterator] = function() {
                    return this;
                }, t);
                function i(n) {
                    t[n] = e[n] && function(t) {
                        return new Promise(function(i, r) {
                            (function(e, t, n, i) {
                                Promise.resolve(i).then(function(t) {
                                    e({
                                        value: t,
                                        done: n
                                    });
                                }, t);
                            })(i, r, (t = e[n](t)).done, t.value);
                        });
                    };
                }
            }
            function f(e, t) {
                return Object.defineProperty ? Object.defineProperty(e, "raw", {
                    value: t
                }) : e.raw = t, e;
            }
            var L = Object.create ? function(e, t) {
                Object.defineProperty(e, "default", {
                    enumerable: !0,
                    value: t
                });
            } : function(e, t) {
                e.default = t;
            };
            function E(e) {
                if (e && e.__esModule) return e;
                var t = {};
                if (null != e) for(var n in e)"default" !== n && Object.prototype.hasOwnProperty.call(e, n) && N(t, e, n);
                return L(t, e), t;
            }
            function C(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            function x(e, t, n, i) {
                if ("a" === n && !i) throw new TypeError("Private accessor was defined without a getter");
                if ("function" == typeof t ? e !== t || !i : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
                return "m" === n ? i : "a" === n ? i.call(e) : i ? i.value : t.get(e);
            }
            function p(e, t, n, i, r) {
                if ("m" === i) throw new TypeError("Private method is not writable");
                if ("a" === i && !r) throw new TypeError("Private accessor was defined without a setter");
                if ("function" == typeof t ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
                return "a" === i ? r.call(e, n) : r ? r.value = n : t.set(e, n), n;
            }
        },
        function(e, t, n) {
            "use strict";
            e.exports = n(27);
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            i.__exportStar(n(34), t), i.__exportStar(n(35), t), i.__exportStar(n(36), t), i.__exportStar(n(37), t);
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            i.__exportStar(n(32), t), i.__exportStar(n(110), t), i.__exportStar(n(10), t);
        },
        function(e, t, n) {
            "use strict";
            var i;
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.themesList = void 0;
            var r = n(0), M = r.__importDefault(n(38)), u = r.__importDefault(n(39));
            t.themesList = ((i = {
                default: M.default
            })[M.default.name] = M.default, i[u.default.name] = u.default, i);
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.providers = t.injected = t.connectors = void 0;
            var i = n(0), r = i.__importStar(n(40));
            t.connectors = r;
            var M = i.__importStar(n(12));
            t.injected = M;
            var u = i.__importStar(n(94));
            t.providers = u;
        },
        function(e, t, n) {
            "use strict";
            e.exports = n(115);
        },
        function(e, t, n) {
            "use strict";
            var i = n(116), r = {
                childContextTypes: !0,
                contextType: !0,
                contextTypes: !0,
                defaultProps: !0,
                displayName: !0,
                getDefaultProps: !0,
                getDerivedStateFromError: !0,
                getDerivedStateFromProps: !0,
                mixins: !0,
                propTypes: !0,
                type: !0
            }, M = {
                name: !0,
                length: !0,
                prototype: !0,
                caller: !0,
                callee: !0,
                arguments: !0,
                arity: !0
            }, u = {
                $$typeof: !0,
                compare: !0,
                defaultProps: !0,
                displayName: !0,
                propTypes: !0,
                type: !0
            }, o = {};
            function c(e) {
                return i.isMemo(e) ? u : o[e.$$typeof] || r;
            }
            o[i.ForwardRef] = {
                $$typeof: !0,
                render: !0,
                defaultProps: !0,
                displayName: !0,
                propTypes: !0
            }, o[i.Memo] = u;
            var a = Object.defineProperty, I = Object.getOwnPropertyNames, l = Object.getOwnPropertySymbols, N = Object.getOwnPropertyDescriptor, j = Object.getPrototypeOf, g = Object.prototype;
            e.exports = function e(t, n, i) {
                if ("string" != typeof n) {
                    if (g) {
                        var r = j(n);
                        r && r !== g && e(t, r, i);
                    }
                    var u = I(n);
                    l && (u = u.concat(l(n)));
                    for(var o = c(t), s = c(n), A = 0; A < u.length; ++A){
                        var D = u[A];
                        if (!(M[D] || i && i[D] || s && s[D] || o && o[D])) {
                            var d = N(n, D);
                            try {
                                a(t, D, d);
                            } catch (e) {}
                        }
                    }
                }
                return t;
            };
        },
        function(e, t, n) {
            "use strict";
            var i = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, r = function(e) {
                var t = {};
                return function(n) {
                    return void 0 === t[n] && (t[n] = e(n)), t[n];
                };
            }(function(e) {
                return i.test(e) || 111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91;
            });
            t.a = r;
        },
        function(e, t, n) {
            "use strict";
            /*
object-assign
(c) Sindre Sorhus
@license MIT
*/ var i = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, M = Object.prototype.propertyIsEnumerable;
            function u(e) {
                if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
                return Object(e);
            }
            e.exports = function() {
                try {
                    if (!Object.assign) return !1;
                    var e = new String("abc");
                    if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
                    for(var t = {}, n = 0; n < 10; n++)t["_" + String.fromCharCode(n)] = n;
                    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function(e) {
                        return t[e];
                    }).join("")) return !1;
                    var i = {};
                    return "abcdefghijklmnopqrst".split("").forEach(function(e) {
                        i[e] = e;
                    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, i)).join("");
                } catch (e) {
                    return !1;
                }
            }() ? Object.assign : function(e, t) {
                for(var n, o, c = u(e), a = 1; a < arguments.length; a++){
                    for(var I in n = Object(arguments[a]))r.call(n, I) && (c[I] = n[I]);
                    if (i) {
                        o = i(n);
                        for(var l = 0; l < o.length; l++)M.call(n, o[l]) && (c[o[l]] = n[o[l]]);
                    }
                }
                return c;
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.isLocalStorageAvailable = t.findMatchingRequiredOptions = t.getThemeColors = t.getChainId = t.filterProviderChecks = t.filterProviders = t.filterMatches = t.getProviderDescription = t.isMobile = t.getProviderInfoByCheck = t.getProviderInfoById = t.getProviderInfoByName = t.getProviderInfoFromChecksArray = t.getProviderInfo = t.getInjectedProviderName = t.getInjectedProvider = t.verifyInjectedProvider = t.checkInjectedProviders = void 0;
            var i = n(0).__importStar(n(33)), r = n(2), M = n(4), u = n(5);
            function o() {
                var e = {
                    injectedAvailable: !!window.ethereum || !!window.web3
                };
                if (e.injectedAvailable) {
                    var t = !0;
                    Object.values(u.injected).forEach(function(n) {
                        c(n.check) && (e[n.check] = !0, t = !1);
                    });
                    var n = i.detect();
                    n && "opera" === n.name && (e[u.injected.OPERA.check] = !0, t = !1), t && (e[u.injected.FALLBACK.check] = !0);
                }
                return e;
            }
            function c(e) {
                return window.ethereum ? window.ethereum[e] : window.web3 && window.web3.currentProvider && window.web3.currentProvider[e];
            }
            function a() {
                var e = null, t = o();
                t.injectedAvailable && (delete t.injectedAvailable, e = I(Object.keys(t)));
                return e;
            }
            function I(e) {
                return N("check", j(e));
            }
            function l(e, t, n) {
                var i = n, r = e.filter(t);
                return r && r.length && (i = r[0]), i;
            }
            function N(e, t) {
                return t && l(Object.values(u.providers), function(n) {
                    return n[e] === t;
                }, u.providers.FALLBACK) || u.providers.FALLBACK;
            }
            function j(e) {
                return e && e.length ? e.length > 1 && (e[0] === u.injected.METAMASK.check || e[0] === u.injected.CIPHER.check) ? e[1] : e[0] : u.providers.FALLBACK.check;
            }
            t.checkInjectedProviders = o, t.verifyInjectedProvider = c, t.getInjectedProvider = a, t.getInjectedProviderName = function() {
                var e = a();
                return e ? e.name : null;
            }, t.getProviderInfo = function(e) {
                return e ? I(Object.values(u.providers).filter(function(t) {
                    return e[t.check];
                }).map(function(e) {
                    return e.check;
                })) : u.providers.FALLBACK;
            }, t.getProviderInfoFromChecksArray = I, t.getProviderInfoByName = function(e) {
                return N("name", e);
            }, t.getProviderInfoById = function(e) {
                return N("id", e);
            }, t.getProviderInfoByCheck = function(e) {
                return N("check", e);
            }, t.isMobile = function() {
                return !(!/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) && !/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(navigator.userAgent.substr(0, 4)) && !function() {
                    try {
                        return document.createEvent("TouchEvent"), !0;
                    } catch (e) {
                        return !1;
                    }
                }());
            }, t.getProviderDescription = function(e) {
                if (e.description) return e.description;
                var t = "";
                switch(e.type){
                    case "injected":
                        t = "Connect to your " + e.name + " Wallet";
                        break;
                    case "web":
                        t = "Connect with your " + e.name + " account";
                        break;
                    case "qrcode":
                        t = "Scan with " + e.name + " to connect";
                        break;
                    case "hardware":
                        t = "Connect to your " + e.name + " Hardware Wallet";
                }
                return t;
            }, t.filterMatches = l, t.filterProviders = N, t.filterProviderChecks = j, t.getChainId = function(e) {
                var t = l(Object.values(r.CHAIN_DATA_LIST), function(t) {
                    return t.network === e;
                }, void 0);
                if (!t) throw new Error("No chainId found match " + e);
                return t.chainId;
            }, t.getThemeColors = function(e) {
                return "string" == typeof e ? M.themesList[e].colors : e;
            }, t.findMatchingRequiredOptions = function e(t, n) {
                return t.filter(function(t) {
                    if ("string" == typeof t) return t in n;
                    var i = e(t, n);
                    return i && i.length;
                });
            }, t.isLocalStorageAvailable = function() {
                try {
                    return localStorage.setItem("test", "test"), localStorage.removeItem("test"), !0;
                } catch (e) {
                    return !1;
                }
            };
        },
        function(e, t) {
            var n, i, r = e.exports = {};
            function M() {
                throw new Error("setTimeout has not been defined");
            }
            function u() {
                throw new Error("clearTimeout has not been defined");
            }
            function o(e) {
                if (n === setTimeout) return setTimeout(e, 0);
                if ((n === M || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);
                try {
                    return n(e, 0);
                } catch (t) {
                    try {
                        return n.call(null, e, 0);
                    } catch (t) {
                        return n.call(this, e, 0);
                    }
                }
            }
            !function() {
                try {
                    n = "function" == typeof setTimeout ? setTimeout : M;
                } catch (e) {
                    n = M;
                }
                try {
                    i = "function" == typeof clearTimeout ? clearTimeout : u;
                } catch (e) {
                    i = u;
                }
            }();
            var c, a = [], I = !1, l = -1;
            function N() {
                I && c && (I = !1, c.length ? a = c.concat(a) : l = -1, a.length && j());
            }
            function j() {
                if (!I) {
                    var e = o(N);
                    I = !0;
                    for(var t = a.length; t;){
                        for(c = a, a = []; ++l < t;)c && c[l].run();
                        l = -1, t = a.length;
                    }
                    c = null, I = !1, function(e) {
                        if (i === clearTimeout) return clearTimeout(e);
                        if ((i === u || !i) && clearTimeout) return i = clearTimeout, clearTimeout(e);
                        try {
                            i(e);
                        } catch (t) {
                            try {
                                return i.call(null, e);
                            } catch (t) {
                                return i.call(this, e);
                            }
                        }
                    }(e);
                }
            }
            function g(e, t) {
                this.fun = e, this.array = t;
            }
            function s() {}
            r.nextTick = function(e) {
                var t = new Array(arguments.length - 1);
                if (arguments.length > 1) for(var n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                a.push(new g(e, t)), 1 !== a.length || I || o(j);
            }, g.prototype.run = function() {
                this.fun.apply(null, this.array);
            }, r.title = "browser", r.browser = !0, r.env = {}, r.argv = [], r.version = "", r.versions = {}, r.on = s, r.addListener = s, r.once = s, r.off = s, r.removeListener = s, r.removeAllListeners = s, r.emit = s, r.prependListener = s, r.prependOnceListener = s, r.listeners = function(e) {
                return [];
            }, r.binding = function(e) {
                throw new Error("process.binding is not supported");
            }, r.cwd = function() {
                return "/";
            }, r.chdir = function(e) {
                throw new Error("process.chdir is not supported");
            }, r.umask = function() {
                return 0;
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.RAINBOW = t.PHANTOM = t.ZERION = t.GAMESTOP = t.TOKENPOCKET = t.CORE = t.BITKEEPWALLET = t.CLV = t.BRAVE = t.RABBY = t.SEQUENCEINJECTED = t.PORTAL = t.TALLYINJECTED = t.BLOCKWALLET = t.CELOINJECTED = t.BITPIE = t.XDEFI = t.RWALLET = t.MATHWALLET = t.BOLTX = t.LIQUALITY = t.FRAMEINJECTED = t.TOKENARY = t.STATUS = t.IMTOKEN = t.CIPHER = t.COINBASE = t.TRUST = t.OPERA = t.DAPPER = t.NIFTY = t.SAFE = t.METAMASK = t.FALLBACK = void 0;
            var i = n(0), r = i.__importDefault(n(64)), M = i.__importDefault(n(65)), u = i.__importDefault(n(66)), o = i.__importDefault(n(67)), c = i.__importDefault(n(68)), a = i.__importDefault(n(69)), I = i.__importDefault(n(70)), l = i.__importDefault(n(71)), N = i.__importDefault(n(72)), j = i.__importDefault(n(73)), g = i.__importDefault(n(74)), s = i.__importDefault(n(13)), A = i.__importDefault(n(14)), D = i.__importDefault(n(75)), d = i.__importDefault(n(76)), T = i.__importDefault(n(77)), y = i.__importDefault(n(78)), z = i.__importDefault(n(79)), w = i.__importDefault(n(80)), f = i.__importDefault(n(81)), L = i.__importDefault(n(82)), E = i.__importDefault(n(83)), C = i.__importDefault(n(84)), x = i.__importDefault(n(15)), p = i.__importDefault(n(85)), S = i.__importDefault(n(86)), m = i.__importDefault(n(16)), O = i.__importDefault(n(87)), v = i.__importDefault(n(88)), b = i.__importDefault(n(89)), h = i.__importDefault(n(90)), k = i.__importDefault(n(91)), Q = i.__importDefault(n(92)), Y = i.__importDefault(n(93));
            t.FALLBACK = {
                id: "injected",
                name: "Web3",
                logo: r.default,
                type: "injected",
                check: "isWeb3"
            }, t.METAMASK = {
                id: "injected",
                name: "MetaMask",
                logo: M.default,
                type: "injected",
                check: "isMetaMask"
            }, t.SAFE = {
                id: "injected",
                name: "Safe",
                logo: u.default,
                type: "injected",
                check: "isSafe"
            }, t.NIFTY = {
                id: "injected",
                name: "Nifty",
                logo: o.default,
                type: "injected",
                check: "isNiftyWallet"
            }, t.DAPPER = {
                id: "injected",
                name: "Dapper",
                logo: a.default,
                type: "injected",
                check: "isDapper"
            }, t.OPERA = {
                id: "injected",
                name: "Opera",
                logo: s.default,
                type: "injected",
                check: "isOpera"
            }, t.TRUST = {
                id: "injected",
                name: "Trust",
                logo: c.default,
                type: "injected",
                check: "isTrust"
            }, t.COINBASE = {
                id: "injected",
                name: "Coinbase",
                logo: I.default,
                type: "injected",
                check: "isCoinbaseWallet"
            }, t.CIPHER = {
                id: "injected",
                name: "Cipher",
                logo: l.default,
                type: "injected",
                check: "isCipher"
            }, t.IMTOKEN = {
                id: "injected",
                name: "imToken",
                logo: N.default,
                type: "injected",
                check: "isImToken"
            }, t.STATUS = {
                id: "injected",
                name: "Status",
                logo: j.default,
                type: "injected",
                check: "isStatus"
            }, t.TOKENARY = {
                id: "injected",
                name: "Tokenary",
                logo: g.default,
                type: "injected",
                check: "isTokenary"
            }, t.FRAMEINJECTED = {
                id: "injected",
                name: "Frame",
                logo: A.default,
                type: "injected",
                check: "isFrame"
            }, t.LIQUALITY = {
                id: "injected",
                name: "Liquality",
                logo: D.default,
                type: "injected",
                check: "isLiquality"
            }, t.BOLTX = {
                id: "boltx",
                name: "Bolt-X",
                logo: d.default,
                type: "injected",
                check: "isBoltX"
            }, t.MATHWALLET = {
                id: "injected",
                name: "Math Wallet",
                logo: T.default,
                type: "injected",
                check: "isMathWallet"
            }, t.RWALLET = {
                id: "injected",
                name: "rWallet",
                logo: y.default,
                type: "injected",
                check: "isRWallet"
            }, t.XDEFI = {
                id: "injected",
                name: "XDEFI",
                logo: w.default,
                type: "injected",
                check: "__XDEFI"
            }, t.BITPIE = {
                id: "injected",
                name: "Bitpie",
                logo: z.default,
                type: "injected",
                check: "isBitpie"
            }, t.CELOINJECTED = {
                id: "injected",
                name: "Celo extension wallet",
                logo: f.default,
                type: "injected",
                check: "isCelo"
            }, t.BLOCKWALLET = {
                id: "injected",
                name: "BlockWallet",
                logo: L.default,
                type: "injected",
                check: "isBlockWallet"
            }, t.TALLYINJECTED = {
                id: "injected",
                name: "Tally",
                logo: E.default,
                type: "injected",
                check: "isTally"
            }, t.PORTAL = {
                id: "injected",
                name: "Ripio Portal",
                logo: C.default,
                type: "injected",
                check: "isPortal"
            }, t.SEQUENCEINJECTED = {
                id: "injected",
                name: "Sequence",
                logo: x.default,
                type: "injected",
                check: "isSequence"
            }, t.RABBY = {
                id: "injected",
                name: "Rabby",
                logo: S.default,
                type: "injected",
                check: "isRabby"
            }, t.BRAVE = {
                id: "injected",
                name: "Brave",
                logo: p.default,
                type: "injected",
                check: "isBraveWallet"
            }, t.CLV = {
                id: "injected",
                name: "CLV",
                logo: O.default,
                type: "injected",
                check: "isCloverWallet"
            }, t.BITKEEPWALLET = {
                id: "injected",
                name: "Bitkeep Wallet",
                logo: m.default,
                type: "injected",
                check: "isBitKeep"
            }, t.CORE = {
                id: "injected",
                name: "Core",
                logo: b.default,
                type: "injected",
                check: "isAvalanche"
            }, t.TOKENPOCKET = {
                id: "injected",
                name: "TokenPocket Wallet",
                logo: v.default,
                type: "injected",
                check: "isTokenPocket"
            }, t.GAMESTOP = {
                id: "injected",
                name: "GameStop Wallet",
                logo: h.default,
                type: "injected",
                check: "isGamestop"
            }, t.ZERION = {
                id: "injected",
                name: "Zerion Wallet",
                logo: k.default,
                type: "injected",
                check: "isZerion"
            }, t.PHANTOM = {
                id: "phantom",
                name: "Phantom",
                logo: Q.default,
                type: "injected",
                check: "isPhantom",
                package: {
                    required: [
                        "networkType"
                    ]
                }
            }, t.RAINBOW = {
                id: "injected",
                name: "Rainbow",
                logo: Y.default,
                type: "injected",
                check: "isRainbow"
            };
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDE1My40IDE1Mi45Ij48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9InBoYXNlIiBncmFkaWVudFRyYW5zZm9ybT0icm90YXRlKDQ1KSI+PHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6ICMyYjI1NGYiLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiAjMTkyZjQ1Ii8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHBhdGggZmlsbD0idXJsKCcjcGhhc2UnKSIgZD0iTTE0NS4xLDc1LjZ2LTU4YzAtNS4xLTQuMi05LjMtOS4zLTkuM2gwSDc3LjdjLTAuNiwwLTEuMS0wLjItMS42LTAuNmwtNy03Yy0wLjQtMC40LTEtMC43LTEuNi0wLjdIOS4zIEM0LjIsMCwwLDQuMSwwLDkuM2MwLDAsMCwwLDAsMGwwLDB2NThjMCwwLjYsMC4yLDEuMSwwLjYsMS42bDcsN2MwLjQsMC40LDAuNywxLDAuNywxLjZ2NThjMCw1LjEsNC4yLDkuMyw5LjMsOS4zYzAsMCwwLDAsMCwwaDU4LjIgYzAuNiwwLDEuMSwwLjIsMS42LDAuNmw3LDdjMC40LDAuNCwxLDAuNiwxLjYsMC42aDU4LjJjNS4xLDAsOS4zLTQuMSw5LjMtOS4zYzAsMCwwLDAsMCwwbDAsMHYtNThjMC0wLjYtMC4yLTEuMS0wLjYtMS42bC03LTcgQzE0NS40LDc2LjcsMTQ1LjEsNzYuMiwxNDUuMSw3NS42eiBNMTA1LjYsMTA2LjZINDcuOWMtMC43LDAtMS4zLTAuNi0xLjMtMS4zVjQ3LjdjMC0wLjcsMC42LTEuMywxLjMtMS4zaDU3LjcgYzAuNywwLDEuMywwLjYsMS4zLDEuM3Y1Ny42QzEwNywxMDYsMTA2LjQsMTA2LjYsMTA1LjYsMTA2LjZ6Ii8+PC9zdmc+Cg==";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            i.__exportStar(n(111), t), i.__exportStar(n(19), t);
        },
        function(e, t, n) {
            "use strict";
            n.r(t), (function(e) {
                n.d(t, "ServerStyleSheet", function() {
                    return Ze;
                }), n.d(t, "StyleSheetConsumer", function() {
                    return re;
                }), n.d(t, "StyleSheetContext", function() {
                    return ie;
                }), n.d(t, "StyleSheetManager", function() {
                    return Ie;
                }), n.d(t, "ThemeConsumer", function() {
                    return ve;
                }), n.d(t, "ThemeContext", function() {
                    return Oe;
                }), n.d(t, "ThemeProvider", function() {
                    return be;
                }), n.d(t, "__PRIVATE__", function() {
                    return Re;
                }), n.d(t, "createGlobalStyle", function() {
                    return Pe;
                }), n.d(t, "css", function() {
                    return ye;
                }), n.d(t, "isStyledComponent", function() {
                    return y;
                }), n.d(t, "keyframes", function() {
                    return Ue;
                }), n.d(t, "useTheme", function() {
                    return Be;
                }), n.d(t, "version", function() {
                    return w;
                }), n.d(t, "withTheme", function() {
                    return Ge;
                });
                var i = n(6), r = n(1), M = n.n(r), u = n(22), o = n.n(u), c = n(23), a = n(24), I = n(8), l = n(7), N = n.n(l);
                function j() {
                    return (j = Object.assign || function(e) {
                        for(var t = 1; t < arguments.length; t++){
                            var n = arguments[t];
                            for(var i in n)Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i]);
                        }
                        return e;
                    }).apply(this, arguments);
                }
                var g = function(e, t) {
                    for(var n = [
                        e[0]
                    ], i = 0, r = t.length; i < r; i += 1)n.push(t[i], e[i + 1]);
                    return n;
                }, s = function(e) {
                    return null !== e && "object" == typeof e && "[object Object]" === (e.toString ? e.toString() : Object.prototype.toString.call(e)) && !Object(i.typeOf)(e);
                }, A = Object.freeze([]), D = Object.freeze({});
                function d(e) {
                    return "function" == typeof e;
                }
                function T(e) {
                    return e.displayName || e.name || "Component";
                }
                function y(e) {
                    return e && "string" == typeof e.styledComponentId;
                }
                var z = void 0 !== e && (e.env.REACT_APP_SC_ATTR || e.env.SC_ATTR) || "data-styled", w = "5.3.3", f = "undefined" != typeof window && "HTMLElement" in window, L = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : void 0 !== e && void 0 !== e.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== e.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== e.env.REACT_APP_SC_DISABLE_SPEEDY && e.env.REACT_APP_SC_DISABLE_SPEEDY : void 0 !== e && void 0 !== e.env.SC_DISABLE_SPEEDY && "" !== e.env.SC_DISABLE_SPEEDY && "false" !== e.env.SC_DISABLE_SPEEDY && e.env.SC_DISABLE_SPEEDY), E = {};
                function C(e) {
                    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)n[i - 1] = arguments[i];
                    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
                }
                var x = function() {
                    function e(e) {
                        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
                    }
                    var t = e.prototype;
                    return t.indexOfGroup = function(e) {
                        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
                        return t;
                    }, t.insertRules = function(e, t) {
                        if (e >= this.groupSizes.length) {
                            for(var n = this.groupSizes, i = n.length, r = i; e >= r;)(r <<= 1) < 0 && C(16, "" + e);
                            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
                            for(var M = i; M < r; M++)this.groupSizes[M] = 0;
                        }
                        for(var u = this.indexOfGroup(e + 1), o = 0, c = t.length; o < c; o++)this.tag.insertRule(u, t[o]) && (this.groupSizes[e]++, u++);
                    }, t.clearGroup = function(e) {
                        if (e < this.length) {
                            var t = this.groupSizes[e], n = this.indexOfGroup(e), i = n + t;
                            this.groupSizes[e] = 0;
                            for(var r = n; r < i; r++)this.tag.deleteRule(n);
                        }
                    }, t.getGroup = function(e) {
                        var t = "";
                        if (e >= this.length || 0 === this.groupSizes[e]) return t;
                        for(var n = this.groupSizes[e], i = this.indexOfGroup(e), r = i + n, M = i; M < r; M++)t += this.tag.getRule(M) + "/*!sc*/\n";
                        return t;
                    }, e;
                }(), p = new Map, S = new Map, m = 1, O = function(e) {
                    if (p.has(e)) return p.get(e);
                    for(; S.has(m);)m++;
                    var t = m++;
                    return p.set(e, t), S.set(t, e), t;
                }, v = function(e) {
                    return S.get(e);
                }, b = function(e, t) {
                    t >= m && (m = t + 1), p.set(e, t), S.set(t, e);
                }, h = "style[" + z + '][data-styled-version="5.3.3"]', k = new RegExp("^" + z + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), Q = function(e, t, n) {
                    for(var i, r = n.split(","), M = 0, u = r.length; M < u; M++)(i = r[M]) && e.registerName(t, i);
                }, Y = function(e, t) {
                    for(var n = (t.textContent || "").split("/*!sc*/\n"), i = [], r = 0, M = n.length; r < M; r++){
                        var u = n[r].trim();
                        if (u) {
                            var o = u.match(k);
                            if (o) {
                                var c = 0 | parseInt(o[1], 10), a = o[2];
                                0 !== c && (b(a, c), Q(e, a, o[3]), e.getTag().insertRules(c, i)), i.length = 0;
                            } else i.push(u);
                        }
                    }
                }, P = function() {
                    return "undefined" != typeof window && void 0 !== window.__webpack_nonce__ ? window.__webpack_nonce__ : null;
                }, U = function(e) {
                    var t = document.head, n = e || t, i = document.createElement("style"), r = function(e) {
                        for(var t = e.childNodes, n = t.length; n >= 0; n--){
                            var i = t[n];
                            if (i && 1 === i.nodeType && i.hasAttribute(z)) return i;
                        }
                    }(n), M = void 0 !== r ? r.nextSibling : null;
                    i.setAttribute(z, "active"), i.setAttribute("data-styled-version", "5.3.3");
                    var u = P();
                    return u && i.setAttribute("nonce", u), n.insertBefore(i, M), i;
                }, Z = function() {
                    function e(e) {
                        var t = this.element = U(e);
                        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
                            if (e.sheet) return e.sheet;
                            for(var t = document.styleSheets, n = 0, i = t.length; n < i; n++){
                                var r = t[n];
                                if (r.ownerNode === e) return r;
                            }
                            C(17);
                        }(t), this.length = 0;
                    }
                    var t = e.prototype;
                    return t.insertRule = function(e, t) {
                        try {
                            return this.sheet.insertRule(t, e), this.length++, !0;
                        } catch (e) {
                            return !1;
                        }
                    }, t.deleteRule = function(e) {
                        this.sheet.deleteRule(e), this.length--;
                    }, t.getRule = function(e) {
                        var t = this.sheet.cssRules[e];
                        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
                    }, e;
                }(), G = function() {
                    function e(e) {
                        var t = this.element = U(e);
                        this.nodes = t.childNodes, this.length = 0;
                    }
                    var t = e.prototype;
                    return t.insertRule = function(e, t) {
                        if (e <= this.length && e >= 0) {
                            var n = document.createTextNode(t), i = this.nodes[e];
                            return this.element.insertBefore(n, i || null), this.length++, !0;
                        }
                        return !1;
                    }, t.deleteRule = function(e) {
                        this.element.removeChild(this.nodes[e]), this.length--;
                    }, t.getRule = function(e) {
                        return e < this.length ? this.nodes[e].textContent : "";
                    }, e;
                }(), B = function() {
                    function e(e) {
                        this.rules = [], this.length = 0;
                    }
                    var t = e.prototype;
                    return t.insertRule = function(e, t) {
                        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
                    }, t.deleteRule = function(e) {
                        this.rules.splice(e, 1), this.length--;
                    }, t.getRule = function(e) {
                        return e < this.length ? this.rules[e] : "";
                    }, e;
                }(), R = f, W = {
                    isServer: !f,
                    useCSSOMInjection: !L
                }, H = function() {
                    function e(e, t, n) {
                        void 0 === e && (e = D), void 0 === t && (t = {}), this.options = j({}, W, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && f && R && (R = !1, function(e) {
                            for(var t = document.querySelectorAll(h), n = 0, i = t.length; n < i; n++){
                                var r = t[n];
                                r && "active" !== r.getAttribute(z) && (Y(e, r), r.parentNode && r.parentNode.removeChild(r));
                            }
                        }(this));
                    }
                    e.registerId = function(e) {
                        return O(e);
                    };
                    var t = e.prototype;
                    return t.reconstructWithOptions = function(t, n) {
                        return void 0 === n && (n = !0), new e(j({}, this.options, {}, t), this.gs, n && this.names || void 0);
                    }, t.allocateGSInstance = function(e) {
                        return this.gs[e] = (this.gs[e] || 0) + 1;
                    }, t.getTag = function() {
                        var e, t, n, i, r;
                        return this.tag || (this.tag = (n = (t = this.options).isServer, i = t.useCSSOMInjection, r = t.target, e = n ? new B(r) : i ? new Z(r) : new G(r), new x(e)));
                    }, t.hasNameForId = function(e, t) {
                        return this.names.has(e) && this.names.get(e).has(t);
                    }, t.registerName = function(e, t) {
                        if (O(e), this.names.has(e)) this.names.get(e).add(t);
                        else {
                            var n = new Set;
                            n.add(t), this.names.set(e, n);
                        }
                    }, t.insertRules = function(e, t, n) {
                        this.registerName(e, t), this.getTag().insertRules(O(e), n);
                    }, t.clearNames = function(e) {
                        this.names.has(e) && this.names.get(e).clear();
                    }, t.clearRules = function(e) {
                        this.getTag().clearGroup(O(e)), this.clearNames(e);
                    }, t.clearTag = function() {
                        this.tag = void 0;
                    }, t.toString = function() {
                        return function(e) {
                            for(var t = e.getTag(), n = t.length, i = "", r = 0; r < n; r++){
                                var M = v(r);
                                if (void 0 !== M) {
                                    var u = e.names.get(M), o = t.getGroup(r);
                                    if (u && o && u.size) {
                                        var c = z + ".g" + r + '[id="' + M + '"]', a = "";
                                        void 0 !== u && u.forEach(function(e) {
                                            e.length > 0 && (a += e + ",");
                                        }), i += "" + o + c + '{content:"' + a + '"}/*!sc*/\n';
                                    }
                                }
                            }
                            return i;
                        }(this);
                    }, e;
                }(), V = /(a)(d)/gi, J = function(e) {
                    return String.fromCharCode(e + (e > 25 ? 39 : 97));
                };
                function F(e) {
                    var t, n = "";
                    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = J(t % 52) + n;
                    return (J(t % 52) + n).replace(V, "$1-$2");
                }
                var X = function(e, t) {
                    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
                    return e;
                }, K = function(e) {
                    return X(5381, e);
                };
                function q(e) {
                    for(var t = 0; t < e.length; t += 1){
                        var n = e[t];
                        if (d(n) && !y(n)) return !1;
                    }
                    return !0;
                }
                var _ = K("5.3.3"), $ = function() {
                    function e(e, t, n) {
                        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && q(e), this.componentId = t, this.baseHash = X(_, t), this.baseStyle = n, H.registerId(t);
                    }
                    return e.prototype.generateAndInjectStyles = function(e, t, n) {
                        var i = this.componentId, r = [];
                        if (this.baseStyle && r.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
                            if (this.staticRulesId && t.hasNameForId(i, this.staticRulesId)) r.push(this.staticRulesId);
                            else {
                                var M = de(this.rules, e, t, n).join(""), u = F(X(this.baseHash, M) >>> 0);
                                if (!t.hasNameForId(i, u)) {
                                    var o = n(M, "." + u, void 0, i);
                                    t.insertRules(i, u, o);
                                }
                                r.push(u), this.staticRulesId = u;
                            }
                        } else {
                            for(var c = this.rules.length, a = X(this.baseHash, n.hash), I = "", l = 0; l < c; l++){
                                var N = this.rules[l];
                                if ("string" == typeof N) I += N;
                                else if (N) {
                                    var j = de(N, e, t, n), g = Array.isArray(j) ? j.join("") : j;
                                    a = X(a, g + l), I += g;
                                }
                            }
                            if (I) {
                                var s = F(a >>> 0);
                                if (!t.hasNameForId(i, s)) {
                                    var A = n(I, "." + s, void 0, i);
                                    t.insertRules(i, s, A);
                                }
                                r.push(s);
                            }
                        }
                        return r.join(" ");
                    }, e;
                }(), ee = /^\s*\/\/.*$/gm, te = [
                    ":",
                    "[",
                    ".",
                    "#"
                ];
                function ne(e) {
                    var t, n, i, r, M = void 0 === e ? D : e, u = M.options, o = void 0 === u ? D : u, a = M.plugins, I = void 0 === a ? A : a, l = new c.a(o), N = [], j = function(e) {
                        function t(t) {
                            if (t) try {
                                e(t + "}");
                            } catch (e) {}
                        }
                        return function(n, i, r, M, u, o, c, a, I, l) {
                            switch(n){
                                case 1:
                                    if (0 === I && 64 === i.charCodeAt(0)) return e(i + ";"), "";
                                    break;
                                case 2:
                                    if (0 === a) return i + "/*|*/";
                                    break;
                                case 3:
                                    switch(a){
                                        case 102:
                                        case 112:
                                            return e(r[0] + i), "";
                                        default:
                                            return i + (0 === l ? "/*|*/" : "");
                                    }
                                case -2:
                                    i.split("/*|*/}").forEach(t);
                            }
                        };
                    }(function(e) {
                        N.push(e);
                    }), g = function(e, i, M) {
                        return 0 === i && -1 !== te.indexOf(M[n.length]) || M.match(r) ? e : "." + t;
                    };
                    function s(e, M, u, o) {
                        void 0 === o && (o = "&");
                        var c = e.replace(ee, ""), a = M && u ? u + " " + M + " { " + c + " }" : c;
                        return t = o, n = M, i = new RegExp("\\" + n + "\\b", "g"), r = new RegExp("(\\" + n + "\\b){2,}"), l(u || !M ? "" : M, a);
                    }
                    return l.use([].concat(I, [
                        function(e, t, r) {
                            2 === e && r.length && r[0].lastIndexOf(n) > 0 && (r[0] = r[0].replace(i, g));
                        },
                        j,
                        function(e) {
                            if (-2 === e) {
                                var t = N;
                                return N = [], t;
                            }
                        }
                    ])), s.hash = I.length ? I.reduce(function(e, t) {
                        return t.name || C(15), X(e, t.name);
                    }, 5381).toString() : "", s;
                }
                var ie = M.a.createContext(), re = ie.Consumer, Me = M.a.createContext(), ue = (Me.Consumer, new H), oe = ne();
                function ce() {
                    return Object(r.useContext)(ie) || ue;
                }
                function ae() {
                    return Object(r.useContext)(Me) || oe;
                }
                function Ie(e) {
                    var t = Object(r.useState)(e.stylisPlugins), n = t[0], i = t[1], u = ce(), c = Object(r.useMemo)(function() {
                        var t = u;
                        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
                            target: e.target
                        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
                            useCSSOMInjection: !1
                        })), t;
                    }, [
                        e.disableCSSOMInjection,
                        e.sheet,
                        e.target
                    ]), a = Object(r.useMemo)(function() {
                        return ne({
                            options: {
                                prefix: !e.disableVendorPrefixes
                            },
                            plugins: n
                        });
                    }, [
                        e.disableVendorPrefixes,
                        n
                    ]);
                    return Object(r.useEffect)(function() {
                        o()(n, e.stylisPlugins) || i(e.stylisPlugins);
                    }, [
                        e.stylisPlugins
                    ]), M.a.createElement(ie.Provider, {
                        value: c
                    }, M.a.createElement(Me.Provider, {
                        value: a
                    }, e.children));
                }
                var le = function() {
                    function e(e, t) {
                        var n = this;
                        this.inject = function(e, t) {
                            void 0 === t && (t = oe);
                            var i = n.name + t.hash;
                            e.hasNameForId(n.id, i) || e.insertRules(n.id, i, t(n.rules, i, "@keyframes"));
                        }, this.toString = function() {
                            return C(12, String(n.name));
                        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
                    }
                    return e.prototype.getName = function(e) {
                        return void 0 === e && (e = oe), this.name + e.hash;
                    }, e;
                }(), Ne = /([A-Z])/, je = /([A-Z])/g, ge = /^ms-/, se = function(e) {
                    return "-" + e.toLowerCase();
                };
                function Ae(e) {
                    return Ne.test(e) ? e.replace(je, se).replace(ge, "-ms-") : e;
                }
                var De = function(e) {
                    return null == e || !1 === e || "" === e;
                };
                function de(e, t, n, i) {
                    if (Array.isArray(e)) {
                        for(var r, M = [], u = 0, o = e.length; u < o; u += 1)"" !== (r = de(e[u], t, n, i)) && (Array.isArray(r) ? M.push.apply(M, r) : M.push(r));
                        return M;
                    }
                    var c;
                    return De(e) ? "" : y(e) ? "." + e.styledComponentId : d(e) ? "function" != typeof (c = e) || c.prototype && c.prototype.isReactComponent || !t ? e : de(e(t), t, n, i) : e instanceof le ? n ? (e.inject(n, i), e.getName(i)) : e : s(e) ? function e(t, n) {
                        var i, r, M = [];
                        for(var u in t)t.hasOwnProperty(u) && !De(t[u]) && (Array.isArray(t[u]) && t[u].isCss || d(t[u]) ? M.push(Ae(u) + ":", t[u], ";") : s(t[u]) ? M.push.apply(M, e(t[u], u)) : M.push(Ae(u) + ": " + (i = u, (null == (r = t[u]) || "boolean" == typeof r || "" === r ? "" : "number" != typeof r || 0 === r || i in a.a ? String(r).trim() : r + "px") + ";")));
                        return n ? [
                            n + " {"
                        ].concat(M, [
                            "}"
                        ]) : M;
                    }(e) : e.toString();
                }
                var Te = function(e) {
                    return Array.isArray(e) && (e.isCss = !0), e;
                };
                function ye(e) {
                    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)n[i - 1] = arguments[i];
                    return d(e) || s(e) ? Te(de(g(A, [
                        e
                    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : Te(de(g(e, n)));
                }
                new Set;
                var ze = function(e, t, n) {
                    return void 0 === n && (n = D), e.theme !== n.theme && e.theme || t || n.theme;
                }, we = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, fe = /(^-|-$)/g;
                function Le(e) {
                    return e.replace(we, "-").replace(fe, "");
                }
                var Ee = function(e) {
                    return F(K(e) >>> 0);
                };
                function Ce(e) {
                    return "string" == typeof e && !0;
                }
                var xe = function(e) {
                    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
                }, pe = function(e) {
                    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
                };
                function Se(e, t, n) {
                    var i = e[n];
                    xe(t) && xe(i) ? me(i, t) : e[n] = t;
                }
                function me(e) {
                    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)n[i - 1] = arguments[i];
                    for(var r = 0, M = n; r < M.length; r++){
                        var u = M[r];
                        if (xe(u)) for(var o in u)pe(o) && Se(e, u[o], o);
                    }
                    return e;
                }
                var Oe = M.a.createContext(), ve = Oe.Consumer;
                function be(e) {
                    var t = Object(r.useContext)(Oe), n = Object(r.useMemo)(function() {
                        return function(e, t) {
                            return e ? d(e) ? e(t) : Array.isArray(e) || "object" != typeof e ? C(8) : t ? j({}, t, {}, e) : e : C(14);
                        }(e.theme, t);
                    }, [
                        e.theme,
                        t
                    ]);
                    return e.children ? M.a.createElement(Oe.Provider, {
                        value: n
                    }, e.children) : null;
                }
                var he = {};
                function ke(e, t, n) {
                    var i = y(e), u = !Ce(e), o = t.attrs, c = void 0 === o ? A : o, a = t.componentId, l = void 0 === a ? function(e, t) {
                        var n = "string" != typeof e ? "sc" : Le(e);
                        he[n] = (he[n] || 0) + 1;
                        var i = n + "-" + Ee("5.3.3" + n + he[n]);
                        return t ? t + "-" + i : i;
                    }(t.displayName, t.parentComponentId) : a, g = t.displayName, s = void 0 === g ? function(e) {
                        return Ce(e) ? "styled." + e : "Styled(" + T(e) + ")";
                    }(e) : g, z = t.displayName && t.componentId ? Le(t.displayName) + "-" + t.componentId : t.componentId || l, w = i && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, f = t.shouldForwardProp;
                    i && e.shouldForwardProp && (f = t.shouldForwardProp ? function(n, i, r) {
                        return e.shouldForwardProp(n, i, r) && t.shouldForwardProp(n, i, r);
                    } : e.shouldForwardProp);
                    var L, E = new $(n, z, i ? e.componentStyle : void 0), C = E.isStatic && 0 === c.length, x = function(e, t) {
                        return function(e, t, n, i) {
                            var M = e.attrs, u = e.componentStyle, o = e.defaultProps, c = e.foldedComponentIds, a = e.shouldForwardProp, l = e.styledComponentId, N = e.target, g = function(e, t, n) {
                                void 0 === e && (e = D);
                                var i = j({}, t, {
                                    theme: e
                                }), r = {};
                                return n.forEach(function(e) {
                                    var t, n, M, u = e;
                                    for(t in d(u) && (u = u(i)), u)i[t] = r[t] = "className" === t ? (n = r[t], M = u[t], n && M ? n + " " + M : n || M) : u[t];
                                }), [
                                    i,
                                    r
                                ];
                            }(ze(t, Object(r.useContext)(Oe), o) || D, t, M), s = g[0], A = g[1], T = function(e, t, n, i) {
                                var r = ce(), M = ae();
                                return t ? e.generateAndInjectStyles(D, r, M) : e.generateAndInjectStyles(n, r, M);
                            }(u, i, s), y = n, z = A.$as || t.$as || A.as || t.as || N, w = Ce(z), f = A !== t ? j({}, t, {}, A) : t, L = {};
                            for(var E in f)"$" !== E[0] && "as" !== E && ("forwardedAs" === E ? L.as = f[E] : (a ? a(E, I.a, z) : !w || Object(I.a)(E)) && (L[E] = f[E]));
                            return t.style && A.style !== t.style && (L.style = j({}, t.style, {}, A.style)), L.className = Array.prototype.concat(c, l, T !== l ? T : null, t.className, A.className).filter(Boolean).join(" "), L.ref = y, Object(r.createElement)(z, L);
                        }(L, e, t, C);
                    };
                    return x.displayName = s, (L = M.a.forwardRef(x)).attrs = w, L.componentStyle = E, L.displayName = s, L.shouldForwardProp = f, L.foldedComponentIds = i ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : A, L.styledComponentId = z, L.target = i ? e.target : e, L.withComponent = function(e) {
                        var i = t.componentId, r = function(e, t) {
                            if (null == e) return {};
                            var n, i, r = {}, M = Object.keys(e);
                            for(i = 0; i < M.length; i++)n = M[i], t.indexOf(n) >= 0 || (r[n] = e[n]);
                            return r;
                        }(t, [
                            "componentId"
                        ]), M = i && i + "-" + (Ce(e) ? e : Le(T(e)));
                        return ke(e, j({}, r, {
                            attrs: w,
                            componentId: M
                        }), n);
                    }, Object.defineProperty(L, "defaultProps", {
                        get: function() {
                            return this._foldedDefaultProps;
                        },
                        set: function(t) {
                            this._foldedDefaultProps = i ? me({}, e.defaultProps, t) : t;
                        }
                    }), L.toString = function() {
                        return "." + L.styledComponentId;
                    }, u && N()(L, e, {
                        attrs: !0,
                        componentStyle: !0,
                        displayName: !0,
                        foldedComponentIds: !0,
                        shouldForwardProp: !0,
                        styledComponentId: !0,
                        target: !0,
                        withComponent: !0
                    }), L;
                }
                var Qe = function(e) {
                    return function e(t, n, r) {
                        if (void 0 === r && (r = D), !Object(i.isValidElementType)(n)) return C(1, String(n));
                        var M = function() {
                            return t(n, r, ye.apply(void 0, arguments));
                        };
                        return M.withConfig = function(i) {
                            return e(t, n, j({}, r, {}, i));
                        }, M.attrs = function(i) {
                            return e(t, n, j({}, r, {
                                attrs: Array.prototype.concat(r.attrs, i).filter(Boolean)
                            }));
                        }, M;
                    }(ke, e);
                };
                [
                    "a",
                    "abbr",
                    "address",
                    "area",
                    "article",
                    "aside",
                    "audio",
                    "b",
                    "base",
                    "bdi",
                    "bdo",
                    "big",
                    "blockquote",
                    "body",
                    "br",
                    "button",
                    "canvas",
                    "caption",
                    "cite",
                    "code",
                    "col",
                    "colgroup",
                    "data",
                    "datalist",
                    "dd",
                    "del",
                    "details",
                    "dfn",
                    "dialog",
                    "div",
                    "dl",
                    "dt",
                    "em",
                    "embed",
                    "fieldset",
                    "figcaption",
                    "figure",
                    "footer",
                    "form",
                    "h1",
                    "h2",
                    "h3",
                    "h4",
                    "h5",
                    "h6",
                    "head",
                    "header",
                    "hgroup",
                    "hr",
                    "html",
                    "i",
                    "iframe",
                    "img",
                    "input",
                    "ins",
                    "kbd",
                    "keygen",
                    "label",
                    "legend",
                    "li",
                    "link",
                    "main",
                    "map",
                    "mark",
                    "marquee",
                    "menu",
                    "menuitem",
                    "meta",
                    "meter",
                    "nav",
                    "noscript",
                    "object",
                    "ol",
                    "optgroup",
                    "option",
                    "output",
                    "p",
                    "param",
                    "picture",
                    "pre",
                    "progress",
                    "q",
                    "rp",
                    "rt",
                    "ruby",
                    "s",
                    "samp",
                    "script",
                    "section",
                    "select",
                    "small",
                    "source",
                    "span",
                    "strong",
                    "style",
                    "sub",
                    "summary",
                    "sup",
                    "table",
                    "tbody",
                    "td",
                    "textarea",
                    "tfoot",
                    "th",
                    "thead",
                    "time",
                    "title",
                    "tr",
                    "track",
                    "u",
                    "ul",
                    "var",
                    "video",
                    "wbr",
                    "circle",
                    "clipPath",
                    "defs",
                    "ellipse",
                    "foreignObject",
                    "g",
                    "image",
                    "line",
                    "linearGradient",
                    "marker",
                    "mask",
                    "path",
                    "pattern",
                    "polygon",
                    "polyline",
                    "radialGradient",
                    "rect",
                    "stop",
                    "svg",
                    "text",
                    "textPath",
                    "tspan"
                ].forEach(function(e) {
                    Qe[e] = Qe(e);
                });
                var Ye = function() {
                    function e(e, t) {
                        this.rules = e, this.componentId = t, this.isStatic = q(e), H.registerId(this.componentId + 1);
                    }
                    var t = e.prototype;
                    return t.createStyles = function(e, t, n, i) {
                        var r = i(de(this.rules, t, n, i).join(""), ""), M = this.componentId + e;
                        n.insertRules(M, M, r);
                    }, t.removeStyles = function(e, t) {
                        t.clearRules(this.componentId + e);
                    }, t.renderStyles = function(e, t, n, i) {
                        e > 2 && H.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, i);
                    }, e;
                }();
                function Pe(e) {
                    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)n[i - 1] = arguments[i];
                    var u = ye.apply(void 0, [
                        e
                    ].concat(n)), o = "sc-global-" + Ee(JSON.stringify(u)), c = new Ye(u, o);
                    function a(e) {
                        var t = ce(), n = ae(), i = Object(r.useContext)(Oe), M = Object(r.useRef)(t.allocateGSInstance(o)).current;
                        return t.server && I(M, e, t, i, n), Object(r.useLayoutEffect)(function() {
                            if (!t.server) return I(M, e, t, i, n), function() {
                                return c.removeStyles(M, t);
                            };
                        }, [
                            M,
                            e,
                            t,
                            i,
                            n
                        ]), null;
                    }
                    function I(e, t, n, i, r) {
                        if (c.isStatic) c.renderStyles(e, E, n, r);
                        else {
                            var M = j({}, t, {
                                theme: ze(t, i, a.defaultProps)
                            });
                            c.renderStyles(e, M, n, r);
                        }
                    }
                    return M.a.memo(a);
                }
                function Ue(e) {
                    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)n[i - 1] = arguments[i];
                    var r = ye.apply(void 0, [
                        e
                    ].concat(n)).join(""), M = Ee(r);
                    return new le(M, r);
                }
                var Ze = function() {
                    function e() {
                        var e = this;
                        this._emitSheetCSS = function() {
                            var t = e.instance.toString();
                            if (!t) return "";
                            var n = P();
                            return "<style " + [
                                n && 'nonce="' + n + '"',
                                z + '="true"',
                                'data-styled-version="5.3.3"'
                            ].filter(Boolean).join(" ") + ">" + t + "</style>";
                        }, this.getStyleTags = function() {
                            return e.sealed ? C(2) : e._emitSheetCSS();
                        }, this.getStyleElement = function() {
                            var t;
                            if (e.sealed) return C(2);
                            var n = ((t = {})[z] = "", t["data-styled-version"] = "5.3.3", t.dangerouslySetInnerHTML = {
                                __html: e.instance.toString()
                            }, t), i = P();
                            return i && (n.nonce = i), [
                                M.a.createElement("style", j({}, n, {
                                    key: "sc-0-0"
                                }))
                            ];
                        }, this.seal = function() {
                            e.sealed = !0;
                        }, this.instance = new H({
                            isServer: !0
                        }), this.sealed = !1;
                    }
                    var t = e.prototype;
                    return t.collectStyles = function(e) {
                        return this.sealed ? C(2) : M.a.createElement(Ie, {
                            sheet: this.instance
                        }, e);
                    }, t.interleaveWithNodeStream = function(e) {
                        return C(3);
                    }, e;
                }(), Ge = function(e) {
                    var t = M.a.forwardRef(function(t, n) {
                        var i = Object(r.useContext)(Oe), u = e.defaultProps, o = ze(t, i, u);
                        return M.a.createElement(e, j({}, t, {
                            theme: o,
                            ref: n
                        }));
                    });
                    return N()(t, e), t.displayName = "WithTheme(" + T(e) + ")", t;
                }, Be = function() {
                    return Object(r.useContext)(Oe);
                }, Re = {
                    StyleSheet: H,
                    masterSheet: ue
                };
                t.default = Qe;
            }).call(this, n(11));
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Provider = void 0;
            var i, r, M, u, o, c = n(0), a = c.__importStar(n(1)), I = c.__importDefault(n(18)), l = n(2), N = I.default.div(i || (i = c.__makeTemplateObject([
                "\n  width: 45px;\n  height: 45px;\n  display: flex;\n  border-radius: 50%;\n  overflow: visible;\n  box-shadow: none;\n  justify-content: center;\n  align-items: center;\n  & img {\n    width: 100%;\n    height: 100%;\n  }\n\n  @media screen and (max-width: 768px) {\n    width: 8.5vw;\n    height: 8.5vw;\n  }\n"
            ], [
                "\n  width: 45px;\n  height: 45px;\n  display: flex;\n  border-radius: 50%;\n  overflow: visible;\n  box-shadow: none;\n  justify-content: center;\n  align-items: center;\n  & img {\n    width: 100%;\n    height: 100%;\n  }\n\n  @media screen and (max-width: 768px) {\n    width: 8.5vw;\n    height: 8.5vw;\n  }\n"
            ]))), j = I.default.div(r || (r = c.__makeTemplateObject([
                "\n  width: 100%;\n  font-size: 24px;\n  font-weight: 700;\n  margin-top: 0.5em;\n  color: ",
                ";\n  @media screen and (max-width: 768px) {\n    font-size: 5vw;\n  }\n"
            ], [
                "\n  width: 100%;\n  font-size: 24px;\n  font-weight: 700;\n  margin-top: 0.5em;\n  color: ",
                ";\n  @media screen and (max-width: 768px) {\n    font-size: 5vw;\n  }\n"
            ])), function(e) {
                return e.themeColors.main;
            }), g = I.default.div(M || (M = c.__makeTemplateObject([
                "\n  width: 100%;\n  font-size: 18px;\n  margin: 0.333em 0;\n  color: ",
                ";\n  @media screen and (max-width: 768px) {\n    font-size: 4vw;\n  }\n"
            ], [
                "\n  width: 100%;\n  font-size: 18px;\n  margin: 0.333em 0;\n  color: ",
                ";\n  @media screen and (max-width: 768px) {\n    font-size: 4vw;\n  }\n"
            ])), function(e) {
                return e.themeColors.secondary;
            }), s = I.default.div(u || (u = c.__makeTemplateObject([
                "\n  transition: background-color 0.2s ease-in-out;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
                ";\n  border-radius: 12px;\n  padding: 24px 16px;\n  @media screen and (max-width: 768px) {\n    padding: 1vw;\n  }\n"
            ], [
                "\n  transition: background-color 0.2s ease-in-out;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: ",
                ";\n  border-radius: 12px;\n  padding: 24px 16px;\n  @media screen and (max-width: 768px) {\n    padding: 1vw;\n  }\n"
            ])), function(e) {
                return e.themeColors.background;
            }), A = I.default.div(o || (o = c.__makeTemplateObject([
                "\n  width: 100%;\n  padding: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  cursor: pointer;\n  border-radius: 0;\n  border: ",
                ";\n  @media (hover: hover) {\n    &:hover ",
                " {\n      background-color: ",
                ";\n    }\n  }\n"
            ], [
                "\n  width: 100%;\n  padding: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  cursor: pointer;\n  border-radius: 0;\n  border: ",
                ";\n  @media (hover: hover) {\n    &:hover ",
                " {\n      background-color: ",
                ";\n    }\n  }\n"
            ])), function(e) {
                return "1px solid " + e.themeColors.border;
            }, s, function(e) {
                return e.themeColors.hover;
            });
            t.Provider = function(e) {
                var t = e.name, n = e.logo, i = e.description, r = e.themeColors, M = e.onClick, u = c.__rest(e, [
                    "name",
                    "logo",
                    "description",
                    "themeColors",
                    "onClick"
                ]);
                return a.createElement(A, c.__assign({
                    themeColors: r,
                    className: l.PROVIDER_WRAPPER_CLASSNAME,
                    onClick: M
                }, u), a.createElement(s, {
                    themeColors: r,
                    className: l.PROVIDER_CONTAINER_CLASSNAME
                }, a.createElement(N, {
                    className: l.PROVIDER_ICON_CLASSNAME
                }, a.createElement("img", {
                    src: n,
                    alt: t
                })), a.createElement(j, {
                    themeColors: r,
                    className: l.PROVIDER_NAME_CLASSNAME
                }, t), a.createElement(g, {
                    themeColors: r,
                    className: l.PROVIDER_DESCRIPTION_CLASSNAME
                }, i)));
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            i.__exportStar(n(21), t), i.__exportStar(n(118), t);
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.EventController = void 0;
            var i = function() {
                function e() {
                    this._eventCallbacks = [];
                }
                return e.prototype.on = function(e) {
                    this._eventCallbacks.push(e);
                }, e.prototype.off = function(e) {
                    e ? e.callback ? this._eventCallbacks = this._eventCallbacks.filter(function(t) {
                        return t.event !== e.event || t.callback !== e.callback;
                    }) : this._eventCallbacks = this._eventCallbacks.filter(function(t) {
                        return t.event !== e.event;
                    }) : this._eventCallbacks = [];
                }, e.prototype.trigger = function(e, t) {
                    var n = this._eventCallbacks.filter(function(t) {
                        return t.event === e;
                    });
                    n && n.length && n.forEach(function(e) {
                        e.callback(t);
                    });
                }, e;
            }();
            t.EventController = i;
        },
        function(e, t) {
            e.exports = function(e, t, n, i) {
                var r = n ? n.call(i, e, t) : void 0;
                if (void 0 !== r) return !!r;
                if (e === t) return !0;
                if ("object" != typeof e || !e || "object" != typeof t || !t) return !1;
                var M = Object.keys(e), u = Object.keys(t);
                if (M.length !== u.length) return !1;
                for(var o = Object.prototype.hasOwnProperty.bind(t), c = 0; c < M.length; c++){
                    var a = M[c];
                    if (!o(a)) return !1;
                    var I = e[a], l = t[a];
                    if (!1 === (r = n ? n.call(i, I, l, a) : void 0) || void 0 === r && I !== l) return !1;
                }
                return !0;
            };
        },
        function(e, t, n) {
            "use strict";
            t.a = function(e) {
                function t(e, t, i) {
                    var r = t.trim().split(g);
                    t = r;
                    var M = r.length, u = e.length;
                    switch(u){
                        case 0:
                        case 1:
                            var o = 0;
                            for(e = 0 === u ? "" : e[0] + " "; o < M; ++o)t[o] = n(e, t[o], i).trim();
                            break;
                        default:
                            var c = o = 0;
                            for(t = []; o < M; ++o)for(var a = 0; a < u; ++a)t[c++] = n(e[a] + " ", r[o], i).trim();
                    }
                    return t;
                }
                function n(e, t, n) {
                    var i = t.charCodeAt(0);
                    switch(33 > i && (i = (t = t.trim()).charCodeAt(0)), i){
                        case 38:
                            return t.replace(s, "$1" + e.trim());
                        case 58:
                            return e.trim() + t.replace(s, "$1" + e.trim());
                        default:
                            if (0 < 1 * n && 0 < t.indexOf("\f")) return t.replace(s, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
                    }
                    return e + t;
                }
                function i(e, t, n, M) {
                    var u = e + ";", o = 2 * t + 3 * n + 4 * M;
                    if (944 === o) {
                        e = u.indexOf(":", 9) + 1;
                        var c = u.substring(e, u.length - 1).trim();
                        return c = u.substring(0, e).trim() + c + ";", 1 === S || 2 === S && r(c, 1) ? "-webkit-" + c + c : c;
                    }
                    if (0 === S || 2 === S && !r(u, 1)) return u;
                    switch(o){
                        case 1015:
                            return 97 === u.charCodeAt(10) ? "-webkit-" + u + u : u;
                        case 951:
                            return 116 === u.charCodeAt(3) ? "-webkit-" + u + u : u;
                        case 963:
                            return 110 === u.charCodeAt(5) ? "-webkit-" + u + u : u;
                        case 1009:
                            if (100 !== u.charCodeAt(4)) break;
                        case 969:
                        case 942:
                            return "-webkit-" + u + u;
                        case 978:
                            return "-webkit-" + u + "-moz-" + u + u;
                        case 1019:
                        case 983:
                            return "-webkit-" + u + "-moz-" + u + "-ms-" + u + u;
                        case 883:
                            if (45 === u.charCodeAt(8)) return "-webkit-" + u + u;
                            if (0 < u.indexOf("image-set(", 11)) return u.replace(E, "$1-webkit-$2") + u;
                            break;
                        case 932:
                            if (45 === u.charCodeAt(4)) switch(u.charCodeAt(5)){
                                case 103:
                                    return "-webkit-box-" + u.replace("-grow", "") + "-webkit-" + u + "-ms-" + u.replace("grow", "positive") + u;
                                case 115:
                                    return "-webkit-" + u + "-ms-" + u.replace("shrink", "negative") + u;
                                case 98:
                                    return "-webkit-" + u + "-ms-" + u.replace("basis", "preferred-size") + u;
                            }
                            return "-webkit-" + u + "-ms-" + u + u;
                        case 964:
                            return "-webkit-" + u + "-ms-flex-" + u + u;
                        case 1023:
                            if (99 !== u.charCodeAt(8)) break;
                            return "-webkit-box-pack" + (c = u.substring(u.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + u + "-ms-flex-pack" + c + u;
                        case 1005:
                            return N.test(u) ? u.replace(l, ":-webkit-") + u.replace(l, ":-moz-") + u : u;
                        case 1e3:
                            switch(t = (c = u.substring(13).trim()).indexOf("-") + 1, c.charCodeAt(0) + c.charCodeAt(t)){
                                case 226:
                                    c = u.replace(T, "tb");
                                    break;
                                case 232:
                                    c = u.replace(T, "tb-rl");
                                    break;
                                case 220:
                                    c = u.replace(T, "lr");
                                    break;
                                default:
                                    return u;
                            }
                            return "-webkit-" + u + "-ms-" + c + u;
                        case 1017:
                            if (-1 === u.indexOf("sticky", 9)) break;
                        case 975:
                            switch(t = (u = e).length - 10, o = (c = (33 === u.charCodeAt(t) ? u.substring(0, t) : u).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | c.charCodeAt(7))){
                                case 203:
                                    if (111 > c.charCodeAt(8)) break;
                                case 115:
                                    u = u.replace(c, "-webkit-" + c) + ";" + u;
                                    break;
                                case 207:
                                case 102:
                                    u = u.replace(c, "-webkit-" + (102 < o ? "inline-" : "") + "box") + ";" + u.replace(c, "-webkit-" + c) + ";" + u.replace(c, "-ms-" + c + "box") + ";" + u;
                            }
                            return u + ";";
                        case 938:
                            if (45 === u.charCodeAt(5)) switch(u.charCodeAt(6)){
                                case 105:
                                    return c = u.replace("-items", ""), "-webkit-" + u + "-webkit-box-" + c + "-ms-flex-" + c + u;
                                case 115:
                                    return "-webkit-" + u + "-ms-flex-item-" + u.replace(w, "") + u;
                                default:
                                    return "-webkit-" + u + "-ms-flex-line-pack" + u.replace("align-content", "").replace(w, "") + u;
                            }
                            break;
                        case 973:
                        case 989:
                            if (45 !== u.charCodeAt(3) || 122 === u.charCodeAt(4)) break;
                        case 931:
                        case 953:
                            if (!0 === L.test(e)) return 115 === (c = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? i(e.replace("stretch", "fill-available"), t, n, M).replace(":fill-available", ":stretch") : u.replace(c, "-webkit-" + c) + u.replace(c, "-moz-" + c.replace("fill-", "")) + u;
                            break;
                        case 962:
                            if (u = "-webkit-" + u + (102 === u.charCodeAt(5) ? "-ms-" + u : "") + u, 211 === n + M && 105 === u.charCodeAt(13) && 0 < u.indexOf("transform", 10)) return u.substring(0, u.indexOf(";", 27) + 1).replace(j, "$1-webkit-$2") + u;
                    }
                    return u;
                }
                function r(e, t) {
                    var n = e.indexOf(1 === t ? ":" : "{"), i = e.substring(0, 3 !== t ? n : 10);
                    return n = e.substring(n + 1, e.length - 1), b(2 !== t ? i : i.replace(f, "$1"), n, t);
                }
                function M(e, t) {
                    var n = i(t, t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2));
                    return n !== t + ";" ? n.replace(z, " or ($1)").substring(4) : "(" + t + ")";
                }
                function u(e, t, n, i, r, M, u, o, a, I) {
                    for(var l, N = 0, j = t; N < v; ++N)switch(l = O[N].call(c, e, j, n, i, r, M, u, o, a, I)){
                        case void 0:
                        case !1:
                        case !0:
                        case null:
                            break;
                        default:
                            j = l;
                    }
                    if (j !== t) return j;
                }
                function o(e) {
                    return void 0 !== (e = e.prefix) && (b = null, e ? "function" != typeof e ? S = 1 : (S = 2, b = e) : S = 0), o;
                }
                function c(e, n) {
                    var o = e;
                    if (33 > o.charCodeAt(0) && (o = o.trim()), o = [
                        o
                    ], 0 < v) {
                        var c = u(-1, n, o, o, x, C, 0, 0, 0, 0);
                        void 0 !== c && "string" == typeof c && (n = c);
                    }
                    var l = function e(n, o, c, l, N) {
                        for(var j, g, s, T, z, w = 0, f = 0, L = 0, E = 0, O = 0, b = 0, k = s = j = 0, Q = 0, Y = 0, P = 0, U = 0, Z = c.length, G = Z - 1, B = "", R = "", W = "", H = ""; Q < Z;){
                            if (g = c.charCodeAt(Q), Q === G && 0 !== f + E + L + w && (0 !== f && (g = 47 === f ? 10 : 47), E = L = w = 0, Z++, G++), 0 === f + E + L + w) {
                                if (Q === G && (0 < Y && (B = B.replace(I, "")), 0 < B.trim().length)) {
                                    switch(g){
                                        case 32:
                                        case 9:
                                        case 59:
                                        case 13:
                                        case 10:
                                            break;
                                        default:
                                            B += c.charAt(Q);
                                    }
                                    g = 59;
                                }
                                switch(g){
                                    case 123:
                                        for(j = (B = B.trim()).charCodeAt(0), s = 1, U = ++Q; Q < Z;){
                                            switch(g = c.charCodeAt(Q)){
                                                case 123:
                                                    s++;
                                                    break;
                                                case 125:
                                                    s--;
                                                    break;
                                                case 47:
                                                    switch(g = c.charCodeAt(Q + 1)){
                                                        case 42:
                                                        case 47:
                                                            e: {
                                                                for(k = Q + 1; k < G; ++k)switch(c.charCodeAt(k)){
                                                                    case 47:
                                                                        if (42 === g && 42 === c.charCodeAt(k - 1) && Q + 2 !== k) {
                                                                            Q = k + 1;
                                                                            break e;
                                                                        }
                                                                        break;
                                                                    case 10:
                                                                        if (47 === g) {
                                                                            Q = k + 1;
                                                                            break e;
                                                                        }
                                                                }
                                                                Q = k;
                                                            }
                                                    }
                                                    break;
                                                case 91:
                                                    g++;
                                                case 40:
                                                    g++;
                                                case 34:
                                                case 39:
                                                    for(; Q++ < G && c.charCodeAt(Q) !== g;);
                                            }
                                            if (0 === s) break;
                                            Q++;
                                        }
                                        switch(s = c.substring(U, Q), 0 === j && (j = (B = B.replace(a, "").trim()).charCodeAt(0)), j){
                                            case 64:
                                                switch(0 < Y && (B = B.replace(I, "")), g = B.charCodeAt(1)){
                                                    case 100:
                                                    case 109:
                                                    case 115:
                                                    case 45:
                                                        Y = o;
                                                        break;
                                                    default:
                                                        Y = m;
                                                }
                                                if (U = (s = e(o, Y, s, g, N + 1)).length, 0 < v && (z = u(3, s, Y = t(m, B, P), o, x, C, U, g, N, l), B = Y.join(""), void 0 !== z && 0 === (U = (s = z.trim()).length) && (g = 0, s = "")), 0 < U) switch(g){
                                                    case 115:
                                                        B = B.replace(y, M);
                                                    case 100:
                                                    case 109:
                                                    case 45:
                                                        s = B + "{" + s + "}";
                                                        break;
                                                    case 107:
                                                        s = (B = B.replace(A, "$1 $2")) + "{" + s + "}", s = 1 === S || 2 === S && r("@" + s, 3) ? "@-webkit-" + s + "@" + s : "@" + s;
                                                        break;
                                                    default:
                                                        s = B + s, 112 === l && (R += s, s = "");
                                                }
                                                else s = "";
                                                break;
                                            default:
                                                s = e(o, t(o, B, P), s, l, N + 1);
                                        }
                                        W += s, s = P = Y = k = j = 0, B = "", g = c.charCodeAt(++Q);
                                        break;
                                    case 125:
                                    case 59:
                                        if (1 < (U = (B = (0 < Y ? B.replace(I, "") : B).trim()).length)) switch(0 === k && (j = B.charCodeAt(0), 45 === j || 96 < j && 123 > j) && (U = (B = B.replace(" ", ":")).length), 0 < v && void 0 !== (z = u(1, B, o, n, x, C, R.length, l, N, l)) && 0 === (U = (B = z.trim()).length) && (B = "\0\0"), j = B.charCodeAt(0), g = B.charCodeAt(1), j){
                                            case 0:
                                                break;
                                            case 64:
                                                if (105 === g || 99 === g) {
                                                    H += B + c.charAt(Q);
                                                    break;
                                                }
                                            default:
                                                58 !== B.charCodeAt(U - 1) && (R += i(B, j, g, B.charCodeAt(2)));
                                        }
                                        P = Y = k = j = 0, B = "", g = c.charCodeAt(++Q);
                                }
                            }
                            switch(g){
                                case 13:
                                case 10:
                                    47 === f ? f = 0 : 0 === 1 + j && 107 !== l && 0 < B.length && (Y = 1, B += "\0"), 0 < v * h && u(0, B, o, n, x, C, R.length, l, N, l), C = 1, x++;
                                    break;
                                case 59:
                                case 125:
                                    if (0 === f + E + L + w) {
                                        C++;
                                        break;
                                    }
                                default:
                                    switch(C++, T = c.charAt(Q), g){
                                        case 9:
                                        case 32:
                                            if (0 === E + w + f) switch(O){
                                                case 44:
                                                case 58:
                                                case 9:
                                                case 32:
                                                    T = "";
                                                    break;
                                                default:
                                                    32 !== g && (T = " ");
                                            }
                                            break;
                                        case 0:
                                            T = "\\0";
                                            break;
                                        case 12:
                                            T = "\\f";
                                            break;
                                        case 11:
                                            T = "\\v";
                                            break;
                                        case 38:
                                            0 === E + f + w && (Y = P = 1, T = "\f" + T);
                                            break;
                                        case 108:
                                            if (0 === E + f + w + p && 0 < k) switch(Q - k){
                                                case 2:
                                                    112 === O && 58 === c.charCodeAt(Q - 3) && (p = O);
                                                case 8:
                                                    111 === b && (p = b);
                                            }
                                            break;
                                        case 58:
                                            0 === E + f + w && (k = Q);
                                            break;
                                        case 44:
                                            0 === f + L + E + w && (Y = 1, T += "\r");
                                            break;
                                        case 34:
                                        case 39:
                                            0 === f && (E = E === g ? 0 : 0 === E ? g : E);
                                            break;
                                        case 91:
                                            0 === E + f + L && w++;
                                            break;
                                        case 93:
                                            0 === E + f + L && w--;
                                            break;
                                        case 41:
                                            0 === E + f + w && L--;
                                            break;
                                        case 40:
                                            if (0 === E + f + w) {
                                                if (0 === j) switch(2 * O + 3 * b){
                                                    case 533:
                                                        break;
                                                    default:
                                                        j = 1;
                                                }
                                                L++;
                                            }
                                            break;
                                        case 64:
                                            0 === f + L + E + w + k + s && (s = 1);
                                            break;
                                        case 42:
                                        case 47:
                                            if (!(0 < E + w + L)) switch(f){
                                                case 0:
                                                    switch(2 * g + 3 * c.charCodeAt(Q + 1)){
                                                        case 235:
                                                            f = 47;
                                                            break;
                                                        case 220:
                                                            U = Q, f = 42;
                                                    }
                                                    break;
                                                case 42:
                                                    47 === g && 42 === O && U + 2 !== Q && (33 === c.charCodeAt(U + 2) && (R += c.substring(U, Q + 1)), T = "", f = 0);
                                            }
                                    }
                                    0 === f && (B += T);
                            }
                            b = O, O = g, Q++;
                        }
                        if (0 < (U = R.length)) {
                            if (Y = o, 0 < v && void 0 !== (z = u(2, R, Y, n, x, C, U, l, N, l)) && 0 === (R = z).length) return H + R + W;
                            if (R = Y.join(",") + "{" + R + "}", 0 != S * p) {
                                switch(2 !== S || r(R, 2) || (p = 0), p){
                                    case 111:
                                        R = R.replace(d, ":-moz-$1") + R;
                                        break;
                                    case 112:
                                        R = R.replace(D, "::-webkit-input-$1") + R.replace(D, "::-moz-$1") + R.replace(D, ":-ms-input-$1") + R;
                                }
                                p = 0;
                            }
                        }
                        return H + R + W;
                    }(m, o, n, 0, 0);
                    return 0 < v && void 0 !== (c = u(-2, l, o, o, x, C, l.length, 0, 0, 0)) && (l = c), p = 0, C = x = 1, l;
                }
                var a = /^\0+/g, I = /[\0\r\f]/g, l = /: */g, N = /zoo|gra/, j = /([,: ])(transform)/g, g = /,\r+?/g, s = /([\t\r\n ])*\f?&/g, A = /@(k\w+)\s*(\S*)\s*/, D = /::(place)/g, d = /:(read-only)/g, T = /[svh]\w+-[tblr]{2}/, y = /\(\s*(.*)\s*\)/g, z = /([\s\S]*?);/g, w = /-self|flex-/g, f = /[^]*?(:[rp][el]a[\w-]+)[^]*/, L = /stretch|:\s*\w+\-(?:conte|avail)/, E = /([^-])(image-set\()/, C = 1, x = 1, p = 0, S = 1, m = [], O = [], v = 0, b = null, h = 0;
                return c.use = function e(t) {
                    switch(t){
                        case void 0:
                        case null:
                            v = O.length = 0;
                            break;
                        default:
                            if ("function" == typeof t) O[v++] = t;
                            else if ("object" == typeof t) for(var n = 0, i = t.length; n < i; ++n)e(t[n]);
                            else h = 0 | !!t;
                    }
                    return e;
                }, c.set = o, void 0 !== e && o(e), c;
            };
        },
        function(e, t, n) {
            "use strict";
            t.a = {
                animationIterationCount: 1,
                borderImageOutset: 1,
                borderImageSlice: 1,
                borderImageWidth: 1,
                boxFlex: 1,
                boxFlexGroup: 1,
                boxOrdinalGroup: 1,
                columnCount: 1,
                columns: 1,
                flex: 1,
                flexGrow: 1,
                flexPositive: 1,
                flexShrink: 1,
                flexNegative: 1,
                flexOrder: 1,
                gridRow: 1,
                gridRowEnd: 1,
                gridRowSpan: 1,
                gridRowStart: 1,
                gridColumn: 1,
                gridColumnEnd: 1,
                gridColumnSpan: 1,
                gridColumnStart: 1,
                msGridRow: 1,
                msGridRowSpan: 1,
                msGridColumn: 1,
                msGridColumnSpan: 1,
                fontWeight: 1,
                lineHeight: 1,
                opacity: 1,
                order: 1,
                orphans: 1,
                tabSize: 1,
                widows: 1,
                zIndex: 1,
                zoom: 1,
                WebkitLineClamp: 1,
                fillOpacity: 1,
                floodOpacity: 1,
                stopOpacity: 1,
                strokeDasharray: 1,
                strokeDashoffset: 1,
                strokeMiterlimit: 1,
                strokeOpacity: 1,
                strokeWidth: 1
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0), r = n(26);
            i.__exportStar(n(17), t), i.__exportStar(n(2), t), i.__exportStar(n(20), t), i.__exportStar(n(5), t), i.__exportStar(n(3), t), i.__exportStar(n(4), t), t.default = r.Core;
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Core = void 0;
            var i = n(0), r = i.__importStar(n(1)), M = i.__importStar(n(28)), u = n(3), o = n(2), c = n(4), a = n(17), I = n(20), l = {
                show: !1
            }, N = {
                lightboxOpacity: .4,
                theme: c.themesList.default.name,
                cacheProvider: !1,
                disableInjectedProvider: !1,
                providerOptions: {},
                network: ""
            }, j = function() {
                function e(e) {
                    var t = this;
                    this.show = l.show, this.eventController = new I.EventController, this.connect = function() {
                        return new Promise(function(e, n) {
                            return i.__awaiter(t, void 0, void 0, function() {
                                return i.__generator(this, function(t) {
                                    switch(t.label){
                                        case 0:
                                            return this.on(o.CONNECT_EVENT, function(t) {
                                                return e(t);
                                            }), this.on(o.ERROR_EVENT, function(e) {
                                                return n(e);
                                            }), this.on(o.CLOSE_EVENT, function() {
                                                return n("Modal closed by user");
                                            }), [
                                                4,
                                                this.toggleModal()
                                            ];
                                        case 1:
                                            return t.sent(), [
                                                2
                                            ];
                                    }
                                });
                            });
                        });
                    }, this.connectTo = function(e) {
                        return new Promise(function(n, r) {
                            return i.__awaiter(t, void 0, void 0, function() {
                                var t;
                                return i.__generator(this, function(i) {
                                    switch(i.label){
                                        case 0:
                                            return this.on(o.CONNECT_EVENT, function(e) {
                                                return n(e);
                                            }), this.on(o.ERROR_EVENT, function(e) {
                                                return r(e);
                                            }), this.on(o.CLOSE_EVENT, function() {
                                                return r("Modal closed by user");
                                            }), (t = this.providerController.getProvider(e)) ? [
                                                4,
                                                this.providerController.connectTo(t.id, t.connector)
                                            ] : [
                                                2,
                                                r(new Error("Cannot connect to provider (" + e + "), check provider options"))
                                            ];
                                        case 1:
                                            return i.sent(), [
                                                2
                                            ];
                                    }
                                });
                            });
                        });
                    }, this._toggleModal = function() {
                        return i.__awaiter(t, void 0, void 0, function() {
                            var e, t;
                            return i.__generator(this, function(n) {
                                switch(n.label){
                                    case 0:
                                        return e = "undefined" != typeof window ? document : "", (t = e ? e.body || e.getElementsByTagName("body")[0] : "") && (this.show ? t.style.overflow = "" : t.style.overflow = "hidden"), [
                                            4,
                                            this.updateState({
                                                show: !this.show
                                            })
                                        ];
                                    case 1:
                                        return n.sent(), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.onError = function(e) {
                        return i.__awaiter(t, void 0, void 0, function() {
                            return i.__generator(this, function(t) {
                                switch(t.label){
                                    case 0:
                                        return this.show ? [
                                            4,
                                            this._toggleModal()
                                        ] : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        t.sent(), t.label = 2;
                                    case 2:
                                        return this.eventController.trigger(o.ERROR_EVENT, e), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.onProviderSelect = function(e) {
                        t.eventController.trigger(o.SELECT_EVENT, e);
                    }, this.onConnect = function(e) {
                        return i.__awaiter(t, void 0, void 0, function() {
                            return i.__generator(this, function(t) {
                                switch(t.label){
                                    case 0:
                                        return this.show ? [
                                            4,
                                            this._toggleModal()
                                        ] : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        t.sent(), t.label = 2;
                                    case 2:
                                        return this.eventController.trigger(o.CONNECT_EVENT, e), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.onClose = function() {
                        return i.__awaiter(t, void 0, void 0, function() {
                            return i.__generator(this, function(e) {
                                switch(e.label){
                                    case 0:
                                        return this.show ? [
                                            4,
                                            this._toggleModal()
                                        ] : [
                                            3,
                                            2
                                        ];
                                    case 1:
                                        e.sent(), e.label = 2;
                                    case 2:
                                        return this.eventController.trigger(o.CLOSE_EVENT), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.updateState = function(e) {
                        return i.__awaiter(t, void 0, void 0, function() {
                            var t = this;
                            return i.__generator(this, function(n) {
                                switch(n.label){
                                    case 0:
                                        return Object.keys(e).forEach(function(n) {
                                            t[n] = e[n];
                                        }), [
                                            4,
                                            window.updateWeb3Modal(e)
                                        ];
                                    case 1:
                                        return n.sent(), [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.resetState = function() {
                        return t.updateState(i.__assign({}, l));
                    };
                    var n = i.__assign(i.__assign({}, N), e);
                    this.lightboxOpacity = n.lightboxOpacity, this.themeColors = u.getThemeColors(n.theme), this.providerController = new I.ProviderController({
                        disableInjectedProvider: n.disableInjectedProvider,
                        cacheProvider: n.cacheProvider,
                        providerOptions: n.providerOptions,
                        network: n.network
                    }), this.providerController.on(o.CONNECT_EVENT, function(e) {
                        return t.onConnect(e);
                    }), this.providerController.on(o.ERROR_EVENT, function(e) {
                        return t.onError(e);
                    }), this.providerController.on(o.SELECT_EVENT, this.onProviderSelect), this.userOptions = this.providerController.getUserOptions(), this.renderModal();
                }
                return Object.defineProperty(e.prototype, "cachedProvider", {
                    get: function() {
                        return this.providerController.cachedProvider;
                    },
                    enumerable: !1,
                    configurable: !0
                }), e.prototype.toggleModal = function() {
                    return i.__awaiter(this, void 0, void 0, function() {
                        return i.__generator(this, function(e) {
                            switch(e.label){
                                case 0:
                                    return this.cachedProvider ? [
                                        4,
                                        this.providerController.connectToCachedProvider()
                                    ] : [
                                        3,
                                        2
                                    ];
                                case 1:
                                    return e.sent(), [
                                        2
                                    ];
                                case 2:
                                    return this.userOptions && 1 === this.userOptions.length && this.userOptions[0].name ? [
                                        4,
                                        this.userOptions[0].onClick()
                                    ] : [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return e.sent(), [
                                        2
                                    ];
                                case 4:
                                    return [
                                        4,
                                        this._toggleModal()
                                    ];
                                case 5:
                                    return e.sent(), [
                                        2
                                    ];
                            }
                        });
                    });
                }, e.prototype.on = function(e, t) {
                    var n = this;
                    return this.eventController.on({
                        event: e,
                        callback: t
                    }), function() {
                        return n.eventController.off({
                            event: e,
                            callback: t
                        });
                    };
                }, e.prototype.off = function(e, t) {
                    this.eventController.off({
                        event: e,
                        callback: t
                    });
                }, e.prototype.getUserOptions = function() {
                    return this.userOptions;
                }, e.prototype.clearCachedProvider = function() {
                    this.providerController.clearCachedProvider();
                }, e.prototype.setCachedProvider = function(e) {
                    this.providerController.setCachedProvider(e);
                }, e.prototype.updateTheme = function(e) {
                    return i.__awaiter(this, void 0, void 0, function() {
                        return i.__generator(this, function(t) {
                            switch(t.label){
                                case 0:
                                    return this.themeColors = u.getThemeColors(e), [
                                        4,
                                        this.updateState({
                                            themeColors: this.themeColors
                                        })
                                    ];
                                case 1:
                                    return t.sent(), [
                                        2
                                    ];
                            }
                        });
                    });
                }, e.prototype.renderModal = function() {
                    var e = document.createElement("div");
                    e.id = o.WEB3_CONNECT_MODAL_ID, document.body.appendChild(e), M.render(r.createElement(a.Modal, {
                        themeColors: this.themeColors,
                        userOptions: this.userOptions,
                        onClose: this.onClose,
                        resetState: this.resetState,
                        lightboxOpacity: this.lightboxOpacity
                    }), document.getElementById(o.WEB3_CONNECT_MODAL_ID));
                }, e;
            }();
            t.Core = j;
        },
        function(e, t, n) {
            "use strict";
            /** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var i = n(9), r = "function" == typeof Symbol && Symbol.for, M = r ? Symbol.for("react.element") : 60103, u = r ? Symbol.for("react.portal") : 60106, o = r ? Symbol.for("react.fragment") : 60107, c = r ? Symbol.for("react.strict_mode") : 60108, a = r ? Symbol.for("react.profiler") : 60114, I = r ? Symbol.for("react.provider") : 60109, l = r ? Symbol.for("react.context") : 60110, N = r ? Symbol.for("react.forward_ref") : 60112, j = r ? Symbol.for("react.suspense") : 60113, g = r ? Symbol.for("react.memo") : 60115, s = r ? Symbol.for("react.lazy") : 60116, A = "function" == typeof Symbol && Symbol.iterator;
            function D(e) {
                for(var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++)t += "&args[]=" + encodeURIComponent(arguments[n]);
                return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            }
            var d = {
                isMounted: function() {
                    return !1;
                },
                enqueueForceUpdate: function() {},
                enqueueReplaceState: function() {},
                enqueueSetState: function() {}
            }, T = {};
            function y(e, t, n) {
                this.props = e, this.context = t, this.refs = T, this.updater = n || d;
            }
            function z() {}
            function w(e, t, n) {
                this.props = e, this.context = t, this.refs = T, this.updater = n || d;
            }
            y.prototype.isReactComponent = {}, y.prototype.setState = function(e, t) {
                if ("object" != typeof e && "function" != typeof e && null != e) throw Error(D(85));
                this.updater.enqueueSetState(this, e, t, "setState");
            }, y.prototype.forceUpdate = function(e) {
                this.updater.enqueueForceUpdate(this, e, "forceUpdate");
            }, z.prototype = y.prototype;
            var f = w.prototype = new z;
            f.constructor = w, i(f, y.prototype), f.isPureReactComponent = !0;
            var L = {
                current: null
            }, E = Object.prototype.hasOwnProperty, C = {
                key: !0,
                ref: !0,
                __self: !0,
                __source: !0
            };
            function x(e, t, n) {
                var i, r = {}, u = null, o = null;
                if (null != t) for(i in void 0 !== t.ref && (o = t.ref), void 0 !== t.key && (u = "" + t.key), t)E.call(t, i) && !C.hasOwnProperty(i) && (r[i] = t[i]);
                var c = arguments.length - 2;
                if (1 === c) r.children = n;
                else if (1 < c) {
                    for(var a = Array(c), I = 0; I < c; I++)a[I] = arguments[I + 2];
                    r.children = a;
                }
                if (e && e.defaultProps) for(i in c = e.defaultProps)void 0 === r[i] && (r[i] = c[i]);
                return {
                    $$typeof: M,
                    type: e,
                    key: u,
                    ref: o,
                    props: r,
                    _owner: L.current
                };
            }
            function p(e) {
                return "object" == typeof e && null !== e && e.$$typeof === M;
            }
            var S = /\/+/g, m = [];
            function O(e, t, n, i) {
                if (m.length) {
                    var r = m.pop();
                    return r.result = e, r.keyPrefix = t, r.func = n, r.context = i, r.count = 0, r;
                }
                return {
                    result: e,
                    keyPrefix: t,
                    func: n,
                    context: i,
                    count: 0
                };
            }
            function v(e) {
                e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, 10 > m.length && m.push(e);
            }
            function b(e, t, n) {
                return null == e ? 0 : function e(t, n, i, r) {
                    var o = typeof t;
                    "undefined" !== o && "boolean" !== o || (t = null);
                    var c = !1;
                    if (null === t) c = !0;
                    else switch(o){
                        case "string":
                        case "number":
                            c = !0;
                            break;
                        case "object":
                            switch(t.$$typeof){
                                case M:
                                case u:
                                    c = !0;
                            }
                    }
                    if (c) return i(r, t, "" === n ? "." + h(t, 0) : n), 1;
                    if (c = 0, n = "" === n ? "." : n + ":", Array.isArray(t)) for(var a = 0; a < t.length; a++){
                        var I = n + h(o = t[a], a);
                        c += e(o, I, i, r);
                    }
                    else if (null === t || "object" != typeof t ? I = null : I = "function" == typeof (I = A && t[A] || t["@@iterator"]) ? I : null, "function" == typeof I) for(t = I.call(t), a = 0; !(o = t.next()).done;)c += e(o = o.value, I = n + h(o, a++), i, r);
                    else if ("object" === o) throw i = "" + t, Error(D(31, "[object Object]" === i ? "object with keys {" + Object.keys(t).join(", ") + "}" : i, ""));
                    return c;
                }(e, "", t, n);
            }
            function h(e, t) {
                return "object" == typeof e && null !== e && null != e.key ? function(e) {
                    var t = {
                        "=": "=0",
                        ":": "=2"
                    };
                    return "$" + ("" + e).replace(/[=:]/g, function(e) {
                        return t[e];
                    });
                }(e.key) : t.toString(36);
            }
            function k(e, t) {
                e.func.call(e.context, t, e.count++);
            }
            function Q(e, t, n) {
                var i = e.result, r = e.keyPrefix;
                e = e.func.call(e.context, t, e.count++), Array.isArray(e) ? Y(e, i, n, function(e) {
                    return e;
                }) : null != e && (p(e) && (e = function(e, t) {
                    return {
                        $$typeof: M,
                        type: e.type,
                        key: t,
                        ref: e.ref,
                        props: e.props,
                        _owner: e._owner
                    };
                }(e, r + (!e.key || t && t.key === e.key ? "" : ("" + e.key).replace(S, "$&/") + "/") + n)), i.push(e));
            }
            function Y(e, t, n, i, r) {
                var M = "";
                null != n && (M = ("" + n).replace(S, "$&/") + "/"), b(e, Q, t = O(t, M, i, r)), v(t);
            }
            var P = {
                current: null
            };
            function U() {
                var e = P.current;
                if (null === e) throw Error(D(321));
                return e;
            }
            var Z = {
                ReactCurrentDispatcher: P,
                ReactCurrentBatchConfig: {
                    suspense: null
                },
                ReactCurrentOwner: L,
                IsSomeRendererActing: {
                    current: !1
                },
                assign: i
            };
            t.Children = {
                map: function(e, t, n) {
                    if (null == e) return e;
                    var i = [];
                    return Y(e, i, null, t, n), i;
                },
                forEach: function(e, t, n) {
                    if (null == e) return e;
                    b(e, k, t = O(null, null, t, n)), v(t);
                },
                count: function(e) {
                    return b(e, function() {
                        return null;
                    }, null);
                },
                toArray: function(e) {
                    var t = [];
                    return Y(e, t, null, function(e) {
                        return e;
                    }), t;
                },
                only: function(e) {
                    if (!p(e)) throw Error(D(143));
                    return e;
                }
            }, t.Component = y, t.Fragment = o, t.Profiler = a, t.PureComponent = w, t.StrictMode = c, t.Suspense = j, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Z, t.cloneElement = function(e, t, n) {
                if (null == e) throw Error(D(267, e));
                var r = i({}, e.props), u = e.key, o = e.ref, c = e._owner;
                if (null != t) {
                    if (void 0 !== t.ref && (o = t.ref, c = L.current), void 0 !== t.key && (u = "" + t.key), e.type && e.type.defaultProps) var a = e.type.defaultProps;
                    for(I in t)E.call(t, I) && !C.hasOwnProperty(I) && (r[I] = void 0 === t[I] && void 0 !== a ? a[I] : t[I]);
                }
                var I = arguments.length - 2;
                if (1 === I) r.children = n;
                else if (1 < I) {
                    a = Array(I);
                    for(var l = 0; l < I; l++)a[l] = arguments[l + 2];
                    r.children = a;
                }
                return {
                    $$typeof: M,
                    type: e.type,
                    key: u,
                    ref: o,
                    props: r,
                    _owner: c
                };
            }, t.createContext = function(e, t) {
                return void 0 === t && (t = null), (e = {
                    $$typeof: l,
                    _calculateChangedBits: t,
                    _currentValue: e,
                    _currentValue2: e,
                    _threadCount: 0,
                    Provider: null,
                    Consumer: null
                }).Provider = {
                    $$typeof: I,
                    _context: e
                }, e.Consumer = e;
            }, t.createElement = x, t.createFactory = function(e) {
                var t = x.bind(null, e);
                return t.type = e, t;
            }, t.createRef = function() {
                return {
                    current: null
                };
            }, t.forwardRef = function(e) {
                return {
                    $$typeof: N,
                    render: e
                };
            }, t.isValidElement = p, t.lazy = function(e) {
                return {
                    $$typeof: s,
                    _ctor: e,
                    _status: -1,
                    _result: null
                };
            }, t.memo = function(e, t) {
                return {
                    $$typeof: g,
                    type: e,
                    compare: void 0 === t ? null : t
                };
            }, t.useCallback = function(e, t) {
                return U().useCallback(e, t);
            }, t.useContext = function(e, t) {
                return U().useContext(e, t);
            }, t.useDebugValue = function() {}, t.useEffect = function(e, t) {
                return U().useEffect(e, t);
            }, t.useImperativeHandle = function(e, t, n) {
                return U().useImperativeHandle(e, t, n);
            }, t.useLayoutEffect = function(e, t) {
                return U().useLayoutEffect(e, t);
            }, t.useMemo = function(e, t) {
                return U().useMemo(e, t);
            }, t.useReducer = function(e, t, n) {
                return U().useReducer(e, t, n);
            }, t.useRef = function(e) {
                return U().useRef(e);
            }, t.useState = function(e) {
                return U().useState(e);
            }, t.version = "16.14.0";
        },
        function(e, t, n) {
            "use strict";
            !function e() {
                if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) try {
                    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
                } catch (e) {
                    console.error(e);
                }
            }(), e.exports = n(29);
        },
        function(e, t, n) {
            "use strict";
            /** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var i = n(1), r = n(9), M = n(30);
            function u(e) {
                for(var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++)t += "&args[]=" + encodeURIComponent(arguments[n]);
                return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            }
            if (!i) throw Error(u(227));
            function o(e, t, n, i, r, M, u, o, c) {
                var a = Array.prototype.slice.call(arguments, 3);
                try {
                    t.apply(n, a);
                } catch (e) {
                    this.onError(e);
                }
            }
            var c = !1, a = null, I = !1, l = null, N = {
                onError: function(e) {
                    c = !0, a = e;
                }
            };
            function j(e, t, n, i, r, M, u, I, l) {
                c = !1, a = null, o.apply(N, arguments);
            }
            var g = null, s = null, A = null;
            function D(e, t, n) {
                var i = e.type || "unknown-event";
                e.currentTarget = A(n), function(e, t, n, i, r, M, o, N, g) {
                    if (j.apply(this, arguments), c) {
                        if (!c) throw Error(u(198));
                        var s = a;
                        c = !1, a = null, I || (I = !0, l = s);
                    }
                }(i, t, void 0, e), e.currentTarget = null;
            }
            var d = null, T = {};
            function y() {
                if (d) for(var e in T){
                    var t = T[e], n = d.indexOf(e);
                    if (!(-1 < n)) throw Error(u(96, e));
                    if (!w[n]) {
                        if (!t.extractEvents) throw Error(u(97, e));
                        for(var i in w[n] = t, n = t.eventTypes){
                            var r = void 0, M = n[i], o = t, c = i;
                            if (f.hasOwnProperty(c)) throw Error(u(99, c));
                            f[c] = M;
                            var a = M.phasedRegistrationNames;
                            if (a) {
                                for(r in a)a.hasOwnProperty(r) && z(a[r], o, c);
                                r = !0;
                            } else M.registrationName ? (z(M.registrationName, o, c), r = !0) : r = !1;
                            if (!r) throw Error(u(98, i, e));
                        }
                    }
                }
            }
            function z(e, t, n) {
                if (L[e]) throw Error(u(100, e));
                L[e] = t, E[e] = t.eventTypes[n].dependencies;
            }
            var w = [], f = {}, L = {}, E = {};
            function C(e) {
                var t, n = !1;
                for(t in e)if (e.hasOwnProperty(t)) {
                    var i = e[t];
                    if (!T.hasOwnProperty(t) || T[t] !== i) {
                        if (T[t]) throw Error(u(102, t));
                        T[t] = i, n = !0;
                    }
                }
                n && y();
            }
            var x = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement), p = null, S = null, m = null;
            function O(e) {
                if (e = s(e)) {
                    if ("function" != typeof p) throw Error(u(280));
                    var t = e.stateNode;
                    t && (t = g(t), p(e.stateNode, e.type, t));
                }
            }
            function v(e) {
                S ? m ? m.push(e) : m = [
                    e
                ] : S = e;
            }
            function b() {
                if (S) {
                    var e = S, t = m;
                    if (m = S = null, O(e), t) for(e = 0; e < t.length; e++)O(t[e]);
                }
            }
            function h(e, t) {
                return e(t);
            }
            function k(e, t, n, i, r) {
                return e(t, n, i, r);
            }
            function Q() {}
            var Y = h, P = !1, U = !1;
            function Z() {
                null === S && null === m || (Q(), b());
            }
            function G(e, t, n) {
                if (U) return e(t, n);
                U = !0;
                try {
                    return Y(e, t, n);
                } finally{
                    U = !1, Z();
                }
            }
            var B = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, R = Object.prototype.hasOwnProperty, W = {}, H = {};
            function V(e, t, n, i, r, M) {
                this.acceptsBooleans = 2 === t || 3 === t || 4 === t, this.attributeName = i, this.attributeNamespace = r, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = M;
            }
            var J = {};
            "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e) {
                J[e] = new V(e, 0, !1, e, null, !1);
            }), [
                [
                    "acceptCharset",
                    "accept-charset"
                ],
                [
                    "className",
                    "class"
                ],
                [
                    "htmlFor",
                    "for"
                ],
                [
                    "httpEquiv",
                    "http-equiv"
                ]
            ].forEach(function(e) {
                var t = e[0];
                J[t] = new V(t, 1, !1, e[1], null, !1);
            }), [
                "contentEditable",
                "draggable",
                "spellCheck",
                "value"
            ].forEach(function(e) {
                J[e] = new V(e, 2, !1, e.toLowerCase(), null, !1);
            }), [
                "autoReverse",
                "externalResourcesRequired",
                "focusable",
                "preserveAlpha"
            ].forEach(function(e) {
                J[e] = new V(e, 2, !1, e, null, !1);
            }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e) {
                J[e] = new V(e, 3, !1, e.toLowerCase(), null, !1);
            }), [
                "checked",
                "multiple",
                "muted",
                "selected"
            ].forEach(function(e) {
                J[e] = new V(e, 3, !0, e, null, !1);
            }), [
                "capture",
                "download"
            ].forEach(function(e) {
                J[e] = new V(e, 4, !1, e, null, !1);
            }), [
                "cols",
                "rows",
                "size",
                "span"
            ].forEach(function(e) {
                J[e] = new V(e, 6, !1, e, null, !1);
            }), [
                "rowSpan",
                "start"
            ].forEach(function(e) {
                J[e] = new V(e, 5, !1, e.toLowerCase(), null, !1);
            });
            var F = /[\-:]([a-z])/g;
            function X(e) {
                return e[1].toUpperCase();
            }
            "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e) {
                var t = e.replace(F, X);
                J[t] = new V(t, 1, !1, e, null, !1);
            }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e) {
                var t = e.replace(F, X);
                J[t] = new V(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1);
            }), [
                "xml:base",
                "xml:lang",
                "xml:space"
            ].forEach(function(e) {
                var t = e.replace(F, X);
                J[t] = new V(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1);
            }), [
                "tabIndex",
                "crossOrigin"
            ].forEach(function(e) {
                J[e] = new V(e, 1, !1, e.toLowerCase(), null, !1);
            }), J.xlinkHref = new V("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0), [
                "src",
                "href",
                "action",
                "formAction"
            ].forEach(function(e) {
                J[e] = new V(e, 1, !1, e.toLowerCase(), null, !0);
            });
            var K = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
            function q(e, t, n, i) {
                var r = J.hasOwnProperty(t) ? J[t] : null;
                (null !== r ? 0 === r.type : !i && 2 < t.length && ("o" === t[0] || "O" === t[0]) && ("n" === t[1] || "N" === t[1])) || (function(e, t, n, i) {
                    if (null == t || function(e, t, n, i) {
                        if (null !== n && 0 === n.type) return !1;
                        switch(typeof t){
                            case "function":
                            case "symbol":
                                return !0;
                            case "boolean":
                                return !i && (null !== n ? !n.acceptsBooleans : "data-" !== (e = e.toLowerCase().slice(0, 5)) && "aria-" !== e);
                            default:
                                return !1;
                        }
                    }(e, t, n, i)) return !0;
                    if (i) return !1;
                    if (null !== n) switch(n.type){
                        case 3:
                            return !t;
                        case 4:
                            return !1 === t;
                        case 5:
                            return isNaN(t);
                        case 6:
                            return isNaN(t) || 1 > t;
                    }
                    return !1;
                }(t, n, r, i) && (n = null), i || null === r ? function(e) {
                    return !!R.call(H, e) || !R.call(W, e) && (B.test(e) ? H[e] = !0 : (W[e] = !0, !1));
                }(t) && (null === n ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : r.mustUseProperty ? e[r.propertyName] = null === n ? 3 !== r.type && "" : n : (t = r.attributeName, i = r.attributeNamespace, null === n ? e.removeAttribute(t) : (n = 3 === (r = r.type) || 4 === r && !0 === n ? "" : "" + n, i ? e.setAttributeNS(i, t, n) : e.setAttribute(t, n))));
            }
            K.hasOwnProperty("ReactCurrentDispatcher") || (K.ReactCurrentDispatcher = {
                current: null
            }), K.hasOwnProperty("ReactCurrentBatchConfig") || (K.ReactCurrentBatchConfig = {
                suspense: null
            });
            var _ = /^(.*)[\\\/]/, $ = "function" == typeof Symbol && Symbol.for, ee = $ ? Symbol.for("react.element") : 60103, te = $ ? Symbol.for("react.portal") : 60106, ne = $ ? Symbol.for("react.fragment") : 60107, ie = $ ? Symbol.for("react.strict_mode") : 60108, re = $ ? Symbol.for("react.profiler") : 60114, Me = $ ? Symbol.for("react.provider") : 60109, ue = $ ? Symbol.for("react.context") : 60110, oe = $ ? Symbol.for("react.concurrent_mode") : 60111, ce = $ ? Symbol.for("react.forward_ref") : 60112, ae = $ ? Symbol.for("react.suspense") : 60113, Ie = $ ? Symbol.for("react.suspense_list") : 60120, le = $ ? Symbol.for("react.memo") : 60115, Ne = $ ? Symbol.for("react.lazy") : 60116, je = $ ? Symbol.for("react.block") : 60121, ge = "function" == typeof Symbol && Symbol.iterator;
            function se(e) {
                return null === e || "object" != typeof e ? null : "function" == typeof (e = ge && e[ge] || e["@@iterator"]) ? e : null;
            }
            function Ae(e) {
                if (null == e) return null;
                if ("function" == typeof e) return e.displayName || e.name || null;
                if ("string" == typeof e) return e;
                switch(e){
                    case ne:
                        return "Fragment";
                    case te:
                        return "Portal";
                    case re:
                        return "Profiler";
                    case ie:
                        return "StrictMode";
                    case ae:
                        return "Suspense";
                    case Ie:
                        return "SuspenseList";
                }
                if ("object" == typeof e) switch(e.$$typeof){
                    case ue:
                        return "Context.Consumer";
                    case Me:
                        return "Context.Provider";
                    case ce:
                        var t = e.render;
                        return t = t.displayName || t.name || "", e.displayName || ("" !== t ? "ForwardRef(" + t + ")" : "ForwardRef");
                    case le:
                        return Ae(e.type);
                    case je:
                        return Ae(e.render);
                    case Ne:
                        if (e = 1 === e._status ? e._result : null) return Ae(e);
                }
                return null;
            }
            function De(e) {
                var t = "";
                do {
                    e: switch(e.tag){
                        case 3:
                        case 4:
                        case 6:
                        case 7:
                        case 10:
                        case 9:
                            var n = "";
                            break e;
                        default:
                            var i = e._debugOwner, r = e._debugSource, M = Ae(e.type);
                            n = null, i && (n = Ae(i.type)), i = M, M = "", r ? M = " (at " + r.fileName.replace(_, "") + ":" + r.lineNumber + ")" : n && (M = " (created by " + n + ")"), n = "\n    in " + (i || "Unknown") + M;
                    }
                    t += n, e = e.return;
                }while (e);
                return t;
            }
            function de(e) {
                switch(typeof e){
                    case "boolean":
                    case "number":
                    case "object":
                    case "string":
                    case "undefined":
                        return e;
                    default:
                        return "";
                }
            }
            function Te(e) {
                var t = e.type;
                return (e = e.nodeName) && "input" === e.toLowerCase() && ("checkbox" === t || "radio" === t);
            }
            function ye(e) {
                e._valueTracker || (e._valueTracker = function(e) {
                    var t = Te(e) ? "checked" : "value", n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t), i = "" + e[t];
                    if (!e.hasOwnProperty(t) && void 0 !== n && "function" == typeof n.get && "function" == typeof n.set) {
                        var r = n.get, M = n.set;
                        return Object.defineProperty(e, t, {
                            configurable: !0,
                            get: function() {
                                return r.call(this);
                            },
                            set: function(e) {
                                i = "" + e, M.call(this, e);
                            }
                        }), Object.defineProperty(e, t, {
                            enumerable: n.enumerable
                        }), {
                            getValue: function() {
                                return i;
                            },
                            setValue: function(e) {
                                i = "" + e;
                            },
                            stopTracking: function() {
                                e._valueTracker = null, delete e[t];
                            }
                        };
                    }
                }(e));
            }
            function ze(e) {
                if (!e) return !1;
                var t = e._valueTracker;
                if (!t) return !0;
                var n = t.getValue(), i = "";
                return e && (i = Te(e) ? e.checked ? "true" : "false" : e.value), (e = i) !== n && (t.setValue(e), !0);
            }
            function we(e, t) {
                var n = t.checked;
                return r({}, t, {
                    defaultChecked: void 0,
                    defaultValue: void 0,
                    value: void 0,
                    checked: null != n ? n : e._wrapperState.initialChecked
                });
            }
            function fe(e, t) {
                var n = null == t.defaultValue ? "" : t.defaultValue, i = null != t.checked ? t.checked : t.defaultChecked;
                n = de(null != t.value ? t.value : n), e._wrapperState = {
                    initialChecked: i,
                    initialValue: n,
                    controlled: "checkbox" === t.type || "radio" === t.type ? null != t.checked : null != t.value
                };
            }
            function Le(e, t) {
                null != (t = t.checked) && q(e, "checked", t, !1);
            }
            function Ee(e, t) {
                Le(e, t);
                var n = de(t.value), i = t.type;
                if (null != n) "number" === i ? (0 === n && "" === e.value || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);
                else if ("submit" === i || "reset" === i) return void e.removeAttribute("value");
                t.hasOwnProperty("value") ? xe(e, t.type, n) : t.hasOwnProperty("defaultValue") && xe(e, t.type, de(t.defaultValue)), null == t.checked && null != t.defaultChecked && (e.defaultChecked = !!t.defaultChecked);
            }
            function Ce(e, t, n) {
                if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
                    var i = t.type;
                    if (!("submit" !== i && "reset" !== i || void 0 !== t.value && null !== t.value)) return;
                    t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
                }
                "" !== (n = e.name) && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, "" !== n && (e.name = n);
            }
            function xe(e, t, n) {
                "number" === t && e.ownerDocument.activeElement === e || (null == n ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
            }
            function pe(e, t) {
                return e = r({
                    children: void 0
                }, t), (t = function(e) {
                    var t = "";
                    return i.Children.forEach(e, function(e) {
                        null != e && (t += e);
                    }), t;
                }(t.children)) && (e.children = t), e;
            }
            function Se(e, t, n, i) {
                if (e = e.options, t) {
                    t = {};
                    for(var r = 0; r < n.length; r++)t["$" + n[r]] = !0;
                    for(n = 0; n < e.length; n++)r = t.hasOwnProperty("$" + e[n].value), e[n].selected !== r && (e[n].selected = r), r && i && (e[n].defaultSelected = !0);
                } else {
                    for(n = "" + de(n), t = null, r = 0; r < e.length; r++){
                        if (e[r].value === n) return e[r].selected = !0, void (i && (e[r].defaultSelected = !0));
                        null !== t || e[r].disabled || (t = e[r]);
                    }
                    null !== t && (t.selected = !0);
                }
            }
            function me(e, t) {
                if (null != t.dangerouslySetInnerHTML) throw Error(u(91));
                return r({}, t, {
                    value: void 0,
                    defaultValue: void 0,
                    children: "" + e._wrapperState.initialValue
                });
            }
            function Oe(e, t) {
                var n = t.value;
                if (null == n) {
                    if (n = t.children, t = t.defaultValue, null != n) {
                        if (null != t) throw Error(u(92));
                        if (Array.isArray(n)) {
                            if (!(1 >= n.length)) throw Error(u(93));
                            n = n[0];
                        }
                        t = n;
                    }
                    null == t && (t = ""), n = t;
                }
                e._wrapperState = {
                    initialValue: de(n)
                };
            }
            function ve(e, t) {
                var n = de(t.value), i = de(t.defaultValue);
                null != n && ((n = "" + n) !== e.value && (e.value = n), null == t.defaultValue && e.defaultValue !== n && (e.defaultValue = n)), null != i && (e.defaultValue = "" + i);
            }
            function be(e) {
                var t = e.textContent;
                t === e._wrapperState.initialValue && "" !== t && null !== t && (e.value = t);
            }
            var he = "http://www.w3.org/1999/xhtml", ke = "http://www.w3.org/2000/svg";
            function Qe(e) {
                switch(e){
                    case "svg":
                        return "http://www.w3.org/2000/svg";
                    case "math":
                        return "http://www.w3.org/1998/Math/MathML";
                    default:
                        return "http://www.w3.org/1999/xhtml";
                }
            }
            function Ye(e, t) {
                return null == e || "http://www.w3.org/1999/xhtml" === e ? Qe(t) : "http://www.w3.org/2000/svg" === e && "foreignObject" === t ? "http://www.w3.org/1999/xhtml" : e;
            }
            var Pe, Ue = function(e) {
                return "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function(t, n, i, r) {
                    MSApp.execUnsafeLocalFunction(function() {
                        return e(t, n);
                    });
                } : e;
            }(function(e, t) {
                if (e.namespaceURI !== ke || "innerHTML" in e) e.innerHTML = t;
                else {
                    for((Pe = Pe || document.createElement("div")).innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = Pe.firstChild; e.firstChild;)e.removeChild(e.firstChild);
                    for(; t.firstChild;)e.appendChild(t.firstChild);
                }
            });
            function Ze(e, t) {
                if (t) {
                    var n = e.firstChild;
                    if (n && n === e.lastChild && 3 === n.nodeType) return void (n.nodeValue = t);
                }
                e.textContent = t;
            }
            function Ge(e, t) {
                var n = {};
                return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
            }
            var Be = {
                animationend: Ge("Animation", "AnimationEnd"),
                animationiteration: Ge("Animation", "AnimationIteration"),
                animationstart: Ge("Animation", "AnimationStart"),
                transitionend: Ge("Transition", "TransitionEnd")
            }, Re = {}, We = {};
            function He(e) {
                if (Re[e]) return Re[e];
                if (!Be[e]) return e;
                var t, n = Be[e];
                for(t in n)if (n.hasOwnProperty(t) && t in We) return Re[e] = n[t];
                return e;
            }
            x && (We = document.createElement("div").style, "AnimationEvent" in window || (delete Be.animationend.animation, delete Be.animationiteration.animation, delete Be.animationstart.animation), "TransitionEvent" in window || delete Be.transitionend.transition);
            var Ve = He("animationend"), Je = He("animationiteration"), Fe = He("animationstart"), Xe = He("transitionend"), Ke = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), qe = new ("function" == typeof WeakMap ? WeakMap : Map);
            function _e(e) {
                var t = qe.get(e);
                return void 0 === t && (t = new Map, qe.set(e, t)), t;
            }
            function $e(e) {
                var t = e, n = e;
                if (e.alternate) for(; t.return;)t = t.return;
                else {
                    e = t;
                    do 0 != (1026 & (t = e).effectTag) && (n = t.return), e = t.return;
                    while (e);
                }
                return 3 === t.tag ? n : null;
            }
            function et(e) {
                if (13 === e.tag) {
                    var t = e.memoizedState;
                    if (null === t && null !== (e = e.alternate) && (t = e.memoizedState), null !== t) return t.dehydrated;
                }
                return null;
            }
            function tt(e) {
                if ($e(e) !== e) throw Error(u(188));
            }
            function nt(e) {
                if (!(e = function(e) {
                    var t = e.alternate;
                    if (!t) {
                        if (null === (t = $e(e))) throw Error(u(188));
                        return t !== e ? null : e;
                    }
                    for(var n = e, i = t;;){
                        var r = n.return;
                        if (null === r) break;
                        var M = r.alternate;
                        if (null === M) {
                            if (null !== (i = r.return)) {
                                n = i;
                                continue;
                            }
                            break;
                        }
                        if (r.child === M.child) {
                            for(M = r.child; M;){
                                if (M === n) return tt(r), e;
                                if (M === i) return tt(r), t;
                                M = M.sibling;
                            }
                            throw Error(u(188));
                        }
                        if (n.return !== i.return) n = r, i = M;
                        else {
                            for(var o = !1, c = r.child; c;){
                                if (c === n) {
                                    o = !0, n = r, i = M;
                                    break;
                                }
                                if (c === i) {
                                    o = !0, i = r, n = M;
                                    break;
                                }
                                c = c.sibling;
                            }
                            if (!o) {
                                for(c = M.child; c;){
                                    if (c === n) {
                                        o = !0, n = M, i = r;
                                        break;
                                    }
                                    if (c === i) {
                                        o = !0, i = M, n = r;
                                        break;
                                    }
                                    c = c.sibling;
                                }
                                if (!o) throw Error(u(189));
                            }
                        }
                        if (n.alternate !== i) throw Error(u(190));
                    }
                    if (3 !== n.tag) throw Error(u(188));
                    return n.stateNode.current === n ? e : t;
                }(e))) return null;
                for(var t = e;;){
                    if (5 === t.tag || 6 === t.tag) return t;
                    if (t.child) t.child.return = t, t = t.child;
                    else {
                        if (t === e) break;
                        for(; !t.sibling;){
                            if (!t.return || t.return === e) return null;
                            t = t.return;
                        }
                        t.sibling.return = t.return, t = t.sibling;
                    }
                }
                return null;
            }
            function it(e, t) {
                if (null == t) throw Error(u(30));
                return null == e ? t : Array.isArray(e) ? Array.isArray(t) ? (e.push.apply(e, t), e) : (e.push(t), e) : Array.isArray(t) ? [
                    e
                ].concat(t) : [
                    e,
                    t
                ];
            }
            function rt(e, t, n) {
                Array.isArray(e) ? e.forEach(t, n) : e && t.call(n, e);
            }
            var Mt = null;
            function ut(e) {
                if (e) {
                    var t = e._dispatchListeners, n = e._dispatchInstances;
                    if (Array.isArray(t)) for(var i = 0; i < t.length && !e.isPropagationStopped(); i++)D(e, t[i], n[i]);
                    else t && D(e, t, n);
                    e._dispatchListeners = null, e._dispatchInstances = null, e.isPersistent() || e.constructor.release(e);
                }
            }
            function ot(e) {
                if (null !== e && (Mt = it(Mt, e)), e = Mt, Mt = null, e) {
                    if (rt(e, ut), Mt) throw Error(u(95));
                    if (I) throw e = l, I = !1, l = null, e;
                }
            }
            function ct(e) {
                return (e = e.target || e.srcElement || window).correspondingUseElement && (e = e.correspondingUseElement), 3 === e.nodeType ? e.parentNode : e;
            }
            function at(e) {
                if (!x) return !1;
                var t = (e = "on" + e) in document;
                return t || ((t = document.createElement("div")).setAttribute(e, "return;"), t = "function" == typeof t[e]), t;
            }
            var It = [];
            function lt(e) {
                e.topLevelType = null, e.nativeEvent = null, e.targetInst = null, e.ancestors.length = 0, 10 > It.length && It.push(e);
            }
            function Nt(e, t, n, i) {
                if (It.length) {
                    var r = It.pop();
                    return r.topLevelType = e, r.eventSystemFlags = i, r.nativeEvent = t, r.targetInst = n, r;
                }
                return {
                    topLevelType: e,
                    eventSystemFlags: i,
                    nativeEvent: t,
                    targetInst: n,
                    ancestors: []
                };
            }
            function jt(e) {
                var t = e.targetInst, n = t;
                do {
                    if (!n) {
                        e.ancestors.push(n);
                        break;
                    }
                    var i = n;
                    if (3 === i.tag) i = i.stateNode.containerInfo;
                    else {
                        for(; i.return;)i = i.return;
                        i = 3 !== i.tag ? null : i.stateNode.containerInfo;
                    }
                    if (!i) break;
                    5 !== (t = n.tag) && 6 !== t || e.ancestors.push(n), n = xn(i);
                }while (n);
                for(n = 0; n < e.ancestors.length; n++){
                    t = e.ancestors[n];
                    var r = ct(e.nativeEvent);
                    i = e.topLevelType;
                    var M = e.nativeEvent, u = e.eventSystemFlags;
                    0 === n && (u |= 64);
                    for(var o = null, c = 0; c < w.length; c++){
                        var a = w[c];
                        a && (a = a.extractEvents(i, t, M, r, u)) && (o = it(o, a));
                    }
                    ot(o);
                }
            }
            function gt(e, t, n) {
                if (!n.has(e)) {
                    switch(e){
                        case "scroll":
                            Ft(t, "scroll", !0);
                            break;
                        case "focus":
                        case "blur":
                            Ft(t, "focus", !0), Ft(t, "blur", !0), n.set("blur", null), n.set("focus", null);
                            break;
                        case "cancel":
                        case "close":
                            at(e) && Ft(t, e, !0);
                            break;
                        case "invalid":
                        case "submit":
                        case "reset":
                            break;
                        default:
                            -1 === Ke.indexOf(e) && Jt(e, t);
                    }
                    n.set(e, null);
                }
            }
            var st, At, Dt, dt = !1, Tt = [], yt = null, zt = null, wt = null, ft = new Map, Lt = new Map, Et = [], Ct = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), xt = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
            function pt(e, t, n, i, r) {
                return {
                    blockedOn: e,
                    topLevelType: t,
                    eventSystemFlags: 32 | n,
                    nativeEvent: r,
                    container: i
                };
            }
            function St(e, t) {
                switch(e){
                    case "focus":
                    case "blur":
                        yt = null;
                        break;
                    case "dragenter":
                    case "dragleave":
                        zt = null;
                        break;
                    case "mouseover":
                    case "mouseout":
                        wt = null;
                        break;
                    case "pointerover":
                    case "pointerout":
                        ft.delete(t.pointerId);
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                        Lt.delete(t.pointerId);
                }
            }
            function mt(e, t, n, i, r, M) {
                return null === e || e.nativeEvent !== M ? (e = pt(t, n, i, r, M), null !== t && null !== (t = pn(t)) && At(t), e) : (e.eventSystemFlags |= i, e);
            }
            function Ot(e) {
                var t = xn(e.target);
                if (null !== t) {
                    var n = $e(t);
                    if (null !== n) {
                        if (13 === (t = n.tag)) {
                            if (null !== (t = et(n))) return e.blockedOn = t, void M.unstable_runWithPriority(e.priority, function() {
                                Dt(n);
                            });
                        } else if (3 === t && n.stateNode.hydrate) return void (e.blockedOn = 3 === n.tag ? n.stateNode.containerInfo : null);
                    }
                }
                e.blockedOn = null;
            }
            function vt(e) {
                if (null !== e.blockedOn) return !1;
                var t = _t(e.topLevelType, e.eventSystemFlags, e.container, e.nativeEvent);
                if (null !== t) {
                    var n = pn(t);
                    return null !== n && At(n), e.blockedOn = t, !1;
                }
                return !0;
            }
            function bt(e, t, n) {
                vt(e) && n.delete(t);
            }
            function ht() {
                for(dt = !1; 0 < Tt.length;){
                    var e = Tt[0];
                    if (null !== e.blockedOn) {
                        null !== (e = pn(e.blockedOn)) && st(e);
                        break;
                    }
                    var t = _t(e.topLevelType, e.eventSystemFlags, e.container, e.nativeEvent);
                    null !== t ? e.blockedOn = t : Tt.shift();
                }
                null !== yt && vt(yt) && (yt = null), null !== zt && vt(zt) && (zt = null), null !== wt && vt(wt) && (wt = null), ft.forEach(bt), Lt.forEach(bt);
            }
            function kt(e, t) {
                e.blockedOn === t && (e.blockedOn = null, dt || (dt = !0, M.unstable_scheduleCallback(M.unstable_NormalPriority, ht)));
            }
            function Qt(e) {
                function t(t) {
                    return kt(t, e);
                }
                if (0 < Tt.length) {
                    kt(Tt[0], e);
                    for(var n = 1; n < Tt.length; n++){
                        var i = Tt[n];
                        i.blockedOn === e && (i.blockedOn = null);
                    }
                }
                for(null !== yt && kt(yt, e), null !== zt && kt(zt, e), null !== wt && kt(wt, e), ft.forEach(t), Lt.forEach(t), n = 0; n < Et.length; n++)(i = Et[n]).blockedOn === e && (i.blockedOn = null);
                for(; 0 < Et.length && null === (n = Et[0]).blockedOn;)Ot(n), null === n.blockedOn && Et.shift();
            }
            var Yt = {}, Pt = new Map, Ut = new Map, Zt = [
                "abort",
                "abort",
                Ve,
                "animationEnd",
                Je,
                "animationIteration",
                Fe,
                "animationStart",
                "canplay",
                "canPlay",
                "canplaythrough",
                "canPlayThrough",
                "durationchange",
                "durationChange",
                "emptied",
                "emptied",
                "encrypted",
                "encrypted",
                "ended",
                "ended",
                "error",
                "error",
                "gotpointercapture",
                "gotPointerCapture",
                "load",
                "load",
                "loadeddata",
                "loadedData",
                "loadedmetadata",
                "loadedMetadata",
                "loadstart",
                "loadStart",
                "lostpointercapture",
                "lostPointerCapture",
                "playing",
                "playing",
                "progress",
                "progress",
                "seeking",
                "seeking",
                "stalled",
                "stalled",
                "suspend",
                "suspend",
                "timeupdate",
                "timeUpdate",
                Xe,
                "transitionEnd",
                "waiting",
                "waiting"
            ];
            function Gt(e, t) {
                for(var n = 0; n < e.length; n += 2){
                    var i = e[n], r = e[n + 1], M = "on" + (r[0].toUpperCase() + r.slice(1));
                    M = {
                        phasedRegistrationNames: {
                            bubbled: M,
                            captured: M + "Capture"
                        },
                        dependencies: [
                            i
                        ],
                        eventPriority: t
                    }, Ut.set(i, t), Pt.set(i, M), Yt[r] = M;
                }
            }
            Gt("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0), Gt("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1), Gt(Zt, 2);
            for(var Bt = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), Rt = 0; Rt < Bt.length; Rt++)Ut.set(Bt[Rt], 0);
            var Wt = M.unstable_UserBlockingPriority, Ht = M.unstable_runWithPriority, Vt = !0;
            function Jt(e, t) {
                Ft(t, e, !1);
            }
            function Ft(e, t, n) {
                var i = Ut.get(t);
                switch(void 0 === i ? 2 : i){
                    case 0:
                        i = Xt.bind(null, t, 1, e);
                        break;
                    case 1:
                        i = Kt.bind(null, t, 1, e);
                        break;
                    default:
                        i = qt.bind(null, t, 1, e);
                }
                n ? e.addEventListener(t, i, !0) : e.addEventListener(t, i, !1);
            }
            function Xt(e, t, n, i) {
                P || Q();
                var r = qt, M = P;
                P = !0;
                try {
                    k(r, e, t, n, i);
                } finally{
                    (P = M) || Z();
                }
            }
            function Kt(e, t, n, i) {
                Ht(Wt, qt.bind(null, e, t, n, i));
            }
            function qt(e, t, n, i) {
                if (Vt) {
                    if (0 < Tt.length && -1 < Ct.indexOf(e)) e = pt(null, e, t, n, i), Tt.push(e);
                    else {
                        var r = _t(e, t, n, i);
                        if (null === r) St(e, i);
                        else if (-1 < Ct.indexOf(e)) e = pt(r, e, t, n, i), Tt.push(e);
                        else if (!function(e, t, n, i, r) {
                            switch(t){
                                case "focus":
                                    return yt = mt(yt, e, t, n, i, r), !0;
                                case "dragenter":
                                    return zt = mt(zt, e, t, n, i, r), !0;
                                case "mouseover":
                                    return wt = mt(wt, e, t, n, i, r), !0;
                                case "pointerover":
                                    var M = r.pointerId;
                                    return ft.set(M, mt(ft.get(M) || null, e, t, n, i, r)), !0;
                                case "gotpointercapture":
                                    return M = r.pointerId, Lt.set(M, mt(Lt.get(M) || null, e, t, n, i, r)), !0;
                            }
                            return !1;
                        }(r, e, t, n, i)) {
                            St(e, i), e = Nt(e, i, null, t);
                            try {
                                G(jt, e);
                            } finally{
                                lt(e);
                            }
                        }
                    }
                }
            }
            function _t(e, t, n, i) {
                if (null !== (n = xn(n = ct(i)))) {
                    var r = $e(n);
                    if (null === r) n = null;
                    else {
                        var M = r.tag;
                        if (13 === M) {
                            if (null !== (n = et(r))) return n;
                            n = null;
                        } else if (3 === M) {
                            if (r.stateNode.hydrate) return 3 === r.tag ? r.stateNode.containerInfo : null;
                            n = null;
                        } else r !== n && (n = null);
                    }
                }
                e = Nt(e, i, n, t);
                try {
                    G(jt, e);
                } finally{
                    lt(e);
                }
                return null;
            }
            var $t = {
                animationIterationCount: !0,
                borderImageOutset: !0,
                borderImageSlice: !0,
                borderImageWidth: !0,
                boxFlex: !0,
                boxFlexGroup: !0,
                boxOrdinalGroup: !0,
                columnCount: !0,
                columns: !0,
                flex: !0,
                flexGrow: !0,
                flexPositive: !0,
                flexShrink: !0,
                flexNegative: !0,
                flexOrder: !0,
                gridArea: !0,
                gridRow: !0,
                gridRowEnd: !0,
                gridRowSpan: !0,
                gridRowStart: !0,
                gridColumn: !0,
                gridColumnEnd: !0,
                gridColumnSpan: !0,
                gridColumnStart: !0,
                fontWeight: !0,
                lineClamp: !0,
                lineHeight: !0,
                opacity: !0,
                order: !0,
                orphans: !0,
                tabSize: !0,
                widows: !0,
                zIndex: !0,
                zoom: !0,
                fillOpacity: !0,
                floodOpacity: !0,
                stopOpacity: !0,
                strokeDasharray: !0,
                strokeDashoffset: !0,
                strokeMiterlimit: !0,
                strokeOpacity: !0,
                strokeWidth: !0
            }, en = [
                "Webkit",
                "ms",
                "Moz",
                "O"
            ];
            function tn(e, t, n) {
                return null == t || "boolean" == typeof t || "" === t ? "" : n || "number" != typeof t || 0 === t || $t.hasOwnProperty(e) && $t[e] ? ("" + t).trim() : t + "px";
            }
            function nn(e, t) {
                for(var n in e = e.style, t)if (t.hasOwnProperty(n)) {
                    var i = 0 === n.indexOf("--"), r = tn(n, t[n], i);
                    "float" === n && (n = "cssFloat"), i ? e.setProperty(n, r) : e[n] = r;
                }
            }
            Object.keys($t).forEach(function(e) {
                en.forEach(function(t) {
                    t = t + e.charAt(0).toUpperCase() + e.substring(1), $t[t] = $t[e];
                });
            });
            var rn = r({
                menuitem: !0
            }, {
                area: !0,
                base: !0,
                br: !0,
                col: !0,
                embed: !0,
                hr: !0,
                img: !0,
                input: !0,
                keygen: !0,
                link: !0,
                meta: !0,
                param: !0,
                source: !0,
                track: !0,
                wbr: !0
            });
            function Mn(e, t) {
                if (t) {
                    if (rn[e] && (null != t.children || null != t.dangerouslySetInnerHTML)) throw Error(u(137, e, ""));
                    if (null != t.dangerouslySetInnerHTML) {
                        if (null != t.children) throw Error(u(60));
                        if ("object" != typeof t.dangerouslySetInnerHTML || !("__html" in t.dangerouslySetInnerHTML)) throw Error(u(61));
                    }
                    if (null != t.style && "object" != typeof t.style) throw Error(u(62, ""));
                }
            }
            function un(e, t) {
                if (-1 === e.indexOf("-")) return "string" == typeof t.is;
                switch(e){
                    case "annotation-xml":
                    case "color-profile":
                    case "font-face":
                    case "font-face-src":
                    case "font-face-uri":
                    case "font-face-format":
                    case "font-face-name":
                    case "missing-glyph":
                        return !1;
                    default:
                        return !0;
                }
            }
            var on = he;
            function cn(e, t) {
                var n = _e(e = 9 === e.nodeType || 11 === e.nodeType ? e : e.ownerDocument);
                t = E[t];
                for(var i = 0; i < t.length; i++)gt(t[i], e, n);
            }
            function an() {}
            function In(e) {
                if (void 0 === (e = e || ("undefined" != typeof document ? document : void 0))) return null;
                try {
                    return e.activeElement || e.body;
                } catch (t) {
                    return e.body;
                }
            }
            function ln(e) {
                for(; e && e.firstChild;)e = e.firstChild;
                return e;
            }
            function Nn(e, t) {
                var n, i = ln(e);
                for(e = 0; i;){
                    if (3 === i.nodeType) {
                        if (n = e + i.textContent.length, e <= t && n >= t) return {
                            node: i,
                            offset: t - e
                        };
                        e = n;
                    }
                    e: {
                        for(; i;){
                            if (i.nextSibling) {
                                i = i.nextSibling;
                                break e;
                            }
                            i = i.parentNode;
                        }
                        i = void 0;
                    }
                    i = ln(i);
                }
            }
            function jn() {
                for(var e = window, t = In(); t instanceof e.HTMLIFrameElement;){
                    try {
                        var n = "string" == typeof t.contentWindow.location.href;
                    } catch (e) {
                        n = !1;
                    }
                    if (!n) break;
                    t = In((e = t.contentWindow).document);
                }
                return t;
            }
            function gn(e) {
                var t = e && e.nodeName && e.nodeName.toLowerCase();
                return t && ("input" === t && ("text" === e.type || "search" === e.type || "tel" === e.type || "url" === e.type || "password" === e.type) || "textarea" === t || "true" === e.contentEditable);
            }
            var sn = null, An = null;
            function Dn(e, t) {
                switch(e){
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                        return !!t.autoFocus;
                }
                return !1;
            }
            function dn(e, t) {
                return "textarea" === e || "option" === e || "noscript" === e || "string" == typeof t.children || "number" == typeof t.children || "object" == typeof t.dangerouslySetInnerHTML && null !== t.dangerouslySetInnerHTML && null != t.dangerouslySetInnerHTML.__html;
            }
            var Tn = "function" == typeof setTimeout ? setTimeout : void 0, yn = "function" == typeof clearTimeout ? clearTimeout : void 0;
            function zn(e) {
                for(; null != e; e = e.nextSibling){
                    var t = e.nodeType;
                    if (1 === t || 3 === t) break;
                }
                return e;
            }
            function wn(e) {
                e = e.previousSibling;
                for(var t = 0; e;){
                    if (8 === e.nodeType) {
                        var n = e.data;
                        if ("$" === n || "$!" === n || "$?" === n) {
                            if (0 === t) return e;
                            t--;
                        } else "/$" === n && t++;
                    }
                    e = e.previousSibling;
                }
                return null;
            }
            var fn = Math.random().toString(36).slice(2), Ln = "__reactInternalInstance$" + fn, En = "__reactEventHandlers$" + fn, Cn = "__reactContainere$" + fn;
            function xn(e) {
                var t = e[Ln];
                if (t) return t;
                for(var n = e.parentNode; n;){
                    if (t = n[Cn] || n[Ln]) {
                        if (n = t.alternate, null !== t.child || null !== n && null !== n.child) for(e = wn(e); null !== e;){
                            if (n = e[Ln]) return n;
                            e = wn(e);
                        }
                        return t;
                    }
                    n = (e = n).parentNode;
                }
                return null;
            }
            function pn(e) {
                return !(e = e[Ln] || e[Cn]) || 5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag ? null : e;
            }
            function Sn(e) {
                if (5 === e.tag || 6 === e.tag) return e.stateNode;
                throw Error(u(33));
            }
            function mn(e) {
                return e[En] || null;
            }
            function On(e) {
                do e = e.return;
                while (e && 5 !== e.tag);
                return e || null;
            }
            function vn(e, t) {
                var n = e.stateNode;
                if (!n) return null;
                var i = g(n);
                if (!i) return null;
                n = i[t];
                e: switch(t){
                    case "onClick":
                    case "onClickCapture":
                    case "onDoubleClick":
                    case "onDoubleClickCapture":
                    case "onMouseDown":
                    case "onMouseDownCapture":
                    case "onMouseMove":
                    case "onMouseMoveCapture":
                    case "onMouseUp":
                    case "onMouseUpCapture":
                    case "onMouseEnter":
                        (i = !i.disabled) || (i = !("button" === (e = e.type) || "input" === e || "select" === e || "textarea" === e)), e = !i;
                        break e;
                    default:
                        e = !1;
                }
                if (e) return null;
                if (n && "function" != typeof n) throw Error(u(231, t, typeof n));
                return n;
            }
            function bn(e, t, n) {
                (t = vn(e, n.dispatchConfig.phasedRegistrationNames[t])) && (n._dispatchListeners = it(n._dispatchListeners, t), n._dispatchInstances = it(n._dispatchInstances, e));
            }
            function hn(e) {
                if (e && e.dispatchConfig.phasedRegistrationNames) {
                    for(var t = e._targetInst, n = []; t;)n.push(t), t = On(t);
                    for(t = n.length; 0 < t--;)bn(n[t], "captured", e);
                    for(t = 0; t < n.length; t++)bn(n[t], "bubbled", e);
                }
            }
            function kn(e, t, n) {
                e && n && n.dispatchConfig.registrationName && (t = vn(e, n.dispatchConfig.registrationName)) && (n._dispatchListeners = it(n._dispatchListeners, t), n._dispatchInstances = it(n._dispatchInstances, e));
            }
            function Qn(e) {
                e && e.dispatchConfig.registrationName && kn(e._targetInst, null, e);
            }
            function Yn(e) {
                rt(e, hn);
            }
            var Pn = null, Un = null, Zn = null;
            function Gn() {
                if (Zn) return Zn;
                var e, t, n = Un, i = n.length, r = "value" in Pn ? Pn.value : Pn.textContent, M = r.length;
                for(e = 0; e < i && n[e] === r[e]; e++);
                var u = i - e;
                for(t = 1; t <= u && n[i - t] === r[M - t]; t++);
                return Zn = r.slice(e, 1 < t ? 1 - t : void 0);
            }
            function Bn() {
                return !0;
            }
            function Rn() {
                return !1;
            }
            function Wn(e, t, n, i) {
                for(var r in this.dispatchConfig = e, this._targetInst = t, this.nativeEvent = n, e = this.constructor.Interface)e.hasOwnProperty(r) && ((t = e[r]) ? this[r] = t(n) : "target" === r ? this.target = i : this[r] = n[r]);
                return this.isDefaultPrevented = (null != n.defaultPrevented ? n.defaultPrevented : !1 === n.returnValue) ? Bn : Rn, this.isPropagationStopped = Rn, this;
            }
            function Hn(e, t, n, i) {
                if (this.eventPool.length) {
                    var r = this.eventPool.pop();
                    return this.call(r, e, t, n, i), r;
                }
                return new this(e, t, n, i);
            }
            function Vn(e) {
                if (!(e instanceof this)) throw Error(u(279));
                e.destructor(), 10 > this.eventPool.length && this.eventPool.push(e);
            }
            function Jn(e) {
                e.eventPool = [], e.getPooled = Hn, e.release = Vn;
            }
            r(Wn.prototype, {
                preventDefault: function() {
                    this.defaultPrevented = !0;
                    var e = this.nativeEvent;
                    e && (e.preventDefault ? e.preventDefault() : "unknown" != typeof e.returnValue && (e.returnValue = !1), this.isDefaultPrevented = Bn);
                },
                stopPropagation: function() {
                    var e = this.nativeEvent;
                    e && (e.stopPropagation ? e.stopPropagation() : "unknown" != typeof e.cancelBubble && (e.cancelBubble = !0), this.isPropagationStopped = Bn);
                },
                persist: function() {
                    this.isPersistent = Bn;
                },
                isPersistent: Rn,
                destructor: function() {
                    var e, t = this.constructor.Interface;
                    for(e in t)this[e] = null;
                    this.nativeEvent = this._targetInst = this.dispatchConfig = null, this.isPropagationStopped = this.isDefaultPrevented = Rn, this._dispatchInstances = this._dispatchListeners = null;
                }
            }), Wn.Interface = {
                type: null,
                target: null,
                currentTarget: function() {
                    return null;
                },
                eventPhase: null,
                bubbles: null,
                cancelable: null,
                timeStamp: function(e) {
                    return e.timeStamp || Date.now();
                },
                defaultPrevented: null,
                isTrusted: null
            }, Wn.extend = function(e) {
                function t() {}
                function n() {
                    return i.apply(this, arguments);
                }
                var i = this;
                t.prototype = i.prototype;
                var M = new t;
                return r(M, n.prototype), n.prototype = M, n.prototype.constructor = n, n.Interface = r({}, i.Interface, e), n.extend = i.extend, Jn(n), n;
            }, Jn(Wn);
            var Fn = Wn.extend({
                data: null
            }), Xn = Wn.extend({
                data: null
            }), Kn = [
                9,
                13,
                27,
                32
            ], qn = x && "CompositionEvent" in window, _n = null;
            x && "documentMode" in document && (_n = document.documentMode);
            var $n = x && "TextEvent" in window && !_n, ei = x && (!qn || _n && 8 < _n && 11 >= _n), ti = String.fromCharCode(32), ni = {
                beforeInput: {
                    phasedRegistrationNames: {
                        bubbled: "onBeforeInput",
                        captured: "onBeforeInputCapture"
                    },
                    dependencies: [
                        "compositionend",
                        "keypress",
                        "textInput",
                        "paste"
                    ]
                },
                compositionEnd: {
                    phasedRegistrationNames: {
                        bubbled: "onCompositionEnd",
                        captured: "onCompositionEndCapture"
                    },
                    dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
                },
                compositionStart: {
                    phasedRegistrationNames: {
                        bubbled: "onCompositionStart",
                        captured: "onCompositionStartCapture"
                    },
                    dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
                },
                compositionUpdate: {
                    phasedRegistrationNames: {
                        bubbled: "onCompositionUpdate",
                        captured: "onCompositionUpdateCapture"
                    },
                    dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
                }
            }, ii = !1;
            function ri(e, t) {
                switch(e){
                    case "keyup":
                        return -1 !== Kn.indexOf(t.keyCode);
                    case "keydown":
                        return 229 !== t.keyCode;
                    case "keypress":
                    case "mousedown":
                    case "blur":
                        return !0;
                    default:
                        return !1;
                }
            }
            function Mi(e) {
                return "object" == typeof (e = e.detail) && "data" in e ? e.data : null;
            }
            var ui = !1;
            var oi = {
                eventTypes: ni,
                extractEvents: function(e, t, n, i) {
                    var r;
                    if (qn) e: {
                        switch(e){
                            case "compositionstart":
                                var M = ni.compositionStart;
                                break e;
                            case "compositionend":
                                M = ni.compositionEnd;
                                break e;
                            case "compositionupdate":
                                M = ni.compositionUpdate;
                                break e;
                        }
                        M = void 0;
                    }
                    else ui ? ri(e, n) && (M = ni.compositionEnd) : "keydown" === e && 229 === n.keyCode && (M = ni.compositionStart);
                    return M ? (ei && "ko" !== n.locale && (ui || M !== ni.compositionStart ? M === ni.compositionEnd && ui && (r = Gn()) : (Un = "value" in (Pn = i) ? Pn.value : Pn.textContent, ui = !0)), M = Fn.getPooled(M, t, n, i), r ? M.data = r : null !== (r = Mi(n)) && (M.data = r), Yn(M), r = M) : r = null, (e = $n ? function(e, t) {
                        switch(e){
                            case "compositionend":
                                return Mi(t);
                            case "keypress":
                                return 32 !== t.which ? null : (ii = !0, ti);
                            case "textInput":
                                return (e = t.data) === ti && ii ? null : e;
                            default:
                                return null;
                        }
                    }(e, n) : function(e, t) {
                        if (ui) return "compositionend" === e || !qn && ri(e, t) ? (e = Gn(), Zn = Un = Pn = null, ui = !1, e) : null;
                        switch(e){
                            case "paste":
                                return null;
                            case "keypress":
                                if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
                                    if (t.char && 1 < t.char.length) return t.char;
                                    if (t.which) return String.fromCharCode(t.which);
                                }
                                return null;
                            case "compositionend":
                                return ei && "ko" !== t.locale ? null : t.data;
                            default:
                                return null;
                        }
                    }(e, n)) ? ((t = Xn.getPooled(ni.beforeInput, t, n, i)).data = e, Yn(t)) : t = null, null === r ? t : null === t ? r : [
                        r,
                        t
                    ];
                }
            }, ci = {
                color: !0,
                date: !0,
                datetime: !0,
                "datetime-local": !0,
                email: !0,
                month: !0,
                number: !0,
                password: !0,
                range: !0,
                search: !0,
                tel: !0,
                text: !0,
                time: !0,
                url: !0,
                week: !0
            };
            function ai(e) {
                var t = e && e.nodeName && e.nodeName.toLowerCase();
                return "input" === t ? !!ci[e.type] : "textarea" === t;
            }
            var Ii = {
                change: {
                    phasedRegistrationNames: {
                        bubbled: "onChange",
                        captured: "onChangeCapture"
                    },
                    dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
                }
            };
            function li(e, t, n) {
                return (e = Wn.getPooled(Ii.change, e, t, n)).type = "change", v(n), Yn(e), e;
            }
            var Ni = null, ji = null;
            function gi(e) {
                ot(e);
            }
            function si(e) {
                if (ze(Sn(e))) return e;
            }
            function Ai(e, t) {
                if ("change" === e) return t;
            }
            var Di = !1;
            function di() {
                Ni && (Ni.detachEvent("onpropertychange", Ti), ji = Ni = null);
            }
            function Ti(e) {
                if ("value" === e.propertyName && si(ji)) {
                    if (e = li(ji, e, ct(e)), P) ot(e);
                    else {
                        P = !0;
                        try {
                            h(gi, e);
                        } finally{
                            P = !1, Z();
                        }
                    }
                }
            }
            function yi(e, t, n) {
                "focus" === e ? (di(), ji = n, (Ni = t).attachEvent("onpropertychange", Ti)) : "blur" === e && di();
            }
            function zi(e) {
                if ("selectionchange" === e || "keyup" === e || "keydown" === e) return si(ji);
            }
            function wi(e, t) {
                if ("click" === e) return si(t);
            }
            function fi(e, t) {
                if ("input" === e || "change" === e) return si(t);
            }
            x && (Di = at("input") && (!document.documentMode || 9 < document.documentMode));
            var Li = {
                eventTypes: Ii,
                _isInputEventSupported: Di,
                extractEvents: function(e, t, n, i) {
                    var r = t ? Sn(t) : window, M = r.nodeName && r.nodeName.toLowerCase();
                    if ("select" === M || "input" === M && "file" === r.type) var u = Ai;
                    else if (ai(r)) {
                        if (Di) u = fi;
                        else {
                            u = zi;
                            var o = yi;
                        }
                    } else (M = r.nodeName) && "input" === M.toLowerCase() && ("checkbox" === r.type || "radio" === r.type) && (u = wi);
                    if (u && (u = u(e, t))) return li(u, n, i);
                    o && o(e, r, t), "blur" === e && (e = r._wrapperState) && e.controlled && "number" === r.type && xe(r, "number", r.value);
                }
            }, Ei = Wn.extend({
                view: null,
                detail: null
            }), Ci = {
                Alt: "altKey",
                Control: "ctrlKey",
                Meta: "metaKey",
                Shift: "shiftKey"
            };
            function xi(e) {
                var t = this.nativeEvent;
                return t.getModifierState ? t.getModifierState(e) : !!(e = Ci[e]) && !!t[e];
            }
            function pi() {
                return xi;
            }
            var Si = 0, mi = 0, Oi = !1, vi = !1, bi = Ei.extend({
                screenX: null,
                screenY: null,
                clientX: null,
                clientY: null,
                pageX: null,
                pageY: null,
                ctrlKey: null,
                shiftKey: null,
                altKey: null,
                metaKey: null,
                getModifierState: pi,
                button: null,
                buttons: null,
                relatedTarget: function(e) {
                    return e.relatedTarget || (e.fromElement === e.srcElement ? e.toElement : e.fromElement);
                },
                movementX: function(e) {
                    if ("movementX" in e) return e.movementX;
                    var t = Si;
                    return Si = e.screenX, Oi ? "mousemove" === e.type ? e.screenX - t : 0 : (Oi = !0, 0);
                },
                movementY: function(e) {
                    if ("movementY" in e) return e.movementY;
                    var t = mi;
                    return mi = e.screenY, vi ? "mousemove" === e.type ? e.screenY - t : 0 : (vi = !0, 0);
                }
            }), hi = bi.extend({
                pointerId: null,
                width: null,
                height: null,
                pressure: null,
                tangentialPressure: null,
                tiltX: null,
                tiltY: null,
                twist: null,
                pointerType: null,
                isPrimary: null
            }), ki = {
                mouseEnter: {
                    registrationName: "onMouseEnter",
                    dependencies: [
                        "mouseout",
                        "mouseover"
                    ]
                },
                mouseLeave: {
                    registrationName: "onMouseLeave",
                    dependencies: [
                        "mouseout",
                        "mouseover"
                    ]
                },
                pointerEnter: {
                    registrationName: "onPointerEnter",
                    dependencies: [
                        "pointerout",
                        "pointerover"
                    ]
                },
                pointerLeave: {
                    registrationName: "onPointerLeave",
                    dependencies: [
                        "pointerout",
                        "pointerover"
                    ]
                }
            }, Qi = {
                eventTypes: ki,
                extractEvents: function(e, t, n, i, r) {
                    var M = "mouseover" === e || "pointerover" === e, u = "mouseout" === e || "pointerout" === e;
                    if (M && 0 == (32 & r) && (n.relatedTarget || n.fromElement) || !u && !M) return null;
                    (M = i.window === i ? i : (M = i.ownerDocument) ? M.defaultView || M.parentWindow : window, u) ? (u = t, null !== (t = (t = n.relatedTarget || n.toElement) ? xn(t) : null) && (t !== $e(t) || 5 !== t.tag && 6 !== t.tag) && (t = null)) : u = null;
                    if (u === t) return null;
                    if ("mouseout" === e || "mouseover" === e) var o = bi, c = ki.mouseLeave, a = ki.mouseEnter, I = "mouse";
                    else "pointerout" !== e && "pointerover" !== e || (o = hi, c = ki.pointerLeave, a = ki.pointerEnter, I = "pointer");
                    if (e = null == u ? M : Sn(u), M = null == t ? M : Sn(t), (c = o.getPooled(c, u, n, i)).type = I + "leave", c.target = e, c.relatedTarget = M, (n = o.getPooled(a, t, n, i)).type = I + "enter", n.target = M, n.relatedTarget = e, I = t, (i = u) && I) e: {
                        for(a = I, u = 0, e = o = i; e; e = On(e))u++;
                        for(e = 0, t = a; t; t = On(t))e++;
                        for(; 0 < u - e;)o = On(o), u--;
                        for(; 0 < e - u;)a = On(a), e--;
                        for(; u--;){
                            if (o === a || o === a.alternate) break e;
                            o = On(o), a = On(a);
                        }
                        o = null;
                    }
                    else o = null;
                    for(a = o, o = []; i && i !== a && (null === (u = i.alternate) || u !== a);)o.push(i), i = On(i);
                    for(i = []; I && I !== a && (null === (u = I.alternate) || u !== a);)i.push(I), I = On(I);
                    for(I = 0; I < o.length; I++)kn(o[I], "bubbled", c);
                    for(I = i.length; 0 < I--;)kn(i[I], "captured", n);
                    return 0 == (64 & r) ? [
                        c
                    ] : [
                        c,
                        n
                    ];
                }
            };
            var Yi = "function" == typeof Object.is ? Object.is : function(e, t) {
                return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
            }, Pi = Object.prototype.hasOwnProperty;
            function Ui(e, t) {
                if (Yi(e, t)) return !0;
                if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
                var n = Object.keys(e), i = Object.keys(t);
                if (n.length !== i.length) return !1;
                for(i = 0; i < n.length; i++)if (!Pi.call(t, n[i]) || !Yi(e[n[i]], t[n[i]])) return !1;
                return !0;
            }
            var Zi = x && "documentMode" in document && 11 >= document.documentMode, Gi = {
                select: {
                    phasedRegistrationNames: {
                        bubbled: "onSelect",
                        captured: "onSelectCapture"
                    },
                    dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
                }
            }, Bi = null, Ri = null, Wi = null, Hi = !1;
            function Vi(e, t) {
                var n = t.window === t ? t.document : 9 === t.nodeType ? t : t.ownerDocument;
                return Hi || null == Bi || Bi !== In(n) ? null : ("selectionStart" in (n = Bi) && gn(n) ? n = {
                    start: n.selectionStart,
                    end: n.selectionEnd
                } : n = {
                    anchorNode: (n = (n.ownerDocument && n.ownerDocument.defaultView || window).getSelection()).anchorNode,
                    anchorOffset: n.anchorOffset,
                    focusNode: n.focusNode,
                    focusOffset: n.focusOffset
                }, Wi && Ui(Wi, n) ? null : (Wi = n, (e = Wn.getPooled(Gi.select, Ri, e, t)).type = "select", e.target = Bi, Yn(e), e));
            }
            var Ji = {
                eventTypes: Gi,
                extractEvents: function(e, t, n, i, r, M) {
                    if (!(M = !(r = M || (i.window === i ? i.document : 9 === i.nodeType ? i : i.ownerDocument)))) {
                        e: {
                            r = _e(r), M = E.onSelect;
                            for(var u = 0; u < M.length; u++)if (!r.has(M[u])) {
                                r = !1;
                                break e;
                            }
                            r = !0;
                        }
                        M = !r;
                    }
                    if (M) return null;
                    switch(r = t ? Sn(t) : window, e){
                        case "focus":
                            (ai(r) || "true" === r.contentEditable) && (Bi = r, Ri = t, Wi = null);
                            break;
                        case "blur":
                            Wi = Ri = Bi = null;
                            break;
                        case "mousedown":
                            Hi = !0;
                            break;
                        case "contextmenu":
                        case "mouseup":
                        case "dragend":
                            return Hi = !1, Vi(n, i);
                        case "selectionchange":
                            if (Zi) break;
                        case "keydown":
                        case "keyup":
                            return Vi(n, i);
                    }
                    return null;
                }
            }, Fi = Wn.extend({
                animationName: null,
                elapsedTime: null,
                pseudoElement: null
            }), Xi = Wn.extend({
                clipboardData: function(e) {
                    return "clipboardData" in e ? e.clipboardData : window.clipboardData;
                }
            }), Ki = Ei.extend({
                relatedTarget: null
            });
            function qi(e) {
                var t = e.keyCode;
                return "charCode" in e ? 0 === (e = e.charCode) && 13 === t && (e = 13) : e = t, 10 === e && (e = 13), 32 <= e || 13 === e ? e : 0;
            }
            var _i = {
                Esc: "Escape",
                Spacebar: " ",
                Left: "ArrowLeft",
                Up: "ArrowUp",
                Right: "ArrowRight",
                Down: "ArrowDown",
                Del: "Delete",
                Win: "OS",
                Menu: "ContextMenu",
                Apps: "ContextMenu",
                Scroll: "ScrollLock",
                MozPrintableKey: "Unidentified"
            }, $i = {
                8: "Backspace",
                9: "Tab",
                12: "Clear",
                13: "Enter",
                16: "Shift",
                17: "Control",
                18: "Alt",
                19: "Pause",
                20: "CapsLock",
                27: "Escape",
                32: " ",
                33: "PageUp",
                34: "PageDown",
                35: "End",
                36: "Home",
                37: "ArrowLeft",
                38: "ArrowUp",
                39: "ArrowRight",
                40: "ArrowDown",
                45: "Insert",
                46: "Delete",
                112: "F1",
                113: "F2",
                114: "F3",
                115: "F4",
                116: "F5",
                117: "F6",
                118: "F7",
                119: "F8",
                120: "F9",
                121: "F10",
                122: "F11",
                123: "F12",
                144: "NumLock",
                145: "ScrollLock",
                224: "Meta"
            }, er = Ei.extend({
                key: function(e) {
                    if (e.key) {
                        var t = _i[e.key] || e.key;
                        if ("Unidentified" !== t) return t;
                    }
                    return "keypress" === e.type ? 13 === (e = qi(e)) ? "Enter" : String.fromCharCode(e) : "keydown" === e.type || "keyup" === e.type ? $i[e.keyCode] || "Unidentified" : "";
                },
                location: null,
                ctrlKey: null,
                shiftKey: null,
                altKey: null,
                metaKey: null,
                repeat: null,
                locale: null,
                getModifierState: pi,
                charCode: function(e) {
                    return "keypress" === e.type ? qi(e) : 0;
                },
                keyCode: function(e) {
                    return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
                },
                which: function(e) {
                    return "keypress" === e.type ? qi(e) : "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
                }
            }), tr = bi.extend({
                dataTransfer: null
            }), nr = Ei.extend({
                touches: null,
                targetTouches: null,
                changedTouches: null,
                altKey: null,
                metaKey: null,
                ctrlKey: null,
                shiftKey: null,
                getModifierState: pi
            }), ir = Wn.extend({
                propertyName: null,
                elapsedTime: null,
                pseudoElement: null
            }), rr = bi.extend({
                deltaX: function(e) {
                    return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
                },
                deltaY: function(e) {
                    return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
                },
                deltaZ: null,
                deltaMode: null
            }), Mr = {
                eventTypes: Yt,
                extractEvents: function(e, t, n, i) {
                    var r = Pt.get(e);
                    if (!r) return null;
                    switch(e){
                        case "keypress":
                            if (0 === qi(n)) return null;
                        case "keydown":
                        case "keyup":
                            e = er;
                            break;
                        case "blur":
                        case "focus":
                            e = Ki;
                            break;
                        case "click":
                            if (2 === n.button) return null;
                        case "auxclick":
                        case "dblclick":
                        case "mousedown":
                        case "mousemove":
                        case "mouseup":
                        case "mouseout":
                        case "mouseover":
                        case "contextmenu":
                            e = bi;
                            break;
                        case "drag":
                        case "dragend":
                        case "dragenter":
                        case "dragexit":
                        case "dragleave":
                        case "dragover":
                        case "dragstart":
                        case "drop":
                            e = tr;
                            break;
                        case "touchcancel":
                        case "touchend":
                        case "touchmove":
                        case "touchstart":
                            e = nr;
                            break;
                        case Ve:
                        case Je:
                        case Fe:
                            e = Fi;
                            break;
                        case Xe:
                            e = ir;
                            break;
                        case "scroll":
                            e = Ei;
                            break;
                        case "wheel":
                            e = rr;
                            break;
                        case "copy":
                        case "cut":
                        case "paste":
                            e = Xi;
                            break;
                        case "gotpointercapture":
                        case "lostpointercapture":
                        case "pointercancel":
                        case "pointerdown":
                        case "pointermove":
                        case "pointerout":
                        case "pointerover":
                        case "pointerup":
                            e = hi;
                            break;
                        default:
                            e = Wn;
                    }
                    return Yn(t = e.getPooled(r, t, n, i)), t;
                }
            };
            if (d) throw Error(u(101));
            d = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" ")), y(), g = mn, s = pn, A = Sn, C({
                SimpleEventPlugin: Mr,
                EnterLeaveEventPlugin: Qi,
                ChangeEventPlugin: Li,
                SelectEventPlugin: Ji,
                BeforeInputEventPlugin: oi
            });
            var ur = [], or = -1;
            function cr(e) {
                0 > or || (e.current = ur[or], ur[or] = null, or--);
            }
            function ar(e, t) {
                or++, ur[or] = e.current, e.current = t;
            }
            var Ir = {}, lr = {
                current: Ir
            }, Nr = {
                current: !1
            }, jr = Ir;
            function gr(e, t) {
                var n = e.type.contextTypes;
                if (!n) return Ir;
                var i = e.stateNode;
                if (i && i.__reactInternalMemoizedUnmaskedChildContext === t) return i.__reactInternalMemoizedMaskedChildContext;
                var r, M = {};
                for(r in n)M[r] = t[r];
                return i && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = M), M;
            }
            function sr(e) {
                return null != (e = e.childContextTypes);
            }
            function Ar() {
                cr(Nr), cr(lr);
            }
            function Dr(e, t, n) {
                if (lr.current !== Ir) throw Error(u(168));
                ar(lr, t), ar(Nr, n);
            }
            function dr(e, t, n) {
                var i = e.stateNode;
                if (e = t.childContextTypes, "function" != typeof i.getChildContext) return n;
                for(var M in i = i.getChildContext())if (!(M in e)) throw Error(u(108, Ae(t) || "Unknown", M));
                return r({}, n, {}, i);
            }
            function Tr(e) {
                return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || Ir, jr = lr.current, ar(lr, e), ar(Nr, Nr.current), !0;
            }
            function yr(e, t, n) {
                var i = e.stateNode;
                if (!i) throw Error(u(169));
                n ? (e = dr(e, t, jr), i.__reactInternalMemoizedMergedChildContext = e, cr(Nr), cr(lr), ar(lr, e)) : cr(Nr), ar(Nr, n);
            }
            var zr = M.unstable_runWithPriority, wr = M.unstable_scheduleCallback, fr = M.unstable_cancelCallback, Lr = M.unstable_requestPaint, Er = M.unstable_now, Cr = M.unstable_getCurrentPriorityLevel, xr = M.unstable_ImmediatePriority, pr = M.unstable_UserBlockingPriority, Sr = M.unstable_NormalPriority, mr = M.unstable_LowPriority, Or = M.unstable_IdlePriority, vr = {}, br = M.unstable_shouldYield, hr = void 0 !== Lr ? Lr : function() {}, kr = null, Qr = null, Yr = !1, Pr = Er(), Ur = 1e4 > Pr ? Er : function() {
                return Er() - Pr;
            };
            function Zr() {
                switch(Cr()){
                    case xr:
                        return 99;
                    case pr:
                        return 98;
                    case Sr:
                        return 97;
                    case mr:
                        return 96;
                    case Or:
                        return 95;
                    default:
                        throw Error(u(332));
                }
            }
            function Gr(e) {
                switch(e){
                    case 99:
                        return xr;
                    case 98:
                        return pr;
                    case 97:
                        return Sr;
                    case 96:
                        return mr;
                    case 95:
                        return Or;
                    default:
                        throw Error(u(332));
                }
            }
            function Br(e, t) {
                return e = Gr(e), zr(e, t);
            }
            function Rr(e, t, n) {
                return e = Gr(e), wr(e, t, n);
            }
            function Wr(e) {
                return null === kr ? (kr = [
                    e
                ], Qr = wr(xr, Vr)) : kr.push(e), vr;
            }
            function Hr() {
                if (null !== Qr) {
                    var e = Qr;
                    Qr = null, fr(e);
                }
                Vr();
            }
            function Vr() {
                if (!Yr && null !== kr) {
                    Yr = !0;
                    var e = 0;
                    try {
                        var t = kr;
                        Br(99, function() {
                            for(; e < t.length; e++){
                                var n = t[e];
                                do n = n(!0);
                                while (null !== n);
                            }
                        }), kr = null;
                    } catch (t) {
                        throw null !== kr && (kr = kr.slice(e + 1)), wr(xr, Hr), t;
                    } finally{
                        Yr = !1;
                    }
                }
            }
            function Jr(e, t, n) {
                return 1073741821 - (1 + ((1073741821 - e + t / 10) / (n /= 10) | 0)) * n;
            }
            function Fr(e, t) {
                if (e && e.defaultProps) for(var n in t = r({}, t), e = e.defaultProps)void 0 === t[n] && (t[n] = e[n]);
                return t;
            }
            var Xr = {
                current: null
            }, Kr = null, qr = null, _r = null;
            function $r() {
                _r = qr = Kr = null;
            }
            function eM(e) {
                var t = Xr.current;
                cr(Xr), e.type._context._currentValue = t;
            }
            function tM(e, t) {
                for(; null !== e;){
                    var n = e.alternate;
                    if (e.childExpirationTime < t) e.childExpirationTime = t, null !== n && n.childExpirationTime < t && (n.childExpirationTime = t);
                    else {
                        if (!(null !== n && n.childExpirationTime < t)) break;
                        n.childExpirationTime = t;
                    }
                    e = e.return;
                }
            }
            function nM(e, t) {
                Kr = e, _r = qr = null, null !== (e = e.dependencies) && null !== e.firstContext && (e.expirationTime >= t && (Su = !0), e.firstContext = null);
            }
            function iM(e, t) {
                if (_r !== e && !1 !== t && 0 !== t) {
                    if ("number" == typeof t && 1073741823 !== t || (_r = e, t = 1073741823), t = {
                        context: e,
                        observedBits: t,
                        next: null
                    }, null === qr) {
                        if (null === Kr) throw Error(u(308));
                        qr = t, Kr.dependencies = {
                            expirationTime: 0,
                            firstContext: t,
                            responders: null
                        };
                    } else qr = qr.next = t;
                }
                return e._currentValue;
            }
            var rM = !1;
            function MM(e) {
                e.updateQueue = {
                    baseState: e.memoizedState,
                    baseQueue: null,
                    shared: {
                        pending: null
                    },
                    effects: null
                };
            }
            function uM(e, t) {
                e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
                    baseState: e.baseState,
                    baseQueue: e.baseQueue,
                    shared: e.shared,
                    effects: e.effects
                });
            }
            function oM(e, t) {
                return (e = {
                    expirationTime: e,
                    suspenseConfig: t,
                    tag: 0,
                    payload: null,
                    callback: null,
                    next: null
                }).next = e;
            }
            function cM(e, t) {
                if (null !== (e = e.updateQueue)) {
                    var n = (e = e.shared).pending;
                    null === n ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
                }
            }
            function aM(e, t) {
                var n = e.alternate;
                null !== n && uM(n, e), null === (n = (e = e.updateQueue).baseQueue) ? (e.baseQueue = t.next = t, t.next = t) : (t.next = n.next, n.next = t);
            }
            function IM(e, t, n, i) {
                var M = e.updateQueue;
                rM = !1;
                var u = M.baseQueue, o = M.shared.pending;
                if (null !== o) {
                    if (null !== u) {
                        var c = u.next;
                        u.next = o.next, o.next = c;
                    }
                    u = o, M.shared.pending = null, null !== (c = e.alternate) && null !== (c = c.updateQueue) && (c.baseQueue = o);
                }
                if (null !== u) {
                    c = u.next;
                    var a = M.baseState, I = 0, l = null, N = null, j = null;
                    if (null !== c) for(var g = c;;){
                        if ((o = g.expirationTime) < i) {
                            var s = {
                                expirationTime: g.expirationTime,
                                suspenseConfig: g.suspenseConfig,
                                tag: g.tag,
                                payload: g.payload,
                                callback: g.callback,
                                next: null
                            };
                            null === j ? (N = j = s, l = a) : j = j.next = s, o > I && (I = o);
                        } else {
                            null !== j && (j = j.next = {
                                expirationTime: 1073741823,
                                suspenseConfig: g.suspenseConfig,
                                tag: g.tag,
                                payload: g.payload,
                                callback: g.callback,
                                next: null
                            }), Mc(o, g.suspenseConfig);
                            e: {
                                var A = e, D = g;
                                switch(o = t, s = n, D.tag){
                                    case 1:
                                        if ("function" == typeof (A = D.payload)) {
                                            a = A.call(s, a, o);
                                            break e;
                                        }
                                        a = A;
                                        break e;
                                    case 3:
                                        A.effectTag = -4097 & A.effectTag | 64;
                                    case 0:
                                        if (null == (o = "function" == typeof (A = D.payload) ? A.call(s, a, o) : A)) break e;
                                        a = r({}, a, o);
                                        break e;
                                    case 2:
                                        rM = !0;
                                }
                            }
                            null !== g.callback && (e.effectTag |= 32, null === (o = M.effects) ? M.effects = [
                                g
                            ] : o.push(g));
                        }
                        if (null === (g = g.next) || g === c) {
                            if (null === (o = M.shared.pending)) break;
                            g = u.next = o.next, o.next = c, M.baseQueue = u = o, M.shared.pending = null;
                        }
                    }
                    null === j ? l = a : j.next = N, M.baseState = l, M.baseQueue = j, uc(I), e.expirationTime = I, e.memoizedState = a;
                }
            }
            function lM(e, t, n) {
                if (e = t.effects, t.effects = null, null !== e) for(t = 0; t < e.length; t++){
                    var i = e[t], r = i.callback;
                    if (null !== r) {
                        if (i.callback = null, i = r, r = n, "function" != typeof i) throw Error(u(191, i));
                        i.call(r);
                    }
                }
            }
            var NM = K.ReactCurrentBatchConfig, jM = (new i.Component).refs;
            function gM(e, t, n, i) {
                n = null == (n = n(i, t = e.memoizedState)) ? t : r({}, t, n), e.memoizedState = n, 0 === e.expirationTime && (e.updateQueue.baseState = n);
            }
            var sM = {
                isMounted: function(e) {
                    return !!(e = e._reactInternalFiber) && $e(e) === e;
                },
                enqueueSetState: function(e, t, n) {
                    e = e._reactInternalFiber;
                    var i = Vo(), r = NM.suspense;
                    (r = oM(i = Jo(i, e, r), r)).payload = t, null != n && (r.callback = n), cM(e, r), Fo(e, i);
                },
                enqueueReplaceState: function(e, t, n) {
                    e = e._reactInternalFiber;
                    var i = Vo(), r = NM.suspense;
                    (r = oM(i = Jo(i, e, r), r)).tag = 1, r.payload = t, null != n && (r.callback = n), cM(e, r), Fo(e, i);
                },
                enqueueForceUpdate: function(e, t) {
                    e = e._reactInternalFiber;
                    var n = Vo(), i = NM.suspense;
                    (i = oM(n = Jo(n, e, i), i)).tag = 2, null != t && (i.callback = t), cM(e, i), Fo(e, n);
                }
            };
            function AM(e, t, n, i, r, M, u) {
                return "function" == typeof (e = e.stateNode).shouldComponentUpdate ? e.shouldComponentUpdate(i, M, u) : !t.prototype || !t.prototype.isPureReactComponent || !Ui(n, i) || !Ui(r, M);
            }
            function DM(e, t, n) {
                var i = !1, r = Ir, M = t.contextType;
                return "object" == typeof M && null !== M ? M = iM(M) : (r = sr(t) ? jr : lr.current, M = (i = null != (i = t.contextTypes)) ? gr(e, r) : Ir), t = new t(n, M), e.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null, t.updater = sM, e.stateNode = t, t._reactInternalFiber = e, i && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = r, e.__reactInternalMemoizedMaskedChildContext = M), t;
            }
            function dM(e, t, n, i) {
                e = t.state, "function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, i), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, i), t.state !== e && sM.enqueueReplaceState(t, t.state, null);
            }
            function TM(e, t, n, i) {
                var r = e.stateNode;
                r.props = n, r.state = e.memoizedState, r.refs = jM, MM(e);
                var M = t.contextType;
                "object" == typeof M && null !== M ? r.context = iM(M) : (M = sr(t) ? jr : lr.current, r.context = gr(e, M)), IM(e, n, r, i), r.state = e.memoizedState, "function" == typeof (M = t.getDerivedStateFromProps) && (gM(e, t, M, n), r.state = e.memoizedState), "function" == typeof t.getDerivedStateFromProps || "function" == typeof r.getSnapshotBeforeUpdate || "function" != typeof r.UNSAFE_componentWillMount && "function" != typeof r.componentWillMount || (t = r.state, "function" == typeof r.componentWillMount && r.componentWillMount(), "function" == typeof r.UNSAFE_componentWillMount && r.UNSAFE_componentWillMount(), t !== r.state && sM.enqueueReplaceState(r, r.state, null), IM(e, n, r, i), r.state = e.memoizedState), "function" == typeof r.componentDidMount && (e.effectTag |= 4);
            }
            var yM = Array.isArray;
            function zM(e, t, n) {
                if (null !== (e = n.ref) && "function" != typeof e && "object" != typeof e) {
                    if (n._owner) {
                        if (n = n._owner) {
                            if (1 !== n.tag) throw Error(u(309));
                            var i = n.stateNode;
                        }
                        if (!i) throw Error(u(147, e));
                        var r = "" + e;
                        return null !== t && null !== t.ref && "function" == typeof t.ref && t.ref._stringRef === r ? t.ref : ((t = function(e) {
                            var t = i.refs;
                            t === jM && (t = i.refs = {}), null === e ? delete t[r] : t[r] = e;
                        })._stringRef = r, t);
                    }
                    if ("string" != typeof e) throw Error(u(284));
                    if (!n._owner) throw Error(u(290, e));
                }
                return e;
            }
            function wM(e, t) {
                if ("textarea" !== e.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(t) ? "object with keys {" + Object.keys(t).join(", ") + "}" : t, ""));
            }
            function fM(e) {
                function t(t, n) {
                    if (e) {
                        var i = t.lastEffect;
                        null !== i ? (i.nextEffect = n, t.lastEffect = n) : t.firstEffect = t.lastEffect = n, n.nextEffect = null, n.effectTag = 8;
                    }
                }
                function n(n, i) {
                    if (!e) return null;
                    for(; null !== i;)t(n, i), i = i.sibling;
                    return null;
                }
                function i(e, t) {
                    for(e = new Map; null !== t;)null !== t.key ? e.set(t.key, t) : e.set(t.index, t), t = t.sibling;
                    return e;
                }
                function r(e, t) {
                    return (e = Cc(e, t)).index = 0, e.sibling = null, e;
                }
                function M(t, n, i) {
                    return t.index = i, e ? null !== (i = t.alternate) ? (i = i.index) < n ? (t.effectTag = 2, n) : i : (t.effectTag = 2, n) : n;
                }
                function o(t) {
                    return e && null === t.alternate && (t.effectTag = 2), t;
                }
                function c(e, t, n, i) {
                    return null === t || 6 !== t.tag ? ((t = Sc(n, e.mode, i)).return = e, t) : ((t = r(t, n)).return = e, t);
                }
                function a(e, t, n, i) {
                    return null !== t && t.elementType === n.type ? ((i = r(t, n.props)).ref = zM(e, t, n), i.return = e, i) : ((i = xc(n.type, n.key, n.props, null, e.mode, i)).ref = zM(e, t, n), i.return = e, i);
                }
                function I(e, t, n, i) {
                    return null === t || 4 !== t.tag || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? ((t = mc(n, e.mode, i)).return = e, t) : ((t = r(t, n.children || [])).return = e, t);
                }
                function l(e, t, n, i, M) {
                    return null === t || 7 !== t.tag ? ((t = pc(n, e.mode, i, M)).return = e, t) : ((t = r(t, n)).return = e, t);
                }
                function N(e, t, n) {
                    if ("string" == typeof t || "number" == typeof t) return (t = Sc("" + t, e.mode, n)).return = e, t;
                    if ("object" == typeof t && null !== t) {
                        switch(t.$$typeof){
                            case ee:
                                return (n = xc(t.type, t.key, t.props, null, e.mode, n)).ref = zM(e, null, t), n.return = e, n;
                            case te:
                                return (t = mc(t, e.mode, n)).return = e, t;
                        }
                        if (yM(t) || se(t)) return (t = pc(t, e.mode, n, null)).return = e, t;
                        wM(e, t);
                    }
                    return null;
                }
                function j(e, t, n, i) {
                    var r = null !== t ? t.key : null;
                    if ("string" == typeof n || "number" == typeof n) return null !== r ? null : c(e, t, "" + n, i);
                    if ("object" == typeof n && null !== n) {
                        switch(n.$$typeof){
                            case ee:
                                return n.key === r ? n.type === ne ? l(e, t, n.props.children, i, r) : a(e, t, n, i) : null;
                            case te:
                                return n.key === r ? I(e, t, n, i) : null;
                        }
                        if (yM(n) || se(n)) return null !== r ? null : l(e, t, n, i, null);
                        wM(e, n);
                    }
                    return null;
                }
                function g(e, t, n, i, r) {
                    if ("string" == typeof i || "number" == typeof i) return c(t, e = e.get(n) || null, "" + i, r);
                    if ("object" == typeof i && null !== i) {
                        switch(i.$$typeof){
                            case ee:
                                return e = e.get(null === i.key ? n : i.key) || null, i.type === ne ? l(t, e, i.props.children, r, i.key) : a(t, e, i, r);
                            case te:
                                return I(t, e = e.get(null === i.key ? n : i.key) || null, i, r);
                        }
                        if (yM(i) || se(i)) return l(t, e = e.get(n) || null, i, r, null);
                        wM(t, i);
                    }
                    return null;
                }
                function s(r, u, o, c) {
                    for(var a = null, I = null, l = u, s = u = 0, A = null; null !== l && s < o.length; s++){
                        l.index > s ? (A = l, l = null) : A = l.sibling;
                        var D = j(r, l, o[s], c);
                        if (null === D) {
                            null === l && (l = A);
                            break;
                        }
                        e && l && null === D.alternate && t(r, l), u = M(D, u, s), null === I ? a = D : I.sibling = D, I = D, l = A;
                    }
                    if (s === o.length) return n(r, l), a;
                    if (null === l) {
                        for(; s < o.length; s++)null !== (l = N(r, o[s], c)) && (u = M(l, u, s), null === I ? a = l : I.sibling = l, I = l);
                        return a;
                    }
                    for(l = i(r, l); s < o.length; s++)null !== (A = g(l, r, s, o[s], c)) && (e && null !== A.alternate && l.delete(null === A.key ? s : A.key), u = M(A, u, s), null === I ? a = A : I.sibling = A, I = A);
                    return e && l.forEach(function(e) {
                        return t(r, e);
                    }), a;
                }
                function A(r, o, c, a) {
                    var I = se(c);
                    if ("function" != typeof I) throw Error(u(150));
                    if (null == (c = I.call(c))) throw Error(u(151));
                    for(var l = I = null, s = o, A = o = 0, D = null, d = c.next(); null !== s && !d.done; A++, d = c.next()){
                        s.index > A ? (D = s, s = null) : D = s.sibling;
                        var T = j(r, s, d.value, a);
                        if (null === T) {
                            null === s && (s = D);
                            break;
                        }
                        e && s && null === T.alternate && t(r, s), o = M(T, o, A), null === l ? I = T : l.sibling = T, l = T, s = D;
                    }
                    if (d.done) return n(r, s), I;
                    if (null === s) {
                        for(; !d.done; A++, d = c.next())null !== (d = N(r, d.value, a)) && (o = M(d, o, A), null === l ? I = d : l.sibling = d, l = d);
                        return I;
                    }
                    for(s = i(r, s); !d.done; A++, d = c.next())null !== (d = g(s, r, A, d.value, a)) && (e && null !== d.alternate && s.delete(null === d.key ? A : d.key), o = M(d, o, A), null === l ? I = d : l.sibling = d, l = d);
                    return e && s.forEach(function(e) {
                        return t(r, e);
                    }), I;
                }
                return function(e, i, M, c) {
                    var a = "object" == typeof M && null !== M && M.type === ne && null === M.key;
                    a && (M = M.props.children);
                    var I = "object" == typeof M && null !== M;
                    if (I) switch(M.$$typeof){
                        case ee:
                            e: {
                                for(I = M.key, a = i; null !== a;){
                                    if (a.key === I) {
                                        switch(a.tag){
                                            case 7:
                                                if (M.type === ne) {
                                                    n(e, a.sibling), (i = r(a, M.props.children)).return = e, e = i;
                                                    break e;
                                                }
                                                break;
                                            default:
                                                if (a.elementType === M.type) {
                                                    n(e, a.sibling), (i = r(a, M.props)).ref = zM(e, a, M), i.return = e, e = i;
                                                    break e;
                                                }
                                        }
                                        n(e, a);
                                        break;
                                    }
                                    t(e, a), a = a.sibling;
                                }
                                M.type === ne ? ((i = pc(M.props.children, e.mode, c, M.key)).return = e, e = i) : ((c = xc(M.type, M.key, M.props, null, e.mode, c)).ref = zM(e, i, M), c.return = e, e = c);
                            }
                            return o(e);
                        case te:
                            e: {
                                for(a = M.key; null !== i;){
                                    if (i.key === a) {
                                        if (4 === i.tag && i.stateNode.containerInfo === M.containerInfo && i.stateNode.implementation === M.implementation) {
                                            n(e, i.sibling), (i = r(i, M.children || [])).return = e, e = i;
                                            break e;
                                        }
                                        n(e, i);
                                        break;
                                    }
                                    t(e, i), i = i.sibling;
                                }
                                (i = mc(M, e.mode, c)).return = e, e = i;
                            }
                            return o(e);
                    }
                    if ("string" == typeof M || "number" == typeof M) return M = "" + M, null !== i && 6 === i.tag ? (n(e, i.sibling), (i = r(i, M)).return = e, e = i) : (n(e, i), (i = Sc(M, e.mode, c)).return = e, e = i), o(e);
                    if (yM(M)) return s(e, i, M, c);
                    if (se(M)) return A(e, i, M, c);
                    if (I && wM(e, M), void 0 === M && !a) switch(e.tag){
                        case 1:
                        case 0:
                            throw e = e.type, Error(u(152, e.displayName || e.name || "Component"));
                    }
                    return n(e, i);
                };
            }
            var LM = fM(!0), EM = fM(!1), CM = {}, xM = {
                current: CM
            }, pM = {
                current: CM
            }, SM = {
                current: CM
            };
            function mM(e) {
                if (e === CM) throw Error(u(174));
                return e;
            }
            function OM(e, t) {
                switch(ar(SM, t), ar(pM, e), ar(xM, CM), e = t.nodeType){
                    case 9:
                    case 11:
                        t = (t = t.documentElement) ? t.namespaceURI : Ye(null, "");
                        break;
                    default:
                        t = Ye(t = (e = 8 === e ? t.parentNode : t).namespaceURI || null, e = e.tagName);
                }
                cr(xM), ar(xM, t);
            }
            function vM() {
                cr(xM), cr(pM), cr(SM);
            }
            function bM(e) {
                mM(SM.current);
                var t = mM(xM.current), n = Ye(t, e.type);
                t !== n && (ar(pM, e), ar(xM, n));
            }
            function hM(e) {
                pM.current === e && (cr(xM), cr(pM));
            }
            var kM = {
                current: 0
            };
            function QM(e) {
                for(var t = e; null !== t;){
                    if (13 === t.tag) {
                        var n = t.memoizedState;
                        if (null !== n && (null === (n = n.dehydrated) || "$?" === n.data || "$!" === n.data)) return t;
                    } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
                        if (0 != (64 & t.effectTag)) return t;
                    } else if (null !== t.child) {
                        t.child.return = t, t = t.child;
                        continue;
                    }
                    if (t === e) break;
                    for(; null === t.sibling;){
                        if (null === t.return || t.return === e) return null;
                        t = t.return;
                    }
                    t.sibling.return = t.return, t = t.sibling;
                }
                return null;
            }
            function YM(e, t) {
                return {
                    responder: e,
                    props: t
                };
            }
            var PM = K.ReactCurrentDispatcher, UM = K.ReactCurrentBatchConfig, ZM = 0, GM = null, BM = null, RM = null, WM = !1;
            function HM() {
                throw Error(u(321));
            }
            function VM(e, t) {
                if (null === t) return !1;
                for(var n = 0; n < t.length && n < e.length; n++)if (!Yi(e[n], t[n])) return !1;
                return !0;
            }
            function JM(e, t, n, i, r, M) {
                if (ZM = M, GM = t, t.memoizedState = null, t.updateQueue = null, t.expirationTime = 0, PM.current = null === e || null === e.memoizedState ? Au : Du, e = n(i, r), t.expirationTime === ZM) {
                    M = 0;
                    do {
                        if (t.expirationTime = 0, !(25 > M)) throw Error(u(301));
                        M += 1, RM = BM = null, t.updateQueue = null, PM.current = du, e = n(i, r);
                    }while (t.expirationTime === ZM);
                }
                if (PM.current = su, t = null !== BM && null !== BM.next, ZM = 0, RM = BM = GM = null, WM = !1, t) throw Error(u(300));
                return e;
            }
            function FM() {
                var e = {
                    memoizedState: null,
                    baseState: null,
                    baseQueue: null,
                    queue: null,
                    next: null
                };
                return null === RM ? GM.memoizedState = RM = e : RM = RM.next = e, RM;
            }
            function XM() {
                if (null === BM) {
                    var e = GM.alternate;
                    e = null !== e ? e.memoizedState : null;
                } else e = BM.next;
                var t = null === RM ? GM.memoizedState : RM.next;
                if (null !== t) RM = t, BM = e;
                else {
                    if (null === e) throw Error(u(310));
                    e = {
                        memoizedState: (BM = e).memoizedState,
                        baseState: BM.baseState,
                        baseQueue: BM.baseQueue,
                        queue: BM.queue,
                        next: null
                    }, null === RM ? GM.memoizedState = RM = e : RM = RM.next = e;
                }
                return RM;
            }
            function KM(e, t) {
                return "function" == typeof t ? t(e) : t;
            }
            function qM(e) {
                var t = XM(), n = t.queue;
                if (null === n) throw Error(u(311));
                n.lastRenderedReducer = e;
                var i = BM, r = i.baseQueue, M = n.pending;
                if (null !== M) {
                    if (null !== r) {
                        var o = r.next;
                        r.next = M.next, M.next = o;
                    }
                    i.baseQueue = r = M, n.pending = null;
                }
                if (null !== r) {
                    r = r.next, i = i.baseState;
                    var c = o = M = null, a = r;
                    do {
                        var I = a.expirationTime;
                        if (I < ZM) {
                            var l = {
                                expirationTime: a.expirationTime,
                                suspenseConfig: a.suspenseConfig,
                                action: a.action,
                                eagerReducer: a.eagerReducer,
                                eagerState: a.eagerState,
                                next: null
                            };
                            null === c ? (o = c = l, M = i) : c = c.next = l, I > GM.expirationTime && (GM.expirationTime = I, uc(I));
                        } else null !== c && (c = c.next = {
                            expirationTime: 1073741823,
                            suspenseConfig: a.suspenseConfig,
                            action: a.action,
                            eagerReducer: a.eagerReducer,
                            eagerState: a.eagerState,
                            next: null
                        }), Mc(I, a.suspenseConfig), i = a.eagerReducer === e ? a.eagerState : e(i, a.action);
                        a = a.next;
                    }while (null !== a && a !== r);
                    null === c ? M = i : c.next = o, Yi(i, t.memoizedState) || (Su = !0), t.memoizedState = i, t.baseState = M, t.baseQueue = c, n.lastRenderedState = i;
                }
                return [
                    t.memoizedState,
                    n.dispatch
                ];
            }
            function _M(e) {
                var t = XM(), n = t.queue;
                if (null === n) throw Error(u(311));
                n.lastRenderedReducer = e;
                var i = n.dispatch, r = n.pending, M = t.memoizedState;
                if (null !== r) {
                    n.pending = null;
                    var o = r = r.next;
                    do M = e(M, o.action), o = o.next;
                    while (o !== r);
                    Yi(M, t.memoizedState) || (Su = !0), t.memoizedState = M, null === t.baseQueue && (t.baseState = M), n.lastRenderedState = M;
                }
                return [
                    M,
                    i
                ];
            }
            function $M(e) {
                var t = FM();
                return "function" == typeof e && (e = e()), t.memoizedState = t.baseState = e, e = (e = t.queue = {
                    pending: null,
                    dispatch: null,
                    lastRenderedReducer: KM,
                    lastRenderedState: e
                }).dispatch = gu.bind(null, GM, e), [
                    t.memoizedState,
                    e
                ];
            }
            function eu(e, t, n, i) {
                return e = {
                    tag: e,
                    create: t,
                    destroy: n,
                    deps: i,
                    next: null
                }, null === (t = GM.updateQueue) ? (t = {
                    lastEffect: null
                }, GM.updateQueue = t, t.lastEffect = e.next = e) : null === (n = t.lastEffect) ? t.lastEffect = e.next = e : (i = n.next, n.next = e, e.next = i, t.lastEffect = e), e;
            }
            function tu() {
                return XM().memoizedState;
            }
            function nu(e, t, n, i) {
                var r = FM();
                GM.effectTag |= e, r.memoizedState = eu(1 | t, n, void 0, void 0 === i ? null : i);
            }
            function iu(e, t, n, i) {
                var r = XM();
                i = void 0 === i ? null : i;
                var M = void 0;
                if (null !== BM) {
                    var u = BM.memoizedState;
                    if (M = u.destroy, null !== i && VM(i, u.deps)) return void eu(t, n, M, i);
                }
                GM.effectTag |= e, r.memoizedState = eu(1 | t, n, M, i);
            }
            function ru(e, t) {
                return nu(516, 4, e, t);
            }
            function Mu(e, t) {
                return iu(516, 4, e, t);
            }
            function uu(e, t) {
                return iu(4, 2, e, t);
            }
            function ou(e, t) {
                return "function" == typeof t ? (e = e(), t(e), function() {
                    t(null);
                }) : null != t ? (e = e(), t.current = e, function() {
                    t.current = null;
                }) : void 0;
            }
            function cu(e, t, n) {
                return n = null != n ? n.concat([
                    e
                ]) : null, iu(4, 2, ou.bind(null, t, e), n);
            }
            function au() {}
            function Iu(e, t) {
                return FM().memoizedState = [
                    e,
                    void 0 === t ? null : t
                ], e;
            }
            function lu(e, t) {
                var n = XM();
                t = void 0 === t ? null : t;
                var i = n.memoizedState;
                return null !== i && null !== t && VM(t, i[1]) ? i[0] : (n.memoizedState = [
                    e,
                    t
                ], e);
            }
            function Nu(e, t) {
                var n = XM();
                t = void 0 === t ? null : t;
                var i = n.memoizedState;
                return null !== i && null !== t && VM(t, i[1]) ? i[0] : (e = e(), n.memoizedState = [
                    e,
                    t
                ], e);
            }
            function ju(e, t, n) {
                var i = Zr();
                Br(98 > i ? 98 : i, function() {
                    e(!0);
                }), Br(97 < i ? 97 : i, function() {
                    var i = UM.suspense;
                    UM.suspense = void 0 === t ? null : t;
                    try {
                        e(!1), n();
                    } finally{
                        UM.suspense = i;
                    }
                });
            }
            function gu(e, t, n) {
                var i = Vo(), r = NM.suspense;
                r = {
                    expirationTime: i = Jo(i, e, r),
                    suspenseConfig: r,
                    action: n,
                    eagerReducer: null,
                    eagerState: null,
                    next: null
                };
                var M = t.pending;
                if (null === M ? r.next = r : (r.next = M.next, M.next = r), t.pending = r, M = e.alternate, e === GM || null !== M && M === GM) WM = !0, r.expirationTime = ZM, GM.expirationTime = ZM;
                else {
                    if (0 === e.expirationTime && (null === M || 0 === M.expirationTime) && null !== (M = t.lastRenderedReducer)) try {
                        var u = t.lastRenderedState, o = M(u, n);
                        if (r.eagerReducer = M, r.eagerState = o, Yi(o, u)) return;
                    } catch (e) {}
                    Fo(e, i);
                }
            }
            var su = {
                readContext: iM,
                useCallback: HM,
                useContext: HM,
                useEffect: HM,
                useImperativeHandle: HM,
                useLayoutEffect: HM,
                useMemo: HM,
                useReducer: HM,
                useRef: HM,
                useState: HM,
                useDebugValue: HM,
                useResponder: HM,
                useDeferredValue: HM,
                useTransition: HM
            }, Au = {
                readContext: iM,
                useCallback: Iu,
                useContext: iM,
                useEffect: ru,
                useImperativeHandle: function(e, t, n) {
                    return n = null != n ? n.concat([
                        e
                    ]) : null, nu(4, 2, ou.bind(null, t, e), n);
                },
                useLayoutEffect: function(e, t) {
                    return nu(4, 2, e, t);
                },
                useMemo: function(e, t) {
                    var n = FM();
                    return t = void 0 === t ? null : t, e = e(), n.memoizedState = [
                        e,
                        t
                    ], e;
                },
                useReducer: function(e, t, n) {
                    var i = FM();
                    return t = void 0 !== n ? n(t) : t, i.memoizedState = i.baseState = t, e = (e = i.queue = {
                        pending: null,
                        dispatch: null,
                        lastRenderedReducer: e,
                        lastRenderedState: t
                    }).dispatch = gu.bind(null, GM, e), [
                        i.memoizedState,
                        e
                    ];
                },
                useRef: function(e) {
                    return e = {
                        current: e
                    }, FM().memoizedState = e;
                },
                useState: $M,
                useDebugValue: au,
                useResponder: YM,
                useDeferredValue: function(e, t) {
                    var n = $M(e), i = n[0], r = n[1];
                    return ru(function() {
                        var n = UM.suspense;
                        UM.suspense = void 0 === t ? null : t;
                        try {
                            r(e);
                        } finally{
                            UM.suspense = n;
                        }
                    }, [
                        e,
                        t
                    ]), i;
                },
                useTransition: function(e) {
                    var t = $M(!1), n = t[0];
                    return t = t[1], [
                        Iu(ju.bind(null, t, e), [
                            t,
                            e
                        ]),
                        n
                    ];
                }
            }, Du = {
                readContext: iM,
                useCallback: lu,
                useContext: iM,
                useEffect: Mu,
                useImperativeHandle: cu,
                useLayoutEffect: uu,
                useMemo: Nu,
                useReducer: qM,
                useRef: tu,
                useState: function() {
                    return qM(KM);
                },
                useDebugValue: au,
                useResponder: YM,
                useDeferredValue: function(e, t) {
                    var n = qM(KM), i = n[0], r = n[1];
                    return Mu(function() {
                        var n = UM.suspense;
                        UM.suspense = void 0 === t ? null : t;
                        try {
                            r(e);
                        } finally{
                            UM.suspense = n;
                        }
                    }, [
                        e,
                        t
                    ]), i;
                },
                useTransition: function(e) {
                    var t = qM(KM), n = t[0];
                    return t = t[1], [
                        lu(ju.bind(null, t, e), [
                            t,
                            e
                        ]),
                        n
                    ];
                }
            }, du = {
                readContext: iM,
                useCallback: lu,
                useContext: iM,
                useEffect: Mu,
                useImperativeHandle: cu,
                useLayoutEffect: uu,
                useMemo: Nu,
                useReducer: _M,
                useRef: tu,
                useState: function() {
                    return _M(KM);
                },
                useDebugValue: au,
                useResponder: YM,
                useDeferredValue: function(e, t) {
                    var n = _M(KM), i = n[0], r = n[1];
                    return Mu(function() {
                        var n = UM.suspense;
                        UM.suspense = void 0 === t ? null : t;
                        try {
                            r(e);
                        } finally{
                            UM.suspense = n;
                        }
                    }, [
                        e,
                        t
                    ]), i;
                },
                useTransition: function(e) {
                    var t = _M(KM), n = t[0];
                    return t = t[1], [
                        lu(ju.bind(null, t, e), [
                            t,
                            e
                        ]),
                        n
                    ];
                }
            }, Tu = null, yu = null, zu = !1;
            function wu(e, t) {
                var n = Lc(5, null, null, 0);
                n.elementType = "DELETED", n.type = "DELETED", n.stateNode = t, n.return = e, n.effectTag = 8, null !== e.lastEffect ? (e.lastEffect.nextEffect = n, e.lastEffect = n) : e.firstEffect = e.lastEffect = n;
            }
            function fu(e, t) {
                switch(e.tag){
                    case 5:
                        var n = e.type;
                        return null !== (t = 1 !== t.nodeType || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t) && (e.stateNode = t, !0);
                    case 6:
                        return null !== (t = "" === e.pendingProps || 3 !== t.nodeType ? null : t) && (e.stateNode = t, !0);
                    case 13:
                    default:
                        return !1;
                }
            }
            function Lu(e) {
                if (zu) {
                    var t = yu;
                    if (t) {
                        var n = t;
                        if (!fu(e, t)) {
                            if (!(t = zn(n.nextSibling)) || !fu(e, t)) return e.effectTag = -1025 & e.effectTag | 2, zu = !1, void (Tu = e);
                            wu(Tu, n);
                        }
                        Tu = e, yu = zn(t.firstChild);
                    } else e.effectTag = -1025 & e.effectTag | 2, zu = !1, Tu = e;
                }
            }
            function Eu(e) {
                for(e = e.return; null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag;)e = e.return;
                Tu = e;
            }
            function Cu(e) {
                if (e !== Tu) return !1;
                if (!zu) return Eu(e), zu = !0, !1;
                var t = e.type;
                if (5 !== e.tag || "head" !== t && "body" !== t && !dn(t, e.memoizedProps)) for(t = yu; t;)wu(e, t), t = zn(t.nextSibling);
                if (Eu(e), 13 === e.tag) {
                    if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null)) throw Error(u(317));
                    e: {
                        for(e = e.nextSibling, t = 0; e;){
                            if (8 === e.nodeType) {
                                var n = e.data;
                                if ("/$" === n) {
                                    if (0 === t) {
                                        yu = zn(e.nextSibling);
                                        break e;
                                    }
                                    t--;
                                } else "$" !== n && "$!" !== n && "$?" !== n || t++;
                            }
                            e = e.nextSibling;
                        }
                        yu = null;
                    }
                } else yu = Tu ? zn(e.stateNode.nextSibling) : null;
                return !0;
            }
            function xu() {
                yu = Tu = null, zu = !1;
            }
            var pu = K.ReactCurrentOwner, Su = !1;
            function mu(e, t, n, i) {
                t.child = null === e ? EM(t, null, n, i) : LM(t, e.child, n, i);
            }
            function Ou(e, t, n, i, r) {
                n = n.render;
                var M = t.ref;
                return nM(t, r), i = JM(e, t, n, i, M, r), null === e || Su ? (t.effectTag |= 1, mu(e, t, i, r), t.child) : (t.updateQueue = e.updateQueue, t.effectTag &= -517, e.expirationTime <= r && (e.expirationTime = 0), Ju(e, t, r));
            }
            function vu(e, t, n, i, r, M) {
                if (null === e) {
                    var u = n.type;
                    return "function" != typeof u || Ec(u) || void 0 !== u.defaultProps || null !== n.compare || void 0 !== n.defaultProps ? ((e = xc(n.type, null, i, null, t.mode, M)).ref = t.ref, e.return = t, t.child = e) : (t.tag = 15, t.type = u, bu(e, t, u, i, r, M));
                }
                return u = e.child, r < M && (r = u.memoizedProps, (n = null !== (n = n.compare) ? n : Ui)(r, i) && e.ref === t.ref) ? Ju(e, t, M) : (t.effectTag |= 1, (e = Cc(u, i)).ref = t.ref, e.return = t, t.child = e);
            }
            function bu(e, t, n, i, r, M) {
                return null !== e && Ui(e.memoizedProps, i) && e.ref === t.ref && (Su = !1, r < M) ? (t.expirationTime = e.expirationTime, Ju(e, t, M)) : ku(e, t, n, i, M);
            }
            function hu(e, t) {
                var n = t.ref;
                (null === e && null !== n || null !== e && e.ref !== n) && (t.effectTag |= 128);
            }
            function ku(e, t, n, i, r) {
                var M = sr(n) ? jr : lr.current;
                return M = gr(t, M), nM(t, r), n = JM(e, t, n, i, M, r), null === e || Su ? (t.effectTag |= 1, mu(e, t, n, r), t.child) : (t.updateQueue = e.updateQueue, t.effectTag &= -517, e.expirationTime <= r && (e.expirationTime = 0), Ju(e, t, r));
            }
            function Qu(e, t, n, i, r) {
                if (sr(n)) {
                    var M = !0;
                    Tr(t);
                } else M = !1;
                if (nM(t, r), null === t.stateNode) null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), DM(t, n, i), TM(t, n, i, r), i = !0;
                else if (null === e) {
                    var u = t.stateNode, o = t.memoizedProps;
                    u.props = o;
                    var c = u.context, a = n.contextType;
                    "object" == typeof a && null !== a ? a = iM(a) : a = gr(t, a = sr(n) ? jr : lr.current);
                    var I = n.getDerivedStateFromProps, l = "function" == typeof I || "function" == typeof u.getSnapshotBeforeUpdate;
                    l || "function" != typeof u.UNSAFE_componentWillReceiveProps && "function" != typeof u.componentWillReceiveProps || (o !== i || c !== a) && dM(t, u, i, a), rM = !1;
                    var N = t.memoizedState;
                    u.state = N, IM(t, i, u, r), c = t.memoizedState, o !== i || N !== c || Nr.current || rM ? ("function" == typeof I && (gM(t, n, I, i), c = t.memoizedState), (o = rM || AM(t, n, o, i, N, c, a)) ? (l || "function" != typeof u.UNSAFE_componentWillMount && "function" != typeof u.componentWillMount || ("function" == typeof u.componentWillMount && u.componentWillMount(), "function" == typeof u.UNSAFE_componentWillMount && u.UNSAFE_componentWillMount()), "function" == typeof u.componentDidMount && (t.effectTag |= 4)) : ("function" == typeof u.componentDidMount && (t.effectTag |= 4), t.memoizedProps = i, t.memoizedState = c), u.props = i, u.state = c, u.context = a, i = o) : ("function" == typeof u.componentDidMount && (t.effectTag |= 4), i = !1);
                } else u = t.stateNode, uM(e, t), o = t.memoizedProps, u.props = t.type === t.elementType ? o : Fr(t.type, o), c = u.context, "object" == typeof (a = n.contextType) && null !== a ? a = iM(a) : a = gr(t, a = sr(n) ? jr : lr.current), (l = "function" == typeof (I = n.getDerivedStateFromProps) || "function" == typeof u.getSnapshotBeforeUpdate) || "function" != typeof u.UNSAFE_componentWillReceiveProps && "function" != typeof u.componentWillReceiveProps || (o !== i || c !== a) && dM(t, u, i, a), rM = !1, c = t.memoizedState, u.state = c, IM(t, i, u, r), N = t.memoizedState, o !== i || c !== N || Nr.current || rM ? ("function" == typeof I && (gM(t, n, I, i), N = t.memoizedState), (I = rM || AM(t, n, o, i, c, N, a)) ? (l || "function" != typeof u.UNSAFE_componentWillUpdate && "function" != typeof u.componentWillUpdate || ("function" == typeof u.componentWillUpdate && u.componentWillUpdate(i, N, a), "function" == typeof u.UNSAFE_componentWillUpdate && u.UNSAFE_componentWillUpdate(i, N, a)), "function" == typeof u.componentDidUpdate && (t.effectTag |= 4), "function" == typeof u.getSnapshotBeforeUpdate && (t.effectTag |= 256)) : ("function" != typeof u.componentDidUpdate || o === e.memoizedProps && c === e.memoizedState || (t.effectTag |= 4), "function" != typeof u.getSnapshotBeforeUpdate || o === e.memoizedProps && c === e.memoizedState || (t.effectTag |= 256), t.memoizedProps = i, t.memoizedState = N), u.props = i, u.state = N, u.context = a, i = I) : ("function" != typeof u.componentDidUpdate || o === e.memoizedProps && c === e.memoizedState || (t.effectTag |= 4), "function" != typeof u.getSnapshotBeforeUpdate || o === e.memoizedProps && c === e.memoizedState || (t.effectTag |= 256), i = !1);
                return Yu(e, t, n, i, M, r);
            }
            function Yu(e, t, n, i, r, M) {
                hu(e, t);
                var u = 0 != (64 & t.effectTag);
                if (!i && !u) return r && yr(t, n, !1), Ju(e, t, M);
                i = t.stateNode, pu.current = t;
                var o = u && "function" != typeof n.getDerivedStateFromError ? null : i.render();
                return t.effectTag |= 1, null !== e && u ? (t.child = LM(t, e.child, null, M), t.child = LM(t, null, o, M)) : mu(e, t, o, M), t.memoizedState = i.state, r && yr(t, n, !0), t.child;
            }
            function Pu(e) {
                var t = e.stateNode;
                t.pendingContext ? Dr(0, t.pendingContext, t.pendingContext !== t.context) : t.context && Dr(0, t.context, !1), OM(e, t.containerInfo);
            }
            var Uu, Zu, Gu, Bu = {
                dehydrated: null,
                retryTime: 0
            };
            function Ru(e, t, n) {
                var i, r = t.mode, M = t.pendingProps, u = kM.current, o = !1;
                if ((i = 0 != (64 & t.effectTag)) || (i = 0 != (2 & u) && (null === e || null !== e.memoizedState)), i ? (o = !0, t.effectTag &= -65) : null !== e && null === e.memoizedState || void 0 === M.fallback || !0 === M.unstable_avoidThisFallback || (u |= 1), ar(kM, 1 & u), null === e) {
                    if (void 0 !== M.fallback && Lu(t), o) {
                        if (o = M.fallback, (M = pc(null, r, 0, null)).return = t, 0 == (2 & t.mode)) for(e = null !== t.memoizedState ? t.child.child : t.child, M.child = e; null !== e;)e.return = M, e = e.sibling;
                        return (n = pc(o, r, n, null)).return = t, M.sibling = n, t.memoizedState = Bu, t.child = M, n;
                    }
                    return r = M.children, t.memoizedState = null, t.child = EM(t, null, r, n);
                }
                if (null !== e.memoizedState) {
                    if (r = (e = e.child).sibling, o) {
                        if (M = M.fallback, (n = Cc(e, e.pendingProps)).return = t, 0 == (2 & t.mode) && (o = null !== t.memoizedState ? t.child.child : t.child) !== e.child) for(n.child = o; null !== o;)o.return = n, o = o.sibling;
                        return (r = Cc(r, M)).return = t, n.sibling = r, n.childExpirationTime = 0, t.memoizedState = Bu, t.child = n, r;
                    }
                    return n = LM(t, e.child, M.children, n), t.memoizedState = null, t.child = n;
                }
                if (e = e.child, o) {
                    if (o = M.fallback, (M = pc(null, r, 0, null)).return = t, M.child = e, null !== e && (e.return = M), 0 == (2 & t.mode)) for(e = null !== t.memoizedState ? t.child.child : t.child, M.child = e; null !== e;)e.return = M, e = e.sibling;
                    return (n = pc(o, r, n, null)).return = t, M.sibling = n, n.effectTag |= 2, M.childExpirationTime = 0, t.memoizedState = Bu, t.child = M, n;
                }
                return t.memoizedState = null, t.child = LM(t, e, M.children, n);
            }
            function Wu(e, t) {
                e.expirationTime < t && (e.expirationTime = t);
                var n = e.alternate;
                null !== n && n.expirationTime < t && (n.expirationTime = t), tM(e.return, t);
            }
            function Hu(e, t, n, i, r, M) {
                var u = e.memoizedState;
                null === u ? e.memoizedState = {
                    isBackwards: t,
                    rendering: null,
                    renderingStartTime: 0,
                    last: i,
                    tail: n,
                    tailExpiration: 0,
                    tailMode: r,
                    lastEffect: M
                } : (u.isBackwards = t, u.rendering = null, u.renderingStartTime = 0, u.last = i, u.tail = n, u.tailExpiration = 0, u.tailMode = r, u.lastEffect = M);
            }
            function Vu(e, t, n) {
                var i = t.pendingProps, r = i.revealOrder, M = i.tail;
                if (mu(e, t, i.children, n), 0 != (2 & (i = kM.current))) i = 1 & i | 2, t.effectTag |= 64;
                else {
                    if (null !== e && 0 != (64 & e.effectTag)) e: for(e = t.child; null !== e;){
                        if (13 === e.tag) null !== e.memoizedState && Wu(e, n);
                        else if (19 === e.tag) Wu(e, n);
                        else if (null !== e.child) {
                            e.child.return = e, e = e.child;
                            continue;
                        }
                        if (e === t) break e;
                        for(; null === e.sibling;){
                            if (null === e.return || e.return === t) break e;
                            e = e.return;
                        }
                        e.sibling.return = e.return, e = e.sibling;
                    }
                    i &= 1;
                }
                if (ar(kM, i), 0 == (2 & t.mode)) t.memoizedState = null;
                else switch(r){
                    case "forwards":
                        for(n = t.child, r = null; null !== n;)null !== (e = n.alternate) && null === QM(e) && (r = n), n = n.sibling;
                        null === (n = r) ? (r = t.child, t.child = null) : (r = n.sibling, n.sibling = null), Hu(t, !1, r, n, M, t.lastEffect);
                        break;
                    case "backwards":
                        for(n = null, r = t.child, t.child = null; null !== r;){
                            if (null !== (e = r.alternate) && null === QM(e)) {
                                t.child = r;
                                break;
                            }
                            e = r.sibling, r.sibling = n, n = r, r = e;
                        }
                        Hu(t, !0, n, null, M, t.lastEffect);
                        break;
                    case "together":
                        Hu(t, !1, null, null, void 0, t.lastEffect);
                        break;
                    default:
                        t.memoizedState = null;
                }
                return t.child;
            }
            function Ju(e, t, n) {
                null !== e && (t.dependencies = e.dependencies);
                var i = t.expirationTime;
                if (0 !== i && uc(i), t.childExpirationTime < n) return null;
                if (null !== e && t.child !== e.child) throw Error(u(153));
                if (null !== t.child) {
                    for(n = Cc(e = t.child, e.pendingProps), t.child = n, n.return = t; null !== e.sibling;)e = e.sibling, (n = n.sibling = Cc(e, e.pendingProps)).return = t;
                    n.sibling = null;
                }
                return t.child;
            }
            function Fu(e, t) {
                switch(e.tailMode){
                    case "hidden":
                        t = e.tail;
                        for(var n = null; null !== t;)null !== t.alternate && (n = t), t = t.sibling;
                        null === n ? e.tail = null : n.sibling = null;
                        break;
                    case "collapsed":
                        n = e.tail;
                        for(var i = null; null !== n;)null !== n.alternate && (i = n), n = n.sibling;
                        null === i ? t || null === e.tail ? e.tail = null : e.tail.sibling = null : i.sibling = null;
                }
            }
            function Xu(e, t, n) {
                var i = t.pendingProps;
                switch(t.tag){
                    case 2:
                    case 16:
                    case 15:
                    case 0:
                    case 11:
                    case 7:
                    case 8:
                    case 12:
                    case 9:
                    case 14:
                        return null;
                    case 1:
                        return sr(t.type) && Ar(), null;
                    case 3:
                        return vM(), cr(Nr), cr(lr), (n = t.stateNode).pendingContext && (n.context = n.pendingContext, n.pendingContext = null), null !== e && null !== e.child || !Cu(t) || (t.effectTag |= 4), null;
                    case 5:
                        hM(t), n = mM(SM.current);
                        var M = t.type;
                        if (null !== e && null != t.stateNode) Zu(e, t, M, i, n), e.ref !== t.ref && (t.effectTag |= 128);
                        else {
                            if (!i) {
                                if (null === t.stateNode) throw Error(u(166));
                                return null;
                            }
                            if (e = mM(xM.current), Cu(t)) {
                                i = t.stateNode, M = t.type;
                                var o = t.memoizedProps;
                                switch(i[Ln] = t, i[En] = o, M){
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        Jt("load", i);
                                        break;
                                    case "video":
                                    case "audio":
                                        for(e = 0; e < Ke.length; e++)Jt(Ke[e], i);
                                        break;
                                    case "source":
                                        Jt("error", i);
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        Jt("error", i), Jt("load", i);
                                        break;
                                    case "form":
                                        Jt("reset", i), Jt("submit", i);
                                        break;
                                    case "details":
                                        Jt("toggle", i);
                                        break;
                                    case "input":
                                        fe(i, o), Jt("invalid", i), cn(n, "onChange");
                                        break;
                                    case "select":
                                        i._wrapperState = {
                                            wasMultiple: !!o.multiple
                                        }, Jt("invalid", i), cn(n, "onChange");
                                        break;
                                    case "textarea":
                                        Oe(i, o), Jt("invalid", i), cn(n, "onChange");
                                }
                                for(var c in Mn(M, o), e = null, o)if (o.hasOwnProperty(c)) {
                                    var a = o[c];
                                    "children" === c ? "string" == typeof a ? i.textContent !== a && (e = [
                                        "children",
                                        a
                                    ]) : "number" == typeof a && i.textContent !== "" + a && (e = [
                                        "children",
                                        "" + a
                                    ]) : L.hasOwnProperty(c) && null != a && cn(n, c);
                                }
                                switch(M){
                                    case "input":
                                        ye(i), Ce(i, o, !0);
                                        break;
                                    case "textarea":
                                        ye(i), be(i);
                                        break;
                                    case "select":
                                    case "option":
                                        break;
                                    default:
                                        "function" == typeof o.onClick && (i.onclick = an);
                                }
                                n = e, t.updateQueue = n, null !== n && (t.effectTag |= 4);
                            } else {
                                switch(c = 9 === n.nodeType ? n : n.ownerDocument, e === on && (e = Qe(M)), e === on ? "script" === M ? ((e = c.createElement("div")).innerHTML = "<script></script>", e = e.removeChild(e.firstChild)) : "string" == typeof i.is ? e = c.createElement(M, {
                                    is: i.is
                                }) : (e = c.createElement(M), "select" === M && (c = e, i.multiple ? c.multiple = !0 : i.size && (c.size = i.size))) : e = c.createElementNS(e, M), e[Ln] = t, e[En] = i, Uu(e, t), t.stateNode = e, c = un(M, i), M){
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        Jt("load", e), a = i;
                                        break;
                                    case "video":
                                    case "audio":
                                        for(a = 0; a < Ke.length; a++)Jt(Ke[a], e);
                                        a = i;
                                        break;
                                    case "source":
                                        Jt("error", e), a = i;
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        Jt("error", e), Jt("load", e), a = i;
                                        break;
                                    case "form":
                                        Jt("reset", e), Jt("submit", e), a = i;
                                        break;
                                    case "details":
                                        Jt("toggle", e), a = i;
                                        break;
                                    case "input":
                                        fe(e, i), a = we(e, i), Jt("invalid", e), cn(n, "onChange");
                                        break;
                                    case "option":
                                        a = pe(e, i);
                                        break;
                                    case "select":
                                        e._wrapperState = {
                                            wasMultiple: !!i.multiple
                                        }, a = r({}, i, {
                                            value: void 0
                                        }), Jt("invalid", e), cn(n, "onChange");
                                        break;
                                    case "textarea":
                                        Oe(e, i), a = me(e, i), Jt("invalid", e), cn(n, "onChange");
                                        break;
                                    default:
                                        a = i;
                                }
                                Mn(M, a);
                                var I = a;
                                for(o in I)if (I.hasOwnProperty(o)) {
                                    var l = I[o];
                                    "style" === o ? nn(e, l) : "dangerouslySetInnerHTML" === o ? null != (l = l ? l.__html : void 0) && Ue(e, l) : "children" === o ? "string" == typeof l ? ("textarea" !== M || "" !== l) && Ze(e, l) : "number" == typeof l && Ze(e, "" + l) : "suppressContentEditableWarning" !== o && "suppressHydrationWarning" !== o && "autoFocus" !== o && (L.hasOwnProperty(o) ? null != l && cn(n, o) : null != l && q(e, o, l, c));
                                }
                                switch(M){
                                    case "input":
                                        ye(e), Ce(e, i, !1);
                                        break;
                                    case "textarea":
                                        ye(e), be(e);
                                        break;
                                    case "option":
                                        null != i.value && e.setAttribute("value", "" + de(i.value));
                                        break;
                                    case "select":
                                        e.multiple = !!i.multiple, null != (n = i.value) ? Se(e, !!i.multiple, n, !1) : null != i.defaultValue && Se(e, !!i.multiple, i.defaultValue, !0);
                                        break;
                                    default:
                                        "function" == typeof a.onClick && (e.onclick = an);
                                }
                                Dn(M, i) && (t.effectTag |= 4);
                            }
                            null !== t.ref && (t.effectTag |= 128);
                        }
                        return null;
                    case 6:
                        if (e && null != t.stateNode) Gu(0, t, e.memoizedProps, i);
                        else {
                            if ("string" != typeof i && null === t.stateNode) throw Error(u(166));
                            n = mM(SM.current), mM(xM.current), Cu(t) ? (n = t.stateNode, i = t.memoizedProps, n[Ln] = t, n.nodeValue !== i && (t.effectTag |= 4)) : ((n = (9 === n.nodeType ? n : n.ownerDocument).createTextNode(i))[Ln] = t, t.stateNode = n);
                        }
                        return null;
                    case 13:
                        return cr(kM), i = t.memoizedState, 0 != (64 & t.effectTag) ? (t.expirationTime = n, t) : (n = null !== i, i = !1, null === e ? void 0 !== t.memoizedProps.fallback && Cu(t) : (i = null !== (M = e.memoizedState), n || null === M || null !== (M = e.child.sibling) && (null !== (o = t.firstEffect) ? (t.firstEffect = M, M.nextEffect = o) : (t.firstEffect = t.lastEffect = M, M.nextEffect = null), M.effectTag = 8)), n && !i && 0 != (2 & t.mode) && (null === e && !0 !== t.memoizedProps.unstable_avoidThisFallback || 0 != (1 & kM.current) ? xo === yo && (xo = zo) : (xo !== yo && xo !== zo || (xo = wo), 0 !== vo && null !== Lo && (bc(Lo, Co), hc(Lo, vo)))), (n || i) && (t.effectTag |= 4), null);
                    case 4:
                        return vM(), null;
                    case 10:
                        return eM(t), null;
                    case 17:
                        return sr(t.type) && Ar(), null;
                    case 19:
                        if (cr(kM), null === (i = t.memoizedState)) return null;
                        if (M = 0 != (64 & t.effectTag), null === (o = i.rendering)) {
                            if (M) Fu(i, !1);
                            else if (xo !== yo || null !== e && 0 != (64 & e.effectTag)) for(o = t.child; null !== o;){
                                if (null !== (e = QM(o))) {
                                    for(t.effectTag |= 64, Fu(i, !1), null !== (M = e.updateQueue) && (t.updateQueue = M, t.effectTag |= 4), null === i.lastEffect && (t.firstEffect = null), t.lastEffect = i.lastEffect, i = t.child; null !== i;)o = n, (M = i).effectTag &= 2, M.nextEffect = null, M.firstEffect = null, M.lastEffect = null, null === (e = M.alternate) ? (M.childExpirationTime = 0, M.expirationTime = o, M.child = null, M.memoizedProps = null, M.memoizedState = null, M.updateQueue = null, M.dependencies = null) : (M.childExpirationTime = e.childExpirationTime, M.expirationTime = e.expirationTime, M.child = e.child, M.memoizedProps = e.memoizedProps, M.memoizedState = e.memoizedState, M.updateQueue = e.updateQueue, o = e.dependencies, M.dependencies = null === o ? null : {
                                        expirationTime: o.expirationTime,
                                        firstContext: o.firstContext,
                                        responders: o.responders
                                    }), i = i.sibling;
                                    return ar(kM, 1 & kM.current | 2), t.child;
                                }
                                o = o.sibling;
                            }
                        } else {
                            if (!M) {
                                if (null !== (e = QM(o))) {
                                    if (t.effectTag |= 64, M = !0, null !== (n = e.updateQueue) && (t.updateQueue = n, t.effectTag |= 4), Fu(i, !0), null === i.tail && "hidden" === i.tailMode && !o.alternate) return null !== (t = t.lastEffect = i.lastEffect) && (t.nextEffect = null), null;
                                } else 2 * Ur() - i.renderingStartTime > i.tailExpiration && 1 < n && (t.effectTag |= 64, M = !0, Fu(i, !1), t.expirationTime = t.childExpirationTime = n - 1);
                            }
                            i.isBackwards ? (o.sibling = t.child, t.child = o) : (null !== (n = i.last) ? n.sibling = o : t.child = o, i.last = o);
                        }
                        return null !== i.tail ? (0 === i.tailExpiration && (i.tailExpiration = Ur() + 500), n = i.tail, i.rendering = n, i.tail = n.sibling, i.lastEffect = t.lastEffect, i.renderingStartTime = Ur(), n.sibling = null, t = kM.current, ar(kM, M ? 1 & t | 2 : 1 & t), n) : null;
                }
                throw Error(u(156, t.tag));
            }
            function Ku(e) {
                switch(e.tag){
                    case 1:
                        sr(e.type) && Ar();
                        var t = e.effectTag;
                        return 4096 & t ? (e.effectTag = -4097 & t | 64, e) : null;
                    case 3:
                        if (vM(), cr(Nr), cr(lr), 0 != (64 & (t = e.effectTag))) throw Error(u(285));
                        return e.effectTag = -4097 & t | 64, e;
                    case 5:
                        return hM(e), null;
                    case 13:
                        return cr(kM), 4096 & (t = e.effectTag) ? (e.effectTag = -4097 & t | 64, e) : null;
                    case 19:
                        return cr(kM), null;
                    case 4:
                        return vM(), null;
                    case 10:
                        return eM(e), null;
                    default:
                        return null;
                }
            }
            function qu(e, t) {
                return {
                    value: e,
                    source: t,
                    stack: De(t)
                };
            }
            Uu = function(e, t) {
                for(var n = t.child; null !== n;){
                    if (5 === n.tag || 6 === n.tag) e.appendChild(n.stateNode);
                    else if (4 !== n.tag && null !== n.child) {
                        n.child.return = n, n = n.child;
                        continue;
                    }
                    if (n === t) break;
                    for(; null === n.sibling;){
                        if (null === n.return || n.return === t) return;
                        n = n.return;
                    }
                    n.sibling.return = n.return, n = n.sibling;
                }
            }, Zu = function(e, t, n, i, M) {
                var u = e.memoizedProps;
                if (u !== i) {
                    var o, c, a = t.stateNode;
                    switch(mM(xM.current), e = null, n){
                        case "input":
                            u = we(a, u), i = we(a, i), e = [];
                            break;
                        case "option":
                            u = pe(a, u), i = pe(a, i), e = [];
                            break;
                        case "select":
                            u = r({}, u, {
                                value: void 0
                            }), i = r({}, i, {
                                value: void 0
                            }), e = [];
                            break;
                        case "textarea":
                            u = me(a, u), i = me(a, i), e = [];
                            break;
                        default:
                            "function" != typeof u.onClick && "function" == typeof i.onClick && (a.onclick = an);
                    }
                    for(o in Mn(n, i), n = null, u)if (!i.hasOwnProperty(o) && u.hasOwnProperty(o) && null != u[o]) {
                        if ("style" === o) for(c in a = u[o])a.hasOwnProperty(c) && (n || (n = {}), n[c] = "");
                        else "dangerouslySetInnerHTML" !== o && "children" !== o && "suppressContentEditableWarning" !== o && "suppressHydrationWarning" !== o && "autoFocus" !== o && (L.hasOwnProperty(o) ? e || (e = []) : (e = e || []).push(o, null));
                    }
                    for(o in i){
                        var I = i[o];
                        if (a = null != u ? u[o] : void 0, i.hasOwnProperty(o) && I !== a && (null != I || null != a)) {
                            if ("style" === o) {
                                if (a) {
                                    for(c in a)!a.hasOwnProperty(c) || I && I.hasOwnProperty(c) || (n || (n = {}), n[c] = "");
                                    for(c in I)I.hasOwnProperty(c) && a[c] !== I[c] && (n || (n = {}), n[c] = I[c]);
                                } else n || (e || (e = []), e.push(o, n)), n = I;
                            } else "dangerouslySetInnerHTML" === o ? (I = I ? I.__html : void 0, a = a ? a.__html : void 0, null != I && a !== I && (e = e || []).push(o, I)) : "children" === o ? a === I || "string" != typeof I && "number" != typeof I || (e = e || []).push(o, "" + I) : "suppressContentEditableWarning" !== o && "suppressHydrationWarning" !== o && (L.hasOwnProperty(o) ? (null != I && cn(M, o), e || a === I || (e = [])) : (e = e || []).push(o, I));
                        }
                    }
                    n && (e = e || []).push("style", n), M = e, (t.updateQueue = M) && (t.effectTag |= 4);
                }
            }, Gu = function(e, t, n, i) {
                n !== i && (t.effectTag |= 4);
            };
            var _u = "function" == typeof WeakSet ? WeakSet : Set;
            function $u(e, t) {
                var n = t.source, i = t.stack;
                null === i && null !== n && (i = De(n)), null !== n && Ae(n.type), t = t.value, null !== e && 1 === e.tag && Ae(e.type);
                try {
                    console.error(t);
                } catch (e) {
                    setTimeout(function() {
                        throw e;
                    });
                }
            }
            function eo(e) {
                var t = e.ref;
                if (null !== t) {
                    if ("function" == typeof t) try {
                        t(null);
                    } catch (t) {
                        dc(e, t);
                    }
                    else t.current = null;
                }
            }
            function to(e, t) {
                switch(t.tag){
                    case 0:
                    case 11:
                    case 15:
                    case 22:
                        return;
                    case 1:
                        if (256 & t.effectTag && null !== e) {
                            var n = e.memoizedProps, i = e.memoizedState;
                            t = (e = t.stateNode).getSnapshotBeforeUpdate(t.elementType === t.type ? n : Fr(t.type, n), i), e.__reactInternalSnapshotBeforeUpdate = t;
                        }
                        return;
                    case 3:
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                        return;
                }
                throw Error(u(163));
            }
            function no(e, t) {
                if (null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)) {
                    var n = t = t.next;
                    do {
                        if ((n.tag & e) === e) {
                            var i = n.destroy;
                            n.destroy = void 0, void 0 !== i && i();
                        }
                        n = n.next;
                    }while (n !== t);
                }
            }
            function io(e, t) {
                if (null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)) {
                    var n = t = t.next;
                    do {
                        if ((n.tag & e) === e) {
                            var i = n.create;
                            n.destroy = i();
                        }
                        n = n.next;
                    }while (n !== t);
                }
            }
            function ro(e, t, n) {
                switch(n.tag){
                    case 0:
                    case 11:
                    case 15:
                    case 22:
                        return void io(3, n);
                    case 1:
                        if (e = n.stateNode, 4 & n.effectTag) {
                            if (null === t) e.componentDidMount();
                            else {
                                var i = n.elementType === n.type ? t.memoizedProps : Fr(n.type, t.memoizedProps);
                                e.componentDidUpdate(i, t.memoizedState, e.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        return void (null !== (t = n.updateQueue) && lM(n, t, e));
                    case 3:
                        if (null !== (t = n.updateQueue)) {
                            if (e = null, null !== n.child) switch(n.child.tag){
                                case 5:
                                    e = n.child.stateNode;
                                    break;
                                case 1:
                                    e = n.child.stateNode;
                            }
                            lM(n, t, e);
                        }
                        return;
                    case 5:
                        return e = n.stateNode, void (null === t && 4 & n.effectTag && Dn(n.type, n.memoizedProps) && e.focus());
                    case 6:
                    case 4:
                    case 12:
                        return;
                    case 13:
                        return void (null === n.memoizedState && (n = n.alternate, null !== n && (n = n.memoizedState, null !== n && (n = n.dehydrated, null !== n && Qt(n)))));
                    case 19:
                    case 17:
                    case 20:
                    case 21:
                        return;
                }
                throw Error(u(163));
            }
            function Mo(e, t, n) {
                switch("function" == typeof wc && wc(t), t.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                    case 22:
                        if (null !== (e = t.updateQueue) && null !== (e = e.lastEffect)) {
                            var i = e.next;
                            Br(97 < n ? 97 : n, function() {
                                var e = i;
                                do {
                                    var n = e.destroy;
                                    if (void 0 !== n) {
                                        var r = t;
                                        try {
                                            n();
                                        } catch (e) {
                                            dc(r, e);
                                        }
                                    }
                                    e = e.next;
                                }while (e !== i);
                            });
                        }
                        break;
                    case 1:
                        eo(t), "function" == typeof (n = t.stateNode).componentWillUnmount && function(e, t) {
                            try {
                                t.props = e.memoizedProps, t.state = e.memoizedState, t.componentWillUnmount();
                            } catch (t) {
                                dc(e, t);
                            }
                        }(t, n);
                        break;
                    case 5:
                        eo(t);
                        break;
                    case 4:
                        ao(e, t, n);
                }
            }
            function uo(e) {
                var t = e.alternate;
                e.return = null, e.child = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.alternate = null, e.firstEffect = null, e.lastEffect = null, e.pendingProps = null, e.memoizedProps = null, e.stateNode = null, null !== t && uo(t);
            }
            function oo(e) {
                return 5 === e.tag || 3 === e.tag || 4 === e.tag;
            }
            function co(e) {
                e: {
                    for(var t = e.return; null !== t;){
                        if (oo(t)) {
                            var n = t;
                            break e;
                        }
                        t = t.return;
                    }
                    throw Error(u(160));
                }
                switch(t = n.stateNode, n.tag){
                    case 5:
                        var i = !1;
                        break;
                    case 3:
                    case 4:
                        t = t.containerInfo, i = !0;
                        break;
                    default:
                        throw Error(u(161));
                }
                16 & n.effectTag && (Ze(t, ""), n.effectTag &= -17);
                e: t: for(n = e;;){
                    for(; null === n.sibling;){
                        if (null === n.return || oo(n.return)) {
                            n = null;
                            break e;
                        }
                        n = n.return;
                    }
                    for(n.sibling.return = n.return, n = n.sibling; 5 !== n.tag && 6 !== n.tag && 18 !== n.tag;){
                        if (2 & n.effectTag) continue t;
                        if (null === n.child || 4 === n.tag) continue t;
                        n.child.return = n, n = n.child;
                    }
                    if (!(2 & n.effectTag)) {
                        n = n.stateNode;
                        break e;
                    }
                }
                i ? function e(t, n, i) {
                    var r = t.tag, M = 5 === r || 6 === r;
                    if (M) t = M ? t.stateNode : t.stateNode.instance, n ? 8 === i.nodeType ? i.parentNode.insertBefore(t, n) : i.insertBefore(t, n) : (8 === i.nodeType ? (n = i.parentNode).insertBefore(t, i) : (n = i).appendChild(t), null !== (i = i._reactRootContainer) && void 0 !== i || null !== n.onclick || (n.onclick = an));
                    else if (4 !== r && null !== (t = t.child)) for(e(t, n, i), t = t.sibling; null !== t;)e(t, n, i), t = t.sibling;
                }(e, n, t) : function e(t, n, i) {
                    var r = t.tag, M = 5 === r || 6 === r;
                    if (M) t = M ? t.stateNode : t.stateNode.instance, n ? i.insertBefore(t, n) : i.appendChild(t);
                    else if (4 !== r && null !== (t = t.child)) for(e(t, n, i), t = t.sibling; null !== t;)e(t, n, i), t = t.sibling;
                }(e, n, t);
            }
            function ao(e, t, n) {
                for(var i, r, M = t, o = !1;;){
                    if (!o) {
                        o = M.return;
                        e: for(;;){
                            if (null === o) throw Error(u(160));
                            switch(i = o.stateNode, o.tag){
                                case 5:
                                    r = !1;
                                    break e;
                                case 3:
                                case 4:
                                    i = i.containerInfo, r = !0;
                                    break e;
                            }
                            o = o.return;
                        }
                        o = !0;
                    }
                    if (5 === M.tag || 6 === M.tag) {
                        e: for(var c = e, a = M, I = n, l = a;;)if (Mo(c, l, I), null !== l.child && 4 !== l.tag) l.child.return = l, l = l.child;
                        else {
                            if (l === a) break e;
                            for(; null === l.sibling;){
                                if (null === l.return || l.return === a) break e;
                                l = l.return;
                            }
                            l.sibling.return = l.return, l = l.sibling;
                        }
                        r ? (c = i, a = M.stateNode, 8 === c.nodeType ? c.parentNode.removeChild(a) : c.removeChild(a)) : i.removeChild(M.stateNode);
                    } else if (4 === M.tag) {
                        if (null !== M.child) {
                            i = M.stateNode.containerInfo, r = !0, M.child.return = M, M = M.child;
                            continue;
                        }
                    } else if (Mo(e, M, n), null !== M.child) {
                        M.child.return = M, M = M.child;
                        continue;
                    }
                    if (M === t) break;
                    for(; null === M.sibling;){
                        if (null === M.return || M.return === t) return;
                        4 === (M = M.return).tag && (o = !1);
                    }
                    M.sibling.return = M.return, M = M.sibling;
                }
            }
            function Io(e, t) {
                switch(t.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                    case 22:
                        return void no(3, t);
                    case 1:
                        return;
                    case 5:
                        var n = t.stateNode;
                        if (null != n) {
                            var i = t.memoizedProps, r = null !== e ? e.memoizedProps : i;
                            e = t.type;
                            var M = t.updateQueue;
                            if (t.updateQueue = null, null !== M) {
                                for(n[En] = i, "input" === e && "radio" === i.type && null != i.name && Le(n, i), un(e, r), t = un(e, i), r = 0; r < M.length; r += 2){
                                    var o = M[r], c = M[r + 1];
                                    "style" === o ? nn(n, c) : "dangerouslySetInnerHTML" === o ? Ue(n, c) : "children" === o ? Ze(n, c) : q(n, o, c, t);
                                }
                                switch(e){
                                    case "input":
                                        Ee(n, i);
                                        break;
                                    case "textarea":
                                        ve(n, i);
                                        break;
                                    case "select":
                                        t = n._wrapperState.wasMultiple, n._wrapperState.wasMultiple = !!i.multiple, null != (e = i.value) ? Se(n, !!i.multiple, e, !1) : t !== !!i.multiple && (null != i.defaultValue ? Se(n, !!i.multiple, i.defaultValue, !0) : Se(n, !!i.multiple, i.multiple ? [] : "", !1));
                                }
                            }
                        }
                        return;
                    case 6:
                        if (null === t.stateNode) throw Error(u(162));
                        return void (t.stateNode.nodeValue = t.memoizedProps);
                    case 3:
                        return void ((t = t.stateNode).hydrate && (t.hydrate = !1, Qt(t.containerInfo)));
                    case 12:
                        return;
                    case 13:
                        if (n = t, null === t.memoizedState ? i = !1 : (i = !0, n = t.child, ho = Ur()), null !== n) e: for(e = n;;){
                            if (5 === e.tag) M = e.stateNode, i ? "function" == typeof (M = M.style).setProperty ? M.setProperty("display", "none", "important") : M.display = "none" : (M = e.stateNode, r = null != (r = e.memoizedProps.style) && r.hasOwnProperty("display") ? r.display : null, M.style.display = tn("display", r));
                            else if (6 === e.tag) e.stateNode.nodeValue = i ? "" : e.memoizedProps;
                            else {
                                if (13 === e.tag && null !== e.memoizedState && null === e.memoizedState.dehydrated) {
                                    (M = e.child.sibling).return = e, e = M;
                                    continue;
                                }
                                if (null !== e.child) {
                                    e.child.return = e, e = e.child;
                                    continue;
                                }
                            }
                            if (e === n) break;
                            for(; null === e.sibling;){
                                if (null === e.return || e.return === n) break e;
                                e = e.return;
                            }
                            e.sibling.return = e.return, e = e.sibling;
                        }
                        return void lo(t);
                    case 19:
                        return void lo(t);
                    case 17:
                        return;
                }
                throw Error(u(163));
            }
            function lo(e) {
                var t = e.updateQueue;
                if (null !== t) {
                    e.updateQueue = null;
                    var n = e.stateNode;
                    null === n && (n = e.stateNode = new _u), t.forEach(function(t) {
                        var i = yc.bind(null, e, t);
                        n.has(t) || (n.add(t), t.then(i, i));
                    });
                }
            }
            var No = "function" == typeof WeakMap ? WeakMap : Map;
            function jo(e, t, n) {
                (n = oM(n, null)).tag = 3, n.payload = {
                    element: null
                };
                var i = t.value;
                return n.callback = function() {
                    Qo || (Qo = !0, Yo = i), $u(e, t);
                }, n;
            }
            function go(e, t, n) {
                (n = oM(n, null)).tag = 3;
                var i = e.type.getDerivedStateFromError;
                if ("function" == typeof i) {
                    var r = t.value;
                    n.payload = function() {
                        return $u(e, t), i(r);
                    };
                }
                var M = e.stateNode;
                return null !== M && "function" == typeof M.componentDidCatch && (n.callback = function() {
                    "function" != typeof i && (null === Po ? Po = new Set([
                        this
                    ]) : Po.add(this), $u(e, t));
                    var n = t.stack;
                    this.componentDidCatch(t.value, {
                        componentStack: null !== n ? n : ""
                    });
                }), n;
            }
            var so, Ao = Math.ceil, Do = K.ReactCurrentDispatcher, To = K.ReactCurrentOwner, yo = 0, zo = 3, wo = 4, fo = 0, Lo = null, Eo = null, Co = 0, xo = yo, po = null, So = 1073741823, mo = 1073741823, Oo = null, vo = 0, bo = !1, ho = 0, ko = null, Qo = !1, Yo = null, Po = null, Uo = !1, Zo = null, Go = 90, Bo = null, Ro = 0, Wo = null, Ho = 0;
            function Vo() {
                return 0 != (48 & fo) ? 1073741821 - (Ur() / 10 | 0) : 0 !== Ho ? Ho : Ho = 1073741821 - (Ur() / 10 | 0);
            }
            function Jo(e, t, n) {
                if (0 == (2 & (t = t.mode))) return 1073741823;
                var i = Zr();
                if (0 == (4 & t)) return 99 === i ? 1073741823 : 1073741822;
                if (0 != (16 & fo)) return Co;
                if (null !== n) e = Jr(e, 0 | n.timeoutMs || 5e3, 250);
                else switch(i){
                    case 99:
                        e = 1073741823;
                        break;
                    case 98:
                        e = Jr(e, 150, 100);
                        break;
                    case 97:
                    case 96:
                        e = Jr(e, 5e3, 250);
                        break;
                    case 95:
                        e = 2;
                        break;
                    default:
                        throw Error(u(326));
                }
                return null !== Lo && e === Co && --e, e;
            }
            function Fo(e, t) {
                if (50 < Ro) throw Ro = 0, Wo = null, Error(u(185));
                if (null !== (e = Xo(e, t))) {
                    var n = Zr();
                    1073741823 === t ? 0 != (8 & fo) && 0 == (48 & fo) ? $o(e) : (qo(e), 0 === fo && Hr()) : qo(e), 0 == (4 & fo) || 98 !== n && 99 !== n || (null === Bo ? Bo = new Map([
                        [
                            e,
                            t
                        ]
                    ]) : (void 0 === (n = Bo.get(e)) || n > t) && Bo.set(e, t));
                }
            }
            function Xo(e, t) {
                e.expirationTime < t && (e.expirationTime = t);
                var n = e.alternate;
                null !== n && n.expirationTime < t && (n.expirationTime = t);
                var i = e.return, r = null;
                if (null === i && 3 === e.tag) r = e.stateNode;
                else for(; null !== i;){
                    if (n = i.alternate, i.childExpirationTime < t && (i.childExpirationTime = t), null !== n && n.childExpirationTime < t && (n.childExpirationTime = t), null === i.return && 3 === i.tag) {
                        r = i.stateNode;
                        break;
                    }
                    i = i.return;
                }
                return null !== r && (Lo === r && (uc(t), xo === wo && bc(r, Co)), hc(r, t)), r;
            }
            function Ko(e) {
                var t = e.lastExpiredTime;
                if (0 !== t) return t;
                if (!vc(e, t = e.firstPendingTime)) return t;
                var n = e.lastPingedTime;
                return 2 >= (e = n > (e = e.nextKnownPendingLevel) ? n : e) && t !== e ? 0 : e;
            }
            function qo(e) {
                if (0 !== e.lastExpiredTime) e.callbackExpirationTime = 1073741823, e.callbackPriority = 99, e.callbackNode = Wr($o.bind(null, e));
                else {
                    var t = Ko(e), n = e.callbackNode;
                    if (0 === t) null !== n && (e.callbackNode = null, e.callbackExpirationTime = 0, e.callbackPriority = 90);
                    else {
                        var i = Vo();
                        if (1073741823 === t ? i = 99 : 1 === t || 2 === t ? i = 95 : i = 0 >= (i = 10 * (1073741821 - t) - 10 * (1073741821 - i)) ? 99 : 250 >= i ? 98 : 5250 >= i ? 97 : 95, null !== n) {
                            var r = e.callbackPriority;
                            if (e.callbackExpirationTime === t && r >= i) return;
                            n !== vr && fr(n);
                        }
                        e.callbackExpirationTime = t, e.callbackPriority = i, t = 1073741823 === t ? Wr($o.bind(null, e)) : Rr(i, _o.bind(null, e), {
                            timeout: 10 * (1073741821 - t) - Ur()
                        }), e.callbackNode = t;
                    }
                }
            }
            function _o(e, t) {
                if (Ho = 0, t) return kc(e, t = Vo()), qo(e), null;
                var n = Ko(e);
                if (0 !== n) {
                    if (t = e.callbackNode, 0 != (48 & fo)) throw Error(u(327));
                    if (sc(), e === Lo && n === Co || nc(e, n), null !== Eo) {
                        var i = fo;
                        fo |= 16;
                        for(var r = rc();;)try {
                            cc();
                            break;
                        } catch (t) {
                            ic(e, t);
                        }
                        if ($r(), fo = i, Do.current = r, 1 === xo) throw t = po, nc(e, n), bc(e, n), qo(e), t;
                        if (null === Eo) switch(r = e.finishedWork = e.current.alternate, e.finishedExpirationTime = n, i = xo, Lo = null, i){
                            case yo:
                            case 1:
                                throw Error(u(345));
                            case 2:
                                kc(e, 2 < n ? 2 : n);
                                break;
                            case zo:
                                if (bc(e, n), n === (i = e.lastSuspendedTime) && (e.nextKnownPendingLevel = lc(r)), 1073741823 === So && 10 < (r = ho + 500 - Ur())) {
                                    if (bo) {
                                        var M = e.lastPingedTime;
                                        if (0 === M || M >= n) {
                                            e.lastPingedTime = n, nc(e, n);
                                            break;
                                        }
                                    }
                                    if (0 !== (M = Ko(e)) && M !== n) break;
                                    if (0 !== i && i !== n) {
                                        e.lastPingedTime = i;
                                        break;
                                    }
                                    e.timeoutHandle = Tn(Nc.bind(null, e), r);
                                    break;
                                }
                                Nc(e);
                                break;
                            case wo:
                                if (bc(e, n), n === (i = e.lastSuspendedTime) && (e.nextKnownPendingLevel = lc(r)), bo && (0 === (r = e.lastPingedTime) || r >= n)) {
                                    e.lastPingedTime = n, nc(e, n);
                                    break;
                                }
                                if (0 !== (r = Ko(e)) && r !== n) break;
                                if (0 !== i && i !== n) {
                                    e.lastPingedTime = i;
                                    break;
                                }
                                if (1073741823 !== mo ? i = 10 * (1073741821 - mo) - Ur() : 1073741823 === So ? i = 0 : (i = 10 * (1073741821 - So) - 5e3, 0 > (i = (r = Ur()) - i) && (i = 0), (n = 10 * (1073741821 - n) - r) < (i = (120 > i ? 120 : 480 > i ? 480 : 1080 > i ? 1080 : 1920 > i ? 1920 : 3e3 > i ? 3e3 : 4320 > i ? 4320 : 1960 * Ao(i / 1960)) - i) && (i = n)), 10 < i) {
                                    e.timeoutHandle = Tn(Nc.bind(null, e), i);
                                    break;
                                }
                                Nc(e);
                                break;
                            case 5:
                                if (1073741823 !== So && null !== Oo) {
                                    M = So;
                                    var o = Oo;
                                    if (0 >= (i = 0 | o.busyMinDurationMs) ? i = 0 : (r = 0 | o.busyDelayMs, i = (M = Ur() - (10 * (1073741821 - M) - (0 | o.timeoutMs || 5e3))) <= r ? 0 : r + i - M), 10 < i) {
                                        bc(e, n), e.timeoutHandle = Tn(Nc.bind(null, e), i);
                                        break;
                                    }
                                }
                                Nc(e);
                                break;
                            default:
                                throw Error(u(329));
                        }
                        if (qo(e), e.callbackNode === t) return _o.bind(null, e);
                    }
                }
                return null;
            }
            function $o(e) {
                var t = e.lastExpiredTime;
                if (t = 0 !== t ? t : 1073741823, 0 != (48 & fo)) throw Error(u(327));
                if (sc(), e === Lo && t === Co || nc(e, t), null !== Eo) {
                    var n = fo;
                    fo |= 16;
                    for(var i = rc();;)try {
                        oc();
                        break;
                    } catch (t) {
                        ic(e, t);
                    }
                    if ($r(), fo = n, Do.current = i, 1 === xo) throw n = po, nc(e, t), bc(e, t), qo(e), n;
                    if (null !== Eo) throw Error(u(261));
                    e.finishedWork = e.current.alternate, e.finishedExpirationTime = t, Lo = null, Nc(e), qo(e);
                }
                return null;
            }
            function ec(e, t) {
                var n = fo;
                fo |= 1;
                try {
                    return e(t);
                } finally{
                    0 === (fo = n) && Hr();
                }
            }
            function tc(e, t) {
                var n = fo;
                fo &= -2, fo |= 8;
                try {
                    return e(t);
                } finally{
                    0 === (fo = n) && Hr();
                }
            }
            function nc(e, t) {
                e.finishedWork = null, e.finishedExpirationTime = 0;
                var n = e.timeoutHandle;
                if (-1 !== n && (e.timeoutHandle = -1, yn(n)), null !== Eo) for(n = Eo.return; null !== n;){
                    var i = n;
                    switch(i.tag){
                        case 1:
                            null != (i = i.type.childContextTypes) && Ar();
                            break;
                        case 3:
                            vM(), cr(Nr), cr(lr);
                            break;
                        case 5:
                            hM(i);
                            break;
                        case 4:
                            vM();
                            break;
                        case 13:
                        case 19:
                            cr(kM);
                            break;
                        case 10:
                            eM(i);
                    }
                    n = n.return;
                }
                Lo = e, Eo = Cc(e.current, null), Co = t, xo = yo, po = null, mo = So = 1073741823, Oo = null, vo = 0, bo = !1;
            }
            function ic(e, t) {
                for(;;){
                    try {
                        if ($r(), PM.current = su, WM) for(var n = GM.memoizedState; null !== n;){
                            var i = n.queue;
                            null !== i && (i.pending = null), n = n.next;
                        }
                        if (ZM = 0, RM = BM = GM = null, WM = !1, null === Eo || null === Eo.return) return xo = 1, po = t, Eo = null;
                        e: {
                            var r = e, M = Eo.return, u = Eo, o = t;
                            if (t = Co, u.effectTag |= 2048, u.firstEffect = u.lastEffect = null, null !== o && "object" == typeof o && "function" == typeof o.then) {
                                var c = o;
                                if (0 == (2 & u.mode)) {
                                    var a = u.alternate;
                                    a ? (u.updateQueue = a.updateQueue, u.memoizedState = a.memoizedState, u.expirationTime = a.expirationTime) : (u.updateQueue = null, u.memoizedState = null);
                                }
                                var I = 0 != (1 & kM.current), l = M;
                                do {
                                    var N;
                                    if (N = 13 === l.tag) {
                                        var j = l.memoizedState;
                                        if (null !== j) N = null !== j.dehydrated;
                                        else {
                                            var g = l.memoizedProps;
                                            N = void 0 !== g.fallback && (!0 !== g.unstable_avoidThisFallback || !I);
                                        }
                                    }
                                    if (N) {
                                        var s = l.updateQueue;
                                        if (null === s) {
                                            var A = new Set;
                                            A.add(c), l.updateQueue = A;
                                        } else s.add(c);
                                        if (0 == (2 & l.mode)) {
                                            if (l.effectTag |= 64, u.effectTag &= -2981, 1 === u.tag) {
                                                if (null === u.alternate) u.tag = 17;
                                                else {
                                                    var D = oM(1073741823, null);
                                                    D.tag = 2, cM(u, D);
                                                }
                                            }
                                            u.expirationTime = 1073741823;
                                            break e;
                                        }
                                        o = void 0, u = t;
                                        var d = r.pingCache;
                                        if (null === d ? (d = r.pingCache = new No, o = new Set, d.set(c, o)) : void 0 === (o = d.get(c)) && (o = new Set, d.set(c, o)), !o.has(u)) {
                                            o.add(u);
                                            var T = Tc.bind(null, r, c, u);
                                            c.then(T, T);
                                        }
                                        l.effectTag |= 4096, l.expirationTime = t;
                                        break e;
                                    }
                                    l = l.return;
                                }while (null !== l);
                                o = Error((Ae(u.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + De(u));
                            }
                            5 !== xo && (xo = 2), o = qu(o, u), l = M;
                            do {
                                switch(l.tag){
                                    case 3:
                                        c = o, l.effectTag |= 4096, l.expirationTime = t, aM(l, jo(l, c, t));
                                        break e;
                                    case 1:
                                        c = o;
                                        var y = l.type, z = l.stateNode;
                                        if (0 == (64 & l.effectTag) && ("function" == typeof y.getDerivedStateFromError || null !== z && "function" == typeof z.componentDidCatch && (null === Po || !Po.has(z)))) {
                                            l.effectTag |= 4096, l.expirationTime = t, aM(l, go(l, c, t));
                                            break e;
                                        }
                                }
                                l = l.return;
                            }while (null !== l);
                        }
                        Eo = Ic(Eo);
                    } catch (e) {
                        t = e;
                        continue;
                    }
                    break;
                }
            }
            function rc() {
                var e = Do.current;
                return Do.current = su, null === e ? su : e;
            }
            function Mc(e, t) {
                e < So && 2 < e && (So = e), null !== t && e < mo && 2 < e && (mo = e, Oo = t);
            }
            function uc(e) {
                e > vo && (vo = e);
            }
            function oc() {
                for(; null !== Eo;)Eo = ac(Eo);
            }
            function cc() {
                for(; null !== Eo && !br();)Eo = ac(Eo);
            }
            function ac(e) {
                var t = so(e.alternate, e, Co);
                return e.memoizedProps = e.pendingProps, null === t && (t = Ic(e)), To.current = null, t;
            }
            function Ic(e) {
                Eo = e;
                do {
                    var t = Eo.alternate;
                    if (e = Eo.return, 0 == (2048 & Eo.effectTag)) {
                        if (t = Xu(t, Eo, Co), 1 === Co || 1 !== Eo.childExpirationTime) {
                            for(var n = 0, i = Eo.child; null !== i;){
                                var r = i.expirationTime, M = i.childExpirationTime;
                                r > n && (n = r), M > n && (n = M), i = i.sibling;
                            }
                            Eo.childExpirationTime = n;
                        }
                        if (null !== t) return t;
                        null !== e && 0 == (2048 & e.effectTag) && (null === e.firstEffect && (e.firstEffect = Eo.firstEffect), null !== Eo.lastEffect && (null !== e.lastEffect && (e.lastEffect.nextEffect = Eo.firstEffect), e.lastEffect = Eo.lastEffect), 1 < Eo.effectTag && (null !== e.lastEffect ? e.lastEffect.nextEffect = Eo : e.firstEffect = Eo, e.lastEffect = Eo));
                    } else {
                        if (null !== (t = Ku(Eo))) return t.effectTag &= 2047, t;
                        null !== e && (e.firstEffect = e.lastEffect = null, e.effectTag |= 2048);
                    }
                    if (null !== (t = Eo.sibling)) return t;
                    Eo = e;
                }while (null !== Eo);
                return xo === yo && (xo = 5), null;
            }
            function lc(e) {
                var t = e.expirationTime;
                return t > (e = e.childExpirationTime) ? t : e;
            }
            function Nc(e) {
                var t = Zr();
                return Br(99, jc.bind(null, e, t)), null;
            }
            function jc(e, t) {
                do sc();
                while (null !== Zo);
                if (0 != (48 & fo)) throw Error(u(327));
                var n = e.finishedWork, i = e.finishedExpirationTime;
                if (null === n) return null;
                if (e.finishedWork = null, e.finishedExpirationTime = 0, n === e.current) throw Error(u(177));
                e.callbackNode = null, e.callbackExpirationTime = 0, e.callbackPriority = 90, e.nextKnownPendingLevel = 0;
                var r = lc(n);
                if (e.firstPendingTime = r, i <= e.lastSuspendedTime ? e.firstSuspendedTime = e.lastSuspendedTime = e.nextKnownPendingLevel = 0 : i <= e.firstSuspendedTime && (e.firstSuspendedTime = i - 1), i <= e.lastPingedTime && (e.lastPingedTime = 0), i <= e.lastExpiredTime && (e.lastExpiredTime = 0), e === Lo && (Eo = Lo = null, Co = 0), 1 < n.effectTag ? null !== n.lastEffect ? (n.lastEffect.nextEffect = n, r = n.firstEffect) : r = n : r = n.firstEffect, null !== r) {
                    var M = fo;
                    fo |= 32, To.current = null, sn = Vt;
                    var o = jn();
                    if (gn(o)) {
                        if ("selectionStart" in o) var c = {
                            start: o.selectionStart,
                            end: o.selectionEnd
                        };
                        else e: {
                            var a = (c = (c = o.ownerDocument) && c.defaultView || window).getSelection && c.getSelection();
                            if (a && 0 !== a.rangeCount) {
                                c = a.anchorNode;
                                var I = a.anchorOffset, l = a.focusNode;
                                a = a.focusOffset;
                                try {
                                    c.nodeType, l.nodeType;
                                } catch (e) {
                                    c = null;
                                    break e;
                                }
                                var N = 0, j = -1, g = -1, s = 0, A = 0, D = o, d = null;
                                t: for(;;){
                                    for(var T; D !== c || 0 !== I && 3 !== D.nodeType || (j = N + I), D !== l || 0 !== a && 3 !== D.nodeType || (g = N + a), 3 === D.nodeType && (N += D.nodeValue.length), null !== (T = D.firstChild);)d = D, D = T;
                                    for(;;){
                                        if (D === o) break t;
                                        if (d === c && ++s === I && (j = N), d === l && ++A === a && (g = N), null !== (T = D.nextSibling)) break;
                                        d = (D = d).parentNode;
                                    }
                                    D = T;
                                }
                                c = -1 === j || -1 === g ? null : {
                                    start: j,
                                    end: g
                                };
                            } else c = null;
                        }
                        c = c || {
                            start: 0,
                            end: 0
                        };
                    } else c = null;
                    An = {
                        activeElementDetached: null,
                        focusedElem: o,
                        selectionRange: c
                    }, Vt = !1, ko = r;
                    do try {
                        gc();
                    } catch (e) {
                        if (null === ko) throw Error(u(330));
                        dc(ko, e), ko = ko.nextEffect;
                    }
                    while (null !== ko);
                    ko = r;
                    do try {
                        for(o = e, c = t; null !== ko;){
                            var y = ko.effectTag;
                            if (16 & y && Ze(ko.stateNode, ""), 128 & y) {
                                var z = ko.alternate;
                                if (null !== z) {
                                    var w = z.ref;
                                    null !== w && ("function" == typeof w ? w(null) : w.current = null);
                                }
                            }
                            switch(1038 & y){
                                case 2:
                                    co(ko), ko.effectTag &= -3;
                                    break;
                                case 6:
                                    co(ko), ko.effectTag &= -3, Io(ko.alternate, ko);
                                    break;
                                case 1024:
                                    ko.effectTag &= -1025;
                                    break;
                                case 1028:
                                    ko.effectTag &= -1025, Io(ko.alternate, ko);
                                    break;
                                case 4:
                                    Io(ko.alternate, ko);
                                    break;
                                case 8:
                                    ao(o, I = ko, c), uo(I);
                            }
                            ko = ko.nextEffect;
                        }
                    } catch (e) {
                        if (null === ko) throw Error(u(330));
                        dc(ko, e), ko = ko.nextEffect;
                    }
                    while (null !== ko);
                    if (w = An, z = jn(), y = w.focusedElem, c = w.selectionRange, z !== y && y && y.ownerDocument && function e(t, n) {
                        return !(!t || !n) && (t === n || (!t || 3 !== t.nodeType) && (n && 3 === n.nodeType ? e(t, n.parentNode) : "contains" in t ? t.contains(n) : !!t.compareDocumentPosition && !!(16 & t.compareDocumentPosition(n))));
                    }(y.ownerDocument.documentElement, y)) {
                        null !== c && gn(y) && (z = c.start, void 0 === (w = c.end) && (w = z), "selectionStart" in y ? (y.selectionStart = z, y.selectionEnd = Math.min(w, y.value.length)) : (w = (z = y.ownerDocument || document) && z.defaultView || window).getSelection && (w = w.getSelection(), I = y.textContent.length, o = Math.min(c.start, I), c = void 0 === c.end ? o : Math.min(c.end, I), !w.extend && o > c && (I = c, c = o, o = I), I = Nn(y, o), l = Nn(y, c), I && l && (1 !== w.rangeCount || w.anchorNode !== I.node || w.anchorOffset !== I.offset || w.focusNode !== l.node || w.focusOffset !== l.offset) && ((z = z.createRange()).setStart(I.node, I.offset), w.removeAllRanges(), o > c ? (w.addRange(z), w.extend(l.node, l.offset)) : (z.setEnd(l.node, l.offset), w.addRange(z))))), z = [];
                        for(w = y; w = w.parentNode;)1 === w.nodeType && z.push({
                            element: w,
                            left: w.scrollLeft,
                            top: w.scrollTop
                        });
                        for("function" == typeof y.focus && y.focus(), y = 0; y < z.length; y++)(w = z[y]).element.scrollLeft = w.left, w.element.scrollTop = w.top;
                    }
                    Vt = !!sn, An = sn = null, e.current = n, ko = r;
                    do try {
                        for(y = e; null !== ko;){
                            var f = ko.effectTag;
                            if (36 & f && ro(y, ko.alternate, ko), 128 & f) {
                                z = void 0;
                                var L = ko.ref;
                                if (null !== L) {
                                    var E = ko.stateNode;
                                    switch(ko.tag){
                                        case 5:
                                            z = E;
                                            break;
                                        default:
                                            z = E;
                                    }
                                    "function" == typeof L ? L(z) : L.current = z;
                                }
                            }
                            ko = ko.nextEffect;
                        }
                    } catch (e) {
                        if (null === ko) throw Error(u(330));
                        dc(ko, e), ko = ko.nextEffect;
                    }
                    while (null !== ko);
                    ko = null, hr(), fo = M;
                } else e.current = n;
                if (Uo) Uo = !1, Zo = e, Go = t;
                else for(ko = r; null !== ko;)t = ko.nextEffect, ko.nextEffect = null, ko = t;
                if (0 === (t = e.firstPendingTime) && (Po = null), 1073741823 === t ? e === Wo ? Ro++ : (Ro = 0, Wo = e) : Ro = 0, "function" == typeof zc && zc(n.stateNode, i), qo(e), Qo) throw Qo = !1, e = Yo, Yo = null, e;
                return 0 != (8 & fo) || Hr(), null;
            }
            function gc() {
                for(; null !== ko;){
                    var e = ko.effectTag;
                    0 != (256 & e) && to(ko.alternate, ko), 0 == (512 & e) || Uo || (Uo = !0, Rr(97, function() {
                        return sc(), null;
                    })), ko = ko.nextEffect;
                }
            }
            function sc() {
                if (90 !== Go) {
                    var e = 97 < Go ? 97 : Go;
                    return Go = 90, Br(e, Ac);
                }
            }
            function Ac() {
                if (null === Zo) return !1;
                var e = Zo;
                if (Zo = null, 0 != (48 & fo)) throw Error(u(331));
                var t = fo;
                for(fo |= 32, e = e.current.firstEffect; null !== e;){
                    try {
                        var n = e;
                        if (0 != (512 & n.effectTag)) switch(n.tag){
                            case 0:
                            case 11:
                            case 15:
                            case 22:
                                no(5, n), io(5, n);
                        }
                    } catch (t) {
                        if (null === e) throw Error(u(330));
                        dc(e, t);
                    }
                    n = e.nextEffect, e.nextEffect = null, e = n;
                }
                return fo = t, Hr(), !0;
            }
            function Dc(e, t, n) {
                cM(e, t = jo(e, t = qu(n, t), 1073741823)), null !== (e = Xo(e, 1073741823)) && qo(e);
            }
            function dc(e, t) {
                if (3 === e.tag) Dc(e, e, t);
                else for(var n = e.return; null !== n;){
                    if (3 === n.tag) {
                        Dc(n, e, t);
                        break;
                    }
                    if (1 === n.tag) {
                        var i = n.stateNode;
                        if ("function" == typeof n.type.getDerivedStateFromError || "function" == typeof i.componentDidCatch && (null === Po || !Po.has(i))) {
                            cM(n, e = go(n, e = qu(t, e), 1073741823)), null !== (n = Xo(n, 1073741823)) && qo(n);
                            break;
                        }
                    }
                    n = n.return;
                }
            }
            function Tc(e, t, n) {
                var i = e.pingCache;
                null !== i && i.delete(t), Lo === e && Co === n ? xo === wo || xo === zo && 1073741823 === So && Ur() - ho < 500 ? nc(e, Co) : bo = !0 : vc(e, n) && (0 !== (t = e.lastPingedTime) && t < n || (e.lastPingedTime = n, qo(e)));
            }
            function yc(e, t) {
                var n = e.stateNode;
                null !== n && n.delete(t), 0 === (t = 0) && (t = Jo(t = Vo(), e, null)), null !== (e = Xo(e, t)) && qo(e);
            }
            so = function(e, t, n) {
                var i = t.expirationTime;
                if (null !== e) {
                    var r = t.pendingProps;
                    if (e.memoizedProps !== r || Nr.current) Su = !0;
                    else {
                        if (i < n) {
                            switch(Su = !1, t.tag){
                                case 3:
                                    Pu(t), xu();
                                    break;
                                case 5:
                                    if (bM(t), 4 & t.mode && 1 !== n && r.hidden) return t.expirationTime = t.childExpirationTime = 1, null;
                                    break;
                                case 1:
                                    sr(t.type) && Tr(t);
                                    break;
                                case 4:
                                    OM(t, t.stateNode.containerInfo);
                                    break;
                                case 10:
                                    i = t.memoizedProps.value, r = t.type._context, ar(Xr, r._currentValue), r._currentValue = i;
                                    break;
                                case 13:
                                    if (null !== t.memoizedState) return 0 !== (i = t.child.childExpirationTime) && i >= n ? Ru(e, t, n) : (ar(kM, 1 & kM.current), null !== (t = Ju(e, t, n)) ? t.sibling : null);
                                    ar(kM, 1 & kM.current);
                                    break;
                                case 19:
                                    if (i = t.childExpirationTime >= n, 0 != (64 & e.effectTag)) {
                                        if (i) return Vu(e, t, n);
                                        t.effectTag |= 64;
                                    }
                                    if (null !== (r = t.memoizedState) && (r.rendering = null, r.tail = null), ar(kM, kM.current), !i) return null;
                            }
                            return Ju(e, t, n);
                        }
                        Su = !1;
                    }
                } else Su = !1;
                switch(t.expirationTime = 0, t.tag){
                    case 2:
                        if (i = t.type, null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), e = t.pendingProps, r = gr(t, lr.current), nM(t, n), r = JM(null, t, i, e, r, n), t.effectTag |= 1, "object" == typeof r && null !== r && "function" == typeof r.render && void 0 === r.$$typeof) {
                            if (t.tag = 1, t.memoizedState = null, t.updateQueue = null, sr(i)) {
                                var M = !0;
                                Tr(t);
                            } else M = !1;
                            t.memoizedState = null !== r.state && void 0 !== r.state ? r.state : null, MM(t);
                            var o = i.getDerivedStateFromProps;
                            "function" == typeof o && gM(t, i, o, e), r.updater = sM, t.stateNode = r, r._reactInternalFiber = t, TM(t, i, e, n), t = Yu(null, t, i, !0, M, n);
                        } else t.tag = 0, mu(null, t, r, n), t = t.child;
                        return t;
                    case 16:
                        e: {
                            if (r = t.elementType, null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), e = t.pendingProps, function(e) {
                                if (-1 === e._status) {
                                    e._status = 0;
                                    var t = e._ctor;
                                    t = t(), e._result = t, t.then(function(t) {
                                        0 === e._status && (t = t.default, e._status = 1, e._result = t);
                                    }, function(t) {
                                        0 === e._status && (e._status = 2, e._result = t);
                                    });
                                }
                            }(r), 1 !== r._status) throw r._result;
                            switch(r = r._result, t.type = r, M = t.tag = function(e) {
                                if ("function" == typeof e) return Ec(e) ? 1 : 0;
                                if (null != e) {
                                    if ((e = e.$$typeof) === ce) return 11;
                                    if (e === le) return 14;
                                }
                                return 2;
                            }(r), e = Fr(r, e), M){
                                case 0:
                                    t = ku(null, t, r, e, n);
                                    break e;
                                case 1:
                                    t = Qu(null, t, r, e, n);
                                    break e;
                                case 11:
                                    t = Ou(null, t, r, e, n);
                                    break e;
                                case 14:
                                    t = vu(null, t, r, Fr(r.type, e), i, n);
                                    break e;
                            }
                            throw Error(u(306, r, ""));
                        }
                        return t;
                    case 0:
                        return i = t.type, r = t.pendingProps, ku(e, t, i, r = t.elementType === i ? r : Fr(i, r), n);
                    case 1:
                        return i = t.type, r = t.pendingProps, Qu(e, t, i, r = t.elementType === i ? r : Fr(i, r), n);
                    case 3:
                        if (Pu(t), i = t.updateQueue, null === e || null === i) throw Error(u(282));
                        if (i = t.pendingProps, r = null !== (r = t.memoizedState) ? r.element : null, uM(e, t), IM(t, i, null, n), (i = t.memoizedState.element) === r) xu(), t = Ju(e, t, n);
                        else {
                            if ((r = t.stateNode.hydrate) && (yu = zn(t.stateNode.containerInfo.firstChild), Tu = t, r = zu = !0), r) for(n = EM(t, null, i, n), t.child = n; n;)n.effectTag = -3 & n.effectTag | 1024, n = n.sibling;
                            else mu(e, t, i, n), xu();
                            t = t.child;
                        }
                        return t;
                    case 5:
                        return bM(t), null === e && Lu(t), i = t.type, r = t.pendingProps, M = null !== e ? e.memoizedProps : null, o = r.children, dn(i, r) ? o = null : null !== M && dn(i, M) && (t.effectTag |= 16), hu(e, t), 4 & t.mode && 1 !== n && r.hidden ? (t.expirationTime = t.childExpirationTime = 1, t = null) : (mu(e, t, o, n), t = t.child), t;
                    case 6:
                        return null === e && Lu(t), null;
                    case 13:
                        return Ru(e, t, n);
                    case 4:
                        return OM(t, t.stateNode.containerInfo), i = t.pendingProps, null === e ? t.child = LM(t, null, i, n) : mu(e, t, i, n), t.child;
                    case 11:
                        return i = t.type, r = t.pendingProps, Ou(e, t, i, r = t.elementType === i ? r : Fr(i, r), n);
                    case 7:
                        return mu(e, t, t.pendingProps, n), t.child;
                    case 8:
                    case 12:
                        return mu(e, t, t.pendingProps.children, n), t.child;
                    case 10:
                        e: {
                            i = t.type._context, r = t.pendingProps, o = t.memoizedProps, M = r.value;
                            var c = t.type._context;
                            if (ar(Xr, c._currentValue), c._currentValue = M, null !== o) {
                                if (c = o.value, 0 === (M = Yi(c, M) ? 0 : 0 | ("function" == typeof i._calculateChangedBits ? i._calculateChangedBits(c, M) : 1073741823))) {
                                    if (o.children === r.children && !Nr.current) {
                                        t = Ju(e, t, n);
                                        break e;
                                    }
                                } else for(null !== (c = t.child) && (c.return = t); null !== c;){
                                    var a = c.dependencies;
                                    if (null !== a) {
                                        o = c.child;
                                        for(var I = a.firstContext; null !== I;){
                                            if (I.context === i && 0 != (I.observedBits & M)) {
                                                1 === c.tag && ((I = oM(n, null)).tag = 2, cM(c, I)), c.expirationTime < n && (c.expirationTime = n), null !== (I = c.alternate) && I.expirationTime < n && (I.expirationTime = n), tM(c.return, n), a.expirationTime < n && (a.expirationTime = n);
                                                break;
                                            }
                                            I = I.next;
                                        }
                                    } else o = 10 === c.tag && c.type === t.type ? null : c.child;
                                    if (null !== o) o.return = c;
                                    else for(o = c; null !== o;){
                                        if (o === t) {
                                            o = null;
                                            break;
                                        }
                                        if (null !== (c = o.sibling)) {
                                            c.return = o.return, o = c;
                                            break;
                                        }
                                        o = o.return;
                                    }
                                    c = o;
                                }
                            }
                            mu(e, t, r.children, n), t = t.child;
                        }
                        return t;
                    case 9:
                        return r = t.type, i = (M = t.pendingProps).children, nM(t, n), i = i(r = iM(r, M.unstable_observedBits)), t.effectTag |= 1, mu(e, t, i, n), t.child;
                    case 14:
                        return M = Fr(r = t.type, t.pendingProps), vu(e, t, r, M = Fr(r.type, M), i, n);
                    case 15:
                        return bu(e, t, t.type, t.pendingProps, i, n);
                    case 17:
                        return i = t.type, r = t.pendingProps, r = t.elementType === i ? r : Fr(i, r), null !== e && (e.alternate = null, t.alternate = null, t.effectTag |= 2), t.tag = 1, sr(i) ? (e = !0, Tr(t)) : e = !1, nM(t, n), DM(t, i, r), TM(t, i, r, n), Yu(null, t, i, !0, e, n);
                    case 19:
                        return Vu(e, t, n);
                }
                throw Error(u(156, t.tag));
            };
            var zc = null, wc = null;
            function fc(e, t, n, i) {
                this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = i, this.effectTag = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childExpirationTime = this.expirationTime = 0, this.alternate = null;
            }
            function Lc(e, t, n, i) {
                return new fc(e, t, n, i);
            }
            function Ec(e) {
                return !(!(e = e.prototype) || !e.isReactComponent);
            }
            function Cc(e, t) {
                var n = e.alternate;
                return null === n ? ((n = Lc(e.tag, t, e.key, e.mode)).elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.effectTag = 0, n.nextEffect = null, n.firstEffect = null, n.lastEffect = null), n.childExpirationTime = e.childExpirationTime, n.expirationTime = e.expirationTime, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = null === t ? null : {
                    expirationTime: t.expirationTime,
                    firstContext: t.firstContext,
                    responders: t.responders
                }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
            }
            function xc(e, t, n, i, r, M) {
                var o = 2;
                if (i = e, "function" == typeof e) Ec(e) && (o = 1);
                else if ("string" == typeof e) o = 5;
                else e: switch(e){
                    case ne:
                        return pc(n.children, r, M, t);
                    case oe:
                        o = 8, r |= 7;
                        break;
                    case ie:
                        o = 8, r |= 1;
                        break;
                    case re:
                        return (e = Lc(12, n, t, 8 | r)).elementType = re, e.type = re, e.expirationTime = M, e;
                    case ae:
                        return (e = Lc(13, n, t, r)).type = ae, e.elementType = ae, e.expirationTime = M, e;
                    case Ie:
                        return (e = Lc(19, n, t, r)).elementType = Ie, e.expirationTime = M, e;
                    default:
                        if ("object" == typeof e && null !== e) switch(e.$$typeof){
                            case Me:
                                o = 10;
                                break e;
                            case ue:
                                o = 9;
                                break e;
                            case ce:
                                o = 11;
                                break e;
                            case le:
                                o = 14;
                                break e;
                            case Ne:
                                o = 16, i = null;
                                break e;
                            case je:
                                o = 22;
                                break e;
                        }
                        throw Error(u(130, null == e ? e : typeof e, ""));
                }
                return (t = Lc(o, n, t, r)).elementType = e, t.type = i, t.expirationTime = M, t;
            }
            function pc(e, t, n, i) {
                return (e = Lc(7, e, i, t)).expirationTime = n, e;
            }
            function Sc(e, t, n) {
                return (e = Lc(6, e, null, t)).expirationTime = n, e;
            }
            function mc(e, t, n) {
                return (t = Lc(4, null !== e.children ? e.children : [], e.key, t)).expirationTime = n, t.stateNode = {
                    containerInfo: e.containerInfo,
                    pendingChildren: null,
                    implementation: e.implementation
                }, t;
            }
            function Oc(e, t, n) {
                this.tag = t, this.current = null, this.containerInfo = e, this.pingCache = this.pendingChildren = null, this.finishedExpirationTime = 0, this.finishedWork = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = n, this.callbackNode = null, this.callbackPriority = 90, this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
            }
            function vc(e, t) {
                var n = e.firstSuspendedTime;
                return e = e.lastSuspendedTime, 0 !== n && n >= t && e <= t;
            }
            function bc(e, t) {
                var n = e.firstSuspendedTime, i = e.lastSuspendedTime;
                n < t && (e.firstSuspendedTime = t), (i > t || 0 === n) && (e.lastSuspendedTime = t), t <= e.lastPingedTime && (e.lastPingedTime = 0), t <= e.lastExpiredTime && (e.lastExpiredTime = 0);
            }
            function hc(e, t) {
                t > e.firstPendingTime && (e.firstPendingTime = t);
                var n = e.firstSuspendedTime;
                0 !== n && (t >= n ? e.firstSuspendedTime = e.lastSuspendedTime = e.nextKnownPendingLevel = 0 : t >= e.lastSuspendedTime && (e.lastSuspendedTime = t + 1), t > e.nextKnownPendingLevel && (e.nextKnownPendingLevel = t));
            }
            function kc(e, t) {
                var n = e.lastExpiredTime;
                (0 === n || n > t) && (e.lastExpiredTime = t);
            }
            function Qc(e, t, n, i) {
                var r = t.current, M = Vo(), o = NM.suspense;
                M = Jo(M, r, o);
                e: if (n) {
                    t: {
                        if ($e(n = n._reactInternalFiber) !== n || 1 !== n.tag) throw Error(u(170));
                        var c = n;
                        do {
                            switch(c.tag){
                                case 3:
                                    c = c.stateNode.context;
                                    break t;
                                case 1:
                                    if (sr(c.type)) {
                                        c = c.stateNode.__reactInternalMemoizedMergedChildContext;
                                        break t;
                                    }
                            }
                            c = c.return;
                        }while (null !== c);
                        throw Error(u(171));
                    }
                    if (1 === n.tag) {
                        var a = n.type;
                        if (sr(a)) {
                            n = dr(n, a, c);
                            break e;
                        }
                    }
                    n = c;
                } else n = Ir;
                return null === t.context ? t.context = n : t.pendingContext = n, (t = oM(M, o)).payload = {
                    element: e
                }, null !== (i = void 0 === i ? null : i) && (t.callback = i), cM(r, t), Fo(r, M), M;
            }
            function Yc(e) {
                if (!(e = e.current).child) return null;
                e.child.tag;
                return e.child.stateNode;
            }
            function Pc(e, t) {
                null !== (e = e.memoizedState) && null !== e.dehydrated && e.retryTime < t && (e.retryTime = t);
            }
            function Uc(e, t) {
                Pc(e, t), (e = e.alternate) && Pc(e, t);
            }
            function Zc(e, t, n) {
                var i = new Oc(e, t, n = null != n && !0 === n.hydrate), r = Lc(3, null, null, 2 === t ? 7 : 1 === t ? 3 : 0);
                i.current = r, r.stateNode = i, MM(r), e[Cn] = i.current, n && 0 !== t && function(e, t) {
                    var n = _e(t);
                    Ct.forEach(function(e) {
                        gt(e, t, n);
                    }), xt.forEach(function(e) {
                        gt(e, t, n);
                    });
                }(0, 9 === e.nodeType ? e : e.ownerDocument), this._internalRoot = i;
            }
            function Gc(e) {
                return !(!e || 1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType && (8 !== e.nodeType || " react-mount-point-unstable " !== e.nodeValue));
            }
            function Bc(e, t, n, i, r) {
                var M = n._reactRootContainer;
                if (M) {
                    var u = M._internalRoot;
                    if ("function" == typeof r) {
                        var o = r;
                        r = function() {
                            var e = Yc(u);
                            o.call(e);
                        };
                    }
                    Qc(t, u, e, r);
                } else {
                    if (M = n._reactRootContainer = function(e, t) {
                        if (t || (t = !(!(t = e ? 9 === e.nodeType ? e.documentElement : e.firstChild : null) || 1 !== t.nodeType || !t.hasAttribute("data-reactroot"))), !t) for(var n; n = e.lastChild;)e.removeChild(n);
                        return new Zc(e, 0, t ? {
                            hydrate: !0
                        } : void 0);
                    }(n, i), u = M._internalRoot, "function" == typeof r) {
                        var c = r;
                        r = function() {
                            var e = Yc(u);
                            c.call(e);
                        };
                    }
                    tc(function() {
                        Qc(t, u, e, r);
                    });
                }
                return Yc(u);
            }
            function Rc(e, t, n) {
                var i = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
                return {
                    $$typeof: te,
                    key: null == i ? null : "" + i,
                    children: e,
                    containerInfo: t,
                    implementation: n
                };
            }
            function Wc(e, t) {
                var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
                if (!Gc(t)) throw Error(u(200));
                return Rc(e, t, null, n);
            }
            Zc.prototype.render = function(e) {
                Qc(e, this._internalRoot, null, null);
            }, Zc.prototype.unmount = function() {
                var e = this._internalRoot, t = e.containerInfo;
                Qc(null, e, null, function() {
                    t[Cn] = null;
                });
            }, st = function(e) {
                if (13 === e.tag) {
                    var t = Jr(Vo(), 150, 100);
                    Fo(e, t), Uc(e, t);
                }
            }, At = function(e) {
                13 === e.tag && (Fo(e, 3), Uc(e, 3));
            }, Dt = function(e) {
                if (13 === e.tag) {
                    var t = Vo();
                    Fo(e, t = Jo(t, e, null)), Uc(e, t);
                }
            }, p = function(e, t, n) {
                switch(t){
                    case "input":
                        if (Ee(e, n), t = n.name, "radio" === n.type && null != t) {
                            for(n = e; n.parentNode;)n = n.parentNode;
                            for(n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++){
                                var i = n[t];
                                if (i !== e && i.form === e.form) {
                                    var r = mn(i);
                                    if (!r) throw Error(u(90));
                                    ze(i), Ee(i, r);
                                }
                            }
                        }
                        break;
                    case "textarea":
                        ve(e, n);
                        break;
                    case "select":
                        null != (t = n.value) && Se(e, !!n.multiple, t, !1);
                }
            }, h = ec, k = function(e, t, n, i, r) {
                var M = fo;
                fo |= 4;
                try {
                    return Br(98, e.bind(null, t, n, i, r));
                } finally{
                    0 === (fo = M) && Hr();
                }
            }, Q = function() {
                0 == (49 & fo) && (function() {
                    if (null !== Bo) {
                        var e = Bo;
                        Bo = null, e.forEach(function(e, t) {
                            kc(t, e), qo(t);
                        }), Hr();
                    }
                }(), sc());
            }, Y = function(e, t) {
                var n = fo;
                fo |= 2;
                try {
                    return e(t);
                } finally{
                    0 === (fo = n) && Hr();
                }
            };
            var Hc, Vc, Jc = {
                Events: [
                    pn,
                    Sn,
                    mn,
                    C,
                    f,
                    Yn,
                    function(e) {
                        rt(e, Qn);
                    },
                    v,
                    b,
                    qt,
                    ot,
                    sc,
                    {
                        current: !1
                    }
                ]
            };
            Vc = (Hc = {
                findFiberByHostInstance: xn,
                bundleType: 0,
                version: "16.14.0",
                rendererPackageName: "react-dom"
            }).findFiberByHostInstance, function(e) {
                if ("undefined" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
                var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                if (t.isDisabled || !t.supportsFiber) return !0;
                try {
                    var n = t.inject(e);
                    zc = function(e) {
                        try {
                            t.onCommitFiberRoot(n, e, void 0, 64 == (64 & e.current.effectTag));
                        } catch (e) {}
                    }, wc = function(e) {
                        try {
                            t.onCommitFiberUnmount(n, e);
                        } catch (e) {}
                    };
                } catch (e) {}
            }(r({}, Hc, {
                overrideHookState: null,
                overrideProps: null,
                setSuspenseHandler: null,
                scheduleUpdate: null,
                currentDispatcherRef: K.ReactCurrentDispatcher,
                findHostInstanceByFiber: function(e) {
                    return null === (e = nt(e)) ? null : e.stateNode;
                },
                findFiberByHostInstance: function(e) {
                    return Vc ? Vc(e) : null;
                },
                findHostInstancesForRefresh: null,
                scheduleRefresh: null,
                scheduleRoot: null,
                setRefreshHandler: null,
                getCurrentFiber: null
            })), t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Jc, t.createPortal = Wc, t.findDOMNode = function(e) {
                if (null == e) return null;
                if (1 === e.nodeType) return e;
                var t = e._reactInternalFiber;
                if (void 0 === t) {
                    if ("function" == typeof e.render) throw Error(u(188));
                    throw Error(u(268, Object.keys(e)));
                }
                return e = null === (e = nt(t)) ? null : e.stateNode;
            }, t.flushSync = function(e, t) {
                if (0 != (48 & fo)) throw Error(u(187));
                var n = fo;
                fo |= 1;
                try {
                    return Br(99, e.bind(null, t));
                } finally{
                    fo = n, Hr();
                }
            }, t.hydrate = function(e, t, n) {
                if (!Gc(t)) throw Error(u(200));
                return Bc(null, e, t, !0, n);
            }, t.render = function(e, t, n) {
                if (!Gc(t)) throw Error(u(200));
                return Bc(null, e, t, !1, n);
            }, t.unmountComponentAtNode = function(e) {
                if (!Gc(e)) throw Error(u(40));
                return !!e._reactRootContainer && (tc(function() {
                    Bc(null, null, e, !1, function() {
                        e._reactRootContainer = null, e[Cn] = null;
                    });
                }), !0);
            }, t.unstable_batchedUpdates = ec, t.unstable_createPortal = function(e, t) {
                return Wc(e, t, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
            }, t.unstable_renderSubtreeIntoContainer = function(e, t, n, i) {
                if (!Gc(n)) throw Error(u(200));
                if (null == e || void 0 === e._reactInternalFiber) throw Error(u(38));
                return Bc(e, t, n, !1, i);
            }, t.version = "16.14.0";
        },
        function(e, t, n) {
            "use strict";
            e.exports = n(31);
        },
        function(e, t, n) {
            "use strict";
            /** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var i, r, M, u, o;
            if ("undefined" == typeof window || "function" != typeof MessageChannel) {
                var c = null, a = null, I = function() {
                    if (null !== c) try {
                        var e = t.unstable_now();
                        c(!0, e), c = null;
                    } catch (e) {
                        throw setTimeout(I, 0), e;
                    }
                }, l = Date.now();
                t.unstable_now = function() {
                    return Date.now() - l;
                }, i = function(e) {
                    null !== c ? setTimeout(i, 0, e) : (c = e, setTimeout(I, 0));
                }, r = function(e, t) {
                    a = setTimeout(e, t);
                }, M = function() {
                    clearTimeout(a);
                }, u = function() {
                    return !1;
                }, o = t.unstable_forceFrameRate = function() {};
            } else {
                var N = window.performance, j = window.Date, g = window.setTimeout, s = window.clearTimeout;
                if ("undefined" != typeof console) {
                    var A = window.cancelAnimationFrame;
                    "function" != typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), "function" != typeof A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
                }
                if ("object" == typeof N && "function" == typeof N.now) t.unstable_now = function() {
                    return N.now();
                };
                else {
                    var D = j.now();
                    t.unstable_now = function() {
                        return j.now() - D;
                    };
                }
                var d = !1, T = null, y = -1, z = 5, w = 0;
                u = function() {
                    return t.unstable_now() >= w;
                }, o = function() {}, t.unstable_forceFrameRate = function(e) {
                    0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : z = 0 < e ? Math.floor(1e3 / e) : 5;
                };
                var f = new MessageChannel, L = f.port2;
                f.port1.onmessage = function() {
                    if (null !== T) {
                        var e = t.unstable_now();
                        w = e + z;
                        try {
                            T(!0, e) ? L.postMessage(null) : (d = !1, T = null);
                        } catch (e) {
                            throw L.postMessage(null), e;
                        }
                    } else d = !1;
                }, i = function(e) {
                    T = e, d || (d = !0, L.postMessage(null));
                }, r = function(e, n) {
                    y = g(function() {
                        e(t.unstable_now());
                    }, n);
                }, M = function() {
                    s(y), y = -1;
                };
            }
            function E(e, t) {
                var n = e.length;
                e.push(t);
                e: for(;;){
                    var i = n - 1 >>> 1, r = e[i];
                    if (!(void 0 !== r && 0 < p(r, t))) break e;
                    e[i] = t, e[n] = r, n = i;
                }
            }
            function C(e) {
                return void 0 === (e = e[0]) ? null : e;
            }
            function x(e) {
                var t = e[0];
                if (void 0 !== t) {
                    var n = e.pop();
                    if (n !== t) {
                        e[0] = n;
                        e: for(var i = 0, r = e.length; i < r;){
                            var M = 2 * (i + 1) - 1, u = e[M], o = M + 1, c = e[o];
                            if (void 0 !== u && 0 > p(u, n)) void 0 !== c && 0 > p(c, u) ? (e[i] = c, e[o] = n, i = o) : (e[i] = u, e[M] = n, i = M);
                            else {
                                if (!(void 0 !== c && 0 > p(c, n))) break e;
                                e[i] = c, e[o] = n, i = o;
                            }
                        }
                    }
                    return t;
                }
                return null;
            }
            function p(e, t) {
                var n = e.sortIndex - t.sortIndex;
                return 0 !== n ? n : e.id - t.id;
            }
            var S = [], m = [], O = 1, v = null, b = 3, h = !1, k = !1, Q = !1;
            function Y(e) {
                for(var t = C(m); null !== t;){
                    if (null === t.callback) x(m);
                    else {
                        if (!(t.startTime <= e)) break;
                        x(m), t.sortIndex = t.expirationTime, E(S, t);
                    }
                    t = C(m);
                }
            }
            function P(e) {
                if (Q = !1, Y(e), !k) {
                    if (null !== C(S)) k = !0, i(U);
                    else {
                        var t = C(m);
                        null !== t && r(P, t.startTime - e);
                    }
                }
            }
            function U(e, n) {
                k = !1, Q && (Q = !1, M()), h = !0;
                var i = b;
                try {
                    for(Y(n), v = C(S); null !== v && (!(v.expirationTime > n) || e && !u());){
                        var o = v.callback;
                        if (null !== o) {
                            v.callback = null, b = v.priorityLevel;
                            var c = o(v.expirationTime <= n);
                            n = t.unstable_now(), "function" == typeof c ? v.callback = c : v === C(S) && x(S), Y(n);
                        } else x(S);
                        v = C(S);
                    }
                    if (null !== v) var a = !0;
                    else {
                        var I = C(m);
                        null !== I && r(P, I.startTime - n), a = !1;
                    }
                    return a;
                } finally{
                    v = null, b = i, h = !1;
                }
            }
            function Z(e) {
                switch(e){
                    case 1:
                        return -1;
                    case 2:
                        return 250;
                    case 5:
                        return 1073741823;
                    case 4:
                        return 1e4;
                    default:
                        return 5e3;
                }
            }
            var G = o;
            t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function(e) {
                e.callback = null;
            }, t.unstable_continueExecution = function() {
                k || h || (k = !0, i(U));
            }, t.unstable_getCurrentPriorityLevel = function() {
                return b;
            }, t.unstable_getFirstCallbackNode = function() {
                return C(S);
            }, t.unstable_next = function(e) {
                switch(b){
                    case 1:
                    case 2:
                    case 3:
                        var t = 3;
                        break;
                    default:
                        t = b;
                }
                var n = b;
                b = t;
                try {
                    return e();
                } finally{
                    b = n;
                }
            }, t.unstable_pauseExecution = function() {}, t.unstable_requestPaint = G, t.unstable_runWithPriority = function(e, t) {
                switch(e){
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    default:
                        e = 3;
                }
                var n = b;
                b = e;
                try {
                    return t();
                } finally{
                    b = n;
                }
            }, t.unstable_scheduleCallback = function(e, n, u) {
                var o = t.unstable_now();
                if ("object" == typeof u && null !== u) {
                    var c = u.delay;
                    c = "number" == typeof c && 0 < c ? o + c : o, u = "number" == typeof u.timeout ? u.timeout : Z(e);
                } else u = Z(e), c = o;
                return e = {
                    id: O++,
                    callback: n,
                    priorityLevel: e,
                    startTime: c,
                    expirationTime: u = c + u,
                    sortIndex: -1
                }, c > o ? (e.sortIndex = c, E(m, e), null === C(S) && e === C(m) && (Q ? M() : Q = !0, r(P, c - o))) : (e.sortIndex = u, E(S, e), k || h || (k = !0, i(U))), e;
            }, t.unstable_shouldYield = function() {
                var e = t.unstable_now();
                Y(e);
                var n = C(S);
                return n !== v && null !== v && null !== n && null !== n.callback && n.startTime <= e && n.expirationTime < v.expirationTime || u();
            }, t.unstable_wrapCallback = function(e) {
                var t = b;
                return function() {
                    var n = b;
                    b = t;
                    try {
                        return e.apply(this, arguments);
                    } finally{
                        b = n;
                    }
                };
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.updateLocal = t.removeLocal = t.getLocal = t.setLocal = t.local = void 0;
            var i = n(0);
            n(10).isLocalStorageAvailable() && (t.local = window.localStorage), t.setLocal = function(e, n) {
                var i = JSON.stringify(n);
                t.local && t.local.setItem(e, i);
            }, t.getLocal = function(e) {
                var n = null, i = null;
                if (t.local && (i = t.local.getItem(e)), i && "string" == typeof i) try {
                    n = JSON.parse(i);
                } catch (e) {
                    return null;
                }
                return n;
            }, t.removeLocal = function(e) {
                t.local && t.local.removeItem(e);
            }, t.updateLocal = function(e, n) {
                var r = t.getLocal(e) || {}, M = i.__assign(i.__assign({}, r), n);
                t.setLocal(e, M);
            };
        },
        function(e, t, n) {
            "use strict";
            n.r(t), (function(e) {
                n.d(t, "BrowserInfo", function() {
                    return r;
                }), n.d(t, "NodeInfo", function() {
                    return M;
                }), n.d(t, "SearchBotDeviceInfo", function() {
                    return u;
                }), n.d(t, "BotInfo", function() {
                    return o;
                }), n.d(t, "ReactNativeInfo", function() {
                    return c;
                }), n.d(t, "detect", function() {
                    return N;
                }), n.d(t, "browserName", function() {
                    return g;
                }), n.d(t, "parseUserAgent", function() {
                    return s;
                }), n.d(t, "detectOS", function() {
                    return A;
                }), n.d(t, "getNodeVersion", function() {
                    return D;
                });
                var i = function(e, t, n) {
                    if (n || 2 === arguments.length) for(var i, r = 0, M = t.length; r < M; r++)!i && r in t || (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
                    return e.concat(i || Array.prototype.slice.call(t));
                }, r = function(e, t, n) {
                    this.name = e, this.version = t, this.os = n, this.type = "browser";
                }, M = function(t) {
                    this.version = t, this.type = "node", this.name = "node", this.os = e.platform;
                }, u = function(e, t, n, i) {
                    this.name = e, this.version = t, this.os = n, this.bot = i, this.type = "bot-device";
                }, o = function() {
                    this.type = "bot", this.bot = !0, this.name = "bot", this.version = null, this.os = null;
                }, c = function() {
                    this.type = "react-native", this.name = "react-native", this.version = null, this.os = null;
                }, a = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/, I = [
                    [
                        "aol",
                        /AOLShield\/([0-9\._]+)/
                    ],
                    [
                        "edge",
                        /Edge\/([0-9\._]+)/
                    ],
                    [
                        "edge-ios",
                        /EdgiOS\/([0-9\._]+)/
                    ],
                    [
                        "yandexbrowser",
                        /YaBrowser\/([0-9\._]+)/
                    ],
                    [
                        "kakaotalk",
                        /KAKAOTALK\s([0-9\.]+)/
                    ],
                    [
                        "samsung",
                        /SamsungBrowser\/([0-9\.]+)/
                    ],
                    [
                        "silk",
                        /\bSilk\/([0-9._-]+)\b/
                    ],
                    [
                        "miui",
                        /MiuiBrowser\/([0-9\.]+)$/
                    ],
                    [
                        "beaker",
                        /BeakerBrowser\/([0-9\.]+)/
                    ],
                    [
                        "edge-chromium",
                        /EdgA?\/([0-9\.]+)/
                    ],
                    [
                        "chromium-webview",
                        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
                    ],
                    [
                        "chrome",
                        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
                    ],
                    [
                        "phantomjs",
                        /PhantomJS\/([0-9\.]+)(:?\s|$)/
                    ],
                    [
                        "crios",
                        /CriOS\/([0-9\.]+)(:?\s|$)/
                    ],
                    [
                        "firefox",
                        /Firefox\/([0-9\.]+)(?:\s|$)/
                    ],
                    [
                        "fxios",
                        /FxiOS\/([0-9\.]+)/
                    ],
                    [
                        "opera-mini",
                        /Opera Mini.*Version\/([0-9\.]+)/
                    ],
                    [
                        "opera",
                        /Opera\/([0-9\.]+)(?:\s|$)/
                    ],
                    [
                        "opera",
                        /OPR\/([0-9\.]+)(:?\s|$)/
                    ],
                    [
                        "pie",
                        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
                    ],
                    [
                        "pie",
                        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
                    ],
                    [
                        "netfront",
                        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
                    ],
                    [
                        "ie",
                        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
                    ],
                    [
                        "ie",
                        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
                    ],
                    [
                        "ie",
                        /MSIE\s(7\.0)/
                    ],
                    [
                        "bb10",
                        /BB10;\sTouch.*Version\/([0-9\.]+)/
                    ],
                    [
                        "android",
                        /Android\s([0-9\.]+)/
                    ],
                    [
                        "ios",
                        /Version\/([0-9\._]+).*Mobile.*Safari.*/
                    ],
                    [
                        "safari",
                        /Version\/([0-9\._]+).*Safari/
                    ],
                    [
                        "facebook",
                        /FB[AS]V\/([0-9\.]+)/
                    ],
                    [
                        "instagram",
                        /Instagram\s([0-9\.]+)/
                    ],
                    [
                        "ios-webview",
                        /AppleWebKit\/([0-9\.]+).*Mobile/
                    ],
                    [
                        "ios-webview",
                        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
                    ],
                    [
                        "curl",
                        /^curl\/([0-9\.]+)$/
                    ],
                    [
                        "searchbot",
                        /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/
                    ]
                ], l = [
                    [
                        "iOS",
                        /iP(hone|od|ad)/
                    ],
                    [
                        "Android OS",
                        /Android/
                    ],
                    [
                        "BlackBerry OS",
                        /BlackBerry|BB10/
                    ],
                    [
                        "Windows Mobile",
                        /IEMobile/
                    ],
                    [
                        "Amazon OS",
                        /Kindle/
                    ],
                    [
                        "Windows 3.11",
                        /Win16/
                    ],
                    [
                        "Windows 95",
                        /(Windows 95)|(Win95)|(Windows_95)/
                    ],
                    [
                        "Windows 98",
                        /(Windows 98)|(Win98)/
                    ],
                    [
                        "Windows 2000",
                        /(Windows NT 5.0)|(Windows 2000)/
                    ],
                    [
                        "Windows XP",
                        /(Windows NT 5.1)|(Windows XP)/
                    ],
                    [
                        "Windows Server 2003",
                        /(Windows NT 5.2)/
                    ],
                    [
                        "Windows Vista",
                        /(Windows NT 6.0)/
                    ],
                    [
                        "Windows 7",
                        /(Windows NT 6.1)/
                    ],
                    [
                        "Windows 8",
                        /(Windows NT 6.2)/
                    ],
                    [
                        "Windows 8.1",
                        /(Windows NT 6.3)/
                    ],
                    [
                        "Windows 10",
                        /(Windows NT 10.0)/
                    ],
                    [
                        "Windows ME",
                        /Windows ME/
                    ],
                    [
                        "Windows CE",
                        /Windows CE|WinCE|Microsoft Pocket Internet Explorer/
                    ],
                    [
                        "Open BSD",
                        /OpenBSD/
                    ],
                    [
                        "Sun OS",
                        /SunOS/
                    ],
                    [
                        "Chrome OS",
                        /CrOS/
                    ],
                    [
                        "Linux",
                        /(Linux)|(X11)/
                    ],
                    [
                        "Mac OS",
                        /(Mac_PowerPC)|(Macintosh)/
                    ],
                    [
                        "QNX",
                        /QNX/
                    ],
                    [
                        "BeOS",
                        /BeOS/
                    ],
                    [
                        "OS/2",
                        /OS\/2/
                    ]
                ];
                function N(e) {
                    return e ? s(e) : "undefined" == typeof document && "undefined" != typeof navigator && "ReactNative" === navigator.product ? new c : "undefined" != typeof navigator ? s(navigator.userAgent) : D();
                }
                function j(e) {
                    return "" !== e && I.reduce(function(t, n) {
                        var i = n[0], r = n[1];
                        if (t) return t;
                        var M = r.exec(e);
                        return !!M && [
                            i,
                            M
                        ];
                    }, !1);
                }
                function g(e) {
                    var t = j(e);
                    return t ? t[0] : null;
                }
                function s(e) {
                    var t = j(e);
                    if (!t) return null;
                    var n = t[0], M = t[1];
                    if ("searchbot" === n) return new o;
                    var c = M[1] && M[1].split(".").join("_").split("_").slice(0, 3);
                    c ? c.length < 3 && (c = i(i([], c, !0), function(e) {
                        for(var t = [], n = 0; n < e; n++)t.push("0");
                        return t;
                    }(3 - c.length), !0)) : c = [];
                    var I = c.join("."), l = A(e), N = a.exec(e);
                    return N && N[1] ? new u(n, I, l, N[1]) : new r(n, I, l);
                }
                function A(e) {
                    for(var t = 0, n = l.length; t < n; t++){
                        var i = l[t], r = i[0];
                        if (i[1].exec(e)) return r;
                    }
                    return null;
                }
                function D() {
                    return void 0 !== e && e.version ? new M(e.version.slice(1)) : null;
                }
            }).call(this, n(11));
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.CHAIN_DATA_LIST = void 0, t.CHAIN_DATA_LIST = {
                1: {
                    chainId: 1,
                    chain: "ETH",
                    network: "mainnet",
                    networkId: 1
                },
                2: {
                    chainId: 2,
                    chain: "EXP",
                    network: "expanse",
                    networkId: 1
                },
                3: {
                    chainId: 3,
                    chain: "ETH",
                    network: "ropsten",
                    networkId: 3
                },
                4: {
                    chainId: 4,
                    chain: "ETH",
                    network: "rinkeby",
                    networkId: 4
                },
                5: {
                    chainId: 5,
                    chain: "ETH",
                    network: "goerli",
                    networkId: 5
                },
                6: {
                    chainId: 6,
                    chain: "ETC",
                    network: "kotti",
                    networkId: 6
                },
                8: {
                    chainId: 8,
                    chain: "UBQ",
                    network: "ubiq",
                    networkId: 88
                },
                9: {
                    chainId: 9,
                    chain: "UBQ",
                    network: "ubiq-testnet",
                    networkId: 2
                },
                10: {
                    chainId: 10,
                    chain: "ETH",
                    network: "optimism",
                    networkId: 10
                },
                11: {
                    chainId: 11,
                    chain: "META",
                    network: "metadium",
                    networkId: 11
                },
                12: {
                    chainId: 12,
                    chain: "META",
                    network: "metadium-testnet",
                    networkId: 12
                },
                18: {
                    chainId: 18,
                    chain: "TST",
                    network: "thundercore-testnet",
                    networkId: 18
                },
                22: {
                    chainId: 22,
                    chain: "LYX",
                    network: "lukso-l14-testnet",
                    networkId: 22
                },
                23: {
                    chainId: 23,
                    chain: "LYX",
                    network: "lukso-l15-testnet",
                    networkId: 23
                },
                25: {
                    chainId: 25,
                    chain: "CRO",
                    network: "cronos",
                    networkId: 25
                },
                30: {
                    chainId: 30,
                    chain: "RSK",
                    network: "rsk",
                    networkId: 30
                },
                31: {
                    chainId: 31,
                    chain: "RSK",
                    network: "rsk-testnet",
                    networkId: 31
                },
                42: {
                    chainId: 42,
                    chain: "ETH",
                    network: "kovan",
                    networkId: 42
                },
                56: {
                    chainId: 56,
                    chain: "BSC",
                    network: "binance",
                    networkId: 56
                },
                60: {
                    chainId: 60,
                    chain: "GO",
                    network: "gochain",
                    networkId: 60
                },
                61: {
                    chainId: 61,
                    chain: "ETC",
                    network: "etc",
                    networkId: 1
                },
                62: {
                    chainId: 62,
                    chain: "ETC",
                    network: "etc-morden",
                    networkId: 2
                },
                63: {
                    chainId: 63,
                    chain: "ETC",
                    network: "etc-testnet",
                    networkId: 7
                },
                64: {
                    chainId: 64,
                    chain: "ELLA",
                    network: "ellaism",
                    networkId: 64
                },
                69: {
                    chainId: 69,
                    chain: "ETH",
                    network: "optimism-kovan",
                    networkId: 69
                },
                76: {
                    chainId: 76,
                    chain: "MIX",
                    network: "mix",
                    networkId: 76
                },
                77: {
                    chainId: 77,
                    chain: "POA",
                    network: "poa-sokol",
                    networkId: 77
                },
                88: {
                    chainId: 88,
                    chain: "TOMO",
                    network: "tomochain",
                    networkId: 88
                },
                97: {
                    chainId: 97,
                    chain: "BSC",
                    network: "binance-testnet",
                    networkId: 97
                },
                99: {
                    chainId: 99,
                    chain: "POA",
                    network: "poa-core",
                    networkId: 99
                },
                100: {
                    chainId: 100,
                    chain: "XDAI",
                    network: "xdai",
                    networkId: 100
                },
                101: {
                    chainId: 101,
                    chain: "ETI",
                    network: "etherinc",
                    networkId: 1
                },
                108: {
                    chainId: 108,
                    chain: "TT",
                    network: "thundercore",
                    networkId: 108
                },
                162: {
                    chainId: 162,
                    chain: "PHT",
                    network: "sirius",
                    networkId: 162
                },
                163: {
                    chainId: 163,
                    chain: "PHT",
                    network: "lightstreams",
                    networkId: 163
                },
                180: {
                    chainId: 180,
                    chain: "AME",
                    network: "ame",
                    networkId: 180
                },
                211: {
                    chainId: 211,
                    chain: "FTN",
                    network: "freight",
                    networkId: 0
                },
                250: {
                    chainId: 250,
                    chain: "FTM",
                    network: "fantom",
                    networkId: 250
                },
                269: {
                    chainId: 269,
                    chain: "HPB",
                    network: "hpb",
                    networkId: 100
                },
                338: {
                    chainId: 338,
                    chain: "CRO",
                    network: "cronos-testnet",
                    networkId: 338
                },
                385: {
                    chainId: 385,
                    chain: "CRO",
                    network: "lisinski",
                    networkId: 385
                },
                534: {
                    chainId: 534,
                    chain: "CNDL",
                    network: "candle",
                    networkId: 534
                },
                820: {
                    chainId: 820,
                    chain: "CLO",
                    network: "callisto",
                    networkId: 1
                },
                821: {
                    chainId: 821,
                    chain: "CLO",
                    network: "callisto-testnet",
                    networkId: 2
                },
                137: {
                    chainId: 137,
                    chain: "MATIC",
                    network: "matic",
                    networkId: 137
                },
                1284: {
                    chainId: 1284,
                    chain: "GLMR",
                    network: "moonbeam",
                    networkId: 1284
                },
                1285: {
                    chainId: 1285,
                    chain: "MOVR",
                    network: "moonriver",
                    networkId: 1285
                },
                42161: {
                    chainId: 42161,
                    chain: "ETH",
                    network: "arbitrum",
                    networkId: 42161
                },
                42220: {
                    chainId: 42220,
                    chain: "CELO",
                    network: "celo",
                    networkId: 42220
                },
                44787: {
                    chainId: 44787,
                    chain: "CELO",
                    network: "celo-alfajores",
                    networkId: 44787
                },
                62320: {
                    chainId: 62320,
                    chain: "CELO",
                    network: "celo-baklava",
                    networkId: 62320
                },
                80001: {
                    chainId: 80001,
                    chain: "MUMBAI",
                    network: "mumbai",
                    networkId: 80001
                },
                43113: {
                    chainId: 43113,
                    chain: "AVAX",
                    network: "avalanche-fuji-testnet",
                    networkId: 43113
                },
                43114: {
                    chainId: 43114,
                    chain: "AVAX",
                    network: "avalanche-mainnet",
                    networkId: 43114
                },
                246529: {
                    chainId: 246529,
                    chain: "ARTIS sigma1",
                    network: "artis-s1",
                    networkId: 246529
                },
                246785: {
                    chainId: 246785,
                    chain: "ARTIS tau1",
                    network: "artis-t1",
                    networkId: 246785
                },
                1007: {
                    chainId: 1007,
                    chain: "NewChain TestNet",
                    network: "newchain-testnet",
                    networkId: 1007
                },
                1012: {
                    chainId: 1012,
                    chain: "NewChain MainNet",
                    network: "newchain-mainnet",
                    networkId: 1012
                },
                421611: {
                    chainId: 421611,
                    chain: "ETH",
                    network: "arbitrum-rinkeby",
                    networkId: 421611
                },
                16666e5: {
                    chainId: 16666e5,
                    chain: "ONE",
                    network: "harmony-shard1",
                    networkId: 16666e5
                },
                1313161554: {
                    chainId: 1313161554,
                    chain: "AETH",
                    network: "aurora",
                    networkId: 1313161554
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.CONNECT_BUTTON_CLASSNAME = t.PROVIDER_DESCRIPTION_CLASSNAME = t.PROVIDER_NAME_CLASSNAME = t.PROVIDER_ICON_CLASSNAME = t.PROVIDER_CONTAINER_CLASSNAME = t.PROVIDER_WRAPPER_CLASSNAME = t.MODAL_CARD_CLASSNAME = t.MODAL_HITBOX_CLASSNAME = t.MODAL_CONTAINER_CLASSNAME = t.MODAL_LIGHTBOX_CLASSNAME = void 0, t.MODAL_LIGHTBOX_CLASSNAME = "web3modal-modal-lightbox", t.MODAL_CONTAINER_CLASSNAME = "web3modal-modal-container", t.MODAL_HITBOX_CLASSNAME = "web3modal-modal-hitbox", t.MODAL_CARD_CLASSNAME = "web3modal-modal-card", t.PROVIDER_WRAPPER_CLASSNAME = "web3modal-provider-wrapper", t.PROVIDER_CONTAINER_CLASSNAME = "web3modal-provider-container", t.PROVIDER_ICON_CLASSNAME = "web3modal-provider-icon", t.PROVIDER_NAME_CLASSNAME = "web3modal-provider-name", t.PROVIDER_DESCRIPTION_CLASSNAME = "web3modal-provider-description", t.CONNECT_BUTTON_CLASSNAME = "web3modal-connect-button";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.SELECT_EVENT = t.CLOSE_EVENT = t.ERROR_EVENT = t.CONNECT_EVENT = void 0, t.CONNECT_EVENT = "connect", t.ERROR_EVENT = "error", t.CLOSE_EVENT = "close", t.SELECT_EVENT = "select";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.CACHED_PROVIDER_KEY = t.INJECTED_PROVIDER_ID = t.WEB3_CONNECT_MODAL_ID = void 0, t.WEB3_CONNECT_MODAL_ID = "WEB3_CONNECT_MODAL_ID", t.INJECTED_PROVIDER_ID = "injected", t.CACHED_PROVIDER_KEY = "WEB3_CONNECT_CACHED_PROVIDER";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            t.default = {
                name: "light",
                colors: {
                    background: "rgb(255, 255, 255)",
                    main: "rgb(12, 12, 13)",
                    secondary: "rgb(169, 169, 188)",
                    border: "rgba(195, 195, 195, 0.14)",
                    hover: "rgba(195, 195, 195, 0.14)"
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            t.default = {
                name: "dark",
                colors: {
                    background: "rgb(39, 49, 56)",
                    main: "rgb(199, 199, 199)",
                    secondary: "rgb(136, 136, 136)",
                    border: "rgba(195, 195, 195, 0.14)",
                    hover: "rgb(16, 26, 32)"
                }
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.phantom = t.ledger = t.web3auth = t.starzwallet = t.bitkeep = t.opera = t.clvwallet = t.sequence = t.walletlink = t.coinbasewallet = t.binancechainwallet = t.frame = t.bitski = t.dcentwallet = t.mewconnect = t.burnerconnect = t.authereum = t.venly = t.fortmatic = t.torus = t.portis = t.boltx = t.walletconnect = t.injected = void 0;
            var i = n(0), r = i.__importDefault(n(41));
            t.injected = r.default;
            var M = i.__importDefault(n(42));
            t.boltx = M.default;
            var u = i.__importDefault(n(43));
            t.walletconnect = u.default;
            var o = i.__importDefault(n(44));
            t.portis = o.default;
            var c = i.__importDefault(n(45));
            t.fortmatic = c.default;
            var a = i.__importDefault(n(46));
            t.torus = a.default;
            var I = i.__importDefault(n(47));
            t.venly = I.default;
            var l = i.__importDefault(n(48));
            t.authereum = l.default;
            var N = i.__importDefault(n(49));
            t.burnerconnect = N.default;
            var j = i.__importDefault(n(50));
            t.mewconnect = j.default;
            var g = i.__importDefault(n(51));
            t.dcentwallet = g.default;
            var s = i.__importDefault(n(52));
            t.bitski = s.default;
            var A = i.__importDefault(n(53));
            t.frame = A.default;
            var D = i.__importDefault(n(54));
            t.binancechainwallet = D.default;
            var d = i.__importStar(n(55));
            t.coinbasewallet = d.default, Object.defineProperty(t, "walletlink", {
                enumerable: !0,
                get: function() {
                    return d.walletlink;
                }
            });
            var T = i.__importDefault(n(56));
            t.sequence = T.default;
            var y = i.__importDefault(n(57));
            t.clvwallet = y.default;
            var z = i.__importDefault(n(58));
            t.opera = z.default;
            var w = i.__importDefault(n(59));
            t.web3auth = w.default;
            var f = i.__importDefault(n(60));
            t.bitkeep = f.default;
            var L = i.__importDefault(n(61));
            t.starzwallet = L.default;
            var E = i.__importDefault(n(62));
            t.ledger = E.default;
            var C = i.__importDefault(n(63));
            t.phantom = C.default;
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e;
                    return i.__generator(this, function(t) {
                        switch(t.label){
                            case 0:
                                if (e = null, void 0 === window.ethereum) return [
                                    3,
                                    5
                                ];
                                e = window.ethereum, t.label = 1;
                            case 1:
                                return t.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return t.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw t.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (window.web3) e = window.web3.currentProvider;
                                else {
                                    if (!window.celo) throw new Error("No Web3 Provider found");
                                    e = window.celo;
                                }
                                t.label = 6;
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e;
                    return i.__generator(this, function(t) {
                        switch(t.label){
                            case 0:
                                if (e = null, void 0 === window.boltX) return [
                                    3,
                                    5
                                ];
                                e = window.boltX.ethereum, t.label = 1;
                            case 1:
                                return t.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return t.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw t.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error("BoltX not found");
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0), r = n(3);
            t.default = function(e, t) {
                return new Promise(function(n, M) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var u, o, c, a, I, l, N, j;
                        return i.__generator(this, function(i) {
                            switch(i.label){
                                case 0:
                                    u = "https://bridge.walletconnect.org", o = !0, c = "", a = void 0, I = 1, l = void 0, t && (u = t.bridge || u, o = void 0 !== t.qrcode ? t.qrcode : o, c = t.infuraId || "", a = t.rpc || void 0, I = t.network && r.getChainId(t.network) ? r.getChainId(t.network) : 1, l = t.qrcodeModalOptions || void 0), N = new e({
                                        bridge: u,
                                        qrcode: o,
                                        infuraId: c,
                                        rpc: a,
                                        chainId: I,
                                        qrcodeModalOptions: l
                                    }), i.label = 1;
                                case 1:
                                    return i.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), [
                                        4,
                                        N.enable()
                                    ];
                                case 2:
                                    return i.sent(), n(N), [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return j = i.sent(), M(j), [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return new Promise(function(n, r) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var M, u, o, c, a;
                        return i.__generator(this, function(i) {
                            switch(i.label){
                                case 0:
                                    if (!t || !t.id) return [
                                        3,
                                        5
                                    ];
                                    i.label = 1;
                                case 1:
                                    return i.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), M = t.id, u = t.network || "mainnet", o = t.config, [
                                        4,
                                        (c = new e(M, u, o)).provider.enable()
                                    ];
                                case 2:
                                    return i.sent(), c.provider._portis = c, n(c.provider), [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return a = i.sent(), [
                                        2,
                                        r(a)
                                    ];
                                case 4:
                                    return [
                                        3,
                                        6
                                    ];
                                case 5:
                                    return [
                                        2,
                                        r(new Error("Missing Portis Id"))
                                    ];
                                case 6:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var n, r, M;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                if (!t || !t.key) return [
                                    3,
                                    7
                                ];
                                i.label = 1;
                            case 1:
                                return i.trys.push([
                                    1,
                                    5,
                                    ,
                                    6
                                ]), n = t.key, [
                                    4,
                                    (r = new e(n, t.network)).getProvider()
                                ];
                            case 2:
                                return (M = i.sent()).fm = r, [
                                    4,
                                    r.user.login()
                                ];
                            case 3:
                                return i.sent(), [
                                    4,
                                    r.user.isLoggedIn()
                                ];
                            case 4:
                                if (i.sent()) return [
                                    2,
                                    M
                                ];
                                throw new Error("Failed to login to Fortmatic");
                            case 5:
                                throw i.sent();
                            case 6:
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                throw new Error("Missing Fortmatic key");
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    return i.__generator(this, function(n) {
                        return [
                            2,
                            new Promise(function(n, r) {
                                return i.__awaiter(void 0, void 0, void 0, function() {
                                    var M, u, o, c, a, I, l, N;
                                    return i.__generator(this, function(j) {
                                        switch(j.label){
                                            case 0:
                                                return j.trys.push([
                                                    0,
                                                    3,
                                                    ,
                                                    4
                                                ]), M = {
                                                    host: "mainnet"
                                                }, u = void 0, M = t.networkParams || t.network ? i.__assign({
                                                    host: t.network
                                                }, t.networkParams) : M, [
                                                    4,
                                                    (o = new e({
                                                        buttonPosition: (null === (I = t.config) || void 0 === I ? void 0 : I.buttonPosition) || "bottom-left",
                                                        apiKey: (null === (l = t.config) || void 0 === l ? void 0 : l.apiKey) || "torus-default",
                                                        modalZIndex: (null === (N = t.config) || void 0 === N ? void 0 : N.modalZIndex) || 99999
                                                    })).init(i.__assign(i.__assign({
                                                        showTorusButton: !1
                                                    }, t.config), {
                                                        network: M
                                                    }))
                                                ];
                                            case 1:
                                                return j.sent(), t.loginParams && (u = t.loginParams.verifier), [
                                                    4,
                                                    o.login({
                                                        verifier: u
                                                    })
                                                ];
                                            case 2:
                                                return j.sent(), (c = o.provider).torus = o, n(c), [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                return a = j.sent(), r(a), [
                                                    3,
                                                    4
                                                ];
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return new Promise(function(e, n) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var r, M, u;
                        return i.__generator(this, function(i) {
                            switch(i.label){
                                case 0:
                                    if (!t || !t.clientId) return [
                                        3,
                                        5
                                    ];
                                    i.label = 1;
                                case 1:
                                    return i.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), r = {
                                        clientId: t.clientId,
                                        secretType: t.secretType || "ETHEREUM",
                                        environment: t.environment,
                                        authenticationOptions: t.authenticationOptions,
                                        signMethod: "POPUP"
                                    }, [
                                        4,
                                        window.Venly.createProviderEngine(r)
                                    ];
                                case 2:
                                    return M = i.sent(), [
                                        2,
                                        e(M)
                                    ];
                                case 3:
                                    return u = i.sent(), console.error(u), [
                                        2,
                                        n(new Error("Failed to login to Venly"))
                                    ];
                                case 4:
                                    return [
                                        3,
                                        6
                                    ];
                                case 5:
                                    return [
                                        2,
                                        n(new Error("Please provide an Venly client id"))
                                    ];
                                case 6:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return void 0 === t && (t = {}), new Promise(function(n, r) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var M, u, o;
                        return i.__generator(this, function(c) {
                            switch(c.label){
                                case 0:
                                    return c.trys.push([
                                        0,
                                        2,
                                        ,
                                        3
                                    ]), M = new e(i.__assign(i.__assign({}, t), {
                                        networkName: t.networkName || t.network
                                    })), (u = M.getProvider()).authereum = M, [
                                        4,
                                        u.enable()
                                    ];
                                case 1:
                                    return c.sent(), n(u), [
                                        3,
                                        3
                                    ];
                                case 2:
                                    return o = c.sent(), [
                                        2,
                                        r(o)
                                    ];
                                case 3:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var n;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                return t.defaultNetwork = t.defaultNetwork || t.network, [
                                    4,
                                    (n = new e(t)).enable()
                                ];
                            case 1:
                                return i.sent(), [
                                    2,
                                    n
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0), r = n(3);
            t.default = function(e, t) {
                return new Promise(function(n, M) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var u, o, c, a, I, l, N;
                        return i.__generator(this, function(i) {
                            switch(i.label){
                                case 0:
                                    if (u = "", o = void 0, c = 1, t && (u = t.infuraId || "", o = t.rpc || void 0, t.infuraId && !o && (o = "wss://mainnet.infura.io/ws/v3/" + u), c = t.network && r.getChainId(t.network) ? r.getChainId(t.network) : 1), e.Provider.isConnected) return [
                                        3,
                                        4
                                    ];
                                    a = new e.Provider, I = a.makeWeb3Provider(c, o, !0), a.on("disconnected", function() {}), i.label = 1;
                                case 1:
                                    return i.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), [
                                        4,
                                        a.enable()
                                    ];
                                case 2:
                                    return l = i.sent(), console.log(l), n(I), [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return N = i.sent(), M(N), [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var n;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                return [
                                    4,
                                    (n = new e(t)).enable()
                                ];
                            case 1:
                                return i.sent(), [
                                    2,
                                    n
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var n;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                return [
                                    4,
                                    (n = new e(t.clientId, t.callbackUrl, t.extraBitskiOptions)).signIn()
                                ];
                            case 1:
                                return i.sent(), [
                                    2,
                                    n.getProvider(t.extraProviderOptions)
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var t;
                    return i.__generator(this, function(n) {
                        try {
                            return (t = e("frame")).isFrameNative = !0, [
                                2,
                                t
                            ];
                        } catch (e) {
                            throw e;
                        }
                        return [
                            2
                        ];
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e;
                    return i.__generator(this, function(t) {
                        switch(t.label){
                            case 0:
                                if (e = null, void 0 === window.BinanceChain) return [
                                    3,
                                    5
                                ];
                                e = window.BinanceChain, t.label = 1;
                            case 1:
                                return t.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return t.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw t.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error("No Binance Chain Wallet found");
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.walletlink = void 0;
            var i = n(0), r = function(e, t) {
                return new Promise(function(n, r) {
                    return i.__awaiter(void 0, void 0, void 0, function() {
                        var M, u, o, c, a, I, l, N, j, g;
                        return i.__generator(this, function(i) {
                            switch(i.label){
                                case 0:
                                    u = (M = t || {}).infuraId || "", o = M.chainId || 1, c = M.appName || "", a = M.appLogoUrl, I = M.darkMode || !1, l = M.rpc || void 0, M.infuraId && !M.rpc && (l = "https://mainnet.infura.io/v3/" + u), N = new e({
                                        appName: c,
                                        appLogoUrl: a,
                                        darkMode: I
                                    }), i.label = 1;
                                case 1:
                                    return i.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), [
                                        4,
                                        (j = N.makeWeb3Provider(l, o)).send("eth_requestAccounts")
                                    ];
                                case 2:
                                    return i.sent(), n(j), [
                                        3,
                                        4
                                    ];
                                case 3:
                                    return g = i.sent(), r(g), [
                                        3,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                });
            };
            t.walletlink = r, t.default = r;
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var n, r, M, u, o;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                if (!(null === (o = null === window || void 0 === window ? void 0 : window.ethereum) || void 0 === o ? void 0 : o.isSequence)) return [
                                    3,
                                    4
                                ];
                                n = window.ethereum, i.label = 1;
                            case 1:
                                return i.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    n.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return i.sent(), [
                                    2,
                                    n
                                ];
                            case 3:
                                throw i.sent(), new Error("User Rejected");
                            case 4:
                                return i.trys.push([
                                    4,
                                    5,
                                    ,
                                    7
                                ]), r = e.getWallet(), [
                                    3,
                                    7
                                ];
                            case 5:
                                return i.sent(), M = {}, (null == t ? void 0 : t.networkRpcUrl) && (M = {
                                    networkRpcUrl: t.networkRpcUrl
                                }), [
                                    4,
                                    e.initWallet((null == t ? void 0 : t.defaultNetwork) || "mainnet", M)
                                ];
                            case 6:
                                return r = i.sent(), [
                                    3,
                                    7
                                ];
                            case 7:
                                return r.isConnected() ? [
                                    3,
                                    9
                                ] : [
                                    4,
                                    r.connect({
                                        app: null == t ? void 0 : t.appName,
                                        authorize: (null == t ? void 0 : t.authorize) || !1,
                                        keepWalletOpeneed: (null == t ? void 0 : t.keepWalletOpened) || !1
                                    })
                                ];
                            case 8:
                                if (!(u = i.sent()).connected) throw new Error("Failed to connect");
                                (null == t ? void 0 : t.onConnect) && t.onConnect(u), i.label = 9;
                            case 9:
                                return (n = r.getProvider()).sequence = r, (null == t ? void 0 : t.getSequenceWallet) && t.getSequenceWallet(r), [
                                    2,
                                    n
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e;
                    return i.__generator(this, function(t) {
                        switch(t.label){
                            case 0:
                                if (e = null, void 0 === window.clover) return [
                                    3,
                                    5
                                ];
                                e = window.clover, t.label = 1;
                            case 1:
                                return t.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return t.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw t.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error("No CLV Wallet found");
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e, t;
                    return i.__generator(this, function(n) {
                        switch(n.label){
                            case 0:
                                if (e = null, void 0 === (null === (t = window.ethereum) || void 0 === t ? void 0 : t.isOpera)) return [
                                    3,
                                    5
                                ];
                                e = window.ethereum, n.label = 1;
                            case 1:
                                return n.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return n.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw n.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error("Opera not found");
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    return i.__generator(this, function(n) {
                        return [
                            2,
                            new Promise(function(n, r) {
                                return i.__awaiter(void 0, void 0, void 0, function() {
                                    var M, u, o, c, a, I, l;
                                    return i.__generator(this, function(i) {
                                        switch(i.label){
                                            case 0:
                                                return i.trys.push([
                                                    0,
                                                    3,
                                                    ,
                                                    4
                                                ]), u = (M = t || {}).chainId || "0x1", o = M.clientId || "localhostid", c = M.infuraId, a = new e({
                                                    chainConfig: {
                                                        chainNamespace: "eip155",
                                                        chainId: u,
                                                        rpcTarget: "https://mainnet.infura.io/v3/" + c
                                                    },
                                                    clientId: o
                                                }), console.log(a), [
                                                    4,
                                                    a.initModal()
                                                ];
                                            case 1:
                                                return i.sent(), [
                                                    4,
                                                    a.connect()
                                                ];
                                            case 2:
                                                return i.sent(), (I = a.provider).web3auth = a, n(I), [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                return l = i.sent(), console.log(l), r(l), [
                                                    3,
                                                    4
                                                ];
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e, t, n;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                if (e = null, void 0 === (null === (t = null === window || void 0 === window ? void 0 : window.bitkeep) || void 0 === t ? void 0 : t.ethereum)) return [
                                    3,
                                    5
                                ];
                                e = null === (n = null === window || void 0 === window ? void 0 : window.bitkeep) || void 0 === n ? void 0 : n.ethereum, i.label = 1;
                            case 1:
                                return i.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), console.log("ConnectToBitkeep"), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return i.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw i.sent(), new Error("User Rejected");
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (!window.web3) throw new Error("No Web3 Provider found");
                                e = window.web3.currentProvider, i.label = 6;
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function() {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e;
                    return i.__generator(this, function(t) {
                        switch(t.label){
                            case 0:
                                return e = null, [
                                    4,
                                    new Promise(function(e) {
                                        return setTimeout(e, 1e3);
                                    })
                                ];
                            case 1:
                                if (t.sent(), void 0 === window.starzwallet) return [
                                    3,
                                    6
                                ];
                                e = window.starzwallet, t.label = 2;
                            case 2:
                                return t.trys.push([
                                    2,
                                    4,
                                    ,
                                    5
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 3:
                                return t.sent(), [
                                    3,
                                    5
                                ];
                            case 4:
                                throw t.sent(), new Error("User Rejected");
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                throw new Error("No 99Starz Wallet found");
                            case 7:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    return i.__generator(this, function(n) {
                        return [
                            2,
                            new Promise(function(n, r) {
                                return i.__awaiter(void 0, void 0, void 0, function() {
                                    var M, u, o;
                                    return i.__generator(this, function(c) {
                                        switch(c.label){
                                            case 0:
                                                return c.trys.push([
                                                    0,
                                                    3,
                                                    ,
                                                    4
                                                ]), [
                                                    4,
                                                    e()
                                                ];
                                            case 1:
                                                return (M = c.sent()).checkSupport(i.__assign({
                                                    providerType: "Ethereum"
                                                }, t)), [
                                                    4,
                                                    M.getProvider()
                                                ];
                                            case 2:
                                                return (u = c.sent()).request({
                                                    method: "eth_requestAccounts"
                                                }), [
                                                    2,
                                                    n(u)
                                                ];
                                            case 3:
                                                return o = c.sent(), [
                                                    2,
                                                    r(o)
                                                ];
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                            })
                        ];
                    });
                });
            };
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var i = n(0);
            t.default = function(e, t) {
                return i.__awaiter(void 0, void 0, void 0, function() {
                    var e, n, r;
                    return i.__generator(this, function(i) {
                        switch(i.label){
                            case 0:
                                if (e = null, void 0 === (null === (n = window.phantom) || void 0 === n ? void 0 : n[t.networkType])) return [
                                    3,
                                    5
                                ];
                                e = null === (r = window.phantom) || void 0 === r ? void 0 : r[t.networkType], i.label = 1;
                            case 1:
                                return i.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]), [
                                    4,
                                    e.request({
                                        method: "eth_requestAccounts"
                                    })
                                ];
                            case 2:
                                return i.sent(), [
                                    3,
                                    4
                                ];
                            case 3:
                                throw i.sent();
                            case 4:
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                throw new Error("phantom wallet not found");
                            case 6:
                                return [
                                    2,
                                    e
                                ];
                        }
                    });
                });
            };
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NDAgNDQwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzAwOGM3Mzt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPnNhbnNfd2hpdGUgY29weTwvdGl0bGU+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjIwLDkuODJDMTAzLjkyLDkuODIsOS44MiwxMDMuOTIsOS44MiwyMjBTMTAzLjkyLDQzMC4xOCwyMjAsNDMwLjE4LDQzMC4xOCwzMzYuMDgsNDMwLjE4LDIyMCwzMzYuMDgsOS44MiwyMjAsOS44MlpNMzczLjgzLDIzMS40N0gyNzYuM2E1OS40MSw1OS40MSwwLDEsMSwuNDUtMjAuNjdoOTcuMDhhMTAuMzQsMTAuMzQsMCwxLDEsMCwyMC42N1oiLz48L3N2Zz4=";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAxNTguOCAxODQiIHZpZXdCb3g9IjAgMCAxNTguOCAxODQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzU0IDM1MSkiPjxwYXRoIGQ9Im0tMjc0LjYtMzQzLjdjMjkuMyAyMi43IDYyLjkgMjEuMyA3Mi41IDIxLjMtMi4xIDEyOS4xLTE4LjEgMTExLjktNzIuNSAxNDguMS01NC40LTM2LjItNzAuMy0xOS03Mi40LTE0OC4xIDkuNSAwIDQzIDEuNCA3Mi40LTIxLjN6IiBmaWxsPSIjZmZmIi8+PHBhdGggZD0ibS0yNzQuNi0zNDMuNyA0LjItNS41Yy0yLjUtMS45LTYtMS45LTguNSAwem03Mi41IDIxLjMgNi45LjFjMC0xLjktLjctMy42LTItNS0xLjMtMS4zLTMuMS0yLjEtNC45LTIuMXptLTcyLjUgMTQ4LjEtMy44IDUuOGMyLjMgMS41IDUuMyAxLjUgNy43IDB6bS03Mi40LTE0OC4xdi02LjljLTEuOSAwLTMuNi43LTQuOSAyLjEtMS4zIDEuMy0yIDMuMS0yIDV6bTY4LjEtMTUuOGMzMS40IDI0LjMgNjcuMyAyMi43IDc2LjcgMjIuN3YtMTMuOGMtOS44IDAtNDEuMSAxLjItNjguMy0xOS45em02OS44IDE1LjdjLS41IDMyLjEtMS45IDU0LjgtNC41IDcxLjYtMi42IDE2LjYtNi4yIDI2LjYtMTEgMzMuNi00LjggNy4zLTEwLjggMTEuNi0xOS43IDE2LjktOSA1LjQtMjAuMyAxMS4yLTM0LjMgMjAuNGw3LjcgMTEuNWMxMy4zLTguOCAyNC4zLTE0LjUgMzMuNy0yMC4xIDkuNS01LjcgMTcuOC0xMS45IDI0LjEtMjEgNi4zLTkuNCAxMC41LTIxLjYgMTMuMi0zOS4yIDIuNy0xNy40IDQuMS00MSA0LjYtNzMuNXptLTYxLjcgMTQyLjRjLTEzLjktOS4zLTI1LjMtMTUuMS0zNC4yLTIwLjRzLTE0LjktOS42LTE5LjctMTYuOWMtNC43LTctOC40LTE2LjktMTAuOS0zMy42LTIuNi0xNi44LTMuOS0zOS40LTQuNS03MS42bC0xMy45LjNjLjUgMzIuNCAyIDU2IDQuNiA3My41IDIuNyAxNy42IDYuOCAyOS44IDEzLjEgMzkuMiA2LjMgOS4xIDE0LjYgMTUuMyAyNCAyMSA5LjQgNS42IDIwLjQgMTEuMiAzMy43IDIwLjF6bS03Ni4yLTEzNS40YzkuMyAwIDQ1LjMgMS42IDc2LjYtMjIuN2wtOC40LTExYy0yNy4yIDIxLjEtNTguNSAxOS45LTY4LjIgMTkuOXoiIGZpbGw9IiMzMzc1YmIiLz48L2c+PC9zdmc+";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTI4IDEyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PGNpcmNsZSBpZD0iYSIgY3g9IjU5LjkyOCIgY3k9IjU5LjkyOCIgcj0iNTkuOTI4Ii8+PGxpbmVhckdyYWRpZW50IHgxPSI1MCUiIHkxPSIwJSIgeDI9IjUwJSIgeTI9IjEwMCUiIGlkPSJjIj48c3RvcCBzdG9wLWNvbG9yPSIjMkU2NkY4IiBvZmZzZXQ9IjAlIi8+PHN0b3Agc3RvcC1jb2xvcj0iIzEyNEFEQiIgb2Zmc2V0PSIxMDAlIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0wIDBoMTI4djEyOEgweiIvPjxwYXRoIGZpbGw9IiNGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTAgMGgxMjh2MTI4SDB6Ii8+PHBhdGggZD0iTTAgMGgxMjh2MTI4SDB6Ii8+PHBhdGggZD0iTTE5IDY0YzAgMjQuODUzIDIwLjE0NyA0NSA0NSA0NXM0NS0yMC4xNDcgNDUtNDUtMjAuMTQ3LTQ1LTQ1LTQ1LTQ1IDIwLjE0Ny00NSA0NXptMzMuNS0xNC41YTMgMyAwIDAgMC0zIDN2MjNhMyAzIDAgMCAwIDMgM2gyM2EzIDMgMCAwIDAgMy0zdi0yM2EzIDMgMCAwIDAtMy0zaC0yM3oiIGZpbGw9IiNGRkYiLz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0IDQpIj48bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+PHVzZSB4bGluazpocmVmPSIjYSIvPjwvbWFzaz48ZyBtYXNrPSJ1cmwoI2IpIj48cGF0aCBkPSJNMCAwaDExOS44NTZ2MTE5Ljg1NkgweiIvPjxyZWN0IGZpbGw9InVybCgjYykiIGZpbGwtcnVsZT0ibm9uemVybyIgd2lkdGg9IjExOS44NTYiIGhlaWdodD0iMTE5Ljg1NiIgcng9IjQ4Ii8+PHBhdGggZD0iTTI0Ljk3IDU5LjkyOGMwIDE5LjMwNyAxNS42NTEgMzQuOTU4IDM0Ljk1OCAzNC45NThzMzQuOTU4LTE1LjY1MSAzNC45NTgtMzQuOTU4Uzc5LjIzNSAyNC45NyA1OS45MjggMjQuOTcgMjQuOTcgNDAuNjIgMjQuOTcgNTkuOTI4em0yNi4wMjQtMTEuMjY0YTIuMzMgMi4zMyAwIDAgMC0yLjMzIDIuMzN2MTcuODY4YTIuMzMgMi4zMyAwIDAgMCAyLjMzIDIuMzNoMTcuODY4YTIuMzMgMi4zMyAwIDAgMCAyLjMzLTIuMzNWNTAuOTk0YTIuMzMgMi4zMyAwIDAgMC0yLjMzLTIuMzNINTAuOTk0eiIgZmlsbD0iI0ZGRiIvPjwvZz48L2c+PC9nPjwvc3ZnPg==";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA2NCA2NCIgdmlld0JveD0iMCAwIDY0IDY0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48bGluZWFyR3JhZGllbnQgaWQ9ImEiIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoMjMuOTg2NiAwIDAgLTE2Ljk0NiA2NTk3LjEzNTMgNTY5NS40OTA3KSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIHgxPSItMjcyLjUyNzIiIHgyPSItMjc1LjEyMDciIHkxPSIzMzUuNTUzMiIgeTI9IjMzMi45NTk3Ij48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiMxMWM0ZDEiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMwMDYyYWQiLz48L2xpbmVhckdyYWRpZW50PjxwYXRoIGQ9Im02My44IDEwLjljMi4xIDI4LjYtMTYuMiA0Mi4xLTMyLjcgNDMuNi0xNS4zIDEuMy0yOS43LTguMS0zMS0yMi41LTEtMTEuOSA2LjMtMTcgMTIuMS0xNy41IDYtLjUgMTEgMy42IDExLjQgOC42LjQgNC44LTIuNiA3LTQuNiA3LjItMS42LjEtMy43LS45LTMuOS0zLS4yLTEuOC41LTIuMS40LTQtLjMtMy41LTMuMy0zLjktNS0zLjctMiAuMi01LjcgMi41LTUuMSA4LjQuNSA1LjkgNi4yIDEwLjYgMTMuNiA5LjkgOC0uNyAxMy42LTYuOSAxNC0xNS43IDAtLjUuMS0uOS4zLTEuMy4xLS4yLjItLjQuMy0uNS4yLS4zLjQtLjUuNy0uOC4yLS4yLjUtLjUuNy0uOCAzLjUtMy4zIDE2LjEtMTEuMSAyOC04LjYuNC0uMi44LjIuOC43IiBmaWxsPSJ1cmwoI2EpIi8+PC9zdmc+";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMDAwIiBoZWlnaHQ9IjIwMDAiPjxjaXJjbGUgY3g9IjEwMDAiIGN5PSIxMDAwIiByPSIxMDAwIiBmaWxsPSIjNWI2ZGVlIi8+PHBhdGggZD0iTTgzMS4yNyA5MzguNzlhNTcxLjUgNTcxLjUgMCAwIDAtMTA0IDguOTVjMjguMjUtMjYxLjI4IDI0Ni00NTkuMTIgNTA1LjI0LTQ1OS4xIDE1OC43MyAwIDI2Ny40OSA3Ny43MiAyNjcuNDkgMjM4LjY0cy0xMzAuNTQgMjM4LjY0LTMyMSAyMzguNjRjLTE0MC41OC0uMDEtMjA3LjEzLTI3LjEzLTM0Ny43My0yNy4xM20tMTAuMjcgOTUuM2MtMTkwLjQ1IDAtMzIxIDc3LjcyLTMyMSAyMzguNjRzMTA4Ljc2IDIzOC42NCAyNjcuNDkgMjM4LjY0YzI1OS4yNyAwIDQ3Ny0xOTcuODIgNTA1LjI0LTQ1OS4xYTU3MS41IDU3MS41IDAgMCAxLTEwNCA4Ljk1Yy0xNDAuNi0uMDEtMjA3LjE1LTI3LjEzLTM0Ny43My0yNy4xMyIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2Vsb19SaW5ncyIgZGF0YS1uYW1lPSJDZWxvIFJpbmdzIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA5NTAgOTUwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZiY2M1Yzt9LmNscy0ye2ZpbGw6IzM1ZDA3Zjt9LmNscy0ze2ZpbGw6IzVlYTMzYjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkFydGJvYXJkIDE8L3RpdGxlPjxwYXRoIGlkPSJCb3R0b21fUmluZyIgZGF0YS1uYW1lPSJCb3R0b20gUmluZyIgY2xhc3M9ImNscy0xIiBkPSJNMzc1LDg1MGMxNTEuODgsMCwyNzUtMTIzLjEyLDI3NS0yNzVTNTI2Ljg4LDMwMCwzNzUsMzAwLDEwMCw0MjMuMTIsMTAwLDU3NSwyMjMuMTIsODUwLDM3NSw4NTBabTAsMTAwQzE2Ny45LDk1MCwwLDc4Mi4xLDAsNTc1UzE2Ny45LDIwMCwzNzUsMjAwLDc1MCwzNjcuOSw3NTAsNTc1LDU4Mi4xLDk1MCwzNzUsOTUwWiIvPjxwYXRoIGlkPSJUb3BfUmluZyIgZGF0YS1uYW1lPSJUb3AgUmluZyIgY2xhc3M9ImNscy0yIiBkPSJNNTc1LDY1MGMxNTEuODgsMCwyNzUtMTIzLjEyLDI3NS0yNzVTNzI2Ljg4LDEwMCw1NzUsMTAwLDMwMCwyMjMuMTIsMzAwLDM3NSw0MjMuMTIsNjUwLDU3NSw2NTBabTAsMTAwYy0yMDcuMSwwLTM3NS0xNjcuOS0zNzUtMzc1UzM2Ny45LDAsNTc1LDAsOTUwLDE2Ny45LDk1MCwzNzUsNzgyLjEsNzUwLDU3NSw3NTBaIi8+PHBhdGggaWQ9IlJpbmdzX092ZXJsYXAiIGRhdGEtbmFtZT0iUmluZ3MgT3ZlcmxhcCIgY2xhc3M9ImNscy0zIiBkPSJNNTg3LjM5LDc1MGEyNzQuMzgsMjc0LjM4LDAsMCwwLDU0LjU1LTEwOC4wNkEyNzQuMzYsMjc0LjM2LDAsMCwwLDc1MCw1ODcuNGEzNzMuNjMsMzczLjYzLDAsMCwxLTI5LjE2LDEzMy40NUEzNzMuNjIsMzczLjYyLDAsMCwxLDU4Ny4zOSw3NTBaTTMwOC4wNiwzMDguMDZBMjc0LjM2LDI3NC4zNiwwLDAsMCwyMDAsMzYyLjZhMzczLjYzLDM3My42MywwLDAsMSwyOS4xNi0xMzMuNDVBMzczLjYyLDM3My42MiwwLDAsMSwzNjIuNjEsMjAwLDI3NC4zOCwyNzQuMzgsMCwwLDAsMzA4LjA2LDMwOC4wNloiLz48L3N2Zz4=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDg2IiBoZWlnaHQ9IjQ4NiIgdmlld0JveD0iMCAwIDQ4NiA0ODYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0ODYiIGhlaWdodD0iNDg2IiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI0MyA0ODZDMzc3LjIwNSA0ODYgNDg2IDM3Ny4yMDUgNDg2IDI0M0M0ODYgMTA4Ljc5NSAzNzcuMjA1IDAgMjQzIDBDMTA4Ljc5NSAwIDAgMTA4Ljc5NSAwIDI0M0MwIDM3Ny4yMDUgMTA4Ljc5NSA0ODYgMjQzIDQ4NlpNMzc4IDEwOEgxMDhWMzc4SDM3OFYxMDhaIiBmaWxsPSIjMEExMjFFIi8+Cjwvc3ZnPgo=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0ibG9nby1yaXBpby1wb3J0YWwiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiPgogIDxwYXRoIGlkPSJjb250YWluZXIiIGQ9Ik0zMiwxNkExNiwxNiwwLDEsMSwxNiwwLDE2LDE2LDAsMCwxLDMyLDE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIiBmaWxsPSIjNjRmZmI1Ii8+CiAgPHBhdGggaWQ9ImlzbyIgZD0iTTc0LjA4LDYwLjA1NmwtMTIuMTY4LDQuOVY1My4zNjVsMTIuMTg4LTQuOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01Mi4wMDYgLTQwLjcxMSkiIGZpbGw9IiMyNjI2M2YiLz4KPC9zdmc+Cg==";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl82MTU3XzEzMDQ5MykiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMS43NDkyIDYuNzVIMTQuMjQ5M1YxNC4zMjgzSDYuNzVWMjEuOTA3MkgxNC4yNDkzVjI5LjI1MDZIMjEuNzQ5MlYyMS42NzE3SDE0LjI1VjE0LjMyODlIMjEuNzQ5MlY2Ljc1Wk0yOS4yNTAyIDE0LjMyODNIMjEuNzUwMlYyMS45MDcySDI5LjI1MDJWMTQuMzI4M1oiIGZpbGw9ImJsYWNrIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNjE1N18xMzA0OTMiIHgxPSIzNiIgeTE9Ii0yLjE0NTc3ZS0wNiIgeDI9IjIuMTQ1NzdlLTA2IiB5Mj0iMzYiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwLjM5NTgzMyIgc3RvcC1jb2xvcj0iI0E5RkZFMCIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM4NkQ1RkYiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNy41Mjg2MiA5Ljc1VjE1Ljk2NDZDNy41Mjg2MiAxNi40NzA2IDcuOTE5NjUgMTYuODU2NSA4LjQyNTQgMTYuODU2NUgxNS43NjIxQzE2LjI2NzkgMTYuODU2NSAxNi42NTg5IDE2LjQ3MDYgMTYuNjU4OSAxNS45NjQ2VjEwLjc1MjRIMTcuNjI1VjE1Ljk2NDZDMTcuNjI1IDE2Ljk5NTYgMTYuODA0NSAxNy44MTI1IDE1Ljc2MjEgMTcuODEyNUg4LjQyNTRDNy4zODMwNCAxNy44MTI1IDYuNTYyNSAxNi45OTU2IDYuNTYyNSAxNS45NjQ2VjkuNzVINy41Mjg2MloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi41NjI1IDguMjIyNTFDNi41NjI1IDcuMTkxNzYgNy4zODMwNCA2LjM3NSA4LjQyNTQgNi4zNzVIMTUuOTA4NlY4LjY0NjU3SDE2LjEzMjNDMTYuOTcyNyA4LjY0NjU3IDE3LjYyNSA5LjI5NjMxIDE3LjYyNSAxMC4xMjY2VjEwLjg5NDlDMTcuNjI1IDExLjcyNTMgMTYuOTcyNyAxMi4zNzUgMTYuMTMyMyAxMi4zNzVIOC40MjU0QzcuMzgzMDQgMTIuMzc1IDYuNTYyNSAxMS41NTgyIDYuNTYyNSAxMC41Mjc1VjguMjIyNTFaTTE0Ljk0MjUgOC42NDY1N1Y3LjMzMDc3SDguNDI1NEM3LjkxOTY1IDcuMzMwNzcgNy41Mjg2MiA3LjcxNjYxIDcuNTI4NjIgOC4yMjI1MVYxMC41Mjc1QzcuNTI4NjIgMTEuMDMzNCA3LjkxOTY1IDExLjQxOTIgOC40MjU0IDExLjQxOTJIMTEuNjEwN1Y4LjY0NjU3SDE0Ljk0MjVaTTEyLjU3NjggMTEuNDE5MkgxNi4xMzIzQzE2LjQzNjEgMTEuNDE5MiAxNi42NTg5IDExLjIwMDQgMTYuNjU4OSAxMC44OTQ5VjEwLjEyNjZDMTYuNjU4OSA5LjgyMTE1IDE2LjQzNjEgOS42MDIzNSAxNi4xMzIzIDkuNjAyMzVIMTIuNTc2OFYxMS40MTkyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMTQwLjhDMCA5MS41MTU0IDAgNjYuODczMSA5LjU5MTQzIDQ4LjA0ODhDMTguMDI4MyAzMS40OTA2IDMxLjQ5MDYgMTguMDI4MyA0OC4wNDg4IDkuNTkxNDNDNjYuODczMSAwIDkxLjUxNTQgMCAxNDAuOCAwSDM3MS4yQzQyMC40ODUgMCA0NDUuMTI3IDAgNDYzLjk1MSA5LjU5MTQzQzQ4MC41MDkgMTguMDI4MyA0OTMuOTcyIDMxLjQ5MDYgNTAyLjQwOSA0OC4wNDg4QzUxMiA2Ni44NzMxIDUxMiA5MS41MTU0IDUxMiAxNDAuOFYzNzEuMkM1MTIgNDIwLjQ4NSA1MTIgNDQ1LjEyNyA1MDIuNDA5IDQ2My45NTFDNDkzLjk3MiA0ODAuNTA5IDQ4MC41MDkgNDkzLjk3MiA0NjMuOTUxIDUwMi40MDlDNDQ1LjEyNyA1MTIgNDIwLjQ4NSA1MTIgMzcxLjIgNTEySDE0MC44QzkxLjUxNTQgNTEyIDY2Ljg3MzEgNTEyIDQ4LjA0ODggNTAyLjQwOUMzMS40OTA2IDQ5My45NzIgMTguMDI4MyA0ODAuNTA5IDkuNTkxNDMgNDYzLjk1MUMwIDQ0NS4xMjcgMCA0MjAuNDg1IDAgMzcxLjJWMTQwLjhaIiBmaWxsPSIjMjk2MkVGIi8+CjxwYXRoIGQ9Ik0xMTEuMDQ4IDEyOEMxMDIuMjc0IDEyOCA5OC44OTMxIDEzOC44NSAxMDYuMjU2IDE0My4zODJMMjkwLjQ0MyAyNTQuNDQxQzI5NS4wMzQgMjU3LjI2NyAzMDEuMTU3IDI1Ni4xNSAzMDQuMzE5IDI1MS45MDlMMzg1LjMwMSAxNDUuNTk0QzM5MC44MDcgMTM4LjIwOCAzODUuMjQ0IDEyOCAzNzUuNzEzIDEyOEgxMTEuMDQ4WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTQwMC41MzggMzg0QzQwOS4zMTEgMzg0IDQxMi43OCAzNzMuMDkyIDQwNS40MTkgMzY4LjU2MUwyMjEuMTc4IDI1Ny41MTZDMjE2LjU4NyAyNTQuNjkgMjEwLjYxMiAyNTUuOTQ4IDIwNy40NTIgMjYwLjE4OEwxMjYuMzEyIDM2Ni40ODJDMTIwLjgwOCAzNzMuODY2IDEyNi41NDUgMzg0IDEzNi4wNzQgMzg0SDQwMC41MzhaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgdmlld0JveD0iMCAwIDEyOCAxMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjY0IiBjeT0iNjQiIHI9IjY0IiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXIpIi8+CjxwYXRoIGQ9Ik0xMTAuNTg0IDY0LjkxNDJIOTkuMTQyQzk5LjE0MiA0MS43NjUxIDgwLjE3MyAyMyA1Ni43NzI0IDIzQzMzLjY2MTIgMjMgMTQuODcxNiA0MS4zMDU3IDE0LjQxMTggNjQuMDU4M0MxMy45MzYgODcuNTc3IDM2LjI0MSAxMDggNjAuMDE4NiAxMDhINjMuMDA5NEM4My45NzIzIDEwOCAxMTIuMDY5IDkxLjc2NjcgMTE2LjQ1OSA3MS45ODc0QzExNy4yNyA2OC4zNDEzIDExNC4zNTggNjQuOTE0MiAxMTAuNTg0IDY0LjkxNDJaTTM5Ljc2ODkgNjUuOTQ1NEMzOS43Njg5IDY5LjA0MTEgMzcuMjA5NSA3MS41NzI5IDM0LjA4MDIgNzEuNTcyOUMzMC45NTA5IDcxLjU3MjkgMjguMzkxNiA2OS4wMzk5IDI4LjM5MTYgNjUuOTQ1NFY1Ni44NDE0QzI4LjM5MTYgNTMuNzQ1NyAzMC45NTA5IDUxLjIxMzkgMzQuMDgwMiA1MS4yMTM5QzM3LjIwOTUgNTEuMjEzOSAzOS43Njg5IDUzLjc0NTcgMzkuNzY4OSA1Ni44NDE0VjY1Ljk0NTRaTTU5LjUyMjQgNjUuOTQ1NEM1OS41MjI0IDY5LjA0MTEgNTYuOTYzMSA3MS41NzI5IDUzLjgzMzggNzEuNTcyOUM1MC43MDQ1IDcxLjU3MjkgNDguMTQ1MSA2OS4wMzk5IDQ4LjE0NTEgNjUuOTQ1NFY1Ni44NDE0QzQ4LjE0NTEgNTMuNzQ1NyA1MC43MDU2IDUxLjIxMzkgNTMuODMzOCA1MS4yMTM5QzU2Ljk2MzEgNTEuMjEzOSA1OS41MjI0IDUzLjc0NTcgNTkuNTIyNCA1Ni44NDE0VjY1Ljk0NTRaIiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXIpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXIiIHgxPSI2NCIgeTE9IjAiIHgyPSI2NCIgeTI9IjEyOCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjNTM0QkIxIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzU1MUJGOSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXIiIHgxPSI2NS40OTk4IiB5MT0iMjMiIHgyPSI2NS40OTk4IiB5Mj0iMTA4IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IndoaXRlIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0id2hpdGUiIHN0b3Atb3BhY2l0eT0iMC44MiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.STARZWALLET = t.BITKEEPWALLET = t.WEB3AUTH = t.OPERA = t.SEQUENCE = t.COINBASEWALLET = t.WALLETLINK = t.BINANCECHAINWALLET = t.FRAME = t.BITSKI = t.LEDGER = t.DCENT = t.MEWCONNECT = t.BURNERCONNECT = t.AUTHEREUM = t.VENLY = t.TORUS = t.FORTMATIC = t.PORTIS = t.WALLETCONNECT = void 0;
            var i = n(0), r = i.__importDefault(n(95)), M = i.__importDefault(n(96)), u = i.__importDefault(n(97)), o = i.__importDefault(n(98)), c = i.__importDefault(n(99)), a = i.__importDefault(n(100)), I = i.__importDefault(n(101)), l = i.__importDefault(n(102)), N = i.__importDefault(n(103)), j = i.__importDefault(n(104)), g = i.__importDefault(n(105)), s = i.__importDefault(n(13)), A = i.__importDefault(n(14)), D = i.__importDefault(n(106)), d = i.__importDefault(n(107)), T = i.__importDefault(n(108)), y = i.__importDefault(n(15)), z = i.__importDefault(n(16)), w = i.__importDefault(n(109));
            i.__exportStar(n(12), t), t.WALLETCONNECT = {
                id: "walletconnect",
                name: "WalletConnect",
                logo: r.default,
                type: "qrcode",
                check: "isWalletConnect",
                package: {
                    required: [
                        [
                            "infuraId",
                            "rpc"
                        ]
                    ]
                }
            }, t.PORTIS = {
                id: "portis",
                name: "Portis",
                logo: M.default,
                type: "web",
                check: "isPortis",
                package: {
                    required: [
                        "id"
                    ]
                }
            }, t.FORTMATIC = {
                id: "fortmatic",
                name: "Fortmatic",
                logo: u.default,
                type: "web",
                check: "isFortmatic",
                package: {
                    required: [
                        "key"
                    ]
                }
            }, t.TORUS = {
                id: "torus",
                name: "Torus",
                logo: c.default,
                type: "web",
                check: "isTorus"
            }, t.VENLY = {
                id: "venly",
                name: "Venly",
                logo: o.default,
                type: "web",
                check: "isVenly",
                package: {
                    required: [
                        "clientId"
                    ]
                }
            }, t.AUTHEREUM = {
                id: "authereum",
                name: "Authereum",
                logo: a.default,
                type: "web",
                check: "isAuthereum"
            }, t.BURNERCONNECT = {
                id: "burnerconnect",
                name: "Burner Connect",
                logo: I.default,
                type: "web",
                check: "isBurnerProvider"
            }, t.MEWCONNECT = {
                id: "mewconnect",
                name: "MEW wallet",
                logo: l.default,
                type: "qrcode",
                check: "isMEWconnect",
                package: {
                    required: [
                        [
                            "infuraId",
                            "rpc"
                        ]
                    ]
                }
            }, t.DCENT = {
                id: "dcentwallet",
                name: "D'CENT",
                logo: N.default,
                type: "hardware",
                check: "isDcentWallet",
                package: {
                    required: [
                        "rpcUrl"
                    ]
                }
            }, t.LEDGER = {
                id: "ledger",
                name: "Ledger",
                logo: j.default,
                type: "hardware",
                check: "isLedgerConnect"
            }, t.BITSKI = {
                id: "bitski",
                name: "Bitski",
                logo: g.default,
                type: "web",
                check: "isBitski",
                package: {
                    required: [
                        "clientId",
                        "callbackUrl"
                    ]
                }
            }, t.FRAME = {
                id: "frame",
                name: "Frame",
                logo: A.default,
                type: "web",
                check: "isFrameNative"
            }, t.BINANCECHAINWALLET = {
                id: "binancechainwallet",
                name: "Binance Chain",
                logo: D.default,
                type: "injected",
                check: "isBinanceChainWallet"
            }, t.WALLETLINK = {
                id: "walletlink",
                name: "Coinbase Wallet",
                logo: d.default,
                type: "qrcode",
                check: "isWalletLink",
                package: {
                    required: [
                        [
                            "appName",
                            "infuraId",
                            "rpc"
                        ]
                    ]
                }
            }, t.COINBASEWALLET = {
                id: "coinbasewallet",
                name: "Coinbase",
                logo: d.default,
                type: "injected",
                check: "isWalletLink",
                package: {
                    required: [
                        [
                            "appName",
                            "infuraId",
                            "rpc"
                        ]
                    ]
                }
            }, t.SEQUENCE = {
                id: "sequence",
                name: "Sequence",
                logo: y.default,
                type: "web",
                check: "isSequenceWeb"
            }, t.OPERA = {
                id: "opera",
                name: "Opera",
                logo: s.default,
                type: "injected",
                check: "isOpera"
            }, t.WEB3AUTH = {
                id: "web3auth",
                name: "Web3Auth",
                logo: T.default,
                type: "injected",
                check: "isWeb3Auth"
            }, t.BITKEEPWALLET = {
                id: "bitkeep",
                name: "Bitkeep Wallet",
                logo: z.default,
                type: "injected",
                check: "isBitKeep"
            }, t.STARZWALLET = {
                id: "starzwallet",
                name: "99Starz",
                logo: w.default,
                type: "injected",
                check: "isStarzWallet"
            };
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjYzIiB2aWV3Qm94PSIwIDAgNjMgNjMiIHdpZHRoPSI2MyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im0zMS42MzkzLjk4NDM3NWgxNS4zMjc0IDE1LjMyNzV2MTUuMjk5MDI1aC0xNS4zMjc1LTE1LjMyNzQtMTUuMzI3NXYxNS4yOTg5Ljk4MSAxNC4yMjg5LjA4OTEgMTUuMjA5OWgtMTUuMzI3NDI1di0xNS4yMDk5LS4wODkxLTE0LjIyODktLjk4MS0xNS4yOTg5LTE1LjI5OTAyNWgxNS4zMjc0MjV6bTE1LjMyNzQgNDUuODA4MzI1aC0xNS4yMzgxdi0xNS4yMDk4aDMwLjU1NjZ2MTUuNzQ0OWMwIDMuOTE0LTEuNTU3MSA3LjY2OC00LjMyOTEgMTAuNDM2NXMtNi41MzE5IDQuMzI1LTEwLjQ1MzMgNC4zMjc0aC0uNTM2MXoiIGZpbGw9IiM2MTdiZmYiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYwIiBoZWlnaHQ9IjUxNyIgdmlld0JveD0iMCAwIDU2MCA1MTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01NTQuNTU1IDE2OS4yNzZMNDg1Ljg2NyAxOTUuMzY1QzQ4Mi45NzkgMTk2LjQxNSA0ODAuMTc5IDE5My42MTQgNDgxLjQwNCAxOTAuNzI1TDU1Ny45NjggNC44NjA4M0M1NTkuMTA1IDIuMDU5MyA1NTYuMzkzIC0wLjgyOTc3OCA1NTMuNTkzIDAuMjIwNzk1TDQwOC4wNzggNTEuMTczNkM0MDUuMjc4IDUyLjEzNjYgNDAzLjAwMyA1NC4zMjUzIDQwMS44NjYgNTcuMTI2OEwzMDMuMjUyIDMwNi4wMjVDMzAyLjAyNyAzMDkuMTc3IDMwNS4wODkgMzEyLjMyOSAzMDguMjM5IDMxMS4xOUwzNjkuODQgMjg4LjYwM0MzNzMuMjUzIDI4Ny4zNzcgMzc2LjQwMyAyOTEuMDU0IDM3NC41NjUgMjk0LjI5NEwyODQuMDg5IDQ0Ny45NEMyODIuMTY0IDQ1MS4yNjcgMjc3LjI2NCA0NTEuMjY3IDI3NS4zMzkgNDQ3Ljk0TDE4NC44NjMgMjk0LjIwNkMxODMuMDI1IDI5MS4wNTQgMTg2LjA4OCAyODcuMjkgMTg5LjU4OCAyODguNTE2TDI1MS4xODkgMzExLjEwM0MyNTQuMzM5IDMxMi4yNDEgMjU3LjQwMSAzMDkuMDg5IDI1Ni4xNzYgMzA1LjkzOEwxNTcuNDc1IDU3LjEyNjhDMTU2LjMzNyA1NC4zMjUzIDE1NC4xNSA1Mi4yMjQyIDE1MS4yNjIgNTEuMTczNkw1LjkyMjY3IDAuMjIwNzk1QzMuMDM1MTMgLTAuNzQyMjMgMC40MTAwOTIgMi4wNTkzIDEuNTQ3NjEgNC44NjA4M0w3OC4wMjM3IDE5MC43MjVDNzkuMTYxMiAxOTMuNTI2IDc2LjM2MTIgMTk2LjQxNSA3My41NjExIDE5NS4zNjVMNS4zMTAxNiAxNjkuMjc2QzEuODEwMTEgMTY3Ljk2MiAtMS4zMzk5MyAxNzEuNzI3IDAuNTg1MDk1IDE3NC45NjZMMjAzLjc2MyA1MTEuNUMyMDUuNzc1IDUxNC44MjYgMjA5LjM2MyA1MTYuODQgMjEzLjMwMSA1MTYuODRIMzQ2LjQ3N0MzNTAuMzI4IDUxNi44NCAzNTQuMDAzIDUxNC44MjYgMzU2LjAxNSA1MTEuNUw1NTkuNTQzIDE3NC45NjZDNTYxLjIwNSAxNzEuNzI3IDU1OC4wNTUgMTY3Ljk2MiA1NTQuNTU1IDE2OS4yNzZaIiBmaWxsPSIjNzkyN0ZGIi8+Cjwvc3ZnPgo=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjU3IiBoZWlnaHQ9IjI3NyIgdmlld0JveD0iMCAwIDI1NyAyNzciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cmVjdCB3aWR0aD0iMTUzLjg4OSIgaGVpZ2h0PSI4Mi4wNzQxIiBmaWxsPSIjMDM2NEZGIiAvPgogICAgPHJlY3QgeD0iNzEuODEzNSIgd2lkdGg9IjgyLjA3NDEiIGhlaWdodD0iMjc3IiBmaWxsPSIjMDM2NEZGIiAvPgogICAgPHBhdGggZD0iTTIxNS40NDMgODIuMDc0MUMyMzguMTA3IDgyLjA3NDEgMjU2LjQ4IDYzLjcwMTIgMjU2LjQ4IDQxLjAzN0MyNTYuNDggMTguMzcyOSAyMzguMTA3IDAgMjE1LjQ0MyAwQzE5Mi43NzkgMCAxNzQuNDA2IDE4LjM3MjkgMTc0LjQwNiA0MS4wMzdDMTc0LjQwNiA2My43MDEyIDE5Mi43NzkgODIuMDc0MSAyMTUuNDQzIDgyLjA3NDFaIiBmaWxsPSIjMDM2NEZGIiAvPgo8L3N2Zz4=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/png;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGcgZmlsbD0iI2YwYjkwYiI+PHBhdGggZD0iTTIwLjI0NSAwTDkuNjM0IDYuMTI1bDMuOTAxIDIuMjYyIDYuNzEtMy44NjIgNi43MSAzLjg2MiAzLjkwMi0yLjI2MkwyMC4yNDUgMHptNi43MTEgMTEuNTg2bDMuOSAyLjI2M3Y0LjUyNmwtNi43MSAzLjg2MnY3LjcyNGwtMy45IDIuMjYzLTMuOTAyLTIuMjYzdi03LjcyNGwtNi43MS0zLjg2MnYtNC41MjZsMy45MDEtMi4yNjMgNi43MSAzLjg2MyA2LjcxLTMuODYzaC4wMDF6Ii8+PHBhdGggZD0iTTMwLjg1NyAyMS41NzNWMjYuMWwtMy45MDEgMi4yNjJ2LTQuNTI1bDMuOS0yLjI2My4wMDEtLjAwMXoiLz48cGF0aCBkPSJNMjYuOTE2IDMxLjU2bDYuNzEtMy44NjJ2LTcuNzI0bDMuOTAyLTIuMjYzdjEyLjI1bC0xMC42MTEgNi4xMjVWMzEuNTZoLS4wMDF6bTYuNzExLTE5LjMxbC0zLjkwMi0yLjI2MyAzLjkwMi0yLjI2MyAzLjkgMi4yNjN2NC41MjVsLTMuOSAyLjI2M1YxMi4yNXpNMTYuMzQ0IDM3LjcyNFYzMy4ybDMuOTAxIDIuMjYzIDMuOTAyLTIuMjYzdjQuNTI1bC0zLjkwMiAyLjI2My0zLjktMi4yNjMtLjAwMS0uMDAxem0tMi44MDktOS4zNjNMOS42MzQgMjYuMXYtNC41MjZsMy45MDEgMi4yNjN2NC41MjUtLjAwMXptNi43MS0xNi4xMTFsLTMuOS0yLjI2MyAzLjktMi4yNjMgMy45MDIgMi4yNjMtMy45MDIgMi4yNjN6bS05LjQ4LTIuMjYzbC0zLjkgMi4yNjN2NC41MjVsLTMuOTAyLTIuMjYzVjkuOTg3bDMuOTAxLTIuMjYzIDMuOTAxIDIuMjYzeiIvPjxwYXRoIGQ9Ik0yLjk2MyAxNy43MTFsMy45MDEgMi4yNjN2Ny43MjRsNi43MSAzLjg2MnY0LjUyNkwyLjk2MyAyOS45NlYxNy43MXYuMDAxeiIvPjwvZz48L3N2Zz4=";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzgzcHgiIGhlaWdodD0iMzgzcHgiIHZpZXdCb3g9IjAgMCAzODMgMzgzIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1NC4xICg3NjQ5MCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+Q29pbmJhc2UgV2FsbGV0IFNESzwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPgogICAgICAgIDxyZWN0IGlkPSJwYXRoLTEiIHg9IjAiIHk9IjAiIHdpZHRoPSIzODMiIGhlaWdodD0iMzgzIiByeD0iNjQiPjwvcmVjdD4KICAgICAgICA8bGluZWFyR3JhZGllbnQgeDE9IjQ5Ljk5OTk5MzglIiB5MT0iMCUiIHgyPSI0OS45OTk5OTM4JSIgeTI9IjEwMCUiIGlkPSJsaW5lYXJHcmFkaWVudC0zIj4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iIzJFNjZGOCIgb2Zmc2V0PSIwJSI+PC9zdG9wPgogICAgICAgICAgICA8c3RvcCBzdG9wLWNvbG9yPSIjMTI0QURCIiBvZmZzZXQ9IjEwMCUiPjwvc3RvcD4KICAgICAgICA8L2xpbmVhckdyYWRpZW50PgogICAgPC9kZWZzPgogICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9ImNvaW5iYXNld2FsbGV0Ij4KICAgICAgICAgICAgPGcgaWQ9IlBhdGgiPgogICAgICAgICAgICAgICAgPG1hc2sgaWQ9Im1hc2stMiIgZmlsbD0id2hpdGUiPgogICAgICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+CiAgICAgICAgICAgICAgICA8L21hc2s+CiAgICAgICAgICAgICAgICA8cmVjdCBzdHJva2U9IiM5Nzk3OTciIHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMzgyIiBoZWlnaHQ9IjM4MiIgcng9IjY0Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBmaWxsPSJ1cmwoI2xpbmVhckdyYWRpZW50LTMpIiBmaWxsLXJ1bGU9Im5vbnplcm8iIG1hc2s9InVybCgjbWFzay0yKSIgcG9pbnRzPSIwIDAgMzgzIDAgMzgzIDM4NCAwIDM4NCI+PC9wb2x5Z29uPgogICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik02MC4xMDc0LDE5MS41NzIgQzYwLjEwNzQsMjY0Ljk2NiAxMTkuNjA1LDMyNC40NjMgMTkyLjk5OCwzMjQuNDYzIEMyNjYuMzkyLDMyNC40NjMgMzI1Ljg4OSwyNjQuOTY2IDMyNS44ODksMTkxLjU3MiBDMzI1Ljg4OSwxMTguMTc5IDI2Ni4zOTIsNTguNjgxNiAxOTIuOTk4LDU4LjY4MTYgQzExOS42MDUsNTguNjgxNiA2MC4xMDc0LDExOC4xNzkgNjAuMTA3NCwxOTEuNTcyIFogTTE1OS4wMzcsMTQ4Ljc1MiBDMTU0LjE0NCwxNDguNzUyIDE1MC4xNzgsMTUyLjcxOCAxNTAuMTc4LDE1Ny42MTEgTDE1MC4xNzgsMjI1LjUzMyBDMTUwLjE3OCwyMzAuNDI2IDE1NC4xNDQsMjM0LjM5MyAxNTkuMDM3LDIzNC4zOTMgTDIyNi45NTksMjM0LjM5MyBDMjMxLjg1MiwyMzQuMzkzIDIzNS44MTgsMjMwLjQyNiAyMzUuODE4LDIyNS41MzMgTDIzNS44MTgsMTU3LjYxMSBDMjM1LjgxOCwxNTIuNzE4IDIzMS44NTIsMTQ4Ljc1MiAyMjYuOTU5LDE0OC43NTIgTDE1OS4wMzcsMTQ4Ljc1MiBaIiBpZD0iU2hhcGUiIGZpbGw9IiNGRkZGRkYiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t) {
            e.exports = "data:image/svg+xml;base64,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";
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Modal = void 0;
            var i, r, M, u, o = n(0), c = o.__importStar(n(1)), a = o.__importStar(n(112)), I = o.__importDefault(n(18)), l = n(19), N = n(2), j = I.default.div(i || (i = o.__makeTemplateObject([
                "\n  transition: opacity 0.1s ease-in-out;\n  text-align: center;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  margin-left: -50vw;\n  top: ",
                ";\n  left: 50%;\n  z-index: 2;\n  will-change: opacity;\n  background-color: ",
                ";\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & * {\n    box-sizing: border-box !important;\n  }\n"
            ], [
                "\n  transition: opacity 0.1s ease-in-out;\n  text-align: center;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  margin-left: -50vw;\n  top: ",
                ";\n  left: 50%;\n  z-index: 2;\n  will-change: opacity;\n  background-color: ",
                ";\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  & * {\n    box-sizing: border-box !important;\n  }\n"
            ])), function(e) {
                var t = e.offset;
                return t ? "-" + t + "px" : 0;
            }, function(e) {
                var t = e.opacity, n = .4;
                return "number" == typeof t && (n = t), "rgba(0, 0, 0, " + n + ")";
            }, function(e) {
                return e.show ? 1 : 0;
            }, function(e) {
                return e.show ? "visible" : "hidden";
            }, function(e) {
                return e.show ? "auto" : "none";
            }), g = I.default.div(r || (r = o.__makeTemplateObject([
                "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n"
            ], [
                "\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n"
            ])), function(e) {
                return e.show ? 1 : 0;
            }, function(e) {
                return e.show ? "visible" : "hidden";
            }, function(e) {
                return e.show ? "auto" : "none";
            }), s = I.default.div(M || (M = o.__makeTemplateObject([
                "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"
            ], [
                "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"
            ]))), A = I.default.div(u || (u = o.__makeTemplateObject([
                "\n  position: relative;\n  width: 100%;\n  background-color: ",
                ";\n  border-radius: 12px;\n  margin: 10px;\n  padding: 0;\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  max-width: ",
                ";\n  min-width: fit-content;\n  max-height: 100%;\n  overflow: auto;\n\n  @media screen and (max-width: 768px) {\n    max-width: ",
                ";\n    grid-template-columns: 1fr;\n  }\n"
            ], [
                "\n  position: relative;\n  width: 100%;\n  background-color: ",
                ";\n  border-radius: 12px;\n  margin: 10px;\n  padding: 0;\n  opacity: ",
                ";\n  visibility: ",
                ";\n  pointer-events: ",
                ";\n\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  max-width: ",
                ";\n  min-width: fit-content;\n  max-height: 100%;\n  overflow: auto;\n\n  @media screen and (max-width: 768px) {\n    max-width: ",
                ";\n    grid-template-columns: 1fr;\n  }\n"
            ])), function(e) {
                return e.themeColors.background;
            }, function(e) {
                return e.show ? 1 : 0;
            }, function(e) {
                return e.show ? "visible" : "hidden";
            }, function(e) {
                return e.show ? "auto" : "none";
            }, function(e) {
                var t = e.maxWidth;
                return t ? t + "px" : "800px";
            }, function(e) {
                var t = e.maxWidth;
                return t ? t + "px" : "500px";
            }), D = {
                show: !1,
                lightboxOffset: 0
            }, d = function(e) {
                function t(t) {
                    var n = e.call(this, t) || this;
                    return n.state = o.__assign({}, D), n.render = function() {
                        var e = n.state, t = e.show, i = e.lightboxOffset, r = n.props, M = r.onClose, u = r.lightboxOpacity, o = r.userOptions, a = r.themeColors;
                        return c.createElement(j, {
                            className: N.MODAL_LIGHTBOX_CLASSNAME,
                            offset: i,
                            opacity: u,
                            ref: function(e) {
                                return n.lightboxRef = e;
                            },
                            show: t
                        }, c.createElement(g, {
                            className: N.MODAL_CONTAINER_CLASSNAME,
                            show: t
                        }, c.createElement(s, {
                            className: N.MODAL_HITBOX_CLASSNAME,
                            onClick: M
                        }), c.createElement(A, {
                            className: N.MODAL_CARD_CLASSNAME,
                            show: t,
                            themeColors: a,
                            maxWidth: o.length < 3 ? 500 : 800,
                            ref: function(e) {
                                return n.mainModalCard = e;
                            }
                        }, o.map(function(e) {
                            return e ? c.createElement(l.Provider, {
                                name: e.name,
                                logo: e.logo,
                                description: e.description,
                                themeColors: a,
                                onClick: e.onClick
                            }) : null;
                        }))));
                    }, window.updateWeb3Modal = function(e) {
                        return o.__awaiter(n, void 0, void 0, function() {
                            return o.__generator(this, function(t) {
                                return this.setState(e), [
                                    2
                                ];
                            });
                        });
                    }, n;
                }
                return o.__extends(t, e), t.prototype.componentDidUpdate = function(e, t) {
                    if (t.show && !this.state.show && this.props.resetState(), this.lightboxRef) {
                        var n = this.lightboxRef.getBoundingClientRect(), i = n.top > 0 ? n.top : 0;
                        i !== D.lightboxOffset && i !== this.state.lightboxOffset && this.setState({
                            lightboxOffset: i
                        });
                    }
                }, t.propTypes = {
                    userOptions: a.object.isRequired,
                    onClose: a.func.isRequired,
                    resetState: a.func.isRequired,
                    lightboxOpacity: a.number.isRequired
                }, t;
            }(c.Component);
            t.Modal = d;
        },
        function(e, t, n) {
            e.exports = n(113)();
        },
        function(e, t, n) {
            "use strict";
            var i = n(114);
            function r() {}
            function M() {}
            M.resetWarningCache = r, e.exports = function() {
                function e(e, t, n, r, M, u) {
                    if (u !== i) {
                        var o = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                        throw o.name = "Invariant Violation", o;
                    }
                }
                function t() {
                    return e;
                }
                e.isRequired = e;
                var n = {
                    array: e,
                    bigint: e,
                    bool: e,
                    func: e,
                    number: e,
                    object: e,
                    string: e,
                    symbol: e,
                    any: e,
                    arrayOf: t,
                    element: e,
                    elementType: e,
                    instanceOf: t,
                    node: e,
                    objectOf: t,
                    oneOf: t,
                    oneOfType: t,
                    shape: t,
                    exact: t,
                    checkPropTypes: M,
                    resetWarningCache: r
                };
                return n.PropTypes = n, n;
            };
        },
        function(e, t, n) {
            "use strict";
            e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
        },
        function(e, t, n) {
            "use strict";
            /** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var i = 60103, r = 60106, M = 60107, u = 60108, o = 60114, c = 60109, a = 60110, I = 60112, l = 60113, N = 60120, j = 60115, g = 60116, s = 60121, A = 60122, D = 60117, d = 60129, T = 60131;
            if ("function" == typeof Symbol && Symbol.for) {
                var y = Symbol.for;
                i = y("react.element"), r = y("react.portal"), M = y("react.fragment"), u = y("react.strict_mode"), o = y("react.profiler"), c = y("react.provider"), a = y("react.context"), I = y("react.forward_ref"), l = y("react.suspense"), N = y("react.suspense_list"), j = y("react.memo"), g = y("react.lazy"), s = y("react.block"), A = y("react.server.block"), D = y("react.fundamental"), d = y("react.debug_trace_mode"), T = y("react.legacy_hidden");
            }
            function z(e) {
                if ("object" == typeof e && null !== e) {
                    var t = e.$$typeof;
                    switch(t){
                        case i:
                            switch(e = e.type){
                                case M:
                                case o:
                                case u:
                                case l:
                                case N:
                                    return e;
                                default:
                                    switch(e = e && e.$$typeof){
                                        case a:
                                        case I:
                                        case g:
                                        case j:
                                        case c:
                                            return e;
                                        default:
                                            return t;
                                    }
                            }
                        case r:
                            return t;
                    }
                }
            }
            var w = c, f = i, L = I, E = M, C = g, x = j, p = r, S = o, m = u, O = l;
            t.ContextConsumer = a, t.ContextProvider = w, t.Element = f, t.ForwardRef = L, t.Fragment = E, t.Lazy = C, t.Memo = x, t.Portal = p, t.Profiler = S, t.StrictMode = m, t.Suspense = O, t.isAsyncMode = function() {
                return !1;
            }, t.isConcurrentMode = function() {
                return !1;
            }, t.isContextConsumer = function(e) {
                return z(e) === a;
            }, t.isContextProvider = function(e) {
                return z(e) === c;
            }, t.isElement = function(e) {
                return "object" == typeof e && null !== e && e.$$typeof === i;
            }, t.isForwardRef = function(e) {
                return z(e) === I;
            }, t.isFragment = function(e) {
                return z(e) === M;
            }, t.isLazy = function(e) {
                return z(e) === g;
            }, t.isMemo = function(e) {
                return z(e) === j;
            }, t.isPortal = function(e) {
                return z(e) === r;
            }, t.isProfiler = function(e) {
                return z(e) === o;
            }, t.isStrictMode = function(e) {
                return z(e) === u;
            }, t.isSuspense = function(e) {
                return z(e) === l;
            }, t.isValidElementType = function(e) {
                return "string" == typeof e || "function" == typeof e || e === M || e === o || e === d || e === u || e === l || e === N || e === T || "object" == typeof e && null !== e && (e.$$typeof === g || e.$$typeof === j || e.$$typeof === c || e.$$typeof === a || e.$$typeof === I || e.$$typeof === D || e.$$typeof === s || e[0] === A);
            }, t.typeOf = z;
        },
        function(e, t, n) {
            "use strict";
            e.exports = n(117);
        },
        function(e, t, n) {
            "use strict";
            /** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var i = "function" == typeof Symbol && Symbol.for, r = i ? Symbol.for("react.element") : 60103, M = i ? Symbol.for("react.portal") : 60106, u = i ? Symbol.for("react.fragment") : 60107, o = i ? Symbol.for("react.strict_mode") : 60108, c = i ? Symbol.for("react.profiler") : 60114, a = i ? Symbol.for("react.provider") : 60109, I = i ? Symbol.for("react.context") : 60110, l = i ? Symbol.for("react.async_mode") : 60111, N = i ? Symbol.for("react.concurrent_mode") : 60111, j = i ? Symbol.for("react.forward_ref") : 60112, g = i ? Symbol.for("react.suspense") : 60113, s = i ? Symbol.for("react.suspense_list") : 60120, A = i ? Symbol.for("react.memo") : 60115, D = i ? Symbol.for("react.lazy") : 60116, d = i ? Symbol.for("react.block") : 60121, T = i ? Symbol.for("react.fundamental") : 60117, y = i ? Symbol.for("react.responder") : 60118, z = i ? Symbol.for("react.scope") : 60119;
            function w(e) {
                if ("object" == typeof e && null !== e) {
                    var t = e.$$typeof;
                    switch(t){
                        case r:
                            switch(e = e.type){
                                case l:
                                case N:
                                case u:
                                case c:
                                case o:
                                case g:
                                    return e;
                                default:
                                    switch(e = e && e.$$typeof){
                                        case I:
                                        case j:
                                        case D:
                                        case A:
                                        case a:
                                            return e;
                                        default:
                                            return t;
                                    }
                            }
                        case M:
                            return t;
                    }
                }
            }
            function f(e) {
                return w(e) === N;
            }
            t.AsyncMode = l, t.ConcurrentMode = N, t.ContextConsumer = I, t.ContextProvider = a, t.Element = r, t.ForwardRef = j, t.Fragment = u, t.Lazy = D, t.Memo = A, t.Portal = M, t.Profiler = c, t.StrictMode = o, t.Suspense = g, t.isAsyncMode = function(e) {
                return f(e) || w(e) === l;
            }, t.isConcurrentMode = f, t.isContextConsumer = function(e) {
                return w(e) === I;
            }, t.isContextProvider = function(e) {
                return w(e) === a;
            }, t.isElement = function(e) {
                return "object" == typeof e && null !== e && e.$$typeof === r;
            }, t.isForwardRef = function(e) {
                return w(e) === j;
            }, t.isFragment = function(e) {
                return w(e) === u;
            }, t.isLazy = function(e) {
                return w(e) === D;
            }, t.isMemo = function(e) {
                return w(e) === A;
            }, t.isPortal = function(e) {
                return w(e) === M;
            }, t.isProfiler = function(e) {
                return w(e) === c;
            }, t.isStrictMode = function(e) {
                return w(e) === o;
            }, t.isSuspense = function(e) {
                return w(e) === g;
            }, t.isValidElementType = function(e) {
                return "string" == typeof e || "function" == typeof e || e === u || e === N || e === c || e === o || e === g || e === s || "object" == typeof e && null !== e && (e.$$typeof === D || e.$$typeof === A || e.$$typeof === a || e.$$typeof === I || e.$$typeof === j || e.$$typeof === T || e.$$typeof === y || e.$$typeof === z || e.$$typeof === d);
            }, t.typeOf = w;
        },
        function(e, t, n) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.ProviderController = void 0;
            var i = n(0), r = i.__importStar(n(5)), M = n(2), u = n(3), o = n(21), c = function() {
                function e(e) {
                    var t = this;
                    this.cachedProvider = "", this.shouldCacheProvider = !1, this.disableInjectedProvider = !1, this.eventController = new o.EventController, this.injectedProvider = null, this.providers = [], this.network = "", this.getUserOptions = function() {
                        var e = u.isMobile(), n = t.providers.map(function(e) {
                            return e.id;
                        }), i = !!t.injectedProvider && !t.disableInjectedProvider, r = [];
                        i && e ? r.push(M.INJECTED_PROVIDER_ID) : (i && r.push(M.INJECTED_PROVIDER_ID), n.forEach(function(e) {
                            e !== M.INJECTED_PROVIDER_ID && t.shouldDisplayProvider(e) && r.push(e);
                        }));
                        var o = [];
                        return r.forEach(function(e) {
                            var n = t.getProvider(e);
                            if (void 0 !== n) {
                                var i = n.id, r = n.name, M = n.logo, c = n.connector;
                                o.push({
                                    id: i,
                                    name: r,
                                    logo: M,
                                    description: u.getProviderDescription(n),
                                    onClick: function() {
                                        return t.connectTo(i, c);
                                    }
                                });
                            }
                        }), o;
                    }, this.connectTo = function(e, n) {
                        return i.__awaiter(t, void 0, void 0, function() {
                            var t, r, u, o, c;
                            return i.__generator(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        return a.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]), this.eventController.trigger(M.SELECT_EVENT, e), t = this.getProviderOption(e, "package"), r = this.getProviderOption(e, "options"), u = i.__assign({
                                            network: this.network || void 0
                                        }, r), [
                                            4,
                                            n(t, u)
                                        ];
                                    case 1:
                                        return o = a.sent(), this.eventController.trigger(M.CONNECT_EVENT, o), this.shouldCacheProvider && this.cachedProvider !== e && this.setCachedProvider(e), [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        return c = a.sent(), this.eventController.trigger(M.ERROR_EVENT, c), [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }, this.cachedProvider = u.getLocal(M.CACHED_PROVIDER_KEY) || "", this.disableInjectedProvider = e.disableInjectedProvider, this.shouldCacheProvider = e.cacheProvider, this.providerOptions = e.providerOptions, this.network = e.network, this.injectedProvider = u.getInjectedProvider(), this.providers = Object.keys(r.connectors).map(function(e) {
                        var n;
                        (n = e === M.INJECTED_PROVIDER_ID ? t.injectedProvider || r.providers.FALLBACK : u.getProviderInfoById(e), t.providerOptions[e]) && void 0 !== t.providerOptions[e].display && (n = i.__assign(i.__assign({}, n), t.providerOptions[e].display));
                        return i.__assign(i.__assign({}, n), {
                            connector: r.connectors[e],
                            package: n.package
                        });
                    }), Object.keys(this.providerOptions).filter(function(e) {
                        return e.startsWith("custom-");
                    }).map(function(e) {
                        if (e && t.providerOptions[e]) {
                            var n = t.providerOptions[e];
                            void 0 !== n.display && void 0 !== n.connector && t.providers.push(i.__assign(i.__assign(i.__assign(i.__assign({}, r.providers.FALLBACK), {
                                id: e
                            }), n.display), {
                                connector: n.connector
                            }));
                        }
                    });
                }
                return e.prototype.shouldDisplayProvider = function(e) {
                    var t = this.getProvider(e);
                    if (void 0 !== t) {
                        var n = this.providerOptions[e];
                        if (n) {
                            if (!!n.package) {
                                var i = t.package ? t.package.required : void 0;
                                if (!i || !i.length) return !0;
                                var r = n.options;
                                if (r && Object.keys(r).length) {
                                    var M = u.findMatchingRequiredOptions(i, r);
                                    if (i.length === M.length) return !0;
                                }
                            }
                        }
                    }
                    return !1;
                }, e.prototype.getProvider = function(e) {
                    return u.filterMatches(this.providers, function(t) {
                        return t.id === e;
                    }, void 0);
                }, e.prototype.getProviderOption = function(e, t) {
                    return this.providerOptions && this.providerOptions[e] && this.providerOptions[e][t] ? this.providerOptions[e][t] : {};
                }, e.prototype.clearCachedProvider = function() {
                    this.cachedProvider = "", u.removeLocal(M.CACHED_PROVIDER_KEY);
                }, e.prototype.setCachedProvider = function(e) {
                    this.cachedProvider = e, u.setLocal(M.CACHED_PROVIDER_KEY, e);
                }, e.prototype.connectToCachedProvider = function() {
                    return i.__awaiter(this, void 0, void 0, function() {
                        var e;
                        return i.__generator(this, function(t) {
                            switch(t.label){
                                case 0:
                                    return void 0 === (e = this.getProvider(this.cachedProvider)) ? [
                                        3,
                                        2
                                    ] : [
                                        4,
                                        this.connectTo(e.id, e.connector)
                                    ];
                                case 1:
                                    t.sent(), t.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }, e.prototype.on = function(e, t) {
                    var n = this;
                    return this.eventController.on({
                        event: e,
                        callback: t
                    }), function() {
                        return n.eventController.off({
                            event: e,
                            callback: t
                        });
                    };
                }, e.prototype.off = function(e, t) {
                    this.eventController.off({
                        event: e,
                        callback: t
                    });
                }, e;
            }();
            t.ProviderController = c;
        }
    ]);
});



var $e5s6c = parcelRequire("e5s6c");
var $f6ca566de446e670$exports = {};

$f6ca566de446e670$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "starknet.a4d930bd.png";


const $050990180fbd2df8$export$af1c0561ce3e4019 = {
    // [9001]: {
    //   chainId: utils.hexValue(9001),
    //   rpcUrls: ["https://eth.bd.evmos.org:8545"],
    //   chainName: "Evmos Mainnet",
    //   label: "Evmos",
    //   nativeCurrency: {
    //     name: "EVMOS",
    //     symbol: "EVMOS",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://evm.evmos.org/"],
    //   exampleContractAddress: "0x2e441adc345daeb11ff9c2cae7efd461e5525850",
    //   contractExplorerUrl:
    //     "https://evm.evmos.org/address/0x2e441adc345daeb11ff9c2cae7efd461e5525850",
    //   logo: EvmosLogo,
    // },
    // [137]: {
    //   chainId: utils.hexValue(137),
    //   rpcUrls: ["https://polygon-rpc.com"],
    //   chainName: "Polygon",
    //   label: "Polygon",
    //   nativeCurrency: {
    //     name: "MATIC",
    //     symbol: "MATIC",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://polygonscan.com/"],
    //   exampleContractAddress: "0x0721b16dDC4931472b69855A5C149443C232205F",
    //   contractExplorerUrl:
    //     "https://polygonscan.com/address/0x0721b16dDC4931472b69855A5C149443C232205F",
    //   logo: PolygonLogo,
    // },
    // [42161]: {
    //   chainId: utils.hexValue(42161),
    //   rpcUrls: ["https://arb1.arbitrum.io/rpc"],
    //   chainName: "Arbitrum One",
    //   label: "Arbitrum",
    //   nativeCurrency: {
    //     name: "ETH",
    //     symbol: "ETH",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://arbiscan.io/"],
    //   exampleContractAddress: "0x2e441adc345daeb11ff9c2cae7efd461e5525850",
    //   contractExplorerUrl:
    //     "https://arbiscan.io/address/0x2e441adc345daeb11ff9c2cae7efd461e5525850",
    //   logo: ArbitrumLogo,
    // },
    // [10]: {
    //   chainId: utils.hexValue(10),
    //   rpcUrls: ["https://mainnet.optimism.io"],
    //   chainName: "Optimism",
    //   label: "Optimism",
    //   nativeCurrency: {
    //     name: "ETH",
    //     symbol: "ETH",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://optimistic.etherscan.io/"],
    //   exampleContractAddress: "0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
    //   contractExplorerUrl:
    //     "https://optimistic.etherscan.io/address/0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
    //   logo: OptimismLogo,
    // },
    // [5]: {
    //   chainId: utils.hexValue(5),
    //   rpcUrls: ["https://goerli.infura.io/v3/"],
    //   chainName: "Goerli Test Network",
    //   label: "Goerli",
    //   nativeCurrency: {
    //     name: "GoerliETH",
    //     symbol: "GoerliETH",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://goerli.etherscan.io/"],
    //   exampleContractAddress: "0xC9BE33f28520B1D94614039Ed06D5e8ed2cee048",
    //   contractExplorerUrl:
    //     "https://goerli.etherscan.io/address/0xC9BE33f28520B1D94614039Ed06D5e8ed2cee048",
    //   logo: EthereumLogo,
    // },
    // [43114]: {
    //   chainId: utils.hexValue(43114),
    //   rpcUrls: ["https://api.avax.network/ext/bc/C/rpc"],
    //   chainName: "Avalanche Network",
    //   label: "Avalanche",
    //   nativeCurrency: {
    //     name: "AVAX",
    //     symbol: "AVAX",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://snowtrace.io/"],
    //   exampleContractAddress: "0x4d58dbF4a921FdD964Ece0732B1577cC25662587",
    //   contractExplorerUrl:
    //     "https://snowtrace.io/address/0x4d58dbF4a921FdD964Ece0732B1577cC25662587",
    //   logo: AvalancheLogo,
    // },
    // [42220]: {
    //   chainId: utils.hexValue(42220),
    //   rpcUrls: ["https://forno.celo.org"],
    //   chainName: "Celo",
    //   label: "Celo",
    //   nativeCurrency: {
    //     name: "Celo",
    //     symbol: "CELO",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://explorer.celo.org/"],
    //   exampleContractAddress: "0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
    //   contractExplorerUrl:
    //     "https://explorer.celo.org/address/0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
    //   logo: CeloLogo,
    // },
    // [56]: {
    //   chainId: utils.hexValue(56),
    //   rpcUrls: ["https://bsc-dataseed.binance.org/"],
    //   chainName: "Smart Chain",
    //   label: "BNB",
    //   nativeCurrency: {
    //     name: "BNB",
    //     symbol: "BNB",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://bscscan.com/"],
    //   exampleContractAddress: "0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
    //   contractExplorerUrl:
    //     "https://bscscan.com/address/0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
    //   logo: BnbLogo,
    // },
    // [250]: {
    //   chainId: utils.hexValue(250),
    //   rpcUrls: ["https://rpc.ankr.com/fantom/"],
    //   chainName: "Fantom",
    //   label: "Fantom",
    //   nativeCurrency: {
    //     name: "FTM",
    //     symbol: "FTM",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://ftmscan.com/"],
    //   exampleContractAddress: "0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
    //   contractExplorerUrl:
    //     "https://ftmscan.com/address/0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
    //   logo: FantomLogo,
    // },
    // [8217]: {
    //   chainId: utils.hexValue(8217),
    //   rpcUrls: ["https://public-node-api.klaytnapi.com/v1/cypress"],
    //   chainName: "Klaytn Mainnet",
    //   label: "Klaytn",
    //   nativeCurrency: {
    //     name: "KLAY",
    //     symbol: "KLAY",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://scope.klaytn.com/"],
    //   exampleContractAddress: "0x2e441adc345daeb11ff9c2cae7efd461e5525850",
    //   contractExplorerUrl:
    //     "https://scope.klaytn.com/address/0x2e441adc345daeb11ff9c2cae7efd461e5525850",
    //   logo: KlaytnLogo,
    // },
    // [1284]: {
    //   chainId: utils.hexValue(1284),
    //   rpcUrls: ["https://rpc.api.moonbeam.network"],
    //   chainName: "Moonbeam",
    //   label: "Moonbeam",
    //   nativeCurrency: {
    //     name: "GLMR",
    //     symbol: "GLMR",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://moonscan.io/"],
    //   exampleContractAddress: "0xd75F4B5AA9480E6956f2570Dd258ca716784f6E1",
    //   contractExplorerUrl:
    //     "https://moonscan.io/address/0xd75F4B5AA9480E6956f2570Dd258ca716784f6E1",
    //   logo: MoonbeamLogo,
    // },
    // [280]: {
    //   chainId: utils.hexValue(280),
    //   rpcUrls: ["https://zksync2-testnet.zksync.dev"],
    //   chainName: "zkSync Era Testnet",
    //   label: "zkSync Era Testnet",
    //   nativeCurrency: {
    //     name: "ETH",
    //     symbol: "ETH",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://goerli.explorer.zksync.io/"],
    //   exampleContractAddress: "0xfC751219f2d99f9fE01e777625352Fe22D37433A",
    //   contractExplorerUrl:
    //     "https://goerli.explorer.zksync.io/address/0xfC751219f2d99f9fE01e777625352Fe22D37433A",
    //   logo: zkSyncLogo,
    // },
    // [324]: {
    //   chainId: utils.hexValue(324),
    //   rpcUrls: ["https://mainnet.era.zksync.io"],
    //   chainName: "zkSync Era Mainnet",
    //   label: "zkSync Era Mainnet",
    //   nativeCurrency: {
    //     name: "ETH",
    //     symbol: "ETH",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://explorer.zksync.io/"],
    //   exampleContractAddress: "0xB6cA02A43EF32504876799B6c3Af12482f29a836",
    //   contractExplorerUrl:
    //     "https://explorer.zksync.io/address/0xB6cA02A43EF32504876799B6c3Af12482f29a836",
    //   logo: zkSyncLogo,
    // },
    // [1313161554]: {
    //   chainId: utils.hexValue(1313161554),
    //   rpcUrls: ["https://mainnet.aurora.dev"],
    //   chainName: "Aurora",
    //   label: "Aurora",
    //   nativeCurrency: {
    //     name: "ETH",
    //     symbol: "ETH",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://aurorascan.dev/"],
    //   exampleContractAddress: "0x1a6bbc6Ff8BEeE20B4177Ac87580F4e2aF3Abf71",
    //   contractExplorerUrl:
    //     "https://aurorascan.dev/address/0x1a6bbc6Ff8BEeE20B4177Ac87580F4e2aF3Abf71",
    //   logo: AuroraLogo,
    // },
    // [534353]: {
    //   chainId: utils.hexValue(534353),
    //   rpcUrls: ["https://alpha-rpc.scroll.io/l2"],
    //   chainName: "Scroll Alpha Testnet",
    //   label: "Scroll",
    //   nativeCurrency: {
    //     name: "ETH",
    //     symbol: "ETH",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://blockscout.scroll.io/"],
    //   exampleContractAddress: "0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
    //   contractExplorerUrl:
    //     "https://blockscout.scroll.io/address/0x2e441aDC345dAeB11Ff9c2caE7eFD461E5525850",
    //   logo: ScrollLogo,
    // },
    // [2000]: {
    //   chainId: utils.hexValue(2000),
    //   rpcUrls: ["https://rpc.dogechain.dog"],
    //   chainName: "Dogechain",
    //   label: "Dogechain",
    //   nativeCurrency: {
    //     name: "DOGE",
    //     symbol: "DOGE",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://explorer.dogechain.dog/"],
    //   exampleContractAddress: "0xaCf97fb2f2c336c45b799DAB925ad10ADC70fCAC",
    //   contractExplorerUrl:
    //     "https://explorer.dogechain.dog/address/0xaCf97fb2f2c336c45b799DAB925ad10ADC70fCAC",
    //   logo: DogechainLogo,
    // },
    // [5001]: {
    //   chainId: utils.hexValue(5001),
    //   rpcUrls: ["​​https://rpc.testnet.mantle.xyz/"],
    //   chainName: "Mantle Testnet",
    //   label: "Mantle",
    //   nativeCurrency: {
    //     name: "BIT",
    //     symbol: "BIT",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://explorer.testnet.mantle.xyz/"],
    //   exampleContractAddress: "0xaCf97fb2f2c336c45b799DAB925ad10ADC70fCAC",
    //   contractExplorerUrl:
    //     "https://explorer.testnet.mantle.xyz/address/0xaCf97fb2f2c336c45b799DAB925ad10ADC70fCAC",
    //   logo: MantleLogo,
    // },
    // [11111]: {
    //   chainId: utils.hexValue(11111),
    //   rpcUrls: ["https://subnets.avax.network/wagmi/wagmi-chain-testnet/rpc"],
    //   chainName: "WAGMI",
    //   label: "WAGMI Testnet",
    //   nativeCurrency: {
    //     name: "WGM",
    //     symbol: "WGM",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://subnets-test.avax.network/wagmi/"],
    //   exampleContractAddress: "0xd75F4B5AA9480E6956f2570Dd258ca716784f6E1",
    //   contractExplorerUrl:
    //     "https://subnets-test.avax.network/wagmi/address/0xd75F4B5AA9480E6956f2570Dd258ca716784f6E1",
    //   logo: WagmiLogo,
    // },
    // [1442]: {
    //   chainId: utils.hexValue(1442),
    //   rpcUrls: ["https://rpc.public.zkevm-test.net"],
    //   chainName: "Polygon zkEVM Testnet",
    //   label: "Polygon zkEVM Testnet",
    //   nativeCurrency: {
    //     name: "ETH",
    //     symbol: "ETH",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://explorer.public.zkevm-test.net/"],
    //   exampleContractAddress: "0xaCf97fb2f2c336c45b799DAB925ad10ADC70fCAC",
    //   contractExplorerUrl:
    //     "https://explorer.public.zkevm-test.net/address/0xaCf97fb2f2c336c45b799DAB925ad10ADC70fCAC",
    //   logo: PolygonZkEVMLogo,
    // },
    // [1101]: {
    //   chainId: utils.hexValue(1101),
    //   rpcUrls: ["https://zkevm-rpc.com"],
    //   chainName: "Polygon zkEVM",
    //   label: "Polygon zkEVM",
    //   nativeCurrency: {
    //     name: "ETH",
    //     symbol: "ETH",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://zkevm.polygonscan.com/"],
    //   exampleContractAddress: "0x2e441adc345daeb11ff9c2cae7efd461e5525850",
    //   contractExplorerUrl:
    //     "https://zkevm.polygonscan.com/address/0x2e441adc345daeb11ff9c2cae7efd461e5525850",
    //   logo: PolygonZkEVMLogo,
    // },
    // [7700]: {
    //   chainId: utils.hexValue(7700),
    //   rpcUrls: ["https://canto.slingshot.finance"],
    //   chainName: "Canto",
    //   label: "Canto",
    //   nativeCurrency: {
    //     name: "CANTO",
    //     symbol: "CANTO",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://evm.explorer.canto.io/"],
    //   exampleContractAddress: "0xf16dA7ABcac966B3ba9c1DFa17D8A9626237bcf8",
    //   contractExplorerUrl:
    //     "https://evm.explorer.canto.io/address/0xf16dA7ABcac966B3ba9c1DFa17D8A9626237bcf8",
    //   logo: CantoLogo,
    // },
    // [84531]: {
    //   chainId: utils.hexValue(84531),
    //   rpcUrls: ["https://goerli.base.org"],
    //   chainName: "Base Goerli",
    //   label: "Base Goerli",
    //   nativeCurrency: {
    //     name: "ETH",
    //     symbol: "ETH",
    //     decimals: 18,
    //   },
    //   blockExplorerUrls: ["https://goerli.basescan.org/"],
    //   exampleContractAddress: "0xd75F4B5AA9480E6956f2570Dd258ca716784f6E1",
    //   contractExplorerUrl:
    //     "https://goerli.basescan.org/address/0xd75f4b5aa9480e6956f2570dd258ca716784f6e1",
    //   logo: BaseLogo,
    // },
    [9999999997]: {
        chainId: (0, $e5s6c).hexValue(9999999997),
        rpcUrls: [],
        chainName: "Starknet Sepolia Network",
        label: "Sepolia",
        nativeCurrency: {
            name: "SepoliaETH",
            symbol: "SepoliaETH",
            decimals: 18
        },
        blockExplorerUrls: [
            "https://sepolia.starkscan.co/"
        ],
        exampleContractAddress: "0x0037b17a782f5a0134bd21faf200f35c96b436dc3af51f5534aa69fd4261bec9",
        contractExplorerUrl: "https://sepolia.starkscan.co/contract/0x0037b17a782f5a0134bd21faf200f35c96b436dc3af51f5534aa69fd4261bec9",
        txExplorerUrl: "https://sepolia.starkscan.co/tx/",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($f6ca566de446e670$exports))),
        type: "starknet"
    },
    [9999999998]: {
        chainId: (0, $e5s6c).hexValue(9999999998),
        rpcUrls: [],
        chainName: "Starknet Mainnet",
        label: "Mainnet",
        nativeCurrency: {
            name: "ETH",
            symbol: "ETH",
            decimals: 18
        },
        blockExplorerUrls: [
            "https://starkscan.co/"
        ],
        exampleContractAddress: "0x06c2a5ad0542e37c57750c6f35c05df47179453d0724b7d04bd6de4cb36cf227",
        contractExplorerUrl: "https://starkscan.co/contract/0x06c2a5ad0542e37c57750c6f35c05df47179453d0724b7d04bd6de4cb36cf227",
        txExplorerUrl: "https://starkscan.co/tx/",
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($f6ca566de446e670$exports))),
        type: "starknet"
    }
};


const $429f470a166ef670$export$83e74882c5df8fe1 = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $429f470a166ef670$export$19d7d19559261303 = {
    btc: "",
    eth: "",
    bnb: "",
    ar: "",
    avax: "",
    celo: ""
};
const $429f470a166ef670$export$c86caf1be068fb8d = (price)=>{
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
    });
    return formatter.format(price);
};


const $6d74eea438614f0e$export$69804ca079d47f29 = (setNetwork)=>{
    const [prices, setPrices] = (0, $6cds3.useState)((0, $429f470a166ef670$export$19d7d19559261303));
    const [web3Modal, setWeb3Modal] = (0, $6cds3.useState)(null);
    const [signer, setSigner] = (0, $6cds3.useState)(null);
    const [walletAddress, setWalletAddress] = (0, $6cds3.useState)("");
    const [isChangingNetwork, setIsChangingNetwork] = (0, $6cds3.useState)(false);
    const [isConnecting, setIsConnecting] = (0, $6cds3.useState)(false);
    (0, $6cds3.useEffect)(()=>{
        const web3Modal = new (0, (/*@__PURE__*/$parcel$interopDefault($5f6146cb2a3d4ecb$exports)))({
            cacheProvider: true
        });
        setWeb3Modal(web3Modal);
    }, []);
    const changeNetwork = async (network)=>{
        if (network && (network.type || "eth") === "eth") {
            setIsChangingNetwork(true);
            const { exampleContractAddress: exampleContractAddress, contractExplorerUrl: contractExplorerUrl, logo: logo, label: label, ...restNetworkParams } = network;
            try {
                await window.ethereum.request({
                    method: "wallet_switchEthereumChain",
                    params: [
                        {
                            chainId: restNetworkParams.chainId
                        }
                    ]
                });
                setIsChangingNetwork(false);
            } catch (switchError) {
                if (switchError.code === 4902) {
                    await addNewNetwork(restNetworkParams);
                    setIsChangingNetwork(false);
                }
            } finally{
                setPrices((0, $429f470a166ef670$export$19d7d19559261303));
            }
        }
    };
    const addNewNetwork = async (networkParams)=>{
        try {
            await window.ethereum.request({
                method: "wallet_addEthereumChain",
                params: [
                    networkParams
                ]
            });
        } catch (error) {
            setPrices((0, $429f470a166ef670$export$19d7d19559261303));
        }
    };
    const connectWallet = async (network)=>{
        if (web3Modal) try {
            await changeNetwork(network);
            setIsConnecting(true);
            const instance = await web3Modal.connect();
            addListeners(instance);
            const provider = new (0, $ldxXU).Web3Provider(instance);
            const signer = provider.getSigner();
            setSigner(signer);
            const walletAddress = await signer.getAddress();
            setWalletAddress(walletAddress);
        } catch (error) {
            console.error(error);
        } finally{
            setIsConnecting(false);
            setPrices((0, $429f470a166ef670$export$19d7d19559261303));
        }
    };
    const reconnectWallet = async ()=>{
        if (web3Modal) {
            const instance = await web3Modal.connect();
            const provider = new (0, $ldxXU).Web3Provider(instance);
            const signer = provider.getSigner();
            setSigner(signer);
            const walletAddress = await signer.getAddress();
            setWalletAddress(walletAddress);
        }
    };
    const addListeners = (web3ModalProvider)=>{
        web3ModalProvider.on("accountsChanged", ()=>{
            window.location.reload();
        });
        web3ModalProvider.on("chainChanged", async (chainId)=>{
            const chainIdAsNumber = Number(chainId.toString());
            const chainFromConfig = (0, $050990180fbd2df8$export$af1c0561ce3e4019)[chainIdAsNumber];
            if (!chainFromConfig) setNetwork(null);
            else {
                setNetwork(chainFromConfig);
                await reconnectWallet();
            }
        });
    };
    return {
        prices: prices,
        setPrices: setPrices,
        signer: signer,
        connectWallet: connectWallet,
        walletAddress: walletAddress,
        isChangingNetwork: isChangingNetwork,
        isConnecting: isConnecting
    };
};



const $894a8d90f8ca8f9d$export$179a2d4534d0f37d = ({ chain: chain, network: network, onChainClick: onChainClick, disabled: disabled })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("button", {
        className: `flex align-center gap-2 border py-2 px-2 rounded ${chain.chainId === (network === null || network === void 0 ? void 0 : network.chainId) && "border-redstone"} disabled:opacity-30 hover:scale-110	ease-in-out duration-300`,
        onClick: ()=>onChainClick(chain),
        disabled: disabled,
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                style: {
                    height: 24,
                    width: 24
                },
                src: chain.logo,
                alt: `${chain.label} logo`
            }),
            chain.label
        ]
    });





var $24291953e17427e9$exports = {};

$24291953e17427e9$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "wallet.a022815f.png";


var $8f6eae30a1f30502$exports = {};

$8f6eae30a1f30502$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "contract.a02eadc2.png";


const $d0adf8410d59fd78$export$f34f01f5ad9bfa8 = ({ walletAddress: walletAddress, network: network })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("table", {
        className: "w-3/5 table-auto border mb-8",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tbody", {
            className: "text-md",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("td", {
                            className: "flex items-center gap-3 py-3 px-3",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    className: "object-scale-down w-6 h-6",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($24291953e17427e9$exports))),
                                    alt: "Wallet icon"
                                }),
                                "Your wallet"
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                            className: "py-3 px-3 text-right",
                            children: walletAddress
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("td", {
                            className: "flex items-center gap-3 py-3 px-3",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    className: "object-scale-down w-6 h-6",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8f6eae30a1f30502$exports))),
                                    alt: "Contract icon"
                                }),
                                "Integrated Contract"
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                            className: "py-3 px-3 text-right underline",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                href: network.contractExplorerUrl.replace("{walletAddress}", walletAddress),
                                target: "blank",
                                referrerPolicy: "no-referrer",
                                children: network.exampleContractAddress
                            })
                        })
                    ]
                })
            ]
        })
    });




const $c9c9a28c2efa9cdd$export$7f7cbe89f1eacd2 = ({ size: size = 10 })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("svg", {
        role: "status",
        className: `inline w-${size} h-${size} text-gray-200 animate-spin dark:text-gray-300 fill-redstone`,
        viewBox: "0 0 100 101",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                fill: "currentFill"
            })
        ]
    });
const $c9c9a28c2efa9cdd$export$3b0d6d7590275603 = ()=>{
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "flex items-center justify-center",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            className: "w-[45px]",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)($c9c9a28c2efa9cdd$export$7f7cbe89f1eacd2, {})
        })
    });
};


const $400629623ad58cec$export$f39eb86f0e5c1a78 = ({ text: text })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex justify-center items-center flex-col",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $c9c9a28c2efa9cdd$export$3b0d6d7590275603), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: "text-md font-semibold mt-4",
                children: text
            })
        ]
    });




const $29fbb8d85bb99ed5$export$d877cf1ea46d4d85 = ({ blockNumber: blockNumber, timestamp: timestamp, prices: prices })=>{
    const pricesArray = Object.entries(prices).map(([key, price])=>({
            label: key.toUpperCase(),
            value: price
        }));
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("table", {
        className: "w-3/5 table-auto border mb-5",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tbody", {
            className: "text-md",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                            className: "py-3 px-6",
                            children: "Block number"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                            className: "py-3 px-6 font-bold text-right",
                            children: blockNumber
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                            className: "py-3 px-6",
                            children: "Timestamp"
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                            className: "py-3 px-6 font-bold text-right",
                            children: new Date(timestamp).toLocaleString()
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("tr", {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                        colSpan: 2,
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("hr", {})
                    })
                }),
                pricesArray.map((price)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                className: "py-3 px-6",
                                children: price.label
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                                className: "py-3 px-6 font-bold text-right",
                                children: (0, $429f470a166ef670$export$c86caf1be068fb8d)(price.value)
                            })
                        ]
                    }, price.label))
            ]
        })
    });
};



const $1f09082810955268$export$a6bbb1b7f40755b9 = ({ writePricesToContract: writePricesToContract })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
        className: "bg-gray-400 hover:opacity-75 text-white py-3 px-8 rounded-full text-xl",
        onClick: writePricesToContract,
        children: "Write prices"
    });



const $291736910945f543$export$30ee6dea872700fe = ({ readPricesFromContract: readPricesFromContract })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
        className: "bg-redstone bg-opacity-60 hover:opacity-75 text-white py-3 px-8 rounded-full text-xl",
        onClick: readPricesFromContract,
        children: "Read prices"
    });



const $f1a9f66f6ca0bed1$export$d38cca4e3d3fe8c0 = ({ getPriceFromContract: getPriceFromContract })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
        className: "bg-redstone hover:opacity-75 text-white py-3 px-8 rounded-full text-xl",
        onClick: getPriceFromContract,
        children: "Get prices"
    });



var $cdd38f01d1460639$exports = {};

$cdd38f01d1460639$exports = (parcelRequire("17QCl")).getBundleURL("1DUm8") + "tx.bf8999f2.png";


const $72f10b3fcf20060f$export$d22914518d6cfe65 = ({ txHash: txHash, network: network })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("table", {
        className: "w-3/5 table-auto border mt-8",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tbody", {
            className: "text-md",
            children: [
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("td", {
                            className: "flex items-center gap-3 py-3 px-3",
                            children: [
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("img", {
                                    className: "object-scale-down w-6 h-6",
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cdd38f01d1460639$exports))),
                                    alt: "Contract icon"
                                }),
                                "Last transaction:"
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                            className: "py-3 px-3 text-right underline",
                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                href: network.txExplorerUrl + txHash,
                                target: "blank",
                                referrerPolicy: "no-referrer",
                                children: txHash
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("tr", {
                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("td", {
                        colSpan: 2,
                        className: "text-sm px-3 text-gray-500",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("i", {
                            children: "This transaction writes a snapshot of current prices to the contract's storage."
                        })
                    })
                })
            ]
        })
    });



var $6cds3 = parcelRequire("6cds3");

const $ae7f937efe139789$var$loaderTexts = [
    "Fetching price data",
    "Sending transaction with fetched price data",
    "Receiving data from smart contract"
];
const $ae7f937efe139789$export$3ca8f5b83ba7703a = ()=>{
    const [isMockLoading, setIsMockLoading] = (0, $6cds3.useState)(false);
    const [text, setText] = (0, $6cds3.useState)($ae7f937efe139789$var$loaderTexts[0]);
    const handleTextChange = async ()=>{
        for (const text of $ae7f937efe139789$var$loaderTexts){
            setText(text);
            await (0, $429f470a166ef670$export$83e74882c5df8fe1)(500);
        }
    };
    const startMockLoader = ()=>{
        setIsMockLoading(true);
        handleTextChange();
    };
    return {
        text: text,
        isMockLoading: isMockLoading,
        setIsMockLoading: setIsMockLoading,
        startMockLoader: startMockLoader
    };
};



var $6cds3 = parcelRequire("6cds3");

const $cac0522f2cadd058$export$b87f2cac0597d124 = ()=>{
    const getPricesTimestamp = async ()=>{
        return Date.now();
    };
    return {
        getPricesTimestamp: getPricesTimestamp
    };
};



var $e5s6c = parcelRequire("e5s6c");

var $5zREg = parcelRequire("5zREg");
const $753cc36948ba3c23$var$dataPackageRequestParams = {
    dataServiceId: "redstone-rapid-demo",
    uniqueSignersCount: 1,
    dataFeeds: [
        "BTC",
        "ETH",
        "BNB",
        "AR",
        "AVAX",
        "CELO"
    ]
};
const $753cc36948ba3c23$export$37ebad50d75f51b = (network, connector, startMockLoader, setPrices, setIsMockLoading, paramsProviderClass = (0, $5zREg.ContractParamsProvider))=>{
    const [blockNumber, setBlockNumber] = (0, $6cds3.useState)(0);
    const [txHash, setTxHash] = (0, $6cds3.useState)("");
    const [timestamp, setTimestamp] = (0, $6cds3.useState)(0);
    const [isLoading, setIsLoading] = (0, $6cds3.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $6cds3.useState)("");
    const { getPricesTimestamp: getPricesTimestamp } = (0, $cac0522f2cadd058$export$b87f2cac0597d124)();
    const paramsProvider = new paramsProviderClass($753cc36948ba3c23$var$dataPackageRequestParams);
    const readPricesFromContract = async ()=>{
        await getPrices(true);
    };
    const getPricesFromPayload = async ()=>{
        await getPrices(false);
    };
    const getPrices = async (fromContract)=>{
        await performContractAction(async (adapter)=>{
            const date = new Date().getTime();
            console.log(`START ${new Date().getTime() - date}`);
            const [prices, blockNumber, timestamp] = await Promise.all([
                fromContract ? adapter.readPricesFromContract(paramsProvider) : adapter.getPricesFromPayload(paramsProvider),
                connector.getBlockNumber(network.rpcUrls[0]),
                fromContract ? adapter.readTimestampFromContract() : getPricesTimestamp()
            ]);
            handlePrices(setPrices, prices);
            setBlockNumber(blockNumber);
            setTimestamp(timestamp < 1000000000000 ? timestamp * 1000 : timestamp);
            console.log(`END ${new Date().getTime() - date}`);
        });
    };
    const writePricesToContract = async ()=>{
        setPrices((0, $429f470a166ef670$export$19d7d19559261303));
        await performContractAction(async (adapter)=>{
            const txHashOrPrices = await adapter.writePricesFromPayloadToContract(paramsProvider);
            if (typeof txHashOrPrices === "string") setTxHash(txHashOrPrices);
            else {
                handlePrices(setPrices, txHashOrPrices);
                const [timestamp, blockNumber] = await Promise.all([
                    adapter.readTimestampFromContract(),
                    connector.getBlockNumber(network.rpcUrls[0])
                ]);
                setBlockNumber(blockNumber);
                setTimestamp(timestamp);
            }
        });
    };
    const performContractAction = async (callback)=>{
        if (network) try {
            startMockLoader();
            setIsLoading(true);
            const adapter = await connector.getAdapter();
            if (adapter) {
                await callback(adapter);
                setIsMockLoading(false);
                setIsLoading(false);
            }
        } catch (error) {
            console.error(error);
            handleError();
            setIsMockLoading(false);
            setIsLoading(false);
        }
        else handleError();
    };
    const handleError = ()=>{
        setIsLoading(false);
        setPrices((0, $429f470a166ef670$export$19d7d19559261303));
        setIsMockLoading(false);
        setErrorMessage("There was problem with fetching data from smart adapter. Please try again or contact RedStone team");
    };
    const handlePrices = (setPrices, prices)=>{
        setPrices({
            btc: (0, $e5s6c).formatUnits(prices[0], 8),
            eth: (0, $e5s6c).formatUnits(prices[1], 8),
            bnb: (0, $e5s6c).formatUnits(prices[2], 8),
            ar: (0, $e5s6c).formatUnits(prices[3], 8),
            avax: (0, $e5s6c).formatUnits(prices[4], 8),
            celo: (0, $e5s6c).formatUnits(prices[5], 8)
        });
    };
    return {
        blockNumber: blockNumber,
        txHash: txHash,
        timestamp: timestamp,
        isLoading: isLoading,
        errorMessage: errorMessage,
        setErrorMessage: setErrorMessage,
        getPricesFromPayload: getPricesFromPayload,
        readPricesFromContract: readPricesFromContract,
        writePricesToContract: writePricesToContract
    };
};



const $b76a4ff75d0d9de2$var$Modal = ({ closeModal: closeModal, title: title, text: text })=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
        className: "fixed top-0 left-0 z-50 w-screen h-screen bg-gray-400 bg-opacity-60",
        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
            className: "relative mx-auto w-full max-w-xl mt-24",
            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                className: "relative bg-white rounded-xl shadow bg-white p-4",
                children: [
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                        className: "flex justify-between items-start mb-5 rounded-t",
                        children: [
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("h3", {
                                className: "text-xl font-semibold",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                                type: "button",
                                className: "text-gray-400 bg-transparent rounded-xl text-sm p-1.5 ml-auto inline-flex items-center",
                                onClick: ()=>closeModal(),
                                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("svg", {
                                    className: "w-5 h-5",
                                    fill: "currentColor",
                                    viewBox: "0 0 20 20",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("path", {
                                        fillRule: "evenodd",
                                        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                                        clipRule: "evenodd"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "mb-6",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                            className: "leading-relaxed",
                            children: text
                        })
                    }),
                    /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                        className: "flex items-center rounded-b",
                        children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("button", {
                            type: "button",
                            className: "bg-redstone hover:opacity-75 text-white py-2 px-4 rounded-full",
                            onClick: ()=>closeModal(),
                            children: "Close"
                        })
                    })
                ]
            })
        })
    });
var $b76a4ff75d0d9de2$export$2e2bcd8739ae039 = $b76a4ff75d0d9de2$var$Modal;


var $1e464729fed94ea8$exports = {};
"use strict";
var $1e464729fed94ea8$var$__createBinding = $1e464729fed94ea8$exports && $1e464729fed94ea8$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1e464729fed94ea8$var$__exportStar = $1e464729fed94ea8$exports && $1e464729fed94ea8$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1e464729fed94ea8$var$__createBinding(exports1, m, p);
};
Object.defineProperty($1e464729fed94ea8$exports, "__esModule", {
    value: true
});

$1e464729fed94ea8$var$__exportStar((parcelRequire("kHc9u")), $1e464729fed94ea8$exports);

$1e464729fed94ea8$var$__exportStar((parcelRequire("lnWdi")), $1e464729fed94ea8$exports);

$1e464729fed94ea8$var$__exportStar((parcelRequire("lTZjH")), $1e464729fed94ea8$exports);

$1e464729fed94ea8$var$__exportStar((parcelRequire("hzheU")), $1e464729fed94ea8$exports);

$1e464729fed94ea8$var$__exportStar((parcelRequire("a787O")), $1e464729fed94ea8$exports);

$1e464729fed94ea8$var$__exportStar((parcelRequire("1uXqT")), $1e464729fed94ea8$exports);

$1e464729fed94ea8$var$__exportStar((parcelRequire("iyjmS")), $1e464729fed94ea8$exports);


const $aca49255d66f39fc$export$6d4e842c29c48185 = ({ props: props, network: network })=>{
    const { prices: prices, setPrices: setPrices, walletAddress: walletAddress, starknet: starknet } = props;
    const { text: text, isMockLoading: isMockLoading, setIsMockLoading: setIsMockLoading, startMockLoader: startMockLoader } = (0, $ae7f937efe139789$export$3ca8f5b83ba7703a)();
    const connector = new (0, $1e464729fed94ea8$exports.PriceAdapterStarknetContractConnector)(starknet === null || starknet === void 0 ? void 0 : starknet.account, network === null || network === void 0 ? void 0 : network.exampleContractAddress);
    const { blockNumber: blockNumber, txHash: txHash, timestamp: timestamp, isLoading: isLoading, getPricesFromPayload: getPricesFromPayload, readPricesFromContract: readPricesFromContract, writePricesToContract: writePricesToContract, errorMessage: errorMessage, setErrorMessage: setErrorMessage } = (0, $753cc36948ba3c23$export$37ebad50d75f51b)(network, connector, startMockLoader, setPrices, setIsMockLoading);
    const arePrices = Object.values(prices).every((price)=>!!price);
    return !starknet ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
        className: "mt-10 mb-0 text-lg font-bold",
        children: "Please sign in to Starknet"
    }) : /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex w-full justify-center items-center mt-8 flex-col",
        children: [
            network && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d0adf8410d59fd78$export$f34f01f5ad9bfa8), {
                walletAddress: walletAddress,
                network: network
            }),
            isMockLoading || isLoading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $400629623ad58cec$export$f39eb86f0e5c1a78), {
                text: isMockLoading ? text : ""
            }) : [
                arePrices && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $29fbb8d85bb99ed5$export$d877cf1ea46d4d85), {
                    blockNumber: blockNumber,
                    timestamp: timestamp,
                    prices: prices
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "flex gap-3",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1f09082810955268$export$a6bbb1b7f40755b9), {
                            writePricesToContract: writePricesToContract
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $291736910945f543$export$30ee6dea872700fe), {
                            readPricesFromContract: readPricesFromContract
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1a9f66f6ca0bed1$export$d38cca4e3d3fe8c0), {
                            getPriceFromContract: getPricesFromPayload
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
                    className: "px-6 py-3 text-sm w-3/5 text-center text-gray-500",
                    children: [
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("i", {
                            children: [
                                "To ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                    children: "write"
                                }),
                                " a snapshot of current ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                    children: "prices"
                                }),
                                " to the contract's storage you should have",
                                " ",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                                    children: network === null || network === void 0 ? void 0 : network.nativeCurrency.symbol
                                }),
                                " be added to the wallet.",
                                /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                                (network === null || network === void 0 ? void 0 : network.label) === "Sepolia" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("span", {
                                    children: [
                                        "For sepolia is described here:\xa0",
                                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("a", {
                                            target: "blank",
                                            href: "https://book.starknet.io/ch02-05-01-start-with-sepolia.html",
                                            referrerPolicy: "no-referrer",
                                            children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("u", {
                                                children: "https://book.starknet.io/ch02-05-01-start-with-sepolia.html"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("br", {}),
                        "Pay attention to the ",
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                            children: "network"
                        }),
                        " you have ",
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                            children: "selected"
                        }),
                        " in your",
                        " ",
                        /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("b", {
                            children: "ArgentX "
                        }),
                        "extension!"
                    ]
                }),
                network && txHash && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $72f10b3fcf20060f$export$d22914518d6cfe65), {
                    txHash: txHash,
                    network: network
                })
            ],
            !!errorMessage && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b76a4ff75d0d9de2$export$2e2bcd8739ae039), {
                closeModal: ()=>setErrorMessage(""),
                title: "Problem with contract interaction",
                text: errorMessage
            })
        ]
    });
};



var $6cds3 = parcelRequire("6cds3");

var $37abfb837d2dd31d$export$37dfea93db2e14ed;
var $37abfb837d2dd31d$export$64605811ab45167f;
var $37abfb837d2dd31d$export$b5c0cdb6e6d5b23c;
"use strict";

var $3GDHM = parcelRequire("3GDHM");
var $37abfb837d2dd31d$var$It = {}, $37abfb837d2dd31d$var$ue;
$37abfb837d2dd31d$export$37dfea93db2e14ed = void 0;
var $37abfb837d2dd31d$var$fe;
Object.defineProperty($37abfb837d2dd31d$var$It, "__esModule", {
    value: !0
});
var $37abfb837d2dd31d$var$Ht = $3GDHM;
function $37abfb837d2dd31d$var$Nt(e, t, i, s) {
    return new (i || (i = Promise))(function(r, a) {
        function l(c) {
            try {
                o(s.next(c));
            } catch (g) {
                a(g);
            }
        }
        function n(c) {
            try {
                o(s.throw(c));
            } catch (g) {
                a(g);
            }
        }
        function o(c) {
            var g;
            c.done ? r(c.value) : (g = c.value, g instanceof i ? g : new i(function(u) {
                u(g);
            })).then(l, n);
        }
        o((s = s.apply(e, t || [])).next());
    });
}
function $37abfb837d2dd31d$var$I(e, t, i, s) {
    if (i === "a" && !s) throw new TypeError("Private accessor was defined without a getter");
    if (typeof t == "function" ? e !== t || !s : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return i === "m" ? s : i === "a" ? s.call(e) : s ? s.value : t.get(e);
}
function $37abfb837d2dd31d$var$At(e, t, i, s, r) {
    if (s === "m") throw new TypeError("Private method is not writable");
    if (s === "a" && !r) throw new TypeError("Private accessor was defined without a setter");
    if (typeof t == "function" ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return s === "a" ? r.call(e, i) : r ? r.value = i : t.set(e, i), i;
}
var $37abfb837d2dd31d$var$pe = Array.from([
    {
        id: "braavos",
        name: "Braavos",
        icon: "data:image/svg+xml;base64,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",
        downloads: {
            chrome: "https://chrome.google.com/webstore/detail/braavos-wallet/jnlgamecbpmbajjfhmmmlhejkemejdma",
            firefox: "https://addons.mozilla.org/en-US/firefox/addon/braavos-wallet",
            edge: "https://microsoftedge.microsoft.com/addons/detail/braavos-wallet/hkkpjehhcnhgefhbdcgfkeegglpjchdc"
        }
    },
    {
        id: "argentX",
        name: "Argent X",
        icon: "data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjQwIiBoZWlnaHQ9IjM2IiB2aWV3Qm94PSIwIDAgNDAgMzYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yNC43NTgyIC0zLjk3MzY0ZS0wN0gxNC42MjM4QzE0LjI4NTEgLTMuOTczNjRlLTA3IDE0LjAxMzggMC4yODExNzggMTQuMDA2NCAwLjYzMDY4M0MxMy44MDE3IDEwLjQ1NDkgOC44MjIzNCAxOS43NzkyIDAuMjUxODkzIDI2LjM4MzdDLTAuMDIwMjA0NiAyNi41OTMzIC0wLjA4MjE5NDYgMjYuOTg3MiAwLjExNjczNCAyNy4yNzA5TDYuMDQ2MjMgMzUuNzM0QzYuMjQ3OTYgMzYuMDIyIDYuNjQwOTkgMzYuMDg3IDYuOTE3NjYgMzUuODc1NEMxMi4yNzY1IDMxLjc3MjggMTYuNTg2OSAyNi44MjM2IDE5LjY5MSAyMS4zMzhDMjIuNzk1MSAyNi44MjM2IDI3LjEwNTcgMzEuNzcyOCAzMi40NjQ2IDM1Ljg3NTRDMzIuNzQxIDM2LjA4NyAzMy4xMzQxIDM2LjAyMiAzMy4zMzYxIDM1LjczNEwzOS4yNjU2IDI3LjI3MDlDMzkuNDY0MiAyNi45ODcyIDM5LjQwMjIgMjYuNTkzMyAzOS4xMzA0IDI2LjM4MzdDMzAuNTU5NyAxOS43NzkyIDI1LjU4MDQgMTAuNDU0OSAyNS4zNzU5IDAuNjMwNjgzQzI1LjM2ODUgMC4yODExNzggMjUuMDk2OSAtMy45NzM2NGUtMDcgMjQuNzU4MiAtMy45NzM2NGUtMDdaIiBmaWxsPSIjRkY4NzVCIi8+Cjwvc3ZnPgo=",
        downloads: {
            chrome: "https://chrome.google.com/webstore/detail/argent-x-starknet-wallet/dlcobpjiigpikoobohmabehhmhfoodbb",
            firefox: "https://addons.mozilla.org/en-US/firefox/addon/argent-x"
        }
    }
]);
const $37abfb837d2dd31d$var$Jt = (e)=>{
    for(let t = e.length - 1; t > 0; t--){
        const i = Math.floor(Math.random() * (t + 1));
        [e[t], e[i]] = [
            e[i],
            e[t]
        ];
    }
    return e;
}, $37abfb837d2dd31d$var$ge = (e, t)=>{
    if (t && Array.isArray(t)) {
        e.sort((s, r)=>t.indexOf(s.id) - t.indexOf(r.id));
        const i = e.length - t.length;
        return [
            ...e.slice(i),
            ...$37abfb837d2dd31d$var$Jt(e.slice(0, i))
        ];
    }
    return t && t !== "random" ? e : $37abfb837d2dd31d$var$Jt(e);
};
function $37abfb837d2dd31d$var$he(e, t) {
    var i, s;
    if (!((i = t === null || t === void 0 ? void 0 : t.include) === null || i === void 0) && i.length) {
        const r = new Set(t.include);
        return e.filter((a)=>r.has(a.id));
    }
    if (!((s = t === null || t === void 0 ? void 0 : t.exclude) === null || s === void 0) && s.length) {
        const r = new Set(t.exclude);
        return e.filter((a)=>!r.has(a.id));
    }
    return e;
}
var $37abfb837d2dd31d$var$ht, $37abfb837d2dd31d$var$at, $37abfb837d2dd31d$var$nt, $37abfb837d2dd31d$var$jt, $37abfb837d2dd31d$var$me, $37abfb837d2dd31d$var$Lt;
class $37abfb837d2dd31d$var$Me {
    set(t) {
        return !(!$37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$at, "f") && !$37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$ht, "m", $37abfb837d2dd31d$var$Lt).call(this)) && (this.delete(), this.value = t, t && ($37abfb837d2dd31d$var$At(this, $37abfb837d2dd31d$var$nt, `${$37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$jt, "f")}-${Date.now()}-${Math.floor(8999999999999 * Math.random()) + 1e12}`, "f"), localStorage.setItem($37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$nt, "f"), t)), !0);
    }
    get() {
        return $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$ht, "m", $37abfb837d2dd31d$var$me).call(this), this.value;
    }
    delete() {
        return !(!$37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$at, "f") && !$37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$ht, "m", $37abfb837d2dd31d$var$Lt).call(this)) && (this.value = null, $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$nt, "f") && localStorage.removeItem($37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$nt, "f")), !0);
    }
    constructor(t){
        $37abfb837d2dd31d$var$ht.add(this), $37abfb837d2dd31d$var$at.set(this, !1), $37abfb837d2dd31d$var$nt.set(this, void 0), $37abfb837d2dd31d$var$jt.set(this, void 0), this.value = void 0, $37abfb837d2dd31d$var$At(this, $37abfb837d2dd31d$var$jt, t, "f"), $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$ht, "m", $37abfb837d2dd31d$var$Lt).call(this);
    }
}
$37abfb837d2dd31d$var$at = new WeakMap, $37abfb837d2dd31d$var$nt = new WeakMap, $37abfb837d2dd31d$var$jt = new WeakMap, $37abfb837d2dd31d$var$ht = new WeakSet, $37abfb837d2dd31d$var$me = function() {
    this.value && this.set(this.value);
}, $37abfb837d2dd31d$var$Lt = function() {
    try {
        $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$at, "f") || typeof window > "u" || ($37abfb837d2dd31d$var$At(this, $37abfb837d2dd31d$var$nt, Object.keys(localStorage).find((e)=>e.startsWith($37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$jt, "f"))), "f"), $37abfb837d2dd31d$var$At(this, $37abfb837d2dd31d$var$at, !0, "f"), $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$nt, "f") && this.set(localStorage.getItem($37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$nt, "f"))));
    } catch  {}
    return $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$at, "f");
};
const $37abfb837d2dd31d$var$Xt = new $37abfb837d2dd31d$var$Me("gsw-default"), $37abfb837d2dd31d$var$_t = new $37abfb837d2dd31d$var$Me("gsw-last");
function $37abfb837d2dd31d$var$E() {}
const $37abfb837d2dd31d$var$Tt = (e)=>e;
function $37abfb837d2dd31d$var$Dt(e, t) {
    for(const i in t)e[i] = t[i];
    return e;
}
function $37abfb837d2dd31d$var$ve(e) {
    return e();
}
function $37abfb837d2dd31d$var$be() {
    return Object.create(null);
}
function $37abfb837d2dd31d$var$U(e) {
    e.forEach($37abfb837d2dd31d$var$ve);
}
function $37abfb837d2dd31d$var$F(e) {
    return typeof e == "function";
}
function $37abfb837d2dd31d$var$H(e, t) {
    return e != e ? t == t : e !== t || e && typeof e == "object" || typeof e == "function";
}
let $37abfb837d2dd31d$var$Pt;
function $37abfb837d2dd31d$var$lt(e, t) {
    return $37abfb837d2dd31d$var$Pt || ($37abfb837d2dd31d$var$Pt = document.createElement("a")), $37abfb837d2dd31d$var$Pt.href = t, e === $37abfb837d2dd31d$var$Pt.href;
}
function $37abfb837d2dd31d$var$B(e, t, i, s) {
    if (e) {
        const r = $37abfb837d2dd31d$var$ye(e, t, i, s);
        return e[0](r);
    }
}
function $37abfb837d2dd31d$var$ye(e, t, i, s) {
    return e[1] && s ? $37abfb837d2dd31d$var$Dt(i.ctx.slice(), e[1](s(t))) : i.ctx;
}
function $37abfb837d2dd31d$var$R(e, t, i, s) {
    if (e[2] && s) {
        const r = e[2](s(i));
        if (t.dirty === void 0) return r;
        if (typeof r == "object") {
            const a = [], l = Math.max(t.dirty.length, r.length);
            for(let n = 0; n < l; n += 1)a[n] = t.dirty[n] | r[n];
            return a;
        }
        return t.dirty | r;
    }
    return t.dirty;
}
function $37abfb837d2dd31d$var$W(e, t, i, s, r, a) {
    if (r) {
        const l = $37abfb837d2dd31d$var$ye(t, i, s, a);
        e.p(l, r);
    }
}
function $37abfb837d2dd31d$var$Q(e) {
    if (e.ctx.length > 32) {
        const t = [], i = e.ctx.length / 32;
        for(let s = 0; s < i; s++)t[s] = -1;
        return t;
    }
    return -1;
}
function $37abfb837d2dd31d$var$we(e, t) {
    const i = {};
    t = new Set(t);
    for(const s in e)t.has(s) || s[0] === "$" || (i[s] = e[s]);
    return i;
}
function $37abfb837d2dd31d$var$it(e) {
    return e && $37abfb837d2dd31d$var$F(e.destroy) ? e.destroy : $37abfb837d2dd31d$var$E;
}
const $37abfb837d2dd31d$var$xe = typeof window < "u";
let $37abfb837d2dd31d$var$qt = $37abfb837d2dd31d$var$xe ? ()=>window.performance.now() : ()=>Date.now(), $37abfb837d2dd31d$var$Kt = $37abfb837d2dd31d$var$xe ? (e)=>requestAnimationFrame(e) : $37abfb837d2dd31d$var$E;
const $37abfb837d2dd31d$var$mt = new Set;
function $37abfb837d2dd31d$var$Ie(e) {
    $37abfb837d2dd31d$var$mt.forEach((t)=>{
        t.c(e) || ($37abfb837d2dd31d$var$mt.delete(t), t.f());
    }), $37abfb837d2dd31d$var$mt.size !== 0 && $37abfb837d2dd31d$var$Kt($37abfb837d2dd31d$var$Ie);
}
function $37abfb837d2dd31d$var$te(e) {
    let t;
    return $37abfb837d2dd31d$var$mt.size === 0 && $37abfb837d2dd31d$var$Kt($37abfb837d2dd31d$var$Ie), {
        promise: new Promise((i)=>{
            $37abfb837d2dd31d$var$mt.add(t = {
                c: e,
                f: i
            });
        }),
        abort () {
            $37abfb837d2dd31d$var$mt.delete(t);
        }
    };
}
function $37abfb837d2dd31d$var$L(e, t) {
    e.appendChild(t);
}
function $37abfb837d2dd31d$var$K(e, t, i) {
    const s = $37abfb837d2dd31d$var$ee(e);
    if (!s.getElementById(t)) {
        const r = $37abfb837d2dd31d$var$S("style");
        r.id = t, r.textContent = i, $37abfb837d2dd31d$var$Ne(s, r);
    }
}
function $37abfb837d2dd31d$var$ee(e) {
    if (!e) return document;
    const t = e.getRootNode ? e.getRootNode() : e.ownerDocument;
    return t && t.host ? t : e.ownerDocument;
}
function $37abfb837d2dd31d$var$qe(e) {
    const t = $37abfb837d2dd31d$var$S("style");
    return $37abfb837d2dd31d$var$Ne($37abfb837d2dd31d$var$ee(e), t), t.sheet;
}
function $37abfb837d2dd31d$var$Ne(e, t) {
    $37abfb837d2dd31d$var$L(e.head || e, t);
}
function $37abfb837d2dd31d$var$$(e, t, i) {
    e.insertBefore(t, i || null);
}
function $37abfb837d2dd31d$var$z(e) {
    e.parentNode.removeChild(e);
}
function $37abfb837d2dd31d$var$S(e) {
    return document.createElement(e);
}
function $37abfb837d2dd31d$var$st(e) {
    return document.createTextNode(e);
}
function $37abfb837d2dd31d$var$_() {
    return $37abfb837d2dd31d$var$st(" ");
}
function $37abfb837d2dd31d$var$ne() {
    return $37abfb837d2dd31d$var$st("");
}
function $37abfb837d2dd31d$var$Y(e, t, i, s) {
    return e.addEventListener(t, i, s), ()=>e.removeEventListener(t, i, s);
}
function $37abfb837d2dd31d$var$b(e, t, i) {
    i == null ? e.removeAttribute(t) : e.getAttribute(t) !== i && e.setAttribute(t, i);
}
function $37abfb837d2dd31d$var$Ae(e, t) {
    const i = Object.getOwnPropertyDescriptors(e.__proto__);
    for(const s in t)t[s] == null ? e.removeAttribute(s) : s === "style" ? e.style.cssText = t[s] : s === "__value" ? e.value = e[s] = t[s] : i[s] && i[s].set ? e[s] = t[s] : $37abfb837d2dd31d$var$b(e, s, t[s]);
}
function $37abfb837d2dd31d$var$je(e, t) {
    t = "" + t, e.wholeText !== t && (e.data = t);
}
function $37abfb837d2dd31d$var$T(e, t, i, s) {
    i === null ? e.style.removeProperty(t) : e.style.setProperty(t, i, s ? "important" : "");
}
function $37abfb837d2dd31d$var$y(e, t, i) {
    e.classList[i ? "add" : "remove"](t);
}
const $37abfb837d2dd31d$var$Et = new Map;
let $37abfb837d2dd31d$var$zt, $37abfb837d2dd31d$var$Ft = 0;
function $37abfb837d2dd31d$var$Bt(e, t, i, s, r, a, l, n = 0) {
    const o = 16.666 / s;
    let c = `{
`;
    for(let h = 0; h <= 1; h += o){
        const x = t + (i - t) * a(h);
        c += 100 * h + `%{${l(x, 1 - x)}}
`;
    }
    const g = c + `100% {${l(i, 1 - i)}}
}`, u = `__svelte_${function(h) {
        let x = 5381, N = h.length;
        for(; N--;)x = (x << 5) - x ^ h.charCodeAt(N);
        return x >>> 0;
    }(g)}_${n}`, d = $37abfb837d2dd31d$var$ee(e), { stylesheet: f, rules: p } = $37abfb837d2dd31d$var$Et.get(d) || function(h, x) {
        const N = {
            stylesheet: $37abfb837d2dd31d$var$qe(x),
            rules: {}
        };
        return $37abfb837d2dd31d$var$Et.set(h, N), N;
    }(d, e);
    p[u] || (p[u] = !0, f.insertRule(`@keyframes ${u} ${g}`, f.cssRules.length));
    const m = e.style.animation || "";
    return e.style.animation = `${m ? `${m}, ` : ""}${u} ${s}ms linear ${r}ms 1 both`, $37abfb837d2dd31d$var$Ft += 1, u;
}
function $37abfb837d2dd31d$var$Rt(e, t) {
    const i = (e.style.animation || "").split(", "), s = i.filter(t ? (a)=>a.indexOf(t) < 0 : (a)=>a.indexOf("__svelte") === -1), r = i.length - s.length;
    r && (e.style.animation = s.join(", "), $37abfb837d2dd31d$var$Ft -= r, $37abfb837d2dd31d$var$Ft || $37abfb837d2dd31d$var$Kt(()=>{
        $37abfb837d2dd31d$var$Ft || ($37abfb837d2dd31d$var$Et.forEach((a)=>{
            const { stylesheet: l } = a;
            let n = l.cssRules.length;
            for(; n--;)l.deleteRule(n);
            a.rules = {};
        }), $37abfb837d2dd31d$var$Et.clear());
    }));
}
function $37abfb837d2dd31d$var$$t(e) {
    $37abfb837d2dd31d$var$zt = e;
}
function $37abfb837d2dd31d$var$De() {
    if (!$37abfb837d2dd31d$var$zt) throw new Error("Function called outside component initialization");
    return $37abfb837d2dd31d$var$zt;
}
function $37abfb837d2dd31d$var$kt(e) {
    return $37abfb837d2dd31d$var$De().$$.context.get(e);
}
function $37abfb837d2dd31d$var$rt(e, t) {
    const i = e.$$.callbacks[t.type];
    i && i.slice().forEach((s)=>s.call(this, t));
}
const $37abfb837d2dd31d$var$St = [], $37abfb837d2dd31d$var$Wt = [], $37abfb837d2dd31d$var$Qt = [], $37abfb837d2dd31d$var$ie = [], $37abfb837d2dd31d$var$Ke = Promise.resolve();
let $37abfb837d2dd31d$var$se = !1;
function $37abfb837d2dd31d$var$ot(e) {
    $37abfb837d2dd31d$var$Qt.push(e);
}
const $37abfb837d2dd31d$var$re = new Set;
let $37abfb837d2dd31d$var$Ot, $37abfb837d2dd31d$var$Ut = 0;
function $37abfb837d2dd31d$var$ze() {
    const e = $37abfb837d2dd31d$var$zt;
    do {
        for(; $37abfb837d2dd31d$var$Ut < $37abfb837d2dd31d$var$St.length;){
            const t = $37abfb837d2dd31d$var$St[$37abfb837d2dd31d$var$Ut];
            $37abfb837d2dd31d$var$Ut++, $37abfb837d2dd31d$var$$t(t), $37abfb837d2dd31d$var$tn(t.$$);
        }
        for($37abfb837d2dd31d$var$$t(null), $37abfb837d2dd31d$var$St.length = 0, $37abfb837d2dd31d$var$Ut = 0; $37abfb837d2dd31d$var$Wt.length;)$37abfb837d2dd31d$var$Wt.pop()();
        for(let t = 0; t < $37abfb837d2dd31d$var$Qt.length; t += 1){
            const i = $37abfb837d2dd31d$var$Qt[t];
            $37abfb837d2dd31d$var$re.has(i) || ($37abfb837d2dd31d$var$re.add(i), i());
        }
        $37abfb837d2dd31d$var$Qt.length = 0;
    }while ($37abfb837d2dd31d$var$St.length);
    for(; $37abfb837d2dd31d$var$ie.length;)$37abfb837d2dd31d$var$ie.pop()();
    $37abfb837d2dd31d$var$se = !1, $37abfb837d2dd31d$var$re.clear(), $37abfb837d2dd31d$var$$t(e);
}
function $37abfb837d2dd31d$var$tn(e) {
    if (e.fragment !== null) {
        e.update(), $37abfb837d2dd31d$var$U(e.before_update);
        const t = e.dirty;
        e.dirty = [
            -1
        ], e.fragment && e.fragment.p(e.ctx, t), e.after_update.forEach($37abfb837d2dd31d$var$ot);
    }
}
function $37abfb837d2dd31d$var$oe() {
    return $37abfb837d2dd31d$var$Ot || ($37abfb837d2dd31d$var$Ot = Promise.resolve(), $37abfb837d2dd31d$var$Ot.then(()=>{
        $37abfb837d2dd31d$var$Ot = null;
    })), $37abfb837d2dd31d$var$Ot;
}
function $37abfb837d2dd31d$var$ct(e, t, i) {
    e.dispatchEvent(function(s, r, { bubbles: a = !1, cancelable: l = !1 } = {}) {
        const n = document.createEvent("CustomEvent");
        return n.initCustomEvent(s, a, l, r), n;
    }(`${t ? "intro" : "outro"}${i}`));
}
const $37abfb837d2dd31d$var$Yt = new Set;
let $37abfb837d2dd31d$var$tt;
function $37abfb837d2dd31d$var$Mt() {
    $37abfb837d2dd31d$var$tt = {
        r: 0,
        c: [],
        p: $37abfb837d2dd31d$var$tt
    };
}
function $37abfb837d2dd31d$var$vt() {
    $37abfb837d2dd31d$var$tt.r || $37abfb837d2dd31d$var$U($37abfb837d2dd31d$var$tt.c), $37abfb837d2dd31d$var$tt = $37abfb837d2dd31d$var$tt.p;
}
function $37abfb837d2dd31d$var$j(e, t) {
    e && e.i && ($37abfb837d2dd31d$var$Yt.delete(e), e.i(t));
}
function $37abfb837d2dd31d$var$k(e, t, i, s) {
    if (e && e.o) {
        if ($37abfb837d2dd31d$var$Yt.has(e)) return;
        $37abfb837d2dd31d$var$Yt.add(e), $37abfb837d2dd31d$var$tt.c.push(()=>{
            $37abfb837d2dd31d$var$Yt.delete(e), s && (i && e.d(1), s());
        }), e.o(t);
    } else s && s();
}
const $37abfb837d2dd31d$var$ae = {
    duration: 0
};
function $37abfb837d2dd31d$var$$e(e, t, i, s) {
    let r = t(e, i), a = s ? 0 : 1, l = null, n = null, o = null;
    function c() {
        o && $37abfb837d2dd31d$var$Rt(e, o);
    }
    function g(d, f) {
        const p = d.b - a;
        return f *= Math.abs(p), {
            a: a,
            b: d.b,
            d: p,
            duration: f,
            start: d.start,
            end: d.start + f,
            group: d.group
        };
    }
    function u(d) {
        const { delay: f = 0, duration: p = 300, easing: m = $37abfb837d2dd31d$var$Tt, tick: h = $37abfb837d2dd31d$var$E, css: x } = r || $37abfb837d2dd31d$var$ae, N = {
            start: $37abfb837d2dd31d$var$qt() + f,
            b: d
        };
        d || (N.group = $37abfb837d2dd31d$var$tt, $37abfb837d2dd31d$var$tt.r += 1), l || n ? n = N : (x && (c(), o = $37abfb837d2dd31d$var$Bt(e, a, d, p, f, m, x)), d && h(0, 1), l = g(N, p), $37abfb837d2dd31d$var$ot(()=>$37abfb837d2dd31d$var$ct(e, d, "start")), $37abfb837d2dd31d$var$te((M)=>{
            if (n && M > n.start && (l = g(n, p), n = null, $37abfb837d2dd31d$var$ct(e, l.b, "start"), x && (c(), o = $37abfb837d2dd31d$var$Bt(e, a, l.b, l.duration, 0, m, r.css))), l) {
                if (M >= l.end) h(a = l.b, 1 - a), $37abfb837d2dd31d$var$ct(e, l.b, "end"), n || (l.b ? c() : --l.group.r || $37abfb837d2dd31d$var$U(l.group.c)), l = null;
                else if (M >= l.start) {
                    const w = M - l.start;
                    a = l.a + l.d * m(w / l.duration), h(a, 1 - a);
                }
            }
            return !(!l && !n);
        }));
    }
    return {
        run (d) {
            $37abfb837d2dd31d$var$F(r) ? $37abfb837d2dd31d$var$oe().then(()=>{
                r = r(), u(d);
            }) : u(d);
        },
        end () {
            c(), l = n = null;
        }
    };
}
function $37abfb837d2dd31d$var$ke(e, t) {
    const i = {}, s = {}, r = {
        $$scope: 1
    };
    let a = e.length;
    for(; a--;){
        const l = e[a], n = t[a];
        if (n) {
            for(const o in l)o in n || (s[o] = 1);
            for(const o in n)r[o] || (i[o] = n[o], r[o] = 1);
            e[a] = n;
        } else for(const o in l)r[o] = 1;
    }
    for(const l in s)l in i || (i[l] = void 0);
    return i;
}
function $37abfb837d2dd31d$var$J(e) {
    e && e.c();
}
function $37abfb837d2dd31d$var$G(e, t, i, s) {
    const { fragment: r, on_mount: a, on_destroy: l, after_update: n } = e.$$;
    r && r.m(t, i), s || $37abfb837d2dd31d$var$ot(()=>{
        const o = a.map($37abfb837d2dd31d$var$ve).filter($37abfb837d2dd31d$var$F);
        l ? l.push(...o) : $37abfb837d2dd31d$var$U(o), e.$$.on_mount = [];
    }), n.forEach($37abfb837d2dd31d$var$ot);
}
function $37abfb837d2dd31d$var$Z(e, t) {
    const i = e.$$;
    i.fragment !== null && ($37abfb837d2dd31d$var$U(i.on_destroy), i.fragment && i.fragment.d(t), i.on_destroy = i.fragment = null, i.ctx = []);
}
function $37abfb837d2dd31d$var$en(e, t) {
    e.$$.dirty[0] === -1 && ($37abfb837d2dd31d$var$St.push(e), $37abfb837d2dd31d$var$se || ($37abfb837d2dd31d$var$se = !0, $37abfb837d2dd31d$var$Ke.then($37abfb837d2dd31d$var$ze)), e.$$.dirty.fill(0)), e.$$.dirty[t / 31 | 0] |= 1 << t % 31;
}
function $37abfb837d2dd31d$var$X(e, t, i, s, r, a, l, n = [
    -1
]) {
    const o = $37abfb837d2dd31d$var$zt;
    $37abfb837d2dd31d$var$$t(e);
    const c = e.$$ = {
        fragment: null,
        ctx: null,
        props: a,
        update: $37abfb837d2dd31d$var$E,
        not_equal: r,
        bound: $37abfb837d2dd31d$var$be(),
        on_mount: [],
        on_destroy: [],
        on_disconnect: [],
        before_update: [],
        after_update: [],
        context: new Map(t.context || (o ? o.$$.context : [])),
        callbacks: $37abfb837d2dd31d$var$be(),
        dirty: n,
        skip_bound: !1,
        root: t.target || o.$$.root
    };
    l && l(c.root);
    let g = !1;
    if (c.ctx = i ? i(e, t.props || {}, (u, d, ...f)=>{
        const p = f.length ? f[0] : d;
        return c.ctx && r(c.ctx[u], c.ctx[u] = p) && (!c.skip_bound && c.bound[u] && c.bound[u](p), g && $37abfb837d2dd31d$var$en(e, u)), d;
    }) : [], c.update(), g = !0, $37abfb837d2dd31d$var$U(c.before_update), c.fragment = !!s && s(c.ctx), t.target) {
        if (t.hydrate) {
            const u = function(d) {
                return Array.from(d.childNodes);
            }(t.target);
            c.fragment && c.fragment.l(u), u.forEach($37abfb837d2dd31d$var$z);
        } else c.fragment && c.fragment.c();
        t.intro && $37abfb837d2dd31d$var$j(e.$$.fragment), $37abfb837d2dd31d$var$G(e, t.target, t.anchor, t.customElement), $37abfb837d2dd31d$var$ze();
    }
    $37abfb837d2dd31d$var$$t(o);
}
class $37abfb837d2dd31d$var$q {
    $destroy() {
        $37abfb837d2dd31d$var$Z(this, 1), this.$destroy = $37abfb837d2dd31d$var$E;
    }
    $on(t, i) {
        const s = this.$$.callbacks[t] || (this.$$.callbacks[t] = []);
        return s.push(i), ()=>{
            const r = s.indexOf(i);
            r !== -1 && s.splice(r, 1);
        };
    }
    $set(t) {
        var i;
        this.$$set && (i = t, Object.keys(i).length !== 0) && (this.$$.skip_bound = !0, this.$$set(t), this.$$.skip_bound = !1);
    }
}
const $37abfb837d2dd31d$var$nn = {
    color: "currentColor",
    class: "",
    opacity: .1,
    centered: !1,
    spreadingDuration: ".4s",
    spreadingDelay: "0s",
    spreadingTimingFunction: "linear",
    clearingDuration: "1s",
    clearingDelay: "0s",
    clearingTimingFunction: "ease-in-out"
};
function $37abfb837d2dd31d$var$Se(e, t = {}) {
    e.stopImmediatePropagation();
    const i = {
        ...$37abfb837d2dd31d$var$nn,
        ...t
    }, s = !!e.touches && !!e.touches[0], r = s ? e.touches[0].currentTarget : e.currentTarget, a = document.createElement("div"), l = a.style;
    a.className = `material-ripple ${i.class}`, l.position = "absolute", l.color = "inherit", l.borderRadius = "50%", l.pointerEvents = "none", l.width = "100px", l.height = "100px", l.marginTop = "-50px", l.marginLeft = "-50px", r.appendChild(a), l.opacity = i.opacity, l.transition = `transform ${i.spreadingDuration} ${i.spreadingTimingFunction} ${i.spreadingDelay},opacity ${i.clearingDuration} ${i.clearingTimingFunction} ${i.clearingDelay}`, l.transform = "scale(0) translate(0,0)", l.background = i.color;
    const n = r.getBoundingClientRect();
    if (i.centered) l.top = n.height / 2 + "px", l.left = n.width / 2 + "px";
    else {
        const o = s ? e.touches[0].clientY : e.clientY, c = s ? e.touches[0].clientX : e.clientX;
        l.top = o - n.top + "px", l.left = c - n.left + "px";
    }
    return l.transform = `scale(${.02 * Math.max(n.width, n.height)}) translate(0,0)`, a;
}
var $37abfb837d2dd31d$var$Oe = (e, t = {})=>{
    let i, s = t, r = !1, a = !1;
    const l = (d)=>{
        i = $37abfb837d2dd31d$var$Se(d, s);
    }, n = ()=>(function(d) {
            d && (d.addEventListener("transitionend", (f)=>{
                f.propertyName === "opacity" && d.remove();
            }), d.style.opacity = 0);
        })(i), o = (d)=>{
        a || d.keyCode !== 13 && d.keyCode !== 32 || (i = $37abfb837d2dd31d$var$Se(d, {
            ...s,
            centered: !0
        }), a = !0);
    }, c = ()=>{
        a = !1, n();
    };
    function g() {
        e.classList.add("s-ripple-container"), e.addEventListener("pointerdown", l), e.addEventListener("pointerup", n), e.addEventListener("pointerleave", n), e.addEventListener("keydown", o), e.addEventListener("keyup", c), r = !1;
    }
    function u() {
        e.classList.remove("s-ripple-container"), e.removeEventListener("pointerdown", l), e.removeEventListener("pointerup", n), e.removeEventListener("pointerleave", n), e.removeEventListener("keydown", o), e.removeEventListener("keyup", c), r = !0;
    }
    return s && g(), {
        update (d) {
            s = d, s && r ? g() : s || r || u();
        },
        destroy: u
    };
};
function $37abfb837d2dd31d$var$Ce(e) {
    return typeof e == "number" ? `${e}px` : e;
}
var $37abfb837d2dd31d$var$sn = (e, t)=>{
    let i = t;
    return Object.entries(i).forEach(([s, r])=>{
        r && e.style.setProperty(`--s-${s}`, $37abfb837d2dd31d$var$Ce(r));
    }), {
        update (s) {
            Object.entries(s).forEach(([r, a])=>{
                a && (e.style.setProperty(`--s-${r}`, $37abfb837d2dd31d$var$Ce(a)), delete i[r]);
            }), Object.keys(i).forEach((r)=>e.style.removeProperty(`--s-${r}`)), i = s;
        }
    };
};
const $37abfb837d2dd31d$var$le = (e)=>e.split(" ").filter((t)=>!!t);
var $37abfb837d2dd31d$var$Le = (e, t)=>{
    let i = t;
    return e.classList.add(...$37abfb837d2dd31d$var$le(((s)=>s.filter((r)=>!!r))(i).join(" "))), {
        update (s) {
            const r = s;
            r.forEach((a, l)=>{
                a ? e.classList.add(...$37abfb837d2dd31d$var$le(a)) : i[l] && e.classList.remove(...$37abfb837d2dd31d$var$le(i[l]));
            }), i = r;
        }
    };
};
function $37abfb837d2dd31d$var$rn(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-1is7e95", '.s-btn{align-items:center;border-radius:4px;display:inline-flex;flex:0 0 auto;overflow:hidden;position:relative;outline:0;justify-content:center;user-select:none;vertical-align:middle;white-space:nowrap;text-decoration:none;transition-duration:0.28s;transition-property:box-shadow, transform, opacity;background-color:var(--theme-app-bar);box-shadow:0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)}.s-btn .s-icon,.s-btn a{color:inherit}.s-btn .s-btn__content{display:flex;align-items:center;flex:1 0 auto;color:inherit;justify-content:inherit;line-height:normal;position:relative;font-size:inherit;font-weight:500;letter-spacing:0.0892857143em;text-transform:uppercase}.s-btn:before{border-radius:inherit;bottom:0;color:inherit;content:"";left:0;opacity:0;pointer-events:none;position:absolute;right:0;top:0;transition:opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);background-color:currentColor}.s-btn.size-x-small{font-size:0.625rem}.s-btn.size-small{font-size:0.75rem}.s-btn.size-default,.s-btn.size-large{font-size:0.875rem}.s-btn.size-x-large{font-size:1rem}.s-btn:not(.disabled):hover:before{opacity:0.08}.s-btn:not(.disabled).active:before{opacity:0.18}.s-btn:not(.disabled).focus-visible:before{opacity:0.24}.s-btn:not(.outlined).error-color,.s-btn:not(.outlined).info-color,.s-btn:not(.outlined).primary-color,.s-btn:not(.outlined).secondary-color,.s-btn:not(.outlined).success-color,.s-btn:not(.outlined).warning-color{color:#fff}.s-btn:not(.icon):not(.s-btn--fab).size-x-small{height:20px;min-width:36px;padding:0 8.8888888889px}.s-btn:not(.icon):not(.s-btn--fab).size-small{height:28px;min-width:50px;padding:0 12.4444444444px}.s-btn:not(.icon):not(.s-btn--fab).size-default{height:36px;min-width:64px;padding:0 16px}.s-btn:not(.icon):not(.s-btn--fab).size-large{height:44px;min-width:78px;padding:0 19.5555555556px}.s-btn:not(.icon):not(.s-btn--fab).size-x-large{height:52px;min-width:92px;padding:0 23.1111111111px}.s-btn:not(.disabled):not(.depressed){will-change:box-shadow}.s-btn.block{display:flex;flex:1 0 auto;min-width:100% !important;max-width:auto}.s-btn.tile{border-radius:0}.s-btn.text{background-color:transparent}.s-btn.depressed{box-shadow:none}.s-btn.outlined{border:1px solid;background-color:transparent !important}.s-btn.rounded{border-radius:9999px}.s-btn.disabled{pointer-events:none;color:var(--theme-buttons-disabled)}.s-btn.disabled:not(.flat):not(.text):not(.outlined){background-color:var(--theme-buttons-disabled)}.s-btn.icon.size-x-small{height:20px;width:20px}.s-btn.icon.size-small{height:28px;width:28px}.s-btn.icon.size-default{height:36px;width:36px}.s-btn.icon.size-large{height:44px;width:44px}.s-btn.icon.size-x-large{height:52px;width:52px}.s-btn.icon,.s-btn.s-btn--fab{border-radius:50%;min-width:0;min-height:0;padding:0}.s-btn.icon.size-x-small .s-icon,.s-btn.s-btn--fab.size-x-small .s-icon{font-size:18px}.s-btn.icon.size-default .s-icon,.s-btn.icon.size-small .s-icon,.s-btn.s-btn--fab.size-default .s-icon,.s-btn.s-btn--fab.size-small .s-icon{font-size:24px}.s-btn.icon.size-large .s-icon,.s-btn.s-btn--fab.size-large .s-icon{font-size:28px}.s-btn.icon.size-x-large .s-icon,.s-btn.s-btn--fab.size-x-large .s-icon{font-size:32px}.s-btn.s-btn--fab.size-x-small{height:32px;width:32px}.s-btn.s-btn--fab.size-small{height:40px;width:40px}.s-btn.s-btn--fab.size-default{height:56px;width:56px}.s-btn.s-btn--fab.size-large{height:64px;width:64px}.s-btn.s-btn--fab.size-x-large{height:72px;width:72px}');
}
function $37abfb837d2dd31d$var$on(e) {
    let t, i, s, r, a, l, n, o;
    const c = e[19].default, g = $37abfb837d2dd31d$var$B(c, e, e[18], null);
    let u = [
        {
            class: s = "s-btn size-" + e[5] + " " + e[1]
        },
        {
            type: e[14]
        },
        {
            style: e[16]
        },
        {
            disabled: e[11]
        },
        {
            "aria-disabled": e[11]
        },
        e[17]
    ], d = {};
    for(let f = 0; f < u.length; f += 1)d = $37abfb837d2dd31d$var$Dt(d, u[f]);
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("button"), i = $37abfb837d2dd31d$var$S("span"), g && g.c(), $37abfb837d2dd31d$var$b(i, "class", "s-btn__content"), $37abfb837d2dd31d$var$Ae(t, d), $37abfb837d2dd31d$var$y(t, "s-btn--fab", e[2]), $37abfb837d2dd31d$var$y(t, "icon", e[3]), $37abfb837d2dd31d$var$y(t, "block", e[4]), $37abfb837d2dd31d$var$y(t, "tile", e[6]), $37abfb837d2dd31d$var$y(t, "text", e[7] || e[3]), $37abfb837d2dd31d$var$y(t, "depressed", e[8] || e[7] || e[11] || e[9] || e[3]), $37abfb837d2dd31d$var$y(t, "outlined", e[9]), $37abfb837d2dd31d$var$y(t, "rounded", e[10]), $37abfb837d2dd31d$var$y(t, "disabled", e[11]);
        },
        m (f, p) {
            $37abfb837d2dd31d$var$$(f, t, p), $37abfb837d2dd31d$var$L(t, i), g && g.m(i, null), t.autofocus && t.focus(), e[21](t), l = !0, n || (o = [
                $37abfb837d2dd31d$var$it(r = $37abfb837d2dd31d$var$Le.call(null, t, [
                    e[12] && e[13]
                ])),
                $37abfb837d2dd31d$var$it(a = $37abfb837d2dd31d$var$Oe.call(null, t, e[15])),
                $37abfb837d2dd31d$var$Y(t, "click", e[20])
            ], n = !0);
        },
        p (f, [p]) {
            g && g.p && (!l || 262144 & p) && $37abfb837d2dd31d$var$W(g, c, f, f[18], l ? $37abfb837d2dd31d$var$R(c, f[18], p, null) : $37abfb837d2dd31d$var$Q(f[18]), null), $37abfb837d2dd31d$var$Ae(t, d = $37abfb837d2dd31d$var$ke(u, [
                (!l || 34 & p && s !== (s = "s-btn size-" + f[5] + " " + f[1])) && {
                    class: s
                },
                (!l || 16384 & p) && {
                    type: f[14]
                },
                (!l || 65536 & p) && {
                    style: f[16]
                },
                (!l || 2048 & p) && {
                    disabled: f[11]
                },
                (!l || 2048 & p) && {
                    "aria-disabled": f[11]
                },
                131072 & p && f[17]
            ])), r && $37abfb837d2dd31d$var$F(r.update) && 12288 & p && r.update.call(null, [
                f[12] && f[13]
            ]), a && $37abfb837d2dd31d$var$F(a.update) && 32768 & p && a.update.call(null, f[15]), $37abfb837d2dd31d$var$y(t, "s-btn--fab", f[2]), $37abfb837d2dd31d$var$y(t, "icon", f[3]), $37abfb837d2dd31d$var$y(t, "block", f[4]), $37abfb837d2dd31d$var$y(t, "tile", f[6]), $37abfb837d2dd31d$var$y(t, "text", f[7] || f[3]), $37abfb837d2dd31d$var$y(t, "depressed", f[8] || f[7] || f[11] || f[9] || f[3]), $37abfb837d2dd31d$var$y(t, "outlined", f[9]), $37abfb837d2dd31d$var$y(t, "rounded", f[10]), $37abfb837d2dd31d$var$y(t, "disabled", f[11]);
        },
        i (f) {
            l || ($37abfb837d2dd31d$var$j(g, f), l = !0);
        },
        o (f) {
            $37abfb837d2dd31d$var$k(g, f), l = !1;
        },
        d (f) {
            f && $37abfb837d2dd31d$var$z(t), g && g.d(f), e[21](null), n = !1, $37abfb837d2dd31d$var$U(o);
        }
    };
}
function $37abfb837d2dd31d$var$an(e, t, i) {
    const s = [
        "class",
        "fab",
        "icon",
        "block",
        "size",
        "tile",
        "text",
        "depressed",
        "outlined",
        "rounded",
        "disabled",
        "active",
        "activeClass",
        "type",
        "ripple",
        "style",
        "button"
    ];
    let r = $37abfb837d2dd31d$var$we(t, s), { $$slots: a = {}, $$scope: l } = t, { class: n = "" } = t, { fab: o = !1 } = t, { icon: c = !1 } = t, { block: g = !1 } = t, { size: u = "default" } = t, { tile: d = !1 } = t, { text: f = !1 } = t, { depressed: p = !1 } = t, { outlined: m = !1 } = t, { rounded: h = !1 } = t, { disabled: x = null } = t, { active: N = !1 } = t, { activeClass: M = "active" } = t, { type: w = "button" } = t, { ripple: A = {} } = t, { style: C = null } = t, { button: O = null } = t;
    return e.$$set = (v)=>{
        t = $37abfb837d2dd31d$var$Dt($37abfb837d2dd31d$var$Dt({}, t), function(D) {
            const P = {};
            for(const et in D)et[0] !== "$" && (P[et] = D[et]);
            return P;
        }(v)), i(17, r = $37abfb837d2dd31d$var$we(t, s)), "class" in v && i(1, n = v.class), "fab" in v && i(2, o = v.fab), "icon" in v && i(3, c = v.icon), "block" in v && i(4, g = v.block), "size" in v && i(5, u = v.size), "tile" in v && i(6, d = v.tile), "text" in v && i(7, f = v.text), "depressed" in v && i(8, p = v.depressed), "outlined" in v && i(9, m = v.outlined), "rounded" in v && i(10, h = v.rounded), "disabled" in v && i(11, x = v.disabled), "active" in v && i(12, N = v.active), "activeClass" in v && i(13, M = v.activeClass), "type" in v && i(14, w = v.type), "ripple" in v && i(15, A = v.ripple), "style" in v && i(16, C = v.style), "button" in v && i(0, O = v.button), "$$scope" in v && i(18, l = v.$$scope);
    }, [
        O,
        n,
        o,
        c,
        g,
        u,
        d,
        f,
        p,
        m,
        h,
        x,
        N,
        M,
        w,
        A,
        C,
        r,
        l,
        a,
        function(v) {
            $37abfb837d2dd31d$var$rt.call(this, e, v);
        },
        function(v) {
            $37abfb837d2dd31d$var$Wt[v ? "unshift" : "push"](()=>{
                O = v, i(0, O);
            });
        }
    ];
}
class $37abfb837d2dd31d$var$ln extends $37abfb837d2dd31d$var$q {
    constructor(t){
        super(), $37abfb837d2dd31d$var$X(this, t, $37abfb837d2dd31d$var$an, $37abfb837d2dd31d$var$on, $37abfb837d2dd31d$var$H, {
            class: 1,
            fab: 2,
            icon: 3,
            block: 4,
            size: 5,
            tile: 6,
            text: 7,
            depressed: 8,
            outlined: 9,
            rounded: 10,
            disabled: 11,
            active: 12,
            activeClass: 13,
            type: 14,
            ripple: 15,
            style: 16,
            button: 0
        }, $37abfb837d2dd31d$var$rn);
    }
}
let $37abfb837d2dd31d$var$_e = 36, $37abfb837d2dd31d$var$cn = "";
for(; $37abfb837d2dd31d$var$_e--;)$37abfb837d2dd31d$var$cn += $37abfb837d2dd31d$var$_e.toString(36);
function $37abfb837d2dd31d$var$dn(e) {
    const t = e - 1;
    return t * t * t + 1;
}
function $37abfb837d2dd31d$var$un(e, { delay: t = 0, duration: i = 400, easing: s = $37abfb837d2dd31d$var$Tt } = {}) {
    const r = +getComputedStyle(e).opacity;
    return {
        delay: t,
        duration: i,
        easing: s,
        css: (a)=>"opacity: " + a * r
    };
}
function $37abfb837d2dd31d$var$fn(e, { delay: t = 0, duration: i = 400, easing: s = $37abfb837d2dd31d$var$dn, start: r = 0, opacity: a = 0 } = {}) {
    const l = getComputedStyle(e), n = +l.opacity, o = l.transform === "none" ? "" : l.transform, c = 1 - r, g = n * (1 - a);
    return {
        delay: t,
        duration: i,
        easing: s,
        css: (u, d)=>`
			transform: ${o} scale(${1 - c * d});
			opacity: ${n - g * d}
		`
    };
}
function $37abfb837d2dd31d$var$pn(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-1qc2404", ".s-list{color:var(--theme-text-primary);display:block;padding:8px 0;position:static}.s-list .s-subheader{padding-top:0}.s-list .s-list-item.active{color:inherit}.s-list.disabled{pointer-events:none}.s-list.dense .s-subheader{font-size:0.75rem;height:40px;padding:0 8px}.s-list.rounded{padding:8px}.s-list.rounded .s-list-item{border-radius:32px !important}.s-list.nav{padding-left:8px;padding-right:8px}.s-list.nav .s-list-item{padding:0 8px;border-radius:4px}.s-list.nav .s-list-item:before{border-radius:4px}.s-list.nav .s-list-item:not(:last-child):not(:only-child),.s-list.rounded .s-list-item:not(:last-child):not(:only-child){margin-bottom:8px}.s-list.nav .s-list-item.dense:not(:last-child):not(:only-child),.s-list.rounded .s-list-item.dense:not(:last-child):not(:only-child){margin-bottom:4px}.s-list.outlined{border:thin solid var(--theme-dividers)}.s-list.flat .s-list-item:before{display:none}");
}
function $37abfb837d2dd31d$var$gn(e) {
    let t, i, s;
    const r = e[10].default, a = $37abfb837d2dd31d$var$B(r, e, e[9], null);
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("div"), a && a.c(), $37abfb837d2dd31d$var$b(t, "role", e[8]), $37abfb837d2dd31d$var$b(t, "class", i = "s-list " + e[0]), $37abfb837d2dd31d$var$b(t, "aria-disabled", e[2]), $37abfb837d2dd31d$var$b(t, "style", e[7]), $37abfb837d2dd31d$var$y(t, "dense", e[1]), $37abfb837d2dd31d$var$y(t, "disabled", e[2]), $37abfb837d2dd31d$var$y(t, "flat", e[3]), $37abfb837d2dd31d$var$y(t, "nav", e[5]), $37abfb837d2dd31d$var$y(t, "outlined", e[6]), $37abfb837d2dd31d$var$y(t, "rounded", e[4]);
        },
        m (l, n) {
            $37abfb837d2dd31d$var$$(l, t, n), a && a.m(t, null), s = !0;
        },
        p (l, [n]) {
            a && a.p && (!s || 512 & n) && $37abfb837d2dd31d$var$W(a, r, l, l[9], s ? $37abfb837d2dd31d$var$R(r, l[9], n, null) : $37abfb837d2dd31d$var$Q(l[9]), null), (!s || 256 & n) && $37abfb837d2dd31d$var$b(t, "role", l[8]), (!s || 1 & n && i !== (i = "s-list " + l[0])) && $37abfb837d2dd31d$var$b(t, "class", i), (!s || 4 & n) && $37abfb837d2dd31d$var$b(t, "aria-disabled", l[2]), (!s || 128 & n) && $37abfb837d2dd31d$var$b(t, "style", l[7]), 3 & n && $37abfb837d2dd31d$var$y(t, "dense", l[1]), 5 & n && $37abfb837d2dd31d$var$y(t, "disabled", l[2]), 9 & n && $37abfb837d2dd31d$var$y(t, "flat", l[3]), 33 & n && $37abfb837d2dd31d$var$y(t, "nav", l[5]), 65 & n && $37abfb837d2dd31d$var$y(t, "outlined", l[6]), 17 & n && $37abfb837d2dd31d$var$y(t, "rounded", l[4]);
        },
        i (l) {
            s || ($37abfb837d2dd31d$var$j(a, l), s = !0);
        },
        o (l) {
            $37abfb837d2dd31d$var$k(a, l), s = !1;
        },
        d (l) {
            l && $37abfb837d2dd31d$var$z(t), a && a.d(l);
        }
    };
}
function $37abfb837d2dd31d$var$hn(e, t, i) {
    let { $$slots: s = {}, $$scope: r } = t, { class: a = "" } = t, { dense: l = null } = t, { disabled: n = null } = t, { flat: o = !1 } = t, { rounded: c = !1 } = t, { nav: g = !1 } = t, { outlined: u = !1 } = t, { style: d = null } = t, f = null;
    var p, m;
    return $37abfb837d2dd31d$var$kt("S_ListItemRole") || (p = "S_ListItemRole", m = "listitem", $37abfb837d2dd31d$var$De().$$.context.set(p, m), f = "list"), e.$$set = (h)=>{
        "class" in h && i(0, a = h.class), "dense" in h && i(1, l = h.dense), "disabled" in h && i(2, n = h.disabled), "flat" in h && i(3, o = h.flat), "rounded" in h && i(4, c = h.rounded), "nav" in h && i(5, g = h.nav), "outlined" in h && i(6, u = h.outlined), "style" in h && i(7, d = h.style), "$$scope" in h && i(9, r = h.$$scope);
    }, [
        a,
        l,
        n,
        o,
        c,
        g,
        u,
        d,
        f,
        r,
        s
    ];
}
class $37abfb837d2dd31d$var$mn extends $37abfb837d2dd31d$var$q {
    constructor(t){
        super(), $37abfb837d2dd31d$var$X(this, t, $37abfb837d2dd31d$var$hn, $37abfb837d2dd31d$var$gn, $37abfb837d2dd31d$var$H, {
            class: 0,
            dense: 1,
            disabled: 2,
            flat: 3,
            rounded: 4,
            nav: 5,
            outlined: 6,
            style: 7
        }, $37abfb837d2dd31d$var$pn);
    }
}
function $37abfb837d2dd31d$var$Mn(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-1lt8zv0", '.s-list-item__content{align-items:center;align-self:center;display:flex;flex-wrap:wrap;flex:1 1;overflow:hidden;padding:12px 0}.s-list-item__content>*{line-height:1.1;flex:1 0 100%}.s-list-item__content>:not(:last-child){margin-bottom:2px}.s-list-item__subtitle,.s-list-item__title{flex:1 1 100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;line-height:1.2}.s-list-item__title{align-self:center;font-size:1rem}.s-list-item__subtitle{font-size:0.875rem;color:var(--theme-text-secondary)}.s-list-item{align-items:center;display:flex;flex:1 1 100%;letter-spacing:normal;min-height:48px;outline:none;padding:0 16px;position:relative;text-decoration:none}.s-list-item .s-avatar{align-self:center;margin-top:8px;margin-bottom:8px}.s-list-item .s-icon{align-self:flex-start;margin-top:16px;margin-bottom:16px}.s-list-item .s-avatar,.s-list-item .s-icon{display:inline-flex;min-width:24px}.s-list-item [slot=prepend] .s-avatar{margin-right:16px}.s-list-item [slot=prepend] .s-checkbox,.s-list-item [slot=prepend] .s-icon,.s-list-item [slot=prepend] .s-radio{margin-right:32px}.s-list-item.link{cursor:pointer;user-select:none}.s-list-item.link:before{background-color:currentColor;bottom:0;top:0;left:0;right:0;content:"";pointer-events:none;position:absolute;opacity:0;transition:0.3s cubic-bezier(0.25, 0.8, 0.5, 1)}.s-list-item.link:not(.active):hover:before{opacity:0.04}.s-list-item.selectable{user-select:auto}.s-list-item.multiline .s-list-item__subtitle,.s-list-item.multiline .s-list-item__title{white-space:normal}.s-list-item:not(.disabled).focus-visible:before{opacity:0.12}.s-list-item.disabled{pointer-events:none;color:var(--theme-text-disabled)}.s-list-item.flat:before{display:none}.s-list-item.active:before{opacity:0.12}.s-list-item.active .s-icon{color:inherit}.s-list-item:after{content:"";min-height:inherit;font-size:0}.s-list-item:not(.active){color:var(--theme-text-primary)}.s-list-item.dense,.s-list.dense .s-list-item{min-height:32px}.s-list-item.dense .s-icon,.s-list.dense .s-list-item .s-icon{margin-top:8px;margin-bottom:8px}.s-list-item.dense [slot=prepend] .s-checkbox,.s-list-item.dense [slot=prepend] .s-icon,.s-list-item.dense [slot=prepend] .s-radio,.s-list.dense .s-list-item [slot=prepend] .s-checkbox,.s-list.dense .s-list-item [slot=prepend] .s-icon,.s-list.dense .s-list-item [slot=prepend] .s-radio{margin-right:24px}.s-list-item.dense .s-list-item__content,.s-list.dense .s-list-item .s-list-item__content{padding:8px 0}.s-list-item.dense .s-list-item__subtitle,.s-list-item.dense .s-list-item__title,.s-list.dense .s-list-item .s-list-item__subtitle,.s-list.dense .s-list-item .s-list-item__title{font-size:0.8125rem;font-weight:500;line-height:1rem}');
}
const $37abfb837d2dd31d$var$vn = (e)=>({}), $37abfb837d2dd31d$var$Te = (e)=>({}), $37abfb837d2dd31d$var$bn = (e)=>({}), $37abfb837d2dd31d$var$Pe = (e)=>({}), $37abfb837d2dd31d$var$yn = (e)=>({}), $37abfb837d2dd31d$var$Ee = (e)=>({});
function $37abfb837d2dd31d$var$wn(e) {
    let t, i, s, r, a, l, n, o, c, g, u, d, f, p, m;
    const h = e[14].prepend, x = $37abfb837d2dd31d$var$B(h, e, e[13], $37abfb837d2dd31d$var$Ee), N = e[14].default, M = $37abfb837d2dd31d$var$B(N, e, e[13], null), w = e[14].subtitle, A = $37abfb837d2dd31d$var$B(w, e, e[13], $37abfb837d2dd31d$var$Pe), C = e[14].append, O = $37abfb837d2dd31d$var$B(C, e, e[13], $37abfb837d2dd31d$var$Te);
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("div"), x && x.c(), i = $37abfb837d2dd31d$var$_(), s = $37abfb837d2dd31d$var$S("div"), r = $37abfb837d2dd31d$var$S("div"), M && M.c(), a = $37abfb837d2dd31d$var$_(), l = $37abfb837d2dd31d$var$S("div"), A && A.c(), n = $37abfb837d2dd31d$var$_(), O && O.c(), $37abfb837d2dd31d$var$b(r, "class", "s-list-item__title"), $37abfb837d2dd31d$var$b(l, "class", "s-list-item__subtitle"), $37abfb837d2dd31d$var$b(s, "class", "s-list-item__content"), $37abfb837d2dd31d$var$b(t, "class", o = "s-list-item " + e[1]), $37abfb837d2dd31d$var$b(t, "role", e[10]), $37abfb837d2dd31d$var$b(t, "tabindex", c = e[6] ? 0 : -1), $37abfb837d2dd31d$var$b(t, "aria-selected", g = e[10] === "option" ? e[0] : null), $37abfb837d2dd31d$var$b(t, "style", e[9]), $37abfb837d2dd31d$var$y(t, "dense", e[3]), $37abfb837d2dd31d$var$y(t, "disabled", e[4]), $37abfb837d2dd31d$var$y(t, "multiline", e[5]), $37abfb837d2dd31d$var$y(t, "link", e[6]), $37abfb837d2dd31d$var$y(t, "selectable", e[7]);
        },
        m (v, D) {
            $37abfb837d2dd31d$var$$(v, t, D), x && x.m(t, null), $37abfb837d2dd31d$var$L(t, i), $37abfb837d2dd31d$var$L(t, s), $37abfb837d2dd31d$var$L(s, r), M && M.m(r, null), $37abfb837d2dd31d$var$L(s, a), $37abfb837d2dd31d$var$L(s, l), A && A.m(l, null), $37abfb837d2dd31d$var$L(t, n), O && O.m(t, null), f = !0, p || (m = [
                $37abfb837d2dd31d$var$it(u = $37abfb837d2dd31d$var$Le.call(null, t, [
                    e[0] && e[2]
                ])),
                $37abfb837d2dd31d$var$it(d = $37abfb837d2dd31d$var$Oe.call(null, t, e[8])),
                $37abfb837d2dd31d$var$Y(t, "click", e[11]),
                $37abfb837d2dd31d$var$Y(t, "click", e[15]),
                $37abfb837d2dd31d$var$Y(t, "dblclick", e[16])
            ], p = !0);
        },
        p (v, [D]) {
            x && x.p && (!f || 8192 & D) && $37abfb837d2dd31d$var$W(x, h, v, v[13], f ? $37abfb837d2dd31d$var$R(h, v[13], D, $37abfb837d2dd31d$var$yn) : $37abfb837d2dd31d$var$Q(v[13]), $37abfb837d2dd31d$var$Ee), M && M.p && (!f || 8192 & D) && $37abfb837d2dd31d$var$W(M, N, v, v[13], f ? $37abfb837d2dd31d$var$R(N, v[13], D, null) : $37abfb837d2dd31d$var$Q(v[13]), null), A && A.p && (!f || 8192 & D) && $37abfb837d2dd31d$var$W(A, w, v, v[13], f ? $37abfb837d2dd31d$var$R(w, v[13], D, $37abfb837d2dd31d$var$bn) : $37abfb837d2dd31d$var$Q(v[13]), $37abfb837d2dd31d$var$Pe), O && O.p && (!f || 8192 & D) && $37abfb837d2dd31d$var$W(O, C, v, v[13], f ? $37abfb837d2dd31d$var$R(C, v[13], D, $37abfb837d2dd31d$var$vn) : $37abfb837d2dd31d$var$Q(v[13]), $37abfb837d2dd31d$var$Te), (!f || 2 & D && o !== (o = "s-list-item " + v[1])) && $37abfb837d2dd31d$var$b(t, "class", o), (!f || 64 & D && c !== (c = v[6] ? 0 : -1)) && $37abfb837d2dd31d$var$b(t, "tabindex", c), (!f || 1 & D && g !== (g = v[10] === "option" ? v[0] : null)) && $37abfb837d2dd31d$var$b(t, "aria-selected", g), (!f || 512 & D) && $37abfb837d2dd31d$var$b(t, "style", v[9]), u && $37abfb837d2dd31d$var$F(u.update) && 5 & D && u.update.call(null, [
                v[0] && v[2]
            ]), d && $37abfb837d2dd31d$var$F(d.update) && 256 & D && d.update.call(null, v[8]), 10 & D && $37abfb837d2dd31d$var$y(t, "dense", v[3]), 18 & D && $37abfb837d2dd31d$var$y(t, "disabled", v[4]), 34 & D && $37abfb837d2dd31d$var$y(t, "multiline", v[5]), 66 & D && $37abfb837d2dd31d$var$y(t, "link", v[6]), 130 & D && $37abfb837d2dd31d$var$y(t, "selectable", v[7]);
        },
        i (v) {
            f || ($37abfb837d2dd31d$var$j(x, v), $37abfb837d2dd31d$var$j(M, v), $37abfb837d2dd31d$var$j(A, v), $37abfb837d2dd31d$var$j(O, v), f = !0);
        },
        o (v) {
            $37abfb837d2dd31d$var$k(x, v), $37abfb837d2dd31d$var$k(M, v), $37abfb837d2dd31d$var$k(A, v), $37abfb837d2dd31d$var$k(O, v), f = !1;
        },
        d (v) {
            v && $37abfb837d2dd31d$var$z(t), x && x.d(v), M && M.d(v), A && A.d(v), O && O.d(v), p = !1, $37abfb837d2dd31d$var$U(m);
        }
    };
}
function $37abfb837d2dd31d$var$xn(e, t, i) {
    let { $$slots: s = {}, $$scope: r } = t;
    const a = $37abfb837d2dd31d$var$kt("S_ListItemRole"), l = $37abfb837d2dd31d$var$kt("S_ListItemGroup"), n = l ? $37abfb837d2dd31d$var$kt(l) : {
        select: ()=>null,
        register: ()=>null,
        index: ()=>null,
        activeClass: "active"
    };
    let { class: o = "" } = t, { activeClass: c = n.activeClass } = t, { value: g = n.index() } = t, { active: u = !1 } = t, { dense: d = !1 } = t, { disabled: f = null } = t, { multiline: p = !1 } = t, { link: m = a } = t, { selectable: h = !m } = t, { ripple: x = $37abfb837d2dd31d$var$kt("S_ListItemRipple") || a || !1 } = t, { style: N = null } = t;
    return n.register((M)=>{
        i(0, u = M.includes(g));
    }), e.$$set = (M)=>{
        "class" in M && i(1, o = M.class), "activeClass" in M && i(2, c = M.activeClass), "value" in M && i(12, g = M.value), "active" in M && i(0, u = M.active), "dense" in M && i(3, d = M.dense), "disabled" in M && i(4, f = M.disabled), "multiline" in M && i(5, p = M.multiline), "link" in M && i(6, m = M.link), "selectable" in M && i(7, h = M.selectable), "ripple" in M && i(8, x = M.ripple), "style" in M && i(9, N = M.style), "$$scope" in M && i(13, r = M.$$scope);
    }, [
        u,
        o,
        c,
        d,
        f,
        p,
        m,
        h,
        x,
        N,
        a,
        function() {
            f || n.select(g);
        },
        g,
        r,
        s,
        function(M) {
            $37abfb837d2dd31d$var$rt.call(this, e, M);
        },
        function(M) {
            $37abfb837d2dd31d$var$rt.call(this, e, M);
        }
    ];
}
class $37abfb837d2dd31d$var$In extends $37abfb837d2dd31d$var$q {
    constructor(t){
        super(), $37abfb837d2dd31d$var$X(this, t, $37abfb837d2dd31d$var$xn, $37abfb837d2dd31d$var$wn, $37abfb837d2dd31d$var$H, {
            class: 1,
            activeClass: 2,
            value: 12,
            active: 0,
            dense: 3,
            disabled: 4,
            multiline: 5,
            link: 6,
            selectable: 7,
            ripple: 8,
            style: 9
        }, $37abfb837d2dd31d$var$Mn);
    }
}
const $37abfb837d2dd31d$var$Nn = [
    "primary",
    "secondary",
    "success",
    "info",
    "warning",
    "error"
];
function $37abfb837d2dd31d$var$Fe(e, t) {
    if (/^(#|rgb|hsl|currentColor)/.test(t)) return e.style.backgroundColor = t, !1;
    if (t.startsWith("--")) return e.style.backgroundColor = `var(${t})`, !1;
    const i = function(s) {
        return s.split(" ").map((r)=>$37abfb837d2dd31d$var$Nn.includes(r) ? `${r}-color` : r);
    }(t);
    return e.classList.add(...i), i;
}
var $37abfb837d2dd31d$var$Gt = (e, t)=>{
    let i;
    return typeof t == "string" && (i = $37abfb837d2dd31d$var$Fe(e, t)), {
        update (s) {
            i ? e.classList.remove(...i) : e.style.backgroundColor = null, typeof s == "string" && (i = $37abfb837d2dd31d$var$Fe(e, s));
        }
    };
};
function $37abfb837d2dd31d$var$An(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-x5kbih", ".s-overlay.svelte-x5kbih{align-items:center;border-radius:inherit;display:flex;justify-content:center;position:fixed;top:0;left:0;right:0;bottom:0;pointer-events:auto}.s-overlay.absolute.svelte-x5kbih{position:absolute}.s-overlay__scrim.svelte-x5kbih{border-radius:inherit;bottom:0;height:100%;left:0;position:absolute;right:0;top:0;transition:inherit;width:100%;will-change:opacity}.s-overlay__content.svelte-x5kbih{position:relative}");
}
function $37abfb837d2dd31d$var$Be(e) {
    let t, i, s, r, a, l, n, o, c, g, u, d;
    const f = e[11].default, p = $37abfb837d2dd31d$var$B(f, e, e[10], null);
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("div"), i = $37abfb837d2dd31d$var$S("div"), r = $37abfb837d2dd31d$var$_(), a = $37abfb837d2dd31d$var$S("div"), p && p.c(), $37abfb837d2dd31d$var$b(i, "class", "s-overlay__scrim svelte-x5kbih"), $37abfb837d2dd31d$var$T(i, "opacity", e[5]), $37abfb837d2dd31d$var$b(a, "class", "s-overlay__content svelte-x5kbih"), $37abfb837d2dd31d$var$b(t, "class", l = "s-overlay " + e[0] + " svelte-x5kbih"), $37abfb837d2dd31d$var$b(t, "style", n = "z-index:" + e[7] + ";" + e[9]), $37abfb837d2dd31d$var$y(t, "absolute", e[8]);
        },
        m (m, h) {
            $37abfb837d2dd31d$var$$(m, t, h), $37abfb837d2dd31d$var$L(t, i), $37abfb837d2dd31d$var$L(t, r), $37abfb837d2dd31d$var$L(t, a), p && p.m(a, null), g = !0, u || (d = [
                $37abfb837d2dd31d$var$it(s = $37abfb837d2dd31d$var$Gt.call(null, i, e[6])),
                $37abfb837d2dd31d$var$Y(t, "click", e[12])
            ], u = !0);
        },
        p (m, h) {
            e = m, (!g || 32 & h) && $37abfb837d2dd31d$var$T(i, "opacity", e[5]), s && $37abfb837d2dd31d$var$F(s.update) && 64 & h && s.update.call(null, e[6]), p && p.p && (!g || 1024 & h) && $37abfb837d2dd31d$var$W(p, f, e, e[10], g ? $37abfb837d2dd31d$var$R(f, e[10], h, null) : $37abfb837d2dd31d$var$Q(e[10]), null), (!g || 1 & h && l !== (l = "s-overlay " + e[0] + " svelte-x5kbih")) && $37abfb837d2dd31d$var$b(t, "class", l), (!g || 640 & h && n !== (n = "z-index:" + e[7] + ";" + e[9])) && $37abfb837d2dd31d$var$b(t, "style", n), 257 & h && $37abfb837d2dd31d$var$y(t, "absolute", e[8]);
        },
        i (m) {
            g || ($37abfb837d2dd31d$var$j(p, m), $37abfb837d2dd31d$var$ot(()=>{
                c && c.end(1), o = function(h, x, N) {
                    let M, w, A = x(h, N), C = !1, O = 0;
                    function v() {
                        M && $37abfb837d2dd31d$var$Rt(h, M);
                    }
                    function D() {
                        const { delay: et = 0, duration: ut = 300, easing: ft = $37abfb837d2dd31d$var$Tt, tick: xt = $37abfb837d2dd31d$var$E, css: pt } = A || $37abfb837d2dd31d$var$ae;
                        pt && (M = $37abfb837d2dd31d$var$Bt(h, 0, 1, ut, et, ft, pt, O++)), xt(0, 1);
                        const gt = $37abfb837d2dd31d$var$qt() + et, Je = gt + ut;
                        w && w.abort(), C = !0, $37abfb837d2dd31d$var$ot(()=>$37abfb837d2dd31d$var$ct(h, !0, "start")), w = $37abfb837d2dd31d$var$te((Vt)=>{
                            if (C) {
                                if (Vt >= Je) return xt(1, 0), $37abfb837d2dd31d$var$ct(h, !0, "end"), v(), C = !1;
                                if (Vt >= gt) {
                                    const de = ft((Vt - gt) / ut);
                                    xt(de, 1 - de);
                                }
                            }
                            return C;
                        });
                    }
                    let P = !1;
                    return {
                        start () {
                            P || (P = !0, $37abfb837d2dd31d$var$Rt(h), $37abfb837d2dd31d$var$F(A) ? (A = A(), $37abfb837d2dd31d$var$oe().then(D)) : D());
                        },
                        invalidate () {
                            P = !1;
                        },
                        end () {
                            C && (v(), C = !1);
                        }
                    };
                }(t, e[1], e[2]), o.start();
            }), g = !0);
        },
        o (m) {
            $37abfb837d2dd31d$var$k(p, m), o && o.invalidate(), c = function(h, x, N) {
                let M, w = x(h, N), A = !0;
                const C = $37abfb837d2dd31d$var$tt;
                function O() {
                    const { delay: v = 0, duration: D = 300, easing: P = $37abfb837d2dd31d$var$Tt, tick: et = $37abfb837d2dd31d$var$E, css: ut } = w || $37abfb837d2dd31d$var$ae;
                    ut && (M = $37abfb837d2dd31d$var$Bt(h, 1, 0, D, v, P, ut));
                    const ft = $37abfb837d2dd31d$var$qt() + v, xt = ft + D;
                    $37abfb837d2dd31d$var$ot(()=>$37abfb837d2dd31d$var$ct(h, !1, "start")), $37abfb837d2dd31d$var$te((pt)=>{
                        if (A) {
                            if (pt >= xt) return et(0, 1), $37abfb837d2dd31d$var$ct(h, !1, "end"), --C.r || $37abfb837d2dd31d$var$U(C.c), !1;
                            if (pt >= ft) {
                                const gt = P((pt - ft) / D);
                                et(1 - gt, gt);
                            }
                        }
                        return A;
                    });
                }
                return C.r += 1, $37abfb837d2dd31d$var$F(w) ? $37abfb837d2dd31d$var$oe().then(()=>{
                    w = w(), O();
                }) : O(), {
                    end (v) {
                        v && w.tick && w.tick(1, 0), A && (M && $37abfb837d2dd31d$var$Rt(h, M), A = !1);
                    }
                };
            }(t, e[1], e[3]), g = !1;
        },
        d (m) {
            m && $37abfb837d2dd31d$var$z(t), p && p.d(m), m && c && c.end(), u = !1, $37abfb837d2dd31d$var$U(d);
        }
    };
}
function $37abfb837d2dd31d$var$jn(e) {
    let t, i, s = e[4] && $37abfb837d2dd31d$var$Be(e);
    return {
        c () {
            s && s.c(), t = $37abfb837d2dd31d$var$ne();
        },
        m (r, a) {
            s && s.m(r, a), $37abfb837d2dd31d$var$$(r, t, a), i = !0;
        },
        p (r, [a]) {
            r[4] ? s ? (s.p(r, a), 16 & a && $37abfb837d2dd31d$var$j(s, 1)) : (s = $37abfb837d2dd31d$var$Be(r), s.c(), $37abfb837d2dd31d$var$j(s, 1), s.m(t.parentNode, t)) : s && ($37abfb837d2dd31d$var$Mt(), $37abfb837d2dd31d$var$k(s, 1, 1, ()=>{
                s = null;
            }), $37abfb837d2dd31d$var$vt());
        },
        i (r) {
            i || ($37abfb837d2dd31d$var$j(s), i = !0);
        },
        o (r) {
            $37abfb837d2dd31d$var$k(s), i = !1;
        },
        d (r) {
            s && s.d(r), r && $37abfb837d2dd31d$var$z(t);
        }
    };
}
function $37abfb837d2dd31d$var$Dn(e, t, i) {
    let { $$slots: s = {}, $$scope: r } = t, { class: a = "" } = t, { transition: l = $37abfb837d2dd31d$var$un } = t, { inOpts: n = {
        duration: 250
    } } = t, { outOpts: o = {
        duration: 250
    } } = t, { active: c = !0 } = t, { opacity: g = .46 } = t, { color: u = "rgb(33, 33, 33)" } = t, { index: d = 5 } = t, { absolute: f = !1 } = t, { style: p = "" } = t;
    return e.$$set = (m)=>{
        "class" in m && i(0, a = m.class), "transition" in m && i(1, l = m.transition), "inOpts" in m && i(2, n = m.inOpts), "outOpts" in m && i(3, o = m.outOpts), "active" in m && i(4, c = m.active), "opacity" in m && i(5, g = m.opacity), "color" in m && i(6, u = m.color), "index" in m && i(7, d = m.index), "absolute" in m && i(8, f = m.absolute), "style" in m && i(9, p = m.style), "$$scope" in m && i(10, r = m.$$scope);
    }, [
        a,
        l,
        n,
        o,
        c,
        g,
        u,
        d,
        f,
        p,
        r,
        s,
        function(m) {
            $37abfb837d2dd31d$var$rt.call(this, e, m);
        }
    ];
}
class $37abfb837d2dd31d$var$zn extends $37abfb837d2dd31d$var$q {
    constructor(t){
        super(), $37abfb837d2dd31d$var$X(this, t, $37abfb837d2dd31d$var$Dn, $37abfb837d2dd31d$var$jn, $37abfb837d2dd31d$var$H, {
            class: 0,
            transition: 1,
            inOpts: 2,
            outOpts: 3,
            active: 4,
            opacity: 5,
            color: 6,
            index: 7,
            absolute: 8,
            style: 9
        }, $37abfb837d2dd31d$var$An);
    }
}
function $37abfb837d2dd31d$var$$n(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-47jzcv", ".s-dialog{align-items:center;display:flex;height:100%;justify-content:center;left:0;pointer-events:none;position:fixed;top:0;transition:0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;width:100%;z-index:6;outline:none}.s-dialog__content{background-color:var(--theme-surface);border-radius:4px;margin:24px;overflow-y:auto;pointer-events:auto;z-index:inherit;box-shadow:0 11px 15px -7px rgba(0, 0, 0, 0.2), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12)}.s-dialog__content:not(.fullscreen){max-height:90%;width:var(--s-dialog-width)}.s-dialog__content.fullscreen{border-radius:0;margin:0;height:100%;width:100%;position:fixed;overflow-y:auto;top:0;left:0}.s-dialog__content>.s-card>.s-card-title{font-size:1.25rem;font-weight:500;letter-spacing:0.0125em;padding:16px 24px 10px}.s-dialog__content>.s-card>.s-card-subtitle,.s-dialog__content>.s-card>.s-card-text{padding:0 24px 20px}.fullscreen{border-radius:0;margin:0;height:100%;position:fixed;overflow-y:auto;top:0;left:0}.fullscreen>.s-card{min-height:100%;min-width:100%;margin:0 !important;padding:0 !important}");
}
function $37abfb837d2dd31d$var$Re(e) {
    let t, i, s, r, a, l, n, o;
    const c = e[11].default, g = $37abfb837d2dd31d$var$B(c, e, e[10], null);
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("div"), i = $37abfb837d2dd31d$var$S("div"), g && g.c(), $37abfb837d2dd31d$var$b(i, "class", s = "s-dialog__content " + e[0]), $37abfb837d2dd31d$var$y(i, "fullscreen", e[2]), $37abfb837d2dd31d$var$b(t, "role", "document"), $37abfb837d2dd31d$var$b(t, "class", "s-dialog");
        },
        m (u, d) {
            $37abfb837d2dd31d$var$$(u, t, d), $37abfb837d2dd31d$var$L(t, i), g && g.m(i, null), l = !0, n || (o = [
                $37abfb837d2dd31d$var$Y(i, "introstart", e[12]),
                $37abfb837d2dd31d$var$Y(i, "outrostart", e[13]),
                $37abfb837d2dd31d$var$Y(i, "introend", e[14]),
                $37abfb837d2dd31d$var$Y(i, "outroend", e[15]),
                $37abfb837d2dd31d$var$it(a = $37abfb837d2dd31d$var$sn.call(null, t, {
                    "dialog-width": e[1]
                }))
            ], n = !0);
        },
        p (u, d) {
            g && g.p && (!l || 1024 & d) && $37abfb837d2dd31d$var$W(g, c, u, u[10], l ? $37abfb837d2dd31d$var$R(c, u[10], d, null) : $37abfb837d2dd31d$var$Q(u[10]), null), (!l || 1 & d && s !== (s = "s-dialog__content " + u[0])) && $37abfb837d2dd31d$var$b(i, "class", s), 5 & d && $37abfb837d2dd31d$var$y(i, "fullscreen", u[2]), a && $37abfb837d2dd31d$var$F(a.update) && 2 & d && a.update.call(null, {
                "dialog-width": u[1]
            });
        },
        i (u) {
            l || ($37abfb837d2dd31d$var$j(g, u), $37abfb837d2dd31d$var$ot(()=>{
                r || (r = $37abfb837d2dd31d$var$$e(i, e[3], {
                    duration: 300,
                    start: .1
                }, !0)), r.run(1);
            }), l = !0);
        },
        o (u) {
            $37abfb837d2dd31d$var$k(g, u), r || (r = $37abfb837d2dd31d$var$$e(i, e[3], {
                duration: 300,
                start: .1
            }, !1)), r.run(0), l = !1;
        },
        d (u) {
            u && $37abfb837d2dd31d$var$z(t), g && g.d(u), u && r && r.end(), n = !1, $37abfb837d2dd31d$var$U(o);
        }
    };
}
function $37abfb837d2dd31d$var$kn(e) {
    let t, i, s, r = e[5] && $37abfb837d2dd31d$var$Re(e);
    const a = [
        e[4],
        {
            active: e[5]
        }
    ];
    let l = {};
    for(let n = 0; n < a.length; n += 1)l = $37abfb837d2dd31d$var$Dt(l, a[n]);
    return i = new $37abfb837d2dd31d$var$zn({
        props: l
    }), i.$on("click", e[6]), {
        c () {
            r && r.c(), t = $37abfb837d2dd31d$var$_(), $37abfb837d2dd31d$var$J(i.$$.fragment);
        },
        m (n, o) {
            r && r.m(n, o), $37abfb837d2dd31d$var$$(n, t, o), $37abfb837d2dd31d$var$G(i, n, o), s = !0;
        },
        p (n, [o]) {
            n[5] ? r ? (r.p(n, o), 32 & o && $37abfb837d2dd31d$var$j(r, 1)) : (r = $37abfb837d2dd31d$var$Re(n), r.c(), $37abfb837d2dd31d$var$j(r, 1), r.m(t.parentNode, t)) : r && ($37abfb837d2dd31d$var$Mt(), $37abfb837d2dd31d$var$k(r, 1, 1, ()=>{
                r = null;
            }), $37abfb837d2dd31d$var$vt());
            const c = 48 & o ? $37abfb837d2dd31d$var$ke(a, [
                16 & o && (g = n[4], typeof g == "object" && g !== null ? g : {}),
                32 & o && {
                    active: n[5]
                }
            ]) : {};
            var g;
            i.$set(c);
        },
        i (n) {
            s || ($37abfb837d2dd31d$var$j(r), $37abfb837d2dd31d$var$j(i.$$.fragment, n), s = !0);
        },
        o (n) {
            $37abfb837d2dd31d$var$k(r), $37abfb837d2dd31d$var$k(i.$$.fragment, n), s = !1;
        },
        d (n) {
            r && r.d(n), n && $37abfb837d2dd31d$var$z(t), $37abfb837d2dd31d$var$Z(i, n);
        }
    };
}
function $37abfb837d2dd31d$var$Sn(e, t, i) {
    let s, { $$slots: r = {}, $$scope: a } = t, { class: l = "" } = t, { active: n = !1 } = t, { persistent: o = !1 } = t, { disabled: c = !1 } = t, { width: g = 500 } = t, { fullscreen: u = !1 } = t, { transition: d = $37abfb837d2dd31d$var$fn } = t, { overlay: f = {} } = t;
    return e.$$set = (p)=>{
        "class" in p && i(0, l = p.class), "active" in p && i(7, n = p.active), "persistent" in p && i(8, o = p.persistent), "disabled" in p && i(9, c = p.disabled), "width" in p && i(1, g = p.width), "fullscreen" in p && i(2, u = p.fullscreen), "transition" in p && i(3, d = p.transition), "overlay" in p && i(4, f = p.overlay), "$$scope" in p && i(10, a = p.$$scope);
    }, e.$$.update = ()=>{
        640 & e.$$.dirty && i(5, s = n && !c);
    }, [
        l,
        g,
        u,
        d,
        f,
        s,
        function() {
            o || i(7, n = !1);
        },
        n,
        o,
        c,
        a,
        r,
        function(p) {
            $37abfb837d2dd31d$var$rt.call(this, e, p);
        },
        function(p) {
            $37abfb837d2dd31d$var$rt.call(this, e, p);
        },
        function(p) {
            $37abfb837d2dd31d$var$rt.call(this, e, p);
        },
        function(p) {
            $37abfb837d2dd31d$var$rt.call(this, e, p);
        }
    ];
}
class $37abfb837d2dd31d$var$On extends $37abfb837d2dd31d$var$q {
    constructor(t){
        super(), $37abfb837d2dd31d$var$X(this, t, $37abfb837d2dd31d$var$Sn, $37abfb837d2dd31d$var$kn, $37abfb837d2dd31d$var$H, {
            class: 0,
            active: 7,
            persistent: 8,
            disabled: 9,
            width: 1,
            fullscreen: 2,
            transition: 3,
            overlay: 4
        }, $37abfb837d2dd31d$var$$n);
    }
}
function $37abfb837d2dd31d$var$Cn(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-18svewl", ".s-progress-linear.svelte-18svewl.svelte-18svewl{background:transparent;overflow:hidden;position:relative;transition:0.2s cubic-bezier(0.4, 0, 0.6, 1);width:100%;color:var(--theme-text-primary)}.s-progress-linear.inactive.svelte-18svewl.svelte-18svewl{height:0 !important}.s-progress-linear.rounded.svelte-18svewl.svelte-18svewl{border-radius:4px}.s-progress-linear.svelte-18svewl .background.svelte-18svewl,.s-progress-linear.svelte-18svewl .determinate.svelte-18svewl,.s-progress-linear.svelte-18svewl .indeterminate.svelte-18svewl{top:0;bottom:0;position:absolute;transition:inherit}.s-progress-linear.svelte-18svewl .determinate.striped.svelte-18svewl{background-image:linear-gradient(135deg, hsla(0deg, 0%, 100%, 0.25) 25%, transparent 0, transparent 50%, hsla(0deg, 0%, 100%, 0.25) 0, hsla(0deg, 0%, 100%, 0.25) 75%, transparent 0, transparent);background-size:40px 40px;background-repeat:repeat}.s-progress-linear.svelte-18svewl .indeterminate.svelte-18svewl{right:auto;width:auto;will-change:left, right;background-color:inherit;animation-duration:2.2s;animation-iteration-count:infinite}.s-progress-linear.svelte-18svewl .indeterminate.long.svelte-18svewl{animation-name:svelte-18svewl-indeterminate}.s-progress-linear.svelte-18svewl .indeterminate.short.svelte-18svewl{animation-name:svelte-18svewl-indeterminate-short}.s-progress-linear.svelte-18svewl .stream.svelte-18svewl{background:transparent !important;animation:svelte-18svewl-stream 0.25s linear infinite;bottom:0;opacity:0.3;pointer-events:none;position:absolute;border-top:4px dotted;top:calc(50% - 2px);transition:inherit}.s-progress-linear.reversed.svelte-18svewl .background.svelte-18svewl,.s-progress-linear.reversed.svelte-18svewl .determinate.svelte-18svewl,.s-progress-linear.reversed.svelte-18svewl .indeterminate.svelte-18svewl{right:0}.s-progress-linear.reversed.svelte-18svewl .indeterminate.svelte-18svewl{animation-direction:reverse}.s-progress-linear.reversed.svelte-18svewl .stream.svelte-18svewl{right:auto;animation-direction:reverse}.s-progress-linear.svelte-18svewl:not(.reversed) .background.svelte-18svewl,.s-progress-linear.svelte-18svewl:not(.reversed) .determinate.svelte-18svewl,.s-progress-linear.svelte-18svewl:not(.reversed) .indeterminate.svelte-18svewl{left:0}.s-progress-linear.svelte-18svewl:not(.reversed) .stream.svelte-18svewl{left:auto;right:-8px}.s-progress-linear__content.svelte-18svewl.svelte-18svewl{align-items:center;display:flex;height:100%;left:0;justify-content:center;position:absolute;top:0;width:100%;z-index:2;pointer-events:none}@keyframes svelte-18svewl-indeterminate{0%{left:-90%;right:100%}60%{left:-90%;right:100%}to{left:100%;right:-35%}}@keyframes svelte-18svewl-indeterminate-short{0%{left:-200%;right:100%}60%{left:107%;right:-8%}to{left:107%;right:-8%}}@keyframes svelte-18svewl-stream{to{transform:translateX(-8px)}}");
}
function $37abfb837d2dd31d$var$Ln(e) {
    let t, i, s, r;
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("div"), $37abfb837d2dd31d$var$b(t, "class", "determinate svelte-18svewl"), $37abfb837d2dd31d$var$T(t, "width", e[1] + "%"), $37abfb837d2dd31d$var$y(t, "striped", e[12]);
        },
        m (a, l) {
            $37abfb837d2dd31d$var$$(a, t, l), s || (r = $37abfb837d2dd31d$var$it(i = $37abfb837d2dd31d$var$Gt.call(null, t, e[7])), s = !0);
        },
        p (a, l) {
            2 & l && $37abfb837d2dd31d$var$T(t, "width", a[1] + "%"), i && $37abfb837d2dd31d$var$F(i.update) && 128 & l && i.update.call(null, a[7]), 4096 & l && $37abfb837d2dd31d$var$y(t, "striped", a[12]);
        },
        d (a) {
            a && $37abfb837d2dd31d$var$z(t), s = !1, r();
        }
    };
}
function $37abfb837d2dd31d$var$_n(e) {
    let t, i, s, r;
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("div"), t.innerHTML = `<div class="indeterminate long svelte-18svewl"></div> 
      <div class="indeterminate short svelte-18svewl"></div>`;
        },
        m (a, l) {
            $37abfb837d2dd31d$var$$(a, t, l), s || (r = $37abfb837d2dd31d$var$it(i = $37abfb837d2dd31d$var$Gt.call(null, t, e[7])), s = !0);
        },
        p (a, l) {
            i && $37abfb837d2dd31d$var$F(i.update) && 128 & l && i.update.call(null, a[7]);
        },
        d (a) {
            a && $37abfb837d2dd31d$var$z(t), s = !1, r();
        }
    };
}
function $37abfb837d2dd31d$var$We(e) {
    let t, i;
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("div"), $37abfb837d2dd31d$var$b(t, "class", i = "stream " + e[7] + " svelte-18svewl"), $37abfb837d2dd31d$var$T(t, "width", 100 - e[8] + "%");
        },
        m (s, r) {
            $37abfb837d2dd31d$var$$(s, t, r);
        },
        p (s, r) {
            128 & r && i !== (i = "stream " + s[7] + " svelte-18svewl") && $37abfb837d2dd31d$var$b(t, "class", i), 256 & r && $37abfb837d2dd31d$var$T(t, "width", 100 - s[8] + "%");
        },
        d (s) {
            s && $37abfb837d2dd31d$var$z(t);
        }
    };
}
function $37abfb837d2dd31d$var$Tn(e) {
    let t, i, s, r, a, l, n, o, c, g, u, d, f;
    function p(w, A) {
        return w[3] ? $37abfb837d2dd31d$var$_n : $37abfb837d2dd31d$var$Ln;
    }
    let m = p(e), h = m(e);
    const x = e[15].default, N = $37abfb837d2dd31d$var$B(x, e, e[14], null);
    let M = e[10] && $37abfb837d2dd31d$var$We(e);
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("div"), i = $37abfb837d2dd31d$var$S("div"), a = $37abfb837d2dd31d$var$_(), h.c(), l = $37abfb837d2dd31d$var$_(), n = $37abfb837d2dd31d$var$S("div"), N && N.c(), o = $37abfb837d2dd31d$var$_(), M && M.c(), $37abfb837d2dd31d$var$b(i, "class", "background svelte-18svewl"), $37abfb837d2dd31d$var$b(i, "style", s = "opacity:" + e[6] + ";" + (e[9] ? "right" : "left") + ":" + e[1] + "%;width:" + (e[8] - e[1]) + "%"), $37abfb837d2dd31d$var$b(n, "class", "s-progress-linear__content svelte-18svewl"), $37abfb837d2dd31d$var$b(t, "role", "progressbar"), $37abfb837d2dd31d$var$b(t, "aria-valuemin", "0"), $37abfb837d2dd31d$var$b(t, "aria-valuemax", "100"), $37abfb837d2dd31d$var$b(t, "aria-valuenow", e[1]), $37abfb837d2dd31d$var$b(t, "class", c = "s-progress-linear " + e[0] + " svelte-18svewl"), $37abfb837d2dd31d$var$b(t, "style", g = "height:" + e[4] + ";" + e[13]), $37abfb837d2dd31d$var$y(t, "inactive", !e[2]), $37abfb837d2dd31d$var$y(t, "reversed", e[9]), $37abfb837d2dd31d$var$y(t, "rounded", e[11]);
        },
        m (w, A) {
            $37abfb837d2dd31d$var$$(w, t, A), $37abfb837d2dd31d$var$L(t, i), $37abfb837d2dd31d$var$L(t, a), h.m(t, null), $37abfb837d2dd31d$var$L(t, l), $37abfb837d2dd31d$var$L(t, n), N && N.m(n, null), $37abfb837d2dd31d$var$L(t, o), M && M.m(t, null), u = !0, d || (f = $37abfb837d2dd31d$var$it(r = $37abfb837d2dd31d$var$Gt.call(null, i, e[5])), d = !0);
        },
        p (w, [A]) {
            (!u || 834 & A && s !== (s = "opacity:" + w[6] + ";" + (w[9] ? "right" : "left") + ":" + w[1] + "%;width:" + (w[8] - w[1]) + "%")) && $37abfb837d2dd31d$var$b(i, "style", s), r && $37abfb837d2dd31d$var$F(r.update) && 32 & A && r.update.call(null, w[5]), m === (m = p(w)) && h ? h.p(w, A) : (h.d(1), h = m(w), h && (h.c(), h.m(t, l))), N && N.p && (!u || 16384 & A) && $37abfb837d2dd31d$var$W(N, x, w, w[14], u ? $37abfb837d2dd31d$var$R(x, w[14], A, null) : $37abfb837d2dd31d$var$Q(w[14]), null), w[10] ? M ? M.p(w, A) : (M = $37abfb837d2dd31d$var$We(w), M.c(), M.m(t, null)) : M && (M.d(1), M = null), (!u || 2 & A) && $37abfb837d2dd31d$var$b(t, "aria-valuenow", w[1]), (!u || 1 & A && c !== (c = "s-progress-linear " + w[0] + " svelte-18svewl")) && $37abfb837d2dd31d$var$b(t, "class", c), (!u || 8208 & A && g !== (g = "height:" + w[4] + ";" + w[13])) && $37abfb837d2dd31d$var$b(t, "style", g), 5 & A && $37abfb837d2dd31d$var$y(t, "inactive", !w[2]), 513 & A && $37abfb837d2dd31d$var$y(t, "reversed", w[9]), 2049 & A && $37abfb837d2dd31d$var$y(t, "rounded", w[11]);
        },
        i (w) {
            u || ($37abfb837d2dd31d$var$j(N, w), u = !0);
        },
        o (w) {
            $37abfb837d2dd31d$var$k(N, w), u = !1;
        },
        d (w) {
            w && $37abfb837d2dd31d$var$z(t), h.d(), N && N.d(w), M && M.d(), d = !1, f();
        }
    };
}
function $37abfb837d2dd31d$var$Pn(e, t, i) {
    let { $$slots: s = {}, $$scope: r } = t, { class: a = "" } = t, { value: l = 0 } = t, { active: n = !0 } = t, { indeterminate: o = !1 } = t, { height: c = "4px" } = t, { backgroundColor: g = "primary" } = t, { backgroundOpacity: u = .3 } = t, { color: d = g } = t, { buffer: f = 100 } = t, { reversed: p = !1 } = t, { stream: m = !1 } = t, { rounded: h = !1 } = t, { striped: x = !1 } = t, { style: N = "" } = t;
    return e.$$set = (M)=>{
        "class" in M && i(0, a = M.class), "value" in M && i(1, l = M.value), "active" in M && i(2, n = M.active), "indeterminate" in M && i(3, o = M.indeterminate), "height" in M && i(4, c = M.height), "backgroundColor" in M && i(5, g = M.backgroundColor), "backgroundOpacity" in M && i(6, u = M.backgroundOpacity), "color" in M && i(7, d = M.color), "buffer" in M && i(8, f = M.buffer), "reversed" in M && i(9, p = M.reversed), "stream" in M && i(10, m = M.stream), "rounded" in M && i(11, h = M.rounded), "striped" in M && i(12, x = M.striped), "style" in M && i(13, N = M.style), "$$scope" in M && i(14, r = M.$$scope);
    }, [
        a,
        l,
        n,
        o,
        c,
        g,
        u,
        d,
        f,
        p,
        m,
        h,
        x,
        N,
        r,
        s
    ];
}
class $37abfb837d2dd31d$var$En extends $37abfb837d2dd31d$var$q {
    constructor(t){
        super(), $37abfb837d2dd31d$var$X(this, t, $37abfb837d2dd31d$var$Pn, $37abfb837d2dd31d$var$Tn, $37abfb837d2dd31d$var$H, {
            class: 0,
            value: 1,
            active: 2,
            indeterminate: 3,
            height: 4,
            backgroundColor: 5,
            backgroundOpacity: 6,
            color: 7,
            buffer: 8,
            reversed: 9,
            stream: 10,
            rounded: 11,
            striped: 12,
            style: 13
        }, $37abfb837d2dd31d$var$Cn);
    }
}
function $37abfb837d2dd31d$var$Fn(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-14lzzdw", '.s-card{background-color:var(--theme-cards);color:var(--theme-text-primary);display:block;max-width:100%;outline:none;text-decoration:none;transition-property:box-shadow, opacity;overflow-wrap:break-word;position:relative;white-space:normal}.s-card:not(.flat){box-shadow:0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)}.s-card:not(.tile){border-radius:4px}.s-card.outlined{border:thin solid rgba(0, 0, 0, 0.12);box-shadow:0 0 0 0 rgba(0, 0, 0, 0.2), 0 0 0 0 rgba(0, 0, 0, 0.14), 0 0 0 0 rgba(0, 0, 0, 0.12)}.s-card.raised{box-shadow:0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12)}.s-card.shaped{border-radius:24px 4px}.s-card.hover{cursor:pointer;transition:box-shadow 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)}.s-card.hover:focus,.s-card.hover:hover{box-shadow:0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12)}.s-card.link,.s-card.link .s-chip{cursor:pointer}.s-card.link:before{background:currentColor;bottom:0;content:"";left:0;opacity:0;pointer-events:none;position:absolute;right:0;top:0;transition:opacity 0.2s}.s-card.link:focus:before{opacity:0.08}.s-card.disabled{pointer-events:none;user-select:none}.s-card.disabled>:not(.s-progress-linear){opacity:0.6;transition:inherit}.s-card>:first-child:not(.s-btn):not(.s-chip),.s-card>[slot=progress]+:not(.s-btn):not(.s-chip){border-top-left-radius:inherit;border-top-right-radius:inherit}.s-card>:last-child:not(.s-btn):not(.s-chip){border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}');
}
const $37abfb837d2dd31d$var$Bn = (e)=>({}), $37abfb837d2dd31d$var$Qe = (e)=>({});
function $37abfb837d2dd31d$var$Ue(e) {
    let t;
    const i = e[12].progress, s = $37abfb837d2dd31d$var$B(i, e, e[11], $37abfb837d2dd31d$var$Qe), r = s || function(a) {
        let l, n;
        return l = new $37abfb837d2dd31d$var$En({
            props: {
                indeterminate: !0
            }
        }), {
            c () {
                $37abfb837d2dd31d$var$J(l.$$.fragment);
            },
            m (o, c) {
                $37abfb837d2dd31d$var$G(l, o, c), n = !0;
            },
            p: $37abfb837d2dd31d$var$E,
            i (o) {
                n || ($37abfb837d2dd31d$var$j(l.$$.fragment, o), n = !0);
            },
            o (o) {
                $37abfb837d2dd31d$var$k(l.$$.fragment, o), n = !1;
            },
            d (o) {
                $37abfb837d2dd31d$var$Z(l, o);
            }
        };
    }();
    return {
        c () {
            r && r.c();
        },
        m (a, l) {
            r && r.m(a, l), t = !0;
        },
        p (a, l) {
            s && s.p && (!t || 2048 & l) && $37abfb837d2dd31d$var$W(s, i, a, a[11], t ? $37abfb837d2dd31d$var$R(i, a[11], l, $37abfb837d2dd31d$var$Bn) : $37abfb837d2dd31d$var$Q(a[11]), $37abfb837d2dd31d$var$Qe);
        },
        i (a) {
            t || ($37abfb837d2dd31d$var$j(r, a), t = !0);
        },
        o (a) {
            $37abfb837d2dd31d$var$k(r, a), t = !1;
        },
        d (a) {
            r && r.d(a);
        }
    };
}
function $37abfb837d2dd31d$var$Rn(e) {
    let t, i, s, r, a = e[8] && $37abfb837d2dd31d$var$Ue(e);
    const l = e[12].default, n = $37abfb837d2dd31d$var$B(l, e, e[11], null);
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("div"), a && a.c(), i = $37abfb837d2dd31d$var$_(), n && n.c(), $37abfb837d2dd31d$var$b(t, "class", s = "s-card " + e[0]), $37abfb837d2dd31d$var$b(t, "style", e[10]), $37abfb837d2dd31d$var$y(t, "flat", e[1]), $37abfb837d2dd31d$var$y(t, "tile", e[2]), $37abfb837d2dd31d$var$y(t, "outlined", e[3]), $37abfb837d2dd31d$var$y(t, "raised", e[4]), $37abfb837d2dd31d$var$y(t, "shaped", e[5]), $37abfb837d2dd31d$var$y(t, "hover", e[6]), $37abfb837d2dd31d$var$y(t, "link", e[7]), $37abfb837d2dd31d$var$y(t, "disabled", e[9]);
        },
        m (o, c) {
            $37abfb837d2dd31d$var$$(o, t, c), a && a.m(t, null), $37abfb837d2dd31d$var$L(t, i), n && n.m(t, null), r = !0;
        },
        p (o, [c]) {
            o[8] ? a ? (a.p(o, c), 256 & c && $37abfb837d2dd31d$var$j(a, 1)) : (a = $37abfb837d2dd31d$var$Ue(o), a.c(), $37abfb837d2dd31d$var$j(a, 1), a.m(t, i)) : a && ($37abfb837d2dd31d$var$Mt(), $37abfb837d2dd31d$var$k(a, 1, 1, ()=>{
                a = null;
            }), $37abfb837d2dd31d$var$vt()), n && n.p && (!r || 2048 & c) && $37abfb837d2dd31d$var$W(n, l, o, o[11], r ? $37abfb837d2dd31d$var$R(l, o[11], c, null) : $37abfb837d2dd31d$var$Q(o[11]), null), (!r || 1 & c && s !== (s = "s-card " + o[0])) && $37abfb837d2dd31d$var$b(t, "class", s), (!r || 1024 & c) && $37abfb837d2dd31d$var$b(t, "style", o[10]), 3 & c && $37abfb837d2dd31d$var$y(t, "flat", o[1]), 5 & c && $37abfb837d2dd31d$var$y(t, "tile", o[2]), 9 & c && $37abfb837d2dd31d$var$y(t, "outlined", o[3]), 17 & c && $37abfb837d2dd31d$var$y(t, "raised", o[4]), 33 & c && $37abfb837d2dd31d$var$y(t, "shaped", o[5]), 65 & c && $37abfb837d2dd31d$var$y(t, "hover", o[6]), 129 & c && $37abfb837d2dd31d$var$y(t, "link", o[7]), 513 & c && $37abfb837d2dd31d$var$y(t, "disabled", o[9]);
        },
        i (o) {
            r || ($37abfb837d2dd31d$var$j(a), $37abfb837d2dd31d$var$j(n, o), r = !0);
        },
        o (o) {
            $37abfb837d2dd31d$var$k(a), $37abfb837d2dd31d$var$k(n, o), r = !1;
        },
        d (o) {
            o && $37abfb837d2dd31d$var$z(t), a && a.d(), n && n.d(o);
        }
    };
}
function $37abfb837d2dd31d$var$Wn(e, t, i) {
    let { $$slots: s = {}, $$scope: r } = t, { class: a = "" } = t, { flat: l = !1 } = t, { tile: n = !1 } = t, { outlined: o = !1 } = t, { raised: c = !1 } = t, { shaped: g = !1 } = t, { hover: u = !1 } = t, { link: d = !1 } = t, { loading: f = !1 } = t, { disabled: p = !1 } = t, { style: m = null } = t;
    return e.$$set = (h)=>{
        "class" in h && i(0, a = h.class), "flat" in h && i(1, l = h.flat), "tile" in h && i(2, n = h.tile), "outlined" in h && i(3, o = h.outlined), "raised" in h && i(4, c = h.raised), "shaped" in h && i(5, g = h.shaped), "hover" in h && i(6, u = h.hover), "link" in h && i(7, d = h.link), "loading" in h && i(8, f = h.loading), "disabled" in h && i(9, p = h.disabled), "style" in h && i(10, m = h.style), "$$scope" in h && i(11, r = h.$$scope);
    }, [
        a,
        l,
        n,
        o,
        c,
        g,
        u,
        d,
        f,
        p,
        m,
        r,
        s
    ];
}
class $37abfb837d2dd31d$var$Qn extends $37abfb837d2dd31d$var$q {
    constructor(t){
        super(), $37abfb837d2dd31d$var$X(this, t, $37abfb837d2dd31d$var$Wn, $37abfb837d2dd31d$var$Rn, $37abfb837d2dd31d$var$H, {
            class: 0,
            flat: 1,
            tile: 2,
            outlined: 3,
            raised: 4,
            shaped: 5,
            hover: 6,
            link: 7,
            loading: 8,
            disabled: 9,
            style: 10
        }, $37abfb837d2dd31d$var$Fn);
    }
}
function $37abfb837d2dd31d$var$Un(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-eawucv", ".s-card-actions{align-items:center;display:flex;padding:8px}");
}
function $37abfb837d2dd31d$var$Yn(e) {
    let t, i, s;
    const r = e[3].default, a = $37abfb837d2dd31d$var$B(r, e, e[2], null);
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("div"), a && a.c(), $37abfb837d2dd31d$var$b(t, "class", i = "s-card-actions " + e[0]), $37abfb837d2dd31d$var$b(t, "style", e[1]);
        },
        m (l, n) {
            $37abfb837d2dd31d$var$$(l, t, n), a && a.m(t, null), s = !0;
        },
        p (l, [n]) {
            a && a.p && (!s || 4 & n) && $37abfb837d2dd31d$var$W(a, r, l, l[2], s ? $37abfb837d2dd31d$var$R(r, l[2], n, null) : $37abfb837d2dd31d$var$Q(l[2]), null), (!s || 1 & n && i !== (i = "s-card-actions " + l[0])) && $37abfb837d2dd31d$var$b(t, "class", i), (!s || 2 & n) && $37abfb837d2dd31d$var$b(t, "style", l[1]);
        },
        i (l) {
            s || ($37abfb837d2dd31d$var$j(a, l), s = !0);
        },
        o (l) {
            $37abfb837d2dd31d$var$k(a, l), s = !1;
        },
        d (l) {
            l && $37abfb837d2dd31d$var$z(t), a && a.d(l);
        }
    };
}
function $37abfb837d2dd31d$var$Gn(e, t, i) {
    let { $$slots: s = {}, $$scope: r } = t, { class: a = "" } = t, { style: l = null } = t;
    return e.$$set = (n)=>{
        "class" in n && i(0, a = n.class), "style" in n && i(1, l = n.style), "$$scope" in n && i(2, r = n.$$scope);
    }, [
        a,
        l,
        r,
        s
    ];
}
class $37abfb837d2dd31d$var$Zn extends $37abfb837d2dd31d$var$q {
    constructor(t){
        super(), $37abfb837d2dd31d$var$X(this, t, $37abfb837d2dd31d$var$Gn, $37abfb837d2dd31d$var$Yn, $37abfb837d2dd31d$var$H, {
            class: 0,
            style: 1
        }, $37abfb837d2dd31d$var$Un);
    }
}
function $37abfb837d2dd31d$var$Vn(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-2cbqpn", ".s-card-text{width:100%;color:var(--theme-text-secondary);font-size:0.875rem;font-weight:400;line-height:1.375rem;letter-spacing:0.0071428571em;padding:16px}");
}
function $37abfb837d2dd31d$var$Hn(e) {
    let t, i, s;
    const r = e[3].default, a = $37abfb837d2dd31d$var$B(r, e, e[2], null);
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("div"), a && a.c(), $37abfb837d2dd31d$var$b(t, "class", i = "s-card-text " + e[0]), $37abfb837d2dd31d$var$b(t, "style", e[1]);
        },
        m (l, n) {
            $37abfb837d2dd31d$var$$(l, t, n), a && a.m(t, null), s = !0;
        },
        p (l, [n]) {
            a && a.p && (!s || 4 & n) && $37abfb837d2dd31d$var$W(a, r, l, l[2], s ? $37abfb837d2dd31d$var$R(r, l[2], n, null) : $37abfb837d2dd31d$var$Q(l[2]), null), (!s || 1 & n && i !== (i = "s-card-text " + l[0])) && $37abfb837d2dd31d$var$b(t, "class", i), (!s || 2 & n) && $37abfb837d2dd31d$var$b(t, "style", l[1]);
        },
        i (l) {
            s || ($37abfb837d2dd31d$var$j(a, l), s = !0);
        },
        o (l) {
            $37abfb837d2dd31d$var$k(a, l), s = !1;
        },
        d (l) {
            l && $37abfb837d2dd31d$var$z(t), a && a.d(l);
        }
    };
}
function $37abfb837d2dd31d$var$Jn(e, t, i) {
    let { $$slots: s = {}, $$scope: r } = t, { class: a = "" } = t, { style: l = null } = t;
    return e.$$set = (n)=>{
        "class" in n && i(0, a = n.class), "style" in n && i(1, l = n.style), "$$scope" in n && i(2, r = n.$$scope);
    }, [
        a,
        l,
        r,
        s
    ];
}
class $37abfb837d2dd31d$var$Xn extends $37abfb837d2dd31d$var$q {
    constructor(t){
        super(), $37abfb837d2dd31d$var$X(this, t, $37abfb837d2dd31d$var$Jn, $37abfb837d2dd31d$var$Hn, $37abfb837d2dd31d$var$H, {
            class: 0,
            style: 1
        }, $37abfb837d2dd31d$var$Vn);
    }
}
function $37abfb837d2dd31d$var$qn(e) {
    $37abfb837d2dd31d$var$K(e, "svelte-1jn8jdl", ".s-card-title{align-items:center;display:flex;flex-wrap:wrap;font-size:1.25rem;font-weight:500;letter-spacing:0.0125em;line-height:2rem;word-break:break-all;padding:16px}.s-card-title+.s-card-subtitle,.s-card-title+.s-card-title{padding-top:0;margin-top:-16px}.s-card-title+.s-card-subtitle{margin-top:-16px}");
}
function $37abfb837d2dd31d$var$Kn(e) {
    let t, i, s;
    const r = e[3].default, a = $37abfb837d2dd31d$var$B(r, e, e[2], null);
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("div"), a && a.c(), $37abfb837d2dd31d$var$b(t, "class", i = "s-card-title " + e[0]), $37abfb837d2dd31d$var$b(t, "style", e[1]);
        },
        m (l, n) {
            $37abfb837d2dd31d$var$$(l, t, n), a && a.m(t, null), s = !0;
        },
        p (l, [n]) {
            a && a.p && (!s || 4 & n) && $37abfb837d2dd31d$var$W(a, r, l, l[2], s ? $37abfb837d2dd31d$var$R(r, l[2], n, null) : $37abfb837d2dd31d$var$Q(l[2]), null), (!s || 1 & n && i !== (i = "s-card-title " + l[0])) && $37abfb837d2dd31d$var$b(t, "class", i), (!s || 2 & n) && $37abfb837d2dd31d$var$b(t, "style", l[1]);
        },
        i (l) {
            s || ($37abfb837d2dd31d$var$j(a, l), s = !0);
        },
        o (l) {
            $37abfb837d2dd31d$var$k(a, l), s = !1;
        },
        d (l) {
            l && $37abfb837d2dd31d$var$z(t), a && a.d(l);
        }
    };
}
function $37abfb837d2dd31d$var$ti(e, t, i) {
    let { $$slots: s = {}, $$scope: r } = t, { class: a = "" } = t, { style: l = null } = t;
    return e.$$set = (n)=>{
        "class" in n && i(0, a = n.class), "style" in n && i(1, l = n.style), "$$scope" in n && i(2, r = n.$$scope);
    }, [
        a,
        l,
        r,
        s
    ];
}
class $37abfb837d2dd31d$var$Ye extends $37abfb837d2dd31d$var$q {
    constructor(t){
        super(), $37abfb837d2dd31d$var$X(this, t, $37abfb837d2dd31d$var$ti, $37abfb837d2dd31d$var$Kn, $37abfb837d2dd31d$var$H, {
            class: 0,
            style: 1
        }, $37abfb837d2dd31d$var$qn);
    }
}
function $37abfb837d2dd31d$var$ei(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $37abfb837d2dd31d$var$ni = $37abfb837d2dd31d$var$ei(function(e) {
    var t = {};
    function i(s) {
        if (t[s]) return t[s].exports;
        var r = t[s] = {
            i: s,
            l: !1,
            exports: {}
        };
        return e[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
    }
    return i.m = e, i.c = t, i.d = function(s, r, a) {
        i.o(s, r) || Object.defineProperty(s, r, {
            enumerable: !0,
            get: a
        });
    }, i.r = function(s) {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(s, "__esModule", {
            value: !0
        });
    }, i.t = function(s, r) {
        if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
        var a = Object.create(null);
        if (i.r(a), Object.defineProperty(a, "default", {
            enumerable: !0,
            value: s
        }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(n) {
            return s[n];
        }).bind(null, l));
        return a;
    }, i.n = function(s) {
        var r = s && s.__esModule ? function() {
            return s.default;
        } : function() {
            return s;
        };
        return i.d(r, "a", r), r;
    }, i.o = function(s, r) {
        return Object.prototype.hasOwnProperty.call(s, r);
    }, i.p = "", i(i.s = 90);
}({
    17: function(e, t, i) {
        t.__esModule = !0, t.default = void 0;
        var s = i(18), r = function() {
            function a() {}
            return a.getFirstMatch = function(l, n) {
                var o = n.match(l);
                return o && o.length > 0 && o[1] || "";
            }, a.getSecondMatch = function(l, n) {
                var o = n.match(l);
                return o && o.length > 1 && o[2] || "";
            }, a.matchAndReturnConst = function(l, n, o) {
                if (l.test(n)) return o;
            }, a.getWindowsVersionName = function(l) {
                switch(l){
                    case "NT":
                        return "NT";
                    case "XP":
                    case "NT 5.1":
                        return "XP";
                    case "NT 5.0":
                        return "2000";
                    case "NT 5.2":
                        return "2003";
                    case "NT 6.0":
                        return "Vista";
                    case "NT 6.1":
                        return "7";
                    case "NT 6.2":
                        return "8";
                    case "NT 6.3":
                        return "8.1";
                    case "NT 10.0":
                        return "10";
                    default:
                        return;
                }
            }, a.getMacOSVersionName = function(l) {
                var n = l.split(".").splice(0, 2).map(function(o) {
                    return parseInt(o, 10) || 0;
                });
                if (n.push(0), n[0] === 10) switch(n[1]){
                    case 5:
                        return "Leopard";
                    case 6:
                        return "Snow Leopard";
                    case 7:
                        return "Lion";
                    case 8:
                        return "Mountain Lion";
                    case 9:
                        return "Mavericks";
                    case 10:
                        return "Yosemite";
                    case 11:
                        return "El Capitan";
                    case 12:
                        return "Sierra";
                    case 13:
                        return "High Sierra";
                    case 14:
                        return "Mojave";
                    case 15:
                        return "Catalina";
                    default:
                        return;
                }
            }, a.getAndroidVersionName = function(l) {
                var n = l.split(".").splice(0, 2).map(function(o) {
                    return parseInt(o, 10) || 0;
                });
                if (n.push(0), !(n[0] === 1 && n[1] < 5)) return n[0] === 1 && n[1] < 6 ? "Cupcake" : n[0] === 1 && n[1] >= 6 ? "Donut" : n[0] === 2 && n[1] < 2 ? "Eclair" : n[0] === 2 && n[1] === 2 ? "Froyo" : n[0] === 2 && n[1] > 2 ? "Gingerbread" : n[0] === 3 ? "Honeycomb" : n[0] === 4 && n[1] < 1 ? "Ice Cream Sandwich" : n[0] === 4 && n[1] < 4 ? "Jelly Bean" : n[0] === 4 && n[1] >= 4 ? "KitKat" : n[0] === 5 ? "Lollipop" : n[0] === 6 ? "Marshmallow" : n[0] === 7 ? "Nougat" : n[0] === 8 ? "Oreo" : n[0] === 9 ? "Pie" : void 0;
            }, a.getVersionPrecision = function(l) {
                return l.split(".").length;
            }, a.compareVersions = function(l, n, o) {
                o === void 0 && (o = !1);
                var c = a.getVersionPrecision(l), g = a.getVersionPrecision(n), u = Math.max(c, g), d = 0, f = a.map([
                    l,
                    n
                ], function(p) {
                    var m = u - a.getVersionPrecision(p), h = p + new Array(m + 1).join(".0");
                    return a.map(h.split("."), function(x) {
                        return new Array(20 - x.length).join("0") + x;
                    }).reverse();
                });
                for(o && (d = u - Math.min(c, g)), u -= 1; u >= d;){
                    if (f[0][u] > f[1][u]) return 1;
                    if (f[0][u] === f[1][u]) {
                        if (u === d) return 0;
                        u -= 1;
                    } else if (f[0][u] < f[1][u]) return -1;
                }
            }, a.map = function(l, n) {
                var o, c = [];
                if (Array.prototype.map) return Array.prototype.map.call(l, n);
                for(o = 0; o < l.length; o += 1)c.push(n(l[o]));
                return c;
            }, a.find = function(l, n) {
                var o, c;
                if (Array.prototype.find) return Array.prototype.find.call(l, n);
                for(o = 0, c = l.length; o < c; o += 1){
                    var g = l[o];
                    if (n(g, o)) return g;
                }
            }, a.assign = function(l) {
                for(var n, o, c = l, g = arguments.length, u = new Array(g > 1 ? g - 1 : 0), d = 1; d < g; d++)u[d - 1] = arguments[d];
                if (Object.assign) return Object.assign.apply(Object, [
                    l
                ].concat(u));
                var f = function() {
                    var p = u[n];
                    typeof p == "object" && p !== null && Object.keys(p).forEach(function(m) {
                        c[m] = p[m];
                    });
                };
                for(n = 0, o = u.length; n < o; n += 1)f();
                return l;
            }, a.getBrowserAlias = function(l) {
                return s.BROWSER_ALIASES_MAP[l];
            }, a.getBrowserTypeByAlias = function(l) {
                return s.BROWSER_MAP[l] || "";
            }, a;
        }();
        t.default = r, e.exports = t.default;
    },
    18: function(e, t, i) {
        t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0, t.BROWSER_ALIASES_MAP = {
            "Amazon Silk": "amazon_silk",
            "Android Browser": "android",
            Bada: "bada",
            BlackBerry: "blackberry",
            Chrome: "chrome",
            Chromium: "chromium",
            Electron: "electron",
            Epiphany: "epiphany",
            Firefox: "firefox",
            Focus: "focus",
            Generic: "generic",
            "Google Search": "google_search",
            Googlebot: "googlebot",
            "Internet Explorer": "ie",
            "K-Meleon": "k_meleon",
            Maxthon: "maxthon",
            "Microsoft Edge": "edge",
            "MZ Browser": "mz",
            "NAVER Whale Browser": "naver",
            Opera: "opera",
            "Opera Coast": "opera_coast",
            PhantomJS: "phantomjs",
            Puffin: "puffin",
            QupZilla: "qupzilla",
            QQ: "qq",
            QQLite: "qqlite",
            Safari: "safari",
            Sailfish: "sailfish",
            "Samsung Internet for Android": "samsung_internet",
            SeaMonkey: "seamonkey",
            Sleipnir: "sleipnir",
            Swing: "swing",
            Tizen: "tizen",
            "UC Browser": "uc",
            Vivaldi: "vivaldi",
            "WebOS Browser": "webos",
            WeChat: "wechat",
            "Yandex Browser": "yandex",
            Roku: "roku"
        }, t.BROWSER_MAP = {
            amazon_silk: "Amazon Silk",
            android: "Android Browser",
            bada: "Bada",
            blackberry: "BlackBerry",
            chrome: "Chrome",
            chromium: "Chromium",
            electron: "Electron",
            epiphany: "Epiphany",
            firefox: "Firefox",
            focus: "Focus",
            generic: "Generic",
            googlebot: "Googlebot",
            google_search: "Google Search",
            ie: "Internet Explorer",
            k_meleon: "K-Meleon",
            maxthon: "Maxthon",
            edge: "Microsoft Edge",
            mz: "MZ Browser",
            naver: "NAVER Whale Browser",
            opera: "Opera",
            opera_coast: "Opera Coast",
            phantomjs: "PhantomJS",
            puffin: "Puffin",
            qupzilla: "QupZilla",
            qq: "QQ Browser",
            qqlite: "QQ Browser Lite",
            safari: "Safari",
            sailfish: "Sailfish",
            samsung_internet: "Samsung Internet for Android",
            seamonkey: "SeaMonkey",
            sleipnir: "Sleipnir",
            swing: "Swing",
            tizen: "Tizen",
            uc: "UC Browser",
            vivaldi: "Vivaldi",
            webos: "WebOS Browser",
            wechat: "WeChat",
            yandex: "Yandex Browser"
        }, t.PLATFORMS_MAP = {
            tablet: "tablet",
            mobile: "mobile",
            desktop: "desktop",
            tv: "tv"
        }, t.OS_MAP = {
            WindowsPhone: "Windows Phone",
            Windows: "Windows",
            MacOS: "macOS",
            iOS: "iOS",
            Android: "Android",
            WebOS: "WebOS",
            BlackBerry: "BlackBerry",
            Bada: "Bada",
            Tizen: "Tizen",
            Linux: "Linux",
            ChromeOS: "Chrome OS",
            PlayStation4: "PlayStation 4",
            Roku: "Roku"
        }, t.ENGINE_MAP = {
            EdgeHTML: "EdgeHTML",
            Blink: "Blink",
            Trident: "Trident",
            Presto: "Presto",
            Gecko: "Gecko",
            WebKit: "WebKit"
        };
    },
    90: function(e, t, i) {
        t.__esModule = !0, t.default = void 0;
        var s, r = (s = i(91)) && s.__esModule ? s : {
            default: s
        }, a = i(18);
        function l(o, c) {
            for(var g = 0; g < c.length; g++){
                var u = c[g];
                u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(o, u.key, u);
            }
        }
        var n = function() {
            function o() {}
            var c, g, u;
            return o.getParser = function(d, f) {
                if (f === void 0 && (f = !1), typeof d != "string") throw new Error("UserAgent should be a string");
                return new r.default(d, f);
            }, o.parse = function(d) {
                return new r.default(d).getResult();
            }, c = o, u = [
                {
                    key: "BROWSER_MAP",
                    get: function() {
                        return a.BROWSER_MAP;
                    }
                },
                {
                    key: "ENGINE_MAP",
                    get: function() {
                        return a.ENGINE_MAP;
                    }
                },
                {
                    key: "OS_MAP",
                    get: function() {
                        return a.OS_MAP;
                    }
                },
                {
                    key: "PLATFORMS_MAP",
                    get: function() {
                        return a.PLATFORMS_MAP;
                    }
                }
            ], g = null, u && l(c, u), o;
        }();
        t.default = n, e.exports = t.default;
    },
    91: function(e, t, i) {
        t.__esModule = !0, t.default = void 0;
        var s = o(i(92)), r = o(i(93)), a = o(i(94)), l = o(i(95)), n = o(i(17));
        function o(g) {
            return g && g.__esModule ? g : {
                default: g
            };
        }
        var c = function() {
            function g(d, f) {
                if (f === void 0 && (f = !1), d == null || d === "") throw new Error("UserAgent parameter can't be empty");
                this._ua = d, this.parsedResult = {}, f !== !0 && this.parse();
            }
            var u = g.prototype;
            return u.getUA = function() {
                return this._ua;
            }, u.test = function(d) {
                return d.test(this._ua);
            }, u.parseBrowser = function() {
                var d = this;
                this.parsedResult.browser = {};
                var f = n.default.find(s.default, function(p) {
                    if (typeof p.test == "function") return p.test(d);
                    if (p.test instanceof Array) return p.test.some(function(m) {
                        return d.test(m);
                    });
                    throw new Error("Browser's test function is not valid");
                });
                return f && (this.parsedResult.browser = f.describe(this.getUA())), this.parsedResult.browser;
            }, u.getBrowser = function() {
                return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
            }, u.getBrowserName = function(d) {
                return d ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
            }, u.getBrowserVersion = function() {
                return this.getBrowser().version;
            }, u.getOS = function() {
                return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
            }, u.parseOS = function() {
                var d = this;
                this.parsedResult.os = {};
                var f = n.default.find(r.default, function(p) {
                    if (typeof p.test == "function") return p.test(d);
                    if (p.test instanceof Array) return p.test.some(function(m) {
                        return d.test(m);
                    });
                    throw new Error("Browser's test function is not valid");
                });
                return f && (this.parsedResult.os = f.describe(this.getUA())), this.parsedResult.os;
            }, u.getOSName = function(d) {
                var f = this.getOS().name;
                return d ? String(f).toLowerCase() || "" : f || "";
            }, u.getOSVersion = function() {
                return this.getOS().version;
            }, u.getPlatform = function() {
                return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
            }, u.getPlatformType = function(d) {
                d === void 0 && (d = !1);
                var f = this.getPlatform().type;
                return d ? String(f).toLowerCase() || "" : f || "";
            }, u.parsePlatform = function() {
                var d = this;
                this.parsedResult.platform = {};
                var f = n.default.find(a.default, function(p) {
                    if (typeof p.test == "function") return p.test(d);
                    if (p.test instanceof Array) return p.test.some(function(m) {
                        return d.test(m);
                    });
                    throw new Error("Browser's test function is not valid");
                });
                return f && (this.parsedResult.platform = f.describe(this.getUA())), this.parsedResult.platform;
            }, u.getEngine = function() {
                return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
            }, u.getEngineName = function(d) {
                return d ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
            }, u.parseEngine = function() {
                var d = this;
                this.parsedResult.engine = {};
                var f = n.default.find(l.default, function(p) {
                    if (typeof p.test == "function") return p.test(d);
                    if (p.test instanceof Array) return p.test.some(function(m) {
                        return d.test(m);
                    });
                    throw new Error("Browser's test function is not valid");
                });
                return f && (this.parsedResult.engine = f.describe(this.getUA())), this.parsedResult.engine;
            }, u.parse = function() {
                return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
            }, u.getResult = function() {
                return n.default.assign({}, this.parsedResult);
            }, u.satisfies = function(d) {
                var f = this, p = {}, m = 0, h = {}, x = 0;
                if (Object.keys(d).forEach(function(D) {
                    var P = d[D];
                    typeof P == "string" ? (h[D] = P, x += 1) : typeof P == "object" && (p[D] = P, m += 1);
                }), m > 0) {
                    var N = Object.keys(p), M = n.default.find(N, function(D) {
                        return f.isOS(D);
                    });
                    if (M) {
                        var w = this.satisfies(p[M]);
                        if (w !== void 0) return w;
                    }
                    var A = n.default.find(N, function(D) {
                        return f.isPlatform(D);
                    });
                    if (A) {
                        var C = this.satisfies(p[A]);
                        if (C !== void 0) return C;
                    }
                }
                if (x > 0) {
                    var O = Object.keys(h), v = n.default.find(O, function(D) {
                        return f.isBrowser(D, !0);
                    });
                    if (v !== void 0) return this.compareVersion(h[v]);
                }
            }, u.isBrowser = function(d, f) {
                f === void 0 && (f = !1);
                var p = this.getBrowserName().toLowerCase(), m = d.toLowerCase(), h = n.default.getBrowserTypeByAlias(m);
                return f && h && (m = h.toLowerCase()), m === p;
            }, u.compareVersion = function(d) {
                var f = [
                    0
                ], p = d, m = !1, h = this.getBrowserVersion();
                if (typeof h == "string") return d[0] === ">" || d[0] === "<" ? (p = d.substr(1), d[1] === "=" ? (m = !0, p = d.substr(2)) : f = [], d[0] === ">" ? f.push(1) : f.push(-1)) : d[0] === "=" ? p = d.substr(1) : d[0] === "~" && (m = !0, p = d.substr(1)), f.indexOf(n.default.compareVersions(h, p, m)) > -1;
            }, u.isOS = function(d) {
                return this.getOSName(!0) === String(d).toLowerCase();
            }, u.isPlatform = function(d) {
                return this.getPlatformType(!0) === String(d).toLowerCase();
            }, u.isEngine = function(d) {
                return this.getEngineName(!0) === String(d).toLowerCase();
            }, u.is = function(d, f) {
                return f === void 0 && (f = !1), this.isBrowser(d, f) || this.isOS(d) || this.isPlatform(d);
            }, u.some = function(d) {
                var f = this;
                return d === void 0 && (d = []), d.some(function(p) {
                    return f.is(p);
                });
            }, g;
        }();
        t.default = c, e.exports = t.default;
    },
    92: function(e, t, i) {
        t.__esModule = !0, t.default = void 0;
        var s, r = (s = i(17)) && s.__esModule ? s : {
            default: s
        }, a = /version\/(\d+(\.?_?\d+)+)/i, l = [
            {
                test: [
                    /googlebot/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Googlebot"
                    }, c = r.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /opera/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Opera"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /opr\/|opios/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Opera"
                    }, c = r.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /SamsungBrowser/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Samsung Internet for Android"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /Whale/i
                ],
                describe: function(n) {
                    var o = {
                        name: "NAVER Whale Browser"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /MZBrowser/i
                ],
                describe: function(n) {
                    var o = {
                        name: "MZ Browser"
                    }, c = r.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /focus/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Focus"
                    }, c = r.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /swing/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Swing"
                    }, c = r.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /coast/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Opera Coast"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /opt\/\d+(?:.?_?\d+)+/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Opera Touch"
                    }, c = r.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /yabrowser/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Yandex Browser"
                    }, c = r.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /ucbrowser/i
                ],
                describe: function(n) {
                    var o = {
                        name: "UC Browser"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /Maxthon|mxios/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Maxthon"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /epiphany/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Epiphany"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /puffin/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Puffin"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /sleipnir/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Sleipnir"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /k-meleon/i
                ],
                describe: function(n) {
                    var o = {
                        name: "K-Meleon"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /micromessenger/i
                ],
                describe: function(n) {
                    var o = {
                        name: "WeChat"
                    }, c = r.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /qqbrowser/i
                ],
                describe: function(n) {
                    var o = {
                        name: /qqbrowserlite/i.test(n) ? "QQ Browser Lite" : "QQ Browser"
                    }, c = r.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /msie|trident/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Internet Explorer"
                    }, c = r.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /\sedg\//i
                ],
                describe: function(n) {
                    var o = {
                        name: "Microsoft Edge"
                    }, c = r.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /edg([ea]|ios)/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Microsoft Edge"
                    }, c = r.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /vivaldi/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Vivaldi"
                    }, c = r.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /seamonkey/i
                ],
                describe: function(n) {
                    var o = {
                        name: "SeaMonkey"
                    }, c = r.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /sailfish/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Sailfish"
                    }, c = r.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /silk/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Amazon Silk"
                    }, c = r.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /phantom/i
                ],
                describe: function(n) {
                    var o = {
                        name: "PhantomJS"
                    }, c = r.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /slimerjs/i
                ],
                describe: function(n) {
                    var o = {
                        name: "SlimerJS"
                    }, c = r.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /blackberry|\bbb\d+/i,
                    /rim\stablet/i
                ],
                describe: function(n) {
                    var o = {
                        name: "BlackBerry"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /(web|hpw)[o0]s/i
                ],
                describe: function(n) {
                    var o = {
                        name: "WebOS Browser"
                    }, c = r.default.getFirstMatch(a, n) || r.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /bada/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Bada"
                    }, c = r.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /tizen/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Tizen"
                    }, c = r.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /qupzilla/i
                ],
                describe: function(n) {
                    var o = {
                        name: "QupZilla"
                    }, c = r.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /firefox|iceweasel|fxios/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Firefox"
                    }, c = r.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /electron/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Electron"
                    }, c = r.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /MiuiBrowser/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Miui"
                    }, c = r.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /chromium/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Chromium"
                    }, c = r.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, n) || r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /chrome|crios|crmo/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Chrome"
                    }, c = r.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /GSA/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Google Search"
                    }, c = r.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: function(n) {
                    var o = !n.test(/like android/i), c = n.test(/android/i);
                    return o && c;
                },
                describe: function(n) {
                    var o = {
                        name: "Android Browser"
                    }, c = r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /playstation 4/i
                ],
                describe: function(n) {
                    var o = {
                        name: "PlayStation 4"
                    }, c = r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /safari|applewebkit/i
                ],
                describe: function(n) {
                    var o = {
                        name: "Safari"
                    }, c = r.default.getFirstMatch(a, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /.*/i
                ],
                describe: function(n) {
                    var o = n.search("\\(") !== -1 ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                    return {
                        name: r.default.getFirstMatch(o, n),
                        version: r.default.getSecondMatch(o, n)
                    };
                }
            }
        ];
        t.default = l, e.exports = t.default;
    },
    93: function(e, t, i) {
        t.__esModule = !0, t.default = void 0;
        var s, r = (s = i(17)) && s.__esModule ? s : {
            default: s
        }, a = i(18), l = [
            {
                test: [
                    /Roku\/DVP/
                ],
                describe: function(n) {
                    var o = r.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, n);
                    return {
                        name: a.OS_MAP.Roku,
                        version: o
                    };
                }
            },
            {
                test: [
                    /windows phone/i
                ],
                describe: function(n) {
                    var o = r.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, n);
                    return {
                        name: a.OS_MAP.WindowsPhone,
                        version: o
                    };
                }
            },
            {
                test: [
                    /windows /i
                ],
                describe: function(n) {
                    var o = r.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, n), c = r.default.getWindowsVersionName(o);
                    return {
                        name: a.OS_MAP.Windows,
                        version: o,
                        versionName: c
                    };
                }
            },
            {
                test: [
                    /Macintosh(.*?) FxiOS(.*?)\//
                ],
                describe: function(n) {
                    var o = {
                        name: a.OS_MAP.iOS
                    }, c = r.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /macintosh/i
                ],
                describe: function(n) {
                    var o = r.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, n).replace(/[_\s]/g, "."), c = r.default.getMacOSVersionName(o), g = {
                        name: a.OS_MAP.MacOS,
                        version: o
                    };
                    return c && (g.versionName = c), g;
                }
            },
            {
                test: [
                    /(ipod|iphone|ipad)/i
                ],
                describe: function(n) {
                    var o = r.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, n).replace(/[_\s]/g, ".");
                    return {
                        name: a.OS_MAP.iOS,
                        version: o
                    };
                }
            },
            {
                test: function(n) {
                    var o = !n.test(/like android/i), c = n.test(/android/i);
                    return o && c;
                },
                describe: function(n) {
                    var o = r.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, n), c = r.default.getAndroidVersionName(o), g = {
                        name: a.OS_MAP.Android,
                        version: o
                    };
                    return c && (g.versionName = c), g;
                }
            },
            {
                test: [
                    /(web|hpw)[o0]s/i
                ],
                describe: function(n) {
                    var o = r.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, n), c = {
                        name: a.OS_MAP.WebOS
                    };
                    return o && o.length && (c.version = o), c;
                }
            },
            {
                test: [
                    /blackberry|\bbb\d+/i,
                    /rim\stablet/i
                ],
                describe: function(n) {
                    var o = r.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, n) || r.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, n) || r.default.getFirstMatch(/\bbb(\d+)/i, n);
                    return {
                        name: a.OS_MAP.BlackBerry,
                        version: o
                    };
                }
            },
            {
                test: [
                    /bada/i
                ],
                describe: function(n) {
                    var o = r.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, n);
                    return {
                        name: a.OS_MAP.Bada,
                        version: o
                    };
                }
            },
            {
                test: [
                    /tizen/i
                ],
                describe: function(n) {
                    var o = r.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, n);
                    return {
                        name: a.OS_MAP.Tizen,
                        version: o
                    };
                }
            },
            {
                test: [
                    /linux/i
                ],
                describe: function() {
                    return {
                        name: a.OS_MAP.Linux
                    };
                }
            },
            {
                test: [
                    /CrOS/
                ],
                describe: function() {
                    return {
                        name: a.OS_MAP.ChromeOS
                    };
                }
            },
            {
                test: [
                    /PlayStation 4/
                ],
                describe: function(n) {
                    var o = r.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, n);
                    return {
                        name: a.OS_MAP.PlayStation4,
                        version: o
                    };
                }
            }
        ];
        t.default = l, e.exports = t.default;
    },
    94: function(e, t, i) {
        t.__esModule = !0, t.default = void 0;
        var s, r = (s = i(17)) && s.__esModule ? s : {
            default: s
        }, a = i(18), l = [
            {
                test: [
                    /googlebot/i
                ],
                describe: function() {
                    return {
                        type: "bot",
                        vendor: "Google"
                    };
                }
            },
            {
                test: [
                    /huawei/i
                ],
                describe: function(n) {
                    var o = r.default.getFirstMatch(/(can-l01)/i, n) && "Nova", c = {
                        type: a.PLATFORMS_MAP.mobile,
                        vendor: "Huawei"
                    };
                    return o && (c.model = o), c;
                }
            },
            {
                test: [
                    /nexus\s*(?:7|8|9|10).*/i
                ],
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.tablet,
                        vendor: "Nexus"
                    };
                }
            },
            {
                test: [
                    /ipad/i
                ],
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.tablet,
                        vendor: "Apple",
                        model: "iPad"
                    };
                }
            },
            {
                test: [
                    /Macintosh(.*?) FxiOS(.*?)\//
                ],
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.tablet,
                        vendor: "Apple",
                        model: "iPad"
                    };
                }
            },
            {
                test: [
                    /kftt build/i
                ],
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.tablet,
                        vendor: "Amazon",
                        model: "Kindle Fire HD 7"
                    };
                }
            },
            {
                test: [
                    /silk/i
                ],
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.tablet,
                        vendor: "Amazon"
                    };
                }
            },
            {
                test: [
                    /tablet(?! pc)/i
                ],
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.tablet
                    };
                }
            },
            {
                test: function(n) {
                    var o = n.test(/ipod|iphone/i), c = n.test(/like (ipod|iphone)/i);
                    return o && !c;
                },
                describe: function(n) {
                    var o = r.default.getFirstMatch(/(ipod|iphone)/i, n);
                    return {
                        type: a.PLATFORMS_MAP.mobile,
                        vendor: "Apple",
                        model: o
                    };
                }
            },
            {
                test: [
                    /nexus\s*[0-6].*/i,
                    /galaxy nexus/i
                ],
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.mobile,
                        vendor: "Nexus"
                    };
                }
            },
            {
                test: [
                    /[^-]mobi/i
                ],
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.mobile
                    };
                }
            },
            {
                test: function(n) {
                    return n.getBrowserName(!0) === "blackberry";
                },
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.mobile,
                        vendor: "BlackBerry"
                    };
                }
            },
            {
                test: function(n) {
                    return n.getBrowserName(!0) === "bada";
                },
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.mobile
                    };
                }
            },
            {
                test: function(n) {
                    return n.getBrowserName() === "windows phone";
                },
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.mobile,
                        vendor: "Microsoft"
                    };
                }
            },
            {
                test: function(n) {
                    var o = Number(String(n.getOSVersion()).split(".")[0]);
                    return n.getOSName(!0) === "android" && o >= 3;
                },
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.tablet
                    };
                }
            },
            {
                test: function(n) {
                    return n.getOSName(!0) === "android";
                },
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.mobile
                    };
                }
            },
            {
                test: function(n) {
                    return n.getOSName(!0) === "macos";
                },
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.desktop,
                        vendor: "Apple"
                    };
                }
            },
            {
                test: function(n) {
                    return n.getOSName(!0) === "windows";
                },
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.desktop
                    };
                }
            },
            {
                test: function(n) {
                    return n.getOSName(!0) === "linux";
                },
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.desktop
                    };
                }
            },
            {
                test: function(n) {
                    return n.getOSName(!0) === "playstation 4";
                },
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.tv
                    };
                }
            },
            {
                test: function(n) {
                    return n.getOSName(!0) === "roku";
                },
                describe: function() {
                    return {
                        type: a.PLATFORMS_MAP.tv
                    };
                }
            }
        ];
        t.default = l, e.exports = t.default;
    },
    95: function(e, t, i) {
        t.__esModule = !0, t.default = void 0;
        var s, r = (s = i(17)) && s.__esModule ? s : {
            default: s
        }, a = i(18), l = [
            {
                test: function(n) {
                    return n.getBrowserName(!0) === "microsoft edge";
                },
                describe: function(n) {
                    if (/\sedg\//i.test(n)) return {
                        name: a.ENGINE_MAP.Blink
                    };
                    var o = r.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, n);
                    return {
                        name: a.ENGINE_MAP.EdgeHTML,
                        version: o
                    };
                }
            },
            {
                test: [
                    /trident/i
                ],
                describe: function(n) {
                    var o = {
                        name: a.ENGINE_MAP.Trident
                    }, c = r.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: function(n) {
                    return n.test(/presto/i);
                },
                describe: function(n) {
                    var o = {
                        name: a.ENGINE_MAP.Presto
                    }, c = r.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: function(n) {
                    var o = n.test(/gecko/i), c = n.test(/like gecko/i);
                    return o && !c;
                },
                describe: function(n) {
                    var o = {
                        name: a.ENGINE_MAP.Gecko
                    }, c = r.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            },
            {
                test: [
                    /(apple)?webkit\/537\.36/i
                ],
                describe: function() {
                    return {
                        name: a.ENGINE_MAP.Blink
                    };
                }
            },
            {
                test: [
                    /(apple)?webkit/i
                ],
                describe: function(n) {
                    var o = {
                        name: a.ENGINE_MAP.WebKit
                    }, c = r.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, n);
                    return c && (o.version = c), o;
                }
            }
        ];
        t.default = l, e.exports = t.default;
    }
}));
function $37abfb837d2dd31d$var$Ge(e, t, i) {
    const s = e.slice();
    return s[22] = t[i], s[24] = i, s;
}
function $37abfb837d2dd31d$var$ii(e) {
    let t, i;
    return t = new $37abfb837d2dd31d$var$Ye({
        props: {
            style: "display: flex; justify-content: space-between; align-items: center; color: " + e[7],
            $$slots: {
                default: [
                    $37abfb837d2dd31d$var$ri
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), {
        c () {
            $37abfb837d2dd31d$var$J(t.$$.fragment);
        },
        m (s, r) {
            $37abfb837d2dd31d$var$G(t, s, r), i = !0;
        },
        p (s, r) {
            const a = {};
            33554441 & r && (a.$$scope = {
                dirty: r,
                ctx: s
            }), t.$set(a);
        },
        i (s) {
            i || ($37abfb837d2dd31d$var$j(t.$$.fragment, s), i = !0);
        },
        o (s) {
            $37abfb837d2dd31d$var$k(t.$$.fragment, s), i = !1;
        },
        d (s) {
            $37abfb837d2dd31d$var$Z(t, s);
        }
    };
}
function $37abfb837d2dd31d$var$si(e) {
    let t, i;
    return t = new $37abfb837d2dd31d$var$Ye({
        props: {
            style: "display: flex; justify-content: flex-start; align-items: center; color: " + e[7],
            $$slots: {
                default: [
                    $37abfb837d2dd31d$var$oi
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), {
        c () {
            $37abfb837d2dd31d$var$J(t.$$.fragment);
        },
        m (s, r) {
            $37abfb837d2dd31d$var$G(t, s, r), i = !0;
        },
        p (s, r) {
            const a = {};
            33554457 & r && (a.$$scope = {
                dirty: r,
                ctx: s
            }), t.$set(a);
        },
        i (s) {
            i || ($37abfb837d2dd31d$var$j(t.$$.fragment, s), i = !0);
        },
        o (s) {
            $37abfb837d2dd31d$var$k(t.$$.fragment, s), i = !1;
        },
        d (s) {
            $37abfb837d2dd31d$var$Z(t, s);
        }
    };
}
function $37abfb837d2dd31d$var$ri(e) {
    let t, i, s, r, a, l;
    return {
        c () {
            t = $37abfb837d2dd31d$var$st($37abfb837d2dd31d$var$wi), i = $37abfb837d2dd31d$var$_(), s = $37abfb837d2dd31d$var$S("img"), $37abfb837d2dd31d$var$b(s, "alt", "Close"), $37abfb837d2dd31d$var$T(s, "cursor", "pointer"), $37abfb837d2dd31d$var$T(s, "filter", e[9]), $37abfb837d2dd31d$var$lt(s.src, r = $37abfb837d2dd31d$var$Ve) || $37abfb837d2dd31d$var$b(s, "src", r);
        },
        m (n, o) {
            $37abfb837d2dd31d$var$$(n, t, o), $37abfb837d2dd31d$var$$(n, i, o), $37abfb837d2dd31d$var$$(n, s, o), a || (l = $37abfb837d2dd31d$var$Y(s, "click", e[16]), a = !0);
        },
        p: $37abfb837d2dd31d$var$E,
        d (n) {
            n && $37abfb837d2dd31d$var$z(t), n && $37abfb837d2dd31d$var$z(i), n && $37abfb837d2dd31d$var$z(s), a = !1, l();
        }
    };
}
function $37abfb837d2dd31d$var$oi(e) {
    let t, i, s, r, a, l, n, o, c, g, u, d, f, p = e[4].name + "";
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("img"), i = $37abfb837d2dd31d$var$_(), s = $37abfb837d2dd31d$var$S("img"), l = $37abfb837d2dd31d$var$_(), n = $37abfb837d2dd31d$var$S("div"), o = $37abfb837d2dd31d$var$st(p), c = $37abfb837d2dd31d$var$_(), g = $37abfb837d2dd31d$var$S("img"), $37abfb837d2dd31d$var$b(t, "alt", "Back"), $37abfb837d2dd31d$var$T(t, "cursor", "pointer"), $37abfb837d2dd31d$var$T(t, "filter", e[9]), $37abfb837d2dd31d$var$lt(t.src, "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTIwIDExSDcuODNsNS41OS01LjU5TDEyIDRsLTggOCA4IDggMS40MS0xLjQxTDcuODMgMTNIMjB2LTJ6Ii8+PC9zdmc+") || $37abfb837d2dd31d$var$b(t, "src", "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTIwIDExSDcuODNsNS41OS01LjU5TDEyIDRsLTggOCA4IDggMS40MS0xLjQxTDcuODMgMTNIMjB2LTJ6Ii8+PC9zdmc+"), $37abfb837d2dd31d$var$T(s, "margin-inline-start", "10px"), $37abfb837d2dd31d$var$b(s, "width", "24px"), $37abfb837d2dd31d$var$lt(s.src, r = e[4].icon) || $37abfb837d2dd31d$var$b(s, "src", r), $37abfb837d2dd31d$var$b(s, "alt", a = e[4].name + " logo"), $37abfb837d2dd31d$var$T(n, "flex-grow", "1"), $37abfb837d2dd31d$var$T(n, "margin-inline-start", "4px"), $37abfb837d2dd31d$var$b(g, "alt", "Close"), $37abfb837d2dd31d$var$T(g, "cursor", "pointer"), $37abfb837d2dd31d$var$T(g, "filter", e[9]), $37abfb837d2dd31d$var$lt(g.src, u = $37abfb837d2dd31d$var$Ve) || $37abfb837d2dd31d$var$b(g, "src", u);
        },
        m (m, h) {
            $37abfb837d2dd31d$var$$(m, t, h), $37abfb837d2dd31d$var$$(m, i, h), $37abfb837d2dd31d$var$$(m, s, h), $37abfb837d2dd31d$var$$(m, l, h), $37abfb837d2dd31d$var$$(m, n, h), $37abfb837d2dd31d$var$L(n, o), $37abfb837d2dd31d$var$$(m, c, h), $37abfb837d2dd31d$var$$(m, g, h), d || (f = [
                $37abfb837d2dd31d$var$Y(t, "click", e[14]),
                $37abfb837d2dd31d$var$Y(g, "click", e[15])
            ], d = !0);
        },
        p (m, h) {
            16 & h && !$37abfb837d2dd31d$var$lt(s.src, r = m[4].icon) && $37abfb837d2dd31d$var$b(s, "src", r), 16 & h && a !== (a = m[4].name + " logo") && $37abfb837d2dd31d$var$b(s, "alt", a), 16 & h && p !== (p = m[4].name + "") && $37abfb837d2dd31d$var$je(o, p);
        },
        d (m) {
            m && $37abfb837d2dd31d$var$z(t), m && $37abfb837d2dd31d$var$z(i), m && $37abfb837d2dd31d$var$z(s), m && $37abfb837d2dd31d$var$z(l), m && $37abfb837d2dd31d$var$z(n), m && $37abfb837d2dd31d$var$z(c), m && $37abfb837d2dd31d$var$z(g), d = !1, $37abfb837d2dd31d$var$U(f);
        }
    };
}
function $37abfb837d2dd31d$var$ai(e) {
    let t;
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("div"), t.textContent = `No compatible wallets found for ${e[10]}`;
        },
        m (i, s) {
            $37abfb837d2dd31d$var$$(i, t, s);
        },
        p: $37abfb837d2dd31d$var$E,
        i: $37abfb837d2dd31d$var$E,
        o: $37abfb837d2dd31d$var$E,
        d (i) {
            i && $37abfb837d2dd31d$var$z(t);
        }
    };
}
function $37abfb837d2dd31d$var$li(e) {
    let t, i;
    return t = new $37abfb837d2dd31d$var$mn({
        props: {
            style: "margin-inline-start: 24px; margin-inline-end: 24px",
            $$slots: {
                default: [
                    $37abfb837d2dd31d$var$gi
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), {
        c () {
            $37abfb837d2dd31d$var$J(t.$$.fragment);
        },
        m (s, r) {
            $37abfb837d2dd31d$var$G(t, s, r), i = !0;
        },
        p (s, r) {
            const a = {};
            33554463 & r && (a.$$scope = {
                dirty: r,
                ctx: s
            }), t.$set(a);
        },
        i (s) {
            i || ($37abfb837d2dd31d$var$j(t.$$.fragment, s), i = !0);
        },
        o (s) {
            $37abfb837d2dd31d$var$k(t.$$.fragment, s), i = !1;
        },
        d (s) {
            $37abfb837d2dd31d$var$Z(t, s);
        }
    };
}
function $37abfb837d2dd31d$var$ci(e) {
    let t, i, s, r;
    return t = new $37abfb837d2dd31d$var$Xn({
        props: {
            style: "margin-top: 12px; font-size: 0.92rem; color: " + e[7] + "; width: auto",
            $$slots: {
                default: [
                    $37abfb837d2dd31d$var$hi
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), s = new $37abfb837d2dd31d$var$Zn({
        props: {
            style: "justify-content: flex-end; margin-inline-end: 16px",
            $$slots: {
                default: [
                    $37abfb837d2dd31d$var$Mi
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), {
        c () {
            $37abfb837d2dd31d$var$J(t.$$.fragment), i = $37abfb837d2dd31d$var$_(), $37abfb837d2dd31d$var$J(s.$$.fragment);
        },
        m (a, l) {
            $37abfb837d2dd31d$var$G(t, a, l), $37abfb837d2dd31d$var$$(a, i, l), $37abfb837d2dd31d$var$G(s, a, l), r = !0;
        },
        p (a, l) {
            const n = {};
            33554432 & l && (n.$$scope = {
                dirty: l,
                ctx: a
            }), t.$set(n);
            const o = {};
            33554457 & l && (o.$$scope = {
                dirty: l,
                ctx: a
            }), s.$set(o);
        },
        i (a) {
            r || ($37abfb837d2dd31d$var$j(t.$$.fragment, a), $37abfb837d2dd31d$var$j(s.$$.fragment, a), r = !0);
        },
        o (a) {
            $37abfb837d2dd31d$var$k(t.$$.fragment, a), $37abfb837d2dd31d$var$k(s.$$.fragment, a), r = !1;
        },
        d (a) {
            $37abfb837d2dd31d$var$Z(t, a), a && $37abfb837d2dd31d$var$z(i), $37abfb837d2dd31d$var$Z(s, a);
        }
    };
}
function $37abfb837d2dd31d$var$di(e) {
    let t, i, s, r = e[24] >= e[1].length ? "Install " : "", a = (e[22].name || "Injected") + "";
    return {
        c () {
            t = $37abfb837d2dd31d$var$st(r), i = $37abfb837d2dd31d$var$st(a), s = $37abfb837d2dd31d$var$_();
        },
        m (l, n) {
            $37abfb837d2dd31d$var$$(l, t, n), $37abfb837d2dd31d$var$$(l, i, n), $37abfb837d2dd31d$var$$(l, s, n);
        },
        p (l, n) {
            2 & n && r !== (r = l[24] >= l[1].length ? "Install " : "") && $37abfb837d2dd31d$var$je(t, r);
        },
        d (l) {
            l && $37abfb837d2dd31d$var$z(t), l && $37abfb837d2dd31d$var$z(i), l && $37abfb837d2dd31d$var$z(s);
        }
    };
}
function $37abfb837d2dd31d$var$ui(e) {
    let t;
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("img"), $37abfb837d2dd31d$var$b(t, "alt", (e[22].name || "Injected") + " logo"), $37abfb837d2dd31d$var$T(t, "filter", e[9]), $37abfb837d2dd31d$var$lt(t.src, "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDI0IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0cHgiIGZpbGw9IiMwMDAwMDAiPjxnPjxyZWN0IGZpbGw9Im5vbmUiIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIvPjwvZz48Zz48cGF0aCBkPSJNMTEuMDcsMTIuODVjMC43Ny0xLjM5LDIuMjUtMi4yMSwzLjExLTMuNDRjMC45MS0xLjI5LDAuNC0zLjctMi4xOC0zLjdjLTEuNjksMC0yLjUyLDEuMjgtMi44NywyLjM0TDYuNTQsNi45NiBDNy4yNSw0LjgzLDkuMTgsMywxMS45OSwzYzIuMzUsMCwzLjk2LDEuMDcsNC43OCwyLjQxYzAuNywxLjE1LDEuMTEsMy4zLDAuMDMsNC45Yy0xLjIsMS43Ny0yLjM1LDIuMzEtMi45NywzLjQ1IGMtMC4yNSwwLjQ2LTAuMzUsMC43Ni0wLjM1LDIuMjRoLTIuODlDMTAuNTgsMTUuMjIsMTAuNDYsMTMuOTUsMTEuMDcsMTIuODV6IE0xNCwyMGMwLDEuMS0wLjksMi0yLDJzLTItMC45LTItMmMwLTEuMSwwLjktMiwyLTIgUzE0LDE4LjksMTQsMjB6Ii8+PC9nPjwvc3ZnPg==") || $37abfb837d2dd31d$var$b(t, "src", "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDI0IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0cHgiIGZpbGw9IiMwMDAwMDAiPjxnPjxyZWN0IGZpbGw9Im5vbmUiIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIvPjwvZz48Zz48cGF0aCBkPSJNMTEuMDcsMTIuODVjMC43Ny0xLjM5LDIuMjUtMi4yMSwzLjExLTMuNDRjMC45MS0xLjI5LDAuNC0zLjctMi4xOC0zLjdjLTEuNjksMC0yLjUyLDEuMjgtMi44NywyLjM0TDYuNTQsNi45NiBDNy4yNSw0LjgzLDkuMTgsMywxMS45OSwzYzIuMzUsMCwzLjk2LDEuMDcsNC43OCwyLjQxYzAuNywxLjE1LDEuMTEsMy4zLDAuMDMsNC45Yy0xLjIsMS43Ny0yLjM1LDIuMzEtMi45NywzLjQ1IGMtMC4yNSwwLjQ2LTAuMzUsMC43Ni0wLjM1LDIuMjRoLTIuODlDMTAuNTgsMTUuMjIsMTAuNDYsMTMuOTUsMTEuMDcsMTIuODV6IE0xNCwyMGMwLDEuMS0wLjksMi0yLDJzLTItMC45LTItMmMwLTEuMSwwLjktMiwyLTIgUzE0LDE4LjksMTQsMjB6Ii8+PC9nPjwvc3ZnPg==");
        },
        m (i, s) {
            $37abfb837d2dd31d$var$$(i, t, s);
        },
        p: $37abfb837d2dd31d$var$E,
        d (i) {
            i && $37abfb837d2dd31d$var$z(t);
        }
    };
}
function $37abfb837d2dd31d$var$fi(e) {
    let t, i;
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("img"), $37abfb837d2dd31d$var$b(t, "width", "32px"), $37abfb837d2dd31d$var$lt(t.src, i = e[22].icon) || $37abfb837d2dd31d$var$b(t, "src", i), $37abfb837d2dd31d$var$b(t, "alt", e[22].name + " logo");
        },
        m (s, r) {
            $37abfb837d2dd31d$var$$(s, t, r);
        },
        p: $37abfb837d2dd31d$var$E,
        d (s) {
            s && $37abfb837d2dd31d$var$z(t);
        }
    };
}
function $37abfb837d2dd31d$var$pi(e) {
    let t, i, s = function(a, l) {
        return a[22].icon ? $37abfb837d2dd31d$var$fi : $37abfb837d2dd31d$var$ui;
    }(e), r = s(e);
    return {
        c () {
            t = $37abfb837d2dd31d$var$S("span"), r.c(), i = $37abfb837d2dd31d$var$_(), $37abfb837d2dd31d$var$b(t, "slot", "append");
        },
        m (a, l) {
            $37abfb837d2dd31d$var$$(a, t, l), r.m(t, null), $37abfb837d2dd31d$var$L(t, i);
        },
        p (a, l) {
            r.p(a, l);
        },
        d (a) {
            a && $37abfb837d2dd31d$var$z(t), r.d();
        }
    };
}
function $37abfb837d2dd31d$var$Ze(e) {
    let t, i;
    return t = new $37abfb837d2dd31d$var$In({
        props: {
            style: `
                            border: 1px solid ` + e[8] + `;
                            /* use same border-radius as dialog's */
                            border-radius: 4px;
                            height: 58px;
                            background: ` + e[6] + `;
                            margin-bottom: 10px;
                            color: ` + e[7] + `;
                        `,
            $$slots: {
                append: [
                    $37abfb837d2dd31d$var$pi
                ],
                default: [
                    $37abfb837d2dd31d$var$di
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), t.$on("click", function() {
        return e[18](e[24], e[22]);
    }), {
        c () {
            $37abfb837d2dd31d$var$J(t.$$.fragment);
        },
        m (s, r) {
            $37abfb837d2dd31d$var$G(t, s, r), i = !0;
        },
        p (s, r) {
            e = s;
            const a = {};
            33554434 & r && (a.$$scope = {
                dirty: r,
                ctx: e
            }), t.$set(a);
        },
        i (s) {
            i || ($37abfb837d2dd31d$var$j(t.$$.fragment, s), i = !0);
        },
        o (s) {
            $37abfb837d2dd31d$var$k(t.$$.fragment, s), i = !1;
        },
        d (s) {
            $37abfb837d2dd31d$var$Z(t, s);
        }
    };
}
function $37abfb837d2dd31d$var$gi(e) {
    let t, i, s = e[11], r = [];
    for(let l = 0; l < s.length; l += 1)r[l] = $37abfb837d2dd31d$var$Ze($37abfb837d2dd31d$var$Ge(e, s, l));
    const a = (l)=>$37abfb837d2dd31d$var$k(r[l], 1, 1, ()=>{
            r[l] = null;
        });
    return {
        c () {
            for(let l = 0; l < r.length; l += 1)r[l].c();
            t = $37abfb837d2dd31d$var$ne();
        },
        m (l, n) {
            for(let o = 0; o < r.length; o += 1)r[o].m(l, n);
            $37abfb837d2dd31d$var$$(l, t, n), i = !0;
        },
        p (l, n) {
            if (3039 & n) {
                let o;
                for(s = l[11], o = 0; o < s.length; o += 1){
                    const c = $37abfb837d2dd31d$var$Ge(l, s, o);
                    r[o] ? (r[o].p(c, n), $37abfb837d2dd31d$var$j(r[o], 1)) : (r[o] = $37abfb837d2dd31d$var$Ze(c), r[o].c(), $37abfb837d2dd31d$var$j(r[o], 1), r[o].m(t.parentNode, t));
                }
                for($37abfb837d2dd31d$var$Mt(), o = s.length; o < r.length; o += 1)a(o);
                $37abfb837d2dd31d$var$vt();
            }
        },
        i (l) {
            if (!i) {
                for(let n = 0; n < s.length; n += 1)$37abfb837d2dd31d$var$j(r[n]);
                i = !0;
            }
        },
        o (l) {
            r = r.filter(Boolean);
            for(let n = 0; n < r.length; n += 1)$37abfb837d2dd31d$var$k(r[n]);
            i = !1;
        },
        d (l) {
            (function(n, o) {
                for(let c = 0; c < n.length; c += 1)n[c] && n[c].d(o);
            })(r, l), l && $37abfb837d2dd31d$var$z(t);
        }
    };
}
function $37abfb837d2dd31d$var$hi(e) {
    let t;
    return {
        c () {
            t = $37abfb837d2dd31d$var$st("Click the REFRESH button after installing and setting up the new wallet.");
        },
        m (i, s) {
            $37abfb837d2dd31d$var$$(i, t, s);
        },
        d (i) {
            i && $37abfb837d2dd31d$var$z(t);
        }
    };
}
function $37abfb837d2dd31d$var$mi(e) {
    let t;
    return {
        c () {
            t = $37abfb837d2dd31d$var$st("Refresh");
        },
        m (i, s) {
            $37abfb837d2dd31d$var$$(i, t, s);
        },
        d (i) {
            i && $37abfb837d2dd31d$var$z(t);
        }
    };
}
function $37abfb837d2dd31d$var$Mi(e) {
    let t, i;
    return t = new $37abfb837d2dd31d$var$ln({
        props: {
            style: "margin-bottom: 12px; border: 1px solid " + e[7] + "; color: " + e[7] + ";",
            outlined: !0,
            $$slots: {
                default: [
                    $37abfb837d2dd31d$var$mi
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), t.$on("click", e[17]), {
        c () {
            $37abfb837d2dd31d$var$J(t.$$.fragment);
        },
        m (s, r) {
            $37abfb837d2dd31d$var$G(t, s, r), i = !0;
        },
        p (s, r) {
            const a = {};
            33554432 & r && (a.$$scope = {
                dirty: r,
                ctx: s
            }), t.$set(a);
        },
        i (s) {
            i || ($37abfb837d2dd31d$var$j(t.$$.fragment, s), i = !0);
        },
        o (s) {
            $37abfb837d2dd31d$var$k(t.$$.fragment, s), i = !1;
        },
        d (s) {
            $37abfb837d2dd31d$var$Z(t, s);
        }
    };
}
function $37abfb837d2dd31d$var$vi(e) {
    let t, i, s, r, a, l, n;
    const o = [
        $37abfb837d2dd31d$var$si,
        $37abfb837d2dd31d$var$ii
    ], c = [];
    function g(p, m) {
        return p[4] ? 0 : 1;
    }
    t = g(e), i = c[t] = o[t](e);
    const u = [
        $37abfb837d2dd31d$var$ci,
        $37abfb837d2dd31d$var$li,
        $37abfb837d2dd31d$var$ai
    ], d = [];
    function f(p, m) {
        return p[4] ? 0 : p[11].length ? 1 : 2;
    }
    return r = f(e), a = d[r] = u[r](e), {
        c () {
            i.c(), s = $37abfb837d2dd31d$var$_(), a.c(), l = $37abfb837d2dd31d$var$ne();
        },
        m (p, m) {
            c[t].m(p, m), $37abfb837d2dd31d$var$$(p, s, m), d[r].m(p, m), $37abfb837d2dd31d$var$$(p, l, m), n = !0;
        },
        p (p, m) {
            let h = t;
            t = g(p), t === h ? c[t].p(p, m) : ($37abfb837d2dd31d$var$Mt(), $37abfb837d2dd31d$var$k(c[h], 1, 1, ()=>{
                c[h] = null;
            }), $37abfb837d2dd31d$var$vt(), i = c[t], i ? i.p(p, m) : (i = c[t] = o[t](p), i.c()), $37abfb837d2dd31d$var$j(i, 1), i.m(s.parentNode, s));
            let x = r;
            r = f(p), r === x ? d[r].p(p, m) : ($37abfb837d2dd31d$var$Mt(), $37abfb837d2dd31d$var$k(d[x], 1, 1, ()=>{
                d[x] = null;
            }), $37abfb837d2dd31d$var$vt(), a = d[r], a ? a.p(p, m) : (a = d[r] = u[r](p), a.c()), $37abfb837d2dd31d$var$j(a, 1), a.m(l.parentNode, l));
        },
        i (p) {
            n || ($37abfb837d2dd31d$var$j(i), $37abfb837d2dd31d$var$j(a), n = !0);
        },
        o (p) {
            $37abfb837d2dd31d$var$k(i), $37abfb837d2dd31d$var$k(a), n = !1;
        },
        d (p) {
            c[t].d(p), p && $37abfb837d2dd31d$var$z(s), d[r].d(p), p && $37abfb837d2dd31d$var$z(l);
        }
    };
}
function $37abfb837d2dd31d$var$bi(e) {
    let t, i;
    return t = new $37abfb837d2dd31d$var$Qn({
        props: {
            style: "background: " + e[5],
            $$slots: {
                default: [
                    $37abfb837d2dd31d$var$vi
                ]
            },
            $$scope: {
                ctx: e
            }
        }
    }), {
        c () {
            $37abfb837d2dd31d$var$J(t.$$.fragment);
        },
        m (s, r) {
            $37abfb837d2dd31d$var$G(t, s, r), i = !0;
        },
        p (s, r) {
            const a = {};
            33554463 & r && (a.$$scope = {
                dirty: r,
                ctx: s
            }), t.$set(a);
        },
        i (s) {
            i || ($37abfb837d2dd31d$var$j(t.$$.fragment, s), i = !0);
        },
        o (s) {
            $37abfb837d2dd31d$var$k(t.$$.fragment, s), i = !1;
        },
        d (s) {
            $37abfb837d2dd31d$var$Z(t, s);
        }
    };
}
function $37abfb837d2dd31d$var$yi(e) {
    let t, i, s;
    function r(l) {
        e[19](l);
    }
    let a = {
        persistent: !0,
        $$slots: {
            default: [
                $37abfb837d2dd31d$var$bi
            ]
        },
        $$scope: {
            ctx: e
        }
    };
    return e[3] !== void 0 && (a.active = e[3]), t = new $37abfb837d2dd31d$var$On({
        props: a
    }), $37abfb837d2dd31d$var$Wt.push(()=>(function(l, n, o) {
            const c = l.$$.props[n];
            c !== void 0 && (l.$$.bound[c] = o, o(l.$$.ctx[c]));
        })(t, "active", r)), {
        c () {
            $37abfb837d2dd31d$var$J(t.$$.fragment);
        },
        m (l, n) {
            $37abfb837d2dd31d$var$G(t, l, n), s = !0;
        },
        p (l, [n]) {
            const o = {};
            var c;
            33554463 & n && (o.$$scope = {
                dirty: n,
                ctx: l
            }), !i && 8 & n && (i = !0, o.active = l[3], c = ()=>i = !1, $37abfb837d2dd31d$var$ie.push(c)), t.$set(o);
        },
        i (l) {
            s || ($37abfb837d2dd31d$var$j(t.$$.fragment, l), s = !0);
        },
        o (l) {
            $37abfb837d2dd31d$var$k(t.$$.fragment, l), s = !1;
        },
        d (l) {
            $37abfb837d2dd31d$var$Z(t, l);
        }
    };
}
const $37abfb837d2dd31d$var$wi = "Connect a wallet", $37abfb837d2dd31d$var$Ve = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTE5IDYuNDFMMTcuNTkgNSAxMiAxMC41OSA2LjQxIDUgNSA2LjQxIDEwLjU5IDEyIDUgMTcuNTkgNi40MSAxOSAxMiAxMy40MSAxNy41OSAxOSAxOSAxNy41OSAxMy40MSAxMiAxOSA2LjQxeiIvPjwvc3ZnPg==";
function $37abfb837d2dd31d$var$xi(e, t, i) {
    var s;
    let { callback: r = ()=>{} } = t, { installed: a = [] } = t, { discovery: l = [] } = t, { options: n = {} } = t;
    const o = (n === null || n === void 0 ? void 0 : n.theme) || "light", c = o === "light" ? "#fff" : "#333", g = o === "light" ? "#e9e9e9" : "#555", u = o === "light" ? "#000" : "#f7f7f7", d = o === "light" ? "#99999950" : "#aaaaaa30", f = o === "light" ? "unset" : "invert(1)", p = (s = $37abfb837d2dd31d$var$ni.getParser(window.navigator.userAgent).getBrowser().name) === null || s === void 0 ? void 0 : s.toLowerCase();
    let m;
    switch(p){
        case "chrome":
        case "chromium":
        case "electron":
            m = "chrome";
            break;
        case "firefox":
            m = "firefox";
            break;
        case "microsoft edge":
            m = "edge";
    }
    const h = m ? [
        ...a,
        ...l.filter((M)=>!!M.downloads[m] || m === "edge" && !!M.downloads.chrome)
    ] : a;
    let x, N = !0;
    return e.$$set = (M)=>{
        "callback" in M && i(0, r = M.callback), "installed" in M && i(1, a = M.installed), "discovery" in M && i(12, l = M.discovery), "options" in M && i(13, n = M.options);
    }, [
        r,
        a,
        m,
        N,
        x,
        c,
        g,
        u,
        d,
        f,
        p,
        h,
        l,
        n,
        ()=>i(4, x = void 0),
        ()=>{
            r(x), i(3, N = !1);
        },
        ()=>{
            r(void 0), i(3, N = !1);
        },
        ()=>{
            r(x), i(3, N = !1), window.location.reload();
        },
        (M, w)=>{
            if (M < a.length) r(w), i(3, N = !1);
            else {
                const A = w.downloads[m] || m === "edge" && w.downloads.chrome;
                if (!A) return;
                window.open(A, "_blank"), i(4, x = h[M]);
            }
        },
        function(M) {
            N = M, i(3, N);
        }
    ];
}
class $37abfb837d2dd31d$var$Ii extends $37abfb837d2dd31d$var$q {
    constructor(t){
        super(), $37abfb837d2dd31d$var$X(this, t, $37abfb837d2dd31d$var$xi, $37abfb837d2dd31d$var$yi, $37abfb837d2dd31d$var$H, {
            callback: 0,
            installed: 1,
            discovery: 12,
            options: 13
        });
    }
}
var $37abfb837d2dd31d$var$dt, $37abfb837d2dd31d$var$V, $37abfb837d2dd31d$var$bt, $37abfb837d2dd31d$var$yt, $37abfb837d2dd31d$var$Ct, $37abfb837d2dd31d$var$ce, $37abfb837d2dd31d$var$wt;
$37abfb837d2dd31d$var$V = new WeakMap, $37abfb837d2dd31d$var$yt = new WeakMap, $37abfb837d2dd31d$var$Ct = new WeakMap, $37abfb837d2dd31d$var$ce = new WeakMap, $37abfb837d2dd31d$var$wt = new WeakMap, $37abfb837d2dd31d$var$dt = new WeakSet, $37abfb837d2dd31d$var$bt = function() {
    return !!$37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$V, "f").current;
};
const $37abfb837d2dd31d$var$Zt = new class {
    constructor(){
        $37abfb837d2dd31d$var$dt.add(this), $37abfb837d2dd31d$var$V.set(this, {}), this.connect = (e)=>$37abfb837d2dd31d$var$Nt(this, void 0, void 0, function*() {
                try {
                    $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$wt, "f").call(this);
                    const t = $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$dt, "m", $37abfb837d2dd31d$var$bt).call(this), { installed: i, preAuthorized: s, defaultWallet: r, lastWallet: a } = yield $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$Ct, "f").call(this, e);
                    if ((e === null || e === void 0 ? void 0 : e.showList) === !1) {
                        const n = s[0];
                        return n ? $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$yt, "f").call(this, n) : void 0;
                    }
                    if (!(t || (e === null || e === void 0 ? void 0 : e.showList) || !a)) {
                        for (const n of [
                            r,
                            a
                        ])if (n) return $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$yt, "f").call(this, n);
                        if (i.length === 1) return $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$yt, "f").call(this, i[0]);
                    }
                    const l = yield function(n, o) {
                        return $37abfb837d2dd31d$var$Nt(this, void 0, void 0, function*() {
                            const c = new Set(n.map((u)=>u.id));
                            let g = $37abfb837d2dd31d$var$pe.filter((u)=>!c.has(u.id));
                            return g = $37abfb837d2dd31d$var$he(g, o), g = $37abfb837d2dd31d$var$ge(g, o === null || o === void 0 ? void 0 : o.order), new Promise((u)=>{
                                const d = new $37abfb837d2dd31d$var$Ii({
                                    target: document.body,
                                    props: {
                                        callback: (f)=>{
                                            d.$destroy(), u(f);
                                        },
                                        installed: n,
                                        discovery: g,
                                        options: o === null || o === void 0 ? void 0 : o.modalOptions
                                    }
                                });
                            });
                        });
                    }(i, e);
                    return $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$yt, "f").call(this, l);
                } catch  {}
            }), this.disconnect = (e)=>{
            $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$wt, "f").call(this);
            const t = $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$dt, "m", $37abfb837d2dd31d$var$bt).call(this);
            return $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$V, "f").current = void 0, (e === null || e === void 0 ? void 0 : e.clearLastWallet) && $37abfb837d2dd31d$var$_t.delete(), (e === null || e === void 0 ? void 0 : e.clearDefaultWallet) && $37abfb837d2dd31d$var$Xt.delete(), t;
        }, this.getStarknet = ()=>{
            var e, t, i, s, r;
            $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$wt, "f").call(this);
            const a = this;
            return (e = $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$V, "f").current) !== null && e !== void 0 ? e : new (r = class {
                constructor(){
                    this.id = "disconnected", this.name = "Disconnected", this.icon = "", this.selectedAddress = void 0, this.provider = $37abfb837d2dd31d$var$Ht.defaultProvider, this.isConnected = !1, this.account = new $37abfb837d2dd31d$var$Ht.Account($37abfb837d2dd31d$var$Ht.defaultProvider, "", {}), this.version = "", this.signer = void 0, t.set(this, {}), this.enable = (l)=>$37abfb837d2dd31d$var$Nt(this, void 0, void 0, function*() {
                            try {
                                const n = yield $37abfb837d2dd31d$var$I(this, i, "f").call(this, {
                                    showList: l === null || l === void 0 ? void 0 : l.showModal
                                });
                                if (n) {
                                    const o = yield n.enable();
                                    return $37abfb837d2dd31d$var$I(this, s, "f").call(this, n), o;
                                }
                            } catch  {}
                            return [];
                        }), this.isPreauthorized = ()=>$37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$dt, "m", $37abfb837d2dd31d$var$bt).call(a) ? $37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$V, "f").current.isPreauthorized() : $37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$Ct, "f").call(a).then((l)=>!!l.preAuthorized.length), this.off = (l, n)=>{
                        var o;
                        $37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$dt, "m", $37abfb837d2dd31d$var$bt).call(a) ? (o = $37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$V, "f").current) === null || o === void 0 || o.off(l, n) : $37abfb837d2dd31d$var$I(this, t, "f")[l] && ($37abfb837d2dd31d$var$I(this, t, "f")[l] = $37abfb837d2dd31d$var$I(this, t, "f")[l].filter((c)=>c !== n));
                    }, this.on = (l, n)=>{
                        var o, c;
                        if ($37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$dt, "m", $37abfb837d2dd31d$var$bt).call(a)) (o = $37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$V, "f").current) === null || o === void 0 || o.on(l, n);
                        else {
                            const g = (c = $37abfb837d2dd31d$var$I(this, t, "f")[l]) !== null && c !== void 0 ? c : $37abfb837d2dd31d$var$I(this, t, "f")[l] = [];
                            g.includes(n) || g.push(n);
                        }
                    }, this.request = (l)=>$37abfb837d2dd31d$var$Nt(this, void 0, void 0, function*() {
                            const n = $37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$V, "f").current;
                            if (!n) throw new Error("can't request a disconnected wallet");
                            return n.request(l);
                        }), i.set(this, (l)=>($37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$V, "f").current ? Promise.resolve($37abfb837d2dd31d$var$I(a, $37abfb837d2dd31d$var$V, "f").current) : a.connect(l)).then((n)=>(n && (this.id = n.id, this.name = n.name, this.icon = n.icon, this.version = n.version, $37abfb837d2dd31d$var$I(this, s, "f").call(this, n), Object.entries($37abfb837d2dd31d$var$I(this, t, "f")).forEach(([o, c])=>c.forEach((g)=>n.on(o, g))), $37abfb837d2dd31d$var$At(this, t, {}, "f")), n))), s.set(this, (l)=>{
                        l && (this.selectedAddress = l.selectedAddress, this.provider = l.provider, this.isConnected = l.isConnected, this.account = l.account, this.signer = l.signer);
                    });
                }
            }, t = new WeakMap, i = new WeakMap, s = new WeakMap, r);
        }, this.getInstalledWallets = (e)=>$37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$Ct, "f").call(this, e).then((t)=>t.installed), $37abfb837d2dd31d$var$yt.set(this, (e)=>($37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$V, "f").current = e, e && $37abfb837d2dd31d$var$_t.set(e.id), e)), $37abfb837d2dd31d$var$Ct.set(this, (e)=>$37abfb837d2dd31d$var$Nt(this, void 0, void 0, function*() {
                yield $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$ce, "f").call(this);
                const t = Object.values(Object.getOwnPropertyNames(window).reduce((n, o)=>{
                    if (o.startsWith("starknet")) {
                        const c = window[o];
                        ((g, u)=>{
                            try {
                                if (u && [
                                    "request",
                                    "isConnected",
                                    "provider",
                                    "enable",
                                    "isPreauthorized",
                                    "on",
                                    "off",
                                    "version"
                                ].every((d)=>d in u)) {
                                    if (!(g !== "starknet" || u.id && u.name && u.icon)) try {
                                        const d = $37abfb837d2dd31d$var$pe.find((f)=>f.id === "argentX");
                                        d && (u.id = d.id, u.name = d.name, u.icon = d.icon);
                                    } catch  {}
                                    return [
                                        "id",
                                        "name",
                                        "icon"
                                    ].every((d)=>d in u);
                                }
                            } catch  {}
                            return !1;
                        })(o, c) && !n[c.id] && (n[c.id] = c);
                    }
                    return n;
                }, {})), i = t.find((n)=>n.id === $37abfb837d2dd31d$var$Xt.get());
                i || $37abfb837d2dd31d$var$Xt.delete();
                const s = t.find((n)=>n.id === $37abfb837d2dd31d$var$_t.get());
                s || $37abfb837d2dd31d$var$_t.delete();
                const r = $37abfb837d2dd31d$var$Jt((yield ((n)=>Promise.all(n.map((o)=>o.isPreauthorized().then((c)=>c ? o : void 0).catch(()=>{}))).then((o)=>o.filter((c)=>!!c)))(t))), a = (n)=>([
                        s,
                        i
                    ].forEach((o)=>{
                        if (o) {
                            const c = n.filter((g)=>g.id !== o.id);
                            c.length !== n.length && (n = [
                                o,
                                ...c
                            ]);
                        }
                    }), n), l = {
                    installed: a(t),
                    preAuthorized: a(r),
                    defaultWallet: i,
                    lastWallet: s
                };
                if (l.installed = $37abfb837d2dd31d$var$he(l.installed, e), l.installed = $37abfb837d2dd31d$var$ge(l.installed, e === null || e === void 0 ? void 0 : e.order), !(e && Array.isArray(e.order))) {
                    const n = new Set(r.map((o)=>o.id));
                    l.installed = l.installed.filter((o)=>!n.has(o.id)), l.installed = [
                        ...r,
                        ...l.installed
                    ], l.installed = a(l.installed);
                }
                return l;
            })), $37abfb837d2dd31d$var$ce.set(this, ()=>{
            const e = ()=>document.readyState === "complete";
            return new Promise((t)=>{
                if (e()) t();
                else {
                    const i = setInterval(()=>{
                        e() && (clearInterval(i), t());
                    }, 50);
                }
            });
        }), $37abfb837d2dd31d$var$wt.set(this, ()=>{
            typeof window < "u" && (window.gsw = !0);
        }), $37abfb837d2dd31d$var$I(this, $37abfb837d2dd31d$var$wt, "f").call(this);
    }
}, $37abfb837d2dd31d$var$Ni = $37abfb837d2dd31d$var$Zt.getStarknet, $37abfb837d2dd31d$var$Ai = $37abfb837d2dd31d$var$Zt.connect, $37abfb837d2dd31d$var$ji = $37abfb837d2dd31d$var$Zt.disconnect, $37abfb837d2dd31d$var$Di = $37abfb837d2dd31d$var$Zt.getInstalledWallets;
$37abfb837d2dd31d$var$fe = $37abfb837d2dd31d$var$It.connect = $37abfb837d2dd31d$var$Ai, $37abfb837d2dd31d$export$37dfea93db2e14ed = $37abfb837d2dd31d$var$It.disconnect = $37abfb837d2dd31d$var$ji, $37abfb837d2dd31d$var$It.getInstalledWallets = $37abfb837d2dd31d$var$Di, $37abfb837d2dd31d$var$ue = $37abfb837d2dd31d$var$It.getStarknet = $37abfb837d2dd31d$var$Ni;
const $37abfb837d2dd31d$var$zi = ()=>{
    const e = $37abfb837d2dd31d$var$ue();
    return e.enable = async (t)=>{
        var _this;
        return ((_this = await $37abfb837d2dd31d$var$He({
            showList: t === null || t === void 0 ? void 0 : t.showModal
        })) === null || _this === void 0 ? void 0 : _this.enable(t)) || [];
    }, e;
}, $37abfb837d2dd31d$var$He = (e)=>$37abfb837d2dd31d$var$fe({
        order: [
            "argentX"
        ],
        ...e
    });
$37abfb837d2dd31d$export$64605811ab45167f = $37abfb837d2dd31d$var$He, $37abfb837d2dd31d$export$b5c0cdb6e6d5b23c = $37abfb837d2dd31d$var$zi;


const $855eec528252b37a$export$5359a20ca62641f = ()=>{
    const [prices, setPrices] = (0, $6cds3.useState)((0, $429f470a166ef670$export$19d7d19559261303));
    const [starknet, setStarknet] = (0, $6cds3.useState)(undefined);
    const [walletAddress, setWalletAddress] = (0, $6cds3.useState)("");
    const [_, setIsConnecting] = (0, $6cds3.useState)(false);
    const connectWallet = async ()=>{
        setPrices((0, $429f470a166ef670$export$19d7d19559261303));
        if (starknet) return;
        setIsConnecting(true);
        setStarknet(undefined);
        const newStarknet = await (0, $37abfb837d2dd31d$export$64605811ab45167f)();
        if (!newStarknet) return setIsConnecting(false);
        try {
            const [address] = await newStarknet.enable();
            if (!newStarknet.isConnected) return setIsConnecting(false);
            setWalletAddress(address);
            setIsConnecting(false);
            addListeners(newStarknet);
            return setStarknet(newStarknet);
        } catch (error) {
            console.error(error);
        } finally{
            setIsConnecting(false);
        }
    };
    const addListeners = (starknet)=>{
        starknet.on("accountsChanged", ()=>{
            window.location.reload();
        });
        starknet.on("networkChanged", ()=>{
            window.location.reload();
        });
    };
    return {
        prices: prices,
        setPrices: setPrices,
        starknet: starknet,
        connectWallet: connectWallet,
        walletAddress: walletAddress
    };
};









var $dxWQo = parcelRequire("dxWQo");

var $lHP19 = parcelRequire("lHP19");

var $dxWQo = parcelRequire("dxWQo");
var $207f10d2a89dedd1$exports = {};
"use strict";
var $207f10d2a89dedd1$var$__createBinding = $207f10d2a89dedd1$exports && $207f10d2a89dedd1$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $207f10d2a89dedd1$var$__exportStar = $207f10d2a89dedd1$exports && $207f10d2a89dedd1$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $207f10d2a89dedd1$var$__createBinding(exports1, m, p);
};
Object.defineProperty($207f10d2a89dedd1$exports, "__esModule", {
    value: true
});

$207f10d2a89dedd1$var$__exportStar((parcelRequire("fIBDJ")), $207f10d2a89dedd1$exports);

$207f10d2a89dedd1$var$__exportStar((parcelRequire("aqROd")), $207f10d2a89dedd1$exports);


class $d1c26202b1637768$export$733bdbce7393a3c2 {
    async getPricesFromPayload(paramsProvider) {
        return await (0, $207f10d2a89dedd1$exports.WrapperBuilder).wrap(this.contract).usingDataService(paramsProvider.requestParams).getPrices();
    }
    readPricesFromContract(paramsProvider) {
        throw "Method not supported";
    }
    readTimestampFromContract() {
        throw "Method not supported";
    }
    writePricesFromPayloadToContract(paramsProvider) {
        throw "Method not supported";
    }
    constructor(contract){
        (0, $dxWQo._)(this, "contract", void 0);
        this.contract = contract;
    }
}


var $992631f770fd1e09$exports = {};
$992631f770fd1e09$exports = JSON.parse('{"abi":[{"inputs":[],"name":"CalldataMustHaveValidPayload","type":"error"},{"inputs":[],"name":"CalldataOverOrUnderFlow","type":"error"},{"inputs":[],"name":"CanNotPickMedianOfEmptyArray","type":"error"},{"inputs":[],"name":"EachSignerMustProvideTheSameValue","type":"error"},{"inputs":[],"name":"EmptyCalldataPointersArr","type":"error"},{"inputs":[],"name":"IncorrectUnsignedMetadataSize","type":"error"},{"inputs":[{"internalType":"uint256","name":"receviedSignersCount","type":"uint256"},{"internalType":"uint256","name":"requiredSignersCount","type":"uint256"}],"name":"InsufficientNumberOfUniqueSigners","type":"error"},{"inputs":[],"name":"InvalidCalldataPointer","type":"error"},{"inputs":[{"internalType":"address","name":"receivedSigner","type":"address"}],"name":"SignerNotAuthorised","type":"error"},{"inputs":[{"internalType":"uint256","name":"receivedTimestampSeconds","type":"uint256"},{"internalType":"uint256","name":"blockTimestamp","type":"uint256"}],"name":"TimestampFromTooLongFuture","type":"error"},{"inputs":[{"internalType":"uint256","name":"receivedTimestampSeconds","type":"uint256"},{"internalType":"uint256","name":"blockTimestamp","type":"uint256"}],"name":"TimestampIsTooOld","type":"error"},{"inputs":[{"internalType":"uint256[]","name":"values","type":"uint256[]"}],"name":"aggregateValues","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"signerAddress","type":"address"}],"name":"getAuthorisedSignerIndex","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getPrices","outputs":[{"internalType":"uint256[]","name":"","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"getUniqueSignersThreshold","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"receivedTimestampMilliseconds","type":"uint256"}],"name":"validateTimestamp","outputs":[],"stateMutability":"view","type":"function"}]}');


class $3b1d864c6009b95d$export$40adee5c66c8f092 {
    getBlockNumber(rpcUrl) {
        return this.signer.provider.getBlockNumber();
    }
    async getAdapter() {
        return new (0, $d1c26202b1637768$export$733bdbce7393a3c2)(new (0, $lHP19.Contract)(this.contractAddress, (0, $992631f770fd1e09$exports.abi), this.signer));
    }
    constructor(contractAddress, signer){
        (0, $dxWQo._)(this, "contractAddress", void 0);
        (0, $dxWQo._)(this, "signer", void 0);
        this.contractAddress = contractAddress;
        this.signer = signer;
    }
}




const $bd9f40d2e954ba14$export$79fa1f4c2d188e01 = ({ props: props, network: network })=>{
    const { signer: signer, walletAddress: walletAddress, isChangingNetwork: isChangingNetwork, isConnecting: isConnecting, prices: prices, setPrices: setPrices } = props;
    const { text: text, isMockLoading: isMockLoading, setIsMockLoading: setIsMockLoading, startMockLoader: startMockLoader } = (0, $ae7f937efe139789$export$3ca8f5b83ba7703a)();
    const connector = new (0, $3b1d864c6009b95d$export$40adee5c66c8f092)(network === null || network === void 0 ? void 0 : network.exampleContractAddress, signer);
    const { blockNumber: blockNumber, timestamp: timestamp, isLoading: isLoading, getPricesFromPayload: getPricesFromPayload, errorMessage: errorMessage, setErrorMessage: setErrorMessage } = (0, $753cc36948ba3c23$export$37ebad50d75f51b)(network, connector, startMockLoader, setPrices, setIsMockLoading);
    const arePrices = Object.values(prices).every((price)=>!!price);
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex w-full justify-center items-center mt-8 flex-col",
        children: [
            isConnecting && ((network === null || network === void 0 ? void 0 : network.type) || "eth") === "eth" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: "mt-0 mb-10 text-lg font-bold",
                children: "Please sign in to MetaMask"
            }),
            isChangingNetwork && signer && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: "mt-0 mb-10 text-lg font-bold",
                children: "Please change network in MetaMask"
            }),
            !isChangingNetwork && network && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $d0adf8410d59fd78$export$f34f01f5ad9bfa8), {
                walletAddress: walletAddress,
                network: network
            }),
            isMockLoading || isLoading ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $400629623ad58cec$export$f39eb86f0e5c1a78), {
                text: isMockLoading ? text : ""
            }) : arePrices ? /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $29fbb8d85bb99ed5$export$d877cf1ea46d4d85), {
                blockNumber: blockNumber,
                timestamp: timestamp,
                prices: prices
            }) : !isChangingNetwork && network && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $f1a9f66f6ca0bed1$export$d38cca4e3d3fe8c0), {
                getPriceFromContract: getPricesFromPayload
            }),
            !!errorMessage && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $b76a4ff75d0d9de2$export$2e2bcd8739ae039), {
                closeModal: ()=>setErrorMessage(""),
                title: "Problem with contract interaction",
                text: errorMessage
            })
        ]
    });
};



var $6cds3 = parcelRequire("6cds3");
const $05f234adb52dd49e$var$chainsArray = Object.values((0, $050990180fbd2df8$export$af1c0561ce3e4019));
const $05f234adb52dd49e$export$9d4b6b226bc0829 = ()=>{
    const [network, setNetwork] = (0, $6cds3.useState)(null);
    const evm = (0, $6d74eea438614f0e$export$69804ca079d47f29)(setNetwork);
    const starknet = (0, $855eec528252b37a$export$5359a20ca62641f)();
    const onChainClick = async (chain)=>{
        setNetwork(chain);
        if (((chain === null || chain === void 0 ? void 0 : chain.type) || "eth") === "eth") return await evm.connectWallet(chain);
        if ((chain === null || chain === void 0 ? void 0 : chain.type) === "starknet") return await starknet.connectWallet();
    };
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex justify-center items-center flex-col",
        children: [
            !network && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("p", {
                className: "mb-10 text-lg font-bold",
                children: "Please select a chain-button to integrate your wallet:"
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "w-3/5 flex flex-wrap justify-center gap-3 px-10",
                children: $05f234adb52dd49e$var$chainsArray.map((ch)=>/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $894a8d90f8ca8f9d$export$179a2d4534d0f37d), {
                        chain: ch,
                        network: network,
                        onChainClick: onChainClick,
                        disabled: false
                    }, ch.chainId))
            }),
            ((network === null || network === void 0 ? void 0 : network.type) || "eth") === "eth" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $bd9f40d2e954ba14$export$79fa1f4c2d188e01), {
                props: {
                    ...evm
                },
                network: network
            }),
            (network === null || network === void 0 ? void 0 : network.type) === "starknet" && /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $aca49255d66f39fc$export$6d4e842c29c48185), {
                props: {
                    ...starknet
                },
                network: network
            })
        ]
    });
};


const $18cb66d1e7a58135$var$App = ()=>{
    return /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsxs)("div", {
        className: "flex flex-col h-full bg-neutral-100 overflow-auto",
        children: [
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $ca9b163af4bfc596$export$8b251419efc915eb), {}),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)("div", {
                className: "mb-5",
                children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $05f234adb52dd49e$export$9d4b6b226bc0829), {})
            }),
            /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $1d10e2dedeefcec7$export$a06f1c675e846f6f), {})
        ]
    });
};
var $18cb66d1e7a58135$export$2e2bcd8739ae039 = $18cb66d1e7a58135$var$App;



(0, (/*@__PURE__*/$parcel$interopDefault($64d0b1ebdd6bcffe$exports))).createRoot(document.getElementById("root")).render(/*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).StrictMode, {
    children: /*#__PURE__*/ (0, $fba0f23e9e6a11bb$exports.jsx)((0, $18cb66d1e7a58135$export$2e2bcd8739ae039), {})
}));

})();
//# sourceMappingURL=index.ad077c48.js.map
